import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (example format: 2023-03-28) */
  date: { input: any; output: any; }
  /** Date time */
  datetime: { input: any; output: any; }
  /** A JSONB scalar */
  jsonb: { input: any; output: any; }
  /** Local Time (example format: 23:59) */
  localtime: { input: any; output: any; }
  /** Large number */
  long: { input: any; output: any; }
  /** numeric */
  numeric: { input: any; output: any; }
  /** Timezone */
  timezone: { input: any; output: any; }
  /** UUID */
  uuid: { input: any; output: any; }
};

export type AbsentAuditLogPayload = {
  __typename?: 'AbsentAuditLogPayload';
  empty: Scalars['Boolean']['output'];
};

/** Result of creating an activity. */
export type ActivityCreateResult = {
  __typename?: 'ActivityCreateResult';
  activityLog?: Maybe<ActivityLog>;
};

/** Represents a single activity log entry. */
export type ActivityLog = {
  __typename?: 'ActivityLog';
  /** @deprecated please use actor */
  activityActorEmployeeId?: Maybe<Scalars['uuid']['output']>;
  /** @deprecated please use actor */
  activityActorType: ActorType;
  /** The type of activity recorded. */
  activityType: ActivityType;
  /** Information about the actor who performed the activity. */
  actor: ActivityLogActor;
  /** @deprecated please use actor */
  actorEmployee?: Maybe<Employee>;
  /** Timestamp when the activity was created. */
  createdAt: Scalars['datetime']['output'];
  /** Additional details about the activity, varies based on activity type. */
  details?: Maybe<ActivityLogDetails>;
  /**
   * Whether this activity log is ephemeral (temporary progress indicator).
   * Ephemeral entries are replaced by the next activity from the same source.
   */
  ephemeral: Scalars['Boolean']['output'];
  /** Unique identifier for the activity log. */
  id: Scalars['uuid']['output'];
  /**
   * Server-generated plain-text description. Clients should render this when present
   * and fall back to existing activity-type-specific renderers when null.
   */
  plaintext?: Maybe<Scalars['String']['output']>;
  /** The primary entity associated with the activity. */
  primaryEntity: ActivityLogPrimaryEntity;
  /** Optional secondary entity associated with the activity. */
  secondaryEntity?: Maybe<ActivityLogSecondaryEntity>;
  /**
   *  V1 fields (deprecated)
   * @deprecated please use primaryEntity
   */
  source?: Maybe<ActivityLogSource>;
  /** @deprecated please use primaryEntity */
  sourceId: Scalars['uuid']['output'];
  /** @deprecated please use primaryEntity */
  sourceType: SourceType;
};

/** Represents the possible actors for activities. */
export type ActivityLogActor = Candidate | Employee | SystemActor;

/** AI agent debug dump — full turn context, messages, and tool calls as JSON. Only populated in dev/staging. */
export type ActivityLogAgentDebugDetails = {
  __typename?: 'ActivityLogAgentDebugDetails';
  json: Scalars['String']['output'];
};

/** AI agent message details. */
export type ActivityLogAgentMessageDetails = {
  __typename?: 'ActivityLogAgentMessageDetails';
  content?: Maybe<ActivityLogContent>;
  message: Scalars['String']['output'];
};

/** AI agent question details. */
export type ActivityLogAgentQuestionDetails = {
  __typename?: 'ActivityLogAgentQuestionDetails';
  content?: Maybe<ActivityLogContent>;
  options: Array<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

/** Agent queued — the agent is queued to start after a delay (ephemeral). startAt is when the agent will start. */
export type ActivityLogAgentQueuedDetails = {
  __typename?: 'ActivityLogAgentQueuedDetails';
  startAt: Scalars['datetime']['output'];
};

/** AI agent reasoning details. */
export type ActivityLogAgentReasoningDetails = {
  __typename?: 'ActivityLogAgentReasoningDetails';
  content?: Maybe<ActivityLogContent>;
  reasoning: Scalars['String']['output'];
};

/** Agent tool calls continue — some completed, others still running (ephemeral). */
export type ActivityLogAgentToolCallsContinueDetails = {
  __typename?: 'ActivityLogAgentToolCallsContinueDetails';
  completedToolCalls: Array<AgentToolCallCompletedInfo>;
  remainingToolCalls: Array<AgentToolCallStartInfo>;
};

/** Agent tool calls — durable expandable batch of tool calls for one agent phase. */
export type ActivityLogAgentToolCallsDetails = {
  __typename?: 'ActivityLogAgentToolCallsDetails';
  completedToolCalls: Array<AgentToolCallCompletedInfo>;
  toolCalls: Array<AgentToolCallStartInfo>;
};

/** Agent tool calls start — the agent is executing tool calls (ephemeral). */
export type ActivityLogAgentToolCallsStartDetails = {
  __typename?: 'ActivityLogAgentToolCallsStartDetails';
  toolCalls: Array<AgentToolCallStartInfo>;
};

/** Agent turn start — the agent is starting a turn (ephemeral). */
export type ActivityLogAgentTurnStartDetails = {
  __typename?: 'ActivityLogAgentTurnStartDetails';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents details for candidate portal note-related activities. */
export type ActivityLogCandidatePortalNoteDetails = {
  __typename?: 'ActivityLogCandidatePortalNoteDetails';
  candidatePortalNoteId: Scalars['uuid']['output'];
  content?: Maybe<Scalars['String']['output']>;
  sendToCandidate?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents details for changes to a candidate's preferred phone number. */
export type ActivityLogCandidatePreferredPhoneNumberChangeDetails = {
  __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails';
  isUnset?: Maybe<Scalars['Boolean']['output']>;
  updatedPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Represents details for Candidate RSVP Accepted activity */
export type ActivityLogCandidateRsvpAcceptedDetails = {
  __typename?: 'ActivityLogCandidateRsvpAcceptedDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  startAt: Scalars['datetime']['output'];
};

/** Represents details for Candidate RSVP Declined activity */
export type ActivityLogCandidateRsvpDeclinedDetails = {
  __typename?: 'ActivityLogCandidateRsvpDeclinedDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  startAt: Scalars['datetime']['output'];
};

/** Represents details for Candidate RSVP Needs Action activity */
export type ActivityLogCandidateRsvpNeedsActionDetails = {
  __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  startAt: Scalars['datetime']['output'];
};

/** Represents details for Candidate RSVP Tentative activity */
export type ActivityLogCandidateRsvpTentativeDetails = {
  __typename?: 'ActivityLogCandidateRsvpTentativeDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  startAt: Scalars['datetime']['output'];
};

/** Represents details for candidate portal tab view activities. */
export type ActivityLogCandidateViewedTabDetails = {
  __typename?: 'ActivityLogCandidateViewedTabDetails';
  currentJobStageId: Scalars['uuid']['output'];
  tabName: Scalars['String']['output'];
};

export type ActivityLogContent = {
  __typename?: 'ActivityLogContent';
  editorStateJson: Scalars['String']['output'];
  formatVersion: Scalars['Int']['output'];
  markdown: Scalars['String']['output'];
  plaintext: Scalars['String']['output'];
};

/** Input for creating an activity note. */
export type ActivityLogContentInput = {
  editorStateJson?: InputMaybe<Scalars['String']['input']>;
  formatVersion: Scalars['Int']['input'];
  markdown: Scalars['String']['input'];
  plaintext: Scalars['String']['input'];
};

/**
 * Represents the possible detail types for activity logs.
 * Keep this union in sync with `details` messages in `activity_log_db.proto`!
 */
export type ActivityLogDetails = ActivityLogAgentDebugDetails | ActivityLogAgentMessageDetails | ActivityLogAgentQuestionDetails | ActivityLogAgentQueuedDetails | ActivityLogAgentReasoningDetails | ActivityLogAgentToolCallsContinueDetails | ActivityLogAgentToolCallsDetails | ActivityLogAgentToolCallsStartDetails | ActivityLogAgentTurnStartDetails | ActivityLogCandidatePortalNoteDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogCandidateRsvpAcceptedDetails | ActivityLogCandidateRsvpDeclinedDetails | ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogCandidateRsvpTentativeDetails | ActivityLogCandidateViewedTabDetails | ActivityLogEmailDetails | ActivityLogEmployeeEmailReceivedDetails | ActivityLogEmployeeEmailSentDetails | ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogEmployeeSlackMessageSentDetails | ActivityLogFlagDetails | ActivityLogInterviewerNoResponseDetails | ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogInterviewerRsvpTentativeDetails | ActivityLogNoteDetails | ActivityLogRescheduleLogDetails | ActivityLogRsvpDetails | ActivityLogScheduleDetails | ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskAssigneeDetails | ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskAvailabilityDetails | ActivityLogTaskDetails | ActivityLogTaskEventDetails | ActivityLogTaskInterviewerDetails | ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskMeetingRoomDetails | ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskQueueDetails | ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskStatusDetails | ActivityLogTaskTagDetails;

/** Represents details for email-related activities. */
export type ActivityLogEmailDetails = {
  __typename?: 'ActivityLogEmailDetails';
  body: Scalars['String']['output'];
  ccAddresses: Array<Scalars['String']['output']>;
  fromEmailAddress: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  toEmailAddress: Scalars['String']['output'];
};

/** Represents details for employee/interviewer email received activities. */
export type ActivityLogEmployeeEmailReceivedDetails = {
  __typename?: 'ActivityLogEmployeeEmailReceivedDetails';
  body: Scalars['String']['output'];
  ccAddresses: Array<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['uuid']['output']>;
  employeeName: Scalars['String']['output'];
  fromEmailAddress: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  toEmailAddress: Scalars['String']['output'];
};

/** Represents details for employee/interviewer email sent activities. */
export type ActivityLogEmployeeEmailSentDetails = {
  __typename?: 'ActivityLogEmployeeEmailSentDetails';
  body: Scalars['String']['output'];
  ccAddresses: Array<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['uuid']['output']>;
  employeeName: Scalars['String']['output'];
  fromEmailAddress: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  toEmailAddress: Scalars['String']['output'];
};

/** Represents details for employee/interviewer Slack message received activities. */
export type ActivityLogEmployeeSlackMessageReceivedDetails = {
  __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails';
  body: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['uuid']['output']>;
  employeeName: Scalars['String']['output'];
  messageTs: Scalars['String']['output'];
  threadTs: Scalars['String']['output'];
};

/** Represents details for employee/interviewer Slack message sent activities. */
export type ActivityLogEmployeeSlackMessageSentDetails = {
  __typename?: 'ActivityLogEmployeeSlackMessageSentDetails';
  body: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['uuid']['output']>;
  employeeName: Scalars['String']['output'];
  messageTs: Scalars['String']['output'];
  threadTs: Scalars['String']['output'];
};

/** Represents the types of entities that can have activity logs. */
export enum ActivityLogEntityType {
  ActivityLogEntityApplication = 'ACTIVITY_LOG_ENTITY_APPLICATION',
  ActivityLogEntityCandidate = 'ACTIVITY_LOG_ENTITY_CANDIDATE',
  ActivityLogEntityEmployee = 'ACTIVITY_LOG_ENTITY_EMPLOYEE',
  ActivityLogEntityInterviewModule = 'ACTIVITY_LOG_ENTITY_INTERVIEW_MODULE',
  ActivityLogEntityJob = 'ACTIVITY_LOG_ENTITY_JOB',
  ActivityLogEntityOrg = 'ACTIVITY_LOG_ENTITY_ORG',
  ActivityLogEntityTask = 'ACTIVITY_LOG_ENTITY_TASK',
  ActivityLogEntityTaskQueue = 'ACTIVITY_LOG_ENTITY_TASK_QUEUE'
}

/** What an activity log feed is scoped to. */
export enum ActivityLogFeedScope {
  /** One entity's feed. Requires entityType and entityId. */
  ActivityLogFeedScopeEntity = 'ACTIVITY_LOG_FEED_SCOPE_ENTITY',
  /** Every activity in the organization, newest first. Takes no entity and is admin-only. */
  ActivityLogFeedScopeOrgWide = 'ACTIVITY_LOG_FEED_SCOPE_ORG_WIDE'
}

/** Represents details for flag-related activities. */
export type ActivityLogFlagDetails = {
  __typename?: 'ActivityLogFlagDetails';
  flagContent: Scalars['String']['output'];
};

/** Represents details for Interviewer No Response activity */
export type ActivityLogInterviewerNoResponseDetails = {
  __typename?: 'ActivityLogInterviewerNoResponseDetails';
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  startAt: Scalars['datetime']['output'];
};

/** Represents details for Interviewer RSVP Accepted activity */
export type ActivityLogInterviewerRsvpAcceptedDetails = {
  __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  proposedTime?: Maybe<DateTimeRangeOutput>;
  startAt: Scalars['datetime']['output'];
};

/** Represents details for Interviewer RSVP Declined activity */
export type ActivityLogInterviewerRsvpDeclinedDetails = {
  __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  proposedTime?: Maybe<DateTimeRangeOutput>;
  startAt: Scalars['datetime']['output'];
};

/** Represents details for Interviewer RSVP Needs Action activity */
export type ActivityLogInterviewerRsvpNeedsActionDetails = {
  __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  proposedTime?: Maybe<DateTimeRangeOutput>;
  startAt: Scalars['datetime']['output'];
};

/** Represents details for Interviewer RSVP Tentative activity */
export type ActivityLogInterviewerRsvpTentativeDetails = {
  __typename?: 'ActivityLogInterviewerRsvpTentativeDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  proposedTime?: Maybe<DateTimeRangeOutput>;
  startAt: Scalars['datetime']['output'];
};

/** Represents details for note-related activities. */
export type ActivityLogNoteDetails = {
  __typename?: 'ActivityLogNoteDetails';
  content?: Maybe<ActivityLogContent>;
  isEdited: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
};

/** Represents the possible primary entities for activities. */
export type ActivityLogPrimaryEntity = Application | ApplicationStageInterview | Candidate | Employee | InterviewModule | Job | Org | Task | TaskQueue;

/** Represents details for reschedule log-related activities. */
export type ActivityLogRescheduleLogDetails = {
  __typename?: 'ActivityLogRescheduleLogDetails';
  rescheduleLog?: Maybe<RescheduleLog>;
  rescheduleLogId: Scalars['uuid']['output'];
};

/** Represents details for RSVP-related activities. */
export type ActivityLogRsvpDetails = {
  __typename?: 'ActivityLogRsvpDetails';
  addedInterviewer?: Maybe<Employee>;
  /**  This is not required for candidate RSVP */
  addedInterviewerId?: Maybe<Scalars['uuid']['output']>;
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  /**  This is not required for candidate RSVP */
  interviewer?: Maybe<Employee>;
  interviewerId?: Maybe<Scalars['uuid']['output']>;
  proposedTime?: Maybe<DateTimeRangeOutput>;
  responseStatus: ResponseStatus;
  startAt: Scalars['datetime']['output'];
};

/** Represents details specific to scheduling activities. */
export type ActivityLogScheduleDetails = {
  __typename?: 'ActivityLogScheduleDetails';
  applicationStageId: Scalars['uuid']['output'];
};

/** Represents the possible secondary entities for activities. */
export type ActivityLogSecondaryEntity = Employee | TaskQueue;

/** Represents the possible sources for activity logs. */
export type ActivityLogSource = Application | Candidate | Task;

export type ActivityLogSubscriptionInput = {
  entityId: Scalars['uuid']['input'];
  entityType: ActivityLogEntityType;
};

/** Represents details for a change to one calendar event's additional-attendee list. */
export type ActivityLogTaskAdditionalAttendeesUpdatedDetails = {
  __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails';
  applicationStageInterviewId?: Maybe<Scalars['uuid']['output']>;
  attendeeChanges: Array<AdditionalAttendeeChange>;
  eventKind: AdditionalAttendeesEventKind;
  eventName: Scalars['String']['output'];
};

/** Represents details for task assignee change activities. */
export type ActivityLogTaskAssigneeDetails = {
  __typename?: 'ActivityLogTaskAssigneeDetails';
  assignee: Employee;
  assigneeId: Scalars['uuid']['output'];
};

/** Represents details for task auto-cancel failure activities. */
export type ActivityLogTaskAutoCancelFailedDetails = {
  __typename?: 'ActivityLogTaskAutoCancelFailedDetails';
  failureMessage: Scalars['String']['output'];
  failureReason: TaskAutoCancelFailureReason;
};

/** Represents details for task availability-related activities. */
export type ActivityLogTaskAvailabilityDetails = {
  __typename?: 'ActivityLogTaskAvailabilityDetails';
  candidateAvailability: Array<DateTimeRangeOutput>;
  note: Scalars['String']['output'];
  sourcingLinkId?: Maybe<Scalars['uuid']['output']>;
};

/** Represents details specific to task-related activities. */
export type ActivityLogTaskDetails = {
  __typename?: 'ActivityLogTaskDetails';
  atsName?: Maybe<Scalars['String']['output']>;
  sourcingLinkId?: Maybe<Scalars['uuid']['output']>;
  task: Task;
  taskId: Scalars['uuid']['output'];
};

/** Represents details for task event-related activities. */
export type ActivityLogTaskEventDetails = {
  __typename?: 'ActivityLogTaskEventDetails';
  candidateCancellationReason?: Maybe<CandidateCancellationReason>;
  endAt: Scalars['datetime']['output'];
  name: Scalars['String']['output'];
  selfScheduleCandidateNote: Scalars['String']['output'];
  sourcingLinkId?: Maybe<Scalars['uuid']['output']>;
  startAt: Scalars['datetime']['output'];
};

/** Represents details for task interviewer-related activities. */
export type ActivityLogTaskInterviewerDetails = {
  __typename?: 'ActivityLogTaskInterviewerDetails';
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  interviewer: Employee;
  interviewerId: Scalars['String']['output'];
  startAt: Scalars['datetime']['output'];
};

/** Represents details for task meeting location updates. */
export type ActivityLogTaskMeetingLocationUpdatedDetails = {
  __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails';
  description: Scalars['String']['output'];
};

/** Represents details for task meeting room-related activities. */
export type ActivityLogTaskMeetingRoomDetails = {
  __typename?: 'ActivityLogTaskMeetingRoomDetails';
  comment: Scalars['String']['output'];
  endAt: Scalars['datetime']['output'];
  interviewName: Scalars['String']['output'];
  meetingRoomId: Scalars['uuid']['output'];
  responseStatus: ResponseStatus;
  room?: Maybe<MeetingRoom>;
  startAt: Scalars['datetime']['output'];
};

/** Represents details for a task where automatic booking found no perfect schedule. */
export type ActivityLogTaskPerfectScheduleNotFoundDetails = {
  __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails';
  reason: TaskPerfectScheduleNotFoundReason;
};

/** Represents details for task queue-related activities. */
export type ActivityLogTaskQueueDetails = {
  __typename?: 'ActivityLogTaskQueueDetails';
  taskQueue?: Maybe<TaskQueue>;
  taskQueueId: Scalars['uuid']['output'];
};

/** Represents details for activities related to tasks being ready for candidate communication. */
export type ActivityLogTaskReadyForCandidateCommDetails = {
  __typename?: 'ActivityLogTaskReadyForCandidateCommDetails';
  subscriberIds: Array<Scalars['uuid']['output']>;
};

export type ActivityLogTaskSourcingLinkResumeUploadDetails = {
  __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails';
  reason: Scalars['String']['output'];
};

/** Represents details for task status change activities. */
export type ActivityLogTaskStatusDetails = {
  __typename?: 'ActivityLogTaskStatusDetails';
  taskStatus: TaskStatus;
};

/** Represents details for task tag-related activities. */
export type ActivityLogTaskTagDetails = {
  __typename?: 'ActivityLogTaskTagDetails';
  tagIds: Array<Scalars['uuid']['output']>;
  taskTags: Array<TaskTag>;
};

export type ActivityLogsForSourceInput = {
  activityTypes?: InputMaybe<Array<ActivityType>>;
  actorTypes?: InputMaybe<Array<ActorType>>;
  pageInput: PageInput;
};

/** Input for querying activity logs. */
export type ActivityLogsInput = {
  /** Optional list of specific activity types to filter the logs. */
  activityTypes?: InputMaybe<Array<ActivityType>>;
  /**
   * The unique identifier of the entity. Required for entity-scoped feeds (the default); must be
   * omitted when scope is ACTIVITY_LOG_FEED_SCOPE_ORG_WIDE.
   */
  entityId?: InputMaybe<Scalars['uuid']['input']>;
  /**
   * The type of entity for which activity logs are being queried. Required for entity-scoped feeds
   * (the default); ignored when scope is ACTIVITY_LOG_FEED_SCOPE_ORG_WIDE.
   */
  entityType?: InputMaybe<ActivityLogEntityType>;
  /**
   * When true, also include activities the entity performed as the actor. Absent or null returns only
   * activities taken on the entity. Ignored for org-wide feeds, which already span every actor.
   */
  includeActorActivities?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pagination input for the activity logs query. */
  pageInput: PageInput;
  /** What the feed is scoped to. Absent or null means ACTIVITY_LOG_FEED_SCOPE_ENTITY. */
  scope?: InputMaybe<ActivityLogFeedScope>;
};

/** Result type for activity logs query. */
export type ActivityLogsResult = {
  __typename?: 'ActivityLogsResult';
  /** List of activity log items. */
  items: Array<ActivityLog>;
  /** Cursor for the next page of results, if available. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type ActivityNoteCreateInput = {
  content?: InputMaybe<ActivityLogContentInput>;
  note: Scalars['String']['input'];
  sourceId: Scalars['uuid']['input'];
  sourceType: SourceType;
};

/** Result of creating an activity note. */
export type ActivityNoteCreateResult = {
  __typename?: 'ActivityNoteCreateResult';
  activityLog?: Maybe<ActivityLog>;
};

/** Input for deleting an activity note. */
export type ActivityNoteDeleteInput = {
  activityLogId: Scalars['uuid']['input'];
};

/** Result of deleting an activity note. */
export type ActivityNoteDeleteResult = {
  __typename?: 'ActivityNoteDeleteResult';
  result?: Maybe<Result>;
};

/** Input for editing an activity note. */
export type ActivityNoteEditInput = {
  activityLogId: Scalars['uuid']['input'];
  content?: InputMaybe<ActivityLogContentInput>;
  note: Scalars['String']['input'];
};

/** Result of editing an activity note. */
export type ActivityNoteEditResult = {
  __typename?: 'ActivityNoteEditResult';
  activityLog?: Maybe<ActivityLog>;
};

/** Input for creating an activity reschedule. */
export type ActivityRescheduleCreateInput = {
  rescheduleReason: Scalars['String']['input'];
  taskId: Scalars['uuid']['input'];
};

/**
 * Represents the types of activities that can be logged.
 * Keep this enum in sync with `ActivityType` enum in `activity_log_db.proto`
 */
export enum ActivityType {
  AgentDebug = 'AGENT_DEBUG',
  AgentMemoryAdded = 'AGENT_MEMORY_ADDED',
  AgentMemoryDeleted = 'AGENT_MEMORY_DELETED',
  AgentMessage = 'AGENT_MESSAGE',
  AgentQuestion = 'AGENT_QUESTION',
  AgentQueued = 'AGENT_QUEUED',
  AgentReasoning = 'AGENT_REASONING',
  AgentStopped = 'AGENT_STOPPED',
  AgentToolCalls = 'AGENT_TOOL_CALLS',
  AgentToolCallsContinue = 'AGENT_TOOL_CALLS_CONTINUE',
  AgentToolCallsStart = 'AGENT_TOOL_CALLS_START',
  AgentTurnStart = 'AGENT_TURN_START',
  ApplicationCandidatePortalNoteCreated = 'APPLICATION_CANDIDATE_PORTAL_NOTE_CREATED',
  ApplicationCandidatePortalNoteDeleted = 'APPLICATION_CANDIDATE_PORTAL_NOTE_DELETED',
  ApplicationCandidatePortalNoteUpdated = 'APPLICATION_CANDIDATE_PORTAL_NOTE_UPDATED',
  CandidateAnonymized = 'CANDIDATE_ANONYMIZED',
  CandidatePreferredPhoneNumberChanged = 'CANDIDATE_PREFERRED_PHONE_NUMBER_CHANGED',
  CandidatePulseSurveyRequested = 'CANDIDATE_PULSE_SURVEY_REQUESTED',
  CandidatePulseSurveySubmitted = 'CANDIDATE_PULSE_SURVEY_SUBMITTED',
  CandidateViewedTab = 'CANDIDATE_VIEWED_TAB',
  EmployeeEmailReceived = 'EMPLOYEE_EMAIL_RECEIVED',
  EmployeeEmailSent = 'EMPLOYEE_EMAIL_SENT',
  EmployeeLoadLimitChanged = 'EMPLOYEE_LOAD_LIMIT_CHANGED',
  EmployeePauseDatesChanged = 'EMPLOYEE_PAUSE_DATES_CHANGED',
  EmployeeSlackMessageReceived = 'EMPLOYEE_SLACK_MESSAGE_RECEIVED',
  EmployeeSlackMessageSent = 'EMPLOYEE_SLACK_MESSAGE_SENT',
  InterviewModuleCreated = 'INTERVIEW_MODULE_CREATED',
  InterviewModuleDeleted = 'INTERVIEW_MODULE_DELETED',
  InterviewModuleMemberAdded = 'INTERVIEW_MODULE_MEMBER_ADDED',
  InterviewModuleMemberGraduatedToReverseShadow = 'INTERVIEW_MODULE_MEMBER_GRADUATED_TO_REVERSE_SHADOW',
  InterviewModuleMemberGraduatedToTrained = 'INTERVIEW_MODULE_MEMBER_GRADUATED_TO_TRAINED',
  InterviewModuleMemberRemoved = 'INTERVIEW_MODULE_MEMBER_REMOVED',
  InterviewModuleMemberReverseShadowAssignedToInterview = 'INTERVIEW_MODULE_MEMBER_REVERSE_SHADOW_ASSIGNED_TO_INTERVIEW',
  InterviewModuleMemberReverseShadowGraduatedToTrained = 'INTERVIEW_MODULE_MEMBER_REVERSE_SHADOW_GRADUATED_TO_TRAINED',
  InterviewModuleMemberReverseShadowGraduationRejected = 'INTERVIEW_MODULE_MEMBER_REVERSE_SHADOW_GRADUATION_REJECTED',
  InterviewModuleMemberReverseShadowInterviewCompleted = 'INTERVIEW_MODULE_MEMBER_REVERSE_SHADOW_INTERVIEW_COMPLETED',
  InterviewModuleMemberReverseShadowToTrainedApprovalRequired = 'INTERVIEW_MODULE_MEMBER_REVERSE_SHADOW_TO_TRAINED_APPROVAL_REQUIRED',
  InterviewModuleMemberShadowAssignedToInterview = 'INTERVIEW_MODULE_MEMBER_SHADOW_ASSIGNED_TO_INTERVIEW',
  InterviewModuleMemberShadowGraduatedToTrained = 'INTERVIEW_MODULE_MEMBER_SHADOW_GRADUATED_TO_TRAINED',
  InterviewModuleMemberShadowGraduationRejected = 'INTERVIEW_MODULE_MEMBER_SHADOW_GRADUATION_REJECTED',
  InterviewModuleMemberShadowInterviewCompleted = 'INTERVIEW_MODULE_MEMBER_SHADOW_INTERVIEW_COMPLETED',
  InterviewModuleMemberShadowToReverseShadowApprovalRequired = 'INTERVIEW_MODULE_MEMBER_SHADOW_TO_REVERSE_SHADOW_APPROVAL_REQUIRED',
  InterviewModuleMemberShadowToTrainedApprovalRequired = 'INTERVIEW_MODULE_MEMBER_SHADOW_TO_TRAINED_APPROVAL_REQUIRED',
  InterviewModuleMemberTrainedAssignedToInterview = 'INTERVIEW_MODULE_MEMBER_TRAINED_ASSIGNED_TO_INTERVIEW',
  InterviewModuleMemberTrainedInterviewCompleted = 'INTERVIEW_MODULE_MEMBER_TRAINED_INTERVIEW_COMPLETED',
  InterviewModuleMemberUpdated = 'INTERVIEW_MODULE_MEMBER_UPDATED',
  InterviewModuleUpdated = 'INTERVIEW_MODULE_UPDATED',
  Note = 'NOTE',
  OrgMemberAdditionalPermissionsUpdated = 'ORG_MEMBER_ADDITIONAL_PERMISSIONS_UPDATED',
  OrgSettingChanged = 'ORG_SETTING_CHANGED',
  OrgUserAdded = 'ORG_USER_ADDED',
  OrgUserRemoved = 'ORG_USER_REMOVED',
  OrgUserRoleChanged = 'ORG_USER_ROLE_CHANGED',
  TaskAdditionalAttendeesUpdated = 'TASK_ADDITIONAL_ATTENDEES_UPDATED',
  TaskAgentDelegated = 'TASK_AGENT_DELEGATED',
  TaskAgentThinking = 'TASK_AGENT_THINKING',
  TaskAgentUndelegated = 'TASK_AGENT_UNDELEGATED',
  TaskAssigned = 'TASK_ASSIGNED',
  TaskAutoCancelFailed = 'TASK_AUTO_CANCEL_FAILED',
  TaskAvailabilityCandidateReminderSent = 'TASK_AVAILABILITY_CANDIDATE_REMINDER_SENT',
  TaskCalendarChanges = 'TASK_CALENDAR_CHANGES',
  TaskCandidateAvailabilityDeleted = 'TASK_CANDIDATE_AVAILABILITY_DELETED',
  TaskCandidateEditedAvailability = 'TASK_CANDIDATE_EDITED_AVAILABILITY',
  TaskCandidateEmailSent = 'TASK_CANDIDATE_EMAIL_SENT',
  TaskCandidateRsvp = 'TASK_CANDIDATE_RSVP',
  TaskCandidateRsvpAccepted = 'TASK_CANDIDATE_RSVP_ACCEPTED',
  TaskCandidateRsvpDeclined = 'TASK_CANDIDATE_RSVP_DECLINED',
  TaskCandidateRsvpNeedsAction = 'TASK_CANDIDATE_RSVP_NEEDS_ACTION',
  TaskCandidateRsvpTentative = 'TASK_CANDIDATE_RSVP_TENTATIVE',
  TaskCandidateSelfScheduleCanceled = 'TASK_CANDIDATE_SELF_SCHEDULE_CANCELED',
  TaskCandidateSelfScheduleCreated = 'TASK_CANDIDATE_SELF_SCHEDULE_CREATED',
  TaskCandidateSelfScheduleRescheduled = 'TASK_CANDIDATE_SELF_SCHEDULE_RESCHEDULED',
  TaskChangedStatus = 'TASK_CHANGED_STATUS',
  TaskChangeRequested = 'TASK_CHANGE_REQUESTED',
  TaskClosed = 'TASK_CLOSED',
  TaskClosedDueToStageChange = 'TASK_CLOSED_DUE_TO_STAGE_CHANGE',
  TaskCreated = 'TASK_CREATED',
  TaskDebriefCanceled = 'TASK_DEBRIEF_CANCELED',
  TaskDebriefCreated = 'TASK_DEBRIEF_CREATED',
  TaskDebriefRescheduled = 'TASK_DEBRIEF_RESCHEDULED',
  TaskDebriefUpdated = 'TASK_DEBRIEF_UPDATED',
  TaskDeclinedInterviewerAutoReplaced = 'TASK_DECLINED_INTERVIEWER_AUTO_REPLACED',
  TaskEmployeeEditedAvailability = 'TASK_EMPLOYEE_EDITED_AVAILABILITY',
  TaskFlagAdded = 'TASK_FLAG_ADDED',
  TaskFlagResolvedCandidateDeclined = 'TASK_FLAG_RESOLVED_CANDIDATE_DECLINED',
  TaskFlagResolvedCandidateTentative = 'TASK_FLAG_RESOLVED_CANDIDATE_TENTATIVE',
  TaskFlagResolvedChangeRequested = 'TASK_FLAG_RESOLVED_CHANGE_REQUESTED',
  TaskFlagResolvedDebriefAttendeeDeactivated = 'TASK_FLAG_RESOLVED_DEBRIEF_ATTENDEE_DEACTIVATED',
  TaskFlagResolvedDebriefAttendeeTentative = 'TASK_FLAG_RESOLVED_DEBRIEF_ATTENDEE_TENTATIVE',
  TaskFlagResolvedDebriefDeclined = 'TASK_FLAG_RESOLVED_DEBRIEF_DECLINED',
  TaskFlagResolvedInterviewerDeactivated = 'TASK_FLAG_RESOLVED_INTERVIEWER_DEACTIVATED',
  TaskFlagResolvedInterviewerTentative = 'TASK_FLAG_RESOLVED_INTERVIEWER_TENTATIVE',
  TaskFlagResolvedInterviewDeclined = 'TASK_FLAG_RESOLVED_INTERVIEW_DECLINED',
  TaskInterviewerAdded = 'TASK_INTERVIEWER_ADDED',
  TaskInterviewerNoResponse = 'TASK_INTERVIEWER_NO_RESPONSE',
  TaskInterviewerRsvpAccepted = 'TASK_INTERVIEWER_RSVP_ACCEPTED',
  TaskInterviewerRsvpDeclined = 'TASK_INTERVIEWER_RSVP_DECLINED',
  TaskInterviewerRsvpNeedsAction = 'TASK_INTERVIEWER_RSVP_NEEDS_ACTION',
  TaskInterviewerRsvpTentative = 'TASK_INTERVIEWER_RSVP_TENTATIVE',
  TaskInterviewCandidateReminderSent = 'TASK_INTERVIEW_CANDIDATE_REMINDER_SENT',
  TaskMarkedUrgent = 'TASK_MARKED_URGENT',
  TaskMeetingLocationUpdated = 'TASK_MEETING_LOCATION_UPDATED',
  TaskMeetingRoomAdded = 'TASK_MEETING_ROOM_ADDED',
  TaskMeetingRoomRsvp = 'TASK_MEETING_ROOM_RSVP',
  TaskMigrated = 'TASK_MIGRATED',
  TaskPerfectScheduleNotFound = 'TASK_PERFECT_SCHEDULE_NOT_FOUND',
  TaskQueueSet = 'TASK_QUEUE_SET',
  TaskQueueUnset = 'TASK_QUEUE_UNSET',
  TaskRcAdjustInterviewerRsvp = 'TASK_RC_ADJUST_INTERVIEWER_RSVP',
  TaskReadyForCandidateComm = 'TASK_READY_FOR_CANDIDATE_COMM',
  TaskReopened = 'TASK_REOPENED',
  TaskRequirementAppDebriefAdded = 'TASK_REQUIREMENT_APP_DEBRIEF_ADDED',
  TaskRequirementAppDebriefRemoved = 'TASK_REQUIREMENT_APP_DEBRIEF_REMOVED',
  TaskRequirementCandidateAvailabilityAdded = 'TASK_REQUIREMENT_CANDIDATE_AVAILABILITY_ADDED',
  TaskRequirementCandidateAvailabilityRemoved = 'TASK_REQUIREMENT_CANDIDATE_AVAILABILITY_REMOVED',
  TaskRequirementCandidateAvailabilityUpdated = 'TASK_REQUIREMENT_CANDIDATE_AVAILABILITY_UPDATED',
  TaskRequirementScheduleAdded = 'TASK_REQUIREMENT_SCHEDULE_ADDED',
  TaskRequirementSelfScheduleAdded = 'TASK_REQUIREMENT_SELF_SCHEDULE_ADDED',
  TaskRequirementSelfScheduleRemoved = 'TASK_REQUIREMENT_SELF_SCHEDULE_REMOVED',
  TaskRequirementSelfScheduleUpdated = 'TASK_REQUIREMENT_SELF_SCHEDULE_UPDATED',
  TaskRescheduleLogAdded = 'TASK_RESCHEDULE_LOG_ADDED',
  TaskRescheduleLogRemoved = 'TASK_RESCHEDULE_LOG_REMOVED',
  TaskRescheduleLogUpdated = 'TASK_RESCHEDULE_LOG_UPDATED',
  TaskRescheduleRecorded = 'TASK_RESCHEDULE_RECORDED',
  TaskScheduleAdded = 'TASK_SCHEDULE_ADDED',
  TaskScheduleCanceled = 'TASK_SCHEDULE_CANCELED',
  TaskScheduleInterviewAdded = 'TASK_SCHEDULE_INTERVIEW_ADDED',
  TaskScheduleInterviewCanceled = 'TASK_SCHEDULE_INTERVIEW_CANCELED',
  TaskScheduleInterviewUpdated = 'TASK_SCHEDULE_INTERVIEW_UPDATED',
  TaskScheduleRescheduled = 'TASK_SCHEDULE_RESCHEDULED',
  TaskScheduleUpdated = 'TASK_SCHEDULE_UPDATED',
  TaskSelfScheduleCandidateReminderSent = 'TASK_SELF_SCHEDULE_CANDIDATE_REMINDER_SENT',
  TaskSourcingLinkResumeUploadFailed = 'TASK_SOURCING_LINK_RESUME_UPLOAD_FAILED',
  TaskTagAdded = 'TASK_TAG_ADDED',
  TaskTagRemoved = 'TASK_TAG_REMOVED',
  TaskUnassigned = 'TASK_UNASSIGNED',
  TaskUnmarkedUrgent = 'TASK_UNMARKED_URGENT',
  TypeEmailFromCandidate = 'TYPE_EMAIL_FROM_CANDIDATE'
}

export type Actor = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ActorType;
};

/** Represents the types of actors in activity logs. */
export enum ActorType {
  Agent = 'AGENT',
  Candidate = 'CANDIDATE',
  Employee = 'EMPLOYEE',
  System = 'SYSTEM'
}

export type AddModuleMemberInput = {
  level?: InputMaybe<Scalars['Int']['input']>;
  memberId: Scalars['uuid']['input'];
  reverseShadowRequiredCount?: InputMaybe<Scalars['Int']['input']>;
  shadowRequiredCount?: InputMaybe<Scalars['Int']['input']>;
  status: TrainingStatus;
  weeklyNumInterviewLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type AddZoomHostAsInternalInviteePref = {
  __typename?: 'AddZoomHostAsInternalInviteePref';
  enabled: Scalars['Boolean']['output'];
  zoomHostUser: Array<ZoomHost>;
};

export type AdditionalAttendee = {
  __typename?: 'AdditionalAttendee';
  /**  Set when this entry names a free-form address; null when it names an employee. */
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  /**  Set when this entry names an employee; null when it names a free-form address. */
  employeeId?: Maybe<Scalars['uuid']['output']>;
  isOptional: Scalars['Boolean']['output'];
  /**
   *  Set when this entry was materialized from a dynamic audience, so the client can group or
   *  badge the members and re-offer the audience on a later edit.
   */
  sourceAudience?: Maybe<DynamicAudience>;
};

/** Represents one person added to, or removed from, an additional-attendee list. */
export type AdditionalAttendeeChange = {
  __typename?: 'AdditionalAttendeeChange';
  attendeeDisplayName?: Maybe<Scalars['String']['output']>;
  attendeeEmail: Scalars['String']['output'];
  attendeeEmployeeId?: Maybe<Scalars['uuid']['output']>;
  changeKind: AdditionalAttendeeChangeKind;
  isOptional: Scalars['Boolean']['output'];
};

/** Represents whether an additional attendee arrived on or left an invite. */
export enum AdditionalAttendeeChangeKind {
  Added = 'ADDED',
  ChangeKindUnspecified = 'CHANGE_KIND_UNSPECIFIED',
  Removed = 'REMOVED'
}

export type AdditionalAttendeeInput = {
  /**  Give exactly one of email or employeeId. */
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  /**  Defaults to false (a required attendee) when omitted. */
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *  Set this when the entry came from resolving a dynamic audience on the client, so the entry
   *  can be grouped, badged, and the audience re-offered on a later edit.
   */
  sourceAudience?: InputMaybe<DynamicAudience>;
};

export type AdditionalAttendees = {
  __typename?: 'AdditionalAttendees';
  /**
   *  One entry per recipient, each with its own role. Nullable for rollout compat. An event stored
   *  before per-recipient roles existed still answers here: its entries are materialized from
   *  `emails` and `employeeIds`, all carrying the old collection-wide `isOptional`.
   */
  attendees?: Maybe<Array<AdditionalAttendee>>;
  emails: Array<Scalars['String']['output']>;
  employeeIds: Array<Scalars['uuid']['output']>;
  employees: Array<Employee>;
  /**  One role for the whole list; it cannot express a mixed invite. Read `attendees` for roles. */
  isOptional: Scalars['Boolean']['output'];
};

/** Represents which of a task's calendar events an additional-attendee list belongs to. */
export enum AdditionalAttendeesEventKind {
  CandidateEvent = 'CANDIDATE_EVENT',
  DebriefEvent = 'DEBRIEF_EVENT',
  EventKindUnspecified = 'EVENT_KIND_UNSPECIFIED',
  InterviewerEvent = 'INTERVIEWER_EVENT'
}

export type AgentActor = Actor & {
  __typename?: 'AgentActor';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ActorType;
};

export type AgentThread = {
  __typename?: 'AgentThread';
  externalThreadId: Scalars['String']['output'];
  lastAccessedAt: Scalars['datetime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['datetime']['output'];
};

export type AgentThreadInput = {
  externalThreadId: Scalars['String']['input'];
};

export type AgentThreadRenameInput = {
  externalThreadId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type AgentThreadRenameInvalidTitleError = Error & {
  __typename?: 'AgentThreadRenameInvalidTitleError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AgentThreadRenameNotFoundError = Error & {
  __typename?: 'AgentThreadRenameNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AgentThreadRenameOutput = AgentThreadRenameInvalidTitleError | AgentThreadRenameNotFoundError | AgentThreadRenameSuccess | UnknownError;

export type AgentThreadRenameSuccess = {
  __typename?: 'AgentThreadRenameSuccess';
  externalThreadId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AgentThreadsInput = {
  pageInput: PageInput;
};

export type AgentThreadsResult = {
  __typename?: 'AgentThreadsResult';
  items: Array<AgentThread>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Output shape — what tool returned. */
export type AgentToolCallCompletedInfo = {
  __typename?: 'AgentToolCallCompletedInfo';
  isError: Scalars['Boolean']['output'];
  resultJson: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
};

/** Input shape — what tool was called and with what arguments. */
export type AgentToolCallStartInfo = {
  __typename?: 'AgentToolCallStartInfo';
  argumentsJson: Scalars['String']['output'];
  displayLabelPast: Scalars['String']['output'];
  /**
   * Human-readable feed labels resolved from the tool definition, e.g. "sending an email to the
   * candidate" / "sent an email to the candidate". Empty on rows written before labels existed.
   */
  displayLabelPresent: Scalars['String']['output'];
  toolCallId: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count?: Maybe<Scalars['numeric']['output']>;
};

/** The AI agent email organization setting is empty, so no employee can act as the agent. */
export type AiAgentEmailNotConfiguredError = Error & {
  __typename?: 'AiAgentEmailNotConfiguredError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The AI agent email organization setting holds an address that matches no member. */
export type AiAgentEmployeeNotFoundError = Error & {
  __typename?: 'AiAgentEmployeeNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AiAgentIntegrationConnectInput = {
  provider: AiAgentIntegrationProvider;
};

export type AiAgentIntegrationConnectOutput = AiAgentEmailNotConfiguredError | AiAgentEmployeeNotFoundError | AiAgentIntegrationConnectSuccess | AiAgentIntegrationProviderNotInstalledError | UnknownError;

export type AiAgentIntegrationConnectSuccess = {
  __typename?: 'AiAgentIntegrationConnectSuccess';
  redirectUri: Scalars['String']['output'];
  /**
   * Provider consent URL. Send the administrator here to grant the agent account access. The
   * provider stores the resulting tokens on the agent employee and returns to the AI settings page.
   */
  url: Scalars['String']['output'];
};

/**
 * Google or Microsoft connection state of the employee that the organization assigns as its AI
 * agent. Tokens live on that employee, never on the administrator who starts the connection.
 */
export type AiAgentIntegrationConnection = {
  __typename?: 'AiAgentIntegrationConnection';
  /**
   * Provider account that granted the tokens. Null when not connected, or when the provider
   * reported no account.
   */
  accountEmail?: Maybe<Scalars['String']['output']>;
  /** True when the agent employee holds tokens for this provider. */
  connected: Scalars['Boolean']['output'];
  /**
   * True when the organization has a matching directory integration, so the agent can connect.
   * False when an administrator must install the Google or Microsoft integration first.
   */
  installed: Scalars['Boolean']['output'];
  provider: AiAgentIntegrationProvider;
};

export type AiAgentIntegrationDisconnectInput = {
  provider: AiAgentIntegrationProvider;
};

export type AiAgentIntegrationDisconnectOutput = AiAgentEmailNotConfiguredError | AiAgentEmployeeNotFoundError | AiAgentIntegrationDisconnectSuccess | AiAgentIntegrationProviderNotInstalledError | UnknownError;

export type AiAgentIntegrationDisconnectSuccess = {
  __typename?: 'AiAgentIntegrationDisconnectSuccess';
  provider: AiAgentIntegrationProvider;
};

/**
 * Directory provider that the AI agent connects to. Each value maps to the employee-level
 * integration type that matches the organization's own Google or Microsoft install.
 */
export enum AiAgentIntegrationProvider {
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

/**
 * The organization has no Google or Microsoft directory integration for the requested provider, so
 * the agent has no application to authorize against.
 */
export type AiAgentIntegrationProviderNotInstalledError = Error & {
  __typename?: 'AiAgentIntegrationProviderNotInstalledError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** Connection state of both providers for the organization's AI agent employee. */
export type AiAgentIntegrations = {
  __typename?: 'AiAgentIntegrations';
  /** Email that the AI agent email organization setting holds. */
  agentEmail: Scalars['String']['output'];
  agentEmployeeId: Scalars['uuid']['output'];
  google: AiAgentIntegrationConnection;
  microsoft: AiAgentIntegrationConnection;
};

export type AiAgentIntegrationsOutput = AiAgentEmailNotConfiguredError | AiAgentEmployeeNotFoundError | AiAgentIntegrations | UnknownError;

export type AiContextTarget = {
  id: Scalars['uuid']['output'];
  type: AiContextTargetType;
};

export type AiContextTargetInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  type: AiContextTargetType;
};

export enum AiContextTargetType {
  Candidate = 'CANDIDATE',
  Employee = 'EMPLOYEE',
  Job = 'JOB',
  Organization = 'ORGANIZATION'
}

export type AiInstruction = {
  __typename?: 'AiInstruction';
  content: Scalars['String']['output'];
  createdAt: Scalars['datetime']['output'];
  createdBy?: Maybe<Actor>;
  id: Scalars['uuid']['output'];
  orgId: Scalars['uuid']['output'];
  target: AiContextTarget;
  updatedAt: Scalars['datetime']['output'];
  updatedBy?: Maybe<Actor>;
};

export type AiInstructionDeleteInput = {
  target: AiContextTargetInput;
};

export type AiInstructionUpsertInput = {
  content: Scalars['String']['input'];
  target: AiContextTargetInput;
};

export type AiMemory = {
  __typename?: 'AiMemory';
  content: Scalars['String']['output'];
  createdAt: Scalars['datetime']['output'];
  createdBy?: Maybe<Actor>;
  id: Scalars['uuid']['output'];
  orgId: Scalars['uuid']['output'];
  target: AiContextTarget;
  updatedAt: Scalars['datetime']['output'];
  updatedBy?: Maybe<Actor>;
};

export type AiMemoryCreateInput = {
  content: Scalars['String']['input'];
  target: AiContextTargetInput;
};

export type AiMemoryUpdateInput = {
  content: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
};

export type AiOrgCustomLlmPref = {
  __typename?: 'AiOrgCustomLlmPref';
  apiKey?: Maybe<Scalars['String']['output']>;
  completionUrl: Scalars['String']['output'];
  headers: Array<AiOrgLlmHeaderEntry>;
  model: Scalars['String']['output'];
  responseJsonPath?: Maybe<Scalars['String']['output']>;
  wireFormat: Scalars['String']['output'];
};

export type AiOrgLlmHeaderEntry = {
  __typename?: 'AiOrgLlmHeaderEntry';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum AmplitudeLoggingHeaderNames {
  XAmpCreateLocation = 'X_AMP_CREATE_LOCATION'
}

/** A durable REST API-request audit record. */
export type ApiRequestAuditLogEntry = {
  __typename?: 'ApiRequestAuditLogEntry';
  actor?: Maybe<Employee>;
  actorId: Scalars['String']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  operationId?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  requestBody: AuditLogPayload;
  requestQuery: AuditLogPayload;
  requestedAt: Scalars['datetime']['output'];
  responseBody: AuditLogPayload;
  statusCode: Scalars['Int']['output'];
  tokenName?: Maybe<Scalars['String']['output']>;
  tokenType: PlatformAuditTokenType;
};

/** Optional inclusive UTC date range and cursor for REST API audit records. */
export type ApiRequestAuditLogsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** A page of REST API-request audit records. */
export type ApiRequestAuditLogsResult = {
  __typename?: 'ApiRequestAuditLogsResult';
  items: Array<ApiRequestAuditLogEntry>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Input type for querying application stage candidate events. */
export type AppStgCandidateEventsAppStgInput = {
  orderBy?: InputMaybe<DateOrderByInput>;
};

export type AppStgInterviewsAppStgInput = {
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<DateOrderByInput>;
};

export type Application = {
  __typename?: 'Application';
  activityLogs: ActivityLogsResult;
  applicationDebriefs?: Maybe<Array<ApplicationDebrief>>;
  applicationStages?: Maybe<Array<ApplicationStage>>;
  atsApplication?: Maybe<AtsApplication>;
  atsId?: Maybe<Scalars['String']['output']>;
  atsType?: Maybe<AtsType>;
  candidate?: Maybe<Candidate>;
  candidateId: Scalars['uuid']['output'];
  candidatePortalNote?: Maybe<CandidatePortalNote>;
  coordinator?: Maybe<Employee>;
  createdAt: Scalars['datetime']['output'];
  currentJobStageActiveTaskCount: Scalars['Int']['output'];
  existingConversations?: Maybe<Array<Conversation>>;
  hiringManager?: Maybe<Employee>;
  hiringManagerId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  isAtsDisabled: Scalars['Boolean']['output'];
  isPortalAccessible: Scalars['Boolean']['output'];
  isTaskEnabled: Scalars['Boolean']['output'];
  job?: Maybe<Job>;
  jobId: Scalars['uuid']['output'];
  jobStage?: Maybe<JobStage>;
  jobStageCount?: Maybe<Scalars['numeric']['output']>;
  jobStageId?: Maybe<Scalars['uuid']['output']>;
  org?: Maybe<Org>;
  orgId: Scalars['uuid']['output'];
  recruiter?: Maybe<Employee>;
  sourcer?: Maybe<Employee>;
  sourcingLink?: Maybe<SourcingLink>;
  state?: Maybe<ApplicationState>;
  status: ApplicationStatus;
  tasks: Array<Task>;
  upcomingApplicationStage?: Maybe<ApplicationStage>;
  updatedAt: Scalars['datetime']['output'];
  validateCanEnterScheduleFlow: ValidationResult;
  validateCanMoveStage: ValidationResult;
  validationIssuesForCreateTask: TaskCreateValidationResult;
};


export type ApplicationActivityLogsArgs = {
  input: ActivityLogsForSourceInput;
};


export type ApplicationApplicationDebriefsArgs = {
  input?: InputMaybe<ApplicationDebriefApplicationInput>;
};


export type ApplicationApplicationStagesArgs = {
  input?: InputMaybe<ApplicationStageApplicationInput>;
};


export type ApplicationExistingConversationsArgs = {
  input?: InputMaybe<ConversationsApplicationInput>;
};

export type ApplicationByAtsIdInput = {
  /** The ATS ID of the application. */
  atsId: Scalars['String']['input'];
  /** The type of ATS. */
  atsType?: InputMaybe<AtsType>;
};

/** Input for retrieving an application by its ATS ID with typed lookup errors. */
export type ApplicationByAtsIdV2Input = {
  /** The ATS ID of the application. */
  atsId: Scalars['String']['input'];
  /** The type of ATS. */
  atsType?: InputMaybe<AtsType>;
};

export type ApplicationByAtsIdV2Output = Application | ApplicationNotFoundError | ApplicationPermissionDeniedError | UnknownError;

/** Input for creating a candidate portal note for an application. */
export type ApplicationCandidatePortalNoteCreateInput = {
  applicationId: Scalars['uuid']['input'];
  content: Scalars['String']['input'];
  sendToCandidate: Scalars['Boolean']['input'];
};

/** Input for updating a candidate portal note for an application. */
export type ApplicationCandidatePortalNoteUpdateInput = {
  applicationId: Scalars['uuid']['input'];
  content: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
  sendToCandidate: Scalars['Boolean']['input'];
};

export type ApplicationDebrief = {
  __typename?: 'ApplicationDebrief';
  /** @deprecated Use additionalAttendeesV2 */
  additionalAttendees: Array<Scalars['String']['output']>;
  additionalAttendeesV2: AdditionalAttendees;
  application?: Maybe<Application>;
  applicationId?: Maybe<Scalars['uuid']['output']>;
  attendees?: Maybe<Array<ApplicationDebriefAttendee>>;
  conversation?: Maybe<Conversation>;
  conversationTemplateId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['datetime']['output']>;
  creator?: Maybe<Employee>;
  creatorEmployeeId?: Maybe<Scalars['uuid']['output']>;
  creatorUserId?: Maybe<Scalars['uuid']['output']>;
  emailTemplateId?: Maybe<Scalars['uuid']['output']>;
  endAt?: Maybe<Scalars['datetime']['output']>;
  googleCalendarId?: Maybe<Scalars['String']['output']>;
  googleEventId?: Maybe<Scalars['String']['output']>;
  googleEventUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  isPrivateCalendarEvent?: Maybe<Scalars['Boolean']['output']>;
  meetingRooms?: Maybe<Array<ApplicationDebriefRoom>>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   *  The scorecard recipients chosen while booking, if any. Empty means nobody has chosen yet, so
   *  the ATS write falls back to the configured recipient roles.
   */
  scorecardRecipientEmployeeIds: Array<Scalars['uuid']['output']>;
  startAt?: Maybe<Scalars['datetime']['output']>;
  /**  Task can be null for non Task based debriefs hence optional */
  task?: Maybe<Task>;
  updatedAt?: Maybe<Scalars['datetime']['output']>;
  videoMeetingUrl?: Maybe<Scalars['String']['output']>;
  zoomDialIns?: Maybe<Scalars['jsonb']['output']>;
  zoomHostUserId?: Maybe<Scalars['String']['output']>;
  zoomMeetingId?: Maybe<Scalars['numeric']['output']>;
  zoomPassword?: Maybe<Scalars['String']['output']>;
  zoomPstnPassword?: Maybe<Scalars['numeric']['output']>;
};

export type ApplicationDebriefApplicationInput = {
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<DateOrderByInput>;
};

export type ApplicationDebriefAttendee = {
  __typename?: 'ApplicationDebriefAttendee';
  applicationDebriefId: Scalars['uuid']['output'];
  interviewer?: Maybe<Employee>;
  interviewerId: Scalars['uuid']['output'];
  isOptional: Scalars['Boolean']['output'];
  proposedTime?: Maybe<DateTimeRangeOutput>;
  responseStatus?: Maybe<ResponseStatus>;
};

export type ApplicationDebriefRoom = {
  __typename?: 'ApplicationDebriefRoom';
  applicationDebriefId: Scalars['uuid']['output'];
  meetingRoom?: Maybe<MeetingRoom>;
  meetingRoomId: Scalars['uuid']['output'];
  responseStatus?: Maybe<ResponseStatus>;
};

export type ApplicationEmail = {
  __typename?: 'ApplicationEmail';
  application?: Maybe<Application>;
  email?: Maybe<Email>;
};

export type ApplicationEmailInput = {
  applicationId: Scalars['uuid']['input'];
};

export type ApplicationEmailOutput = {
  __typename?: 'ApplicationEmailOutput';
  items?: Maybe<Array<ApplicationEmail>>;
};

export type ApplicationNotFoundError = Error & {
  __typename?: 'ApplicationNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type ApplicationPermissionDeniedError = Error & {
  __typename?: 'ApplicationPermissionDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** Represents the response structure for application queries. */
export type ApplicationResponse = {
  __typename?: 'ApplicationResponse';
  /** A list of Application objects representing the queried applications. */
  applications?: Maybe<Array<Application>>;
  /** The total number of applications matching the query criteria. */
  total?: Maybe<Scalars['numeric']['output']>;
};

/** Input for searching applications. */
export type ApplicationSearchInput = {
  /** List of application statuses to filter by. */
  applicationStatuses?: InputMaybe<Array<InputMaybe<ApplicationStatus>>>;
  /** The name of the candidate to search for. */
  candidateName?: InputMaybe<Scalars['String']['input']>;
  /** List of coordinator IDs to filter by. */
  coordinatorIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  /** Indicates whether to show declined applications. */
  hasNoActiveTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of hiring team member IDs to filter by. */
  hiringTeamMemberIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  /** List of job IDs to filter by. */
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  /** List of job stage names to filter by. */
  jobStageNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Ordering criteria for the search results. */
  orderBy?: InputMaybe<ApplicationSearchOrderBy>;
  /** Pagination input for the query. */
  pageInput: PageInput;
  /** List of recruiter IDs to filter by. */
  recruiterIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  /** Indicates whether to show declined applications. */
  showDeclines?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of status filter groups to apply. */
  statusFilterGroups?: InputMaybe<Array<InputMaybe<StatusFilterGroup>>>;
};

/** Input for ordering application search results. */
export type ApplicationSearchOrderBy = {
  /** The direction of the ordering. */
  direction: Sort;
  /** The property to order by. */
  property: ApplicationSearchOrderByProperty;
};

/** Enum representing properties that can be used for ordering application search results. */
export enum ApplicationSearchOrderByProperty {
  LastActivityAt = 'LAST_ACTIVITY_AT',
  Name = 'NAME',
  Stage = 'STAGE',
  TaskCount = 'TASK_COUNT'
}

/** Output type for application search results. */
export type ApplicationSearchOutput = {
  __typename?: 'ApplicationSearchOutput';
  /** Indicates if there are more results available. */
  hasNext: Scalars['Boolean']['output'];
  /** The list of applications matching the search criteria. */
  items: Array<Application>;
  /** The offset to use for the next page. */
  nextOffset: Scalars['Int']['output'];
  /**
   * A lower bound for the number of matching applications. Use hasNext for pagination.
   * @deprecated The permission-filtered total is not exact. Use hasNext for pagination.
   */
  total: Scalars['Int']['output'];
};

export type ApplicationStage = {
  __typename?: 'ApplicationStage';
  application?: Maybe<Application>;
  applicationId?: Maybe<Scalars['uuid']['output']>;
  applicationStageCandidateEvents?: Maybe<Array<ApplicationStageCandidateEvent>>;
  applicationStageInterviews?: Maybe<Array<ApplicationStageInterview>>;
  atsScheduleId?: Maybe<Scalars['String']['output']>;
  atsType?: Maybe<AtsType>;
  bccRecipients?: Maybe<NotificationPreference>;
  candidateCancellationNote?: Maybe<Scalars['String']['output']>;
  candidateCancellationReason?: Maybe<CandidateCancellationReason>;
  ccRecipients?: Maybe<NotificationPreference>;
  conversation?: Maybe<Conversation>;
  createdAt: Scalars['datetime']['output'];
  creator?: Maybe<Employee>;
  emailTemplateId?: Maybe<Scalars['String']['output']>;
  endAt?: Maybe<Scalars['datetime']['output']>;
  frozenAt?: Maybe<Scalars['datetime']['output']>;
  hasCandidateDeclined: Scalars['Boolean']['output'];
  hasCandidateNeedsAction: Scalars['Boolean']['output'];
  hasCandidateTentative: Scalars['Boolean']['output'];
  hasInterviewerDeclined: Scalars['Boolean']['output'];
  hasInterviewerNeedsAction: Scalars['Boolean']['output'];
  hasInterviewerTentative: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  initialCalendarEventBody?: Maybe<Scalars['String']['output']>;
  initialCalendarEventSubject?: Maybe<Scalars['String']['output']>;
  initialEmailBody?: Maybe<Scalars['String']['output']>;
  initialEmailSubject?: Maybe<Scalars['String']['output']>;
  internalEvents: Array<ApplicationStageInternalEvent>;
  isCancelled: Scalars['Boolean']['output'];
  isHoldForRsvp: Scalars['Boolean']['output'];
  isPrivateCalendarEvent: Scalars['Boolean']['output'];
  isReadyForCandidateComms: Scalars['Boolean']['output'];
  jobStage?: Maybe<JobStage>;
  jobStageId?: Maybe<Scalars['uuid']['output']>;
  maxEndAt: Scalars['datetime']['output'];
  minStartAt: Scalars['datetime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Org>;
  orgId: Scalars['uuid']['output'];
  selfScheduleOptions?: Maybe<SelfScheduleOptions>;
  selfScheduleOptionsId?: Maybe<Scalars['uuid']['output']>;
  startAt?: Maybe<Scalars['datetime']['output']>;
  task?: Maybe<Task>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['datetime']['output'];
  videoMeetingUrl?: Maybe<Scalars['String']['output']>;
};


export type ApplicationStageApplicationStageCandidateEventsArgs = {
  input?: InputMaybe<AppStgCandidateEventsAppStgInput>;
};


export type ApplicationStageApplicationStageInterviewsArgs = {
  input?: InputMaybe<AppStgInterviewsAppStgInput>;
};


export type ApplicationStageInternalEventsArgs = {
  input?: InputMaybe<ApplicationStageInternalEventsInput>;
};

/** Input type for querying application stage applications. */
export type ApplicationStageApplicationInput = {
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<DateOrderByInput>;
};

export type ApplicationStageCandidateEvent = {
  __typename?: 'ApplicationStageCandidateEvent';
  /** @deprecated Use additionalAttendeesV2 */
  additionalAttendees: Array<Scalars['String']['output']>;
  additionalAttendeesV2: AdditionalAttendees;
  applicationStage?: Maybe<ApplicationStage>;
  applicationStageId: Scalars['uuid']['output'];
  calendar?: Maybe<Calendar>;
  calendarEventTemplateId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['datetime']['output'];
  creator?: Maybe<Employee>;
  endAt: Scalars['datetime']['output'];
  googleCalendarId?: Maybe<Scalars['String']['output']>;
  googleEventId?: Maybe<Scalars['String']['output']>;
  googleEventUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Org>;
  orgId: Scalars['uuid']['output'];
  responseStatus?: Maybe<ResponseStatus>;
  startAt: Scalars['datetime']['output'];
  updatedAt: Scalars['datetime']['output'];
};

/** Input for filtering application stages. */
export type ApplicationStageFilterInput = {
  /** List of candidate IDs to filter by. */
  candidates?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** List of interviewer IDs to filter by. */
  interviewers?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** List of recruiter IDs to filter by. */
  recruiters?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** RSVP status to filter by. */
  rsvp?: InputMaybe<EventsRsvp>;
  /** List of scheduler IDs to filter by. */
  schedulers?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** List of task assignee employee IDs to filter by. */
  taskAssignees?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** List of task creator employee IDs to filter by. */
  taskCreators?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Input for retrieving application stages. */
export type ApplicationStageInput = {
  /** Filters for the application stages. */
  filters?: InputMaybe<ApplicationStageFilterInput>;
  /** Indicates if the application stage is cancelled. */
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the job associated with the application stages. */
  jobId?: InputMaybe<Scalars['uuid']['input']>;
  /** Pagination input for the query. */
  pageInput: PageInput;
  /** The time range for the application stages. */
  timeRange?: InputMaybe<DateTimeRangeInput>;
};

export type ApplicationStageInternalEvent = {
  __typename?: 'ApplicationStageInternalEvent';
  applicationStageId: Scalars['uuid']['output'];
  attendees: Array<ApplicationStageInternalEventAttendee>;
  cancelledAt?: Maybe<Scalars['datetime']['output']>;
  createdAt: Scalars['datetime']['output'];
  creatorEmployeeId: Scalars['uuid']['output'];
  endAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['uuid']['output'];
  remoteCalendarId: Scalars['String']['output'];
  remoteEventId: Scalars['String']['output'];
  remoteEventUrl: Scalars['String']['output'];
  startAt: Scalars['datetime']['output'];
  templateId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['datetime']['output'];
};

export type ApplicationStageInternalEventAttendee = {
  __typename?: 'ApplicationStageInternalEventAttendee';
  applicationStageInternalEventId: Scalars['uuid']['output'];
  attendeeId: Scalars['uuid']['output'];
  orgId: Scalars['uuid']['output'];
  responseStatus: ResponseStatus;
};

export type ApplicationStageInternalEventsInput = {
  orderBy?: InputMaybe<DateOrderByInput>;
};

export type ApplicationStageInterview = {
  __typename?: 'ApplicationStageInterview';
  /** @deprecated Use additionalAttendeesV2 */
  additionalAttendees: Array<Scalars['String']['output']>;
  additionalAttendeesV2: AdditionalAttendees;
  applicationStage?: Maybe<ApplicationStage>;
  applicationStageId: Scalars['uuid']['output'];
  applicationStageInterviewInterviewers?: Maybe<Array<ApplicationStageInterviewInterviewer>>;
  applicationStageInterviewRooms?: Maybe<Array<ApplicationStageInterviewRoom>>;
  atsInterviewDefinition?: Maybe<AtsInterviewDefinition>;
  atsInterviewDefinitionId?: Maybe<Scalars['String']['output']>;
  atsScheduledInterviewId?: Maybe<Scalars['String']['output']>;
  /** Durable sync status of the ATS scheduled interview backing this one; null when untracked. */
  atsSyncStatus?: Maybe<ExternalObjectSyncStatus>;
  atsType?: Maybe<AtsType>;
  calendar?: Maybe<Calendar>;
  calendarEventTitle?: Maybe<Scalars['String']['output']>;
  codingInterviewUrl?: Maybe<Scalars['String']['output']>;
  collaborationLink?: Maybe<CollaborationLink>;
  collaborationLinkId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['datetime']['output'];
  creator?: Maybe<Employee>;
  creatorEmployeeId?: Maybe<Scalars['uuid']['output']>;
  emailTemplateId?: Maybe<Scalars['String']['output']>;
  endAt: Scalars['datetime']['output'];
  googleCalendarId?: Maybe<Scalars['String']['output']>;
  googleEventId?: Maybe<Scalars['String']['output']>;
  googleEventUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  interviewGuide?: Maybe<InterviewGuide>;
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  isHiddenFromCandidate: Scalars['Boolean']['output'];
  jobStageInterviewId?: Maybe<Scalars['uuid']['output']>;
  meetingLocation?: Maybe<MeetingLocation>;
  meetingLocationId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  org?: Maybe<Org>;
  orgId: Scalars['uuid']['output'];
  startAt: Scalars['datetime']['output'];
  traineeFeedback?: Maybe<ApplicationStageInterviewFeedback>;
  updatedAt: Scalars['datetime']['output'];
  videoMeetingHostEmployee?: Maybe<Employee>;
  videoMeetingHostEmployeeId?: Maybe<Scalars['uuid']['output']>;
  videoMeetingUrl?: Maybe<Scalars['String']['output']>;
  zoomDialInInfo?: Maybe<Scalars['jsonb']['output']>;
  zoomHostUserId?: Maybe<Scalars['String']['output']>;
  zoomMeetingId?: Maybe<Scalars['numeric']['output']>;
  zoomPassword?: Maybe<Scalars['String']['output']>;
  zoomPstnPassword?: Maybe<Scalars['numeric']['output']>;
};


export type ApplicationStageInterviewTraineeFeedbackArgs = {
  reviewerType?: InputMaybe<GraduationApproverType>;
};

export type ApplicationStageInterviewFeedback = {
  __typename?: 'ApplicationStageInterviewFeedback';
  decisionType?: Maybe<GraduationApproverDecisionType>;
  lastRequestedAt?: Maybe<Scalars['datetime']['output']>;
  lastRequestedBy?: Maybe<Employee>;
  nagType?: Maybe<TrainingFeedbackNagType>;
  note?: Maybe<Scalars['String']['output']>;
  reviewedAt?: Maybe<Scalars['datetime']['output']>;
  reviewer?: Maybe<Employee>;
  reviewerId?: Maybe<Scalars['uuid']['output']>;
  trainee?: Maybe<Employee>;
  traineeId?: Maybe<Scalars['uuid']['output']>;
};

export type ApplicationStageInterviewInterviewer = {
  __typename?: 'ApplicationStageInterviewInterviewer';
  applicationStageInterviewId: Scalars['uuid']['output'];
  calendarEventNote?: Maybe<Scalars['String']['output']>;
  declines?: Maybe<Array<InterviewInterviewerDeclined>>;
  interviewModuleId?: Maybe<Scalars['uuid']['output']>;
  interviewer?: Maybe<Employee>;
  interviewerId: Scalars['uuid']['output'];
  isOptional: Scalars['Boolean']['output'];
  jobStageInterviewSeatId?: Maybe<Scalars['uuid']['output']>;
  proposedTime?: Maybe<DateTimeRangeOutput>;
  responseStatus?: Maybe<ResponseStatus>;
  role?: Maybe<InterviewerRole>;
  shouldCountForModule?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationStageInterviewInterviewerResult = {
  __typename?: 'ApplicationStageInterviewInterviewerResult';
  result?: Maybe<Result>;
};

/** Input for updating an interviewer for an application stage interview. */
export type ApplicationStageInterviewInterviewerUpdateInput = {
  applicationStageInterviewId: Scalars['uuid']['input'];
  interviewerId: Scalars['uuid']['input'];
  interviewerRole?: InputMaybe<InterviewerRole>;
  rsvp?: InputMaybe<InterviewerRsvpInput>;
  shouldCountForModule?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for upserting an interviewer for an application stage interview. */
export type ApplicationStageInterviewInterviewerUpsertInput = {
  applicationStageInterviewId: Scalars['uuid']['input'];
  interviewerId: Scalars['uuid']['input'];
  interviewerRole?: InputMaybe<InterviewerRole>;
  rsvp?: InputMaybe<InterviewerRsvpInput>;
  shouldCountForModule?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplicationStageInterviewRoom = {
  __typename?: 'ApplicationStageInterviewRoom';
  /** This is a computed field. */
  applicationStageInterviewId: Scalars['uuid']['output'];
  id: Scalars['String']['output'];
  meetingRoom?: Maybe<MeetingRoom>;
  meetingRoomId: Scalars['uuid']['output'];
  responseStatus?: Maybe<ResponseStatus>;
};

export type ApplicationStageInterviewsInput = {
  pageInput: PageInput;
  role?: InputMaybe<InterviewerRole>;
};

export type ApplicationStageInterviewsOutput = {
  __typename?: 'ApplicationStageInterviewsOutput';
  items: Array<ApplicationStageInterview>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Output for application stages query. */
export type ApplicationStageOutput = {
  __typename?: 'ApplicationStageOutput';
  /** The list of application stages. */
  items?: Maybe<Array<ApplicationStage>>;
  /** The cursor for the next page of results. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents the current state of an application in the recruitment process.
 * This type provides boolean flags for various stages and conditions of an application.
 */
export type ApplicationState = {
  __typename?: 'ApplicationState';
  /** Indicates whether availability has been requested from the candidate for scheduling. */
  isAvailabilityRequested?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application or associated interview has been canceled. */
  isCanceled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the candidate has declined to proceed with the application or interview. */
  isCandidateDeclined?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application process (e.g., interview or assessment) has been completed. */
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application has been marked as completed in the Applicant Tracking System (ATS). */
  isCompletedInAts?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application is on hold pending an RSVP from the candidate or interviewer. */
  isHoldForRsvp?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether an interviewer has declined to participate in the scheduled interview. */
  isInterviewerDeclined?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application is not schedulable for an interview or assessment. */
  isNotScheduleable?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application is currently in an ongoing stage (e.g., interview in progress). */
  isOngoing?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application is ready for candidate communications (e.g., sending interview details). */
  isReadyForCandidateComms?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application is ready to be scheduled for an interview or assessment. */
  isReadyToSchedule?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application is currently schedulable for an interview or assessment. */
  isSchedulable?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application has been scheduled for an interview or assessment. */
  isScheduled?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application has been scheduled in the Applicant Tracking System (ATS). */
  isScheduledInAts?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether a self-scheduling request has been sent to the candidate. */
  isSelfScheduleRequested?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the application has not yet been scheduled for an interview or assessment. */
  isUnscheduled?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Enum representing the status of an application.
 * This enum should be in sync with interview/client/src/main/proto/interview-db.proto#Application
 */
export enum ApplicationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Converted = 'CONVERTED',
  Hired = 'HIRED',
  Rejected = 'REJECTED'
}

/** Input for updating an application. */
export type ApplicationUpdateInput = {
  applicationId: Scalars['uuid']['input'];
  coordinatorId?: InputMaybe<Scalars['uuid']['input']>;
  hiringManagerId?: InputMaybe<Scalars['uuid']['input']>;
  isPortalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated No longer supported */
  isTaskEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  recruiterId?: InputMaybe<Scalars['uuid']['input']>;
  sourcerId?: InputMaybe<Scalars['uuid']['input']>;
};

export type ApplicationV2Input = {
  id: Scalars['uuid']['input'];
};

export type ApplicationV2Output = Application | ApplicationNotFoundError | ApplicationPermissionDeniedError | UnknownError;

/** Ashby-specific fields for applications. */
export type AshbyApplication = {
  __typename?: 'AshbyApplication';
  interviewPlanId: Scalars['String']['output'];
};

/** Ashby-specific fields for candidates. */
export type AshbyCandidate = {
  __typename?: 'AshbyCandidate';
  profileUrl: Scalars['String']['output'];
};

export type AshbyIntegration = {
  __typename?: 'AshbyIntegration';
  apiKey: Scalars['String']['output'];
};

export type AshbyIntegrationHealth = {
  __typename?: 'AshbyIntegrationHealth';
  isDefaultRemoteInterviewActive: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

/** Ashby-specific fields for interview definitions. */
export type AshbyInterviewDefinition = {
  __typename?: 'AshbyInterviewDefinition';
  ashbyType: Scalars['String']['output'];
  externalTitle: Scalars['String']['output'];
  internalTitle: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  isDebrief: Scalars['Boolean']['output'];
  isFeedbackRequested: Scalars['Boolean']['output'];
  isFeedbackRequired: Scalars['Boolean']['output'];
};

/** Ashby-specific fields for jobs. */
export type AshbyJob = {
  __typename?: 'AshbyJob';
  defaultInterviewPlanId: Scalars['String']['output'];
};

/** Represents an application in an Applicant Tracking System (ATS). */
export type AtsApplication = {
  __typename?: 'AtsApplication';
  atsCandidateId: Scalars['String']['output'];
  atsFields?: Maybe<AtsFieldsApplication>;
  atsId: Scalars['String']['output'];
  atsJobId: Scalars['String']['output'];
  atsJobStageId: Scalars['String']['output'];
  atsScheduledInterviews?: Maybe<Array<AtsScheduledInterview>>;
  atsType: AtsType;
  atsUrl?: Maybe<Scalars['String']['output']>;
  canMoveJobStage: Scalars['Boolean']['output'];
  notSchedulableReason?: Maybe<AtsNotSchedulableReason>;
  orgId: Scalars['uuid']['output'];
  status: AtsApplicationStatus;
};

/** Possible statuses for an ATS application. */
export enum AtsApplicationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Converted = 'CONVERTED',
  Hired = 'HIRED',
  NotSet = 'NOT_SET',
  Rejected = 'REJECTED'
}

/** Represents a candidate in an Applicant Tracking System (ATS). */
export type AtsCandidate = {
  __typename?: 'AtsCandidate';
  atsFields?: Maybe<AtsFieldsCandidate>;
  atsId: Scalars['String']['output'];
  atsType: AtsType;
  atsUrl: Scalars['String']['output'];
  emails: Array<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['uuid']['output'];
  primaryEmail: Scalars['String']['output'];
};

export type AtsConfig = SmartRecruitersConfig;

/** Union of ATS-specific fields for applications. */
export type AtsFieldsApplication = AshbyApplication | WorkdayApplication;

/** Union of ATS-specific fields for candidates. */
export type AtsFieldsCandidate = AshbyCandidate | GreenhouseCandidate | LeverCandidate | WorkdayCandidate;

/** Union of ATS-specific fields for interview definitions. */
export type AtsFieldsInterviewDefinition = AshbyInterviewDefinition | GemInterviewDefinition | GreenhouseInterviewDefinition | LeverInterviewDefinition | WorkdayInterviewDefinition;

/** Union of ATS-specific fields for jobs. */
export type AtsFieldsJob = AshbyJob | GemJob | GreenhouseJob | SmartRecruitersJob | WorkdayJob;

/** Raw ATS IDs. The ATS integration parses each ID at its provider boundary. */
export type AtsIdSelection = {
  __typename?: 'AtsIdSelection';
  ids: Array<Scalars['String']['output']>;
};

/** Represents an interview definition in an Applicant Tracking System (ATS). */
export type AtsInterviewDefinition = {
  __typename?: 'AtsInterviewDefinition';
  /** Additional ATS-specific fields for the interview definition. */
  atsFields?: Maybe<AtsFieldsInterviewDefinition>;
  /** Unique identifier for the interview definition in the ATS. */
  atsId: Scalars['String']['output'];
  /** The ATS job ID associated with this interview definition, if any. */
  atsJobId?: Maybe<Scalars['String']['output']>;
  /** The ATS job stage associated with this interview definition, if any. */
  atsJobStage?: Maybe<AtsJobStage>;
  /** The ATS job stage ID associated with this interview definition, if any. */
  atsJobStageId?: Maybe<Scalars['String']['output']>;
  /** The type of ATS this interview definition belongs to. */
  atsType: AtsType;
  /** Name of the interview definition. */
  name: Scalars['String']['output'];
  /** The organization ID associated with this interview definition. */
  orgId: Scalars['uuid']['output'];
  /** Indicates whether this interview definition is schedulable. */
  schedulable?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for retrieving ATS interview definitions by ATS-specific IDs. */
export type AtsInterviewDefinitionsByIdsInput = {
  /** ATS-specific interview definition IDs. */
  atsInterviewDefinitionIds: Array<Scalars['String']['input']>;
  /** The ATS that owns the interview definitions. */
  atsType: AtsType;
};

/** Input for retrieving ATS interview definitions. */
export type AtsInterviewDefinitionsInput = {
  /** The unique identifier of the ATS job. */
  atsJobId: Scalars['String']['input'];
  /** Indicates whether the interview definitions should be schedulable. */
  schedulable: Scalars['Boolean']['input'];
};

/** Output type for ATS interview definitions query. */
export type AtsInterviewDefinitionsOutput = {
  __typename?: 'AtsInterviewDefinitionsOutput';
  /** List of ATS interview definitions. */
  atsInterviewDefinitions?: Maybe<Array<AtsInterviewDefinition>>;
};

/** Represents a job in an Applicant Tracking System (ATS). */
export type AtsJob = {
  __typename?: 'AtsJob';
  atsCustomerFriendlyId?: Maybe<Scalars['String']['output']>;
  atsFields?: Maybe<AtsFieldsJob>;
  atsId: Scalars['String']['output'];
  atsType: AtsType;
  atsUrl?: Maybe<Scalars['String']['output']>;
  isConfidential?: Maybe<Scalars['Boolean']['output']>;
  /** Currently for Greenhouse and Gem */
  jobRequisitionId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Represents a job stage in an Applicant Tracking System (ATS). */
export type AtsJobStage = {
  __typename?: 'AtsJobStage';
  atsId: Scalars['String']['output'];
  atsJobId: Scalars['String']['output'];
  atsType: AtsType;
  /**  Not implemented yet! */
  canResetInterviewPlan: Scalars['Boolean']['output'];
  index: Scalars['Int']['output'];
  isSchedulable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
};

/** The ATS job sync scope. Exactly one strategy is stored when this pref exists. */
export type AtsJobSyncScopePref = {
  __typename?: 'AtsJobSyncScopePref';
  departments?: Maybe<AtsIdSelection>;
  jobs?: Maybe<AtsIdSelection>;
  offices?: Maybe<AtsIdSelection>;
};

export type AtsJobSyncScopeUpdateInput = {
  allJobs?: InputMaybe<Scalars['Boolean']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  officeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AtsJobSyncScopeUpdateInvalidSelectionError = Error & {
  __typename?: 'AtsJobSyncScopeUpdateInvalidSelectionError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AtsJobSyncScopeUpdateNotConnectedError = Error & {
  __typename?: 'AtsJobSyncScopeUpdateNotConnectedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AtsJobSyncScopeUpdateOutput = AtsJobSyncScopeUpdateInvalidSelectionError | AtsJobSyncScopeUpdateNotConnectedError | AtsJobSyncScopeUpdateSuccess | UnknownError;

export type AtsJobSyncScopeUpdateSuccess = {
  __typename?: 'AtsJobSyncScopeUpdateSuccess';
  scope?: Maybe<AtsJobSyncScopePref>;
};

/** Reasons why an application might not be schedulable. */
export enum AtsNotSchedulableReason {
  NotSchedulable = 'NOT_SCHEDULABLE',
  NotSchedulableOnCurrentStep = 'NOT_SCHEDULABLE_ON_CURRENT_STEP'
}

/** Live Greenhouse department. */
export type AtsRemoteDepartment = {
  __typename?: 'AtsRemoteDepartment';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
};

/** Greenhouse denied access to the remote list. */
export type AtsRemoteDepartmentsAccessDeniedError = Error & {
  __typename?: 'AtsRemoteDepartmentsAccessDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The Greenhouse OAuth connection lacks the required scope. */
export type AtsRemoteDepartmentsInsufficientScopeError = Error & {
  __typename?: 'AtsRemoteDepartmentsInsufficientScopeError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

/** The organization has no Greenhouse OAuth connection. */
export type AtsRemoteDepartmentsNotConnectedError = Error & {
  __typename?: 'AtsRemoteDepartmentsNotConnectedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AtsRemoteDepartmentsOutput = AtsRemoteDepartmentsAccessDeniedError | AtsRemoteDepartmentsInsufficientScopeError | AtsRemoteDepartmentsNotConnectedError | AtsRemoteDepartmentsSuccess | UnknownError;

/** Successful live Greenhouse department list. */
export type AtsRemoteDepartmentsSuccess = {
  __typename?: 'AtsRemoteDepartmentsSuccess';
  items: Array<AtsRemoteDepartment>;
};

/** Live Greenhouse job. */
export type AtsRemoteJob = {
  __typename?: 'AtsRemoteJob';
  departmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  officeIds: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Greenhouse denied access to the remote list. */
export type AtsRemoteJobsAccessDeniedError = Error & {
  __typename?: 'AtsRemoteJobsAccessDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/**
 * Input for hydrating selected Greenhouse jobs. An empty list returns open jobs.
 * When IDs are present, the list must contain at most 500 unique IDs.
 */
export type AtsRemoteJobsInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The Greenhouse OAuth connection lacks the required scope. */
export type AtsRemoteJobsInsufficientScopeError = Error & {
  __typename?: 'AtsRemoteJobsInsufficientScopeError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

/** The selected job ID list is too large or contains a duplicate. */
export type AtsRemoteJobsInvalidInputError = Error & {
  __typename?: 'AtsRemoteJobsInvalidInputError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The organization has no Greenhouse OAuth connection. */
export type AtsRemoteJobsNotConnectedError = Error & {
  __typename?: 'AtsRemoteJobsNotConnectedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AtsRemoteJobsOutput = AtsRemoteJobsAccessDeniedError | AtsRemoteJobsInsufficientScopeError | AtsRemoteJobsInvalidInputError | AtsRemoteJobsNotConnectedError | AtsRemoteJobsSuccess | UnknownError;

/** Successful live Greenhouse job list. */
export type AtsRemoteJobsSuccess = {
  __typename?: 'AtsRemoteJobsSuccess';
  items: Array<AtsRemoteJob>;
};

/**
 * Input for refreshing Greenhouse remote lists and hydrating selected jobs. An empty job ID list
 * returns open jobs.
 */
export type AtsRemoteListsInput = {
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Live Greenhouse office. */
export type AtsRemoteOffice = {
  __typename?: 'AtsRemoteOffice';
  id: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
};

/** Greenhouse denied access to the remote list. */
export type AtsRemoteOfficesAccessDeniedError = Error & {
  __typename?: 'AtsRemoteOfficesAccessDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The Greenhouse OAuth connection lacks the required scope. */
export type AtsRemoteOfficesInsufficientScopeError = Error & {
  __typename?: 'AtsRemoteOfficesInsufficientScopeError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
  scope: Scalars['String']['output'];
};

/** The organization has no Greenhouse OAuth connection. */
export type AtsRemoteOfficesNotConnectedError = Error & {
  __typename?: 'AtsRemoteOfficesNotConnectedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type AtsRemoteOfficesOutput = AtsRemoteOfficesAccessDeniedError | AtsRemoteOfficesInsufficientScopeError | AtsRemoteOfficesNotConnectedError | AtsRemoteOfficesSuccess | UnknownError;

/** Successful live Greenhouse office list. */
export type AtsRemoteOfficesSuccess = {
  __typename?: 'AtsRemoteOfficesSuccess';
  items: Array<AtsRemoteOffice>;
};

/** Represents a scheduled interview in an Applicant Tracking System (ATS). */
export type AtsScheduledInterview = {
  __typename?: 'AtsScheduledInterview';
  atsApplicationId: Scalars['String']['output'];
  atsCandidateId: Scalars['String']['output'];
  atsCreatorUserId?: Maybe<Scalars['String']['output']>;
  atsId: Scalars['String']['output'];
  atsInterviewDefinition?: Maybe<AtsInterviewDefinition>;
  atsInterviewDefinitionId: Scalars['String']['output'];
  atsScheduledId?: Maybe<Scalars['String']['output']>;
  atsType: AtsType;
  createdAt: Scalars['datetime']['output'];
  endAt: Scalars['datetime']['output'];
  interviewers?: Maybe<Array<AtsScheduledInterviewInterviewer>>;
  orgId: Scalars['uuid']['output'];
  startAt: Scalars['datetime']['output'];
  status: AtsScheduledInterviewStatus;
};

/** Represents an interviewer for a scheduled interview in an ATS. */
export type AtsScheduledInterviewInterviewer = {
  __typename?: 'AtsScheduledInterviewInterviewer';
  atsScheduledInterviewId: Scalars['String']['output'];
  atsUser?: Maybe<AtsUser>;
  atsUserId: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  responseStatus?: Maybe<ResponseStatus>;
};

/** Possible statuses for a scheduled interview in an ATS. */
export enum AtsScheduledInterviewStatus {
  AwaitingFeedback = 'AWAITING_FEEDBACK',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Scheduled = 'SCHEDULED',
  ToBeScheduled = 'TO_BE_SCHEDULED'
}

export enum AtsType {
  Ashby = 'ASHBY',
  Gem = 'GEM',
  Greenhouse = 'GREENHOUSE',
  Kula = 'KULA',
  Lever = 'LEVER',
  SmartRecruiters = 'SMART_RECRUITERS',
  Workday = 'WORKDAY'
}

/** Represents a user in an Applicant Tracking System (ATS). */
export type AtsUser = {
  __typename?: 'AtsUser';
  atsId: Scalars['String']['output'];
  atsType: AtsType;
  disabled: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDisabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Input for updating the association between an ATS user and an employee. */
export type AtsUserEmployeeAssociationUpdateInput = {
  atsUserId: Scalars['String']['input'];
  employeeId: Scalars['uuid']['input'];
  executeUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of updating the association between an ATS user and an employee. */
export type AtsUserEmployeeAssociationUpdateResult = {
  __typename?: 'AtsUserEmployeeAssociationUpdateResult';
  atsUser: AtsUser;
};

/** Input for retrieving ATS users. */
export type AtsUserInput = {
  /** The name to filter ATS users by (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Pagination input for the query. */
  pageInput: PageInput;
};

/** Output for ATS users query. */
export type AtsUserOutput = {
  __typename?: 'AtsUserOutput';
  /** The list of ATS users. */
  items?: Maybe<Array<AtsUser>>;
  /** The cursor for the next page of results. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['numeric']['output']>;
  timestamp?: Maybe<Scalars['numeric']['output']>;
};

export type AttachmentInput = {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  size?: InputMaybe<Scalars['numeric']['input']>;
  timestamp?: InputMaybe<Scalars['numeric']['input']>;
};

export enum AttributeNameType {
  Country = 'COUNTRY',
  Custom = 'CUSTOM',
  Department = 'DEPARTMENT',
  Level = 'LEVEL',
  Location = 'LOCATION',
  Team = 'TEAM'
}

export type AttributeNameValueMapInput = {
  attributeNameId: Scalars['uuid']['input'];
  attributeValueIds: Array<Scalars['uuid']['input']>;
};

export type AttributeValueEmployeesInput = {
  attributeNameId: Scalars['uuid']['input'];
  attributeTagValueId: Scalars['uuid']['input'];
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** A captured, redacted, and size-bounded audit payload. */
export type AuditLogPayload = AbsentAuditLogPayload | CapturedAuditLogPayload | ExpiredAuditLogPayload | TooLargeAuditLogPayload;

export type AutomatedTaskOnBehalfOf = {
  __typename?: 'AutomatedTaskOnBehalfOf';
  backupSenderEmployee?: Maybe<Employee>;
  dynamicAudience?: Maybe<DynamicAudience>;
  employee?: Maybe<Employee>;
};

/** If dynamicAudience does not access backupSenderEmployeeId will be used. */
export type AutomatedTaskOnBehalfOfInput = {
  backupSenderEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  dynamicAudience?: InputMaybe<DynamicAudience>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
};

/**  ---- Automation Dropdown Options ---- */
export type AutomationDepartment = {
  __typename?: 'AutomationDepartment';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
};

export type AutomationDepartmentsInput = {
  page: PageInput;
};

export type AutomationDepartmentsOutput = {
  __typename?: 'AutomationDepartmentsOutput';
  items: Array<AutomationDepartment>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type AutomationJobLocationsOutput = {
  __typename?: 'AutomationJobLocationsOutput';
  items: Array<Scalars['String']['output']>;
};

/**
 * One classified span of the projection window.
 *
 * The type carries spans and classifications only. It has no event title, attendee, description, or
 * any other event content, for any actor, so the projection cannot leak calendar content.
 */
export type AvailabilityInterval = {
  __typename?: 'AvailabilityInterval';
  /** When the interval ends. */
  endAt: Scalars['datetime']['output'];
  /** When the interval starts. */
  startAt: Scalars['datetime']['output'];
  /** What the interval means. */
  type: AvailabilityIntervalType;
};

/**
 * How one interval of the projection window is classified.
 *
 * The values mirror the interview service's `AvailabilityIntervalType`, which in turn mirrors the
 * scheduling engine's own vocabulary. `FREE` is the derived free time. A value is a conflict when it
 * blocks free time under the input toggles, and it then explains why an instant is not free.
 * `RECRUITING_BLOCK` and `AVAILABLE_TIME_BLOCK` are the two values the toggles can relax: a relaxed
 * block is returned at its full extent as bookable context, so `FREE` may overlap it and a client can
 * mark those slots as the ones the interviewer set aside. An ignored load limit is not returned.
 */
export enum AvailabilityIntervalType {
  /**
   * An event the interviewer tagged as available time. It blocks free time only when
   * `canScheduleOverAvailableKeywords` is false; when true it is context that free time may
   * overlap.
   */
  AvailableTimeBlock = 'AVAILABLE_TIME_BLOCK',
  /** Buffer time the interviewer keeps around a scheduled interview. */
  Buffer = 'BUFFER',
  /** A busy calendar event with no tag. */
  CalendarConflict = 'CALENDAR_CONFLICT',
  /** A company holiday. The interval covers the whole affected local day. */
  CompanyHoliday = 'COMPANY_HOLIDAY',
  /** An event with an attendee outside the organization. */
  External = 'EXTERNAL',
  /** A focus-time event. */
  FocusTime = 'FOCUS_TIME',
  /** The interviewer is available. The projection is an estimate, not a booking guarantee. */
  Free = 'FREE',
  /**
   * Empty calendar time the organization does not schedule over. Present only when the input
   * clears `canScheduleOverFreeTime`.
   */
  FreeTime = 'FREE_TIME',
  /** A hard conflict supplied by the caller. */
  HardConflict = 'HARD_CONFLICT',
  /**
   * The interviewer's calendar has a delegate, so the engine never schedules on it. The interval
   * covers the whole window and `FREE` is empty.
   */
  HasCalendarDelegate = 'HAS_CALENDAR_DELEGATE',
  /** A one-on-one meeting. */
  OneOnOne = 'ONE_ON_ONE',
  /** An out-of-office event. */
  Ooo = 'OOO',
  /** Time outside the interviewer's effective work hours. */
  OutsideWorkHours = 'OUTSIDE_WORK_HOURS',
  /**
   * The interviewer reached their daily interview limit. The interval covers the whole affected
   * local day.
   */
  OverDailyLimit = 'OVER_DAILY_LIMIT',
  /**
   * The interviewer reached their weekly interview limit. The interval covers the whole affected
   * local day.
   */
  OverWeeklyLimit = 'OVER_WEEKLY_LIMIT',
  /** The interviewer paused interviewing across this span. */
  Paused = 'PAUSED',
  /**
   * A span on a calendar the actor cannot read. The projection keeps the times and drops
   * everything else.
   */
  PrivateCalendar = 'PRIVATE_CALENDAR',
  /**
   * A recruiting block. It blocks free time only when `canScheduleOverRecruitingKeywords` is
   * false; when true it is context that free time may overlap, which marks those slots as the ones
   * the interviewer set aside for recruiting.
   */
  RecruitingBlock = 'RECRUITING_BLOCK',
  /** A ModernLoop or ATS interview the interviewer is already booked for. */
  ScheduledInterview = 'SCHEDULED_INTERVIEW',
  /** A generic time block on the interviewer's calendar. */
  TimeBlock = 'TIME_BLOCK',
  /** An event the interviewer tagged as unavailable time. */
  UnavailableTimeBlock = 'UNAVAILABLE_TIME_BLOCK'
}

/** Enum representing the types of blocks available in a portal template. */
export enum BlockType {
  ContentCard = 'CONTENT_CARD',
  Divider = 'DIVIDER',
  Image = 'IMAGE',
  LinkedCard = 'LINKED_CARD',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export enum BoolEmployeePref {
  /**  keep-sorted:begin */
  BoolAllowSendOnBehalfOfForAutomateTaskCreate = 'bool_allow_send_on_behalf_of_for_automate_task_create',
  BoolHideTaskTimeline = 'bool_hide_task_timeline',
  BoolShowTasksOnCandidateDashboard = 'bool_show_tasks_on_candidate_dashboard'
}

export type BoolEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'BoolEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  value?: Maybe<Scalars['Boolean']['output']>;
};

export enum BoolOrgPref {
  /**  keep-sorted:begin */
  BoolAiEnabledForOrg = 'bool_ai_enabled_for_org',
  BoolAllSchedulerCalendarsBookable = 'bool_all_scheduler_calendars_bookable',
  BoolAllowOverlappingInterviewTimeRanges = 'bool_allow_overlapping_interview_time_ranges',
  BoolAutoCancelTasksOnApplicationClose = 'bool_auto_cancel_tasks_on_application_close',
  BoolAutomaticallyReplaceDeclinedInterviewer = 'bool_automatically_replace_declined_interviewer',
  BoolAvailabilityRequestBookPerfectSchedule = 'bool_availability_request_book_perfect_schedule',
  BoolAvailabilityRequestCanScheduleOverAvailableKeywords = 'bool_availability_request_can_schedule_over_available_keywords',
  BoolAvailabilityRequestCanScheduleOverFreeTime = 'bool_availability_request_can_schedule_over_free_time',
  BoolAvailabilityRequestCanScheduleOverRecruitingKeywords = 'bool_availability_request_can_schedule_over_recruiting_keywords',
  BoolAvailabilityRequestShouldRespectLoadLimit = 'bool_availability_request_should_respect_load_limit',
  BoolAvailabilityRequestUseRollingWindow = 'bool_availability_request_use_rolling_window',
  BoolCandidateFacingShowInterviewName = 'bool_candidate_facing_show_interview_name',
  BoolCandidateSchedulingRequestChangeEnabled = 'bool_candidate_scheduling_request_change_enabled',
  BoolDeleteOrphanedZoomMeetings = 'bool_delete_orphaned_zoom_meetings',
  BoolEventVisibilityIsPrivate = 'bool_event_visibility_is_private',
  BoolHasVerifiedCandidateWritePermission = 'bool_has_verified_candidate_write_permission',
  BoolHideExternalJobName = 'bool_hide_external_job_name',
  BoolHideOrgNameFromCandidatePortal = 'bool_hide_org_name_from_candidate_portal',
  BoolIncludeResumeInChat = 'bool_include_resume_in_chat',
  BoolNotifyEmailInterviewerDeclined = 'bool_notify_email_interviewer_declined',
  BoolNotifySlack_24HoursReminderInterviewerDirect = 'bool_notify_slack_24_hours_reminder_interviewer_direct',
  BoolNotifySlack_24hoursreminder = 'bool_notify_slack_24hoursreminder',
  BoolNotifySlackInterviewerIncludeRcNoResponse = 'bool_notify_slack_interviewer_include_rc_no_response',
  BoolNotifySlackInterviewerNoResponse = 'bool_notify_slack_interviewer_no_response',
  BoolOnlyUseNumericPasscodeForZoom = 'bool_only_use_numeric_passcode_for_zoom',
  BoolScimManagedUserRoles = 'bool_scim_managed_user_roles',
  BoolSecurityAllowStorageOfEventAttendees = 'bool_security_allow_storage_of_event_attendees',
  BoolSecurityAllowStorageOfEventDescriptions = 'bool_security_allow_storage_of_event_descriptions',
  BoolSelfScheduleRequestCanScheduleOverAvailableKeywords = 'bool_self_schedule_request_can_schedule_over_available_keywords',
  BoolSelfScheduleRequestCanScheduleOverFreeTime = 'bool_self_schedule_request_can_schedule_over_free_time',
  BoolSelfScheduleRequestCanScheduleOverRecruitingKeywords = 'bool_self_schedule_request_can_schedule_over_recruiting_keywords',
  BoolSelfScheduleRequestShouldRespectLoadLimit = 'bool_self_schedule_request_should_respect_load_limit',
  BoolSelfScheduleRequestUseRollingWindow = 'bool_self_schedule_request_use_rolling_window',
  BoolShouldAddMultipleTrainees = 'bool_should_add_multiple_trainees',
  BoolShouldSendCandidatePulse = 'bool_should_send_candidate_pulse',
  BoolShouldWriteActivityBackToAts = 'bool_should_write_activity_back_to_ats',
  BoolShouldWriteEmailBackToAts = 'bool_should_write_email_back_to_ats',
  BoolSyncScorecardsFromAts = 'bool_sync_scorecards_from_ats',
  BoolSyncSlackUserImages = 'bool_sync_slack_user_images',
  BoolTreatFocusTimeAsConflict = 'bool_treat_focus_time_as_conflict',
  BoolUseOutlookDisplayNameForNames = 'bool_use_outlook_display_name_for_names',
  BoolUseSchedulerCalendarToken = 'bool_use_scheduler_calendar_token',
  BoolZoomMeetingLinkShowUrl = 'bool_zoom_meeting_link_show_url'
}

/** Represents a branding theme for the candidate portal. */
export type BrandingTheme = {
  __typename?: 'BrandingTheme';
  /** The URL of the cover image used in the branding theme. */
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the branding theme was created. */
  createdAt: Scalars['datetime']['output'];
  /** The URL of the favicon image used in the branding theme. */
  faviconImageUrl?: Maybe<Scalars['String']['output']>;
  /** The font used in the branding theme. */
  font?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the branding theme. */
  id: Scalars['uuid']['output'];
  /** Indicates whether this is the default branding theme for the organization. */
  isOrgDefault: Scalars['Boolean']['output'];
  /** The number of active applications for jobs using this branding theme. */
  livePortals: Scalars['numeric']['output'];
  /** The name of the branding theme. */
  name: Scalars['String']['output'];
  /** The organization ID associated with this branding theme. */
  orgId: Scalars['uuid']['output'];
  /** The primary color used in the branding theme. */
  primaryColor?: Maybe<Scalars['String']['output']>;
  /** The URL of the profile image used in the branding theme. */
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  /** The theme mode (light or dark) of the branding theme. */
  themeMode?: Maybe<BrandingThemeMode>;
  /** The timestamp when the branding theme was last updated. */
  updatedAt: Scalars['datetime']['output'];
};

/** Input for creating a new branding theme. */
export type BrandingThemeCreateInput = {
  /** The URL of the cover image for the new branding theme. */
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the favicon image for the new branding theme. */
  faviconImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The font for the new branding theme. */
  font?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this should be the default branding theme for the organization. */
  isOrgDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the new branding theme. */
  name: Scalars['String']['input'];
  /** The primary color for the new branding theme. */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the profile image for the new branding theme. */
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The theme mode (light or dark) for the new branding theme. */
  themeMode?: InputMaybe<BrandingThemeMode>;
};

/** Represents the theme mode options for branding. */
export enum BrandingThemeMode {
  Dark = 'DARK',
  Light = 'LIGHT'
}

/** Result type for branding theme queries. */
export type BrandingThemeResult = {
  __typename?: 'BrandingThemeResult';
  /** The retrieved branding theme. */
  theme: BrandingTheme;
};

/** Input for updating an existing branding theme. */
export type BrandingThemeUpdateInput = {
  /** The updated URL of the cover image. */
  coverImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The updated URL of the favicon image. */
  faviconImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The updated font. */
  font?: InputMaybe<Scalars['String']['input']>;
  /** The unique identifier of the branding theme to update. */
  id: Scalars['uuid']['input'];
  /** Updated flag indicating whether this should be the default branding theme. */
  isOrgDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** The updated name of the branding theme. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The updated primary color. */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  /** The updated URL of the profile image. */
  profileImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The updated theme mode (light or dark). */
  themeMode?: InputMaybe<BrandingThemeMode>;
};

/** Result type for queries returning multiple branding themes. */
export type BrandingThemesResult = {
  __typename?: 'BrandingThemesResult';
  /** List of branding themes. */
  items: Array<BrandingTheme>;
};

export type BrighthireIntegration = {
  __typename?: 'BrighthireIntegration';
  apiKey: Scalars['String']['output'];
};

/** A ledger entry recording a bulk access (search, list, or export) over many data subjects. */
export type BulkPrivacyAuditLogEntry = PrivacyAuditLogEntry & {
  __typename?: 'BulkPrivacyAuditLogEntry';
  accessData: Array<PrivacyAuditAccessData>;
  accessMenu: Scalars['String']['output'];
  accessMenuPath: Scalars['String']['output'];
  accessTime: Scalars['datetime']['output'];
  activityCategory: PrivacyAuditActivityCategory;
  actor?: Maybe<Employee>;
  actorId: Scalars['uuid']['output'];
  bulkCount: Scalars['Int']['output'];
  /** Human-readable rendering of the query the bulk access ran (ids, search terms, or scope). */
  bulkQuery: Scalars['String']['output'];
  /** Whole-org scope when the query was not a specific id/search set; null otherwise. */
  bulkScope?: Maybe<PrivacyAuditBulkScope>;
  customData?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  ipAddresses: Array<Scalars['String']['output']>;
  /** Optional reason supplied for the access. It can appear on any activity category. */
  userProvidedReason?: Maybe<Scalars['String']['output']>;
};

/** Represents a calendar in the system. */
export type Calendar = {
  __typename?: 'Calendar';
  /** Indicates whether the actor can write to the calendar, aka is in calendar list and has write permissions */
  canActorWriteToCalendar?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the employee associated with this calendar, if any. */
  employeeId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the calendar. */
  id?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the calendar is part of the employee's calendar list. */
  isPartOfCalendarList?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the calendar is read-only. */
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the calendar. */
  name?: Maybe<Scalars['String']['output']>;
  /** Directory integration through which this calendar has been added. */
  orgDirectoryIntegration?: Maybe<OrgDirectoryIntegration>;
  /** The remote ID of the calendar (e.g., in the external calendar system). */
  remoteId?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the calendar supports RSVP synchronization. */
  supportsRsvpSync: Scalars['Boolean']['output'];
};

export enum CalendarDynamicValue {
  Scheduler = 'SCHEDULER'
}

/** Represents the busy time ranges for a specific email address. */
export type CalendarEmailBusyTimeRange = {
  __typename?: 'CalendarEmailBusyTimeRange';
  /** The email address associated with the busy time ranges. */
  email?: Maybe<Scalars['String']['output']>;
  /** List of time ranges during which the user is busy. */
  timeRanges?: Maybe<Array<DateTimeRangeOutput>>;
};

/** Input for retrieving free/busy information for calendar users. */
export type CalendarFreeBusyInput = {
  /** List of email addresses for which to retrieve free/busy information. */
  emails: Array<Scalars['String']['input']>;
  /** The time range for which to retrieve free/busy information. */
  timeRange: DateTimeRangeInput;
};

/** Output type for the calendar free/busy query. */
export type CalendarFreeBusyOutput = {
  __typename?: 'CalendarFreeBusyOutput';
  /** List of email addresses and their corresponding busy time ranges. */
  emailBusyTimeRanges?: Maybe<Array<CalendarEmailBusyTimeRange>>;
};

/** Input for creating a calendar meeting. */
export type CalendarMeetingCreateInput = {
  /** The ID of the employee who will host the meeting. */
  hostEmployeeId: Scalars['uuid']['input'];
  /** The time range for the meeting. */
  timeRange: DateTimeRangeInput;
};

/** The calendar read failed, so the projection would report an unread calendar as free time. */
export type CalendarUnavailableError = Error & {
  __typename?: 'CalendarUnavailableError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** Input for querying calendars. */
export type CalendarsInput = {
  /** Optional filter for read-only status. */
  isReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pagination input for the calendars query. */
  pageInput: PageInput;
  /** Optional filter for a specific remote ID. */
  remoteId?: InputMaybe<Scalars['String']['input']>;
  /** Name or email prefix/substring of the Outlook calendar owner, or calendar name for Google. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Result type for the calendars query. */
export type CalendarsResult = {
  __typename?: 'CalendarsResult';
  /**
   * Dummy field to avoid breaking FE
   * @deprecated Use items instead
   */
  calendars: Array<Calendar>;
  /** List of calendars matching the query criteria. */
  items: Array<Calendar>;
  /** Cursor for the next page of results, if available. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CanPoSettings = {
  contentTabMappings?: InputMaybe<Array<ContentTabMappingInput>>;
  importBrandingTheme: Scalars['Boolean']['input'];
  importIntroText: Scalars['Boolean']['input'];
  /**
   *  When true, link the target job to the source job's portal config.
   *  Mutually exclusive with the other fields; when true, the other fields are ignored server-side.
   */
  importPortalConfigLink: Scalars['Boolean']['input'];
};

export type CanPoSettingsImportConfig = {
  contentTabs?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type Candidate = {
  __typename?: 'Candidate';
  additionalEmails?: Maybe<Array<Scalars['String']['output']>>;
  aiInstruction?: Maybe<AiInstruction>;
  aiMemories: Array<AiMemory>;
  anonymizedAt?: Maybe<Scalars['datetime']['output']>;
  applications?: Maybe<Array<Application>>;
  atsCandidate?: Maybe<AtsCandidate>;
  atsId?: Maybe<Scalars['String']['output']>;
  atsLatestAvailability?: Maybe<CandidateAtsAvailability>;
  atsType?: Maybe<AtsType>;
  conflictOfInterestEmployees: Array<Employee>;
  /** The identifier which is exposed on public internet for candidate portal. */
  cryptoHash?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  lastActivityAt?: Maybe<Scalars['datetime']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Locale>;
  org?: Maybe<Org>;
  orgId: Scalars['uuid']['output'];
  phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  preferredEmail?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  preferredPhoneNumber?: Maybe<Scalars['String']['output']>;
  pronoun?: Maybe<Scalars['String']['output']>;
  sourcer?: Maybe<Employee>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['datetime']['output']>;
};

export type CandidateActor = Actor & {
  __typename?: 'CandidateActor';
  candidate: Candidate;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ActorType;
};

export type CandidateAiContextTarget = AiContextTarget & {
  __typename?: 'CandidateAiContextTarget';
  candidate: Candidate;
  id: Scalars['uuid']['output'];
  type: AiContextTargetType;
};

export type CandidateAnonymizeInput = {
  candidateId?: InputMaybe<Scalars['uuid']['input']>;
  /**  Provide any of the following to anonymize the candidate. candidateId will be considered if both are provided. */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type CandidateAtsAvailability = {
  __typename?: 'CandidateAtsAvailability';
  intervals?: Maybe<Array<DateTimeRangeOutput>>;
  jobName?: Maybe<Scalars['String']['output']>;
  jobStageName?: Maybe<Scalars['String']['output']>;
  originalText?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['timezone']['output']>;
};

export type CandidateAvailability = {
  __typename?: 'CandidateAvailability';
  candidateEnteredAvailability?: Maybe<Array<DateTimeRangeOutput>>;
  candidateUpdatedAt?: Maybe<Scalars['datetime']['output']>;
  createdAt: Scalars['datetime']['output'];
  employeeUpdatedAt?: Maybe<Scalars['datetime']['output']>;
  id: Scalars['uuid']['output'];
  lastUpdatedByEmployee?: Maybe<Employee>;
  lastUpdatedByEmployeeId?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  rcEnteredAvailability?: Maybe<Array<DateTimeRangeOutput>>;
  updatedAt: Scalars['datetime']['output'];
};

/** ########################################################## */
export type CandidateAvailabilityInput = {
  applicationId: Scalars['uuid']['input'];
  jobStageId: Scalars['uuid']['input'];
  taskId?: InputMaybe<Scalars['uuid']['input']>;
};

export type CandidateAvailabilityOptions = {
  __typename?: 'CandidateAvailabilityOptions';
  advanceNoticeMinutes?: Maybe<Scalars['numeric']['output']>;
  applicationId: Scalars['uuid']['output'];
  availabilityEndDate?: Maybe<Scalars['datetime']['output']>;
  availabilityStartDate?: Maybe<Scalars['datetime']['output']>;
  /** @deprecated No longer supported */
  availabilitySubmittedNotificationPrefs?: Maybe<Scalars['jsonb']['output']>;
  /** @deprecated No longer supported */
  availabilitySubmittedNotificationPrefsV2?: Maybe<NotificationPreference>;
  bookIfPerfectScheduleFound: Scalars['Boolean']['output'];
  candidateNote?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['datetime']['output'];
  creator?: Maybe<Employee>;
  creatorEmployeeId?: Maybe<Scalars['uuid']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  inclusionDays: Array<Scalars['String']['output']>;
  jobStageId: Scalars['uuid']['output'];
  lastCandidateCommunicationSentAt?: Maybe<Scalars['datetime']['output']>;
  minimumTimeBlockMinutes: Scalars['numeric']['output'];
  minutesPerDays: Scalars['numeric']['output'];
  numberOfDays: Scalars['numeric']['output'];
  rollingDays: Scalars['numeric']['output'];
  shouldRespectLoadLimit: Scalars['Boolean']['output'];
  suggestOverAvailableKeywords: Scalars['Boolean']['output'];
  suggestOverFreeTime: Scalars['Boolean']['output'];
  suggestOverRecruitingKeywords: Scalars['Boolean']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['datetime']['output'];
};

export type CandidateAvailabilityOptionsInput = {
  applicationId: Scalars['uuid']['input'];
  jobStageId: Scalars['uuid']['input'];
};

/** ########################################## */
export type CandidateAvailabilityOptionsSettingInput = {
  advanceNoticeMinutes?: InputMaybe<Scalars['numeric']['input']>;
  bccRecipients?: InputMaybe<NotificationPreferenceInput>;
  bookIfPerfectScheduleFound?: InputMaybe<Scalars['Boolean']['input']>;
  canScheduleOverAvailableKeywords?: InputMaybe<Scalars['Boolean']['input']>;
  canScheduleOverFreeTime?: InputMaybe<Scalars['Boolean']['input']>;
  canScheduleOverRecruitingKeywords?: InputMaybe<Scalars['Boolean']['input']>;
  candidateNote?: InputMaybe<Scalars['String']['input']>;
  ccRecipients?: InputMaybe<NotificationPreferenceInput>;
  minimumTimeBlockMinutes?: InputMaybe<Scalars['numeric']['input']>;
  minutesPerDays?: InputMaybe<Scalars['numeric']['input']>;
  numberOfDays?: InputMaybe<Scalars['numeric']['input']>;
  rollingDays?: InputMaybe<Scalars['numeric']['input']>;
  shouldRespectLoadLimit?: InputMaybe<Scalars['Boolean']['input']>;
  timeframeNumberOfDays?: InputMaybe<Scalars['numeric']['input']>;
  useRollingDays?: InputMaybe<Scalars['Boolean']['input']>;
};

/** @deprecated use JobStageCandidateAvailabilitySettings instead */
export type CandidateAvailabilityOptionsSettings = {
  __typename?: 'CandidateAvailabilityOptionsSettings';
  advanceNoticeMinutes?: Maybe<Scalars['numeric']['output']>;
  bccRecipients?: Maybe<NotificationPreference>;
  canScheduleOverAvailableKeywords?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverFreeTime?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverRecruitingKeywords?: Maybe<Scalars['Boolean']['output']>;
  candidateNote?: Maybe<Scalars['String']['output']>;
  ccRecipients?: Maybe<NotificationPreference>;
  minimumTimeBlockMinutes?: Maybe<Scalars['numeric']['output']>;
  minutesPerDays?: Maybe<Scalars['numeric']['output']>;
  numberOfDays?: Maybe<Scalars['numeric']['output']>;
  /** @deprecated No longer supported */
  rollingDays?: Maybe<Scalars['numeric']['output']>;
  shouldRespectLoadLimit?: Maybe<Scalars['Boolean']['output']>;
  timeframeNumberOfDays?: Maybe<Scalars['numeric']['output']>;
  useRollingDays?: Maybe<Scalars['Boolean']['output']>;
};

export type CandidateAvailabilityOptionsUpsertInput = {
  advanceNoticeMinutes: Scalars['numeric']['input'];
  bookIfPerfectScheduleFound?: InputMaybe<Scalars['Boolean']['input']>;
  candidateNote?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<CandidateEmailContentInput>;
  inclusionDays?: InputMaybe<Array<Scalars['String']['input']>>;
  minimumTimeBlockMinutes: Scalars['numeric']['input'];
  minutesPerDays: Scalars['numeric']['input'];
  numberOfDays: Scalars['numeric']['input'];
  rollingDays: Scalars['numeric']['input'];
  shouldRespectLoadLimit: Scalars['Boolean']['input'];
  suggestOverAvailableKeywords: Scalars['Boolean']['input'];
  suggestOverFreeTime: Scalars['Boolean']['input'];
  suggestOverRecruitingKeywords: Scalars['Boolean']['input'];
  taskId: Scalars['uuid']['input'];
  timezone: Scalars['timezone']['input'];
};

export type CandidateAvailabilityOptionsUpsertResult = {
  __typename?: 'CandidateAvailabilityOptionsUpsertResult';
  options?: Maybe<CandidateAvailabilityOptions>;
};

export type CandidateBulkAnonymizeInput = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CandidateBulkAnonymizeResult = {
  __typename?: 'CandidateBulkAnonymizeResult';
  count: Scalars['Int']['output'];
};

/** Input for retrieving a candidate by their ATS ID. */
export type CandidateByAtsIdInput = {
  /** The ATS ID of the candidate. */
  atsId: Scalars['String']['input'];
  /** The type of ATS. */
  atsType?: InputMaybe<AtsType>;
  /** Boolean to indicate if we should query by a field other than the `remoteAtsId`. */
  isReferenceId?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for retrieving a candidate by their ATS ID with typed lookup errors. */
export type CandidateByAtsIdV2Input = {
  /** The ATS ID of the candidate. */
  atsId: Scalars['String']['input'];
  /** The type of ATS. */
  atsType?: InputMaybe<AtsType>;
  /** Boolean to indicate if we should query by a field other than the `remoteAtsId`. */
  isReferenceId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CandidateByAtsIdV2Output = Candidate | CandidateNotFoundError | CandidatePermissionDeniedError | UnknownError;

/**
 * Represents reasons a candidate might provide when cancelling a self-scheduled interview.
 * This enum helps categorize and track reasons for interview cancellations.
 */
export enum CandidateCancellationReason {
  /** The candidate has accepted another job offer. */
  AcceptedAnotherOffer = 'ACCEPTED_ANOTHER_OFFER',
  /** The candidate is unable to make the scheduled time. */
  CantMakeTime = 'CANT_MAKE_TIME',
  /** No specific reason has been set or provided by the candidate. */
  NotSet = 'NOT_SET',
  /** The candidate is no longer interested in the position. */
  NoLongerInterested = 'NO_LONGER_INTERESTED',
  /** The candidate has a reason not covered by the other options. */
  Other = 'OTHER'
}

export type CandidateCommunicationsSettingPref = {
  __typename?: 'CandidateCommunicationsSettingPref';
  bccRecipients?: Maybe<NotificationPreference>;
  ccRecipients?: Maybe<NotificationPreference>;
};

export type CandidateDeAnonymizeInput = {
  candidateId: Scalars['uuid']['input'];
};

export type CandidateEmailContentInput = {
  attachments?: InputMaybe<Array<RemoteAttachmentInput>>;
  bccDynamicAudiences?: InputMaybe<Array<DynamicAudience>>;
  bccEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  bccExternalAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  ccDynamicAudiences?: InputMaybe<Array<DynamicAudience>>;
  ccEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  ccExternalAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  emailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  parentEmailId?: InputMaybe<Scalars['uuid']['input']>;
  summary: Scalars['String']['input'];
  toEmailAddress: Scalars['String']['input'];
};

/**
 * Read rule for the three prefs below: additionalAttendees wins when non-empty; otherwise the legacy
 * list plus additionalRecipientsOptional materialize into uniform entries. The two shapes are both
 * mirrored here because this type mirrors the stored JSON exactly.
 */
export type CandidateEventAdditionalAttendeesPref = {
  __typename?: 'CandidateEventAdditionalAttendeesPref';
  additionalAttendees: Array<SettingAdditionalAttendee>;
  additionalRecipientsOptional: Scalars['Boolean']['output'];
  candidateEventAdditionalAttendees: NotificationPreference;
};

export type CandidateEventContentInput = {
  /**
   *  Nullable for rollout compat; null behaves like an empty list. Seeded from the invite
   *  template's attachments by the client; the backend appends an "Attachments" link section
   *  to the event description.
   */
  attachments?: InputMaybe<Array<RemoteAttachmentInput>>;
  calendarEventTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  description: Scalars['String']['input'];
  summary: Scalars['String']['input'];
  toEmailAddress: Scalars['String']['input'];
  videoMeetingUrl: Scalars['String']['input'];
};

export type CandidateFacingHiringTeamContactInfo = {
  __typename?: 'CandidateFacingHiringTeamContactInfo';
  canShowBio: Scalars['Boolean']['output'];
  canShowJobTitle: Scalars['Boolean']['output'];
  canShowLinkedin: Scalars['Boolean']['output'];
  canShowPhone: Scalars['Boolean']['output'];
  canShowProfilePicture: Scalars['Boolean']['output'];
  canShowPronouns: Scalars['Boolean']['output'];
  showCoordinator: Scalars['Boolean']['output'];
  showRecruiter: Scalars['Boolean']['output'];
};

export type CandidateFacingInterviewerInfo = {
  __typename?: 'CandidateFacingInterviewerInfo';
  canShowBio: Scalars['Boolean']['output'];
  canShowEmail: Scalars['Boolean']['output'];
  canShowFullName: Scalars['Boolean']['output'];
  canShowInfo: Scalars['Boolean']['output'];
  canShowJobTitle: Scalars['Boolean']['output'];
  canShowLinkedin: Scalars['Boolean']['output'];
  canShowProfilePicture: Scalars['Boolean']['output'];
  canShowPronouns: Scalars['Boolean']['output'];
};

export type CandidateNotFoundError = Error & {
  __typename?: 'CandidateNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type CandidatePageFiltersPref = {
  __typename?: 'CandidatePageFiltersPref';
  coordinatorEmployeeIds: Array<Scalars['uuid']['output']>;
  coordinatorEmployees: Array<Employee>;
  jobIds: Array<Scalars['uuid']['output']>;
  jobStageNames: Array<Scalars['String']['output']>;
  jobs: Array<Job>;
  recruiterEmployeeIds: Array<Scalars['uuid']['output']>;
  recruiterEmployees: Array<Employee>;
  showInactiveApplications: Scalars['Boolean']['output'];
};

export type CandidatePermissionDeniedError = Error & {
  __typename?: 'CandidatePermissionDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** Represents a note in the candidate portal. */
export type CandidatePortalNote = {
  __typename?: 'CandidatePortalNote';
  /** The content of the note. */
  content?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the note was created. */
  createdAt: Scalars['datetime']['output'];
  /** The unique identifier of the note. */
  id: Scalars['uuid']['output'];
  /** The timestamp when the last notification about this note was sent. */
  lastNotificationSentAt?: Maybe<Scalars['datetime']['output']>;
  /** The timestamp when the note was last updated. */
  updatedAt: Scalars['datetime']['output'];
  /** The employee who last updated the note. */
  updatedBy: Employee;
};

export type CandidatePulseDownloadMetrics = {
  __typename?: 'CandidatePulseDownloadMetrics';
  negativeNote?: Maybe<Scalars['String']['output']>;
  negativeTags?: Maybe<Scalars['String']['output']>;
  overallScore: Scalars['numeric']['output'];
  positiveNote?: Maybe<Scalars['String']['output']>;
  positiveTags?: Maybe<Scalars['String']['output']>;
  referralScore: Scalars['numeric']['output'];
};

/** Filters for candidate pulse metrics query. */
export type CandidatePulseFilters = {
  jobIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  jobStageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  pulseNoteType?: InputMaybe<CandidatePulseTagType>;
};

export type CandidatePulseMetrics = {
  __typename?: 'CandidatePulseMetrics';
  negative: CandidatePulseMetricsAggregate;
  positive: CandidatePulseMetricsAggregate;
  summary: CandidatePulseMetricsSummary;
};

export type CandidatePulseMetricsAggregate = {
  __typename?: 'CandidatePulseMetricsAggregate';
  /** @deprecated No longer supported */
  notes: CandidatePulseNotePage;
  tags: Array<CandidatePulseTagWithPercentage>;
};


export type CandidatePulseMetricsAggregateNotesArgs = {
  input: PageInput;
};

export type CandidatePulseMetricsInput = {
  filters: CandidatePulseFilters;
  timeRange: DateTimeRangeInput;
};

export type CandidatePulseMetricsSummary = {
  __typename?: 'CandidatePulseMetricsSummary';
  averageRating: Scalars['Float']['output'];
  npsScore: Scalars['numeric']['output'];
  totalResponses: Scalars['numeric']['output'];
};

export type CandidatePulseNotePage = {
  __typename?: 'CandidatePulseNotePage';
  items: Array<CandidatePulseNoteWithRating>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CandidatePulseNoteWithRating = {
  __typename?: 'CandidatePulseNoteWithRating';
  note: Scalars['String']['output'];
  rating: Scalars['numeric']['output'];
};

export type CandidatePulseResponse = {
  __typename?: 'CandidatePulseResponse';
  id: Scalars['uuid']['output'];
  negativeNote?: Maybe<Scalars['String']['output']>;
  negativeTags?: Maybe<Array<CandidatePulseTag>>;
  npsRating: Scalars['numeric']['output'];
  positiveNote?: Maybe<Scalars['String']['output']>;
  positiveTags?: Maybe<Array<CandidatePulseTag>>;
  rating: Scalars['numeric']['output'];
};

export type CandidatePulseSearchInput = {
  filters: CandidatePulseFilters;
  pageInput: PageInput;
  timeRange: DateTimeRangeInput;
};

export type CandidatePulseSearchOutput = {
  __typename?: 'CandidatePulseSearchOutput';
  hasNext: Scalars['Boolean']['output'];
  items: Array<CandidatePulseResponse>;
  total: Scalars['Int']['output'];
};

export type CandidatePulseTag = {
  __typename?: 'CandidatePulseTag';
  archivedAt?: Maybe<Scalars['datetime']['output']>;
  emoji: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  name: Scalars['String']['output'];
  tagType: CandidatePulseTagType;
  translationStatus: TranslationStatus;
  translations: Array<ContentTranslationValue>;
};

/** Represents the question type for a candidate pulse tag. */
export enum CandidatePulseTagType {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type CandidatePulseTagUpsertInput = {
  tagType?: InputMaybe<CandidatePulseTagType>;
  tags: Array<CandidatePulseTagsInput>;
};

export type CandidatePulseTagWithPercentage = {
  __typename?: 'CandidatePulseTagWithPercentage';
  percentage: Scalars['Float']['output'];
  tag: CandidatePulseTag;
  tagId: Scalars['uuid']['output'];
};

export type CandidatePulseTags = {
  __typename?: 'CandidatePulseTags';
  negative: Array<Maybe<CandidatePulseTag>>;
  positive: Array<Maybe<CandidatePulseTag>>;
};

export type CandidatePulseTagsInput = {
  emoji: Scalars['String']['input'];
  id: Scalars['uuid']['input'];
  index: Scalars['numeric']['input'];
  /**  Only used on insert, not on update. We don't allow changing the tag type. */
  isArchived: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  tagType: CandidatePulseTagType;
};

export type CandidateRequestValidateSingleDateResult = {
  __typename?: 'CandidateRequestValidateSingleDateResult';
  /** The day in yyyy-MM-dd format. */
  day: Scalars['date']['output'];
  /** Errors for the day which are not associated with any employee. */
  errors: Array<TaskCreateValidateErrorFlags>;
  /** suggestion count for the day. */
  suggestionCount: Scalars['Int']['output'];
  /** Warnings for the day which are not associated with any employee. */
  warnings: Array<TaskCreateValidateWarnFlags>;
};

/** Input for setting candidate information. */
export type CandidateSetInput = {
  clearPreferredEmail?: InputMaybe<Scalars['Boolean']['input']>;
  conflictOfInterestEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  coordinatorId?: InputMaybe<Scalars['uuid']['input']>;
  locale?: InputMaybe<Locale>;
  preferredPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  recruiterId?: InputMaybe<Scalars['uuid']['input']>;
  sourcerId?: InputMaybe<Scalars['uuid']['input']>;
  timezone?: InputMaybe<Scalars['timezone']['input']>;
};

/** Input for updating a candidate's information. */
export type CandidateUpdateInput = {
  id: Scalars['uuid']['input'];
  set: CandidateSetInput;
};

/** Result of updating a candidate's information. */
export type CandidateUpdateResult = {
  __typename?: 'CandidateUpdateResult';
  candidate: Candidate;
};

export type CandidateV2Input = {
  id: Scalars['uuid']['input'];
};

export type CandidateV2Output = Candidate | CandidateNotFoundError | CandidatePermissionDeniedError | UnknownError;

export type CapturedAuditLogPayload = {
  __typename?: 'CapturedAuditLogPayload';
  text: Scalars['String']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type ChartCoordinateData = {
  __typename?: 'ChartCoordinateData';
  xpoint?: Maybe<Scalars['String']['output']>;
  ypoint?: Maybe<Scalars['Float']['output']>;
};

export type ChatCommunicationsSettingPref = {
  __typename?: 'ChatCommunicationsSettingPref';
  chatConversation?: Maybe<Conversation>;
  chatConversationId?: Maybe<Scalars['uuid']['output']>;
  chatConversationType: ChatConversationType;
  remoteChatConversationId?: Maybe<Scalars['String']['output']>;
};

export type ChatConversationInput = {
  /** @deprecated Use remoteChatConversationId instead */
  chatConversationId?: InputMaybe<Scalars['uuid']['input']>;
  chatConversationType: ChatConversationType;
  remoteChatConversationId?: InputMaybe<Scalars['String']['input']>;
};

export enum ChatConversationType {
  ApplicationSpecificConversation = 'APPLICATION_SPECIFIC_CONVERSATION',
  ExistingConversation = 'EXISTING_CONVERSATION',
  NewConversation = 'NEW_CONVERSATION'
}

/** ######################################### */
export type CheckCreateCandidatePermissionInput = {
  jobId?: InputMaybe<Scalars['uuid']['input']>;
};

export type CheckCreateCandidatePermissionResult = {
  __typename?: 'CheckCreateCandidatePermissionResult';
  hasPermission: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['uuid']['output']>;
  testCandidateAtsUrl?: Maybe<Scalars['String']['output']>;
};

export type CodeLinkInput = {
  type: CodeLinkType;
  url: Scalars['String']['input'];
};

export enum CodeLinkType {
  Coderpad = 'CODERPAD',
  Codesignal = 'CODESIGNAL',
  Codility = 'CODILITY',
  Hackerrank = 'HACKERRANK',
  None = 'NONE'
}

export type CoderpadIntegration = {
  __typename?: 'CoderpadIntegration';
  apiKey: Scalars['String']['output'];
};

export type CodesignalIntegration = {
  __typename?: 'CodesignalIntegration';
  apiKey: Scalars['String']['output'];
};

export type CodilityIntegration = {
  __typename?: 'CodilityIntegration';
  apiKey: Scalars['String']['output'];
};

export type CollaborationLink = {
  __typename?: 'CollaborationLink';
  collaborationLinkTemplateId?: Maybe<Scalars['uuid']['output']>;
  collaborationToolType: CollaborationToolType;
  createdAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  orgId: Scalars['uuid']['output'];
  url: Scalars['String']['output'];
};

export type CollaborationLinkCreateInput = {
  /** Application being scheduled; the backend assembles coding-link title token values from it. */
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  candidateId: Scalars['uuid']['input'];
  collaborationLinkTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  collaborationToolType: CollaborationToolType;
  /** @deprecated No longer supported */
  remoteTemplateId?: InputMaybe<Scalars['String']['input']>;
};

export type CollaborationLinkCreateResult = {
  __typename?: 'CollaborationLinkCreateResult';
  collaborationLink: CollaborationLink;
  /** @deprecated No longer supported */
  collaborationLinkId: Scalars['uuid']['output'];
  /** @deprecated No longer supported */
  url: Scalars['String']['output'];
};

export type CollaborationLinkTemplate = {
  __typename?: 'CollaborationLinkTemplate';
  collaborationToolType: CollaborationToolType;
  createdAt: Scalars['datetime']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  /** @deprecated No longer supported */
  remoteId: Scalars['String']['output'];
  remoteTemplateId: Scalars['String']['output'];
  updatedAt: Scalars['datetime']['output'];
};

export type CollaborationLinkTemplatesInput = {
  collaborationToolType: CollaborationToolType;
  pageInput: PageInput;
};

export type CollaborationLinkTemplatesResult = {
  __typename?: 'CollaborationLinkTemplatesResult';
  items: Array<CollaborationLinkTemplate>;
  /**  If null, means there are no more results. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type CollaborationLinkType = {
  __typename?: 'CollaborationLinkType';
  collaborationLinkTemplateId?: Maybe<Scalars['uuid']['output']>;
  collaborationToolType: CollaborationToolType;
};

export type CollaborationLinkTypesInput = {
  /** The optional template ID to be used when generating the collaboration link. */
  collaborationLinkTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  collaborationToolType: CollaborationToolType;
};

export enum CollaborationToolType {
  Coderpad = 'CODERPAD',
  Codesignal = 'CODESIGNAL',
  Codility = 'CODILITY',
  Hackerrank = 'HACKERRANK'
}

export type CompanyHoliday = {
  __typename?: 'CompanyHoliday';
  allCountries: Scalars['Boolean']['output'];
  countries?: Maybe<Array<EmployeeAttributeTagValue>>;
  createdAt: Scalars['datetime']['output'];
  endAt: Scalars['date']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  startAt: Scalars['date']['output'];
  updatedAt: Scalars['datetime']['output'];
};

export type CompanyHolidayCreateInput = {
  allCountries: Scalars['Boolean']['input'];
  countries?: InputMaybe<Array<Scalars['uuid']['input']>>;
  endAt: Scalars['date']['input'];
  name: Scalars['String']['input'];
  startAt: Scalars['date']['input'];
};

export type CompanyHolidayDeleteInput = {
  id: Scalars['uuid']['input'];
};

export type CompanyHolidayDeleteResult = {
  __typename?: 'CompanyHolidayDeleteResult';
  result?: Maybe<Result>;
};

export type CompanyHolidayOrderBy = {
  direction: Sort;
  property: CompanyHolidayOrderByProperty;
};

export enum CompanyHolidayOrderByProperty {
  Date = 'DATE',
  Name = 'NAME'
}

export type CompanyHolidayResult = {
  __typename?: 'CompanyHolidayResult';
  items: Array<CompanyHoliday>;
  nextCursor: Scalars['String']['output'];
};

export type CompanyHolidayUpdateInput = {
  allCountries: Scalars['Boolean']['input'];
  countries?: InputMaybe<Array<Scalars['uuid']['input']>>;
  endAt: Scalars['date']['input'];
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  startAt: Scalars['date']['input'];
};

export type CompanyHolidayUpsertResult = {
  __typename?: 'CompanyHolidayUpsertResult';
  companyHoliday: CompanyHoliday;
};

export type CompanyHolidaysForDays = {
  __typename?: 'CompanyHolidaysForDays';
  companyHolidays: Array<CompanyHoliday>;
  date: Scalars['date']['output'];
};

export type CompanyHolidaysForDaysInput = {
  endAt: Scalars['date']['input'];
  startAt: Scalars['date']['input'];
};

export type CompanyHolidaysForDaysResult = {
  __typename?: 'CompanyHolidaysForDaysResult';
  items: Array<CompanyHolidaysForDays>;
};

/**
 * ################################
 *  Company Holiday
 */
export type CompanyHolidaysInput = {
  allCountries?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Array<Scalars['uuid']['input']>>;
  endAt?: InputMaybe<Scalars['date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CompanyHolidayOrderBy>;
  pageInput: PageInput;
  startAt?: InputMaybe<Scalars['date']['input']>;
};

export type ConfigOverride = {
  __typename?: 'ConfigOverride';
  multiDay: Scalars['Boolean']['output'];
};

/** Represents a single content card. */
export type ContentCard = {
  __typename?: 'ContentCard';
  /** The body text for the content card. */
  body?: Maybe<Scalars['String']['output']>;
  /** The header text for the content card. */
  header: Scalars['String']['output'];
};

/** Input for creating or updating a content card. */
export type ContentCardInput = {
  /** The body text for the content card. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The header text for the content card. */
  header: Scalars['String']['input'];
};

export type ContentTabMapping = {
  __typename?: 'ContentTabMapping';
  /**
   *  Populated only when sourceContentTabType = PORTAL_JOB_OPTIONS_TAB (source job is unlinked).
   *  For PORTAL_CONFIG_TAB sources, use the flat `sourceIcon` / `sourceVisibility` /
   *  `sourceStageNameFilter` fields instead.
   */
  sourceContentTab?: Maybe<PortalJobOptionsTab>;
  sourceContentTabId: Scalars['uuid']['output'];
  sourceContentTabType: ContentTabSourceType;
  /**
   *  Icon + visibility from the source tab, denormalized so the FE can render both source
   *  types (PortalJobOptionsTab / PortalConfigTab) without a separate loader call.
   */
  sourceIcon?: Maybe<Scalars['String']['output']>;
  sourceJobStage?: Maybe<JobStage>;
  sourceJobStageId?: Maybe<Scalars['uuid']['output']>;
  sourceName: Scalars['String']['output'];
  /**
   *  Display-only: when the source tab has visibility=JOB_STAGE and carries a stageNameFilter,
   *  this is that filter value (never round-tripped into ContentTabMappingInput).
   */
  sourceStageNameFilter?: Maybe<Scalars['String']['output']>;
  sourceVisibility?: Maybe<PortalJobOptionsTabVisibilityType>;
  /** @deprecated Use targetAtsId instead. */
  targetContentTabId?: Maybe<Scalars['uuid']['output']>;
  targetJobStage?: Maybe<JobStage>;
  targetJobStageId?: Maybe<Scalars['uuid']['output']>;
};

export type ContentTabMappingInput = {
  sourceContentTabId: Scalars['uuid']['input'];
  /**
   *  only used if above type is "JOB_STAGE"
   *  Which entity sourceContentTabId refers to. Required — callers must specify
   *  PORTAL_JOB_OPTIONS_TAB (source job's own tab) or PORTAL_CONFIG_TAB (tab from the
   *  source job's linked portal config).
   */
  sourceContentTabType: ContentTabSourceType;
  targetJobStageId?: InputMaybe<Scalars['uuid']['input']>;
  visibility: PortalJobOptionsTabVisibilityType;
};

export enum ContentTabSourceType {
  PortalConfigTab = 'PORTAL_CONFIG_TAB',
  PortalJobOptionsTab = 'PORTAL_JOB_OPTIONS_TAB'
}

export type ContentTranslationFieldInput = {
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ContentTranslationUpsertInput = {
  entityId: Scalars['uuid']['input'];
  entityType: TranslationEntityType;
  fields: Array<ContentTranslationFieldInput>;
  locale: Locale;
};

export type ContentTranslationUpsertOutput = {
  __typename?: 'ContentTranslationUpsertOutput';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** A translated name value for a single locale. */
export type ContentTranslationValue = {
  __typename?: 'ContentTranslationValue';
  locale: Locale;
  name: Scalars['String']['output'];
};

/** Represents a conversation in the system, typically associated with a communication channel. */
export type Conversation = {
  __typename?: 'Conversation';
  /** The timestamp when the conversation was created. */
  createdAt: Scalars['datetime']['output'];
  /** The unique identifier for the conversation. */
  id: Scalars['uuid']['output'];
  /** Indicates whether the conversation has been archived. */
  isArchived: Scalars['Boolean']['output'];
  /** Indicates whether the conversation is private or not. */
  isPrivate: Scalars['Boolean']['output'];
  /** The organization ID associated with this conversation. */
  orgId: Scalars['uuid']['output'];
  /** The remote identifier for the conversation, typically used to link with external systems. */
  remoteId: Scalars['String']['output'];
  /**
   * The name of the conversation as it appears in the remote system.
   * Note: This field may be redacted to "private channel" behind a feature flag.
   */
  remoteName: Scalars['String']['output'];
  /** The type of conversation, indicating the platform or service it belongs to. */
  type: ConversationType;
  /** The timestamp when the conversation was last updated. */
  updatedAt: Scalars['datetime']['output'];
};

/** Enum representing the types of conversations supported by the system. */
export enum ConversationType {
  /** Indicates that the conversation is associated with Slack. */
  Slack = 'SLACK'
}

export type ConversationsApplicationInput = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateExternalApiTokenInput = {
  expiresAt?: InputMaybe<Scalars['datetime']['input']>;
  name: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};

export type CreateExternalApiTokenPayload = {
  __typename?: 'CreateExternalApiTokenPayload';
  token: Scalars['String']['output'];
  tokenId: Scalars['uuid']['output'];
  tokenPrefix: Scalars['String']['output'];
};

export enum CurrentTrainingSessionStatus {
  /**  For in training interviewer for no upcoming scheduled via ModernLoop */
  NeedsApproval = 'NEEDS_APPROVAL',
  None = 'NONE',
  /**  For in training interviewer and upcoming scheduled via ModernLoop */
  RequiredInterviewsScheduled = 'REQUIRED_INTERVIEWS_SCHEDULED',
  /**  Ideally for trained interviews */
  Scheduled = 'SCHEDULED',
  /**  For in training interviewer and all required upcoming scheduled via ModernLoop */
  Unscheduled = 'UNSCHEDULED'
}

/** Input type for custom interview schedule token preferences. */
export type CustomInterviewScheduleTokenPref = {
  /** The format for displaying break dividers. */
  breakDividerFormat: Scalars['String']['input'];
  /** The format for displaying the candidate's phone number. */
  candidatePhoneNumberFormat?: InputMaybe<Scalars['String']['input']>;
  /** The format for coding links. */
  codingLinkFormat?: InputMaybe<Scalars['String']['input']>;
  /** The format for displaying date headers. */
  dateHeaderFormat: Scalars['String']['input'];
  /** The format for displaying interview details with time. */
  interviewDetailWithTime: Scalars['String']['input'];
  /** The format for single meeting links. */
  singleMeetingLinkFormat?: InputMaybe<MeetingLinkFormat>;
  /** The format for unique meeting links. */
  uniqueMeetingLinkFormat?: InputMaybe<MeetingLinkFormat>;
};

/** Input for previewing a custom interview schedule token. */
export type CustomInterviewScheduleTokenPreviewInput = {
  /** The candidate for whom the interview is scheduled. */
  candidate: PreviewTokenCandidate;
  /** List of employees involved in the interview process. */
  employees?: InputMaybe<Array<PreviewTokenEmployee>>;
  /** Preferences for the custom interview schedule token. */
  pref: CustomInterviewScheduleTokenPref;
  /** The interview schedule to be previewed. */
  previewSchedule: TokenInterviewScheduleInput;
};

/** Result type for the custom interview schedule token preview. */
export type CustomInterviewScheduleTokenPreviewResult = {
  __typename?: 'CustomInterviewScheduleTokenPreviewResult';
  /** The HTML representation of the preview. */
  html?: Maybe<Scalars['String']['output']>;
};

/** Input for a custom job stage. */
export type CustomJobStageInput = {
  candidateId: Scalars['uuid']['input'];
  customJobStageId: Scalars['uuid']['input'];
  jobStageId: Scalars['uuid']['input'];
};

/** Result of deleting a custom job stage interview plan. */
export type CustomJobStageInterviewPlanResult = {
  __typename?: 'CustomJobStageInterviewPlanResult';
  customJobStageId?: Maybe<Scalars['uuid']['output']>;
};

/** Names a browser-built CSV so the server can record its privacy access metadata. */
export enum DataDownloadType {
  /**  keep-sorted:begin */
  InterviewModulesAll = 'INTERVIEW_MODULES_ALL',
  MetricsCandidateSurveysSummary = 'METRICS_CANDIDATE_SURVEYS_SUMMARY',
  MetricsDebriefAttendeeRsvps = 'METRICS_DEBRIEF_ATTENDEE_RSVPS',
  MetricsDebriefByScheduler = 'METRICS_DEBRIEF_BY_SCHEDULER',
  MetricsInterviewerAutoReplacement = 'METRICS_INTERVIEWER_AUTO_REPLACEMENT',
  MetricsInterviewerDeclineNotes = 'METRICS_INTERVIEWER_DECLINE_NOTES',
  MetricsInterviewerDeclineReasons = 'METRICS_INTERVIEWER_DECLINE_REASONS',
  MetricsInterviewerDeclineTable = 'METRICS_INTERVIEWER_DECLINE_TABLE',
  MetricsInterviewerInterviewingTable = 'METRICS_INTERVIEWER_INTERVIEWING_TABLE',
  MetricsInterviewerTrainingTable = 'METRICS_INTERVIEWER_TRAINING_TABLE',
  MetricsRecruiterRescheduleNotes = 'METRICS_RECRUITER_RESCHEDULE_NOTES',
  MetricsRecruiterRescheduleReasons = 'METRICS_RECRUITER_RESCHEDULE_REASONS',
  MetricsRecruiterTable = 'METRICS_RECRUITER_TABLE',
  MetricsTimeToScheduleAllTasks = 'METRICS_TIME_TO_SCHEDULE_ALL_TASKS',
  MetricsTimeToScheduleGroupTable = 'METRICS_TIME_TO_SCHEDULE_GROUP_TABLE',
  MetricsTimeToScheduleGroupTasks = 'METRICS_TIME_TO_SCHEDULE_GROUP_TASKS',
  MetricsTimeToScheduleTaskTable = 'METRICS_TIME_TO_SCHEDULE_TASK_TABLE'
}

/** Represents a date range with start and end dates. */
export type DateBlock = {
  __typename?: 'DateBlock';
  /** The end date of the block in yyyy-MM-dd format. */
  end?: Maybe<Scalars['String']['output']>;
  /** The start date of the block in yyyy-MM-dd format. */
  start?: Maybe<Scalars['String']['output']>;
};

/** Input type for specifying a date range. */
export type DateBlockInput = {
  /** The end date of the block in yyyy-MM-dd format. */
  end?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the block in yyyy-MM-dd format. */
  start?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for specifying date-based ordering criteria. */
export type DateOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  endAt?: InputMaybe<Sort>;
  startAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

/** Input type for specifying a date-time range. */
export type DateTimeRangeInput = {
  endAt: Scalars['datetime']['input'];
  startAt: Scalars['datetime']['input'];
};

/** Output type for representing a date-time range. */
export type DateTimeRangeOutput = {
  __typename?: 'DateTimeRangeOutput';
  /** @deprecated No longer supported */
  end: Scalars['datetime']['output'];
  endAt: Scalars['datetime']['output'];
  /** @deprecated No longer supported */
  start: Scalars['datetime']['output'];
  startAt: Scalars['datetime']['output'];
};

export type DebriefAtsWriteSettingInput = {
  atsInterviewDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /** Mutually exclusive with atsInterviewDefinitionId; sending both is rejected. */
  definitionNameMatch?: InputMaybe<Scalars['String']['input']>;
  scorecardRecipients?: InputMaybe<NotificationPreferenceInput>;
};

/**
 * Debrief -> ATS write setting. A resolved setting with a non-null atsInterviewDefinitionId is the
 * on-switch; there is no separate enabled flag.
 */
export type DebriefAtsWriteSettingPref = {
  __typename?: 'DebriefAtsWriteSettingPref';
  atsInterviewDefinitionId?: Maybe<Scalars['String']['output']>;
  /**
   * A scorecard name matched against each job's own interview definitions at write time. Mutually
   * exclusive with atsInterviewDefinitionId; setting either one is the on-switch.
   */
  definitionNameMatch?: Maybe<Scalars['String']['output']>;
  scorecardRecipients?: Maybe<NotificationPreference>;
};

export type DebriefAtsWriteSettingWithLevel = {
  __typename?: 'DebriefAtsWriteSettingWithLevel';
  debriefAtsWriteSetting?: Maybe<DebriefAtsWriteSettingPref>;
  level: SettingLevel;
};

export type DebriefEventAdditionalAttendeesPref = {
  __typename?: 'DebriefEventAdditionalAttendeesPref';
  additionalAttendees: Array<SettingAdditionalAttendee>;
  additionalRecipientsOptional: Scalars['Boolean']['output'];
  debriefEventAdditionalAttendees: NotificationPreference;
};

export type DebriefMeetingLocationSettingWithLevel = {
  __typename?: 'DebriefMeetingLocationSettingWithLevel';
  debriefMeetingLocationSetting?: Maybe<InterviewMeetingLocationSettingPref>;
  level: SettingLevel;
};

export type DebriefMetrics = {
  __typename?: 'DebriefMetrics';
  byAttendees: Array<DebriefMetricsAttendeeRow>;
  bySchedulers: Array<DebriefMetricsSchedulerRow>;
  totals: DebriefMetricsTotals;
  trend: Array<DebriefMetricsTrendPoint>;
};

export type DebriefMetricsAttendeeRow = {
  __typename?: 'DebriefMetricsAttendeeRow';
  accepted: Scalars['Int']['output'];
  declined: Scalars['Int']['output'];
  interviewer?: Maybe<Employee>;
  interviewerId: Scalars['uuid']['output'];
  invited: Scalars['Int']['output'];
  needsAction: Scalars['Int']['output'];
  tentative: Scalars['Int']['output'];
};

export enum DebriefMetricsBucket {
  Day = 'DAY',
  Week = 'WEEK'
}

/**
 *  Same shape as DebriefMetricsInput; separate types at GraphQL and gRPC so each query/RPC
 *  can evolve independently.
 */
export type DebriefMetricsDownloadInput = {
  bucket: DebriefMetricsBucket;
  downloadReason?: InputMaybe<Scalars['String']['input']>;
  endAt: Scalars['datetime']['input'];
  filters?: InputMaybe<DebriefMetricsFilters>;
  startAt: Scalars['datetime']['input'];
  timezone: Scalars['String']['input'];
};

export type DebriefMetricsDownloadRow = {
  __typename?: 'DebriefMetricsDownloadRow';
  acceptedCount: Scalars['Int']['output'];
  attendeeCount: Scalars['Int']['output'];
  cancelledAt?: Maybe<Scalars['datetime']['output']>;
  candidateName?: Maybe<Scalars['String']['output']>;
  debriefId: Scalars['uuid']['output'];
  declinedCount: Scalars['Int']['output'];
  endAt: Scalars['datetime']['output'];
  isCancelled: Scalars['Boolean']['output'];
  jobName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scheduler?: Maybe<Employee>;
  schedulerEmployeeId?: Maybe<Scalars['uuid']['output']>;
  startAt: Scalars['datetime']['output'];
  taskId?: Maybe<Scalars['uuid']['output']>;
};

export type DebriefMetricsFilters = {
  jobIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  schedulerEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type DebriefMetricsInput = {
  bucket: DebriefMetricsBucket;
  endAt: Scalars['datetime']['input'];
  filters?: InputMaybe<DebriefMetricsFilters>;
  startAt: Scalars['datetime']['input'];
  timezone: Scalars['String']['input'];
};

export type DebriefMetricsSchedulerRow = {
  __typename?: 'DebriefMetricsSchedulerRow';
  attendeeDeclines: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  scheduler?: Maybe<Employee>;
  schedulerEmployeeId?: Maybe<Scalars['uuid']['output']>;
  upcoming: Scalars['Int']['output'];
};

export type DebriefMetricsTotals = {
  __typename?: 'DebriefMetricsTotals';
  attendeeDeclines: Scalars['Int']['output'];
  cancelled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
};

export type DebriefMetricsTrendPoint = {
  __typename?: 'DebriefMetricsTrendPoint';
  bucketStart: Scalars['datetime']['output'];
  cancelled: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
};

export type DebriefOptionsInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  durationMinutes: Scalars['numeric']['input'];
  exactTime?: InputMaybe<Scalars['datetime']['input']>;
  hardConflicts?: InputMaybe<Array<HardConflictInput>>;
  interviewerIds: Array<Scalars['uuid']['input']>;
  /** One of the following 2 need to be sent. */
  timeRanges?: InputMaybe<Array<DateTimeRangeInput>>;
};

export type DebriefRescheduleDetails = {
  __typename?: 'DebriefRescheduleDetails';
  hasAttendeeAdded: Scalars['Boolean']['output'];
  hasScheduleTimeAfterDebriefStartAt: Scalars['Boolean']['output'];
};

/** ################################################################### */
export enum DeclineReason {
  Conflict = 'CONFLICT',
  KnowTheCandidate = 'KNOW_THE_CANDIDATE',
  Missed = 'MISSED',
  Other = 'OTHER',
  OutsideWorkHours = 'OUTSIDE_WORK_HOURS',
  OutOfOffice = 'OUT_OF_OFFICE',
  OverLimit = 'OVER_LIMIT'
}

export type DefaultCustomInterviewScheduleTokenPref = {
  __typename?: 'DefaultCustomInterviewScheduleTokenPref';
  breakDividerFormat: Scalars['String']['output'];
  candidatePhoneNumberFormat?: Maybe<Scalars['String']['output']>;
  codingLinkFormat?: Maybe<Scalars['String']['output']>;
  dateHeaderFormat: Scalars['String']['output'];
  interviewDetailWithTime: Scalars['String']['output'];
  singleMeetingLinkFormat?: Maybe<DefaultMeetingLinkFormat>;
  uniqueMeetingLinkFormat?: Maybe<DefaultMeetingLinkFormat>;
};

/** Result type for default custom interview schedule token preferences. */
export type DefaultCustomInterviewScheduleTokenResult = {
  __typename?: 'DefaultCustomInterviewScheduleTokenResult';
  /** The default preferences for custom interview schedule tokens. */
  pref?: Maybe<DefaultCustomInterviewScheduleTokenPref>;
};

export type DefaultMeetingLinkFormat = {
  __typename?: 'DefaultMeetingLinkFormat';
  customLinkFormat?: Maybe<Scalars['String']['output']>;
  workspaceVideoLinkFormat?: Maybe<Scalars['String']['output']>;
  zoomLinkFormat?: Maybe<Scalars['String']['output']>;
};

/**
 * Specifies the scope of self-scheduled interviews to be deleted.
 * This enum is used when deleting self-scheduled interviews to determine which ones should be removed.
 */
export enum DeleteType {
  /** Delete all self-scheduled interviews, both past and upcoming. */
  All = 'ALL',
  /** Delete only past self-scheduled interviews. */
  Past = 'PAST',
  /** Delete only upcoming self-scheduled interviews. */
  Upcoming = 'UPCOMING'
}

export type DialInfo = {
  __typename?: 'DialInfo';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DirectoryPageFiltersPref = {
  __typename?: 'DirectoryPageFiltersPref';
  countryAttributeIds: Array<Scalars['uuid']['output']>;
  customAttributeIds: Array<Scalars['uuid']['output']>;
  departmentAttributeIds: Array<Scalars['uuid']['output']>;
  levelAttributeIds: Array<Scalars['uuid']['output']>;
  locationAttributeIds: Array<Scalars['uuid']['output']>;
  teamAttributeIds: Array<Scalars['uuid']['output']>;
};

export enum DirectoryType {
  Google = 'GOOGLE',
  MultiDomain = 'MULTI_DOMAIN',
  Outlook = 'OUTLOOK'
}

/** Represents a duration of time. */
export type Duration = {
  __typename?: 'Duration';
  nanos: Scalars['numeric']['output'];
  seconds: Scalars['numeric']['output'];
};

export enum DurationEmployeePref {
  /**  keep-sorted:begin */
  DurationFeedbackWritingTime = 'duration_feedback_writing_time'
}

export type DurationEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'DurationEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  value?: Maybe<Duration>;
};

/** Input type for specifying a duration. */
export type DurationInput = {
  nanos?: InputMaybe<Scalars['numeric']['input']>;
  seconds: Scalars['numeric']['input'];
};

export enum DurationOrgPref {
  /**  keep-sorted:begin */
  DurationAgentAutoWakeDuration = 'duration_agent_auto_wake_duration',
  DurationAvailabilityRequestAdvanceNotice = 'duration_availability_request_advance_notice',
  DurationAvailabilityRequestStepIncrement = 'duration_availability_request_step_increment',
  DurationAvailabilityRequestTimeframe = 'duration_availability_request_timeframe',
  DurationCandidateRetention = 'duration_candidate_retention',
  DurationDefaultDebriefDuration = 'duration_default_debrief_duration',
  DurationDefaultInterviewDuration = 'duration_default_interview_duration',
  DurationDefaultSchedulingWindow = 'duration_default_scheduling_window',
  DurationFeedbackWritingTime = 'duration_feedback_writing_time',
  DurationSelfScheduleRequestAdvanceNotice = 'duration_self_schedule_request_advance_notice',
  DurationSelfScheduleRequestStepIncrement = 'duration_self_schedule_request_step_increment',
  DurationSelfScheduleRequestTimeframe = 'duration_self_schedule_request_timeframe',
  DurationSessionInactivityTimeout = 'duration_session_inactivity_timeout'
}

export enum DynamicAudience {
  CandidatesPreviousInterviewers = 'CANDIDATES_PREVIOUS_INTERVIEWERS',
  CandidateCoordinator = 'CANDIDATE_COORDINATOR',
  CandidateRecruiter = 'CANDIDATE_RECRUITER',
  CandidateSourcer = 'CANDIDATE_SOURCER',
  DebriefAttendees = 'DEBRIEF_ATTENDEES',
  InterviewersForThisCandidate = 'INTERVIEWERS_FOR_THIS_CANDIDATE',
  InterviewersOnSchedule = 'INTERVIEWERS_ON_SCHEDULE',
  JobCoordinators = 'JOB_COORDINATORS',
  JobHiringManagers = 'JOB_HIRING_MANAGERS',
  JobRecruiters = 'JOB_RECRUITERS',
  JobSourcers = 'JOB_SOURCERS',
  NotSpecified = 'NOT_SPECIFIED',
  TaskAssignee = 'TASK_ASSIGNEE',
  TaskCreator = 'TASK_CREATOR',
  TaskSubscribers = 'TASK_SUBSCRIBERS'
}

export type DynamicEmployee = {
  __typename?: 'DynamicEmployee';
  /** Includes interviewers for completed and future interviews */
  CANDIDATES_PREVIOUS_INTERVIEWERS: Array<Employee>;
  CANDIDATE_COORDINATOR?: Maybe<Employee>;
  CANDIDATE_RECRUITER?: Maybe<Employee>;
  CANDIDATE_SOURCER?: Maybe<Employee>;
  /** Includes interviewers for completed interviews */
  DEBRIEF_ATTENDEES: Array<Employee>;
  INTERVIEWERS_FOR_THIS_CANDIDATE: Array<Employee>;
  INTERVIEWERS_ON_SCHEDULE: Array<Employee>;
  JOB_COORDINATORS: Array<Employee>;
  JOB_HIRING_MANAGERS: Array<Employee>;
  JOB_RECRUITERS: Array<Employee>;
  JOB_SOURCERS: Array<Employee>;
  TASK_ASSIGNEE?: Maybe<Employee>;
  TASK_CREATOR?: Maybe<Employee>;
  TASK_SUBSCRIBERS: Array<Employee>;
  id?: Maybe<Scalars['String']['output']>;
};


export type DynamicEmployeeCandidates_Previous_InterviewersArgs = {
  input: DynamicEmployeeApplicationInput;
};


export type DynamicEmployeeCandidate_CoordinatorArgs = {
  input: DynamicEmployeeApplicationInput;
};


export type DynamicEmployeeCandidate_RecruiterArgs = {
  input: DynamicEmployeeApplicationInput;
};


export type DynamicEmployeeCandidate_SourcerArgs = {
  input: DynamicEmployeeApplicationInput;
};


export type DynamicEmployeeDebrief_AttendeesArgs = {
  input: DynamicEmployeeTaskInput;
};


export type DynamicEmployeeInterviewers_For_This_CandidateArgs = {
  input: DynamicEmployeeApplicationInput;
};


export type DynamicEmployeeInterviewers_On_ScheduleArgs = {
  input: DynamicEmployeeScheduleInterviewerInput;
};


export type DynamicEmployeeJob_CoordinatorsArgs = {
  input: DynamicEmployeeJobInput;
};


export type DynamicEmployeeJob_Hiring_ManagersArgs = {
  input: DynamicEmployeeJobInput;
};


export type DynamicEmployeeJob_RecruitersArgs = {
  input: DynamicEmployeeJobInput;
};


export type DynamicEmployeeJob_SourcersArgs = {
  input: DynamicEmployeeJobInput;
};


export type DynamicEmployeeTask_AssigneeArgs = {
  input: DynamicEmployeeTaskInput;
};


export type DynamicEmployeeTask_CreatorArgs = {
  input: DynamicEmployeeTaskInput;
};


export type DynamicEmployeeTask_SubscribersArgs = {
  input: DynamicEmployeeTaskInput;
};

export type DynamicEmployeeApplicationInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
};

export type DynamicEmployeeJobInput = {
  jobId: Scalars['uuid']['input'];
};

export type DynamicEmployeeScheduleInterviewerInput = {
  employeeIds: Array<Scalars['uuid']['input']>;
};

export type DynamicEmployeeTaskInput = {
  taskId: Scalars['uuid']['input'];
};

export enum DynamicInterviewMeetingHost {
  CustomMeetingHost = 'CUSTOM_MEETING_HOST',
  CustomZoomHost = 'CUSTOM_ZOOM_HOST',
  Interviewers = 'INTERVIEWERS',
  NotSet = 'NOT_SET',
  Scheduler = 'SCHEDULER'
}

/** Enum representing different types of dynamic links. */
export enum DynamicLinkType {
  Coderpad = 'CODERPAD',
  Codesignal = 'CODESIGNAL',
  Codility = 'CODILITY',
  Hackerrank = 'HACKERRANK'
}

export type Email = {
  __typename?: 'Email';
  id: Scalars['uuid']['output'];
  isSmtpIdAvailable?: Maybe<Scalars['Boolean']['output']>;
  jobStage: JobStage;
  recipients: Recipient;
  sentAt?: Maybe<Scalars['datetime']['output']>;
  subject: Scalars['String']['output'];
};

export type Employee = {
  __typename?: 'Employee';
  absoluteWorkHours: Array<DateTimeRangeOutput>;
  aiInstruction?: Maybe<AiInstruction>;
  aiMemories: Array<AiMemory>;
  applicationStageInterviews?: Maybe<EmployeeApplicationStageInterviewsOutput>;
  atsAccountStatus: EmployeeIntegrationAccountStatus;
  atsId?: Maybe<Scalars['String']['output']>;
  atsType?: Maybe<AtsType>;
  atsUser?: Maybe<AtsUser>;
  atsUserLastSyncedAt?: Maybe<Scalars['datetime']['output']>;
  attributes?: Maybe<Array<EmployeeAttributeTagValue>>;
  bio?: Maybe<Scalars['String']['output']>;
  calendarDelegate?: Maybe<Employee>;
  calendarTimezone?: Maybe<Scalars['String']['output']>;
  chatAccountStatus: EmployeeIntegrationAccountStatus;
  directoryAccountStatus: EmployeeIntegrationAccountStatus;
  directoryUserId?: Maybe<Scalars['String']['output']>;
  directoryUserLastSyncedAt?: Maybe<Scalars['datetime']['output']>;
  email: Scalars['String']['output'];
  employeePref?: Maybe<EmployeePref>;
  employeePrefByNames: Array<EmployeePref>;
  employeePrefValues: Array<EmployeePrefValue>;
  employeePrefs?: Maybe<Array<EmployeePref>>;
  externalProfilePicture?: Maybe<ProfilePicture>;
  familyName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  googleUserId?: Maybe<Scalars['String']['output']>;
  hasAtsId?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /**  This will also be returned for any employee and not just for the actor. */
  integrations?: Maybe<EmployeeIntegrations>;
  internalProfilePictureUrl?: Maybe<Scalars['String']['output']>;
  interviewModuleMember?: Maybe<InterviewModuleMember>;
  interviewModuleMembers?: Maybe<EmployeeInterviewModuleMembersOutput>;
  interviewPauseDates?: Maybe<Array<DateBlock>>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isAtsDisabled?: Maybe<Scalars['Boolean']['output']>;
  isDirectoryDisabled: Scalars['Boolean']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  /**  is the employee currently paused? */
  isPaused: Scalars['Boolean']['output'];
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  loadAndLimit?: Maybe<LoadAndLimit>;
  locale?: Maybe<Locale>;
  manager?: Maybe<Employee>;
  modulesInTrainingCount?: Maybe<Scalars['numeric']['output']>;
  modulesTrainedCount?: Maybe<Scalars['numeric']['output']>;
  notificationPrefs: Array<EmployeeNotificationPreference>;
  orgDirectoryIntegration?: Maybe<OrgDirectoryIntegration>;
  orgId: Scalars['uuid']['output'];
  orgUser?: Maybe<OrgUser>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  plannedAvailabilities: Array<EmployeePlannedAvailability>;
  primaryCalendarLastSyncedAt?: Maybe<Scalars['datetime']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  slackImageUrl?: Maybe<Scalars['String']['output']>;
  slackUserId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  upcomingInterviewsCount?: Maybe<Scalars['numeric']['output']>;
  useCalendarTimezone: Scalars['Boolean']['output'];
  workHours?: Maybe<TimeBlockWeek>;
  zoomAccountStatus: EmployeeIntegrationAccountStatus;
  zoomUser?: Maybe<ZoomUser>;
};


export type EmployeeAbsoluteWorkHoursArgs = {
  input: EmployeeAbsoluteWorkHoursInput;
};


export type EmployeeApplicationStageInterviewsArgs = {
  input: EmployeeApplicationStageInterviewsInput;
};


export type EmployeeEmployeePrefArgs = {
  prefName: Scalars['String']['input'];
};


export type EmployeeEmployeePrefByNamesArgs = {
  prefNames: Array<Scalars['String']['input']>;
};


export type EmployeeInterviewModuleMemberArgs = {
  interviewModuleId: Scalars['uuid']['input'];
};


export type EmployeeInterviewModuleMembersArgs = {
  input: EmployeeInterviewModuleMembersInput;
};


export type EmployeeLoadAndLimitArgs = {
  input: LoadAndLimitInput;
};

export type EmployeeAbsoluteWorkHoursInput = {
  range: DateTimeRangeInput;
};

export type EmployeeActor = Actor & {
  __typename?: 'EmployeeActor';
  displayName: Scalars['String']['output'];
  employee: Employee;
  id: Scalars['String']['output'];
  type: ActorType;
};

export type EmployeeAiContextTarget = AiContextTarget & {
  __typename?: 'EmployeeAiContextTarget';
  employee: Employee;
  id: Scalars['uuid']['output'];
  type: AiContextTargetType;
};

export enum EmployeeApplicationStageInterviewOrderByProperty {
  Date = 'DATE'
}

export type EmployeeApplicationStageInterviewsInput = {
  includeCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  jobIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  jobStageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy: EmployeeApplicationStageInterviewsOrderBy;
  pageInput: PageInput;
  statusFilters?: InputMaybe<Array<InputMaybe<EmployeeApplicationStageInterviewsStatusFilter>>>;
};

export type EmployeeApplicationStageInterviewsOrderBy = {
  direction: Sort;
  property: EmployeeApplicationStageInterviewOrderByProperty;
};

export type EmployeeApplicationStageInterviewsOutput = {
  __typename?: 'EmployeeApplicationStageInterviewsOutput';
  items: Array<ApplicationStageInterview>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export enum EmployeeApplicationStageInterviewsStatusFilter {
  Completed = 'COMPLETED',
  Ongoing = 'ONGOING',
  Scheduled = 'SCHEDULED'
}

export type EmployeeAttribute = {
  attributeNameId?: InputMaybe<Scalars['uuid']['input']>;
  attributeValueIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
};

/** ########################################## */
export type EmployeeAttributeBulkUpsertInput = {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type EmployeeAttributeName = {
  __typename?: 'EmployeeAttributeName';
  id: Scalars['uuid']['output'];
  mappingType: MappingType;
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  syncSourceType: SyncSourceType;
  type: AttributeNameType;
  values?: Maybe<Array<EmployeeAttributeTagValue>>;
};

/**
 * ##########################################################
 *  Employee Attribute
 */
export type EmployeeAttributeNameCreateInput = {
  name: Scalars['String']['input'];
};

export type EmployeeAttributeNameDeleteInput = {
  attributeNameId: Scalars['uuid']['input'];
};

export type EmployeeAttributeNameUpdateInput = {
  attributeNameId: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  syncSourceType?: InputMaybe<SyncSourceType>;
};

export type EmployeeAttributeNamesInput = {
  types?: InputMaybe<Array<InputMaybe<AttributeNameType>>>;
};

export type EmployeeAttributeNamesResult = {
  __typename?: 'EmployeeAttributeNamesResult';
  items?: Maybe<Array<EmployeeAttributeName>>;
};

export type EmployeeAttributeSet = {
  attributes?: InputMaybe<Array<InputMaybe<EmployeeAttribute>>>;
};

export type EmployeeAttributeTagValue = {
  __typename?: 'EmployeeAttributeTagValue';
  employees?: Maybe<Array<Employee>>;
  id: Scalars['uuid']['output'];
  name?: Maybe<EmployeeAttributeName>;
  value: Scalars['String']['output'];
};

export type EmployeeAttributeValueCreateInput = {
  attributeNameId: Scalars['uuid']['input'];
  value: Scalars['String']['input'];
};

export type EmployeeAttributeValueDeleteInput = {
  attributeNameId: Scalars['uuid']['input'];
  /** If null is passed, then all values associated to the attribute name is passed. */
  attributeTagValueId?: InputMaybe<Scalars['uuid']['input']>;
};

export type EmployeeAttributeValueUpdateInput = {
  attributeNameId: Scalars['uuid']['input'];
  attributeTagValueId: Scalars['uuid']['input'];
  value: Scalars['String']['input'];
};

export type EmployeeAttributesInput = {
  id: Scalars['uuid']['input'];
  set: EmployeeAttributeSet;
};

export type EmployeeBulkUpdateInput = {
  clearLinkedInUrl?: InputMaybe<Scalars['Boolean']['input']>;
  clearManagerEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  clearTitle?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum EmployeeBulkUploadDataType {
  CompanyHolidays = 'COMPANY_HOLIDAYS',
  CustomAttributes = 'CUSTOM_ATTRIBUTES',
  Modules = 'MODULES',
  SystemAttributes = 'SYSTEM_ATTRIBUTES'
}

export type EmployeeDataBulkUpsertInput = {
  dataType: EmployeeBulkUploadDataType;
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type EmployeeFieldSyncSourcePref = {
  __typename?: 'EmployeeFieldSyncSourcePref';
  linkedInUrl?: Maybe<SyncSourceType>;
  manager?: Maybe<SyncSourceType>;
  name?: Maybe<SyncSourceType>;
  title?: Maybe<SyncSourceType>;
};

export enum EmployeeIntegrationAccountStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  NotFound = 'NOT_FOUND'
}

/**
 *  This will also be returned for any employee and not just for the actor.
 *  Never return sensitive info like refresh/access token on this response. Whats okay to return is the integration status.
 *  Maybe scopes, but nothing more than that.
 */
export type EmployeeIntegrations = {
  __typename?: 'EmployeeIntegrations';
  google?: Maybe<GoogleEmployeeIntegration>;
  id: Scalars['uuid']['output'];
  microsoft?: Maybe<MicrosoftEmployeeIntegration>;
  microsoftCustomEmployee?: Maybe<MicrosoftEmployeeIntegration>;
  microsoftGccHighEmployee?: Maybe<MicrosoftGccHighEmployeeIntegration>;
  microsoftServiceUser?: Maybe<MicrosoftEmployeeIntegration>;
  slack?: Maybe<SlackEmployeeIntegration>;
};

export type EmployeeInterviewModuleMembersInput = {
  interviewModuleIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  pageInput: PageInput;
};

export type EmployeeInterviewModuleMembersOutput = {
  __typename?: 'EmployeeInterviewModuleMembersOutput';
  items?: Maybe<Array<InterviewModuleMember>>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type EmployeeJsonPref = CandidatePageFiltersPref | DirectoryPageFiltersPref | EmployeeTaskDashboardFilterPref | EmployeeTaskDashboardLayoutPref | InterviewBufferTimePref | InterviewLimit | MetricsPageAverageTimesFiltersPref | MetricsPageCandidatePulseFiltersPref | MetricsPageInterviewerFiltersPref | MetricsPageRecruitingTeamFiltersPref | ProfilePicturePref | RecentlyUsedZoomUsersPref | UpcomingEventsPageFiltersPref;

/** The organization has no active employee with the requested identifier. */
export type EmployeeNotFoundError = Error & {
  __typename?: 'EmployeeNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** Employee notification inbox — the canonical notification record. */
export type EmployeeNotification = {
  __typename?: 'EmployeeNotification';
  actorEmployee?: Maybe<Employee>;
  createdAt: Scalars['datetime']['output'];
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isRead: Scalars['Boolean']['output'];
  isSeen: Scalars['Boolean']['output'];
  notificationType: Scalars['String']['output'];
  plainText: Scalars['String']['output'];
  readAt?: Maybe<Scalars['datetime']['output']>;
  seenAt?: Maybe<Scalars['datetime']['output']>;
};

export enum EmployeeNotificationMedium {
  Chat = 'CHAT',
  Email = 'EMAIL',
  InApp = 'IN_APP'
}

/** ########################################## */
export type EmployeeNotificationPrefUpdateInput = {
  medium: EmployeeNotificationMedium;
  prefName: EmployeeNotificationType;
  value: Scalars['Boolean']['input'];
};

export type EmployeeNotificationPrefUpdateResult = {
  __typename?: 'EmployeeNotificationPrefUpdateResult';
  employeeNotificationPref?: Maybe<EmployeeNotificationPreference>;
};

export type EmployeeNotificationPreference = {
  __typename?: 'EmployeeNotificationPreference';
  employeeId: Scalars['uuid']['output'];
  id: Scalars['String']['output'];
  medium: EmployeeNotificationMedium;
  /** This is a computed PK */
  orgId: Scalars['uuid']['output'];
  type: EmployeeNotificationType;
  value: Scalars['Boolean']['output'];
};

export enum EmployeeNotificationType {
  CandidateAnonymizationCompleted = 'CANDIDATE_ANONYMIZATION_COMPLETED',
  CandidateDataExportCompleted = 'CANDIDATE_DATA_EXPORT_COMPLETED',
  HiringProcessMismatch = 'HIRING_PROCESS_MISMATCH',
  HiringProcessWarning = 'HIRING_PROCESS_WARNING',
  InterviewerRsvpReminder = 'INTERVIEWER_RSVP_REMINDER',
  InterviewerUpcomingInterview = 'INTERVIEWER_UPCOMING_INTERVIEW',
  InterviewModuleReverseShadowAssignedToInterview = 'INTERVIEW_MODULE_REVERSE_SHADOW_ASSIGNED_TO_INTERVIEW',
  InterviewModuleReverseShadowGraduatedToTrained = 'INTERVIEW_MODULE_REVERSE_SHADOW_GRADUATED_TO_TRAINED',
  InterviewModuleReverseShadowGraduationRejected = 'INTERVIEW_MODULE_REVERSE_SHADOW_GRADUATION_REJECTED',
  InterviewModuleReverseShadowToTrainedApprovalRequired = 'INTERVIEW_MODULE_REVERSE_SHADOW_TO_TRAINED_APPROVAL_REQUIRED',
  InterviewModuleShadowAssignedToInterview = 'INTERVIEW_MODULE_SHADOW_ASSIGNED_TO_INTERVIEW',
  InterviewModuleShadowGraduatedToReverseShadow = 'INTERVIEW_MODULE_SHADOW_GRADUATED_TO_REVERSE_SHADOW',
  InterviewModuleShadowGraduatedToTrained = 'INTERVIEW_MODULE_SHADOW_GRADUATED_TO_TRAINED',
  InterviewModuleShadowGraduationRejected = 'INTERVIEW_MODULE_SHADOW_GRADUATION_REJECTED',
  InterviewModuleShadowToReverseShadowApprovalRequired = 'INTERVIEW_MODULE_SHADOW_TO_REVERSE_SHADOW_APPROVAL_REQUIRED',
  InterviewModuleShadowToTrainedApprovalRequired = 'INTERVIEW_MODULE_SHADOW_TO_TRAINED_APPROVAL_REQUIRED',
  InterviewModuleTrainedAssignedToInterview = 'INTERVIEW_MODULE_TRAINED_ASSIGNED_TO_INTERVIEW',
  InterviewTrainingUpdate = 'INTERVIEW_TRAINING_UPDATE',
  TaskAgentQuestion = 'TASK_AGENT_QUESTION',
  TaskAssigned = 'TASK_ASSIGNED',
  TaskAutomateCreateFailure = 'TASK_AUTOMATE_CREATE_FAILURE',
  TaskAvailabilityRequested = 'TASK_AVAILABILITY_REQUESTED',
  TaskAvailabilitySubmittedByCandidate = 'TASK_AVAILABILITY_SUBMITTED_BY_CANDIDATE',
  TaskAvailabilitySubmittedByEmployee = 'TASK_AVAILABILITY_SUBMITTED_BY_EMPLOYEE',
  TaskCandidateDeclined = 'TASK_CANDIDATE_DECLINED',
  TaskCandidateTentative = 'TASK_CANDIDATE_TENTATIVE',
  TaskChangeRequested = 'TASK_CHANGE_REQUESTED',
  TaskDebriefAttendeeDeactivated = 'TASK_DEBRIEF_ATTENDEE_DEACTIVATED',
  TaskDebriefAttendeeDeclined = 'TASK_DEBRIEF_ATTENDEE_DECLINED',
  TaskDebriefAttendeeTentative = 'TASK_DEBRIEF_ATTENDEE_TENTATIVE',
  TaskInterviewerDeactivated = 'TASK_INTERVIEWER_DEACTIVATED',
  TaskInterviewerDeclined = 'TASK_INTERVIEWER_DECLINED',
  TaskInterviewerTentative = 'TASK_INTERVIEWER_TENTATIVE',
  TaskMarkedUrgent = 'TASK_MARKED_URGENT',
  TaskMention = 'TASK_MENTION',
  TaskNoteAdded = 'TASK_NOTE_ADDED',
  TaskQueueEmployeeMembershipChanged = 'TASK_QUEUE_EMPLOYEE_MEMBERSHIP_CHANGED',
  TaskQueueTaskUnassigned = 'TASK_QUEUE_TASK_UNASSIGNED',
  TaskRcAdjustInterviewerRsvp = 'TASK_RC_ADJUST_INTERVIEWER_RSVP',
  TaskReadyForCandidateComm = 'TASK_READY_FOR_CANDIDATE_COMM',
  TaskSelfScheduleBooked = 'TASK_SELF_SCHEDULE_BOOKED',
  TaskSelfScheduleCanceled = 'TASK_SELF_SCHEDULE_CANCELED',
  TaskSelfScheduleChanged = 'TASK_SELF_SCHEDULE_CHANGED',
  TaskSelfScheduleRequested = 'TASK_SELF_SCHEDULE_REQUESTED'
}

/** Input for querying employee notifications. */
export type EmployeeNotificationsInput = {
  pageInput: PageInput;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result type for employee notifications query. */
export type EmployeeNotificationsResult = {
  __typename?: 'EmployeeNotificationsResult';
  items: Array<EmployeeNotification>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  unreadCount: Scalars['Int']['output'];
  unseenCount: Scalars['Int']['output'];
};

/**
 * ################################
 *  Planned availability
 * ################################
 *  Planned availability for an employee
 */
export type EmployeePlannedAvailability = {
  __typename?: 'EmployeePlannedAvailability';
  createdAt: Scalars['datetime']['output'];
  employeeId: Scalars['uuid']['output'];
  endAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  startAt: Scalars['datetime']['output'];
  timezone: Scalars['timezone']['output'];
  updatedAt: Scalars['datetime']['output'];
  workHours: TimeBlockWeek;
};

export type EmployeePlannedAvailabilityCreateInput = {
  employeeId: Scalars['uuid']['input'];
  endAt: Scalars['datetime']['input'];
  startAt: Scalars['datetime']['input'];
  timezone: Scalars['timezone']['input'];
  workHours: TimeBlockWeekInput;
};

export type EmployeePlannedAvailabilityDeleteInput = {
  id: Scalars['uuid']['input'];
};

export type EmployeePlannedAvailabilityResult = {
  __typename?: 'EmployeePlannedAvailabilityResult';
  item: EmployeePlannedAvailability;
};

export type EmployeePlannedAvailabilityUpdateInput = {
  endAt?: InputMaybe<Scalars['datetime']['input']>;
  id: Scalars['uuid']['input'];
  startAt?: InputMaybe<Scalars['datetime']['input']>;
  timezone?: InputMaybe<Scalars['timezone']['input']>;
  workHours?: InputMaybe<TimeBlockWeekInput>;
};

export type EmployeePref = {
  __typename?: 'EmployeePref';
  /**
   *  Derived from the backend pref registry and never persisted; read-only. Always USER_DRIVEN
   *  today — see EmployeePref.getAudience().
   */
  audience?: Maybe<PrefAudience>;
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['datetime']['output']>;
  duration?: Maybe<Duration>;
  employeeId: Scalars['uuid']['output'];
  id: Scalars['String']['output'];
  intValue?: Maybe<Scalars['numeric']['output']>;
  json?: Maybe<Scalars['jsonb']['output']>;
  jsonArray?: Maybe<Array<Scalars['jsonb']['output']>>;
  jsonArrayPref: Array<EmployeeJsonPref>;
  jsonPref?: Maybe<EmployeeJsonPref>;
  /** This is a computed PK */
  orgId: Scalars['uuid']['output'];
  prefName: Scalars['String']['output'];
  stringArray?: Maybe<Array<Scalars['String']['output']>>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['datetime']['output']>;
  updatedAt?: Maybe<Scalars['datetime']['output']>;
};

/** ########################################## */
export type EmployeePrefUpdateInput = {
  employeeId: Scalars['uuid']['input'];
  prefName: Scalars['String']['input'];
  set?: InputMaybe<PrefSet>;
};

export type EmployeePrefUpdateResult = {
  __typename?: 'EmployeePrefUpdateResult';
  employeePref?: Maybe<EmployeePref>;
};

export type EmployeePrefValue = {
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
};

/** ######################################################### */
export type EmployeeSearchInput = {
  attributeNameValueMap?: InputMaybe<Array<AttributeNameValueMapInput>>;
  directoryIntegrationIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  hasAtsId?: InputMaybe<Scalars['Boolean']['input']>;
  hasIntegrations?: InputMaybe<Array<IntegrationType>>;
  hasTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAtsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isSendOnBehalfOfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeSearchOutput = {
  __typename?: 'EmployeeSearchOutput';
  items: Array<Employee>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EmployeeSet = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  calendarDelegateEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  clearCalendarDelegateEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  interviewPauseDates?: InputMaybe<Array<InputMaybe<DateBlockInput>>>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Locale>;
  managerEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  useCalendarTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  workHours?: InputMaybe<TimeBlockWeekInput>;
};

export type EmployeeTaskDashboardFilterPref = {
  __typename?: 'EmployeeTaskDashboardFilterPref';
  applicationStatuses: Array<ApplicationStatus>;
  assigneeEmployeeIds: Array<Scalars['uuid']['output']>;
  assigneeEmployees: Array<Employee>;
  creatorEmployeeIds: Array<Scalars['uuid']['output']>;
  creatorEmployees: Array<Employee>;
  delegateTypes?: Maybe<Array<Scalars['String']['output']>>;
  flags: Array<TaskFlagType>;
  isUrgent: Scalars['Boolean']['output'];
  jobIds: Array<Scalars['uuid']['output']>;
  jobStageNames: Array<Scalars['String']['output']>;
  jobs: Array<Job>;
  showCompletedInFlagged: Scalars['Boolean']['output'];
  showNoQueue: Scalars['Boolean']['output'];
  showUnassigned: Scalars['Boolean']['output'];
  tagIds: Array<Scalars['uuid']['output']>;
  tags: Array<TaskTag>;
  taskQueueIds: Array<Scalars['uuid']['output']>;
  taskQueues: Array<TaskQueue>;
  taskStatuses: Array<TaskStatus>;
};

export type EmployeeTaskDashboardLayoutPref = {
  __typename?: 'EmployeeTaskDashboardLayoutPref';
  columnType: ScheduleTaskColumnType;
  isVisible: Scalars['Boolean']['output'];
};

export type EmployeeUpdateInput = {
  id: Scalars['uuid']['input'];
  set: EmployeeSet;
};

export type EmployeeUpdateResult = {
  __typename?: 'EmployeeUpdateResult';
  employee?: Maybe<Employee>;
};

/**
 * ##########################################################
 *  Input and output for employees
 */
export type EmployeesInput = {
  directoryIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  directoryType?: InputMaybe<DirectoryType>;
  /**  Exclude employees which are already added as user of modernloop. */
  excludeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAtsId?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAtsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
  /** Prefer active organization users before other employees while preserving email order within each group. */
  preferActiveOrganizationUsers?: InputMaybe<Scalars['Boolean']['input']>;
  requiredPermission?: InputMaybe<Permission>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeesOutput = {
  __typename?: 'EmployeesOutput';
  items: Array<Employee>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Represents the result of an operation that doesn't return any data. */
export type EmptyResult = {
  __typename?: 'EmptyResult';
  result?: Maybe<Result>;
};

export type Error = {
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export enum ErrorCode {
  ActiveSelfScheduleAlreadyPresent = 'ACTIVE_SELF_SCHEDULE_ALREADY_PRESENT',
  ActivityLogNotFound = 'ACTIVITY_LOG_NOT_FOUND',
  ActorAuthContextNotFound = 'ACTOR_AUTH_CONTEXT_NOT_FOUND',
  ActorMissingAtsId = 'ACTOR_MISSING_ATS_ID',
  AgentThreadNotFound = 'AGENT_THREAD_NOT_FOUND',
  AgentToolCallCannotBookAdditionalInterviewWithoutSchedule = 'AGENT_TOOL_CALL_CANNOT_BOOK_ADDITIONAL_INTERVIEW_WITHOUT_SCHEDULE',
  AgentToolCallCannotBookScheduleWithoutInterviewPlan = 'AGENT_TOOL_CALL_CANNOT_BOOK_SCHEDULE_WITHOUT_INTERVIEW_PLAN',
  AgentToolCallCannotBookScheduleWithActiveAvailabilityRequest = 'AGENT_TOOL_CALL_CANNOT_BOOK_SCHEDULE_WITH_ACTIVE_AVAILABILITY_REQUEST',
  AgentToolCallCannotBookScheduleWithActiveSelfScheduleRequest = 'AGENT_TOOL_CALL_CANNOT_BOOK_SCHEDULE_WITH_ACTIVE_SELF_SCHEDULE_REQUEST',
  AgentToolCallCannotBookScheduleWithExistingSchedule = 'AGENT_TOOL_CALL_CANNOT_BOOK_SCHEDULE_WITH_EXISTING_SCHEDULE',
  AgentToolCallCannotBookScheduleWithInvalidInterviewPlan = 'AGENT_TOOL_CALL_CANNOT_BOOK_SCHEDULE_WITH_INVALID_INTERVIEW_PLAN',
  AgentToolCallCannotCancelAvailabilityRequestWithoutActiveRequest = 'AGENT_TOOL_CALL_CANNOT_CANCEL_AVAILABILITY_REQUEST_WITHOUT_ACTIVE_REQUEST',
  AgentToolCallCannotCancelLastSingleInterview = 'AGENT_TOOL_CALL_CANNOT_CANCEL_LAST_SINGLE_INTERVIEW',
  AgentToolCallCannotCancelScheduleWithoutSchedule = 'AGENT_TOOL_CALL_CANNOT_CANCEL_SCHEDULE_WITHOUT_SCHEDULE',
  AgentToolCallCannotCancelSelfScheduleRequestWithoutActiveRequest = 'AGENT_TOOL_CALL_CANNOT_CANCEL_SELF_SCHEDULE_REQUEST_WITHOUT_ACTIVE_REQUEST',
  AgentToolCallCannotCancelSingleInterviewWithoutSchedule = 'AGENT_TOOL_CALL_CANNOT_CANCEL_SINGLE_INTERVIEW_WITHOUT_SCHEDULE',
  AgentToolCallCannotGetScheduleOptionsWithoutCandidateAvailability = 'AGENT_TOOL_CALL_CANNOT_GET_SCHEDULE_OPTIONS_WITHOUT_CANDIDATE_AVAILABILITY',
  AgentToolCallCannotGetScheduleOptionsWithInsufficientCandidateAvailability = 'AGENT_TOOL_CALL_CANNOT_GET_SCHEDULE_OPTIONS_WITH_INSUFFICIENT_CANDIDATE_AVAILABILITY',
  AgentToolCallCannotRescheduleInterviewWithoutSchedule = 'AGENT_TOOL_CALL_CANNOT_RESCHEDULE_INTERVIEW_WITHOUT_SCHEDULE',
  AgentToolCallCannotScheduleDebriefWithoutSchedule = 'AGENT_TOOL_CALL_CANNOT_SCHEDULE_DEBRIEF_WITHOUT_SCHEDULE',
  AgentToolCallCannotScheduleDebriefWithExistingDebrief = 'AGENT_TOOL_CALL_CANNOT_SCHEDULE_DEBRIEF_WITH_EXISTING_DEBRIEF',
  AgentToolCallCannotSendAvailabilityRequestWithActiveAvailabilityRequest = 'AGENT_TOOL_CALL_CANNOT_SEND_AVAILABILITY_REQUEST_WITH_ACTIVE_AVAILABILITY_REQUEST',
  AgentToolCallCannotSendAvailabilityRequestWithActiveSelfScheduleRequest = 'AGENT_TOOL_CALL_CANNOT_SEND_AVAILABILITY_REQUEST_WITH_ACTIVE_SELF_SCHEDULE_REQUEST',
  AgentToolCallCannotSendAvailabilityRequestWithExistingSchedule = 'AGENT_TOOL_CALL_CANNOT_SEND_AVAILABILITY_REQUEST_WITH_EXISTING_SCHEDULE',
  AgentToolCallCannotSendSelfScheduleRequestWithoutInterviewPlan = 'AGENT_TOOL_CALL_CANNOT_SEND_SELF_SCHEDULE_REQUEST_WITHOUT_INTERVIEW_PLAN',
  AgentToolCallCannotSendSelfScheduleRequestWithActiveAvailabilityRequest = 'AGENT_TOOL_CALL_CANNOT_SEND_SELF_SCHEDULE_REQUEST_WITH_ACTIVE_AVAILABILITY_REQUEST',
  AgentToolCallCannotSendSelfScheduleRequestWithActiveSelfScheduleRequest = 'AGENT_TOOL_CALL_CANNOT_SEND_SELF_SCHEDULE_REQUEST_WITH_ACTIVE_SELF_SCHEDULE_REQUEST',
  AgentToolCallCannotSendSelfScheduleRequestWithExistingSchedule = 'AGENT_TOOL_CALL_CANNOT_SEND_SELF_SCHEDULE_REQUEST_WITH_EXISTING_SCHEDULE',
  AgentToolCallCannotSendSelfScheduleRequestWithInvalidInterviewPlan = 'AGENT_TOOL_CALL_CANNOT_SEND_SELF_SCHEDULE_REQUEST_WITH_INVALID_INTERVIEW_PLAN',
  AgentToolCallCannotSetInterviewPlanWithActiveAvailabilityRequest = 'AGENT_TOOL_CALL_CANNOT_SET_INTERVIEW_PLAN_WITH_ACTIVE_AVAILABILITY_REQUEST',
  AgentToolCallCannotSetInterviewPlanWithActiveSelfScheduleRequest = 'AGENT_TOOL_CALL_CANNOT_SET_INTERVIEW_PLAN_WITH_ACTIVE_SELF_SCHEDULE_REQUEST',
  AgentToolCallCannotSetInterviewPlanWithExistingSchedule = 'AGENT_TOOL_CALL_CANNOT_SET_INTERVIEW_PLAN_WITH_EXISTING_SCHEDULE',
  AgentToolCallCannotUpdateAvailabilityRequestWithoutActiveRequest = 'AGENT_TOOL_CALL_CANNOT_UPDATE_AVAILABILITY_REQUEST_WITHOUT_ACTIVE_REQUEST',
  AgentToolCallCannotUpdateDebriefWithoutDebrief = 'AGENT_TOOL_CALL_CANNOT_UPDATE_DEBRIEF_WITHOUT_DEBRIEF',
  AgentToolCallCannotUpdateInterviewWithoutSchedule = 'AGENT_TOOL_CALL_CANNOT_UPDATE_INTERVIEW_WITHOUT_SCHEDULE',
  AgentToolCallCannotUpdateSelfScheduleRequestWithoutActiveRequest = 'AGENT_TOOL_CALL_CANNOT_UPDATE_SELF_SCHEDULE_REQUEST_WITHOUT_ACTIVE_REQUEST',
  AgentToolCallDeadlineExceeded = 'AGENT_TOOL_CALL_DEADLINE_EXCEEDED',
  AgentToolCallInternalError = 'AGENT_TOOL_CALL_INTERNAL_ERROR',
  AgentToolCallInvalidInput = 'AGENT_TOOL_CALL_INVALID_INPUT',
  AgentToolCallRequestCancelled = 'AGENT_TOOL_CALL_REQUEST_CANCELLED',
  AgentToolCallServiceUnavailable = 'AGENT_TOOL_CALL_SERVICE_UNAVAILABLE',
  AiAgentDirectoryNotConnected = 'AI_AGENT_DIRECTORY_NOT_CONNECTED',
  AiAgentEmployeeNotFound = 'AI_AGENT_EMPLOYEE_NOT_FOUND',
  AiAgentMissingRequiredPermissions = 'AI_AGENT_MISSING_REQUIRED_PERMISSIONS',
  AiAgentNotConfigured = 'AI_AGENT_NOT_CONFIGURED',
  AiSchedulingNotEnabled = 'AI_SCHEDULING_NOT_ENABLED',
  ApplicationDebriefNotFound = 'APPLICATION_DEBRIEF_NOT_FOUND',
  ApplicationNotFound = 'APPLICATION_NOT_FOUND',
  ApplicationPermissionDenied = 'APPLICATION_PERMISSION_DENIED',
  ApplicationRejected = 'APPLICATION_REJECTED',
  ApplicationStageInterviewNotFound = 'APPLICATION_STAGE_INTERVIEW_NOT_FOUND',
  ApplicationStageNotFound = 'APPLICATION_STAGE_NOT_FOUND',
  AshbyCannotScheduleArchivedDefaultInterview = 'ASHBY_CANNOT_SCHEDULE_ARCHIVED_DEFAULT_INTERVIEW',
  AshbyCannotScheduleArchivedInterview = 'ASHBY_CANNOT_SCHEDULE_ARCHIVED_INTERVIEW',
  AshbyInterviewAssociatedWithOtherJob = 'ASHBY_INTERVIEW_ASSOCIATED_WITH_OTHER_JOB',
  AshbyServiceUnavailable = 'ASHBY_SERVICE_UNAVAILABLE',
  AshbyUserNotFound = 'ASHBY_USER_NOT_FOUND',
  AtleastOneInterviewHasNoSeats = 'ATLEAST_ONE_INTERVIEW_HAS_NO_SEATS',
  AtsJobStageIdNotFound = 'ATS_JOB_STAGE_ID_NOT_FOUND',
  AtsRecentlyDisconnected = 'ATS_RECENTLY_DISCONNECTED',
  AttemptingToAddRepeatedDirectoryDomain = 'ATTEMPTING_TO_ADD_REPEATED_DIRECTORY_DOMAIN',
  AttemptingToAddUnverifiedDomain = 'ATTEMPTING_TO_ADD_UNVERIFIED_DOMAIN',
  AttemptingToChangeDomainOfDirectoryIntegration = 'ATTEMPTING_TO_CHANGE_DOMAIN_OF_DIRECTORY_INTEGRATION',
  AttemptingToScheduleUnschedulableInterview = 'ATTEMPTING_TO_SCHEDULE_UNSCHEDULABLE_INTERVIEW',
  AttributeCannotBeSyncedFromDirectory = 'ATTRIBUTE_CANNOT_BE_SYNCED_FROM_DIRECTORY',
  AuthCodeGrantFailed = 'AUTH_CODE_GRANT_FAILED',
  AvailabilityRequestCreateFailed = 'AVAILABILITY_REQUEST_CREATE_FAILED',
  AvailabilityRequestUpdateFailed = 'AVAILABILITY_REQUEST_UPDATE_FAILED',
  CalendarEventBodyCannotBeBlank = 'CALENDAR_EVENT_BODY_CANNOT_BE_BLANK',
  CalendarEventCandidateCalendarIdRequired = 'CALENDAR_EVENT_CANDIDATE_CALENDAR_ID_REQUIRED',
  CalendarEventPrivacyNotSpecified = 'CALENDAR_EVENT_PRIVACY_NOT_SPECIFIED',
  CalendarEventSubjectCannotBeBlank = 'CALENDAR_EVENT_SUBJECT_CANNOT_BE_BLANK',
  CalendarHasTooManyEvents = 'CALENDAR_HAS_TOO_MANY_EVENTS',
  CalendarUnavailable = 'CALENDAR_UNAVAILABLE',
  CancelScheduleAlreadyStarted = 'CANCEL_SCHEDULE_ALREADY_STARTED',
  CandidateAlreadyAnonymized = 'CANDIDATE_ALREADY_ANONYMIZED',
  CandidateAlreadyAppliedToJob = 'CANDIDATE_ALREADY_APPLIED_TO_JOB',
  CandidateAvailabilityExceeds_100Hours = 'CANDIDATE_AVAILABILITY_EXCEEDS_100_HOURS',
  CandidateAvailabilityNotFound = 'CANDIDATE_AVAILABILITY_NOT_FOUND',
  CandidateAvailabilityOptionsMissingNotificationRecipients = 'CANDIDATE_AVAILABILITY_OPTIONS_MISSING_NOTIFICATION_RECIPIENTS',
  CandidateAvailabilityOptionsNotFound = 'CANDIDATE_AVAILABILITY_OPTIONS_NOT_FOUND',
  CandidateAvailabilitySetFailed = 'CANDIDATE_AVAILABILITY_SET_FAILED',
  CandidateEmailAddressNotFound = 'CANDIDATE_EMAIL_ADDRESS_NOT_FOUND',
  CandidateEmailAddressRequiredForInvitation = 'CANDIDATE_EMAIL_ADDRESS_REQUIRED_FOR_INVITATION',
  CandidateEmailAttachmentInvalid = 'CANDIDATE_EMAIL_ATTACHMENT_INVALID',
  CandidateEmailBodyCannotBeBlank = 'CANDIDATE_EMAIL_BODY_CANNOT_BE_BLANK',
  CandidateEmailDoesNotBelongToCandidate = 'CANDIDATE_EMAIL_DOES_NOT_BELONG_TO_CANDIDATE',
  CandidateEmailSubjectCannotBeBlank = 'CANDIDATE_EMAIL_SUBJECT_CANNOT_BE_BLANK',
  CandidateHasNoApplication = 'CANDIDATE_HAS_NO_APPLICATION',
  CandidateInvalidApplicationState = 'CANDIDATE_INVALID_APPLICATION_STATE',
  CandidateLinkExpired = 'CANDIDATE_LINK_EXPIRED',
  CandidateLinkInvalid = 'CANDIDATE_LINK_INVALID',
  CandidateMissingEmail = 'CANDIDATE_MISSING_EMAIL',
  CandidateNameEmpty = 'CANDIDATE_NAME_EMPTY',
  CandidateNotAnonymized = 'CANDIDATE_NOT_ANONYMIZED',
  CandidateNotFound = 'CANDIDATE_NOT_FOUND',
  CandidatePermissionDenied = 'CANDIDATE_PERMISSION_DENIED',
  CandidatePortalCannotBeEnabledAsApplicationTooOld = 'CANDIDATE_PORTAL_CANNOT_BE_ENABLED_AS_APPLICATION_TOO_OLD',
  CandidatePortalNoteExists = 'CANDIDATE_PORTAL_NOTE_EXISTS',
  CandidateRescheduleCancelLimitExceeded = 'CANDIDATE_RESCHEDULE_CANCEL_LIMIT_EXCEEDED',
  CandidateResumeNotFound = 'CANDIDATE_RESUME_NOT_FOUND',
  CandidateTimezoneSetFailed = 'CANDIDATE_TIMEZONE_SET_FAILED',
  CannotAddValueToNonManualAttribute = 'CANNOT_ADD_VALUE_TO_NON_MANUAL_ATTRIBUTE',
  CannotAssignEmployeeToNonManualAttribute = 'CANNOT_ASSIGN_EMPLOYEE_TO_NON_MANUAL_ATTRIBUTE',
  CannotCreateSelfScheduleRequestWithZeroOptions = 'CANNOT_CREATE_SELF_SCHEDULE_REQUEST_WITH_ZERO_OPTIONS',
  CannotSetLoadLimitBelowOrgMinimum = 'CANNOT_SET_LOAD_LIMIT_BELOW_ORG_MINIMUM',
  CannotUpdateCancelledSchedule = 'CANNOT_UPDATE_CANCELLED_SCHEDULE',
  CanNotAddDirectoryDisabledEmployeeToModule = 'CAN_NOT_ADD_DIRECTORY_DISABLED_EMPLOYEE_TO_MODULE',
  CanNotConnectGoogleAsOutlookIsConnected = 'CAN_NOT_CONNECT_GOOGLE_AS_OUTLOOK_IS_CONNECTED',
  CanNotConnectOutlookAsGoogleIsConnected = 'CAN_NOT_CONNECT_OUTLOOK_AS_GOOGLE_IS_CONNECTED',
  CompanyHolidayAlreadyExists = 'COMPANY_HOLIDAY_ALREADY_EXISTS',
  CompanyHolidayApplicabilityEmpty = 'COMPANY_HOLIDAY_APPLICABILITY_EMPTY',
  CompanyHolidayDateRangeInvalid = 'COMPANY_HOLIDAY_DATE_RANGE_INVALID',
  CompanyHolidayNameExists = 'COMPANY_HOLIDAY_NAME_EXISTS',
  CompanyHolidayNameRequired = 'COMPANY_HOLIDAY_NAME_REQUIRED',
  CompanyHolidayNameTooLong = 'COMPANY_HOLIDAY_NAME_TOO_LONG',
  CompanyHolidayNotFound = 'COMPANY_HOLIDAY_NOT_FOUND',
  ConnectedAtsIsDifferentThanScheduleAts = 'CONNECTED_ATS_IS_DIFFERENT_THAN_SCHEDULE_ATS',
  ContractExpired = 'CONTRACT_EXPIRED',
  ConversationNotFound = 'CONVERSATION_NOT_FOUND',
  CountryTagValueNotFound = 'COUNTRY_TAG_VALUE_NOT_FOUND',
  CountryTagValueNotUsableForCompanyHoliday = 'COUNTRY_TAG_VALUE_NOT_USABLE_FOR_COMPANY_HOLIDAY',
  CreateSourcingLinkCalendarPermissionMissing = 'CREATE_SOURCING_LINK_CALENDAR_PERMISSION_MISSING',
  CreateSourcingLinkCalendarPreferenceMissing = 'CREATE_SOURCING_LINK_CALENDAR_PREFERENCE_MISSING',
  DuplicateJobStageMapping = 'DUPLICATE_JOB_STAGE_MAPPING',
  EmailTemplateFailedToRender = 'EMAIL_TEMPLATE_FAILED_TO_RENDER',
  EmployeeAttributeNotFound = 'EMPLOYEE_ATTRIBUTE_NOT_FOUND',
  EmployeeIntegrationNotFound = 'EMPLOYEE_INTEGRATION_NOT_FOUND',
  EmployeeInvalidApplicationState = 'EMPLOYEE_INVALID_APPLICATION_STATE',
  EmployeeNotFound = 'EMPLOYEE_NOT_FOUND',
  EmployeePlannedAvailabilityNotFound = 'EMPLOYEE_PLANNED_AVAILABILITY_NOT_FOUND',
  EmployeePlannedAvailabilityTimeRangeInvalid = 'EMPLOYEE_PLANNED_AVAILABILITY_TIME_RANGE_INVALID',
  EmployeePlannedAvailabilityTimeRangeInPast = 'EMPLOYEE_PLANNED_AVAILABILITY_TIME_RANGE_IN_PAST',
  EmployeePlannedAvailabilityTimeRangeOverlaps = 'EMPLOYEE_PLANNED_AVAILABILITY_TIME_RANGE_OVERLAPS',
  EmptyList = 'EMPTY_LIST',
  EmptySet = 'EMPTY_SET',
  EmptyString = 'EMPTY_STRING',
  ErrorCreatingCandidateEvents = 'ERROR_CREATING_CANDIDATE_EVENTS',
  ErrorCreatingInterviewerEvents = 'ERROR_CREATING_INTERVIEWER_EVENTS',
  ErrorCreatingInterviewerFeedbackWritingEvents = 'ERROR_CREATING_INTERVIEWER_FEEDBACK_WRITING_EVENTS',
  ErrorCreatingInterviewOnAts = 'ERROR_CREATING_INTERVIEW_ON_ATS',
  ErrorCreatingScheduleOnAts = 'ERROR_CREATING_SCHEDULE_ON_ATS',
  ErrorListingUsersFromAts = 'ERROR_LISTING_USERS_FROM_ATS',
  ErrorUpdatingInterviewOnAts = 'ERROR_UPDATING_INTERVIEW_ON_ATS',
  ExternalApiKeyAlreadyRevoked = 'EXTERNAL_API_KEY_ALREADY_REVOKED',
  ExternalApiKeyNotFound = 'EXTERNAL_API_KEY_NOT_FOUND',
  FeatureUnavailable = 'FEATURE_UNAVAILABLE',
  ForbiddenBrandingThemeName = 'FORBIDDEN_BRANDING_THEME_NAME',
  GenericInvalidInput = 'GENERIC_INVALID_INPUT',
  GoogleAccessTokenNotFound = 'GOOGLE_ACCESS_TOKEN_NOT_FOUND',
  GoogleDelegatedAuthClientNotAuthorized = 'GOOGLE_DELEGATED_AUTH_CLIENT_NOT_AUTHORIZED',
  GoogleIntegrationAdminMayNotBelongToYourOrg = 'GOOGLE_INTEGRATION_ADMIN_MAY_NOT_BELONG_TO_YOUR_ORG',
  GooglePermissionDeniedForCalendarEventCreateOrUpdate = 'GOOGLE_PERMISSION_DENIED_FOR_CALENDAR_EVENT_CREATE_OR_UPDATE',
  GreenhouseAccessDenied = 'GREENHOUSE_ACCESS_DENIED',
  GreenhouseApplicationNotFound = 'GREENHOUSE_APPLICATION_NOT_FOUND',
  GreenhouseHarvestReadDenied = 'GREENHOUSE_HARVEST_READ_DENIED',
  GreenhouseInterviewCannotBeScheduled = 'GREENHOUSE_INTERVIEW_CANNOT_BE_SCHEDULED',
  GreenhouseInterviewDeletedOrInactive = 'GREENHOUSE_INTERVIEW_DELETED_OR_INACTIVE',
  GreenhouseOauthAccessTokenIsExpired = 'GREENHOUSE_OAUTH_ACCESS_TOKEN_IS_EXPIRED',
  GreenhouseOauthEmployeeIntegrationIsServiceUser = 'GREENHOUSE_OAUTH_EMPLOYEE_INTEGRATION_IS_SERVICE_USER',
  GreenhouseOauthEmployeeIntegrationMismatchingUser = 'GREENHOUSE_OAUTH_EMPLOYEE_INTEGRATION_MISMATCHING_USER',
  GreenhouseOauthEmployeeIntegrationNotAllowedInSandbox = 'GREENHOUSE_OAUTH_EMPLOYEE_INTEGRATION_NOT_ALLOWED_IN_SANDBOX',
  GreenhouseOauthInsufficientScope = 'GREENHOUSE_OAUTH_INSUFFICIENT_SCOPE',
  GreenhouseOauthIntegrationNotFound = 'GREENHOUSE_OAUTH_INTEGRATION_NOT_FOUND',
  GreenhouseOauthIntegrationUserNotFound = 'GREENHOUSE_OAUTH_INTEGRATION_USER_NOT_FOUND',
  GreenhouseOauthInvalidAccessToken = 'GREENHOUSE_OAUTH_INVALID_ACCESS_TOKEN',
  GreenhouseOauthOrgIntegrationIsNotServiceUser = 'GREENHOUSE_OAUTH_ORG_INTEGRATION_IS_NOT_SERVICE_USER',
  GreenhouseServiceUnavailable = 'GREENHOUSE_SERVICE_UNAVAILABLE',
  ImportSourceJobNotLinkedToPortalConfig = 'IMPORT_SOURCE_JOB_NOT_LINKED_TO_PORTAL_CONFIG',
  IntegrationApiKeyInvalid = 'INTEGRATION_API_KEY_INVALID',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InterviewerAvailabilityInvalidWindow = 'INTERVIEWER_AVAILABILITY_INVALID_WINDOW',
  InterviewDefinitionDoesNotExistOnJob = 'INTERVIEW_DEFINITION_DOES_NOT_EXIST_ON_JOB',
  InterviewModuleMemberManualLogDateInFuture = 'INTERVIEW_MODULE_MEMBER_MANUAL_LOG_DATE_IN_FUTURE',
  InterviewModuleMemberManualLogNotFound = 'INTERVIEW_MODULE_MEMBER_MANUAL_LOG_NOT_FOUND',
  InterviewModuleMemberNotFound = 'INTERVIEW_MODULE_MEMBER_NOT_FOUND',
  InterviewModuleMemberStatsNotLoaded = 'INTERVIEW_MODULE_MEMBER_STATS_NOT_LOADED',
  InterviewModuleNotFound = 'INTERVIEW_MODULE_NOT_FOUND',
  InterviewPlanBreakTooLarge = 'INTERVIEW_PLAN_BREAK_TOO_LARGE',
  InterviewPlanHasHiddenInterviews = 'INTERVIEW_PLAN_HAS_HIDDEN_INTERVIEWS',
  InterviewPlanHasUnschedulableInterviewDefinition = 'INTERVIEW_PLAN_HAS_UNSCHEDULABLE_INTERVIEW_DEFINITION',
  /**  Kept for push safety; remove in a follow-up PR after this change is deployed. */
  InterviewPlanIncorrectNumberOfInterviews = 'INTERVIEW_PLAN_INCORRECT_NUMBER_OF_INTERVIEWS',
  InterviewPlanNoInterviewsSpecifiedInGroup = 'INTERVIEW_PLAN_NO_INTERVIEWS_SPECIFIED_IN_GROUP',
  InterviewScheduleAtsInterviewDefinitionUnchanged = 'INTERVIEW_SCHEDULE_ATS_INTERVIEW_DEFINITION_UNCHANGED',
  InterviewScheduleAttachedModuleNotFound = 'INTERVIEW_SCHEDULE_ATTACHED_MODULE_NOT_FOUND',
  InterviewScheduleCancelAlreadyInProgress = 'INTERVIEW_SCHEDULE_CANCEL_ALREADY_IN_PROGRESS',
  InterviewScheduleCreateFailed = 'INTERVIEW_SCHEDULE_CREATE_FAILED',
  InterviewScheduleInterviewerCannotBeOnTheSameInterviewMoreThanOnce = 'INTERVIEW_SCHEDULE_INTERVIEWER_CANNOT_BE_ON_THE_SAME_INTERVIEW_MORE_THAN_ONCE',
  InterviewScheduleInterviewDurationCannotBeNegative = 'INTERVIEW_SCHEDULE_INTERVIEW_DURATION_CANNOT_BE_NEGATIVE',
  InterviewScheduleInterviewDurationRequired = 'INTERVIEW_SCHEDULE_INTERVIEW_DURATION_REQUIRED',
  InterviewScheduleInterviewNotFound = 'INTERVIEW_SCHEDULE_INTERVIEW_NOT_FOUND',
  InterviewScheduleInvalidInterviewDate = 'INTERVIEW_SCHEDULE_INVALID_INTERVIEW_DATE',
  InterviewScheduleNoOptionsForCandidateAvailability = 'INTERVIEW_SCHEDULE_NO_OPTIONS_FOR_CANDIDATE_AVAILABILITY',
  InterviewScheduleOptionsQueryFailed = 'INTERVIEW_SCHEDULE_OPTIONS_QUERY_FAILED',
  InterviewScheduleStartTimeCannotBeInThePast = 'INTERVIEW_SCHEDULE_START_TIME_CANNOT_BE_IN_THE_PAST',
  InvalidAtsApplicationId = 'INVALID_ATS_APPLICATION_ID',
  InvalidAtsCandidateId = 'INVALID_ATS_CANDIDATE_ID',
  InvalidAtsInterviewDefinitionId = 'INVALID_ATS_INTERVIEW_DEFINITION_ID',
  InvalidAtsJobId = 'INVALID_ATS_JOB_ID',
  InvalidAtsJobStageId = 'INVALID_ATS_JOB_STAGE_ID',
  InvalidAtsScheduledInterviewId = 'INVALID_ATS_SCHEDULED_INTERVIEW_ID',
  InvalidAtsScheduleId = 'INVALID_ATS_SCHEDULE_ID',
  InvalidAtsUserId = 'INVALID_ATS_USER_ID',
  InvalidAutomatedTaskInput = 'INVALID_AUTOMATED_TASK_INPUT',
  InvalidCandidateAvailabilitySettings = 'INVALID_CANDIDATE_AVAILABILITY_SETTINGS',
  InvalidCandidateEmailAsEmployeeRequest = 'INVALID_CANDIDATE_EMAIL_AS_EMPLOYEE_REQUEST',
  InvalidCandidateTimezone = 'INVALID_CANDIDATE_TIMEZONE',
  InvalidCompanyHoliday = 'INVALID_COMPANY_HOLIDAY',
  InvalidCompanyHolidayCountry = 'INVALID_COMPANY_HOLIDAY_COUNTRY',
  InvalidCountryValue = 'INVALID_COUNTRY_VALUE',
  InvalidCreatedAt = 'INVALID_CREATED_AT',
  InvalidCreatedBy = 'INVALID_CREATED_BY',
  InvalidCreateMeetingLocationRequest = 'INVALID_CREATE_MEETING_LOCATION_REQUEST',
  InvalidEmailArgument = 'INVALID_EMAIL_ARGUMENT',
  InvalidEmployeeNotificationRequest = 'INVALID_EMPLOYEE_NOTIFICATION_REQUEST',
  InvalidInput = 'INVALID_INPUT',
  InvalidInputBulkUploadEmpCustomAttribute = 'INVALID_INPUT_BULK_UPLOAD_EMP_CUSTOM_ATTRIBUTE',
  InvalidInputBulkUploadEmpModuleTrainingInfo = 'INVALID_INPUT_BULK_UPLOAD_EMP_MODULE_TRAINING_INFO',
  InvalidInputDuplicateInterviewer = 'INVALID_INPUT_DUPLICATE_INTERVIEWER',
  InvalidInputForNote = 'INVALID_INPUT_FOR_NOTE',
  InvalidInputForNoteCreate = 'INVALID_INPUT_FOR_NOTE_CREATE',
  InvalidInputLeverJobStage = 'INVALID_INPUT_LEVER_JOB_STAGE',
  InvalidInputManualStartConflict = 'INVALID_INPUT_MANUAL_START_CONFLICT',
  InvalidInputModuleMissingTrainedInterviewer = 'INVALID_INPUT_MODULE_MISSING_TRAINED_INTERVIEWER',
  InvalidInputNoCandidateAvailability = 'INVALID_INPUT_NO_CANDIDATE_AVAILABILITY',
  InvalidInputNoCandidateAvailabilityInPast = 'INVALID_INPUT_NO_CANDIDATE_AVAILABILITY_IN_PAST',
  InvalidInputNoInterviewer = 'INVALID_INPUT_NO_INTERVIEWER',
  InvalidInputNoInterviewerSlot = 'INVALID_INPUT_NO_INTERVIEWER_SLOT',
  InvalidInputTerminalBreak = 'INVALID_INPUT_TERMINAL_BREAK',
  InvalidInputTerminalDayDivider = 'INVALID_INPUT_TERMINAL_DAY_DIVIDER',
  InvalidInputTimeRangesOverlap = 'INVALID_INPUT_TIME_RANGES_OVERLAP',
  InvalidInstant = 'INVALID_INSTANT',
  InvalidLongUrl = 'INVALID_LONG_URL',
  InvalidMeetingLocationSettings = 'INVALID_MEETING_LOCATION_SETTINGS',
  InvalidPortalOrgSlug = 'INVALID_PORTAL_ORG_SLUG',
  InvalidSearchArguments = 'INVALID_SEARCH_ARGUMENTS',
  InvalidSelfScheduleSettings = 'INVALID_SELF_SCHEDULE_SETTINGS',
  InvalidSlackChannelSettings = 'INVALID_SLACK_CHANNEL_SETTINGS',
  InvalidToken = 'INVALID_TOKEN',
  InvalidZoomHost = 'INVALID_ZOOM_HOST',
  JobNotFound = 'JOB_NOT_FOUND',
  JobPermissionDenied = 'JOB_PERMISSION_DENIED',
  JobStageNotFound = 'JOB_STAGE_NOT_FOUND',
  JobValidationsFailed = 'JOB_VALIDATIONS_FAILED',
  LeverOauthInvalid = 'LEVER_OAUTH_INVALID',
  LeverRateLimited = 'LEVER_RATE_LIMITED',
  LeverServiceUnavailable = 'LEVER_SERVICE_UNAVAILABLE',
  LoginUsernamePasswordNotAllowed = 'LOGIN_USERNAME_PASSWORD_NOT_ALLOWED',
  LoginUserAttemptingGoogleWithSamlOrg = 'LOGIN_USER_ATTEMPTING_GOOGLE_WITH_SAML_ORG',
  LoginUserAttemptingSamlWithGoogleOrg = 'LOGIN_USER_ATTEMPTING_SAML_WITH_GOOGLE_ORG',
  LoginUserAttemptingWrongOrg = 'LOGIN_USER_ATTEMPTING_WRONG_ORG',
  LoginUserMissingEmail = 'LOGIN_USER_MISSING_EMAIL',
  LoginUserNotConnectedToAnyOrg = 'LOGIN_USER_NOT_CONNECTED_TO_ANY_ORG',
  ManualSyncUnsupported = 'MANUAL_SYNC_UNSUPPORTED',
  MeetingHostNotSet = 'MEETING_HOST_NOT_SET',
  MeetingLocationSettingsNotSet = 'MEETING_LOCATION_SETTINGS_NOT_SET',
  MethodNotAllowedInThisEnv = 'METHOD_NOT_ALLOWED_IN_THIS_ENV',
  MissingCandidateCalendarId = 'MISSING_CANDIDATE_CALENDAR_ID',
  MissingPrimaryColumnBulkUploadEmpData = 'MISSING_PRIMARY_COLUMN_BULK_UPLOAD_EMP_DATA',
  ModuleAlreadyExists = 'MODULE_ALREADY_EXISTS',
  ModuleInterviewLimitTooHigh = 'MODULE_INTERVIEW_LIMIT_TOO_HIGH',
  MultiDayPlanNotAllowed = 'MULTI_DAY_PLAN_NOT_ALLOWED',
  MultiDomainDirectoryIntegrationNotFound = 'MULTI_DOMAIN_DIRECTORY_INTEGRATION_NOT_FOUND',
  NameIsRequired = 'NAME_IS_REQUIRED',
  NegativeInteger = 'NEGATIVE_INTEGER',
  NonPositiveInteger = 'NON_POSITIVE_INTEGER',
  NotAllRequiredScopesConsentedByUser = 'NOT_ALL_REQUIRED_SCOPES_CONSENTED_BY_USER',
  NotFound = 'NOT_FOUND',
  NoActiveAvailabilityRequestToCancel = 'NO_ACTIVE_AVAILABILITY_REQUEST_TO_CANCEL',
  NoActiveAvailabilityRequestToUpdate = 'NO_ACTIVE_AVAILABILITY_REQUEST_TO_UPDATE',
  NoActiveSelfScheduleRequestToCancel = 'NO_ACTIVE_SELF_SCHEDULE_REQUEST_TO_CANCEL',
  NoActiveSelfScheduleRequestToUpdate = 'NO_ACTIVE_SELF_SCHEDULE_REQUEST_TO_UPDATE',
  NoDebriefPresentToCancel = 'NO_DEBRIEF_PRESENT_TO_CANCEL',
  NoSchedulesFoundWhileBookingSelfSchedule = 'NO_SCHEDULES_FOUND_WHILE_BOOKING_SELF_SCHEDULE',
  NoSchedulePresentToCancel = 'NO_SCHEDULE_PRESENT_TO_CANCEL',
  NoSchedulePresentToUpdate = 'NO_SCHEDULE_PRESENT_TO_UPDATE',
  OauthGrantAlreadyRevoked = 'OAUTH_GRANT_ALREADY_REVOKED',
  OauthGrantNotFound = 'OAUTH_GRANT_NOT_FOUND',
  OneAtsIsAlreadyConnected = 'ONE_ATS_IS_ALREADY_CONNECTED',
  OrganizationMembershipNotFound = 'ORGANIZATION_MEMBERSHIP_NOT_FOUND',
  OrganizationSwitchNotAllowedWhileImpersonating = 'ORGANIZATION_SWITCH_NOT_ALLOWED_WHILE_IMPERSONATING',
  OrgCantForceDeletionOfNonDeletedOrg = 'ORG_CANT_FORCE_DELETION_OF_NON_DELETED_ORG',
  OrgDeletingOrgNameDoesntMatchRequest = 'ORG_DELETING_ORG_NAME_DOESNT_MATCH_REQUEST',
  OrgIntegrationNotFound = 'ORG_INTEGRATION_NOT_FOUND',
  OrgNameTooLong = 'ORG_NAME_TOO_LONG',
  OrgNotConnectedToAts = 'ORG_NOT_CONNECTED_TO_ATS',
  OrgNotConnectedToAuth0 = 'ORG_NOT_CONNECTED_TO_AUTH0',
  OrgNotFound = 'ORG_NOT_FOUND',
  OrgPrefPermissionDenied = 'ORG_PREF_PERMISSION_DENIED',
  OtpExpired = 'OTP_EXPIRED',
  OutlookEmployeeNotConfigured = 'OUTLOOK_EMPLOYEE_NOT_CONFIGURED',
  PermissionDenied = 'PERMISSION_DENIED',
  PermissionDeniedForCalendarEventCreateOrUpdate = 'PERMISSION_DENIED_FOR_CALENDAR_EVENT_CREATE_OR_UPDATE',
  PermissionDeniedForImpersonatedUser = 'PERMISSION_DENIED_FOR_IMPERSONATED_USER',
  PlanWithDynamicBreaksNotSupported = 'PLAN_WITH_DYNAMIC_BREAKS_NOT_SUPPORTED',
  PortalBrandingThemeAlreadyExists = 'PORTAL_BRANDING_THEME_ALREADY_EXISTS',
  PortalBrandingThemeLimitReached = 'PORTAL_BRANDING_THEME_LIMIT_REACHED',
  PortalConfigAutomationRuleNotFound = 'PORTAL_CONFIG_AUTOMATION_RULE_NOT_FOUND',
  PortalConfigNotFound = 'PORTAL_CONFIG_NOT_FOUND',
  PortalEmailIsRequired = 'PORTAL_EMAIL_IS_REQUIRED',
  PortalEmailMismatchWithApplication = 'PORTAL_EMAIL_MISMATCH_WITH_APPLICATION',
  PortalJobStageIsRequired = 'PORTAL_JOB_STAGE_IS_REQUIRED',
  PortalOrgSlugExists = 'PORTAL_ORG_SLUG_EXISTS',
  PortalOrgSlugLimitReached = 'PORTAL_ORG_SLUG_LIMIT_REACHED',
  PortalOrgSlugTooLong = 'PORTAL_ORG_SLUG_TOO_LONG',
  PortalOrgSlugTooShort = 'PORTAL_ORG_SLUG_TOO_SHORT',
  PortalTemplateBlockRequired = 'PORTAL_TEMPLATE_BLOCK_REQUIRED',
  PortalTemplateIsNotRequired = 'PORTAL_TEMPLATE_IS_NOT_REQUIRED',
  PortalTemplateIsRequired = 'PORTAL_TEMPLATE_IS_REQUIRED',
  PortalTemplateNameAlreadyExists = 'PORTAL_TEMPLATE_NAME_ALREADY_EXISTS',
  PrefNotFound = 'PREF_NOT_FOUND',
  PremiumPortalNotEnabled = 'PREMIUM_PORTAL_NOT_ENABLED',
  PrivacyAuditLogEmptyAccessData = 'PRIVACY_AUDIT_LOG_EMPTY_ACCESS_DATA',
  PrivacyAuditLogIdConflict = 'PRIVACY_AUDIT_LOG_ID_CONFLICT',
  PrivacyAuditLogInvalidBulkQuery = 'PRIVACY_AUDIT_LOG_INVALID_BULK_QUERY',
  PrivacyAuditLogInvalidCategory = 'PRIVACY_AUDIT_LOG_INVALID_CATEGORY',
  PrivacyAuditLogInvalidIpAddress = 'PRIVACY_AUDIT_LOG_INVALID_IP_ADDRESS',
  PrivacyAuditLogInvalidValue = 'PRIVACY_AUDIT_LOG_INVALID_VALUE',
  PublicIdInvalid = 'PUBLIC_ID_INVALID',
  PublicIdNotFound = 'PUBLIC_ID_NOT_FOUND',
  RateLimitExceeded = 'RATE_LIMIT_EXCEEDED',
  RefreshAdminCodeGrantFailed = 'REFRESH_ADMIN_CODE_GRANT_FAILED',
  RefreshCodeGrantFailed = 'REFRESH_CODE_GRANT_FAILED',
  RequestMissingCandidateTimezone = 'REQUEST_MISSING_CANDIDATE_TIMEZONE',
  RescheduleLogNotFound = 'RESCHEDULE_LOG_NOT_FOUND',
  RescheduleLogReasonAlreadyExists = 'RESCHEDULE_LOG_REASON_ALREADY_EXISTS',
  RescheduleScheduleAlreadyStarted = 'RESCHEDULE_SCHEDULE_ALREADY_STARTED',
  RescheduleSystemLogCannotArchive = 'RESCHEDULE_SYSTEM_LOG_CANNOT_ARCHIVE',
  RoleChangesBlockedByScim = 'ROLE_CHANGES_BLOCKED_BY_SCIM',
  SamlBadRequest = 'SAML_BAD_REQUEST',
  SamlDuplicateName = 'SAML_DUPLICATE_NAME',
  ScheduleAlreadyExists = 'SCHEDULE_ALREADY_EXISTS',
  ScheduleAlreadyExistsOnTask = 'SCHEDULE_ALREADY_EXISTS_ON_TASK',
  ScheduleCancelCalendarPermissionMissing = 'SCHEDULE_CANCEL_CALENDAR_PERMISSION_MISSING',
  ScheduleContextNotFound = 'SCHEDULE_CONTEXT_NOT_FOUND',
  ScheduleCreateAlreadyInProgress = 'SCHEDULE_CREATE_ALREADY_IN_PROGRESS',
  ScheduleCreateCalendarPermissionMissing = 'SCHEDULE_CREATE_CALENDAR_PERMISSION_MISSING',
  ScheduleLocationCandidatePhoneSetButNotDefined = 'SCHEDULE_LOCATION_CANDIDATE_PHONE_SET_BUT_NOT_DEFINED',
  ScheduleLocationCustomLinkSetButNotDefined = 'SCHEDULE_LOCATION_CUSTOM_LINK_SET_BUT_NOT_DEFINED',
  ScheduleLocationCustomPhoneSetButNotDefined = 'SCHEDULE_LOCATION_CUSTOM_PHONE_SET_BUT_NOT_DEFINED',
  ScheduleLocationCustomTextSetButNotDefined = 'SCHEDULE_LOCATION_CUSTOM_TEXT_SET_BUT_NOT_DEFINED',
  ScheduleOrganizerCalendarNotInDirectory = 'SCHEDULE_ORGANIZER_CALENDAR_NOT_IN_DIRECTORY',
  ScheduleUpdateAlreadyInProgress = 'SCHEDULE_UPDATE_ALREADY_IN_PROGRESS',
  ScheduleUpdateCalendarPermissionMissing = 'SCHEDULE_UPDATE_CALENDAR_PERMISSION_MISSING',
  ScimUserAlreadyExists = 'SCIM_USER_ALREADY_EXISTS',
  ScimUserNotFound = 'SCIM_USER_NOT_FOUND',
  SearchIndexNotFound = 'SEARCH_INDEX_NOT_FOUND',
  SearchQueryFailed = 'SEARCH_QUERY_FAILED',
  SearchServiceUnavailable = 'SEARCH_SERVICE_UNAVAILABLE',
  SelectedUserDoesNotHaveRequiredPermissions = 'SELECTED_USER_DOES_NOT_HAVE_REQUIRED_PERMISSIONS',
  SelfScheduleAdvanceNoticeNotHonoured = 'SELF_SCHEDULE_ADVANCE_NOTICE_NOT_HONOURED',
  SelfScheduleCandidateCalendarNotSet = 'SELF_SCHEDULE_CANDIDATE_CALENDAR_NOT_SET',
  SelfScheduleCandidateEmailIsInvalid = 'SELF_SCHEDULE_CANDIDATE_EMAIL_IS_INVALID',
  SelfScheduleCreateCalendarPermissionMissing = 'SELF_SCHEDULE_CREATE_CALENDAR_PERMISSION_MISSING',
  SelfScheduleInterviewerCalendarNotSet = 'SELF_SCHEDULE_INTERVIEWER_CALENDAR_NOT_SET',
  SelfScheduleOptionsNotFound = 'SELF_SCHEDULE_OPTIONS_NOT_FOUND',
  SelfScheduleRequestCreateFailed = 'SELF_SCHEDULE_REQUEST_CREATE_FAILED',
  SelfScheduleRequestNotFound = 'SELF_SCHEDULE_REQUEST_NOT_FOUND',
  SelfScheduleRequestUpdateFailed = 'SELF_SCHEDULE_REQUEST_UPDATE_FAILED',
  SelfScheduleSchedulerTimeout = 'SELF_SCHEDULE_SCHEDULER_TIMEOUT',
  SelfScheduleStartTimeAlreadyElapsed = 'SELF_SCHEDULE_START_TIME_ALREADY_ELAPSED',
  ServiceUserEmailMismatch = 'SERVICE_USER_EMAIL_MISMATCH',
  SettingsCannotBeSetAsSourceIsNotManual = 'SETTINGS_CANNOT_BE_SET_AS_SOURCE_IS_NOT_MANUAL',
  SettingsEmailCannotBeNone = 'SETTINGS_EMAIL_CANNOT_BE_NONE',
  SettingsEmailCannotBeWrite = 'SETTINGS_EMAIL_CANNOT_BE_WRITE',
  SettingsFirstNameCannotBeNone = 'SETTINGS_FIRST_NAME_CANNOT_BE_NONE',
  SettingsLastNameCannotBeNone = 'SETTINGS_LAST_NAME_CANNOT_BE_NONE',
  SettingsTimezoneCannotBeNone = 'SETTINGS_TIMEZONE_CANNOT_BE_NONE',
  SlackContentInvalid = 'SLACK_CONTENT_INVALID',
  SlackConversationInviteError = 'SLACK_CONVERSATION_INVITE_ERROR',
  SlackEventHandleAlreadyInProgress = 'SLACK_EVENT_HANDLE_ALREADY_IN_PROGRESS',
  SlackTeamIdsDoNotMatch = 'SLACK_TEAM_IDS_DO_NOT_MATCH',
  SlackTeamMissingInOauth = 'SLACK_TEAM_MISSING_IN_OAUTH',
  SmartRecruitersInvalidStage = 'SMART_RECRUITERS_INVALID_STAGE',
  SmartRecruitersJobPostingNotFound = 'SMART_RECRUITERS_JOB_POSTING_NOT_FOUND',
  SmartRecruitersRequiredStageSkipped = 'SMART_RECRUITERS_REQUIRED_STAGE_SKIPPED',
  SmartRecruitersSourcingLinkInvalidInitialStage = 'SMART_RECRUITERS_SOURCING_LINK_INVALID_INITIAL_STAGE',
  SmartRecruitersStageError = 'SMART_RECRUITERS_STAGE_ERROR',
  SourcingLinkAlreadyUsed = 'SOURCING_LINK_ALREADY_USED',
  SourcingLinkApplyInProgress = 'SOURCING_LINK_APPLY_IN_PROGRESS',
  SourcingLinkInterviewPlanIsMandatoryForSelfSchedule = 'SOURCING_LINK_INTERVIEW_PLAN_IS_MANDATORY_FOR_SELF_SCHEDULE',
  SourcingLinkInterviewTimeAlreadyBooked = 'SOURCING_LINK_INTERVIEW_TIME_ALREADY_BOOKED',
  SourcingLinkJobIsClosed = 'SOURCING_LINK_JOB_IS_CLOSED',
  SourcingLinkResumeInvalid = 'SOURCING_LINK_RESUME_INVALID',
  SourcingLinkResumeNotAccepted = 'SOURCING_LINK_RESUME_NOT_ACCEPTED',
  SourcingLinkResumeRequired = 'SOURCING_LINK_RESUME_REQUIRED',
  TargetCalendarIdSetToSelf = 'TARGET_CALENDAR_ID_SET_TO_SELF',
  TaskAlreadyCancelled = 'TASK_ALREADY_CANCELLED',
  TaskAssigneeDoesNotHaveJobPermissions = 'TASK_ASSIGNEE_DOES_NOT_HAVE_JOB_PERMISSIONS',
  TaskAutoCreateSendOnBehalfOfDynamicAudienceIncorrect = 'TASK_AUTO_CREATE_SEND_ON_BEHALF_OF_DYNAMIC_AUDIENCE_INCORRECT',
  TaskAutoCreateSendOnBehalfOfMissing = 'TASK_AUTO_CREATE_SEND_ON_BEHALF_OF_MISSING',
  TaskCreateAlreadyInProgress = 'TASK_CREATE_ALREADY_IN_PROGRESS',
  TaskEnabledApplicationMissingTaskId = 'TASK_ENABLED_APPLICATION_MISSING_TASK_ID',
  TaskMissingCandidateSchedulingRequest = 'TASK_MISSING_CANDIDATE_SCHEDULING_REQUEST',
  TaskNotDelegatedToAgent = 'TASK_NOT_DELEGATED_TO_AGENT',
  TaskNotFound = 'TASK_NOT_FOUND',
  TaskQueueAlreadyExists = 'TASK_QUEUE_ALREADY_EXISTS',
  TaskQueueLimitExceeded = 'TASK_QUEUE_LIMIT_EXCEEDED',
  TaskQueueNameEmpty = 'TASK_QUEUE_NAME_EMPTY',
  TaskQueueNameNoQueue = 'TASK_QUEUE_NAME_NO_QUEUE',
  TaskQueueNotFound = 'TASK_QUEUE_NOT_FOUND',
  TaskTagAlreadyExists = 'TASK_TAG_ALREADY_EXISTS',
  TaskTagLimitExceeded = 'TASK_TAG_LIMIT_EXCEEDED',
  TaskTagNameEmpty = 'TASK_TAG_NAME_EMPTY',
  TaskTagNotFound = 'TASK_TAG_NOT_FOUND',
  TemplateBodyCannotBeEmpty = 'TEMPLATE_BODY_CANNOT_BE_EMPTY',
  TemplateCannotDeleteOrgDefault = 'TEMPLATE_CANNOT_DELETE_ORG_DEFAULT',
  TemplateCannotUpdateSystemTemplate = 'TEMPLATE_CANNOT_UPDATE_SYSTEM_TEMPLATE',
  TemplateCannotUpdateTemplateTypeForDefaultTemplate = 'TEMPLATE_CANNOT_UPDATE_TEMPLATE_TYPE_FOR_DEFAULT_TEMPLATE',
  TemplateContainsModernloopUrl = 'TEMPLATE_CONTAINS_MODERNLOOP_URL',
  TemplateNameAlreadyExists = 'TEMPLATE_NAME_ALREADY_EXISTS',
  TooManyCandidatePulseTags = 'TOO_MANY_CANDIDATE_PULSE_TAGS',
  TooManyRescheduleLogs = 'TOO_MANY_RESCHEDULE_LOGS',
  TryingDisconnectCurrentAts = 'TRYING_DISCONNECT_CURRENT_ATS',
  Unauthenticated = 'UNAUTHENTICATED',
  UnresolvedDynamicCalendarId = 'UNRESOLVED_DYNAMIC_CALENDAR_ID',
  UnsupportedDynamicHostOnSelfSchedule = 'UNSUPPORTED_DYNAMIC_HOST_ON_SELF_SCHEDULE',
  UnusedTokensCandidateEmailBody = 'UNUSED_TOKENS_CANDIDATE_EMAIL_BODY',
  UnusedTokensCandidateEmailSubject = 'UNUSED_TOKENS_CANDIDATE_EMAIL_SUBJECT',
  UnusedTokensCandidateEventBody = 'UNUSED_TOKENS_CANDIDATE_EVENT_BODY',
  UnusedTokensCandidateEventTitle = 'UNUSED_TOKENS_CANDIDATE_EVENT_TITLE',
  UnusedTokensInterviewerEventBody = 'UNUSED_TOKENS_INTERVIEWER_EVENT_BODY',
  UnusedTokensInterviewerEventTitle = 'UNUSED_TOKENS_INTERVIEWER_EVENT_TITLE',
  UnusedTokensInterviewerSlackBody = 'UNUSED_TOKENS_INTERVIEWER_SLACK_BODY',
  UserAttemptingToChangeOwnRole = 'USER_ATTEMPTING_TO_CHANGE_OWN_ROLE',
  UserFacingEmployeeNotFound = 'USER_FACING_EMPLOYEE_NOT_FOUND',
  UserNotFound = 'USER_NOT_FOUND',
  WorkdayActivityPdfGenerationFailed = 'WORKDAY_ACTIVITY_PDF_GENERATION_FAILED',
  WorkdayApplicationNotInSchedulableStep = 'WORKDAY_APPLICATION_NOT_IN_SCHEDULABLE_STEP',
  WorkdayCannotMapAtsInterviewMloopInterview = 'WORKDAY_CANNOT_MAP_ATS_INTERVIEW_MLOOP_INTERVIEW',
  WorkdayException = 'WORKDAY_EXCEPTION',
  WorkdayInvalidNextJobStage = 'WORKDAY_INVALID_NEXT_JOB_STAGE',
  WorkdayJobStageNotSchedulable = 'WORKDAY_JOB_STAGE_NOT_SCHEDULABLE',
  WorkdayMoreThanOneEventInProgress = 'WORKDAY_MORE_THAN_ONE_EVENT_IN_PROGRESS',
  WorkdayScheduleFrozen = 'WORKDAY_SCHEDULE_FROZEN',
  WorkdayScheduleNotAwaitingUserAction = 'WORKDAY_SCHEDULE_NOT_AWAITING_USER_ACTION',
  WorkdayValidationError = 'WORKDAY_VALIDATION_ERROR',
  ZoomIntegrationAlreadyConnectedBySameUser = 'ZOOM_INTEGRATION_ALREADY_CONNECTED_BY_SAME_USER',
  ZoomNotConnectedButLocationIsZoom = 'ZOOM_NOT_CONNECTED_BUT_LOCATION_IS_ZOOM',
  ZoomUserDoesNotExist = 'ZOOM_USER_DOES_NOT_EXIST',
  ZoomUserNotFound = 'ZOOM_USER_NOT_FOUND',
  ZoomUserNotFoundForInterviewPlan = 'ZOOM_USER_NOT_FOUND_FOR_INTERVIEW_PLAN',
  ZoomUserNoPermission = 'ZOOM_USER_NO_PERMISSION',
  ZoomUserRateLimited = 'ZOOM_USER_RATE_LIMITED'
}

export enum ErrorDomain {
  ActivityLog = 'ACTIVITY_LOG',
  Ats = 'ATS',
  Calendar = 'CALENDAR',
  CandidateAvailability = 'CANDIDATE_AVAILABILITY',
  CandidatePortal = 'CANDIDATE_PORTAL',
  Debrief = 'DEBRIEF',
  Email = 'EMAIL',
  Employee = 'EMPLOYEE',
  EmployeeInfoBulkUpload = 'EMPLOYEE_INFO_BULK_UPLOAD',
  ErrorCode = 'ERROR_CODE',
  Graphql = 'GRAPHQL',
  Integration = 'INTEGRATION',
  Interview = 'INTERVIEW',
  InterviewerPortal = 'INTERVIEWER_PORTAL',
  InterviewModule = 'INTERVIEW_MODULE',
  Job = 'JOB',
  JobStage = 'JOB_STAGE',
  Notification = 'NOTIFICATION',
  Org = 'ORG',
  Permission = 'PERMISSION',
  S3 = 'S3',
  Saml = 'SAML',
  Schedule = 'SCHEDULE',
  Scim = 'SCIM',
  SelfSchedule = 'SELF_SCHEDULE',
  Slack = 'SLACK',
  SourcingLink = 'SOURCING_LINK',
  Task = 'TASK',
  TaskFlag = 'TASK_FLAG',
  TemplateModule = 'TEMPLATE_MODULE',
  UrlShortner = 'URL_SHORTNER',
  Zoom = 'ZOOM'
}

export type EventInput = {
  codeLink?: InputMaybe<CodeLinkInput>;
  /** @deprecated Use meetingLocationId instead */
  customVideoMeetingLinkUrl?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use interviewers instead */
  interviewerIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  interviewers?: InputMaybe<Array<InterviewerInput>>;
  isBreak: Scalars['Boolean']['input'];
  isHiddenFromCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  meetingLocationId?: InputMaybe<Scalars['uuid']['input']>;
  name: Scalars['String']['input'];
  timeRange: DateTimeRangeInput;
  /** @deprecated Use meetingLocationId instead */
  workspaceVideoLink?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use meetingLocationId instead */
  workspaceVideoLinkUrl?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use meetingLocationId instead */
  zoomInfo?: InputMaybe<ZoomInfoInput>;
};

/** Input for filtering events by RSVP status. */
export type EventsRsvp = {
  /** Indicates if all participants have accepted. */
  allAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of candidate RSVP statuses to filter by. */
  candidateRsvp?: InputMaybe<Array<InputMaybe<ResponseStatus>>>;
  /** List of interviewer RSVP statuses to filter by. */
  interviewerRsvp?: InputMaybe<Array<InputMaybe<ResponseStatus>>>;
};

export type EventsWithConflicts = {
  __typename?: 'EventsWithConflicts';
  events?: Maybe<Array<Scalars['String']['output']>>;
  flag?: Maybe<InterviewerFlag>;
};

export type ExpiredAuditLogPayload = {
  __typename?: 'ExpiredAuditLogPayload';
  empty: Scalars['Boolean']['output'];
};

export type ExternalApiKeyRevokeFailureAlreadyRevoked = Error & {
  __typename?: 'ExternalApiKeyRevokeFailureAlreadyRevoked';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type ExternalApiKeyRevokeFailureNotFound = Error & {
  __typename?: 'ExternalApiKeyRevokeFailureNotFound';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type ExternalApiKeyRevokeInput = {
  id: Scalars['uuid']['input'];
};

export type ExternalApiKeyRevokeOutput = ExternalApiKeyRevokeFailureAlreadyRevoked | ExternalApiKeyRevokeFailureNotFound | ExternalApiKeyRevokeSuccess | UnknownError;

export type ExternalApiKeyRevokeSuccess = {
  __typename?: 'ExternalApiKeyRevokeSuccess';
  tokenId: Scalars['uuid']['output'];
};

export type ExternalApiTokenMetadata = {
  __typename?: 'ExternalApiTokenMetadata';
  createdAt: Scalars['datetime']['output'];
  employee: Employee;
  employeeId: Scalars['uuid']['output'];
  expiresAt?: Maybe<Scalars['datetime']['output']>;
  lastUsedAt?: Maybe<Scalars['datetime']['output']>;
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  revokedAt?: Maybe<Scalars['datetime']['output']>;
  scopes: Array<Scalars['String']['output']>;
  tokenId: Scalars['uuid']['output'];
  tokenPrefix: Scalars['String']['output'];
};

export type ExternalApiTokensFilters = {
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Input for listing external API token metadata for the current org. */
export type ExternalApiTokensInput = {
  filters?: InputMaybe<ExternalApiTokensFilters>;
};

/** Provider that owns a durable external object. */
export enum ExternalObjectSyncProvider {
  Ats = 'ATS',
  Calendar = 'CALENDAR'
}

/**
 * Product-facing state of a durable external object (e.g. the ATS scheduled
 * interview) backing a local one.
 */
export enum ExternalObjectSyncState {
  Failed = 'FAILED',
  NoConnection = 'NO_CONNECTION',
  Pending = 'PENDING',
  Synced = 'SYNCED'
}

/**
 * Durable sync status of an externally-owned object (e.g. an ATS scheduled
 * interview) backing a local one. Generic: any object with provider-owned
 * counterparts can connect to it.
 */
export type ExternalObjectSyncStatus = {
  __typename?: 'ExternalObjectSyncStatus';
  attemptCount: Scalars['Int']['output'];
  /** Structured provider error code for failed syncs (e.g. ASHBY_USER_NOT_FOUND, UNAVAILABLE). */
  errorCode?: Maybe<Scalars['String']['output']>;
  /**
   * Verbatim provider error message for failed syncs. Intentionally unsanitized (product
   * decision): coordinators need the provider's exact words to act on the failure, and the
   * field is only visible to the org's own authenticated employees.
   */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /**
   * True when automatic retries have stopped (attempt cap reached); a manual retry or
   * "Push to ATS" is required.
   */
  isRetryExhausted: Scalars['Boolean']['output'];
  providerType: ExternalObjectSyncProvider;
  state: ExternalObjectSyncState;
  /** When the external object last matched local state; null until a sync has succeeded. */
  syncedAt?: Maybe<Scalars['datetime']['output']>;
  updatedAt: Scalars['datetime']['output'];
};

export type FilledInterviewSeat = {
  __typename?: 'FilledInterviewSeat';
  interviewerId?: Maybe<Scalars['uuid']['output']>;
  seatId: Scalars['uuid']['output'];
  traineeId?: Maybe<Scalars['uuid']['output']>;
  traineeRole: InterviewerRole;
};

export type FreeformSeat = {
  __typename?: 'FreeformSeat';
  jobStageInterviewSeatEmployees?: Maybe<Array<JobStageInterviewSeatEmployee>>;
};

/** Input for a freeform seat. */
export type FreeformSeatInput = {
  jobStageInterviewSeatEmployees: Array<JobStageInterviewSeatEmployeeInput>;
};

export type GemIntegration = {
  __typename?: 'GemIntegration';
  apiKey: Scalars['String']['output'];
};

export type GemIntegrationHealth = {
  __typename?: 'GemIntegrationHealth';
  canReadActivityFeed: Scalars['Boolean']['output'];
  canReadApplication: Scalars['Boolean']['output'];
  canReadApplications: Scalars['Boolean']['output'];
  canReadCandidate: Scalars['Boolean']['output'];
  canReadCandidates: Scalars['Boolean']['output'];
  canReadInterview: Scalars['Boolean']['output'];
  canReadInterviews: Scalars['Boolean']['output'];
  canReadJob: Scalars['Boolean']['output'];
  canReadJobPostings: Scalars['Boolean']['output'];
  canReadJobStageForJob: Scalars['Boolean']['output'];
  canReadJobStages: Scalars['Boolean']['output'];
  canReadJobs: Scalars['Boolean']['output'];
  canReadUser: Scalars['Boolean']['output'];
  canReadUserRoles: Scalars['Boolean']['output'];
  canReadUsers: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

/** Gem-specific fields for interview definitions. */
export type GemInterviewDefinition = {
  __typename?: 'GemInterviewDefinition';
  estimatedMinutes: Scalars['numeric']['output'];
  gemInterviewKitId: Scalars['String']['output'];
  index: Scalars['numeric']['output'];
};

/** Gem-specific fields for jobs. */
export type GemJob = {
  __typename?: 'GemJob';
  jobRequisitionId?: Maybe<Scalars['String']['output']>;
};

export type GenerateOrgApiKeyResponse = {
  __typename?: 'GenerateOrgApiKeyResponse';
  apiKey: Scalars['String']['output'];
};

export type GenerateOrgScimTokenResponse = {
  __typename?: 'GenerateOrgScimTokenResponse';
  scimToken: Scalars['String']['output'];
};

/**
 * Input for resolving a public API ID (for example can_a1b2..., tsk_a1b2...) to the best
 * in-app URL for that object.
 */
export type GetUrlForPublicIdInput = {
  /**
   * A prefixed public ID as issued by the public API, for example
   * can_a1b2c3d4e5f64789a1b2c3d4e5f64789. The UUID body may be compact or dashed and is
   * case-insensitive, but the prefix is required to identify the object type.
   */
  publicId: Scalars['String']['input'];
};

export type GetUrlForPublicIdOutput = PublicIdInvalidError | PublicIdNotFoundError | PublicIdUrl | UnknownError;

export type GoogleEmployeeIntegration = {
  __typename?: 'GoogleEmployeeIntegration';
  active: Scalars['Boolean']['output'];
};

export type GoogleIntegration = {
  __typename?: 'GoogleIntegration';
  adminUserId: Scalars['String']['output'];
};

export type GoogleIntegrationHealth = {
  __typename?: 'GoogleIntegrationHealth';
  canReadCalendars: Scalars['Boolean']['output'];
  canReadDirectory: Scalars['Boolean']['output'];
  canReadMeetingRooms: Scalars['Boolean']['output'];
  canSendGmail: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

/** Represents the result of creating a Google Meet meeting. */
export type GoogleMeetingResult = {
  __typename?: 'GoogleMeetingResult';
  /** The URL for the created Google Meet meeting. */
  url: Scalars['String']['output'];
};

export type GoogleServiceUserIntegration = {
  __typename?: 'GoogleServiceUserIntegration';
  serviceAccountEmail: Scalars['String']['output'];
};

export enum GraduationApprovalType {
  Automatic = 'AUTOMATIC',
  Custom = 'CUSTOM',
  Scheduler = 'SCHEDULER'
}

export enum GraduationApproverDecisionType {
  AwaitingFeedback = 'AWAITING_FEEDBACK',
  DoAnother = 'DO_ANOTHER',
  Invalid = 'INVALID',
  MissedInterview = 'MISSED_INTERVIEW',
  MoveForward = 'MOVE_FORWARD',
  Override = 'OVERRIDE'
}

export enum GraduationApproverType {
  Scheduler = 'SCHEDULER',
  Trained = 'TRAINED',
  Trainee = 'TRAINEE'
}

/** Greenhouse-specific fields for candidates. */
export type GreenhouseCandidate = {
  __typename?: 'GreenhouseCandidate';
  greenhouseCoordinatorId?: Maybe<Scalars['numeric']['output']>;
  greenhouseRecruiterId?: Maybe<Scalars['numeric']['output']>;
};

/**
 *  Deploy-order shim, not a live integration. The Greenhouse API-key integration is retired: the
 *  proto message, the Jackson subtype, and the IntegrationType value are all gone, so no resolver can
 *  ever populate this. It survives only so an old frontend bundle that still selects
 *  `OrgIntegrations.greenhouse` keeps validating. Delete it with the field below.
 */
export type GreenhouseIntegration = {
  __typename?: 'GreenhouseIntegration';
  apiKey: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
  webhookSecret?: Maybe<Scalars['String']['output']>;
};

export type GreenhouseIntegrationHealth = {
  __typename?: 'GreenhouseIntegrationHealth';
  canReadActivityFeed: Scalars['Boolean']['output'];
  canReadApplication: Scalars['Boolean']['output'];
  canReadApplications: Scalars['Boolean']['output'];
  canReadCandidate: Scalars['Boolean']['output'];
  canReadCandidates: Scalars['Boolean']['output'];
  canReadEmailTemplates: Scalars['Boolean']['output'];
  canReadInterview: Scalars['Boolean']['output'];
  canReadInterviews: Scalars['Boolean']['output'];
  canReadJob: Scalars['Boolean']['output'];
  canReadJobPostings: Scalars['Boolean']['output'];
  canReadJobStageForJob: Scalars['Boolean']['output'];
  canReadJobStages: Scalars['Boolean']['output'];
  canReadJobs: Scalars['Boolean']['output'];
  canReadUser: Scalars['Boolean']['output'];
  canReadUserPermission: Scalars['Boolean']['output'];
  canReadUserRoles: Scalars['Boolean']['output'];
  canReadUsers: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
  needsReauth: Scalars['Boolean']['output'];
};

/** Greenhouse-specific fields for interview definitions. */
export type GreenhouseInterviewDefinition = {
  __typename?: 'GreenhouseInterviewDefinition';
  estimatedMinutes: Scalars['numeric']['output'];
  greenhouseInterviewKitId: Scalars['numeric']['output'];
  index: Scalars['numeric']['output'];
};

/** Greenhouse-specific fields for jobs. */
export type GreenhouseJob = {
  __typename?: 'GreenhouseJob';
  jobRequisitionId?: Maybe<Scalars['String']['output']>;
};

export type GreenhouseOAuthIntegration = {
  __typename?: 'GreenhouseOAuthIntegration';
  subdomain: Scalars['String']['output'];
};

export type HackerRankIntegration = {
  __typename?: 'HackerRankIntegration';
  apiKey: Scalars['String']['output'];
};

export type HardConflict = {
  endAt: Scalars['datetime']['input'];
  eventUid: Scalars['String']['input'];
  startAt: Scalars['datetime']['input'];
};

export type HardConflictInput = {
  endAt: Scalars['datetime']['input'];
  eventUid: Scalars['String']['input'];
  organizerEmail: Scalars['String']['input'];
  startAt: Scalars['datetime']['input'];
};

export type HiringProcess = {
  __typename?: 'HiringProcess';
  atsId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Keep in sync with interview_db.proto#SmartRecruitersHiringProcessStatus */
export enum HiringProcessStatus {
  Deleted = 'DELETED',
  Mismatch = 'MISMATCH',
  NotSet = 'NOT_SET',
  Set = 'SET'
}

export type HiringProcessWithStatus = {
  __typename?: 'HiringProcessWithStatus';
  atsId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: HiringProcessStatus;
};

/** Represents an ID. */
export type Id = {
  __typename?: 'Id';
  id: Scalars['uuid']['output'];
};

export type IndexOrderBy = {
  index?: InputMaybe<Sort>;
};

/** Input for initializing the schedule flow. */
export type InitScheduleFlowInput = {
  /** The ID of the job stage to initialize the schedule flow for. */
  jobStageId: Scalars['uuid']['input'];
};

/** Result of initializing the schedule flow. */
export type InitScheduleFlowResult = {
  __typename?: 'InitScheduleFlowResult';
  /** The calendar for the candidate. */
  candidateCalendar?: Maybe<Calendar>;
  /** The template for candidate confirmation email. */
  candidateConfirmationEmailTemplate?: Maybe<Template>;
  /** The template for candidate confirmation invite. */
  candidateConfirmationInviteTemplate?: Maybe<Template>;
  /** The calendar for the interviewer. */
  interviewerCalendar?: Maybe<Calendar>;
  /** The template for interviewer confirmation invite. */
  interviewerConfirmationInviteTemplate?: Maybe<Template>;
  /** The template for interviewer conversation message. */
  interviewerConversationMessageTemplate?: Maybe<Template>;
  /** Indicates if calendar events are private. True if job is confidential OR set in job stage settings. */
  isPrivateCalendarEvents: Scalars['Boolean']['output'];
};

/** Input for initiating a candidate data export (for DSAR compliance). */
export type InitiateCandidateDataExportInput = {
  /** Optional reason for this candidate data download. */
  downloadReason?: InputMaybe<Scalars['String']['input']>;
  /** Query string to search for candidates. Can be an email address, phone number, or candidate ID (UUID). */
  query: Scalars['String']['input'];
};

/**
 * Output for the initiateCandidateDataExport mutation.
 * Using a custom output type instead of EmptyResult allows for future extensibility.
 */
export type InitiateCandidateDataExportOutput = {
  __typename?: 'InitiateCandidateDataExportOutput';
  /** Placeholder field - future versions may include export_id, status, etc. */
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

export enum IntEmployeePref {
  /**  keep-sorted:begin */
  IntPref = 'int_pref'
}

export type IntEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'IntEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  value?: Maybe<Scalars['numeric']['output']>;
};

/**
 *  JSON-shaped org prefs expose structured data via OrgPref.jsonPref: OrgJsonPref; union members and
 *  field shapes are defined here and in org_pref.proto. Union resolution: OrgJsonPrefUnionType.java.
 * ###############################################################
 */
export enum IntOrgPref {
  /**  keep-sorted:begin */
  IntAgentStartDelaySeconds = 'int_agent_start_delay_seconds',
  IntAvailabilityRequestMinimumTimeBlockMinutes = 'int_availability_request_minimum_time_block_minutes',
  IntAvailabilityRequestMinutesPerDay = 'int_availability_request_minutes_per_day',
  IntAvailabilityRequestNumberOfDays = 'int_availability_request_number_of_days',
  IntCandidateAvailabilityReminderMinutes = 'int_candidate_availability_reminder_minutes',
  IntCandidateInterviewReminderMinutes = 'int_candidate_interview_reminder_minutes',
  IntCandidateSelfScheduleRescheduleCancelLimit = 'int_candidate_self_schedule_reschedule_cancel_limit',
  IntCompanyDataRetentionDays = 'int_company_data_retention_days',
  IntDaysUntilHiredApplicationCanSeePortal = 'int_days_until_hired_application_can_see_portal',
  IntDaysUntilRejectedApplicationCanSeePortal = 'int_days_until_rejected_application_can_see_portal',
  IntSelfScheduleReminderMinutes = 'int_self_schedule_reminder_minutes'
}

export type IntegrationCheckHealthInput = {
  /** If you want to evict the cache before checking health, pass true. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationCheckHealthResult = {
  __typename?: 'IntegrationCheckHealthResult';
  ashby?: Maybe<AshbyIntegrationHealth>;
  gem?: Maybe<GemIntegrationHealth>;
  google?: Maybe<GoogleIntegrationHealth>;
  greenhouse?: Maybe<GreenhouseIntegrationHealth>;
  greenhouseV3?: Maybe<GreenhouseIntegrationHealth>;
  id: Scalars['uuid']['output'];
  lever?: Maybe<LeverIntegrationHealth>;
  microsoft?: Maybe<MicrosoftIntegrationHealth>;
  microsoftGccHigh?: Maybe<MicrosoftIntegrationHealth>;
  slack?: Maybe<SlackIntegrationHealth>;
  smartRecruiters?: Maybe<SmartRecruitersIntegrationHealth>;
  zoom?: Maybe<ZoomIntegrationHealth>;
};

/** Represents the status of an integration connection. */
export enum IntegrationConnectionStatus {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED',
  Syncing = 'SYNCING'
}

export type IntegrationGetOauthUrlInput = {
  /** Service mailbox for a new Microsoft Multi-Domain directory. It rides in the signed OAuth state and applies only to Service mailbox mode when the app-only directory flag is on. */
  adminUserEmail?: InputMaybe<Scalars['String']['input']>;
  /** Access mode for a new Microsoft Multi-Domain directory. It rides in the signed OAuth state and applies only when the app-only directory flag is on. */
  directoryMode?: InputMaybe<Scalars['String']['input']>;
  /** Display name for a new Microsoft Multi-Domain directory. It rides in the signed OAuth state. */
  directoryName?: InputMaybe<Scalars['String']['input']>;
  integrationType: IntegrationType;
  isGov?: InputMaybe<Scalars['Boolean']['input']>;
  loginHint?: InputMaybe<Scalars['String']['input']>;
  /** Optional OAuth scopes to request in addition to the provider's required scopes. Each must be one of the provider's declared optional scopes. */
  optionalScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationGetOauthUrlResult = {
  __typename?: 'IntegrationGetOauthUrlResult';
  redirectUri: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum IntegrationType {
  AshbyApiKey = 'ASHBY_API_KEY',
  Brighthire = 'BRIGHTHIRE',
  CoderpadApiKey = 'CODERPAD_API_KEY',
  CodesignalApiKey = 'CODESIGNAL_API_KEY',
  CodilityApiKey = 'CODILITY_API_KEY',
  Docusign = 'DOCUSIGN',
  GemApiKey = 'GEM_API_KEY',
  Google = 'GOOGLE',
  GoogleEmployee = 'GOOGLE_EMPLOYEE',
  GoogleServiceUser = 'GOOGLE_SERVICE_USER',
  GreenhouseOauth = 'GREENHOUSE_OAUTH',
  GreenhouseOauthEmployee = 'GREENHOUSE_OAUTH_EMPLOYEE',
  HackerrankApiKey = 'HACKERRANK_API_KEY',
  Kombo = 'KOMBO',
  Lever = 'LEVER',
  Microsoft = 'MICROSOFT',
  MicrosoftCustom = 'MICROSOFT_CUSTOM',
  MicrosoftCustomEmployee = 'MICROSOFT_CUSTOM_EMPLOYEE',
  MicrosoftEmployee = 'MICROSOFT_EMPLOYEE',
  MicrosoftGccHigh = 'MICROSOFT_GCC_HIGH',
  MicrosoftGccHighEmployee = 'MICROSOFT_GCC_HIGH_EMPLOYEE',
  MicrosoftServiceUser = 'MICROSOFT_SERVICE_USER',
  MicrosoftServiceUserEmployee = 'MICROSOFT_SERVICE_USER_EMPLOYEE',
  MultiDomain = 'MULTI_DOMAIN',
  SlackEmployee = 'SLACK_EMPLOYEE',
  SlackOrg = 'SLACK_ORG',
  SmartRecruiters = 'SMART_RECRUITERS',
  Workday = 'WORKDAY',
  Zoom = 'ZOOM',
  ZoomCustom = 'ZOOM_CUSTOM'
}

export type InterviewAdjustRsvpInput = {
  applicationStageInterviewId: Scalars['uuid']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  interviewerId: Scalars['uuid']['input'];
  reason?: InputMaybe<DeclineReason>;
  responseStatus: ResponseStatus;
};

export type InterviewAdjustRsvpResult = {
  __typename?: 'InterviewAdjustRsvpResult';
  result?: Maybe<Result>;
};

export type InterviewBufferTimePref = {
  __typename?: 'InterviewBufferTimePref';
  after?: Maybe<Duration>;
  before?: Maybe<Duration>;
};

export type InterviewEvent = {
  __typename?: 'InterviewEvent';
  endAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  interviewers: Array<InterviewerSuggestion>;
  isBreak: Scalars['Boolean']['output'];
  isHiddenFromCandidate: Scalars['Boolean']['output'];
  jobStageInterviewId: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  seats: Array<FilledInterviewSeat>;
  startAt: Scalars['datetime']['output'];
};

export type InterviewGroupInput = {
  interviews: Array<InterviewInput>;
  jobStageInterviewGroupId: Scalars['uuid']['input'];
  locked: Scalars['Boolean']['input'];
};

export type InterviewGuide = {
  __typename?: 'InterviewGuide';
  id: Scalars['uuid']['output'];
  job?: Maybe<Job>;
  name: Scalars['String']['output'];
  remoteInterviewGuideId: Scalars['String']['output'];
  remoteInterviewGuideType: InterviewGuideType;
};

export enum InterviewGuideType {
  Brighthire = 'BRIGHTHIRE'
}

export type InterviewInput = {
  durationMinutes: Scalars['Int']['input'];
  forcedStartAt?: InputMaybe<Scalars['datetime']['input']>;
  isHiddenFromCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  jobStageInterviewId: Scalars['uuid']['input'];
  locked: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  seats: Array<ScheduleOptionSeatInput>;
  type: InterviewType;
};

export type InterviewInterviewerDeclined = {
  __typename?: 'InterviewInterviewerDeclined';
  applicationStageInterviewId: Scalars['uuid']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<DeclineReason>;
  source?: Maybe<Scalars['String']['output']>;
};

export type InterviewLimit = {
  __typename?: 'InterviewLimit';
  limit?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<InterviewLimitType>;
};

export enum InterviewLimitType {
  NumberOfInterviews = 'NUMBER_OF_INTERVIEWS',
  NumberOfMinutes = 'NUMBER_OF_MINUTES'
}

/** Represents the location details for an interview. */
export type InterviewLocation = {
  __typename?: 'InterviewLocation';
  /** The type of interview location. Can be null if the type is not yet understood by the backend. */
  type?: Maybe<InterviewLocationType>;
  /** The value associated with the interview location (e.g., a link or phone number). */
  value?: Maybe<Scalars['String']['output']>;
};

/** Represents different types of interview locations or platforms. */
export enum InterviewLocationType {
  CustomLink = 'CUSTOM_LINK',
  GoogleMeet = 'GOOGLE_MEET',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  Phone = 'PHONE',
  Zoom = 'ZOOM'
}

export type InterviewMeetingLocationSettingPref = {
  __typename?: 'InterviewMeetingLocationSettingPref';
  customLocation?: Maybe<Scalars['String']['output']>;
  dynamicHost?: Maybe<DynamicInterviewMeetingHost>;
  hostEmployee?: Maybe<Employee>;
  hostEmployeeId?: Maybe<Scalars['String']['output']>;
  interviewMeetingLocationType: InterviewMeetingLocationType;
  /**  zoomUserId goes here */
  remoteVideoMeetingHostUser?: Maybe<RemoteVideoMeetingHostUser>;
  remoteVideoMeetingHostUserId?: Maybe<Scalars['String']['output']>;
  videoMeetingLinkScope: VideoMeetingLinkScope;
};

export type InterviewMeetingLocationSettingWithLevel = {
  __typename?: 'InterviewMeetingLocationSettingWithLevel';
  interviewMeetingLocationSetting?: Maybe<InterviewMeetingLocationSettingPref>;
  level: SettingLevel;
};

export type InterviewMeetingLocationSettingsInput = {
  customLocation?: InputMaybe<Scalars['String']['input']>;
  dynamicHost?: InputMaybe<DynamicInterviewMeetingHost>;
  hostEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  interviewMeetingLocationType: InterviewMeetingLocationType;
  remoteVideoMeetingHostUserId?: InputMaybe<Scalars['String']['input']>;
  videoMeetingLinkScope?: InputMaybe<VideoMeetingLinkScope>;
};

/** Represents different types of interview meeting locations or methods. */
export enum InterviewMeetingLocationType {
  CandidatePhone = 'CANDIDATE_PHONE',
  CustomLink = 'CUSTOM_LINK',
  CustomPhone = 'CUSTOM_PHONE',
  CustomText = 'CUSTOM_TEXT',
  GoogleMeet = 'GOOGLE_MEET',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  None = 'NONE',
  NotSpecified = 'NOT_SPECIFIED',
  Zoom = 'ZOOM'
}

export type InterviewMetrics = {
  __typename?: 'InterviewMetrics';
  /**  for download chart */
  atsApplicationId?: Maybe<Scalars['String']['output']>;
  /**  For download chart - remote ATS application id */
  atsCandidateId?: Maybe<Scalars['String']['output']>;
  atsInterviewId?: Maybe<Scalars['String']['output']>;
  /**  This is mloop id */
  atsJobId?: Maybe<Scalars['String']['output']>;
  autoReplacementStatus?: Maybe<InterviewerDeclineAutoReplacementStatus>;
  calendarEventTitle?: Maybe<Scalars['String']['output']>;
  candidate?: Maybe<Scalars['String']['output']>;
  declineComment?: Maybe<Scalars['String']['output']>;
  declineLeadTime?: Maybe<Scalars['Float']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  declineSource?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['datetime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /**  this should be schedulerName */
  interviewDate?: Maybe<Scalars['datetime']['output']>;
  interviewDurationSeconds?: Maybe<Scalars['numeric']['output']>;
  /**  For download chart # this should be interviewer */
  interviewModule?: Maybe<InterviewModule>;
  /**  This can be mloop, lever or gh id hence string as gh is not uuid */
  interviewName?: Maybe<Scalars['String']['output']>;
  interviewer?: Maybe<Scalars['String']['output']>;
  /**  For download chart - # this should be scheduler */
  interviewerEmployee?: Maybe<Employee>;
  /**  For ashby we can send empty string */
  interviewerId?: Maybe<Scalars['uuid']['output']>;
  /** @deprecated Use jobName instead */
  job?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['uuid']['output']>;
  /**  For download chart # this should be Interview module */
  jobLocations: Array<Scalars['String']['output']>;
  jobName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use jobStageName instead */
  jobStage?: Maybe<Scalars['String']['output']>;
  jobStageName?: Maybe<Scalars['String']['output']>;
  replacementInterviewer?: Maybe<Employee>;
  scheduler?: Maybe<Scalars['String']['output']>;
  /**  Need download chart */
  schedulerEmployee?: Maybe<Employee>;
  /**  this should be interviewerName */
  schedulerId?: Maybe<Scalars['String']['output']>;
  scorecard?: Maybe<Scalars['String']['output']>;
  /**  For download chart - mloop task id linked to this interview's stage */
  startsAt?: Maybe<Scalars['datetime']['output']>;
  /**  For download chart - remote ATS candidate id */
  taskId?: Maybe<Scalars['String']['output']>;
};

export type InterviewModule = {
  __typename?: 'InterviewModule';
  graduateFromReverseShadowApprovalType: GraduationApprovalType;
  graduateFromReverseShadowCustomApprovers?: Maybe<Array<GraduationApproverType>>;
  graduateFromShadowApprovalType: GraduationApprovalType;
  graduateFromShadowCustomApprovers?: Maybe<Array<GraduationApproverType>>;
  id: Scalars['uuid']['output'];
  interviewModuleMembers?: Maybe<InterviewModuleMembersOutput>;
  interviewModuleMembersByIds: Array<InterviewModuleMember>;
  membersCount: Scalars['numeric']['output'];
  membersInPendingApprovalCount: Scalars['numeric']['output'];
  /**  number shadow + reverse_shadow */
  membersInReverseShadowCount: Scalars['numeric']['output'];
  membersInShadowCount: Scalars['numeric']['output'];
  membersInTrainingCount: Scalars['numeric']['output'];
  membersTrainedCount: Scalars['numeric']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  reverseShadowsRequired: Scalars['numeric']['output'];
  shadowsRequired: Scalars['numeric']['output'];
  shouldFastTrackTraining: Scalars['Boolean']['output'];
  /**  Number of interviews which can be conducted at max. null means no limit. */
  weeklyNumInterviewLimit?: Maybe<Scalars['numeric']['output']>;
};


export type InterviewModuleInterviewModuleMembersArgs = {
  input: InterviewModuleMembersInput;
};


export type InterviewModuleInterviewModuleMembersByIdsArgs = {
  input: InterviewModuleMembersByIdsInput;
};

export type InterviewModuleAddMembersInput = {
  addMembers: Array<AddModuleMemberInput>;
  interviewModuleId: Scalars['uuid']['input'];
};

export type InterviewModuleCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  requiredReverseShadowsCount?: InputMaybe<Scalars['Int']['input']>;
  requiredShadowsCount?: InputMaybe<Scalars['Int']['input']>;
  shouldFastTrackTraining?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyNumInterviewLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type InterviewModuleMember = {
  __typename?: 'InterviewModuleMember';
  /** @deprecated Use moduleMemberInterviewLogs instead. */
  applicationStageInterviews?: Maybe<ApplicationStageInterviewsOutput>;
  createdAt?: Maybe<Scalars['datetime']['output']>;
  employee?: Maybe<Employee>;
  employeeId: Scalars['uuid']['output'];
  id: Scalars['String']['output'];
  interviewModule?: Maybe<InterviewModule>;
  /** This is a computed field. */
  interviewModuleId: Scalars['uuid']['output'];
  isPaused?: Maybe<Scalars['Boolean']['output']>;
  isPausedIndefinitely?: Maybe<Scalars['Boolean']['output']>;
  moduleMemberInterviewLogs?: Maybe<ModuleMemberInterviewLogOutput>;
  nextStatus: TrainingStatus;
  pausedUntil?: Maybe<Scalars['datetime']['output']>;
  pendingApprovalApplicationStageInterview?: Maybe<ApplicationStageInterview>;
  reverseShadowStartAt?: Maybe<Scalars['datetime']['output']>;
  reverseShadowsRequired: Scalars['Int']['output'];
  shadowStartAt?: Maybe<Scalars['datetime']['output']>;
  shadowsRequired: Scalars['Int']['output'];
  stats?: Maybe<InterviewModuleMemberStats>;
  status: TrainingStatus;
  timeToTrain?: Maybe<Scalars['numeric']['output']>;
  trainedAt?: Maybe<Scalars['datetime']['output']>;
  /**  Number of interviews which can be conducted at max. null means no limit. */
  weeklyNumInterviewLimit?: Maybe<Scalars['numeric']['output']>;
};


export type InterviewModuleMemberApplicationStageInterviewsArgs = {
  input?: InputMaybe<ApplicationStageInterviewsInput>;
};


export type InterviewModuleMemberModuleMemberInterviewLogsArgs = {
  input?: InputMaybe<ModuleMemberInterviewLogInput>;
};

/** Input for approving an interview module member. */
export type InterviewModuleMemberApproveInput = {
  interviewModuleId: Scalars['uuid']['input'];
  interviewModuleMemberId: Scalars['uuid']['input'];
};

/** Input for creating a log entry for an interview module member. */
export type InterviewModuleMemberLogCreateInput = {
  interviewDate: Scalars['datetime']['input'];
  memberId: Scalars['uuid']['input'];
  moduleId: Scalars['uuid']['input'];
  role: TrainingStatus;
};

/** Input for deleting a log entry for an interview module member. */
export type InterviewModuleMemberLogDeleteInput = {
  id: Scalars['uuid']['input'];
};

/** Input for updating a log entry for an interview module member. */
export type InterviewModuleMemberLogUpdateInput = {
  id: Scalars['uuid']['input'];
  interviewDate: Scalars['datetime']['input'];
  /**  Can be asi_id or InterviewModuleMemberLog_id */
  role: TrainingStatus;
};

/** ########################################################## */
export type InterviewModuleMemberLookupInput = {
  interviewModuleIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  interviewModuleMemberIds: Array<Scalars['uuid']['input']>;
};

export type InterviewModuleMemberLookupOutput = {
  __typename?: 'InterviewModuleMemberLookupOutput';
  items: Array<InterviewModuleMember>;
};

export type InterviewModuleMemberManualLog = {
  __typename?: 'InterviewModuleMemberManualLog';
  createdAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  interviewDate: Scalars['datetime']['output'];
  memberId: Scalars['uuid']['output'];
  moduleId: Scalars['uuid']['output'];
  role: TrainingStatus;
  updatedAt: Scalars['datetime']['output'];
  updatedBy: Employee;
};

/** Result of creating or updating a manual log for an interview module member. */
export type InterviewModuleMemberManualLogResult = {
  __typename?: 'InterviewModuleMemberManualLogResult';
  interviewModuleMemberManualLog?: Maybe<InterviewModuleMemberManualLog>;
};

/** Input for moving an interview module member to a different stage. */
export type InterviewModuleMemberMoveStageInput = {
  interviewModuleId: Scalars['uuid']['input'];
  interviewModuleMemberId: Scalars['uuid']['input'];
  newLevel: Scalars['Int']['input'];
  newStatus: TrainingStatus;
};

export type InterviewModuleMemberResult = {
  __typename?: 'InterviewModuleMemberResult';
  interviewModuleMember?: Maybe<InterviewModuleMember>;
};

/**
 * ##########################################################
 *  Input and output for interviewModuleMemberSearch
 */
export type InterviewModuleMemberSearchInput = {
  attributeNameValueMap?: InputMaybe<Array<AttributeNameValueMapInput>>;
  filterByState?: InputMaybe<Array<InputMaybe<InterviewModuleMemberState>>>;
  filterByTrainingStatus?: InputMaybe<Array<InputMaybe<TrainingStatus>>>;
  hasAtsId?: InputMaybe<Scalars['Boolean']['input']>;
  interviewModuleId: Scalars['uuid']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAtsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<InterviewModuleMemberSearchOrderBy>;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  useArchivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  useAtsDisabledFilter?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InterviewModuleMemberSearchOrderBy = {
  direction: Sort;
  property: InterviewModuleMemberSearchOrderByProperty;
};

export enum InterviewModuleMemberSearchOrderByProperty {
  Name = 'NAME',
  ProgressPercentage = 'PROGRESS_PERCENTAGE',
  TrainingEndDate = 'TRAINING_END_DATE',
  TrainingStartDate = 'TRAINING_START_DATE'
}

export type InterviewModuleMemberSearchOutput = {
  __typename?: 'InterviewModuleMemberSearchOutput';
  items: Array<InterviewModuleMember>;
  total?: Maybe<Scalars['Int']['output']>;
};

/**  The states by which we can query for interview module members. */
export enum InterviewModuleMemberState {
  NeedsApproval = 'NEEDS_APPROVAL',
  Paused = 'PAUSED',
  Scheduled = 'SCHEDULED',
  Unscheduled = 'UNSCHEDULED'
}

export type InterviewModuleMemberStats = {
  __typename?: 'InterviewModuleMemberStats';
  completed?: Maybe<Scalars['numeric']['output']>;
  completedAsInterviewer: Scalars['numeric']['output'];
  /**  completed as shadow in ModernLoop */
  completedAsReverseShadow?: Maybe<Scalars['numeric']['output']>;
  /**  upcoming scheduled in ModernLoop */
  completedAsShadow?: Maybe<Scalars['numeric']['output']>;
  currentTrainingSession?: Maybe<Scalars['String']['output']>;
  /**  Training Status + Level */
  currentTrainingSessionStatus?: Maybe<CurrentTrainingSessionStatus>;
  interviewModule?: Maybe<InterviewModule>;
  interviewModuleMember?: Maybe<InterviewModuleMember>;
  isPaused: Scalars['Boolean']['output'];
  manualCompletedAsInterviewer: Scalars['numeric']['output'];
  manualCompletedAsReverseShadow: Scalars['numeric']['output'];
  manualCompletedAsShadow: Scalars['numeric']['output'];
  pausedUntil?: Maybe<Scalars['datetime']['output']>;
  reverseShadowOffset?: Maybe<Scalars['numeric']['output']>;
  reverseShadowsRequired?: Maybe<Scalars['numeric']['output']>;
  shadowOffset?: Maybe<Scalars['numeric']['output']>;
  shadowsRequired?: Maybe<Scalars['numeric']['output']>;
  /**  completed as reverse shadow in ModernLoop */
  trainingStatus?: Maybe<TrainingStatus>;
  trainingsToPass?: Maybe<Scalars['numeric']['output']>;
  /**  completed in ModernLoop */
  upcoming?: Maybe<Scalars['numeric']['output']>;
};

export type InterviewModuleMemberUpdateInput = {
  addedToModuleAt?: InputMaybe<Scalars['datetime']['input']>;
  clearPaused?: InputMaybe<Scalars['Boolean']['input']>;
  clearTrainedAt?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId: Scalars['uuid']['input'];
  interviewModuleId: Scalars['uuid']['input'];
  isPausedIndefinitely?: InputMaybe<Scalars['Boolean']['input']>;
  pausedUntil?: InputMaybe<Scalars['datetime']['input']>;
  reverseShadowRequiredCount?: InputMaybe<Scalars['Int']['input']>;
  shadowOrReverseShadowIncrementBy?: InputMaybe<Scalars['Int']['input']>;
  shadowRequiredCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TrainingStatus>;
  trainedAt?: InputMaybe<Scalars['datetime']['input']>;
  weeklyNumInterviewLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type InterviewModuleMembersByIdsInput = {
  interviewModuleMemberIds: Array<Scalars['uuid']['input']>;
};

/**
 * ##########################################################
 *  Input and output for interviewModuleMembers
 */
export type InterviewModuleMembersInput = {
  interviewModuleId?: InputMaybe<Scalars['uuid']['input']>;
  pageInput: PageInput;
  status?: InputMaybe<Array<TrainingStatus>>;
};

export type InterviewModuleMembersOutput = {
  __typename?: 'InterviewModuleMembersOutput';
  items: Array<InterviewModuleMember>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type InterviewModuleRemoveMembersInput = {
  employeeIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  interviewModuleId: Scalars['uuid']['input'];
};

/** Result of creating or updating an interview module. */
export type InterviewModuleResult = {
  __typename?: 'InterviewModuleResult';
  interviewModule?: Maybe<InterviewModule>;
};

export type InterviewModuleSearchFilter = {
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/**
 * ##########################################################
 *  Input and output for interviewModuleSearch
 */
export type InterviewModuleSearchInput = {
  filters?: InputMaybe<InterviewModuleSearchFilter>;
  orderBy: InterviewModulesOrderBy;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InterviewModuleSearchOutput = {
  __typename?: 'InterviewModuleSearchOutput';
  items: Array<InterviewModule>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type InterviewModuleSeatConfig = {
  __typename?: 'InterviewModuleSeatConfig';
  selectedAttributes?: Maybe<Array<JobStageInterviewSeatAttribute>>;
  selectedEmployeeIds?: Maybe<Array<Scalars['uuid']['output']>>;
};

export type InterviewModuleSeatConfigInput = {
  selectedAttributes?: InputMaybe<Array<JobStageInterviewSeatAttributeInput>>;
  selectedEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type InterviewModuleUpdateInput = {
  graduateFromReverseShadowApprovalType?: InputMaybe<GraduationApprovalType>;
  graduateFromReverseShadowCustomApprovers?: InputMaybe<Array<InputMaybe<GraduationApproverType>>>;
  graduateFromShadowApprovalType?: InputMaybe<GraduationApprovalType>;
  graduateFromShadowCustomApprovers?: InputMaybe<Array<InputMaybe<GraduationApproverType>>>;
  id: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  requiredReverseShadowsCount?: InputMaybe<Scalars['Int']['input']>;
  requiredShadowsCount?: InputMaybe<Scalars['Int']['input']>;
  shouldFastTrackTraining?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyNumInterviewLimit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * ##########################################################
 *  Input and output for interviewModules
 */
export type InterviewModulesInput = {
  orderBy: InterviewModulesOrderBy;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

/**  How to order by interview modules? */
export type InterviewModulesOrderBy = {
  direction: Sort;
  property: InterviewModulesOrderByProperty;
};

export enum InterviewModulesOrderByProperty {
  InTrainingCount = 'IN_TRAINING_COUNT',
  Name = 'NAME',
  NeedsApprovalCount = 'NEEDS_APPROVAL_COUNT',
  TrainedCount = 'TRAINED_COUNT'
}

export type InterviewModulesOutput = {
  __typename?: 'InterviewModulesOutput';
  items: Array<InterviewModule>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type InterviewNameSetting = {
  __typename?: 'InterviewNameSetting';
  isCustom: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  level: SettingLevel;
  /**  Specific to this setting */
  showInterviewName: Scalars['Boolean']['output'];
};

export type InterviewNameSettingInput = {
  /**
   *  Setting "isCustom" to false has the affect of explicitly setting the Job Setting's value to be the org default.
   *  Otherwise, if "isCustom" is true, then the "showInterviewName" value must be present and will be used.
   */
  isCustom: Scalars['Boolean']['input'];
  showInterviewName?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InterviewPlan = {
  __typename?: 'InterviewPlan';
  id: Scalars['uuid']['output'];
  interviewPlanSource: InterviewPlanSource;
  /** This is jobStageId */
  jobStageInterviewGroups: Array<JobStageInterviewGroup>;
};

export type InterviewPlanInput = {
  excludedEmployeeIds: Array<Scalars['uuid']['input']>;
  groups: Array<JobStageInterviewGroupInput>;
  schedulingWindow?: InputMaybe<DurationInput>;
};

export enum InterviewPlanSource {
  Ats = 'ATS',
  Candidate = 'CANDIDATE',
  SourcingLink = 'SOURCING_LINK',
  Task = 'TASK'
}

export enum InterviewType {
  AnyTimeLater = 'ANY_TIME_LATER',
  Break = 'BREAK',
  /** This means we can schedule on any day after the current day. */
  DayDivider = 'DAY_DIVIDER',
  Interview = 'INTERVIEW',
  /** This strictly means that we should schedule this interview on the very next day, no later. */
  NextDay = 'NEXT_DAY'
}

export enum InterviewTypePrefType {
  AnyTimeLater = 'ANY_TIME_LATER',
  ImmediatelyAfter = 'IMMEDIATELY_AFTER'
}

export type InterviewerAndPreferenceLevel = {
  employeeId: Scalars['uuid']['input'];
  preferenceLevel: Scalars['Int']['input'];
};

/** Input for the estimated-availability projection of one interviewer. */
export type InterviewerAvailabilityInput = {
  /**
   * Whether the engine may book over an available keyword event. When true, such a block no longer
   * blocks free time, and is still returned as `AVAILABLE_TIME_BLOCK` for the same reason a relaxed
   * recruiting block is: free time may overlap it.
   */
  canScheduleOverAvailableKeywords?: Scalars['Boolean']['input'];
  /**
   * Whether empty calendar time, and an event whose status is free, is bookable. When false, that
   * time is returned as `FREE_TIME`, a conflict, and only a relaxed keyword block can be free.
   */
  canScheduleOverFreeTime?: Scalars['Boolean']['input'];
  /**
   * Whether the engine may book over a recruiting-block keyword event. When true, such a block no
   * longer blocks free time, and an ordinary calendar conflict inside it is not a conflict either.
   * The block is still returned, as `RECRUITING_BLOCK`, so a caller can show that the interviewer
   * set that time aside for recruiting: free time may overlap it, and a client may present those
   * slots first.
   */
  canScheduleOverRecruitingKeywords?: Scalars['Boolean']['input'];
  /** The employee whose availability the projection explains. */
  employeeId: Scalars['uuid']['input'];
  /**
   * Whether the interviewer's daily and weekly load limits count as conflicts. The same switch a
   * self-schedule or availability request carries; the default is the product default.
   */
  shouldRespectLoadLimit?: Scalars['Boolean']['input'];
  /**
   * The window the projection covers. A window that is empty, inverted, or longer than 31 days
   * resolves to `InterviewerAvailabilityInvalidWindowError`.
   */
  timeRange: DateTimeRangeInput;
};

/** The requested window is empty, inverted, or longer than the 31 days the projection supports. */
export type InterviewerAvailabilityInvalidWindowError = Error & {
  __typename?: 'InterviewerAvailabilityInvalidWindowError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type InterviewerAvailabilityOutput = CalendarUnavailableError | EmployeeNotFoundError | InterviewerAvailabilityInvalidWindowError | InterviewerAvailabilitySuccess | UnknownError;

/** A completed availability projection. */
export type InterviewerAvailabilitySuccess = {
  __typename?: 'InterviewerAvailabilitySuccess';
  /**
   * Everything else in the window, merged and disjoint. `freeBlocks` and `busyBlocks` together
   * cover the whole requested window exactly once, so a client can draw a plain free/busy calendar
   * without reading a single interval type.
   */
  busyBlocks: Array<DateTimeRangeOutput>;
  /**
   * Correlates this projection with the interview-service log line that records its resolved
   * inputs. Quote it in a bug report.
   */
  computationId: Scalars['String']['output'];
  /** The bookable time, merged and disjoint, with no classification. */
  freeBlocks: Array<DateTimeRangeOutput>;
  /**
   * Identifies this projection by the request that produced it: the employee and the window,
   * tokenized as `employeeId|windowStartAt|windowEndAt|toggles` with canonical ISO-8601 UTC instants
   * and the four toggle values.
   *
   * The same employee and window always produce the same identifier, and two different windows
   * never share one, so a normalized client cache keys each projection on its own request instead
   * of overwriting one window's result with another's.
   */
  id: Scalars['ID']['output'];
  /** The classified spans of the window, in the engine's own vocabulary. */
  intervals: Array<AvailabilityInterval>;
  /** The end of the window this projection covers, echoed from the request. */
  windowEndAt: Scalars['datetime']['output'];
  /**
   * The start of the window this projection covers, echoed from the request so a cached result
   * carries the window it belongs to.
   */
  windowStartAt: Scalars['datetime']['output'];
};

export type InterviewerContentInput = {
  /**
   *  Additional attendees for THIS interview only, each with its own role. Nullable for rollout
   *  compat, and the null-vs-empty distinction is meaningful: null means "use the schedule-level
   *  interviewerEventAdditionalAttendee* fields for this interview", an empty list means "this
   *  interview has no additional attendees".
   */
  additionalAttendees?: InputMaybe<Array<AdditionalAttendeeInput>>;
  atsInterviewDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Nullable for rollout compat; null behaves like an empty list. Seeded from the invite
   *  template's attachments by the client; the backend appends an "Attachments" link section
   *  to the event description.
   */
  attachments?: InputMaybe<Array<RemoteAttachmentInput>>;
  /** @deprecated Use collaborationLinkId instead */
  codingInterviewUrl?: InputMaybe<Scalars['String']['input']>;
  collaborationLinkId?: InputMaybe<Scalars['uuid']['input']>;
  description: Scalars['String']['input'];
  emailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  endAt: Scalars['datetime']['input'];
  interviewGuideId?: InputMaybe<Scalars['uuid']['input']>;
  interviewName: Scalars['String']['input'];
  interviewers: Array<InterviewerInput>;
  isHiddenFromCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  /**  maps to `job_stage_interview_id` in `application_stage_interview` table */
  jobStageInterviewId?: InputMaybe<Scalars['uuid']['input']>;
  /**  maps to `meeting_location_id` in `application_stage_interview` table */
  meetingLocationId?: InputMaybe<Scalars['uuid']['input']>;
  meetingRoomIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  startAt: Scalars['datetime']['input'];
  summary: Scalars['String']['input'];
  /** @deprecated Use meetingLocationId instead */
  videoMeetingHostEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  /** @deprecated Use meetingLocationId instead */
  videoMeetingUrl?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use meetingLocationId instead */
  zoomInfo?: InputMaybe<ZoomInfoInput>;
};

/** ######################### */
export enum InterviewerDeclineAutoReplacementStatus {
  NoneFound = 'NONE_FOUND',
  NotAttempted = 'NOT_ATTEMPTED',
  Replaced = 'REPLACED',
  Unknown = 'UNKNOWN'
}

export type InterviewerEventAdditionalAttendeesPref = {
  __typename?: 'InterviewerEventAdditionalAttendeesPref';
  additionalAttendees: Array<SettingAdditionalAttendee>;
  additionalRecipientsOptional: Scalars['Boolean']['output'];
  interviewerEventAdditionalAttendees: NotificationPreference;
};

export type InterviewerFilters = {
  atsDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributeValueIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  interviewModuleIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  interviewerIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  jobLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobStageIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  jobStageNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  showArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InterviewerFlag {
  BufferConflict = 'BUFFER_CONFLICT',
  CompanyCountryHoliday = 'COMPANY_COUNTRY_HOLIDAY',
  Conflict = 'CONFLICT',
  ConflictFocusTime = 'CONFLICT_FOCUS_TIME',
  ConflictOfInterestWithCandidate = 'CONFLICT_OF_INTEREST_WITH_CANDIDATE',
  ExternalConflict = 'EXTERNAL_CONFLICT',
  HasCalendarDelegate = 'HAS_CALENDAR_DELEGATE',
  HoldConflict = 'HOLD_CONFLICT',
  InsideRecruitingBlock = 'INSIDE_RECRUITING_BLOCK',
  InterviewConflict = 'INTERVIEW_CONFLICT',
  Linked = 'LINKED',
  MiddleOfTheNight = 'MIDDLE_OF_THE_NIGHT',
  MissingCalendar = 'MISSING_CALENDAR',
  MissingTimezone = 'MISSING_TIMEZONE',
  NotPreferred = 'NOT_PREFERRED',
  OneOnOneConflict = 'ONE_ON_ONE_CONFLICT',
  Ooo = 'OOO',
  OutsideRecruitingBlock = 'OUTSIDE_RECRUITING_BLOCK',
  OutsideWorkHours = 'OUTSIDE_WORK_HOURS',
  /** Within the earliest work hour and latest work hour, but not a work hour */
  OutsideWorkHours_30 = 'OUTSIDE_WORK_HOURS_30',
  /** Starting or ending within 30 minutes of work hours */
  OutsideWorkHours_60 = 'OUTSIDE_WORK_HOURS_60',
  /** Starting or ending within 60 minutes of work hours */
  OutsideWorkHours_90 = 'OUTSIDE_WORK_HOURS_90',
  /** Starting or ending within 90 minutes of work hours */
  OutsideWorkHours_120 = 'OUTSIDE_WORK_HOURS_120',
  /** The event belongs to a private calendar */
  OutsideWorkHoursBreakTime = 'OUTSIDE_WORK_HOURS_BREAK_TIME',
  OverDailyLimit = 'OVER_DAILY_LIMIT',
  OverWeeklyLimit = 'OVER_WEEKLY_LIMIT',
  /** Starting or ending within 120 minutes of work hours */
  OverWeeklyModuleLimit = 'OVER_WEEKLY_MODULE_LIMIT',
  Paused = 'PAUSED',
  PausedInModule = 'PAUSED_IN_MODULE',
  Preferred = 'PREFERRED',
  PreviousInterviewsForApplication = 'PREVIOUS_INTERVIEWS_FOR_APPLICATION',
  /** The hours between 9PM and 6AM */
  PrivateCalendar = 'PRIVATE_CALENDAR',
  Repeat = 'REPEAT',
  Required = 'REQUIRED',
  ReverseShadow = 'REVERSE_SHADOW',
  SchedulableConflict = 'SCHEDULABLE_CONFLICT',
  Shadow = 'SHADOW',
  UnschedulableConflict = 'UNSCHEDULABLE_CONFLICT',
  Weekend = 'WEEKEND'
}

export type InterviewerInfoSetting = {
  __typename?: 'InterviewerInfoSetting';
  canShowBio: Scalars['Boolean']['output'];
  canShowEmail: Scalars['Boolean']['output'];
  canShowFullName: Scalars['Boolean']['output'];
  /**  Specific to this setting */
  canShowInfo: Scalars['Boolean']['output'];
  canShowJobTitle: Scalars['Boolean']['output'];
  canShowLinkedin: Scalars['Boolean']['output'];
  canShowProfilePicture: Scalars['Boolean']['output'];
  canShowPronouns: Scalars['Boolean']['output'];
  isCustom: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  level: SettingLevel;
};

export type InterviewerInfoSettingInput = {
  canShowInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *  Setting "isCustom" to false has the affect of explicitly setting the Job Setting's value to be the org default.
   *  Otherwise, if "isCustom" is true, then the "canShowInfo" value must be present and will be used.
   */
  isCustom: Scalars['Boolean']['input'];
};

export type InterviewerInput = {
  employeeId: Scalars['uuid']['input'];
  interviewModuleId?: InputMaybe<Scalars['uuid']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  jobStageInterviewSeatId?: InputMaybe<Scalars['uuid']['input']>;
  role: InterviewerRole;
};

/**
 * #########################
 *  input for interviewer metrics chart and tables
 */
export type InterviewerMetricsChartInput = {
  chartType?: InputMaybe<InterviewerMetricsChartType>;
  downloadReason?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['datetime']['input']>;
  filters: InterviewerFilters;
  sources?: InputMaybe<Array<MetricsSource>>;
  startAt?: InputMaybe<Scalars['datetime']['input']>;
  timezone?: InputMaybe<Scalars['timezone']['input']>;
};

/**
 * #########################
 *  input types for interviewer metrics chart and tables
 */
export type InterviewerMetricsChartResult = {
  __typename?: 'InterviewerMetricsChartResult';
  chartType: InterviewerMetricsChartType;
  data?: Maybe<Array<ChartCoordinateData>>;
};

/**
 * #########################
 *  enum types for interviewer metrics chart and tables
 */
export enum InterviewerMetricsChartType {
  InterviewsCompleted = 'INTERVIEWS_COMPLETED',
  InterviewsDeclines = 'INTERVIEWS_DECLINES',
  InterviewsDeclineLeadTime = 'INTERVIEWS_DECLINE_LEAD_TIME',
  InterviewsDeclineReasons = 'INTERVIEWS_DECLINE_REASONS'
}

export type InterviewerMetricsDeclines = {
  __typename?: 'InterviewerMetricsDeclines';
  autoReplacementStatus?: Maybe<InterviewerDeclineAutoReplacementStatus>;
  date?: Maybe<Scalars['String']['output']>;
  declineComment?: Maybe<Scalars['String']['output']>;
  declineReason?: Maybe<Scalars['String']['output']>;
  declineSource?: Maybe<Scalars['String']['output']>;
  interviewer?: Maybe<Employee>;
  leadTime?: Maybe<Scalars['Float']['output']>;
  replacementInterviewer?: Maybe<Employee>;
};

export type InterviewerMetricsDeclinesResult = {
  __typename?: 'InterviewerMetricsDeclinesResult';
  items?: Maybe<Array<InterviewerMetricsDeclines>>;
};

export type InterviewerMetricsDeclinesWrapperResult = {
  __typename?: 'InterviewerMetricsDeclinesWrapperResult';
  autoReplacementChart?: Maybe<InterviewerMetricsChartResult>;
  declineLeadTimeChart?: Maybe<InterviewerMetricsChartResult>;
  declineReasonsChart?: Maybe<InterviewerMetricsChartResult>;
  declineTable?: Maybe<InterviewerMetricsDeclinesResult>;
  declinesChart?: Maybe<InterviewerMetricsChartResult>;
};

export type InterviewerMetricsInterviewing = {
  __typename?: 'InterviewerMetricsInterviewing';
  completed?: Maybe<Scalars['numeric']['output']>;
  declines?: Maybe<Scalars['numeric']['output']>;
  interviewPerWeek?: Maybe<Scalars['Float']['output']>;
  interviewer?: Maybe<Employee>;
  timePerWeek?: Maybe<Scalars['Float']['output']>;
  totalTime?: Maybe<Scalars['Float']['output']>;
  upcoming?: Maybe<Scalars['numeric']['output']>;
};

export type InterviewerMetricsInterviewingResult = {
  __typename?: 'InterviewerMetricsInterviewingResult';
  items?: Maybe<Array<InterviewerMetricsInterviewing>>;
};

export type InterviewerMetricsTableInput = {
  endAt?: InputMaybe<Scalars['datetime']['input']>;
  filters: InterviewerFilters;
  pageInput?: InputMaybe<PageInput>;
  sources?: InputMaybe<Array<MetricsSource>>;
  startAt?: InputMaybe<Scalars['datetime']['input']>;
};

export type InterviewerMetricsTraining = {
  __typename?: 'InterviewerMetricsTraining';
  interviewer?: Maybe<Employee>;
  modulesAsTrainee?: Maybe<Scalars['String']['output']>;
  reverseShadows?: Maybe<Scalars['numeric']['output']>;
  shadows?: Maybe<Scalars['numeric']['output']>;
  trainer?: Maybe<Scalars['numeric']['output']>;
};

export type InterviewerMetricsTrainingResult = {
  __typename?: 'InterviewerMetricsTrainingResult';
  items?: Maybe<Array<InterviewerMetricsTraining>>;
};

export enum InterviewerPortalFieldPermission {
  None = 'NONE',
  Read = 'READ',
  Write = 'WRITE'
}

export type InterviewerPortalSettings = {
  __typename?: 'InterviewerPortalSettings';
  bio: InterviewerPortalFieldPermission;
  bufferTime: InterviewerPortalFieldPermission;
  emailAddress: InterviewerPortalFieldPermission;
  feedbackWritingTime: InterviewerPortalFieldPermission;
  firstName: InterviewerPortalFieldPermission;
  id: Scalars['uuid']['output'];
  interviewAvailability: InterviewerPortalFieldPermission;
  interviewLoadCapacity: InterviewerPortalFieldPermission;
  interviewerKeywords: InterviewerPortalFieldPermission;
  lastName: InterviewerPortalFieldPermission;
  linkedinUrl: InterviewerPortalFieldPermission;
  pauseFromInterviews: InterviewerPortalFieldPermission;
  profilePicture: InterviewerPortalFieldPermission;
  pronouns: InterviewerPortalFieldPermission;
  temporaryAvailability: InterviewerPortalFieldPermission;
  timezone: InterviewerPortalFieldPermission;
  title: InterviewerPortalFieldPermission;
};

/** ######################################### */
export type InterviewerPortalSettingsUpsertInput = {
  bio?: InputMaybe<InterviewerPortalFieldPermission>;
  bufferTime?: InputMaybe<InterviewerPortalFieldPermission>;
  emailAddress?: InputMaybe<InterviewerPortalFieldPermission>;
  feedbackWritingTime?: InputMaybe<InterviewerPortalFieldPermission>;
  firstName?: InputMaybe<InterviewerPortalFieldPermission>;
  interviewAvailability?: InputMaybe<InterviewerPortalFieldPermission>;
  interviewLoadCapacity?: InputMaybe<InterviewerPortalFieldPermission>;
  interviewerKeywords?: InputMaybe<InterviewerPortalFieldPermission>;
  lastName?: InputMaybe<InterviewerPortalFieldPermission>;
  linkedinUrl?: InputMaybe<InterviewerPortalFieldPermission>;
  pauseFromInterviews?: InputMaybe<InterviewerPortalFieldPermission>;
  profilePicture?: InputMaybe<InterviewerPortalFieldPermission>;
  pronouns?: InputMaybe<InterviewerPortalFieldPermission>;
  temporaryAvailability?: InputMaybe<InterviewerPortalFieldPermission>;
  timezone?: InputMaybe<InterviewerPortalFieldPermission>;
  title?: InputMaybe<InterviewerPortalFieldPermission>;
};

export type InterviewerResponseStatusInput = {
  endAt: Scalars['datetime']['input'];
  interviewerId: Scalars['uuid']['input'];
  responseStatus: ResponseStatus;
  startAt: Scalars['datetime']['input'];
};

export enum InterviewerRole {
  Interviewer = 'INTERVIEWER',
  ReverseShadow = 'REVERSE_SHADOW',
  Shadow = 'SHADOW'
}

export type InterviewerRsvpInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<DeclineReason>;
  responseStatus: ResponseStatus;
};

export type InterviewerSuggestion = {
  __typename?: 'InterviewerSuggestion';
  companyHolidays: Array<CompanyHoliday>;
  employee?: Maybe<Employee>;
  employeeId: Scalars['String']['output'];
  eventsWithConflicts?: Maybe<Array<EventsWithConflicts>>;
  flags?: Maybe<Array<InterviewerFlag>>;
  loadAndLimit?: Maybe<LoadAndLimit>;
  previousInterviewsForApplication?: Maybe<PreviousInterviewsForApplication>;
  role?: Maybe<InterviewerRole>;
};

/**
 * ##########################################################
 * ##########################################################
 *  Input and output for interviewerSuggestions
 */
export type InterviewerSuggestionsInput = {
  /**
   *  below field is mandatory going forward to avoid break change will add it now.
   *  will add mandatory in next build
   */
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  attributeValueIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  attributes?: InputMaybe<Array<EmployeeAttribute>>;
  endAt: Scalars['datetime']['input'];
  excludedEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** @deprecated Use freeformInterviewers instead. */
  freeformEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  freeformInterviewers?: InputMaybe<Array<InterviewerAndPreferenceLevel>>;
  hardConflicts?: InputMaybe<Array<HardConflict>>;
  interviewModuleId?: InputMaybe<Scalars['uuid']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['datetime']['input'];
};

export type InterviewerSuggestionsOutput = {
  __typename?: 'InterviewerSuggestionsOutput';
  employees?: Maybe<Array<InterviewerSuggestion>>;
  others?: Maybe<Array<InterviewerSuggestion>>;
};

export type InterviewerWithRole = {
  __typename?: 'InterviewerWithRole';
  employee?: Maybe<Employee>;
  employeeId: Scalars['uuid']['output'];
  role: InterviewerRole;
};

/** Reports a download reason that is blank or too long. */
export type InvalidDownloadReasonError = Error & {
  __typename?: 'InvalidDownloadReasonError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** Reports a row count that is less than zero. */
export type InvalidRowCountError = Error & {
  __typename?: 'InvalidRowCountError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  aiInstruction?: Maybe<AiInstruction>;
  aiMemories: Array<AiMemory>;
  atsId: Scalars['String']['output'];
  atsJob?: Maybe<AtsJob>;
  /**
   *  The preferred synced ATS posting name: Greenhouse external/live/active, then live/active,
   *  then active; otherwise a nonblank posting from another ATS.
   */
  atsJobPostingName?: Maybe<Scalars['String']['output']>;
  atsType: AtsType;
  coordinators?: Maybe<Array<Employee>>;
  /**
   * Department names attached to this Job's ATS row. `null` (or empty) for jobs
   * without an ATS, and for jobs whose ATS row has no department mappings yet.
   */
  departments?: Maybe<Array<Scalars['String']['output']>>;
  /**  This will be the name of the posting or if there is no posting, the name of the job. */
  externalJobName: Scalars['String']['output'];
  fallbackName?: Maybe<Scalars['String']['output']>;
  hiringManagers?: Maybe<Array<Employee>>;
  id: Scalars['uuid']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  interviewGuides: Array<InterviewGuide>;
  isConfidential: Scalars['Boolean']['output'];
  jobSettings: JobSettings;
  jobStages?: Maybe<Array<JobStage>>;
  jobStagesAggregate?: Maybe<Scalars['numeric']['output']>;
  jobStagesWithInterviewPlansCount: Scalars['numeric']['output'];
  location?: Maybe<Array<Scalars['String']['output']>>;
  mismatchedApplications?: Maybe<Array<JobMismatchedApplication>>;
  name: Scalars['String']['output'];
  org?: Maybe<Org>;
  orgId: Scalars['uuid']['output'];
  portalJobOptions?: Maybe<PortalJobOptions>;
  portalJobOptionsPreview?: Maybe<PortalJobOptions>;
  recruiters?: Maybe<Array<Employee>>;
  sourcers?: Maybe<Array<Employee>>;
  sourcingLinks: Array<SourcingLink>;
  status: JobStatus;
  validationIssues: JobValidationResult;
};


export type JobPortalJobOptionsPreviewArgs = {
  input: JobPortalJobOptionsPreviewInput;
};

export type JobAiContextTarget = AiContextTarget & {
  __typename?: 'JobAiContextTarget';
  id: Scalars['uuid']['output'];
  job: Job;
  type: AiContextTargetType;
};

/** Enum representing the roles in a hiring team. */
export enum JobHiringTeamRole {
  Coordinator = 'COORDINATOR',
  HiringManager = 'HIRING_MANAGER',
  Recruiter = 'RECRUITER',
  Sourcer = 'SOURCER'
}

export type JobImportValidateResult = {
  __typename?: 'JobImportValidateResult';
  contentTabMappings: Array<ContentTabMapping>;
  jobStageMappings: Array<JobStageMapping>;
  scorecardMappings: Array<ScorecardMapping>;
  targetJob: Job;
};

export type JobMismatchedApplication = {
  __typename?: 'JobMismatchedApplication';
  application?: Maybe<Application>;
  applicationId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  jobStageName?: Maybe<Scalars['String']['output']>;
};

export type JobNotFoundError = Error & {
  __typename?: 'JobNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type JobPermissionDeniedError = Error & {
  __typename?: 'JobPermissionDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type JobPortalJobOptionsPreviewInput = {
  jobStageId: Scalars['uuid']['input'];
};

export type JobSettings = {
  __typename?: 'JobSettings';
  defaultTaskQueue?: Maybe<TaskQueue>;
  hiringProcess?: Maybe<HiringProcessWithStatus>;
  id: Scalars['uuid']['output'];
  interviewNameSetting: InterviewNameSetting;
  interviewerInfoSetting: InterviewerInfoSetting;
  locale: SettingLocaleValue;
  recruitingTeamContactInfoSetting: RecruitingTeamContactInfoSetting;
  /** @deprecated No longer supported */
  remoteAtsHiringProcess?: Maybe<SmartRecruitersHiringProcessWithStatus>;
  settingLevel: SettingLevel;
  /**  Alias to settingLevelId for Apollo cache */
  settingLevelId: Scalars['uuid']['output'];
};

export type JobSettingsConfigImportInput = {
  canPoSettings?: InputMaybe<CanPoSettings>;
  jobSetupSettings?: InputMaybe<JobSetupSettingsInput>;
  jobStageMappings?: InputMaybe<Array<JobStageMappingInput>>;
  scorecardMappings?: InputMaybe<Array<ScorecardMappingInput>>;
  targetJobId: Scalars['uuid']['input'];
};

export type JobSettingsImportInput = {
  sourceJobId: Scalars['uuid']['input'];
  targetJobs: Array<JobSettingsConfigImportInput>;
};

export type JobSettingsImportResult = {
  __typename?: 'JobSettingsImportResult';
  sourceJob: Job;
  sourceJobId: Scalars['uuid']['output'];
  targetJobIds: Array<Scalars['uuid']['output']>;
  targetJobs: Array<Job>;
};

export type JobSettingsImportValidateInput = {
  canPoImportConfig: CanPoSettingsImportConfig;
  sourceJobId: Scalars['uuid']['input'];
  stageImportConfigs: Array<JobStageSettingsImportConfig>;
  targetJobIds: Array<Scalars['uuid']['input']>;
};

export type JobSettingsImportValidateResult = {
  __typename?: 'JobSettingsImportValidateResult';
  items: Array<JobImportValidateResult>;
  sourceJob: Job;
};

export type JobSettingsUpsertInput = {
  defaultTaskQueueId?: InputMaybe<Scalars['uuid']['input']>;
  hiringProcessId?: InputMaybe<Scalars['String']['input']>;
  interviewNameSetting?: InputMaybe<InterviewNameSettingInput>;
  interviewerInfoSetting?: InputMaybe<InterviewerInfoSettingInput>;
  jobId: Scalars['uuid']['input'];
  locale?: InputMaybe<Locale>;
  recruitingTeamContactInfoSetting?: InputMaybe<RecruitingTeamContactInfoSettingInput>;
  /**
   * To unset, send null explicitly.
   * @deprecated Use hiringProcessId instead
   */
  remoteAtsHiringProcessId?: InputMaybe<Scalars['String']['input']>;
};

export type JobSettingsUpsertResult = {
  __typename?: 'JobSettingsUpsertResult';
  jobSettings: JobSettings;
};

export type JobSetupSettingsInput = {
  /**  Nullable for backwards compatibility with already-deployed clients; null means false. */
  importLocale?: InputMaybe<Scalars['Boolean']['input']>;
  importNewTaskDefault: Scalars['Boolean']['input'];
  importPrivacy: Scalars['Boolean']['input'];
};

export type JobStage = {
  __typename?: 'JobStage';
  atsId?: Maybe<Scalars['String']['output']>;
  atsJobStage?: Maybe<AtsJobStage>;
  atsType?: Maybe<AtsType>;
  canBeInitialStageForSourcingLink: Scalars['Boolean']['output'];
  createdAt: Scalars['datetime']['output'];
  excludedEmployees?: Maybe<Array<Employee>>;
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  job?: Maybe<Job>;
  jobId: Scalars['uuid']['output'];
  jobStageInterviewGroups?: Maybe<Array<JobStageInterviewGroup>>;
  /**
   * This is deprecated because it would give null if value is not set.
   * Use jobStageSettingsV2 instead fallbacks to Org value or gives default value and never null.
   * @deprecated Use jobStageSettingsV2 instead.
   */
  jobStageSettings?: Maybe<JobStageSettings>;
  /** jobStageSettingsV2 if absent fallbacks to Org value or gives default value and never null. */
  jobStageSettingsV2?: Maybe<JobStageSettingsV2>;
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  schedulable: Scalars['Boolean']['output'];
  schedulingWindow?: Maybe<Duration>;
  updatedAt: Scalars['datetime']['output'];
};


export type JobStageJobStageInterviewGroupsArgs = {
  orderBy?: InputMaybe<IndexOrderBy>;
};

/** Maps to JobStageSettingsV2.CandidateAvailabilitySettings */
export type JobStageCandidateAvailabilitySettings = {
  __typename?: 'JobStageCandidateAvailabilitySettings';
  advanceNoticeMinutes?: Maybe<Scalars['numeric']['output']>;
  bccRecipients?: Maybe<NotificationPreference>;
  canScheduleOverAvailableKeywords?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverFreeTime?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverRecruitingKeywords?: Maybe<Scalars['Boolean']['output']>;
  candidateNote?: Maybe<Scalars['String']['output']>;
  ccRecipients?: Maybe<NotificationPreference>;
  minimumTimeBlockMinutes?: Maybe<Scalars['numeric']['output']>;
  minutesPerDays?: Maybe<Scalars['numeric']['output']>;
  numberOfDays?: Maybe<Scalars['numeric']['output']>;
  shouldRespectLoadLimit?: Maybe<Scalars['Boolean']['output']>;
  timeframeNumberOfDays?: Maybe<Scalars['numeric']['output']>;
  useRollingDays?: Maybe<Scalars['Boolean']['output']>;
};

/** Maps to JobStageSettingsV2.CandidateAvailabilitySettingsV2 */
export type JobStageCandidateAvailabilitySettingsV2 = {
  __typename?: 'JobStageCandidateAvailabilitySettingsV2';
  advanceNotice: SettingDuration;
  bccRecipients: SettingNotificationPreference;
  bookIfPerfectScheduleFound: SettingBoolValue;
  canScheduleOverAvailableKeywords: SettingBoolValue;
  canScheduleOverFreeTime: SettingBoolValue;
  canScheduleOverRecruitingKeywords: SettingBoolValue;
  candidateNote: SettingStringValue;
  ccRecipients: SettingNotificationPreference;
  minimumTimeBlockMinutes: SettingIntValue;
  minutesPerDays: SettingIntValue;
  numberOfDays: SettingIntValue;
  shouldRespectLoadLimit: SettingBoolValue;
  timeframe: SettingDuration;
  useRollingDays: SettingBoolValue;
};

export type JobStageInterview = {
  __typename?: 'JobStageInterview';
  atsInterviewDefinition?: Maybe<AtsInterviewDefinition>;
  atsInterviewDefinitionId?: Maybe<Scalars['String']['output']>;
  atsType?: Maybe<AtsType>;
  collaborationLinkTypes?: Maybe<Array<CollaborationLinkType>>;
  customDuration?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use collaborationLinkTypes instead. */
  dynamicLinkTypes?: Maybe<Array<DynamicLinkType>>;
  forcedStartAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  interviewGuide?: Maybe<InterviewGuide>;
  interviewType: InterviewType;
  isHiddenFromCandidate: Scalars['Boolean']['output'];
  isLockedOrder: Scalars['Boolean']['output'];
  jobStage: JobStage;
  jobStageId: Scalars['uuid']['output'];
  jobStageInterviewGroupId?: Maybe<Scalars['uuid']['output']>;
  jobStageInterviewSeats?: Maybe<Array<JobStageInterviewSeat>>;
  name?: Maybe<Scalars['String']['output']>;
  schedulable: Scalars['Boolean']['output'];
  staticLinks?: Maybe<Array<Scalars['String']['output']>>;
  useAtsDuration: Scalars['Boolean']['output'];
  useAtsName: Scalars['Boolean']['output'];
};

export type JobStageInterviewGroup = {
  __typename?: 'JobStageInterviewGroup';
  atsId?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  jobStageId: Scalars['uuid']['output'];
  jobStageInterviews?: Maybe<Array<JobStageInterview>>;
  locked: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Input for a job stage interview group. */
export type JobStageInterviewGroupInput = {
  atsId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  jobStageId?: InputMaybe<Scalars['uuid']['input']>;
  jobStageInterviews?: InputMaybe<Array<InputMaybe<JobStageInterviewInput>>>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for a job stage interview. */
export type JobStageInterviewInput = {
  atsInterviewDefinitionId?: InputMaybe<Scalars['String']['input']>;
  collaborationLinkTypes?: InputMaybe<Array<CollaborationLinkTypesInput>>;
  customDuration?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  dynamicLinkTypes?: InputMaybe<Array<InputMaybe<DynamicLinkType>>>;
  id: Scalars['uuid']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  interviewGuideId?: InputMaybe<Scalars['uuid']['input']>;
  interviewType?: InputMaybe<InterviewType>;
  isHiddenFromCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  isLockedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  jobStageId?: InputMaybe<Scalars['uuid']['input']>;
  jobStageInterviewGroupId?: InputMaybe<Scalars['uuid']['input']>;
  jobStageInterviewSeats?: InputMaybe<Array<InputMaybe<JobStageInterviewSeatInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  staticLinks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useAtsDuration?: InputMaybe<Scalars['Boolean']['input']>;
  useAtsName?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of upserting a job stage interview plan. */
export type JobStageInterviewPlanResult = {
  __typename?: 'JobStageInterviewPlanResult';
  jobStage?: Maybe<JobStage>;
};

/** Input for upserting a job stage interview plan. */
export type JobStageInterviewPlanUpsertInput = {
  customJobStage?: InputMaybe<CustomJobStageInput>;
  excludedEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  groups: Array<JobStageInterviewGroupInput>;
  jobStageId?: InputMaybe<Scalars['uuid']['input']>;
  schedulingWindow?: InputMaybe<DurationInput>;
};

export type JobStageInterviewSeat = {
  __typename?: 'JobStageInterviewSeat';
  freeformSeat?: Maybe<FreeformSeat>;
  id: Scalars['uuid']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  linkedSeat?: Maybe<LinkedSeat>;
  moduleSeat?: Maybe<ModuleSeat>;
  type: JobStageInterviewSeatType;
};

export type JobStageInterviewSeatAttribute = {
  __typename?: 'JobStageInterviewSeatAttribute';
  attributeNameId?: Maybe<Scalars['uuid']['output']>;
  attributeTagValueId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  jobStageInterviewSeatId?: Maybe<Scalars['uuid']['output']>;
};

/** Input for a job stage interview seat attribute. */
export type JobStageInterviewSeatAttributeInput = {
  attributeNameId?: InputMaybe<Scalars['uuid']['input']>;
  attributeTagValueId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobStageInterviewSeatId?: InputMaybe<Scalars['uuid']['input']>;
  orgId?: InputMaybe<Scalars['uuid']['input']>;
};

export type JobStageInterviewSeatEmployee = {
  __typename?: 'JobStageInterviewSeatEmployee';
  employee?: Maybe<Employee>;
  employeeId: Scalars['uuid']['output'];
  jobStageInterviewSeatId: Scalars['uuid']['output'];
  preferenceLevel?: Maybe<Scalars['Int']['output']>;
};

/** Input for a job stage interview seat employee. */
export type JobStageInterviewSeatEmployeeInput = {
  employeeId: Scalars['uuid']['input'];
  jobStageInterviewSeatId?: InputMaybe<Scalars['uuid']['input']>;
  preferenceLevel?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for a job stage interview seat. */
export type JobStageInterviewSeatInput = {
  freeformSeat?: InputMaybe<FreeformSeatInput>;
  id: Scalars['uuid']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  jobStageInterviewId?: InputMaybe<Scalars['uuid']['input']>;
  linkedSeat?: InputMaybe<LinkedSeatInput>;
  moduleSeat?: InputMaybe<ModuleSeatInput>;
};

export enum JobStageInterviewSeatType {
  Freeform = 'FREEFORM',
  Linked = 'LINKED',
  Module = 'MODULE'
}

export type JobStageMapping = {
  __typename?: 'JobStageMapping';
  sourceJobStage: JobStage;
  sourceJobStageId: Scalars['uuid']['output'];
  sourceName: Scalars['String']['output'];
  targetJobStageId?: Maybe<Scalars['uuid']['output']>;
};

export type JobStageMappingInput = {
  importAvailabilitySettings: Scalars['Boolean']['input'];
  importCandidateComms: Scalars['Boolean']['input'];
  importInternalEvents: Scalars['Boolean']['input'];
  importInterviewPlan: Scalars['Boolean']['input'];
  importSelfScheduleSettings: Scalars['Boolean']['input'];
  importSlackChannel: Scalars['Boolean']['input'];
  sourceJobStageId: Scalars['uuid']['input'];
  targetJobStageId: Scalars['uuid']['input'];
};

/** Maps to JobStageSettingsV2.SelfScheduleSettings */
export type JobStageSelfScheduleSettings = {
  __typename?: 'JobStageSelfScheduleSettings';
  advanceNoticeMinutes?: Maybe<Scalars['numeric']['output']>;
  bccRecipients?: Maybe<NotificationPreference>;
  canScheduleOverAvailableKeywords?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverFreeTime?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverRecruitingKeywords?: Maybe<Scalars['Boolean']['output']>;
  candidateCalendarId?: Maybe<SettingCalendarId>;
  candidateNote?: Maybe<Scalars['String']['output']>;
  ccRecipients?: Maybe<NotificationPreference>;
  customLocation?: Maybe<Scalars['String']['output']>;
  interviewerCalendarId?: Maybe<SettingCalendarId>;
  isPrivateCalendarEvent?: Maybe<SettingBoolValue>;
  location?: Maybe<SelfScheduleLocation>;
  meetingHost?: Maybe<SelfScheduleMeetingHost>;
  shouldRespectLoadLimit?: Maybe<Scalars['Boolean']['output']>;
  timeframeNumberOfDays?: Maybe<Scalars['numeric']['output']>;
  useRollingDays?: Maybe<Scalars['Boolean']['output']>;
  videoMeetingHostEmployeeId?: Maybe<Scalars['uuid']['output']>;
  zoomHost?: Maybe<SelfScheduleZoomHost>;
  zoomHostUserId?: Maybe<Scalars['String']['output']>;
};

/** Maps to JobStageSettingsV2.SelfScheduleSettingsV2 */
export type JobStageSelfScheduleSettingsV2 = {
  __typename?: 'JobStageSelfScheduleSettingsV2';
  advanceNotice: SettingDuration;
  bccRecipients: SettingNotificationPreference;
  canScheduleOverAvailableKeywords: SettingBoolValue;
  canScheduleOverFreeTime: SettingBoolValue;
  canScheduleOverRecruitingKeywords: SettingBoolValue;
  candidateNote: SettingStringValue;
  ccRecipients: SettingNotificationPreference;
  shouldRespectLoadLimit: SettingBoolValue;
  timeframe: SettingDuration;
  useRollingDays: SettingBoolValue;
};

/** deprecated because it would give null if value is not set and has no org fallback. */
export type JobStageSettings = {
  __typename?: 'JobStageSettings';
  availabilityRequestEmailTemplateId?: Maybe<Scalars['uuid']['output']>;
  bccRecipients?: Maybe<NotificationPreference>;
  candidateAvailabilityOptions?: Maybe<CandidateAvailabilityOptionsSettings>;
  candidateCalendarId?: Maybe<Scalars['String']['output']>;
  candidateEmailTemplate?: Maybe<Template>;
  candidateEmailTemplateId?: Maybe<Scalars['uuid']['output']>;
  candidateEventTemplate?: Maybe<Template>;
  candidateEventTemplateId?: Maybe<Scalars['uuid']['output']>;
  ccRecipients?: Maybe<NotificationPreference>;
  id: Scalars['uuid']['output'];
  interviewMeetingLocationSetting?: Maybe<InterviewMeetingLocationSettingPref>;
  interviewerCalendarId?: Maybe<Scalars['String']['output']>;
  interviewerEventTemplate?: Maybe<Template>;
  interviewerEventTemplateId?: Maybe<Scalars['uuid']['output']>;
  jobStageId: Scalars['uuid']['output'];
  privateCalendarEvents?: Maybe<Scalars['Boolean']['output']>;
  selfScheduleCandidateEmailTemplateId?: Maybe<Scalars['uuid']['output']>;
  selfScheduleInterviewerEventTemplateId?: Maybe<Scalars['uuid']['output']>;
  selfScheduleOptions?: Maybe<SelfScheduleOptionSettings>;
  selfScheduleRequestEmailTemplateId?: Maybe<Scalars['uuid']['output']>;
  slackTemplate?: Maybe<Template>;
  slackTemplateId?: Maybe<Scalars['uuid']['output']>;
  toRecipients?: Maybe<NotificationPreference>;
};

export type JobStageSettingsImportConfig = {
  importInterviewPlan: Scalars['Boolean']['input'];
  jobStageId: Scalars['uuid']['input'];
};

export type JobStageSettingsUpsertInput = {
  automaticallyReplaceDeclinedInterviewer?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityRequestEmailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  bccRecipients?: InputMaybe<NotificationPreferenceInput>;
  candidateAvailabilityOptions?: InputMaybe<CandidateAvailabilityOptionsSettingInput>;
  candidateCalendarId?: InputMaybe<Scalars['String']['input']>;
  candidateEmailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  candidateEventAdditionalAttendees?: InputMaybe<NotificationPreferenceInput>;
  candidateEventAdditionalAttendeesOptional?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   *  Per-entry defaults, an independent patch per event type: omit to leave the stage alone, send
   *  null to drop back to syncing with the Org Default, send a value to replace.
   */
  candidateEventAdditionalAttendeesV2?: InputMaybe<SettingAdditionalAttendeesInput>;
  /**  this is used for self/schedule request */
  candidateEventTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  ccRecipients?: InputMaybe<NotificationPreferenceInput>;
  chatConversation?: InputMaybe<ChatConversationInput>;
  chatConversationMembers?: InputMaybe<NotificationPreferenceInput>;
  createAutomatedTaskOnBehalfOf?: InputMaybe<AutomatedTaskOnBehalfOfInput>;
  debriefAtsWriteSetting?: InputMaybe<DebriefAtsWriteSettingInput>;
  debriefEventAdditionalAttendees?: InputMaybe<NotificationPreferenceInput>;
  debriefEventAdditionalAttendeesOptional?: InputMaybe<Scalars['Boolean']['input']>;
  debriefEventAdditionalAttendeesV2?: InputMaybe<SettingAdditionalAttendeesInput>;
  debriefMeetingLocationSetting?: InputMaybe<InterviewMeetingLocationSettingsInput>;
  defaultTask?: InputMaybe<TaskCreationSource>;
  interviewMeetingLocationSetting?: InputMaybe<InterviewMeetingLocationSettingsInput>;
  interviewerCalendarId?: InputMaybe<Scalars['String']['input']>;
  interviewerEventAdditionalAttendees?: InputMaybe<NotificationPreferenceInput>;
  interviewerEventAdditionalAttendeesOptional?: InputMaybe<Scalars['Boolean']['input']>;
  interviewerEventAdditionalAttendeesV2?: InputMaybe<SettingAdditionalAttendeesInput>;
  /**  V2 attributes */
  interviewerEventTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  /**  null means no default task. */
  isAutomatedTaskEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  jobStageId: Scalars['uuid']['input'];
  privateCalendarEvents?: InputMaybe<Scalars['Boolean']['input']>;
  selfScheduleCandidateEmailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  selfScheduleInterviewerEventTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  selfScheduleOptions?: InputMaybe<SelfScheduleOptionsSettingInput>;
  selfScheduleRequestEmailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  shouldSendCalendarInviteToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSendCandidatePulse?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSendChatMessage?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSendEmailToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  /**  same */
  slackTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  syncScorecardsFromAts?: InputMaybe<Scalars['Boolean']['input']>;
  toRecipients?: InputMaybe<NotificationPreferenceInput>;
};

export type JobStageSettingsUpsertResult = {
  __typename?: 'JobStageSettingsUpsertResult';
  jobStageSettings?: Maybe<JobStageSettings>;
  jobStageSettingsV2?: Maybe<JobStageSettingsV2>;
};

/** If absent fallbacks to Org value or gives default value and never null. */
export type JobStageSettingsV2 = {
  __typename?: 'JobStageSettingsV2';
  automaticallyReplaceDeclinedInterviewer: SettingBoolValue;
  availabilityRequestEmailTemplateId?: Maybe<SettingTemplateId>;
  /** @deprecated Use bccRecipientsV2 instead. */
  bccRecipients?: Maybe<NotificationPreference>;
  bccRecipientsV2?: Maybe<SettingNotificationPreference>;
  /** @deprecated Use candidateAvailabilitySettingsV2 instead. */
  candidateAvailabilitySettings?: Maybe<JobStageCandidateAvailabilitySettings>;
  candidateAvailabilitySettingsV2?: Maybe<JobStageCandidateAvailabilitySettingsV2>;
  candidateCalendarId?: Maybe<SettingCalendarId>;
  candidateEmailTemplateId?: Maybe<SettingTemplateId>;
  candidateEventAdditionalAttendees?: Maybe<SettingNotificationPreference>;
  candidateEventAdditionalAttendeesOptional?: Maybe<SettingBoolValue>;
  /**
   *  Resolved per-entry defaults. Always answers, including for an org/stage still on the legacy
   *  list-plus-boolean shape, which the settings read rule materializes into uniform entries.
   */
  candidateEventAdditionalAttendeesV2?: Maybe<SettingAdditionalAttendees>;
  candidateEventTemplateId?: Maybe<SettingTemplateId>;
  /** @deprecated Use ccRecipientsV2 instead. */
  ccRecipients?: Maybe<NotificationPreference>;
  ccRecipientsV2?: Maybe<SettingNotificationPreference>;
  chatConversation?: Maybe<SettingChatConversation>;
  chatConversationMembers?: Maybe<SettingNotificationPreference>;
  createAutomatedTaskOnBehalfOf?: Maybe<AutomatedTaskOnBehalfOf>;
  debriefAtsWriteSettingWithLevel?: Maybe<DebriefAtsWriteSettingWithLevel>;
  debriefEventAdditionalAttendees?: Maybe<SettingNotificationPreference>;
  debriefEventAdditionalAttendeesOptional?: Maybe<SettingBoolValue>;
  debriefEventAdditionalAttendeesV2?: Maybe<SettingAdditionalAttendees>;
  debriefMeetingLocationSettingWithLevel?: Maybe<DebriefMeetingLocationSettingWithLevel>;
  defaultTask?: Maybe<TaskCreationSource>;
  id: Scalars['uuid']['output'];
  interviewMeetingLocationSettingWithLevel?: Maybe<InterviewMeetingLocationSettingWithLevel>;
  interviewerCalendarId?: Maybe<SettingCalendarId>;
  interviewerEventAdditionalAttendees?: Maybe<SettingNotificationPreference>;
  interviewerEventAdditionalAttendeesOptional?: Maybe<SettingBoolValue>;
  interviewerEventAdditionalAttendeesV2?: Maybe<SettingAdditionalAttendees>;
  interviewerEventTemplateId?: Maybe<SettingTemplateId>;
  isAutomatedTaskEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPrivateCalendarEvent: SettingBoolValue;
  jobStageId: Scalars['uuid']['output'];
  selfScheduleCandidateEmailTemplateId?: Maybe<SettingTemplateId>;
  selfScheduleInterviewerEventTemplateId?: Maybe<SettingTemplateId>;
  selfScheduleRequestEmailTemplateId?: Maybe<SettingTemplateId>;
  /** @deprecated Use selfScheduleSettingsV2 instead. */
  selfScheduleSettings?: Maybe<JobStageSelfScheduleSettings>;
  selfScheduleSettingsV2?: Maybe<JobStageSelfScheduleSettingsV2>;
  shouldSendCalendarInviteToCandidate?: Maybe<SettingBoolValue>;
  shouldSendCandidatePulse?: Maybe<SettingBoolValue>;
  shouldSendChatMessage?: Maybe<SettingBoolValue>;
  shouldSendEmailToCandidate?: Maybe<SettingBoolValue>;
  slackTemplateId?: Maybe<SettingTemplateId>;
  syncScorecardsFromAts: SettingBoolValue;
  toRecipients?: Maybe<NotificationPreference>;
};

export type JobStagesByNameOutput = {
  __typename?: 'JobStagesByNameOutput';
  items: Array<Maybe<Scalars['String']['output']>>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * ##########################################################
 *  Input and output for job stages
 */
export type JobStagesInput = {
  isSchedulable?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['uuid']['input']>;
  orderBy?: InputMaybe<JobsOrderBy>;
  /** optional */
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type JobStagesOrderBy = {
  direction: Sort;
  property: JobStagesOrderByProperty;
};

export enum JobStagesOrderByProperty {
  Name = 'NAME'
}

export type JobStagesOutput = {
  __typename?: 'JobStagesOutput';
  items: Array<JobStage>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export enum JobStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export type JobUpdateInput = {
  fallbackName?: InputMaybe<Scalars['String']['input']>;
  internalNote?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['uuid']['input'];
};

export type JobUpdateResult = {
  __typename?: 'JobUpdateResult';
  job: Job;
};

export type JobV2Input = {
  id: Scalars['uuid']['input'];
};

export type JobV2Output = Job | JobNotFoundError | JobPermissionDeniedError | UnknownError;

export type JobValidationErrorFlags = {
  __typename?: 'JobValidationErrorFlags';
  message: Scalars['String']['output'];
  type: TaskCreateValidateErrorFlagType;
};

export type JobValidationResult = {
  __typename?: 'JobValidationResult';
  errors?: Maybe<Array<JobValidationErrorFlags>>;
};

/**
 * ##########################################################
 * ##########################################################
 *  Input and output for jobs
 */
export type JobsInput = {
  defaultTaskQueueIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  hiringTeamEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  interviewModuleIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<JobsOrderBy>;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<JobStatus>>>;
};

/**  How to order by jobs? */
export type JobsOrderBy = {
  direction: Sort;
  property: JobsOrderByProperty;
};

export enum JobsOrderByProperty {
  Name = 'NAME'
}

export type JobsOutput = {
  __typename?: 'JobsOutput';
  items: Array<Job>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export enum JsonArrayEmployeePref {
  /**  keep-sorted:begin */
  ArrAllTasksDashboardLayout = 'arr_all_tasks_dashboard_layout',
  ArrMyTasksDashboardLayout = 'arr_my_tasks_dashboard_layout'
}

export type JsonArrayEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'JsonArrayEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  value?: Maybe<Array<EmployeeJsonPref>>;
};

export enum JsonEmployeePref {
  /**  keep-sorted:begin */
  ObjAllTasksDashboardFilters = 'obj_all_tasks_dashboard_filters',
  ObjCandidatePageFilters = 'obj_candidate_page_filters',
  ObjDailyInterviewLimit = 'obj_daily_interview_limit',
  ObjDirectoryPageFilters = 'obj_directory_page_filters',
  ObjInterviewBufferTime = 'obj_interview_buffer_time',
  ObjMetricsAverageTimesFilters = 'obj_metrics_average_times_filters',
  ObjMetricsPageCandidatePulseFilters = 'obj_metrics_page_candidate_pulse_filters',
  ObjMetricsPageInterviewerFilters = 'obj_metrics_page_interviewer_filters',
  ObjMetricsPageRecruitingTeamFilters = 'obj_metrics_page_recruiting_team_filters',
  ObjMyTasksDashboardAssignedToMeFilters = 'obj_my_tasks_dashboard_assigned_to_me_filters',
  ObjMyTasksDashboardCreatedByMeFilters = 'obj_my_tasks_dashboard_created_by_me_filters',
  ObjMyTasksDashboardMyQueuesFilters = 'obj_my_tasks_dashboard_my_queues_filters',
  ObjMyTasksDashboardSubscribedByMeFilters = 'obj_my_tasks_dashboard_subscribed_by_me_filters',
  ObjProfilePicture = 'obj_profile_picture',
  ObjRecentlyUsedZoomUsers = 'obj_recently_used_zoom_users',
  ObjUpcomingEventsPageFilters = 'obj_upcoming_events_page_filters',
  ObjWeeklyInterviewLimit = 'obj_weekly_interview_limit'
}

export type JsonEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'JsonEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  value?: Maybe<EmployeeJsonPref>;
};

export enum JsonOrgPref {
  /**  keep-sorted:begin */
  ObjAddZoomHostAsInternalInvitee = 'obj_add_zoom_host_as_internal_invitee',
  ObjAiOrgCustomLlm = 'obj_ai_org_custom_llm',
  ObjAtsJobSyncScope = 'obj_ats_job_sync_scope',
  ObjAvailabilityRequestBccRecipients = 'obj_availability_request_bcc_recipients',
  ObjAvailabilityRequestCcRecipients = 'obj_availability_request_cc_recipients',
  ObjCandidateCommunicationsSetting = 'obj_candidate_communications_setting',
  ObjCandidateEventAdditionalAttendees = 'obj_candidate_event_additional_attendees',
  ObjCandidateFacingHiringTeamContactInfo = 'obj_candidate_facing_hiring_team_contact_info',
  ObjCandidateFacingInterviewerInfo = 'obj_candidate_facing_interviewer_info',
  ObjCandidatePortalAutomationRules = 'obj_candidate_portal_automation_rules',
  ObjChatCommunicationsSetting = 'obj_chat_communications_setting',
  ObjChatConversationMembers = 'obj_chat_conversation_members',
  ObjCustomInterviewScheduleToken = 'obj_custom_interview_schedule_token',
  ObjDailyInterviewLimit = 'obj_daily_interview_limit',
  ObjDebriefAtsWriteSetting = 'obj_debrief_ats_write_setting',
  ObjDebriefEventAdditionalAttendees = 'obj_debrief_event_additional_attendees',
  ObjDebriefMeetingLocationSetting = 'obj_debrief_meeting_location_setting',
  ObjDefaultWorkHours = 'obj_default_work_hours',
  ObjEmployeeFieldSyncSource = 'obj_employee_field_sync_source',
  ObjInterviewBufferTime = 'obj_interview_buffer_time',
  ObjInterviewMeetingLocationSetting = 'obj_interview_meeting_location_setting',
  ObjInterviewerEventAdditionalAttendees = 'obj_interviewer_event_additional_attendees',
  ObjMinimumDailyInterviewerLoadLimit = 'obj_minimum_daily_interviewer_load_limit',
  ObjMinimumWeeklyInterviewerLoadLimit = 'obj_minimum_weekly_interviewer_load_limit',
  ObjPremiumCandidatePortal = 'obj_premium_candidate_portal',
  ObjSelfScheduleRequestBccRecipients = 'obj_self_schedule_request_bcc_recipients',
  ObjSelfScheduleRequestCcRecipients = 'obj_self_schedule_request_cc_recipients',
  ObjTrainingModuleGraduationNotification = 'obj_training_module_graduation_notification',
  ObjWeeklyInterviewLimit = 'obj_weekly_interview_limit'
}

/** Lever-specific fields for candidates. */
export type LeverCandidate = {
  __typename?: 'LeverCandidate';
  leverOpportunityUrl: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
};

export type LeverIntegration = {
  __typename?: 'LeverIntegration';
  active: Scalars['Boolean']['output'];
};

export type LeverIntegrationHealth = {
  __typename?: 'LeverIntegrationHealth';
  canReadApplications: Scalars['Boolean']['output'];
  canReadArchiveReasons: Scalars['Boolean']['output'];
  canReadCandidates: Scalars['Boolean']['output'];
  canReadDeletedCandidates: Scalars['Boolean']['output'];
  canReadJobs: Scalars['Boolean']['output'];
  canReadPanels: Scalars['Boolean']['output'];
  canReadStages: Scalars['Boolean']['output'];
  canReadUsers: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

/** Lever-specific fields for interview definitions. */
export type LeverInterviewDefinition = {
  __typename?: 'LeverInterviewDefinition';
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
};

/** Input for unfurling a link. */
export type LinkUnfurlInput = {
  /** The URL to unfurl. */
  url: Scalars['String']['input'];
};

/** Result type for link unfurling. */
export type LinkUnfurlResult = {
  __typename?: 'LinkUnfurlResult';
  /** A description of the linked content. */
  description?: Maybe<Scalars['String']['output']>;
  /** The URL of the favicon for the linked site. */
  favicon?: Maybe<Scalars['String']['output']>;
  /** The URL of a thumbnail image representing the linked content. */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** The title of the linked content. */
  title?: Maybe<Scalars['String']['output']>;
  /** The original URL that was unfurled. */
  url: Scalars['String']['output'];
};

/** Represents a single linked card. */
export type LinkedCard = {
  __typename?: 'LinkedCard';
  /** The body text for the linked card. */
  body?: Maybe<Scalars['String']['output']>;
  /** The header text for the linked card. */
  header: Scalars['String']['output'];
  /** The URL of a preview image for the linked card. */
  previewImageUrl?: Maybe<Scalars['String']['output']>;
  /** The URL that the card links to. */
  url: Scalars['String']['output'];
};

/** Input for creating or updating a linked card. */
export type LinkedCardInput = {
  /** The body text for the linked card. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The header text for the linked card. */
  header: Scalars['String']['input'];
  /** The URL of a preview image for the linked card. */
  previewImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** The URL that the card links to. */
  url: Scalars['String']['input'];
};

export type LinkedSeat = {
  __typename?: 'LinkedSeat';
  linkedJobStageInterviewSeatId: Scalars['uuid']['output'];
};

/** Input for a linked seat. */
export type LinkedSeatInput = {
  linkedJobStageInterviewSeatId: Scalars['uuid']['input'];
};

export type LoadAndLimit = {
  __typename?: 'LoadAndLimit';
  dailyInterviewLimit?: Maybe<InterviewLimit>;
  dailyLoad?: Maybe<Scalars['Int']['output']>;
  dailyLoadMinutes?: Maybe<Scalars['Int']['output']>;
  lastWeeklyLoad?: Maybe<Scalars['Int']['output']>;
  lastWeeklyLoadMinutes?: Maybe<Scalars['Int']['output']>;
  weeklyInterviewLimit?: Maybe<InterviewLimit>;
  weeklyLoad?: Maybe<Scalars['Int']['output']>;
  weeklyLoadMinutes?: Maybe<Scalars['Int']['output']>;
};

export type LoadAndLimitInput = {
  date: Scalars['date']['input'];
  timezone: Scalars['String']['input'];
};

/** Represents a date range with start and end dates using the custom 'date' scalar type. */
export type LocalDateBlock = {
  __typename?: 'LocalDateBlock';
  end: Scalars['date']['output'];
  start: Scalars['date']['output'];
};

/** Represents a time range with start and end times using the custom 'localtime' scalar type. */
export type LocalTimeBlock = {
  __typename?: 'LocalTimeBlock';
  end: Scalars['localtime']['output'];
  start: Scalars['localtime']['output'];
};

/** Input type for specifying a time range. */
export type LocalTimeBlockInput = {
  end: Scalars['localtime']['input'];
  start: Scalars['localtime']['input'];
};

/** Represents a supported locale identifier. */
export enum Locale {
  DaDk = 'DA_DK',
  EnUs = 'EN_US',
  Es_419 = 'ES_419',
  EsEs = 'ES_ES',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  JaJp = 'JA_JP',
  KoKr = 'KO_KR',
  PtBr = 'PT_BR',
  ZhCn = 'ZH_CN',
  ZhTw = 'ZH_TW'
}

export type LocaleTranslationStatusInput = {
  locale: Locale;
};

export type LocaleTranslationStatusResult = {
  __typename?: 'LocaleTranslationStatusResult';
  missing: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  translated: Scalars['Int']['output'];
};

/** ######################################################## */
export type ManagersInput = {
  /**  Exclude employees which are already added as user of modernloop. */
  excludeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAtsId?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isAtsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDirectoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum MappingType {
  OneToMany = 'ONE_TO_MANY',
  OneToOne = 'ONE_TO_ONE'
}

/** Output for marking all notifications as read. */
export type MarkAllNotificationsReadOutput = {
  __typename?: 'MarkAllNotificationsReadOutput';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Output for marking all notifications as seen. */
export type MarkAllNotificationsSeenOutput = {
  __typename?: 'MarkAllNotificationsSeenOutput';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for marking a single notification as read. */
export type MarkNotificationReadInput = {
  notificationId: Scalars['uuid']['input'];
};

/** Output for marking a single notification as read. */
export type MarkNotificationReadOutput = {
  __typename?: 'MarkNotificationReadOutput';
  notification?: Maybe<EmployeeNotification>;
};

/** Input for marking a single notification as unread. */
export type MarkNotificationUnreadInput = {
  notificationId: Scalars['uuid']['input'];
};

/** Output for marking a single notification as unread. */
export type MarkNotificationUnreadOutput = {
  __typename?: 'MarkNotificationUnreadOutput';
  notification?: Maybe<EmployeeNotification>;
};

/** A durable MCP tool-call audit record. */
export type McpToolCallAuditLogEntry = {
  __typename?: 'McpToolCallAuditLogEntry';
  actor?: Maybe<Employee>;
  actorId: Scalars['String']['output'];
  calledAt: Scalars['datetime']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  status: PlatformAuditCallStatus;
  tokenName?: Maybe<Scalars['String']['output']>;
  tokenType: PlatformAuditTokenType;
  toolInput: AuditLogPayload;
  toolName: Scalars['String']['output'];
  toolOutput: AuditLogPayload;
};

/** Optional inclusive UTC date range and cursor for MCP audit records. */
export type McpToolCallAuditLogsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** A page of MCP tool-call audit records. */
export type McpToolCallAuditLogsResult = {
  __typename?: 'McpToolCallAuditLogsResult';
  items: Array<McpToolCallAuditLogEntry>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Input type for specifying meeting link formats. */
export type MeetingLinkFormat = {
  /** The format for custom links. */
  customLinkFormat?: InputMaybe<Scalars['String']['input']>;
  /** The format for workspace video links. */
  workspaceVideoLinkFormat?: InputMaybe<Scalars['String']['input']>;
  /** The format for Zoom links. */
  zoomLinkFormat?: InputMaybe<Scalars['String']['input']>;
};

export type MeetingLocation = {
  __typename?: 'MeetingLocation';
  canceledAt?: Maybe<Scalars['datetime']['output']>;
  createdAt: Scalars['datetime']['output'];
  details?: Maybe<MeetingLocationDetails>;
  hostEmployee?: Maybe<Employee>;
  id: Scalars['uuid']['output'];
  remoteNotetakerTranscript?: Maybe<Scalars['jsonb']['output']>;
  remoteVideoMeetingHostUser?: Maybe<RemoteVideoMeetingHostUser>;
  type: InterviewMeetingLocationType;
  updatedAt: Scalars['datetime']['output'];
  videoMeetingLink?: Maybe<Scalars['String']['output']>;
};

export type MeetingLocationCreateInput = {
  customLocation?: InputMaybe<Scalars['String']['input']>;
  locationType: InterviewMeetingLocationType;
  /** Either of videoMeeting or customLocation must be set */
  videoMeeting?: InputMaybe<VideoMeetingCreateInput>;
};

export type MeetingLocationCreateResult = {
  __typename?: 'MeetingLocationCreateResult';
  meetingLocation?: Maybe<MeetingLocation>;
};

export type MeetingLocationDetails = {
  __typename?: 'MeetingLocationDetails';
  customLocation?: Maybe<Scalars['String']['output']>;
  zoomInfo?: Maybe<ZoomInfo>;
};

export enum MeetingLocationHostType {
  DynamicInterviewers = 'DYNAMIC_INTERVIEWERS',
  DynamicScheduler = 'DYNAMIC_SCHEDULER',
  Employee = 'EMPLOYEE',
  RemoteUser = 'REMOTE_USER'
}

export enum MeetingPurpose {
  Debrief = 'DEBRIEF',
  Interview = 'INTERVIEW'
}

export type MeetingRoom = {
  __typename?: 'MeetingRoom';
  buildingRemoteId?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  floorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  updatedAt: Scalars['datetime']['output'];
};

export type MeetingRoomOrderBy = {
  direction: Sort;
  property: MeetingRoomOrderByProperty;
};

export enum MeetingRoomOrderByProperty {
  Description = 'DESCRIPTION'
}

/**
 * ##########################################################
 *  In future we will add calendar events to this type.
 */
export type MeetingRoomSuggestion = {
  __typename?: 'MeetingRoomSuggestion';
  busyTimeRanges?: Maybe<Array<DateTimeRangeOutput>>;
  hasError?: Maybe<Scalars['Boolean']['output']>;
  isBusy?: Maybe<Scalars['Boolean']['output']>;
  room?: Maybe<MeetingRoom>;
};

/**
 * ##########################################################
 *  Input and output for meetingRoomSuggestions
 */
export type MeetingRoomSuggestionsInput = {
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  minCapacity?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MeetingRoomOrderBy>;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  timeRange: DateTimeRangeInput;
};

export type MeetingRoomSuggestionsOutput = {
  __typename?: 'MeetingRoomSuggestionsOutput';
  items: Array<MeetingRoomSuggestion>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * ##########################################################
 *  Input and output for meetingRooms
 */
export type MeetingRoomsInput = {
  orderBy?: InputMaybe<MeetingRoomOrderBy>;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MeetingRoomsOutput = {
  __typename?: 'MeetingRoomsOutput';
  items: Array<MeetingRoom>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * The Organization of an Organization Membership, by id and name only. Deliberately not `Org`: every
 * other `Org` field resolves data owned by that Organization, and a Membership is not permission to
 * read another Organization's ATS status, tokens, preferences or directory.
 */
export type MembershipOrganization = {
  __typename?: 'MembershipOrganization';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type MetricsChartDownloadResult = {
  __typename?: 'MetricsChartDownloadResult';
  data?: Maybe<Array<InterviewMetrics>>;
  scheduleStages?: Maybe<Array<ScheduleStageMetrics>>;
};

export type MetricsPageAverageTimesFiltersPref = {
  __typename?: 'MetricsPageAverageTimesFiltersPref';
  assigneeEmployeeIds: Array<Scalars['uuid']['output']>;
  endMetric: TimeToScheduleMetric;
  jobIds: Array<Scalars['uuid']['output']>;
  jobStageNames: Array<Scalars['String']['output']>;
  startMetric: TimeToScheduleMetric;
};

export type MetricsPageCandidatePulseFiltersPref = {
  __typename?: 'MetricsPageCandidatePulseFiltersPref';
  jobIds: Array<Scalars['uuid']['output']>;
  jobStageNames: Array<Scalars['String']['output']>;
};

export type MetricsPageInterviewerFiltersPref = {
  __typename?: 'MetricsPageInterviewerFiltersPref';
  atsDepartmentIds: Array<Scalars['String']['output']>;
  countryAttributeIds: Array<Scalars['uuid']['output']>;
  customAttributeIds: Array<Scalars['uuid']['output']>;
  departmentAttributeIds: Array<Scalars['uuid']['output']>;
  interviewModuleIds: Array<Scalars['uuid']['output']>;
  interviewModules: Array<InterviewModule>;
  interviewerEmployeeIds: Array<Scalars['uuid']['output']>;
  interviewerEmployees: Array<Employee>;
  jobIds: Array<Scalars['uuid']['output']>;
  jobLocations: Array<Scalars['String']['output']>;
  jobs: Array<Job>;
  levelAttributeIds: Array<Scalars['uuid']['output']>;
  locationAttributeIds: Array<Scalars['uuid']['output']>;
  managerEmployeeIds: Array<Scalars['uuid']['output']>;
  managerEmployees: Array<Employee>;
  showArchived: Scalars['Boolean']['output'];
  teamAttributeIds: Array<Scalars['uuid']['output']>;
};

export type MetricsPageRecruitingTeamFiltersPref = {
  __typename?: 'MetricsPageRecruitingTeamFiltersPref';
  atsDepartmentIds: Array<Scalars['String']['output']>;
  jobIds: Array<Scalars['uuid']['output']>;
  jobLocations: Array<Scalars['String']['output']>;
  jobStageNames: Array<Scalars['String']['output']>;
  jobs: Array<Job>;
  schedulerEmployeeIds: Array<Scalars['uuid']['output']>;
  schedulerEmployees: Array<Employee>;
  showArchived: Scalars['Boolean']['output'];
};

/**
 * #########################
 *  Enum for metrics data source
 */
export enum MetricsSource {
  MetricsSourceAts = 'METRICS_SOURCE_ATS',
  MetricsSourceModernloop = 'METRICS_SOURCE_MODERNLOOP'
}

export type MicrosoftEmployeeIntegration = {
  __typename?: 'MicrosoftEmployeeIntegration';
  active: Scalars['Boolean']['output'];
  updatedAt: Scalars['datetime']['output'];
};

export type MicrosoftGccHighEmployeeIntegration = {
  __typename?: 'MicrosoftGccHighEmployeeIntegration';
  active: Scalars['Boolean']['output'];
};

export type MicrosoftGccHighIntegration = {
  __typename?: 'MicrosoftGccHighIntegration';
  active: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
};

export type MicrosoftIntegration = {
  __typename?: 'MicrosoftIntegration';
  active: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
};

export type MicrosoftIntegrationHealth = {
  __typename?: 'MicrosoftIntegrationHealth';
  canReadCalendars: Scalars['Boolean']['output'];
  canReadDirectory: Scalars['Boolean']['output'];
  canReadMeetingRooms: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

export type MicrosoftServiceUserIntegration = {
  __typename?: 'MicrosoftServiceUserIntegration';
  serviceAccountEmail: Scalars['String']['output'];
  updatedAt: Scalars['datetime']['output'];
};

export type MinimumInterviewerLoadLimitOrgPref = {
  __typename?: 'MinimumInterviewerLoadLimitOrgPref';
  interviews?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
};

export type MintFirstPartyAgentAccessTokenInput = {
  unused?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MintFirstPartyAgentAccessTokenOutput = MintFirstPartyAgentAccessTokenPermissionDeniedError | MintFirstPartyAgentAccessTokenSuccess | MintFirstPartyAgentAccessTokenUnknownError;

export type MintFirstPartyAgentAccessTokenPermissionDeniedError = Error & {
  __typename?: 'MintFirstPartyAgentAccessTokenPermissionDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type MintFirstPartyAgentAccessTokenSuccess = {
  __typename?: 'MintFirstPartyAgentAccessTokenSuccess';
  accessTokenId: Scalars['uuid']['output'];
  audience: Scalars['String']['output'];
  expiresAt: Scalars['datetime']['output'];
  scopes: Array<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type MintFirstPartyAgentAccessTokenUnknownError = Error & {
  __typename?: 'MintFirstPartyAgentAccessTokenUnknownError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type ModernLoopStaff = {
  __typename?: 'ModernLoopStaff';
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
};

export type ModuleMemberApplicationStageInterviewLog = ModuleMemberInterview & {
  __typename?: 'ModuleMemberApplicationStageInterviewLog';
  /**  SCHEDULED, Didn't Count, COMPLETED */
  applicationStageInterview: ApplicationStageInterview;
  id: Scalars['uuid']['output'];
  /**  This is applicationStageInterviewId */
  interviewDate: Scalars['datetime']['output'];
  status: ModuleMemberInterviewStatus;
  trainingRole: TrainingStatus;
};

export type ModuleMemberInterview = {
  id: Scalars['uuid']['output'];
  interviewDate: Scalars['datetime']['output'];
  status: ModuleMemberInterviewStatus;
  trainingRole: TrainingStatus;
};

export type ModuleMemberInterviewLogInput = {
  orderBy?: InputMaybe<ModuleMemberInterviewLogOrderBy>;
  pageInput: PageInput;
  trainingRole?: InputMaybe<TrainingStatus>;
};

export type ModuleMemberInterviewLogOrderBy = {
  direction: Sort;
};

export type ModuleMemberInterviewLogOutput = {
  __typename?: 'ModuleMemberInterviewLogOutput';
  items: Array<ModuleMemberInterview>;
  nextCursor: Scalars['String']['output'];
  prevCursor: Scalars['String']['output'];
};

export enum ModuleMemberInterviewStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DidntCount = 'DIDNT_COUNT',
  Scheduled = 'SCHEDULED'
}

/** ## Extend above interface */
export type ModuleMemberManualLog = ModuleMemberInterview & {
  __typename?: 'ModuleMemberManualLog';
  id: Scalars['uuid']['output'];
  /**  This is ModuleMemberManualLogId */
  interviewDate: Scalars['datetime']['output'];
  status: ModuleMemberInterviewStatus;
  trainingRole: TrainingStatus;
};

export type ModuleSeat = {
  __typename?: 'ModuleSeat';
  interviewModule?: Maybe<InterviewModule>;
  interviewModuleId: Scalars['uuid']['output'];
  jobStageInterviewSeatAttributes?: Maybe<Array<JobStageInterviewSeatAttribute>>;
  reverseShadowConfig?: Maybe<InterviewModuleSeatConfig>;
  selectedEmployeeIds: Array<Scalars['uuid']['output']>;
  shadowConfig?: Maybe<InterviewModuleSeatConfig>;
  trainedConfig?: Maybe<InterviewModuleSeatConfig>;
  traineeRequirement?: Maybe<TraineeRequirement>;
  traineeSchedulingStrategy?: Maybe<TraineeSchedulingStrategy>;
};

/** Input for a module seat. */
export type ModuleSeatInput = {
  interviewModuleId: Scalars['uuid']['input'];
  jobStageInterviewSeatAttributes?: InputMaybe<Array<JobStageInterviewSeatAttributeInput>>;
  reverseShadowConfig?: InputMaybe<InterviewModuleSeatConfigInput>;
  selectedEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  shadowConfig?: InputMaybe<InterviewModuleSeatConfigInput>;
  trainedConfig?: InputMaybe<InterviewModuleSeatConfigInput>;
  traineeRequirement?: InputMaybe<TraineeRequirement>;
  traineeSchedulingStrategy?: InputMaybe<TraineeSchedulingStrategy>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a new activity note. */
  activityNoteCreate?: Maybe<ActivityNoteCreateResult>;
  /** Deletes an activity note. */
  activityNoteDelete?: Maybe<ActivityNoteDeleteResult>;
  /** Edits an existing activity note. */
  activityNoteEdit?: Maybe<ActivityNoteEditResult>;
  /** Rename an Agent thread owned by the authenticated employee. */
  agentThreadRename: AgentThreadRenameOutput;
  /**
   * Returns the provider consent URL that connects a Google or Microsoft account for the
   * organization's AI agent. The resolver reads the agent employee from the AI agent email
   * organization setting, so a caller cannot target another employee.
   */
  aiAgentIntegrationConnect: AiAgentIntegrationConnectOutput;
  /**
   * Deletes the agent employee's Google or Microsoft tokens. The agent then cannot read or write
   * that provider's calendars and mail until an administrator connects it again.
   */
  aiAgentIntegrationDisconnect: AiAgentIntegrationDisconnectOutput;
  /** Deletes scoped AI instructions. */
  aiInstructionDelete: EmptyResult;
  /** Creates or updates scoped AI instructions. */
  aiInstructionUpsert: AiInstruction;
  /** Creates a new scoped AI memory entry. */
  aiMemoryCreate: AiMemory;
  /** Deletes a scoped AI memory entry. */
  aiMemoryDelete: EmptyResult;
  /** Updates an existing scoped AI memory entry. */
  aiMemoryUpdate: AiMemory;
  /** Creates a new candidate portal note for an application. */
  applicationCandidatePortalNoteCreate: CandidatePortalNote;
  /** Deletes a candidate portal note for an application. */
  applicationCandidatePortalNoteDelete: EmptyResult;
  /** Updates an existing candidate portal note for an application. */
  applicationCandidatePortalNoteUpdate: CandidatePortalNote;
  /** Updates an interviewer for an application stage interview. */
  applicationStageInterviewInterviewerUpdate?: Maybe<ApplicationStageInterviewInterviewerResult>;
  /** Upserts an interviewer for an application stage interview. */
  applicationStageInterviewInterviewerUpsert?: Maybe<ApplicationStageInterviewInterviewerResult>;
  /** Updates an application's information. */
  applicationUpdate: Application;
  /**
   * Updates the ATS job sync scope and starts a full synchronization. Requires an active Greenhouse
   * V3 connection.
   */
  atsJobSyncScopeUpdate: AtsJobSyncScopeUpdateOutput;
  /** Updates the association between an ATS user and an employee. */
  atsUserEmployeeAssociationUpdate?: Maybe<AtsUserEmployeeAssociationUpdateResult>;
  /** Upserts attribute values for multiple employees. */
  attributeValueEmployeesUpsert?: Maybe<Array<EmployeeUpdateResult>>;
  /** Creates a new branding theme. */
  brandingThemeCreate: BrandingThemeResult;
  /** Deletes a branding theme. */
  brandingThemeDelete: EmptyResult;
  /** Updates an existing branding theme. */
  brandingThemeUpdate: BrandingThemeResult;
  /** Creates a new calendar meeting. */
  calendarMeetingCreate?: Maybe<GoogleMeetingResult>;
  /** Anonymizes a candidate's information. */
  candidateAnonymize: EmptyResult;
  /** Deletes candidate availability options. */
  candidateAvailabilityOptionsDelete?: Maybe<EmptyResult>;
  /** Upserts candidate availability options. */
  candidateAvailabilityOptionsUpsert?: Maybe<CandidateAvailabilityOptionsUpsertResult>;
  /** Anonymizes multiple candidates' information. */
  candidateBulkAnonymize: CandidateBulkAnonymizeResult;
  /** De-anonymizes a candidate's information. */
  candidateDeAnonymize: EmptyResult;
  /** Deletes a candidate pulse tag. */
  candidatePulseTagDelete: EmptyResult;
  /**
   * Upserts candidate pulse tags.
   * This can include adding a new tag, updating some fields of an existing tag, and archiving a tag.
   * This method will delete any tags (of the same type) not included in the input.
   */
  candidatePulseTagUpsert: EmptyResult;
  /** Updates a candidate's information. */
  candidateUpdate: CandidateUpdateResult;
  /** Checks if the user has permission to create a candidate. */
  checkCreateCandidatePermission: CheckCreateCandidatePermissionResult;
  /** Creates a new collaboration link. */
  collaborationLinkCreate: CollaborationLinkCreateResult;
  /** Creates a new company holiday. */
  companyHolidayCreate?: Maybe<CompanyHolidayUpsertResult>;
  /** Deletes a company holiday. */
  companyHolidayDelete?: Maybe<CompanyHolidayDeleteResult>;
  /** Updates an existing company holiday. */
  companyHolidayUpdate?: Maybe<CompanyHolidayUpsertResult>;
  /** Upsert content translations for an entity in a given locale. */
  contentTranslationUpsert: ContentTranslationUpsertOutput;
  /** Creates an external API token tied to the authenticated acting user account. */
  createExternalApiToken: CreateExternalApiTokenPayload;
  /** Deletes a custom job stage interview plan. */
  customJobStageInterviewPlanDelete?: Maybe<CustomJobStageInterviewPlanResult>;
  /** Performs a bulk upsert of employee attributes. */
  employeeAttributeBulkUpsert?: Maybe<EmptyResult>;
  /** Creates a new employee attribute name. */
  employeeAttributeNameCreate?: Maybe<EmployeeAttributeName>;
  /** Deletes an employee attribute name. */
  employeeAttributeNameDelete?: Maybe<Id>;
  /** Updates an existing employee attribute name. */
  employeeAttributeNameUpdate?: Maybe<EmployeeAttributeName>;
  /** Creates new employee attribute values. */
  employeeAttributeValueCreate?: Maybe<Array<EmployeeAttributeTagValue>>;
  /** Deletes an employee attribute value. */
  employeeAttributeValueDelete?: Maybe<Id>;
  /** Updates existing employee attribute values. */
  employeeAttributeValueUpdate?: Maybe<Array<EmployeeAttributeTagValue>>;
  /** Upserts employee attributes. */
  employeeAttributesUpsert?: Maybe<EmployeeUpdateResult>;
  /** Performs a bulk update of employee attributes for all employees. */
  employeeBulkUpdate?: Maybe<EmptyResult>;
  /** Performs a bulk upsert of employee data. */
  employeeDataBulkUpsert?: Maybe<EmptyResult>;
  /** Updates employee notification preferences. */
  employeeNotificationPrefUpdate?: Maybe<EmployeeNotificationPrefUpdateResult>;
  /** Creates a new employee planned availability. */
  employeePlannedAvailabilityCreate: EmployeePlannedAvailabilityResult;
  /** Deletes an employee planned availability. */
  employeePlannedAvailabilityDelete: EmptyResult;
  /** Updates an existing employee planned availability. */
  employeePlannedAvailabilityUpdate: EmployeePlannedAvailabilityResult;
  /** Updates employee preferences. */
  employeePrefUpdate?: Maybe<EmployeePrefUpdateResult>;
  /** Updates an employee's information. */
  employeeUpdate?: Maybe<EmployeeUpdateResult>;
  /** Revokes an external API token owned by the authenticated organization. */
  externalApiKeyRevoke: ExternalApiKeyRevokeOutput;
  /** Create a new API key for the org and replaces any existing one */
  generateOrgApiKey: GenerateOrgApiKeyResponse;
  /** Create a new scim token for the org and replaces any existing one */
  generateOrgScimToken: GenerateOrgScimTokenResponse;
  /**
   * Initiate a candidate data export (for DSAR compliance).
   * Accepts a query (email, phone number, or candidate ID) and emails a CSV export
   * of all candidate data to the requesting employee.
   */
  initiateCandidateDataExport: InitiateCandidateDataExportOutput;
  /**
   * Adjusts the RSVP status for an interview.
   * @deprecated Use applicationStageInterviewInterviewerUpdate instead
   */
  interviewAdjustRsvp?: Maybe<InterviewAdjustRsvpResult>;
  /** Adds members to an interview module. */
  interviewModuleAddMembers?: Maybe<InterviewModuleResult>;
  /** Creates a new interview module. */
  interviewModuleCreate?: Maybe<InterviewModuleResult>;
  /** Deletes an interview module. */
  interviewModuleDelete?: Maybe<InterviewModuleResult>;
  /** Approves an interview module member. */
  interviewModuleMemberApprove?: Maybe<InterviewModuleMemberResult>;
  /** Creates a log entry for an interview module member. */
  interviewModuleMemberLogCreate?: Maybe<InterviewModuleMemberManualLogResult>;
  /** Deletes a log entry for an interview module member. */
  interviewModuleMemberLogDelete?: Maybe<EmptyResult>;
  /** Updates a log entry for an interview module member. */
  interviewModuleMemberLogUpdate?: Maybe<InterviewModuleMemberManualLogResult>;
  /** Updates an interview module member. */
  interviewModuleMemberUpdate?: Maybe<InterviewModuleMemberResult>;
  /** Removes members from an interview module. */
  interviewModuleRemoveMembers?: Maybe<InterviewModuleResult>;
  /** Updates an existing interview module. */
  interviewModuleUpdate?: Maybe<InterviewModuleResult>;
  /** Upserts interviewer portal settings. */
  interviewerPortalSettingsUpsert: InterviewerPortalSettings;
  /** Imports job settings. */
  jobSettingsImport?: Maybe<JobSettingsImportResult>;
  /** Upserts job settings. */
  jobSettingsUpsert?: Maybe<JobSettingsUpsertResult>;
  /** Upserts a job stage interview plan. */
  jobStageInterviewPlanUpsert?: Maybe<JobStageInterviewPlanResult>;
  /** Upserts job stage settings. */
  jobStageSettingsUpsert?: Maybe<JobStageSettingsUpsertResult>;
  /** Updates a job's information. */
  jobUpdate?: Maybe<JobUpdateResult>;
  /** Mark all notifications as read for the current user. */
  markAllNotificationsRead: MarkAllNotificationsReadOutput;
  /** Mark all notifications as seen (clears the bell badge). */
  markAllNotificationsSeen: MarkAllNotificationsSeenOutput;
  /** Mark a single notification as read. */
  markNotificationRead: MarkNotificationReadOutput;
  /** Mark a single notification as unread. */
  markNotificationUnread: MarkNotificationUnreadOutput;
  /** Creates a new meeting location. */
  meetingLocationCreate?: Maybe<MeetingLocationCreateResult>;
  /** Mint a short-lived first-party agent access token for the authenticated employee. */
  mintFirstPartyAgentAccessToken: MintFirstPartyAgentAccessTokenOutput;
  /** Complete OAuth consent as an authenticated, non-impersonated scheduler. */
  oauthConsentComplete: OAuthConsentCompleteOutput;
  /** Revoke an OAuth grant owned by the authenticated organization. */
  oauthGrantRevoke: OAuthGrantRevokeOutput;
  /** Replace the additional permissions for an Organization member. */
  orgMemberSetAdditionalPermissions: OrgMemberSetAdditionalPermissionsOutput;
  /** Updates organization preferences. */
  orgPrefUpdate?: Maybe<OrgPrefUpdateResult>;
  /** Updates the organization's information. */
  orgUpdate?: Maybe<Org>;
  /** Applies an automation rule to existing unlinked jobs. */
  portalConfigAutomationRuleApply: PortalConfigAutomationRuleApplyResult;
  /** Previews how many unlinked jobs would be linked by applying an automation rule. */
  portalConfigAutomationRulePreviewApply: PortalConfigAutomationRulePreviewResult;
  /** Saves the entire portal config automation (default + all rules). Replaces existing rules. */
  portalConfigAutomationSave: PortalConfigAutomationRulesResult;
  /** Creates a new portal config. */
  portalConfigCreate: PortalConfigResult;
  /** Deletes a portal config. */
  portalConfigDelete: EmptyResult;
  /** Creates a new portal config tab. */
  portalConfigTabCreate: PortalConfigTabResult;
  /** Deletes a portal config tab. */
  portalConfigTabDelete: EmptyResult;
  /** Updates an existing portal config tab. */
  portalConfigTabUpdate: PortalConfigTabResult;
  /** Updates an existing portal config. */
  portalConfigUpdate: PortalConfigResult;
  /** Deletes portal job options. */
  portalJobOptionsDelete: EmptyResult;
  /** Links a job's portal options to a portal config. */
  portalJobOptionsLinkToConfig: EmptyResult;
  /** Unlinks a job's portal options from its current portal config, snapshotting the config tabs. */
  portalJobOptionsUnlinkFromConfig: EmptyResult;
  /** Upserts portal job options. */
  portalJobOptionsUpsert: PortalJobOptionsResult;
  /** Creates a new portal slug for the organization. */
  portalSlugCreate?: Maybe<PortalOrgSlug>;
  /** Creates a new portal template. */
  portalTemplateCreate: PortalTemplateResult;
  /** Deletes a portal template. */
  portalTemplateDelete: EmptyResult;
  /** Updates an existing portal template. */
  portalTemplateUpdate: PortalTemplateResult;
  /** Pushes a schedule to the ATS, creating, updating, or canceling interviews as needed. */
  pushScheduleToAts: PushScheduleToAtsResult;
  /** Records the privacy access entry before the client saves a CSV. */
  recordDataDownload: RecordDataDownloadOutput;
  /** Creates a new reschedule log entry. */
  rescheduleLogCreate?: Maybe<RescheduleLogResult>;
  /** Deletes a reschedule log entry. */
  rescheduleLogDelete?: Maybe<EmptyResult>;
  /** Updates an existing reschedule log entry. */
  rescheduleLogUpdate?: Maybe<RescheduleLogResult>;
  /** Creates a new reschedule reason. */
  rescheduleReasonCreate?: Maybe<RescheduleReasonUpsertResult>;
  /** Updates an existing reschedule reason. */
  rescheduleReasonUpdate?: Maybe<RescheduleReasonUpsertResult>;
  /** Resets a job stage to use the ATS interview plan. */
  resetJobStageToAtsInterviewPlan?: Maybe<JobStageInterviewPlanResult>;
  /** Queues an immediate retry of a schedule task's failed external-object syncs (e.g. ATS interviews). */
  retryExternalObjectSync: RetryExternalObjectSyncResult;
  /** Cancels a schedule. */
  scheduleCancel?: Maybe<EmptyResult>;
  /** Creates a new schedule. */
  scheduleCreate?: Maybe<ScheduleCreateResult>;
  /** Reschedules an existing schedule. */
  scheduleReschedule?: Maybe<ScheduleRescheduleResult>;
  /** Deletes self-schedule options. */
  selfScheduleOptionsDelete?: Maybe<SelfScheduleOptionsDeleteInput>;
  /** Upserts self-schedule options. */
  selfScheduleOptionsUpsert?: Maybe<SelfScheduleOptions>;
  /** Creates a short URL. */
  shortUrlCreate?: Maybe<ShortUrlCreateResult>;
  /** Creates a new sourcing link. */
  sourcingLinkCreate: SourcingLinkResult;
  /** Deletes a sourcing link. */
  sourcingLinkDelete: EmptyResult;
  /** Updates an existing sourcing link. */
  sourcingLinkUpdate: SourcingLinkResult;
  /** Adds a subscriber. */
  subscriberAdd?: Maybe<SubscriberAddResult>;
  /** Removes a subscriber. */
  subscriberRemove?: Maybe<SubscriberRemoveResult>;
  /**
   * Makes one of the acting user's Organization Memberships their Active Organization. The user is
   * taken from the request, never from the input, so this moves the caller and nobody else. Every
   * role may switch, so it asks only for CAN_INTERVIEW.
   *
   * A staffer impersonating a customer must not move that customer's own selection. The refusal
   * is the store's, not the directive's: @allowOnImpersonation lets an impersonated request through
   * to OrgEmployeeStore.switchActiveOrganization, which answers with
   * SwitchActiveOrganizationNotAllowedWhileImpersonatingError and its localized message instead of
   * a bare permission error. The store never stamps a Membership while impersonating, so the
   * directive here widens what the client can read, never what the server will do.
   */
  switchActiveOrganization: SwitchActiveOrganizationOutput;
  /**
   * Enqueues an immediate re-sync of a single application from the connected ATS. Gated behind the
   * ORG_MANUAL_ENTITY_SYNC feature flag and debounced by a per-application cooldown (ENG-26264).
   */
  syncApplication: SyncApplicationOutput;
  /**
   * Enqueues an immediate re-sync of a single candidate from the connected ATS. Gated behind the
   * ORG_MANUAL_ENTITY_SYNC feature flag and debounced by a per-candidate cooldown (ENG-26264).
   */
  syncCandidate: SyncCandidateOutput;
  /**
   * Enqueues an immediate re-sync of an employee's linked ATS user record from the connected ATS.
   * Gated behind the ORG_MANUAL_ENTITY_SYNC feature flag and debounced by a per-employee cooldown
   * (ENG-26267). Employee ATS association is an org-admin concern rather than a scheduling one, so
   * this requires CAN_MANAGE_ORG_SETTINGS rather than the CAN_SCHEDULE used by the other "Sync
   * <Entity>" mutations.
   */
  syncEmployeeAts: SyncEmployeeAtsOutput;
  /**
   * Enqueues an immediate re-sync of an employee's calendar (Google/Outlook). Gated behind the
   * ORG_MANUAL_ENTITY_SYNC feature flag and debounced by a per-employee cooldown (ENG-26263).
   */
  syncEmployeeCalendar: SyncEmployeeCalendarOutput;
  /**
   * Enqueues an immediate re-sync of a single job from the connected ATS. Gated behind the
   * ORG_MANUAL_ENTITY_SYNC feature flag and debounced by a per-job cooldown (ENG-26265).
   */
  syncJob: SyncJobOutput;
  /**
   * Enqueues an immediate re-sync of a job stage's parent job's stages from the connected ATS.
   * Gated behind the ORG_MANUAL_ENTITY_SYNC feature flag and debounced by a per-job-stage
   * cooldown (ENG-26266).
   */
  syncJobStage: SyncJobStageOutput;
  /**
   * Enqueues an immediate scoped re-sync of user job permissions for an employee from Greenhouse V3.
   * Gated behind ORG_MANUAL_ENTITY_SYNC and debounced by a per-employee cooldown (FEAT-1721).
   */
  syncUserJobPermissionsForEmployee: SyncUserJobPermissionsForEmployeeOutput;
  /**
   * Enqueues an immediate scoped re-sync of user job permissions for a job from Greenhouse V3. Gated
   * behind ORG_MANUAL_ENTITY_SYNC and debounced by a per-job cooldown (FEAT-1721).
   */
  syncUserJobPermissionsForJob: SyncUserJobPermissionsForJobOutput;
  /**
   * Cancels a task.
   * If there is a self-schedule request it is closed.
   * If there is an availability request it is closed.
   * If there is a schedule it is canceled.
   * If there is a debrief it is canceled.
   */
  taskCancel: Task;
  /** Creates a new task. */
  taskCreate?: Maybe<TaskCreateResult>;
  /** Creates a task delegated to the AI agent. */
  taskCreateWithAgentDelegate: TaskCreateWithAgentDelegateResult;
  /** Marks a task flag as resolved. */
  taskFlagMarkResolved: TaskFlagMarkResolvedResult;
  /**
   * Pokes the AI agent on an agent-delegated task: resets the delegate status to QUEUED (from any
   * state, including a wedged ACTIVE turn or STOPPED) and immediately re-queues an agent start.
   * Writes no activity-log entry, so the poke leaves no visible artifact in the task feed.
   */
  taskPokeAgent: TaskPokeAgentOutput;
  /** Creates a new task queue. */
  taskQueueCreate?: Maybe<TaskQueueCreateOutput>;
  /** Deletes a task queue. */
  taskQueueDelete?: Maybe<TaskQueueDeleteResult>;
  /** Updates an existing task queue. */
  taskQueueUpdate?: Maybe<TaskQueueUpdateOutput>;
  /** Quickly creates a new task. */
  taskQuickCreate: TaskQuickCreateResult;
  /** Requests a change for a task. */
  taskRequestChange: TaskRequestChangeResult;
  /** Sets or unsets the assignee. */
  taskSetAssignee: Task;
  /** Set whether or not a debrief will be required for the task to be considered complete. */
  taskSetDebriefRequired: Task;
  /** Sets the delegate type on a task (e.g. "AGENT" or empty string to unset). */
  taskSetDelegate: Task;
  /** Sets the task as urgent or not. */
  taskSetIsUrgent: Task;
  /** Set the tags on a task. All tags must be sent, this is a full replace. */
  taskSetTags: Task;
  /** Sets or unsets the task queue. */
  taskSetTaskQueue: Task;
  /** Stops the AI agent on a task. Sets delegate status to STOPPED. */
  taskStopAgent: TaskStopAgentOutput;
  /** Creates a new task tag. */
  taskTagCreate?: Maybe<TaskTagCreateOutput>;
  /** Deletes a task tag. */
  taskTagDelete?: Maybe<TaskTagDeleteOutput>;
  /** Updates an existing task tag. */
  taskTagUpdate?: Maybe<TaskTagUpdateOutput>;
  /**
   * Updates fields on a task.
   *
   * IMPORTANT: Only one field can be set at a time.
   * @deprecated Use field specific mutations instead
   */
  taskUpdate: Task;
  /** Creates a new template. */
  templateCreate?: Maybe<TemplateResult>;
  /** Deletes a template. */
  templateDelete?: Maybe<TemplateResult>;
  /** Updates an existing template. */
  templateUpdate?: Maybe<TemplateResult>;
  /** Accept tos for current user */
  tosAccept?: Maybe<EmptyResult>;
  /** Sends a training feedback reminder nag. */
  trainingFeedbackReminderNag?: Maybe<InterviewModuleMemberResult>;
  /** Updates a user's information. */
  userUpdate?: Maybe<UserUpdateResult>;
  /** Bulk invites users to the organization by email + role. */
  usersInvite?: Maybe<UsersInviteResult>;
  /** Creates a new Zoom meeting. */
  zoomMeetingCreate?: Maybe<ZoomMeetingCreateResult>;
  /** Updates a Zoom meeting. */
  zoomMeetingUpdate?: Maybe<ZoomMeetingResult>;
  /** Delete max concurrent meetings entry for zoom hosts */
  zoomUserConcurrentMeetingsDelete: EmptyResult;
  /** Set max concurrent meetings for zoom hosts */
  zoomUserConcurrentMeetingsPut: EmptyResult;
  /** Update max concurrent meetings for zoom hosts */
  zoomUserConcurrentMeetingsUpdate: EmptyResult;
};


export type MutationActivityNoteCreateArgs = {
  input: ActivityNoteCreateInput;
};


export type MutationActivityNoteDeleteArgs = {
  input: ActivityNoteDeleteInput;
};


export type MutationActivityNoteEditArgs = {
  input: ActivityNoteEditInput;
};


export type MutationAgentThreadRenameArgs = {
  input: AgentThreadRenameInput;
};


export type MutationAiAgentIntegrationConnectArgs = {
  input: AiAgentIntegrationConnectInput;
};


export type MutationAiAgentIntegrationDisconnectArgs = {
  input: AiAgentIntegrationDisconnectInput;
};


export type MutationAiInstructionDeleteArgs = {
  input: AiInstructionDeleteInput;
};


export type MutationAiInstructionUpsertArgs = {
  input: AiInstructionUpsertInput;
};


export type MutationAiMemoryCreateArgs = {
  input: AiMemoryCreateInput;
};


export type MutationAiMemoryDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationAiMemoryUpdateArgs = {
  input: AiMemoryUpdateInput;
};


export type MutationApplicationCandidatePortalNoteCreateArgs = {
  input: ApplicationCandidatePortalNoteCreateInput;
};


export type MutationApplicationCandidatePortalNoteDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationApplicationCandidatePortalNoteUpdateArgs = {
  input: ApplicationCandidatePortalNoteUpdateInput;
};


export type MutationApplicationStageInterviewInterviewerUpdateArgs = {
  input: ApplicationStageInterviewInterviewerUpdateInput;
};


export type MutationApplicationStageInterviewInterviewerUpsertArgs = {
  input: ApplicationStageInterviewInterviewerUpsertInput;
};


export type MutationApplicationUpdateArgs = {
  input: ApplicationUpdateInput;
};


export type MutationAtsJobSyncScopeUpdateArgs = {
  input: AtsJobSyncScopeUpdateInput;
};


export type MutationAtsUserEmployeeAssociationUpdateArgs = {
  input: AtsUserEmployeeAssociationUpdateInput;
};


export type MutationAttributeValueEmployeesUpsertArgs = {
  input: AttributeValueEmployeesInput;
};


export type MutationBrandingThemeCreateArgs = {
  input: BrandingThemeCreateInput;
};


export type MutationBrandingThemeDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationBrandingThemeUpdateArgs = {
  input: BrandingThemeUpdateInput;
};


export type MutationCalendarMeetingCreateArgs = {
  input: CalendarMeetingCreateInput;
};


export type MutationCandidateAnonymizeArgs = {
  input: CandidateAnonymizeInput;
};


export type MutationCandidateAvailabilityOptionsDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationCandidateAvailabilityOptionsUpsertArgs = {
  input: CandidateAvailabilityOptionsUpsertInput;
};


export type MutationCandidateBulkAnonymizeArgs = {
  input: CandidateBulkAnonymizeInput;
};


export type MutationCandidateDeAnonymizeArgs = {
  input: CandidateDeAnonymizeInput;
};


export type MutationCandidatePulseTagDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationCandidatePulseTagUpsertArgs = {
  input: CandidatePulseTagUpsertInput;
};


export type MutationCandidateUpdateArgs = {
  input: CandidateUpdateInput;
};


export type MutationCheckCreateCandidatePermissionArgs = {
  input: CheckCreateCandidatePermissionInput;
};


export type MutationCollaborationLinkCreateArgs = {
  input: CollaborationLinkCreateInput;
};


export type MutationCompanyHolidayCreateArgs = {
  input: CompanyHolidayCreateInput;
};


export type MutationCompanyHolidayDeleteArgs = {
  input: CompanyHolidayDeleteInput;
};


export type MutationCompanyHolidayUpdateArgs = {
  input: CompanyHolidayUpdateInput;
};


export type MutationContentTranslationUpsertArgs = {
  input: ContentTranslationUpsertInput;
};


export type MutationCreateExternalApiTokenArgs = {
  input: CreateExternalApiTokenInput;
};


export type MutationCustomJobStageInterviewPlanDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationEmployeeAttributeBulkUpsertArgs = {
  input: EmployeeAttributeBulkUpsertInput;
};


export type MutationEmployeeAttributeNameCreateArgs = {
  input: EmployeeAttributeNameCreateInput;
};


export type MutationEmployeeAttributeNameDeleteArgs = {
  input: EmployeeAttributeNameDeleteInput;
};


export type MutationEmployeeAttributeNameUpdateArgs = {
  input: EmployeeAttributeNameUpdateInput;
};


export type MutationEmployeeAttributeValueCreateArgs = {
  input: EmployeeAttributeValueCreateInput;
};


export type MutationEmployeeAttributeValueDeleteArgs = {
  input: EmployeeAttributeValueDeleteInput;
};


export type MutationEmployeeAttributeValueUpdateArgs = {
  input: EmployeeAttributeValueUpdateInput;
};


export type MutationEmployeeAttributesUpsertArgs = {
  input: EmployeeAttributesInput;
};


export type MutationEmployeeBulkUpdateArgs = {
  input: EmployeeBulkUpdateInput;
};


export type MutationEmployeeDataBulkUpsertArgs = {
  input: EmployeeDataBulkUpsertInput;
};


export type MutationEmployeeNotificationPrefUpdateArgs = {
  input: EmployeeNotificationPrefUpdateInput;
};


export type MutationEmployeePlannedAvailabilityCreateArgs = {
  input: EmployeePlannedAvailabilityCreateInput;
};


export type MutationEmployeePlannedAvailabilityDeleteArgs = {
  input: EmployeePlannedAvailabilityDeleteInput;
};


export type MutationEmployeePlannedAvailabilityUpdateArgs = {
  input: EmployeePlannedAvailabilityUpdateInput;
};


export type MutationEmployeePrefUpdateArgs = {
  input: EmployeePrefUpdateInput;
};


export type MutationEmployeeUpdateArgs = {
  input: EmployeeUpdateInput;
};


export type MutationExternalApiKeyRevokeArgs = {
  input: ExternalApiKeyRevokeInput;
};


export type MutationInitiateCandidateDataExportArgs = {
  input: InitiateCandidateDataExportInput;
};


export type MutationInterviewAdjustRsvpArgs = {
  input: InterviewAdjustRsvpInput;
};


export type MutationInterviewModuleAddMembersArgs = {
  input: InterviewModuleAddMembersInput;
};


export type MutationInterviewModuleCreateArgs = {
  input: InterviewModuleCreateInput;
};


export type MutationInterviewModuleDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationInterviewModuleMemberApproveArgs = {
  input: InterviewModuleMemberApproveInput;
};


export type MutationInterviewModuleMemberLogCreateArgs = {
  input: InterviewModuleMemberLogCreateInput;
};


export type MutationInterviewModuleMemberLogDeleteArgs = {
  input: InterviewModuleMemberLogDeleteInput;
};


export type MutationInterviewModuleMemberLogUpdateArgs = {
  input: InterviewModuleMemberLogUpdateInput;
};


export type MutationInterviewModuleMemberUpdateArgs = {
  input: InterviewModuleMemberUpdateInput;
};


export type MutationInterviewModuleRemoveMembersArgs = {
  input: InterviewModuleRemoveMembersInput;
};


export type MutationInterviewModuleUpdateArgs = {
  input: InterviewModuleUpdateInput;
};


export type MutationInterviewerPortalSettingsUpsertArgs = {
  input: InterviewerPortalSettingsUpsertInput;
};


export type MutationJobSettingsImportArgs = {
  input: JobSettingsImportInput;
};


export type MutationJobSettingsUpsertArgs = {
  input: JobSettingsUpsertInput;
};


export type MutationJobStageInterviewPlanUpsertArgs = {
  input: JobStageInterviewPlanUpsertInput;
};


export type MutationJobStageSettingsUpsertArgs = {
  input: JobStageSettingsUpsertInput;
};


export type MutationJobUpdateArgs = {
  input: JobUpdateInput;
};


export type MutationMarkNotificationReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMarkNotificationUnreadArgs = {
  input: MarkNotificationUnreadInput;
};


export type MutationMeetingLocationCreateArgs = {
  input: MeetingLocationCreateInput;
};


export type MutationMintFirstPartyAgentAccessTokenArgs = {
  input: MintFirstPartyAgentAccessTokenInput;
};


export type MutationOauthConsentCompleteArgs = {
  input: OAuthConsentCompleteInput;
};


export type MutationOauthGrantRevokeArgs = {
  input: OAuthGrantRevokeInput;
};


export type MutationOrgMemberSetAdditionalPermissionsArgs = {
  input: OrgMemberSetAdditionalPermissionsInput;
};


export type MutationOrgPrefUpdateArgs = {
  input: OrgPrefUpdateInput;
};


export type MutationOrgUpdateArgs = {
  input: OrgUpdateInput;
};


export type MutationPortalConfigAutomationRuleApplyArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationPortalConfigAutomationRulePreviewApplyArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationPortalConfigAutomationSaveArgs = {
  input: PortalConfigAutomationSaveInput;
};


export type MutationPortalConfigCreateArgs = {
  input: PortalConfigCreateInput;
};


export type MutationPortalConfigDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationPortalConfigTabCreateArgs = {
  input: PortalConfigTabCreateInput;
};


export type MutationPortalConfigTabDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationPortalConfigTabUpdateArgs = {
  input: PortalConfigTabUpdateInput;
};


export type MutationPortalConfigUpdateArgs = {
  input: PortalConfigUpdateInput;
};


export type MutationPortalJobOptionsDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationPortalJobOptionsLinkToConfigArgs = {
  input: PortalJobOptionsLinkToConfigInput;
};


export type MutationPortalJobOptionsUnlinkFromConfigArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationPortalJobOptionsUpsertArgs = {
  input: PortalJobOptionsUpsertInput;
};


export type MutationPortalSlugCreateArgs = {
  input: PortalSlugCreateInput;
};


export type MutationPortalTemplateCreateArgs = {
  input: PortalTemplateCreateInput;
};


export type MutationPortalTemplateDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationPortalTemplateUpdateArgs = {
  input: PortalTemplateUpdateInput;
};


export type MutationPushScheduleToAtsArgs = {
  input: PushScheduleToAtsInput;
};


export type MutationRecordDataDownloadArgs = {
  input: RecordDataDownloadInput;
};


export type MutationRescheduleLogCreateArgs = {
  input: RescheduleLogCreateInput;
};


export type MutationRescheduleLogDeleteArgs = {
  input: RescheduleLogDeleteInput;
};


export type MutationRescheduleLogUpdateArgs = {
  input: RescheduleLogUpdateInput;
};


export type MutationRescheduleReasonCreateArgs = {
  input: RescheduleReasonCreateInput;
};


export type MutationRescheduleReasonUpdateArgs = {
  input: RescheduleReasonUpdateInput;
};


export type MutationResetJobStageToAtsInterviewPlanArgs = {
  input: ResetJobStageToAtsInterviewPlanInput;
};


export type MutationRetryExternalObjectSyncArgs = {
  input: RetryExternalObjectSyncInput;
};


export type MutationScheduleCancelArgs = {
  input: ScheduleCancelInput;
};


export type MutationScheduleCreateArgs = {
  input: ScheduleCreateInput;
};


export type MutationScheduleRescheduleArgs = {
  input: ScheduleRescheduleInput;
};


export type MutationSelfScheduleOptionsDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationSelfScheduleOptionsUpsertArgs = {
  input: SelfScheduleOptionsUpsertInput;
};


export type MutationShortUrlCreateArgs = {
  input: ShortUrlCreateInput;
};


export type MutationSourcingLinkCreateArgs = {
  input: SourcingLinkCreateInput;
};


export type MutationSourcingLinkDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationSourcingLinkUpdateArgs = {
  input: SourcingLinkUpdateInput;
};


export type MutationSubscriberAddArgs = {
  input: SubscriberAddInput;
};


export type MutationSubscriberRemoveArgs = {
  input: SubscriberRemoveInput;
};


export type MutationSwitchActiveOrganizationArgs = {
  input: SwitchActiveOrganizationInput;
};


export type MutationSyncApplicationArgs = {
  input: SyncApplicationInput;
};


export type MutationSyncCandidateArgs = {
  input: SyncCandidateInput;
};


export type MutationSyncEmployeeAtsArgs = {
  input: SyncEmployeeAtsInput;
};


export type MutationSyncEmployeeCalendarArgs = {
  input: SyncEmployeeCalendarInput;
};


export type MutationSyncJobArgs = {
  input: SyncJobInput;
};


export type MutationSyncJobStageArgs = {
  input: SyncJobStageInput;
};


export type MutationSyncUserJobPermissionsForEmployeeArgs = {
  input: SyncUserJobPermissionsForEmployeeInput;
};


export type MutationSyncUserJobPermissionsForJobArgs = {
  input: SyncUserJobPermissionsForJobInput;
};


export type MutationTaskCancelArgs = {
  input: TaskCancelInput;
};


export type MutationTaskCreateArgs = {
  input: TaskCreateInput;
};


export type MutationTaskCreateWithAgentDelegateArgs = {
  input: TaskCreateWithAgentDelegateInput;
};


export type MutationTaskFlagMarkResolvedArgs = {
  input: TaskFlagMarkResolvedInput;
};


export type MutationTaskPokeAgentArgs = {
  input: TaskPokeAgentInput;
};


export type MutationTaskQueueCreateArgs = {
  input: TaskQueueCreateInput;
};


export type MutationTaskQueueDeleteArgs = {
  input: TaskQueueDeleteInput;
};


export type MutationTaskQueueUpdateArgs = {
  input: TaskQueueUpdateInput;
};


export type MutationTaskQuickCreateArgs = {
  input: TaskQuickCreateInput;
};


export type MutationTaskRequestChangeArgs = {
  input: TaskRequestChangeInput;
};


export type MutationTaskSetAssigneeArgs = {
  input: TaskSetAssigneeInput;
};


export type MutationTaskSetDebriefRequiredArgs = {
  input: TaskSetDebriefRequiredInput;
};


export type MutationTaskSetDelegateArgs = {
  input: TaskSetDelegateInput;
};


export type MutationTaskSetIsUrgentArgs = {
  input: TaskSetIsUrgentInput;
};


export type MutationTaskSetTagsArgs = {
  input: TaskSetTagsInput;
};


export type MutationTaskSetTaskQueueArgs = {
  input: TaskSetTaskQueueInput;
};


export type MutationTaskStopAgentArgs = {
  input: TaskStopAgentInput;
};


export type MutationTaskTagCreateArgs = {
  input: TaskTagCreateInput;
};


export type MutationTaskTagDeleteArgs = {
  input: TaskTagDeleteInput;
};


export type MutationTaskTagUpdateArgs = {
  input: TaskTagUpdateInput;
};


export type MutationTaskUpdateArgs = {
  input: TaskUpdateInput;
};


export type MutationTemplateCreateArgs = {
  input: TemplateCreateInput;
};


export type MutationTemplateDeleteArgs = {
  id: Scalars['uuid']['input'];
};


export type MutationTemplateUpdateArgs = {
  input: TemplateUpdateInput;
};


export type MutationTrainingFeedbackReminderNagArgs = {
  input: TrainingFeedbackReminderNagInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationUsersInviteArgs = {
  input: UsersInviteInput;
};


export type MutationZoomMeetingCreateArgs = {
  input: ZoomMeetingCreateInput;
};


export type MutationZoomMeetingUpdateArgs = {
  input: ZoomMeetingUpdateInput;
};


export type MutationZoomUserConcurrentMeetingsDeleteArgs = {
  input: ZoomUserConcurrentMeetingsDeleteInput;
};


export type MutationZoomUserConcurrentMeetingsPutArgs = {
  input: ZoomUserConcurrentMeetingsPutInput;
};


export type MutationZoomUserConcurrentMeetingsUpdateArgs = {
  input: ZoomUserConcurrentMeetingsUpdateInput;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  dynamicAudiences?: Maybe<Array<DynamicAudience>>;
  employeeIds?: Maybe<Array<Scalars['uuid']['output']>>;
  employees: Array<Employee>;
  externalEmailAddresses?: Maybe<Array<Scalars['String']['output']>>;
};

export type NotificationPreferenceInput = {
  dynamicAudiences?: InputMaybe<Array<DynamicAudience>>;
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  externalEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OAuthConnectedAppGrant = {
  __typename?: 'OAuthConnectedAppGrant';
  actingEmployeeName: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  createdAt: Scalars['datetime']['output'];
  grantId: Scalars['uuid']['output'];
  lastUsedAt?: Maybe<Scalars['datetime']['output']>;
  scopes: Array<Scalars['String']['output']>;
  status: OAuthConnectedAppGrantStatus;
};

export enum OAuthConnectedAppGrantStatus {
  Active = 'ACTIVE',
  Revoked = 'REVOKED'
}

export type OAuthConnectedAppsFilters = {
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Input for listing OAuth applications connected to the authenticated organization. */
export type OAuthConnectedAppsInput = {
  filters?: InputMaybe<OAuthConnectedAppsFilters>;
};

export type OAuthConsentCompleteInput = {
  authorizationRequestId: Scalars['String']['input'];
  decision: OAuthConsentDecision;
  organizationId: Scalars['uuid']['input'];
};

export type OAuthConsentCompleteOutput = {
  __typename?: 'OAuthConsentCompleteOutput';
  handoffPath: Scalars['String']['output'];
};

export enum OAuthConsentDecision {
  Approve = 'APPROVE',
  Deny = 'DENY'
}

export type OAuthConsentInput = {
  authorizationRequestId: Scalars['String']['input'];
};

export type OAuthConsentOrganization = {
  __typename?: 'OAuthConsentOrganization';
  displayName: Scalars['String']['output'];
  organizationId: Scalars['uuid']['output'];
};

export type OAuthConsentProjection = {
  __typename?: 'OAuthConsentProjection';
  applicationName: Scalars['String']['output'];
  eligibleOrganizations: Array<OAuthConsentOrganization>;
  expiresAt: Scalars['datetime']['output'];
  redirectHost: Scalars['String']['output'];
  requestedScopes: Array<Scalars['String']['output']>;
  verifiedClientName: Scalars['String']['output'];
};

export type OAuthConsentResult = {
  __typename?: 'OAuthConsentResult';
  projection?: Maybe<OAuthConsentProjection>;
  status: OAuthConsentStatus;
  verifiedClientName?: Maybe<Scalars['String']['output']>;
};

export enum OAuthConsentStatus {
  AlreadyConsumed = 'ALREADY_CONSUMED',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Ready = 'READY'
}

export type OAuthGrantRevokeFailureAlreadyRevoked = Error & {
  __typename?: 'OAuthGrantRevokeFailureAlreadyRevoked';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type OAuthGrantRevokeFailureNotFound = Error & {
  __typename?: 'OAuthGrantRevokeFailureNotFound';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type OAuthGrantRevokeInput = {
  grantId: Scalars['uuid']['input'];
};

export type OAuthGrantRevokeOutput = OAuthGrantRevokeFailureAlreadyRevoked | OAuthGrantRevokeFailureNotFound | OAuthGrantRevokeSuccess | UnknownError;

export type OAuthGrantRevokeSuccess = {
  __typename?: 'OAuthGrantRevokeSuccess';
  grantId: Scalars['uuid']['output'];
};

/** ########################################################## */
export type Options = {
  __typename?: 'Options';
  advanceNoticeInHours?: Maybe<Scalars['numeric']['output']>;
  canScheduleOverAvailableKeywords: Scalars['Boolean']['output'];
  canScheduleOverFreeTime: Scalars['Boolean']['output'];
  canScheduleOverRecruitingKeywords: Scalars['Boolean']['output'];
  candidateCalendarId?: Maybe<Scalars['String']['output']>;
  candidateEmail: Scalars['String']['output'];
  candidateEventAdditionalAttendees?: Maybe<NotificationPreference>;
  customLocation?: Maybe<Scalars['String']['output']>;
  inclusionDays?: Maybe<Array<Scalars['String']['output']>>;
  interviewerCalendarId?: Maybe<Scalars['String']['output']>;
  interviewerEventAdditionalAttendees?: Maybe<NotificationPreference>;
  isPrivateCalendarEvent?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<SelfScheduleLocation>;
  meetingHost?: Maybe<SelfScheduleMeetingHost>;
  note?: Maybe<Scalars['String']['output']>;
  notificationPreference?: Maybe<SelfScheduleNotificationPreference>;
  rollingDays?: Maybe<Scalars['numeric']['output']>;
  shouldRespectLoadLimit: Scalars['Boolean']['output'];
  videoMeetingHostEmployeeId?: Maybe<Scalars['uuid']['output']>;
  zoomHost?: Maybe<SelfScheduleZoomHost>;
  zoomHostUserId?: Maybe<Scalars['String']['output']>;
};

/** ################################## */
export type OptionsInput = {
  advanceNoticeInHours?: InputMaybe<Scalars['numeric']['input']>;
  /**  Default false */
  canScheduleOverAvailableKeywords?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Default true */
  canScheduleOverFreeTime?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Default false */
  canScheduleOverRecruitingKeywords?: InputMaybe<Scalars['Boolean']['input']>;
  candidateCalendarId: Scalars['String']['input'];
  candidateEventAdditionalAttendees?: InputMaybe<NotificationPreferenceInput>;
  /** @deprecated Use parent level interviewMeetingLocationSetting */
  customLocation?: InputMaybe<Scalars['String']['input']>;
  inclusionDays?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  interviewerCalendarId: Scalars['String']['input'];
  interviewerEventAdditionalAttendees?: InputMaybe<NotificationPreferenceInput>;
  isPrivateCalendarEvent?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use parent level interviewMeetingLocationSetting */
  location?: InputMaybe<SelfScheduleLocation>;
  /** @deprecated Use parent level interviewMeetingLocationSetting */
  meetingHost?: InputMaybe<SelfScheduleMeetingHost>;
  note?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This is no longer used */
  notificationPreference?: InputMaybe<SelfScheduleNotificationPreferenceInput>;
  rollingDays?: InputMaybe<Scalars['numeric']['input']>;
  /**  default true */
  shouldRespectLoadLimit?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use parent level interviewMeetingLocationSetting */
  videoMeetingHostEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  /** @deprecated Use parent level interviewMeetingLocationSetting */
  zoomHost?: InputMaybe<SelfScheduleZoomHost>;
  /** @deprecated Use parent level interviewMeetingLocationSetting */
  zoomHostUserId?: InputMaybe<Scalars['String']['input']>;
};

/** ########################################################## */
export type Org = {
  __typename?: 'Org';
  accountExecutive?: Maybe<ModernLoopStaff>;
  activeCandidateAvailabilityLinksCount: Scalars['numeric']['output'];
  activeSelfScheduleLinksCount: Scalars['numeric']['output'];
  aiInstruction?: Maybe<AiInstruction>;
  aiMemories: Array<AiMemory>;
  apiKey?: Maybe<Scalars['String']['output']>;
  atsStatus: IntegrationConnectionStatus;
  atsType?: Maybe<AtsType>;
  authOrganizationId?: Maybe<Scalars['String']['output']>;
  canSendDebriefToAts: Scalars['Boolean']['output'];
  candidatePulseTags: CandidatePulseTags;
  collaborationToolType?: Maybe<CollaborationToolType>;
  createdAt: Scalars['datetime']['output'];
  customerSuccessManager?: Maybe<ModernLoopStaff>;
  /** The organization's default locale. */
  defaultLocale: Locale;
  directoryIntegrations: Array<OrgDirectoryIntegration>;
  directoryStatus: IntegrationConnectionStatus;
  directoryType?: Maybe<DirectoryType>;
  domain: Scalars['String']['output'];
  domains: Array<Scalars['String']['output']>;
  hasAdmin: Scalars['Boolean']['output'];
  /** Whether the organization can write calendars through its application integration. */
  hasApplicationCalendarWrite?: Maybe<Scalars['Boolean']['output']>;
  hasSamlSso: Scalars['Boolean']['output'];
  hasScim: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  integrations?: Maybe<OrgIntegrations>;
  interviewerPortalSettings: InterviewerPortalSettings;
  /** Whether product AI is enabled (AI_ENABLED feature flag and org AI on/off pref). */
  isAiEnabled: Scalars['Boolean']['output'];
  jobDepartments: Array<AutomationDepartment>;
  locations: Array<Scalars['String']['output']>;
  multiDomainEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orgPref?: Maybe<OrgPref>;
  orgPrefByNames: Array<OrgPref>;
  orgPrefs?: Maybe<Array<OrgPref>>;
  recruitingSources: Array<RecruitingSource>;
  schedulerCalendarTokenAvailable?: Maybe<Scalars['Boolean']['output']>;
  scimToken?: Maybe<Scalars['String']['output']>;
  sessionInactivityTimeout?: Maybe<Duration>;
  slugs: Array<PortalOrgSlug>;
  /** Whether the organization can accept resumes on sourcing links. */
  sourcingLinkResumeUploadEnabled: Scalars['Boolean']['output'];
  /** Locales the organization has enabled for internal localization. Always non-empty. */
  supportedLocales: Array<Locale>;
  totalEmployees: Scalars['Int']['output'];
  upcomingInterviewsCount: Scalars['numeric']['output'];
  updatedAt: Scalars['datetime']['output'];
  userInfos: UserInfoResult;
  userRoles: Array<UserRole>;
};


/** ########################################################## */
export type OrgOrgPrefArgs = {
  prefName: Scalars['String']['input'];
};


/** ########################################################## */
export type OrgOrgPrefByNamesArgs = {
  prefNames: Array<Scalars['String']['input']>;
};


/** ########################################################## */
export type OrgUserInfosArgs = {
  input: OrgUserInfoInput;
};

export type OrgDirectoryIntegration = {
  __typename?: 'OrgDirectoryIntegration';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  type: DirectoryType;
};

export type OrgIntegrations = {
  __typename?: 'OrgIntegrations';
  ashby?: Maybe<AshbyIntegration>;
  brighthire?: Maybe<BrighthireIntegration>;
  coderpad?: Maybe<CoderpadIntegration>;
  codesignal?: Maybe<CodesignalIntegration>;
  codility?: Maybe<CodilityIntegration>;
  gem?: Maybe<GemIntegration>;
  google?: Maybe<GoogleIntegration>;
  googleServiceUser?: Maybe<GoogleServiceUserIntegration>;
  /** @deprecated Always null. The Greenhouse API-key integration is retired; use greenhouseOauth. Kept so old frontend bundles that still select this field keep validating. Delete one full frontend-deploy cycle after ENG-27501 ships, once no old bundle can still be in flight. */
  greenhouse?: Maybe<GreenhouseIntegration>;
  greenhouseOauth?: Maybe<GreenhouseOAuthIntegration>;
  hackerrank?: Maybe<HackerRankIntegration>;
  id: Scalars['uuid']['output'];
  lever?: Maybe<LeverIntegration>;
  microsoft?: Maybe<MicrosoftIntegration>;
  microsoftCustom?: Maybe<MicrosoftIntegration>;
  microsoftGccHigh?: Maybe<MicrosoftGccHighIntegration>;
  microsoftServiceUser?: Maybe<MicrosoftServiceUserIntegration>;
  slack?: Maybe<SlackOrgIntegration>;
  smartRecruiters?: Maybe<SmartRecruitersIntegration>;
  workday?: Maybe<WorkdayIntegration>;
  zoom?: Maybe<ZoomIntegration>;
  zoomCustom?: Maybe<ZoomIntegration>;
};

export type OrgJsonPref = AddZoomHostAsInternalInviteePref | AiOrgCustomLlmPref | AtsJobSyncScopePref | CandidateCommunicationsSettingPref | CandidateEventAdditionalAttendeesPref | CandidateFacingHiringTeamContactInfo | CandidateFacingInterviewerInfo | ChatCommunicationsSettingPref | DateBlock | DebriefAtsWriteSettingPref | DebriefEventAdditionalAttendeesPref | DefaultCustomInterviewScheduleTokenPref | EmployeeFieldSyncSourcePref | InterviewBufferTimePref | InterviewLimit | InterviewMeetingLocationSettingPref | InterviewerEventAdditionalAttendeesPref | MinimumInterviewerLoadLimitOrgPref | NotificationPreference | PaidFeaturePreference | PortalConfigAutomationRulesPref | TimeBlockWeek;

/** Select the member and the complete replacement set of additional permissions. */
export type OrgMemberSetAdditionalPermissionsInput = {
  permissions: Array<Permission>;
  userId: Scalars['uuid']['input'];
};

/** An Interviewer cannot receive additional permissions. */
export type OrgMemberSetAdditionalPermissionsInterviewerError = Error & {
  __typename?: 'OrgMemberSetAdditionalPermissionsInterviewerError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The requested member does not exist in the Organization. */
export type OrgMemberSetAdditionalPermissionsNotFoundError = Error & {
  __typename?: 'OrgMemberSetAdditionalPermissionsNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type OrgMemberSetAdditionalPermissionsOutput = OrgMemberSetAdditionalPermissionsInterviewerError | OrgMemberSetAdditionalPermissionsNotFoundError | OrgMemberSetAdditionalPermissionsPermissionDeniedError | OrgMemberSetAdditionalPermissionsSuccess | UnknownError;

/** The Actor cannot change additional permissions. */
export type OrgMemberSetAdditionalPermissionsPermissionDeniedError = Error & {
  __typename?: 'OrgMemberSetAdditionalPermissionsPermissionDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The member profile after the additional permissions change. */
export type OrgMemberSetAdditionalPermissionsSuccess = {
  __typename?: 'OrgMemberSetAdditionalPermissionsSuccess';
  userInfo: UserInfo;
};

export type OrgPref = {
  __typename?: 'OrgPref';
  /**
   *  Derived from the backend pref registry and never persisted; read-only. Nullable so clients
   *  rolling out ahead of a pref losing its classification keep working.
   */
  audience?: Maybe<PrefAudience>;
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['datetime']['output']>;
  duration?: Maybe<Duration>;
  id: Scalars['String']['output'];
  intValue?: Maybe<Scalars['numeric']['output']>;
  isLocked: Scalars['Boolean']['output'];
  json?: Maybe<Scalars['jsonb']['output']>;
  jsonArray?: Maybe<Array<Scalars['jsonb']['output']>>;
  jsonArrayPref: Array<OrgJsonPref>;
  jsonPref?: Maybe<OrgJsonPref>;
  /** This is a computed PK */
  orgId: Scalars['uuid']['output'];
  prefName: Scalars['String']['output'];
  stringArray?: Maybe<Array<Scalars['String']['output']>>;
  stringValue?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['datetime']['output']>;
  updatedAt?: Maybe<Scalars['datetime']['output']>;
};

/** ######################################### */
export type OrgPrefUpdateInput = {
  prefName: Scalars['String']['input'];
  set?: InputMaybe<PrefSet>;
};

export type OrgPrefUpdateResult = {
  __typename?: 'OrgPrefUpdateResult';
  orgPref?: Maybe<OrgPref>;
};

export type OrgTranslationsInput = {
  category?: InputMaybe<TranslationEntityType>;
  status?: InputMaybe<TranslationStatusFilter>;
};

export type OrgTranslationsResult = {
  __typename?: 'OrgTranslationsResult';
  rows: Array<TranslationRow>;
};

/** ########################################################## */
export type OrgUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** An organization user and their optional matching employee directory record. */
export type OrgUser = {
  __typename?: 'OrgUser';
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  role: OrgUserRole;
};

export type OrgUserInfoInput = {
  pageInput: PageInput;
  query?: InputMaybe<Scalars['String']['input']>;
  requiredPermission?: InputMaybe<Permission>;
  sortBy?: InputMaybe<OrgUserInfoSortBy>;
  sortOrder?: InputMaybe<Sort>;
};

export enum OrgUserInfoSortBy {
  Email = 'EMAIL',
  Name = 'NAME',
  UserId = 'USER_ID'
}

export enum OrgUserRole {
  Admin = 'ADMIN',
  Interviewer = 'INTERVIEWER',
  Owner = 'OWNER',
  Scheduler = 'SCHEDULER'
}

export type OrganizationAiContextTarget = AiContextTarget & {
  __typename?: 'OrganizationAiContextTarget';
  id: Scalars['uuid']['output'];
  org: Org;
  type: AiContextTargetType;
};

/** One Organization the user is a member of, as an Organization switcher shows it. */
export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  /** False when that Organization holds no directory record for this user yet. */
  hasEmployee: Scalars['Boolean']['output'];
  /** True for the Membership this request resolved to. */
  isActive: Scalars['Boolean']['output'];
  /** Null when the user has never logged in to, or switched to, that Organization. */
  lastAccessedAt?: Maybe<Scalars['datetime']['output']>;
  organization: MembershipOrganization;
  role: UserRole;
};

/** Input for pagination. */
export type PageInput = {
  /** The cursor for pagination. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The limit for the number of items to return. */
  limit: Scalars['Int']['input'];
  /** The offset for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PaidFeaturePreference = {
  __typename?: 'PaidFeaturePreference';
  expireAt?: Maybe<Scalars['datetime']['output']>;
  type?: Maybe<PaidFeatureType>;
};

export enum PaidFeatureType {
  Paid = 'PAID',
  Trial = 'TRIAL'
}

export enum Permission {
  /**  keep-sorted:begin */
  CanCreateFirstPartyAccessToken = 'CAN_CREATE_FIRST_PARTY_ACCESS_TOKEN',
  CanCreateOauthAppConnection = 'CAN_CREATE_OAUTH_APP_CONNECTION',
  CanCreateThirdPartyAccessToken = 'CAN_CREATE_THIRD_PARTY_ACCESS_TOKEN',
  CanDelegateToSchedulingAgent = 'CAN_DELEGATE_TO_SCHEDULING_AGENT',
  CanInterview = 'CAN_INTERVIEW',
  /**  Permission to manage additional permissions for Employees */
  CanManageAdditionalUserPermissions = 'CAN_MANAGE_ADDITIONAL_USER_PERMISSIONS',
  CanManageOrgSettings = 'CAN_MANAGE_ORG_SETTINGS',
  CanSchedule = 'CAN_SCHEDULE',
  ReadAuditLogs = 'READ_AUDIT_LOGS'
}

/** Reports that the caller cannot access the exported data. */
export type PermissionDeniedError = Error & {
  __typename?: 'PermissionDeniedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** Outcome of an MCP tool call. */
export enum PlatformAuditCallStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

/** Authentication provenance for a platform request. */
export enum PlatformAuditTokenType {
  Agent = 'AGENT',
  ApiKey = 'API_KEY',
  Oauth = 'OAUTH'
}

/** Represents a reusable portal configuration that can be linked to multiple jobs. */
export type PortalConfig = {
  __typename?: 'PortalConfig';
  aiAssistantId?: Maybe<Scalars['String']['output']>;
  brandingThemeId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  intro?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  linkedJobs: Array<Job>;
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  tabs: Array<PortalConfigTab>;
  updatedAt: Scalars['datetime']['output'];
};

export type PortalConfigAutomationRule = {
  __typename?: 'PortalConfigAutomationRule';
  criteria: Array<PortalConfigAutomationRuleCriterion>;
  id: Scalars['uuid']['output'];
  index: Scalars['Int']['output'];
  portalConfig?: Maybe<PortalConfig>;
  /**
   * Null when the rule is configured as "None" — it matches by criteria but intentionally
   * does not link any portal config (the evaluator skips it, leaving the matched job's
   * portal_job_options unchanged).
   */
  portalConfigId?: Maybe<Scalars['uuid']['output']>;
};

export type PortalConfigAutomationRuleApplyResult = {
  __typename?: 'PortalConfigAutomationRuleApplyResult';
  linkedJobCount: Scalars['Int']['output'];
};

export type PortalConfigAutomationRuleCriterion = {
  __typename?: 'PortalConfigAutomationRuleCriterion';
  field: PortalConfigAutomationRuleField;
  operator: PortalConfigAutomationRuleOperator;
  value: Array<Scalars['String']['output']>;
};

export type PortalConfigAutomationRuleCriterionInput = {
  field: PortalConfigAutomationRuleField;
  operator: PortalConfigAutomationRuleOperator;
  value: Array<Scalars['String']['input']>;
};

/**  ---- Portal Config Automation Rules ---- */
export enum PortalConfigAutomationRuleField {
  Department = 'DEPARTMENT',
  JobTitle = 'JOB_TITLE',
  Location = 'LOCATION'
}

export enum PortalConfigAutomationRuleOperator {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  Is = 'IS',
  IsNot = 'IS_NOT'
}

export type PortalConfigAutomationRulePreviewResult = {
  __typename?: 'PortalConfigAutomationRulePreviewResult';
  affectedJobCount: Scalars['Int']['output'];
};

export type PortalConfigAutomationRuleResult = {
  __typename?: 'PortalConfigAutomationRuleResult';
  rule: PortalConfigAutomationRule;
};

export type PortalConfigAutomationRuleSaveInput = {
  criteria: Array<PortalConfigAutomationRuleCriterionInput>;
  index: Scalars['Int']['input'];
  portalConfigId?: InputMaybe<Scalars['uuid']['input']>;
};

export type PortalConfigAutomationRulesPref = {
  __typename?: 'PortalConfigAutomationRulesPref';
  rules: Array<PortalConfigAutomationRule>;
};

export type PortalConfigAutomationRulesResult = {
  __typename?: 'PortalConfigAutomationRulesResult';
  rules: Array<PortalConfigAutomationRule>;
};

export type PortalConfigAutomationSaveInput = {
  rules: Array<PortalConfigAutomationRuleSaveInput>;
};

/** Input for creating a new portal config. */
export type PortalConfigCreateInput = {
  aiAssistantId?: InputMaybe<Scalars['String']['input']>;
  brandingThemeId?: InputMaybe<Scalars['uuid']['input']>;
  intro?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Result type for a single portal config query. */
export type PortalConfigResult = {
  __typename?: 'PortalConfigResult';
  config: PortalConfig;
};

/** Represents a tab belonging to a portal config. */
export type PortalConfigTab = {
  __typename?: 'PortalConfigTab';
  createdAt: Scalars['datetime']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['uuid']['output'];
  portalConfigId: Scalars['uuid']['output'];
  portalTemplateId: Scalars['uuid']['output'];
  stageNameFilter?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['datetime']['output'];
  visibility: PortalJobOptionsTabVisibilityType;
};

/** Input for creating a new portal config tab. */
export type PortalConfigTabCreateInput = {
  icon: Scalars['String']['input'];
  index: Scalars['numeric']['input'];
  name: Scalars['String']['input'];
  portalConfigId: Scalars['uuid']['input'];
  portalTemplateId: Scalars['uuid']['input'];
  stageNameFilter?: InputMaybe<Scalars['String']['input']>;
  visibility: PortalJobOptionsTabVisibilityType;
};

/** Result type for a single portal config tab. */
export type PortalConfigTabResult = {
  __typename?: 'PortalConfigTabResult';
  tab: PortalConfigTab;
};

/** Input for updating an existing portal config tab. */
export type PortalConfigTabUpdateInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  index?: InputMaybe<Scalars['numeric']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portalTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  stageNameFilter?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<PortalJobOptionsTabVisibilityType>;
};

/** Input for updating an existing portal config. */
export type PortalConfigUpdateInput = {
  aiAssistantId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Pass a valid UUID to set, or an empty string to clear the branding theme.
   * Omit the field entirely to leave the current value unchanged.
   * Typed as String (not uuid) so clients can send "" to clear.
   */
  brandingThemeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  intro?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Result type for queries returning multiple portal configs. */
export type PortalConfigsResult = {
  __typename?: 'PortalConfigsResult';
  items: Array<PortalConfig>;
};

/** Represents the options for a job in the candidate portal. */
export type PortalJobOptions = {
  __typename?: 'PortalJobOptions';
  /** The ModernLoop AI Assistant ID associated with these job options, if any. */
  aiAssistantId?: Maybe<Scalars['String']['output']>;
  /** The branding theme associated with these job options. */
  brandingTheme?: Maybe<BrandingTheme>;
  /** The ID of the branding theme used for this job. */
  brandingThemeId?: Maybe<Scalars['uuid']['output']>;
  /** The timestamp when these options were created. */
  createdAt: Scalars['datetime']['output'];
  /** The unique identifier of the portal job options. */
  id: Scalars['uuid']['output'];
  /** Introductory text for the job. */
  intro?: Maybe<Scalars['String']['output']>;
  /** The job ID associated with these options. */
  jobId: Scalars['uuid']['output'];
  /** The portal config this job is linked to, if any. */
  linkedPortalConfig?: Maybe<PortalConfig>;
  /** The organization ID associated with these options. */
  orgId: Scalars['uuid']['output'];
  /** The tabs associated with these job options. */
  tabs: Array<PortalJobOptionsTab>;
  /** The timestamp when these options were last updated. */
  updatedAt: Scalars['datetime']['output'];
  /** Indicates whether to use the organization's default branding theme. */
  useOrgDefaultBrandingTheme?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for linking a job's portal options to a portal config. */
export type PortalJobOptionsLinkToConfigInput = {
  portalConfigId: Scalars['uuid']['input'];
  portalJobOptionsId: Scalars['uuid']['input'];
};

/** Result type for portal job options queries. */
export type PortalJobOptionsResult = {
  __typename?: 'PortalJobOptionsResult';
  /** The retrieved portal job options. */
  options: PortalJobOptions;
};

/** Represents a tab in the portal job options. */
export type PortalJobOptionsTab = {
  __typename?: 'PortalJobOptionsTab';
  /** The timestamp when this tab was created. */
  createdAt: Scalars['datetime']['output'];
  /** The icon used for the tab. */
  icon: Scalars['String']['output'];
  /** The unique identifier of the tab. */
  id: Scalars['uuid']['output'];
  /** The index determining the order of the tab. */
  index: Scalars['numeric']['output'];
  /** The jobStage associated with this tab, if any. */
  jobStage?: Maybe<JobStage>;
  /** The ID of the job stage associated with this tab, if any. */
  jobStageId?: Maybe<Scalars['uuid']['output']>;
  /** The name of the tab. */
  name: Scalars['String']['output'];
  /** The organization ID associated with this tab. */
  orgId: Scalars['uuid']['output'];
  /** The ID of the portal job options this tab belongs to. */
  portalJobOptionsId: Scalars['uuid']['output'];
  /** The ID of the portal template associated with this tab. */
  portalTemplateId: Scalars['uuid']['output'];
  /** The stage name filter for visibility matching (copied from portal config on unsync). */
  stageNameFilter?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this tab was last updated. */
  updatedAt: Scalars['datetime']['output'];
  /** The visibility type of the tab. */
  visibility: PortalJobOptionsTabVisibilityType;
};

/** Input for creating or updating a portal job options tab. */
export type PortalJobOptionsTabInput = {
  /** The icon to use for the tab. */
  icon: Scalars['String']['input'];
  /** The index determining the order of the tab. */
  index: Scalars['numeric']['input'];
  /** The ID of the job stage associated with this tab, if any. */
  jobStageId?: InputMaybe<Scalars['uuid']['input']>;
  /** The name of the tab. */
  name: Scalars['String']['input'];
  /** The ID of the portal template to use for this tab. */
  portalTemplateId: Scalars['uuid']['input'];
  /** The visibility type of the tab. */
  visibility: PortalJobOptionsTabVisibilityType;
};

/**
 * Defines the visibility options for job option tabs in the candidate portal.
 * This enum is used to control when and how job option tabs are displayed to candidates.
 */
export enum PortalJobOptionsTabVisibilityType {
  /**
   * The job options tab is always visible to candidates, regardless of their current stage in the application process.
   * This option provides maximum transparency and allows candidates to see all available options at any time.
   */
  Always = 'ALWAYS',
  /**
   * The visibility of the job options tab depends on the candidate's current stage in the application process.
   * This allows for a dynamic user experience, showing relevant options as the candidate progresses through different stages of the application.
   */
  JobStage = 'JOB_STAGE',
  /**
   * The job options tab is never visible to candidates.
   * This option might be used for jobs where additional options are not applicable or when the recruitment process is strictly linear.
   */
  Never = 'NEVER'
}

/** Input for creating or updating portal job options. */
export type PortalJobOptionsUpsertInput = {
  /** The ModernLoop AI Assistant ID to associate with these job options, if any. */
  aiAssistantId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the branding theme to use. */
  brandingThemeId?: InputMaybe<Scalars['uuid']['input']>;
  /** The roles of the hiring team members to include as contact information. */
  contactInfos?: InputMaybe<Array<JobHiringTeamRole>>;
  /** Introductory text for the job. */
  intro?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the job these options are for. */
  jobId: Scalars['uuid']['input'];
  /** The tabs to include in the job options. */
  tabs: Array<PortalJobOptionsTabInput>;
  /** Indicates whether to use the organization's default branding theme. */
  useOrgDefaultBrandingTheme: Scalars['Boolean']['input'];
};

/** Represents a portal slug for an organization. */
export type PortalOrgSlug = {
  __typename?: 'PortalOrgSlug';
  /** The timestamp when the slug was created. */
  createdAt: Scalars['datetime']['output'];
  /** Indicates whether this is the primary slug for the organization. */
  isPrimary: Scalars['Boolean']['output'];
  /** The timestamp when the slug was last used, if applicable. */
  lastUsedAt?: Maybe<Scalars['datetime']['output']>;
  /** The unique identifier of the organization. */
  orgId: Scalars['uuid']['output'];
  /** The slug used for the organization's portal. */
  slug: Scalars['String']['output'];
};

/** Input for creating a new portal slug. */
export type PortalSlugCreateInput = {
  /** The desired slug for the portal. */
  slug: Scalars['String']['input'];
};

/** Represents a portal template. */
export type PortalTemplate = {
  __typename?: 'PortalTemplate';
  /** The blocks that make up the content of this template. */
  blocks: Array<PortalTemplateBlock>;
  /** The timestamp when this template was created. */
  createdAt: Scalars['datetime']['output'];
  /** The unique identifier of the template. */
  id: Scalars['uuid']['output'];
  /** The number of active portals using this template. */
  livePortals: Scalars['numeric']['output'];
  /** The name of the template. */
  name: Scalars['String']['output'];
  /** The organization ID associated with this template. */
  orgId: Scalars['uuid']['output'];
  /** The timestamp when this template was last updated. */
  updatedAt: Scalars['datetime']['output'];
};

/** Interface for portal template blocks. */
export type PortalTemplateBlock = {
  /** The timestamp when this block was created. */
  createdAt: Scalars['datetime']['output'];
  /** The unique identifier of the block. */
  id: Scalars['uuid']['output'];
  /** The index determining the order of the block within the template. */
  index: Scalars['numeric']['output'];
  /** The organization ID associated with this block. */
  orgId: Scalars['uuid']['output'];
  /** The ID of the portal template this block belongs to. */
  portalTemplateId: Scalars['uuid']['output'];
  /** The type of the block. */
  type: BlockType;
  /** The timestamp when this block was last updated. */
  updatedAt: Scalars['datetime']['output'];
};

/** Represents a content card block in a portal template. */
export type PortalTemplateBlockContentCard = PortalTemplateBlock & {
  __typename?: 'PortalTemplateBlockContentCard';
  /** The individual content cards within this block. */
  cards: Array<ContentCard>;
  createdAt: Scalars['datetime']['output'];
  /** The header text for the content card block. */
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  orgId: Scalars['uuid']['output'];
  portalTemplateId: Scalars['uuid']['output'];
  type: BlockType;
  updatedAt: Scalars['datetime']['output'];
};

/** Represents a divider block in a portal template. */
export type PortalTemplateBlockDivider = PortalTemplateBlock & {
  __typename?: 'PortalTemplateBlockDivider';
  createdAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  orgId: Scalars['uuid']['output'];
  portalTemplateId: Scalars['uuid']['output'];
  type: BlockType;
  updatedAt: Scalars['datetime']['output'];
};

/** Represents an image block in a portal template. */
export type PortalTemplateBlockImage = PortalTemplateBlock & {
  __typename?: 'PortalTemplateBlockImage';
  /** The caption for the image. */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['datetime']['output'];
  /** Indicates whether the image should fill the entire page. */
  fillPage: Scalars['Boolean']['output'];
  /** The header text for the image. */
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  /** The name of the image. */
  name?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['uuid']['output'];
  portalTemplateId: Scalars['uuid']['output'];
  type: BlockType;
  updatedAt: Scalars['datetime']['output'];
  /** The URL of the image. */
  url: Scalars['String']['output'];
};

/** Input for creating or updating a block in a portal template. */
export type PortalTemplateBlockInput = {
  /** The caption for image or video blocks. */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** The content for text blocks. */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The content cards for content card blocks. */
  contentCards?: InputMaybe<Array<ContentCardInput>>;
  /** Indicates whether an image should fill the page. */
  fillPage?: InputMaybe<Scalars['Boolean']['input']>;
  /** The header text for various block types. */
  header?: InputMaybe<Scalars['String']['input']>;
  /** The index determining the order of the block. */
  index: Scalars['numeric']['input'];
  /** The linked cards for linked card blocks. */
  linkedCards?: InputMaybe<Array<LinkedCardInput>>;
  /** The name for image blocks. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of the block. */
  type: BlockType;
  /** The URL for image or video blocks. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a linked card block in a portal template. */
export type PortalTemplateBlockLinkedCard = PortalTemplateBlock & {
  __typename?: 'PortalTemplateBlockLinkedCard';
  /** The individual linked cards within this block. */
  cards: Array<LinkedCard>;
  createdAt: Scalars['datetime']['output'];
  /** The header text for the linked card block. */
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  orgId: Scalars['uuid']['output'];
  portalTemplateId: Scalars['uuid']['output'];
  type: BlockType;
  updatedAt: Scalars['datetime']['output'];
};

/** Represents a text block in a portal template. */
export type PortalTemplateBlockText = PortalTemplateBlock & {
  __typename?: 'PortalTemplateBlockText';
  /** The text content of the block. */
  content: Scalars['String']['output'];
  createdAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  orgId: Scalars['uuid']['output'];
  portalTemplateId: Scalars['uuid']['output'];
  type: BlockType;
  updatedAt: Scalars['datetime']['output'];
};

/** Represents a video block in a portal template. */
export type PortalTemplateBlockVideo = PortalTemplateBlock & {
  __typename?: 'PortalTemplateBlockVideo';
  /** The caption for the video. */
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['datetime']['output'];
  /** The header text for the video. */
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  index: Scalars['numeric']['output'];
  orgId: Scalars['uuid']['output'];
  portalTemplateId: Scalars['uuid']['output'];
  type: BlockType;
  updatedAt: Scalars['datetime']['output'];
  /** The URL of the video. */
  url: Scalars['String']['output'];
};

/** Input for creating a new portal template. */
export type PortalTemplateCreateInput = {
  /** The blocks to include in the new template. */
  blocks: Array<PortalTemplateBlockInput>;
  /** The name of the new template. */
  name: Scalars['String']['input'];
};

/** Result type for portal template queries. */
export type PortalTemplateResult = {
  __typename?: 'PortalTemplateResult';
  /** The retrieved portal template. */
  template: PortalTemplate;
};

/** Input for updating an existing portal template. */
export type PortalTemplateUpdateInput = {
  /** The updated blocks for the template. */
  blocks: Array<PortalTemplateBlockInput>;
  /** The ID of the template to update. */
  id: Scalars['uuid']['input'];
  /** The updated name of the template. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for querying portal templates. */
export type PortalTemplatesInput = {
  /** Optional ordering criteria for the templates. */
  orderBy?: InputMaybe<PortalTemplatesOrderBy>;
  /** Pagination input for the templates query. */
  pageInput: PageInput;
  /** Optional search term to filter templates. */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input for specifying the ordering of portal templates. */
export type PortalTemplatesOrderBy = {
  /** The direction of the ordering. */
  direction: Sort;
  /** The property to order by. */
  property: PortalTemplatesOrderByProperty;
};

/** Enum representing the properties by which portal templates can be ordered. */
export enum PortalTemplatesOrderByProperty {
  Id = 'ID',
  Name = 'NAME'
}

/** Result type for queries returning multiple portal templates. */
export type PortalTemplatesResult = {
  __typename?: 'PortalTemplatesResult';
  /** List of portal templates. */
  items: Array<PortalTemplate>;
  /** Cursor for the next page of results, if available. */
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/**
 *  Who drives changes to a pref. Mirrors the mloop.org.Audience proto enum minus its UNSPECIFIED
 *  value, which the proto fetcher already maps to null. Kept in sync by PrefAudienceSchemaTest.
 */
export enum PrefAudience {
  Internal = 'INTERNAL',
  UserDriven = 'USER_DRIVEN'
}

export enum PrefLevel {
  Employee = 'EMPLOYEE',
  Org = 'ORG'
}

export type PrefSet = {
  boolValue?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<DurationInput>;
  intValue?: InputMaybe<Scalars['numeric']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  json?: InputMaybe<Scalars['jsonb']['input']>;
  jsonArray?: InputMaybe<Array<InputMaybe<Scalars['jsonb']['input']>>>;
  stringArray?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['datetime']['input']>;
};

/** Input type representing a candidate for the preview token. */
export type PreviewTokenCandidate = {
  /** The phone number of the candidate. */
  phoneNumber: Scalars['String']['input'];
};

/** Input type representing an employee for the preview token. */
export type PreviewTokenEmployee = {
  /** The full name of the employee. */
  fullName: Scalars['String']['input'];
  /** The unique identifier of the employee. */
  id: Scalars['uuid']['input'];
  /** The LinkedIn URL of the employee. */
  linkedInUrl: Scalars['String']['input'];
  /** The job title of the employee. */
  title: Scalars['String']['input'];
};

export type PreviousInterviewsForApplication = {
  __typename?: 'PreviousInterviewsForApplication';
  applicationStageInterviews?: Maybe<Array<ApplicationStageInterview>>;
  flag: InterviewerFlag;
};

/** PI category recorded on a privacy audit ledger entry. */
export enum PrivacyAuditAccessData {
  EmailAddress = 'EMAIL_ADDRESS',
  Name = 'NAME',
  PhoneNumber = 'PHONE_NUMBER'
}

/** Activity category of a ledger entry (single-subject and bulk categories share one enum). */
export enum PrivacyAuditActivityCategory {
  BulkCreate = 'BULK_CREATE',
  BulkDelete = 'BULK_DELETE',
  BulkRead = 'BULK_READ',
  BulkUpdate = 'BULK_UPDATE',
  Create = 'CREATE',
  Delete = 'DELETE',
  Download = 'DOWNLOAD',
  Read = 'READ',
  Update = 'UPDATE'
}

/** Whole-org scope of a bulk entry whose query was not a specific id/search set. */
export enum PrivacyAuditBulkScope {
  AllOrgCandidates = 'ALL_ORG_CANDIDATES',
  AllOrgEmployees = 'ALL_ORG_EMPLOYEES'
}

/**
 * One entry in the privacy audit ledger: who accessed whose personal information, when, from which
 * IP, and through which menu. Implemented by single-subject and bulk variants.
 */
export type PrivacyAuditLogEntry = {
  accessData: Array<PrivacyAuditAccessData>;
  accessMenu: Scalars['String']['output'];
  accessMenuPath: Scalars['String']['output'];
  accessTime: Scalars['datetime']['output'];
  activityCategory: PrivacyAuditActivityCategory;
  /** The org user who performed the access; null if that user has since been deleted. */
  actor?: Maybe<Employee>;
  /** Raw actor user id, always present even when the actor was deleted. */
  actorId: Scalars['uuid']['output'];
  /** Free-form JSON string of extra context, when present. */
  customData?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  ipAddresses: Array<Scalars['String']['output']>;
  /** Optional reason supplied for the access. It can appear on any activity category. */
  userProvidedReason?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for the privacy audit ledger listing. All fields are optional (rollout-compatible): the
 * range defaults to the last 30 days, cursor pages via nextCursor, and limit clamps to 1..500.
 */
export type PrivacyAuditLogsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Inclusive ISO date (YYYY-MM-DD), UTC. Defaults to today. */
  endDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Inclusive ISO date (YYYY-MM-DD), UTC. Defaults to 30 days before endDate. */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** A page of privacy audit ledger entries plus the opaque cursor for the next page. */
export type PrivacyAuditLogsResult = {
  __typename?: 'PrivacyAuditLogsResult';
  items: Array<PrivacyAuditLogEntry>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** The candidate or employee whose personal information a single entry recorded access to. */
export type PrivacyAuditSubject = Candidate | Employee;

/** Whether a single entry's data subject is a candidate or an employee. */
export enum PrivacyAuditSubjectType {
  Candidate = 'CANDIDATE',
  Employee = 'EMPLOYEE'
}

/** Represents a profile picture with various size options. */
export type ProfilePicture = {
  __typename?: 'ProfilePicture';
  image32px?: Maybe<Scalars['String']['output']>;
  image64px?: Maybe<Scalars['String']['output']>;
  image128px?: Maybe<Scalars['String']['output']>;
  image256px?: Maybe<Scalars['String']['output']>;
  image512px?: Maybe<Scalars['String']['output']>;
  image1024px?: Maybe<Scalars['String']['output']>;
  imageOriginal?: Maybe<Scalars['String']['output']>;
};

export type ProfilePicturePref = {
  __typename?: 'ProfilePicturePref';
  originalImageUrl?: Maybe<Scalars['String']['output']>;
};

export type PublicIdInvalidError = Error & {
  __typename?: 'PublicIdInvalidError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type PublicIdNotFoundError = Error & {
  __typename?: 'PublicIdNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The best in-app destination for a public ID. */
export type PublicIdUrl = {
  __typename?: 'PublicIdUrl';
  /** The canonical form of the requested public ID (prefix + compact lowercase UUID). */
  publicId: Scalars['String']['output'];
  /**
   * App-relative URL path for the object, for example /candidates/<id>. Resolve it against
   * the app origin (https://app.modernloop.io in production).
   */
  url: Scalars['String']['output'];
};

/** Result for a single interview when pushing to ATS. */
export type PushInterviewToAtsResult = {
  __typename?: 'PushInterviewToAtsResult';
  /** The action that was or would be taken for this interview. */
  action: PushScheduleToAtsActionType;
  /** The name of the interview. */
  interviewName: Scalars['String']['output'];
  /** Details about what changed, populated when the action is UPDATE. */
  updateDetails?: Maybe<PushInterviewToAtsUpdateDetails>;
};

/** Details about what changed for an interview being updated in the ATS. */
export type PushInterviewToAtsUpdateDetails = {
  __typename?: 'PushInterviewToAtsUpdateDetails';
  /** Interviewers being added to this interview. */
  addedInterviewers: Array<Employee>;
  /** The new ATS interview definition (scorecard), resolved from its ATS interview definition ID when scorecardChanged is true. */
  newAtsInterviewDefinition?: Maybe<AtsInterviewDefinition>;
  /** The new end time of the interview, populated when timeChanged is true. */
  newEndAt?: Maybe<Scalars['datetime']['output']>;
  /** The new start time of the interview, populated when timeChanged is true. */
  newStartAt?: Maybe<Scalars['datetime']['output']>;
  /** The previous ATS interview definition (scorecard), resolved from its ATS interview definition ID when scorecardChanged is true. */
  previousAtsInterviewDefinition?: Maybe<AtsInterviewDefinition>;
  /** The previous end time of the interview, populated when timeChanged is true. */
  previousEndAt?: Maybe<Scalars['datetime']['output']>;
  /** The previous start time of the interview, populated when timeChanged is true. */
  previousStartAt?: Maybe<Scalars['datetime']['output']>;
  /** Interviewers being removed from this interview. */
  removedInterviewers: Array<Employee>;
  /** Whether the scorecard/interview definition changed. */
  scorecardChanged: Scalars['Boolean']['output'];
  /** Whether the interview time (start or end) changed. */
  timeChanged: Scalars['Boolean']['output'];
};

/** The action taken when pushing an interview to the ATS. */
export enum PushScheduleToAtsActionType {
  Cancel = 'CANCEL',
  Create = 'CREATE',
  NoOp = 'NO_OP',
  Update = 'UPDATE'
}

/** Input for pushing a schedule to the ATS. */
export type PushScheduleToAtsInput = {
  /** The ID of the task associated with the schedule. */
  taskId: Scalars['uuid']['input'];
};

/** Result of pushing a schedule to the ATS. */
export type PushScheduleToAtsResult = {
  __typename?: 'PushScheduleToAtsResult';
  /**
   * True when the push created the schedule in the ATS from scratch because it did not exist
   * remotely (or, for a dry run, would be).
   */
  isScheduleCreated: Scalars['Boolean']['output'];
  /** The remote ATS schedule ID (new or existing), for ATSes with a schedule/panel concept. */
  remoteAtsInterviewScheduleId?: Maybe<Scalars['String']['output']>;
  /** The list of results for each interview in the schedule. */
  results: Array<PushInterviewToAtsResult>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieves activity logs based on the provided input. */
  activityLogs: ActivityLogsResult;
  /** Get Agent thread metadata owned by the authenticated Employee. */
  agentThread?: Maybe<AgentThread>;
  /** List Agent threads owned by the authenticated Employee. */
  agentThreads: AgentThreadsResult;
  /**
   * Google and Microsoft connection state of the organization's AI agent employee. Requires
   * CAN_MANAGE_ORG_SETTINGS, which the resolver enforces because the directive covers mutations
   * only.
   */
  aiAgentIntegrations: AiAgentIntegrationsOutput;
  apiRequestAuditLogs: ApiRequestAuditLogsResult;
  /** Retrieves an application by its ID. */
  application?: Maybe<Application>;
  /** Retrieves an application by its ATS ID. */
  applicationByAtsId?: Maybe<Application>;
  /** Retrieves an application by its ATS ID, with expected lookup errors represented in the output. */
  applicationByAtsIdV2: ApplicationByAtsIdV2Output;
  /** Retrieves multiple applications by their IDs. */
  applicationByIds?: Maybe<Array<Application>>;
  /** Retrieves application emails based on the provided input. */
  applicationEmails?: Maybe<ApplicationEmailOutput>;
  /** Searches for applications based on the provided criteria. */
  applicationSearch?: Maybe<ApplicationSearchOutput>;
  /** Retrieves an application stage by its ID. */
  applicationStage?: Maybe<ApplicationStage>;
  /** Retrieves application stages based on the provided input. */
  applicationStages?: Maybe<ApplicationStageOutput>;
  /** Retrieves an application by its ID, with expected lookup errors represented in the output. */
  applicationV2: ApplicationV2Output;
  /**
   * Retrieves the ats job config for the org. For smartrecruiters, it returns the hiring processes.
   * @deprecated User hiringProcesses
   */
  atsConfig?: Maybe<AtsConfig>;
  /** Retrieves ATS interview definitions based on the provided input. */
  atsInterviewDefinitions?: Maybe<AtsInterviewDefinitionsOutput>;
  /** Retrieves ATS interview definitions by ATS-specific IDs. */
  atsInterviewDefinitionsByIds?: Maybe<AtsInterviewDefinitionsOutput>;
  /** Retrieves live Greenhouse departments for the ATS job sync scope picker. */
  atsRemoteDepartments: AtsRemoteDepartmentsOutput;
  /** Retrieves open Greenhouse jobs, or selected jobs for hydration. */
  atsRemoteJobs: AtsRemoteJobsOutput;
  /** Retrieves live Greenhouse offices for the ATS job sync scope picker. */
  atsRemoteOffices: AtsRemoteOfficesOutput;
  /** Retrieves ATS users based on the provided input. */
  atsUsers?: Maybe<AtsUserOutput>;
  /** Lists unique departments for the current organization (cursor-paginated). */
  automationDepartments?: Maybe<AutomationDepartmentsOutput>;
  /** Lists unique job locations for the current organization. */
  automationJobLocations?: Maybe<AutomationJobLocationsOutput>;
  /** Retrieves branding themes for the candidate portal. */
  brandingThemes?: Maybe<BrandingThemesResult>;
  /** Retrieves a calendar by its ID. */
  calendar?: Maybe<Calendar>;
  /** Retrieves calendar free/busy information based on the provided input. */
  calendarFreeBusy?: Maybe<CalendarFreeBusyOutput>;
  /** Retrieves multiple calendars based on the provided input. */
  calendars?: Maybe<CalendarsResult>;
  /** Retrieves a candidate by their ID. */
  candidate?: Maybe<Candidate>;
  /** Retrieves candidate availability based on the provided input. */
  candidateAvailability?: Maybe<CandidateAvailability>;
  /** Retrieves a candidate by their ATS ID. */
  candidateByAtsId?: Maybe<Candidate>;
  /** Retrieves a candidate by their ATS ID, with expected lookup errors represented in the output. */
  candidateByAtsIdV2: CandidateByAtsIdV2Output;
  /** Retrieves multiple candidates by their IDs. */
  candidateByIds?: Maybe<Array<Candidate>>;
  /** Retrieves candidate pulse metrics based on the provided input. */
  candidatePulseMetrics?: Maybe<CandidatePulseMetrics>;
  /** Pages through candidate pulse responses based on the provided input. */
  candidatePulseSearch?: Maybe<CandidatePulseSearchOutput>;
  /** Retrieves a candidate by their ID, with expected lookup errors represented in the output. */
  candidateV2: CandidateV2Output;
  /** Retrieves collaboration link templates based on the provided input. */
  collaborationLinkTemplates: CollaborationLinkTemplatesResult;
  /** Retrieves company holidays based on the provided input. */
  companyHolidays?: Maybe<CompanyHolidayResult>;
  /** Retrieves company holidays for specific days based on the provided input. */
  companyHolidaysForDays?: Maybe<CompanyHolidaysForDaysResult>;
  /** Generates a preview of a custom interview schedule token used in organization settings. */
  customInterviewScheduleTokenPreview?: Maybe<CustomInterviewScheduleTokenPreviewResult>;
  /** Retrieves debrief metrics totals, trends, and breakdowns. */
  debriefMetrics: DebriefMetrics;
  /** Retrieves debrief metrics download rows. */
  debriefMetricsDownload: Array<DebriefMetricsDownloadRow>;
  /** Retrieves debrief options based on the provided input. */
  debriefOptions: ScheduleOptionsResult;
  /** Retrieves the default custom interview schedule token preferences. */
  defaultCustomInterviewScheduleToken?: Maybe<DefaultCustomInterviewScheduleTokenPref>;
  /** Retrieves a dynamic employee by their ID. */
  dynamicEmployee?: Maybe<DynamicEmployee>;
  /** Retrieves an employee by their ID. */
  employee?: Maybe<Employee>;
  /** Retrieves employee attribute names based on the provided input. */
  employeeAttributeNames?: Maybe<EmployeeAttributeNamesResult>;
  /** Retrieves multiple employees by their IDs. */
  employeeByIds?: Maybe<Array<Employee>>;
  /** List notifications for the current user. */
  employeeNotifications: EmployeeNotificationsResult;
  /** Searches for employees based on the provided criteria. */
  employeeSearch?: Maybe<EmployeeSearchOutput>;
  /** Retrieves employees based on the provided input. */
  employees?: Maybe<EmployeesOutput>;
  /** Retrieves external API token metadata for the current org, optionally filtered by employee. */
  externalApiTokens: Array<ExternalApiTokenMetadata>;
  /**
   * Resolves a public API ID to the best in-app URL for the object it identifies, so
   * external clients can link to any object as /id/<publicId> without knowing app routes.
   */
  getUrlForPublicId: GetUrlForPublicIdOutput;
  /** A simple hello world query that returns a greeting string. */
  hello?: Maybe<Scalars['String']['output']>;
  /** Retrieves the hiring processes for smartrecruiters. */
  hiringProcesses?: Maybe<Array<HiringProcess>>;
  /** Initializes the schedule flow based on the provided input. */
  initScheduleFlow?: Maybe<InitScheduleFlowResult>;
  /** Checks the health of an integration based on the provided input. */
  integrationCheckHealth?: Maybe<IntegrationCheckHealthResult>;
  /** Retrieves the OAuth URL for integration based on the provided input. */
  integrationGetOauthUrl?: Maybe<IntegrationGetOauthUrlResult>;
  /** Retrieves an interview module by its ID. */
  interviewModule?: Maybe<InterviewModule>;
  /** Retrieves multiple interview modules by their IDs. */
  interviewModuleByIds?: Maybe<Array<InterviewModule>>;
  /** Retrieves an interview module member by interview module ID and employee ID. */
  interviewModuleMember?: Maybe<InterviewModuleMember>;
  /** Looks up interview module members based on the provided input. */
  interviewModuleMemberLookup?: Maybe<InterviewModuleMemberLookupOutput>;
  /** Searches for interview module members based on the provided criteria. */
  interviewModuleMemberSearch?: Maybe<InterviewModuleMemberSearchOutput>;
  /** Retrieves statistics for interview module members. */
  interviewModuleMemberStats?: Maybe<Array<InterviewModuleMemberStats>>;
  /** Retrieves interview module members based on the provided input. */
  interviewModuleMembers?: Maybe<InterviewModuleMembersOutput>;
  /** Searches for interview modules based on the provided criteria. */
  interviewModuleSearch?: Maybe<InterviewModuleSearchOutput>;
  /** Retrieves interview modules based on the provided input. */
  interviewModules?: Maybe<InterviewModulesOutput>;
  /**
   * Estimated availability of one interviewer across a window, as classified spans.
   *
   * The scheduling engine produces the estimate, so it predicts what a scheduling flow would
   * decide for the same interviewer. It cannot apply the candidate-scoped rules a real flow
   * applies, so present it as an estimate. It returns no event content of any kind.
   */
  interviewerAvailability: InterviewerAvailabilityOutput;
  /** Retrieves interviewer metrics chart data based on the provided input. */
  interviewerMetricsChart?: Maybe<InterviewerMetricsChartResult>;
  /** Generates a download for interviewer metrics chart data based on the provided input. */
  interviewerMetricsChartDownload?: Maybe<MetricsChartDownloadResult>;
  /** Retrieves interviewer metrics for declines based on the provided input. */
  interviewerMetricsDeclines?: Maybe<InterviewerMetricsDeclinesResult>;
  /** Retrieves interviewer metrics declines wrapper data based on the provided input. */
  interviewerMetricsDeclinesWrapper?: Maybe<InterviewerMetricsDeclinesWrapperResult>;
  /** Retrieves interviewer metrics for interviewing based on the provided input. */
  interviewerMetricsInterviewing?: Maybe<InterviewerMetricsInterviewingResult>;
  /** Retrieves interviewer metrics for training based on the provided input. */
  interviewerMetricsTraining?: Maybe<InterviewerMetricsTrainingResult>;
  /** Retrieves interviewer suggestions based on the provided input. */
  interviewerSuggestions?: Maybe<InterviewerSuggestionsOutput>;
  /** Retrieves a job by its ID. */
  job?: Maybe<Job>;
  /** Retrieves multiple jobs by their IDs. */
  jobByIds?: Maybe<Array<Job>>;
  /** Validates job settings import based on the provided input. */
  jobSettingsImportValidate: JobSettingsImportValidateResult;
  /** Retrieves a job stage by its ID. */
  jobStage?: Maybe<JobStage>;
  /** Retrieves multiple job stages by their IDs. */
  jobStageByIds?: Maybe<Array<JobStage>>;
  /** Retrieves job stages based on the provided input. */
  jobStages?: Maybe<JobStagesOutput>;
  /** Retrieves job stages by name based on the provided input. */
  jobStagesByName?: Maybe<JobStagesByNameOutput>;
  /** Retrieves a job by its ID, with expected lookup errors represented in the output. */
  jobV2: JobV2Output;
  /** Retrieves jobs based on the provided input. */
  jobs?: Maybe<JobsOutput>;
  /** Unfurls a link based on the provided input. */
  linkUnfurl?: Maybe<LinkUnfurlResult>;
  /** Translation completeness for a locale across all categories (gate for setting it default). */
  localeTranslationStatus: LocaleTranslationStatusResult;
  /** Retrieves managers based on the provided input. */
  managers?: Maybe<EmployeesOutput>;
  mcpToolCallAuditLogs: McpToolCallAuditLogsResult;
  /** Retrieves a meeting room by its ID. */
  meetingRoom?: Maybe<MeetingRoom>;
  /** Retrieves multiple meeting rooms by their IDs. */
  meetingRoomByIds?: Maybe<Array<MeetingRoom>>;
  /** Retrieves meeting room suggestions based on the provided input. */
  meetingRoomSuggestions?: Maybe<MeetingRoomSuggestionsOutput>;
  /** Retrieves meeting rooms for the current organization. */
  meetingRooms?: Maybe<MeetingRoomsOutput>;
  /**
   * The primary calendar of the user making the request. Null when that user has no primary
   * calendar, for example when their calendar was never connected.
   *
   * Lets a client resolve the "Scheduler" calendar smart token the same way the server resolves
   * it in `mloop.data.CalendarIdSetting` / `SettingsManager.getCalendarId`.
   */
  myPrimaryCalendar?: Maybe<Calendar>;
  /** List OAuth applications connected to the authenticated organization. */
  oauthConnectedApps: Array<OAuthConnectedAppGrant>;
  /** Load the safe display projection for an opaque OAuth authorization request. */
  oauthConsent: OAuthConsentResult;
  /** All translatable content with per-locale status. */
  orgTranslations: OrgTranslationsResult;
  /** Retrieves a portal config by its ID. */
  portalConfig?: Maybe<PortalConfig>;
  /** Retrieves all automation rules for the current organization. */
  portalConfigAutomationRules?: Maybe<PortalConfigAutomationRulesResult>;
  /** Retrieves all portal configs for the current organization. */
  portalConfigs?: Maybe<PortalConfigsResult>;
  /** Retrieves a portal template by its ID. */
  portalTemplate?: Maybe<PortalTemplate>;
  /** Retrieves portal templates based on the provided input. */
  portalTemplates?: Maybe<PortalTemplatesResult>;
  /**
   * Owner-only listing of the privacy audit ledger ("who viewed what"). Gated by the
   * org_privacy_audit_log_ui flag; each call is itself recorded in the ledger as a BULK_READ.
   */
  privacyAuditLogs: PrivacyAuditLogsResult;
  /** Previews the changes that would be made when pushing a schedule to the ATS (dry run). */
  pushScheduleToAtsDryRun: PushScheduleToAtsResult;
  /** Retrieves recruiter metrics chart data based on the provided input. */
  recruiterMetricsChart?: Maybe<RecruiterMetricsChartResult>;
  /** Generates a download for recruiter metrics chart data based on the provided input. */
  recruiterMetricsChartDownload?: Maybe<MetricsChartDownloadResult>;
  /** Retrieves recruiter metrics reschedule logs based on the provided input. */
  recruiterMetricsRescheduleLogs?: Maybe<RecruiterRescheduleLogsWrapperResult>;
  /** Retrieves recruiter metrics table data based on the provided input. */
  recruiterMetricsTable?: Maybe<RecruiterMetricsTableResult>;
  /** Retrieves reschedule options based on the provided input. */
  rescheduleOptions: ScheduleOptionsResult;
  /** Retrieves reschedule reasons based on the provided input. */
  rescheduleReasons?: Maybe<RescheduleReasonsResult>;
  /** Retrieves schedule options based on the provided input. */
  scheduleOptions: ScheduleOptionsResult;
  /** Retrieves Slack channels by name. */
  slackChannelByName?: Maybe<Array<SlackChannel>>;
  /** Retrieves subscribers based on the provided input. */
  subscribers?: Maybe<SubscribersResult>;
  /** Retrieves the count of suggested time ranges based on the provided input. */
  suggestedTimeRangesCount?: Maybe<SuggestedTimeRangesCountOutput>;
  /** Retrieves a task by its ID. */
  task?: Maybe<Task>;
  /** Retrieves status options and warnings for a date range from cache. */
  taskCustomCandidateRequestStatusOptions: TaskCustomCandidateRequestStatusOptionsResult;
  /** Validates quick task creation based on the provided input. */
  taskCustomCandidateRequestValidate: TaskCustomCandidateRequestValidateMultipleDatesResult;
  /** Retrieves a task queue by its ID. */
  taskQueue?: Maybe<TaskQueue>;
  /** Retrieves multiple task queues by their IDs. */
  taskQueueByIds?: Maybe<Array<TaskQueue>>;
  /** Searches for task queues based on the provided criteria. */
  taskQueueSearch?: Maybe<TaskQueueSearchResult>;
  /** Retrieves task queues based on the provided input. */
  taskQueues?: Maybe<TaskQueuesResult>;
  /** Validates quick task creation based on the provided input. */
  taskQuickCreateValidate: TaskQuickCreateValidateResult;
  /** Searches for tasks based on the provided criteria. */
  taskSearch?: Maybe<TaskSearchResult>;
  /** Retrieves a task tag by its ID. */
  taskTag?: Maybe<TaskTag>;
  /** Retrieves task tags based on the provided input. */
  taskTags?: Maybe<TaskTagsResult>;
  /** Retrieves a template by its ID. */
  template?: Maybe<Template>;
  /** Retrieves multiple templates by their IDs. */
  templateByIds?: Maybe<Array<Template>>;
  /** Generates a template token based on the provided input. */
  templateToken?: Maybe<TemplateToken>;
  /** Retrieves templates based on the provided input. */
  templates?: Maybe<TemplatesOutput>;
  /** Retrieves information about the current employee. */
  thisEmployee?: Maybe<Employee>;
  /** Retrieves information about the current organization. */
  thisOrg?: Maybe<Org>;
  /** Retrieves user information for the current user. */
  thisUserInfo?: Maybe<UserInfo>;
  /** Retrieves TimeToScheduleMetrics for the org by assignee, job, stage. */
  timeToScheduleMetrics: TimeToScheduleMetricsResult;
  /** Retrieves upcoming events based on the provided input. */
  upcomingEvents?: Maybe<UpcomingEventsResult>;
  /** Retrieves user information for multiple employees based on their IDs. */
  userInfoByEmployeeIds?: Maybe<Array<UserInfo>>;
  /** Retrieves a Zoom user by their ID. */
  zoomUser?: Maybe<ZoomUser>;
  /** Retrieves Zoom users based on the provided input. */
  zoomUsers?: Maybe<ZoomUsersResult>;
  /** Retrieves multiple Zoom users by their IDs. */
  zoomUsersByIds?: Maybe<Array<ZoomUser>>;
};


export type QueryActivityLogsArgs = {
  input: ActivityLogsInput;
};


export type QueryAgentThreadArgs = {
  input: AgentThreadInput;
};


export type QueryAgentThreadsArgs = {
  input: AgentThreadsInput;
};


export type QueryApiRequestAuditLogsArgs = {
  input: ApiRequestAuditLogsInput;
};


export type QueryApplicationArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryApplicationByAtsIdArgs = {
  input: ApplicationByAtsIdInput;
};


export type QueryApplicationByAtsIdV2Args = {
  input: ApplicationByAtsIdV2Input;
};


export type QueryApplicationByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryApplicationEmailsArgs = {
  input: ApplicationEmailInput;
};


export type QueryApplicationSearchArgs = {
  input: ApplicationSearchInput;
};


export type QueryApplicationStageArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryApplicationStagesArgs = {
  input: ApplicationStageInput;
};


export type QueryApplicationV2Args = {
  input: ApplicationV2Input;
};


export type QueryAtsInterviewDefinitionsArgs = {
  input: AtsInterviewDefinitionsInput;
};


export type QueryAtsInterviewDefinitionsByIdsArgs = {
  input: AtsInterviewDefinitionsByIdsInput;
};


export type QueryAtsRemoteDepartmentsArgs = {
  input?: InputMaybe<AtsRemoteListsInput>;
};


export type QueryAtsRemoteJobsArgs = {
  input: AtsRemoteJobsInput;
};


export type QueryAtsRemoteOfficesArgs = {
  input?: InputMaybe<AtsRemoteListsInput>;
};


export type QueryAtsUsersArgs = {
  input: AtsUserInput;
};


export type QueryAutomationDepartmentsArgs = {
  input: AutomationDepartmentsInput;
};


export type QueryCalendarArgs = {
  id: Scalars['String']['input'];
};


export type QueryCalendarFreeBusyArgs = {
  input: CalendarFreeBusyInput;
};


export type QueryCalendarsArgs = {
  input: CalendarsInput;
};


export type QueryCandidateArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryCandidateAvailabilityArgs = {
  input: CandidateAvailabilityInput;
};


export type QueryCandidateByAtsIdArgs = {
  input: CandidateByAtsIdInput;
};


export type QueryCandidateByAtsIdV2Args = {
  input: CandidateByAtsIdV2Input;
};


export type QueryCandidateByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryCandidatePulseMetricsArgs = {
  input: CandidatePulseMetricsInput;
};


export type QueryCandidatePulseSearchArgs = {
  input: CandidatePulseSearchInput;
};


export type QueryCandidateV2Args = {
  input: CandidateV2Input;
};


export type QueryCollaborationLinkTemplatesArgs = {
  input: CollaborationLinkTemplatesInput;
};


export type QueryCompanyHolidaysArgs = {
  input: CompanyHolidaysInput;
};


export type QueryCompanyHolidaysForDaysArgs = {
  input: CompanyHolidaysForDaysInput;
};


export type QueryCustomInterviewScheduleTokenPreviewArgs = {
  input: CustomInterviewScheduleTokenPreviewInput;
};


export type QueryDebriefMetricsArgs = {
  input: DebriefMetricsInput;
};


export type QueryDebriefMetricsDownloadArgs = {
  input: DebriefMetricsDownloadInput;
};


export type QueryDebriefOptionsArgs = {
  input: DebriefOptionsInput;
};


export type QueryDynamicEmployeeArgs = {
  id: Scalars['String']['input'];
};


export type QueryEmployeeArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryEmployeeAttributeNamesArgs = {
  input: EmployeeAttributeNamesInput;
};


export type QueryEmployeeByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryEmployeeNotificationsArgs = {
  input: EmployeeNotificationsInput;
};


export type QueryEmployeeSearchArgs = {
  input: EmployeeSearchInput;
};


export type QueryEmployeesArgs = {
  input: EmployeesInput;
};


export type QueryExternalApiTokensArgs = {
  input?: ExternalApiTokensInput;
};


export type QueryGetUrlForPublicIdArgs = {
  input: GetUrlForPublicIdInput;
};


export type QueryInitScheduleFlowArgs = {
  input: InitScheduleFlowInput;
};


export type QueryIntegrationCheckHealthArgs = {
  input: IntegrationCheckHealthInput;
};


export type QueryIntegrationGetOauthUrlArgs = {
  input: IntegrationGetOauthUrlInput;
};


export type QueryInterviewModuleArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryInterviewModuleByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryInterviewModuleMemberArgs = {
  employeeId: Scalars['uuid']['input'];
  interviewModuleId: Scalars['uuid']['input'];
};


export type QueryInterviewModuleMemberLookupArgs = {
  input: InterviewModuleMemberLookupInput;
};


export type QueryInterviewModuleMemberSearchArgs = {
  input: InterviewModuleMemberSearchInput;
};


export type QueryInterviewModuleMembersArgs = {
  input: InterviewModuleMembersInput;
};


export type QueryInterviewModuleSearchArgs = {
  input: InterviewModuleSearchInput;
};


export type QueryInterviewModulesArgs = {
  input: InterviewModulesInput;
};


export type QueryInterviewerAvailabilityArgs = {
  input: InterviewerAvailabilityInput;
};


export type QueryInterviewerMetricsChartArgs = {
  input: InterviewerMetricsChartInput;
};


export type QueryInterviewerMetricsChartDownloadArgs = {
  input: InterviewerMetricsChartInput;
};


export type QueryInterviewerMetricsDeclinesArgs = {
  input: InterviewerMetricsTableInput;
};


export type QueryInterviewerMetricsDeclinesWrapperArgs = {
  input: InterviewerMetricsChartInput;
};


export type QueryInterviewerMetricsInterviewingArgs = {
  input: InterviewerMetricsTableInput;
};


export type QueryInterviewerMetricsTrainingArgs = {
  input: InterviewerMetricsTableInput;
};


export type QueryInterviewerSuggestionsArgs = {
  input: InterviewerSuggestionsInput;
};


export type QueryJobArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryJobByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryJobSettingsImportValidateArgs = {
  input: JobSettingsImportValidateInput;
};


export type QueryJobStageArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryJobStageByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryJobStagesArgs = {
  input: JobStagesInput;
};


export type QueryJobStagesByNameArgs = {
  input: JobStagesInput;
};


export type QueryJobV2Args = {
  input: JobV2Input;
};


export type QueryJobsArgs = {
  input: JobsInput;
};


export type QueryLinkUnfurlArgs = {
  input: LinkUnfurlInput;
};


export type QueryLocaleTranslationStatusArgs = {
  input: LocaleTranslationStatusInput;
};


export type QueryManagersArgs = {
  input: ManagersInput;
};


export type QueryMcpToolCallAuditLogsArgs = {
  input: McpToolCallAuditLogsInput;
};


export type QueryMeetingRoomArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryMeetingRoomByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryMeetingRoomSuggestionsArgs = {
  input: MeetingRoomSuggestionsInput;
};


export type QueryMeetingRoomsArgs = {
  input: MeetingRoomsInput;
};


export type QueryOauthConnectedAppsArgs = {
  input?: OAuthConnectedAppsInput;
};


export type QueryOauthConsentArgs = {
  input: OAuthConsentInput;
};


export type QueryOrgTranslationsArgs = {
  input: OrgTranslationsInput;
};


export type QueryPortalConfigArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryPortalTemplateArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryPortalTemplatesArgs = {
  input: PortalTemplatesInput;
};


export type QueryPrivacyAuditLogsArgs = {
  input: PrivacyAuditLogsInput;
};


export type QueryPushScheduleToAtsDryRunArgs = {
  input: PushScheduleToAtsInput;
};


export type QueryRecruiterMetricsChartArgs = {
  input: RecruiterMetricsChartInput;
};


export type QueryRecruiterMetricsChartDownloadArgs = {
  input: RecruiterMetricsChartInput;
};


export type QueryRecruiterMetricsRescheduleLogsArgs = {
  input: RecruiterMetricsChartInput;
};


export type QueryRecruiterMetricsTableArgs = {
  input: RecruiterMetricsChartInput;
};


export type QueryRescheduleOptionsArgs = {
  input: ReScheduleOptionsInput;
};


export type QueryRescheduleReasonsArgs = {
  input: RescheduleReasonsInput;
};


export type QueryScheduleOptionsArgs = {
  input: ScheduleOptionsInput;
};


export type QuerySlackChannelByNameArgs = {
  name: Scalars['String']['input'];
};


export type QuerySubscribersArgs = {
  input: SubscribersInput;
};


export type QuerySuggestedTimeRangesCountArgs = {
  input: SuggestedTimeRangesCountInput;
};


export type QueryTaskArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryTaskCustomCandidateRequestStatusOptionsArgs = {
  input: TaskCustomCandidateRequestStatusOptionsInput;
};


export type QueryTaskCustomCandidateRequestValidateArgs = {
  input: TaskCustomCandidateRequestValidateInput;
};


export type QueryTaskQueueArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryTaskQueueByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryTaskQueueSearchArgs = {
  input: TaskQueueSearchInput;
};


export type QueryTaskQueuesArgs = {
  input: TaskQueuesInput;
};


export type QueryTaskQuickCreateValidateArgs = {
  input: TaskQuickCreateValidateInput;
};


export type QueryTaskSearchArgs = {
  input: TaskSearchInput;
};


export type QueryTaskTagArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryTaskTagsArgs = {
  input: TaskTagsInput;
};


export type QueryTemplateArgs = {
  id: Scalars['uuid']['input'];
};


export type QueryTemplateByIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryTemplateTokenArgs = {
  input: TemplateTokenInput;
};


export type QueryTemplatesArgs = {
  input: TemplatesInput;
};


export type QueryTimeToScheduleMetricsArgs = {
  input: TimeToScheduleMetricsInput;
};


export type QueryUpcomingEventsArgs = {
  input: UpcomingEventsInput;
};


export type QueryUserInfoByEmployeeIdsArgs = {
  ids: Array<Scalars['uuid']['input']>;
};


export type QueryZoomUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryZoomUsersArgs = {
  input: ZoomUsersInput;
};


export type QueryZoomUsersByIdsArgs = {
  input: ZoomUsersByIdsInput;
};

export type ReScheduleOptionsInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  availabilities: Array<DateTimeRangeInput>;
  candidateTimezone: Scalars['timezone']['input'];
  excludedInterviewIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  groups: Array<InterviewGroupInput>;
  hardConflicts?: InputMaybe<Array<HardConflictInput>>;
  hasBreaks: Scalars['Boolean']['input'];
  hasMultiDay: Scalars['Boolean']['input'];
  interviewerResponseStatuses?: InputMaybe<Array<InterviewerResponseStatusInput>>;
  jobStageId: Scalars['uuid']['input'];
  numberOfDays: Scalars['Int']['input'];
  throwOnZero: Scalars['Boolean']['input'];
};

export type RecentlyUsedZoomUsersPref = {
  __typename?: 'RecentlyUsedZoomUsersPref';
  zoomUserIds: Array<Scalars['String']['output']>;
  zoomUsers: Array<ZoomUser>;
};

export type Recipient = {
  __typename?: 'Recipient';
  bcc?: Maybe<Array<Scalars['String']['output']>>;
  cc?: Maybe<Array<Scalars['String']['output']>>;
  to?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input for recording a browser-built CSV download. */
export type RecordDataDownloadInput = {
  downloadReason: Scalars['String']['input'];
  downloadType: DataDownloadType;
  rowCount: Scalars['Int']['input'];
};

/** Output for recording a browser-built CSV download. */
export type RecordDataDownloadOutput = InvalidDownloadReasonError | InvalidRowCountError | PermissionDeniedError | RecordDataDownloadSuccess | UnknownError;

/** Confirms that the privacy ledger recorded a browser-built CSV download. */
export type RecordDataDownloadSuccess = {
  __typename?: 'RecordDataDownloadSuccess';
  recorded: Scalars['Boolean']['output'];
};

/** ######################### */
export type RecruiterMetricsChartInput = {
  chartType?: InputMaybe<RecruiterMetricsChartType>;
  downloadReason?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['datetime']['input']>;
  filters: InterviewerFilters;
  sources?: InputMaybe<Array<MetricsSource>>;
  startAt?: InputMaybe<Scalars['datetime']['input']>;
  timezone?: InputMaybe<Scalars['timezone']['input']>;
  viewBy?: InputMaybe<RecruiterMetricsChartViewBy>;
};

/**
 * #########################
 *  input types for recruiter metrics chart and tables
 */
export type RecruiterMetricsChartResult = {
  __typename?: 'RecruiterMetricsChartResult';
  chartType: RecruiterMetricsChartType;
  data?: Maybe<Array<ChartCoordinateData>>;
};

/**
 * #########################
 *  enum types for recruiter metrics chart and tables
 */
export enum RecruiterMetricsChartType {
  RecruiterInterviewsCancelled = 'RECRUITER_INTERVIEWS_CANCELLED',
  RecruiterInterviewsChanged = 'RECRUITER_INTERVIEWS_CHANGED',
  RecruiterInterviewsCompleted = 'RECRUITER_INTERVIEWS_COMPLETED',
  RecruiterInterviewsDeclines = 'RECRUITER_INTERVIEWS_DECLINES',
  RecruiterInterviewsScheduled = 'RECRUITER_INTERVIEWS_SCHEDULED',
  RecruiterRescheduleLogs = 'RECRUITER_RESCHEDULE_LOGS',
  RecruiterScheduleStageCancelled = 'RECRUITER_SCHEDULE_STAGE_CANCELLED',
  RecruiterScheduleStageChanged = 'RECRUITER_SCHEDULE_STAGE_CHANGED',
  RecruiterScheduleStageFacilitated = 'RECRUITER_SCHEDULE_STAGE_FACILITATED',
  RecruiterScheduleStageScheduled = 'RECRUITER_SCHEDULE_STAGE_SCHEDULED'
}

export enum RecruiterMetricsChartViewBy {
  Interviews = 'INTERVIEWS',
  ScheduleStage = 'SCHEDULE_STAGE'
}

export type RecruiterMetricsTable = {
  __typename?: 'RecruiterMetricsTable';
  cancelled?: Maybe<Scalars['numeric']['output']>;
  changed?: Maybe<Scalars['numeric']['output']>;
  completed?: Maybe<Scalars['numeric']['output']>;
  declines?: Maybe<Scalars['numeric']['output']>;
  facilitated?: Maybe<Scalars['numeric']['output']>;
  recruiter?: Maybe<Employee>;
  scheduled?: Maybe<Scalars['numeric']['output']>;
};

export type RecruiterMetricsTableResult = {
  __typename?: 'RecruiterMetricsTableResult';
  items?: Maybe<Array<RecruiterMetricsTable>>;
};

export type RecruiterRescheduleLog = {
  __typename?: 'RecruiterRescheduleLog';
  atsApplicationId?: Maybe<Scalars['String']['output']>;
  atsCandidateId?: Maybe<Scalars['String']['output']>;
  atsJobId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  performedBy?: Maybe<Employee>;
  rescheduleReason?: Maybe<RescheduleReason>;
  rescheduleReasonId?: Maybe<Scalars['uuid']['output']>;
  task?: Maybe<Task>;
  taskId?: Maybe<Scalars['uuid']['output']>;
};

export type RecruiterRescheduleLogsData = {
  __typename?: 'RecruiterRescheduleLogsData';
  data: Array<ChartCoordinateData>;
  rescheduleReason: RescheduleReason;
  rescheduleReasonId: Scalars['uuid']['output'];
};

export type RecruiterRescheduleLogsWrapperResult = {
  __typename?: 'RecruiterRescheduleLogsWrapperResult';
  items?: Maybe<Array<RecruiterRescheduleLog>>;
  rescheduleLogsChart?: Maybe<Array<RecruiterRescheduleLogsData>>;
};

export type RecruitingSource = {
  __typename?: 'RecruitingSource';
  source: Scalars['String']['output'];
};

export type RecruitingTeamContactInfoSetting = {
  __typename?: 'RecruitingTeamContactInfoSetting';
  canShowBio: Scalars['Boolean']['output'];
  canShowJobTitle: Scalars['Boolean']['output'];
  canShowLinkedin: Scalars['Boolean']['output'];
  canShowPhone: Scalars['Boolean']['output'];
  canShowProfilePicture: Scalars['Boolean']['output'];
  canShowPronouns: Scalars['Boolean']['output'];
  isCustom: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  level: SettingLevel;
  showCoordinator: Scalars['Boolean']['output'];
  /**  Specific to this setting */
  showRecruiter: Scalars['Boolean']['output'];
};

export type RecruitingTeamContactInfoSettingInput = {
  /**
   *  Setting "isCustom" to false has the affect of explicitly setting the Job Setting's value to be the org default.
   *  Otherwise, if "isCustom" is true, then the "showRecruiter" and "showCoordinator" values must be present and will
   *  be used.
   */
  isCustom: Scalars['Boolean']['input'];
  showCoordinator?: InputMaybe<Scalars['Boolean']['input']>;
  showRecruiter?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  candidate email content */
export type RemoteAttachmentInput = {
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
};

export type RemoteVideoMeetingHostUser = ZoomUser;

export enum RenderType {
  Html = 'HTML',
  Plaintext = 'PLAINTEXT',
  SlackMarkdown = 'SLACK_MARKDOWN'
}

export type RescheduleLog = {
  __typename?: 'RescheduleLog';
  createdAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  lastUpdatedBy?: Maybe<Employee>;
  lastUpdatedByEmployeeId: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  performedBy?: Maybe<Employee>;
  performedByEmployeeId: Scalars['uuid']['output'];
  rescheduleReason?: Maybe<RescheduleReason>;
  rescheduleReasonId: Scalars['uuid']['output'];
  rescheduledAt: Scalars['datetime']['output'];
  updatedAt: Scalars['datetime']['output'];
};

/** Input for creating a reschedule log entry. */
export type RescheduleLogCreateInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  performedByEmployeeId: Scalars['uuid']['input'];
  rescheduleReasonId: Scalars['uuid']['input'];
  rescheduledAt: Scalars['datetime']['input'];
  taskId: Scalars['uuid']['input'];
};

/** Input for deleting a reschedule log entry. */
export type RescheduleLogDeleteInput = {
  id: Scalars['uuid']['input'];
};

export type RescheduleLogResult = {
  __typename?: 'RescheduleLogResult';
  rescheduleLog?: Maybe<RescheduleLog>;
};

/** Input for updating a reschedule log entry. */
export type RescheduleLogUpdateInput = {
  id: Scalars['uuid']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  performedByEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  rescheduleReasonId?: InputMaybe<Scalars['uuid']['input']>;
  rescheduledAt?: InputMaybe<Scalars['datetime']['input']>;
};

export type RescheduleLogsInput = {
  pageInput: PageInput;
};

export type RescheduleLogsResult = {
  __typename?: 'RescheduleLogsResult';
  items: Array<RescheduleLog>;
  nextCursor: Scalars['String']['output'];
};

export type RescheduleReason = {
  __typename?: 'RescheduleReason';
  archivedAt?: Maybe<Scalars['datetime']['output']>;
  /**  can be null */
  createdAt: Scalars['datetime']['output'];
  creator?: Maybe<Employee>;
  creatorEmployeeId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  lastUpdatedBy?: Maybe<Employee>;
  lastUpdatedByEmployeeId: Scalars['uuid']['output'];
  reason: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['datetime']['output'];
};

/** Input for creating a reschedule reason. */
export type RescheduleReasonCreateInput = {
  reason: Scalars['String']['input'];
};

/** Input for updating a reschedule reason. */
export type RescheduleReasonUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['uuid']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RescheduleReasonUpsertResult = {
  __typename?: 'RescheduleReasonUpsertResult';
  rescheduleReason?: Maybe<RescheduleReason>;
};

export type RescheduleReasonsInput = {
  /**  This is for pagination */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /**  optional to pull archived reasons */
  orderBy?: InputMaybe<RescheduleReasonsOrderBy>;
  pageInput: PageInput;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

export type RescheduleReasonsOrderBy = {
  direction: Sort;
  property: RescheduleReasonsOrderByProperty;
};

export enum RescheduleReasonsOrderByProperty {
  Reason = 'REASON',
  Status = 'STATUS'
}

export type RescheduleReasonsResult = {
  __typename?: 'RescheduleReasonsResult';
  items: Array<RescheduleReason>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

/** Input for resetting a job stage to use the ATS interview plan. */
export type ResetJobStageToAtsInterviewPlanInput = {
  jobStageId: Scalars['uuid']['input'];
};

/** Indicates the status of a response to an invitation or request. */
export enum ResponseStatus {
  /** The recipient has accepted the invitation or request. */
  Accepted = 'ACCEPTED',
  /** The recipient has declined the invitation or request. */
  Declined = 'DECLINED',
  /** The recipient failed to respond within the required timeframe. */
  Missed = 'MISSED',
  /** The recipient has not yet responded and action is required. */
  NeedsAction = 'NEEDS_ACTION',
  /** The recipient responded Maybe, pending confirmation. */
  Tentative = 'TENTATIVE'
}

/** Indicates the outcome of an operation. */
export enum Result {
  /** The operation failed. */
  Failure = 'FAILURE',
  /** The operation was successful. */
  Success = 'SUCCESS'
}

/** Input for queueing a retry of a schedule task's failed external-object syncs. */
export type RetryExternalObjectSyncInput = {
  taskId: Scalars['uuid']['input'];
};

/** Result of queueing schedule external-sync retries. */
export type RetryExternalObjectSyncResult = {
  __typename?: 'RetryExternalObjectSyncResult';
  syncStatusIds: Array<Scalars['uuid']['output']>;
};

/** ########################################################## */
export type ScheduleCancelInput = {
  applicationStageId: Scalars['uuid']['input'];
  candidateCancellationNote?: InputMaybe<Scalars['String']['input']>;
  candidateCancellationReason?: InputMaybe<CandidateCancellationReason>;
  deleteType?: InputMaybe<DeleteType>;
  isReschedule?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ScheduleCandidateEventSplitType {
  OneEventPerBlock = 'ONE_EVENT_PER_BLOCK',
  OneEventPerDay = 'ONE_EVENT_PER_DAY',
  OneEventPerInterview = 'ONE_EVENT_PER_INTERVIEW'
}

export type ScheduleCreateInput = {
  applicationStageId: Scalars['uuid']['input'];
  candidateCalendarId?: InputMaybe<Scalars['String']['input']>;
  /**  can be empty */
  candidateEmailContent?: InputMaybe<CandidateEmailContentInput>;
  candidateEventAdditionalAttendeeDynamicAudiences?: InputMaybe<Array<DynamicAudience>>;
  candidateEventAdditionalAttendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  candidateEventAdditionalAttendeeEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /**
   *  Per-recipient candidate-event attendees. Schedule-wide by design: one candidate event can
   *  span several interviews. Nullable for rollout compat, and the null-vs-empty distinction is
   *  meaningful: null falls back to the three candidateEventAdditionalAttendee* fields above (and
   *  then to settings), an empty list clears the candidate event's attendees.
   */
  candidateEventAdditionalAttendees?: InputMaybe<Array<AdditionalAttendeeInput>>;
  candidateEventAdditionalRecipientsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  candidateEventContent?: InputMaybe<CandidateEventContentInput>;
  candidateTimezone?: InputMaybe<Scalars['timezone']['input']>;
  interviewerCalendarId: Scalars['String']['input'];
  /**  can be empty */
  interviewerContents?: InputMaybe<Array<InterviewerContentInput>>;
  interviewerEventAdditionalAttendeeDynamicAudiences?: InputMaybe<Array<DynamicAudience>>;
  interviewerEventAdditionalAttendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewerEventAdditionalAttendeeEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  interviewerEventAdditionalRecipientsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivateCalendarEvent: Scalars['Boolean']['input'];
  slackChannelContent?: InputMaybe<SlackChannelContentInput>;
  taskId: Scalars['uuid']['input'];
};

/** ########################################################## */
export type ScheduleCreateResult = {
  __typename?: 'ScheduleCreateResult';
  applicationStageId: Scalars['uuid']['output'];
  debriefRescheduleDetails: DebriefRescheduleDetails;
};

export type ScheduleOption = {
  __typename?: 'ScheduleOption';
  events: Array<InterviewEvent>;
  id: Scalars['uuid']['output'];
  jobStageId: Scalars['uuid']['output'];
};

export type ScheduleOptionModuleSeatInput = {
  attributes?: InputMaybe<Array<ScheduleOptionSeatAttributeInput>>;
  interviewModuleId: Scalars['uuid']['input'];
  reverseShadowAttributes?: InputMaybe<Array<ScheduleOptionSeatAttributeInput>>;
  selectedReverseShadowInterviewerIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  selectedShadowInterviewerIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  selectedTrainedInterviewerIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  shadowAttributes?: InputMaybe<Array<ScheduleOptionSeatAttributeInput>>;
};

export type ScheduleOptionSeatAttributeInput = {
  attributeNameId: Scalars['uuid']['input'];
  attributeTagValueId: Scalars['uuid']['input'];
};

export type ScheduleOptionSeatInput = {
  freeformSeat?: InputMaybe<FreeformSeatInput>;
  id: Scalars['uuid']['input'];
  linkedSeat?: InputMaybe<LinkedSeatInput>;
  moduleSeat?: InputMaybe<ScheduleOptionModuleSeatInput>;
};

export type ScheduleOptionsInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  availabilities: Array<DateTimeRangeInput>;
  candidateTimezone: Scalars['timezone']['input'];
  excludedInterviewIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  groups: Array<InterviewGroupInput>;
  hardConflicts?: InputMaybe<Array<HardConflictInput>>;
  hasBreaks: Scalars['Boolean']['input'];
  hasMultiDay: Scalars['Boolean']['input'];
  jobStageId: Scalars['uuid']['input'];
  numberOfDays: Scalars['Int']['input'];
  throwOnZero: Scalars['Boolean']['input'];
};

export type ScheduleOptionsResult = {
  __typename?: 'ScheduleOptionsResult';
  configOverride: ConfigOverride;
  scheduleOptions: Array<ScheduleOption>;
};

export type ScheduleRescheduleInput = {
  applicationStageId: Scalars['uuid']['input'];
  candidateCalendarId?: InputMaybe<Scalars['String']['input']>;
  /**  can be empty */
  candidateEmailContent?: InputMaybe<CandidateEmailContentInput>;
  candidateEventAdditionalAttendeeDynamicAudiences?: InputMaybe<Array<DynamicAudience>>;
  candidateEventAdditionalAttendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  candidateEventAdditionalAttendeeEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /**
   *  Per-recipient candidate-event attendees. Schedule-wide by design: one candidate event can
   *  span several interviews. Nullable for rollout compat, and the null-vs-empty distinction is
   *  meaningful: null falls back to the three candidateEventAdditionalAttendee* fields above (and
   *  then to settings), an empty list clears the candidate event's attendees.
   */
  candidateEventAdditionalAttendees?: InputMaybe<Array<AdditionalAttendeeInput>>;
  candidateEventAdditionalRecipientsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  candidateEventContent?: InputMaybe<CandidateEventContentInput>;
  candidateTimezone?: InputMaybe<Scalars['timezone']['input']>;
  interviewerCalendarId: Scalars['String']['input'];
  /**  can be empty */
  interviewerContents?: InputMaybe<Array<InterviewerContentInput>>;
  interviewerEventAdditionalAttendeeDynamicAudiences?: InputMaybe<Array<DynamicAudience>>;
  interviewerEventAdditionalAttendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  interviewerEventAdditionalAttendeeEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  interviewerEventAdditionalRecipientsOptional?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivateCalendarEvent: Scalars['Boolean']['input'];
  slackChannelContent?: InputMaybe<SlackChannelContentInput>;
  taskId: Scalars['uuid']['input'];
};

export type ScheduleRescheduleResult = {
  __typename?: 'ScheduleRescheduleResult';
  applicationStageId: Scalars['uuid']['output'];
  debriefRescheduleDetails: DebriefRescheduleDetails;
};

export type ScheduleStageFilters = {
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  jobLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobStageIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  schedulerIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
};

export type ScheduleStageMetrics = {
  __typename?: 'ScheduleStageMetrics';
  atsApplicationId?: Maybe<Scalars['String']['output']>;
  /**  For download chart - remote ATS application id */
  atsCandidateId?: Maybe<Scalars['String']['output']>;
  atsJobId?: Maybe<Scalars['String']['output']>;
  candidate?: Maybe<Scalars['String']['output']>;
  endsAt?: Maybe<Scalars['datetime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /**
   *  This can be mloop, lever or gh id hence string as gh is not uuid
   * @deprecated Use jobName instead
   */
  job?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['uuid']['output']>;
  /**  For download chart */
  jobLocations: Array<Scalars['String']['output']>;
  jobName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use jobStageName instead */
  jobStage?: Maybe<Scalars['String']['output']>;
  jobStageId?: Maybe<Scalars['uuid']['output']>;
  jobStageName?: Maybe<Scalars['String']['output']>;
  scheduleStageDate?: Maybe<Scalars['datetime']['output']>;
  scheduler?: Maybe<Scalars['String']['output']>;
  schedulerId?: Maybe<Scalars['uuid']['output']>;
  /**  For download chart - mloop task id linked to this stage */
  startsAt?: Maybe<Scalars['datetime']['output']>;
  /**  For download chart - remote ATS candidate id */
  taskId?: Maybe<Scalars['String']['output']>;
};

export enum ScheduleTaskColumnType {
  ApplicationStatus = 'APPLICATION_STATUS',
  Asignee = 'ASIGNEE',
  Candidate = 'CANDIDATE',
  CandidateAvailabilityStartAt = 'CANDIDATE_AVAILABILITY_START_AT',
  CreatedAt = 'CREATED_AT',
  Creator = 'CREATOR',
  FirstInterviewAt = 'FIRST_INTERVIEW_AT',
  Job = 'JOB',
  JobStage = 'JOB_STAGE',
  LastActivityAt = 'LAST_ACTIVITY_AT',
  Queue = 'QUEUE',
  ScheduleCreatedAt = 'SCHEDULE_CREATED_AT',
  ScheduleStartAt = 'SCHEDULE_START_AT',
  Status = 'STATUS',
  TaskFlags = 'TASK_FLAGS',
  TaskTags = 'TASK_TAGS',
  Urgent = 'URGENT'
}

export type ScorecardMapping = {
  __typename?: 'ScorecardMapping';
  atsType: AtsType;
  jobStageInterviews?: Maybe<Array<JobStageInterview>>;
  sourceAtsId: Scalars['String']['output'];
  sourceAtsInterviewDefinition: AtsInterviewDefinition;
  sourceName: Scalars['String']['output'];
  targetAtsId?: Maybe<Scalars['String']['output']>;
};

export type ScorecardMappingInput = {
  doNotImportInterviewsWithScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  importInterviewsWithoutScorecard?: InputMaybe<Scalars['Boolean']['input']>;
  sourceAtsId: Scalars['String']['input'];
  targetAtsId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Defines the possible locations or platforms for a self-scheduled interview.
 * This enum helps specify how the interview will be conducted.
 */
export enum SelfScheduleLocation {
  /** The interview will use a custom location or platform not listed. */
  Custom = 'CUSTOM',
  /** The interview will be conducted via Google Meet. */
  Google = 'GOOGLE',
  /** The interview will be conducted via Microsoft Teams. */
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  /** No specific location is set for the interview. */
  None = 'NONE',
  /** The interview will be conducted over the phone. */
  Phone = 'PHONE',
  /** The interview will be conducted via Zoom. */
  Zoom = 'ZOOM'
}

/**
 * Specifies who will host the meeting for a self-scheduled interview.
 * This enum is used for various meeting platforms (except Zoom, which uses SelfScheduleZoomHost).
 */
export enum SelfScheduleMeetingHost {
  /** A custom host will be used for the meeting. */
  CustomMeetingHost = 'CUSTOM_MEETING_HOST',
  /** The interviewer will host the meeting. */
  Interviewer = 'INTERVIEWER',
  /** The scheduler will host the meeting. */
  Scheduler = 'SCHEDULER'
}

export type SelfScheduleNotificationPreference = {
  __typename?: 'SelfScheduleNotificationPreference';
  employeeIds?: Maybe<Array<Scalars['uuid']['output']>>;
  externalEmailAddresses?: Maybe<Array<Scalars['String']['output']>>;
};

/** ## NOTE: This input is deprecated, do not use! */
export type SelfScheduleNotificationPreferenceInput = {
  /** @deprecated This entire input is deprecated, do not use! */
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** @deprecated This entire input is deprecated, do not use! */
  externalEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SelfScheduleOptionSettings = {
  __typename?: 'SelfScheduleOptionSettings';
  advanceNoticeInHours?: Maybe<Scalars['numeric']['output']>;
  bccRecipients?: Maybe<NotificationPreference>;
  canScheduleOverAvailableKeywords?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverFreeTime?: Maybe<Scalars['Boolean']['output']>;
  canScheduleOverRecruitingKeywords?: Maybe<Scalars['Boolean']['output']>;
  candidateCalendarId?: Maybe<Scalars['String']['output']>;
  candidateNote?: Maybe<Scalars['String']['output']>;
  ccRecipients?: Maybe<NotificationPreference>;
  customLocation?: Maybe<Scalars['String']['output']>;
  interviewerCalendarId?: Maybe<Scalars['String']['output']>;
  isPrivateCalendarEvent?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<SelfScheduleLocation>;
  meetingHost?: Maybe<SelfScheduleMeetingHost>;
  numberOfDays?: Maybe<Scalars['numeric']['output']>;
  rollingDays?: Maybe<Scalars['numeric']['output']>;
  shouldRespectLoadLimit?: Maybe<Scalars['Boolean']['output']>;
  useRollingDays?: Maybe<Scalars['Boolean']['output']>;
  videoMeetingHostEmployeeId?: Maybe<Scalars['uuid']['output']>;
  zoomHost?: Maybe<SelfScheduleZoomHost>;
  zoomHostUserId?: Maybe<Scalars['String']['output']>;
};

/**  mimics the db object */
export type SelfScheduleOptions = {
  __typename?: 'SelfScheduleOptions';
  applicationId: Scalars['uuid']['output'];
  candidateEmailTemplateId?: Maybe<Scalars['uuid']['output']>;
  candidateEventTemplateId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['datetime']['output']>;
  creatorEmployeeId?: Maybe<Scalars['uuid']['output']>;
  deletedAt?: Maybe<Scalars['datetime']['output']>;
  id: Scalars['uuid']['output'];
  interviewMeetingLocationSetting?: Maybe<InterviewMeetingLocationSettingPref>;
  interviewerEventTemplateId?: Maybe<Scalars['uuid']['output']>;
  jobStageId: Scalars['uuid']['output'];
  lastUpdatedByEmployeeId?: Maybe<Scalars['uuid']['output']>;
  options?: Maybe<Options>;
  orgId: Scalars['uuid']['output'];
  rescheduledAt?: Maybe<Scalars['datetime']['output']>;
  selfScheduleEmailSentAt?: Maybe<Scalars['datetime']['output']>;
  selfScheduleEmailTemplateId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['datetime']['output']>;
};

/**  delete */
export type SelfScheduleOptionsDeleteInput = {
  __typename?: 'SelfScheduleOptionsDeleteInput';
  id: Scalars['uuid']['output'];
};

export type SelfScheduleOptionsInput = {
  id: Scalars['uuid']['input'];
};

export type SelfScheduleOptionsSettingInput = {
  advanceNoticeInHours?: InputMaybe<Scalars['numeric']['input']>;
  bccRecipients?: InputMaybe<NotificationPreferenceInput>;
  canScheduleOverAvailableKeywords?: InputMaybe<Scalars['Boolean']['input']>;
  canScheduleOverFreeTime?: InputMaybe<Scalars['Boolean']['input']>;
  canScheduleOverRecruitingKeywords?: InputMaybe<Scalars['Boolean']['input']>;
  candidateCalendarId?: InputMaybe<Scalars['String']['input']>;
  candidateNote?: InputMaybe<Scalars['String']['input']>;
  ccRecipients?: InputMaybe<NotificationPreferenceInput>;
  customLocation?: InputMaybe<Scalars['String']['input']>;
  interviewerCalendarId?: InputMaybe<Scalars['String']['input']>;
  isPrivateCalendarEvent?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<SelfScheduleLocation>;
  meetingHost?: InputMaybe<SelfScheduleMeetingHost>;
  numberOfDays?: InputMaybe<Scalars['numeric']['input']>;
  rollingDays?: InputMaybe<Scalars['numeric']['input']>;
  shouldRespectLoadLimit?: InputMaybe<Scalars['Boolean']['input']>;
  useRollingDays?: InputMaybe<Scalars['Boolean']['input']>;
  videoMeetingHostEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  zoomHost?: InputMaybe<SelfScheduleZoomHost>;
  zoomHostUserId?: InputMaybe<Scalars['String']['input']>;
};

/** upsert */
export type SelfScheduleOptionsUpsertInput = {
  candidateEmailContent?: InputMaybe<CandidateEmailContentInput>;
  candidateEmailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  candidateEventTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  interviewMeetingLocationSetting?: InputMaybe<InterviewMeetingLocationSettingsInput>;
  interviewerEventTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  options: OptionsInput;
  taskId: Scalars['uuid']['input'];
};

/**
 * Specifies who will host the Zoom meeting for a self-scheduled interview.
 * This enum is used when the interview location is set to Zoom.
 */
export enum SelfScheduleZoomHost {
  /** A custom Zoom host will be used for the meeting. */
  CustomZoomHost = 'CUSTOM_ZOOM_HOST',
  /** The interviewer will host the Zoom meeting. */
  Interviewer = 'INTERVIEWER',
  /** The Zoom host has not been specified. */
  NotSet = 'NOT_SET',
  /** The scheduler will host the Zoom meeting. */
  Scheduler = 'SCHEDULER'
}

/**
 * One configured default additional attendee and the role that recipient alone gets. Unlike the
 * event-side AdditionalAttendee, a dynamic audience is a recipient here rather than provenance: a
 * setting has no application to resolve it against, so the audience carries the role every member it
 * materializes into will inherit.
 */
export type SettingAdditionalAttendee = {
  __typename?: 'SettingAdditionalAttendee';
  /** Set when this entry names an audience resolved per application at schedule time. */
  dynamicAudience?: Maybe<DynamicAudience>;
  /** Set when this entry names a free-form address. */
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  /** Set when this entry names a specific employee. */
  employeeId?: Maybe<Scalars['uuid']['output']>;
  isOptional: Scalars['Boolean']['output'];
};

export type SettingAdditionalAttendeeInput = {
  dynamicAudience?: InputMaybe<DynamicAudience>;
  /** Give exactly one of email, employeeId, or dynamicAudience; zero or several is rejected. */
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['uuid']['input']>;
  /** Defaults to false (a required attendee) when omitted. */
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingAdditionalAttendees = {
  __typename?: 'SettingAdditionalAttendees';
  attendees: Array<SettingAdditionalAttendee>;
  level: SettingLevel;
};

export type SettingAdditionalAttendeesInput = {
  attendees: Array<SettingAdditionalAttendeeInput>;
};

export type SettingBoolValue = {
  __typename?: 'SettingBoolValue';
  level: SettingLevel;
  value: Scalars['Boolean']['output'];
};

export type SettingCalendarId = {
  __typename?: 'SettingCalendarId';
  /** Set when remoteCalendarId was resolved from a smart token rather than stored directly. */
  dynamicValue?: Maybe<CalendarDynamicValue>;
  level?: Maybe<SettingLevel>;
  remoteCalendar?: Maybe<Calendar>;
  remoteCalendarId?: Maybe<Scalars['String']['output']>;
};

export type SettingChatConversation = {
  __typename?: 'SettingChatConversation';
  chatConversation?: Maybe<Conversation>;
  chatConversationId?: Maybe<Scalars['uuid']['output']>;
  chatConversationType?: Maybe<ChatConversationType>;
  level: SettingLevel;
};

export type SettingDuration = {
  __typename?: 'SettingDuration';
  duration: Duration;
  level: SettingLevel;
};

export type SettingIntValue = {
  __typename?: 'SettingIntValue';
  level: SettingLevel;
  value: Scalars['numeric']['output'];
};

export enum SettingLevel {
  Employee = 'EMPLOYEE',
  Job = 'JOB',
  JobStage = 'JOB_STAGE',
  Org = 'ORG'
}

export type SettingLocaleValue = {
  __typename?: 'SettingLocaleValue';
  level: SettingLevel;
  value?: Maybe<Locale>;
};

export type SettingNotificationPreference = {
  __typename?: 'SettingNotificationPreference';
  level: SettingLevel;
  notificationPreference: NotificationPreference;
};

export type SettingStringValue = {
  __typename?: 'SettingStringValue';
  level: SettingLevel;
  value: Scalars['String']['output'];
};

export type SettingTemplateId = {
  __typename?: 'SettingTemplateId';
  level?: Maybe<SettingLevel>;
  template?: Maybe<Template>;
  templateId?: Maybe<Scalars['uuid']['output']>;
};

/** ########################################## */
export type ShortUrlCreateInput = {
  longUrl: Scalars['String']['input'];
};

export type ShortUrlCreateResult = {
  __typename?: 'ShortUrlCreateResult';
  shortUrl: Scalars['String']['output'];
};

/** A ledger entry recording access to a single candidate's or employee's personal information. */
export type SinglePrivacyAuditLogEntry = PrivacyAuditLogEntry & {
  __typename?: 'SinglePrivacyAuditLogEntry';
  accessData: Array<PrivacyAuditAccessData>;
  accessMenu: Scalars['String']['output'];
  accessMenuPath: Scalars['String']['output'];
  accessTime: Scalars['datetime']['output'];
  activityCategory: PrivacyAuditActivityCategory;
  actor?: Maybe<Employee>;
  actorId: Scalars['uuid']['output'];
  customData?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  ipAddresses: Array<Scalars['String']['output']>;
  /** The candidate or employee whose PI was accessed; null if that subject was deleted. */
  subject?: Maybe<PrivacyAuditSubject>;
  /** Raw data-subject id, always present even when the subject was deleted. */
  subjectId: Scalars['uuid']['output'];
  subjectType: PrivacyAuditSubjectType;
  /** Optional reason supplied for the access. It can appear on any activity category. */
  userProvidedReason?: Maybe<Scalars['String']['output']>;
};

/** Represents a Slack channel. */
export type SlackChannel = {
  __typename?: 'SlackChannel';
  /** The ID of the Slack channel. */
  id: Scalars['String']['output'];
  /** The name of the Slack channel. */
  name: Scalars['String']['output'];
};

export type SlackChannelContentInput = {
  /**  Nullable for rollout compat: old clients omit it, which the backend treats as empty. */
  attachments?: InputMaybe<Array<RemoteAttachmentInput>>;
  conversationId?: InputMaybe<Scalars['uuid']['input']>;
  conversationMemberDynamicAudienceTypes?: InputMaybe<Array<DynamicAudience>>;
  conversationMemberEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  slackChannelHiringManagerEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  slackChannelId?: InputMaybe<Scalars['String']['input']>;
  slackChannelInterviewerEmployeeIds: Array<Scalars['uuid']['input']>;
  slackChannelMessageContent: Scalars['String']['input'];
  slackChannelName?: InputMaybe<Scalars['String']['input']>;
  slackChannelRecruitingTeamEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  slackTemplateId?: InputMaybe<Scalars['uuid']['input']>;
};

export type SlackEmployeeIntegration = {
  __typename?: 'SlackEmployeeIntegration';
  active: Scalars['Boolean']['output'];
  scopes: Array<Scalars['String']['output']>;
  slackTeamId: Scalars['String']['output'];
  slackUserId: Scalars['String']['output'];
};

export type SlackIntegrationHealth = {
  __typename?: 'SlackIntegrationHealth';
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

export type SlackOrgIntegration = {
  __typename?: 'SlackOrgIntegration';
  active: Scalars['Boolean']['output'];
  slackTeamId: Scalars['String']['output'];
};

export type SmartRecruitersConfig = {
  __typename?: 'SmartRecruitersConfig';
  hiringProcesses?: Maybe<Array<SmartRecruitersHiringProcess>>;
};

export type SmartRecruitersHiringProcess = {
  __typename?: 'SmartRecruitersHiringProcess';
  atsId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Keep in sync with interview_db.proto#SmartRecruitersHiringProcessStatus */
export enum SmartRecruitersHiringProcessStatus {
  Deleted = 'DELETED',
  Mismatch = 'MISMATCH',
  NotSet = 'NOT_SET',
  Set = 'SET'
}

export type SmartRecruitersHiringProcessWithStatus = {
  __typename?: 'SmartRecruitersHiringProcessWithStatus';
  atsId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: SmartRecruitersHiringProcessStatus;
};

export type SmartRecruitersIntegration = {
  __typename?: 'SmartRecruitersIntegration';
  active: Scalars['Boolean']['output'];
  apiKey?: Maybe<Scalars['String']['output']>;
};

export type SmartRecruitersIntegrationHealth = {
  __typename?: 'SmartRecruitersIntegrationHealth';
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

/** SmartRecruiters-specific fields for jobs. */
export type SmartRecruitersJob = {
  __typename?: 'SmartRecruitersJob';
  atsPostingId?: Maybe<Scalars['String']['output']>;
  brandId?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['String']['output']>;
  jobRequisitionId?: Maybe<Scalars['String']['output']>;
};

/** Represents sorting order options for queries that support ordering. */
export enum Sort {
  /** Ascending order (A to Z, 0 to 9, or oldest to newest). */
  Asc = 'ASC',
  /** Descending order (Z to A, 9 to 0, or newest to oldest). */
  Desc = 'DESC'
}

/** Enum representing sorting filters for applications. */
export enum SortFilter {
  LastActivityAsc = 'LAST_ACTIVITY_ASC',
  LastActivityDesc = 'LAST_ACTIVITY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC'
}

/** Represents the types of sources for activity logs. */
export enum SourceType {
  SourceTypeApplication = 'SOURCE_TYPE_APPLICATION',
  SourceTypeCandidate = 'SOURCE_TYPE_CANDIDATE',
  SourceTypeEmployee = 'SOURCE_TYPE_EMPLOYEE',
  SourceTypeInterviewModule = 'SOURCE_TYPE_INTERVIEW_MODULE',
  SourceTypeJob = 'SOURCE_TYPE_JOB',
  SourceTypeOrg = 'SOURCE_TYPE_ORG',
  SourceTypeTask = 'SOURCE_TYPE_TASK',
  SourceTypeTaskQueue = 'SOURCE_TYPE_TASK_QUEUE'
}

/** Represents a sourcing link used in the recruitment process. */
export type SourcingLink = {
  __typename?: 'SourcingLink';
  /** The coordinator associated with this sourcing link. */
  candidateCoordinator?: Maybe<Employee>;
  /** The ID of the coordinator associated with this sourcing link. */
  candidateCoordinatorId?: Maybe<Scalars['uuid']['output']>;
  /** The recruiter associated with this sourcing link. */
  candidateRecruiter?: Maybe<Employee>;
  /** The ID of the recruiter associated with this sourcing link. */
  candidateRecruiterId?: Maybe<Scalars['uuid']['output']>;
  /** The sourcer associated with this sourcing link. */
  candidateSourcer?: Maybe<Employee>;
  /** The ID of the sourcer associated with this sourcing link. */
  candidateSourcerId?: Maybe<Scalars['uuid']['output']>;
  /** The timestamp when the sourcing link was created. */
  createdAt: Scalars['datetime']['output'];
  /** The employee who created the sourcing link. */
  createdBy?: Maybe<Employee>;
  /** The timestamp when this sourcing link was deactivated, if applicable. */
  deactivatedAt?: Maybe<Scalars['datetime']['output']>;
  /** The unique identifier of the sourcing link. */
  id: Scalars['uuid']['output'];
  /** The initial job stage for this sourcing link. */
  initialJobStage?: Maybe<JobStage>;
  /** The ID of the initial job stage for this sourcing link. */
  initialJobStageId: Scalars['uuid']['output'];
  /** The job stage associated with the interview plan for this sourcing link. */
  interviewPlanJobStage?: Maybe<JobStage>;
  /** The ID of the job stage associated with the interview plan for this sourcing link. */
  interviewPlanJobStageId: Scalars['uuid']['output'];
  /** The name of the sourcing link. */
  name: Scalars['String']['output'];
  /** The organization ID associated with this sourcing link. */
  orgId: Scalars['uuid']['output'];
  /** The recruiting source associated with this sourcing link. */
  recruitingSource?: Maybe<Scalars['String']['output']>;
  /** The stored resume requirement for this sourcing link. This setting is effective only when the organization accepts resumes. */
  requireResume: Scalars['Boolean']['output'];
  /** The action associated with the task for this sourcing link. */
  taskAction: SourcingLinkTaskAction;
  /** The employee assigned to the task associated with this sourcing link. */
  taskAssignee?: Maybe<Employee>;
  /** The ID of the employee assigned to the task associated with this sourcing link. */
  taskAssigneeId: Scalars['uuid']['output'];
  /** The IDs of employees subscribed to the task associated with this sourcing link. */
  taskSubscriberIds: Array<Scalars['uuid']['output']>;
  /** The employees subscribed to the task associated with this sourcing link. */
  taskSubscribers: Array<Employee>;
  /** The timestamp when the sourcing link was last updated. */
  updatedAt: Scalars['datetime']['output'];
  /** The employee who last updated the sourcing link. */
  updatedBy?: Maybe<Employee>;
};

/** Input for creating a new sourcing link. */
export type SourcingLinkCreateInput = {
  /** The ID of the coordinator associated with this sourcing link. */
  candidateCoordinatorId?: InputMaybe<Scalars['uuid']['input']>;
  /** The ID of the recruiter associated with this sourcing link. */
  candidateRecruiterId?: InputMaybe<Scalars['uuid']['input']>;
  /** The ID of the sourcer associated with this sourcing link. */
  candidateSourcerId?: InputMaybe<Scalars['uuid']['input']>;
  /** The ID of the initial job stage for this sourcing link. */
  initialJobStageId: Scalars['uuid']['input'];
  /** The interview plan for this sourcing link. */
  interviewPlan?: InputMaybe<InterviewPlanInput>;
  /**
   * The interview groups associated with job stages (deprecated).
   * @deprecated Use interviewPlan instead
   */
  jobStageInterviewGroups?: InputMaybe<Array<JobStageInterviewGroupInput>>;
  /** The name of the sourcing link. */
  name: Scalars['String']['input'];
  /** The recruiting source associated with this sourcing link. */
  recruitingSource?: InputMaybe<Scalars['String']['input']>;
  /** Whether to store a resume requirement on this sourcing link. */
  requireResume?: InputMaybe<Scalars['Boolean']['input']>;
  /** The action associated with the task for this sourcing link. */
  taskAction: SourcingLinkTaskAction;
  /** The ID of the employee assigned to the task associated with this sourcing link. */
  taskAssigneeId?: InputMaybe<Scalars['uuid']['input']>;
  /** The IDs of employees subscribed to the task associated with this sourcing link. */
  taskSubscriberIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Result type for sourcing link queries. */
export type SourcingLinkResult = {
  __typename?: 'SourcingLinkResult';
  /** The retrieved sourcing link. */
  sourcingLink: SourcingLink;
};

/**
 * Specifies the actions available for sourcing link tasks in the recruitment process.
 * These actions define the next steps a candidate can take when interacting with a sourcing link.
 */
export enum SourcingLinkTaskAction {
  /**
   * Prompts candidates to provide their availability for potential interview or assessment times.
   * This option is useful when the recruiter needs to collect availability information before scheduling.
   */
  Availability = 'AVAILABILITY',
  /**
   * Allows candidates to schedule their own interview or assessment time slot.
   * This option promotes flexibility and can improve candidate experience by giving them control over scheduling.
   */
  SelfSchedule = 'SELF_SCHEDULE'
}

/**
 * Input for updating an existing sourcing link.
 * Pass null to remove a value. Don't pass the field to keep the value unchanged.
 */
export type SourcingLinkUpdateInput = {
  /** The updated ID of the coordinator associated with this sourcing link. */
  candidateCoordinatorId?: InputMaybe<Scalars['uuid']['input']>;
  /** The updated ID of the recruiter associated with this sourcing link. */
  candidateRecruiterId?: InputMaybe<Scalars['uuid']['input']>;
  /** The updated ID of the sourcer associated with this sourcing link. */
  candidateSourcerId?: InputMaybe<Scalars['uuid']['input']>;
  /** The ID of the sourcing link to update. */
  id: Scalars['uuid']['input'];
  /** The updated ID of the initial job stage for this sourcing link. */
  initialJobStageId?: InputMaybe<Scalars['uuid']['input']>;
  /** The updated interview plan for this sourcing link. */
  interviewPlan?: InputMaybe<InterviewPlanInput>;
  /** Indicates whether the sourcing link should be active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The updated interview groups associated with job stages (deprecated).
   * @deprecated Use interviewPlan instead
   */
  jobStageInterviewGroups?: InputMaybe<Array<JobStageInterviewGroupInput>>;
  /** The updated name of the sourcing link. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The updated recruiting source associated with this sourcing link. */
  recruitingSource?: InputMaybe<Scalars['String']['input']>;
  /** Whether to store a resume requirement on this sourcing link. */
  requireResume?: InputMaybe<Scalars['Boolean']['input']>;
  /** The updated action associated with the task for this sourcing link. */
  taskAction?: InputMaybe<SourcingLinkTaskAction>;
  /** The updated ID of the employee assigned to the task associated with this sourcing link. */
  taskAssigneeId?: InputMaybe<Scalars['uuid']['input']>;
  /** The updated IDs of employees subscribed to the task associated with this sourcing link. */
  taskSubscriberIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** Enum representing different status filters for applications. */
export enum StatusFilter {
  AvailabilityNotRequested = 'AVAILABILITY_NOT_REQUESTED',
  AvailabilityRequested = 'AVAILABILITY_REQUESTED',
  Canceled = 'CANCELED',
  CandidateDeclined = 'CANDIDATE_DECLINED',
  Completed = 'COMPLETED',
  CompletedInAts = 'COMPLETED_IN_ATS',
  HoldForRsvp = 'HOLD_FOR_RSVP',
  InterviewerDeclined = 'INTERVIEWER_DECLINED',
  NotSchedulable = 'NOT_SCHEDULABLE',
  Ongoing = 'ONGOING',
  ReadyForCandidateComms = 'READY_FOR_CANDIDATE_COMMS',
  ReadyToSchedule = 'READY_TO_SCHEDULE',
  Schedulable = 'SCHEDULABLE',
  Scheduled = 'SCHEDULED',
  ScheduledInAts = 'SCHEDULED_IN_ATS',
  SelfScheduleNotRequested = 'SELF_SCHEDULE_NOT_REQUESTED',
  SelfScheduleRequested = 'SELF_SCHEDULE_REQUESTED',
  Unscheduled = 'UNSCHEDULED'
}

/** Input for grouping status filters. */
export type StatusFilterGroup = {
  /** List of status filters to apply. */
  statusFilters?: InputMaybe<Array<InputMaybe<StatusFilter>>>;
};

export enum StringArrayEmployeePref {
  /**  keep-sorted:begin */
  ArrAvailableKeywords = 'arr_available_keywords',
  ArrAvoidKeywords = 'arr_avoid_keywords',
  ArrDoNotShowAgainModals = 'arr_do_not_show_again_modals',
  ArrOutOfOfficeKeywords = 'arr_out_of_office_keywords',
  ArrRecentlyUsedTimezones = 'arr_recently_used_timezones',
  ArrRecruitingBlockKeywords = 'arr_recruiting_block_keywords'
}

export type StringArrayEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'StringArrayEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  /**  The array is declared as nullable because if both org and employee pref is not set, array will be null. */
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export enum StringArrayOrgPref {
  /**  keep-sorted:begin */
  ArrHardConflictPhrases = 'arr_hard_conflict_phrases',
  ArrOrgInternalMeetingDomains = 'arr_org_internal_meeting_domains',
  ArrOutOfOfficePhrases = 'arr_out_of_office_phrases',
  ArrOutlookSharedCalendarOwnerIds = 'arr_outlook_shared_calendar_owner_ids',
  ArrRecruitingBlockPhrases = 'arr_recruiting_block_phrases',
  ArrSoftConflictPhrases = 'arr_soft_conflict_phrases',
  ArrSupportedLocales = 'arr_supported_locales'
}

export enum StringEmployeePref {
  /**  keep-sorted:begin */
  StrBio = 'str_bio',
  StrCandidateCalendarInviteTemplateId = 'str_candidate_calendar_invite_template_id',
  StrCandidateEmailConfirmationTemplateId = 'str_candidate_email_confirmation_template_id',
  StrInternalInterviewerNote = 'str_internal_interviewer_note',
  StrInterviewerCalendarInviteTemplateId = 'str_interviewer_calendar_invite_template_id',
  StrInterviewerConversationMessageTemplateId = 'str_interviewer_conversation_message_template_id',
  StrPronouns = 'str_pronouns',
  StrSignature = 'str_signature'
}

export type StringEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'StringEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum StringOrgPref {
  /**  keep-sorted:begin */
  StrAeName = 'str_ae_name',
  StrAiAgentEmailAddress = 'str_ai_agent_email_address',
  StrAiAgentName = 'str_ai_agent_name',
  StrAiModelFamily = 'str_ai_model_family',
  StrApplicantPrivacyPolicyUrl = 'str_applicant_privacy_policy_url',
  StrAshbyDefaultRemoteInterviewId = 'str_ashby_default_remote_interview_id',
  StrAvailabilityRequestCandidateNote = 'str_availability_request_candidate_note',
  StrCoderpadCodingLinkTitleTemplate = 'str_coderpad_coding_link_title_template',
  StrCodesignalCandidateEmail = 'str_codesignal_candidate_email',
  StrCodesignalCandidateName = 'str_codesignal_candidate_name',
  StrCodilityCandidateEmail = 'str_codility_candidate_email',
  StrCodilityCodingLinkTitleTemplate = 'str_codility_coding_link_title_template',
  StrCsmName = 'str_csm_name',
  StrDefaultCandidateCalendar = 'str_default_candidate_calendar',
  StrDefaultInterviewPlanBreakType = 'str_default_interview_plan_break_type',
  StrDefaultInterviewerCalendar = 'str_default_interviewer_calendar',
  StrDefaultTaskComment = 'str_default_task_comment',
  StrDefaultUserRole = 'str_default_user_role',
  StrHackerrankCandidateEmail = 'str_hackerrank_candidate_email',
  StrHackerrankCandidateName = 'str_hackerrank_candidate_name',
  StrHackerrankCodingLinkTitleTemplate = 'str_hackerrank_coding_link_title_template',
  StrLocale = 'str_locale',
  StrScheduleCandidateEventSplit = 'str_schedule_candidate_event_split',
  StrSelfScheduleRequestCandidateNote = 'str_self_schedule_request_candidate_note',
  StrSlackChannelNameFormat = 'str_slack_channel_name_format',
  StrTaskDefaultAssigneeAvailabilityRequests = 'str_task_default_assignee_availability_requests',
  StrTaskDefaultAssigneeRequestToSchedule = 'str_task_default_assignee_request_to_schedule',
  StrTaskDefaultAssigneeSelfScheduleRequests = 'str_task_default_assignee_self_schedule_requests',
  StrZoomMeetingTopicTemplate = 'str_zoom_meeting_topic_template'
}

/** Input for adding a subscriber. */
export type SubscriberAddInput = {
  employeeIds: Array<Scalars['uuid']['input']>;
  sourceId: Scalars['uuid']['input'];
  sourceType?: InputMaybe<SourceType>;
};

/** Result of adding a subscriber. */
export type SubscriberAddResult = {
  __typename?: 'SubscriberAddResult';
  result?: Maybe<Result>;
  /**  SUCCESS | FAILURE */
  subscribers: Array<Employee>;
};

/** Input for removing a subscriber. */
export type SubscriberRemoveInput = {
  employeeIds: Array<Scalars['uuid']['input']>;
  sourceId: Scalars['uuid']['input'];
  sourceType?: InputMaybe<SourceType>;
};

/** Result of removing a subscriber. */
export type SubscriberRemoveResult = {
  __typename?: 'SubscriberRemoveResult';
  result?: Maybe<Result>;
  /**  SUCCESS | FAILURE */
  subscribers: Array<Employee>;
};

export type SubscribersInput = {
  pageInput: PageInput;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['uuid']['input'];
  sourceType?: InputMaybe<SourceType>;
};

export type SubscribersResult = {
  __typename?: 'SubscribersResult';
  cursor?: Maybe<Scalars['String']['output']>;
  items: Array<Employee>;
};

export type Subscription = {
  __typename?: 'Subscription';
  activityLogCreated: ActivityLog;
  employeeNotificationReceived: EmployeeNotification;
  taskUpdated: TaskUpdatedPayload;
};


export type SubscriptionActivityLogCreatedArgs = {
  input: ActivityLogSubscriptionInput;
};


export type SubscriptionTaskUpdatedArgs = {
  input: TaskUpdatedSubscriptionInput;
};

export type SuggestedSchedule = {
  __typename?: 'SuggestedSchedule';
  id: Scalars['uuid']['output'];
  interviews: Array<SuggestedScheduledInterview>;
};

export type SuggestedScheduledInterview = {
  __typename?: 'SuggestedScheduledInterview';
  endAt: Scalars['datetime']['output'];
  /**  Job stage interview id. */
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  seats: Array<SuggestedScheduledInterviewSeat>;
  startAt: Scalars['datetime']['output'];
};

export type SuggestedScheduledInterviewSeat = {
  __typename?: 'SuggestedScheduledInterviewSeat';
  /**  Job stage interview seat id. */
  id: Scalars['uuid']['output'];
  interviewers: Array<InterviewerWithRole>;
};

export type SuggestedTimeRangesCountInput = {
  advanceNoticeHours: Scalars['numeric']['input'];
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  canScheduleOverAvailableKeywords: Scalars['Boolean']['input'];
  canScheduleOverFreeTime: Scalars['Boolean']['input'];
  canScheduleOverRecruitingKeywords: Scalars['Boolean']['input'];
  /** @deprecated Use interviewPlan instead */
  customInterviewPlan?: InputMaybe<Array<JobStageInterviewGroupInput>>;
  includeEmptyRanges: Scalars['Boolean']['input'];
  interviewPlan?: InputMaybe<InterviewPlanInput>;
  requestType?: InputMaybe<SuggestedTimeRangesRequestType>;
  shouldRespectLoadLimit: Scalars['Boolean']['input'];
  /** @deprecated Use requestType instead */
  stepDurationMinutes?: InputMaybe<Scalars['numeric']['input']>;
  /**  exactly one of the following must be provided */
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  timeRange: DateTimeRangeInput;
  /** @deprecated Use validateZoomHostType instead */
  validateZoomHost?: InputMaybe<Scalars['Boolean']['input']>;
  validateZoomHostType?: InputMaybe<DynamicInterviewMeetingHost>;
};

export type SuggestedTimeRangesCountOutput = {
  __typename?: 'SuggestedTimeRangesCountOutput';
  employeeMissingZoomUserId: Array<Scalars['uuid']['output']>;
  timeRangeCounts: Array<TimeRangeCount>;
};

export enum SuggestedTimeRangesRequestType {
  AvailabilityRequest = 'AVAILABILITY_REQUEST',
  SelfScheduleRequest = 'SELF_SCHEDULE_REQUEST'
}

export type SwitchActiveOrganizationInput = {
  /** An Organization the acting user is a member of. */
  organizationId: Scalars['uuid']['input'];
};

/**
 * The acting user holds no Membership in that Organization, or that Organization no longer exists.
 * One member for both: an answer must not tell a user that an Organization they cannot reach exists.
 */
export type SwitchActiveOrganizationNotAMemberError = Error & {
  __typename?: 'SwitchActiveOrganizationNotAMemberError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/** The request impersonates another user. Switching would move that user's own selection. */
export type SwitchActiveOrganizationNotAllowedWhileImpersonatingError = Error & {
  __typename?: 'SwitchActiveOrganizationNotAllowedWhileImpersonatingError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type SwitchActiveOrganizationOutput = SwitchActiveOrganizationNotAMemberError | SwitchActiveOrganizationNotAllowedWhileImpersonatingError | SwitchActiveOrganizationSuccess | UnknownError;

export type SwitchActiveOrganizationSuccess = {
  __typename?: 'SwitchActiveOrganizationSuccess';
  /** The Organization every later request of this user resolves to. */
  activeOrganizationId: Scalars['uuid']['output'];
};

export type SyncApplicationInput = {
  applicationId: Scalars['uuid']['input'];
};

export type SyncApplicationOutput = SyncApplicationSuccess | SyncNotFoundError | SyncRateLimitedError | SyncUnsupportedError | UnknownError;

export type SyncApplicationSuccess = {
  __typename?: 'SyncApplicationSuccess';
  /** True once the application re-sync has been enqueued. The sync itself completes asynchronously. */
  enqueued: Scalars['Boolean']['output'];
};

export type SyncCandidateInput = {
  candidateId: Scalars['uuid']['input'];
};

export type SyncCandidateOutput = SyncCandidateSuccess | SyncNotFoundError | SyncRateLimitedError | UnknownError;

export type SyncCandidateSuccess = {
  __typename?: 'SyncCandidateSuccess';
  /** True once the candidate re-sync has been enqueued. The sync itself completes asynchronously. */
  enqueued: Scalars['Boolean']['output'];
};

export type SyncEmployeeAtsInput = {
  employeeId: Scalars['uuid']['input'];
};

export type SyncEmployeeAtsOutput = SyncEmployeeAtsSuccess | SyncNotFoundError | SyncRateLimitedError | UnknownError;

export type SyncEmployeeAtsSuccess = {
  __typename?: 'SyncEmployeeAtsSuccess';
  /**
   * True once the re-sync of the employee's linked ATS user record has been enqueued. The sync
   * itself completes asynchronously.
   */
  enqueued: Scalars['Boolean']['output'];
};

export type SyncEmployeeCalendarInput = {
  employeeId: Scalars['uuid']['input'];
};

export type SyncEmployeeCalendarOutput = SyncEmployeeCalendarSuccess | SyncRateLimitedError | UnknownError;

export type SyncEmployeeCalendarSuccess = {
  __typename?: 'SyncEmployeeCalendarSuccess';
  /** True once the calendar re-sync has been enqueued. The sync itself completes asynchronously. */
  enqueued: Scalars['Boolean']['output'];
};

export type SyncJobInput = {
  jobId: Scalars['uuid']['input'];
};

export type SyncJobOutput = SyncJobSuccess | SyncNotFoundError | SyncRateLimitedError | SyncUnsupportedError | UnknownError;

export type SyncJobStageInput = {
  jobStageId: Scalars['uuid']['input'];
};

export type SyncJobStageOutput = SyncJobStageSuccess | SyncNotFoundError | SyncRateLimitedError | SyncUnsupportedError | UnknownError;

export type SyncJobStageSuccess = {
  __typename?: 'SyncJobStageSuccess';
  /**
   * True once the re-sync of the job stage's parent job stages has been enqueued. The sync itself
   * completes asynchronously.
   */
  enqueued: Scalars['Boolean']['output'];
};

export type SyncJobSuccess = {
  __typename?: 'SyncJobSuccess';
  /** True once the job re-sync has been enqueued. The sync itself completes asynchronously. */
  enqueued: Scalars['Boolean']['output'];
};

/**
 * Shared error returned when a user-triggered manual entity sync's target has no linked ATS object
 * to re-sync - either the id doesn't resolve to a record, or the record has never been connected to
 * the org's ATS (ENG-26264). Reused by every "Sync <Entity>" mutation in the stack.
 */
export type SyncNotFoundError = Error & {
  __typename?: 'SyncNotFoundError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

/**
 * Shared error returned when a user-triggered manual entity sync is on cooldown (see the
 * ManualSyncRateLimiter debounce, ENG-26262). Reused by the sync mutations that land in later PRs of
 * the "Sync <Entity>" stack.
 */
export type SyncRateLimitedError = Error & {
  __typename?: 'SyncRateLimitedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
  /**
   * Seconds until the manual sync cooldown for this entity expires and another sync attempt may
   * be made. Omitted when the remaining cooldown is not known.
   */
  retryAfterSeconds?: Maybe<Scalars['Int']['output']>;
};

export enum SyncSourceType {
  Directory = 'DIRECTORY',
  Manual = 'MANUAL',
  Scim = 'SCIM'
}

/** The connected ATS cannot safely perform this manual sync operation (ENG-26264). */
export type SyncUnsupportedError = Error & {
  __typename?: 'SyncUnsupportedError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type SyncUserJobPermissionsForEmployeeInput = {
  employeeId: Scalars['uuid']['input'];
};

export type SyncUserJobPermissionsForEmployeeOutput = SyncNotFoundError | SyncRateLimitedError | SyncUnsupportedError | SyncUserJobPermissionsForEmployeeSuccess | UnknownError;

export type SyncUserJobPermissionsForEmployeeSuccess = {
  __typename?: 'SyncUserJobPermissionsForEmployeeSuccess';
  /**
   * True once the scoped user job permissions for an employee sync has been enqueued. The sync itself
   * completes asynchronously.
   */
  enqueued: Scalars['Boolean']['output'];
};

export type SyncUserJobPermissionsForJobInput = {
  jobId: Scalars['uuid']['input'];
};

export type SyncUserJobPermissionsForJobOutput = SyncNotFoundError | SyncRateLimitedError | SyncUnsupportedError | SyncUserJobPermissionsForJobSuccess | UnknownError;

export type SyncUserJobPermissionsForJobSuccess = {
  __typename?: 'SyncUserJobPermissionsForJobSuccess';
  /**
   * True once the scoped user job permissions for a job sync has been enqueued. The sync itself completes
   * asynchronously.
   */
  enqueued: Scalars['Boolean']['output'];
};

/** Represents a system actor in activity logs. */
export type SystemActor = {
  __typename?: 'SystemActor';
  id: Scalars['String']['output'];
};

export type SystemActorV2 = Actor & {
  __typename?: 'SystemActorV2';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ActorType;
};

export type Task = {
  __typename?: 'Task';
  /**  will be added later */
  activityLogs: ActivityLogsResult;
  application: Application;
  assignee?: Maybe<Employee>;
  /**  The availabilities */
  availabilities: Array<CandidateAvailability>;
  /**
   *  The availability provided by recruiting or candidate
   * @deprecated No longer supported
   */
  availability?: Maybe<CandidateAvailability>;
  /**
   *  The availability request if it exists
   * @deprecated No longer supported
   */
  availabilityRequest?: Maybe<CandidateAvailabilityOptions>;
  /**  The availability requests */
  availabilityRequests: Array<CandidateAvailabilityOptions>;
  /**  Canceled time */
  canceledAt?: Maybe<Scalars['datetime']['output']>;
  candidateAvailabilityStartAt?: Maybe<Scalars['datetime']['output']>;
  /**  number of task for this application + job stage */
  count?: Maybe<Scalars['numeric']['output']>;
  /**  Created time */
  createdAt: Scalars['datetime']['output'];
  createdBy: Employee;
  creationSource: TaskCreationSource;
  /**
   *  The single debrief associated to this task
   * @deprecated No longer supported
   */
  debrief?: Maybe<ApplicationDebrief>;
  /**  Debriefs */
  debriefs: Array<ApplicationDebrief>;
  /** The AI agent delegation status. Values: "", "QUEUED", "ACTIVE", "WAITING_ON_CANDIDATE", "WAITING_ON_TEAM", "COMPLETED", "STOPPED". */
  delegateStatus: Scalars['String']['output'];
  /** The AI agent delegation type. Empty string or "AGENT". */
  delegateType: Scalars['String']['output'];
  firstInterviewAt?: Maybe<Scalars['datetime']['output']>;
  /**  Flags */
  flags: Array<TaskFlag>;
  id: Scalars['uuid']['output'];
  /**  Each task should have a custom job stage */
  interviewPlan: JobStage;
  /**  Whether or not the task needs a debrief */
  isDebriefRequired: Scalars['Boolean']['output'];
  /**  Whether or not the task was marked as urgent */
  isUrgent: Scalars['Boolean']['output'];
  /**  use job stage instead */
  jobStage?: Maybe<JobStage>;
  lastActivityAt: Scalars['datetime']['output'];
  /** Task-level meeting location override. Null means use job/org default. */
  meetingLocationSetting?: Maybe<TaskMeetingLocationSetting>;
  /**  activityLog(input): PageableActivityItem! */
  name: Scalars['String']['output'];
  rescheduleLogs: RescheduleLogsResult;
  /**  The schedules associated to this task */
  schedule?: Maybe<ApplicationStage>;
  scheduleCreatedAt?: Maybe<Scalars['datetime']['output']>;
  schedules: Array<ApplicationStage>;
  /**
   *  The self schedule request if it exists
   * @deprecated No longer supported
   */
  selfScheduleRequest?: Maybe<SelfScheduleOptions>;
  /**  The self schedule requests */
  selfScheduleRequests: Array<SelfScheduleOptions>;
  sourcingLink?: Maybe<SourcingLink>;
  /**
   *  Recruiter selected stage when making the task
   * @deprecated No longer supported
   */
  stage?: Maybe<JobStage>;
  status: TaskStatus;
  suggestedSchedules: Array<SuggestedSchedule>;
  /**  Tags */
  tags: Array<TaskTag>;
  taskQueue?: Maybe<TaskQueue>;
};


export type TaskActivityLogsArgs = {
  input: ActivityLogsForSourceInput;
};


export type TaskRescheduleLogsArgs = {
  input: RescheduleLogsInput;
};


export type TaskSuggestedSchedulesArgs = {
  input: TaskSuggestedSchedulesInput;
};

export type TaskAssigneesInput = {
  assigneeIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
  showUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents the possible reasons for task auto-cancel failure. */
export enum TaskAutoCancelFailureReason {
  CalendarNotFound = 'CALENDAR_NOT_FOUND',
  CalendarPermissionDenied = 'CALENDAR_PERMISSION_DENIED',
  EmployeeDeprovisioned = 'EMPLOYEE_DEPROVISIONED',
  FailureReasonUnspecified = 'FAILURE_REASON_UNSPECIFIED',
  IntegrationDisconnected = 'INTEGRATION_DISCONNECTED',
  Unknown = 'UNKNOWN'
}

export type TaskCancelInput = {
  taskId: Scalars['uuid']['input'];
};

export type TaskCreateInput = {
  applicationId: Scalars['uuid']['input'];
  assigneeEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  availability?: InputMaybe<Array<DateTimeRangeInput>>;
  candidateTimezone: Scalars['timezone']['input'];
  creationSource: TaskCreationSource;
  /** @deprecated Use interviewPlan instead */
  customInterviewPlan?: InputMaybe<Array<JobStageInterviewGroupInput>>;
  customJobStageId: Scalars['uuid']['input'];
  interviewPlan?: InputMaybe<InterviewPlanInput>;
  isDebriefRequired: Scalars['Boolean']['input'];
  isUrgent: Scalars['Boolean']['input'];
  jobStageId: Scalars['uuid']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  subscriberEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** Optional client-provided task ID for idempotency. If not provided, a random UUID will be generated. */
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  taskQueueId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TaskCreateResult = {
  __typename?: 'TaskCreateResult';
  task: Task;
};

export enum TaskCreateValidateErrorFlagType {
  ApplicationNotInSchedulableState = 'APPLICATION_NOT_IN_SCHEDULABLE_STATE',
  AshbyApplicationNotOnJobDefaultInterviewPlan = 'ASHBY_APPLICATION_NOT_ON_JOB_DEFAULT_INTERVIEW_PLAN',
  BackupSenderHasInsufficientPermissionOnCandidateCalendar = 'BACKUP_SENDER_HAS_INSUFFICIENT_PERMISSION_ON_CANDIDATE_CALENDAR',
  BackupSenderHasInsufficientPermissionOnInternalCalendar = 'BACKUP_SENDER_HAS_INSUFFICIENT_PERMISSION_ON_INTERNAL_CALENDAR',
  BackupSenderIsIneligible = 'BACKUP_SENDER_IS_INELIGIBLE',
  CalendarNotSetCandidate = 'CALENDAR_NOT_SET_CANDIDATE',
  CalendarNotSetInterviewer = 'CALENDAR_NOT_SET_INTERVIEWER',
  CandidateHasNoEmail = 'CANDIDATE_HAS_NO_EMAIL',
  CandidateIsAnonymized = 'CANDIDATE_IS_ANONYMIZED',
  HiringProcessMismatch = 'HIRING_PROCESS_MISMATCH',
  /** # Used by FE to show error message on sourcing link with deleted job stage. */
  HiringProcessSetupRequired = 'HIRING_PROCESS_SETUP_REQUIRED',
  InterviewerDoesNotHaveZoomAccount = 'INTERVIEWER_DOES_NOT_HAVE_ZOOM_ACCOUNT',
  InterviewDefinitionDoesNotExistOnJob = 'INTERVIEW_DEFINITION_DOES_NOT_EXIST_ON_JOB',
  InterviewPlanHasDynamicBreaks = 'INTERVIEW_PLAN_HAS_DYNAMIC_BREAKS',
  InterviewPlanHasHiddenInterviews = 'INTERVIEW_PLAN_HAS_HIDDEN_INTERVIEWS',
  InterviewPlanHasUnschedulableInterviewDefinition = 'INTERVIEW_PLAN_HAS_UNSCHEDULABLE_INTERVIEW_DEFINITION',
  InterviewPlanIncomplete = 'INTERVIEW_PLAN_INCOMPLETE',
  InterviewPlanSeatWithZeroEligibleInterviewers = 'INTERVIEW_PLAN_SEAT_WITH_ZERO_ELIGIBLE_INTERVIEWERS',
  InterviewPlanSeatWithZeroInterviewers = 'INTERVIEW_PLAN_SEAT_WITH_ZERO_INTERVIEWERS',
  InterviewPlanWithMultiDay = 'INTERVIEW_PLAN_WITH_MULTI_DAY',
  /** # Error flags */
  InterviewPlanWithZeroInterviews = 'INTERVIEW_PLAN_WITH_ZERO_INTERVIEWS',
  MissingInterviewMeetingLocation = 'MISSING_INTERVIEW_MEETING_LOCATION',
  MissingZoomIntegration = 'MISSING_ZOOM_INTEGRATION',
  NoSuggestionsFoundForSelfScheduleTask = 'NO_SUGGESTIONS_FOUND_FOR_SELF_SCHEDULE_TASK',
  SchedulerDoesNotHaveZoomAccount = 'SCHEDULER_DOES_NOT_HAVE_ZOOM_ACCOUNT',
  SchedulerHaveInsufficientPermissionOnApplicationJob = 'SCHEDULER_HAVE_INSUFFICIENT_PERMISSION_ON_APPLICATION_JOB',
  ScheduleLocationCustomLinkSetButNotDefined = 'SCHEDULE_LOCATION_CUSTOM_LINK_SET_BUT_NOT_DEFINED',
  ScheduleLocationCustomPhoneSetButNotDefined = 'SCHEDULE_LOCATION_CUSTOM_PHONE_SET_BUT_NOT_DEFINED',
  ScheduleLocationCustomTextSetButNotDefined = 'SCHEDULE_LOCATION_CUSTOM_TEXT_SET_BUT_NOT_DEFINED',
  SelfScheduleAdvanceNoticeExceedsTimeframe = 'SELF_SCHEDULE_ADVANCE_NOTICE_EXCEEDS_TIMEFRAME',
  SourcingLinkJobStageNotFound = 'SOURCING_LINK_JOB_STAGE_NOT_FOUND',
  TemplateNotSetAvailabilityRequestEmail = 'TEMPLATE_NOT_SET_AVAILABILITY_REQUEST_EMAIL',
  TemplateNotSetCandidateCalendarInvite = 'TEMPLATE_NOT_SET_CANDIDATE_CALENDAR_INVITE',
  TemplateNotSetCandidateConfirmationEmail = 'TEMPLATE_NOT_SET_CANDIDATE_CONFIRMATION_EMAIL',
  TemplateNotSetInternalCalendarInvite = 'TEMPLATE_NOT_SET_INTERNAL_CALENDAR_INVITE',
  TemplateNotSetSelfScheduleRequestEmail = 'TEMPLATE_NOT_SET_SELF_SCHEDULE_REQUEST_EMAIL',
  YouHaveInsufficientPermissionOnCandidateCalendar = 'YOU_HAVE_INSUFFICIENT_PERMISSION_ON_CANDIDATE_CALENDAR',
  YouHaveInsufficientPermissionOnInternalCalendar = 'YOU_HAVE_INSUFFICIENT_PERMISSION_ON_INTERNAL_CALENDAR'
}

export type TaskCreateValidateErrorFlags = {
  __typename?: 'TaskCreateValidateErrorFlags';
  message: Scalars['String']['output'];
  type: TaskCreateValidateErrorFlagType;
};

export enum TaskCreateValidateWarnFlagType {
  InterviewerDoesNotHaveZoomAccount = 'INTERVIEWER_DOES_NOT_HAVE_ZOOM_ACCOUNT',
  InterviewerHasABusyAllDayEvent = 'INTERVIEWER_HAS_A_BUSY_ALL_DAY_EVENT',
  InterviewerHasCompanyHoliday = 'INTERVIEWER_HAS_COMPANY_HOLIDAY',
  InterviewerHasNoBookableTime = 'INTERVIEWER_HAS_NO_BOOKABLE_TIME',
  InterviewerIsAtDailyLoadLimit = 'INTERVIEWER_IS_AT_DAILY_LOAD_LIMIT',
  InterviewerIsAtWeeklyLoadLimit = 'INTERVIEWER_IS_AT_WEEKLY_LOAD_LIMIT',
  /** # Warning flags */
  InterviewerIsOutOfOffice = 'INTERVIEWER_IS_OUT_OF_OFFICE',
  InterviewerIsPaused = 'INTERVIEWER_IS_PAUSED',
  InterviewerIsPausedOnModule = 'INTERVIEWER_IS_PAUSED_ON_MODULE',
  InterviewerNeedsCalendarDelegateApproval = 'INTERVIEWER_NEEDS_CALENDAR_DELEGATE_APPROVAL'
}

export type TaskCreateValidateWarnFlags = {
  __typename?: 'TaskCreateValidateWarnFlags';
  message: Scalars['String']['output'];
  type: TaskCreateValidateWarnFlagType;
};

export type TaskCreateValidationResult = {
  __typename?: 'TaskCreateValidationResult';
  errors?: Maybe<Array<TaskCreateValidateErrorFlags>>;
  warnings?: Maybe<Array<TaskCreateValidateWarnFlags>>;
};

export type TaskCreateWithAgentDelegateInput = {
  applicationId: Scalars['uuid']['input'];
  jobStageId: Scalars['uuid']['input'];
  taskId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TaskCreateWithAgentDelegateResult = {
  __typename?: 'TaskCreateWithAgentDelegateResult';
  task?: Maybe<Task>;
  taskId: Scalars['uuid']['output'];
};

export enum TaskCreationSource {
  AiAgentDelegate = 'AI_AGENT_DELEGATE',
  AssignTask = 'ASSIGN_TASK',
  CandidateAvailabilityRequest = 'CANDIDATE_AVAILABILITY_REQUEST',
  Migration = 'MIGRATION',
  ScheduleNow = 'SCHEDULE_NOW',
  SelfScheduleRequest = 'SELF_SCHEDULE_REQUEST',
  SourcingLinkAvailability = 'SOURCING_LINK_AVAILABILITY',
  SourcingLinkSelfSchedule = 'SOURCING_LINK_SELF_SCHEDULE',
  TaskAutomateAssignTask = 'TASK_AUTOMATE_ASSIGN_TASK',
  TaskAutomateAvailability = 'TASK_AUTOMATE_AVAILABILITY',
  TaskAutomateSelfSchedule = 'TASK_AUTOMATE_SELF_SCHEDULE',
  TaskQuickCreateAssignTask = 'TASK_QUICK_CREATE_ASSIGN_TASK',
  TaskQuickCreateAvailability = 'TASK_QUICK_CREATE_AVAILABILITY',
  TaskQuickCreateSelfSchedule = 'TASK_QUICK_CREATE_SELF_SCHEDULE'
}

export type TaskCustomCandidateRequestStatusOptionsInput = {
  days: Array<Scalars['date']['input']>;
  /** request params for the task. */
  requestParams: TaskCustomCandidateRequestValidateParamsInput;
};

export type TaskCustomCandidateRequestStatusOptionsResult = {
  __typename?: 'TaskCustomCandidateRequestStatusOptionsResult';
  errors?: Maybe<Array<TaskCreateValidateErrorFlags>>;
  suggestionCount: Scalars['Int']['output'];
  warnings?: Maybe<Array<TaskCreateValidateWarnFlags>>;
};

export type TaskCustomCandidateRequestValidateInput = {
  /** request params for the task. */
  requestParams: TaskCustomCandidateRequestValidateParamsInput;
  timeRange: DateTimeRangeInput;
};

export type TaskCustomCandidateRequestValidateMultipleDatesResult = {
  __typename?: 'TaskCustomCandidateRequestValidateMultipleDatesResult';
  items?: Maybe<Array<CandidateRequestValidateSingleDateResult>>;
};

export type TaskCustomCandidateRequestValidateParamsInput = {
  advanceNoticeHours: Scalars['numeric']['input'];
  applicationId: Scalars['uuid']['input'];
  canScheduleOverAvailableKeywords: Scalars['Boolean']['input'];
  canScheduleOverFreeTime: Scalars['Boolean']['input'];
  canScheduleOverRecruitingKeywords: Scalars['Boolean']['input'];
  interviewPlan?: InputMaybe<InterviewPlanInput>;
  jobStageId: Scalars['uuid']['input'];
  shouldRespectLoadLimit: Scalars['Boolean']['input'];
  /**
   * taskId and interviewPlan are one of fields. FE needs to pass either of them.
   * InterviewPlan overrides the taskId (In case of taskId we fetch interviewPlan of the task).
   * Ideally we want @oneOf directive and will check if that is supported by current version.
   */
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  timeRange: DateTimeRangeInput;
  validateZoomHost: Scalars['Boolean']['input'];
};

export enum TaskDefaultAssignee {
  CandidateCoordinator = 'CANDIDATE_COORDINATOR',
  CandidateRecruiter = 'CANDIDATE_RECRUITER',
  TaskCreator = 'TASK_CREATOR',
  Unassigned = 'UNASSIGNED'
}

export type TaskFlag = {
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
};

export enum TaskFlagActorType {
  Candidate = 'CANDIDATE',
  Employee = 'EMPLOYEE',
  System = 'SYSTEM'
}

export type TaskFlagCandidateDeclined = TaskFlag & {
  __typename?: 'TaskFlagCandidateDeclined';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  declinedCandidateEvent: ApplicationStageCandidateEvent;
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
};

export type TaskFlagCandidateTentative = TaskFlag & {
  __typename?: 'TaskFlagCandidateTentative';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
  tentativeCandidateEvent: ApplicationStageCandidateEvent;
};

export type TaskFlagDebriefAttendeeDeactivated = TaskFlag & {
  __typename?: 'TaskFlagDebriefAttendeeDeactivated';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  deactivatedDebrief: ApplicationDebrief;
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
};

export type TaskFlagDebriefAttendeeTentative = TaskFlag & {
  __typename?: 'TaskFlagDebriefAttendeeTentative';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
  tentativeDebrief: ApplicationDebrief;
};

export type TaskFlagInterviewerDeactivated = TaskFlag & {
  __typename?: 'TaskFlagInterviewerDeactivated';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  deactivatedInterview: ApplicationStageInterview;
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
};

export type TaskFlagInterviewerDebriefDeclined = TaskFlag & {
  __typename?: 'TaskFlagInterviewerDebriefDeclined';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  declinedDebrief: ApplicationDebrief;
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
};

export type TaskFlagInterviewerDeclined = TaskFlag & {
  __typename?: 'TaskFlagInterviewerDeclined';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  declinedInterview: ApplicationStageInterview;
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
};

export type TaskFlagInterviewerTentative = TaskFlag & {
  __typename?: 'TaskFlagInterviewerTentative';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
  tentativeInterview: ApplicationStageInterview;
};

export type TaskFlagMarkResolvedInput = {
  taskFlagId: Scalars['uuid']['input'];
};

export type TaskFlagMarkResolvedResult = {
  __typename?: 'TaskFlagMarkResolvedResult';
  taskFlag: TaskFlag;
};

export type TaskFlagRequestedChange = TaskFlag & {
  __typename?: 'TaskFlagRequestedChange';
  actorEmployee?: Maybe<Employee>;
  actorType: TaskFlagActorType;
  createdAt: Scalars['datetime']['output'];
  flagType: TaskFlagType;
  id: Scalars['uuid']['output'];
  note?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['datetime']['output']>;
  resolvedBy?: Maybe<Employee>;
  task: Task;
};

export enum TaskFlagType {
  CandidateDeclined = 'CANDIDATE_DECLINED',
  CandidateTentative = 'CANDIDATE_TENTATIVE',
  DebriefAttendeeDeactivated = 'DEBRIEF_ATTENDEE_DEACTIVATED',
  DebriefAttendeeTentative = 'DEBRIEF_ATTENDEE_TENTATIVE',
  DebriefDeclined = 'DEBRIEF_DECLINED',
  InterviewerDeactivated = 'INTERVIEWER_DEACTIVATED',
  InterviewerTentative = 'INTERVIEWER_TENTATIVE',
  InterviewDeclined = 'INTERVIEW_DECLINED',
  RequestChange = 'REQUEST_CHANGE'
}

export type TaskFlagsInput = {
  showWithoutFlags?: InputMaybe<Scalars['Boolean']['input']>;
  taskFlags?: InputMaybe<Array<TaskFlagType>>;
};

export type TaskMeetingLocationCandidatePhone = {
  __typename?: 'TaskMeetingLocationCandidatePhone';
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskMeetingLocationCustomLink = {
  __typename?: 'TaskMeetingLocationCustomLink';
  value: Scalars['String']['output'];
};

export type TaskMeetingLocationCustomPhone = {
  __typename?: 'TaskMeetingLocationCustomPhone';
  value: Scalars['String']['output'];
};

export type TaskMeetingLocationCustomText = {
  __typename?: 'TaskMeetingLocationCustomText';
  value: Scalars['String']['output'];
};

export type TaskMeetingLocationGoogleMeet = {
  __typename?: 'TaskMeetingLocationGoogleMeet';
  hostEmployeeId?: Maybe<Scalars['uuid']['output']>;
  hostType: MeetingLocationHostType;
};

export type TaskMeetingLocationMicrosoftTeams = {
  __typename?: 'TaskMeetingLocationMicrosoftTeams';
  hostEmployeeId?: Maybe<Scalars['uuid']['output']>;
  hostType: MeetingLocationHostType;
};

export type TaskMeetingLocationNone = {
  __typename?: 'TaskMeetingLocationNone';
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type TaskMeetingLocationSetting = TaskMeetingLocationCandidatePhone | TaskMeetingLocationCustomLink | TaskMeetingLocationCustomPhone | TaskMeetingLocationCustomText | TaskMeetingLocationGoogleMeet | TaskMeetingLocationMicrosoftTeams | TaskMeetingLocationNone | TaskMeetingLocationZoom;

export type TaskMeetingLocationZoom = {
  __typename?: 'TaskMeetingLocationZoom';
  hostEmployeeId?: Maybe<Scalars['uuid']['output']>;
  hostType: MeetingLocationHostType;
  remoteVideoMeetingHostUserId?: Maybe<Scalars['String']['output']>;
};

/** Represents the possible reasons automatic booking did not find a perfect schedule. */
export enum TaskPerfectScheduleNotFoundReason {
  InsufficientAvailability = 'INSUFFICIENT_AVAILABILITY',
  NoCandidateAvailability = 'NO_CANDIDATE_AVAILABILITY',
  NoPerfectSchedule = 'NO_PERFECT_SCHEDULE',
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type TaskPokeAgentFailureNotDelegated = Error & {
  __typename?: 'TaskPokeAgentFailureNotDelegated';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type TaskPokeAgentInput = {
  taskId: Scalars['uuid']['input'];
};

export type TaskPokeAgentOutput = TaskPokeAgentFailureNotDelegated | TaskPokeAgentSuccess | UnknownError;

export type TaskPokeAgentSuccess = {
  __typename?: 'TaskPokeAgentSuccess';
  task: Task;
};

export type TaskQueue = {
  __typename?: 'TaskQueue';
  createdAt: Scalars['datetime']['output'];
  createdBy: Employee;
  id: Scalars['uuid']['output'];
  lastUpdatedBy: Employee;
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  taskCount: Scalars['Int']['output'];
  updatedAt: Scalars['datetime']['output'];
};

export type TaskQueueCreateInput = {
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  name: Scalars['String']['input'];
};

export type TaskQueueCreateOutput = {
  __typename?: 'TaskQueueCreateOutput';
  taskQueue: TaskQueue;
};

export type TaskQueueDeleteInput = {
  id: Scalars['uuid']['input'];
};

export type TaskQueueDeleteResult = {
  __typename?: 'TaskQueueDeleteResult';
  result: Result;
};

export type TaskQueueSearchInput = {
  memberEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  orderBy?: InputMaybe<TaskQueuesOrderBy>;
  pageInput: PageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type TaskQueueSearchResult = {
  __typename?: 'TaskQueueSearchResult';
  hasNext: Scalars['Boolean']['output'];
  items: Array<TaskQueue>;
  total: Scalars['Int']['output'];
};

export type TaskQueueUpdateInput = {
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id: Scalars['uuid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TaskQueueUpdateOutput = {
  __typename?: 'TaskQueueUpdateOutput';
  taskQueue: TaskQueue;
};

export type TaskQueuesFilterInput = {
  showUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
  taskQueueIds?: InputMaybe<Array<InputMaybe<Scalars['uuid']['input']>>>;
};

export type TaskQueuesInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<TaskQueuesOrderBy>;
  page: PageInput;
};

export type TaskQueuesOrderBy = {
  direction: Sort;
  property: TaskQueuesOrderByProperty;
};

export enum TaskQueuesOrderByProperty {
  MemberCount = 'MEMBER_COUNT',
  Name = 'NAME',
  TaskCount = 'TASK_COUNT'
}

export type TaskQueuesResult = {
  __typename?: 'TaskQueuesResult';
  items: Array<TaskQueue>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type TaskQuickCreateInput = {
  applicationId: Scalars['uuid']['input'];
  jobStageId: Scalars['uuid']['input'];
  /** Optional client-provided task ID for idempotency. If not provided, a random UUID will be generated. */
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  taskType: TaskCreationSource;
};

export type TaskQuickCreateResult = {
  __typename?: 'TaskQuickCreateResult';
  task?: Maybe<Task>;
  taskId: Scalars['uuid']['output'];
};

export type TaskQuickCreateValidateInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  /**
   * Uses below employee id to validate calendar permissions for scheduling a task.
   * This is used for sourcing link flow. Keeping it optional as it is not required for other flows.
   */
  forActorEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  interviewPlan?: InputMaybe<InterviewPlanInput>;
  /**  Optional */
  interviewPlanJobStageId?: InputMaybe<Scalars['uuid']['input']>;
  jobStageId: Scalars['uuid']['input'];
  taskType: TaskCreationSource;
};

export type TaskQuickCreateValidateResult = {
  __typename?: 'TaskQuickCreateValidateResult';
  errors?: Maybe<Array<TaskCreateValidateErrorFlags>>;
  suggestionCount: Scalars['numeric']['output'];
  suggestionLastCalculatedAt?: Maybe<Scalars['datetime']['output']>;
  suggestionTimeRanges: Array<DateTimeRangeOutput>;
  warnings?: Maybe<Array<TaskCreateValidateWarnFlags>>;
};

export type TaskRequestChangeInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['uuid']['input'];
};

export type TaskRequestChangeResult = {
  __typename?: 'TaskRequestChangeResult';
  task: Task;
  taskFlag: TaskFlag;
};

export type TaskSearchInput = {
  assignees?: InputMaybe<TaskAssigneesInput>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  createdByIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  delegateTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  filterCompletedCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  flags?: InputMaybe<TaskFlagsInput>;
  jobIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  jobStageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<TaskSearchOrderBy>;
  pageInput: PageInput;
  showIsUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<TaskStatus>>;
  subscribedByIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  taskQueueMemberEmployeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  taskQueues?: InputMaybe<TaskQueuesFilterInput>;
  taskTagIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type TaskSearchOrderBy = {
  order: Sort;
  property: TaskSearchOrderByProperty;
};

export enum TaskSearchOrderByProperty {
  ApplicationStageMaxEndAt = 'APPLICATION_STAGE_MAX_END_AT',
  CandidateAvailabilityStartAt = 'CANDIDATE_AVAILABILITY_START_AT',
  CreatedAt = 'CREATED_AT',
  FirstInterviewAt = 'FIRST_INTERVIEW_AT',
  LastActivityAt = 'LAST_ACTIVITY_AT',
  ScheduleCreatedAt = 'SCHEDULE_CREATED_AT'
}

export type TaskSearchResult = {
  __typename?: 'TaskSearchResult';
  hasNext: Scalars['Boolean']['output'];
  items: Array<Task>;
  nextOffset: Scalars['Int']['output'];
  /** @deprecated The permission-filtered total is not exact. Use hasNext for pagination. */
  total: Scalars['Int']['output'];
};

export type TaskSetAssigneeInput = {
  assigneeEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  taskId: Scalars['uuid']['input'];
};

export type TaskSetDebriefRequiredInput = {
  isDebriefRequired: Scalars['Boolean']['input'];
  taskId: Scalars['uuid']['input'];
};

export type TaskSetDelegateInput = {
  delegateType: Scalars['String']['input'];
  taskId: Scalars['uuid']['input'];
};

export type TaskSetIsUrgentInput = {
  isUrgent: Scalars['Boolean']['input'];
  taskId: Scalars['uuid']['input'];
};

export type TaskSetTagsInput = {
  tagIds: Array<Scalars['uuid']['input']>;
  taskId: Scalars['uuid']['input'];
};

export type TaskSetTaskQueueInput = {
  taskId: Scalars['uuid']['input'];
  taskQueueId?: InputMaybe<Scalars['uuid']['input']>;
};

/**  Task query */
export enum TaskStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Hold = 'HOLD',
  NeedsAvailability = 'NEEDS_AVAILABILITY',
  NeedsDebrief = 'NEEDS_DEBRIEF',
  ReadyToReschedule = 'READY_TO_RESCHEDULE',
  ReadyToSchedule = 'READY_TO_SCHEDULE',
  ReadyToSendToCandidate = 'READY_TO_SEND_TO_CANDIDATE',
  Scheduled = 'SCHEDULED',
  WaitingForCandidate = 'WAITING_FOR_CANDIDATE'
}

export type TaskStopAgentInput = {
  taskId: Scalars['uuid']['input'];
};

export type TaskStopAgentOutput = {
  __typename?: 'TaskStopAgentOutput';
  task: Task;
};

export type TaskSuggestedSchedulesInput = {
  availability: Array<DateTimeRangeInput>;
  timezone: Scalars['timezone']['input'];
};

export type TaskTag = {
  __typename?: 'TaskTag';
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  taskCount: Scalars['Int']['output'];
};

/**  Mutation */
export type TaskTagCreateInput = {
  name: Scalars['String']['input'];
};

export type TaskTagCreateOutput = {
  __typename?: 'TaskTagCreateOutput';
  taskTag: TaskTag;
};

export type TaskTagDeleteInput = {
  id: Scalars['uuid']['input'];
};

export type TaskTagDeleteOutput = {
  __typename?: 'TaskTagDeleteOutput';
  ok: Scalars['Boolean']['output'];
};

export type TaskTagSetInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TaskTagUpdateInput = {
  set: TaskTagSetInput;
  taskTagId: Scalars['uuid']['input'];
};

export type TaskTagUpdateOutput = {
  __typename?: 'TaskTagUpdateOutput';
  taskTag: TaskTag;
};

/**  Query */
export type TaskTagsInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  page: PageInput;
};

export type TaskTagsResult = {
  __typename?: 'TaskTagsResult';
  items: Array<TaskTag>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type TaskUpdateInput = {
  assigneeEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  isDebriefRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['Boolean']['input']>;
  /** To unset, explicitly set to null */
  meetingLocationSetting?: InputMaybe<InterviewMeetingLocationSettingsInput>;
  tagIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  taskId: Scalars['uuid']['input'];
  /** To unset, explicitly set to null */
  taskQueueId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TaskUpdatedPayload = {
  __typename?: 'TaskUpdatedPayload';
  delegateStatus?: Maybe<Scalars['String']['output']>;
  taskId: Scalars['uuid']['output'];
  updateType: Scalars['String']['output'];
};

export type TaskUpdatedSubscriptionInput = {
  taskId: Scalars['uuid']['input'];
};

/** ########################################################## */
export type Template = {
  __typename?: 'Template';
  attachments?: Maybe<Array<Attachment>>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['datetime']['output'];
  greenhouseEmailTemplateId?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  isOrganizationDefault: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  lastSentAt?: Maybe<Scalars['datetime']['output']>;
  liveSettingsUsages: Scalars['numeric']['output'];
  locale: Locale;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  type: TemplateType;
  updatedAt: Scalars['datetime']['output'];
};

/** ########################################################## */
export type TemplateCreateInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars['String']['input'];
  isOrganizationDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Locale>;
  name: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  type: TemplateType;
};

export type TemplateResult = {
  __typename?: 'TemplateResult';
  template?: Maybe<Template>;
};

export type TemplateToken = {
  __typename?: 'TemplateToken';
  APPLICATION_CANDIDATE_PORTAL_URL?: Maybe<Scalars['String']['output']>;
  CANDIDATE_AVAILABILITY?: Maybe<Scalars['String']['output']>;
  CANDIDATE_AVAILABILITY_TIMEZONE?: Maybe<Scalars['String']['output']>;
  CANDIDATE_AVAILABILITY_URL?: Maybe<Scalars['String']['output']>;
  CANDIDATE_EMAIL_ADDRESS?: Maybe<Scalars['String']['output']>;
  CANDIDATE_FIRST_NAME?: Maybe<Scalars['String']['output']>;
  CANDIDATE_LAST_INITIAL?: Maybe<Scalars['String']['output']>;
  CANDIDATE_LAST_NAME?: Maybe<Scalars['String']['output']>;
  CANDIDATE_LINK?: Maybe<Scalars['String']['output']>;
  CANDIDATE_LINKEDIN?: Maybe<Scalars['String']['output']>;
  CANDIDATE_NAME?: Maybe<Scalars['String']['output']>;
  CANDIDATE_PHONE?: Maybe<Scalars['String']['output']>;
  CANDIDATE_PREFERRED_FIRST_NAME?: Maybe<Scalars['String']['output']>;
  CANDIDATE_PREFERRED_FULL_NAME?: Maybe<Scalars['String']['output']>;
  CANDIDATE_PRONOUNS?: Maybe<Scalars['String']['output']>;
  CANDIDATE_SOURCER?: Maybe<Scalars['String']['output']>;
  CANDIDATE_SOURCER_EMAIL?: Maybe<Scalars['String']['output']>;
  CHAT_MENTION_CANDIDATE_COORDINATOR?: Maybe<Scalars['String']['output']>;
  CHAT_MENTION_CANDIDATE_RECRUITER?: Maybe<Scalars['String']['output']>;
  CHAT_MENTION_CANDIDATE_SOURCER?: Maybe<Scalars['String']['output']>;
  CHAT_MENTION_DEBRIEF_ATTENDEES?: Maybe<Scalars['String']['output']>;
  CHAT_MENTION_INTERVIEWERS?: Maybe<Scalars['String']['output']>;
  CHAT_MENTION_JOB_HIRING_MANAGERS?: Maybe<Scalars['String']['output']>;
  CODE_LINK?: Maybe<Scalars['String']['output']>;
  COMPANY?: Maybe<Scalars['String']['output']>;
  COMPANY_NAME?: Maybe<Scalars['String']['output']>;
  COORDINATOR?: Maybe<Scalars['String']['output']>;
  COORDINATOR_EMAIL?: Maybe<Scalars['String']['output']>;
  DEBRIEF_SCHEDULE?: Maybe<Scalars['String']['output']>;
  EXTERNAL_INTERVIEW_NAME?: Maybe<Scalars['String']['output']>;
  EXTERNAL_JOB_NAME?: Maybe<Scalars['String']['output']>;
  HIRING_MANAGER?: Maybe<Scalars['String']['output']>;
  INTERNAL_APPLICATION_NOTE?: Maybe<Scalars['String']['output']>;
  INTERNAL_INTERVIEW_NAME?: Maybe<Scalars['String']['output']>;
  INTERNAL_INTERVIEW_SCHEDULE?: Maybe<Scalars['String']['output']>;
  INTERNAL_JOB_NOTE?: Maybe<Scalars['String']['output']>;
  INTERVIEWER_NAMES?: Maybe<Scalars['String']['output']>;
  INTERVIEWER_TRAINING_INFO?: Maybe<Scalars['String']['output']>;
  INTERVIEW_DAYS?: Maybe<Scalars['String']['output']>;
  INTERVIEW_KIT_LINK?: Maybe<Scalars['String']['output']>;
  INTERVIEW_NAME?: Maybe<Scalars['String']['output']>;
  INTERVIEW_SCHEDULE?: Maybe<Scalars['String']['output']>;
  INTERVIEW_SCHEDULE_START_TIME?: Maybe<Scalars['String']['output']>;
  INTERVIEW_SCORECARD_NAME?: Maybe<Scalars['String']['output']>;
  JOB_LOCATION?: Maybe<Scalars['String']['output']>;
  JOB_NAME?: Maybe<Scalars['String']['output']>;
  JOB_STAGE_NAME?: Maybe<Scalars['String']['output']>;
  ME?: Maybe<Scalars['String']['output']>;
  MY_FIRST_NAME?: Maybe<Scalars['String']['output']>;
  MY_FULL_NAME?: Maybe<Scalars['String']['output']>;
  MY_PHONE_NUMBER?: Maybe<Scalars['String']['output']>;
  MY_SIGNATURE?: Maybe<Scalars['String']['output']>;
  RECRUITER?: Maybe<Scalars['String']['output']>;
  RECRUITER_EMAIL?: Maybe<Scalars['String']['output']>;
  SCHEDULE_LOCATION?: Maybe<Scalars['String']['output']>;
  SELF_SCHEDULE_LINK?: Maybe<Scalars['String']['output']>;
  SOURCER?: Maybe<Scalars['String']['output']>;
  TASK_ASSIGNEE?: Maybe<Scalars['String']['output']>;
  TASK_CREATOR?: Maybe<Scalars['String']['output']>;
  VIDEO_MEETING_LINK?: Maybe<Scalars['String']['output']>;
  ZOOM_MEETING_DIAL_IN_INFO?: Maybe<Scalars['String']['output']>;
  ZOOM_MEETING_INFO?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};


export type TemplateTokenApplication_Candidate_Portal_UrlArgs = {
  input: TokenApplicationInput;
};


export type TemplateTokenCandidate_AvailabilityArgs = {
  input: TokenCandidateAvailabilityInput;
};


export type TemplateTokenCandidate_Availability_TimezoneArgs = {
  input: TokenCandidateAvailabilityTimeZoneInput;
};


export type TemplateTokenCandidate_Availability_UrlArgs = {
  input: TokenCandidateAvailabilityUrlInput;
};


export type TemplateTokenCandidate_Email_AddressArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_First_NameArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_Last_InitialArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_Last_NameArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_LinkArgs = {
  input: TokenCandidateLinkInput;
};


export type TemplateTokenCandidate_LinkedinArgs = {
  input: TokenCandidateLinkedinInput;
};


export type TemplateTokenCandidate_NameArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_PhoneArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_Preferred_First_NameArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_Preferred_Full_NameArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_PronounsArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_SourcerArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCandidate_Sourcer_EmailArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenChat_Mention_Candidate_CoordinatorArgs = {
  input: TokenApplicationInput;
};


export type TemplateTokenChat_Mention_Candidate_RecruiterArgs = {
  input: TokenApplicationInput;
};


export type TemplateTokenChat_Mention_Candidate_SourcerArgs = {
  input: TokenApplicationInput;
};


export type TemplateTokenChat_Mention_Debrief_AttendeesArgs = {
  input: TokenChatMentionInterviewersInput;
};


export type TemplateTokenChat_Mention_InterviewersArgs = {
  input: TokenChatMentionInterviewersInput;
};


export type TemplateTokenChat_Mention_Job_Hiring_ManagersArgs = {
  input: TokenApplicationInput;
};


export type TemplateTokenCode_LinkArgs = {
  input: CodeLinkInput;
};


export type TemplateTokenCoordinatorArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenCoordinator_EmailArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenDebrief_ScheduleArgs = {
  input: TokenDebriefScheduleInput;
};


export type TemplateTokenExternal_Interview_NameArgs = {
  input: TokenInterviewNameInput;
};


export type TemplateTokenExternal_Job_NameArgs = {
  input: TokenExternalJobNameInput;
};


export type TemplateTokenHiring_ManagerArgs = {
  input: TokenHiringManagerInput;
};


export type TemplateTokenInternal_Application_NoteArgs = {
  input: TokenApplicationInput;
};


export type TemplateTokenInternal_Interview_NameArgs = {
  input: TokenInterviewScorecardNameInput;
};


export type TemplateTokenInternal_Interview_ScheduleArgs = {
  input: TokenInterviewScheduleInput;
};


export type TemplateTokenInternal_Job_NoteArgs = {
  input: TokenJobNameInput;
};


export type TemplateTokenInterviewer_NamesArgs = {
  input: TokenInterviewerNamesInput;
};


export type TemplateTokenInterviewer_Training_InfoArgs = {
  input: TokenInterviewerTrainingInfoInput;
};


export type TemplateTokenInterview_DaysArgs = {
  input: TokenInterviewDaysInput;
};


export type TemplateTokenInterview_Kit_LinkArgs = {
  input: TokenInterviewKitLinkInput;
};


export type TemplateTokenInterview_NameArgs = {
  input: TokenInterviewNameInput;
};


export type TemplateTokenInterview_ScheduleArgs = {
  input: TokenInterviewScheduleInput;
};


export type TemplateTokenInterview_Schedule_Start_TimeArgs = {
  input: TokenInterviewScheduleStartTimeInput;
};


export type TemplateTokenInterview_Scorecard_NameArgs = {
  input: TokenInterviewScorecardNameInput;
};


export type TemplateTokenJob_LocationArgs = {
  input: TokenJobLocationInput;
};


export type TemplateTokenJob_NameArgs = {
  input: TokenJobNameInput;
};


export type TemplateTokenJob_Stage_NameArgs = {
  input: TokenJobStageNameInput;
};


export type TemplateTokenRecruiterArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenRecruiter_EmailArgs = {
  input: TokenCandidateInput;
};


export type TemplateTokenSchedule_LocationArgs = {
  input: TokenScheduleLocationInput;
};


export type TemplateTokenSelf_Schedule_LinkArgs = {
  input: TokenSelfScheduleLinkInput;
};


export type TemplateTokenSourcerArgs = {
  input: TokenApplicationInput;
};


export type TemplateTokenTask_AssigneeArgs = {
  input: TokenTaskAssigneeInput;
};


export type TemplateTokenTask_CreatorArgs = {
  input: TokenTaskCreatorInput;
};


export type TemplateTokenVideo_Meeting_LinkArgs = {
  input: TokenVideoMeetingLinkInput;
};


export type TemplateTokenZoom_Meeting_Dial_In_InfoArgs = {
  input: TokenZoomMeetingInput;
};


export type TemplateTokenZoom_Meeting_InfoArgs = {
  input: TokenZoomMeetingInput;
};

export type TemplateTokenInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Locale>;
  renderType: RenderType;
};

/**  Look at template.proto for naming convention. */
export enum TemplateType {
  CandidateAvailabilityRequest = 'CANDIDATE_AVAILABILITY_REQUEST',
  CandidateConfirmation = 'CANDIDATE_CONFIRMATION',
  CandidateInvite = 'CANDIDATE_INVITE',
  DebriefCalendarInvite = 'DEBRIEF_CALENDAR_INVITE',
  DebriefConfirmationConversationMessage = 'DEBRIEF_CONFIRMATION_CONVERSATION_MESSAGE',
  DebriefUpdateConfirmationConversationMessage = 'DEBRIEF_UPDATE_CONFIRMATION_CONVERSATION_MESSAGE',
  DebriefUpdateConfirmationInterviewerCalendarInvite = 'DEBRIEF_UPDATE_CONFIRMATION_INTERVIEWER_CALENDAR_INVITE',
  InterviewerInvite = 'INTERVIEWER_INVITE',
  Other = 'OTHER',
  ScheduleCancellationCandidateEmail = 'SCHEDULE_CANCELLATION_CANDIDATE_EMAIL',
  ScheduleCancellationConversationMessage = 'SCHEDULE_CANCELLATION_CONVERSATION_MESSAGE',
  ScheduleCancellationInterviewerEmail = 'SCHEDULE_CANCELLATION_INTERVIEWER_EMAIL',
  ScheduleUpdateConfirmationCandidateEmail = 'SCHEDULE_UPDATE_CONFIRMATION_CANDIDATE_EMAIL',
  ScheduleUpdateConfirmationCandidateInvite = 'SCHEDULE_UPDATE_CONFIRMATION_CANDIDATE_INVITE',
  ScheduleUpdateConfirmationConversationMessage = 'SCHEDULE_UPDATE_CONFIRMATION_CONVERSATION_MESSAGE',
  ScheduleUpdateConfirmationInterviewerInvite = 'SCHEDULE_UPDATE_CONFIRMATION_INTERVIEWER_INVITE',
  SelfScheduleRequestCandidateEmail = 'SELF_SCHEDULE_REQUEST_CANDIDATE_EMAIL',
  SlackChannelMessage = 'SLACK_CHANNEL_MESSAGE'
}

/** ########################################################## */
export type TemplateUpdateInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  isOrganizationDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Locale>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TemplateType>;
};

/** ########################################################## */
export type TemplatesInput = {
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TemplatesOrderBy>;
  pageInput: PageInput;
  showDefault?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<TemplateType>>;
};

export type TemplatesOrderBy = {
  direction: Sort;
  property: TemplatesOrderByProperty;
};

export enum TemplatesOrderByProperty {
  Id = 'ID',
  Name = 'NAME'
}

export type TemplatesOutput = {
  __typename?: 'TemplatesOutput';
  items: Array<Template>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type TimeBlock = {
  __typename?: 'TimeBlock';
  /**  hh:mm format */
  end?: Maybe<Scalars['String']['output']>;
  /**  hh:mm format */
  start?: Maybe<Scalars['String']['output']>;
};

export type TimeBlockInput = {
  /**  hh:mm format */
  end?: InputMaybe<Scalars['String']['input']>;
  /**  hh:mm format */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type TimeBlockWeek = {
  __typename?: 'TimeBlockWeek';
  friday?: Maybe<Array<TimeBlock>>;
  monday?: Maybe<Array<TimeBlock>>;
  saturday?: Maybe<Array<TimeBlock>>;
  sunday?: Maybe<Array<TimeBlock>>;
  thursday?: Maybe<Array<TimeBlock>>;
  tuesday?: Maybe<Array<TimeBlock>>;
  wednesday?: Maybe<Array<TimeBlock>>;
};

/** ############################################# */
export type TimeBlockWeekInput = {
  friday?: InputMaybe<Array<InputMaybe<TimeBlockInput>>>;
  monday?: InputMaybe<Array<InputMaybe<TimeBlockInput>>>;
  saturday?: InputMaybe<Array<InputMaybe<TimeBlockInput>>>;
  sunday?: InputMaybe<Array<InputMaybe<TimeBlockInput>>>;
  thursday?: InputMaybe<Array<InputMaybe<TimeBlockInput>>>;
  tuesday?: InputMaybe<Array<InputMaybe<TimeBlockInput>>>;
  wednesday?: InputMaybe<Array<InputMaybe<TimeBlockInput>>>;
};

/**
 * Represents a time range and the count of events within that range.
 * This type is useful for aggregating data about self-scheduled interviews over time periods.
 */
export type TimeRangeCount = {
  __typename?: 'TimeRangeCount';
  /** The number of events or interviews within the specified time range. */
  count: Scalars['numeric']['output'];
  /** The time range for which the count is calculated. */
  range: DateTimeRangeOutput;
};

export type TimeToScheduleJobAggregation = {
  __typename?: 'TimeToScheduleJobAggregation';
  average: Duration;
  job: Job;
  taskCount: Scalars['Int']['output'];
};

export type TimeToScheduleJobStageAggregation = {
  __typename?: 'TimeToScheduleJobStageAggregation';
  average: Duration;
  jobStageName: Scalars['String']['output'];
  taskCount: Scalars['Int']['output'];
};

export enum TimeToScheduleMetric {
  AvailabilityRequestedFirst = 'AVAILABILITY_REQUESTED_FIRST',
  AvailabilitySubmittedFirst = 'AVAILABILITY_SUBMITTED_FIRST',
  AvailabilitySubmittedLast = 'AVAILABILITY_SUBMITTED_LAST',
  FirstInterviewStart = 'FIRST_INTERVIEW_START',
  ScheduleCreatedFirst = 'SCHEDULE_CREATED_FIRST',
  ScheduleModifiedLast = 'SCHEDULE_MODIFIED_LAST',
  SelfScheduleRequestedFirst = 'SELF_SCHEDULE_REQUESTED_FIRST',
  TaskAssignedFirst = 'TASK_ASSIGNED_FIRST',
  TaskAssignedLast = 'TASK_ASSIGNED_LAST',
  TaskCreated = 'TASK_CREATED'
}

export enum TimeToScheduleMetricJobStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type TimeToScheduleMetricsInput = {
  end: TimeToScheduleMetric;
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  jobStageNames?: InputMaybe<Array<Scalars['String']['input']>>;
  jobStatuses?: InputMaybe<Array<TimeToScheduleMetricJobStatus>>;
  pageInput?: InputMaybe<PageInput>;
  sort?: InputMaybe<TimeToScheduleTasksSort>;
  start: TimeToScheduleMetric;
  taskAssigneeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeRange: DateTimeRangeInput;
};

export type TimeToScheduleMetricsResult = {
  __typename?: 'TimeToScheduleMetricsResult';
  byAssignee: Array<TimeToScheduleTaskAssigneeAggregation>;
  byJob: Array<TimeToScheduleJobAggregation>;
  byJobStageName: Array<TimeToScheduleJobStageAggregation>;
  hasNext: Scalars['Boolean']['output'];
  tasksPage: Array<TimeToScheduleTask>;
  totalAverage?: Maybe<Duration>;
  totalTaskCount: Scalars['Int']['output'];
};

export type TimeToScheduleTask = {
  __typename?: 'TimeToScheduleTask';
  endTime: Scalars['datetime']['output'];
  startTime: Scalars['datetime']['output'];
  task: Task;
  totalDuration: Duration;
};

export type TimeToScheduleTaskAssigneeAggregation = {
  __typename?: 'TimeToScheduleTaskAssigneeAggregation';
  average: Duration;
  /**  this can be null when we aggregate unassigned tasks */
  taskAssignee?: Maybe<Employee>;
  taskCount: Scalars['Int']['output'];
};

export type TimeToScheduleTasksSort = {
  direction: Sort;
  type: TimeToScheduleTasksSortType;
};

export enum TimeToScheduleTasksSortType {
  CandidateName = 'CANDIDATE_NAME',
  EndMetric = 'END_METRIC',
  JobName = 'JOB_NAME',
  StageName = 'STAGE_NAME',
  StartMetric = 'START_METRIC',
  TaskAssigneeName = 'TASK_ASSIGNEE_NAME',
  TotalTime = 'TOTAL_TIME'
}

export enum TimestampEmployeePref {
  /**  keep-sorted:begin */
  TsTosAcceptedAt = 'ts_tos_accepted_at'
}

export type TimestampEmployeePrefValue = EmployeePrefValue & {
  __typename?: 'TimestampEmployeePrefValue';
  id: Scalars['String']['output'];
  level: PrefLevel;
  prefName: Scalars['String']['output'];
  value?: Maybe<Scalars['datetime']['output']>;
};

export enum TimestampOrgPref {
  /**  keep-sorted:begin */
  TsAgentEmailForwardingVerifiedAt = 'ts_agent_email_forwarding_verified_at',
  TsAiFeaturesEnabledAt = 'ts_ai_features_enabled_at',
  TsAtsDisconnectedAt = 'ts_ats_disconnected_at',
  TsCompanyContractEndDate = 'ts_company_contract_end_date',
  TsDirectoryOnboardingDoneAt = 'ts_directory_onboarding_done_at'
}

/**  This will expect applicationId. */
export type TokenApplicationInput = {
  id: Scalars['uuid']['input'];
};

export type TokenCandidateAvailabilityInput = {
  timeRanges: Array<DateTimeRangeInput>;
  timezone: Scalars['timezone']['input'];
};

export type TokenCandidateAvailabilityTimeZoneInput = {
  timezone: Scalars['timezone']['input'];
};

export type TokenCandidateAvailabilityUrlInput = {
  taskId?: InputMaybe<Scalars['uuid']['input']>;
};

/**  This will expect candidateId. */
export type TokenCandidateInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  id: Scalars['uuid']['input'];
  jobId: Scalars['uuid']['input'];
};

/**  This will expect candidateId. If applicationId is provided, the link will include the application ID in the URL. */
export type TokenCandidateLinkInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  id: Scalars['uuid']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

/**  This will expect candidateId. */
export type TokenCandidateLinkedinInput = {
  id: Scalars['uuid']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type TokenChatMentionInterviewersInput = {
  interviewerIds: Array<Scalars['uuid']['input']>;
};

export type TokenDebriefScheduleInput = {
  employeeIds: Array<Scalars['uuid']['input']>;
  name: Scalars['String']['input'];
  timeRange: DateTimeRangeInput;
};

export type TokenExternalJobNameInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
};

export type TokenHiringManagerInput = {
  jobId: Scalars['uuid']['input'];
};

export type TokenInterviewDaysInput = {
  events: Array<EventInput>;
  timezone?: InputMaybe<Scalars['timezone']['input']>;
};

export type TokenInterviewKitLinkInput = {
  applicationId: Scalars['uuid']['input'];
  applicationStageInterviewId?: InputMaybe<Scalars['uuid']['input']>;
  atsInterviewDefinitionId?: InputMaybe<Scalars['String']['input']>;
  atsScheduledInterviewId?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TokenInterviewNameInput = {
  jobStageInterviewId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TokenInterviewScheduleInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  /** @deprecated We need to use applicationId instead so that we can apply job settings */
  candidateId?: InputMaybe<Scalars['uuid']['input']>;
  events: Array<EventInput>;
  /** @deprecated This should be enforced by job settings going forward */
  hideInterviewName?: InputMaybe<Scalars['Boolean']['input']>;
  linkInterviewerName?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['timezone']['input']>;
};

export type TokenInterviewScheduleStartTimeInput = {
  startAt: Scalars['datetime']['input'];
  timezone: Scalars['timezone']['input'];
};

export type TokenInterviewScorecardNameInput = {
  atsInterviewDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /** Job Stage Id */
  id?: InputMaybe<Scalars['uuid']['input']>;
};

export type TokenInterviewerNamesInput = {
  addUrls?: InputMaybe<Scalars['Boolean']['input']>;
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type TokenInterviewerTrainingInfoInput = {
  interviewers: Array<InterviewerInput>;
};

export type TokenJobLocationInput = {
  id: Scalars['uuid']['input'];
};

export type TokenJobNameInput = {
  id: Scalars['uuid']['input'];
};

export type TokenJobStageNameInput = {
  id: Scalars['uuid']['input'];
};

export type TokenScheduleLocationInput = {
  meetingLocationId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TokenSelfScheduleLinkInput = {
  taskId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TokenTaskAssigneeInput = {
  assigneeId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TokenTaskCreatorInput = {
  taskId?: InputMaybe<Scalars['uuid']['input']>;
};

export type TokenVideoMeetingLinkInput = {
  customVideoMeetingLinkUrl?: InputMaybe<Scalars['String']['input']>;
  videoMeetingLink?: InputMaybe<Scalars['String']['input']>;
  zoomInfo?: InputMaybe<ZoomInfoInput>;
};

export type TokenZoomDialInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TokenZoomMeetingInput = {
  dialInfo?: InputMaybe<Array<TokenZoomDialInfoInput>>;
  joinUrl: Scalars['String']['input'];
  meetingId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  pstnPassword?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type TooLargeAuditLogPayload = {
  __typename?: 'TooLargeAuditLogPayload';
  maxBytes: Scalars['Int']['output'];
};

export enum TraineeRequirement {
  Any = 'ANY',
  None = 'NONE',
  ReverseShadow = 'REVERSE_SHADOW',
  Shadow = 'SHADOW'
}

export enum TraineeSchedulingStrategy {
  IsAvailable = 'IS_AVAILABLE',
  Required = 'REQUIRED'
}

export enum TrainingFeedbackNagType {
  Adhoc = 'ADHOC',
  Automated = 'AUTOMATED',
  None = 'NONE',
  Original = 'ORIGINAL'
}

/** Input for sending a training feedback reminder nag. */
export type TrainingFeedbackReminderNagInput = {
  applicationStageInterviewId: Scalars['uuid']['input'];
  interviewModuleId: Scalars['uuid']['input'];
  interviewModuleMemberId: Scalars['uuid']['input'];
  reviewerId: Scalars['uuid']['input'];
  trainingFeedbackNagType: TrainingFeedbackNagType;
};

export enum TrainingStatus {
  ReverseShadow = 'REVERSE_SHADOW',
  Shadow = 'SHADOW',
  Trained = 'TRAINED'
}

export type TranslationCell = {
  __typename?: 'TranslationCell';
  isMissing: Scalars['Boolean']['output'];
  locale: Locale;
  value?: Maybe<Scalars['String']['output']>;
};

export enum TranslationEntityType {
  CandidatePulseTag = 'CANDIDATE_PULSE_TAG'
}

export type TranslationRow = {
  __typename?: 'TranslationRow';
  category: TranslationEntityType;
  cells: Array<TranslationCell>;
  entityId: Scalars['uuid']['output'];
  sourceText: Scalars['String']['output'];
};

/** Translation completeness for an entity across the org's supported locales. */
export type TranslationStatus = {
  __typename?: 'TranslationStatus';
  isComplete: Scalars['Boolean']['output'];
  missingLocales: Array<Locale>;
};

export enum TranslationStatusFilter {
  All = 'ALL',
  Missing = 'MISSING'
}

export type UnknownError = Error & {
  __typename?: 'UnknownError';
  errorCode: ErrorCode;
  errorMessage: Scalars['String']['output'];
};

export type UpcomingEvent = {
  __typename?: 'UpcomingEvent';
  /** @deprecated Use candidateEvents instead. */
  candidateEvent?: Maybe<ApplicationStageCandidateEvent>;
  candidateEvents: Array<ApplicationStageCandidateEvent>;
  dayIndex: Scalars['numeric']['output'];
  dayTotal: Scalars['numeric']['output'];
  endAt: Scalars['datetime']['output'];
  interviews?: Maybe<Array<ApplicationStageInterview>>;
  schedule: ApplicationStage;
  startAt: Scalars['datetime']['output'];
};

/** Input for retrieving upcoming events. */
export type UpcomingEventsInput = {
  /** Filters for the upcoming events. */
  filters?: InputMaybe<ApplicationStageFilterInput>;
  /** The time range for upcoming events. */
  timeRange: DateTimeRangeInput;
};

export type UpcomingEventsPageFiltersPref = {
  __typename?: 'UpcomingEventsPageFiltersPref';
  allAccepted: Scalars['Boolean']['output'];
  candidateRsvps: Array<ResponseStatus>;
  interviewerEmployeeIds: Array<Scalars['uuid']['output']>;
  interviewerEmployees: Array<Employee>;
  interviewerRsvps: Array<ResponseStatus>;
  recruiterEmployeeIds: Array<Scalars['uuid']['output']>;
  recruiterEmployees: Array<Employee>;
  schedulerEmployeeIds: Array<Scalars['uuid']['output']>;
  schedulerEmployees: Array<Employee>;
  taskAssigneeEmployeeIds: Array<Scalars['uuid']['output']>;
  taskAssigneeEmployees: Array<Employee>;
  taskCreatorEmployeeIds: Array<Scalars['uuid']['output']>;
  taskCreatorEmployees: Array<Employee>;
};

export type UpcomingEventsResult = {
  __typename?: 'UpcomingEventsResult';
  debriefs: Array<ApplicationDebrief>;
  items: Array<UpcomingEvent>;
};

export type UpsertCandidatePulseTagsInput = {
  tags: Array<CandidatePulseTagsInput>;
};

export type UpsertDateByInput = {
  createdAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

export type User = {
  __typename?: 'User';
  auth0Id: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employee?: Maybe<Employee>;
  familyName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lastLoginAt?: Maybe<Scalars['datetime']['output']>;
  signature: Scalars['String']['output'];
  tosAcceptedAt?: Maybe<Scalars['datetime']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  /** Explicit membership grants, independent of permissions supplied by the role. */
  additionalPermissions: Array<Permission>;
  employee?: Maybe<Employee>;
  employeeEmail?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['uuid']['output']>;
  employeeName?: Maybe<Scalars['String']['output']>;
  isAtsAdmin: Scalars['Boolean']['output'];
  /**
   * The Organizations this user may act in, oldest Organization first. Empty for any user other
   * than the one the request is authenticated as: which Organizations a colleague belongs to is
   * that person's business, not this Organization's.
   */
  memberships: Array<OrganizationMembership>;
  orgId?: Maybe<Scalars['uuid']['output']>;
  orgName?: Maybe<Scalars['String']['output']>;
  permissions: Array<Permission>;
  role: UserRole;
  user?: Maybe<User>;
  userEmail: Scalars['String']['output'];
  userId: Scalars['uuid']['output'];
  userName: Scalars['String']['output'];
};

export type UserInfoResult = {
  __typename?: 'UserInfoResult';
  items: Array<UserInfo>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type UserInviteFailure = {
  __typename?: 'UserInviteFailure';
  email: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

/** ########################################## */
export type UserInviteInput = {
  email: Scalars['String']['input'];
  role: UserRole;
};

export enum UserRole {
  Admin = 'ADMIN',
  Interviewer = 'INTERVIEWER',
  Owner = 'OWNER',
  Scheduler = 'SCHEDULER'
}

export type UserRoleSet = {
  role?: InputMaybe<UserRole>;
};

/** ######################################### */
export type UserUpdateInput = {
  set: UserRoleSet;
  userId: Scalars['uuid']['input'];
};

export type UserUpdateResult = {
  __typename?: 'UserUpdateResult';
  userInfo?: Maybe<UserInfo>;
};

export type UsersInviteInput = {
  users: Array<UserInviteInput>;
};

export type UsersInviteResult = {
  __typename?: 'UsersInviteResult';
  failed: Array<UserInviteFailure>;
  skipped: Array<Scalars['String']['output']>;
  success: Array<Scalars['String']['output']>;
};

export type ValidationResult = {
  __typename?: 'ValidationResult';
  message?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type VideoMeetingCreateInput = {
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
  hostEmployeeId?: InputMaybe<Scalars['uuid']['input']>;
  interviewName?: InputMaybe<Scalars['String']['input']>;
  /**  If an ML user exists, use hostEmployeeId */
  purpose?: InputMaybe<MeetingPurpose>;
  remoteVideoHostUserId?: InputMaybe<Scalars['String']['input']>;
  timeRange: DateTimeRangeInput;
  /**  Kept only while a deployed frontend bundle can still send it; the backend ignores it. Remove once no frontend sends it. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoMeetingLinkScope {
  OneLink = 'ONE_LINK',
  UniqueLinkPerInterview = 'UNIQUE_LINK_PER_INTERVIEW',
  VideoMeetingLinkScopeNotSet = 'VIDEO_MEETING_LINK_SCOPE_NOT_SET'
}

/** Workday-specific fields for applications. */
export type WorkdayApplication = {
  __typename?: 'WorkdayApplication';
  currentStepName?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
  stageReferenceId: Scalars['String']['output'];
};

/** Workday-specific fields for candidates. */
export type WorkdayCandidate = {
  __typename?: 'WorkdayCandidate';
  referenceId: Scalars['String']['output'];
};

export type WorkdayIntegration = {
  __typename?: 'WorkdayIntegration';
  domain?: Maybe<Scalars['String']['output']>;
  interviewRaasUrl?: Maybe<Scalars['String']['output']>;
  jobApplicationRaasUrl?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Scalars['String']['output']>;
  tenantTimeZone?: Maybe<Scalars['String']['output']>;
  uiUrl?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  webServiceUrl?: Maybe<Scalars['String']['output']>;
};

/** Workday-specific fields for interview definitions. */
export type WorkdayInterviewDefinition = {
  __typename?: 'WorkdayInterviewDefinition';
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

/** Workday-specific fields for jobs. */
export type WorkdayJob = {
  __typename?: 'WorkdayJob';
  isEvergreen: Scalars['Boolean']['output'];
  referenceId: Scalars['String']['output'];
};

export type ZoomDialInInfoInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ZoomHost = {
  __typename?: 'ZoomHost';
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ZoomInfo = {
  __typename?: 'ZoomInfo';
  dialInfo?: Maybe<Array<DialInfo>>;
  meetingId?: Maybe<Scalars['numeric']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  pstnPassword?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ZoomInfoInput = {
  dialInfo?: InputMaybe<Array<InputMaybe<ZoomDialInInfoInput>>>;
  joinUrl: Scalars['String']['input'];
  meetingId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pstnPassword?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ZoomIntegration = {
  __typename?: 'ZoomIntegration';
  active: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  isGov?: Maybe<Scalars['Boolean']['output']>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
};

export type ZoomIntegrationHealth = {
  __typename?: 'ZoomIntegrationHealth';
  canReadUsers: Scalars['Boolean']['output'];
  isHealthy: Scalars['Boolean']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

export type ZoomMeeting = {
  __typename?: 'ZoomMeeting';
  meetingId?: Maybe<Scalars['numeric']['output']>;
};

export type ZoomMeetingCreateInput = {
  previousMeetingId?: InputMaybe<Scalars['numeric']['input']>;
  timeRange?: InputMaybe<DateTimeRangeInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  zoomUserId: Scalars['String']['input'];
};

export type ZoomMeetingCreateResult = {
  __typename?: 'ZoomMeetingCreateResult';
  dialInfo?: Maybe<Array<DialInfo>>;
  hostId?: Maybe<Scalars['String']['output']>;
  joinUrl?: Maybe<Scalars['String']['output']>;
  meetingId: Scalars['numeric']['output'];
  password?: Maybe<Scalars['String']['output']>;
  pstnPassword?: Maybe<Scalars['String']['output']>;
  startUrl?: Maybe<Scalars['String']['output']>;
};

export type ZoomMeetingResult = {
  __typename?: 'ZoomMeetingResult';
  zoomMeeting?: Maybe<ZoomMeeting>;
};

/**  Input for updating zoom meetings */
export type ZoomMeetingUpdateInput = {
  meetingId: Scalars['numeric']['input'];
  timeRange?: InputMaybe<DateTimeRangeInput>;
};

export type ZoomUser = {
  __typename?: 'ZoomUser';
  email: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['String']['output'];
  status?: Maybe<ZoomUserStatus>;
  type?: Maybe<ZoomUserType>;
  zoomUserId: Scalars['String']['output'];
};

export type ZoomUserConcurrentMeetingsDeleteInput = {
  zoomUserIds: Array<Scalars['String']['input']>;
};

export type ZoomUserConcurrentMeetingsInput = {
  maxConcurrentMeetings: Scalars['numeric']['input'];
  zoomUserId: Scalars['String']['input'];
};

/** input for zoom user concurrent meetings */
export type ZoomUserConcurrentMeetingsPutInput = {
  items: Array<ZoomUserConcurrentMeetingsInput>;
};

export type ZoomUserConcurrentMeetingsUpdateInput = {
  items: Array<ZoomUserConcurrentMeetingsInput>;
};

export enum ZoomUserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum ZoomUserType {
  Basic = 'BASIC',
  Licensed = 'LICENSED',
  None = 'NONE'
}

/**  Use either zoomUserIds or employeeIds. Accidentally if both are sent then zoomUserIds will take precedence. */
export type ZoomUsersByIdsInput = {
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']>>;
  zoomUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ZoomUsersInput = {
  orderBy?: InputMaybe<ZoomUsersOrderBy>;
  pageInput: PageInput;
  prefix: Scalars['String']['input'];
};

export type ZoomUsersOrderBy = {
  direction: Sort;
  property: ZoomUsersOrderByProperty;
};

export enum ZoomUsersOrderByProperty {
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  ZoomUserId = 'ZOOM_USER_ID'
}

export type ZoomUsersResult = {
  __typename?: 'ZoomUsersResult';
  items: Array<ZoomUser>;
  nextCursor?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo_memberships_OrganizationMembership_organization_MembershipOrganization = { __typename?: 'MembershipOrganization', id: any, name: string };

export type OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo_memberships_OrganizationMembership = { __typename?: 'OrganizationMembership', isActive: boolean, organization: OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo_memberships_OrganizationMembership_organization_MembershipOrganization };

export type OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo = { __typename?: 'UserInfo', userId: any, memberships: Array<OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo_memberships_OrganizationMembership> };

export type OrganizationSwitcherMembershipsQuery_Query = { __typename?: 'Query', thisUserInfo?: OrganizationSwitcherMembershipsQuery_thisUserInfo_UserInfo | null };


export type OrganizationSwitcherMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSwitcherMembershipsQuery = OrganizationSwitcherMembershipsQuery_Query;

export type SwitchActiveOrganizationMutation_switchActiveOrganization_SwitchActiveOrganizationNotAMemberError = { __typename: 'SwitchActiveOrganizationNotAMemberError', errorCode: ErrorCode, errorMessage: string };

export type SwitchActiveOrganizationMutation_switchActiveOrganization_SwitchActiveOrganizationNotAllowedWhileImpersonatingError = { __typename: 'SwitchActiveOrganizationNotAllowedWhileImpersonatingError', errorCode: ErrorCode, errorMessage: string };

export type SwitchActiveOrganizationMutation_switchActiveOrganization_SwitchActiveOrganizationSuccess = { __typename: 'SwitchActiveOrganizationSuccess', activeOrganizationId: any };

export type SwitchActiveOrganizationMutation_switchActiveOrganization_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SwitchActiveOrganizationMutation_switchActiveOrganization = SwitchActiveOrganizationMutation_switchActiveOrganization_SwitchActiveOrganizationNotAMemberError | SwitchActiveOrganizationMutation_switchActiveOrganization_SwitchActiveOrganizationNotAllowedWhileImpersonatingError | SwitchActiveOrganizationMutation_switchActiveOrganization_SwitchActiveOrganizationSuccess | SwitchActiveOrganizationMutation_switchActiveOrganization_UnknownError;

export type SwitchActiveOrganizationMutation_Mutation = { __typename?: 'Mutation', switchActiveOrganization: SwitchActiveOrganizationMutation_switchActiveOrganization };


export type SwitchActiveOrganizationMutationVariables = Exact<{
  input: SwitchActiveOrganizationInput;
}>;


export type SwitchActiveOrganizationMutation = SwitchActiveOrganizationMutation_Mutation;

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_actorEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogAvatar_ActivityLogFragment_ActivityLog_details = ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogAvatar_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogAvatar_ActivityLogFragment = { __typename?: 'ActivityLog', id: any, activityActorType: ActorType, actorEmployee?: ActivityLogAvatar_ActivityLogFragment_ActivityLog_actorEmployee_Employee | null, details?: ActivityLogAvatar_ActivityLogFragment_ActivityLog_details | null };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_source_Application = { __typename?: 'Application' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_source_Candidate = { __typename?: 'Candidate' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_source_Task = (
  { __typename: 'Task', id: any }
  & TaskName_TaskFragment
);

export type ActivityLogBase_ActivityLogFragment_ActivityLog_source = ActivityLogBase_ActivityLogFragment_ActivityLog_source_Application | ActivityLogBase_ActivityLogFragment_ActivityLog_source_Candidate | ActivityLogBase_ActivityLogFragment_ActivityLog_source_Task;

export type ActivityLogBase_ActivityLogFragment_ActivityLog_actorEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task_createdBy_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task = { __typename?: 'Task', id: any, createdBy: ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task_createdBy_Employee };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails', task: ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogBase_ActivityLogFragment_ActivityLog_details = ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogBase_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogBase_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, createdAt: any, sourceType: SourceType, activityActorType: ActorType, source?: ActivityLogBase_ActivityLogFragment_ActivityLog_source | null, actorEmployee?: ActivityLogBase_ActivityLogFragment_ActivityLog_actorEmployee_Employee | null, details?: ActivityLogBase_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogAvatar_ActivityLogFragment
);

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails', json: string };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details = ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogAgentDebug_ActivityLogFragment = { __typename?: 'ActivityLog', id: any, details?: ActivityLogAgentDebug_ActivityLogFragment_ActivityLog_details | null };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails_content_ActivityLogContent = { __typename?: 'ActivityLogContent', markdown: string, plaintext: string, formatVersion: number, editorStateJson: string };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails', message: string, content?: ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails_content_ActivityLogContent | null };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details = ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogAgentMessage_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogAgentMessage_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source_Application = { __typename?: 'Application' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source_Candidate = { __typename?: 'Candidate' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source_Task = { __typename?: 'Task', id: any };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source = ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source_Application | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source_Candidate | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source_Task;

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails_content_ActivityLogContent = { __typename?: 'ActivityLogContent', markdown: string, plaintext: string, formatVersion: number, editorStateJson: string };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails', question: string, options: Array<string>, content?: ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails_content_ActivityLogContent | null };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details = ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogAgentQuestion_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, source?: ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_source | null, details?: ActivityLogAgentQuestion_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type TaskStopAgentMutation_taskStopAgent_TaskStopAgentOutput_task_Task = { __typename?: 'Task', id: any, delegateType: string, delegateStatus: string };

export type TaskStopAgentMutation_taskStopAgent_TaskStopAgentOutput = { __typename?: 'TaskStopAgentOutput', task: TaskStopAgentMutation_taskStopAgent_TaskStopAgentOutput_task_Task };

export type TaskStopAgentMutation_Mutation = { __typename?: 'Mutation', taskStopAgent: TaskStopAgentMutation_taskStopAgent_TaskStopAgentOutput };


export type TaskStopAgentMutationVariables = Exact<{
  input: TaskStopAgentInput;
}>;


export type TaskStopAgentMutation = TaskStopAgentMutation_Mutation;

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source_Application = { __typename?: 'Application' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source_Candidate = { __typename?: 'Candidate' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source_Task = { __typename?: 'Task', id: any };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source = ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source_Application | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source_Candidate | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source_Task;

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails', startAt: any };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details = ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogAgentQueued_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, source?: ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_source | null, details?: ActivityLogAgentQueued_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails_content_ActivityLogContent = { __typename?: 'ActivityLogContent', markdown: string, plaintext: string, formatVersion: number, editorStateJson: string };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails', reasoning: string, content?: ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails_content_ActivityLogContent | null };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details = ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogAgentReasoning_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogAgentReasoning_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogAgentStopped_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails_remainingToolCalls_AgentToolCallStartInfo = { __typename?: 'AgentToolCallStartInfo', toolName: string, toolCallId: string, argumentsJson: string, displayLabelPresent: string, displayLabelPast: string };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails_completedToolCalls_AgentToolCallCompletedInfo = { __typename?: 'AgentToolCallCompletedInfo', toolName: string, toolCallId: string, resultJson: string, isError: boolean };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails_toolCalls_AgentToolCallStartInfo = { __typename?: 'AgentToolCallStartInfo', toolName: string, toolCallId: string, argumentsJson: string, displayLabelPresent: string, displayLabelPast: string };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails_completedToolCalls_AgentToolCallCompletedInfo = { __typename?: 'AgentToolCallCompletedInfo', toolName: string, toolCallId: string, resultJson: string, isError: boolean };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails_toolCalls_AgentToolCallStartInfo = { __typename?: 'AgentToolCallStartInfo', toolName: string, toolCallId: string, argumentsJson: string, displayLabelPresent: string, displayLabelPast: string };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails', remainingToolCalls: Array<ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails_remainingToolCalls_AgentToolCallStartInfo>, completedToolCalls: Array<ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails_completedToolCalls_AgentToolCallCompletedInfo> };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails', toolCalls: Array<ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails_toolCalls_AgentToolCallStartInfo>, completedToolCalls: Array<ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails_completedToolCalls_AgentToolCallCompletedInfo> };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails', toolCalls: Array<ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails_toolCalls_AgentToolCallStartInfo> };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details = ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogAgentToolCalls_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogAgentToolCalls_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails', candidatePortalNoteId: any, sendToCandidate?: boolean | null, portalNoteContent?: string | null };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details = ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails', candidatePortalNoteId: any };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details = ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails', candidatePortalNoteId: any, sendToCandidate?: boolean | null, portalNoteContent?: string | null };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details = ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails', updatedPhoneNumber?: string | null };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details = ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails', tabName: string };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details = ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogCandidateViewedTabDetails_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogCandidateViewedTabDetails_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails', fromEmailAddress: string, toEmailAddress: string, ccAddresses: Array<string>, subject: string, body: string };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogEmail_ActivityLogFragment_ActivityLog_details = ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogEmail_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogEmail_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, details?: ActivityLogEmail_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails', employeeId?: any | null, employeeName: string, fromEmailAddress: string, toEmailAddress: string, ccAddresses: Array<string>, subject: string, body: string };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details = ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogEmployeeEmailReceived_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, details?: ActivityLogEmployeeEmailReceived_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails', employeeId?: any | null, employeeName: string, fromEmailAddress: string, toEmailAddress: string, ccAddresses: Array<string>, subject: string, body: string };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details = ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogEmployeeEmailSent_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, details?: ActivityLogEmployeeEmailSent_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails', employeeId?: any | null, employeeName: string, channelId: string, threadTs: string, messageTs: string, body: string };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details = ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, details?: ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails', employeeId?: any | null, employeeName: string, channelId: string, threadTs: string, messageTs: string, body: string };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details = ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogEmployeeSlackMessageSent_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, details?: ActivityLogEmployeeSlackMessageSent_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails_content_ActivityLogContent = { __typename?: 'ActivityLogContent', markdown: string, plaintext: string, formatVersion: number, editorStateJson: string };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails', note: string, isEdited: boolean, content?: ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails_content_ActivityLogContent | null };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogNote_ActivityLogFragment_ActivityLog_details = ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogNote_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogNote_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityActorEmployeeId?: any | null, details?: ActivityLogNote_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogEditNoteMutation_activityNoteEdit_ActivityNoteEditResult_activityLog_ActivityLog = (
  { __typename?: 'ActivityLog' }
  & ActivityLogNote_ActivityLogFragment
);

export type ActivityLogEditNoteMutation_activityNoteEdit_ActivityNoteEditResult = { __typename?: 'ActivityNoteEditResult', activityLog?: ActivityLogEditNoteMutation_activityNoteEdit_ActivityNoteEditResult_activityLog_ActivityLog | null };

export type ActivityLogEditNoteMutation_Mutation = { __typename?: 'Mutation', activityNoteEdit?: ActivityLogEditNoteMutation_activityNoteEdit_ActivityNoteEditResult | null };


export type ActivityLogEditNoteMutationVariables = Exact<{
  input: ActivityNoteEditInput;
  showTaskName?: Scalars['Boolean']['input'];
}>;


export type ActivityLogEditNoteMutation = ActivityLogEditNoteMutation_Mutation;

export type ActivityLogDeleteNoteMutation_activityNoteDelete_ActivityNoteDeleteResult = { __typename?: 'ActivityNoteDeleteResult', result?: Result | null };

export type ActivityLogDeleteNoteMutation_Mutation = { __typename?: 'Mutation', activityNoteDelete?: ActivityLogDeleteNoteMutation_activityNoteDelete_ActivityNoteDeleteResult | null };


export type ActivityLogDeleteNoteMutationVariables = Exact<{
  input: ActivityNoteDeleteInput;
}>;


export type ActivityLogDeleteNoteMutation = ActivityLogDeleteNoteMutation_Mutation;

export type ActivityLogTaskAgentDelegated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskAgentThinking_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskAgentUndelegated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails_assignee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails', assigneeId: any, assignee: ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails_assignee_Employee };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details = ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskAssigned_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskAssigned_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails', failureReason: TaskAutoCancelFailureReason, failureMessage: string };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details = ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskAutoCancelFailed_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskAutoCancelFailed_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCalendarChanges_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateAnonymized_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateAvailabilityDeleted_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateAvailabilityReminderSent_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateInterviewReminderSent_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidatePulseSurveyRequested_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidatePulseSurveySubmitted_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails', startAt: any, endAt: any, responseStatus: ResponseStatus, comment: string };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details = ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskCandidateRsvp_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskCandidateRsvp_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails', startAt: any, endAt: any, comment: string };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details = ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogCandidateRsvpAccepted_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogCandidateRsvpAccepted_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails', startAt: any, endAt: any, comment: string };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details = ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogCandidateRsvpDeclined_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogCandidateRsvpDeclined_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails', startAt: any, endAt: any, comment: string };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details = ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogCandidateRsvpTentative_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogCandidateRsvpTentative_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails', selfScheduleCandidateNote: string };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details = ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails', selfScheduleCandidateNote: string, sourcingLinkId?: any | null };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details = ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateSelfScheduleReminderSent_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails', selfScheduleCandidateNote: string };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details = ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails', sourcingLinkId?: any | null, note: string };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details = ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails', flagContent: string };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details = ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskChangeRequested_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskChangeRequested_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails', taskStatus: TaskStatus };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details = ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskChangedStatus_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskChangedStatus_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task = (
  { __typename?: 'Task', id: any }
  & TaskName_TaskFragment
);

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails', taskId: any, task: ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details = ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskClosed_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskClosed_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details = ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskClosedDueToStageChange_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskClosedDueToStageChange_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task = (
  { __typename?: 'Task', id: any, creationSource: TaskCreationSource }
  & TaskName_TaskFragment
);

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails', taskId: any, sourcingLinkId?: any | null, task: ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details = ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskCreated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskCreated_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskDebriefCanceled_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskDebriefCreated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskDebriefRescheduled_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails_previous_Employee = { __typename?: 'Employee', fullName?: string | null };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails_current_Employee = { __typename?: 'Employee', fullName?: string | null };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails', interviewName: string, previous?: ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails_previous_Employee | null, current?: ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails_current_Employee | null };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details = ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskEditedAvailability_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails', flagContent: string };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details = ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskFlagAdded_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskFlagAdded_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails', interviewName: string, interviewer: ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails_interviewer_Employee };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details = ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, plaintext?: string | null, details?: ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskFlagResolvedCandidateDeclined_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails', flagContent: string };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details = ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails', interviewName: string, interviewer: ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails_interviewer_Employee };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details = ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails', interviewName: string, interviewer: ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails_interviewer_Employee };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details = ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails_proposedTime_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails', interviewName: string, comment: string, proposedTime?: ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails_proposedTime_DateTimeRangeOutput | null };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details = ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogInterviewerRsvpAccepted_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogInterviewerRsvpAccepted_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails_proposedTime_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails', interviewName: string, comment: string, proposedTime?: ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails_proposedTime_DateTimeRangeOutput | null };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details = ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogInterviewerRsvpDeclined_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogInterviewerRsvpDeclined_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails_proposedTime_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails', interviewName: string, comment: string, proposedTime?: ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails_proposedTime_DateTimeRangeOutput | null };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details = ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogInterviewerRsvpTentative_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogInterviewerRsvpTentative_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskMarkedUrgent_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails_room_MeetingRoom = { __typename?: 'MeetingRoom', id: string, name?: string | null };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails', responseStatus: ResponseStatus, comment: string, interviewName: string, room?: ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails_room_MeetingRoom | null };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details = ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskMigrated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails_taskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any, name: string };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails', taskQueue?: ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails_taskQueue_TaskQueue | null };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details = ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskQueueSet_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskQueueSet_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails_taskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any, name: string };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails', taskQueue?: ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails_taskQueue_TaskQueue | null };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details = ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskQueueUnset_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskQueueUnset_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails_rsvp_Employee = { __typename?: 'Employee', fullName?: string | null };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails', interviewName: string, responseStatus: ResponseStatus, comment: string, rsvp?: ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails_rsvp_Employee | null };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details = ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskReadyForCandidateComm_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task = (
  { __typename?: 'Task', id: any }
  & TaskName_TaskFragment
);

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails', taskId: any, task: ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails_task_Task };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details = ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskReopened_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskReopened_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementApplicationDebriefAdded_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementApplicationDebriefRemoved_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementCandidateAvailabilityAdded_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementCandidateAvailabilityRemoved_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementCandidateAvailabilityUpdated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementScheduleAdded_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementSelfScheduleAdded_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementSelfScheduleRemoved_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRequirementSelfScheduleUpdated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog_rescheduleReason_RescheduleReason = { __typename?: 'RescheduleReason', reason: string };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog = { __typename?: 'RescheduleLog', id: any, note?: string | null, rescheduleReason?: ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog_rescheduleReason_RescheduleReason | null };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails', rescheduleLog?: ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog | null };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details = ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskRescheduleLogCreated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskRescheduleLogCreated_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog = { __typename?: 'RescheduleLog', id: any, note?: string | null };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails', rescheduleLog?: ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog | null };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details = ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog = { __typename?: 'RescheduleLog', id: any, note?: string | null };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails', rescheduleLog?: ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails_rescheduleLog_RescheduleLog | null };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details = ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskRescheduleLogEdited_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskRescheduleLogEdited_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskScheduleCanceled_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskScheduleCreated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskScheduleRescheduled_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskScheduleUpdated_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails', reason: string };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details = ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, details?: ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails_taskTags_TaskTag = { __typename?: 'TaskTag', id: any, name: string };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename: 'ActivityLogEmailDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename: 'ActivityLogFlagDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename: 'ActivityLogNoteDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename: 'ActivityLogTaskDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename: 'ActivityLogTaskTagDetails', taskTags: Array<ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails_taskTags_TaskTag> };

export type ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details = ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskTagAdded_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskTagAdded_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails_taskTags_TaskTag = { __typename?: 'TaskTag', id: any, name: string };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails', taskTags: Array<ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails_taskTags_TaskTag> };

export type ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details = ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmailDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogFlagDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogNoteDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogRsvpDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogScheduleDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskEventDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityLogTaskTagRemoved_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, details?: ActivityLogTaskTagRemoved_ActivityLogFragment_ActivityLog_details | null }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskUnassigned_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLogTaskUnmarkedUrgent_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogBase_ActivityLogFragment
);

export type ActivityLog_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType, plaintext?: string | null, ephemeral: boolean }
  & ActivityLogBase_ActivityLogFragment
  & ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragment
  & ActivityLogTaskCandidateAnonymized_ActivityLogFragment
  & ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragment
  & ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragment
  & ActivityLogEmail_ActivityLogFragment
  & ActivityLogEmployeeEmailSent_ActivityLogFragment
  & ActivityLogEmployeeEmailReceived_ActivityLogFragment
  & ActivityLogEmployeeSlackMessageReceived_ActivityLogFragment
  & ActivityLogEmployeeSlackMessageSent_ActivityLogFragment
  & ActivityLogNote_ActivityLogFragment
  & ActivityLogTaskAgentDelegated_ActivityLogFragment
  & ActivityLogTaskAgentThinking_ActivityLogFragment
  & ActivityLogTaskAgentUndelegated_ActivityLogFragment
  & ActivityLogAgentMessage_ActivityLogFragment
  & ActivityLogAgentQuestion_ActivityLogFragment
  & ActivityLogAgentReasoning_ActivityLogFragment
  & ActivityLogAgentDebug_ActivityLogFragment
  & ActivityLogAgentToolCalls_ActivityLogFragment
  & ActivityLogAgentQueued_ActivityLogFragment
  & ActivityLogAgentStopped_ActivityLogFragment
  & ActivityLogTaskAssigned_ActivityLogFragment
  & ActivityLogTaskCalendarChanges_ActivityLogFragment
  & ActivityLogTaskCandidateAvailabilityDeleted_ActivityLogFragment
  & ActivityLogTaskCandidateRsvp_ActivityLogFragment
  & ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragment
  & ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragment
  & ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragment
  & ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragment
  & ActivityLogTaskChangedStatus_ActivityLogFragment
  & ActivityLogTaskChangeRequested_ActivityLogFragment
  & ActivityLogTaskClosed_ActivityLogFragment
  & ActivityLogTaskClosed_ActivityLogFragment
  & ActivityLogTaskCreated_ActivityLogFragment
  & ActivityLogTaskCreated_ActivityLogFragment
  & ActivityLogTaskDebriefCanceled_ActivityLogFragment
  & ActivityLogTaskDebriefCreated_ActivityLogFragment
  & ActivityLogTaskEditedAvailability_ActivityLogFragment
  & ActivityLogTaskFlagAdded_ActivityLogFragment
  & ActivityLogTaskFlagLifecycleResolved_ActivityLogFragment
  & ActivityLogTaskFlagResolvedCandidateDeclined_ActivityLogFragment
  & ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragment
  & ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragment
  & ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragment
  & ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragment
  & ActivityLogTaskMarkedUrgent_ActivityLogFragment
  & ActivityLogTaskMeetingRoomRsvp_ActivityLogFragment
  & ActivityLogTaskRescheduleLogCreated_ActivityLogFragment
  & ActivityLogTaskRescheduleLogDeleted_ActivityLogFragment
  & ActivityLogTaskRescheduleLogEdited_ActivityLogFragment
  & ActivityLogTaskReopened_ActivityLogFragment
  & ActivityLogTaskRequirementApplicationDebriefAdded_ActivityLogFragment
  & ActivityLogTaskRequirementApplicationDebriefRemoved_ActivityLogFragment
  & ActivityLogTaskRequirementCandidateAvailabilityAdded_ActivityLogFragment
  & ActivityLogTaskRequirementCandidateAvailabilityRemoved_ActivityLogFragment
  & ActivityLogTaskRequirementCandidateAvailabilityUpdated_ActivityLogFragment
  & ActivityLogTaskRequirementScheduleAdded_ActivityLogFragment
  & ActivityLogTaskRequirementSelfScheduleAdded_ActivityLogFragment
  & ActivityLogTaskRequirementSelfScheduleRemoved_ActivityLogFragment
  & ActivityLogTaskRequirementSelfScheduleUpdated_ActivityLogFragment
  & ActivityLogTaskScheduleCanceled_ActivityLogFragment
  & ActivityLogTaskScheduleCreated_ActivityLogFragment
  & ActivityLogTaskScheduleRescheduled_ActivityLogFragment
  & ActivityLogTaskScheduleUpdated_ActivityLogFragment
  & ActivityLogTaskTagAdded_ActivityLogFragment
  & ActivityLogTaskTagRemoved_ActivityLogFragment
  & ActivityLogTaskUnassigned_ActivityLogFragment
  & ActivityLogTaskUnmarkedUrgent_ActivityLogFragment
  & ActivityLogTaskReadyForCandidateComm_ActivityLogFragment
  & ActivityLogCandidateViewedTabDetails_ActivityLogFragment
  & ActivityLogTaskQueueSet_ActivityLogFragment
  & ActivityLogTaskQueueUnset_ActivityLogFragment
  & ActivityLogTaskCandidateInterviewReminderSent_ActivityLogFragment
  & ActivityLogTaskCandidateSelfScheduleReminderSent_ActivityLogFragment
  & ActivityLogTaskCandidateAvailabilityReminderSent_ActivityLogFragment
  & ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragment
  & ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragment
  & ActivityLogInterviewerRsvpDeclined_ActivityLogFragment
  & ActivityLogInterviewerRsvpAccepted_ActivityLogFragment
  & ActivityLogInterviewerRsvpTentative_ActivityLogFragment
  & ActivityLogCandidateRsvpAccepted_ActivityLogFragment
  & ActivityLogCandidateRsvpDeclined_ActivityLogFragment
  & ActivityLogCandidateRsvpTentative_ActivityLogFragment
  & ActivityLogTaskCandidatePulseSurveyRequested_ActivityLogFragment
  & ActivityLogTaskCandidatePulseSurveySubmitted_ActivityLogFragment
  & ActivityLogTaskAutoCancelFailed_ActivityLogFragment
  & ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragment
);

export type ApplicationDetailsActivityLogsList_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogsList_ActivityLogFragment
);

export type ApplicationDetailsActivityLogsListQuery_application_Application_activityLogs_ActivityLogsResult_items_ActivityLog = (
  { __typename?: 'ActivityLog' }
  & ApplicationDetailsActivityLogsList_ActivityLogFragment
);

export type ApplicationDetailsActivityLogsListQuery_application_Application_activityLogs_ActivityLogsResult = { __typename?: 'ActivityLogsResult', nextCursor?: string | null, items: Array<ApplicationDetailsActivityLogsListQuery_application_Application_activityLogs_ActivityLogsResult_items_ActivityLog> };

export type ApplicationDetailsActivityLogsListQuery_application_Application = { __typename?: 'Application', id: any, activityLogs: ApplicationDetailsActivityLogsListQuery_application_Application_activityLogs_ActivityLogsResult };

export type ApplicationDetailsActivityLogsListQuery_Query = { __typename?: 'Query', application?: ApplicationDetailsActivityLogsListQuery_application_Application | null };


export type ApplicationDetailsActivityLogsListQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
  input: ActivityLogsForSourceInput;
  showTaskName?: Scalars['Boolean']['input'];
}>;


export type ApplicationDetailsActivityLogsListQuery = ApplicationDetailsActivityLogsListQuery_Query;

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_actorEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentDebugDetails = { __typename?: 'ActivityLogAgentDebugDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentMessageDetails = { __typename?: 'ActivityLogAgentMessageDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentQuestionDetails = { __typename?: 'ActivityLogAgentQuestionDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentQueuedDetails = { __typename?: 'ActivityLogAgentQueuedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentReasoningDetails = { __typename?: 'ActivityLogAgentReasoningDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails = { __typename?: 'ActivityLogAgentToolCallsContinueDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentToolCallsDetails = { __typename?: 'ActivityLogAgentToolCallsDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentToolCallsStartDetails = { __typename?: 'ActivityLogAgentToolCallsStartDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentTurnStartDetails = { __typename?: 'ActivityLogAgentTurnStartDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidatePortalNoteDetails = { __typename?: 'ActivityLogCandidatePortalNoteDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails = { __typename?: 'ActivityLogCandidatePreferredPhoneNumberChangeDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails = { __typename?: 'ActivityLogCandidateRsvpAcceptedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails = { __typename?: 'ActivityLogCandidateRsvpDeclinedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails = { __typename?: 'ActivityLogCandidateRsvpNeedsActionDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails = { __typename?: 'ActivityLogCandidateRsvpTentativeDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateViewedTabDetails = { __typename?: 'ActivityLogCandidateViewedTabDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmailDetails = { __typename?: 'ActivityLogEmailDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails = { __typename?: 'ActivityLogEmployeeEmailReceivedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeEmailSentDetails = { __typename?: 'ActivityLogEmployeeEmailSentDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails = { __typename?: 'ActivityLogEmployeeSlackMessageReceivedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails = { __typename?: 'ActivityLogEmployeeSlackMessageSentDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogFlagDetails = { __typename?: 'ActivityLogFlagDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerNoResponseDetails = { __typename?: 'ActivityLogInterviewerNoResponseDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails = { __typename?: 'ActivityLogInterviewerRsvpAcceptedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails = { __typename?: 'ActivityLogInterviewerRsvpDeclinedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails = { __typename?: 'ActivityLogInterviewerRsvpNeedsActionDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails = { __typename?: 'ActivityLogInterviewerRsvpTentativeDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogNoteDetails = { __typename?: 'ActivityLogNoteDetails', note: string };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogRescheduleLogDetails = { __typename?: 'ActivityLogRescheduleLogDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogRsvpDetails = { __typename?: 'ActivityLogRsvpDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogScheduleDetails = { __typename?: 'ActivityLogScheduleDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails = { __typename?: 'ActivityLogTaskAdditionalAttendeesUpdatedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAssigneeDetails = { __typename?: 'ActivityLogTaskAssigneeDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails = { __typename?: 'ActivityLogTaskAutoCancelFailedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAvailabilityDetails = { __typename?: 'ActivityLogTaskAvailabilityDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskDetails = { __typename?: 'ActivityLogTaskDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskEventDetails = { __typename?: 'ActivityLogTaskEventDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskInterviewerDetails = { __typename?: 'ActivityLogTaskInterviewerDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails = { __typename?: 'ActivityLogTaskMeetingLocationUpdatedDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskMeetingRoomDetails = { __typename?: 'ActivityLogTaskMeetingRoomDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails = { __typename?: 'ActivityLogTaskPerfectScheduleNotFoundDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskQueueDetails = { __typename?: 'ActivityLogTaskQueueDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails = { __typename?: 'ActivityLogTaskReadyForCandidateCommDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails = { __typename?: 'ActivityLogTaskSourcingLinkResumeUploadDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskStatusDetails = { __typename?: 'ActivityLogTaskStatusDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskTagDetails = { __typename?: 'ActivityLogTaskTagDetails' };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details = ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentDebugDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentMessageDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentQuestionDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentQueuedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentReasoningDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentToolCallsContinueDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentToolCallsDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentToolCallsStartDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogAgentTurnStartDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidatePortalNoteDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidatePreferredPhoneNumberChangeDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpAcceptedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpDeclinedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpNeedsActionDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateRsvpTentativeDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogCandidateViewedTabDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmailDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeEmailReceivedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeEmailSentDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeSlackMessageReceivedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogEmployeeSlackMessageSentDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogFlagDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerNoResponseDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpAcceptedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpDeclinedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpNeedsActionDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogInterviewerRsvpTentativeDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogNoteDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogRescheduleLogDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogRsvpDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogScheduleDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAdditionalAttendeesUpdatedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAssigneeDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAutoCancelFailedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskAvailabilityDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskEventDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskInterviewerDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskMeetingLocationUpdatedDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskMeetingRoomDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskPerfectScheduleNotFoundDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskQueueDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskReadyForCandidateCommDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskSourcingLinkResumeUploadDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskStatusDetails | ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details_ActivityLogTaskTagDetails;

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog = { __typename?: 'ActivityLog', id: any, createdAt: any, activityType: ActivityType, activityActorType: ActorType, activityActorEmployeeId?: any | null, actorEmployee?: ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_actorEmployee_Employee | null, details?: ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog_details | null };

export type ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult = { __typename?: 'ActivityNoteCreateResult', activityLog?: ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog | null };

export type ActivityNoteCreateMutation_Mutation = { __typename?: 'Mutation', activityNoteCreate?: ActivityNoteCreateMutation_activityNoteCreate_ActivityNoteCreateResult | null };


export type ActivityNoteCreateMutationVariables = Exact<{
  input: ActivityNoteCreateInput;
}>;


export type ActivityNoteCreateMutation = ActivityNoteCreateMutation_Mutation;

export type MockActivityLogFragment = { __typename?: 'ActivityLog', id: any };

export type ActivityLogsCacheProbeQuery_activityLogs_ActivityLogsResult = { __typename?: 'ActivityLogsResult', nextCursor?: string | null };

export type ActivityLogsCacheProbeQuery_Query = { __typename?: 'Query', activityLogs: ActivityLogsCacheProbeQuery_activityLogs_ActivityLogsResult };


export type ActivityLogsCacheProbeQueryVariables = Exact<{
  input: ActivityLogsInput;
}>;


export type ActivityLogsCacheProbeQuery = ActivityLogsCacheProbeQuery_Query;

export type ActivityLogsScopeCacheProbeQuery_activityLogs_ActivityLogsResult = { __typename?: 'ActivityLogsResult', nextCursor?: string | null };

export type ActivityLogsScopeCacheProbeQuery_Query = { __typename?: 'Query', activityLogs: ActivityLogsScopeCacheProbeQuery_activityLogs_ActivityLogsResult };


export type ActivityLogsScopeCacheProbeQueryVariables = Exact<{
  input: ActivityLogsInput;
}>;


export type ActivityLogsScopeCacheProbeQuery = ActivityLogsScopeCacheProbeQuery_Query;

export type EntityDetailsActivityLogsListQuery_activityLogs_ActivityLogsResult_items_ActivityLog = (
  { __typename?: 'ActivityLog' }
  & ActivityLogsList_ActivityLogFragment
);

export type EntityDetailsActivityLogsListQuery_activityLogs_ActivityLogsResult = { __typename?: 'ActivityLogsResult', nextCursor?: string | null, items: Array<EntityDetailsActivityLogsListQuery_activityLogs_ActivityLogsResult_items_ActivityLog> };

export type EntityDetailsActivityLogsListQuery_Query = { __typename?: 'Query', activityLogs: EntityDetailsActivityLogsListQuery_activityLogs_ActivityLogsResult };


export type EntityDetailsActivityLogsListQueryVariables = Exact<{
  input: ActivityLogsInput;
  showTaskName?: Scalars['Boolean']['input'];
}>;


export type EntityDetailsActivityLogsListQuery = EntityDetailsActivityLogsListQuery_Query;

export type MentionEmployeeSearchQuery_employeeSearch_EmployeeSearchOutput_items_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type MentionEmployeeSearchQuery_employeeSearch_EmployeeSearchOutput = { __typename?: 'EmployeeSearchOutput', items: Array<MentionEmployeeSearchQuery_employeeSearch_EmployeeSearchOutput_items_Employee> };

export type MentionEmployeeSearchQuery_Query = { __typename?: 'Query', employeeSearch?: MentionEmployeeSearchQuery_employeeSearch_EmployeeSearchOutput | null };


export type MentionEmployeeSearchQueryVariables = Exact<{
  input: EmployeeSearchInput;
}>;


export type MentionEmployeeSearchQuery = MentionEmployeeSearchQuery_Query;

export type ActivityNoteCreateWithContentMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog = { __typename?: 'ActivityLog', id: any };

export type ActivityNoteCreateWithContentMutation_activityNoteCreate_ActivityNoteCreateResult = { __typename?: 'ActivityNoteCreateResult', activityLog?: ActivityNoteCreateWithContentMutation_activityNoteCreate_ActivityNoteCreateResult_activityLog_ActivityLog | null };

export type ActivityNoteCreateWithContentMutation_Mutation = { __typename?: 'Mutation', activityNoteCreate?: ActivityNoteCreateWithContentMutation_activityNoteCreate_ActivityNoteCreateResult | null };


export type ActivityNoteCreateWithContentMutationVariables = Exact<{
  input: ActivityNoteCreateInput;
}>;


export type ActivityNoteCreateWithContentMutation = ActivityNoteCreateWithContentMutation_Mutation;

export type MockActivityLogsListFragment = { __typename?: 'ActivityLog', id: any };

export type ActivityLogCreatedSubscription_activityLogCreated_ActivityLog = { __typename?: 'ActivityLog', id: any, activityType: ActivityType, createdAt: any };

export type ActivityLogCreatedSubscription_Subscription = { __typename?: 'Subscription', activityLogCreated: ActivityLogCreatedSubscription_activityLogCreated_ActivityLog };


export type ActivityLogCreatedSubscriptionVariables = Exact<{
  input: ActivityLogSubscriptionInput;
}>;


export type ActivityLogCreatedSubscription = ActivityLogCreatedSubscription_Subscription;

export type TaskUpdatedSubscription_taskUpdated_TaskUpdatedPayload = { __typename?: 'TaskUpdatedPayload', taskId: any, updateType: string, delegateStatus?: string | null };

export type TaskUpdatedSubscription_Subscription = { __typename?: 'Subscription', taskUpdated: TaskUpdatedSubscription_taskUpdated_TaskUpdatedPayload };


export type TaskUpdatedSubscriptionVariables = Exact<{
  input: TaskUpdatedSubscriptionInput;
}>;


export type TaskUpdatedSubscription = TaskUpdatedSubscription_Subscription;

export type NewActivityLogFragment = { __typename?: 'ActivityLog', id: any, activityType: ActivityType, createdAt: any };

export type TaskDetailsActivityLogsList_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogsList_ActivityLogFragment
);

export type TaskDetailsActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult_items_ActivityLog = (
  { __typename?: 'ActivityLog', id: any }
  & TaskDetailsActivityLogsList_ActivityLogFragment
);

export type TaskDetailsActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult = { __typename?: 'ActivityLogsResult', nextCursor?: string | null, items: Array<TaskDetailsActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult_items_ActivityLog> };

export type TaskDetailsActivityLogsListQuery_task_Task = { __typename?: 'Task', id: any, activityLogs: TaskDetailsActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult };

export type TaskDetailsActivityLogsListQuery_Query = { __typename?: 'Query', task?: TaskDetailsActivityLogsListQuery_task_Task | null };


export type TaskDetailsActivityLogsListQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  input: ActivityLogsForSourceInput;
  showTaskName?: Scalars['Boolean']['input'];
}>;


export type TaskDetailsActivityLogsListQuery = TaskDetailsActivityLogsListQuery_Query;

export type NewTimelineActivityLogFragment = { __typename?: 'ActivityLog', id: any, activityType: ActivityType, createdAt: any };

export type TaskTimelineActivityLogsList_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any }
  & ActivityLogsList_ActivityLogFragment
);

export type TaskTimelineActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult_items_ActivityLog = (
  { __typename?: 'ActivityLog', id: any }
  & TaskTimelineActivityLogsList_ActivityLogFragment
);

export type TaskTimelineActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult = { __typename?: 'ActivityLogsResult', nextCursor?: string | null, items: Array<TaskTimelineActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult_items_ActivityLog> };

export type TaskTimelineActivityLogsListQuery_task_Task = { __typename?: 'Task', id: any, activityLogs: TaskTimelineActivityLogsListQuery_task_Task_activityLogs_ActivityLogsResult };

export type TaskTimelineActivityLogsListQuery_Query = { __typename?: 'Query', task?: TaskTimelineActivityLogsListQuery_task_Task | null };


export type TaskTimelineActivityLogsListQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  input: ActivityLogsForSourceInput;
  showTaskName?: Scalars['Boolean']['input'];
}>;


export type TaskTimelineActivityLogsListQuery = TaskTimelineActivityLogsListQuery_Query;

export type ActivityLogsList_ActivityLogFragment = (
  { __typename?: 'ActivityLog', id: any, activityType: ActivityType }
  & ActivityLog_ActivityLogFragment
);

type AiActorName_Actor_AgentActor_Fragment = { __typename: 'AgentActor', id: string, type: ActorType, displayName: string };

type AiActorName_Actor_CandidateActor_Fragment = { __typename: 'CandidateActor', id: string, type: ActorType, displayName: string };

type AiActorName_Actor_EmployeeActor_Fragment = { __typename: 'EmployeeActor', id: string, type: ActorType, displayName: string };

type AiActorName_Actor_SystemActorV2_Fragment = { __typename: 'SystemActorV2', id: string, type: ActorType, displayName: string };

export type AiActorName_ActorFragment = AiActorName_Actor_AgentActor_Fragment | AiActorName_Actor_CandidateActor_Fragment | AiActorName_Actor_EmployeeActor_Fragment | AiActorName_Actor_SystemActorV2_Fragment;

export type AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_AgentActor = (
  { __typename?: 'AgentActor' }
  & AiActorName_Actor_AgentActor_Fragment
);

export type AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_CandidateActor = (
  { __typename?: 'CandidateActor' }
  & AiActorName_Actor_CandidateActor_Fragment
);

export type AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_EmployeeActor = (
  { __typename?: 'EmployeeActor' }
  & AiActorName_Actor_EmployeeActor_Fragment
);

export type AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_SystemActorV2 = (
  { __typename?: 'SystemActorV2' }
  & AiActorName_Actor_SystemActorV2_Fragment
);

export type AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy = AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_AgentActor | AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_CandidateActor | AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_EmployeeActor | AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy_SystemActorV2;

export type AiInstructionsCard_InstructionFragment = { __typename?: 'AiInstruction', id: any, content: string, updatedAt: any, updatedBy?: AiInstructionsCard_InstructionFragment_AiInstruction_updatedBy | null };

export type AiMemoriesCard_MemoryFragment_AiMemory_createdBy_AgentActor = (
  { __typename?: 'AgentActor' }
  & AiActorName_Actor_AgentActor_Fragment
);

export type AiMemoriesCard_MemoryFragment_AiMemory_createdBy_CandidateActor = (
  { __typename?: 'CandidateActor' }
  & AiActorName_Actor_CandidateActor_Fragment
);

export type AiMemoriesCard_MemoryFragment_AiMemory_createdBy_EmployeeActor = (
  { __typename?: 'EmployeeActor' }
  & AiActorName_Actor_EmployeeActor_Fragment
);

export type AiMemoriesCard_MemoryFragment_AiMemory_createdBy_SystemActorV2 = (
  { __typename?: 'SystemActorV2' }
  & AiActorName_Actor_SystemActorV2_Fragment
);

export type AiMemoriesCard_MemoryFragment_AiMemory_createdBy = AiMemoriesCard_MemoryFragment_AiMemory_createdBy_AgentActor | AiMemoriesCard_MemoryFragment_AiMemory_createdBy_CandidateActor | AiMemoriesCard_MemoryFragment_AiMemory_createdBy_EmployeeActor | AiMemoriesCard_MemoryFragment_AiMemory_createdBy_SystemActorV2;

export type AiMemoriesCard_MemoryFragment = { __typename?: 'AiMemory', id: any, content: string, createdAt: any, createdBy?: AiMemoriesCard_MemoryFragment_AiMemory_createdBy | null };

export type AiInstructionUpsertMutation_aiInstructionUpsert_AiInstruction = { __typename?: 'AiInstruction', id: any };

export type AiInstructionUpsertMutation_Mutation = { __typename?: 'Mutation', aiInstructionUpsert: AiInstructionUpsertMutation_aiInstructionUpsert_AiInstruction };


export type AiInstructionUpsertMutationVariables = Exact<{
  input: AiInstructionUpsertInput;
}>;


export type AiInstructionUpsertMutation = AiInstructionUpsertMutation_Mutation;

export type AiInstructionDeleteMutation_aiInstructionDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type AiInstructionDeleteMutation_Mutation = { __typename?: 'Mutation', aiInstructionDelete: AiInstructionDeleteMutation_aiInstructionDelete_EmptyResult };


export type AiInstructionDeleteMutationVariables = Exact<{
  input: AiInstructionDeleteInput;
}>;


export type AiInstructionDeleteMutation = AiInstructionDeleteMutation_Mutation;

export type AiMemoryCreateMutation_aiMemoryCreate_AiMemory = { __typename?: 'AiMemory', id: any };

export type AiMemoryCreateMutation_Mutation = { __typename?: 'Mutation', aiMemoryCreate: AiMemoryCreateMutation_aiMemoryCreate_AiMemory };


export type AiMemoryCreateMutationVariables = Exact<{
  input: AiMemoryCreateInput;
}>;


export type AiMemoryCreateMutation = AiMemoryCreateMutation_Mutation;

export type AiMemoryUpdateMutation_aiMemoryUpdate_AiMemory = { __typename?: 'AiMemory', id: any };

export type AiMemoryUpdateMutation_Mutation = { __typename?: 'Mutation', aiMemoryUpdate: AiMemoryUpdateMutation_aiMemoryUpdate_AiMemory };


export type AiMemoryUpdateMutationVariables = Exact<{
  input: AiMemoryUpdateInput;
}>;


export type AiMemoryUpdateMutation = AiMemoryUpdateMutation_Mutation;

export type AiMemoryDeleteMutation_aiMemoryDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type AiMemoryDeleteMutation_Mutation = { __typename?: 'Mutation', aiMemoryDelete: AiMemoryDeleteMutation_aiMemoryDelete_EmptyResult };


export type AiMemoryDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AiMemoryDeleteMutation = AiMemoryDeleteMutation_Mutation;

export type ApplicationItem_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type ApplicationItem_ApplicationFragment_Application_recruiter_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ApplicationItem_ApplicationFragment_Application_coordinator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ApplicationItem_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type ApplicationItem_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type ApplicationItem_ApplicationFragment = { __typename?: 'Application', id: any, status: ApplicationStatus, currentJobStageActiveTaskCount: number, candidate?: ApplicationItem_ApplicationFragment_Application_candidate_Candidate | null, recruiter?: ApplicationItem_ApplicationFragment_Application_recruiter_Employee | null, coordinator?: ApplicationItem_ApplicationFragment_Application_coordinator_Employee | null, job?: ApplicationItem_ApplicationFragment_Application_job_Job | null, jobStage?: ApplicationItem_ApplicationFragment_Application_jobStage_JobStage | null };

export type AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsJobStage_AtsJobStage = { __typename?: 'AtsJobStage', atsId: string, name: string, index: number };

export type AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition = { __typename?: 'AshbyInterviewDefinition' };

export type AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_GemInterviewDefinition = { __typename?: 'GemInterviewDefinition' };

export type AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition = { __typename?: 'GreenhouseInterviewDefinition', estimatedMinutes: any, index: any };

export type AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_LeverInterviewDefinition = { __typename?: 'LeverInterviewDefinition', groupId?: string | null, groupName?: string | null };

export type AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition = { __typename?: 'WorkdayInterviewDefinition' };

export type AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields = AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition | AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_GemInterviewDefinition | AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition | AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_LeverInterviewDefinition | AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition;

export type AtsInterviewDefinitionFragment = { __typename?: 'AtsInterviewDefinition', name: string, atsId: string, atsJobStageId?: string | null, atsJobId?: string | null, atsJobStage?: AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsJobStage_AtsJobStage | null, atsFields?: AtsInterviewDefinitionFragment_AtsInterviewDefinition_atsFields | null };

export type AtsInterviewDefinitionsQuery_atsInterviewDefinitions_AtsInterviewDefinitionsOutput_atsInterviewDefinitions_AtsInterviewDefinition = (
  { __typename?: 'AtsInterviewDefinition' }
  & AtsInterviewDefinitionFragment
);

export type AtsInterviewDefinitionsQuery_atsInterviewDefinitions_AtsInterviewDefinitionsOutput = { __typename?: 'AtsInterviewDefinitionsOutput', atsInterviewDefinitions?: Array<AtsInterviewDefinitionsQuery_atsInterviewDefinitions_AtsInterviewDefinitionsOutput_atsInterviewDefinitions_AtsInterviewDefinition> | null };

export type AtsInterviewDefinitionsQuery_Query = { __typename?: 'Query', atsInterviewDefinitions?: AtsInterviewDefinitionsQuery_atsInterviewDefinitions_AtsInterviewDefinitionsOutput | null };


export type AtsInterviewDefinitionsQueryVariables = Exact<{
  input: AtsInterviewDefinitionsInput;
}>;


export type AtsInterviewDefinitionsQuery = AtsInterviewDefinitionsQuery_Query;

export type AtsInterviewDefinitionsByIdsQuery_atsInterviewDefinitionsByIds_AtsInterviewDefinitionsOutput_atsInterviewDefinitions_AtsInterviewDefinition = (
  { __typename?: 'AtsInterviewDefinition' }
  & AtsInterviewDefinitionFragment
);

export type AtsInterviewDefinitionsByIdsQuery_atsInterviewDefinitionsByIds_AtsInterviewDefinitionsOutput = { __typename?: 'AtsInterviewDefinitionsOutput', atsInterviewDefinitions?: Array<AtsInterviewDefinitionsByIdsQuery_atsInterviewDefinitionsByIds_AtsInterviewDefinitionsOutput_atsInterviewDefinitions_AtsInterviewDefinition> | null };

export type AtsInterviewDefinitionsByIdsQuery_Query = { __typename?: 'Query', atsInterviewDefinitionsByIds?: AtsInterviewDefinitionsByIdsQuery_atsInterviewDefinitionsByIds_AtsInterviewDefinitionsOutput | null };


export type AtsInterviewDefinitionsByIdsQueryVariables = Exact<{
  input: AtsInterviewDefinitionsByIdsInput;
}>;


export type AtsInterviewDefinitionsByIdsQuery = AtsInterviewDefinitionsByIdsQuery_Query;

export type BrandingThemePlaceholderPreview_BrandingThemeFragment = { __typename?: 'BrandingTheme', id: any, themeMode?: BrandingThemeMode | null, profileImageUrl?: string | null, coverImageUrl?: string | null, primaryColor?: string | null, font?: string | null };

export type Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_AshbyCandidate = { __typename?: 'AshbyCandidate' };

export type Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_GreenhouseCandidate = { __typename?: 'GreenhouseCandidate' };

export type Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_LeverCandidate = { __typename?: 'LeverCandidate', origin?: string | null };

export type Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_WorkdayCandidate = { __typename?: 'WorkdayCandidate' };

export type Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields = Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_AshbyCandidate | Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_GreenhouseCandidate | Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_LeverCandidate | Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields_WorkdayCandidate;

export type Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsId: string, atsFields?: Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate_atsFields | null };

export type Candidate_CandidateFragment = { __typename?: 'Candidate', id: any, fullName?: string | null, anonymizedAt?: any | null, atsCandidate?: Candidate_CandidateFragment_Candidate_atsCandidate_AtsCandidate | null };

export type CompanyHolidayIcon_CompanyHolidaysFragment_CompanyHoliday_countries_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type CompanyHolidayIcon_CompanyHolidaysFragment = { __typename?: 'CompanyHoliday', id: any, name: string, startAt: any, endAt: any, countries?: Array<CompanyHolidayIcon_CompanyHolidaysFragment_CompanyHoliday_countries_EmployeeAttributeTagValue> | null };

export type CompanyHolidaysForDaysQuery_companyHolidaysForDays_CompanyHolidaysForDaysResult_items_CompanyHolidaysForDays_companyHolidays_CompanyHoliday = (
  { __typename?: 'CompanyHoliday' }
  & CompanyHolidayIcon_CompanyHolidaysFragment
);

export type CompanyHolidaysForDaysQuery_companyHolidaysForDays_CompanyHolidaysForDaysResult_items_CompanyHolidaysForDays = { __typename?: 'CompanyHolidaysForDays', date: any, companyHolidays: Array<CompanyHolidaysForDaysQuery_companyHolidaysForDays_CompanyHolidaysForDaysResult_items_CompanyHolidaysForDays_companyHolidays_CompanyHoliday> };

export type CompanyHolidaysForDaysQuery_companyHolidaysForDays_CompanyHolidaysForDaysResult = { __typename?: 'CompanyHolidaysForDaysResult', items: Array<CompanyHolidaysForDaysQuery_companyHolidaysForDays_CompanyHolidaysForDaysResult_items_CompanyHolidaysForDays> };

export type CompanyHolidaysForDaysQuery_Query = { __typename?: 'Query', companyHolidaysForDays?: CompanyHolidaysForDaysQuery_companyHolidaysForDays_CompanyHolidaysForDaysResult | null };


export type CompanyHolidaysForDaysQueryVariables = Exact<{
  input: CompanyHolidaysForDaysInput;
}>;


export type CompanyHolidaysForDaysQuery = CompanyHolidaysForDaysQuery_Query;

export type VisibilitySelectFixIssuesQuery_jobStages_JobStagesOutput_items_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type VisibilitySelectFixIssuesQuery_jobStages_JobStagesOutput = { __typename?: 'JobStagesOutput', items: Array<VisibilitySelectFixIssuesQuery_jobStages_JobStagesOutput_items_JobStage> };

export type VisibilitySelectFixIssuesQuery_Query = { __typename?: 'Query', jobStages?: VisibilitySelectFixIssuesQuery_jobStages_JobStagesOutput | null };


export type VisibilitySelectFixIssuesQueryVariables = Exact<{
  input: JobStagesInput;
}>;


export type VisibilitySelectFixIssuesQuery = VisibilitySelectFixIssuesQuery_Query;

export type VisibilitySelectJobStagesQuery_jobStages_JobStagesOutput_items_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type VisibilitySelectJobStagesQuery_jobStages_JobStagesOutput = { __typename?: 'JobStagesOutput', items: Array<VisibilitySelectJobStagesQuery_jobStages_JobStagesOutput_items_JobStage> };

export type VisibilitySelectJobStagesQuery_Query = { __typename?: 'Query', jobStages?: VisibilitySelectJobStagesQuery_jobStages_JobStagesOutput | null };


export type VisibilitySelectJobStagesQueryVariables = Exact<{
  input: JobStagesInput;
}>;


export type VisibilitySelectJobStagesQuery = VisibilitySelectJobStagesQuery_Query;

export type CountryAttributeQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type CountryAttributeQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, values?: Array<CountryAttributeQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue> | null };

export type CountryAttributeQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<CountryAttributeQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type CountryAttributeQuery_Query = { __typename?: 'Query', employeeAttributeNames?: CountryAttributeQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null };


export type CountryAttributeQueryVariables = Exact<{
  input: EmployeeAttributeNamesInput;
}>;


export type CountryAttributeQuery = CountryAttributeQuery_Query;

export type DebriefAtsWriteRow_SettingFragment_DebriefAtsWriteSettingPref_scorecardRecipients_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null, externalEmailAddresses?: Array<string> | null };

export type DebriefAtsWriteRow_SettingFragment = { __typename?: 'DebriefAtsWriteSettingPref', atsInterviewDefinitionId?: string | null, definitionNameMatch?: string | null, scorecardRecipients?: DebriefAtsWriteRow_SettingFragment_DebriefAtsWriteSettingPref_scorecardRecipients_NotificationPreference | null };

export type DebriefAtsWriteRow_OrgSettingFragment_DebriefAtsWriteSettingPref_scorecardRecipients_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null, externalEmailAddresses?: Array<string> | null };

export type DebriefAtsWriteRow_OrgSettingFragment = { __typename?: 'DebriefAtsWriteSettingPref', atsInterviewDefinitionId?: string | null, definitionNameMatch?: string | null, scorecardRecipients?: DebriefAtsWriteRow_OrgSettingFragment_DebriefAtsWriteSettingPref_scorecardRecipients_NotificationPreference | null };

export type DebriefAtsWriteCapabilityQuery_thisOrg_Org = { __typename?: 'Org', id: any, canSendDebriefToAts: boolean };

export type DebriefAtsWriteCapabilityQuery_Query = { __typename?: 'Query', thisOrg?: DebriefAtsWriteCapabilityQuery_thisOrg_Org | null };


export type DebriefAtsWriteCapabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type DebriefAtsWriteCapabilityQuery = DebriefAtsWriteCapabilityQuery_Query;

export type DebriefContentActions_DebriefFragment_ApplicationDebrief_task_Task = { __typename?: 'Task', id: any };

export type DebriefContentActions_DebriefFragment = { __typename?: 'ApplicationDebrief', id: any, applicationId?: any | null, startAt?: any | null, endAt?: any | null, task?: DebriefContentActions_DebriefFragment_ApplicationDebrief_task_Task | null };

export type DebriefContentDetails_DebriefFragment_ApplicationDebrief_additionalAttendeesV2_AdditionalAttendees = (
  { __typename?: 'AdditionalAttendees' }
  & AdditionalAttendeesDetails_AdditionalAttendeesFragment
);

export type DebriefContentDetails_DebriefFragment_ApplicationDebrief_attendees_ApplicationDebriefAttendee = (
  { __typename?: 'ApplicationDebriefAttendee', applicationDebriefId: any }
  & DebriefContentDetailsInterviewer_DebriefFragment
);

export type DebriefContentDetails_DebriefFragment_ApplicationDebrief_meetingRooms_ApplicationDebriefRoom = (
  { __typename?: 'ApplicationDebriefRoom', applicationDebriefId: any, meetingRoomId: any }
  & DebriefContentDetailsMeetingRoom_MeetingRoomFragment
);

export type DebriefContentDetails_DebriefFragment = { __typename?: 'ApplicationDebrief', id: any, additionalAttendeesV2: DebriefContentDetails_DebriefFragment_ApplicationDebrief_additionalAttendeesV2_AdditionalAttendees, attendees?: Array<DebriefContentDetails_DebriefFragment_ApplicationDebrief_attendees_ApplicationDebriefAttendee> | null, meetingRooms?: Array<DebriefContentDetails_DebriefFragment_ApplicationDebrief_meetingRooms_ApplicationDebriefRoom> | null };

export type DebriefContentDetailsInterviewer_DebriefFragment_ApplicationDebriefAttendee_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type DebriefContentDetailsInterviewer_DebriefFragment_ApplicationDebriefAttendee_proposedTime_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type DebriefContentDetailsInterviewer_DebriefFragment = { __typename?: 'ApplicationDebriefAttendee', applicationDebriefId: any, interviewerId: any, responseStatus?: ResponseStatus | null, isOptional: boolean, interviewer?: DebriefContentDetailsInterviewer_DebriefFragment_ApplicationDebriefAttendee_interviewer_Employee | null, proposedTime?: DebriefContentDetailsInterviewer_DebriefFragment_ApplicationDebriefAttendee_proposedTime_DateTimeRangeOutput | null };

export type DebriefContentDetailsMeetingRoom_MeetingRoomFragment_ApplicationDebriefRoom_meetingRoom_MeetingRoom = { __typename?: 'MeetingRoom', id: string, name?: string | null, description?: string | null };

export type DebriefContentDetailsMeetingRoom_MeetingRoomFragment = { __typename?: 'ApplicationDebriefRoom', applicationDebriefId: any, meetingRoomId: any, responseStatus?: ResponseStatus | null, meetingRoom?: DebriefContentDetailsMeetingRoom_MeetingRoomFragment_ApplicationDebriefRoom_meetingRoom_MeetingRoom | null };

export type DebriefContentHeader_DebriefFragment = (
  { __typename?: 'ApplicationDebrief', id: any, name?: string | null, startAt?: any | null, endAt?: any | null, videoMeetingUrl?: string | null }
  & DebriefContentMenu_DebriefFragment
);

export type DebriefContentMenu_DebriefFragment_ApplicationDebrief_task_Task = { __typename?: 'Task', id: any };

export type DebriefContentMenu_DebriefFragment = { __typename?: 'ApplicationDebrief', id: any, startAt?: any | null, googleEventUrl?: string | null, videoMeetingUrl?: string | null, applicationId?: any | null, zoomMeetingId?: any | null, zoomHostUserId?: string | null, zoomPassword?: string | null, zoomPstnPassword?: any | null, zoomDialIns?: any | null, task?: DebriefContentMenu_DebriefFragment_ApplicationDebrief_task_Task | null };

export type DebriefContentInterviewMenuQuery_templateToken_TemplateToken = { __typename?: 'TemplateToken', ZOOM_MEETING_INFO?: string | null, ZOOM_MEETING_DIAL_IN_INFO?: string | null };

export type DebriefContentInterviewMenuQuery_Query = { __typename?: 'Query', templateToken?: DebriefContentInterviewMenuQuery_templateToken_TemplateToken | null };


export type DebriefContentInterviewMenuQueryVariables = Exact<{
  input: TemplateTokenInput;
  zoomMeetingInfoInput: TokenZoomMeetingInput;
}>;


export type DebriefContentInterviewMenuQuery = DebriefContentInterviewMenuQuery_Query;

export type DebriefContentMeeting_DebriefFragment = (
  { __typename?: 'ApplicationDebrief', id: any }
  & DebriefContentHeader_DebriefFragment
  & DebriefContentDetails_DebriefFragment
);

export type DebriefContentEntity_DebriefFragment_ApplicationDebrief_creator_Employee = { __typename?: 'Employee', fullName?: string | null };

export type DebriefContentEntity_DebriefFragment = (
  { __typename?: 'ApplicationDebrief', id: any, startAt?: any | null, endAt?: any | null, createdAt?: any | null, creator?: DebriefContentEntity_DebriefFragment_ApplicationDebrief_creator_Employee | null }
  & DebriefContentActions_DebriefFragment
  & DebriefContentMeeting_DebriefFragment
);

export type EmployeeFragment = { __typename?: 'Employee', fullName?: string | null, email: string, id: any, orgId: any, internalProfilePictureUrl?: string | null, timezone?: string | null, atsId?: string | null, isDirectoryDisabled: boolean, isArchived?: boolean | null, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null, title?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_monday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_tuesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_wednesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_thursday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_friday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_saturday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_sunday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek = { __typename?: 'TimeBlockWeek', monday?: Array<EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_monday_TimeBlock> | null, tuesday?: Array<EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_tuesday_TimeBlock> | null, wednesday?: Array<EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_wednesday_TimeBlock> | null, thursday?: Array<EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_thursday_TimeBlock> | null, friday?: Array<EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_friday_TimeBlock> | null, saturday?: Array<EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_saturday_TimeBlock> | null, sunday?: Array<EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek_sunday_TimeBlock> | null };

export type EmployeeWorkHoursFragment = { __typename?: 'Employee', workHours?: EmployeeWorkHoursFragment_Employee_workHours_TimeBlockWeek | null };

export type EmployeeAttributesFragment_Employee_manager_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type EmployeeAttributesFragment_Employee_calendarDelegate_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type EmployeeAttributesFragment_Employee_atsUser_AtsUser = { __typename?: 'AtsUser', atsId: string, fullName: string, email: string, isDisabled: boolean };

export type EmployeeAttributesFragment = { __typename?: 'Employee', id: any, isArchived?: boolean | null, fullName?: string | null, email: string, timezone?: string | null, linkedinUrl?: string | null, title?: string | null, googleUserId?: string | null, isDirectoryDisabled: boolean, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null, atsId?: string | null, manager?: EmployeeAttributesFragment_Employee_manager_Employee | null, calendarDelegate?: EmployeeAttributesFragment_Employee_calendarDelegate_Employee | null, atsUser?: EmployeeAttributesFragment_Employee_atsUser_AtsUser | null };

export type EmployeeDetailsFragmentFragment_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type EmployeeDetailsFragmentFragment = (
  { __typename?: 'Employee', linkedinUrl?: string | null, googleUserId?: string | null, givenName?: string | null, useCalendarTimezone: boolean, calendarTimezone?: string | null, interviewPauseDates?: Array<EmployeeDetailsFragmentFragment_Employee_interviewPauseDates_DateBlock> | null }
  & EmployeeFragment
  & EmployeeAttributesFragment
  & EmployeeWorkHoursFragment
);

export type EmployeeListQuery_employeeSearch_EmployeeSearchOutput_items_Employee = (
  { __typename?: 'Employee', upcomingInterviewsCount?: any | null, modulesTrainedCount?: any | null, modulesInTrainingCount?: any | null }
  & EmployeeFragment
);

export type EmployeeListQuery_employeeSearch_EmployeeSearchOutput = { __typename?: 'EmployeeSearchOutput', total?: number | null, items: Array<EmployeeListQuery_employeeSearch_EmployeeSearchOutput_items_Employee> };

export type EmployeeListQuery_Query = { __typename?: 'Query', employeeSearch?: EmployeeListQuery_employeeSearch_EmployeeSearchOutput | null };


export type EmployeeListQueryVariables = Exact<{
  input: EmployeeSearchInput;
}>;


export type EmployeeListQuery = EmployeeListQuery_Query;

export type EmployeesQuery_employees_EmployeesOutput_items_Employee = (
  { __typename?: 'Employee' }
  & EmployeeFragment
);

export type EmployeesQuery_employees_EmployeesOutput = { __typename?: 'EmployeesOutput', nextCursor?: string | null, items: Array<EmployeesQuery_employees_EmployeesOutput_items_Employee> };

export type EmployeesQuery_Query = { __typename?: 'Query', employees?: EmployeesQuery_employees_EmployeesOutput | null };


export type EmployeesQueryVariables = Exact<{
  input: EmployeesInput;
}>;


export type EmployeesQuery = EmployeesQuery_Query;

export type EmployeeByIdsQuery_employeeByIds_Employee = (
  { __typename?: 'Employee' }
  & EmployeeFragment
);

export type EmployeeByIdsQuery_Query = { __typename?: 'Query', employeeByIds?: Array<EmployeeByIdsQuery_employeeByIds_Employee> | null };


export type EmployeeByIdsQueryVariables = Exact<{
  input: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type EmployeeByIdsQuery = EmployeeByIdsQuery_Query;

export type EmployeeDetailsQuery_employee_Employee = (
  { __typename?: 'Employee' }
  & EmployeeDetailsFragmentFragment
);

export type EmployeeDetailsQuery_Query = { __typename?: 'Query', employee?: EmployeeDetailsQuery_employee_Employee | null };


export type EmployeeDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EmployeeDetailsQuery = EmployeeDetailsQuery_Query;

export type UpdateEmployeeMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee = (
  { __typename?: 'Employee' }
  & EmployeeFragment
);

export type UpdateEmployeeMutation_employeeUpdate_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: UpdateEmployeeMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee | null };

export type UpdateEmployeeMutation_Mutation = { __typename?: 'Mutation', employeeUpdate?: UpdateEmployeeMutation_employeeUpdate_EmployeeUpdateResult | null };


export type UpdateEmployeeMutationVariables = Exact<{
  input: EmployeeUpdateInput;
}>;


export type UpdateEmployeeMutation = UpdateEmployeeMutation_Mutation;

export type EmployeesWorkHoursQuery_employeeByIds_Employee = (
  { __typename?: 'Employee', id: any, timezone?: string | null }
  & EmployeeWorkHoursFragment
);

export type EmployeesWorkHoursQuery_Query = { __typename?: 'Query', employeeByIds?: Array<EmployeesWorkHoursQuery_employeeByIds_Employee> | null };


export type EmployeesWorkHoursQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type EmployeesWorkHoursQuery = EmployeesWorkHoursQuery_Query;

export type EmployeePicker_EmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, orgId: any, internalProfilePictureUrl?: string | null, timezone?: string | null, atsId?: string | null, isDirectoryDisabled: boolean, isArchived?: boolean | null, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null, title?: string | null };

export type EmployeePickerListQuery_employeeSearch_EmployeeSearchOutput_items_Employee = (
  { __typename?: 'Employee' }
  & EmployeePicker_EmployeeFragment
);

export type EmployeePickerListQuery_employeeSearch_EmployeeSearchOutput = { __typename?: 'EmployeeSearchOutput', total?: number | null, items: Array<EmployeePickerListQuery_employeeSearch_EmployeeSearchOutput_items_Employee> };

export type EmployeePickerListQuery_Query = { __typename?: 'Query', employeeSearch?: EmployeePickerListQuery_employeeSearch_EmployeeSearchOutput | null };


export type EmployeePickerListQueryVariables = Exact<{
  input: EmployeeSearchInput;
}>;


export type EmployeePickerListQuery = EmployeePickerListQuery_Query;

export type AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue_attribute_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', name: string, id: any, type: AttributeNameType, syncSourceType: SyncSourceType };

export type AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, name: string, attribute?: AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue_attribute_EmployeeAttributeName | null };

export type AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, name: string, values?: Array<AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue> | null };

export type AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type AttributesQuery_Query = { __typename?: 'Query', employeeAttributeNames?: AttributesQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null };


export type AttributesQueryVariables = Exact<{
  input: EmployeeAttributeNamesInput;
}>;


export type AttributesQuery = AttributesQuery_Query;

export type JobStagesByNameQuery_jobStagesByName_JobStagesByNameOutput = { __typename?: 'JobStagesByNameOutput', items: Array<string | null>, nextCursor?: string | null };

export type JobStagesByNameQuery_Query = { __typename?: 'Query', jobStagesByName?: JobStagesByNameQuery_jobStagesByName_JobStagesByNameOutput | null };


export type JobStagesByNameQueryVariables = Exact<{
  input: JobStagesInput;
}>;


export type JobStagesByNameQuery = JobStagesByNameQuery_Query;

export type JobsByIdsQuery_jobByIds_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsCustomerFriendlyId?: string | null };

export type JobsByIdsQuery_jobByIds_Job = { __typename?: 'Job', id: any, name: string, status: JobStatus, atsJob?: JobsByIdsQuery_jobByIds_Job_atsJob_AtsJob | null };

export type JobsByIdsQuery_Query = { __typename?: 'Query', jobByIds?: Array<JobsByIdsQuery_jobByIds_Job> | null };


export type JobsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type JobsByIdsQuery = JobsByIdsQuery_Query;

export type CandidateListJobsQuery_jobs_JobsOutput_items_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsCustomerFriendlyId?: string | null };

export type CandidateListJobsQuery_jobs_JobsOutput_items_Job = { __typename?: 'Job', id: any, name: string, status: JobStatus, atsJob?: CandidateListJobsQuery_jobs_JobsOutput_items_Job_atsJob_AtsJob | null };

export type CandidateListJobsQuery_jobs_JobsOutput = { __typename?: 'JobsOutput', nextCursor?: string | null, items: Array<CandidateListJobsQuery_jobs_JobsOutput_items_Job> };

export type CandidateListJobsQuery_Query = { __typename?: 'Query', jobs?: CandidateListJobsQuery_jobs_JobsOutput | null };


export type CandidateListJobsQueryVariables = Exact<{
  input: JobsInput;
}>;


export type CandidateListJobsQuery = CandidateListJobsQuery_Query;

export type ManagersQuery_managers_EmployeesOutput_items_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type ManagersQuery_managers_EmployeesOutput = { __typename?: 'EmployeesOutput', nextCursor?: string | null, items: Array<ManagersQuery_managers_EmployeesOutput_items_Employee> };

export type ManagersQuery_Query = { __typename?: 'Query', managers?: ManagersQuery_managers_EmployeesOutput | null };


export type ManagersQueryVariables = Exact<{
  input: ManagersInput;
}>;


export type ManagersQuery = ManagersQuery_Query;

export type ListSelectedManagersByIdsQuery_employeeByIds_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type ListSelectedManagersByIdsQuery_Query = { __typename?: 'Query', employeeByIds?: Array<ListSelectedManagersByIdsQuery_employeeByIds_Employee> | null };


export type ListSelectedManagersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ListSelectedManagersByIdsQuery = ListSelectedManagersByIdsQuery_Query;

export type InterviewModulesSelectQuery_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type InterviewModulesSelectQuery_interviewModuleSearch_InterviewModuleSearchOutput = { __typename?: 'InterviewModuleSearchOutput', total?: number | null, items: Array<InterviewModulesSelectQuery_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule> };

export type InterviewModulesSelectQuery_Query = { __typename?: 'Query', interviewModuleSearch?: InterviewModulesSelectQuery_interviewModuleSearch_InterviewModuleSearchOutput | null };


export type InterviewModulesSelectQueryVariables = Exact<{
  input: InterviewModuleSearchInput;
}>;


export type InterviewModulesSelectQuery = InterviewModulesSelectQuery_Query;

export type ListSelectedModulesByIdQuery_interviewModuleByIds_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type ListSelectedModulesByIdQuery_Query = { __typename?: 'Query', interviewModuleByIds?: Array<ListSelectedModulesByIdQuery_interviewModuleByIds_InterviewModule> | null };


export type ListSelectedModulesByIdQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ListSelectedModulesByIdQuery = ListSelectedModulesByIdQuery_Query;

export type TaskQueuesFilterQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue = { __typename?: 'TaskQueue', id: any, name: string, memberCount: number };

export type TaskQueuesFilterQuery_taskQueueSearch_TaskQueueSearchResult = { __typename?: 'TaskQueueSearchResult', total: number, hasNext: boolean, items: Array<TaskQueuesFilterQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue> };

export type TaskQueuesFilterQuery_Query = { __typename?: 'Query', taskQueueSearch?: TaskQueuesFilterQuery_taskQueueSearch_TaskQueueSearchResult | null };


export type TaskQueuesFilterQueryVariables = Exact<{
  input: TaskQueueSearchInput;
}>;


export type TaskQueuesFilterQuery = TaskQueuesFilterQuery_Query;

export type TaskQueueByIdsQuery_taskQueueByIds_TaskQueue = { __typename?: 'TaskQueue', id: any, name: string, memberCount: number };

export type TaskQueueByIdsQuery_Query = { __typename?: 'Query', taskQueueByIds?: Array<TaskQueueByIdsQuery_taskQueueByIds_TaskQueue> | null };


export type TaskQueueByIdsQueryVariables = Exact<{
  input: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type TaskQueueByIdsQuery = TaskQueueByIdsQuery_Query;

export type TaskTagsBase_TaskTagFragment = { __typename?: 'TaskTag', id: any, name: string };

export type TaskTags_SelectedTaskTagFragment = (
  { __typename?: 'TaskTag' }
  & TaskTagsBase_TaskTagFragment
);

export type TaskTagsQuery_taskTags_TaskTagsResult_items_TaskTag = (
  { __typename?: 'TaskTag' }
  & TaskTags_SelectedTaskTagFragment
);

export type TaskTagsQuery_taskTags_TaskTagsResult = { __typename?: 'TaskTagsResult', items: Array<TaskTagsQuery_taskTags_TaskTagsResult_items_TaskTag> };

export type TaskTagsQuery_Query = { __typename?: 'Query', taskTags?: TaskTagsQuery_taskTags_TaskTagsResult | null };


export type TaskTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskTagsQuery = TaskTagsQuery_Query;

export type JobStageMismatchAlert_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags' }
  & GetHiringMismatchError_FlagsFragment
);

export type JobStageMismatchAlert_JobFragment_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<JobStageMismatchAlert_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type JobStageMismatchAlert_JobFragment = (
  { __typename?: 'Job', id: any, validationIssues: JobStageMismatchAlert_JobFragment_Job_validationIssues_JobValidationResult }
  & JobStageMismatchModal_JobFragment
);

export type JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication_application_Application = { __typename?: 'Application', id: any, candidate?: JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication_application_Application_candidate_Candidate | null, job?: JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication_application_Application_job_Job | null };

export type JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication = { __typename?: 'JobMismatchedApplication', id: any, jobStageName?: string | null, application?: JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication_application_Application | null };

export type JobStageMismatchModal_JobFragment = { __typename?: 'Job', id: any, mismatchedApplications?: Array<JobStageMismatchModal_JobFragment_Job_mismatchedApplications_JobMismatchedApplication> | null };

export type GetHiringMismatchError_FlagsFragment = { __typename?: 'JobValidationErrorFlags', type: TaskCreateValidateErrorFlagType, message: string };

export type GetHiringSetupError_FlagsFragment = { __typename?: 'JobValidationErrorFlags', type: TaskCreateValidateErrorFlagType, message: string };

export type InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null, job?: InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_job_Job | null, jobStage?: InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_jobStage_JobStage | null };

export type InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, application?: InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application | null };

export type InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined = { __typename?: 'InterviewInterviewerDeclined', reason?: DeclineReason | null, comment?: string | null, source?: string | null };

export type InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any, role?: InterviewerRole | null, responseStatus?: ResponseStatus | null, isOptional: boolean, interviewer?: InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee | null, declines?: Array<InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined> | null };

export type InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom = { __typename?: 'ApplicationStageInterviewRoom', applicationStageInterviewId: any, meetingRoomId: any, responseStatus?: ResponseStatus | null };

export type InterviewItemFragment = { __typename?: 'ApplicationStageInterview', id: any, name?: string | null, startAt: any, endAt: any, isCancelled?: boolean | null, googleEventUrl?: string | null, applicationStage?: InterviewItemFragment_ApplicationStageInterview_applicationStage_ApplicationStage | null, applicationStageInterviewInterviewers?: Array<InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null, applicationStageInterviewRooms?: Array<InterviewItemFragment_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom> | null };

export type VideoMeetingHost_InterviewMeetingLocationSettingPrefFragment = { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, videoMeetingLinkScope: VideoMeetingLinkScope, dynamicHost?: DynamicInterviewMeetingHost | null, hostEmployeeId?: string | null };

export type VideoMeetingHostEmployeeValueQuery_employeeByIds_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type VideoMeetingHostEmployeeValueQuery_Query = { __typename?: 'Query', employeeByIds?: Array<VideoMeetingHostEmployeeValueQuery_employeeByIds_Employee> | null };


export type VideoMeetingHostEmployeeValueQueryVariables = Exact<{
  employeeId: Scalars['uuid']['input'];
}>;


export type VideoMeetingHostEmployeeValueQuery = VideoMeetingHostEmployeeValueQuery_Query;

export type InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragment_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, firstName?: string | null, lastName?: string | null, email: string };

export type InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, videoMeetingLinkScope: VideoMeetingLinkScope, dynamicHost?: DynamicInterviewMeetingHost | null, hostEmployeeId?: string | null, remoteVideoMeetingHostUserId?: string | null, customLocation?: string | null, remoteVideoMeetingHostUser?: InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragment_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser | null }
  & VideoMeetingHost_InterviewMeetingLocationSettingPrefFragment
);

export type InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment_InterviewMeetingLocationSettingPref_hostEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, firstName?: string | null, lastName?: string | null, email: string };

export type InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment = { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, videoMeetingLinkScope: VideoMeetingLinkScope, dynamicHost?: DynamicInterviewMeetingHost | null, customLocation?: string | null, hostEmployee?: InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment_InterviewMeetingLocationSettingPref_hostEmployee_Employee | null, remoteVideoMeetingHostUser?: InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser | null };

export type InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, videoMeetingLinkScope: VideoMeetingLinkScope }
  & InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragment
);

export type ModuleMember_InterviewModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, title?: string | null };

export type ModuleMember_InterviewModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type ModuleMember_InterviewModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, employee?: ModuleMember_InterviewModuleMemberFragment_InterviewModuleMember_employee_Employee | null, stats?: ModuleMember_InterviewModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & IsModuleMembreOrEmployeePaused_ModuleMemberFragment
  & GetModuleMemberPendingTrainingCount_ModuleMemberFragment
);

export type ModuleMemberPausedChip_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type ModuleMemberPausedChip_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, isPaused: boolean, timezone?: string | null, interviewPauseDates?: Array<ModuleMemberPausedChip_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock> | null };

export type ModuleMemberPausedChip_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, isPausedIndefinitely?: boolean | null, isPaused?: boolean | null, pausedUntil?: any | null, id: string, employee?: ModuleMemberPausedChip_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null }
  & IsModuleMemberEmployeePaused_ModuleMemberFragment
  & IsModuleMembreOrEmployeePaused_ModuleMemberFragment
  & IsModuleMemberPauseIndefinitely_ModuleMemberFragment
  & GetModuleMemberEmployeePausedText_ModuleMemberFragment
  & GetModuleMemberPauseText_ModuleMemberFragment
);

export type ModuleMemberPendingChip_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type ModuleMemberPendingChip_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', id: string, stats?: ModuleMemberPendingChip_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

export type ModuleMemberTrainingStatus_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type ModuleMemberTrainingStatus_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type ModuleMemberTrainingStatus_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, isPaused: boolean, timezone?: string | null, isAtsDisabled?: boolean | null, isDirectoryDisabled: boolean, hasAtsId?: boolean | null, interviewPauseDates?: Array<ModuleMemberTrainingStatus_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock> | null };

export type ModuleMemberTrainingStatus_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, isPausedIndefinitely?: boolean | null, isPaused?: boolean | null, pausedUntil?: any | null, stats?: ModuleMemberTrainingStatus_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null, employee?: ModuleMemberTrainingStatus_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null }
  & ModuleMemberPendingChip_ModuleMemberFragment
  & ModuleMemberPausedChip_ModuleMemberFragment
);

export type IsModuleMemberEmployeePaused_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, isPaused: boolean };

export type IsModuleMemberEmployeePaused_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, employee?: IsModuleMemberEmployeePaused_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null };

export type GetModuleMemberEmployeePausedText_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type GetModuleMemberEmployeePausedText_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, isPaused: boolean, timezone?: string | null, interviewPauseDates?: Array<GetModuleMemberEmployeePausedText_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock> | null };

export type GetModuleMemberEmployeePausedText_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, employee?: GetModuleMemberEmployeePausedText_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null };

export type IsModuleMemberPaused_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, isPaused?: boolean | null, pausedUntil?: any | null };

export type IsModuleMemberPauseIndefinitely_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, isPausedIndefinitely?: boolean | null };

export type GetModuleMemberPauseText_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, timezone?: string | null };

export type GetModuleMemberPauseText_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, pausedUntil?: any | null, employee?: GetModuleMemberPauseText_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null };

export type IsModuleMembreOrEmployeePaused_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, isPaused: boolean };

export type IsModuleMembreOrEmployeePaused_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, isPaused?: boolean | null, employee?: IsModuleMembreOrEmployeePaused_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null };

export type GetShadowCompletedCount_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsShadow?: any | null, manualCompletedAsShadow: any };

export type GetShadowCompletedCount_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, stats?: GetShadowCompletedCount_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

export type GetShadowPendingCount_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, shadowsRequired: number }
  & GetShadowCompletedCount_ModuleMemberFragment
);

export type GetReverseShadowCompletedCount_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsReverseShadow?: any | null, manualCompletedAsReverseShadow: any };

export type GetReverseShadowCompletedCount_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, stats?: GetReverseShadowCompletedCount_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

export type GetReverseShadowPendingCount_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, reverseShadowsRequired: number }
  & GetReverseShadowCompletedCount_ModuleMemberFragment
);

export type GetModuleMemberPendingTrainingCount_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', upcoming?: any | null };

export type GetModuleMemberPendingTrainingCount_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, status: TrainingStatus, stats?: GetModuleMemberPendingTrainingCount_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & GetShadowPendingCount_ModuleMemberFragment
  & GetReverseShadowPendingCount_ModuleMemberFragment
);

export type IsModuleMemberDisabledForScheduling_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type IsModuleMemberDisabledForScheduling_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, shouldFastTrackTraining: boolean };

export type IsModuleMemberDisabledForScheduling_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, status: TrainingStatus, shadowsRequired: number, reverseShadowsRequired: number, stats?: IsModuleMemberDisabledForScheduling_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null, interviewModule?: IsModuleMemberDisabledForScheduling_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule | null }
  & GetModuleMemberPendingTrainingCount_ModuleMemberFragment
);

export type AdvancedOptions_InterviewPlanFragment_JobStage_schedulingWindow_Duration = { __typename?: 'Duration', seconds: any };

export type AdvancedOptions_InterviewPlanFragment_JobStage_excludedEmployees_Employee = { __typename?: 'Employee', id: any };

export type AdvancedOptions_InterviewPlanFragment = { __typename?: 'JobStage', id: any, schedulingWindow?: AdvancedOptions_InterviewPlanFragment_JobStage_schedulingWindow_Duration | null, excludedEmployees?: Array<AdvancedOptions_InterviewPlanFragment_JobStage_excludedEmployees_Employee> | null };

export type Break_BreakSlotFragment = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, name?: string | null, duration?: number | null, isLockedOrder: boolean };

export type Break_SchedulingWindowFragment = { __typename?: 'Duration', seconds: any };

export type BreakSlot_BreakSlotFragment = (
  { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, name?: string | null, duration?: number | null, isLockedOrder: boolean }
  & MoreMenuOptions_JobStageInterviewFragment
);

export type BreakSlot_JobStageInterviewGroupsFragment = (
  { __typename?: 'JobStageInterviewGroup', id: any }
  & MoreMenuOptions_JobStageInterviewGroupsFragment
);

export type CodingLink_JobStageInterviewFragment = { __typename?: 'JobStageInterview', id: any, dynamicLinkTypes?: Array<DynamicLinkType> | null };

export type InterviewCardHeader_JobFragment = { __typename?: 'Job', id: any, atsId: string };

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition = { __typename?: 'AshbyInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition = { __typename?: 'GemInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition = { __typename?: 'GreenhouseInterviewDefinition', estimatedMinutes: any, index: any };

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition = { __typename?: 'LeverInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition = { __typename?: 'WorkdayInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields = InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition | InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition | InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition | InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition | InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition;

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, name: string, atsJobId?: string | null, atsFields?: InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields | null };

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_collaborationLinkTypes_CollaborationLinkType = (
  { __typename?: 'CollaborationLinkType' }
  & CollaborationToolFilterPopover_CollaborationLinkTypeFragment
);

export type InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_interviewGuide_InterviewGuide = (
  { __typename?: 'InterviewGuide' }
  & BrighthireButtonSelect_InterviewGuideFragment
);

export type InterviewCardHeader_JobStageInterviewFragment = (
  { __typename?: 'JobStageInterview', id: any, name?: string | null, isLockedOrder: boolean, duration?: number | null, forcedStartAt?: string | null, atsInterviewDefinition?: InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null, collaborationLinkTypes?: Array<InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_collaborationLinkTypes_CollaborationLinkType> | null, interviewGuide?: InterviewCardHeader_JobStageInterviewFragment_JobStageInterview_interviewGuide_InterviewGuide | null }
  & CodingLink_JobStageInterviewFragment
  & MoreMenuOptions_JobStageInterviewFragment
);

export type InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition = { __typename?: 'AshbyInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition = { __typename?: 'GemInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition = { __typename?: 'GreenhouseInterviewDefinition', estimatedMinutes: any, index: any };

export type InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition = { __typename?: 'LeverInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition = { __typename?: 'WorkdayInterviewDefinition' };

export type InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields = InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition | InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition | InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition | InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition | InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition;

export type InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, atsFields?: InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields | null };

export type InterviewCardHeader_JobStageInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any, duration?: number | null, forcedStartAt?: string | null, atsInterviewDefinition?: InterviewCardHeader_JobStageInterviewsFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null }
  & UseWarningForStartAt_JobStageInterviewsFragment
);

export type InterviewCardHeader_JobStageInterviewGroupsFragment = (
  { __typename?: 'JobStageInterviewGroup', id: any }
  & MoreMenuOptions_JobStageInterviewGroupsFragment
);

export type InterviewGroup_JobFragment = (
  { __typename?: 'Job', id: any }
  & InterviewGroupOld_JobFragment
  & JobStageInterview_JobFragment
);

export type InterviewGroup_JobStageInterviewGroupFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = (
  { __typename?: 'JobStageInterview', id: any }
  & JobStageInterview_JobStageInterviewFragment
);

export type InterviewGroup_JobStageInterviewGroupFragment = (
  { __typename?: 'JobStageInterviewGroup', id: any, locked: boolean, name?: string | null, jobStageInterviews?: Array<InterviewGroup_JobStageInterviewGroupFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null }
  & InterviewGroupOld_JobStageInterviewGroupFragment
);

export type InterviewGroup_JobStageInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any }
  & InterviewGroupOld_JobStageInterviewsFragment
  & JobStageInterview_JobStageInterviewFragment
  & JobStageInterview_JobStageInterviewsFragment
  & JobStageInterview_LinkableInterviewsFragment
);

export type InterviewGroup_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any };

export type InterviewGroup_JobStageInterviewGroupsFragment = (
  { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<InterviewGroup_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null }
  & InterviewGroupOld_JobStageInterviewGroupsFragment
  & JobStageInterview_JobStageInterviewGroupsFragment
);

export type InterviewGroup_SchedulingWindowFragment = (
  { __typename?: 'Duration' }
  & JobStageInterview_SchedulingWindowFragment
);

export type InterviewGroupOld_JobFragment = (
  { __typename?: 'Job', id: any }
  & JobStageInterview_JobFragment
);

export type InterviewGroupOld_JobStageInterviewGroupFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = (
  { __typename?: 'JobStageInterview', id: any }
  & JobStageInterview_JobStageInterviewFragment
);

export type InterviewGroupOld_JobStageInterviewGroupFragment = { __typename?: 'JobStageInterviewGroup', id: any, locked: boolean, name?: string | null, jobStageInterviews?: Array<InterviewGroupOld_JobStageInterviewGroupFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type InterviewGroupOld_JobStageInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any }
  & JobStageInterview_JobStageInterviewFragment
  & JobStageInterview_JobStageInterviewsFragment
  & JobStageInterview_LinkableInterviewsFragment
);

export type InterviewGroupOld_JobStageInterviewGroupsFragment = (
  { __typename?: 'JobStageInterviewGroup', id: any }
  & JobStageInterview_JobStageInterviewGroupsFragment
);

export type InterviewModuleMember_InterviewModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any }
  & ModuleMember_InterviewModuleMemberFragment
);

export type BaseEditInterviewSeatModule_SeatFragment = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & BaseReadInterviewSeatModule_SeatFragment
);

export type BaseEditInterviewSeatModule_LinkableInterviewsFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = { __typename?: 'JobStageInterviewSeat', id: any, type: JobStageInterviewSeatType };

export type BaseEditInterviewSeatModule_LinkableInterviewsFragment = { __typename?: 'JobStageInterview', id: any, name?: string | null, jobStageInterviewSeats?: Array<BaseEditInterviewSeatModule_LinkableInterviewsFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null };

export type BaseEditInterviewSeatModule_LinkedInterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = { __typename?: 'JobStageInterviewSeat', id: any };

export type BaseEditInterviewSeatModule_LinkedInterviewFragment = { __typename?: 'JobStageInterview', id: any, name?: string | null, jobStageInterviewSeats?: Array<BaseEditInterviewSeatModule_LinkedInterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null };

export type BaseEditInterviewSeatModuleEmployeeSearchV2Fragment = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, orgId: any, isDirectoryDisabled: boolean, hasAtsId?: boolean | null, internalProfilePictureUrl?: string | null, timezone?: string | null, atsId?: string | null, isAtsDisabled?: boolean | null };

export type BaseEditInterviewSeatModuleInterviewModuleSearchV2Fragment_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any }
  & EmployeeFilterFragment
);

export type BaseEditInterviewSeatModuleInterviewModuleSearchV2Fragment_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput = { __typename?: 'InterviewModuleMembersOutput', items: Array<BaseEditInterviewSeatModuleInterviewModuleSearchV2Fragment_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember> };

export type BaseEditInterviewSeatModuleInterviewModuleSearchV2Fragment = (
  { __typename?: 'InterviewModule', orgId: any, membersCount: any, membersTrainedCount: any, membersInTrainingCount: any, membersInReverseShadowCount: any, membersInShadowCount: any, membersInPendingApprovalCount: any, graduateFromShadowApprovalType: GraduationApprovalType, graduateFromReverseShadowApprovalType: GraduationApprovalType, interviewModuleMembers?: BaseEditInterviewSeatModuleInterviewModuleSearchV2Fragment_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput | null }
  & InterviewModuleFragment
);

export type EmployeesAndModulesSearchV2Query_employeeSearch_EmployeeSearchOutput_items_Employee = (
  { __typename?: 'Employee' }
  & BaseEditInterviewSeatModuleEmployeeSearchV2Fragment
);

export type EmployeesAndModulesSearchV2Query_employeeSearch_EmployeeSearchOutput = { __typename?: 'EmployeeSearchOutput', items: Array<EmployeesAndModulesSearchV2Query_employeeSearch_EmployeeSearchOutput_items_Employee> };

export type EmployeesAndModulesSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule = (
  { __typename?: 'InterviewModule' }
  & BaseEditInterviewSeatModuleInterviewModuleSearchV2Fragment
);

export type EmployeesAndModulesSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput = { __typename?: 'InterviewModuleSearchOutput', items: Array<EmployeesAndModulesSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule> };

export type EmployeesAndModulesSearchV2Query_Query = { __typename?: 'Query', employeeSearch?: EmployeesAndModulesSearchV2Query_employeeSearch_EmployeeSearchOutput | null, interviewModuleSearch?: EmployeesAndModulesSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput | null };


export type EmployeesAndModulesSearchV2QueryVariables = Exact<{
  employeeSearchInput: EmployeeSearchInput;
  moduleSearchInput: InterviewModuleSearchInput;
}>;


export type EmployeesAndModulesSearchV2Query = EmployeesAndModulesSearchV2Query_Query;

export type BaseInterviewSeatModule_SeatFragment = (
  { __typename?: 'JobStageInterviewSeat', id: any, type: JobStageInterviewSeatType }
  & BaseReadInterviewSeatModule_SeatFragment
  & BaseEditInterviewSeatModule_SeatFragment
);

export type BaseInterviewSeatModule_OriginalSeatFragment = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & BaseReadInterviewSeatModule_OriginalSeatFragment
);

export type BaseInterviewSeatModule_LinkedInterviewFragment = (
  { __typename?: 'JobStageInterview', id: any }
  & BaseReadInterviewSeatModule_LinkedInterviewFragment
  & BaseEditInterviewSeatModule_LinkedInterviewFragment
);

export type BaseInterviewSeatModule_LinkableInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any }
  & BaseEditInterviewSeatModule_LinkableInterviewsFragment
);

export type BaseReadInterviewSeatModule_SeatFragment = (
  { __typename?: 'JobStageInterviewSeat', id: any, type: JobStageInterviewSeatType, index?: number | null }
  & FreeformSeat_SeatFragment
  & ModuleSeat_SeatFragment
  & ModuleSeatV2_SeatFragment
  & LinkedSeat_SeatFragment
);

export type BaseReadInterviewSeatModule_LinkedInterviewFragment = (
  { __typename?: 'JobStageInterview', id: any }
  & LinkedSeat_LinkedInterviewFragment
);

export type BaseReadInterviewSeatModule_OriginalSeatFragment = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & LinkedSeat_OriginalSeatFragment
);

export type FreeformSeat_SeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee_employee_Employee = (
  { __typename?: 'Employee', id: any }
  & EmployeeFragment
);

export type FreeformSeat_SeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee = { __typename?: 'JobStageInterviewSeatEmployee', jobStageInterviewSeatId: any, employeeId: any, preferenceLevel?: number | null, employee?: FreeformSeat_SeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee_employee_Employee | null };

export type FreeformSeat_SeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat = { __typename?: 'FreeformSeat', jobStageInterviewSeatEmployees?: Array<FreeformSeat_SeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee> | null };

export type FreeformSeat_SeatFragment = { __typename?: 'JobStageInterviewSeat', id: any, freeformSeat?: FreeformSeat_SeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat | null };

export type LinkedSeat_SeatFragment_JobStageInterviewSeat_linkedSeat_LinkedSeat = { __typename?: 'LinkedSeat', linkedJobStageInterviewSeatId: any };

export type LinkedSeat_SeatFragment = { __typename?: 'JobStageInterviewSeat', id: any, linkedSeat?: LinkedSeat_SeatFragment_JobStageInterviewSeat_linkedSeat_LinkedSeat | null };

export type LinkedSeat_LinkedInterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = { __typename?: 'JobStageInterviewSeat', id: any };

export type LinkedSeat_LinkedInterviewFragment = { __typename?: 'JobStageInterview', id: any, name?: string | null, jobStageInterviewSeats?: Array<LinkedSeat_LinkedInterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null };

export type LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee = { __typename?: 'JobStageInterviewSeatEmployee', employeeId: any, employee?: LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee_employee_Employee | null };

export type LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat = { __typename?: 'FreeformSeat', jobStageInterviewSeatEmployees?: Array<LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee> | null };

export type LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any, interviewModule?: LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule | null };

export type LinkedSeat_OriginalSeatFragment = { __typename?: 'JobStageInterviewSeat', id: any, freeformSeat?: LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat | null, moduleSeat?: LinkedSeat_OriginalSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat | null };

export type EmployeeFilterFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsReverseShadow?: any | null, completedAsShadow?: any | null, shadowOffset?: any | null, reverseShadowOffset?: any | null };

export type EmployeeFilterFragment_InterviewModuleMember_employee_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type EmployeeFilterFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type EmployeeFilterFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, title?: string | null, internalProfilePictureUrl?: string | null, attributes?: Array<EmployeeFilterFragment_InterviewModuleMember_employee_Employee_attributes_EmployeeAttributeTagValue> | null, interviewPauseDates?: Array<EmployeeFilterFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock> | null };

export type EmployeeFilterFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, status: TrainingStatus, shadowsRequired: number, reverseShadowsRequired: number, pausedUntil?: any | null, stats?: EmployeeFilterFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null, employee?: EmployeeFilterFragment_InterviewModuleMember_employee_Employee | null }
  & IsModuleMemberDisabledForScheduling_ModuleMemberFragment
  & InterviewModuleMember_InterviewModuleMemberFragment
);

export type ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any }
  & EmployeeFilterFragment
);

export type ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput = { __typename?: 'InterviewModuleMembersOutput', items: Array<ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember> };

export type ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, orgId: any, shadowsRequired: any, reverseShadowsRequired: any, membersCount: any, name: string, membersTrainedCount: any, membersInTrainingCount: any, membersInReverseShadowCount: any, membersInShadowCount: any, membersInPendingApprovalCount: any, graduateFromShadowApprovalType: GraduationApprovalType, graduateFromReverseShadowApprovalType: GraduationApprovalType, interviewModuleMembers?: ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput | null };

export type ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, jobStageInterviewSeatId?: any | null, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any, selectedEmployeeIds: Array<any>, interviewModule?: ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule | null, jobStageInterviewSeatAttributes?: Array<ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute> | null };

export type ModuleSeat_SeatFragment = { __typename?: 'JobStageInterviewSeat', id: any, moduleSeat?: ModuleSeat_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat | null };

export type EditModuleSeatInterviewModuleV2Fragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any }
  & EmployeeAndAttributesFilterFragment
);

export type InterviewModuleMemberFilteredByAttributesV2Query_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & EditModuleSeatInterviewModuleV2Fragment
);

export type InterviewModuleMemberFilteredByAttributesV2Query_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput = { __typename?: 'InterviewModuleMemberSearchOutput', items: Array<InterviewModuleMemberFilteredByAttributesV2Query_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput_items_InterviewModuleMember> };

export type InterviewModuleMemberFilteredByAttributesV2Query_Query = { __typename?: 'Query', interviewModuleMemberSearch?: InterviewModuleMemberFilteredByAttributesV2Query_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput | null };


export type InterviewModuleMemberFilteredByAttributesV2QueryVariables = Exact<{
  input: InterviewModuleMemberSearchInput;
}>;


export type InterviewModuleMemberFilteredByAttributesV2Query = InterviewModuleMemberFilteredByAttributesV2Query_Query;

export type EditModuleSeatInterviewStatsV2Fragment = { __typename?: 'InterviewModule', id: any, name: string, membersCount: any, membersInReverseShadowCount: any, membersInShadowCount: any, membersTrainedCount: any };

export type ModuleMemberStatsV2Query_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModule_InterviewModule = (
  { __typename?: 'InterviewModule' }
  & EditModuleSeatInterviewStatsV2Fragment
);

export type ModuleMemberStatsV2Query_interviewModuleMemberStats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', interviewModule?: ModuleMemberStatsV2Query_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModule_InterviewModule | null };

export type ModuleMemberStatsV2Query_Query = { __typename?: 'Query', interviewModuleMemberStats?: Array<ModuleMemberStatsV2Query_interviewModuleMemberStats_InterviewModuleMemberStats> | null };


export type ModuleMemberStatsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type ModuleMemberStatsV2Query = ModuleMemberStatsV2Query_Query;

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any }
  & EmployeeFilterFragment
);

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput = { __typename?: 'InterviewModuleMembersOutput', items: Array<ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember> };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, orgId: any, shadowsRequired: any, reverseShadowsRequired: any, membersCount: any, name: string, membersTrainedCount: any, membersInTrainingCount: any, membersInReverseShadowCount: any, membersInShadowCount: any, membersInPendingApprovalCount: any, graduateFromShadowApprovalType: GraduationApprovalType, graduateFromReverseShadowApprovalType: GraduationApprovalType, interviewModuleMembers?: ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, jobStageInterviewSeatId?: any | null, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_trainedConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, jobStageInterviewSeatId?: any | null, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_trainedConfig_InterviewModuleSeatConfig = { __typename?: 'InterviewModuleSeatConfig', selectedEmployeeIds?: Array<any> | null, selectedAttributes?: Array<ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_trainedConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute> | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, jobStageInterviewSeatId?: any | null, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig = { __typename?: 'InterviewModuleSeatConfig', selectedEmployeeIds?: Array<any> | null, selectedAttributes?: Array<ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute> | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, jobStageInterviewSeatId?: any | null, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig = { __typename?: 'InterviewModuleSeatConfig', selectedEmployeeIds?: Array<any> | null, selectedAttributes?: Array<ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute> | null };

export type ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any, selectedEmployeeIds: Array<any>, traineeRequirement?: TraineeRequirement | null, traineeSchedulingStrategy?: TraineeSchedulingStrategy | null, interviewModule?: ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule | null, jobStageInterviewSeatAttributes?: Array<ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute> | null, trainedConfig?: ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_trainedConfig_InterviewModuleSeatConfig | null, shadowConfig?: ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig | null, reverseShadowConfig?: ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig | null };

export type ModuleSeatV2_SeatFragment = { __typename?: 'JobStageInterviewSeat', id: any, moduleSeat?: ModuleSeatV2_SeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat | null };

export type InterviewSeatsModule_SeatsFragment = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & BaseInterviewSeatModule_SeatFragment
);

export type InterviewSeatsModule_OriginalSeatsFragment = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & BaseInterviewSeatModule_OriginalSeatFragment
);

export type InterviewSeatsModule_LinkableInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any }
  & BaseInterviewSeatModule_LinkableInterviewsFragment
  & BaseInterviewSeatModule_LinkedInterviewFragment
);

export type JobStageInterview_JobFragment = (
  { __typename?: 'Job', id: any }
  & InterviewCardHeader_JobFragment
);

export type JobStageInterview_JobStageInterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & InterviewSeatsModule_SeatsFragment
);

export type JobStageInterview_JobStageInterviewFragment = (
  { __typename?: 'JobStageInterview', id: any, jobStageInterviewSeats?: Array<JobStageInterview_JobStageInterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null }
  & InterviewCardHeader_JobStageInterviewFragment
  & BreakSlot_BreakSlotFragment
  & Break_BreakSlotFragment
);

export type JobStageInterview_LinkableInterviewsFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & InterviewSeatsModule_OriginalSeatsFragment
);

export type JobStageInterview_LinkableInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any, jobStageInterviewSeats?: Array<JobStageInterview_LinkableInterviewsFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null }
  & InterviewSeatsModule_LinkableInterviewsFragment
);

export type JobStageInterview_JobStageInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any }
  & InterviewCardHeader_JobStageInterviewsFragment
);

export type JobStageInterview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType };

export type JobStageInterview_JobStageInterviewGroupsFragment = (
  { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<JobStageInterview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null }
  & BreakSlot_JobStageInterviewGroupsFragment
  & InterviewCardHeader_JobStageInterviewGroupsFragment
);

export type JobStageInterview_SchedulingWindowFragment = (
  { __typename?: 'Duration' }
  & Break_SchedulingWindowFragment
);

export type MoreMenuOptions_JobStageInterviewFragment = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, jobStageInterviewGroupId?: any | null, isHiddenFromCandidate: boolean };

export type MoreMenuOptions_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any };

export type MoreMenuOptions_JobStageInterviewGroupsFragment = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<MoreMenuOptions_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type CloneInterviewPlan_InterviewPlanFragment_JobStage_job_Job = (
  { __typename?: 'Job', id: any }
  & InterviewPlan_JobFragment
);

export type CloneInterviewPlan_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any, job?: CloneInterviewPlan_InterviewPlanFragment_JobStage_job_Job | null }
  & InterviewPlan_JobStageFragment
);

export type GetSaveInterviewPlanInput_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & InterviewPlan_JobStageFragment
);

export type InterviewPlan_JobFragment = (
  { __typename?: 'Job', id: any, atsId: string }
  & InterviewGroup_JobFragment
);

export type InterviewPlan_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = (
  { __typename?: 'JobStageInterview', id: any }
  & InterviewGroup_JobStageInterviewsFragment
);

export type InterviewPlan_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = (
  { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<InterviewPlan_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null }
  & InterviewGroup_JobStageInterviewGroupFragment
  & InterviewGroup_JobStageInterviewGroupsFragment
);

export type InterviewPlan_JobStageFragment_JobStage_schedulingWindow_Duration = (
  { __typename?: 'Duration' }
  & InterviewGroup_SchedulingWindowFragment
);

export type InterviewPlan_JobStageFragment = (
  { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<InterviewPlan_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null, schedulingWindow?: InterviewPlan_JobStageFragment_JobStage_schedulingWindow_Duration | null }
  & AdvancedOptions_InterviewPlanFragment
);

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition = { __typename?: 'AshbyInterviewDefinition' };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition = { __typename?: 'GemInterviewDefinition' };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition = { __typename?: 'GreenhouseInterviewDefinition', estimatedMinutes: any };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition = { __typename?: 'LeverInterviewDefinition' };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition = { __typename?: 'WorkdayInterviewDefinition' };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields = UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition | UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition | UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition | UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition | UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition;

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, atsFields?: UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields | null };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat = { __typename?: 'LinkedSeat', linkedJobStageInterviewSeatId: any };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = { __typename?: 'JobStageInterviewSeat', id: any, type: JobStageInterviewSeatType, linkedSeat?: UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat | null };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, duration?: number | null, atsInterviewDefinition?: UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null, jobStageInterviewSeats?: Array<UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null };

export type UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UseInterviewPlanDescription_JobStageFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UseInterviewPlanDescription_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, isHiddenFromCandidate: boolean };

export type UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, isArchived?: boolean | null, isDirectoryDisabled: boolean, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee = { __typename?: 'JobStageInterviewSeatEmployee', employeeId: any, employee?: UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee_employee_Employee | null };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat = { __typename?: 'FreeformSeat', jobStageInterviewSeatEmployees?: Array<UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee> | null };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat = { __typename?: 'LinkedSeat', linkedJobStageInterviewSeatId: any };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = { __typename?: 'JobStageInterviewSeat', id: any, freeformSeat?: UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat | null, moduleSeat?: UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat | null, linkedSeat?: UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat | null };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, isHiddenFromCandidate: boolean, jobStageInterviewSeats?: Array<UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null };

export type UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UseIsInterviewPlanValid_JobStageFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UseIsInterviewPlanValid_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type ResetInterviewPlanToBaseJobStageQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any }
  & GetSaveInterviewPlanInput_InterviewPlanFragment
);

export type ResetInterviewPlanToBaseJobStageQuery_Query = { __typename?: 'Query', jobStage?: ResetInterviewPlanToBaseJobStageQuery_jobStage_JobStage | null };


export type ResetInterviewPlanToBaseJobStageQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type ResetInterviewPlanToBaseJobStageQuery = ResetInterviewPlanToBaseJobStageQuery_Query;

export type ResetPlanToBaseJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any }
  & GetSaveInterviewPlanInput_InterviewPlanFragment
);

export type ResetPlanToBaseJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult = { __typename?: 'JobStageInterviewPlanResult', jobStage?: ResetPlanToBaseJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage | null };

export type ResetPlanToBaseJobStageMutation_Mutation = { __typename?: 'Mutation', jobStageInterviewPlanUpsert?: ResetPlanToBaseJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult | null };


export type ResetPlanToBaseJobStageMutationVariables = Exact<{
  input: JobStageInterviewPlanUpsertInput;
}>;


export type ResetPlanToBaseJobStageMutation = ResetPlanToBaseJobStageMutation_Mutation;

export type UseWarningForStartAt_JobStageInterviewsFragment = { __typename?: 'JobStageInterview', id: any, duration?: number | null, forcedStartAt?: string | null };

export type JobStageProgressIcon_JobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, atsId?: string | null, index: number };

export type JobStageProgressIcon_JobFragment = { __typename?: 'Job', id: any, jobStages?: Array<JobStageProgressIcon_JobFragment_Job_jobStages_JobStage> | null };

export type MeetingRoomFragmentFragment = { __typename?: 'MeetingRoom', id: string, name?: string | null, floorName?: string | null, description?: string | null, capacity?: number | null, features?: Array<string> | null };

export type MeetingRoomSuggestionsQuery_meetingRoomSuggestions_MeetingRoomSuggestionsOutput_items_MeetingRoomSuggestion_room_MeetingRoom = { __typename?: 'MeetingRoom', id: string, name?: string | null, floorName?: string | null, description?: string | null, capacity?: number | null, features?: Array<string> | null };

export type MeetingRoomSuggestionsQuery_meetingRoomSuggestions_MeetingRoomSuggestionsOutput_items_MeetingRoomSuggestion = { __typename?: 'MeetingRoomSuggestion', isBusy?: boolean | null, room?: MeetingRoomSuggestionsQuery_meetingRoomSuggestions_MeetingRoomSuggestionsOutput_items_MeetingRoomSuggestion_room_MeetingRoom | null };

export type MeetingRoomSuggestionsQuery_meetingRoomSuggestions_MeetingRoomSuggestionsOutput = { __typename?: 'MeetingRoomSuggestionsOutput', nextCursor?: string | null, items: Array<MeetingRoomSuggestionsQuery_meetingRoomSuggestions_MeetingRoomSuggestionsOutput_items_MeetingRoomSuggestion> };

export type MeetingRoomSuggestionsQuery_Query = { __typename?: 'Query', meetingRoomSuggestions?: MeetingRoomSuggestionsQuery_meetingRoomSuggestions_MeetingRoomSuggestionsOutput | null };


export type MeetingRoomSuggestionsQueryVariables = Exact<{
  input: MeetingRoomSuggestionsInput;
}>;


export type MeetingRoomSuggestionsQuery = MeetingRoomSuggestionsQuery_Query;

export type MeetingRoomQuery_meetingRoom_MeetingRoom = (
  { __typename?: 'MeetingRoom' }
  & MeetingRoomFragmentFragment
);

export type MeetingRoomQuery_Query = { __typename?: 'Query', meetingRoom?: MeetingRoomQuery_meetingRoom_MeetingRoom | null };


export type MeetingRoomQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MeetingRoomQuery = MeetingRoomQuery_Query;

export type MeetingRoomByIdsQuery_meetingRoomByIds_MeetingRoom = (
  { __typename?: 'MeetingRoom' }
  & MeetingRoomFragmentFragment
);

export type MeetingRoomByIdsQuery_Query = { __typename?: 'Query', meetingRoomByIds?: Array<MeetingRoomByIdsQuery_meetingRoomByIds_MeetingRoom> | null };


export type MeetingRoomByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type MeetingRoomByIdsQuery = MeetingRoomByIdsQuery_Query;

export type MeetingRoomsQuery_meetingRooms_MeetingRoomsOutput_items_MeetingRoom = (
  { __typename?: 'MeetingRoom' }
  & MeetingRoomFragmentFragment
);

export type MeetingRoomsQuery_meetingRooms_MeetingRoomsOutput = { __typename?: 'MeetingRoomsOutput', nextCursor?: string | null, items: Array<MeetingRoomsQuery_meetingRooms_MeetingRoomsOutput_items_MeetingRoom> };

export type MeetingRoomsQuery_Query = { __typename?: 'Query', meetingRooms?: MeetingRoomsQuery_meetingRooms_MeetingRoomsOutput | null };


export type MeetingRoomsQueryVariables = Exact<{
  input: MeetingRoomsInput;
}>;


export type MeetingRoomsQuery = MeetingRoomsQuery_Query;

export type CreateInfo_WarningsFragment = (
  { __typename?: 'TaskCreateValidateWarnFlags' }
  & InfoList_WarningsFragment
);

export type CreateInfo_SuggestionTimeRangeFragment = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ErrorInfo_ErrorsFragment = (
  { __typename?: 'TaskCreateValidateErrorFlags' }
  & ErrorList_ErrorsFragment
);

export type ErrorList_ErrorsFragment = { __typename?: 'TaskCreateValidateErrorFlags', type: TaskCreateValidateErrorFlagType, message: string };

export type InfoList_WarningsFragment = { __typename?: 'TaskCreateValidateWarnFlags', type: TaskCreateValidateWarnFlagType, message: string };

export type QuickTaskCreateButton_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_errors_TaskCreateValidateErrorFlags = { __typename?: 'TaskCreateValidateErrorFlags', type: TaskCreateValidateErrorFlagType };

export type QuickTaskCreateButton_TaskQuickCreateValidateResultFragment = { __typename?: 'TaskQuickCreateValidateResult', suggestionCount: any, errors?: Array<QuickTaskCreateButton_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_errors_TaskCreateValidateErrorFlags> | null };

export type QuickTaskLabelQuery_taskQuickCreateValidate_TaskQuickCreateValidateResult = (
  { __typename?: 'TaskQuickCreateValidateResult' }
  & QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment
);

export type QuickTaskLabelQuery_Query = { __typename?: 'Query', taskQuickCreateValidate: QuickTaskLabelQuery_taskQuickCreateValidate_TaskQuickCreateValidateResult };


export type QuickTaskLabelQueryVariables = Exact<{
  input: TaskQuickCreateValidateInput;
}>;


export type QuickTaskLabelQuery = QuickTaskLabelQuery_Query;

export type QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_suggestionTimeRanges_DateTimeRangeOutput = (
  { __typename?: 'DateTimeRangeOutput' }
  & CreateInfo_SuggestionTimeRangeFragment
);

export type QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_errors_TaskCreateValidateErrorFlags = (
  { __typename?: 'TaskCreateValidateErrorFlags' }
  & ErrorInfo_ErrorsFragment
);

export type QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_warnings_TaskCreateValidateWarnFlags = (
  { __typename?: 'TaskCreateValidateWarnFlags' }
  & CreateInfo_WarningsFragment
);

export type QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment = { __typename?: 'TaskQuickCreateValidateResult', suggestionCount: any, suggestionLastCalculatedAt?: any | null, suggestionTimeRanges: Array<QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_suggestionTimeRanges_DateTimeRangeOutput>, errors?: Array<QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_errors_TaskCreateValidateErrorFlags> | null, warnings?: Array<QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment_TaskQuickCreateValidateResult_warnings_TaskCreateValidateWarnFlags> | null };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration = { __typename?: 'SettingDuration', duration: QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration_duration_Duration };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 = { __typename?: 'JobStageCandidateAvailabilitySettingsV2', timeframe: QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration = { __typename?: 'SettingDuration', duration: QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration_duration_Duration };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 = { __typename?: 'JobStageSelfScheduleSettingsV2', timeframe: QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, candidateAvailabilitySettingsV2?: QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 | null, selfScheduleSettingsV2?: QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 | null };

export type QuickTaskJobStageSettingsQuery_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: QuickTaskJobStageSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type QuickTaskJobStageSettingsQuery_Query = { __typename?: 'Query', jobStage?: QuickTaskJobStageSettingsQuery_jobStage_JobStage | null };


export type QuickTaskJobStageSettingsQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type QuickTaskJobStageSettingsQuery = QuickTaskJobStageSettingsQuery_Query;

export type JobStageDefaultTaskQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, defaultTask?: TaskCreationSource | null, isAutomatedTaskEnabled?: boolean | null };

export type JobStageDefaultTaskQuery_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: JobStageDefaultTaskQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type JobStageDefaultTaskQuery_Query = { __typename?: 'Query', jobStage?: JobStageDefaultTaskQuery_jobStage_JobStage | null };


export type JobStageDefaultTaskQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobStageDefaultTaskQuery = JobStageDefaultTaskQuery_Query;

export type QuickTaskValidationQuery_taskQuickCreateValidate_TaskQuickCreateValidateResult = (
  { __typename?: 'TaskQuickCreateValidateResult' }
  & QuickTaskCreateButton_TaskQuickCreateValidateResultFragment
  & QuickTaskValidationIcon_TaskQuickCreateValidateResultFragment
);

export type QuickTaskValidationQuery_Query = { __typename?: 'Query', taskQuickCreateValidate: QuickTaskValidationQuery_taskQuickCreateValidate_TaskQuickCreateValidateResult };


export type QuickTaskValidationQueryVariables = Exact<{
  input: TaskQuickCreateValidateInput;
}>;


export type QuickTaskValidationQuery = QuickTaskValidationQuery_Query;

export type HoldForCandidateCommunications_ApplicationStageFragment = { __typename?: 'ApplicationStage', id: any, isHoldForRsvp: boolean, isReadyForCandidateComms: boolean };

export type CancelScheduleDialog_ApplicationStageFragment = { __typename?: 'ApplicationStage', id: any, minStartAt: any, maxEndAt: any };

export type CancelScheduleDialog_InterviewsFragment = { __typename?: 'ApplicationStageInterview', id: any, startAt: any };

export type PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_previousAtsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, name: string };

export type PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_newAtsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, name: string };

export type PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_addedInterviewers_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_removedInterviewers_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails = { __typename?: 'PushInterviewToAtsUpdateDetails', timeChanged: boolean, previousStartAt?: any | null, previousEndAt?: any | null, newStartAt?: any | null, newEndAt?: any | null, scorecardChanged: boolean, previousAtsInterviewDefinition?: PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_previousAtsInterviewDefinition_AtsInterviewDefinition | null, newAtsInterviewDefinition?: PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_newAtsInterviewDefinition_AtsInterviewDefinition | null, addedInterviewers: Array<PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_addedInterviewers_Employee>, removedInterviewers: Array<PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails_removedInterviewers_Employee> };

export type PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult = { __typename?: 'PushInterviewToAtsResult', action: PushScheduleToAtsActionType, interviewName: string, updateDetails?: PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult_updateDetails_PushInterviewToAtsUpdateDetails | null };

export type PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult = { __typename?: 'PushScheduleToAtsResult', results: Array<PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult_results_PushInterviewToAtsResult> };

export type PushScheduleToAtsDryRunQuery_Query = { __typename?: 'Query', pushScheduleToAtsDryRun: PushScheduleToAtsDryRunQuery_pushScheduleToAtsDryRun_PushScheduleToAtsResult };


export type PushScheduleToAtsDryRunQueryVariables = Exact<{
  input: PushScheduleToAtsInput;
}>;


export type PushScheduleToAtsDryRunQuery = PushScheduleToAtsDryRunQuery_Query;

export type PushScheduleToAtsMutation_pushScheduleToAts_PushScheduleToAtsResult_results_PushInterviewToAtsResult = { __typename?: 'PushInterviewToAtsResult', action: PushScheduleToAtsActionType, interviewName: string };

export type PushScheduleToAtsMutation_pushScheduleToAts_PushScheduleToAtsResult = { __typename?: 'PushScheduleToAtsResult', results: Array<PushScheduleToAtsMutation_pushScheduleToAts_PushScheduleToAtsResult_results_PushInterviewToAtsResult> };

export type PushScheduleToAtsMutation_Mutation = { __typename?: 'Mutation', pushScheduleToAts: PushScheduleToAtsMutation_pushScheduleToAts_PushScheduleToAtsResult };


export type PushScheduleToAtsMutationVariables = Exact<{
  input: PushScheduleToAtsInput;
}>;


export type PushScheduleToAtsMutation = PushScheduleToAtsMutation_Mutation;

export type RetryExternalObjectSyncMutation_retryExternalObjectSync_RetryExternalObjectSyncResult = { __typename?: 'RetryExternalObjectSyncResult', syncStatusIds: Array<any> };

export type RetryExternalObjectSyncMutation_Mutation = { __typename?: 'Mutation', retryExternalObjectSync: RetryExternalObjectSyncMutation_retryExternalObjectSync_RetryExternalObjectSyncResult };


export type RetryExternalObjectSyncMutationVariables = Exact<{
  input: RetryExternalObjectSyncInput;
}>;


export type RetryExternalObjectSyncMutation = RetryExternalObjectSyncMutation_Mutation;

export type ScheduleContentActions_ApplicationStageFragment_ApplicationStage_task_Task_availabilityRequests_CandidateAvailabilityOptions = { __typename?: 'CandidateAvailabilityOptions', id: any };

export type ScheduleContentActions_ApplicationStageFragment_ApplicationStage_task_Task = { __typename?: 'Task', id: any, availabilityRequests: Array<ScheduleContentActions_ApplicationStageFragment_ApplicationStage_task_Task_availabilityRequests_CandidateAvailabilityOptions> };

export type ScheduleContentActions_ApplicationStageFragment = (
  { __typename?: 'ApplicationStage', id: any, selfScheduleOptionsId?: any | null, frozenAt?: any | null, task?: ScheduleContentActions_ApplicationStageFragment_ApplicationStage_task_Task | null }
  & CancelScheduleDialog_ApplicationStageFragment
);

export type ScheduleContentActions_InterviewsFragment_ApplicationStageInterview_atsSyncStatus_ExternalObjectSyncStatus = { __typename?: 'ExternalObjectSyncStatus', id: any, state: ExternalObjectSyncState };

export type ScheduleContentActions_InterviewsFragment = (
  { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any, atsSyncStatus?: ScheduleContentActions_InterviewsFragment_ApplicationStageInterview_atsSyncStatus_ExternalObjectSyncStatus | null }
  & CancelScheduleDialog_InterviewsFragment
);

export type InterviewAdjustRsvpMutation_applicationStageInterviewInterviewerUpdate_ApplicationStageInterviewInterviewerResult = { __typename?: 'ApplicationStageInterviewInterviewerResult', result?: Result | null };

export type InterviewAdjustRsvpMutation_Mutation = { __typename?: 'Mutation', applicationStageInterviewInterviewerUpdate?: InterviewAdjustRsvpMutation_applicationStageInterviewInterviewerUpdate_ApplicationStageInterviewInterviewerResult | null };


export type InterviewAdjustRsvpMutationVariables = Exact<{
  applicationStageInterviewId: Scalars['uuid']['input'];
  interviewerId: Scalars['uuid']['input'];
  responseStatus: ResponseStatus;
  reason?: InputMaybe<DeclineReason>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type InterviewAdjustRsvpMutation = InterviewAdjustRsvpMutation_Mutation;

export type AdjustInterviewerRsvp_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined = { __typename?: 'InterviewInterviewerDeclined', reason?: DeclineReason | null, comment?: string | null };

export type AdjustInterviewerRsvp_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null, givenName?: string | null };

export type AdjustInterviewerRsvp_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any, role?: InterviewerRole | null, responseStatus?: ResponseStatus | null, isOptional: boolean, declines?: Array<AdjustInterviewerRsvp_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined> | null, interviewer?: AdjustInterviewerRsvp_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee | null };

export type AdjustInterviewerRsvp_InterviewFragment = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any, name?: string | null, isHiddenFromCandidate: boolean, applicationStageInterviewInterviewers?: Array<AdjustInterviewerRsvp_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null };

export type ScheduleContentInterviewDetails_InterviewFragment_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees = (
  { __typename?: 'AdditionalAttendees' }
  & AdditionalAttendeesDetails_AdditionalAttendeesFragment
);

export type ScheduleContentInterviewDetails_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = (
  { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any }
  & ScheduleContentInterviewDetailsInterviewer_InterviewerFragment
);

export type ScheduleContentInterviewDetails_InterviewFragment_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom = (
  { __typename?: 'ApplicationStageInterviewRoom', applicationStageInterviewId: any, meetingRoomId: any }
  & ScheduleContentInterviewDetailsMeetingRoom_MeetingRoomFragment
);

export type ScheduleContentInterviewDetails_InterviewFragment = (
  { __typename?: 'ApplicationStageInterview', id: any, additionalAttendeesV2: ScheduleContentInterviewDetails_InterviewFragment_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees, applicationStageInterviewInterviewers?: Array<ScheduleContentInterviewDetails_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null, applicationStageInterviewRooms?: Array<ScheduleContentInterviewDetails_InterviewFragment_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom> | null }
  & ScheduleContentInterviewDetailsInterviewer_InterviewFragment
);

export type ScheduleContentInterviewDetails_CandidateEventFragment = { __typename?: 'ApplicationStageCandidateEvent', id: any, responseStatus?: ResponseStatus | null };

export type ScheduleContentInterviewDetailsInterviewer_InterviewFragment = (
  { __typename?: 'ApplicationStageInterview', id: any }
  & AdjustInterviewerRsvp_InterviewFragment
);

export type ScheduleContentInterviewDetailsInterviewer_InterviewerFragment_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ScheduleContentInterviewDetailsInterviewer_InterviewerFragment_ApplicationStageInterviewInterviewer_proposedTime_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ScheduleContentInterviewDetailsInterviewer_InterviewerFragment = { __typename?: 'ApplicationStageInterviewInterviewer', applicationStageInterviewId: any, interviewerId: any, responseStatus?: ResponseStatus | null, calendarEventNote?: string | null, isOptional: boolean, role?: InterviewerRole | null, interviewer?: ScheduleContentInterviewDetailsInterviewer_InterviewerFragment_ApplicationStageInterviewInterviewer_interviewer_Employee | null, proposedTime?: ScheduleContentInterviewDetailsInterviewer_InterviewerFragment_ApplicationStageInterviewInterviewer_proposedTime_DateTimeRangeOutput | null };

export type ScheduleContentInterviewDetailsMeetingRoom_MeetingRoomFragment_ApplicationStageInterviewRoom_meetingRoom_MeetingRoom = { __typename?: 'MeetingRoom', id: string, name?: string | null, description?: string | null };

export type ScheduleContentInterviewDetailsMeetingRoom_MeetingRoomFragment = { __typename?: 'ApplicationStageInterviewRoom', applicationStageInterviewId: any, meetingRoomId: any, responseStatus?: ResponseStatus | null, meetingRoom?: ScheduleContentInterviewDetailsMeetingRoom_MeetingRoomFragment_ApplicationStageInterviewRoom_meetingRoom_MeetingRoom | null };

export type ScheduleContentInterviewHeader_InterviewFragment_ApplicationStageInterview_atsSyncStatus_ExternalObjectSyncStatus = { __typename?: 'ExternalObjectSyncStatus', id: any, providerType: ExternalObjectSyncProvider, state: ExternalObjectSyncState, syncedAt?: any | null, errorCode?: string | null, errorMessage?: string | null, isRetryExhausted: boolean, attemptCount: number };

export type ScheduleContentInterviewHeader_InterviewFragment_ApplicationStageInterview_collaborationLink_CollaborationLink = { __typename?: 'CollaborationLink', id: any, collaborationToolType: CollaborationToolType };

export type ScheduleContentInterviewHeader_InterviewFragment = (
  { __typename?: 'ApplicationStageInterview', id: any, name?: string | null, startAt: any, endAt: any, googleEventUrl?: string | null, videoMeetingUrl?: string | null, zoomDialInInfo?: any | null, atsInterviewDefinitionId?: string | null, atsScheduledInterviewId?: string | null, codingInterviewUrl?: string | null, isHiddenFromCandidate: boolean, atsSyncStatus?: ScheduleContentInterviewHeader_InterviewFragment_ApplicationStageInterview_atsSyncStatus_ExternalObjectSyncStatus | null, collaborationLink?: ScheduleContentInterviewHeader_InterviewFragment_ApplicationStageInterview_collaborationLink_CollaborationLink | null }
  & ScheduleContentInterviewMenu_InterviewFragment
);

export type ScheduleContentInterviewHeader_CandidateEventFragment = (
  { __typename?: 'ApplicationStageCandidateEvent', id: any }
  & ScheduleContentInterviewMenu_CandidateEventFragment
);

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_videoMeetingHostEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_hostEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_remoteVideoMeetingHostUser_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, firstName?: string | null, lastName?: string | null, email: string };

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo = { __typename?: 'DialInfo', type?: string | null, number?: string | null, city?: string | null, countryName?: string | null, country?: string | null };

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo = { __typename?: 'ZoomInfo', meetingId?: any | null, userId?: string | null, password?: string | null, pstnPassword?: string | null, dialInfo?: Array<ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo> | null };

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails = { __typename?: 'MeetingLocationDetails', customLocation?: string | null, zoomInfo?: ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo | null };

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation = { __typename?: 'MeetingLocation', id: any, type: InterviewMeetingLocationType, videoMeetingLink?: string | null, hostEmployee?: ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_hostEmployee_Employee | null, remoteVideoMeetingHostUser?: ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_remoteVideoMeetingHostUser_ZoomUser | null, details?: ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails | null };

export type ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_collaborationLink_CollaborationLink = { __typename?: 'CollaborationLink', id: any, collaborationToolType: CollaborationToolType, url: string };

export type ScheduleContentInterviewMenu_InterviewFragment = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, googleEventUrl?: string | null, videoMeetingUrl?: string | null, zoomHostUserId?: string | null, zoomDialInInfo?: any | null, zoomMeetingId?: any | null, zoomPassword?: string | null, zoomPstnPassword?: any | null, codingInterviewUrl?: string | null, isHiddenFromCandidate: boolean, videoMeetingHostEmployee?: ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_videoMeetingHostEmployee_Employee | null, meetingLocation?: ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_meetingLocation_MeetingLocation | null, collaborationLink?: ScheduleContentInterviewMenu_InterviewFragment_ApplicationStageInterview_collaborationLink_CollaborationLink | null };

export type ScheduleContentInterviewMenu_CandidateEventFragment = { __typename?: 'ApplicationStageCandidateEvent', id: any, googleEventUrl?: string | null };

export type ScheduleContentInterviewMenuQuery_templateToken_TemplateToken = { __typename?: 'TemplateToken', ZOOM_MEETING_INFO?: string | null, ZOOM_MEETING_DIAL_IN_INFO?: string | null };

export type ScheduleContentInterviewMenuQuery_zoomUsersByIds_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, firstName?: string | null, lastName?: string | null, email: string };

export type ScheduleContentInterviewMenuQuery_Query = { __typename?: 'Query', templateToken?: ScheduleContentInterviewMenuQuery_templateToken_TemplateToken | null, zoomUsersByIds?: Array<ScheduleContentInterviewMenuQuery_zoomUsersByIds_ZoomUser> | null };


export type ScheduleContentInterviewMenuQueryVariables = Exact<{
  input: TemplateTokenInput;
  zoomMeetingInfoInput: TokenZoomMeetingInput;
  zoomMeetingUserId: Scalars['String']['input'];
}>;


export type ScheduleContentInterviewMenuQuery = ScheduleContentInterviewMenuQuery_Query;

export type ScheduleContentInterview_InterviewFragment = (
  { __typename?: 'ApplicationStageInterview', id: any }
  & ScheduleContentInterviewHeader_InterviewFragment
  & ScheduleContentInterviewDetails_InterviewFragment
);

export type ScheduleContentInterview_CandidateEventFragment = (
  { __typename?: 'ApplicationStageCandidateEvent', id: any, responseStatus?: ResponseStatus | null }
  & ScheduleContentInterviewHeader_CandidateEventFragment
  & ScheduleContentInterviewHeader_CandidateEventFragment
);

export type ScheduleContent_ApplicationFragment = { __typename?: 'Application', id: any, status: ApplicationStatus };

export type ScheduleContent_ScheduleFragment_ApplicationStage_creator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ScheduleContent_ScheduleFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview', id: any }
  & ScheduleContentActions_InterviewsFragment
  & ScheduleContentInterview_InterviewFragment
  & GroupInterviewEventsByDate_InterviewsFragment
  & GetCandidateEventByInterviewId_InterviewsFragment
);

export type ScheduleContent_ScheduleFragment_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent = (
  { __typename?: 'ApplicationStageCandidateEvent', id: any }
  & ScheduleContentInterview_CandidateEventFragment
  & GetCandidateEventByInterviewId_CandidateEventsFragment
);

export type ScheduleContent_ScheduleFragment = (
  { __typename?: 'ApplicationStage', id: any, createdAt: any, frozenAt?: any | null, creator?: ScheduleContent_ScheduleFragment_ApplicationStage_creator_Employee | null, applicationStageInterviews?: Array<ScheduleContent_ScheduleFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null, applicationStageCandidateEvents?: Array<ScheduleContent_ScheduleFragment_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent> | null }
  & HoldForCandidateCommunications_ApplicationStageFragment
  & ScheduleContentActions_ApplicationStageFragment
);

export type GetCandidateEventByInterviewId_InterviewsFragment = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any };

export type GetCandidateEventByInterviewId_CandidateEventsFragment = { __typename?: 'ApplicationStageCandidateEvent', id: any, startAt: any, endAt: any };

export type GroupInterviewEventsByDate_InterviewsFragment = { __typename?: 'ApplicationStageInterview', id: any, startAt: any };

export type AdditionalRecipientsDialog_CcRecipientsFragment = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type AdditionalRecipientsDialog_BccRecipientsFragment = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type AdditionalRecipientsDialog_OrgBccRecipientsFragment = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type AdditionalRecipientsDialog_OrgCcRecipientsFragment = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type AdditionalRecipientsRow_CcRecipientsFragment_NotificationPreference_employees_Employee = { __typename?: 'Employee', id: any };

export type AdditionalRecipientsRow_CcRecipientsFragment = (
  { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null, employees: Array<AdditionalRecipientsRow_CcRecipientsFragment_NotificationPreference_employees_Employee> }
  & AdditionalRecipientsDialog_CcRecipientsFragment
  & SmartEmployeeSelectLabel_SmartOptionsFragment
);

export type AdditionalRecipientsRow_BccRecipientsFragment_NotificationPreference_employees_Employee = { __typename?: 'Employee', id: any };

export type AdditionalRecipientsRow_BccRecipientsFragment = (
  { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null, employees: Array<AdditionalRecipientsRow_BccRecipientsFragment_NotificationPreference_employees_Employee> }
  & AdditionalRecipientsDialog_BccRecipientsFragment
  & SmartEmployeeSelectLabel_SmartOptionsFragment
);

export type AdditionalRecipientsRow_OrgBccRecipientsFragment = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsDialog_OrgBccRecipientsFragment
  & SmartEmployeeSelectLabel_SmartOptionsFragment
);

export type AdditionalRecipientsRow_OrgCcRecipientsFragment = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsDialog_OrgCcRecipientsFragment
  & SmartEmployeeSelectLabel_SmartOptionsFragment
);

export type ExistingSlackChannelsByNameQuery_slackChannelByName_SlackChannel = { __typename?: 'SlackChannel', id: string, name: string };

export type ExistingSlackChannelsByNameQuery_Query = { __typename?: 'Query', slackChannelByName?: Array<ExistingSlackChannelsByNameQuery_slackChannelByName_SlackChannel> | null };


export type ExistingSlackChannelsByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type ExistingSlackChannelsByNameQuery = ExistingSlackChannelsByNameQuery_Query;

export type ExistingSlackChannels_OrgConversationFragment_ChatCommunicationsSettingPref_chatConversation_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, orgId: any, type: ConversationType, remoteName: string };

export type ExistingSlackChannels_OrgConversationFragment = { __typename?: 'ChatCommunicationsSettingPref', chatConversationType: ChatConversationType, chatConversationId?: any | null, chatConversation?: ExistingSlackChannels_OrgConversationFragment_ChatCommunicationsSettingPref_chatConversation_Conversation | null };

export type ExistingSlackChannels_ChatConversationFragment_SettingChatConversation_chatConversation_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, orgId: any, type: ConversationType, remoteName: string };

export type ExistingSlackChannels_ChatConversationFragment = { __typename?: 'SettingChatConversation', chatConversationType?: ChatConversationType | null, chatConversationId?: any | null, level: SettingLevel, chatConversation?: ExistingSlackChannels_ChatConversationFragment_SettingChatConversation_chatConversation_Conversation | null };

export type SlackChannelRow_OrgConversationFragment = (
  { __typename?: 'ChatCommunicationsSettingPref' }
  & ExistingSlackChannels_OrgConversationFragment
);

export type SlackChannelRow_ChatConversationFragment = (
  { __typename?: 'SettingChatConversation' }
  & ExistingSlackChannels_ChatConversationFragment
);

export type SlackChannelMembersDialog_MembersFragment = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type SlackChannelMembersDialog_OrgMembersFragment = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type SlackChannelMembers_MembersFragment = (
  { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null }
  & SlackChannelMembersDialog_MembersFragment
  & SmartEmployeeSelectLabel_SmartOptionsFragment
);

export type SlackChannelMembers_OrgMembersFragment = (
  { __typename?: 'NotificationPreference' }
  & SlackChannelMembersDialog_OrgMembersFragment
  & SmartEmployeeSelectLabel_SmartOptionsFragment
);

export type RequestTemplateSelect_TemplateFragment = { __typename?: 'Template', id: any, name?: string | null };

export type RequestTemplateSelectQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template', id: any }
  & RequestTemplateSelect_TemplateFragment
  & TemplateOption_TemplateFragment
);

export type RequestTemplateSelectQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<RequestTemplateSelectQuery_templates_TemplatesOutput_items_Template> };

export type RequestTemplateSelectQuery_Query = { __typename?: 'Query', templates?: RequestTemplateSelectQuery_templates_TemplatesOutput | null };


export type RequestTemplateSelectQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type RequestTemplateSelectQuery = RequestTemplateSelectQuery_Query;

export type RequestTemplateValue_TemplateFragment = { __typename?: 'Template', id: any, name?: string | null };

export type RequestTemplateValueQuery_template_Template = (
  { __typename?: 'Template' }
  & RequestTemplateValue_TemplateFragment
);

export type RequestTemplateValueQuery_Query = { __typename?: 'Query', template?: RequestTemplateValueQuery_template_Template | null };


export type RequestTemplateValueQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RequestTemplateValueQuery = RequestTemplateValueQuery_Query;

export type TemplateOption_TemplateFragment = { __typename?: 'Template', id: any, type: TemplateType, name?: string | null, subject?: string | null, body?: string | null };

export type TemplateRow_TemplateFragment = { __typename?: 'Template', id: any, name?: string | null };

export type TemplateRow_OrgTemplateFragment = { __typename?: 'Template', id: any, name?: string | null };

export type AtsUserFragment_AtsUser_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type AtsUserFragment = { __typename?: 'AtsUser', id: string, email: string, name: string, disabled: boolean, employeeId?: string | null, employee?: AtsUserFragment_AtsUser_employee_Employee | null };

export type ListAtsUsersQuery_atsUsers_AtsUserOutput_items_AtsUser = (
  { __typename?: 'AtsUser' }
  & AtsUserFragment
);

export type ListAtsUsersQuery_atsUsers_AtsUserOutput = { __typename?: 'AtsUserOutput', items?: Array<ListAtsUsersQuery_atsUsers_AtsUserOutput_items_AtsUser> | null };

export type ListAtsUsersQuery_Query = { __typename?: 'Query', atsUsers?: ListAtsUsersQuery_atsUsers_AtsUserOutput | null };


export type ListAtsUsersQueryVariables = Exact<{
  input: AtsUserInput;
}>;


export type ListAtsUsersQuery = ListAtsUsersQuery_Query;

export type BrandingThemeSelectQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme = (
  { __typename?: 'BrandingTheme' }
  & Row_BrandingOptionsFragment
);

export type BrandingThemeSelectQuery_brandingThemes_BrandingThemesResult = { __typename?: 'BrandingThemesResult', items: Array<BrandingThemeSelectQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme> };

export type BrandingThemeSelectQuery_Query = { __typename?: 'Query', brandingThemes?: BrandingThemeSelectQuery_brandingThemes_BrandingThemesResult | null };


export type BrandingThemeSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandingThemeSelectQuery = BrandingThemeSelectQuery_Query;

export type Row_BrandingOptionsFragment = (
  { __typename?: 'BrandingTheme', id: any, name: string, profileImageUrl?: string | null, coverImageUrl?: string | null, isOrgDefault: boolean }
  & BrandingThemePlaceholderPreview_BrandingThemeFragment
);

export type BrighthireButtonSelect_InterviewGuideFragment = { __typename?: 'InterviewGuide', id: any, name: string };

export type BrighthireSelect_InterviewGuideFragment = { __typename?: 'InterviewGuide', id: any, name: string };

export type BrighthireGuideOptionFragment_InterviewGuide_job_Job = { __typename?: 'Job', id: any };

export type BrighthireGuideOptionFragment = { __typename?: 'InterviewGuide', id: any, name: string, remoteInterviewGuideId: string, remoteInterviewGuideType: InterviewGuideType, job?: BrighthireGuideOptionFragment_InterviewGuide_job_Job | null };

export type BrighthireFormsQuery_job_Job_interviewGuides_InterviewGuide = (
  { __typename?: 'InterviewGuide' }
  & BrighthireGuideOptionFragment
);

export type BrighthireFormsQuery_job_Job = { __typename?: 'Job', id: any, interviewGuides: Array<BrighthireFormsQuery_job_Job_interviewGuides_InterviewGuide> };

export type BrighthireFormsQuery_Query = { __typename?: 'Query', job?: BrighthireFormsQuery_job_Job | null };


export type BrighthireFormsQueryVariables = Exact<{
  jobId: Scalars['uuid']['input'];
}>;


export type BrighthireFormsQuery = BrighthireFormsQuery_Query;

export type BrighthireIntegrationsQueryQuery_thisOrg_Org_integrations_OrgIntegrations_brighthire_BrighthireIntegration = { __typename?: 'BrighthireIntegration', apiKey: string };

export type BrighthireIntegrationsQueryQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, brighthire?: BrighthireIntegrationsQueryQuery_thisOrg_Org_integrations_OrgIntegrations_brighthire_BrighthireIntegration | null };

export type BrighthireIntegrationsQueryQuery_thisOrg_Org = { __typename?: 'Org', integrations?: BrighthireIntegrationsQueryQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type BrighthireIntegrationsQueryQuery_Query = { __typename?: 'Query', thisOrg?: BrighthireIntegrationsQueryQuery_thisOrg_Org | null };


export type BrighthireIntegrationsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BrighthireIntegrationsQueryQuery = BrighthireIntegrationsQueryQuery_Query;

export type Calendar_CalendarFragment = { __typename?: 'Calendar', id?: string | null, name?: string | null, remoteId?: string | null };

export type CalendarQuery_calendar_Calendar = (
  { __typename?: 'Calendar' }
  & Calendar_CalendarFragment
);

export type CalendarQuery_Query = { __typename?: 'Query', calendar?: CalendarQuery_calendar_Calendar | null };


export type CalendarQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type CalendarQuery = CalendarQuery_Query;

export type CalendarSelectCalendarsQuery_calendars_CalendarsResult_items_Calendar = { __typename?: 'Calendar', id?: string | null, name?: string | null, isReadOnly?: boolean | null, remoteId?: string | null };

export type CalendarSelectCalendarsQuery_calendars_CalendarsResult = { __typename?: 'CalendarsResult', nextCursor?: string | null, items: Array<CalendarSelectCalendarsQuery_calendars_CalendarsResult_items_Calendar> };

export type CalendarSelectCalendarsQuery_Query = { __typename?: 'Query', calendars?: CalendarSelectCalendarsQuery_calendars_CalendarsResult | null };


export type CalendarSelectCalendarsQueryVariables = Exact<{
  input: CalendarsInput;
}>;


export type CalendarSelectCalendarsQuery = CalendarSelectCalendarsQuery_Query;

export type CollaborationToolSelect_CollaborationLinkTypeFragment = { __typename?: 'CollaborationLinkType', collaborationToolType: CollaborationToolType, collaborationLinkTemplateId?: any | null };

export type CollaborationToolTemplate_CollaborationLinkTemplateFragment = { __typename?: 'CollaborationLinkTemplate', id: any, name: string, groupName?: string | null };

export type CollaborationToolTemplateQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult_items_CollaborationLinkTemplate = (
  { __typename?: 'CollaborationLinkTemplate' }
  & CollaborationToolTemplate_CollaborationLinkTemplateFragment
);

export type CollaborationToolTemplateQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult = { __typename?: 'CollaborationLinkTemplatesResult', items: Array<CollaborationToolTemplateQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult_items_CollaborationLinkTemplate> };

export type CollaborationToolTemplateQuery_Query = { __typename?: 'Query', collaborationLinkTemplates: CollaborationToolTemplateQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult };


export type CollaborationToolTemplateQueryVariables = Exact<{
  input: CollaborationLinkTemplatesInput;
}>;


export type CollaborationToolTemplateQuery = CollaborationToolTemplateQuery_Query;

export type CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration = { __typename?: 'CoderpadIntegration', apiKey: string };

export type CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration = { __typename?: 'CodilityIntegration', apiKey: string };

export type CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration = { __typename?: 'CodesignalIntegration', apiKey: string };

export type CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration = { __typename?: 'HackerRankIntegration', apiKey: string };

export type CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, coderpad?: CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration | null, codility?: CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration | null, codesignal?: CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration | null, hackerrank?: CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration | null };

export type CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type CollaborationToolFilterPopoverOrgIntegrationQuery_Query = { __typename?: 'Query', thisOrg?: CollaborationToolFilterPopoverOrgIntegrationQuery_thisOrg_Org | null };


export type CollaborationToolFilterPopoverOrgIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type CollaborationToolFilterPopoverOrgIntegrationQuery = CollaborationToolFilterPopoverOrgIntegrationQuery_Query;

export type CollaborationToolFilterPopover_CollaborationLinkTypeFragment = { __typename?: 'CollaborationLinkType', collaborationToolType: CollaborationToolType, collaborationLinkTemplateId?: any | null };

export type CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration = { __typename?: 'CoderpadIntegration', apiKey: string };

export type CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration = { __typename?: 'CodilityIntegration', apiKey: string };

export type CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration = { __typename?: 'CodesignalIntegration', apiKey: string };

export type CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration = { __typename?: 'HackerRankIntegration', apiKey: string };

export type CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, coderpad?: CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration | null, codility?: CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration | null, codesignal?: CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration | null, hackerrank?: CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration | null };

export type CollaborationToolOptionsIntegrationsQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: CollaborationToolOptionsIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type CollaborationToolOptionsIntegrationsQuery_Query = { __typename?: 'Query', thisOrg?: CollaborationToolOptionsIntegrationsQuery_thisOrg_Org | null };


export type CollaborationToolOptionsIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollaborationToolOptionsIntegrationsQuery = CollaborationToolOptionsIntegrationsQuery_Query;

export type CollaborationToolOptionsQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult_items_CollaborationLinkTemplate = { __typename?: 'CollaborationLinkTemplate', id: any, groupName?: string | null, name: string };

export type CollaborationToolOptionsQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult = { __typename: 'CollaborationLinkTemplatesResult', nextCursor?: string | null, items: Array<CollaborationToolOptionsQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult_items_CollaborationLinkTemplate> };

export type CollaborationToolOptionsQuery_Query = { __typename?: 'Query', collaborationLinkTemplates: CollaborationToolOptionsQuery_collaborationLinkTemplates_CollaborationLinkTemplatesResult };


export type CollaborationToolOptionsQueryVariables = Exact<{
  input: CollaborationLinkTemplatesInput;
}>;


export type CollaborationToolOptionsQuery = CollaborationToolOptionsQuery_Query;

export type CandidateLocaleSelectUpdateMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate = { __typename?: 'Candidate', id: any, locale?: Locale | null };

export type CandidateLocaleSelectUpdateMutation_candidateUpdate_CandidateUpdateResult = { __typename?: 'CandidateUpdateResult', candidate: CandidateLocaleSelectUpdateMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate };

export type CandidateLocaleSelectUpdateMutation_Mutation = { __typename?: 'Mutation', candidateUpdate: CandidateLocaleSelectUpdateMutation_candidateUpdate_CandidateUpdateResult };


export type CandidateLocaleSelectUpdateMutationVariables = Exact<{
  input: CandidateUpdateInput;
}>;


export type CandidateLocaleSelectUpdateMutation = CandidateLocaleSelectUpdateMutation_Mutation;

export type CandidateLocaleSelect_CandidateFragment = { __typename?: 'Candidate', id: any, locale?: Locale | null };

export type CandidateTimezoneSelectUpdateMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate = { __typename?: 'Candidate', id: any, timezone?: string | null };

export type CandidateTimezoneSelectUpdateMutation_candidateUpdate_CandidateUpdateResult = { __typename?: 'CandidateUpdateResult', candidate: CandidateTimezoneSelectUpdateMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate };

export type CandidateTimezoneSelectUpdateMutation_Mutation = { __typename?: 'Mutation', candidateUpdate: CandidateTimezoneSelectUpdateMutation_candidateUpdate_CandidateUpdateResult };


export type CandidateTimezoneSelectUpdateMutationVariables = Exact<{
  input: CandidateUpdateInput;
}>;


export type CandidateTimezoneSelectUpdateMutation = CandidateTimezoneSelectUpdateMutation_Mutation;

export type CandidateTimezoneSelect_CandidateFragment = { __typename?: 'Candidate', id: any, timezone?: string | null };

export type CoordinatorSelectApplicationUpdateMutation_applicationUpdate_Application_coordinator_Employee = (
  { __typename?: 'Employee', id: any }
  & SelectButtonLabel_EmployeeFragment
);

export type CoordinatorSelectApplicationUpdateMutation_applicationUpdate_Application = { __typename?: 'Application', id: any, coordinator?: CoordinatorSelectApplicationUpdateMutation_applicationUpdate_Application_coordinator_Employee | null };

export type CoordinatorSelectApplicationUpdateMutation_Mutation = { __typename?: 'Mutation', applicationUpdate: CoordinatorSelectApplicationUpdateMutation_applicationUpdate_Application };


export type CoordinatorSelectApplicationUpdateMutationVariables = Exact<{
  input: ApplicationUpdateInput;
}>;


export type CoordinatorSelectApplicationUpdateMutation = CoordinatorSelectApplicationUpdateMutation_Mutation;

export type CoordinatorSelect_ApplicationFragment_Application_coordinator_Employee = (
  { __typename?: 'Employee', id: any }
  & SelectButtonLabel_EmployeeFragment
);

export type CoordinatorSelect_ApplicationFragment = { __typename?: 'Application', id: any, coordinator?: CoordinatorSelect_ApplicationFragment_Application_coordinator_Employee | null };

export type RecruiterSelectApplicationUpdateMutation_applicationUpdate_Application_recruiter_Employee = (
  { __typename?: 'Employee', id: any }
  & SelectButtonLabel_EmployeeFragment
);

export type RecruiterSelectApplicationUpdateMutation_applicationUpdate_Application = { __typename?: 'Application', id: any, recruiter?: RecruiterSelectApplicationUpdateMutation_applicationUpdate_Application_recruiter_Employee | null };

export type RecruiterSelectApplicationUpdateMutation_Mutation = { __typename?: 'Mutation', applicationUpdate: RecruiterSelectApplicationUpdateMutation_applicationUpdate_Application };


export type RecruiterSelectApplicationUpdateMutationVariables = Exact<{
  input: ApplicationUpdateInput;
}>;


export type RecruiterSelectApplicationUpdateMutation = RecruiterSelectApplicationUpdateMutation_Mutation;

export type RecruiterSelect_ApplicationFragment_Application_recruiter_Employee = (
  { __typename?: 'Employee', id: any }
  & SelectButtonLabel_EmployeeFragment
);

export type RecruiterSelect_ApplicationFragment = { __typename?: 'Application', id: any, recruiter?: RecruiterSelect_ApplicationFragment_Application_recruiter_Employee | null };

export type SourcerSelectApplicationUpdateMutation_applicationUpdate_Application_sourcer_Employee = (
  { __typename?: 'Employee', id: any }
  & SelectButtonLabel_EmployeeFragment
);

export type SourcerSelectApplicationUpdateMutation_applicationUpdate_Application = { __typename?: 'Application', id: any, sourcer?: SourcerSelectApplicationUpdateMutation_applicationUpdate_Application_sourcer_Employee | null };

export type SourcerSelectApplicationUpdateMutation_Mutation = { __typename?: 'Mutation', applicationUpdate: SourcerSelectApplicationUpdateMutation_applicationUpdate_Application };


export type SourcerSelectApplicationUpdateMutationVariables = Exact<{
  input: ApplicationUpdateInput;
}>;


export type SourcerSelectApplicationUpdateMutation = SourcerSelectApplicationUpdateMutation_Mutation;

export type SourcerSelect_ApplicationFragment_Application_sourcer_Employee = (
  { __typename?: 'Employee', id: any }
  & SelectButtonLabel_EmployeeFragment
);

export type SourcerSelect_ApplicationFragment = { __typename?: 'Application', id: any, candidateId: any, sourcer?: SourcerSelect_ApplicationFragment_Application_sourcer_Employee | null };

export type HiringTeam_ApplicationFragment = (
  { __typename?: 'Application', id: any }
  & RecruiterSelect_ApplicationFragment
  & CoordinatorSelect_ApplicationFragment
  & SourcerSelect_ApplicationFragment
);

export type InterviewModuleFragment = { __typename?: 'InterviewModule', id: any, name: string, shadowsRequired: any, reverseShadowsRequired: any, weeklyNumInterviewLimit?: any | null };

export type InterviewModuleSearchQuery_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule = (
  { __typename?: 'InterviewModule' }
  & InterviewModuleFragment
);

export type InterviewModuleSearchQuery_interviewModuleSearch_InterviewModuleSearchOutput = { __typename?: 'InterviewModuleSearchOutput', total?: number | null, items: Array<InterviewModuleSearchQuery_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule> };

export type InterviewModuleSearchQuery_Query = { __typename?: 'Query', interviewModuleSearch?: InterviewModuleSearchQuery_interviewModuleSearch_InterviewModuleSearchOutput | null };


export type InterviewModuleSearchQueryVariables = Exact<{
  input: InterviewModuleSearchInput;
}>;


export type InterviewModuleSearchQuery = InterviewModuleSearchQuery_Query;

export type JobBrandingTemplate_PortalTemplateFragment = { __typename?: 'PortalTemplate', id: any, name: string };

export type JobBrandingTemplateQuery_portalTemplate_PortalTemplate = (
  { __typename?: 'PortalTemplate' }
  & JobBrandingTemplate_PortalTemplateFragment
);

export type JobBrandingTemplateQuery_Query = { __typename?: 'Query', portalTemplate?: JobBrandingTemplateQuery_portalTemplate_PortalTemplate | null };


export type JobBrandingTemplateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobBrandingTemplateQuery = JobBrandingTemplateQuery_Query;

export type JobBrandingTemplateSelect_PortalTemplateFragment = { __typename?: 'PortalTemplate', id: any, name: string };

export type JobBrandingTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult_items_PortalTemplate = (
  { __typename?: 'PortalTemplate', id: any }
  & JobBrandingTemplateSelect_PortalTemplateFragment
);

export type JobBrandingTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult = { __typename?: 'PortalTemplatesResult', nextCursor?: string | null, items: Array<JobBrandingTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult_items_PortalTemplate> };

export type JobBrandingTemplateSelectQueryQuery_Query = { __typename?: 'Query', portalTemplates?: JobBrandingTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult | null };


export type JobBrandingTemplateSelectQueryQueryVariables = Exact<{
  input: PortalTemplatesInput;
}>;


export type JobBrandingTemplateSelectQueryQuery = JobBrandingTemplateSelectQueryQuery_Query;

export type OrgJobDepartmentsQuery_thisOrg_Org_jobDepartments_AutomationDepartment = { __typename?: 'AutomationDepartment', id: string, name: string };

export type OrgJobDepartmentsQuery_thisOrg_Org = { __typename?: 'Org', id: any, jobDepartments: Array<OrgJobDepartmentsQuery_thisOrg_Org_jobDepartments_AutomationDepartment> };

export type OrgJobDepartmentsQuery_Query = { __typename?: 'Query', thisOrg?: OrgJobDepartmentsQuery_thisOrg_Org | null };


export type OrgJobDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgJobDepartmentsQuery = OrgJobDepartmentsQuery_Query;

export type OrgJobLocationsQuery_thisOrg_Org = { __typename?: 'Org', id: any, locations: Array<string> };

export type OrgJobLocationsQuery_Query = { __typename?: 'Query', thisOrg?: OrgJobLocationsQuery_thisOrg_Org | null };


export type OrgJobLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgJobLocationsQuery = OrgJobLocationsQuery_Query;

export type MemberSelect_UserInfoFragment_UserInfo_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type MemberSelect_UserInfoFragment = { __typename?: 'UserInfo', userId: any, employee?: MemberSelect_UserInfoFragment_UserInfo_employee_Employee | null };

export type OrgMembersQuery_thisOrg_Org_userInfos_UserInfoResult_items_UserInfo = (
  { __typename?: 'UserInfo' }
  & MemberSelect_UserInfoFragment
);

export type OrgMembersQuery_thisOrg_Org_userInfos_UserInfoResult = { __typename?: 'UserInfoResult', nextCursor?: string | null, items: Array<OrgMembersQuery_thisOrg_Org_userInfos_UserInfoResult_items_UserInfo> };

export type OrgMembersQuery_thisOrg_Org = { __typename?: 'Org', id: any, userInfos: OrgMembersQuery_thisOrg_Org_userInfos_UserInfoResult };

export type OrgMembersQuery_Query = { __typename?: 'Query', thisOrg?: OrgMembersQuery_thisOrg_Org | null };


export type OrgMembersQueryVariables = Exact<{
  input: OrgUserInfoInput;
}>;


export type OrgMembersQuery = OrgMembersQuery_Query;

export type UserInfoByEmployeeIdsQuery_userInfoByEmployeeIds_UserInfo = (
  { __typename?: 'UserInfo' }
  & MemberSelect_UserInfoFragment
);

export type UserInfoByEmployeeIdsQuery_Query = { __typename?: 'Query', userInfoByEmployeeIds?: Array<UserInfoByEmployeeIdsQuery_userInfoByEmployeeIds_UserInfo> | null };


export type UserInfoByEmployeeIdsQueryVariables = Exact<{
  input: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UserInfoByEmployeeIdsQuery = UserInfoByEmployeeIdsQuery_Query;

export type PortalTemplateSelect_PortalTemplateFragment = { __typename?: 'PortalTemplate', id: any, name: string };

export type PortalTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult_items_PortalTemplate = (
  { __typename?: 'PortalTemplate', id: any }
  & PortalTemplateSelect_PortalTemplateFragment
);

export type PortalTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult = { __typename?: 'PortalTemplatesResult', nextCursor?: string | null, items: Array<PortalTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult_items_PortalTemplate> };

export type PortalTemplateSelectQueryQuery_Query = { __typename?: 'Query', portalTemplates?: PortalTemplateSelectQueryQuery_portalTemplates_PortalTemplatesResult | null };


export type PortalTemplateSelectQueryQueryVariables = Exact<{
  input: PortalTemplatesInput;
}>;


export type PortalTemplateSelectQueryQuery = PortalTemplateSelectQueryQuery_Query;

export type PortalTemplateSelectByIdQueryQuery_portalTemplate_PortalTemplate = { __typename?: 'PortalTemplate', id: any, name: string };

export type PortalTemplateSelectByIdQueryQuery_Query = { __typename?: 'Query', portalTemplate?: PortalTemplateSelectByIdQueryQuery_portalTemplate_PortalTemplate | null };


export type PortalTemplateSelectByIdQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalTemplateSelectByIdQueryQuery = PortalTemplateSelectByIdQueryQuery_Query;

export type TaskQueuesSelectListQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue = { __typename?: 'TaskQueue', id: any, name: string, memberCount: number };

export type TaskQueuesSelectListQuery_taskQueueSearch_TaskQueueSearchResult = { __typename?: 'TaskQueueSearchResult', items: Array<TaskQueuesSelectListQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue> };

export type TaskQueuesSelectListQuery_Query = { __typename?: 'Query', taskQueueSearch?: TaskQueuesSelectListQuery_taskQueueSearch_TaskQueueSearchResult | null };


export type TaskQueuesSelectListQueryVariables = Exact<{
  input: TaskQueueSearchInput;
}>;


export type TaskQueuesSelectListQuery = TaskQueuesSelectListQuery_Query;

export type TaskQueue_TaskQueueFragment = { __typename?: 'TaskQueue', id: any, name: string, memberCount: number };

export type TaskQueueQuery_taskQueue_TaskQueue = (
  { __typename?: 'TaskQueue' }
  & TaskQueue_TaskQueueFragment
);

export type TaskQueueQuery_Query = { __typename?: 'Query', taskQueue?: TaskQueueQuery_taskQueue_TaskQueue | null };


export type TaskQueueQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TaskQueueQuery = TaskQueueQuery_Query;

export type OptionRenderer_EmployeesFragment = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, familyName?: string | null, internalProfilePictureUrl?: string | null, email: string, isArchived?: boolean | null, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null, isDisabled?: boolean | null, orgId: any };

export type SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, familyName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery_Query = { __typename?: 'Query', employee?: SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery_employee_Employee | null };


export type SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery = SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery_Query;

export type SmartEmployeeSelectLabel_SmartOptionsFragment_NotificationPreference_employees_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, familyName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type SmartEmployeeSelectLabel_SmartOptionsFragment = { __typename?: 'NotificationPreference', dynamicAudiences?: Array<DynamicAudience> | null, externalEmailAddresses?: Array<string> | null, employees: Array<SmartEmployeeSelectLabel_SmartOptionsFragment_NotificationPreference_employees_Employee> };

export type SmartEmployeeSelectFragment = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, familyName?: string | null, internalProfilePictureUrl?: string | null, email: string, isArchived?: boolean | null, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null, isDisabled?: boolean | null, orgId: any };

export type SmartEmployeeSelectMembersQuery_employeeSearch_EmployeeSearchOutput_items_Employee = (
  { __typename?: 'Employee' }
  & SmartEmployeeSelectFragment
);

export type SmartEmployeeSelectMembersQuery_employeeSearch_EmployeeSearchOutput = { __typename?: 'EmployeeSearchOutput', items: Array<SmartEmployeeSelectMembersQuery_employeeSearch_EmployeeSearchOutput_items_Employee> };

export type SmartEmployeeSelectMembersQuery_Query = { __typename?: 'Query', employeeSearch?: SmartEmployeeSelectMembersQuery_employeeSearch_EmployeeSearchOutput | null };


export type SmartEmployeeSelectMembersQueryVariables = Exact<{
  input: EmployeeSearchInput;
}>;


export type SmartEmployeeSelectMembersQuery = SmartEmployeeSelectMembersQuery_Query;

export type SmartEmployeeByIdsQuery_employeeByIds_Employee = (
  { __typename?: 'Employee' }
  & SmartEmployeeSelectFragment
);

export type SmartEmployeeByIdsQuery_Query = { __typename?: 'Query', employeeByIds?: Array<SmartEmployeeByIdsQuery_employeeByIds_Employee> | null };


export type SmartEmployeeByIdsQueryVariables = Exact<{
  input: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SmartEmployeeByIdsQuery = SmartEmployeeByIdsQuery_Query;

export type SmartEmployeeGetInterviewersOnPlanByIdsQuery_employeeByIds_Employee = (
  { __typename?: 'Employee' }
  & UseTaskSmartOptions_TaskInterviewersDataFragment
);

export type SmartEmployeeGetInterviewersOnPlanByIdsQuery_Query = { __typename?: 'Query', employeeByIds?: Array<SmartEmployeeGetInterviewersOnPlanByIdsQuery_employeeByIds_Employee> | null };


export type SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables = Exact<{
  taskInterviewersOnScheduleEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SmartEmployeeGetInterviewersOnPlanByIdsQuery = SmartEmployeeGetInterviewersOnPlanByIdsQuery_Query;

export type DynamicEmployeeQuery_task_DynamicEmployee_TASK_ASSIGNEE_Employee = (
  { __typename?: 'Employee' }
  & UseTaskSmartOptions_TaskAssigneeDataFragment
);

export type DynamicEmployeeQuery_task_DynamicEmployee_TASK_SUBSCRIBERS_Employee = (
  { __typename?: 'Employee' }
  & UseTaskSmartOptions_TaskSubscriberDataFragment
);

export type DynamicEmployeeQuery_task_DynamicEmployee_TASK_CREATOR_Employee = (
  { __typename?: 'Employee' }
  & UseTaskSmartOptions_TaskCreatorDataFragment
);

export type DynamicEmployeeQuery_task_DynamicEmployee_DEBRIEF_ATTENDEES_Employee = (
  { __typename?: 'Employee' }
  & UseTaskSmartOptions_TaskDebriefDataFragment
);

export type DynamicEmployeeQuery_task_DynamicEmployee = { __typename?: 'DynamicEmployee', TASK_ASSIGNEE?: DynamicEmployeeQuery_task_DynamicEmployee_TASK_ASSIGNEE_Employee | null, TASK_SUBSCRIBERS: Array<DynamicEmployeeQuery_task_DynamicEmployee_TASK_SUBSCRIBERS_Employee>, TASK_CREATOR?: DynamicEmployeeQuery_task_DynamicEmployee_TASK_CREATOR_Employee | null, DEBRIEF_ATTENDEES: Array<DynamicEmployeeQuery_task_DynamicEmployee_DEBRIEF_ATTENDEES_Employee> };

export type DynamicEmployeeQuery_job_DynamicEmployee_JOB_COORDINATORS_Employee = (
  { __typename?: 'Employee' }
  & UseJobSmartOptions_JobCoordinatorDataFragment
);

export type DynamicEmployeeQuery_job_DynamicEmployee_JOB_RECRUITERS_Employee = (
  { __typename?: 'Employee' }
  & UseJobSmartOptions_JobRecruiterDataFragment
);

export type DynamicEmployeeQuery_job_DynamicEmployee_JOB_SOURCERS_Employee = (
  { __typename?: 'Employee' }
  & UseJobSmartOptions_JobSourcerDataFragment
);

export type DynamicEmployeeQuery_job_DynamicEmployee_JOB_HIRING_MANAGERS_Employee = (
  { __typename?: 'Employee' }
  & UseJobSmartOptions_JobHiringManagersDataFragment
);

export type DynamicEmployeeQuery_job_DynamicEmployee = { __typename?: 'DynamicEmployee', JOB_COORDINATORS: Array<DynamicEmployeeQuery_job_DynamicEmployee_JOB_COORDINATORS_Employee>, JOB_RECRUITERS: Array<DynamicEmployeeQuery_job_DynamicEmployee_JOB_RECRUITERS_Employee>, JOB_SOURCERS: Array<DynamicEmployeeQuery_job_DynamicEmployee_JOB_SOURCERS_Employee>, JOB_HIRING_MANAGERS: Array<DynamicEmployeeQuery_job_DynamicEmployee_JOB_HIRING_MANAGERS_Employee> };

export type DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_COORDINATOR_Employee = (
  { __typename?: 'Employee' }
  & UseCandidateSmartOptions_CandidateCoordinatorDataFragment
);

export type DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_RECRUITER_Employee = (
  { __typename?: 'Employee' }
  & UseCandidateSmartOptions_CandidateRecruiterDataFragment
);

export type DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_SOURCER_Employee = (
  { __typename?: 'Employee' }
  & UseCandidateSmartOptions_CandidateSourcerDataFragment
);

export type DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATES_PREVIOUS_INTERVIEWERS_Employee = (
  { __typename?: 'Employee' }
  & UseCandidateSmartOptions_PreviousCandidateInterviewersDataFragment
);

export type DynamicEmployeeQuery_candidate_DynamicEmployee = { __typename?: 'DynamicEmployee', CANDIDATE_COORDINATOR?: DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_COORDINATOR_Employee | null, CANDIDATE_RECRUITER?: DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_RECRUITER_Employee | null, CANDIDATE_SOURCER?: DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_SOURCER_Employee | null, CANDIDATES_PREVIOUS_INTERVIEWERS: Array<DynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATES_PREVIOUS_INTERVIEWERS_Employee> };

export type DynamicEmployeeQuery_Query = { __typename?: 'Query', task?: DynamicEmployeeQuery_task_DynamicEmployee | null, job?: DynamicEmployeeQuery_job_DynamicEmployee | null, candidate?: DynamicEmployeeQuery_candidate_DynamicEmployee | null };


export type DynamicEmployeeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  taskId: Scalars['uuid']['input'];
  jobId: Scalars['uuid']['input'];
  applicationId: Scalars['uuid']['input'];
  skipTask: Scalars['Boolean']['input'];
  skipJob: Scalars['Boolean']['input'];
  skipCandidate: Scalars['Boolean']['input'];
}>;


export type DynamicEmployeeQuery = DynamicEmployeeQuery_Query;

export type UseCandidateSmartOptions_CandidateCoordinatorDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseCandidateSmartOptions_CandidateRecruiterDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseCandidateSmartOptions_CandidateSourcerDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseCandidateSmartOptions_PreviousCandidateInterviewersDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseGetDynamicAudienceData_DynamicEmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, familyName?: string | null, internalProfilePictureUrl?: string | null, email: string, isArchived?: boolean | null, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null, isDisabled?: boolean | null, orgId: any };

export type UseGetDynamicAudienceDataForTaskQuery_taskAssigneeData_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataForTaskQuery_taskSubscriberData_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataForTaskQuery_taskDebriefData_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataForTaskQuery_taskCreatorData_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataForTaskQuery_Query = { __typename?: 'Query', taskAssigneeData?: Array<UseGetDynamicAudienceDataForTaskQuery_taskAssigneeData_Employee> | null, taskSubscriberData?: Array<UseGetDynamicAudienceDataForTaskQuery_taskSubscriberData_Employee> | null, taskDebriefData?: Array<UseGetDynamicAudienceDataForTaskQuery_taskDebriefData_Employee> | null, taskCreatorData?: Array<UseGetDynamicAudienceDataForTaskQuery_taskCreatorData_Employee> | null };


export type UseGetDynamicAudienceDataForTaskQueryVariables = Exact<{
  taskAssigneeEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  taskCreatorEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  taskSubscriberEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  taskDebriefEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UseGetDynamicAudienceDataForTaskQuery = UseGetDynamicAudienceDataForTaskQuery_Query;

export type UseGetDynamicAudienceDataByEmployeeIdsQuery_employeeByIds_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataByEmployeeIdsQuery_Query = { __typename?: 'Query', employeeByIds?: Array<UseGetDynamicAudienceDataByEmployeeIdsQuery_employeeByIds_Employee> | null };


export type UseGetDynamicAudienceDataByEmployeeIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UseGetDynamicAudienceDataByEmployeeIdsQuery = UseGetDynamicAudienceDataByEmployeeIdsQuery_Query;

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_TASK_ASSIGNEE_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_TASK_SUBSCRIBERS_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_TASK_CREATOR_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_DEBRIEF_ATTENDEES_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee = { __typename?: 'DynamicEmployee', TASK_ASSIGNEE?: UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_TASK_ASSIGNEE_Employee | null, TASK_SUBSCRIBERS: Array<UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_TASK_SUBSCRIBERS_Employee>, TASK_CREATOR?: UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_TASK_CREATOR_Employee | null, DEBRIEF_ATTENDEES: Array<UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee_DEBRIEF_ATTENDEES_Employee> };

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_COORDINATORS_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_RECRUITERS_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_SOURCERS_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_HIRING_MANAGERS_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee = { __typename?: 'DynamicEmployee', JOB_COORDINATORS: Array<UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_COORDINATORS_Employee>, JOB_RECRUITERS: Array<UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_RECRUITERS_Employee>, JOB_SOURCERS: Array<UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_SOURCERS_Employee>, JOB_HIRING_MANAGERS: Array<UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee_JOB_HIRING_MANAGERS_Employee> };

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_COORDINATOR_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_RECRUITER_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_SOURCER_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATES_PREVIOUS_INTERVIEWERS_Employee = (
  { __typename?: 'Employee' }
  & UseGetDynamicAudienceData_DynamicEmployeeFragment
);

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee = { __typename?: 'DynamicEmployee', CANDIDATE_COORDINATOR?: UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_COORDINATOR_Employee | null, CANDIDATE_RECRUITER?: UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_RECRUITER_Employee | null, CANDIDATE_SOURCER?: UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATE_SOURCER_Employee | null, CANDIDATES_PREVIOUS_INTERVIEWERS: Array<UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee_CANDIDATES_PREVIOUS_INTERVIEWERS_Employee> };

export type UseGetDynamicAudienceDataDynamicEmployeeQuery_Query = { __typename?: 'Query', task?: UseGetDynamicAudienceDataDynamicEmployeeQuery_task_DynamicEmployee | null, job?: UseGetDynamicAudienceDataDynamicEmployeeQuery_job_DynamicEmployee | null, candidate?: UseGetDynamicAudienceDataDynamicEmployeeQuery_candidate_DynamicEmployee | null };


export type UseGetDynamicAudienceDataDynamicEmployeeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  taskId: Scalars['uuid']['input'];
  jobId: Scalars['uuid']['input'];
  applicationId: Scalars['uuid']['input'];
  skipTask: Scalars['Boolean']['input'];
  skipJob: Scalars['Boolean']['input'];
  skipCandidate: Scalars['Boolean']['input'];
}>;


export type UseGetDynamicAudienceDataDynamicEmployeeQuery = UseGetDynamicAudienceDataDynamicEmployeeQuery_Query;

export type UseJobSmartOptions_JobCoordinatorDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseJobSmartOptions_JobRecruiterDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseJobSmartOptions_JobSourcerDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseJobSmartOptions_JobHiringManagersDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptionsEmployeeByIdsQuery_taskAssigneeData_Employee = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptionsEmployeeByIdsQuery_taskSubscriberData_Employee = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptionsEmployeeByIdsQuery_taskDebriefData_Employee = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptionsEmployeeByIdsQuery_taskCreatorData_Employee = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptionsEmployeeByIdsQuery_Query = { __typename?: 'Query', taskAssigneeData?: Array<UseTaskSmartOptionsEmployeeByIdsQuery_taskAssigneeData_Employee> | null, taskSubscriberData?: Array<UseTaskSmartOptionsEmployeeByIdsQuery_taskSubscriberData_Employee> | null, taskDebriefData?: Array<UseTaskSmartOptionsEmployeeByIdsQuery_taskDebriefData_Employee> | null, taskCreatorData?: Array<UseTaskSmartOptionsEmployeeByIdsQuery_taskCreatorData_Employee> | null };


export type UseTaskSmartOptionsEmployeeByIdsQueryVariables = Exact<{
  taskAssigneeEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  taskCreatorEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  taskSubscriberEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  taskDebriefEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UseTaskSmartOptionsEmployeeByIdsQuery = UseTaskSmartOptionsEmployeeByIdsQuery_Query;

export type UseTaskSmartOptionsByEmployeeIdsQuery_employeeByIds_Employee = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptionsByEmployeeIdsQuery_Query = { __typename?: 'Query', employeeByIds?: Array<UseTaskSmartOptionsByEmployeeIdsQuery_employeeByIds_Employee> | null };


export type UseTaskSmartOptionsByEmployeeIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UseTaskSmartOptionsByEmployeeIdsQuery = UseTaskSmartOptionsByEmployeeIdsQuery_Query;

export type UseTaskSmartOptions_TaskAssigneeDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptions_TaskCreatorDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptions_TaskDebriefDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptions_TaskSubscriberDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type UseTaskSmartOptions_TaskInterviewersDataFragment = (
  { __typename?: 'Employee' }
  & OptionRenderer_EmployeesFragment
);

export type ZoomUserFragmentFragment = { __typename?: 'ZoomUser', orgId: string, zoomUserId: string, status?: ZoomUserStatus | null, email: string, employeeId?: string | null, firstName?: string | null, lastName?: string | null };

export type ZoomUsersListQuery_zoomUsers_ZoomUsersResult_items_ZoomUser = (
  { __typename?: 'ZoomUser' }
  & ZoomUserFragmentFragment
);

export type ZoomUsersListQuery_zoomUsers_ZoomUsersResult = { __typename?: 'ZoomUsersResult', nextCursor?: string | null, items: Array<ZoomUsersListQuery_zoomUsers_ZoomUsersResult_items_ZoomUser> };

export type ZoomUsersListQuery_Query = { __typename?: 'Query', zoomUsers?: ZoomUsersListQuery_zoomUsers_ZoomUsersResult | null };


export type ZoomUsersListQueryVariables = Exact<{
  input: ZoomUsersInput;
}>;


export type ZoomUsersListQuery = ZoomUsersListQuery_Query;

export type ZoomUsersByIdsQuery_zoomUsersByIds_ZoomUser = (
  { __typename?: 'ZoomUser' }
  & ZoomUserFragmentFragment
);

export type ZoomUsersByIdsQuery_Query = { __typename?: 'Query', zoomUsersByIds?: Array<ZoomUsersByIdsQuery_zoomUsersByIds_ZoomUser> | null };


export type ZoomUsersByIdsQueryVariables = Exact<{
  input: ZoomUsersByIdsInput;
}>;


export type ZoomUsersByIdsQuery = ZoomUsersByIdsQuery_Query;

export type ZoomUserByIdsQuery_zoomUsersByIds_ZoomUser = (
  { __typename?: 'ZoomUser' }
  & ZoomUserFragmentFragment
);

export type ZoomUserByIdsQuery_Query = { __typename?: 'Query', zoomUsersByIds?: Array<ZoomUserByIdsQuery_zoomUsersByIds_ZoomUser> | null };


export type ZoomUserByIdsQueryVariables = Exact<{
  input: ZoomUsersByIdsInput;
}>;


export type ZoomUserByIdsQuery = ZoomUserByIdsQuery_Query;

export type SubscribersSelect_ThisEmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type CurrentEmployeeDetailsQuery_thisEmployee_Employee = (
  { __typename?: 'Employee', id: any }
  & SubscribersSelect_ThisEmployeeFragment
);

export type CurrentEmployeeDetailsQuery_Query = { __typename?: 'Query', thisEmployee?: CurrentEmployeeDetailsQuery_thisEmployee_Employee | null };


export type CurrentEmployeeDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentEmployeeDetailsQuery = CurrentEmployeeDetailsQuery_Query;

export type SubscribersSelect_EmployeeFragment = (
  { __typename?: 'Employee', id: any }
  & EmployeeFacePile_EmployeeFragment
);

export type SubscribersListQuery_subscribers_SubscribersResult_items_Employee = (
  { __typename?: 'Employee', id: any }
  & SubscribersSelect_EmployeeFragment
);

export type SubscribersListQuery_subscribers_SubscribersResult = { __typename?: 'SubscribersResult', items: Array<SubscribersListQuery_subscribers_SubscribersResult_items_Employee> };

export type SubscribersListQuery_Query = { __typename?: 'Query', subscribers?: SubscribersListQuery_subscribers_SubscribersResult | null };


export type SubscribersListQueryVariables = Exact<{
  input: SubscribersInput;
}>;


export type SubscribersListQuery = SubscribersListQuery_Query;

export type SubscriberAddMutation_subscriberAdd_SubscriberAddResult_subscribers_Employee = (
  { __typename?: 'Employee', id: any }
  & SubscribersSelect_EmployeeFragment
);

export type SubscriberAddMutation_subscriberAdd_SubscriberAddResult = { __typename?: 'SubscriberAddResult', result?: Result | null, subscribers: Array<SubscriberAddMutation_subscriberAdd_SubscriberAddResult_subscribers_Employee> };

export type SubscriberAddMutation_Mutation = { __typename?: 'Mutation', subscriberAdd?: SubscriberAddMutation_subscriberAdd_SubscriberAddResult | null };


export type SubscriberAddMutationVariables = Exact<{
  input: SubscriberAddInput;
}>;


export type SubscriberAddMutation = SubscriberAddMutation_Mutation;

export type SubscriberRemoveMutation_subscriberRemove_SubscriberRemoveResult_subscribers_Employee = (
  { __typename?: 'Employee', id: any }
  & SubscribersSelect_EmployeeFragment
);

export type SubscriberRemoveMutation_subscriberRemove_SubscriberRemoveResult = { __typename?: 'SubscriberRemoveResult', result?: Result | null, subscribers: Array<SubscriberRemoveMutation_subscriberRemove_SubscriberRemoveResult_subscribers_Employee> };

export type SubscriberRemoveMutation_Mutation = { __typename?: 'Mutation', subscriberRemove?: SubscriberRemoveMutation_subscriberRemove_SubscriberRemoveResult | null };


export type SubscriberRemoveMutationVariables = Exact<{
  input: SubscriberRemoveInput;
}>;


export type SubscriberRemoveMutation = SubscriberRemoveMutation_Mutation;

export type TemplateSelectRow_TemplateFragment = (
  { __typename?: 'Template', id: any, name?: string | null }
  & TemplateOption_TemplateFragment
);

export type TemplateSelectTemplateByIdQuery_template_Template = (
  { __typename?: 'Template', id: any }
  & TemplateSelectRow_TemplateFragment
);

export type TemplateSelectTemplateByIdQuery_Query = { __typename?: 'Query', template?: TemplateSelectTemplateByIdQuery_template_Template | null };


export type TemplateSelectTemplateByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TemplateSelectTemplateByIdQuery = TemplateSelectTemplateByIdQuery_Query;

export type TemplateSelectTemplatesSearchQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template', id: any }
  & TemplateSelectRow_TemplateFragment
);

export type TemplateSelectTemplatesSearchQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<TemplateSelectTemplatesSearchQuery_templates_TemplatesOutput_items_Template> };

export type TemplateSelectTemplatesSearchQuery_Query = { __typename?: 'Query', templates?: TemplateSelectTemplatesSearchQuery_templates_TemplatesOutput | null };


export type TemplateSelectTemplatesSearchQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type TemplateSelectTemplatesSearchQuery = TemplateSelectTemplatesSearchQuery_Query;

export type AdditionalAttendeesDetails_AdditionalAttendeesFragment_AdditionalAttendees_attendees_AdditionalAttendee_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type AdditionalAttendeesDetails_AdditionalAttendeesFragment_AdditionalAttendees_attendees_AdditionalAttendee = { __typename?: 'AdditionalAttendee', email?: string | null, employeeId?: any | null, isOptional: boolean, employee?: AdditionalAttendeesDetails_AdditionalAttendeesFragment_AdditionalAttendees_attendees_AdditionalAttendee_employee_Employee | null };

export type AdditionalAttendeesDetails_AdditionalAttendeesFragment_AdditionalAttendees_employees_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type AdditionalAttendeesDetails_AdditionalAttendeesFragment = { __typename?: 'AdditionalAttendees', emails: Array<string>, isOptional: boolean, attendees?: Array<AdditionalAttendeesDetails_AdditionalAttendeesFragment_AdditionalAttendees_attendees_AdditionalAttendee> | null, employees: Array<AdditionalAttendeesDetails_AdditionalAttendeesFragment_AdditionalAttendees_employees_Employee> };

export type AvatarFacePile_InterviewersFragment_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type AvatarFacePile_InterviewersFragment = { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any, responseStatus?: ResponseStatus | null, isOptional: boolean, interviewer?: AvatarFacePile_InterviewersFragment_ApplicationStageInterviewInterviewer_interviewer_Employee | null };

export type EmployeeFacePile_EmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type TaskName_TaskFragment = { __typename?: 'Task', id: any, name: string };

export type EmployeePrefDataFragment = { __typename?: 'EmployeePref', id: string, orgId: any, prefName: string, json?: any | null, boolValue?: boolean | null, stringValue?: string | null, intValue?: any | null, stringArray?: Array<string> | null, jsonArray?: Array<any> | null, employeeId: any, timestamp?: any | null };

export type EmployeePrefsQuery_employee_Employee_employeePref_EmployeePref = (
  { __typename?: 'EmployeePref', id: string, orgId: any, employeeId: any, prefName: string, createdAt?: any | null, updatedAt?: any | null }
  & EmployeePrefDataFragment
);

export type EmployeePrefsQuery_employee_Employee = { __typename?: 'Employee', id: any, employeePref?: EmployeePrefsQuery_employee_Employee_employeePref_EmployeePref | null };

export type EmployeePrefsQuery_Query = { __typename?: 'Query', employee?: EmployeePrefsQuery_employee_Employee | null };


export type EmployeePrefsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  prefName: Scalars['String']['input'];
}>;


export type EmployeePrefsQuery = EmployeePrefsQuery_Query;

export type UpdateEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, orgId: any, employeeId: any, prefName: string, timestamp?: any | null };

export type UpdateEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: UpdateEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type UpdateEmployeePrefMutation_Mutation = { __typename?: 'Mutation', employeePrefUpdate?: UpdateEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult | null };


export type UpdateEmployeePrefMutationVariables = Exact<{
  input: EmployeePrefUpdateInput;
}>;


export type UpdateEmployeePrefMutation = UpdateEmployeePrefMutation_Mutation;

export type EmployeeLocaleQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, locale?: Locale | null };

export type EmployeeLocaleQuery_Query = { __typename?: 'Query', thisEmployee?: EmployeeLocaleQuery_thisEmployee_Employee | null };


export type EmployeeLocaleQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeLocaleQuery = EmployeeLocaleQuery_Query;

export type EmployeeLocaleUpdateMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee = { __typename?: 'Employee', id: any, locale?: Locale | null };

export type EmployeeLocaleUpdateMutation_employeeUpdate_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: EmployeeLocaleUpdateMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee | null };

export type EmployeeLocaleUpdateMutation_Mutation = { __typename?: 'Mutation', employeeUpdate?: EmployeeLocaleUpdateMutation_employeeUpdate_EmployeeUpdateResult | null };


export type EmployeeLocaleUpdateMutationVariables = Exact<{
  input: EmployeeUpdateInput;
}>;


export type EmployeeLocaleUpdateMutation = EmployeeLocaleUpdateMutation_Mutation;

export type CandidateAtsLatestAvailabilityFragmentFragment_Candidate_atsLatestAvailability_CandidateAtsAvailability_intervals_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAtsLatestAvailabilityFragmentFragment_Candidate_atsLatestAvailability_CandidateAtsAvailability = { __typename?: 'CandidateAtsAvailability', jobName?: string | null, jobStageName?: string | null, timezone?: any | null, originalText?: string | null, intervals?: Array<CandidateAtsLatestAvailabilityFragmentFragment_Candidate_atsLatestAvailability_CandidateAtsAvailability_intervals_DateTimeRangeOutput> | null };

export type CandidateAtsLatestAvailabilityFragmentFragment = { __typename?: 'Candidate', atsLatestAvailability?: CandidateAtsLatestAvailabilityFragmentFragment_Candidate_atsLatestAvailability_CandidateAtsAvailability | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability = { __typename?: 'CandidateAvailability', id: any, createdAt: any, candidateEnteredAvailability?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task = { __typename?: 'Task', id: any, availabilities: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability> };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_conversation_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_ccRecipients_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_bccRecipients_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_additionalAttendeesV2_AdditionalAttendees_attendees_AdditionalAttendee = { __typename?: 'AdditionalAttendee', email?: string | null, employeeId?: any | null, isOptional: boolean, sourceAudience?: DynamicAudience | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_additionalAttendeesV2_AdditionalAttendees_employees_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_additionalAttendeesV2_AdditionalAttendees = { __typename?: 'AdditionalAttendees', employeeIds: Array<any>, emails: Array<string>, isOptional: boolean, attendees?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_additionalAttendeesV2_AdditionalAttendees_attendees_AdditionalAttendee> | null, employees: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_additionalAttendeesV2_AdditionalAttendees_employees_Employee> };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent = { __typename: 'ApplicationStageCandidateEvent', id: any, name?: string | null, googleEventId?: string | null, googleCalendarId?: string | null, calendarEventTemplateId?: string | null, additionalAttendeesV2: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_additionalAttendeesV2_AdditionalAttendees };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees_attendees_AdditionalAttendee = { __typename?: 'AdditionalAttendee', email?: string | null, employeeId?: any | null, isOptional: boolean, sourceAudience?: DynamicAudience | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees_employees_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees = { __typename?: 'AdditionalAttendees', employeeIds: Array<any>, emails: Array<string>, isOptional: boolean, attendees?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees_attendees_AdditionalAttendee> | null, employees: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees_employees_Employee> };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename: 'ApplicationStageInterview', id: any, isCancelled?: boolean | null, additionalAttendeesV2: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_additionalAttendeesV2_AdditionalAttendees };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job_hiringManagers_Employee = { __typename?: 'Employee', id: any };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, atsId: string, name: string, hiringManagers?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job_hiringManagers_Employee> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId_template_Template = { __typename?: 'Template', id: any, name?: string | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, template?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId_template_Template | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateCalendarId_SettingCalendarId_remoteCalendar_Calendar = { __typename?: 'Calendar', name?: string | null, id?: string | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null, remoteCalendar?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateCalendarId_SettingCalendarId_remoteCalendar_Calendar | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId_template_Template = { __typename?: 'Template', id: any, name?: string | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, template?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId_template_Template | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, ccRecipientsV2?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference | null, bccRecipientsV2?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference | null, candidateEventAdditionalAttendees?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference | null, interviewerEventAdditionalAttendees?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference | null, debriefEventAdditionalAttendees?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference | null, candidateEventAdditionalAttendeesOptional?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendeesOptional_SettingBoolValue | null, interviewerEventAdditionalAttendeesOptional?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendeesOptional_SettingBoolValue | null, debriefEventAdditionalAttendeesOptional?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue | null, candidateEventAdditionalAttendeesV2?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, interviewerEventAdditionalAttendeesV2?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, debriefEventAdditionalAttendeesV2?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, candidateEmailTemplateId?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId | null, candidateCalendarId?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateCalendarId_SettingCalendarId | null, candidateEventTemplateId?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId | null, chatConversationMembers?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, atsId?: string | null, jobId: any, name: string, createdAt: any, updatedAt: any, schedulable: boolean, job?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job | null, jobStageSettingsV2?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsUrl: string, atsId: string };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any, fullName?: string | null, email?: string | null, additionalEmails?: Array<string> | null, timezone?: string | null, atsCandidate?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsCandidate_AtsCandidate | null }
  & CandidateAtsLatestAvailabilityFragmentFragment
);

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_coordinator_Employee = { __typename?: 'Employee', id: any };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_recruiter_Employee = { __typename?: 'Employee', id: any };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_existingConversations_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string, isArchived: boolean };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null, coordinator?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_coordinator_Employee | null, recruiter?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_recruiter_Employee | null, existingConversations?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application_existingConversations_Conversation> | null };

export type ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, emailTemplateId?: string | null, applicationId?: any | null, isPrivateCalendarEvent: boolean, task?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_task_Task | null, conversation?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_conversation_Conversation | null, ccRecipients?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_ccRecipients_NotificationPreference | null, bccRecipients?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_bccRecipients_NotificationPreference | null, applicationStageCandidateEvents?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent> | null, applicationStageInterviews?: Array<ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null, jobStage?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_jobStage_JobStage | null, application?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage_application_Application | null };

export type ApplicationStageInterviewPlanQuery_Query = { __typename?: 'Query', applicationStage?: ApplicationStageInterviewPlanQuery_applicationStage_ApplicationStage | null };


export type ApplicationStageInterviewPlanQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApplicationStageInterviewPlanQuery = ApplicationStageInterviewPlanQuery_Query;

export type OrgPrefsDataFragment_OrgPref_duration_Duration = { __typename?: 'Duration', seconds: any, nanos: any };

export type OrgPrefsDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref_headers_AiOrgLlmHeaderEntry = { __typename?: 'AiOrgLlmHeaderEntry', name: string, value?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref_departments_AtsIdSelection = { __typename?: 'AtsIdSelection', ids: Array<string> };

export type OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref_offices_AtsIdSelection = { __typename?: 'AtsIdSelection', ids: Array<string> };

export type OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref_jobs_AtsIdSelection = { __typename?: 'AtsIdSelection', ids: Array<string> };

export type OrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref_after_Duration = { __typename?: 'Duration', seconds: any };

export type OrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref_before_Duration = { __typename?: 'Duration', seconds: any };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_sunday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_monday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_tuesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_wednesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_thursday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_friday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_saturday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref', completionUrl: string, model: string, apiKey?: string | null, wireFormat: string, responseJsonPath?: string | null, headers: Array<OrgPrefsDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref_headers_AiOrgLlmHeaderEntry> };

export type OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref', departments?: OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref_departments_AtsIdSelection | null, offices?: OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref_offices_AtsIdSelection | null, jobs?: OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref_jobs_AtsIdSelection | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo', showCoordinator: boolean, showRecruiter: boolean, canShowJobTitle: boolean, canShowLinkedin: boolean, canShowPhone: boolean, canShowProfilePicture: boolean, canShowPronouns: boolean, canShowBio: boolean };

export type OrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo', canShowInfo: boolean, canShowFullName: boolean, canShowJobTitle: boolean, canShowLinkedin: boolean, canShowEmail: boolean, canShowProfilePicture: boolean, canShowPronouns: boolean, canShowBio: boolean };

export type OrgPrefsDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref', name?: SyncSourceType | null, title?: SyncSourceType | null, manager?: SyncSourceType | null, linkedInUrl?: SyncSourceType | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref', after?: OrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref_after_Duration | null, before?: OrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref_before_Duration | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, dynamicHost?: DynamicInterviewMeetingHost | null, hostEmployeeId?: string | null, remoteVideoMeetingHostUserId?: string | null, customLocation?: string | null, videoMeetingLinkScope: VideoMeetingLinkScope };

export type OrgPrefsDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref', interviews?: number | null, minutes?: number | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref_NotificationPreference = { __typename?: 'NotificationPreference' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek', sunday?: Array<OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_sunday_TimeBlock> | null, monday?: Array<OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_monday_TimeBlock> | null, tuesday?: Array<OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_tuesday_TimeBlock> | null, wednesday?: Array<OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_wednesday_TimeBlock> | null, thursday?: Array<OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_thursday_TimeBlock> | null, friday?: Array<OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_friday_TimeBlock> | null, saturday?: Array<OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek_saturday_TimeBlock> | null };

export type OrgPrefsDataFragment_OrgPref_jsonPref = OrgPrefsDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | OrgPrefsDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref | OrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref | OrgPrefsDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref | OrgPrefsDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | OrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | OrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo | OrgPrefsDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref | OrgPrefsDataFragment_OrgPref_jsonPref_DateBlock | OrgPrefsDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref | OrgPrefsDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | OrgPrefsDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | OrgPrefsDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | OrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref | OrgPrefsDataFragment_OrgPref_jsonPref_InterviewLimit | OrgPrefsDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | OrgPrefsDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | OrgPrefsDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | OrgPrefsDataFragment_OrgPref_jsonPref_NotificationPreference | OrgPrefsDataFragment_OrgPref_jsonPref_PaidFeaturePreference | OrgPrefsDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref | OrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek;

export type OrgPrefsDataFragment = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, json?: any | null, boolValue?: boolean | null, stringValue?: string | null, intValue?: any | null, stringArray?: Array<string> | null, jsonArray?: Array<any> | null, isLocked: boolean, timestamp?: any | null, duration?: OrgPrefsDataFragment_OrgPref_duration_Duration | null, jsonPref?: OrgPrefsDataFragment_OrgPref_jsonPref | null };

export type OrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref = (
  { __typename?: 'OrgPref' }
  & OrgPrefsDataFragment
);

export type OrgPrefsQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPrefs?: Array<OrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type OrgPrefsQuery_Query = { __typename?: 'Query', thisOrg?: OrgPrefsQuery_thisOrg_Org | null };


export type OrgPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgPrefsQuery = OrgPrefsQuery_Query;

export type UpdateOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref = (
  { __typename?: 'OrgPref' }
  & OrgPrefsDataFragment
);

export type UpdateOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult = { __typename?: 'OrgPrefUpdateResult', orgPref?: UpdateOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref | null };

export type UpdateOrgPrefsMutation_Mutation = { __typename?: 'Mutation', orgPrefUpdate?: UpdateOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult | null };


export type UpdateOrgPrefsMutationVariables = Exact<{
  input: OrgPrefUpdateInput;
}>;


export type UpdateOrgPrefsMutation = UpdateOrgPrefsMutation_Mutation;

export type SupportedLocalesQuery_thisOrg_Org = { __typename?: 'Org', id: any, supportedLocales: Array<Locale> };

export type SupportedLocalesQuery_Query = { __typename?: 'Query', thisOrg?: SupportedLocalesQuery_thisOrg_Org | null };


export type SupportedLocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedLocalesQuery = SupportedLocalesQuery_Query;

export type UserPermissionQuery_thisUserInfo_UserInfo = { __typename?: 'UserInfo', permissions: Array<Permission> };

export type UserPermissionQuery_Query = { __typename?: 'Query', thisUserInfo?: UserPermissionQuery_thisUserInfo_UserInfo | null };


export type UserPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPermissionQuery = UserPermissionQuery_Query;

export type ResetSmartRecruitersHiringProcessDialog_JobFragment_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsUrl?: string | null };

export type ResetSmartRecruitersHiringProcessDialog_JobFragment_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus = { __typename?: 'HiringProcessWithStatus', atsId?: string | null, name?: string | null };

export type ResetSmartRecruitersHiringProcessDialog_JobFragment_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, hiringProcess?: ResetSmartRecruitersHiringProcessDialog_JobFragment_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus | null };

export type ResetSmartRecruitersHiringProcessDialog_JobFragment = { __typename?: 'Job', id: any, atsJob?: ResetSmartRecruitersHiringProcessDialog_JobFragment_Job_atsJob_AtsJob | null, jobSettings: ResetSmartRecruitersHiringProcessDialog_JobFragment_Job_jobSettings_JobSettings };

export type ResetHiringProcessListAtsConfigQuery_hiringProcesses_HiringProcess = { __typename?: 'HiringProcess', atsId: string, name: string };

export type ResetHiringProcessListAtsConfigQuery_Query = { __typename?: 'Query', hiringProcesses?: Array<ResetHiringProcessListAtsConfigQuery_hiringProcesses_HiringProcess> | null };


export type ResetHiringProcessListAtsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ResetHiringProcessListAtsConfigQuery = ResetHiringProcessListAtsConfigQuery_Query;

export type HiringProcessSelectDialog_JobFragment_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsUrl?: string | null };

export type HiringProcessSelectDialog_JobFragment_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus = { __typename?: 'HiringProcessWithStatus', atsId?: string | null, name?: string | null };

export type HiringProcessSelectDialog_JobFragment_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, hiringProcess?: HiringProcessSelectDialog_JobFragment_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus | null };

export type HiringProcessSelectDialog_JobFragment = { __typename?: 'Job', id: any, atsJob?: HiringProcessSelectDialog_JobFragment_Job_atsJob_AtsJob | null, jobSettings: HiringProcessSelectDialog_JobFragment_Job_jobSettings_JobSettings };

export type HiringProcessListAtsConfigQuery_hiringProcesses_HiringProcess = { __typename?: 'HiringProcess', atsId: string, name: string };

export type HiringProcessListAtsConfigQuery_Query = { __typename?: 'Query', hiringProcesses?: Array<HiringProcessListAtsConfigQuery_hiringProcesses_HiringProcess> | null };


export type HiringProcessListAtsConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type HiringProcessListAtsConfigQuery = HiringProcessListAtsConfigQuery_Query;

export type UpdateHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus = { __typename?: 'HiringProcessWithStatus', atsId?: string | null, name?: string | null };

export type UpdateHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, hiringProcess?: UpdateHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus | null };

export type UpdateHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult = { __typename?: 'JobSettingsUpsertResult', jobSettings: UpdateHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings };

export type UpdateHiringProcessMutation_Mutation = { __typename?: 'Mutation', jobSettingsUpsert?: UpdateHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult | null };


export type UpdateHiringProcessMutationVariables = Exact<{
  input: JobSettingsUpsertInput;
}>;


export type UpdateHiringProcessMutation = UpdateHiringProcessMutation_Mutation;

export type SmartRecruitersHiringProcessByJobIdQuery_job_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus = { __typename?: 'HiringProcessWithStatus', atsId?: string | null, status: HiringProcessStatus };

export type SmartRecruitersHiringProcessByJobIdQuery_job_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, hiringProcess?: SmartRecruitersHiringProcessByJobIdQuery_job_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus | null };

export type SmartRecruitersHiringProcessByJobIdQuery_job_Job = (
  { __typename?: 'Job', id: any, name: string, jobSettings: SmartRecruitersHiringProcessByJobIdQuery_job_Job_jobSettings_JobSettings }
  & HiringProcessSelectDialog_JobFragment
  & JobNameAndLocationHeader_JobFragment
);

export type SmartRecruitersHiringProcessByJobIdQuery_Query = { __typename?: 'Query', job?: SmartRecruitersHiringProcessByJobIdQuery_job_Job | null };


export type SmartRecruitersHiringProcessByJobIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SmartRecruitersHiringProcessByJobIdQuery = SmartRecruitersHiringProcessByJobIdQuery_Query;

export type CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration = { __typename?: 'CoderpadIntegration', apiKey: string };

export type CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration = { __typename?: 'CodilityIntegration', apiKey: string };

export type CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration = { __typename?: 'CodesignalIntegration', apiKey: string };

export type CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration = { __typename?: 'HackerRankIntegration', apiKey: string };

export type CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, coderpad?: CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration | null, codility?: CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration | null, codesignal?: CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration | null, hackerrank?: CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration | null };

export type CollaborationServiceIntegrationsQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: CollaborationServiceIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type CollaborationServiceIntegrationsQuery_Query = { __typename?: 'Query', thisOrg?: CollaborationServiceIntegrationsQuery_thisOrg_Org | null };


export type CollaborationServiceIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CollaborationServiceIntegrationsQuery = CollaborationServiceIntegrationsQuery_Query;

export type DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_google_GoogleIntegration = { __typename?: 'GoogleIntegration', adminUserId: string };

export type DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_microsoft_MicrosoftIntegration = { __typename?: 'MicrosoftIntegration', active: boolean };

export type DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftCustom_MicrosoftIntegration = { __typename?: 'MicrosoftIntegration', active: boolean, scopes?: Array<string> | null };

export type DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftGccHigh_MicrosoftGccHighIntegration = { __typename?: 'MicrosoftGccHighIntegration', active: boolean };

export type DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, google?: DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_google_GoogleIntegration | null, microsoft?: DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_microsoft_MicrosoftIntegration | null, microsoftCustom?: DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftCustom_MicrosoftIntegration | null, microsoftGccHigh?: DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftGccHigh_MicrosoftGccHighIntegration | null };

export type DirectoryServiceQuery_thisOrg_Org = { __typename?: 'Org', id: any, multiDomainEnabled: boolean, integrations?: DirectoryServiceQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type DirectoryServiceQuery_Query = { __typename?: 'Query', thisOrg?: DirectoryServiceQuery_thisOrg_Org | null };


export type DirectoryServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type DirectoryServiceQuery = DirectoryServiceQuery_Query;

export type GoogleIntegrationHealthCheckQuery_integrationCheckHealth_IntegrationCheckHealthResult_google_GoogleIntegrationHealth = { __typename?: 'GoogleIntegrationHealth', canSendGmail: boolean };

export type GoogleIntegrationHealthCheckQuery_integrationCheckHealth_IntegrationCheckHealthResult = { __typename?: 'IntegrationCheckHealthResult', id: any, google?: GoogleIntegrationHealthCheckQuery_integrationCheckHealth_IntegrationCheckHealthResult_google_GoogleIntegrationHealth | null };

export type GoogleIntegrationHealthCheckQuery_thisOrg_Org_integrations_OrgIntegrations_google_GoogleIntegration = { __typename?: 'GoogleIntegration', adminUserId: string };

export type GoogleIntegrationHealthCheckQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, google?: GoogleIntegrationHealthCheckQuery_thisOrg_Org_integrations_OrgIntegrations_google_GoogleIntegration | null };

export type GoogleIntegrationHealthCheckQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: GoogleIntegrationHealthCheckQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type GoogleIntegrationHealthCheckQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_google_GoogleEmployeeIntegration = { __typename?: 'GoogleEmployeeIntegration', active: boolean };

export type GoogleIntegrationHealthCheckQuery_thisEmployee_Employee_integrations_EmployeeIntegrations = { __typename?: 'EmployeeIntegrations', id: any, google?: GoogleIntegrationHealthCheckQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_google_GoogleEmployeeIntegration | null };

export type GoogleIntegrationHealthCheckQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, integrations?: GoogleIntegrationHealthCheckQuery_thisEmployee_Employee_integrations_EmployeeIntegrations | null };

export type GoogleIntegrationHealthCheckQuery_Query = { __typename?: 'Query', integrationCheckHealth?: GoogleIntegrationHealthCheckQuery_integrationCheckHealth_IntegrationCheckHealthResult | null, thisOrg?: GoogleIntegrationHealthCheckQuery_thisOrg_Org | null, thisEmployee?: GoogleIntegrationHealthCheckQuery_thisEmployee_Employee | null };


export type GoogleIntegrationHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleIntegrationHealthCheckQuery = GoogleIntegrationHealthCheckQuery_Query;

export type MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoft_MicrosoftIntegration = { __typename?: 'MicrosoftIntegration', active: boolean };

export type MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftGccHigh_MicrosoftGccHighIntegration = { __typename?: 'MicrosoftGccHighIntegration', active: boolean };

export type MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftCustom_MicrosoftIntegration = { __typename?: 'MicrosoftIntegration', active: boolean };

export type MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftServiceUser_MicrosoftServiceUserIntegration = { __typename?: 'MicrosoftServiceUserIntegration', serviceAccountEmail: string };

export type MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, microsoft?: MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoft_MicrosoftIntegration | null, microsoftGccHigh?: MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftGccHigh_MicrosoftGccHighIntegration | null, microsoftCustom?: MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftCustom_MicrosoftIntegration | null, microsoftServiceUser?: MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftServiceUser_MicrosoftServiceUserIntegration | null };

export type MicrosoftIntegrationQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: MicrosoftIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoft_MicrosoftEmployeeIntegration = { __typename?: 'MicrosoftEmployeeIntegration', active: boolean };

export type MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoftGccHighEmployee_MicrosoftGccHighEmployeeIntegration = { __typename?: 'MicrosoftGccHighEmployeeIntegration', active: boolean };

export type MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoftCustomEmployee_MicrosoftEmployeeIntegration = { __typename?: 'MicrosoftEmployeeIntegration', active: boolean };

export type MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoftServiceUser_MicrosoftEmployeeIntegration = { __typename?: 'MicrosoftEmployeeIntegration', active: boolean };

export type MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations = { __typename?: 'EmployeeIntegrations', id: any, microsoft?: MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoft_MicrosoftEmployeeIntegration | null, microsoftGccHighEmployee?: MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoftGccHighEmployee_MicrosoftGccHighEmployeeIntegration | null, microsoftCustomEmployee?: MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoftCustomEmployee_MicrosoftEmployeeIntegration | null, microsoftServiceUser?: MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations_microsoftServiceUser_MicrosoftEmployeeIntegration | null };

export type MicrosoftIntegrationQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, integrations?: MicrosoftIntegrationQuery_thisEmployee_Employee_integrations_EmployeeIntegrations | null };

export type MicrosoftIntegrationQuery_Query = { __typename?: 'Query', thisOrg?: MicrosoftIntegrationQuery_thisOrg_Org | null, thisEmployee?: MicrosoftIntegrationQuery_thisEmployee_Employee | null };


export type MicrosoftIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type MicrosoftIntegrationQuery = MicrosoftIntegrationQuery_Query;

export type ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability = { __typename?: 'CandidateAvailability', id: any, candidateEnteredAvailability?: Array<ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null };

export type ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task = { __typename?: 'Task', canceledAt?: any | null, id: any, availabilities: Array<ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability> };

export type ImportCandidateAvailabilityApplicationTasksQuery_application_Application = { __typename?: 'Application', tasks: Array<ImportCandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task> };

export type ImportCandidateAvailabilityApplicationTasksQuery_Query = { __typename?: 'Query', application?: ImportCandidateAvailabilityApplicationTasksQuery_application_Application | null };


export type ImportCandidateAvailabilityApplicationTasksQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type ImportCandidateAvailabilityApplicationTasksQuery = ImportCandidateAvailabilityApplicationTasksQuery_Query;

export type DefaultTemplateIdsForTypesQuery_templates_TemplatesOutput_items_Template = { __typename?: 'Template', id: any, type: TemplateType };

export type DefaultTemplateIdsForTypesQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<DefaultTemplateIdsForTypesQuery_templates_TemplatesOutput_items_Template> };

export type DefaultTemplateIdsForTypesQuery_Query = { __typename?: 'Query', templates?: DefaultTemplateIdsForTypesQuery_templates_TemplatesOutput | null };


export type DefaultTemplateIdsForTypesQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type DefaultTemplateIdsForTypesQuery = DefaultTemplateIdsForTypesQuery_Query;

export type UseApplicationJobStageSchedulable_ApplicationFragment_Application_validateCanEnterScheduleFlow_ValidationResult = { __typename?: 'ValidationResult', valid: boolean, message?: string | null };

export type UseApplicationJobStageSchedulable_ApplicationFragment_Application_validateCanMoveStage_ValidationResult = { __typename?: 'ValidationResult', valid: boolean, message?: string | null };

export type UseApplicationJobStageSchedulable_ApplicationFragment = { __typename?: 'Application', id: any, jobStageId?: any | null, validateCanEnterScheduleFlow: UseApplicationJobStageSchedulable_ApplicationFragment_Application_validateCanEnterScheduleFlow_ValidationResult, validateCanMoveStage: UseApplicationJobStageSchedulable_ApplicationFragment_Application_validateCanMoveStage_ValidationResult };

export type CompanyHolidaysFragment_CompanyHoliday_countries_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type CompanyHolidaysFragment = { __typename?: 'CompanyHoliday', id: any, start: any, end: any, countries?: Array<CompanyHolidaysFragment_CompanyHoliday_countries_EmployeeAttributeTagValue> | null };

export type AllCompanyHolidaysQuery_companyHolidays_CompanyHolidayResult_items_CompanyHoliday = (
  { __typename?: 'CompanyHoliday' }
  & CompanyHolidaysFragment
);

export type AllCompanyHolidaysQuery_companyHolidays_CompanyHolidayResult = { __typename?: 'CompanyHolidayResult', items: Array<AllCompanyHolidaysQuery_companyHolidays_CompanyHolidayResult_items_CompanyHoliday> };

export type AllCompanyHolidaysQuery_Query = { __typename?: 'Query', companyHolidays?: AllCompanyHolidaysQuery_companyHolidays_CompanyHolidayResult | null };


export type AllCompanyHolidaysQueryVariables = Exact<{
  input: CompanyHolidaysInput;
}>;


export type AllCompanyHolidaysQuery = AllCompanyHolidaysQuery_Query;

export type DirectoryInfoQuery_thisOrg_Org_directoryIntegrations_OrgDirectoryIntegration = { __typename?: 'OrgDirectoryIntegration', id: any, name: string, type: DirectoryType };

export type DirectoryInfoQuery_thisOrg_Org = { __typename?: 'Org', id: any, directoryType?: DirectoryType | null, directoryIntegrations: Array<DirectoryInfoQuery_thisOrg_Org_directoryIntegrations_OrgDirectoryIntegration> };

export type DirectoryInfoQuery_Query = { __typename?: 'Query', thisOrg?: DirectoryInfoQuery_thisOrg_Org | null };


export type DirectoryInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DirectoryInfoQuery = DirectoryInfoQuery_Query;

export type OrgHasAtLeastOneAdminQuery_thisOrg_Org = { __typename?: 'Org', id: any, hasAdmin: boolean };

export type OrgHasAtLeastOneAdminQuery_Query = { __typename?: 'Query', thisOrg?: OrgHasAtLeastOneAdminQuery_thisOrg_Org | null };


export type OrgHasAtLeastOneAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgHasAtLeastOneAdminQuery = OrgHasAtLeastOneAdminQuery_Query;

export type HasZoomIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_zoom_ZoomIntegration = { __typename?: 'ZoomIntegration', active: boolean };

export type HasZoomIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_zoomCustom_ZoomIntegration = { __typename?: 'ZoomIntegration', active: boolean };

export type HasZoomIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, zoom?: HasZoomIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_zoom_ZoomIntegration | null, zoomCustom?: HasZoomIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_zoomCustom_ZoomIntegration | null };

export type HasZoomIntegrationQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: HasZoomIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type HasZoomIntegrationQuery_Query = { __typename?: 'Query', thisOrg?: HasZoomIntegrationQuery_thisOrg_Org | null };


export type HasZoomIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type HasZoomIntegrationQuery = HasZoomIntegrationQuery_Query;

export type SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar_SyncEmployeeCalendarSuccess = { __typename: 'SyncEmployeeCalendarSuccess', enqueued: boolean };

export type SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar = SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar_SyncEmployeeCalendarSuccess | SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar_SyncRateLimitedError | SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar_UnknownError;

export type SyncEmployeeCalendarManualEntityMutation_Mutation = { __typename?: 'Mutation', syncEmployeeCalendar: SyncEmployeeCalendarManualEntityMutation_syncEmployeeCalendar };


export type SyncEmployeeCalendarManualEntityMutationVariables = Exact<{
  input: SyncEmployeeCalendarInput;
}>;


export type SyncEmployeeCalendarManualEntityMutation = SyncEmployeeCalendarManualEntityMutation_Mutation;

export type SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_SyncEmployeeAtsSuccess = { __typename: 'SyncEmployeeAtsSuccess', enqueued: boolean };

export type SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_SyncNotFoundError = { __typename: 'SyncNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncEmployeeAtsManualEntityMutation_syncEmployeeAts = SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_SyncEmployeeAtsSuccess | SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_SyncNotFoundError | SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_SyncRateLimitedError | SyncEmployeeAtsManualEntityMutation_syncEmployeeAts_UnknownError;

export type SyncEmployeeAtsManualEntityMutation_Mutation = { __typename?: 'Mutation', syncEmployeeAts: SyncEmployeeAtsManualEntityMutation_syncEmployeeAts };


export type SyncEmployeeAtsManualEntityMutationVariables = Exact<{
  input: SyncEmployeeAtsInput;
}>;


export type SyncEmployeeAtsManualEntityMutation = SyncEmployeeAtsManualEntityMutation_Mutation;

export type SyncCandidateManualEntityMutation_syncCandidate_SyncCandidateSuccess = { __typename: 'SyncCandidateSuccess', enqueued: boolean };

export type SyncCandidateManualEntityMutation_syncCandidate_SyncNotFoundError = { __typename: 'SyncNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SyncCandidateManualEntityMutation_syncCandidate_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncCandidateManualEntityMutation_syncCandidate_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncCandidateManualEntityMutation_syncCandidate = SyncCandidateManualEntityMutation_syncCandidate_SyncCandidateSuccess | SyncCandidateManualEntityMutation_syncCandidate_SyncNotFoundError | SyncCandidateManualEntityMutation_syncCandidate_SyncRateLimitedError | SyncCandidateManualEntityMutation_syncCandidate_UnknownError;

export type SyncCandidateManualEntityMutation_Mutation = { __typename?: 'Mutation', syncCandidate: SyncCandidateManualEntityMutation_syncCandidate };


export type SyncCandidateManualEntityMutationVariables = Exact<{
  input: SyncCandidateInput;
}>;


export type SyncCandidateManualEntityMutation = SyncCandidateManualEntityMutation_Mutation;

export type SyncApplicationManualEntityMutation_syncApplication_SyncApplicationSuccess = { __typename: 'SyncApplicationSuccess', enqueued: boolean };

export type SyncApplicationManualEntityMutation_syncApplication_SyncNotFoundError = { __typename: 'SyncNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SyncApplicationManualEntityMutation_syncApplication_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncApplicationManualEntityMutation_syncApplication_SyncUnsupportedError = { __typename: 'SyncUnsupportedError', errorCode: ErrorCode, errorMessage: string };

export type SyncApplicationManualEntityMutation_syncApplication_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncApplicationManualEntityMutation_syncApplication = SyncApplicationManualEntityMutation_syncApplication_SyncApplicationSuccess | SyncApplicationManualEntityMutation_syncApplication_SyncNotFoundError | SyncApplicationManualEntityMutation_syncApplication_SyncRateLimitedError | SyncApplicationManualEntityMutation_syncApplication_SyncUnsupportedError | SyncApplicationManualEntityMutation_syncApplication_UnknownError;

export type SyncApplicationManualEntityMutation_Mutation = { __typename?: 'Mutation', syncApplication: SyncApplicationManualEntityMutation_syncApplication };


export type SyncApplicationManualEntityMutationVariables = Exact<{
  input: SyncApplicationInput;
}>;


export type SyncApplicationManualEntityMutation = SyncApplicationManualEntityMutation_Mutation;

export type SyncJobManualEntityMutation_syncJob_SyncJobSuccess = { __typename: 'SyncJobSuccess', enqueued: boolean };

export type SyncJobManualEntityMutation_syncJob_SyncNotFoundError = { __typename: 'SyncNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SyncJobManualEntityMutation_syncJob_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncJobManualEntityMutation_syncJob_SyncUnsupportedError = { __typename: 'SyncUnsupportedError', errorCode: ErrorCode, errorMessage: string };

export type SyncJobManualEntityMutation_syncJob_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncJobManualEntityMutation_syncJob = SyncJobManualEntityMutation_syncJob_SyncJobSuccess | SyncJobManualEntityMutation_syncJob_SyncNotFoundError | SyncJobManualEntityMutation_syncJob_SyncRateLimitedError | SyncJobManualEntityMutation_syncJob_SyncUnsupportedError | SyncJobManualEntityMutation_syncJob_UnknownError;

export type SyncJobManualEntityMutation_Mutation = { __typename?: 'Mutation', syncJob: SyncJobManualEntityMutation_syncJob };


export type SyncJobManualEntityMutationVariables = Exact<{
  input: SyncJobInput;
}>;


export type SyncJobManualEntityMutation = SyncJobManualEntityMutation_Mutation;

export type SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncNotFoundError = { __typename: 'SyncNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncUnsupportedError = { __typename: 'SyncUnsupportedError', errorCode: ErrorCode, errorMessage: string };

export type SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncUserJobPermissionsForJobSuccess = { __typename: 'SyncUserJobPermissionsForJobSuccess', enqueued: boolean };

export type SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob = SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncNotFoundError | SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncRateLimitedError | SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncUnsupportedError | SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_SyncUserJobPermissionsForJobSuccess | SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob_UnknownError;

export type SyncUserJobPermissionsForJobManualEntityMutation_Mutation = { __typename?: 'Mutation', syncUserJobPermissionsForJob: SyncUserJobPermissionsForJobManualEntityMutation_syncUserJobPermissionsForJob };


export type SyncUserJobPermissionsForJobManualEntityMutationVariables = Exact<{
  input: SyncUserJobPermissionsForJobInput;
}>;


export type SyncUserJobPermissionsForJobManualEntityMutation = SyncUserJobPermissionsForJobManualEntityMutation_Mutation;

export type SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncNotFoundError = { __typename: 'SyncNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncUnsupportedError = { __typename: 'SyncUnsupportedError', errorCode: ErrorCode, errorMessage: string };

export type SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncUserJobPermissionsForEmployeeSuccess = { __typename: 'SyncUserJobPermissionsForEmployeeSuccess', enqueued: boolean };

export type SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee = SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncNotFoundError | SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncRateLimitedError | SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncUnsupportedError | SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_SyncUserJobPermissionsForEmployeeSuccess | SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee_UnknownError;

export type SyncUserJobPermissionsForEmployeeManualEntityMutation_Mutation = { __typename?: 'Mutation', syncUserJobPermissionsForEmployee: SyncUserJobPermissionsForEmployeeManualEntityMutation_syncUserJobPermissionsForEmployee };


export type SyncUserJobPermissionsForEmployeeManualEntityMutationVariables = Exact<{
  input: SyncUserJobPermissionsForEmployeeInput;
}>;


export type SyncUserJobPermissionsForEmployeeManualEntityMutation = SyncUserJobPermissionsForEmployeeManualEntityMutation_Mutation;

export type SyncJobStageManualEntityMutation_syncJobStage_SyncJobStageSuccess = { __typename: 'SyncJobStageSuccess', enqueued: boolean };

export type SyncJobStageManualEntityMutation_syncJobStage_SyncNotFoundError = { __typename: 'SyncNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SyncJobStageManualEntityMutation_syncJobStage_SyncRateLimitedError = { __typename: 'SyncRateLimitedError', errorCode: ErrorCode, errorMessage: string, retryAfterSeconds?: number | null };

export type SyncJobStageManualEntityMutation_syncJobStage_SyncUnsupportedError = { __typename: 'SyncUnsupportedError', errorCode: ErrorCode, errorMessage: string };

export type SyncJobStageManualEntityMutation_syncJobStage_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SyncJobStageManualEntityMutation_syncJobStage = SyncJobStageManualEntityMutation_syncJobStage_SyncJobStageSuccess | SyncJobStageManualEntityMutation_syncJobStage_SyncNotFoundError | SyncJobStageManualEntityMutation_syncJobStage_SyncRateLimitedError | SyncJobStageManualEntityMutation_syncJobStage_SyncUnsupportedError | SyncJobStageManualEntityMutation_syncJobStage_UnknownError;

export type SyncJobStageManualEntityMutation_Mutation = { __typename?: 'Mutation', syncJobStage: SyncJobStageManualEntityMutation_syncJobStage };


export type SyncJobStageManualEntityMutationVariables = Exact<{
  input: SyncJobStageInput;
}>;


export type SyncJobStageManualEntityMutation = SyncJobStageManualEntityMutation_Mutation;

export type OrgNameQuery_thisOrg_Org = { __typename?: 'Org', id: any, name: string };

export type OrgNameQuery_Query = { __typename?: 'Query', thisOrg?: OrgNameQuery_thisOrg_Org | null };


export type OrgNameQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgNameQuery = OrgNameQuery_Query;

export type GetOrgRequiredSetupStatusQuery_thisOrg_Org = { __typename?: 'Org', id: any, atsStatus: IntegrationConnectionStatus, directoryStatus: IntegrationConnectionStatus };

export type GetOrgRequiredSetupStatusQuery_Query = { __typename?: 'Query', thisOrg?: GetOrgRequiredSetupStatusQuery_thisOrg_Org | null };


export type GetOrgRequiredSetupStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgRequiredSetupStatusQuery = GetOrgRequiredSetupStatusQuery_Query;

export type OrgSlugQuery_thisOrg_Org_slugs_PortalOrgSlug = { __typename?: 'PortalOrgSlug', slug: string, id: any };

export type OrgSlugQuery_thisOrg_Org = { __typename?: 'Org', id: any, slugs: Array<OrgSlugQuery_thisOrg_Org_slugs_PortalOrgSlug> };

export type OrgSlugQuery_Query = { __typename?: 'Query', thisOrg?: OrgSlugQuery_thisOrg_Org | null };


export type OrgSlugQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgSlugQuery = OrgSlugQuery_Query;

export type MyPrimaryCalendarQuery_myPrimaryCalendar_Calendar = { __typename?: 'Calendar', id?: string | null, remoteId?: string | null };

export type MyPrimaryCalendarQuery_Query = { __typename?: 'Query', myPrimaryCalendar?: MyPrimaryCalendarQuery_myPrimaryCalendar_Calendar | null };


export type MyPrimaryCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPrimaryCalendarQuery = MyPrimaryCalendarQuery_Query;

export type OrgHasSamlSsoQuery_thisOrg_Org = { __typename?: 'Org', id: any, hasSamlSso: boolean };

export type OrgHasSamlSsoQuery_Query = { __typename?: 'Query', thisOrg?: OrgHasSamlSsoQuery_thisOrg_Org | null };


export type OrgHasSamlSsoQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgHasSamlSsoQuery = OrgHasSamlSsoQuery_Query;

export type OrgHasScimQuery_thisOrg_Org = { __typename?: 'Org', id: any, hasScim: boolean };

export type OrgHasScimQuery_Query = { __typename?: 'Query', thisOrg?: OrgHasScimQuery_thisOrg_Org | null };


export type OrgHasScimQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgHasScimQuery = OrgHasScimQuery_Query;

export type SchedulerCalendarTokenAvailabilityQuery_thisOrg_Org = { __typename?: 'Org', id: any, schedulerCalendarTokenAvailable?: boolean | null };

export type SchedulerCalendarTokenAvailabilityQuery_Query = { __typename?: 'Query', thisOrg?: SchedulerCalendarTokenAvailabilityQuery_thisOrg_Org | null };


export type SchedulerCalendarTokenAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type SchedulerCalendarTokenAvailabilityQuery = SchedulerCalendarTokenAvailabilityQuery_Query;

export type ShortUrlCreateMutation_shortUrlCreate_ShortUrlCreateResult = { __typename?: 'ShortUrlCreateResult', shortUrl: string };

export type ShortUrlCreateMutation_Mutation = { __typename?: 'Mutation', shortUrlCreate?: ShortUrlCreateMutation_shortUrlCreate_ShortUrlCreateResult | null };


export type ShortUrlCreateMutationVariables = Exact<{
  input: ShortUrlCreateInput;
}>;


export type ShortUrlCreateMutation = ShortUrlCreateMutation_Mutation;

export type GreenhouseHarvestV3DialogOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration = { __typename?: 'GreenhouseOAuthIntegration', subdomain: string };

export type GreenhouseHarvestV3DialogOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, greenhouseOauth?: GreenhouseHarvestV3DialogOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration | null };

export type GreenhouseHarvestV3DialogOAuthStatusQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: GreenhouseHarvestV3DialogOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type GreenhouseHarvestV3DialogOAuthStatusQuery_Query = { __typename?: 'Query', thisOrg?: GreenhouseHarvestV3DialogOAuthStatusQuery_thisOrg_Org | null };


export type GreenhouseHarvestV3DialogOAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GreenhouseHarvestV3DialogOAuthStatusQuery = GreenhouseHarvestV3DialogOAuthStatusQuery_Query;

export type GreenhouseHarvestV3BannerOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration = { __typename?: 'GreenhouseOAuthIntegration', subdomain: string };

export type GreenhouseHarvestV3BannerOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, greenhouseOauth?: GreenhouseHarvestV3BannerOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration | null };

export type GreenhouseHarvestV3BannerOAuthStatusQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: GreenhouseHarvestV3BannerOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type GreenhouseHarvestV3BannerOAuthStatusQuery_Query = { __typename?: 'Query', thisOrg?: GreenhouseHarvestV3BannerOAuthStatusQuery_thisOrg_Org | null };


export type GreenhouseHarvestV3BannerOAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GreenhouseHarvestV3BannerOAuthStatusQuery = GreenhouseHarvestV3BannerOAuthStatusQuery_Query;

export type AshbyHealthCheckBanner_AshbyFragment = { __typename?: 'AshbyIntegrationHealth', isHealthy: boolean, isInstalled: boolean };

export type GemHealthCheckBanner_GemFragment = { __typename?: 'GemIntegrationHealth', isInstalled: boolean, isHealthy: boolean, canReadUsers: boolean, canReadUser: boolean, canReadJobs: boolean, canReadJob: boolean, canReadJobStages: boolean, canReadJobStageForJob: boolean, canReadJobPostings: boolean, canReadUserRoles: boolean, canReadInterviews: boolean, canReadInterview: boolean, canReadCandidates: boolean, canReadCandidate: boolean, canReadActivityFeed: boolean, canReadApplications: boolean, canReadApplication: boolean };

export type GoogleHealthCheckBanner_GoogleFragment = { __typename?: 'GoogleIntegrationHealth', isHealthy: boolean, isInstalled: boolean, canReadDirectory: boolean, canReadCalendars: boolean, canReadMeetingRooms: boolean };

export type GreenhouseHealthCheckBanner_GreenhouseFragment = { __typename?: 'GreenhouseIntegrationHealth', isHealthy: boolean, isInstalled: boolean, canReadUsers: boolean, canReadUser: boolean, canReadJobs: boolean, canReadJob: boolean, canReadJobStages: boolean, canReadJobStageForJob: boolean, canReadJobPostings: boolean, canReadUserRoles: boolean, canReadEmailTemplates: boolean, canReadInterviews: boolean, canReadInterview: boolean, canReadCandidates: boolean, canReadCandidate: boolean, canReadActivityFeed: boolean, canReadApplications: boolean, canReadApplication: boolean, canReadUserPermission: boolean };

export type LeverHealthCheckBanner_LeverFragment = { __typename?: 'LeverIntegrationHealth', isHealthy: boolean, isInstalled: boolean, canReadUsers: boolean, canReadJobs: boolean, canReadCandidates: boolean, canReadApplications: boolean, canReadArchiveReasons: boolean, canReadPanels: boolean, canReadStages: boolean, canReadDeletedCandidates: boolean };

export type MicrosoftHealthCheckBanner_MicrosoftGccHighFragment = { __typename?: 'MicrosoftIntegrationHealth', isHealthy: boolean, isInstalled: boolean, canReadDirectory: boolean, canReadCalendars: boolean, canReadMeetingRooms: boolean };

export type MicrosoftHealthCheckBanner_MicrosoftFragment = { __typename?: 'MicrosoftIntegrationHealth', isHealthy: boolean, isInstalled: boolean, canReadDirectory: boolean, canReadCalendars: boolean, canReadMeetingRooms: boolean };

export type SmartRecruitersHealthCheckBanner_SmartRecruitersFragment = { __typename?: 'SmartRecruitersIntegrationHealth', isInstalled: boolean, isHealthy: boolean };

export type ZoomHealthCheckBanner_ZoomFragment = { __typename?: 'ZoomIntegrationHealth', isHealthy: boolean, isInstalled: boolean };

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_google_GoogleIntegrationHealth = (
  { __typename?: 'GoogleIntegrationHealth' }
  & GoogleHealthCheckBanner_GoogleFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_microsoft_MicrosoftIntegrationHealth = (
  { __typename?: 'MicrosoftIntegrationHealth' }
  & MicrosoftHealthCheckBanner_MicrosoftFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_microsoftGccHigh_MicrosoftIntegrationHealth = (
  { __typename?: 'MicrosoftIntegrationHealth' }
  & MicrosoftHealthCheckBanner_MicrosoftGccHighFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_zoom_ZoomIntegrationHealth = (
  { __typename?: 'ZoomIntegrationHealth' }
  & ZoomHealthCheckBanner_ZoomFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_greenhouseV3_GreenhouseIntegrationHealth = (
  { __typename?: 'GreenhouseIntegrationHealth' }
  & GreenhouseHealthCheckBanner_GreenhouseFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_ashby_AshbyIntegrationHealth = (
  { __typename?: 'AshbyIntegrationHealth' }
  & AshbyHealthCheckBanner_AshbyFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_lever_LeverIntegrationHealth = (
  { __typename?: 'LeverIntegrationHealth' }
  & LeverHealthCheckBanner_LeverFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_gem_GemIntegrationHealth = (
  { __typename?: 'GemIntegrationHealth' }
  & GemHealthCheckBanner_GemFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_smartRecruiters_SmartRecruitersIntegrationHealth = (
  { __typename?: 'SmartRecruitersIntegrationHealth' }
  & SmartRecruitersHealthCheckBanner_SmartRecruitersFragment
);

export type IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult = { __typename?: 'IntegrationCheckHealthResult', id: any, google?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_google_GoogleIntegrationHealth | null, microsoft?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_microsoft_MicrosoftIntegrationHealth | null, microsoftGccHigh?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_microsoftGccHigh_MicrosoftIntegrationHealth | null, zoom?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_zoom_ZoomIntegrationHealth | null, greenhouseV3?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_greenhouseV3_GreenhouseIntegrationHealth | null, ashby?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_ashby_AshbyIntegrationHealth | null, lever?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_lever_LeverIntegrationHealth | null, gem?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_gem_GemIntegrationHealth | null, smartRecruiters?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult_smartRecruiters_SmartRecruitersIntegrationHealth | null };

export type IntegrationHealthCheckBannersQuery_Query = { __typename?: 'Query', integrationCheckHealth?: IntegrationHealthCheckBannersQuery_integrationCheckHealth_IntegrationCheckHealthResult | null };


export type IntegrationHealthCheckBannersQueryVariables = Exact<{
  force: Scalars['Boolean']['input'];
}>;


export type IntegrationHealthCheckBannersQuery = IntegrationHealthCheckBannersQuery_Query;

export type MicrosoftCustomExpirationBanner_EmployeeFragment_Employee_integrations_EmployeeIntegrations_microsoftCustomEmployee_MicrosoftEmployeeIntegration = { __typename?: 'MicrosoftEmployeeIntegration', updatedAt: any };

export type MicrosoftCustomExpirationBanner_EmployeeFragment_Employee_integrations_EmployeeIntegrations = { __typename?: 'EmployeeIntegrations', id: any, microsoftCustomEmployee?: MicrosoftCustomExpirationBanner_EmployeeFragment_Employee_integrations_EmployeeIntegrations_microsoftCustomEmployee_MicrosoftEmployeeIntegration | null };

export type MicrosoftCustomExpirationBanner_EmployeeFragment = { __typename?: 'Employee', id: any, email: string, integrations?: MicrosoftCustomExpirationBanner_EmployeeFragment_Employee_integrations_EmployeeIntegrations | null };

export type MicrosoftServiceUserExpirationBanner_MicrosoftServiceUserFragment = { __typename?: 'MicrosoftServiceUserIntegration', updatedAt: any };

export type MicrosoftServiceUserIntegrationExpirationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftServiceUser_MicrosoftServiceUserIntegration = (
  { __typename?: 'MicrosoftServiceUserIntegration' }
  & MicrosoftServiceUserExpirationBanner_MicrosoftServiceUserFragment
);

export type MicrosoftServiceUserIntegrationExpirationQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, microsoftServiceUser?: MicrosoftServiceUserIntegrationExpirationQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftServiceUser_MicrosoftServiceUserIntegration | null };

export type MicrosoftServiceUserIntegrationExpirationQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: MicrosoftServiceUserIntegrationExpirationQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type MicrosoftServiceUserIntegrationExpirationQuery_Query = { __typename?: 'Query', thisOrg?: MicrosoftServiceUserIntegrationExpirationQuery_thisOrg_Org | null };


export type MicrosoftServiceUserIntegrationExpirationQueryVariables = Exact<{ [key: string]: never; }>;


export type MicrosoftServiceUserIntegrationExpirationQuery = MicrosoftServiceUserIntegrationExpirationQuery_Query;

export type MicrosoftCustomEmployeeIntegrationExpirationQuery_employeeByIds_Employee = (
  { __typename?: 'Employee' }
  & MicrosoftCustomExpirationBanner_EmployeeFragment
);

export type MicrosoftCustomEmployeeIntegrationExpirationQuery_Query = { __typename?: 'Query', employeeByIds?: Array<MicrosoftCustomEmployeeIntegrationExpirationQuery_employeeByIds_Employee> | null };


export type MicrosoftCustomEmployeeIntegrationExpirationQueryVariables = Exact<{
  employeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type MicrosoftCustomEmployeeIntegrationExpirationQuery = MicrosoftCustomEmployeeIntegrationExpirationQuery_Query;

export type RecruitingSessionActivityTimeoutQuery_thisOrg_Org_sessionInactivityTimeout_Duration = { __typename?: 'Duration', seconds: any, nanos: any };

export type RecruitingSessionActivityTimeoutQuery_thisOrg_Org = { __typename?: 'Org', id: any, sessionInactivityTimeout?: RecruitingSessionActivityTimeoutQuery_thisOrg_Org_sessionInactivityTimeout_Duration | null };

export type RecruitingSessionActivityTimeoutQuery_Query = { __typename?: 'Query', thisOrg?: RecruitingSessionActivityTimeoutQuery_thisOrg_Org | null };


export type RecruitingSessionActivityTimeoutQueryVariables = Exact<{ [key: string]: never; }>;


export type RecruitingSessionActivityTimeoutQuery = RecruitingSessionActivityTimeoutQuery_Query;

export type InterviewTranscript_TranscriptFragment = { __typename?: 'MeetingLocation', remoteNotetakerTranscript?: any | null };

export type InterviewTranscriptQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string };

export type InterviewTranscriptQuery_applicationStage_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: InterviewTranscriptQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job | null };

export type InterviewTranscriptQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type InterviewTranscriptQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', status: ApplicationStatus, candidate?: InterviewTranscriptQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null };

export type InterviewTranscriptQuery_applicationStage_ApplicationStage_interviews_ApplicationStageInterview_meetingLocation_MeetingLocation = (
  { __typename?: 'MeetingLocation' }
  & InterviewTranscript_TranscriptFragment
);

export type InterviewTranscriptQuery_applicationStage_ApplicationStage_interviews_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview', id: any, meetingLocation?: InterviewTranscriptQuery_applicationStage_ApplicationStage_interviews_ApplicationStageInterview_meetingLocation_MeetingLocation | null }
  & InterviewItemFragment
);

export type InterviewTranscriptQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, jobStage?: InterviewTranscriptQuery_applicationStage_ApplicationStage_jobStage_JobStage | null, application?: InterviewTranscriptQuery_applicationStage_ApplicationStage_application_Application | null, interviews?: Array<InterviewTranscriptQuery_applicationStage_ApplicationStage_interviews_ApplicationStageInterview> | null };

export type InterviewTranscriptQuery_Query = { __typename?: 'Query', applicationStage?: InterviewTranscriptQuery_applicationStage_ApplicationStage | null };


export type InterviewTranscriptQueryVariables = Exact<{
  applicationStageId: Scalars['uuid']['input'];
}>;


export type InterviewTranscriptQuery = InterviewTranscriptQuery_Query;

export type SuggestedSchedule_SuggestedScheduleFragment_SuggestedSchedule_interviews_SuggestedScheduledInterview = (
  { __typename?: 'SuggestedScheduledInterview', id: any }
  & SuggestedScheduleInterview_InterviewFragment
);

export type SuggestedSchedule_SuggestedScheduleFragment = { __typename?: 'SuggestedSchedule', id: any, interviews: Array<SuggestedSchedule_SuggestedScheduleFragment_SuggestedSchedule_interviews_SuggestedScheduledInterview> };

export type SuggestedScheduleInterview_InterviewFragment_SuggestedScheduledInterview_seats_SuggestedScheduledInterviewSeat = (
  { __typename?: 'SuggestedScheduledInterviewSeat', id: any }
  & SuggestedScheduledInterviewSeat_SeatFragment
);

export type SuggestedScheduleInterview_InterviewFragment = { __typename?: 'SuggestedScheduledInterview', id: any, startAt: any, endAt: any, name: string, seats: Array<SuggestedScheduleInterview_InterviewFragment_SuggestedScheduledInterview_seats_SuggestedScheduledInterviewSeat> };

export type SuggestedScheduleInterviewer_InterviewerFragment_InterviewerWithRole_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SuggestedScheduleInterviewer_InterviewerFragment = { __typename?: 'InterviewerWithRole', employeeId: any, role: InterviewerRole, employee?: SuggestedScheduleInterviewer_InterviewerFragment_InterviewerWithRole_employee_Employee | null };

export type SuggestedScheduleOptionsHeader_CandidateFragment = (
  { __typename?: 'Candidate', id: any }
  & Candidate_CandidateFragment
);

export type SuggestedScheduledInterviewSeat_SeatFragment_SuggestedScheduledInterviewSeat_interviewers_InterviewerWithRole = (
  { __typename?: 'InterviewerWithRole' }
  & SuggestedScheduleInterviewer_InterviewerFragment
);

export type SuggestedScheduledInterviewSeat_SeatFragment = { __typename?: 'SuggestedScheduledInterviewSeat', id: any, interviewers: Array<SuggestedScheduledInterviewSeat_SeatFragment_SuggestedScheduledInterviewSeat_interviewers_InterviewerWithRole> };

export type SuggestedScheduleOptions_TaskFragment_Task_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any }
  & SuggestedScheduleOptionsHeader_CandidateFragment
);

export type SuggestedScheduleOptions_TaskFragment_Task_application_Application = { __typename?: 'Application', id: any, candidate?: SuggestedScheduleOptions_TaskFragment_Task_application_Application_candidate_Candidate | null };

export type SuggestedScheduleOptions_TaskFragment_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type SuggestedScheduleOptions_TaskFragment_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type SuggestedScheduleOptions_TaskFragment_Task_availabilities_CandidateAvailability = { __typename?: 'CandidateAvailability', id: any, candidateEnteredAvailability?: Array<SuggestedScheduleOptions_TaskFragment_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<SuggestedScheduleOptions_TaskFragment_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null };

export type SuggestedScheduleOptions_TaskFragment_Task_interviewPlan_JobStage = (
  { __typename?: 'JobStage', id: any }
  & UseIsInterviewPlanValid_JobStageFragment
);

export type SuggestedScheduleOptions_TaskFragment = { __typename?: 'Task', id: any, application: SuggestedScheduleOptions_TaskFragment_Task_application_Application, availabilities: Array<SuggestedScheduleOptions_TaskFragment_Task_availabilities_CandidateAvailability>, interviewPlan: SuggestedScheduleOptions_TaskFragment_Task_interviewPlan_JobStage };

export type TaskSuggestedScheduleOptionsQuery_task_Task_suggestedSchedules_SuggestedSchedule = (
  { __typename?: 'SuggestedSchedule', id: any }
  & SuggestedSchedule_SuggestedScheduleFragment
);

export type TaskSuggestedScheduleOptionsQuery_task_Task = { __typename?: 'Task', suggestedSchedules: Array<TaskSuggestedScheduleOptionsQuery_task_Task_suggestedSchedules_SuggestedSchedule> };

export type TaskSuggestedScheduleOptionsQuery_Query = { __typename?: 'Query', task?: TaskSuggestedScheduleOptionsQuery_task_Task | null };


export type TaskSuggestedScheduleOptionsQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
  input: TaskSuggestedSchedulesInput;
}>;


export type TaskSuggestedScheduleOptionsQuery = TaskSuggestedScheduleOptionsQuery_Query;

export type TaskSuggestedSchedulesQuery_task_Task = (
  { __typename?: 'Task' }
  & ScheduleTask_TaskFragment
  & SuggestedScheduleOptions_TaskFragment
);

export type TaskSuggestedSchedulesQuery_Query = { __typename?: 'Query', task?: TaskSuggestedSchedulesQuery_task_Task | null };


export type TaskSuggestedSchedulesQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type TaskSuggestedSchedulesQuery = TaskSuggestedSchedulesQuery_Query;

export type MockApplicationSidebarContent_ApplicationFragment = { __typename?: 'Application', id: any };

export type MockApplicationSidebarHeader_ApplicationFragment = { __typename?: 'Application', id: any };

export type MockJobStageDetails_JobFragment = { __typename?: 'Job', id: any };

export type MockTaskList_ApplicationFragment = { __typename?: 'Application', id: any };

export type MockApplicationSidebarCreateTaskButton_ApplicationFragment = { __typename?: 'Application', id: any };

export type MockCandidateInfoSidebar_ApplicationFragment = { __typename?: 'Application', id: any };

export type MockCandidateInfoSidebar_CandidateFragment = { __typename?: 'Candidate', id: any };

export type MockJobStageMismatchAlert_JobFragment = { __typename?: 'Job', id: any };

export type MockGetHiringSetupError_FlagsFragment = { __typename?: 'JobValidationErrorFlags', message: string };

export type MockGetHiringMismatchError_FlagsFragment = { __typename?: 'JobValidationErrorFlags', message: string };

export type ApplicationSidebarContent_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type ApplicationSidebarContent_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags' }
  & GetHiringSetupError_FlagsFragment
  & GetHiringMismatchError_FlagsFragment
);

export type ApplicationSidebarContent_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<ApplicationSidebarContent_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type ApplicationSidebarContent_ApplicationFragment_Application_job_Job = (
  { __typename?: 'Job', id: any, validationIssues: ApplicationSidebarContent_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult }
  & JobStageDetails_JobFragment
  & JobStageMismatchAlert_JobFragment
);

export type ApplicationSidebarContent_ApplicationFragment_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any }
  & CandidateInfoSidebar_CandidateFragment
);

export type ApplicationSidebarContent_ApplicationFragment_Application_tasks_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type ApplicationSidebarContent_ApplicationFragment_Application_tasks_Task = { __typename?: 'Task', id: any, jobStage?: ApplicationSidebarContent_ApplicationFragment_Application_tasks_Task_jobStage_JobStage | null };

export type ApplicationSidebarContent_ApplicationFragment_Application_validateCanEnterScheduleFlow_ValidationResult = { __typename?: 'ValidationResult', message?: string | null, valid: boolean };

export type ApplicationSidebarContent_ApplicationFragment = (
  { __typename?: 'Application', id: any, jobStage?: ApplicationSidebarContent_ApplicationFragment_Application_jobStage_JobStage | null, job?: ApplicationSidebarContent_ApplicationFragment_Application_job_Job | null, candidate?: ApplicationSidebarContent_ApplicationFragment_Application_candidate_Candidate | null, tasks: Array<ApplicationSidebarContent_ApplicationFragment_Application_tasks_Task>, validateCanEnterScheduleFlow: ApplicationSidebarContent_ApplicationFragment_Application_validateCanEnterScheduleFlow_ValidationResult }
  & ApplicationSidebarCreateTaskButton_ApplicationFragment
  & TaskList_ApplicationFragment
  & CandidateInfoSidebar_ApplicationFragment
);

export type ApplicationSidebarCreateTaskActions_ApplicationFragment = (
  { __typename?: 'Application', id: any }
  & CreateTaskActions_ApplicationFragment
  & NonSchedulableJobStageAlert_ApplicationFragment
);

export type ApplicationSidebarCreateTaskButton_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags' }
  & GetHiringMismatchError_FlagsFragment
  & GetHiringSetupError_FlagsFragment
);

export type ApplicationSidebarCreateTaskButton_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<ApplicationSidebarCreateTaskButton_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type ApplicationSidebarCreateTaskButton_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, validationIssues: ApplicationSidebarCreateTaskButton_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult };

export type ApplicationSidebarCreateTaskButton_ApplicationFragment = (
  { __typename?: 'Application', id: any, job?: ApplicationSidebarCreateTaskButton_ApplicationFragment_Application_job_Job | null }
  & CreateTaskActions_ApplicationFragment
  & GetActiveTasksForJobStage_ApplictionFragment
  & NonSchedulableJobStageAlert_ApplicationFragment
);

export type JobStageNameByIdQuery_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type JobStageNameByIdQuery_Query = { __typename?: 'Query', jobStage?: JobStageNameByIdQuery_jobStage_JobStage | null };


export type JobStageNameByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobStageNameByIdQuery = JobStageNameByIdQuery_Query;

export type ApplicationSidebarHeader_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type ApplicationSidebarHeader_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string, location?: Array<string> | null };

export type ApplicationSidebarHeader_ApplicationFragment = { __typename?: 'Application', id: any, candidate?: ApplicationSidebarHeader_ApplicationFragment_Application_candidate_Candidate | null, job?: ApplicationSidebarHeader_ApplicationFragment_Application_job_Job | null };

export type MockCandidateLocaleSelect_CandidateFragment = { __typename?: 'Candidate', id: any, locale?: Locale | null };

export type MockCandidateTimezoneSelect_CandidateFragment = { __typename?: 'Candidate', id: any, timezone?: string | null };

export type MockCoordinatorSelect_ApplicationFragment = { __typename?: 'Application', id: any };

export type MockRecruiterSelect_ApplicationFragment = { __typename?: 'Application', id: any };

export type MockSourcerSelect_ApplicationFragment = { __typename?: 'Application', id: any };

export type CandidateInfoSidebar_ApplicationFragment = (
  { __typename?: 'Application', id: any }
  & RecruiterSelect_ApplicationFragment
  & CoordinatorSelect_ApplicationFragment
  & SourcerSelect_ApplicationFragment
);

export type CandidateInfoSidebar_CandidateFragment = (
  { __typename?: 'Candidate', id: any }
  & CandidateTimezoneSelect_CandidateFragment
  & CandidateLocaleSelect_CandidateFragment
);

export type QuickTaskCreateMutation_taskQuickCreate_TaskQuickCreateResult = { __typename?: 'TaskQuickCreateResult', taskId: any };

export type QuickTaskCreateMutation_Mutation = { __typename?: 'Mutation', taskQuickCreate: QuickTaskCreateMutation_taskQuickCreate_TaskQuickCreateResult };


export type QuickTaskCreateMutationVariables = Exact<{
  input: TaskQuickCreateInput;
}>;


export type QuickTaskCreateMutation = QuickTaskCreateMutation_Mutation;

export type TaskCreateWithAgentDelegateMutation_taskCreateWithAgentDelegate_TaskCreateWithAgentDelegateResult = { __typename?: 'TaskCreateWithAgentDelegateResult', taskId: any };

export type TaskCreateWithAgentDelegateMutation_Mutation = { __typename?: 'Mutation', taskCreateWithAgentDelegate: TaskCreateWithAgentDelegateMutation_taskCreateWithAgentDelegate_TaskCreateWithAgentDelegateResult };


export type TaskCreateWithAgentDelegateMutationVariables = Exact<{
  input: TaskCreateWithAgentDelegateInput;
}>;


export type TaskCreateWithAgentDelegateMutation = TaskCreateWithAgentDelegateMutation_Mutation;

export type CreateTaskActions_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags', type: TaskCreateValidateErrorFlagType }
  & GetHiringMismatchError_FlagsFragment
  & GetHiringSetupError_FlagsFragment
);

export type CreateTaskActions_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<CreateTaskActions_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type CreateTaskActions_ApplicationFragment_Application_job_Job = { __typename?: 'Job', validationIssues: CreateTaskActions_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult };

export type CreateTaskActions_ApplicationFragment = (
  { __typename?: 'Application', id: any, status: ApplicationStatus, jobId: any, job?: CreateTaskActions_ApplicationFragment_Application_job_Job | null }
  & CreateTaskModals_ApplicationFragment
  & GetActiveTasksForJobStage_ApplictionFragment
  & UseApplicationJobStageSchedulable_ApplicationFragment
);

export type CreateTaskModals_ApplicationFragment = (
  { __typename?: 'Application', id: any }
  & BasicTaskModal_ApplicationFragment
  & AvailabilityTaskModal_ApplicationFragment
  & SelfScheduleTaskModal_ApplicationFragment
);

export type NonSchedulableJobStageAlert_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type NonSchedulableJobStageAlert_ApplicationFragment_Application_validateCanEnterScheduleFlow_ValidationResult = { __typename?: 'ValidationResult', valid: boolean, message?: string | null };

export type NonSchedulableJobStageAlert_ApplicationFragment = (
  { __typename?: 'Application', id: any, jobStageId?: any | null, jobStage?: NonSchedulableJobStageAlert_ApplicationFragment_Application_jobStage_JobStage | null, validateCanEnterScheduleFlow: NonSchedulableJobStageAlert_ApplicationFragment_Application_validateCanEnterScheduleFlow_ValidationResult }
  & UseApplicationJobStageSchedulable_ApplicationFragment
);

export type SelectButtonLabel_EmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type GetActiveTasksForJobStage_ApplictionFragment_Application_tasks_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type GetActiveTasksForJobStage_ApplictionFragment_Application_tasks_Task = { __typename?: 'Task', status: TaskStatus, jobStage?: GetActiveTasksForJobStage_ApplictionFragment_Application_tasks_Task_jobStage_JobStage | null };

export type GetActiveTasksForJobStage_ApplictionFragment = { __typename?: 'Application', id: any, tasks: Array<GetActiveTasksForJobStage_ApplictionFragment_Application_tasks_Task> };

export type ApplicationSidebarQuery_applicationV2_Application = (
  { __typename: 'Application', id: any }
  & ApplicationSidebarHeader_ApplicationFragment
  & ApplicationSidebarContent_ApplicationFragment
);

export type ApplicationSidebarQuery_applicationV2_ApplicationNotFoundError = { __typename: 'ApplicationNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationSidebarQuery_applicationV2_ApplicationPermissionDeniedError = { __typename: 'ApplicationPermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationSidebarQuery_applicationV2_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationSidebarQuery_applicationV2 = ApplicationSidebarQuery_applicationV2_Application | ApplicationSidebarQuery_applicationV2_ApplicationNotFoundError | ApplicationSidebarQuery_applicationV2_ApplicationPermissionDeniedError | ApplicationSidebarQuery_applicationV2_UnknownError;

export type ApplicationSidebarQuery_Query = { __typename?: 'Query', applicationV2: ApplicationSidebarQuery_applicationV2 };


export type ApplicationSidebarQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type ApplicationSidebarQuery = ApplicationSidebarQuery_Query;

export type ApplicationByAtsIdV2Query_applicationByAtsIdV2_Application = { __typename: 'Application', id: any, candidateId: any };

export type ApplicationByAtsIdV2Query_applicationByAtsIdV2_ApplicationNotFoundError = { __typename: 'ApplicationNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationByAtsIdV2Query_applicationByAtsIdV2_ApplicationPermissionDeniedError = { __typename: 'ApplicationPermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationByAtsIdV2Query_applicationByAtsIdV2_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationByAtsIdV2Query_applicationByAtsIdV2 = ApplicationByAtsIdV2Query_applicationByAtsIdV2_Application | ApplicationByAtsIdV2Query_applicationByAtsIdV2_ApplicationNotFoundError | ApplicationByAtsIdV2Query_applicationByAtsIdV2_ApplicationPermissionDeniedError | ApplicationByAtsIdV2Query_applicationByAtsIdV2_UnknownError;

export type ApplicationByAtsIdV2Query_Query = { __typename?: 'Query', applicationByAtsIdV2: ApplicationByAtsIdV2Query_applicationByAtsIdV2 };


export type ApplicationByAtsIdV2QueryVariables = Exact<{
  input: ApplicationByAtsIdV2Input;
}>;


export type ApplicationByAtsIdV2Query = ApplicationByAtsIdV2Query_Query;

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_AshbyJob = { __typename?: 'AshbyJob' };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_GemJob = { __typename?: 'GemJob' };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_GreenhouseJob = { __typename?: 'GreenhouseJob' };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_SmartRecruitersJob = { __typename?: 'SmartRecruitersJob' };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_WorkdayJob = { __typename?: 'WorkdayJob', referenceId: string };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields = CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_AshbyJob | CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_GemJob | CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_GreenhouseJob | CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_SmartRecruitersJob | CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields_WorkdayJob;

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsId: string, atsFields?: CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob_atsFields | null };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job = { __typename?: 'Job', id: any, atsJob?: CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job_atsJob_AtsJob | null };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application = { __typename?: 'Application', id: any, status: ApplicationStatus, job?: CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application_job_Job | null };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate = { __typename: 'Candidate', id: any, applications?: Array<CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate_applications_Application> | null };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_CandidateNotFoundError = { __typename: 'CandidateNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_CandidatePermissionDeniedError = { __typename: 'CandidatePermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type CandidateByAtsIdV2Query_candidateByAtsIdV2 = CandidateByAtsIdV2Query_candidateByAtsIdV2_Candidate | CandidateByAtsIdV2Query_candidateByAtsIdV2_CandidateNotFoundError | CandidateByAtsIdV2Query_candidateByAtsIdV2_CandidatePermissionDeniedError | CandidateByAtsIdV2Query_candidateByAtsIdV2_UnknownError;

export type CandidateByAtsIdV2Query_Query = { __typename?: 'Query', candidateByAtsIdV2: CandidateByAtsIdV2Query_candidateByAtsIdV2 };


export type CandidateByAtsIdV2QueryVariables = Exact<{
  input: CandidateByAtsIdV2Input;
}>;


export type CandidateByAtsIdV2Query = CandidateByAtsIdV2Query_Query;

export type ApplicationTokensQuery_templateToken_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERNAL_APPLICATION_NOTE?: string | null, APPLICATION_CANDIDATE_PORTAL_URL?: string | null };

export type ApplicationTokensQuery_Query = { __typename?: 'Query', templateToken?: ApplicationTokensQuery_templateToken_TemplateToken | null };


export type ApplicationTokensQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
  input: TokenApplicationInput;
}>;


export type ApplicationTokensQuery = ApplicationTokensQuery_Query;

export type CandidateAvailabilityTokensQuery_CANDIDATE_AVAILABILITY_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_AVAILABILITY?: string | null };

export type CandidateAvailabilityTokensQuery_CANDIDATE_AVAILABILITY_TIMEZONE_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_AVAILABILITY_TIMEZONE?: string | null };

export type CandidateAvailabilityTokensQuery_Query = { __typename?: 'Query', CANDIDATE_AVAILABILITY?: CandidateAvailabilityTokensQuery_CANDIDATE_AVAILABILITY_TemplateToken | null, CANDIDATE_AVAILABILITY_TIMEZONE?: CandidateAvailabilityTokensQuery_CANDIDATE_AVAILABILITY_TIMEZONE_TemplateToken | null };


export type CandidateAvailabilityTokensQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
  candidateAvailabilityInput: TokenCandidateAvailabilityInput;
  timezone: Scalars['timezone']['input'];
}>;


export type CandidateAvailabilityTokensQuery = CandidateAvailabilityTokensQuery_Query;

export type CandidateTokensRequestQuery_CANDIDATE_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_NAME?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_PREFERRED_FULL_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_PREFERRED_FULL_NAME?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_FIRST_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_FIRST_NAME?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_PREFERRED_FIRST_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_PREFERRED_FIRST_NAME?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_LAST_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_LAST_NAME?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_LAST_INITIAL_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_LAST_INITIAL?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_EMAIL_ADDRESS_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_EMAIL_ADDRESS?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_PHONE_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_PHONE?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_PRONOUNS_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_PRONOUNS?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_LINKEDIN_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_LINKEDIN?: string | null };

export type CandidateTokensRequestQuery_COORDINATOR_EMAIL_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, COORDINATOR_EMAIL?: string | null };

export type CandidateTokensRequestQuery_COORDINATOR_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, COORDINATOR?: string | null };

export type CandidateTokensRequestQuery_RECRUITER_EMAIL_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, RECRUITER_EMAIL?: string | null };

export type CandidateTokensRequestQuery_RECRUITER_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, RECRUITER?: string | null };

export type CandidateTokensRequestQuery_HIRING_MANAGER_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, HIRING_MANAGER?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_LINK_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_LINK?: string | null };

export type CandidateTokensRequestQuery_SOURCER_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, SOURCER?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_SOURCER_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_SOURCER?: string | null };

export type CandidateTokensRequestQuery_CANDIDATE_SOURCER_EMAIL_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CANDIDATE_SOURCER_EMAIL?: string | null };

export type CandidateTokensRequestQuery_Query = { __typename?: 'Query', CANDIDATE_NAME?: CandidateTokensRequestQuery_CANDIDATE_NAME_TemplateToken | null, CANDIDATE_PREFERRED_FULL_NAME?: CandidateTokensRequestQuery_CANDIDATE_PREFERRED_FULL_NAME_TemplateToken | null, CANDIDATE_FIRST_NAME?: CandidateTokensRequestQuery_CANDIDATE_FIRST_NAME_TemplateToken | null, CANDIDATE_PREFERRED_FIRST_NAME?: CandidateTokensRequestQuery_CANDIDATE_PREFERRED_FIRST_NAME_TemplateToken | null, CANDIDATE_LAST_NAME?: CandidateTokensRequestQuery_CANDIDATE_LAST_NAME_TemplateToken | null, CANDIDATE_LAST_INITIAL?: CandidateTokensRequestQuery_CANDIDATE_LAST_INITIAL_TemplateToken | null, CANDIDATE_EMAIL_ADDRESS?: CandidateTokensRequestQuery_CANDIDATE_EMAIL_ADDRESS_TemplateToken | null, CANDIDATE_PHONE?: CandidateTokensRequestQuery_CANDIDATE_PHONE_TemplateToken | null, CANDIDATE_PRONOUNS?: CandidateTokensRequestQuery_CANDIDATE_PRONOUNS_TemplateToken | null, CANDIDATE_LINKEDIN?: CandidateTokensRequestQuery_CANDIDATE_LINKEDIN_TemplateToken | null, COORDINATOR_EMAIL?: CandidateTokensRequestQuery_COORDINATOR_EMAIL_TemplateToken | null, COORDINATOR?: CandidateTokensRequestQuery_COORDINATOR_TemplateToken | null, RECRUITER_EMAIL?: CandidateTokensRequestQuery_RECRUITER_EMAIL_TemplateToken | null, RECRUITER?: CandidateTokensRequestQuery_RECRUITER_TemplateToken | null, HIRING_MANAGER?: CandidateTokensRequestQuery_HIRING_MANAGER_TemplateToken | null, CANDIDATE_LINK?: CandidateTokensRequestQuery_CANDIDATE_LINK_TemplateToken | null, SOURCER?: CandidateTokensRequestQuery_SOURCER_TemplateToken | null, CANDIDATE_SOURCER?: CandidateTokensRequestQuery_CANDIDATE_SOURCER_TemplateToken | null, CANDIDATE_SOURCER_EMAIL?: CandidateTokensRequestQuery_CANDIDATE_SOURCER_EMAIL_TemplateToken | null };


export type CandidateTokensRequestQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
  candidateId: Scalars['uuid']['input'];
  applicationId: Scalars['uuid']['input'];
  jobId: Scalars['uuid']['input'];
  candidateLinkLabel?: InputMaybe<Scalars['String']['input']>;
  hasApplicationId: Scalars['Boolean']['input'];
  hasJobId: Scalars['Boolean']['input'];
}>;


export type CandidateTokensRequestQuery = CandidateTokensRequestQuery_Query;

export type ChatMentionTokensQuery_CHAT_MENTION_INTERVIEWERS_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CHAT_MENTION_INTERVIEWERS?: string | null };

export type ChatMentionTokensQuery_CHAT_MENTION_DEBRIEF_ATTENDEES_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CHAT_MENTION_DEBRIEF_ATTENDEES?: string | null };

export type ChatMentionTokensQuery_CHAT_MENTION_CANDIDATE_SOURCER_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CHAT_MENTION_CANDIDATE_SOURCER?: string | null };

export type ChatMentionTokensQuery_CHAT_MENTION_CANDIDATE_RECRUITER_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CHAT_MENTION_CANDIDATE_RECRUITER?: string | null };

export type ChatMentionTokensQuery_CHAT_MENTION_CANDIDATE_COORDINATOR_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CHAT_MENTION_CANDIDATE_COORDINATOR?: string | null };

export type ChatMentionTokensQuery_CHAT_MENTION_JOB_HIRING_MANAGERS_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CHAT_MENTION_JOB_HIRING_MANAGERS?: string | null };

export type ChatMentionTokensQuery_Query = { __typename?: 'Query', CHAT_MENTION_INTERVIEWERS?: ChatMentionTokensQuery_CHAT_MENTION_INTERVIEWERS_TemplateToken | null, CHAT_MENTION_DEBRIEF_ATTENDEES?: ChatMentionTokensQuery_CHAT_MENTION_DEBRIEF_ATTENDEES_TemplateToken | null, CHAT_MENTION_CANDIDATE_SOURCER?: ChatMentionTokensQuery_CHAT_MENTION_CANDIDATE_SOURCER_TemplateToken | null, CHAT_MENTION_CANDIDATE_RECRUITER?: ChatMentionTokensQuery_CHAT_MENTION_CANDIDATE_RECRUITER_TemplateToken | null, CHAT_MENTION_CANDIDATE_COORDINATOR?: ChatMentionTokensQuery_CHAT_MENTION_CANDIDATE_COORDINATOR_TemplateToken | null, CHAT_MENTION_JOB_HIRING_MANAGERS?: ChatMentionTokensQuery_CHAT_MENTION_JOB_HIRING_MANAGERS_TemplateToken | null };


export type ChatMentionTokensQueryVariables = Exact<{
  id: Scalars['String']['input'];
  applicationId: Scalars['uuid']['input'];
  interviewerIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  renderType: RenderType;
}>;


export type ChatMentionTokensQuery = ChatMentionTokensQuery_Query;

export type DebriefTokensQuery_DEBRIEF_SCHEDULE_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, DEBRIEF_SCHEDULE?: string | null };

export type DebriefTokensQuery_Query = { __typename?: 'Query', DEBRIEF_SCHEDULE?: DebriefTokensQuery_DEBRIEF_SCHEDULE_TemplateToken | null };


export type DebriefTokensQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
  input: TokenDebriefScheduleInput;
}>;


export type DebriefTokensQuery = DebriefTokensQuery_Query;

export type InterviewTokensQuery_INTERVIEW_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEW_NAME?: string | null };

export type InterviewTokensQuery_EXTERNAL_INTERVIEW_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, EXTERNAL_INTERVIEW_NAME?: string | null };

export type InterviewTokensQuery_INTERVIEWER_NAMES_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEWER_NAMES?: string | null };

export type InterviewTokensQuery_SCHEDULE_INTERVIEWER_NAMES_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEWER_NAMES?: string | null };

export type InterviewTokensQuery_INTERVIEW_DAYS_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEW_DAYS?: string | null };

export type InterviewTokensQuery_INTERVIEW_SCHEDULE_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEW_SCHEDULE?: string | null };

export type InterviewTokensQuery_INTERVIEW_SCHEDULE_START_TIME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEW_SCHEDULE_START_TIME?: string | null };

export type InterviewTokensQuery_INTERNAL_INTERVIEW_SCHEDULE_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERNAL_INTERVIEW_SCHEDULE?: string | null };

export type InterviewTokensQuery_INTERVIEW_KIT_LINK_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEW_KIT_LINK?: string | null };

export type InterviewTokensQuery_INTERVIEW_SCORECARD_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEW_SCORECARD_NAME?: string | null };

export type InterviewTokensQuery_INTERNAL_INTERVIEW_NAME_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERNAL_INTERVIEW_NAME?: string | null };

export type InterviewTokensQuery_CODE_LINK_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, CODE_LINK?: string | null };

export type InterviewTokensQuery_VIDEO_MEETING_LINK_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, VIDEO_MEETING_LINK?: string | null };

export type InterviewTokensQuery_SCHEDULE_LOCATION_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, SCHEDULE_LOCATION?: string | null };

export type InterviewTokensQuery_ZOOM_MEETING_DIAL_IN_INFO_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, ZOOM_MEETING_DIAL_IN_INFO?: string | null };

export type InterviewTokensQuery_ZOOM_MEETING_INFO_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, ZOOM_MEETING_INFO?: string | null };

export type InterviewTokensQuery_INTERVIEWER_TRAINING_INFO_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, INTERVIEWER_TRAINING_INFO?: string | null };

export type InterviewTokensQuery_Query = { __typename?: 'Query', INTERVIEW_NAME?: InterviewTokensQuery_INTERVIEW_NAME_TemplateToken | null, EXTERNAL_INTERVIEW_NAME?: InterviewTokensQuery_EXTERNAL_INTERVIEW_NAME_TemplateToken | null, INTERVIEWER_NAMES?: InterviewTokensQuery_INTERVIEWER_NAMES_TemplateToken | null, SCHEDULE_INTERVIEWER_NAMES?: InterviewTokensQuery_SCHEDULE_INTERVIEWER_NAMES_TemplateToken | null, INTERVIEW_DAYS?: InterviewTokensQuery_INTERVIEW_DAYS_TemplateToken | null, INTERVIEW_SCHEDULE?: InterviewTokensQuery_INTERVIEW_SCHEDULE_TemplateToken | null, INTERVIEW_SCHEDULE_START_TIME?: InterviewTokensQuery_INTERVIEW_SCHEDULE_START_TIME_TemplateToken | null, INTERNAL_INTERVIEW_SCHEDULE?: InterviewTokensQuery_INTERNAL_INTERVIEW_SCHEDULE_TemplateToken | null, INTERVIEW_KIT_LINK?: InterviewTokensQuery_INTERVIEW_KIT_LINK_TemplateToken | null, INTERVIEW_SCORECARD_NAME?: InterviewTokensQuery_INTERVIEW_SCORECARD_NAME_TemplateToken | null, INTERNAL_INTERVIEW_NAME?: InterviewTokensQuery_INTERNAL_INTERVIEW_NAME_TemplateToken | null, CODE_LINK?: InterviewTokensQuery_CODE_LINK_TemplateToken | null, VIDEO_MEETING_LINK?: InterviewTokensQuery_VIDEO_MEETING_LINK_TemplateToken | null, SCHEDULE_LOCATION?: InterviewTokensQuery_SCHEDULE_LOCATION_TemplateToken | null, ZOOM_MEETING_DIAL_IN_INFO?: InterviewTokensQuery_ZOOM_MEETING_DIAL_IN_INFO_TemplateToken | null, ZOOM_MEETING_INFO?: InterviewTokensQuery_ZOOM_MEETING_INFO_TemplateToken | null, INTERVIEWER_TRAINING_INFO?: InterviewTokensQuery_INTERVIEWER_TRAINING_INFO_TemplateToken | null };


export type InterviewTokensQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['uuid']['input'];
  renderType: RenderType;
  name: TokenInterviewNameInput;
  names: TokenInterviewerNamesInput;
  scheduleNames: TokenInterviewerNamesInput;
  days: TokenInterviewDaysInput;
  schedule: TokenInterviewScheduleInput;
  scheduleStartTime: TokenInterviewScheduleStartTimeInput;
  internalInterviewSchedule: TokenInterviewScheduleInput;
  kitLink: TokenInterviewKitLinkInput;
  codeLink: CodeLinkInput;
  hasScorecard: Scalars['Boolean']['input'];
  videoMeetingLink: TokenVideoMeetingLinkInput;
  scheduleLocation: TokenScheduleLocationInput;
  zoom: TokenZoomMeetingInput;
  trainingInfo: TokenInterviewerTrainingInfoInput;
  hasName: Scalars['Boolean']['input'];
  hasNames: Scalars['Boolean']['input'];
  hasDays: Scalars['Boolean']['input'];
  hasSchedule: Scalars['Boolean']['input'];
  hasScheduleStartTime: Scalars['Boolean']['input'];
  hasInternalInterviewSchedule: Scalars['Boolean']['input'];
  hasCodeLink: Scalars['Boolean']['input'];
  hasVideoMeetingLink: Scalars['Boolean']['input'];
  hasScheduleLocation: Scalars['Boolean']['input'];
  hasZoom: Scalars['Boolean']['input'];
  atsInterviewDefinitionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type InterviewTokensQuery = InterviewTokensQuery_Query;

export type JobTokensQuery_templateToken_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, JOB_NAME?: string | null, JOB_LOCATION?: string | null, JOB_STAGE_NAME?: string | null, EXTERNAL_JOB_NAME?: string | null };

export type JobTokensQuery_Query = { __typename?: 'Query', templateToken?: JobTokensQuery_templateToken_TemplateToken | null };


export type JobTokensQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
  jobId: Scalars['uuid']['input'];
  jobStageId: Scalars['uuid']['input'];
  applicationId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type JobTokensQuery = JobTokensQuery_Query;

export type MeetingsTokenQuery_VIDEO_MEETING_LINK_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, VIDEO_MEETING_LINK?: string | null };

export type MeetingsTokenQuery_SCHEDULE_LOCATION_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, SCHEDULE_LOCATION?: string | null };

export type MeetingsTokenQuery_ZOOM_MEETING_DIAL_IN_INFO_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, ZOOM_MEETING_DIAL_IN_INFO?: string | null };

export type MeetingsTokenQuery_ZOOM_MEETING_INFO_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, ZOOM_MEETING_INFO?: string | null };

export type MeetingsTokenQuery_Query = { __typename?: 'Query', VIDEO_MEETING_LINK?: MeetingsTokenQuery_VIDEO_MEETING_LINK_TemplateToken | null, SCHEDULE_LOCATION?: MeetingsTokenQuery_SCHEDULE_LOCATION_TemplateToken | null, ZOOM_MEETING_DIAL_IN_INFO?: MeetingsTokenQuery_ZOOM_MEETING_DIAL_IN_INFO_TemplateToken | null, ZOOM_MEETING_INFO?: MeetingsTokenQuery_ZOOM_MEETING_INFO_TemplateToken | null };


export type MeetingsTokenQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
  zoom: TokenZoomMeetingInput;
  videoMeetingLink: TokenVideoMeetingLinkInput;
  scheduleLocationInput: TokenScheduleLocationInput;
  hasVideoMeetingLink: Scalars['Boolean']['input'];
  hasZoom: Scalars['Boolean']['input'];
  hasScheduleLocation: Scalars['Boolean']['input'];
}>;


export type MeetingsTokenQuery = MeetingsTokenQuery_Query;

export type TaskTokensQuery_templateToken_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, TASK_CREATOR?: string | null, TASK_ASSIGNEE?: string | null };

export type TaskTokensQuery_Query = { __typename?: 'Query', templateToken?: TaskTokensQuery_templateToken_TemplateToken | null };


export type TaskTokensQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  assigneeId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type TaskTokensQuery = TaskTokensQuery_Query;

export type UserTokensQuery_templateToken_TemplateToken = { __typename?: 'TemplateToken', id?: string | null, ME?: string | null, MY_FULL_NAME?: string | null, MY_FIRST_NAME?: string | null, MY_PHONE_NUMBER?: string | null, MY_SIGNATURE?: string | null, COMPANY_NAME?: string | null, COMPANY?: string | null };

export type UserTokensQuery_Query = { __typename?: 'Query', templateToken?: UserTokensQuery_templateToken_TemplateToken | null };


export type UserTokensQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  renderType: RenderType;
}>;


export type UserTokensQuery = UserTokensQuery_Query;

export type GreenhouseOAuthIntegrationForPreferredNameTokensQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration = { __typename?: 'GreenhouseOAuthIntegration', subdomain: string };

export type GreenhouseOAuthIntegrationForPreferredNameTokensQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, greenhouseOauth?: GreenhouseOAuthIntegrationForPreferredNameTokensQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration | null };

export type GreenhouseOAuthIntegrationForPreferredNameTokensQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: GreenhouseOAuthIntegrationForPreferredNameTokensQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type GreenhouseOAuthIntegrationForPreferredNameTokensQuery_Query = { __typename?: 'Query', thisOrg?: GreenhouseOAuthIntegrationForPreferredNameTokensQuery_thisOrg_Org | null };


export type GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type GreenhouseOAuthIntegrationForPreferredNameTokensQuery = GreenhouseOAuthIntegrationForPreferredNameTokensQuery_Query;

export type ScheduleContentTemplateByIdQuery_template_Template_attachments_Attachment = { __typename?: 'Attachment', name?: string | null, path?: string | null, size?: any | null, timestamp?: any | null };

export type ScheduleContentTemplateByIdQuery_template_Template = { __typename?: 'Template', id: any, subject?: string | null, body?: string | null, type: TemplateType, attachments?: Array<ScheduleContentTemplateByIdQuery_template_Template_attachments_Attachment> | null };

export type ScheduleContentTemplateByIdQuery_Query = { __typename?: 'Query', template?: ScheduleContentTemplateByIdQuery_template_Template | null };


export type ScheduleContentTemplateByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ScheduleContentTemplateByIdQuery = ScheduleContentTemplateByIdQuery_Query;

export type RecordDataDownloadMutation_recordDataDownload_InvalidDownloadReasonError = { __typename: 'InvalidDownloadReasonError', errorCode: ErrorCode, errorMessage: string };

export type RecordDataDownloadMutation_recordDataDownload_InvalidRowCountError = { __typename: 'InvalidRowCountError', errorCode: ErrorCode, errorMessage: string };

export type RecordDataDownloadMutation_recordDataDownload_PermissionDeniedError = { __typename: 'PermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type RecordDataDownloadMutation_recordDataDownload_RecordDataDownloadSuccess = { __typename: 'RecordDataDownloadSuccess', recorded: boolean };

export type RecordDataDownloadMutation_recordDataDownload_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type RecordDataDownloadMutation_recordDataDownload = RecordDataDownloadMutation_recordDataDownload_InvalidDownloadReasonError | RecordDataDownloadMutation_recordDataDownload_InvalidRowCountError | RecordDataDownloadMutation_recordDataDownload_PermissionDeniedError | RecordDataDownloadMutation_recordDataDownload_RecordDataDownloadSuccess | RecordDataDownloadMutation_recordDataDownload_UnknownError;

export type RecordDataDownloadMutation_Mutation = { __typename?: 'Mutation', recordDataDownload: RecordDataDownloadMutation_recordDataDownload };


export type RecordDataDownloadMutationVariables = Exact<{
  input: RecordDataDownloadInput;
}>;


export type RecordDataDownloadMutation = RecordDataDownloadMutation_Mutation;

export type AgentThreadsQuery_agentThreads_AgentThreadsResult_items_AgentThread = { __typename?: 'AgentThread', externalThreadId: string, title?: string | null, updatedAt: any, lastAccessedAt: any };

export type AgentThreadsQuery_agentThreads_AgentThreadsResult = { __typename?: 'AgentThreadsResult', nextCursor?: string | null, items: Array<AgentThreadsQuery_agentThreads_AgentThreadsResult_items_AgentThread> };

export type AgentThreadsQuery_Query = { __typename?: 'Query', agentThreads: AgentThreadsQuery_agentThreads_AgentThreadsResult };


export type AgentThreadsQueryVariables = Exact<{
  input: AgentThreadsInput;
}>;


export type AgentThreadsQuery = AgentThreadsQuery_Query;

export type MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken_MintFirstPartyAgentAccessTokenPermissionDeniedError = { __typename: 'MintFirstPartyAgentAccessTokenPermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken_MintFirstPartyAgentAccessTokenSuccess = { __typename: 'MintFirstPartyAgentAccessTokenSuccess', token: string, expiresAt: any, scopes: Array<string> };

export type MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken_MintFirstPartyAgentAccessTokenUnknownError = { __typename: 'MintFirstPartyAgentAccessTokenUnknownError', errorCode: ErrorCode, errorMessage: string };

export type MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken = MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken_MintFirstPartyAgentAccessTokenPermissionDeniedError | MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken_MintFirstPartyAgentAccessTokenSuccess | MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken_MintFirstPartyAgentAccessTokenUnknownError;

export type MintFirstPartyAgentAccessTokenMutation_Mutation = { __typename?: 'Mutation', mintFirstPartyAgentAccessToken: MintFirstPartyAgentAccessTokenMutation_mintFirstPartyAgentAccessToken };


export type MintFirstPartyAgentAccessTokenMutationVariables = Exact<{
  input: MintFirstPartyAgentAccessTokenInput;
}>;


export type MintFirstPartyAgentAccessTokenMutation = MintFirstPartyAgentAccessTokenMutation_Mutation;

export type AgentThreadRenameMutation_agentThreadRename_AgentThreadRenameInvalidTitleError = { __typename: 'AgentThreadRenameInvalidTitleError', errorCode: ErrorCode, errorMessage: string };

export type AgentThreadRenameMutation_agentThreadRename_AgentThreadRenameNotFoundError = { __typename: 'AgentThreadRenameNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type AgentThreadRenameMutation_agentThreadRename_AgentThreadRenameSuccess = { __typename: 'AgentThreadRenameSuccess', externalThreadId: string, title: string };

export type AgentThreadRenameMutation_agentThreadRename_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type AgentThreadRenameMutation_agentThreadRename = AgentThreadRenameMutation_agentThreadRename_AgentThreadRenameInvalidTitleError | AgentThreadRenameMutation_agentThreadRename_AgentThreadRenameNotFoundError | AgentThreadRenameMutation_agentThreadRename_AgentThreadRenameSuccess | AgentThreadRenameMutation_agentThreadRename_UnknownError;

export type AgentThreadRenameMutation_Mutation = { __typename?: 'Mutation', agentThreadRename: AgentThreadRenameMutation_agentThreadRename };


export type AgentThreadRenameMutationVariables = Exact<{
  input: AgentThreadRenameInput;
}>;


export type AgentThreadRenameMutation = AgentThreadRenameMutation_Mutation;

export type CandidateAiTabQuery_candidate_Candidate_aiInstruction_AiInstruction = (
  { __typename?: 'AiInstruction' }
  & AiInstructionsCard_InstructionFragment
);

export type CandidateAiTabQuery_candidate_Candidate_aiMemories_AiMemory = (
  { __typename?: 'AiMemory' }
  & AiMemoriesCard_MemoryFragment
);

export type CandidateAiTabQuery_candidate_Candidate = { __typename?: 'Candidate', id: any, aiInstruction?: CandidateAiTabQuery_candidate_Candidate_aiInstruction_AiInstruction | null, aiMemories: Array<CandidateAiTabQuery_candidate_Candidate_aiMemories_AiMemory> };

export type CandidateAiTabQuery_Query = { __typename?: 'Query', candidate?: CandidateAiTabQuery_candidate_Candidate | null };


export type CandidateAiTabQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CandidateAiTabQuery = CandidateAiTabQuery_Query;

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagCandidateDeclined = { __typename?: 'TaskFlagCandidateDeclined', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagCandidateTentative = { __typename?: 'TaskFlagCandidateTentative', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagDebriefAttendeeDeactivated = { __typename?: 'TaskFlagDebriefAttendeeDeactivated', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagDebriefAttendeeTentative = { __typename?: 'TaskFlagDebriefAttendeeTentative', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerDeactivated = { __typename?: 'TaskFlagInterviewerDeactivated', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerDebriefDeclined = { __typename?: 'TaskFlagInterviewerDebriefDeclined', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerDeclined = { __typename?: 'TaskFlagInterviewerDeclined', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerTentative = { __typename?: 'TaskFlagInterviewerTentative', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagRequestedChange = { __typename?: 'TaskFlagRequestedChange', id: any, flagType: TaskFlagType, resolvedAt?: any | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags = UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagCandidateDeclined | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagCandidateTentative | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagDebriefAttendeeDeactivated | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagDebriefAttendeeTentative | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerDeactivated | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerDebriefDeclined | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerDeclined | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagInterviewerTentative | UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags_TaskFlagRequestedChange;

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task = { __typename?: 'Task', id: any, status: TaskStatus, flags: Array<UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task_flags> };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined = { __typename?: 'InterviewInterviewerDeclined', applicationStageInterviewId: any };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any, declines?: Array<UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined> | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any, applicationStageInterviewInterviewers?: Array<UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null };

export type UpcomingScheduleAlert_ApplicationStagesFragment = { __typename?: 'ApplicationStage', id: any, jobStageId?: any | null, startAt?: any | null, endAt?: any | null, hasInterviewerDeclined: boolean, task?: UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_task_Task | null, applicationStageInterviews?: Array<UpcomingScheduleAlert_ApplicationStagesFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type ApplicationAlert_ApplicationFragment_Application_applicationStages_ApplicationStage = (
  { __typename?: 'ApplicationStage' }
  & UpcomingScheduleAlert_ApplicationStagesFragment
);

export type ApplicationAlert_ApplicationFragment = { __typename?: 'Application', id: any, status: ApplicationStatus, applicationStages?: Array<ApplicationAlert_ApplicationFragment_Application_applicationStages_ApplicationStage> | null };

export type ApplicationConflict_TaskFragment_Task_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string };

export type ApplicationConflict_TaskFragment_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, job?: ApplicationConflict_TaskFragment_Task_jobStage_JobStage_job_Job | null };

export type ApplicationConflict_TaskFragment_Task_application_Application_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string };

export type ApplicationConflict_TaskFragment_Task_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, job?: ApplicationConflict_TaskFragment_Task_application_Application_jobStage_JobStage_job_Job | null };

export type ApplicationConflict_TaskFragment_Task_application_Application = { __typename?: 'Application', id: any, jobStage?: ApplicationConflict_TaskFragment_Task_application_Application_jobStage_JobStage | null };

export type ApplicationConflict_TaskFragment = { __typename?: 'Task', id: any, jobStage?: ApplicationConflict_TaskFragment_Task_jobStage_JobStage | null, application: ApplicationConflict_TaskFragment_Task_application_Application };

export type ApplicationDebriefs_ApplicationFragment_Application_debriefs_ApplicationDebrief_task_Task = { __typename?: 'Task', id: any };

export type ApplicationDebriefs_ApplicationFragment_Application_debriefs_ApplicationDebrief = (
  { __typename?: 'ApplicationDebrief', id: any, task?: ApplicationDebriefs_ApplicationFragment_Application_debriefs_ApplicationDebrief_task_Task | null }
  & DebriefContentEntity_DebriefFragment
);

export type ApplicationDebriefs_ApplicationFragment = (
  { __typename?: 'Application', id: any, status: ApplicationStatus, debriefs?: Array<ApplicationDebriefs_ApplicationFragment_Application_debriefs_ApplicationDebrief> | null }
  & UseApplicationJobStageSchedulable_ApplicationFragment
);

export type JobSetupRequiredAlert_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags', type: TaskCreateValidateErrorFlagType }
  & GetHiringSetupError_FlagsFragment
);

export type JobSetupRequiredAlert_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<JobSetupRequiredAlert_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type JobSetupRequiredAlert_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, validationIssues: JobSetupRequiredAlert_ApplicationFragment_Application_job_Job_validationIssues_JobValidationResult };

export type JobSetupRequiredAlert_ApplicationFragment = { __typename?: 'Application', id: any, jobStageId?: any | null, job?: JobSetupRequiredAlert_ApplicationFragment_Application_job_Job | null };

export type JobStageDetails_JobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string, index: number };

export type JobStageDetails_JobFragment = { __typename?: 'Job', id: any, jobStages?: Array<JobStageDetails_JobFragment_Job_jobStages_JobStage> | null };

export type JobStageOptionFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, defaultTask?: TaskCreationSource | null, isAutomatedTaskEnabled?: boolean | null };

export type JobStageOptionFragment = { __typename?: 'JobStage', id: any, name: string, index: number, schedulable: boolean, atsId?: string | null, jobId: any, jobStageSettingsV2?: JobStageOptionFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type MoveJobStageButton_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type MoveJobStageButton_ApplicationFragment_Application_job_Job_aliasedJs_JobStage = (
  { __typename?: 'JobStage', id: any }
  & JobStageOptionFragment
);

export type MoveJobStageButton_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, aliasedJs?: Array<MoveJobStageButton_ApplicationFragment_Application_job_Job_aliasedJs_JobStage> | null };

export type MoveJobStageButton_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any };

export type MoveJobStageButton_ApplicationFragment_Application_validateCanMoveStage_ValidationResult = { __typename?: 'ValidationResult', valid: boolean, message?: string | null };

export type MoveJobStageButton_ApplicationFragment = (
  { __typename?: 'Application', id: any, jobStage?: MoveJobStageButton_ApplicationFragment_Application_jobStage_JobStage | null, job?: MoveJobStageButton_ApplicationFragment_Application_job_Job | null, candidate?: MoveJobStageButton_ApplicationFragment_Application_candidate_Candidate | null, validateCanMoveStage: MoveJobStageButton_ApplicationFragment_Application_validateCanMoveStage_ValidationResult }
  & GetActiveTasksForJobStage_ApplictionFragment
);

export type MoveToNextStageAlert_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any };

export type MoveToNextStageAlert_ApplicationFragment_Application_job_Job_MoveToNextStageAlert_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string, index: number };

export type MoveToNextStageAlert_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string, MoveToNextStageAlert_jobStages?: Array<MoveToNextStageAlert_ApplicationFragment_Application_job_Job_MoveToNextStageAlert_jobStages_JobStage> | null };

export type MoveToNextStageAlert_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, index: number };

export type MoveToNextStageAlert_ApplicationFragment_Application_tasks_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type MoveToNextStageAlert_ApplicationFragment_Application_tasks_Task = { __typename?: 'Task', id: any, status: TaskStatus, jobStage?: MoveToNextStageAlert_ApplicationFragment_Application_tasks_Task_jobStage_JobStage | null };

export type MoveToNextStageAlert_ApplicationFragment_Application_atsApplication_AtsApplication = { __typename?: 'AtsApplication', atsId: string, canMoveJobStage: boolean };

export type MoveToNextStageAlert_ApplicationFragment_Application_validateCanMoveStage_ValidationResult = { __typename?: 'ValidationResult', valid: boolean, message?: string | null };

export type MoveToNextStageAlert_ApplicationFragment = (
  { __typename?: 'Application', id: any, candidate?: MoveToNextStageAlert_ApplicationFragment_Application_candidate_Candidate | null, job?: MoveToNextStageAlert_ApplicationFragment_Application_job_Job | null, jobStage?: MoveToNextStageAlert_ApplicationFragment_Application_jobStage_JobStage | null, tasks: Array<MoveToNextStageAlert_ApplicationFragment_Application_tasks_Task>, atsApplication?: MoveToNextStageAlert_ApplicationFragment_Application_atsApplication_AtsApplication | null, validateCanMoveStage: MoveToNextStageAlert_ApplicationFragment_Application_validateCanMoveStage_ValidationResult }
  & GetActiveTasksForJobStage_ApplictionFragment
);

export type OpenTaskOnOtherJobStageAlert_ApplicationFragment_Application_tasks_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type OpenTaskOnOtherJobStageAlert_ApplicationFragment_Application_tasks_Task = { __typename?: 'Task', id: any, status: TaskStatus, jobStage?: OpenTaskOnOtherJobStageAlert_ApplicationFragment_Application_tasks_Task_jobStage_JobStage | null };

export type OpenTaskOnOtherJobStageAlert_ApplicationFragment = { __typename?: 'Application', tasks: Array<OpenTaskOnOtherJobStageAlert_ApplicationFragment_Application_tasks_Task> };

export type TaskCard_TaskFragment_Task_application_Application = (
  { __typename?: 'Application', id: any }
  & ScheduleContent_ApplicationFragment
);

export type TaskCard_TaskFragment_Task_assignee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type TaskCard_TaskFragment_Task_flags_TaskFlagCandidateDeclined = (
  { __typename?: 'TaskFlagCandidateDeclined', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateDeclined_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagCandidateTentative = (
  { __typename?: 'TaskFlagCandidateTentative', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateTentative_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated = (
  { __typename?: 'TaskFlagDebriefAttendeeDeactivated', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative = (
  { __typename?: 'TaskFlagDebriefAttendeeTentative', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated = (
  { __typename?: 'TaskFlagInterviewerDeactivated', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeactivated_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined = (
  { __typename?: 'TaskFlagInterviewerDebriefDeclined', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerDeclined = (
  { __typename?: 'TaskFlagInterviewerDeclined', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeclined_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerTentative = (
  { __typename?: 'TaskFlagInterviewerTentative', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerTentative_Fragment
);

export type TaskCard_TaskFragment_Task_flags_TaskFlagRequestedChange = (
  { __typename?: 'TaskFlagRequestedChange', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagRequestedChange_Fragment
);

export type TaskCard_TaskFragment_Task_flags = TaskCard_TaskFragment_Task_flags_TaskFlagCandidateDeclined | TaskCard_TaskFragment_Task_flags_TaskFlagCandidateTentative | TaskCard_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated | TaskCard_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative | TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated | TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined | TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerDeclined | TaskCard_TaskFragment_Task_flags_TaskFlagInterviewerTentative | TaskCard_TaskFragment_Task_flags_TaskFlagRequestedChange;

export type TaskCard_TaskFragment_Task_tags_TaskTag = (
  { __typename?: 'TaskTag', id: any }
  & ScheduleTaskTagCompact_TaskTagFragment
);

export type TaskCard_TaskFragment_Task_schedules_ApplicationStage = (
  { __typename?: 'ApplicationStage', id: any, createdAt: any }
  & ScheduleContent_ScheduleFragment
);

export type TaskCard_TaskFragment_Task_debriefs_ApplicationDebrief = (
  { __typename?: 'ApplicationDebrief', id: any, createdAt?: any | null }
  & DebriefContentEntity_DebriefFragment
);

export type TaskCard_TaskFragment_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type TaskCard_TaskFragment_Task_availabilityRequests_CandidateAvailabilityOptions = { __typename?: 'CandidateAvailabilityOptions', id: any };

export type TaskCard_TaskFragment = (
  { __typename?: 'Task', id: any, count?: any | null, status: TaskStatus, isUrgent: boolean, application: TaskCard_TaskFragment_Task_application_Application, assignee?: TaskCard_TaskFragment_Task_assignee_Employee | null, flags: Array<TaskCard_TaskFragment_Task_flags>, tags: Array<TaskCard_TaskFragment_Task_tags_TaskTag>, schedules: Array<TaskCard_TaskFragment_Task_schedules_ApplicationStage>, debriefs: Array<TaskCard_TaskFragment_Task_debriefs_ApplicationDebrief>, jobStage?: TaskCard_TaskFragment_Task_jobStage_JobStage | null, availabilityRequests: Array<TaskCard_TaskFragment_Task_availabilityRequests_CandidateAvailabilityOptions> }
  & TaskName_TaskFragment
);

export type TaskList_TaskFragment_Task_flags_TaskFlagCandidateDeclined = { __typename?: 'TaskFlagCandidateDeclined', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagCandidateTentative = { __typename?: 'TaskFlagCandidateTentative', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated = { __typename?: 'TaskFlagDebriefAttendeeDeactivated', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative = { __typename?: 'TaskFlagDebriefAttendeeTentative', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated = { __typename?: 'TaskFlagInterviewerDeactivated', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined = { __typename?: 'TaskFlagInterviewerDebriefDeclined', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagInterviewerDeclined = { __typename?: 'TaskFlagInterviewerDeclined', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagInterviewerTentative = { __typename?: 'TaskFlagInterviewerTentative', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags_TaskFlagRequestedChange = { __typename?: 'TaskFlagRequestedChange', id: any, resolvedAt?: any | null };

export type TaskList_TaskFragment_Task_flags = TaskList_TaskFragment_Task_flags_TaskFlagCandidateDeclined | TaskList_TaskFragment_Task_flags_TaskFlagCandidateTentative | TaskList_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated | TaskList_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative | TaskList_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated | TaskList_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined | TaskList_TaskFragment_Task_flags_TaskFlagInterviewerDeclined | TaskList_TaskFragment_Task_flags_TaskFlagInterviewerTentative | TaskList_TaskFragment_Task_flags_TaskFlagRequestedChange;

export type TaskList_TaskFragment = (
  { __typename?: 'Task', id: any, count?: any | null, status: TaskStatus, flags: Array<TaskList_TaskFragment_Task_flags> }
  & TaskCard_TaskFragment
);

export type TaskListQuery_application_Application_tasks_Task = (
  { __typename?: 'Task' }
  & TaskList_TaskFragment
);

export type TaskListQuery_application_Application = (
  { __typename?: 'Application', id: any, tasks: Array<TaskListQuery_application_Application_tasks_Task> }
  & GetActiveTasksForJobStage_ApplictionFragment
  & ApplicationSidebarCreateTaskActions_ApplicationFragment
);

export type TaskListQuery_Query = { __typename?: 'Query', application?: TaskListQuery_application_Application | null };


export type TaskListQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type TaskListQuery = TaskListQuery_Query;

export type TaskList_ApplicationFragment = (
  { __typename?: 'Application', id: any }
  & GetActiveTasksForJobStage_ApplictionFragment
  & ApplicationSidebarCreateTaskActions_ApplicationFragment
);

export type TaskShareDialogQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2' }
  & CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment
  & SelfScheduleEmail_JobStageSettingsV2Fragment
);

export type TaskShareDialogQuery_task_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: TaskShareDialogQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type TaskShareDialogQuery_task_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type TaskShareDialogQuery_task_Task_application_Application = { __typename?: 'Application', id: any, jobId: any, candidate?: TaskShareDialogQuery_task_Task_application_Application_candidate_Candidate | null };

export type TaskShareDialogQuery_task_Task_availabilityRequests_CandidateAvailabilityOptions = { __typename?: 'CandidateAvailabilityOptions', id: any, applicationId: any, availabilityEndDate?: any | null, availabilityStartDate?: any | null, candidateNote?: string | null, externalId: string, createdAt: any, jobStageId: any, minimumTimeBlockMinutes: any, minutesPerDays: any, numberOfDays: any, timezone: string, updatedAt: any, lastCandidateCommunicationSentAt?: any | null, advanceNoticeMinutes?: any | null, shouldRespectLoadLimit: boolean, bookIfPerfectScheduleFound: boolean, suggestOverAvailableKeywords: boolean, suggestOverFreeTime: boolean, suggestOverRecruitingKeywords: boolean, rollingDays: any, inclusionDays: Array<string> };

export type TaskShareDialogQuery_task_Task_selfScheduleRequests_SelfScheduleOptions_options_Options = { __typename?: 'Options', inclusionDays?: Array<string> | null, rollingDays?: any | null, advanceNoticeInHours?: any | null, candidateCalendarId?: string | null, interviewerCalendarId?: string | null, location?: SelfScheduleLocation | null, zoomHost?: SelfScheduleZoomHost | null, zoomHostUserId?: string | null, candidateEmail: string, canScheduleOverAvailableKeywords: boolean, canScheduleOverFreeTime: boolean, canScheduleOverRecruitingKeywords: boolean, shouldRespectLoadLimit: boolean };

export type TaskShareDialogQuery_task_Task_selfScheduleRequests_SelfScheduleOptions = { __typename?: 'SelfScheduleOptions', id: any, applicationId: any, createdAt?: any | null, creatorEmployeeId?: any | null, deletedAt?: any | null, jobStageId: any, interviewerEventTemplateId?: any | null, candidateEventTemplateId?: any | null, candidateEmailTemplateId?: any | null, lastUpdatedByEmployeeId?: any | null, rescheduledAt?: any | null, selfScheduleEmailTemplateId?: any | null, selfScheduleEmailSentAt?: any | null, updatedAt?: any | null, options?: TaskShareDialogQuery_task_Task_selfScheduleRequests_SelfScheduleOptions_options_Options | null };

export type TaskShareDialogQuery_task_Task = { __typename?: 'Task', id: any, jobStage?: TaskShareDialogQuery_task_Task_jobStage_JobStage | null, application: TaskShareDialogQuery_task_Task_application_Application, availabilityRequests: Array<TaskShareDialogQuery_task_Task_availabilityRequests_CandidateAvailabilityOptions>, selfScheduleRequests: Array<TaskShareDialogQuery_task_Task_selfScheduleRequests_SelfScheduleOptions> };

export type TaskShareDialogQuery_Query = { __typename?: 'Query', task?: TaskShareDialogQuery_task_Task | null };


export type TaskShareDialogQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type TaskShareDialogQuery = TaskShareDialogQuery_Query;

export type ApplicationContent_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type ApplicationContent_ApplicationFragment_Application_job_Job = (
  { __typename?: 'Job', id: any, name: string }
  & JobStageDetails_JobFragment
  & JobStageMismatchAlert_JobFragment
);

export type ApplicationContent_ApplicationFragment_Application_tasks_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type ApplicationContent_ApplicationFragment_Application_tasks_Task = { __typename?: 'Task', id: any, jobStage?: ApplicationContent_ApplicationFragment_Application_tasks_Task_jobStage_JobStage | null };

export type ApplicationContent_ApplicationFragment = (
  { __typename?: 'Application', id: any, jobStageId?: any | null, jobStage?: ApplicationContent_ApplicationFragment_Application_jobStage_JobStage | null, job?: ApplicationContent_ApplicationFragment_Application_job_Job | null, tasks: Array<ApplicationContent_ApplicationFragment_Application_tasks_Task> }
  & JobSetupRequiredAlert_ApplicationFragment
  & ApplicationAlert_ApplicationFragment
  & ApplicationDebriefs_ApplicationFragment
  & MoveJobStageButton_ApplicationFragment
  & TaskList_ApplicationFragment
  & MoveToNextStageAlert_ApplicationFragment
  & OpenTaskOnOtherJobStageAlert_ApplicationFragment
  & ApplicationSidebarCreateTaskButton_ApplicationFragment
);

export type AboutSettings_CandidateFragment_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsUrl: string };

export type AboutSettings_CandidateFragment = (
  { __typename?: 'Candidate', id: any, timezone?: string | null, locale?: Locale | null, updatedAt?: any | null, preferredEmail?: string | null, email?: string | null, linkedinUrl?: string | null, preferredPhoneNumber?: string | null, phoneNumbers?: Array<string> | null, atsCandidate?: AboutSettings_CandidateFragment_Candidate_atsCandidate_AtsCandidate | null }
  & CandidateTimezoneSelect_CandidateFragment
  & CandidateLocaleSelect_CandidateFragment
  & EditCandidatePhoneNumberModal_CandidateFragment
);

export type AboutSettings_ApplicationFragment_Application_atsApplication_AtsApplication = { __typename?: 'AtsApplication', atsType: AtsType, atsId: string, atsUrl?: string | null };

export type AboutSettings_ApplicationFragment_Application_job_Job_mismatchedApplications_JobMismatchedApplication_application_Application = { __typename?: 'Application', id: any };

export type AboutSettings_ApplicationFragment_Application_job_Job_mismatchedApplications_JobMismatchedApplication = { __typename?: 'JobMismatchedApplication', id: any, jobStageName?: string | null, application?: AboutSettings_ApplicationFragment_Application_job_Job_mismatchedApplications_JobMismatchedApplication_application_Application | null };

export type AboutSettings_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, mismatchedApplications?: Array<AboutSettings_ApplicationFragment_Application_job_Job_mismatchedApplications_JobMismatchedApplication> | null };

export type AboutSettings_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type AboutSettings_ApplicationFragment_Application_conversations_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string, isArchived: boolean };

export type AboutSettings_ApplicationFragment = { __typename?: 'Application', id: any, atsApplication?: AboutSettings_ApplicationFragment_Application_atsApplication_AtsApplication | null, job?: AboutSettings_ApplicationFragment_Application_job_Job | null, jobStage?: AboutSettings_ApplicationFragment_Application_jobStage_JobStage | null, conversations?: Array<AboutSettings_ApplicationFragment_Application_conversations_Conversation> | null };

export type EditCandidatePhoneNumberModal_CandidateFragment = { __typename?: 'Candidate', id: any, preferredPhoneNumber?: string | null, phoneNumbers?: Array<string> | null };

export type EditCandidatePhoneNumberMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate = (
  { __typename?: 'Candidate', id: any }
  & EditCandidatePhoneNumberModal_CandidateFragment
);

export type EditCandidatePhoneNumberMutation_candidateUpdate_CandidateUpdateResult = { __typename?: 'CandidateUpdateResult', candidate: EditCandidatePhoneNumberMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate };

export type EditCandidatePhoneNumberMutation_Mutation = { __typename?: 'Mutation', candidateUpdate: EditCandidatePhoneNumberMutation_candidateUpdate_CandidateUpdateResult };


export type EditCandidatePhoneNumberMutationVariables = Exact<{
  input: CandidateUpdateInput;
}>;


export type EditCandidatePhoneNumberMutation = EditCandidatePhoneNumberMutation_Mutation;

export type CandidateInfo_ApplicationFragment_Application_existingConversations_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string, isArchived: boolean };

export type CandidateInfo_ApplicationFragment_Application_atsApplication_AtsApplication = { __typename?: 'AtsApplication', atsId: string, atsUrl?: string | null };

export type CandidateInfo_ApplicationFragment = (
  { __typename?: 'Application', atsType?: AtsType | null, existingConversations?: Array<CandidateInfo_ApplicationFragment_Application_existingConversations_Conversation> | null, atsApplication?: CandidateInfo_ApplicationFragment_Application_atsApplication_AtsApplication | null }
  & CandidatePortalSettings_ApplicationFragment
  & AboutSettings_ApplicationFragment
  & HiringTeam_ApplicationFragment
);

export type CandidateInfo_CandidateFragment_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsId: string, atsUrl: string, primaryEmail: string };

export type CandidateInfo_CandidateFragment = (
  { __typename?: 'Candidate', id: any, email?: string | null, preferredEmail?: string | null, linkedinUrl?: string | null, updatedAt?: any | null, timezone?: string | null, atsCandidate?: CandidateInfo_CandidateFragment_Candidate_atsCandidate_AtsCandidate | null }
  & AboutSettings_CandidateFragment
  & CandidateTimezoneSelect_CandidateFragment
  & ConflictInterestSection_CandidateFragment
);

export type CandidatePortalActionsMenu_ApplicationFragment = { __typename?: 'Application', id: any, jobId: any, jobStageId?: any | null, isPortalAccessible: boolean };

export type ToggleCandidatePortalMutation_applicationUpdate_Application = (
  { __typename?: 'Application' }
  & CandidatePortalActionsMenu_ApplicationFragment
);

export type ToggleCandidatePortalMutation_Mutation = { __typename?: 'Mutation', applicationUpdate: ToggleCandidatePortalMutation_applicationUpdate_Application };


export type ToggleCandidatePortalMutationVariables = Exact<{
  input: ApplicationUpdateInput;
}>;


export type ToggleCandidatePortalMutation = ToggleCandidatePortalMutation_Mutation;

export type ResetPrimaryEmailMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate = { __typename?: 'Candidate', id: any, email?: string | null, preferredEmail?: string | null };

export type ResetPrimaryEmailMutation_candidateUpdate_CandidateUpdateResult = { __typename?: 'CandidateUpdateResult', candidate: ResetPrimaryEmailMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate };

export type ResetPrimaryEmailMutation_Mutation = { __typename?: 'Mutation', candidateUpdate: ResetPrimaryEmailMutation_candidateUpdate_CandidateUpdateResult };


export type ResetPrimaryEmailMutationVariables = Exact<{
  input: CandidateUpdateInput;
}>;


export type ResetPrimaryEmailMutation = ResetPrimaryEmailMutation_Mutation;

export type DeleteCandidatePortalNoteMutation_applicationCandidatePortalNoteDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type DeleteCandidatePortalNoteMutation_Mutation = { __typename?: 'Mutation', applicationCandidatePortalNoteDelete: DeleteCandidatePortalNoteMutation_applicationCandidatePortalNoteDelete_EmptyResult };


export type DeleteCandidatePortalNoteMutationVariables = Exact<{
  applicationCandidatePortalNoteDeleteId: Scalars['uuid']['input'];
}>;


export type DeleteCandidatePortalNoteMutation = DeleteCandidatePortalNoteMutation_Mutation;

export type CandidatePortalNoteEditor_CandidatePortalNoteFragment = { __typename?: 'CandidatePortalNote', id: any, content?: string | null, lastNotificationSentAt?: any | null };

export type CreateCandidatePortalNoteMutation_applicationCandidatePortalNoteCreate_CandidatePortalNote = (
  { __typename?: 'CandidatePortalNote', id: any, updatedAt: any, lastNotificationSentAt?: any | null }
  & CandidatePortalNoteEditor_CandidatePortalNoteFragment
);

export type CreateCandidatePortalNoteMutation_Mutation = { __typename?: 'Mutation', applicationCandidatePortalNoteCreate: CreateCandidatePortalNoteMutation_applicationCandidatePortalNoteCreate_CandidatePortalNote };


export type CreateCandidatePortalNoteMutationVariables = Exact<{
  applicationCandidatePortalNoteCreateInput: ApplicationCandidatePortalNoteCreateInput;
}>;


export type CreateCandidatePortalNoteMutation = CreateCandidatePortalNoteMutation_Mutation;

export type UpdateCandidatePortalNoteMutation_applicationCandidatePortalNoteUpdate_CandidatePortalNote = (
  { __typename?: 'CandidatePortalNote', id: any, updatedAt: any, lastNotificationSentAt?: any | null }
  & CandidatePortalNoteEditor_CandidatePortalNoteFragment
);

export type UpdateCandidatePortalNoteMutation_Mutation = { __typename?: 'Mutation', applicationCandidatePortalNoteUpdate: UpdateCandidatePortalNoteMutation_applicationCandidatePortalNoteUpdate_CandidatePortalNote };


export type UpdateCandidatePortalNoteMutationVariables = Exact<{
  input: ApplicationCandidatePortalNoteUpdateInput;
}>;


export type UpdateCandidatePortalNoteMutation = UpdateCandidatePortalNoteMutation_Mutation;

export type CandidatePortalNote_CandidatePortalNoteFragment = (
  { __typename?: 'CandidatePortalNote', id: any, content?: string | null, updatedAt: any }
  & CandidatePortalNoteEditor_CandidatePortalNoteFragment
);

export type CandidatePortalSettings_ApplicationFragment_Application_job_Job_org_Org_slugs_PortalOrgSlug = { __typename?: 'PortalOrgSlug', orgId: any, slug: string };

export type CandidatePortalSettings_ApplicationFragment_Application_job_Job_org_Org = { __typename?: 'Org', slugs: Array<CandidatePortalSettings_ApplicationFragment_Application_job_Job_org_Org_slugs_PortalOrgSlug> };

export type CandidatePortalSettings_ApplicationFragment_Application_job_Job = { __typename?: 'Job', org?: CandidatePortalSettings_ApplicationFragment_Application_job_Job_org_Org | null };

export type CandidatePortalSettings_ApplicationFragment_Application_candidatePortalNote_CandidatePortalNote = (
  { __typename?: 'CandidatePortalNote', id: any }
  & CandidatePortalNote_CandidatePortalNoteFragment
);

export type CandidatePortalSettings_ApplicationFragment = (
  { __typename?: 'Application', id: any, isPortalAccessible: boolean, job?: CandidatePortalSettings_ApplicationFragment_Application_job_Job | null, candidatePortalNote?: CandidatePortalSettings_ApplicationFragment_Application_candidatePortalNote_CandidatePortalNote | null }
  & CandidatePortalActionsMenu_ApplicationFragment
);

export type ToggleCandidatePortalStatusMutation_applicationUpdate_Application = { __typename?: 'Application', id: any, isPortalAccessible: boolean };

export type ToggleCandidatePortalStatusMutation_Mutation = { __typename?: 'Mutation', applicationUpdate: ToggleCandidatePortalStatusMutation_applicationUpdate_Application };


export type ToggleCandidatePortalStatusMutationVariables = Exact<{
  input: ApplicationUpdateInput;
}>;


export type ToggleCandidatePortalStatusMutation = ToggleCandidatePortalStatusMutation_Mutation;

export type ConflictInterestSection_CandidateFragment_Candidate_conflictOfInterestEmployees_Employee = (
  { __typename?: 'Employee', id: any }
  & EmployeeFragment
);

export type ConflictInterestSection_CandidateFragment = { __typename?: 'Candidate', id: any, conflictOfInterestEmployees: Array<ConflictInterestSection_CandidateFragment_Candidate_conflictOfInterestEmployees_Employee> };

export type CandidateUpdateCoiMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate = (
  { __typename?: 'Candidate', id: any }
  & ConflictInterestSection_CandidateFragment
);

export type CandidateUpdateCoiMutation_candidateUpdate_CandidateUpdateResult = { __typename?: 'CandidateUpdateResult', candidate: CandidateUpdateCoiMutation_candidateUpdate_CandidateUpdateResult_candidate_Candidate };

export type CandidateUpdateCoiMutation_Mutation = { __typename?: 'Mutation', candidateUpdate: CandidateUpdateCoiMutation_candidateUpdate_CandidateUpdateResult };


export type CandidateUpdateCoiMutationVariables = Exact<{
  input: CandidateUpdateInput;
}>;


export type CandidateUpdateCoiMutation = CandidateUpdateCoiMutation_Mutation;

export type ApplicationNoteUpdateMutationMutation_applicationUpdate_Application = { __typename?: 'Application', id: any, internalNote?: string | null };

export type ApplicationNoteUpdateMutationMutation_Mutation = { __typename?: 'Mutation', applicationUpdate: ApplicationNoteUpdateMutationMutation_applicationUpdate_Application };


export type ApplicationNoteUpdateMutationMutationVariables = Exact<{
  input: ApplicationUpdateInput;
}>;


export type ApplicationNoteUpdateMutationMutation = ApplicationNoteUpdateMutationMutation_Mutation;

export type ApplicationNote_ApplicationFragment = (
  { __typename?: 'Application', id: any, internalNote?: string | null }
  & ApplicationNoteEditor_ApplicationFragment
);

export type ApplicationNoteEditor_ApplicationFragment = { __typename?: 'Application', id: any, internalNote?: string | null };

export type InternalNoteUpdateMutation_applicationUpdate_Application = { __typename?: 'Application', id: any, internalNote?: string | null };

export type InternalNoteUpdateMutation_Mutation = { __typename?: 'Mutation', applicationUpdate: InternalNoteUpdateMutation_applicationUpdate_Application };


export type InternalNoteUpdateMutationVariables = Exact<{
  input: ApplicationUpdateInput;
}>;


export type InternalNoteUpdateMutation = InternalNoteUpdateMutation_Mutation;

export type ApplicationList_ApplicationFragment_Application_state_ApplicationState = { __typename?: 'ApplicationState', isSchedulable?: boolean | null, isNotScheduleable?: boolean | null, isUnscheduled?: boolean | null, isAvailabilityRequested?: boolean | null, isReadyToSchedule?: boolean | null, isCanceled?: boolean | null, isOngoing?: boolean | null, isScheduled?: boolean | null, isCompleted?: boolean | null, isScheduledInAts?: boolean | null, isCompletedInAts?: boolean | null, isCandidateDeclined?: boolean | null, isInterviewerDeclined?: boolean | null, isSelfScheduleRequested?: boolean | null };

export type ApplicationList_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string, jobStagesAggregate?: any | null };

export type ApplicationList_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, index: number };

export type ApplicationList_ApplicationFragment = { __typename?: 'Application', id: any, jobStageId?: any | null, status: ApplicationStatus, state?: ApplicationList_ApplicationFragment_Application_state_ApplicationState | null, job?: ApplicationList_ApplicationFragment_Application_job_Job | null, jobStage?: ApplicationList_ApplicationFragment_Application_jobStage_JobStage | null };

export type CandidateSecondaryContent_ApplicationFragment = (
  { __typename?: 'Application' }
  & ApplicationNote_ApplicationFragment
  & CandidateInfo_ApplicationFragment
);

export type CandidateSecondaryContent_ApplicationsFragment = (
  { __typename?: 'Application' }
  & ApplicationList_ApplicationFragment
);

export type CandidateSecondaryContent_CandidateFragment = (
  { __typename?: 'Candidate' }
  & CandidateInfo_CandidateFragment
);

export type ApplicationTaskViewApplicationsQuery_candidateV2_Candidate_applications_Application = { __typename?: 'Application', id: any };

export type ApplicationTaskViewApplicationsQuery_candidateV2_Candidate = { __typename: 'Candidate', id: any, applications?: Array<ApplicationTaskViewApplicationsQuery_candidateV2_Candidate_applications_Application> | null };

export type ApplicationTaskViewApplicationsQuery_candidateV2_CandidateNotFoundError = { __typename: 'CandidateNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationTaskViewApplicationsQuery_candidateV2_CandidatePermissionDeniedError = { __typename: 'CandidatePermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationTaskViewApplicationsQuery_candidateV2_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationTaskViewApplicationsQuery_candidateV2 = ApplicationTaskViewApplicationsQuery_candidateV2_Candidate | ApplicationTaskViewApplicationsQuery_candidateV2_CandidateNotFoundError | ApplicationTaskViewApplicationsQuery_candidateV2_CandidatePermissionDeniedError | ApplicationTaskViewApplicationsQuery_candidateV2_UnknownError;

export type ApplicationTaskViewApplicationsQuery_Query = { __typename?: 'Query', candidateV2: ApplicationTaskViewApplicationsQuery_candidateV2 };


export type ApplicationTaskViewApplicationsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApplicationTaskViewApplicationsQuery = ApplicationTaskViewApplicationsQuery_Query;

export type ApplicationAnonymizeCandidateMutation_candidateAnonymize_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type ApplicationAnonymizeCandidateMutation_Mutation = { __typename?: 'Mutation', candidateAnonymize: ApplicationAnonymizeCandidateMutation_candidateAnonymize_EmptyResult };


export type ApplicationAnonymizeCandidateMutationVariables = Exact<{
  input: CandidateAnonymizeInput;
}>;


export type ApplicationAnonymizeCandidateMutation = ApplicationAnonymizeCandidateMutation_Mutation;

export type ApplicationDeAnonymizeCandidateMutation_candidateDeAnonymize_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type ApplicationDeAnonymizeCandidateMutation_Mutation = { __typename?: 'Mutation', candidateDeAnonymize: ApplicationDeAnonymizeCandidateMutation_candidateDeAnonymize_EmptyResult };


export type ApplicationDeAnonymizeCandidateMutationVariables = Exact<{
  input: CandidateDeAnonymizeInput;
}>;


export type ApplicationDeAnonymizeCandidateMutation = ApplicationDeAnonymizeCandidateMutation_Mutation;

export type ApplicationDetailsTaskViewQuery_applicationV2_Application_candidate_Candidate_applications_Application = (
  { __typename?: 'Application' }
  & CandidateSecondaryContent_ApplicationsFragment
);

export type ApplicationDetailsTaskViewQuery_applicationV2_Application_candidate_Candidate = (
  { __typename?: 'Candidate', email?: string | null, anonymizedAt?: any | null, applications?: Array<ApplicationDetailsTaskViewQuery_applicationV2_Application_candidate_Candidate_applications_Application> | null }
  & CandidateSecondaryContent_CandidateFragment
  & Candidate_CandidateFragment
);

export type ApplicationDetailsTaskViewQuery_applicationV2_Application = (
  { __typename: 'Application', id: any, candidate?: ApplicationDetailsTaskViewQuery_applicationV2_Application_candidate_Candidate | null }
  & ApplicationContent_ApplicationFragment
  & CandidateSecondaryContent_ApplicationFragment
);

export type ApplicationDetailsTaskViewQuery_applicationV2_ApplicationNotFoundError = { __typename: 'ApplicationNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationDetailsTaskViewQuery_applicationV2_ApplicationPermissionDeniedError = { __typename: 'ApplicationPermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationDetailsTaskViewQuery_applicationV2_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type ApplicationDetailsTaskViewQuery_applicationV2 = ApplicationDetailsTaskViewQuery_applicationV2_Application | ApplicationDetailsTaskViewQuery_applicationV2_ApplicationNotFoundError | ApplicationDetailsTaskViewQuery_applicationV2_ApplicationPermissionDeniedError | ApplicationDetailsTaskViewQuery_applicationV2_UnknownError;

export type ApplicationDetailsTaskViewQuery_Query = { __typename?: 'Query', applicationV2: ApplicationDetailsTaskViewQuery_applicationV2 };


export type ApplicationDetailsTaskViewQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type ApplicationDetailsTaskViewQuery = ApplicationDetailsTaskViewQuery_Query;

export type CandidateAvailabilityOptionsModalQuery_application_Application = (
  { __typename?: 'Application', id: any }
  & CreateTaskDialogPage_ApplicationFragment
);

export type CandidateAvailabilityOptionsModalQuery_thisEmployee_Employee = (
  { __typename?: 'Employee', id: any }
  & EmployeeFragment
);

export type CandidateAvailabilityOptionsModalQuery_Query = { __typename?: 'Query', application?: CandidateAvailabilityOptionsModalQuery_application_Application | null, thisEmployee?: CandidateAvailabilityOptionsModalQuery_thisEmployee_Employee | null };


export type CandidateAvailabilityOptionsModalQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type CandidateAvailabilityOptionsModalQuery = CandidateAvailabilityOptionsModalQuery_Query;

export type CandidateAvailabilityOptionsInterviewPlanQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any }
  & CreateTaskDialogPage_InterviewPlanFragment
  & CloneInterviewPlan_InterviewPlanFragment
  & GetSaveInterviewPlanInput_InterviewPlanFragment
  & CandidateAvailabilityOption_InterviewPlanFragment
);

export type CandidateAvailabilityOptionsInterviewPlanQuery_Query = { __typename?: 'Query', jobStage?: CandidateAvailabilityOptionsInterviewPlanQuery_jobStage_JobStage | null };


export type CandidateAvailabilityOptionsInterviewPlanQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type CandidateAvailabilityOptionsInterviewPlanQuery = CandidateAvailabilityOptionsInterviewPlanQuery_Query;

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration = { __typename?: 'SettingDuration', duration: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration_duration_Duration };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_candidateNote_SettingStringValue = { __typename?: 'SettingStringValue', value: string };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null, externalEmailAddresses?: Array<string> | null };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null, externalEmailAddresses?: Array<string> | null };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_shouldRespectLoadLimit_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bookIfPerfectScheduleFound_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverFreeTime_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_useRollingDays_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration = { __typename?: 'SettingDuration', duration: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration_duration_Duration };

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 = (
  { __typename?: 'JobStageCandidateAvailabilitySettingsV2', numberOfDays: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue, minutesPerDays: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue, minimumTimeBlockMinutes: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue, advanceNotice: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration, candidateNote: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_candidateNote_SettingStringValue, ccRecipients: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference, bccRecipients: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference, shouldRespectLoadLimit: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_shouldRespectLoadLimit_SettingBoolValue, bookIfPerfectScheduleFound: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bookIfPerfectScheduleFound_SettingBoolValue, canScheduleOverRecruitingKeywords: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue, canScheduleOverAvailableKeywords: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue, canScheduleOverFreeTime: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverFreeTime_SettingBoolValue, useRollingDays: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_useRollingDays_SettingBoolValue, timeframe: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration }
  & GetBasicAvailabilityOptionsConfigV2_SettingsFragment
);

export type CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment = (
  { __typename?: 'JobStageSettingsV2', id: any, availabilityRequestEmailTemplateId?: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId | null, candidateAvailabilitySettingsV2?: CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 | null }
  & CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment
);

export type CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2Fragment = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & CandidateAvailabilityOptionsModal_JobStageSettingsV2Fragment
);

export type BaseCandidateAvailabilityOption_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseIsInterviewPlanValid_JobStageFragment
  & UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment
);

export type CandidateAvailabilityOption_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & BaseCandidateAvailabilityOption_InterviewPlanFragment
);

export type TaskInterviewPlanQuery_task_Task_interviewPlan_JobStage = { __typename?: 'JobStage', id: any };

export type TaskInterviewPlanQuery_task_Task = { __typename?: 'Task', interviewPlan: TaskInterviewPlanQuery_task_Task_interviewPlan_JobStage };

export type TaskInterviewPlanQuery_Query = { __typename?: 'Query', task?: TaskInterviewPlanQuery_task_Task | null };


export type TaskInterviewPlanQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TaskInterviewPlanQuery = TaskInterviewPlanQuery_Query;

export type CandidateAvailabilityOptionsDeleteMutation_candidateAvailabilityOptionsDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type CandidateAvailabilityOptionsDeleteMutation_Mutation = { __typename?: 'Mutation', candidateAvailabilityOptionsDelete?: CandidateAvailabilityOptionsDeleteMutation_candidateAvailabilityOptionsDelete_EmptyResult | null };


export type CandidateAvailabilityOptionsDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CandidateAvailabilityOptionsDeleteMutation = CandidateAvailabilityOptionsDeleteMutation_Mutation;

export type CandidateAvailabilityTaskCreateMutation_taskCreate_TaskCreateResult_task_Task = { __typename?: 'Task', id: any };

export type CandidateAvailabilityTaskCreateMutation_taskCreate_TaskCreateResult = { __typename?: 'TaskCreateResult', task: CandidateAvailabilityTaskCreateMutation_taskCreate_TaskCreateResult_task_Task };

export type CandidateAvailabilityTaskCreateMutation_Mutation = { __typename?: 'Mutation', taskCreate?: CandidateAvailabilityTaskCreateMutation_taskCreate_TaskCreateResult | null };


export type CandidateAvailabilityTaskCreateMutationVariables = Exact<{
  input: TaskCreateInput;
}>;


export type CandidateAvailabilityTaskCreateMutation = CandidateAvailabilityTaskCreateMutation_Mutation;

export type CandidateAvailabilityRequestUpsertMutation_candidateAvailabilityOptionsUpsert_CandidateAvailabilityOptionsUpsertResult_options_CandidateAvailabilityOptions = { __typename?: 'CandidateAvailabilityOptions', id: any };

export type CandidateAvailabilityRequestUpsertMutation_candidateAvailabilityOptionsUpsert_CandidateAvailabilityOptionsUpsertResult = { __typename?: 'CandidateAvailabilityOptionsUpsertResult', options?: CandidateAvailabilityRequestUpsertMutation_candidateAvailabilityOptionsUpsert_CandidateAvailabilityOptionsUpsertResult_options_CandidateAvailabilityOptions | null };

export type CandidateAvailabilityRequestUpsertMutation_Mutation = { __typename?: 'Mutation', candidateAvailabilityOptionsUpsert?: CandidateAvailabilityRequestUpsertMutation_candidateAvailabilityOptionsUpsert_CandidateAvailabilityOptionsUpsertResult | null };


export type CandidateAvailabilityRequestUpsertMutationVariables = Exact<{
  input: CandidateAvailabilityOptionsUpsertInput;
}>;


export type CandidateAvailabilityRequestUpsertMutation = CandidateAvailabilityRequestUpsertMutation_Mutation;

export type CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template', id: any }
  & TemplateSelectRow_TemplateFragment
);

export type CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, template?: CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId_template_Template | null };

export type CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bookIfPerfectScheduleFound_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 = { __typename?: 'JobStageCandidateAvailabilitySettingsV2', bookIfPerfectScheduleFound: CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bookIfPerfectScheduleFound_SettingBoolValue };

export type CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment = { __typename?: 'JobStageSettingsV2', id: any, availabilityRequestEmailTemplateId?: CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId | null, candidateAvailabilitySettingsV2?: CandidateAvailabilityEmailPreview_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 | null };

export type GetBasicAvailabilityOptionsConfigV2_SettingsFragment_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type GetBasicAvailabilityOptionsConfigV2_SettingsFragment_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type GetBasicAvailabilityOptionsConfigV2_SettingsFragment_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type GetBasicAvailabilityOptionsConfigV2_SettingsFragment = { __typename?: 'JobStageCandidateAvailabilitySettingsV2', numberOfDays: GetBasicAvailabilityOptionsConfigV2_SettingsFragment_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue, minutesPerDays: GetBasicAvailabilityOptionsConfigV2_SettingsFragment_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue, minimumTimeBlockMinutes: GetBasicAvailabilityOptionsConfigV2_SettingsFragment_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue };

export type GetProvideAvailabilitySettings_JobStageFragment = (
  { __typename?: 'JobStage', id: any }
  & CloneInterviewPlan_InterviewPlanFragment
  & GetSaveInterviewPlanInput_InterviewPlanFragment
);

export type GetProvideAvailabilitySettings_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 = (
  { __typename?: 'JobStageCandidateAvailabilitySettingsV2' }
  & GetBasicAvailabilityOptionsConfigV2_SettingsFragment
);

export type GetProvideAvailabilitySettings_JobStageSettingsV2Fragment = { __typename?: 'JobStageSettingsV2', id: any, candidateAvailabilitySettingsV2?: GetProvideAvailabilitySettings_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 | null };

export type ApplicationActionsQuery_application_Application_upcomingApplicationStage_ApplicationStage = { __typename?: 'ApplicationStage', minStartAt: any };

export type ApplicationActionsQuery_application_Application_applicationStages_ApplicationStage = { __typename?: 'ApplicationStage', id: any };

export type ApplicationActionsQuery_application_Application = { __typename?: 'Application', id: any, status: ApplicationStatus, jobStageId?: any | null, upcomingApplicationStage?: ApplicationActionsQuery_application_Application_upcomingApplicationStage_ApplicationStage | null, applicationStages?: Array<ApplicationActionsQuery_application_Application_applicationStages_ApplicationStage> | null };

export type ApplicationActionsQuery_Query = { __typename?: 'Query', application?: ApplicationActionsQuery_application_Application | null };


export type ApplicationActionsQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type ApplicationActionsQuery = ApplicationActionsQuery_Query;

export type ApplicationStageStatusQuery_application_Application_upcomingApplicationStage_ApplicationStage = { __typename?: 'ApplicationStage', minStartAt: any };

export type ApplicationStageStatusQuery_application_Application_applicationStages_ApplicationStage = (
  { __typename?: 'ApplicationStage', minStartAt: any, maxEndAt: any, isCancelled: boolean, hasInterviewerDeclined: boolean, hasInterviewerTentative: boolean, hasCandidateDeclined: boolean, hasCandidateTentative: boolean }
  & CancelScheduleApplicationStageFragment
);

export type ApplicationStageStatusQuery_application_Application = { __typename?: 'Application', id: any, upcomingApplicationStage?: ApplicationStageStatusQuery_application_Application_upcomingApplicationStage_ApplicationStage | null, applicationStages?: Array<ApplicationStageStatusQuery_application_Application_applicationStages_ApplicationStage> | null };

export type ApplicationStageStatusQuery_Query = { __typename?: 'Query', application?: ApplicationStageStatusQuery_application_Application | null };


export type ApplicationStageStatusQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type ApplicationStageStatusQuery = ApplicationStageStatusQuery_Query;

export type ApplicationStageActionsQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any };

export type ApplicationStageActionsQuery_applicationStage_ApplicationStage_task_Task_debriefs_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any };

export type ApplicationStageActionsQuery_applicationStage_ApplicationStage_task_Task = { __typename?: 'Task', id: any, debriefs: Array<ApplicationStageActionsQuery_applicationStage_ApplicationStage_task_Task_debriefs_ApplicationDebrief> };

export type ApplicationStageActionsQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, isCancelled: boolean, minStartAt: any, maxEndAt: any, hasInterviewerDeclined: boolean, hasCandidateDeclined: boolean, applicationId?: any | null, applicationStageInterviews?: Array<ApplicationStageActionsQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null, task?: ApplicationStageActionsQuery_applicationStage_ApplicationStage_task_Task | null };

export type ApplicationStageActionsQuery_Query = { __typename?: 'Query', applicationStage?: ApplicationStageActionsQuery_applicationStage_ApplicationStage | null };


export type ApplicationStageActionsQueryVariables = Exact<{
  applicationStageId: Scalars['uuid']['input'];
}>;


export type ApplicationStageActionsQuery = ApplicationStageActionsQuery_Query;

export type CandidateApplicationStagesFragment_Application_applicationStages_ApplicationStage = (
  { __typename?: 'ApplicationStage' }
  & CandidateApplicationStageFragment
);

export type CandidateApplicationStagesFragment = (
  { __typename?: 'Application', id: any, applicationStages?: Array<CandidateApplicationStagesFragment_Application_applicationStages_ApplicationStage> | null }
  & CandidateApplicationStagesRowApplicationFragment
);

export type CandidateApplicationStagesQuery_candidate_Candidate_applications_Application = (
  { __typename?: 'Application' }
  & CandidateApplicationStagesFragment
);

export type CandidateApplicationStagesQuery_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, applications?: Array<CandidateApplicationStagesQuery_candidate_Candidate_applications_Application> | null };

export type CandidateApplicationStagesQuery_Query = { __typename?: 'Query', candidate?: CandidateApplicationStagesQuery_candidate_Candidate | null };


export type CandidateApplicationStagesQueryVariables = Exact<{
  input: Scalars['uuid']['input'];
}>;


export type CandidateApplicationStagesQuery = CandidateApplicationStagesQuery_Query;

export type CandidateEventRowFragment = { __typename?: 'ApplicationStageCandidateEvent', id: any, isCancelled?: boolean | null, startAt: any, endAt: any, responseStatus?: ResponseStatus | null, name?: string | null, googleEventId?: string | null, googleEventUrl?: string | null, googleCalendarId?: string | null };

export type CandidateInterviewRowFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type CandidateInterviewRowFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', applicationStageInterviewId: any, interviewerId: any, responseStatus?: ResponseStatus | null, role?: InterviewerRole | null, interviewer?: CandidateInterviewRowFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee | null };

export type CandidateInterviewRowFragment = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any, isCancelled?: boolean | null, name?: string | null, googleEventUrl?: string | null, applicationStageInterviewInterviewers?: Array<CandidateInterviewRowFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null };

export type CandidateApplicationStagesRowApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type CandidateApplicationStagesRowApplicationFragment_Application_upcomingApplicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, minStartAt: any };

export type CandidateApplicationStagesRowApplicationFragment = { __typename?: 'Application', job?: CandidateApplicationStagesRowApplicationFragment_Application_job_Job | null, upcomingApplicationStage?: CandidateApplicationStagesRowApplicationFragment_Application_upcomingApplicationStage_ApplicationStage | null };

export type CandidateApplicationStageFragment_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type CandidateApplicationStageFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview' }
  & CandidateInterviewRowFragment
);

export type CandidateApplicationStageFragment_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent = (
  { __typename?: 'ApplicationStageCandidateEvent' }
  & CandidateEventRowFragment
);

export type CandidateApplicationStageFragment = { __typename?: 'ApplicationStage', id: any, isCancelled: boolean, timezone?: string | null, startAt?: any | null, endAt?: any | null, hasCandidateDeclined: boolean, hasInterviewerDeclined: boolean, hasCandidateTentative: boolean, hasInterviewerTentative: boolean, jobStage?: CandidateApplicationStageFragment_ApplicationStage_jobStage_JobStage | null, applicationStageInterviews?: Array<CandidateApplicationStageFragment_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null, applicationStageCandidateEvents?: Array<CandidateApplicationStageFragment_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent> | null };

export type CancelScheduleApplicationStageFragment_ApplicationStage_cancelScheduleApplicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, startAt: any };

export type CancelScheduleApplicationStageFragment = { __typename?: 'ApplicationStage', id: any, minStartAt: any, maxEndAt: any, jobStageId?: any | null, cancelScheduleApplicationStageInterviews?: Array<CancelScheduleApplicationStageFragment_ApplicationStage_cancelScheduleApplicationStageInterviews_ApplicationStageInterview> | null };

export type CandidateAvailability_AvailabilityFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailability_AvailabilityFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailability_AvailabilityFragment = { __typename?: 'CandidateAvailability', id: any, updatedAt: any, rcEnteredAvailability?: Array<CandidateAvailability_AvailabilityFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null, candidateEnteredAvailability?: Array<CandidateAvailability_AvailabilityFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null };

export type CandidateAvailability_AvailabilityRequestFragment = { __typename?: 'CandidateAvailabilityOptions', id: any, timezone: string, lastCandidateCommunicationSentAt?: any | null };

export type CandidateAvailabilityStatus_ApplicationFragment = { __typename?: 'Application', id: any, status: ApplicationStatus };

export type CandidateAvailabilityStatus_AvailabilityFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailabilityStatus_AvailabilityFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailabilityStatus_AvailabilityFragment_CandidateAvailability_lastUpdatedByEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type CandidateAvailabilityStatus_AvailabilityFragment = { __typename?: 'CandidateAvailability', id: any, employeeUpdatedAt?: any | null, candidateUpdatedAt?: any | null, updatedAt: any, candidateEnteredAvailability?: Array<CandidateAvailabilityStatus_AvailabilityFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<CandidateAvailabilityStatus_AvailabilityFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null, lastUpdatedByEmployee?: CandidateAvailabilityStatus_AvailabilityFragment_CandidateAvailability_lastUpdatedByEmployee_Employee | null };

export type CandidateAvailabilityStatus_AvailabilityRequestFragment = (
  { __typename?: 'CandidateAvailabilityOptions' }
  & RecjectetCandidateAvailabilitySectionAlert_AvailabilityRequestFragment
);

export type EditCandidateAvailabilityModal_AvailabilityFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type EditCandidateAvailabilityModal_AvailabilityFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type EditCandidateAvailabilityModal_AvailabilityFragment_CandidateAvailability_lastUpdatedByEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type EditCandidateAvailabilityModal_AvailabilityFragment = { __typename?: 'CandidateAvailability', id: any, candidateEnteredAvailability?: Array<EditCandidateAvailabilityModal_AvailabilityFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<EditCandidateAvailabilityModal_AvailabilityFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null, lastUpdatedByEmployee?: EditCandidateAvailabilityModal_AvailabilityFragment_CandidateAvailability_lastUpdatedByEmployee_Employee | null };

export type RecjectetCandidateAvailabilitySectionAlert_AvailabilityRequestFragment_CandidateAvailabilityOptions_creator_Employee = { __typename?: 'Employee', fullName?: string | null };

export type RecjectetCandidateAvailabilitySectionAlert_AvailabilityRequestFragment = { __typename?: 'CandidateAvailabilityOptions', id: any, updatedAt: any, lastCandidateCommunicationSentAt?: any | null, creator?: RecjectetCandidateAvailabilitySectionAlert_AvailabilityRequestFragment_CandidateAvailabilityOptions_creator_Employee | null };

export type BaseCandidateAvailabilitySection_ApplicationFragment = (
  { __typename?: 'Application', id: any, status: ApplicationStatus }
  & CandidateAvailabilityStatus_ApplicationFragment
);

export type BaseCandidateAvailabilitySection_AvailabilityFragment_CandidateAvailability_lastUpdatedByEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type BaseCandidateAvailabilitySection_AvailabilityFragment = (
  { __typename?: 'CandidateAvailability', id: any, candidateUpdatedAt?: any | null, lastUpdatedByEmployee?: BaseCandidateAvailabilitySection_AvailabilityFragment_CandidateAvailability_lastUpdatedByEmployee_Employee | null }
  & CandidateAvailability_AvailabilityFragment
  & EditCandidateAvailabilityModal_AvailabilityFragment
);

export type BaseCandidateAvailabilitySection_AvailabilityRequestFragment_CandidateAvailabilityOptions_creator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type BaseCandidateAvailabilitySection_AvailabilityRequestFragment = (
  { __typename?: 'CandidateAvailabilityOptions', id: any, createdAt: any, updatedAt: any, timezone: string, externalId: string, lastCandidateCommunicationSentAt?: any | null, creator?: BaseCandidateAvailabilitySection_AvailabilityRequestFragment_CandidateAvailabilityOptions_creator_Employee | null }
  & CandidateAvailabilityStatus_AvailabilityRequestFragment
  & CandidateAvailability_AvailabilityRequestFragment
);

export type BaseCandidateAvailabilitySection_JobStageSettingsV2Fragment = (
  { __typename?: 'JobStageSettingsV2' }
  & CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2Fragment
);

export type CandidateApplicationIdsQuery_candidateV2_Candidate_applications_Application = { __typename?: 'Application', id: any };

export type CandidateApplicationIdsQuery_candidateV2_Candidate = { __typename: 'Candidate', id: any, applications?: Array<CandidateApplicationIdsQuery_candidateV2_Candidate_applications_Application> | null };

export type CandidateApplicationIdsQuery_candidateV2_CandidateNotFoundError = { __typename: 'CandidateNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type CandidateApplicationIdsQuery_candidateV2_CandidatePermissionDeniedError = { __typename: 'CandidatePermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type CandidateApplicationIdsQuery_candidateV2_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type CandidateApplicationIdsQuery_candidateV2 = CandidateApplicationIdsQuery_candidateV2_Candidate | CandidateApplicationIdsQuery_candidateV2_CandidateNotFoundError | CandidateApplicationIdsQuery_candidateV2_CandidatePermissionDeniedError | CandidateApplicationIdsQuery_candidateV2_UnknownError;

export type CandidateApplicationIdsQuery_Query = { __typename?: 'Query', candidateV2: CandidateApplicationIdsQuery_candidateV2 };


export type CandidateApplicationIdsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CandidateApplicationIdsQuery = CandidateApplicationIdsQuery_Query;

export type JobStageFragmentFragment = { __typename?: 'JobStage', id: any, name: string, jobId: any, schedulable: boolean, atsId?: string | null, index: number };

export type CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_AshbyCandidate = { __typename?: 'AshbyCandidate' };

export type CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_GreenhouseCandidate = { __typename?: 'GreenhouseCandidate' };

export type CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_LeverCandidate = { __typename: 'LeverCandidate', origin?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_WorkdayCandidate = { __typename?: 'WorkdayCandidate' };

export type CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields = CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_AshbyCandidate | CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_GreenhouseCandidate | CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_LeverCandidate | CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields_WorkdayCandidate;

export type CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsId: string, atsUrl: string, atsFields?: CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate_atsFields | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_existingConversations_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string, isArchived: boolean };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_job_Job_sourcers_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_job_Job_hiringManagers_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_job_Job = { __typename?: 'Job', id: any, name: string, atsId: string, atsType: AtsType, location?: Array<string> | null, jobStagesAggregate?: any | null, sourcers?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_job_Job_sourcers_Employee> | null, hiringManagers?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_job_Job_hiringManagers_Employee> | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, jobId: any, schedulable: boolean, atsId?: string | null, index: number };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_creator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, index: number };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent = { __typename?: 'ApplicationStageCandidateEvent', id: any, startAt: any, endAt: any, responseStatus?: ResponseStatus | null, googleEventUrl?: string | null, isCancelled?: boolean | null, name?: string | null, googleEventId?: string | null, googleCalendarId?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', role?: InterviewerRole | null, isOptional: boolean, interviewerId: any, responseStatus?: ResponseStatus | null, applicationStageInterviewId: any, interviewer?: CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom_meetingRoom_MeetingRoom = { __typename?: 'MeetingRoom', id: string, name?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom = { __typename?: 'ApplicationStageInterviewRoom', applicationStageInterviewId: any, meetingRoomId: any, responseStatus?: ResponseStatus | null, meetingRoom?: CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom_meetingRoom_MeetingRoom | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any, name?: string | null, calendarEventTitle?: string | null, isCancelled?: boolean | null, googleEventId?: string | null, googleEventUrl?: string | null, googleCalendarId?: string | null, applicationStageInterviewInterviewers?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null, applicationStageInterviewRooms?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom> | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage = { __typename?: 'ApplicationStage', id: any, startAt?: any | null, endAt?: any | null, createdAt: any, updatedAt: any, name?: string | null, timezone?: string | null, selfScheduleOptionsId?: any | null, jobStageId?: any | null, isHoldForRsvp: boolean, isReadyForCandidateComms: boolean, hasCandidateTentative: boolean, hasInterviewerTentative: boolean, isCancelled: boolean, hasCandidateDeclined: boolean, hasInterviewerDeclined: boolean, creator?: CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_creator_Employee | null, jobStage?: CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_jobStage_JobStage | null, applicationStageCandidateEvents?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent> | null, applicationStageInterviews?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee = { __typename?: 'ApplicationDebriefAttendee', interviewerId: any, responseStatus?: ResponseStatus | null, isOptional: boolean, interviewer?: CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee_interviewer_Employee | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief_meetingRooms_ApplicationDebriefRoom = { __typename?: 'ApplicationDebriefRoom', applicationDebriefId: any, meetingRoomId: any, responseStatus?: ResponseStatus | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any, startAt?: any | null, endAt?: any | null, isCancelled?: boolean | null, isPrivateCalendarEvent?: boolean | null, attendees?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee> | null, meetingRooms?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief_meetingRooms_ApplicationDebriefRoom> | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_state_ApplicationState = { __typename?: 'ApplicationState', isSchedulable?: boolean | null, isNotScheduleable?: boolean | null, isUnscheduled?: boolean | null, isAvailabilityRequested?: boolean | null, isReadyToSchedule?: boolean | null, isCanceled?: boolean | null, isOngoing?: boolean | null, isScheduled?: boolean | null, isCompleted?: boolean | null, isScheduledInAts?: boolean | null, isCompletedInAts?: boolean | null, isCandidateDeclined?: boolean | null, isInterviewerDeclined?: boolean | null, isSelfScheduleRequested?: boolean | null, isHoldForRsvp?: boolean | null, isReadyForCandidateComms?: boolean | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_upcomingApplicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application_upcomingApplicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, startAt?: any | null, endAt?: any | null, selfScheduleOptionsId?: any | null, minStartAt: any, applicationStageInterviews?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_upcomingApplicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type CandidateDetailsQuery_candidate_Candidate_applications_Application = (
  { __typename?: 'Application', id: any, status: ApplicationStatus, existingConversations?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_existingConversations_Conversation> | null, job?: CandidateDetailsQuery_candidate_Candidate_applications_Application_job_Job | null, jobStage?: CandidateDetailsQuery_candidate_Candidate_applications_Application_jobStage_JobStage | null, applicationStages?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationStages_ApplicationStage> | null, applicationDebriefs?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application_applicationDebriefs_ApplicationDebrief> | null, state?: CandidateDetailsQuery_candidate_Candidate_applications_Application_state_ApplicationState | null, upcomingApplicationStage?: CandidateDetailsQuery_candidate_Candidate_applications_Application_upcomingApplicationStage_ApplicationStage | null }
  & ApplicationNote_ApplicationFragment
);

export type CandidateDetailsQuery_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, lastActivityAt?: any | null, email?: string | null, familyName?: string | null, givenName?: string | null, atsId?: string | null, atsType?: AtsType | null, linkedinUrl?: string | null, phoneNumbers?: Array<string> | null, pronoun?: string | null, timezone?: string | null, updatedAt?: any | null, additionalEmails?: Array<string> | null, atsCandidate?: CandidateDetailsQuery_candidate_Candidate_atsCandidate_AtsCandidate | null, applications?: Array<CandidateDetailsQuery_candidate_Candidate_applications_Application> | null };

export type CandidateDetailsQuery_Query = { __typename?: 'Query', candidate?: CandidateDetailsQuery_candidate_Candidate | null };


export type CandidateDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CandidateDetailsQuery = CandidateDetailsQuery_Query;

export type JobStageDetailsQuery_jobStages_JobStagesOutput_items_JobStage = (
  { __typename?: 'JobStage' }
  & JobStageFragmentFragment
);

export type JobStageDetailsQuery_jobStages_JobStagesOutput = { __typename?: 'JobStagesOutput', items: Array<JobStageDetailsQuery_jobStages_JobStagesOutput_items_JobStage> };

export type JobStageDetailsQuery_Query = { __typename?: 'Query', jobStages?: JobStageDetailsQuery_jobStages_JobStagesOutput | null };


export type JobStageDetailsQueryVariables = Exact<{
  input: JobStagesInput;
}>;


export type JobStageDetailsQuery = JobStageDetailsQuery_Query;

export type JobStageUpdatedAtQuery_jobStage_JobStage = { __typename?: 'JobStage', id: any, updatedAt: any };

export type JobStageUpdatedAtQuery_Query = { __typename?: 'Query', jobStage?: JobStageUpdatedAtQuery_jobStage_JobStage | null };


export type JobStageUpdatedAtQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobStageUpdatedAtQuery = JobStageUpdatedAtQuery_Query;

export type CandidateAvailabilityFragmentFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailabilityFragmentFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailabilityFragmentFragment_CandidateAvailability_lastUpdatedByEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type CandidateAvailabilityFragmentFragment = { __typename?: 'CandidateAvailability', id: any, createdAt: any, updatedAt: any, lastUpdatedByEmployeeId?: any | null, employeeUpdatedAt?: any | null, candidateUpdatedAt?: any | null, candidateEnteredAvailability?: Array<CandidateAvailabilityFragmentFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<CandidateAvailabilityFragmentFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null, lastUpdatedByEmployee?: CandidateAvailabilityFragmentFragment_CandidateAvailability_lastUpdatedByEmployee_Employee | null };

export type ConfidentialJobByJobStageQuery_jobStage_JobStage_job_Job = { __typename?: 'Job', isConfidential: boolean, id: any };

export type ConfidentialJobByJobStageQuery_jobStage_JobStage = { __typename?: 'JobStage', job?: ConfidentialJobByJobStageQuery_jobStage_JobStage_job_Job | null };

export type ConfidentialJobByJobStageQuery_Query = { __typename?: 'Query', jobStage?: ConfidentialJobByJobStageQuery_jobStage_JobStage | null };


export type ConfidentialJobByJobStageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ConfidentialJobByJobStageQuery = ConfidentialJobByJobStageQuery_Query;

export type ConfidentialJobByApplicationQuery_application_Application_job_Job = { __typename?: 'Job', isConfidential: boolean, id: any };

export type ConfidentialJobByApplicationQuery_application_Application = { __typename?: 'Application', job?: ConfidentialJobByApplicationQuery_application_Application_job_Job | null };

export type ConfidentialJobByApplicationQuery_Query = { __typename?: 'Query', application?: ConfidentialJobByApplicationQuery_application_Application | null };


export type ConfidentialJobByApplicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ConfidentialJobByApplicationQuery = ConfidentialJobByApplicationQuery_Query;

export type QuickTaskBulkItemMutation_taskQuickCreate_TaskQuickCreateResult = { __typename?: 'TaskQuickCreateResult', taskId: any };

export type QuickTaskBulkItemMutation_Mutation = { __typename?: 'Mutation', taskQuickCreate: QuickTaskBulkItemMutation_taskQuickCreate_TaskQuickCreateResult };


export type QuickTaskBulkItemMutationVariables = Exact<{
  input: TaskQuickCreateInput;
}>;


export type QuickTaskBulkItemMutation = QuickTaskBulkItemMutation_Mutation;

export type ActionReadyCandidateRow_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type ActionReadyCandidateRow_ApplicationFragment_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, defaultTask?: TaskCreationSource | null };

export type ActionReadyCandidateRow_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, jobStageSettingsV2?: ActionReadyCandidateRow_ApplicationFragment_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ActionReadyCandidateRow_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, email?: string | null };

export type ActionReadyCandidateRow_ApplicationFragment = { __typename?: 'Application', id: any, job?: ActionReadyCandidateRow_ApplicationFragment_Application_job_Job | null, jobStage?: ActionReadyCandidateRow_ApplicationFragment_Application_jobStage_JobStage | null, candidate?: ActionReadyCandidateRow_ApplicationFragment_Application_candidate_Candidate | null };

export type ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput_items_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, defaultTask?: TaskCreationSource | null };

export type ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput_items_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput_items_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput_items_Application = (
  { __typename?: 'Application', id: any, jobStage?: ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput_items_Application_jobStage_JobStage | null }
  & ActionReadyCandidateRow_ApplicationFragment
);

export type ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput = { __typename?: 'ApplicationSearchOutput', hasNext: boolean, nextOffset: number, items: Array<ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput_items_Application> };

export type ActionReadyCandidatesTableQuery_Query = { __typename?: 'Query', applicationSearch?: ActionReadyCandidatesTableQuery_applicationSearch_ApplicationSearchOutput | null };


export type ActionReadyCandidatesTableQueryVariables = Exact<{
  input: ApplicationSearchInput;
}>;


export type ActionReadyCandidatesTableQuery = ActionReadyCandidatesTableQuery_Query;

export type AllCandidateTable_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type AllCandidateTable_ApplicationFragment_Application_recruiter_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type AllCandidateTable_ApplicationFragment_Application_coordinator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type AllCandidateTable_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type AllCandidateTable_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type AllCandidateTable_ApplicationFragment = { __typename?: 'Application', id: any, status: ApplicationStatus, currentJobStageActiveTaskCount: number, candidate?: AllCandidateTable_ApplicationFragment_Application_candidate_Candidate | null, recruiter?: AllCandidateTable_ApplicationFragment_Application_recruiter_Employee | null, coordinator?: AllCandidateTable_ApplicationFragment_Application_coordinator_Employee | null, job?: AllCandidateTable_ApplicationFragment_Application_job_Job | null, jobStage?: AllCandidateTable_ApplicationFragment_Application_jobStage_JobStage | null };

export type CandidateListV2Query_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any };

export type CandidateListV2Query_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, startAt?: any | null, endAt?: any | null, selfScheduleOptionsId?: any | null, minStartAt: any, applicationStageInterviews?: Array<CandidateListV2Query_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type CandidateListV2Query_applicationSearch_ApplicationSearchOutput_items_Application = (
  { __typename?: 'Application', upcomingApplicationStage?: CandidateListV2Query_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage | null }
  & AllCandidateTable_ApplicationFragment
);

export type CandidateListV2Query_applicationSearch_ApplicationSearchOutput = { __typename?: 'ApplicationSearchOutput', hasNext: boolean, nextOffset: number, items: Array<CandidateListV2Query_applicationSearch_ApplicationSearchOutput_items_Application> };

export type CandidateListV2Query_Query = { __typename?: 'Query', applicationSearch?: CandidateListV2Query_applicationSearch_ApplicationSearchOutput | null };


export type CandidateListV2QueryVariables = Exact<{
  input: ApplicationSearchInput;
}>;


export type CandidateListV2Query = CandidateListV2Query_Query;

export type CandidateListQuery_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any };

export type CandidateListQuery_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, startAt?: any | null, endAt?: any | null, selfScheduleOptionsId?: any | null, minStartAt: any, applicationStageInterviews?: Array<CandidateListQuery_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type CandidateListQuery_applicationSearch_ApplicationSearchOutput_items_Application = (
  { __typename?: 'Application', upcomingApplicationStage?: CandidateListQuery_applicationSearch_ApplicationSearchOutput_items_Application_upcomingApplicationStage_ApplicationStage | null }
  & ApplicationItem_ApplicationFragment
);

export type CandidateListQuery_applicationSearch_ApplicationSearchOutput = { __typename?: 'ApplicationSearchOutput', hasNext: boolean, nextOffset: number, items: Array<CandidateListQuery_applicationSearch_ApplicationSearchOutput_items_Application> };

export type CandidateListQuery_Query = { __typename?: 'Query', applicationSearch?: CandidateListQuery_applicationSearch_ApplicationSearchOutput | null };


export type CandidateListQueryVariables = Exact<{
  input: ApplicationSearchInput;
}>;


export type CandidateListQuery = CandidateListQuery_Query;

export type CandidatePageFiltersEmployeePrefFragment = { __typename?: 'CandidatePageFiltersPref', coordinatorEmployeeIds: Array<any>, jobIds: Array<any>, jobStageNames: Array<string>, recruiterEmployeeIds: Array<any>, showInactiveApplications: boolean };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = (
  { __typename?: 'CandidatePageFiltersPref' }
  & CandidatePageFiltersEmployeePrefFragment
);

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref = UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref | null };

export type UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type UpdateCandidatePageFiltersEmployeePrefMutation_Mutation = { __typename?: 'Mutation', employeePrefUpdate?: UpdateCandidatePageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult | null };


export type UpdateCandidatePageFiltersEmployeePrefMutationVariables = Exact<{
  input: EmployeePrefUpdateInput;
}>;


export type UpdateCandidatePageFiltersEmployeePrefMutation = UpdateCandidatePageFiltersEmployeePrefMutation_Mutation;

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = (
  { __typename?: 'CandidatePageFiltersPref' }
  & CandidatePageFiltersEmployeePrefFragment
);

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref = CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref | null };

export type CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, employeePref?: CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref | null };

export type CandidatePageFiltersEmployeePrefQuery_Query = { __typename?: 'Query', thisEmployee?: CandidatePageFiltersEmployeePrefQuery_thisEmployee_Employee | null };


export type CandidatePageFiltersEmployeePrefQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type CandidatePageFiltersEmployeePrefQuery = CandidatePageFiltersEmployeePrefQuery_Query;

export type EmployeeDataBulkUpsertMutation_employeeDataBulkUpsert_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type EmployeeDataBulkUpsertMutation_Mutation = { __typename?: 'Mutation', employeeDataBulkUpsert?: EmployeeDataBulkUpsertMutation_employeeDataBulkUpsert_EmptyResult | null };


export type EmployeeDataBulkUpsertMutationVariables = Exact<{
  name: Scalars['String']['input'];
  path: Scalars['String']['input'];
  dataType: EmployeeBulkUploadDataType;
}>;


export type EmployeeDataBulkUpsertMutation = EmployeeDataBulkUpsertMutation_Mutation;

export type CalendarPermissionsQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidateId: any };

export type CalendarPermissionsQuery_applicationStage_ApplicationStage_creator_Employee = { __typename?: 'Employee', id: any, orgId: any, email: string, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_calendar_Calendar = { __typename?: 'Calendar', name?: string | null, canActorWriteToCalendar?: boolean | null };

export type CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent = { __typename?: 'ApplicationStageCandidateEvent', googleCalendarId?: string | null, startAt: any, endAt: any, name?: string | null, googleEventId?: string | null, calendar?: CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent_calendar_Calendar | null };

export type CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_calendar_Calendar = { __typename?: 'Calendar', id?: string | null, name?: string | null, remoteId?: string | null, employeeId?: string | null, canActorWriteToCalendar?: boolean | null };

export type CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', calendarEventTitle?: string | null, googleCalendarId?: string | null, id: any, name?: string | null, startAt: any, endAt: any, calendar?: CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_calendar_Calendar | null };

export type CalendarPermissionsQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, application?: CalendarPermissionsQuery_applicationStage_ApplicationStage_application_Application | null, creator?: CalendarPermissionsQuery_applicationStage_ApplicationStage_creator_Employee | null, applicationStageCandidateEvents?: Array<CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent> | null, applicationStageInterviews?: Array<CalendarPermissionsQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type CalendarPermissionsQuery_Query = { __typename?: 'Query', applicationStage?: CalendarPermissionsQuery_applicationStage_ApplicationStage | null };


export type CalendarPermissionsQueryVariables = Exact<{
  applicationStageId: Scalars['uuid']['input'];
}>;


export type CalendarPermissionsQuery = CalendarPermissionsQuery_Query;

export type ApprovalFeedback_FeedbackFragment_ApplicationStageInterviewFeedback_reviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type ApprovalFeedback_FeedbackFragment = { __typename?: 'ApplicationStageInterviewFeedback', reviewerId?: any | null, decisionType?: GraduationApproverDecisionType | null, reviewedAt?: any | null, reviewer?: ApprovalFeedback_FeedbackFragment_ApplicationStageInterviewFeedback_reviewer_Employee | null };

export type ApprovalFeedback_TraineeFeedbackFragment = (
  { __typename?: 'ApplicationStageInterviewFeedback' }
  & ApprovalFeedback_FeedbackFragment
);

export type ApprovalFeedback_TrainedFeedbackFragment = (
  { __typename?: 'ApplicationStageInterviewFeedback' }
  & ApprovalFeedback_FeedbackFragment
);

export type ApprovalFeedback_SchedulerFeedbackFragment = (
  { __typename?: 'ApplicationStageInterviewFeedback' }
  & ApprovalFeedback_FeedbackFragment
);

export type SlackFeedbackNagMutation_trainingFeedbackReminderNag_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any };

export type SlackFeedbackNagMutation_trainingFeedbackReminderNag_InterviewModuleMemberResult = { __typename?: 'InterviewModuleMemberResult', interviewModuleMember?: SlackFeedbackNagMutation_trainingFeedbackReminderNag_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember | null };

export type SlackFeedbackNagMutation_Mutation = { __typename?: 'Mutation', trainingFeedbackReminderNag?: SlackFeedbackNagMutation_trainingFeedbackReminderNag_InterviewModuleMemberResult | null };


export type SlackFeedbackNagMutationVariables = Exact<{
  input: TrainingFeedbackReminderNagInput;
}>;


export type SlackFeedbackNagMutation = SlackFeedbackNagMutation_Mutation;

export type Interviewfeedback_InterviewfeedbackFragment_ApplicationStageInterviewFeedback_reviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type Interviewfeedback_InterviewfeedbackFragment = { __typename?: 'ApplicationStageInterviewFeedback', decisionType?: GraduationApproverDecisionType | null, note?: string | null, reviewerId?: any | null, reviewedAt?: any | null, reviewer?: Interviewfeedback_InterviewfeedbackFragment_ApplicationStageInterviewFeedback_reviewer_Employee | null };

export type InterviewLogInterview_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any };

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', responseStatus?: ResponseStatus | null, interviewerId: any };

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null, job?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_job_Job | null, jobStage?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_jobStage_JobStage | null };

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, taskId?: any | null, application?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application | null };

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_traineeFeedback_ApplicationStageInterviewFeedback = (
  { __typename?: 'ApplicationStageInterviewFeedback' }
  & Interviewfeedback_InterviewfeedbackFragment
  & ApprovalFeedback_TraineeFeedbackFragment
);

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_trainedFeedback_ApplicationStageInterviewFeedback = (
  { __typename?: 'ApplicationStageInterviewFeedback' }
  & Interviewfeedback_InterviewfeedbackFragment
  & ApprovalFeedback_TrainedFeedbackFragment
);

export type InterviewLogInterview_InterviewFragment_ApplicationStageInterview_schedulerFeedback_ApplicationStageInterviewFeedback = (
  { __typename?: 'ApplicationStageInterviewFeedback' }
  & Interviewfeedback_InterviewfeedbackFragment
  & ApprovalFeedback_SchedulerFeedbackFragment
);

export type InterviewLogInterview_InterviewFragment = { __typename?: 'ApplicationStageInterview', id: any, name?: string | null, startAt: any, endAt: any, googleEventUrl?: string | null, isHiddenFromCandidate: boolean, applicationStageInterviewInterviewers?: Array<InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null, applicationStage?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage | null, traineeFeedback?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_traineeFeedback_ApplicationStageInterviewFeedback | null, trainedFeedback?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_trainedFeedback_ApplicationStageInterviewFeedback | null, schedulerFeedback?: InterviewLogInterview_InterviewFragment_ApplicationStageInterview_schedulerFeedback_ApplicationStageInterviewFeedback | null };

export type InterviewLog_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any }
  & InterviewLogInterview_ModuleMemberFragment
);

export type InterviewLog_InterviewLogFragment_ModuleMemberApplicationStageInterviewLog_applicationStageInterview_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview' }
  & InterviewLogInterview_InterviewFragment
);

type InterviewLog_InterviewLog_ModuleMemberApplicationStageInterviewLog_Fragment = { __typename: 'ModuleMemberApplicationStageInterviewLog', id: any, trainingRole: TrainingStatus, applicationStageInterview: InterviewLog_InterviewLogFragment_ModuleMemberApplicationStageInterviewLog_applicationStageInterview_ApplicationStageInterview };

type InterviewLog_InterviewLog_ModuleMemberManualLog_Fragment = { __typename: 'ModuleMemberManualLog', id: any, trainingRole: TrainingStatus };

export type InterviewLog_InterviewLogFragment = InterviewLog_InterviewLog_ModuleMemberApplicationStageInterviewLog_Fragment | InterviewLog_InterviewLog_ModuleMemberManualLog_Fragment;

export type InterviewModuleMemberHeader_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type InterviewModuleMemberHeader_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type InterviewModuleMemberHeader_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, status: TrainingStatus, employee?: InterviewModuleMemberHeader_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null, interviewModule?: InterviewModuleMemberHeader_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule | null }
  & ModuleMemberPausedChip_ModuleMemberFragment
  & ModuleMemberPendingChip_ModuleMemberFragment
);

export type InterviewModuleMemberKeyDates_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type InterviewModuleMemberKeyDates_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type InterviewModuleMemberKeyDates_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, shadowStartAt?: any | null, reverseShadowStartAt?: any | null, shadowsRequired: number, reverseShadowsRequired: number, status: TrainingStatus, createdAt?: any | null, trainedAt?: any | null, timeToTrain?: any | null, employee?: InterviewModuleMemberKeyDates_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null, interviewModule?: InterviewModuleMemberKeyDates_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule | null }
  & EditKeyDatesModal_ModuleMemberFragment
);

export type AddModuleLog_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsReverseShadow?: any | null, completedAsShadow?: any | null, manualCompletedAsReverseShadow: any, manualCompletedAsShadow: any };

export type AddModuleLog_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any, shadowsRequired: number, status: TrainingStatus, reverseShadowsRequired: number, stats?: AddModuleLog_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & EditTrainigPlan_ModuleMemberFragment
  & GetReverseShadowPendingCount_ModuleMemberFragment
);

export type InterviewModuleMemberLogCreateMutation_interviewModuleMemberLogCreate_InterviewModuleMemberManualLogResult_interviewModuleMemberManualLog_InterviewModuleMemberManualLog = { __typename?: 'InterviewModuleMemberManualLog', id: any };

export type InterviewModuleMemberLogCreateMutation_interviewModuleMemberLogCreate_InterviewModuleMemberManualLogResult = { __typename?: 'InterviewModuleMemberManualLogResult', interviewModuleMemberManualLog?: InterviewModuleMemberLogCreateMutation_interviewModuleMemberLogCreate_InterviewModuleMemberManualLogResult_interviewModuleMemberManualLog_InterviewModuleMemberManualLog | null };

export type InterviewModuleMemberLogCreateMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberLogCreate?: InterviewModuleMemberLogCreateMutation_interviewModuleMemberLogCreate_InterviewModuleMemberManualLogResult | null };


export type InterviewModuleMemberLogCreateMutationVariables = Exact<{
  input: InterviewModuleMemberLogCreateInput;
}>;


export type InterviewModuleMemberLogCreateMutation = InterviewModuleMemberLogCreateMutation_Mutation;

export type AddToTrainingPlan_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsShadow?: any | null, completedAsReverseShadow?: any | null, manualCompletedAsShadow: any, manualCompletedAsReverseShadow: any };

export type AddToTrainingPlan_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, shadowsRequired: number, reverseShadowsRequired: number, stats?: AddToTrainingPlan_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

type DeleteModuleLogModal_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment = { __typename?: 'ModuleMemberApplicationStageInterviewLog', id: any, trainingRole: TrainingStatus, status: ModuleMemberInterviewStatus };

type DeleteModuleLogModal_ModuleMemberInterview_ModuleMemberManualLog_Fragment = { __typename?: 'ModuleMemberManualLog', id: any, trainingRole: TrainingStatus, status: ModuleMemberInterviewStatus };

export type DeleteModuleLogModal_ModuleMemberInterviewFragment = DeleteModuleLogModal_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment | DeleteModuleLogModal_ModuleMemberInterview_ModuleMemberManualLog_Fragment;

export type DeleteModuleLogModal_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsShadow?: any | null, manualCompletedAsShadow: any };

export type DeleteModuleLogModal_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, shadowsRequired: number, status: TrainingStatus, stats?: DeleteModuleLogModal_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

export type InterviewModuleMemberLogDeleteMutation_interviewModuleMemberLogDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type InterviewModuleMemberLogDeleteMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberLogDelete?: InterviewModuleMemberLogDeleteMutation_interviewModuleMemberLogDelete_EmptyResult | null };


export type InterviewModuleMemberLogDeleteMutationVariables = Exact<{
  input: InterviewModuleMemberLogDeleteInput;
}>;


export type InterviewModuleMemberLogDeleteMutation = InterviewModuleMemberLogDeleteMutation_Mutation;

export type EditKeyDatesModal_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, trainedAt?: any | null, createdAt?: any | null };

export type EditTrainigPlan_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsReverseShadow?: any | null, completedAsShadow?: any | null, manualCompletedAsShadow: any, manualCompletedAsReverseShadow: any };

export type EditTrainigPlan_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, shadowsRequired: any, reverseShadowsRequired: any, shouldFastTrackTraining: boolean, graduateFromShadowApprovalType: GraduationApprovalType, graduateFromReverseShadowApprovalType: GraduationApprovalType };

export type EditTrainigPlan_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, status: TrainingStatus, shadowsRequired: number, reverseShadowsRequired: number, stats?: EditTrainigPlan_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null, interviewModule?: EditTrainigPlan_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule | null };

export type PauseMemberModalInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & PauseMemberModal_ModuleMemberFragment
);

export type PauseMemberModalInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult = { __typename?: 'InterviewModuleMemberResult', interviewModuleMember?: PauseMemberModalInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember | null };

export type PauseMemberModalInterviewModuleMemberUpdateMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberUpdate?: PauseMemberModalInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult | null };


export type PauseMemberModalInterviewModuleMemberUpdateMutationVariables = Exact<{
  input: InterviewModuleMemberUpdateInput;
}>;


export type PauseMemberModalInterviewModuleMemberUpdateMutation = PauseMemberModalInterviewModuleMemberUpdateMutation_Mutation;

export type PauseMemberModal_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, timezone?: string | null };

export type PauseMemberModal_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any, isPausedIndefinitely?: boolean | null, isPaused?: boolean | null, pausedUntil?: any | null, employee?: PauseMemberModal_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null };

export type RemoveMemberModal_InterviewModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', upcoming?: any | null };

export type RemoveMemberModal_InterviewModuleMemberFragment = { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, stats?: RemoveMemberModal_InterviewModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

export type InterviewModuleDeleteMemberMutation_interviewModuleRemoveMembers_InterviewModuleResult_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any };

export type InterviewModuleDeleteMemberMutation_interviewModuleRemoveMembers_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: InterviewModuleDeleteMemberMutation_interviewModuleRemoveMembers_InterviewModuleResult_interviewModule_InterviewModule | null };

export type InterviewModuleDeleteMemberMutation_Mutation = { __typename?: 'Mutation', interviewModuleRemoveMembers?: InterviewModuleDeleteMemberMutation_interviewModuleRemoveMembers_InterviewModuleResult | null };


export type InterviewModuleDeleteMemberMutationVariables = Exact<{
  input: InterviewModuleRemoveMembersInput;
}>;


export type InterviewModuleDeleteMemberMutation = InterviewModuleDeleteMemberMutation_Mutation;

export type SetModuleMemberAsTrained_InterviewModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', upcoming?: any | null };

export type SetModuleMemberAsTrained_InterviewModuleMemberFragment = { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, stats?: SetModuleMemberAsTrained_InterviewModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

export type SetModuleMemberAsTrainee_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', upcoming?: any | null };

export type SetModuleMemberAsTrainee_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any, stats?: SetModuleMemberAsTrainee_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & AddToTrainingPlan_ModuleMemberFragment
);

export type InterviewModuleMemberLogUpdateMutation_interviewModuleMemberLogUpdate_InterviewModuleMemberManualLogResult_interviewModuleMemberManualLog_InterviewModuleMemberManualLog = { __typename?: 'InterviewModuleMemberManualLog', id: any };

export type InterviewModuleMemberLogUpdateMutation_interviewModuleMemberLogUpdate_InterviewModuleMemberManualLogResult = { __typename?: 'InterviewModuleMemberManualLogResult', interviewModuleMemberManualLog?: InterviewModuleMemberLogUpdateMutation_interviewModuleMemberLogUpdate_InterviewModuleMemberManualLogResult_interviewModuleMemberManualLog_InterviewModuleMemberManualLog | null };

export type InterviewModuleMemberLogUpdateMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberLogUpdate?: InterviewModuleMemberLogUpdateMutation_interviewModuleMemberLogUpdate_InterviewModuleMemberManualLogResult | null };


export type InterviewModuleMemberLogUpdateMutationVariables = Exact<{
  input: InterviewModuleMemberLogUpdateInput;
}>;


export type InterviewModuleMemberLogUpdateMutation = InterviewModuleMemberLogUpdateMutation_Mutation;

export type ApplicationStageInterviewInterviewerUpdateMutation_applicationStageInterviewInterviewerUpdate_ApplicationStageInterviewInterviewerResult = { __typename?: 'ApplicationStageInterviewInterviewerResult', result?: Result | null };

export type ApplicationStageInterviewInterviewerUpdateMutation_Mutation = { __typename?: 'Mutation', applicationStageInterviewInterviewerUpdate?: ApplicationStageInterviewInterviewerUpdateMutation_applicationStageInterviewInterviewerUpdate_ApplicationStageInterviewInterviewerResult | null };


export type ApplicationStageInterviewInterviewerUpdateMutationVariables = Exact<{
  input: ApplicationStageInterviewInterviewerUpdateInput;
}>;


export type ApplicationStageInterviewInterviewerUpdateMutation = ApplicationStageInterviewInterviewerUpdateMutation_Mutation;

export type UpdateModuleLogModal_ModuleMemberInterviewFragment_ModuleMemberApplicationStageInterviewLog_applicationStageInterview_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any };

type UpdateModuleLogModal_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment = (
  { __typename: 'ModuleMemberApplicationStageInterviewLog', id: any, interviewDate: any, trainingRole: TrainingStatus, status: ModuleMemberInterviewStatus, applicationStageInterview: UpdateModuleLogModal_ModuleMemberInterviewFragment_ModuleMemberApplicationStageInterviewLog_applicationStageInterview_ApplicationStageInterview }
  & DeleteModuleLogModal_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment
);

type UpdateModuleLogModal_ModuleMemberInterview_ModuleMemberManualLog_Fragment = (
  { __typename: 'ModuleMemberManualLog', id: any, interviewDate: any, trainingRole: TrainingStatus, status: ModuleMemberInterviewStatus }
  & DeleteModuleLogModal_ModuleMemberInterview_ModuleMemberManualLog_Fragment
);

export type UpdateModuleLogModal_ModuleMemberInterviewFragment = UpdateModuleLogModal_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment | UpdateModuleLogModal_ModuleMemberInterview_ModuleMemberManualLog_Fragment;

export type UpdateModuleLogModal_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completedAsShadow?: any | null, completedAsReverseShadow?: any | null, manualCompletedAsShadow: any, manualCompletedAsReverseShadow: any };

export type UpdateModuleLogModal_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any, shadowsRequired: number, status: TrainingStatus, reverseShadowsRequired: number, stats?: UpdateModuleLogModal_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & DeleteModuleLogModal_ModuleMemberFragment
  & GetReverseShadowCompletedCount_ModuleMemberFragment
);

export type ModuleLoadPauseRow_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type ModuleLoadPauseRow_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, isPaused: boolean, timezone?: string | null, interviewPauseDates?: Array<ModuleLoadPauseRow_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock> | null };

export type ModuleLoadPauseRow_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, weeklyNumInterviewLimit?: any | null, employee?: ModuleLoadPauseRow_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null }
  & PauseMemberModal_ModuleMemberFragment
  & IsModuleMemberEmployeePaused_ModuleMemberFragment
  & IsModuleMembreOrEmployeePaused_ModuleMemberFragment
  & IsModuleMemberPauseIndefinitely_ModuleMemberFragment
);

export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & ModuleLoadPauseRow_ModuleMemberFragment
);

export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult = { __typename?: 'InterviewModuleMemberResult', interviewModuleMember?: ModuleLoadPauseRowInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember | null };

export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberUpdate?: ModuleLoadPauseRowInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult | null };


export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutationVariables = Exact<{
  input: InterviewModuleMemberUpdateInput;
}>;


export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutation = ModuleLoadPauseRowInterviewModuleMemberUpdateMutation_Mutation;

export type ModuleLoad_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type ModuleLoad_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, isPaused: boolean, timezone?: string | null, interviewPauseDates?: Array<ModuleLoad_ModuleMemberFragment_InterviewModuleMember_employee_Employee_interviewPauseDates_DateBlock> | null };

export type ModuleLoad_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, weeklyNumInterviewLimit?: any | null, employee?: ModuleLoad_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null }
  & PauseMemberModal_ModuleMemberFragment
  & ModuleLoadPauseRow_ModuleMemberFragment
  & IsModuleMemberEmployeePaused_ModuleMemberFragment
  & IsModuleMembreOrEmployeePaused_ModuleMemberFragment
  & IsModuleMemberPauseIndefinitely_ModuleMemberFragment
  & GetModuleMemberEmployeePausedText_ModuleMemberFragment
  & GetModuleMemberPauseText_ModuleMemberFragment
);

export type ModuleLoadInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & ModuleLoad_ModuleMemberFragment
);

export type ModuleLoadInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult = { __typename?: 'InterviewModuleMemberResult', interviewModuleMember?: ModuleLoadInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember | null };

export type ModuleLoadInterviewModuleMemberUpdateMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberUpdate?: ModuleLoadInterviewModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult | null };


export type ModuleLoadInterviewModuleMemberUpdateMutationVariables = Exact<{
  input: InterviewModuleMemberUpdateInput;
}>;


export type ModuleLoadInterviewModuleMemberUpdateMutation = ModuleLoadInterviewModuleMemberUpdateMutation_Mutation;

export type InterviewModuleMemberModuleLogRow_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type InterviewModuleMemberModuleLogRow_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, employeeId: any, status: TrainingStatus, interviewModuleId: any, stats?: InterviewModuleMemberModuleLogRow_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & UpdateModuleLogModal_ModuleMemberFragment
  & InterviewLog_ModuleMemberFragment
);

export type InterviewModuleMemberModuleLogRow_ModuleMemberInterviewFragment_ModuleMemberApplicationStageInterviewLog_applicationStageInterview_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', startAt: any, endAt: any, id: any };

type InterviewModuleMemberModuleLogRow_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment = (
  { __typename: 'ModuleMemberApplicationStageInterviewLog', id: any, interviewDate: any, trainingRole: TrainingStatus, status: ModuleMemberInterviewStatus, applicationStageInterview: InterviewModuleMemberModuleLogRow_ModuleMemberInterviewFragment_ModuleMemberApplicationStageInterviewLog_applicationStageInterview_ApplicationStageInterview }
  & UpdateModuleLogModal_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment
  & InterviewLog_InterviewLog_ModuleMemberApplicationStageInterviewLog_Fragment
);

type InterviewModuleMemberModuleLogRow_ModuleMemberInterview_ModuleMemberManualLog_Fragment = (
  { __typename: 'ModuleMemberManualLog', id: any, interviewDate: any, trainingRole: TrainingStatus, status: ModuleMemberInterviewStatus }
  & UpdateModuleLogModal_ModuleMemberInterview_ModuleMemberManualLog_Fragment
  & InterviewLog_InterviewLog_ModuleMemberManualLog_Fragment
);

export type InterviewModuleMemberModuleLogRow_ModuleMemberInterviewFragment = InterviewModuleMemberModuleLogRow_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment | InterviewModuleMemberModuleLogRow_ModuleMemberInterview_ModuleMemberManualLog_Fragment;

export type InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput_items_ModuleMemberApplicationStageInterviewLog = (
  { __typename?: 'ModuleMemberApplicationStageInterviewLog' }
  & InterviewModuleMemberModuleLogRow_ModuleMemberInterview_ModuleMemberApplicationStageInterviewLog_Fragment
);

export type InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput_items_ModuleMemberManualLog = (
  { __typename?: 'ModuleMemberManualLog' }
  & InterviewModuleMemberModuleLogRow_ModuleMemberInterview_ModuleMemberManualLog_Fragment
);

export type InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput_items = InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput_items_ModuleMemberApplicationStageInterviewLog | InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput_items_ModuleMemberManualLog;

export type InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput = { __typename?: 'ModuleMemberInterviewLogOutput', items: Array<InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput_items> };

export type InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember = { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, moduleMemberInterviewLogs?: InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember_moduleMemberInterviewLogs_ModuleMemberInterviewLogOutput | null };

export type InterviewModuleMemberModuleLogSidepanelQuery_Query = { __typename?: 'Query', interviewModuleMember?: InterviewModuleMemberModuleLogSidepanelQuery_interviewModuleMember_InterviewModuleMember | null };


export type InterviewModuleMemberModuleLogSidepanelQueryVariables = Exact<{
  interviewModuleId: Scalars['uuid']['input'];
  moduleMemberId: Scalars['uuid']['input'];
  moduleMemberInterviewLogsInput: ModuleMemberInterviewLogInput;
}>;


export type InterviewModuleMemberModuleLogSidepanelQuery = InterviewModuleMemberModuleLogSidepanelQuery_Query;

export type InterviewModuleMemberModuleLog_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type InterviewModuleMemberModuleLog_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type InterviewModuleMemberModuleLog_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type InterviewModuleMemberModuleLog_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, employee?: InterviewModuleMemberModuleLog_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null, interviewModule?: InterviewModuleMemberModuleLog_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule | null, stats?: InterviewModuleMemberModuleLog_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & AddModuleLog_ModuleMemberFragment
  & InterviewModuleMemberModuleLogRow_ModuleMemberFragment
);

export type ActionButtons_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any };

export type ActionButtons_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null, completedAsShadow?: any | null, completedAsReverseShadow?: any | null, manualCompletedAsShadow: any, manualCompletedAsReverseShadow: any };

export type ActionButtons_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, status: TrainingStatus, shadowsRequired: number, reverseShadowsRequired: number, pendingApprovalApplicationStageInterview?: ActionButtons_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview | null, stats?: ActionButtons_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & GetReverseShadowCompletedCount_ModuleMemberFragment
  & GetShadowCompletedCount_ModuleMemberFragment
  & GetReverseShadowPendingCount_ModuleMemberFragment
);

export type PendingApprovalAlert_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview_traineeFeedback_ApplicationStageInterviewFeedback = { __typename?: 'ApplicationStageInterviewFeedback', reviewerId?: any | null, reviewedAt?: any | null };

export type PendingApprovalAlert_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview_trainedFeedback_ApplicationStageInterviewFeedback = { __typename?: 'ApplicationStageInterviewFeedback', reviewerId?: any | null, reviewedAt?: any | null };

export type PendingApprovalAlert_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, traineeFeedback?: PendingApprovalAlert_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview_traineeFeedback_ApplicationStageInterviewFeedback | null, trainedFeedback?: PendingApprovalAlert_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview_trainedFeedback_ApplicationStageInterviewFeedback | null };

export type PendingApprovalAlert_ModuleMemberFragment = { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any, pendingApprovalApplicationStageInterview?: PendingApprovalAlert_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview | null };

export type PendingApproval_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type PendingApproval_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview', id: any, startAt: any }
  & InterviewLogInterview_InterviewFragment
);

export type PendingApproval_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, interviewModuleId: any, employeeId: any, status: TrainingStatus, stats?: PendingApproval_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null, pendingApprovalApplicationStageInterview?: PendingApproval_ModuleMemberFragment_InterviewModuleMember_pendingApprovalApplicationStageInterview_ApplicationStageInterview | null }
  & ActionButtons_ModuleMemberFragment
  & InterviewLogInterview_ModuleMemberFragment
  & PendingApprovalAlert_ModuleMemberFragment
);

export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutation_applicationStageInterviewInterviewerUpdate_ApplicationStageInterviewInterviewerResult = { __typename?: 'ApplicationStageInterviewInterviewerResult', result?: Result | null };

export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutation_Mutation = { __typename?: 'Mutation', applicationStageInterviewInterviewerUpdate?: PendingApprovalApplicationStageInterviewInterviewerUpdateMutation_applicationStageInterviewInterviewerUpdate_ApplicationStageInterviewInterviewerResult | null };


export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutationVariables = Exact<{
  input: ApplicationStageInterviewInterviewerUpdateInput;
}>;


export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutation = PendingApprovalApplicationStageInterviewInterviewerUpdateMutation_Mutation;

export type TrainingPlanSection_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type TrainingPlanSection_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, status: TrainingStatus, shadowsRequired: number, reverseShadowsRequired: number, trainedAt?: any | null, stats?: TrainingPlanSection_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & GetReverseShadowCompletedCount_ModuleMemberFragment
  & GetReverseShadowPendingCount_ModuleMemberFragment
  & GetShadowCompletedCount_ModuleMemberFragment
  & GetShadowPendingCount_ModuleMemberFragment
  & SetModuleMemberAsTrainee_ModuleMemberFragment
  & EditTrainigPlan_ModuleMemberFragment
);

export type ModuleMemberSidePanelFragment_InterviewModuleMember_interviewModule_InterviewModule = (
  { __typename?: 'InterviewModule', id: any }
  & MembersList_ModuleFragment
);

export type ModuleMemberSidePanelFragment = (
  { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any, interviewModule?: ModuleMemberSidePanelFragment_InterviewModuleMember_interviewModule_InterviewModule | null }
  & PendingApproval_ModuleMemberFragment
  & InterviewModuleMemberHeader_ModuleMemberFragment
  & InterviewModuleMemberKeyDates_ModuleMemberFragment
  & ModuleLoad_ModuleMemberFragment
  & TrainingPlanSection_ModuleMemberFragment
);

export type InterviewModuleMemberSidepanelQueryQuery_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & ModuleMemberSidePanelFragment
  & InterviewModuleMemberModuleLog_ModuleMemberFragment
);

export type InterviewModuleMemberSidepanelQueryQuery_Query = { __typename?: 'Query', interviewModuleMember?: InterviewModuleMemberSidepanelQueryQuery_interviewModuleMember_InterviewModuleMember | null };


export type InterviewModuleMemberSidepanelQueryQueryVariables = Exact<{
  interviewModuleId: Scalars['uuid']['input'];
  moduleMemberId: Scalars['uuid']['input'];
}>;


export type InterviewModuleMemberSidepanelQueryQuery = InterviewModuleMemberSidepanelQueryQuery_Query;

export type ModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & ModuleMemberSidePanelFragment
);

export type ModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult = { __typename?: 'InterviewModuleMemberResult', interviewModuleMember?: ModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember | null };

export type ModuleMemberUpdateMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberUpdate?: ModuleMemberUpdateMutation_interviewModuleMemberUpdate_InterviewModuleMemberResult | null };


export type ModuleMemberUpdateMutationVariables = Exact<{
  input: InterviewModuleMemberUpdateInput;
}>;


export type ModuleMemberUpdateMutation = ModuleMemberUpdateMutation_Mutation;

export type ModuleMemberApproveMutation_interviewModuleMemberApprove_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & ModuleMemberSidePanelFragment
);

export type ModuleMemberApproveMutation_interviewModuleMemberApprove_InterviewModuleMemberResult = { __typename?: 'InterviewModuleMemberResult', interviewModuleMember?: ModuleMemberApproveMutation_interviewModuleMemberApprove_InterviewModuleMemberResult_interviewModuleMember_InterviewModuleMember | null };

export type ModuleMemberApproveMutation_Mutation = { __typename?: 'Mutation', interviewModuleMemberApprove?: ModuleMemberApproveMutation_interviewModuleMemberApprove_InterviewModuleMemberResult | null };


export type ModuleMemberApproveMutationVariables = Exact<{
  input: InterviewModuleMemberApproveInput;
}>;


export type ModuleMemberApproveMutation = ModuleMemberApproveMutation_Mutation;

export type DebriefCommunications_CandidateFragment = { __typename?: 'Candidate', id: any, preferredName?: string | null, preferredPhoneNumber?: string | null };

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & LocationCard_InterviewMeetingLocationSettingFragment
);

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & LocationCard_InterviewMeetingLocationSettingFragment
);

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel = { __typename?: 'DebriefMeetingLocationSettingWithLevel', debriefMeetingLocationSetting?: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type DebriefCommunications_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, interviewMeetingLocationSettingWithLevel?: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null, debriefMeetingLocationSettingWithLevel?: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel | null, debriefEventAdditionalAttendees?: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference | null, debriefEventAdditionalAttendeesOptional?: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue | null, debriefEventAdditionalAttendeesV2?: DebriefCommunications_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees | null }
  & SlackChannelCard_JobStageSettingsV2Fragment
);

export type DebriefFlowDoneQuery_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any };

export type DebriefFlowDoneQuery_application_Application = { __typename?: 'Application', candidate?: DebriefFlowDoneQuery_application_Application_candidate_Candidate | null };

export type DebriefFlowDoneQuery_Query = { __typename?: 'Query', application?: DebriefFlowDoneQuery_application_Application | null };


export type DebriefFlowDoneQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type DebriefFlowDoneQuery = DebriefFlowDoneQuery_Query;

export type DebriefFlowHeaderQuery_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, anonymizedAt?: any | null };

export type DebriefFlowHeaderQuery_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type DebriefFlowHeaderQuery_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type DebriefFlowHeaderQuery_application_Application = { __typename?: 'Application', id: any, candidate?: DebriefFlowHeaderQuery_application_Application_candidate_Candidate | null, jobStage?: DebriefFlowHeaderQuery_application_Application_jobStage_JobStage | null, job?: DebriefFlowHeaderQuery_application_Application_job_Job | null };

export type DebriefFlowHeaderQuery_Query = { __typename?: 'Query', application?: DebriefFlowHeaderQuery_application_Application | null };


export type DebriefFlowHeaderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DebriefFlowHeaderQuery = DebriefFlowHeaderQuery_Query;

export type AttendeeAttributesFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, familyName?: string | null, isArchived?: boolean | null, isAtsDisabled?: boolean | null, isDirectoryDisabled: boolean, hasAtsId?: boolean | null };

export type AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_atsInterviewDefinition_AtsInterviewDefinition_atsJobStage_AtsJobStage = { __typename?: 'AtsJobStage', atsId: string, name: string };

export type AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, atsJobStage?: AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_atsInterviewDefinition_AtsInterviewDefinition_atsJobStage_AtsJobStage | null };

export type AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_interviewers_AtsScheduledInterviewInterviewer_atsUser_AtsUser_employee_Employee = (
  { __typename?: 'Employee' }
  & AttendeeAttributesFragment
);

export type AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_interviewers_AtsScheduledInterviewInterviewer_atsUser_AtsUser = { __typename?: 'AtsUser', id: string, employee?: AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_interviewers_AtsScheduledInterviewInterviewer_atsUser_AtsUser_employee_Employee | null };

export type AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_interviewers_AtsScheduledInterviewInterviewer = { __typename?: 'AtsScheduledInterviewInterviewer', atsUser?: AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_interviewers_AtsScheduledInterviewInterviewer_atsUser_AtsUser | null };

export type AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview = { __typename?: 'AtsScheduledInterview', atsId: string, startAt: any, endAt: any, atsInterviewDefinition?: AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_atsInterviewDefinition_AtsInterviewDefinition | null, interviewers?: Array<AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview_interviewers_AtsScheduledInterviewInterviewer> | null };

export type AtsDebriefStageFromApplicationFragment = { __typename?: 'AtsApplication', atsId: string, atsScheduledInterviews?: Array<AtsDebriefStageFromApplicationFragment_AtsApplication_atsScheduledInterviews_AtsScheduledInterview> | null };

export type ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee = (
  { __typename?: 'Employee' }
  & AttendeeAttributesFragment
);

export type ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any, responseStatus?: ResponseStatus | null, interviewer?: ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee | null };

export type ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, atsScheduledInterviewId?: string | null, applicationStageInterviewInterviewers?: Array<ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null };

export type ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage = { __typename?: 'ApplicationStage', id: any, startAt?: any | null, endAt?: any | null, applicationStageInterviews?: Array<ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null, jobStage?: ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage_jobStage_JobStage | null };

export type ApplicationAttendeesQuery_application_Application_job_Job_hiringManagers_Employee = (
  { __typename?: 'Employee' }
  & AttendeeAttributesFragment
);

export type ApplicationAttendeesQuery_application_Application_job_Job_sourcers_Employee = (
  { __typename?: 'Employee' }
  & AttendeeAttributesFragment
);

export type ApplicationAttendeesQuery_application_Application_job_Job = { __typename?: 'Job', id: any, hiringManagers?: Array<ApplicationAttendeesQuery_application_Application_job_Job_hiringManagers_Employee> | null, sourcers?: Array<ApplicationAttendeesQuery_application_Application_job_Job_sourcers_Employee> | null };

export type ApplicationAttendeesQuery_application_Application_candidate_Candidate_sourcer_Employee = (
  { __typename?: 'Employee' }
  & AttendeeAttributesFragment
);

export type ApplicationAttendeesQuery_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, sourcer?: ApplicationAttendeesQuery_application_Application_candidate_Candidate_sourcer_Employee | null };

export type ApplicationAttendeesQuery_application_Application_recruiter_Employee = (
  { __typename?: 'Employee' }
  & AttendeeAttributesFragment
);

export type ApplicationAttendeesQuery_application_Application_coordinator_Employee = (
  { __typename?: 'Employee' }
  & AttendeeAttributesFragment
);

export type ApplicationAttendeesQuery_application_Application_atsApplication_AtsApplication = (
  { __typename?: 'AtsApplication' }
  & AtsDebriefStageFromApplicationFragment
);

export type ApplicationAttendeesQuery_application_Application = { __typename?: 'Application', id: any, applicationStages?: Array<ApplicationAttendeesQuery_application_Application_applicationStages_ApplicationStage> | null, job?: ApplicationAttendeesQuery_application_Application_job_Job | null, candidate?: ApplicationAttendeesQuery_application_Application_candidate_Candidate | null, recruiter?: ApplicationAttendeesQuery_application_Application_recruiter_Employee | null, coordinator?: ApplicationAttendeesQuery_application_Application_coordinator_Employee | null, atsApplication?: ApplicationAttendeesQuery_application_Application_atsApplication_AtsApplication | null };

export type ApplicationAttendeesQuery_Query = { __typename?: 'Query', application?: ApplicationAttendeesQuery_application_Application | null };


export type ApplicationAttendeesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApplicationAttendeesQuery = ApplicationAttendeesQuery_Query;

export type TaskDebriefAttendeeQuery_thisUserInfo_UserInfo = { __typename?: 'UserInfo', userName: string };

export type TaskDebriefAttendeeQuery_task_Task_debriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, isDirectoryDisabled: boolean, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null };

export type TaskDebriefAttendeeQuery_task_Task_debriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee = { __typename?: 'ApplicationDebriefAttendee', interviewerId: any, interviewer?: TaskDebriefAttendeeQuery_task_Task_debriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee_interviewer_Employee | null };

export type TaskDebriefAttendeeQuery_task_Task_debriefs_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any, attendees?: Array<TaskDebriefAttendeeQuery_task_Task_debriefs_ApplicationDebrief_attendees_ApplicationDebriefAttendee> | null };

export type TaskDebriefAttendeeQuery_task_Task = { __typename?: 'Task', id: any, debriefs: Array<TaskDebriefAttendeeQuery_task_Task_debriefs_ApplicationDebrief> };

export type TaskDebriefAttendeeQuery_Query = { __typename?: 'Query', thisUserInfo?: TaskDebriefAttendeeQuery_thisUserInfo_UserInfo | null, task?: TaskDebriefAttendeeQuery_task_Task | null };


export type TaskDebriefAttendeeQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type TaskDebriefAttendeeQuery = TaskDebriefAttendeeQuery_Query;

export type DebriefTaskQuery_task_Task_jobStage_JobStage_job_Job = (
  { __typename?: 'Job', id: any }
  & ScheduleFlowDataProvider_JobFragment
);

export type DebriefTaskQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & ScheduleFlowDataProvider_JobStageSettingsFragment
);

export type DebriefTaskQuery_task_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, job?: DebriefTaskQuery_task_Task_jobStage_JobStage_job_Job | null, jobStageSettingsV2?: DebriefTaskQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type DebriefTaskQuery_task_Task_schedule_ApplicationStage_conversation_Conversation = { __typename?: 'Conversation', id: any, remoteName: string };

export type DebriefTaskQuery_task_Task_schedule_ApplicationStage = { __typename?: 'ApplicationStage', id: any, conversation?: DebriefTaskQuery_task_Task_schedule_ApplicationStage_conversation_Conversation | null };

export type DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief_additionalAttendeesV2_AdditionalAttendees_attendees_AdditionalAttendee = { __typename?: 'AdditionalAttendee', email?: string | null, employeeId?: any | null, isOptional: boolean, sourceAudience?: DynamicAudience | null };

export type DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief_additionalAttendeesV2_AdditionalAttendees = { __typename?: 'AdditionalAttendees', employeeIds: Array<any>, emails: Array<string>, isOptional: boolean, attendees?: Array<DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief_additionalAttendeesV2_AdditionalAttendees_attendees_AdditionalAttendee> | null };

export type DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief_conversation_Conversation = { __typename?: 'Conversation', id: any, remoteName: string };

export type DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any, conversationTemplateId?: any | null, emailTemplateId?: any | null, googleCalendarId?: string | null, scorecardRecipientEmployeeIds: Array<any>, startAt?: any | null, endAt?: any | null, additionalAttendeesV2: DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief_additionalAttendeesV2_AdditionalAttendees, conversation?: DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief_conversation_Conversation | null };

export type DebriefTaskQuery_task_Task = (
  { __typename?: 'Task', id: any, name: string, jobStage?: DebriefTaskQuery_task_Task_jobStage_JobStage | null, schedule?: DebriefTaskQuery_task_Task_schedule_ApplicationStage | null, debriefs: Array<DebriefTaskQuery_task_Task_debriefs_ApplicationDebrief> }
  & ScheduleFlowDataProvider_TaskFragment
);

export type DebriefTaskQuery_Query = { __typename?: 'Query', task?: DebriefTaskQuery_task_Task | null };


export type DebriefTaskQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type DebriefTaskQuery = DebriefTaskQuery_Query;

export type DebriefApplicationQuery_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any }
  & ScheduleFlowDataProvider_CandidateFragment
);

export type DebriefApplicationQuery_application_Application_job_Job = (
  { __typename?: 'Job', id: any, atsId: string }
  & ScheduleFlowDataProvider_JobFragment
);

export type DebriefApplicationQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & ScheduleFlowDataProvider_JobStageSettingsFragment
);

export type DebriefApplicationQuery_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: DebriefApplicationQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type DebriefApplicationQuery_application_Application_existingConversations_Conversation = { __typename?: 'Conversation', id: any, remoteName: string };

export type DebriefApplicationQuery_application_Application = { __typename?: 'Application', id: any, jobStageId?: any | null, candidate?: DebriefApplicationQuery_application_Application_candidate_Candidate | null, job?: DebriefApplicationQuery_application_Application_job_Job | null, jobStage?: DebriefApplicationQuery_application_Application_jobStage_JobStage | null, existingConversations?: Array<DebriefApplicationQuery_application_Application_existingConversations_Conversation> | null };

export type DebriefApplicationQuery_Query = { __typename?: 'Query', application?: DebriefApplicationQuery_application_Application | null };


export type DebriefApplicationQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type DebriefApplicationQuery = DebriefApplicationQuery_Query;

export type DevToolsTaskSearchQuery_taskSearch_TaskSearchResult_items_Task = { __typename?: 'Task', id: any, status: TaskStatus };

export type DevToolsTaskSearchQuery_taskSearch_TaskSearchResult = { __typename?: 'TaskSearchResult', items: Array<DevToolsTaskSearchQuery_taskSearch_TaskSearchResult_items_Task> };

export type DevToolsTaskSearchQuery_Query = { __typename?: 'Query', taskSearch?: DevToolsTaskSearchQuery_taskSearch_TaskSearchResult | null };


export type DevToolsTaskSearchQueryVariables = Exact<{
  input: TaskSearchInput;
}>;


export type DevToolsTaskSearchQuery = DevToolsTaskSearchQuery_Query;

export type DevToolsApplicationTasksQuery_application_Application_tasks_Task = { __typename?: 'Task', id: any, status: TaskStatus };

export type DevToolsApplicationTasksQuery_application_Application = { __typename?: 'Application', tasks: Array<DevToolsApplicationTasksQuery_application_Application_tasks_Task> };

export type DevToolsApplicationTasksQuery_Query = { __typename?: 'Query', application?: DevToolsApplicationTasksQuery_application_Application | null };


export type DevToolsApplicationTasksQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type DevToolsApplicationTasksQuery = DevToolsApplicationTasksQuery_Query;

export type DevToolsTaskCancelMutation_taskCancel_Task = { __typename?: 'Task', id: any };

export type DevToolsTaskCancelMutation_Mutation = { __typename?: 'Mutation', taskCancel: DevToolsTaskCancelMutation_taskCancel_Task };


export type DevToolsTaskCancelMutationVariables = Exact<{
  input: TaskCancelInput;
}>;


export type DevToolsTaskCancelMutation = DevToolsTaskCancelMutation_Mutation;

export type AttributesFilterFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type AttributesFilterFragment = { __typename?: 'EmployeeAttributeName', id: any, name: string, type: AttributeNameType, values?: Array<AttributesFilterFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue> | null };

export type EmployeeAttributeNamesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = (
  { __typename?: 'EmployeeAttributeName' }
  & AttributesFilterFragment
);

export type EmployeeAttributeNamesQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<EmployeeAttributeNamesQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type EmployeeAttributeNamesQuery_Query = { __typename?: 'Query', employeeAttributeNames?: EmployeeAttributeNamesQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null };


export type EmployeeAttributeNamesQueryVariables = Exact<{
  input: EmployeeAttributeNamesInput;
}>;


export type EmployeeAttributeNamesQuery = EmployeeAttributeNamesQuery_Query;

export type EmployeeAndAttributesFilterFragment = (
  { __typename?: 'InterviewModuleMember' }
  & EmployeeFilterFragment
);

export type InterviewModuleMemberSearchQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & EmployeeFilterFragment
);

export type InterviewModuleMemberSearchQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput = { __typename?: 'InterviewModuleMemberSearchOutput', items: Array<InterviewModuleMemberSearchQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput_items_InterviewModuleMember> };

export type InterviewModuleMemberSearchQuery_Query = { __typename?: 'Query', interviewModuleMemberSearch?: InterviewModuleMemberSearchQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput | null };


export type InterviewModuleMemberSearchQueryVariables = Exact<{
  input: InterviewModuleMemberSearchInput;
}>;


export type InterviewModuleMemberSearchQuery = InterviewModuleMemberSearchQuery_Query;

export type CreateInterviewModuleMutation_interviewModuleCreate_InterviewModuleResult_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any };

export type CreateInterviewModuleMutation_interviewModuleCreate_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: CreateInterviewModuleMutation_interviewModuleCreate_InterviewModuleResult_interviewModule_InterviewModule | null };

export type CreateInterviewModuleMutation_Mutation = { __typename?: 'Mutation', interviewModuleCreate?: CreateInterviewModuleMutation_interviewModuleCreate_InterviewModuleResult | null };


export type CreateInterviewModuleMutationVariables = Exact<{
  input: InterviewModuleCreateInput;
}>;


export type CreateInterviewModuleMutation = CreateInterviewModuleMutation_Mutation;

export type InterviewModuleList_InterviewModuleFragment = (
  { __typename?: 'InterviewModule', id: any }
  & InterviewModuleRow_InterviewModuleFragment
);

export type InterviewModuleRow_InterviewModuleFragment_InterviewModule_trained_InterviewModuleMembersOutput_items_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', internalProfilePictureUrl?: string | null, fullName?: string | null, id: any };

export type InterviewModuleRow_InterviewModuleFragment_InterviewModule_trained_InterviewModuleMembersOutput_items_InterviewModuleMember = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, employee?: InterviewModuleRow_InterviewModuleFragment_InterviewModule_trained_InterviewModuleMembersOutput_items_InterviewModuleMember_employee_Employee | null };

export type InterviewModuleRow_InterviewModuleFragment_InterviewModule_trained_InterviewModuleMembersOutput = { __typename?: 'InterviewModuleMembersOutput', items: Array<InterviewModuleRow_InterviewModuleFragment_InterviewModule_trained_InterviewModuleMembersOutput_items_InterviewModuleMember> };

export type InterviewModuleRow_InterviewModuleFragment_InterviewModule_untrained_InterviewModuleMembersOutput_items_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', internalProfilePictureUrl?: string | null, fullName?: string | null, id: any };

export type InterviewModuleRow_InterviewModuleFragment_InterviewModule_untrained_InterviewModuleMembersOutput_items_InterviewModuleMember = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, employee?: InterviewModuleRow_InterviewModuleFragment_InterviewModule_untrained_InterviewModuleMembersOutput_items_InterviewModuleMember_employee_Employee | null };

export type InterviewModuleRow_InterviewModuleFragment_InterviewModule_untrained_InterviewModuleMembersOutput = { __typename?: 'InterviewModuleMembersOutput', items: Array<InterviewModuleRow_InterviewModuleFragment_InterviewModule_untrained_InterviewModuleMembersOutput_items_InterviewModuleMember> };

export type InterviewModuleRow_InterviewModuleFragment = { __typename?: 'InterviewModule', id: any, name: string, membersTrainedCount: any, membersInTrainingCount: any, membersInPendingApprovalCount: any, shadowsRequired: any, reverseShadowsRequired: any, trained?: InterviewModuleRow_InterviewModuleFragment_InterviewModule_trained_InterviewModuleMembersOutput | null, untrained?: InterviewModuleRow_InterviewModuleFragment_InterviewModule_untrained_InterviewModuleMembersOutput | null };

export type InterviewModuleSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule = (
  { __typename?: 'InterviewModule', id: any }
  & InterviewModuleList_InterviewModuleFragment
);

export type InterviewModuleSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput = { __typename?: 'InterviewModuleSearchOutput', total?: number | null, items: Array<InterviewModuleSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule> };

export type InterviewModuleSearchV2Query_Query = { __typename?: 'Query', interviewModuleSearch?: InterviewModuleSearchV2Query_interviewModuleSearch_InterviewModuleSearchOutput | null };


export type InterviewModuleSearchV2QueryVariables = Exact<{
  input: InterviewModuleSearchInput;
  trainedEmployeesInput: InterviewModuleMembersInput;
  untrainedEmployeesInput: InterviewModuleMembersInput;
}>;


export type InterviewModuleSearchV2Query = InterviewModuleSearchV2Query_Query;

export type InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModule_InterviewModule = { __typename?: 'InterviewModule', name: string };

export type InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModuleMember_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', fullName?: string | null };

export type InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModuleMember_InterviewModuleMember = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, employee?: InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModuleMember_InterviewModuleMember_employee_Employee | null };

export type InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completed?: any | null, trainingStatus?: TrainingStatus | null, trainingsToPass?: any | null, currentTrainingSession?: string | null, currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null, shadowsRequired?: any | null, reverseShadowsRequired?: any | null, isPaused: boolean, pausedUntil?: any | null, interviewModule?: InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModule_InterviewModule | null, interviewModuleMember?: InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats_interviewModuleMember_InterviewModuleMember | null };

export type InterviewModuleMemberStatsQuery_Query = { __typename?: 'Query', interviewModuleMemberStats?: Array<InterviewModuleMemberStatsQuery_interviewModuleMemberStats_InterviewModuleMemberStats> | null };


export type InterviewModuleMemberStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewModuleMemberStatsQuery = InterviewModuleMemberStatsQuery_Query;

export type UpdateInterviewTrainingScheduleMutation_interviewModuleUpdate_InterviewModuleResult_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string, shouldFastTrackTraining: boolean };

export type UpdateInterviewTrainingScheduleMutation_interviewModuleUpdate_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: UpdateInterviewTrainingScheduleMutation_interviewModuleUpdate_InterviewModuleResult_interviewModule_InterviewModule | null };

export type UpdateInterviewTrainingScheduleMutation_Mutation = { __typename?: 'Mutation', interviewModuleUpdate?: UpdateInterviewTrainingScheduleMutation_interviewModuleUpdate_InterviewModuleResult | null };


export type UpdateInterviewTrainingScheduleMutationVariables = Exact<{
  input: InterviewModuleUpdateInput;
}>;


export type UpdateInterviewTrainingScheduleMutation = UpdateInterviewTrainingScheduleMutation_Mutation;

export type UpdateModuleName_TrainingScheduleFragment = { __typename?: 'InterviewModule', id: any, name: string, shouldFastTrackTraining: boolean };

export type UpdateInterviewModuleNameMutation_interviewModuleUpdate_InterviewModuleResult_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type UpdateInterviewModuleNameMutation_interviewModuleUpdate_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: UpdateInterviewModuleNameMutation_interviewModuleUpdate_InterviewModuleResult_interviewModule_InterviewModule | null };

export type UpdateInterviewModuleNameMutation_Mutation = { __typename?: 'Mutation', interviewModuleUpdate?: UpdateInterviewModuleNameMutation_interviewModuleUpdate_InterviewModuleResult | null };


export type UpdateInterviewModuleNameMutationVariables = Exact<{
  input: InterviewModuleUpdateInput;
}>;


export type UpdateInterviewModuleNameMutation = UpdateInterviewModuleNameMutation_Mutation;

export type UpdateModuleName_InterviewModuleFragment = { __typename?: 'InterviewModule', id: any, name: string };

export type TraineeRoleConfigSlackStatusQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration = { __typename?: 'SlackOrgIntegration', active: boolean };

export type TraineeRoleConfigSlackStatusQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, slack?: TraineeRoleConfigSlackStatusQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration | null };

export type TraineeRoleConfigSlackStatusQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: TraineeRoleConfigSlackStatusQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type TraineeRoleConfigSlackStatusQuery_Query = { __typename?: 'Query', thisOrg?: TraineeRoleConfigSlackStatusQuery_thisOrg_Org | null };


export type TraineeRoleConfigSlackStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type TraineeRoleConfigSlackStatusQuery = TraineeRoleConfigSlackStatusQuery_Query;

export type InterviewModuleDeleteMutation_interviewModuleDelete_InterviewModuleResult_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any };

export type InterviewModuleDeleteMutation_interviewModuleDelete_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: InterviewModuleDeleteMutation_interviewModuleDelete_InterviewModuleResult_interviewModule_InterviewModule | null };

export type InterviewModuleDeleteMutation_Mutation = { __typename?: 'Mutation', interviewModuleDelete?: InterviewModuleDeleteMutation_interviewModuleDelete_InterviewModuleResult | null };


export type InterviewModuleDeleteMutationVariables = Exact<{
  interviewModuleId: Scalars['uuid']['input'];
}>;


export type InterviewModuleDeleteMutation = InterviewModuleDeleteMutation_Mutation;

export type UpdateInterviewModuleSetupMutation_interviewModuleUpdate_InterviewModuleResult_interviewModule_InterviewModule = (
  { __typename?: 'InterviewModule', id: any }
  & InterviewModuleSetup_InterviewModuleFragment
);

export type UpdateInterviewModuleSetupMutation_interviewModuleUpdate_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: UpdateInterviewModuleSetupMutation_interviewModuleUpdate_InterviewModuleResult_interviewModule_InterviewModule | null };

export type UpdateInterviewModuleSetupMutation_Mutation = { __typename?: 'Mutation', interviewModuleUpdate?: UpdateInterviewModuleSetupMutation_interviewModuleUpdate_InterviewModuleResult | null };


export type UpdateInterviewModuleSetupMutationVariables = Exact<{
  input: InterviewModuleUpdateInput;
}>;


export type UpdateInterviewModuleSetupMutation = UpdateInterviewModuleSetupMutation_Mutation;

export type InterviewModuleSetup_InterviewModuleFragment = (
  { __typename?: 'InterviewModule', id: any, name: string, weeklyNumInterviewLimit?: any | null, shadowsRequired: any, reverseShadowsRequired: any, shouldFastTrackTraining: boolean, graduateFromReverseShadowApprovalType: GraduationApprovalType, graduateFromReverseShadowCustomApprovers?: Array<GraduationApproverType> | null, graduateFromShadowApprovalType: GraduationApprovalType, graduateFromShadowCustomApprovers?: Array<GraduationApproverType> | null }
  & UpdateModuleName_TrainingScheduleFragment
  & UpdateModuleName_InterviewModuleFragment
);

export type AddMembersToModuleMutation_interviewModuleAddMembers_InterviewModuleResult_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any };

export type AddMembersToModuleMutation_interviewModuleAddMembers_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: AddMembersToModuleMutation_interviewModuleAddMembers_InterviewModuleResult_interviewModule_InterviewModule | null };

export type AddMembersToModuleMutation_Mutation = { __typename?: 'Mutation', interviewModuleAddMembers?: AddMembersToModuleMutation_interviewModuleAddMembers_InterviewModuleResult | null };


export type AddMembersToModuleMutationVariables = Exact<{
  input: InterviewModuleAddMembersInput;
}>;


export type AddMembersToModuleMutation = AddMembersToModuleMutation_Mutation;

export type AddMembersModal_ModuleFragment = { __typename?: 'InterviewModule', id: any, shadowsRequired: any, reverseShadowsRequired: any };

export type EmployeesToAddForInterviewModuleQuery_employees_EmployeesOutput_items_Employee_interviewModuleMember_InterviewModuleMember = { __typename?: 'InterviewModuleMember', employeeId: any, status: TrainingStatus, interviewModuleId: any };

export type EmployeesToAddForInterviewModuleQuery_employees_EmployeesOutput_items_Employee = (
  { __typename?: 'Employee', interviewModuleMember?: EmployeesToAddForInterviewModuleQuery_employees_EmployeesOutput_items_Employee_interviewModuleMember_InterviewModuleMember | null }
  & EmployeeFragment
);

export type EmployeesToAddForInterviewModuleQuery_employees_EmployeesOutput = { __typename?: 'EmployeesOutput', nextCursor?: string | null, items: Array<EmployeesToAddForInterviewModuleQuery_employees_EmployeesOutput_items_Employee> };

export type EmployeesToAddForInterviewModuleQuery_Query = { __typename?: 'Query', employees?: EmployeesToAddForInterviewModuleQuery_employees_EmployeesOutput | null };


export type EmployeesToAddForInterviewModuleQueryVariables = Exact<{
  input: EmployeesInput;
  interviewModuleId: Scalars['uuid']['input'];
}>;


export type EmployeesToAddForInterviewModuleQuery = EmployeesToAddForInterviewModuleQuery_Query;

export type Members_MembersFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any }
  & ModuleMemberRow_ModuleMemberFragment
);

export type ModuleMemberRow_ModuleMemberFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, title?: string | null };

export type ModuleMemberRow_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type ModuleMemberRow_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', upcoming?: any | null, completedAsShadow?: any | null, completedAsReverseShadow?: any | null, completed?: any | null, completedAsInterviewer: any, manualCompletedAsInterviewer: any, manualCompletedAsShadow: any, manualCompletedAsReverseShadow: any };

export type ModuleMemberRow_ModuleMemberFragment = (
  { __typename?: 'InterviewModuleMember', id: string, status: TrainingStatus, employeeId: any, interviewModuleId: any, shadowsRequired: number, reverseShadowsRequired: number, employee?: ModuleMemberRow_ModuleMemberFragment_InterviewModuleMember_employee_Employee | null, interviewModule?: ModuleMemberRow_ModuleMemberFragment_InterviewModuleMember_interviewModule_InterviewModule | null, stats?: ModuleMemberRow_ModuleMemberFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & ModuleMemberTrainingStatus_ModuleMemberFragment
);

export type InterviewModuleMembersListQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & Members_MembersFragment
);

export type InterviewModuleMembersListQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput = { __typename?: 'InterviewModuleMemberSearchOutput', total?: number | null, items: Array<InterviewModuleMembersListQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput_items_InterviewModuleMember> };

export type InterviewModuleMembersListQuery_Query = { __typename?: 'Query', interviewModuleMemberSearch?: InterviewModuleMembersListQuery_interviewModuleMemberSearch_InterviewModuleMemberSearchOutput | null };


export type InterviewModuleMembersListQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  pageInput: PageInput;
  orderBy: InterviewModuleMemberSearchOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
  filterByTrainingStatus?: InputMaybe<Array<InputMaybe<TrainingStatus>> | InputMaybe<TrainingStatus>>;
  filterByState?: InputMaybe<Array<InputMaybe<InterviewModuleMemberState>> | InputMaybe<InterviewModuleMemberState>>;
}>;


export type InterviewModuleMembersListQuery = InterviewModuleMembersListQuery_Query;

export type MembersList_ModuleFragment = (
  { __typename?: 'InterviewModule', id: any, membersCount: any, membersTrainedCount: any }
  & AddMembersModal_ModuleFragment
);

export type ModuleMembersViewQuery_interviewModule_InterviewModule = (
  { __typename?: 'InterviewModule', id: any, name: string }
  & AddMembersModal_ModuleFragment
  & MembersList_ModuleFragment
  & InterviewModuleSetup_InterviewModuleFragment
);

export type ModuleMembersViewQuery_Query = { __typename?: 'Query', interviewModule?: ModuleMembersViewQuery_interviewModule_InterviewModule | null };


export type ModuleMembersViewQueryVariables = Exact<{
  interviewModuleId: Scalars['uuid']['input'];
}>;


export type ModuleMembersViewQuery = ModuleMembersViewQuery_Query;

export type EmployeeAiTabQuery_employee_Employee_aiInstruction_AiInstruction = (
  { __typename?: 'AiInstruction' }
  & AiInstructionsCard_InstructionFragment
);

export type EmployeeAiTabQuery_employee_Employee_aiMemories_AiMemory = (
  { __typename?: 'AiMemory' }
  & AiMemoriesCard_MemoryFragment
);

export type EmployeeAiTabQuery_employee_Employee = { __typename?: 'Employee', id: any, aiInstruction?: EmployeeAiTabQuery_employee_Employee_aiInstruction_AiInstruction | null, aiMemories: Array<EmployeeAiTabQuery_employee_Employee_aiMemories_AiMemory> };

export type EmployeeAiTabQuery_Query = { __typename?: 'Query', employee?: EmployeeAiTabQuery_employee_Employee | null };


export type EmployeeAiTabQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EmployeeAiTabQuery = EmployeeAiTabQuery_Query;

export type InterviewerAvailabilityTabQuery_employee_Employee_calendarDelegate_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type InterviewerAvailabilityTabQuery_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, timezone?: string | null, calendarTimezone?: string | null, useCalendarTimezone: boolean, calendarDelegate?: InterviewerAvailabilityTabQuery_employee_Employee_calendarDelegate_Employee | null };

export type InterviewerAvailabilityTabQuery_interviewerAvailability_InterviewerAvailabilitySuccess_intervals_AvailabilityInterval = { __typename?: 'AvailabilityInterval', startAt: any, endAt: any, type: AvailabilityIntervalType };

export type InterviewerAvailabilityTabQuery_interviewerAvailability_CalendarUnavailableError = { __typename: 'CalendarUnavailableError', errorCode: ErrorCode, errorMessage: string };

export type InterviewerAvailabilityTabQuery_interviewerAvailability_EmployeeNotFoundError = { __typename: 'EmployeeNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type InterviewerAvailabilityTabQuery_interviewerAvailability_InterviewerAvailabilityInvalidWindowError = { __typename: 'InterviewerAvailabilityInvalidWindowError', errorCode: ErrorCode, errorMessage: string };

export type InterviewerAvailabilityTabQuery_interviewerAvailability_InterviewerAvailabilitySuccess = { __typename: 'InterviewerAvailabilitySuccess', id: string, computationId: string, windowStartAt: any, windowEndAt: any, intervals: Array<InterviewerAvailabilityTabQuery_interviewerAvailability_InterviewerAvailabilitySuccess_intervals_AvailabilityInterval> };

export type InterviewerAvailabilityTabQuery_interviewerAvailability_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type InterviewerAvailabilityTabQuery_interviewerAvailability = InterviewerAvailabilityTabQuery_interviewerAvailability_CalendarUnavailableError | InterviewerAvailabilityTabQuery_interviewerAvailability_EmployeeNotFoundError | InterviewerAvailabilityTabQuery_interviewerAvailability_InterviewerAvailabilityInvalidWindowError | InterviewerAvailabilityTabQuery_interviewerAvailability_InterviewerAvailabilitySuccess | InterviewerAvailabilityTabQuery_interviewerAvailability_UnknownError;

export type InterviewerAvailabilityTabQuery_Query = { __typename?: 'Query', employee?: InterviewerAvailabilityTabQuery_employee_Employee | null, interviewerAvailability: InterviewerAvailabilityTabQuery_interviewerAvailability };


export type InterviewerAvailabilityTabQueryVariables = Exact<{
  employeeId: Scalars['uuid']['input'];
  timeRange: DateTimeRangeInput;
  shouldRespectLoadLimit: Scalars['Boolean']['input'];
  canScheduleOverRecruitingKeywords: Scalars['Boolean']['input'];
  canScheduleOverAvailableKeywords: Scalars['Boolean']['input'];
  canScheduleOverFreeTime: Scalars['Boolean']['input'];
}>;


export type InterviewerAvailabilityTabQuery = InterviewerAvailabilityTabQuery_Query;

export type AddModuleToInterviewerMutation_interviewModuleAddMembers_InterviewModuleResult_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any };

export type AddModuleToInterviewerMutation_interviewModuleAddMembers_InterviewModuleResult = { __typename?: 'InterviewModuleResult', interviewModule?: AddModuleToInterviewerMutation_interviewModuleAddMembers_InterviewModuleResult_interviewModule_InterviewModule | null };

export type AddModuleToInterviewerMutation_Mutation = { __typename?: 'Mutation', interviewModuleAddMembers?: AddModuleToInterviewerMutation_interviewModuleAddMembers_InterviewModuleResult | null };


export type AddModuleToInterviewerMutationVariables = Exact<{
  input: InterviewModuleAddMembersInput;
}>;


export type AddModuleToInterviewerMutation = AddModuleToInterviewerMutation_Mutation;

export type Modules_MemberModulesFragment = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any }
  & ModuleMemberRow_ModuleMemberFragment
);

export type ModulesList_EmployeeFragment = { __typename?: 'Employee', id: any, modulesTrainedCount?: any | null, modulesInTrainingCount?: any | null };

export type InterviewerInterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_employee_Employee = (
  { __typename?: 'Employee', id: any }
  & ModulesList_EmployeeFragment
);

export type InterviewerInterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, employee?: InterviewerInterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_employee_Employee | null }
  & Modules_MemberModulesFragment
);

export type InterviewerInterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput = { __typename?: 'InterviewModuleMemberLookupOutput', items: Array<InterviewerInterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember> };

export type InterviewerInterviewModuleMemberLookupQuery_Query = { __typename?: 'Query', interviewModuleMemberLookup?: InterviewerInterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput | null };


export type InterviewerInterviewModuleMemberLookupQueryVariables = Exact<{
  memberIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type InterviewerInterviewModuleMemberLookupQuery = InterviewerInterviewModuleMemberLookupQuery_Query;

export type InterviewModulesTab_EmployeeFragment = (
  { __typename?: 'Employee', id: any }
  & ModulesList_EmployeeFragment
);

export type AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue_parent_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, syncSourceType: SyncSourceType };

export type AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, name: string, parent?: AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue_parent_EmployeeAttributeName | null };

export type AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, name: string, type: AttributeNameType, syncSourceType: SyncSourceType, values?: Array<AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName_values_EmployeeAttributeTagValue> | null };

export type AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref', manager?: SyncSourceType | null };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference = { __typename?: 'NotificationPreference' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref = AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref | AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek;

export type AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref_jsonPref | null };

export type AboutSectionEditDialogQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPref?: AboutSectionEditDialogQuery_thisOrg_Org_orgPref_OrgPref | null };

export type AboutSectionEditDialogQuery_Query = { __typename?: 'Query', employeeAttributeNames?: AboutSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null, thisOrg?: AboutSectionEditDialogQuery_thisOrg_Org | null };


export type AboutSectionEditDialogQueryVariables = Exact<{
  input: EmployeeAttributeNamesInput;
}>;


export type AboutSectionEditDialogQuery = AboutSectionEditDialogQuery_Query;

export type AboutSectionEditDialog_InterviewerFragment_Employee_atsUser_AtsUser = { __typename?: 'AtsUser', atsId: string, name: string, email: string, disabled: boolean };

export type AboutSectionEditDialog_InterviewerFragment_Employee_manager_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type AboutSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, name: string, type: AttributeNameType, syncSourceType: SyncSourceType };

export type AboutSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, parent?: AboutSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName | null };

export type AboutSectionEditDialog_InterviewerFragment = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, isArchived?: boolean | null, familyName?: string | null, email: string, title?: string | null, linkedinUrl?: string | null, atsUser?: AboutSectionEditDialog_InterviewerFragment_Employee_atsUser_AtsUser | null, manager?: AboutSectionEditDialog_InterviewerFragment_Employee_manager_Employee | null, attributes?: Array<AboutSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue> | null };

export type InterviewerAboutSection_InterviewerFragment_Employee_manager_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type InterviewerAboutSection_InterviewerFragment_Employee_atsUser_AtsUser = { __typename?: 'AtsUser', atsId: string, name: string, email: string, disabled: boolean };

export type InterviewerAboutSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, name: string, type: AttributeNameType };

export type InterviewerAboutSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, parent?: InterviewerAboutSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName | null };

export type InterviewerAboutSection_InterviewerFragment = (
  { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, familyName?: string | null, email: string, title?: string | null, linkedinUrl?: string | null, pronouns?: string | null, bio?: string | null, manager?: InterviewerAboutSection_InterviewerFragment_Employee_manager_Employee | null, atsUser?: InterviewerAboutSection_InterviewerFragment_Employee_atsUser_AtsUser | null, attributes?: Array<InterviewerAboutSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue> | null }
  & AboutSectionEditDialog_InterviewerFragment
);

export type InterviewerUpdateMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee = (
  { __typename?: 'Employee' }
  & InterviewerAboutSection_InterviewerFragment
);

export type InterviewerUpdateMutation_employeeUpdate_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: InterviewerUpdateMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee | null };

export type InterviewerUpdateMutation_Mutation = { __typename?: 'Mutation', employeeUpdate?: InterviewerUpdateMutation_employeeUpdate_EmployeeUpdateResult | null };


export type InterviewerUpdateMutationVariables = Exact<{
  input: EmployeeUpdateInput;
}>;


export type InterviewerUpdateMutation = InterviewerUpdateMutation_Mutation;

export type InterviewerUpdateAttributesMutation_employeeAttributesUpsert_EmployeeUpdateResult_employee_Employee = (
  { __typename?: 'Employee' }
  & InterviewerAboutSection_InterviewerFragment
);

export type InterviewerUpdateAttributesMutation_employeeAttributesUpsert_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: InterviewerUpdateAttributesMutation_employeeAttributesUpsert_EmployeeUpdateResult_employee_Employee | null };

export type InterviewerUpdateAttributesMutation_Mutation = { __typename?: 'Mutation', employeeAttributesUpsert?: InterviewerUpdateAttributesMutation_employeeAttributesUpsert_EmployeeUpdateResult | null };


export type InterviewerUpdateAttributesMutationVariables = Exact<{
  input: EmployeeAttributesInput;
}>;


export type InterviewerUpdateAttributesMutation = InterviewerUpdateAttributesMutation_Mutation;

export type AtsUserEmployeeAssociationUpdateMutation_atsUserEmployeeAssociationUpdate_AtsUserEmployeeAssociationUpdateResult_atsUser_AtsUser = (
  { __typename?: 'AtsUser' }
  & AtsUserFragment
);

export type AtsUserEmployeeAssociationUpdateMutation_atsUserEmployeeAssociationUpdate_AtsUserEmployeeAssociationUpdateResult = { __typename?: 'AtsUserEmployeeAssociationUpdateResult', atsUser: AtsUserEmployeeAssociationUpdateMutation_atsUserEmployeeAssociationUpdate_AtsUserEmployeeAssociationUpdateResult_atsUser_AtsUser };

export type AtsUserEmployeeAssociationUpdateMutation_Mutation = { __typename?: 'Mutation', atsUserEmployeeAssociationUpdate?: AtsUserEmployeeAssociationUpdateMutation_atsUserEmployeeAssociationUpdate_AtsUserEmployeeAssociationUpdateResult | null };


export type AtsUserEmployeeAssociationUpdateMutationVariables = Exact<{
  input: AtsUserEmployeeAssociationUpdateInput;
}>;


export type AtsUserEmployeeAssociationUpdateMutation = AtsUserEmployeeAssociationUpdateMutation_Mutation;

export type AttributeEditRow_AttributeTagValueFragment_EmployeeAttributeTagValue_parent_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, type: AttributeNameType, name: string, syncSourceType: SyncSourceType };

export type AttributeEditRow_AttributeTagValueFragment = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, parent?: AttributeEditRow_AttributeTagValueFragment_EmployeeAttributeTagValue_parent_EmployeeAttributeName | null };

export type AttributeEditRow_EmployeeAttributeParentFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue = (
  { __typename?: 'EmployeeAttributeTagValue' }
  & AttributeEditRow_AttributeTagValueFragment
);

export type AttributeEditRow_EmployeeAttributeParentFragment = { __typename?: 'EmployeeAttributeName', id: any, name: string, type: AttributeNameType, syncSourceType: SyncSourceType, values?: Array<AttributeEditRow_EmployeeAttributeParentFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue> | null };

export type AttributeEditRow_InterviewerAttributesFragment = (
  { __typename?: 'EmployeeAttributeTagValue' }
  & AttributeEditRow_AttributeTagValueFragment
);

export type AttributesSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = (
  { __typename?: 'EmployeeAttributeName' }
  & AttributeEditRow_EmployeeAttributeParentFragment
);

export type AttributesSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<AttributesSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type AttributesSectionEditDialogQuery_Query = { __typename?: 'Query', employeeAttributeNames?: AttributesSectionEditDialogQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null };


export type AttributesSectionEditDialogQueryVariables = Exact<{
  input: EmployeeAttributeNamesInput;
}>;


export type AttributesSectionEditDialogQuery = AttributesSectionEditDialogQuery_Query;

export type AttributeSectionEditDialog_AttributeTagValueFragment_EmployeeAttributeTagValue_parent_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, type: AttributeNameType, name: string, syncSourceType: SyncSourceType };

export type AttributeSectionEditDialog_AttributeTagValueFragment = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, parent?: AttributeSectionEditDialog_AttributeTagValueFragment_EmployeeAttributeTagValue_parent_EmployeeAttributeName | null };

export type AttributesSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, type: AttributeNameType, name: string, syncSourceType: SyncSourceType };

export type AttributesSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue = (
  { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, parent?: AttributesSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName | null }
  & AttributeEditRow_InterviewerAttributesFragment
);

export type AttributesSectionEditDialog_InterviewerFragment = { __typename?: 'Employee', id: any, fullName?: string | null, attributes?: Array<AttributesSectionEditDialog_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue> | null };

export type InterviewerAttributesSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, type: AttributeNameType, name: string };

export type InterviewerAttributesSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, parent?: InterviewerAttributesSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue_parent_EmployeeAttributeName | null };

export type InterviewerAttributesSection_InterviewerFragment = (
  { __typename?: 'Employee', id: any, attributes?: Array<InterviewerAttributesSection_InterviewerFragment_Employee_attributes_EmployeeAttributeTagValue> | null }
  & AttributesSectionEditDialog_InterviewerFragment
);

export type AttributeSectionQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, name: string };

export type AttributeSectionQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<AttributeSectionQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type AttributeSectionQuery_Query = { __typename?: 'Query', employeeAttributeNames?: AttributeSectionQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null };


export type AttributeSectionQueryVariables = Exact<{
  input: EmployeeAttributeNamesInput;
}>;


export type AttributeSectionQuery = AttributeSectionQuery_Query;

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_monday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_tuesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_wednesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_thursday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_friday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_saturday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_sunday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek = { __typename?: 'TimeBlockWeek', monday?: Array<InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_monday_TimeBlock> | null, tuesday?: Array<InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_tuesday_TimeBlock> | null, wednesday?: Array<InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_wednesday_TimeBlock> | null, thursday?: Array<InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_thursday_TimeBlock> | null, friday?: Array<InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_friday_TimeBlock> | null, saturday?: Array<InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_saturday_TimeBlock> | null, sunday?: Array<InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek_sunday_TimeBlock> | null };

export type InterviewerWorkHours_WorkHoursFragment = { __typename?: 'Employee', id: any, workHours?: InterviewerWorkHours_WorkHoursFragment_Employee_workHours_TimeBlockWeek | null };

export type AvailabilitySectionEditDialog_InterviewerFragment_Employee_employeePrefs_EmployeePref = { __typename?: 'EmployeePref', id: string, prefName: string, json?: any | null };

export type AvailabilitySectionEditDialog_InterviewerFragment = (
  { __typename?: 'Employee', id: any, fullName?: string | null, useCalendarTimezone: boolean, calendarTimezone?: string | null, timezone?: string | null, employeePrefs?: Array<AvailabilitySectionEditDialog_InterviewerFragment_Employee_employeePrefs_EmployeePref> | null }
  & InterviewerWorkHours_WorkHoursFragment
);

export type AvailabilitySection_InterviewerFragment_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type AvailabilitySection_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type AvailabilitySection_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit = { __typename?: 'LoadAndLimit', dailyInterviewLimit?: AvailabilitySection_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit | null, weeklyInterviewLimit?: AvailabilitySection_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit | null };

export type AvailabilitySection_InterviewerFragment_Employee_employeePrefs_EmployeePref = { __typename?: 'EmployeePref', orgId: any, employeeId: any, prefName: string, json?: any | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_monday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_tuesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_wednesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_thursday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_friday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_saturday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_sunday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek = { __typename?: 'TimeBlockWeek', monday?: Array<AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_monday_TimeBlock> | null, tuesday?: Array<AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_tuesday_TimeBlock> | null, wednesday?: Array<AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_wednesday_TimeBlock> | null, thursday?: Array<AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_thursday_TimeBlock> | null, friday?: Array<AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_friday_TimeBlock> | null, saturday?: Array<AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_saturday_TimeBlock> | null, sunday?: Array<AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek_sunday_TimeBlock> | null };

export type AvailabilitySection_InterviewerFragment = (
  { __typename?: 'Employee', id: any, useCalendarTimezone: boolean, calendarTimezone?: string | null, timezone?: string | null, interviewPauseDates?: Array<AvailabilitySection_InterviewerFragment_Employee_interviewPauseDates_DateBlock> | null, loadAndLimit?: AvailabilitySection_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit | null, employeePrefs?: Array<AvailabilitySection_InterviewerFragment_Employee_employeePrefs_EmployeePref> | null, workHours?: AvailabilitySection_InterviewerFragment_Employee_workHours_TimeBlockWeek | null }
  & AvailabilitySectionEditDialog_InterviewerFragment
);

export type AvailabilitySectionSaveMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee = (
  { __typename?: 'Employee' }
  & AvailabilitySection_InterviewerFragment
);

export type AvailabilitySectionSaveMutation_employeeUpdate_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: AvailabilitySectionSaveMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee | null };

export type AvailabilitySectionSaveMutation_Mutation = { __typename?: 'Mutation', employeeUpdate?: AvailabilitySectionSaveMutation_employeeUpdate_EmployeeUpdateResult | null };


export type AvailabilitySectionSaveMutationVariables = Exact<{
  input: EmployeeUpdateInput;
  date: Scalars['date']['input'];
  timezone: Scalars['String']['input'];
}>;


export type AvailabilitySectionSaveMutation = AvailabilitySectionSaveMutation_Mutation;

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_after_Duration = { __typename?: 'Duration', seconds: any };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_before_Duration = { __typename?: 'Duration', seconds: any };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref', after?: BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_after_Duration | null, before?: BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_before_Duration | null };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewLimit = { __typename?: 'InterviewLimit' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value = BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_CandidatePageFiltersPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_DirectoryPageFiltersPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardFilterPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardLayoutPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewLimit | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageAverageTimesFiltersPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageCandidatePulseFiltersPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageInterviewerFiltersPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageRecruitingTeamFiltersPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_ProfilePicturePref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_RecentlyUsedZoomUsersPref | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value_UpcomingEventsPageFiltersPref;

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_BoolEmployeePrefValue = { __typename?: 'BoolEmployeePrefValue' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_DurationEmployeePrefValue = { __typename?: 'DurationEmployeePrefValue' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_IntEmployeePrefValue = { __typename?: 'IntEmployeePrefValue' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonArrayEmployeePrefValue = { __typename?: 'JsonArrayEmployeePrefValue' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue = { __typename?: 'JsonEmployeePrefValue', id: string, prefName: string, level: PrefLevel, value?: BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue_value | null };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_StringArrayEmployeePrefValue = { __typename?: 'StringArrayEmployeePrefValue' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_StringEmployeePrefValue = { __typename?: 'StringEmployeePrefValue' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_TimestampEmployeePrefValue = { __typename?: 'TimestampEmployeePrefValue' };

export type BufferTimesSection_InterviewerFragment_Employee_employeePrefValues = BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_BoolEmployeePrefValue | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_DurationEmployeePrefValue | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_IntEmployeePrefValue | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonArrayEmployeePrefValue | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_StringArrayEmployeePrefValue | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_StringEmployeePrefValue | BufferTimesSection_InterviewerFragment_Employee_employeePrefValues_TimestampEmployeePrefValue;

export type BufferTimesSection_InterviewerFragment = { __typename?: 'Employee', id: any, employeePrefValues: Array<BufferTimesSection_InterviewerFragment_Employee_employeePrefValues> };

export type ExternalProfileModalInterviewerFragment_Employee_externalProfilePicture_ProfilePicture = { __typename?: 'ProfilePicture', imageOriginal?: string | null };

export type ExternalProfileModalInterviewerFragment = { __typename?: 'Employee', id: any, givenName?: string | null, familyName?: string | null, fullName?: string | null, title?: string | null, linkedinUrl?: string | null, bio?: string | null, pronouns?: string | null, email: string, externalProfilePicture?: ExternalProfileModalInterviewerFragment_Employee_externalProfilePicture_ProfilePicture | null };

export type ExternalProfileUpdateInterviewerMutation_bioUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', employeeId: any, orgId: any, prefName: string };

export type ExternalProfileUpdateInterviewerMutation_bioUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: ExternalProfileUpdateInterviewerMutation_bioUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type ExternalProfileUpdateInterviewerMutation_pronounsUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', employeeId: any, orgId: any, prefName: string };

export type ExternalProfileUpdateInterviewerMutation_pronounsUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: ExternalProfileUpdateInterviewerMutation_pronounsUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type ExternalProfileUpdateInterviewerMutation_profileImageUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', employeeId: any, orgId: any, prefName: string };

export type ExternalProfileUpdateInterviewerMutation_profileImageUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: ExternalProfileUpdateInterviewerMutation_profileImageUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type ExternalProfileUpdateInterviewerMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee = (
  { __typename?: 'Employee' }
  & ExternalProfileModalInterviewerFragment
);

export type ExternalProfileUpdateInterviewerMutation_employeeUpdate_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: ExternalProfileUpdateInterviewerMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee | null };

export type ExternalProfileUpdateInterviewerMutation_Mutation = { __typename?: 'Mutation', bioUpdate?: ExternalProfileUpdateInterviewerMutation_bioUpdate_EmployeePrefUpdateResult | null, pronounsUpdate?: ExternalProfileUpdateInterviewerMutation_pronounsUpdate_EmployeePrefUpdateResult | null, profileImageUpdate?: ExternalProfileUpdateInterviewerMutation_profileImageUpdate_EmployeePrefUpdateResult | null, employeeUpdate?: ExternalProfileUpdateInterviewerMutation_employeeUpdate_EmployeeUpdateResult | null };


export type ExternalProfileUpdateInterviewerMutationVariables = Exact<{
  pronounsInput: EmployeePrefUpdateInput;
  profileImageInput: EmployeePrefUpdateInput;
  bioInput: EmployeePrefUpdateInput;
  input: EmployeeUpdateInput;
}>;


export type ExternalProfileUpdateInterviewerMutation = ExternalProfileUpdateInterviewerMutation_Mutation;

export type ExternalProfileEditModal_InterviewerFragment = (
  { __typename?: 'Employee' }
  & ExternalProfileModalInterviewerFragment
);

export type ExternalProfileEditModal_InterviewerFieldsSyncSourceFragment = { __typename?: 'EmployeeFieldSyncSourcePref', name?: SyncSourceType | null, title?: SyncSourceType | null, linkedInUrl?: SyncSourceType | null };

export type ProfileCard_InterviewerFragment_Employee_externalProfilePicture_ProfilePicture = { __typename?: 'ProfilePicture', imageOriginal?: string | null };

export type ProfileCard_InterviewerFragment = { __typename?: 'Employee', id: any, fullName?: string | null, title?: string | null, linkedinUrl?: string | null, bio?: string | null, pronouns?: string | null, email: string, externalProfilePicture?: ProfileCard_InterviewerFragment_Employee_externalProfilePicture_ProfilePicture | null };

export type ExternalProfileSection_InterviewerFragment = (
  { __typename?: 'Employee' }
  & ExternalProfileEditModal_InterviewerFragment
  & ProfileCard_InterviewerFragment
);

export type ExternalProfileSection_InterviewerFieldsSyncSourceFragment = (
  { __typename?: 'EmployeeFieldSyncSourcePref' }
  & ExternalProfileEditModal_InterviewerFieldsSyncSourceFragment
);

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_DurationEmployeePrefValue_value_Duration = { __typename?: 'Duration', seconds: any };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_BoolEmployeePrefValue = { __typename?: 'BoolEmployeePrefValue' };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_DurationEmployeePrefValue = { __typename?: 'DurationEmployeePrefValue', id: string, prefName: string, level: PrefLevel, value?: FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_DurationEmployeePrefValue_value_Duration | null };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_IntEmployeePrefValue = { __typename?: 'IntEmployeePrefValue' };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_JsonArrayEmployeePrefValue = { __typename?: 'JsonArrayEmployeePrefValue' };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue = { __typename?: 'JsonEmployeePrefValue' };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_StringArrayEmployeePrefValue = { __typename?: 'StringArrayEmployeePrefValue' };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_StringEmployeePrefValue = { __typename?: 'StringEmployeePrefValue' };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_TimestampEmployeePrefValue = { __typename?: 'TimestampEmployeePrefValue' };

export type FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues = FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_BoolEmployeePrefValue | FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_DurationEmployeePrefValue | FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_IntEmployeePrefValue | FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_JsonArrayEmployeePrefValue | FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_JsonEmployeePrefValue | FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_StringArrayEmployeePrefValue | FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_StringEmployeePrefValue | FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues_TimestampEmployeePrefValue;

export type FeedbackWritingTimeSection_InterviewerFragment = { __typename?: 'Employee', id: any, employeePrefValues: Array<FeedbackWritingTimeSection_InterviewerFragment_Employee_employeePrefValues> };

export type InterviewModulesAccordion_InterviewerModulesFragment_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', fullName?: string | null, timezone?: string | null, id: any, isPaused: boolean, internalProfilePictureUrl?: string | null, title?: string | null };

export type InterviewModulesAccordion_InterviewerModulesFragment_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type InterviewModulesAccordion_InterviewerModulesFragment_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null, upcoming?: any | null, completed?: any | null, manualCompletedAsShadow: any, manualCompletedAsReverseShadow: any };

export type InterviewModulesAccordion_InterviewerModulesFragment = (
  { __typename?: 'InterviewModuleMember', id: string, employeeId: any, interviewModuleId: any, status: TrainingStatus, shadowsRequired: number, reverseShadowsRequired: number, isPausedIndefinitely?: boolean | null, pausedUntil?: any | null, weeklyNumInterviewLimit?: any | null, isPaused?: boolean | null, employee?: InterviewModulesAccordion_InterviewerModulesFragment_InterviewModuleMember_employee_Employee | null, interviewModule?: InterviewModulesAccordion_InterviewerModulesFragment_InterviewModuleMember_interviewModule_InterviewModule | null, stats?: InterviewModulesAccordion_InterviewerModulesFragment_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & ModuleMemberRow_ModuleMemberFragment
);

export type InterviewerStatusAccordion_InterviewerFragment_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type InterviewerStatusAccordion_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type InterviewerStatusAccordion_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type InterviewerStatusAccordion_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit = { __typename?: 'LoadAndLimit', dailyLoad?: number | null, weeklyLoad?: number | null, lastWeeklyLoad?: number | null, dailyLoadMinutes?: number | null, weeklyLoadMinutes?: number | null, lastWeeklyLoadMinutes?: number | null, dailyInterviewLimit?: InterviewerStatusAccordion_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit | null, weeklyInterviewLimit?: InterviewerStatusAccordion_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit | null };

export type InterviewerStatusAccordion_InterviewerFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput_items_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string };

export type InterviewerStatusAccordion_InterviewerFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput_items_InterviewModuleMember = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, isPaused?: boolean | null, interviewModule?: InterviewerStatusAccordion_InterviewerFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput_items_InterviewModuleMember_interviewModule_InterviewModule | null };

export type InterviewerStatusAccordion_InterviewerFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput = { __typename?: 'EmployeeInterviewModuleMembersOutput', items?: Array<InterviewerStatusAccordion_InterviewerFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput_items_InterviewModuleMember> | null };

export type InterviewerStatusAccordion_InterviewerFragment_Employee_orgDirectoryIntegration_OrgDirectoryIntegration = { __typename?: 'OrgDirectoryIntegration', name: string, type: DirectoryType };

export type InterviewerStatusAccordion_InterviewerFragment = { __typename?: 'Employee', id: any, isAtsDisabled?: boolean | null, isArchived?: boolean | null, isDirectoryDisabled: boolean, isDisabled?: boolean | null, isPaused: boolean, hasAtsId?: boolean | null, timezone?: string | null, interviewPauseDates?: Array<InterviewerStatusAccordion_InterviewerFragment_Employee_interviewPauseDates_DateBlock> | null, loadAndLimit?: InterviewerStatusAccordion_InterviewerFragment_Employee_loadAndLimit_LoadAndLimit | null, interviewModuleMembers?: InterviewerStatusAccordion_InterviewerFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput | null, orgDirectoryIntegration?: InterviewerStatusAccordion_InterviewerFragment_Employee_orgDirectoryIntegration_OrgDirectoryIntegration | null };

export type InterviewsAccordion_InterviewFragment = (
  { __typename?: 'ApplicationStageInterview' }
  & InterviewItemFragment
);

export type InterviewsAccordion_EmployeeFragment = { __typename?: 'Employee', id: any };

export type EmployeeKeywordsQuery_thisOrg_Org_orgPrefByNames_OrgPref = { __typename?: 'OrgPref', orgId: any, prefName: string, stringArray?: Array<string> | null };

export type EmployeeKeywordsQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPrefByNames: Array<EmployeeKeywordsQuery_thisOrg_Org_orgPrefByNames_OrgPref> };

export type EmployeeKeywordsQuery_employee_Employee_employeePrefByNames_EmployeePref = { __typename?: 'EmployeePref', id: string, orgId: any, employeeId: any, prefName: string, stringArray?: Array<string> | null };

export type EmployeeKeywordsQuery_employee_Employee = { __typename?: 'Employee', id: any, employeePrefByNames: Array<EmployeeKeywordsQuery_employee_Employee_employeePrefByNames_EmployeePref> };

export type EmployeeKeywordsQuery_Query = { __typename?: 'Query', thisOrg?: EmployeeKeywordsQuery_thisOrg_Org | null, employee?: EmployeeKeywordsQuery_employee_Employee | null };


export type EmployeeKeywordsQueryVariables = Exact<{
  employeeId: Scalars['uuid']['input'];
  orgKeywordNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  employeeKeywordNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EmployeeKeywordsQuery = EmployeeKeywordsQuery_Query;

export type DeletePlannedAvailabilityMutation_employeePlannedAvailabilityDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type DeletePlannedAvailabilityMutation_Mutation = { __typename?: 'Mutation', employeePlannedAvailabilityDelete: DeletePlannedAvailabilityMutation_employeePlannedAvailabilityDelete_EmptyResult };


export type DeletePlannedAvailabilityMutationVariables = Exact<{
  input: EmployeePlannedAvailabilityDeleteInput;
}>;


export type DeletePlannedAvailabilityMutation = DeletePlannedAvailabilityMutation_Mutation;

export type TemporaryAvailabilityDialog_PlannedAvailabilityFragment_EmployeePlannedAvailability_workHours_TimeBlockWeek = (
  { __typename?: 'TimeBlockWeek' }
  & TemporaryAvailabilityWorkHours_WorkHoursFragment
);

export type TemporaryAvailabilityDialog_PlannedAvailabilityFragment = { __typename?: 'EmployeePlannedAvailability', id: any, employeeId: any, startAt: any, endAt: any, timezone: any, workHours: TemporaryAvailabilityDialog_PlannedAvailabilityFragment_EmployeePlannedAvailability_workHours_TimeBlockWeek };

export type CreatePlannedAvailabilityMutation_employeePlannedAvailabilityCreate_EmployeePlannedAvailabilityResult_item_EmployeePlannedAvailability = (
  { __typename?: 'EmployeePlannedAvailability' }
  & TemporaryAvailabilityDialog_PlannedAvailabilityFragment
);

export type CreatePlannedAvailabilityMutation_employeePlannedAvailabilityCreate_EmployeePlannedAvailabilityResult = { __typename?: 'EmployeePlannedAvailabilityResult', item: CreatePlannedAvailabilityMutation_employeePlannedAvailabilityCreate_EmployeePlannedAvailabilityResult_item_EmployeePlannedAvailability };

export type CreatePlannedAvailabilityMutation_Mutation = { __typename?: 'Mutation', employeePlannedAvailabilityCreate: CreatePlannedAvailabilityMutation_employeePlannedAvailabilityCreate_EmployeePlannedAvailabilityResult };


export type CreatePlannedAvailabilityMutationVariables = Exact<{
  input: EmployeePlannedAvailabilityCreateInput;
}>;


export type CreatePlannedAvailabilityMutation = CreatePlannedAvailabilityMutation_Mutation;

export type UpdatePlannedAvailabilityMutation_employeePlannedAvailabilityUpdate_EmployeePlannedAvailabilityResult_item_EmployeePlannedAvailability = (
  { __typename?: 'EmployeePlannedAvailability' }
  & TemporaryAvailabilityDialog_PlannedAvailabilityFragment
);

export type UpdatePlannedAvailabilityMutation_employeePlannedAvailabilityUpdate_EmployeePlannedAvailabilityResult = { __typename?: 'EmployeePlannedAvailabilityResult', item: UpdatePlannedAvailabilityMutation_employeePlannedAvailabilityUpdate_EmployeePlannedAvailabilityResult_item_EmployeePlannedAvailability };

export type UpdatePlannedAvailabilityMutation_Mutation = { __typename?: 'Mutation', employeePlannedAvailabilityUpdate: UpdatePlannedAvailabilityMutation_employeePlannedAvailabilityUpdate_EmployeePlannedAvailabilityResult };


export type UpdatePlannedAvailabilityMutationVariables = Exact<{
  input: EmployeePlannedAvailabilityUpdateInput;
}>;


export type UpdatePlannedAvailabilityMutation = UpdatePlannedAvailabilityMutation_Mutation;

export type TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_monday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_tuesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_wednesday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_thursday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_friday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_saturday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_sunday_TimeBlock = { __typename?: 'TimeBlock', start?: string | null, end?: string | null };

export type TemporaryAvailabilityWorkHours_WorkHoursFragment = { __typename?: 'TimeBlockWeek', monday?: Array<TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_monday_TimeBlock> | null, tuesday?: Array<TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_tuesday_TimeBlock> | null, wednesday?: Array<TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_wednesday_TimeBlock> | null, thursday?: Array<TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_thursday_TimeBlock> | null, friday?: Array<TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_friday_TimeBlock> | null, saturday?: Array<TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_saturday_TimeBlock> | null, sunday?: Array<TemporaryAvailabilityWorkHours_WorkHoursFragment_TimeBlockWeek_sunday_TimeBlock> | null };

export type UpdatePauseDatesMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee = (
  { __typename?: 'Employee', id: any, isPaused: boolean }
  & PlannedAvailabilitySection_InterviewerFragment
);

export type UpdatePauseDatesMutation_employeeUpdate_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: UpdatePauseDatesMutation_employeeUpdate_EmployeeUpdateResult_employee_Employee | null };

export type UpdatePauseDatesMutation_Mutation = { __typename?: 'Mutation', employeeUpdate?: UpdatePauseDatesMutation_employeeUpdate_EmployeeUpdateResult | null };


export type UpdatePauseDatesMutationVariables = Exact<{
  input: EmployeeUpdateInput;
}>;


export type UpdatePauseDatesMutation = UpdatePauseDatesMutation_Mutation;

export type PlannedAvailabilitySection_InterviewerFragment_Employee_interviewPauseDates_DateBlock = { __typename?: 'DateBlock', start?: string | null, end?: string | null };

export type PlannedAvailabilitySection_InterviewerFragment_Employee_plannedAvailabilities_EmployeePlannedAvailability = (
  { __typename?: 'EmployeePlannedAvailability', id: any }
  & TemporaryAvailabilityDialog_PlannedAvailabilityFragment
);

export type PlannedAvailabilitySection_InterviewerFragment = { __typename?: 'Employee', id: any, useCalendarTimezone: boolean, calendarTimezone?: string | null, timezone?: string | null, interviewPauseDates?: Array<PlannedAvailabilitySection_InterviewerFragment_Employee_interviewPauseDates_DateBlock> | null, plannedAvailabilities: Array<PlannedAvailabilitySection_InterviewerFragment_Employee_plannedAvailabilities_EmployeePlannedAvailability> };

export type SchedulingContactSection_InterviewerFragment_Employee_calendarDelegate_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type SchedulingContactSection_InterviewerFragment = (
  { __typename?: 'Employee', fullName?: string | null, calendarDelegate?: SchedulingContactSection_InterviewerFragment_Employee_calendarDelegate_Employee | null }
  & SchedulingContactSectionEditDialog_InterviewerFragment
);

export type SchedulingContactEmployeeCacheFragmentFragment = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type SchedulingContactSectionEditDialog_InterviewerFragment_Employee_calendarDelegate_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type SchedulingContactSectionEditDialog_InterviewerFragment = { __typename?: 'Employee', id: any, email: string, calendarDelegate?: SchedulingContactSectionEditDialog_InterviewerFragment_Employee_calendarDelegate_Employee | null };

export type InterviewerInfoContainer_EmployeeFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput_items_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember' }
  & InterviewModulesAccordion_InterviewerModulesFragment
);

export type InterviewerInfoContainer_EmployeeFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput = { __typename?: 'EmployeeInterviewModuleMembersOutput', items?: Array<InterviewerInfoContainer_EmployeeFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput_items_InterviewModuleMember> | null };

export type InterviewerInfoContainer_EmployeeFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput_items_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview' }
  & InterviewsAccordion_InterviewFragment
);

export type InterviewerInfoContainer_EmployeeFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput = { __typename?: 'EmployeeApplicationStageInterviewsOutput', items: Array<InterviewerInfoContainer_EmployeeFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput_items_ApplicationStageInterview> };

export type InterviewerInfoContainer_EmployeeFragment = (
  { __typename?: 'Employee', id: any, fullName?: string | null, email: string, isPaused: boolean, orgId: any, interviewModuleMembers?: InterviewerInfoContainer_EmployeeFragment_Employee_interviewModuleMembers_EmployeeInterviewModuleMembersOutput | null, applicationStageInterviews?: InterviewerInfoContainer_EmployeeFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput | null }
  & BufferTimesSection_InterviewerFragment
  & FeedbackWritingTimeSection_InterviewerFragment
  & InterviewerStatusAccordion_InterviewerFragment
  & InterviewerAboutSection_InterviewerFragment
  & SchedulingContactSection_InterviewerFragment
  & AvailabilitySection_InterviewerFragment
  & InterviewerAttributesSection_InterviewerFragment
  & PlannedAvailabilitySection_InterviewerFragment
  & ExternalProfileSection_InterviewerFragment
  & InterviewsAccordion_EmployeeFragment
);

export type InterviewerInfoContainer_InterviewerFieldsSyncSourceFragment = (
  { __typename?: 'EmployeeFieldSyncSourcePref' }
  & ExternalProfileSection_InterviewerFieldsSyncSourceFragment
);

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null, job?: InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_job_Job | null, jobStage?: InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application_jobStage_JobStage | null };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, application?: InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage_application_Application | null };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined = { __typename?: 'InterviewInterviewerDeclined', reason?: DeclineReason | null, comment?: string | null, source?: string | null };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any, role?: InterviewerRole | null, responseStatus?: ResponseStatus | null, isOptional: boolean, interviewer?: InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee | null, declines?: Array<InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined> | null };

export type InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom = { __typename?: 'ApplicationStageInterviewRoom', applicationStageInterviewId: any, meetingRoomId: any, responseStatus?: ResponseStatus | null };

export type InterviewsTab_InterviewFragment = { __typename?: 'ApplicationStageInterview', id: any, name?: string | null, startAt: any, endAt: any, isCancelled?: boolean | null, googleEventUrl?: string | null, applicationStage?: InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStage_ApplicationStage | null, applicationStageInterviewInterviewers?: Array<InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null, applicationStageInterviewRooms?: Array<InterviewsTab_InterviewFragment_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom> | null };

export type InterviewsTab_InterviewerFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput_items_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview' }
  & InterviewsTab_InterviewFragment
);

export type InterviewsTab_InterviewerFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput = { __typename?: 'EmployeeApplicationStageInterviewsOutput', nextCursor?: string | null, items: Array<InterviewsTab_InterviewerFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput_items_ApplicationStageInterview> };

export type InterviewsTab_InterviewerFragment = { __typename?: 'Employee', id: any, applicationStageInterviews?: InterviewsTab_InterviewerFragment_Employee_applicationStageInterviews_EmployeeApplicationStageInterviewsOutput | null };

export type InterviewsTabInterviewerQuery_employee_Employee = (
  { __typename?: 'Employee', id: any }
  & InterviewsTab_InterviewerFragment
);

export type InterviewsTabInterviewerQuery_Query = { __typename?: 'Query', employee?: InterviewsTabInterviewerQuery_employee_Employee | null };


export type InterviewsTabInterviewerQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: EmployeeApplicationStageInterviewsInput;
}>;


export type InterviewsTabInterviewerQuery = InterviewsTabInterviewerQuery_Query;

export type EmployeeDetailsViewQuery_employee_Employee = (
  { __typename?: 'Employee' }
  & InterviewerInfoContainer_EmployeeFragment
  & InterviewModulesTab_EmployeeFragment
  & EmployeeDetailsFragmentFragment
);

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = (
  { __typename?: 'EmployeeFieldSyncSourcePref' }
  & InterviewerInfoContainer_InterviewerFieldsSyncSourceFragment
);

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference = { __typename?: 'NotificationPreference' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref = EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref | EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek;

export type EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref_jsonPref | null };

export type EmployeeDetailsViewQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPref?: EmployeeDetailsViewQuery_thisOrg_Org_orgPref_OrgPref | null };

export type EmployeeDetailsViewQuery_Query = { __typename?: 'Query', employee?: EmployeeDetailsViewQuery_employee_Employee | null, thisOrg?: EmployeeDetailsViewQuery_thisOrg_Org | null };


export type EmployeeDetailsViewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  date: Scalars['date']['input'];
  timezone: Scalars['String']['input'];
}>;


export type EmployeeDetailsViewQuery = EmployeeDetailsViewQuery_Query;

export type JobAiTabQuery_job_Job_aiInstruction_AiInstruction = (
  { __typename?: 'AiInstruction' }
  & AiInstructionsCard_InstructionFragment
);

export type JobAiTabQuery_job_Job_aiMemories_AiMemory = (
  { __typename?: 'AiMemory' }
  & AiMemoriesCard_MemoryFragment
);

export type JobAiTabQuery_job_Job = { __typename?: 'Job', id: any, aiInstruction?: JobAiTabQuery_job_Job_aiInstruction_AiInstruction | null, aiMemories: Array<JobAiTabQuery_job_Job_aiMemories_AiMemory> };

export type JobAiTabQuery_Query = { __typename?: 'Query', job?: JobAiTabQuery_job_Job | null };


export type JobAiTabQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobAiTabQuery = JobAiTabQuery_Query;

export type PortalPreviewByJobStage_BrandingThemeFragment = { __typename?: 'BrandingTheme', id: any, coverImageUrl?: string | null, profileImageUrl?: string | null, font?: string | null, themeMode?: BrandingThemeMode | null, primaryColor?: string | null };

export type PortalPreviewByJobStage_JobStagesFragment = { __typename?: 'JobStage', id: any, name: string, index: number };

export type PortalPreviewByJobStage_RecruitingTeamContactInfoFragment = { __typename?: 'RecruitingTeamContactInfoSetting', showRecruiter: boolean, showCoordinator: boolean };

export type CandidatePortalPreviewQuery_job_Job_jobStages_JobStage = (
  { __typename?: 'JobStage' }
  & PortalPreviewByJobStage_JobStagesFragment
);

export type CandidatePortalPreviewQuery_job_Job_jobSettings_JobSettings_recruitingTeamContactInfoSetting_RecruitingTeamContactInfoSetting = (
  { __typename?: 'RecruitingTeamContactInfoSetting' }
  & PortalPreviewByJobStage_RecruitingTeamContactInfoFragment
);

export type CandidatePortalPreviewQuery_job_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, recruitingTeamContactInfoSetting: CandidatePortalPreviewQuery_job_Job_jobSettings_JobSettings_recruitingTeamContactInfoSetting_RecruitingTeamContactInfoSetting };

export type CandidatePortalPreviewQuery_job_Job = { __typename?: 'Job', id: any, name: string, jobStages?: Array<CandidatePortalPreviewQuery_job_Job_jobStages_JobStage> | null, jobSettings: CandidatePortalPreviewQuery_job_Job_jobSettings_JobSettings };

export type CandidatePortalPreviewQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme = (
  { __typename?: 'BrandingTheme', id: any, isOrgDefault: boolean }
  & PortalPreviewByJobStage_BrandingThemeFragment
);

export type CandidatePortalPreviewQuery_brandingThemes_BrandingThemesResult = { __typename?: 'BrandingThemesResult', items: Array<CandidatePortalPreviewQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme> };

export type CandidatePortalPreviewQuery_Query = { __typename?: 'Query', job?: CandidatePortalPreviewQuery_job_Job | null, brandingThemes?: CandidatePortalPreviewQuery_brandingThemes_BrandingThemesResult | null };


export type CandidatePortalPreviewQueryVariables = Exact<{
  jobId: Scalars['uuid']['input'];
}>;


export type CandidatePortalPreviewQuery = CandidatePortalPreviewQuery_Query;

export type CustomTabs_CustomTabsFragment = (
  { __typename?: 'PortalJobOptionsTab', id: any }
  & DraggableTabRows_TabsFragment
);

export type DraggableTabRows_TabsFragment = (
  { __typename?: 'PortalJobOptionsTab', id: any }
  & TabRow_TabFragment
);

export type JobPortalConfigQuery_job_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string, index: number };

export type JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions_linkedPortalConfig_PortalConfig_tabs_PortalConfigTab = { __typename?: 'PortalConfigTab', id: any, name: string, icon: string, index: any, portalTemplateId: any, visibility: PortalJobOptionsTabVisibilityType, stageNameFilter?: string | null };

export type JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions_linkedPortalConfig_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string, tabs: Array<JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions_linkedPortalConfig_PortalConfig_tabs_PortalConfigTab> };

export type JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions_tabs_PortalJobOptionsTab = { __typename?: 'PortalJobOptionsTab', id: any, name: string, icon: string, index: any, portalTemplateId: any, visibility: PortalJobOptionsTabVisibilityType, stageNameFilter?: string | null, jobStageId?: any | null };

export type JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions = { __typename?: 'PortalJobOptions', id: any, intro?: string | null, brandingThemeId?: any | null, useOrgDefaultBrandingTheme?: boolean | null, aiAssistantId?: string | null, linkedPortalConfig?: JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions_linkedPortalConfig_PortalConfig | null, tabs: Array<JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions_tabs_PortalJobOptionsTab> };

export type JobPortalConfigQuery_job_Job = { __typename?: 'Job', id: any, externalJobName: string, jobStages?: Array<JobPortalConfigQuery_job_Job_jobStages_JobStage> | null, portalJobOptions?: JobPortalConfigQuery_job_Job_portalJobOptions_PortalJobOptions | null };

export type JobPortalConfigQuery_portalConfigs_PortalConfigsResult_items_PortalConfig_tabs_PortalConfigTab = { __typename?: 'PortalConfigTab', id: any, name: string, icon: string, index: any, portalTemplateId: any, visibility: PortalJobOptionsTabVisibilityType, stageNameFilter?: string | null };

export type JobPortalConfigQuery_portalConfigs_PortalConfigsResult_items_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string, isDefault: boolean, intro?: string | null, brandingThemeId?: any | null, aiAssistantId?: string | null, tabs: Array<JobPortalConfigQuery_portalConfigs_PortalConfigsResult_items_PortalConfig_tabs_PortalConfigTab> };

export type JobPortalConfigQuery_portalConfigs_PortalConfigsResult = { __typename?: 'PortalConfigsResult', items: Array<JobPortalConfigQuery_portalConfigs_PortalConfigsResult_items_PortalConfig> };

export type JobPortalConfigQuery_Query = { __typename?: 'Query', job?: JobPortalConfigQuery_job_Job | null, portalConfigs?: JobPortalConfigQuery_portalConfigs_PortalConfigsResult | null };


export type JobPortalConfigQueryVariables = Exact<{
  jobId: Scalars['uuid']['input'];
}>;


export type JobPortalConfigQuery = JobPortalConfigQuery_Query;

export type JobPortalConfigLinkMutation_portalJobOptionsLinkToConfig_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type JobPortalConfigLinkMutation_Mutation = { __typename?: 'Mutation', portalJobOptionsLinkToConfig: JobPortalConfigLinkMutation_portalJobOptionsLinkToConfig_EmptyResult };


export type JobPortalConfigLinkMutationVariables = Exact<{
  input: PortalJobOptionsLinkToConfigInput;
}>;


export type JobPortalConfigLinkMutation = JobPortalConfigLinkMutation_Mutation;

export type JobPortalConfigUnlinkMutation_portalJobOptionsUnlinkFromConfig_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type JobPortalConfigUnlinkMutation_Mutation = { __typename?: 'Mutation', portalJobOptionsUnlinkFromConfig: JobPortalConfigUnlinkMutation_portalJobOptionsUnlinkFromConfig_EmptyResult };


export type JobPortalConfigUnlinkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobPortalConfigUnlinkMutation = JobPortalConfigUnlinkMutation_Mutation;

export type Settings_PortalJobOptionsFragment = { __typename?: 'PortalJobOptions', intro?: string | null, brandingThemeId?: any | null, useOrgDefaultBrandingTheme?: boolean | null, aiAssistantId?: string | null };

export type TabRow_TabFragment_PortalJobOptionsTab_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type TabRow_TabFragment = { __typename?: 'PortalJobOptionsTab', id: any, index: any, name: string, icon: string, visibility: PortalJobOptionsTabVisibilityType, portalTemplateId: any, jobStageId?: any | null, jobStage?: TabRow_TabFragment_PortalJobOptionsTab_jobStage_JobStage | null };

export type JobPortalOptionsQuery_job_Job_settings_PortalJobOptions = (
  { __typename?: 'PortalJobOptions', id: any }
  & Settings_PortalJobOptionsFragment
);

export type JobPortalOptionsQuery_job_Job_customTabs_PortalJobOptions_tabs_PortalJobOptionsTab_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type JobPortalOptionsQuery_job_Job_customTabs_PortalJobOptions_tabs_PortalJobOptionsTab = (
  { __typename?: 'PortalJobOptionsTab', jobStage?: JobPortalOptionsQuery_job_Job_customTabs_PortalJobOptions_tabs_PortalJobOptionsTab_jobStage_JobStage | null }
  & CustomTabs_CustomTabsFragment
);

export type JobPortalOptionsQuery_job_Job_customTabs_PortalJobOptions = { __typename?: 'PortalJobOptions', id: any, tabs: Array<JobPortalOptionsQuery_job_Job_customTabs_PortalJobOptions_tabs_PortalJobOptionsTab> };

export type JobPortalOptionsQuery_job_Job = { __typename?: 'Job', id: any, externalJobName: string, settings?: JobPortalOptionsQuery_job_Job_settings_PortalJobOptions | null, customTabs?: JobPortalOptionsQuery_job_Job_customTabs_PortalJobOptions | null };

export type JobPortalOptionsQuery_Query = { __typename?: 'Query', job?: JobPortalOptionsQuery_job_Job | null };


export type JobPortalOptionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobPortalOptionsQuery = JobPortalOptionsQuery_Query;

export type JobPortalOptionMutationMutation_portalJobOptionsUpsert_PortalJobOptionsResult_options_PortalJobOptions_tabs_PortalJobOptionsTab = (
  { __typename?: 'PortalJobOptionsTab' }
  & CustomTabs_CustomTabsFragment
);

export type JobPortalOptionMutationMutation_portalJobOptionsUpsert_PortalJobOptionsResult_options_PortalJobOptions = (
  { __typename?: 'PortalJobOptions', id: any, tabs: Array<JobPortalOptionMutationMutation_portalJobOptionsUpsert_PortalJobOptionsResult_options_PortalJobOptions_tabs_PortalJobOptionsTab> }
  & Settings_PortalJobOptionsFragment
);

export type JobPortalOptionMutationMutation_portalJobOptionsUpsert_PortalJobOptionsResult = { __typename?: 'PortalJobOptionsResult', options: JobPortalOptionMutationMutation_portalJobOptionsUpsert_PortalJobOptionsResult_options_PortalJobOptions };

export type JobPortalOptionMutationMutation_Mutation = { __typename?: 'Mutation', portalJobOptionsUpsert: JobPortalOptionMutationMutation_portalJobOptionsUpsert_PortalJobOptionsResult };


export type JobPortalOptionMutationMutationVariables = Exact<{
  input: PortalJobOptionsUpsertInput;
}>;


export type JobPortalOptionMutationMutation = JobPortalOptionMutationMutation_Mutation;

export type HiringProcess_JobFragment = (
  { __typename?: 'Job', id: any }
  & JobNameAndLocationHeader_JobFragment
);

export type HiringTeamJobEmployeeFragmentFragment = { __typename?: 'Employee', fullName?: string | null, email: string, id: any, orgId: any, internalProfilePictureUrl?: string | null, timezone?: string | null, atsId?: string | null };

export type HiringTeam_JobEmployeeFragment_Job_hiringManagers_Employee = (
  { __typename?: 'Employee' }
  & HiringTeamJobEmployeeFragmentFragment
);

export type HiringTeam_JobEmployeeFragment_Job_recruiters_Employee = (
  { __typename?: 'Employee' }
  & HiringTeamJobEmployeeFragmentFragment
);

export type HiringTeam_JobEmployeeFragment_Job_coordinators_Employee = (
  { __typename?: 'Employee' }
  & HiringTeamJobEmployeeFragmentFragment
);

export type HiringTeam_JobEmployeeFragment_Job_sourcers_Employee = (
  { __typename?: 'Employee' }
  & HiringTeamJobEmployeeFragmentFragment
);

export type HiringTeam_JobEmployeeFragment = { __typename?: 'Job', hiringManagers?: Array<HiringTeam_JobEmployeeFragment_Job_hiringManagers_Employee> | null, recruiters?: Array<HiringTeam_JobEmployeeFragment_Job_recruiters_Employee> | null, coordinators?: Array<HiringTeam_JobEmployeeFragment_Job_coordinators_Employee> | null, sourcers?: Array<HiringTeam_JobEmployeeFragment_Job_sourcers_Employee> | null };

export type JobLocale_JobFragment_Job_jobSettings_JobSettings_locale_SettingLocaleValue = { __typename?: 'SettingLocaleValue', value?: Locale | null, level: SettingLevel };

export type JobLocale_JobFragment_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', locale: JobLocale_JobFragment_Job_jobSettings_JobSettings_locale_SettingLocaleValue };

export type JobLocale_JobFragment = { __typename?: 'Job', jobSettings: JobLocale_JobFragment_Job_jobSettings_JobSettings };

export type GeneralSetupSettings_JobFragment_Job_jobSettings_JobSettings_defaultTaskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any };

export type GeneralSetupSettings_JobFragment_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus = { __typename?: 'HiringProcessWithStatus', name?: string | null, status: HiringProcessStatus };

export type GeneralSetupSettings_JobFragment_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, defaultTaskQueue?: GeneralSetupSettings_JobFragment_Job_jobSettings_JobSettings_defaultTaskQueue_TaskQueue | null, hiringProcess?: GeneralSetupSettings_JobFragment_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus | null };

export type GeneralSetupSettings_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags' }
  & GetHiringMismatchError_FlagsFragment
);

export type GeneralSetupSettings_JobFragment_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<GeneralSetupSettings_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type GeneralSetupSettings_JobFragment = (
  { __typename?: 'Job', id: any, jobSettings: GeneralSetupSettings_JobFragment_Job_jobSettings_JobSettings, validationIssues: GeneralSetupSettings_JobFragment_Job_validationIssues_JobValidationResult }
  & JobLocale_JobFragment
  & ResetSmartRecruitersHiringProcessDialog_JobFragment
);

export type JobDisplayNameSection_JobFragment = (
  { __typename?: 'Job', id: any, name: string, fallbackName?: string | null, atsJobPostingName?: string | null }
  & ManageJobDisplayNameModal_JobFragment
);

export type ManageJobDisplayNameModal_JobFragment = { __typename?: 'Job', id: any, name: string, fallbackName?: string | null };

export type JobNameUpdateMutation_jobUpdate_JobUpdateResult_job_Job = (
  { __typename?: 'Job', id: any }
  & ManageJobDisplayNameModal_JobFragment
);

export type JobNameUpdateMutation_jobUpdate_JobUpdateResult = { __typename?: 'JobUpdateResult', job: JobNameUpdateMutation_jobUpdate_JobUpdateResult_job_Job };

export type JobNameUpdateMutation_Mutation = { __typename?: 'Mutation', jobUpdate?: JobNameUpdateMutation_jobUpdate_JobUpdateResult | null };


export type JobNameUpdateMutationVariables = Exact<{
  input: JobUpdateInput;
}>;


export type JobNameUpdateMutation = JobNameUpdateMutation_Mutation;

export type InterviewName_InterviewNameInfoFromJobFragment = (
  { __typename?: 'InterviewNameSetting', isCustom: boolean, isLocked: boolean, showInterviewName: boolean }
  & InterviewNameDialog_InterviewNameInfoFromJobFragment
);

export type InterviewNameDialog_InterviewNameInfoFromJobFragment = { __typename?: 'InterviewNameSetting', showInterviewName: boolean, isCustom: boolean, isLocked: boolean };

export type InterviewerVisibility_InterviewerVisibilityFromJobFragment = (
  { __typename?: 'InterviewerInfoSetting', isCustom: boolean, isLocked: boolean, canShowInfo: boolean, canShowFullName: boolean, canShowJobTitle: boolean, canShowLinkedin: boolean, canShowEmail: boolean, canShowProfilePicture: boolean, canShowPronouns: boolean, canShowBio: boolean }
  & InterviewerVisibilityDialog_InterviewerVisibilityFromJobFragment
);

export type InterviewerVisibilityDialog_InterviewerVisibilityFromJobFragment = { __typename?: 'InterviewerInfoSetting', isCustom: boolean, isLocked: boolean, canShowInfo: boolean };

export type RecruitingTeamDialog_RecruitingTeamVisibilityFromJobFragment = { __typename?: 'RecruitingTeamContactInfoSetting', showCoordinator: boolean, showRecruiter: boolean, isCustom: boolean };

export type RecruitingTeamVisibility_RecruitingTeamVisibilityFromJobFragment = (
  { __typename?: 'RecruitingTeamContactInfoSetting', isCustom: boolean, isLocked: boolean, showCoordinator: boolean, showRecruiter: boolean, canShowJobTitle: boolean, canShowLinkedin: boolean, canShowProfilePicture: boolean, canShowPronouns: boolean, canShowBio: boolean, canShowPhone: boolean }
  & RecruitingTeamDialog_RecruitingTeamVisibilityFromJobFragment
);

export type PrivacySettings_InterviewNameInfoFromJobFragment = (
  { __typename?: 'InterviewNameSetting' }
  & InterviewName_InterviewNameInfoFromJobFragment
);

export type PrivacySettings_InterviewerVisibilityFromJobFragment = (
  { __typename?: 'InterviewerInfoSetting' }
  & InterviewerVisibility_InterviewerVisibilityFromJobFragment
);

export type PrivacySettings_RecruitingTeamVisibilityFromJobFragment = (
  { __typename?: 'RecruitingTeamContactInfoSetting' }
  & RecruitingTeamVisibility_RecruitingTeamVisibilityFromJobFragment
);

export type JobDetailsSetup_JobSettingsFragment_JobSettings_interviewNameSetting_InterviewNameSetting = (
  { __typename?: 'InterviewNameSetting' }
  & InterviewName_InterviewNameInfoFromJobFragment
);

export type JobDetailsSetup_JobSettingsFragment_JobSettings_interviewerInfoSetting_InterviewerInfoSetting = (
  { __typename?: 'InterviewerInfoSetting', canShowEmail: boolean, canShowBio: boolean, canShowPronouns: boolean, canShowProfilePicture: boolean }
  & InterviewerVisibility_InterviewerVisibilityFromJobFragment
);

export type JobDetailsSetup_JobSettingsFragment_JobSettings_recruitingTeamContactInfoSetting_RecruitingTeamContactInfoSetting = (
  { __typename?: 'RecruitingTeamContactInfoSetting', canShowBio: boolean, canShowPronouns: boolean, canShowProfilePicture: boolean, canShowJobTitle: boolean, canShowLinkedin: boolean, canShowPhone: boolean }
  & RecruitingTeamVisibility_RecruitingTeamVisibilityFromJobFragment
);

export type JobDetailsSetup_JobSettingsFragment = { __typename?: 'JobSettings', settingLevelId: any, settingLevel: SettingLevel, interviewNameSetting: JobDetailsSetup_JobSettingsFragment_JobSettings_interviewNameSetting_InterviewNameSetting, interviewerInfoSetting: JobDetailsSetup_JobSettingsFragment_JobSettings_interviewerInfoSetting_InterviewerInfoSetting, recruitingTeamContactInfoSetting: JobDetailsSetup_JobSettingsFragment_JobSettings_recruitingTeamContactInfoSetting_RecruitingTeamContactInfoSetting };

export type JobDetailsSetupQuery_job_Job_jobSettings_JobSettings = (
  { __typename?: 'JobSettings', id: any }
  & JobDetailsSetup_JobSettingsFragment
);

export type JobDetailsSetupQuery_job_Job = (
  { __typename?: 'Job', id: any, jobSettings: JobDetailsSetupQuery_job_Job_jobSettings_JobSettings }
  & GeneralSetupSettings_JobFragment
  & JobDisplayNameSection_JobFragment
);

export type JobDetailsSetupQuery_Query = { __typename?: 'Query', job?: JobDetailsSetupQuery_job_Job | null };


export type JobDetailsSetupQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobDetailsSetupQuery = JobDetailsSetupQuery_Query;

export type UpdateJobSettingsMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings = (
  { __typename?: 'JobSettings', id: any }
  & JobDetailsSetup_JobSettingsFragment
);

export type UpdateJobSettingsMutation_jobSettingsUpsert_JobSettingsUpsertResult = { __typename?: 'JobSettingsUpsertResult', jobSettings: UpdateJobSettingsMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings };

export type UpdateJobSettingsMutation_Mutation = { __typename?: 'Mutation', jobSettingsUpsert?: UpdateJobSettingsMutation_jobSettingsUpsert_JobSettingsUpsertResult | null };


export type UpdateJobSettingsMutationVariables = Exact<{
  input: JobSettingsUpsertInput;
}>;


export type UpdateJobSettingsMutation = UpdateJobSettingsMutation_Mutation;

export type JobNameAndLocationHeader_JobFragment_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsCustomerFriendlyId?: string | null };

export type JobNameAndLocationHeader_JobFragment = { __typename?: 'Job', id: any, status: JobStatus, name: string, location?: Array<string> | null, atsJob?: JobNameAndLocationHeader_JobFragment_Job_atsJob_AtsJob | null };

export type CalendarEventVisibilityRow_JobStageSettingsFragment_JobStageSettingsV2_isPrivateCalendarEvent_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type CalendarEventVisibilityRow_JobStageSettingsFragment = { __typename?: 'JobStageSettingsV2', id: any, isPrivateCalendarEvent: CalendarEventVisibilityRow_JobStageSettingsFragment_JobStageSettingsV2_isPrivateCalendarEvent_SettingBoolValue };

export type CalendarEventVisibilityUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & CalendarEventVisibilityRow_JobStageSettingsFragment
);

export type CalendarEventVisibilityUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: CalendarEventVisibilityUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type CalendarEventVisibilityUpsertMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: CalendarEventVisibilityUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type CalendarEventVisibilityUpsertMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type CalendarEventVisibilityUpsertMutation = CalendarEventVisibilityUpsertMutation_Mutation;

export type DebriefScheduleLocation_DebriefMeetingLocationSettingFragment_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref_hostEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type DebriefScheduleLocation_DebriefMeetingLocationSettingFragment_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, firstName?: string | null, lastName?: string | null, email: string };

export type DebriefScheduleLocation_DebriefMeetingLocationSettingFragment_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, dynamicHost?: DynamicInterviewMeetingHost | null, hostEmployee?: DebriefScheduleLocation_DebriefMeetingLocationSettingFragment_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref_hostEmployee_Employee | null, remoteVideoMeetingHostUser?: DebriefScheduleLocation_DebriefMeetingLocationSettingFragment_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser | null }
  & InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragment
  & InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment
);

export type DebriefScheduleLocation_DebriefMeetingLocationSettingFragment = { __typename?: 'DebriefMeetingLocationSettingWithLevel', level: SettingLevel, debriefMeetingLocationSetting?: DebriefScheduleLocation_DebriefMeetingLocationSettingFragment_DebriefMeetingLocationSettingWithLevel_debriefMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type DebriefMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel = (
  { __typename?: 'DebriefMeetingLocationSettingWithLevel' }
  & DebriefScheduleLocation_DebriefMeetingLocationSettingFragment
);

export type DebriefMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, debriefMeetingLocationSettingWithLevel?: DebriefMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel | null };

export type DebriefMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: DebriefMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type DebriefMeetingLocationUpsertMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: DebriefMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type DebriefMeetingLocationUpsertMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type DebriefMeetingLocationUpsertMutation = DebriefMeetingLocationUpsertMutation_Mutation;

export type ScheduleLocation_InterviewMeetingLocationSettingFragment_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref_hostEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ScheduleLocation_InterviewMeetingLocationSettingFragment_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, firstName?: string | null, lastName?: string | null, email: string };

export type ScheduleLocation_InterviewMeetingLocationSettingFragment_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, dynamicHost?: DynamicInterviewMeetingHost | null, hostEmployee?: ScheduleLocation_InterviewMeetingLocationSettingFragment_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref_hostEmployee_Employee | null, remoteVideoMeetingHostUser?: ScheduleLocation_InterviewMeetingLocationSettingFragment_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref_remoteVideoMeetingHostUser_ZoomUser | null }
  & InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragment
  & InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment
);

export type ScheduleLocation_InterviewMeetingLocationSettingFragment = { __typename?: 'InterviewMeetingLocationSettingWithLevel', level: SettingLevel, interviewMeetingLocationSetting?: ScheduleLocation_InterviewMeetingLocationSettingFragment_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type InterviewMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = (
  { __typename?: 'InterviewMeetingLocationSettingWithLevel' }
  & ScheduleLocation_InterviewMeetingLocationSettingFragment
);

export type InterviewMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, interviewMeetingLocationSettingWithLevel?: InterviewMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null };

export type InterviewMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: InterviewMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type InterviewMeetingLocationUpsertMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: InterviewMeetingLocationUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type InterviewMeetingLocationUpsertMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type InterviewMeetingLocationUpsertMutation = InterviewMeetingLocationUpsertMutation_Mutation;

export type CommunicationSettingsTemplateQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateRow_OrgTemplateFragment
);

export type CommunicationSettingsTemplateQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<CommunicationSettingsTemplateQuery_templates_TemplatesOutput_items_Template> };

export type CommunicationSettingsTemplateQuery_Query = { __typename?: 'Query', templates?: CommunicationSettingsTemplateQuery_templates_TemplatesOutput | null };


export type CommunicationSettingsTemplateQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type CommunicationSettingsTemplateQuery = CommunicationSettingsTemplateQuery_Query;

export type CommunicationOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration = { __typename?: 'SlackOrgIntegration', active: boolean };

export type CommunicationOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, slack?: CommunicationOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration | null };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref_ccRecipients_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgBccRecipientsFragment
);

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref_bccRecipients_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgCcRecipientsFragment
);

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_candidateEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_debriefEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_interviewerEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename: 'AddZoomHostAsInternalInviteePref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename: 'AiOrgCustomLlmPref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename: 'AtsJobSyncScopePref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename: 'CandidateCommunicationsSettingPref', ccRecipients?: CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref_ccRecipients_NotificationPreference | null, bccRecipients?: CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref_bccRecipients_NotificationPreference | null };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename: 'CandidateEventAdditionalAttendeesPref', additionalRecipientsOptional: boolean, candidateEventAdditionalAttendees: CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_candidateEventAdditionalAttendees_NotificationPreference, additionalAttendees: Array<CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee> };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename: 'CandidateFacingHiringTeamContactInfo' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename: 'CandidateFacingInterviewerInfo' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_ChatCommunicationsSettingPref = (
  { __typename: 'ChatCommunicationsSettingPref' }
  & SlackChannelRow_OrgConversationFragment
);

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DateBlock = { __typename: 'DateBlock' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefAtsWriteSettingPref = (
  { __typename: 'DebriefAtsWriteSettingPref' }
  & DebriefAtsWriteRow_OrgSettingFragment
);

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename: 'DebriefEventAdditionalAttendeesPref', additionalRecipientsOptional: boolean, debriefEventAdditionalAttendees: CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_debriefEventAdditionalAttendees_NotificationPreference, additionalAttendees: Array<CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee> };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename: 'DefaultCustomInterviewScheduleTokenPref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename: 'EmployeeFieldSyncSourcePref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewBufferTimePref = { __typename: 'InterviewBufferTimePref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewLimit = { __typename: 'InterviewLimit' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename: 'InterviewMeetingLocationSettingPref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename: 'InterviewerEventAdditionalAttendeesPref', additionalRecipientsOptional: boolean, interviewerEventAdditionalAttendees: CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_interviewerEventAdditionalAttendees_NotificationPreference, additionalAttendees: Array<CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee> };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename: 'MinimumInterviewerLoadLimitOrgPref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_NotificationPreference = (
  { __typename: 'NotificationPreference' }
  & SlackChannelMembers_OrgMembersFragment
);

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PaidFeaturePreference = { __typename: 'PaidFeaturePreference' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename: 'PortalConfigAutomationRulesPref' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_TimeBlockWeek = { __typename: 'TimeBlockWeek' };

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref = CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AiOrgCustomLlmPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AtsJobSyncScopePref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingInterviewerInfo | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_ChatCommunicationsSettingPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DateBlock | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefAtsWriteSettingPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewBufferTimePref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewLimit | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_NotificationPreference | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PaidFeaturePreference | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PortalConfigAutomationRulesPref | CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_TimeBlockWeek;

export type CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, stringValue?: string | null, jsonPref?: CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref | null };

export type CommunicationOrgPrefsQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: CommunicationOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations | null, orgPrefs?: Array<CommunicationOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type CommunicationOrgPrefsQuery_Query = { __typename?: 'Query', thisOrg?: CommunicationOrgPrefsQuery_thisOrg_Org | null };


export type CommunicationOrgPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunicationOrgPrefsQuery = CommunicationOrgPrefsQuery_Query;

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_shouldSendEmailToCandidate_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_shouldSendCalendarInviteToCandidate_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_shouldSendChatMessage_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_slackTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template' }
  & TemplateRow_TemplateFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_slackTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, level?: SettingLevel | null, template?: Communication_JobStageSettingsFragment_JobStageSettingsV2_slackTemplateId_SettingTemplateId_template_Template | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template' }
  & TemplateRow_TemplateFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', level?: SettingLevel | null, templateId?: any | null, template?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId_template_Template | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template' }
  & TemplateRow_TemplateFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, level?: SettingLevel | null, template?: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId_template_Template | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId_remoteCalendar_Calendar = { __typename?: 'Calendar', id?: string | null, name?: string | null, isPartOfCalendarList?: boolean | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null, level?: SettingLevel | null, dynamicValue?: CalendarDynamicValue | null, remoteCalendar?: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId_remoteCalendar_Calendar | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId_remoteCalendar_Calendar = { __typename?: 'Calendar', id?: string | null, name?: string | null, isPartOfCalendarList?: boolean | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null, level?: SettingLevel | null, dynamicValue?: CalendarDynamicValue | null, remoteCalendar?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId_remoteCalendar_Calendar | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template' }
  & TemplateRow_TemplateFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', level?: SettingLevel | null, templateId?: any | null, template?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId_template_Template | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_chatConversation_SettingChatConversation = (
  { __typename?: 'SettingChatConversation' }
  & SlackChannelRow_ChatConversationFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference_notificationPreference_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & SlackChannelMembers_MembersFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: Communication_JobStageSettingsFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_CcRecipientsFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: Communication_JobStageSettingsFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_BccRecipientsFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: Communication_JobStageSettingsFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel_debriefAtsWriteSetting_DebriefAtsWriteSettingPref = (
  { __typename?: 'DebriefAtsWriteSettingPref' }
  & DebriefAtsWriteRow_SettingFragment
);

export type Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel = { __typename?: 'DebriefAtsWriteSettingWithLevel', level: SettingLevel, debriefAtsWriteSetting?: Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel_debriefAtsWriteSetting_DebriefAtsWriteSettingPref | null };

export type Communication_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, shouldSendEmailToCandidate?: Communication_JobStageSettingsFragment_JobStageSettingsV2_shouldSendEmailToCandidate_SettingBoolValue | null, shouldSendCalendarInviteToCandidate?: Communication_JobStageSettingsFragment_JobStageSettingsV2_shouldSendCalendarInviteToCandidate_SettingBoolValue | null, shouldSendChatMessage?: Communication_JobStageSettingsFragment_JobStageSettingsV2_shouldSendChatMessage_SettingBoolValue | null, slackTemplateId?: Communication_JobStageSettingsFragment_JobStageSettingsV2_slackTemplateId_SettingTemplateId | null, candidateEmailTemplateId?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId | null, interviewerEventTemplateId?: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId | null, interviewerCalendarId?: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId | null, candidateCalendarId?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId | null, candidateEventTemplateId?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId | null, chatConversation?: Communication_JobStageSettingsFragment_JobStageSettingsV2_chatConversation_SettingChatConversation | null, chatConversationMembers?: Communication_JobStageSettingsFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference | null, ccRecipientsV2?: Communication_JobStageSettingsFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference | null, bccRecipientsV2?: Communication_JobStageSettingsFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference | null, candidateEventAdditionalAttendees?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference | null, candidateEventAdditionalAttendeesV2?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, interviewerEventAdditionalAttendees?: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference | null, interviewerEventAdditionalAttendeesV2?: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, debriefEventAdditionalAttendees?: Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference | null, debriefEventAdditionalAttendeesV2?: Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, candidateEventAdditionalAttendeesOptional?: Communication_JobStageSettingsFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesOptional_SettingBoolValue | null, interviewerEventAdditionalAttendeesOptional?: Communication_JobStageSettingsFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesOptional_SettingBoolValue | null, debriefEventAdditionalAttendeesOptional?: Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue | null, debriefAtsWriteSettingWithLevel?: Communication_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel | null }
  & CalendarEventVisibilityRow_JobStageSettingsFragment
);

export type SaveCandidatePulseSurveySettingMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_shouldSendCandidatePulse_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type SaveCandidatePulseSurveySettingMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, shouldSendCandidatePulse?: SaveCandidatePulseSurveySettingMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_shouldSendCandidatePulse_SettingBoolValue | null };

export type SaveCandidatePulseSurveySettingMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: SaveCandidatePulseSurveySettingMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type SaveCandidatePulseSurveySettingMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: SaveCandidatePulseSurveySettingMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type SaveCandidatePulseSurveySettingMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type SaveCandidatePulseSurveySettingMutation = SaveCandidatePulseSurveySettingMutation_Mutation;

export type CandidatePulseSurveySetting_JobStageSettingsFragment_JobStageSettingsV2_shouldSendCandidatePulse_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type CandidatePulseSurveySetting_JobStageSettingsFragment = { __typename?: 'JobStageSettingsV2', id: any, shouldSendCandidatePulse?: CandidatePulseSurveySetting_JobStageSettingsFragment_JobStageSettingsV2_shouldSendCandidatePulse_SettingBoolValue | null };

export type SaveJobStageDefaultTaskMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = { __typename: 'JobStageSettingsV2', id: any, defaultTask?: TaskCreationSource | null };

export type SaveJobStageDefaultTaskMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: SaveJobStageDefaultTaskMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type SaveJobStageDefaultTaskMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: SaveJobStageDefaultTaskMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type SaveJobStageDefaultTaskMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type SaveJobStageDefaultTaskMutation = SaveJobStageDefaultTaskMutation_Mutation;

export type DisableJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any, defaultTask?: TaskCreationSource | null }
  & EnableAutomationModal_JobStageSettingsFragment
);

export type DisableJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: DisableJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type DisableJobStageAutomationMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: DisableJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type DisableJobStageAutomationMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type DisableJobStageAutomationMutation = DisableJobStageAutomationMutation_Mutation;

export type EnableAutomationModalCommonFragmentFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type EnableAutomationModalCommonFragmentFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_backupSenderEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type EnableAutomationModalCommonFragmentFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf = { __typename?: 'AutomatedTaskOnBehalfOf', dynamicAudience?: DynamicAudience | null, employee?: EnableAutomationModalCommonFragmentFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_employee_Employee | null, backupSenderEmployee?: EnableAutomationModalCommonFragmentFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_backupSenderEmployee_Employee | null };

export type EnableAutomationModalCommonFragmentFragment = { __typename?: 'JobStageSettingsV2', id: any, isAutomatedTaskEnabled?: boolean | null, createAutomatedTaskOnBehalfOf?: EnableAutomationModalCommonFragmentFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf | null };

export type UpdateJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & EnableAutomationModalCommonFragmentFragment
);

export type UpdateJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: UpdateJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type UpdateJobStageAutomationMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: UpdateJobStageAutomationMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type UpdateJobStageAutomationMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type UpdateJobStageAutomationMutation = UpdateJobStageAutomationMutation_Mutation;

export type EnableAutomationModal_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & EnableAutomationModalCommonFragmentFragment
);

export type SenderEmployeeChip_EmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type General_JobStageSettingsFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_employee_Employee = (
  { __typename?: 'Employee', id: any }
  & SenderEmployeeChip_EmployeeFragment
);

export type General_JobStageSettingsFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_backupSenderEmployee_Employee = (
  { __typename?: 'Employee', id: any }
  & SenderEmployeeChip_EmployeeFragment
);

export type General_JobStageSettingsFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf = { __typename?: 'AutomatedTaskOnBehalfOf', dynamicAudience?: DynamicAudience | null, employee?: General_JobStageSettingsFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_employee_Employee | null, backupSenderEmployee?: General_JobStageSettingsFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf_backupSenderEmployee_Employee | null };

export type General_JobStageSettingsFragment_JobStageSettingsV2_automaticallyReplaceDeclinedInterviewer_SettingBoolValue = (
  { __typename?: 'SettingBoolValue' }
  & Rescheduling_AutomaticallyReplaceDeclinedInterviewerFragment
);

export type General_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, defaultTask?: TaskCreationSource | null, isAutomatedTaskEnabled?: boolean | null, createAutomatedTaskOnBehalfOf?: General_JobStageSettingsFragment_JobStageSettingsV2_createAutomatedTaskOnBehalfOf_AutomatedTaskOnBehalfOf | null, automaticallyReplaceDeclinedInterviewer: General_JobStageSettingsFragment_JobStageSettingsV2_automaticallyReplaceDeclinedInterviewer_SettingBoolValue }
  & CandidatePulseSurveySetting_JobStageSettingsFragment
  & EnableAutomationModal_JobStageSettingsFragment
);

export type InterviewPlan_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = (
  { __typename?: 'InterviewMeetingLocationSettingWithLevel' }
  & ScheduleLocation_InterviewMeetingLocationSettingFragment
);

export type InterviewPlan_JobStageSettingsFragment_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel = (
  { __typename?: 'DebriefMeetingLocationSettingWithLevel' }
  & DebriefScheduleLocation_DebriefMeetingLocationSettingFragment
);

export type InterviewPlan_JobStageSettingsFragment_JobStageSettingsV2_syncScorecardsFromAts_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type InterviewPlan_JobStageSettingsFragment = { __typename?: 'JobStageSettingsV2', id: any, interviewMeetingLocationSettingWithLevel?: InterviewPlan_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null, debriefMeetingLocationSettingWithLevel?: InterviewPlan_JobStageSettingsFragment_JobStageSettingsV2_debriefMeetingLocationSettingWithLevel_DebriefMeetingLocationSettingWithLevel | null, syncScorecardsFromAts: InterviewPlan_JobStageSettingsFragment_JobStageSettingsV2_syncScorecardsFromAts_SettingBoolValue };

export type JobStageInterviewPlanQuery_jobStage_JobStage_job_Job = (
  { __typename?: 'Job', id: any }
  & InterviewPlan_JobFragment
);

export type JobStageInterviewPlanQuery_jobStage_JobStage_atsJobStage_AtsJobStage = { __typename?: 'AtsJobStage', atsId: string, canResetInterviewPlan: boolean };

export type JobStageInterviewPlanQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_syncScorecardsFromAts_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type JobStageInterviewPlanQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, syncScorecardsFromAts: JobStageInterviewPlanQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_syncScorecardsFromAts_SettingBoolValue };

export type JobStageInterviewPlanQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any, job?: JobStageInterviewPlanQuery_jobStage_JobStage_job_Job | null, atsJobStage?: JobStageInterviewPlanQuery_jobStage_JobStage_atsJobStage_AtsJobStage | null, jobStageSettingsV2?: JobStageInterviewPlanQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null }
  & InterviewPlan_JobStageFragment
);

export type JobStageInterviewPlanQuery_Query = { __typename?: 'Query', jobStage?: JobStageInterviewPlanQuery_jobStage_JobStage | null };


export type JobStageInterviewPlanQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobStageInterviewPlanQuery = JobStageInterviewPlanQuery_Query;

export type JobStageInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any }
  & InterviewPlan_JobStageFragment
);

export type JobStageInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult = { __typename?: 'JobStageInterviewPlanResult', jobStage?: JobStageInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage | null };

export type JobStageInterviewPlanUpsertMutation_Mutation = { __typename?: 'Mutation', jobStageInterviewPlanUpsert?: JobStageInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult | null };


export type JobStageInterviewPlanUpsertMutationVariables = Exact<{
  input: JobStageInterviewPlanUpsertInput;
}>;


export type JobStageInterviewPlanUpsertMutation = JobStageInterviewPlanUpsertMutation_Mutation;

export type AvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateRow_OrgTemplateFragment
);

export type AvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<AvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput_items_Template> };

export type AvailabilityRequestSettingsTemplateQuery_Query = { __typename?: 'Query', templates?: AvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput | null };


export type AvailabilityRequestSettingsTemplateQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type AvailabilityRequestSettingsTemplateQuery = AvailabilityRequestSettingsTemplateQuery_Query;

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgBccRecipientsFragment
  & AdditionalRecipientsRow_OrgCcRecipientsFragment
);

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref = AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AiOrgCustomLlmPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AtsJobSyncScopePref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingInterviewerInfo | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_ChatCommunicationsSettingPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DateBlock | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefAtsWriteSettingPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewBufferTimePref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewLimit | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_NotificationPreference | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PaidFeaturePreference | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PortalConfigAutomationRulesPref | AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_TimeBlockWeek;

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref | null };

export type AvailabilityRequestOrgPrefsQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPrefs?: Array<AvailabilityRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type AvailabilityRequestOrgPrefsQuery_Query = { __typename?: 'Query', thisOrg?: AvailabilityRequestOrgPrefsQuery_thisOrg_Org | null };


export type AvailabilityRequestOrgPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityRequestOrgPrefsQuery = AvailabilityRequestOrgPrefsQuery_Query;

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template', id: any }
  & TemplateRow_TemplateFragment
);

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, level?: SettingLevel | null, template?: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId_template_Template | null };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any, level: SettingLevel };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any, level: SettingLevel };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue = { __typename?: 'SettingIntValue', value: any, level: SettingLevel };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any, nanos: any };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration = { __typename?: 'SettingDuration', level: SettingLevel, duration: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration_duration_Duration };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_candidateNote_SettingStringValue = { __typename?: 'SettingStringValue', value: string, level: SettingLevel };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_shouldRespectLoadLimit_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bookIfPerfectScheduleFound_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverFreeTime_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_useRollingDays_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any, nanos: any };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration = { __typename?: 'SettingDuration', level: SettingLevel, duration: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration_duration_Duration };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_CcRecipientsFragment
);

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_BccRecipientsFragment
);

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 = { __typename?: 'JobStageCandidateAvailabilitySettingsV2', numberOfDays: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue, minutesPerDays: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue, minimumTimeBlockMinutes: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue, advanceNotice: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration, candidateNote: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_candidateNote_SettingStringValue, shouldRespectLoadLimit: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_shouldRespectLoadLimit_SettingBoolValue, bookIfPerfectScheduleFound: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bookIfPerfectScheduleFound_SettingBoolValue, canScheduleOverRecruitingKeywords: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue, canScheduleOverAvailableKeywords: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue, canScheduleOverFreeTime: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverFreeTime_SettingBoolValue, useRollingDays: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_useRollingDays_SettingBoolValue, timeframe: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_timeframe_SettingDuration, ccRecipients: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_ccRecipients_SettingNotificationPreference, bccRecipients: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_bccRecipients_SettingNotificationPreference };

export type AvailabilityRequest_JobStageSettingsFragment = { __typename?: 'JobStageSettingsV2', availabilityRequestEmailTemplateId?: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_availabilityRequestEmailTemplateId_SettingTemplateId | null, candidateAvailabilitySettingsV2?: AvailabilityRequest_JobStageSettingsFragment_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 | null };

export type SsrSettingsTemplateQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateRow_OrgTemplateFragment
);

export type SsrSettingsTemplateQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<SsrSettingsTemplateQuery_templates_TemplatesOutput_items_Template> };

export type SsrSettingsTemplateQuery_Query = { __typename?: 'Query', templates?: SsrSettingsTemplateQuery_templates_TemplatesOutput | null };


export type SsrSettingsTemplateQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type SsrSettingsTemplateQuery = SsrSettingsTemplateQuery_Query;

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgBccRecipientsFragment
  & AdditionalRecipientsRow_OrgCcRecipientsFragment
);

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref = SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AiOrgCustomLlmPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_AtsJobSyncScopePref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateCommunicationsSettingPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_CandidateFacingInterviewerInfo | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_ChatCommunicationsSettingPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DateBlock | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefAtsWriteSettingPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewBufferTimePref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewLimit | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_NotificationPreference | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PaidFeaturePreference | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_PortalConfigAutomationRulesPref | SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref_TimeBlockWeek;

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref_jsonPref | null };

export type SelfScheduleRequestOrgPrefsQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPrefs?: Array<SelfScheduleRequestOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type SelfScheduleRequestOrgPrefsQuery_Query = { __typename?: 'Query', thisOrg?: SelfScheduleRequestOrgPrefsQuery_thisOrg_Org | null };


export type SelfScheduleRequestOrgPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfScheduleRequestOrgPrefsQuery = SelfScheduleRequestOrgPrefsQuery_Query;

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template' }
  & TemplateRow_TemplateFragment
);

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, level?: SettingLevel | null, template?: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId_template_Template | null };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any, nanos: any };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration = { __typename?: 'SettingDuration', level: SettingLevel, duration: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration_duration_Duration };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_candidateNote_SettingStringValue = { __typename?: 'SettingStringValue', value: string, level: SettingLevel };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_CcRecipientsFragment
);

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_BccRecipientsFragment
);

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', level: SettingLevel, notificationPreference: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_shouldRespectLoadLimit_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean, level: SettingLevel };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverFreeTime_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_useRollingDays_SettingBoolValue = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration = { __typename?: 'SettingDuration', level: SettingLevel, duration: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration_duration_Duration };

export type SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 = { __typename?: 'JobStageSelfScheduleSettingsV2', advanceNotice: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration, candidateNote: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_candidateNote_SettingStringValue, ccRecipients: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference, bccRecipients: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference, shouldRespectLoadLimit: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_shouldRespectLoadLimit_SettingBoolValue, canScheduleOverRecruitingKeywords: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue, canScheduleOverAvailableKeywords: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue, canScheduleOverFreeTime: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverFreeTime_SettingBoolValue, useRollingDays: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_useRollingDays_SettingBoolValue, timeframe: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration };

export type SelfScheduleRequest_JobStageSettingsFragment = { __typename?: 'JobStageSettingsV2', selfScheduleRequestEmailTemplateId?: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId | null, selfScheduleSettingsV2?: SelfScheduleRequest_JobStageSettingsFragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 | null };

export type Rescheduling_AutomaticallyReplaceDeclinedInterviewerFragment = { __typename?: 'SettingBoolValue', level: SettingLevel, value: boolean };

export type ReschedulingJobStageSettingUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_automaticallyReplaceDeclinedInterviewer_SettingBoolValue = (
  { __typename?: 'SettingBoolValue' }
  & Rescheduling_AutomaticallyReplaceDeclinedInterviewerFragment
);

export type ReschedulingJobStageSettingUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, automaticallyReplaceDeclinedInterviewer: ReschedulingJobStageSettingUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2_automaticallyReplaceDeclinedInterviewer_SettingBoolValue };

export type ReschedulingJobStageSettingUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: ReschedulingJobStageSettingUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ReschedulingJobStageSettingUpsertMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: ReschedulingJobStageSettingUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type ReschedulingJobStageSettingUpsertMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type ReschedulingJobStageSettingUpsertMutation = ReschedulingJobStageSettingUpsertMutation_Mutation;

export type ResetJobStageToAtsInterviewPlanMutation_resetJobStageToAtsInterviewPlan_JobStageInterviewPlanResult_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type ResetJobStageToAtsInterviewPlanMutation_resetJobStageToAtsInterviewPlan_JobStageInterviewPlanResult = { __typename?: 'JobStageInterviewPlanResult', jobStage?: ResetJobStageToAtsInterviewPlanMutation_resetJobStageToAtsInterviewPlan_JobStageInterviewPlanResult_jobStage_JobStage | null };

export type ResetJobStageToAtsInterviewPlanMutation_Mutation = { __typename?: 'Mutation', resetJobStageToAtsInterviewPlan?: ResetJobStageToAtsInterviewPlanMutation_resetJobStageToAtsInterviewPlan_JobStageInterviewPlanResult | null };


export type ResetJobStageToAtsInterviewPlanMutationVariables = Exact<{
  input: ResetJobStageToAtsInterviewPlanInput;
}>;


export type ResetJobStageToAtsInterviewPlanMutation = ResetJobStageToAtsInterviewPlanMutation_Mutation;

export type JobStageSettingsFragmentFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, jobStageId: any, isAutomatedTaskEnabled?: boolean | null }
  & AvailabilityRequest_JobStageSettingsFragment
  & SelfScheduleRequest_JobStageSettingsFragment
  & Communication_JobStageSettingsFragment
  & General_JobStageSettingsFragment
  & InterviewPlan_JobStageSettingsFragment
);

export type JobStageDetailsContent_JobFragment = (
  { __typename?: 'Job', id: any, atsId: string }
  & JobStageProgressIcon_JobFragment
);

export type JobStageDetailsContent_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType };

export type JobStageDetailsContent_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<JobStageDetailsContent_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type JobStageDetailsContent_JobStageFragment = { __typename?: 'JobStage', id: any, name: string, atsId?: string | null, jobStageInterviewGroups?: Array<JobStageDetailsContent_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type JobStageDetailsContent_JobStageSettingsV2Fragment = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & JobStageSettingsFragmentFragment
);

export type JobStageDetailsSettingsUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & JobStageSettingsFragmentFragment
);

export type JobStageDetailsSettingsUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: JobStageDetailsSettingsUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type JobStageDetailsSettingsUpsertMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: JobStageDetailsSettingsUpsertMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type JobStageDetailsSettingsUpsertMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type JobStageDetailsSettingsUpsertMutation = JobStageDetailsSettingsUpsertMutation_Mutation;

export type CheckCreateCandidatePermissionMutation_checkCreateCandidatePermission_CheckCreateCandidatePermissionResult = { __typename?: 'CheckCreateCandidatePermissionResult', hasPermission: boolean, testCandidateAtsUrl?: string | null };

export type CheckCreateCandidatePermissionMutation_Mutation = { __typename?: 'Mutation', checkCreateCandidatePermission: CheckCreateCandidatePermissionMutation_checkCreateCandidatePermission_CheckCreateCandidatePermissionResult };


export type CheckCreateCandidatePermissionMutationVariables = Exact<{
  input: CheckCreateCandidatePermissionInput;
}>;


export type CheckCreateCandidatePermissionMutation = CheckCreateCandidatePermissionMutation_Mutation;

export type SourceSelect_RecruitingSourceFragment = { __typename?: 'RecruitingSource', source: string };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration = { __typename?: 'SettingDuration', duration: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration_duration_Duration };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue = { __typename?: 'SettingIntValue', value: any };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_candidateNote_SettingStringValue = { __typename?: 'SettingStringValue', value: string };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 = { __typename?: 'JobStageCandidateAvailabilitySettingsV2', advanceNotice: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_advanceNotice_SettingDuration, minutesPerDays: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minutesPerDays_SettingIntValue, numberOfDays: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_numberOfDays_SettingIntValue, minimumTimeBlockMinutes: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_minimumTimeBlockMinutes_SettingIntValue, candidateNote: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_candidateNote_SettingStringValue };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration = { __typename?: 'SettingDuration', duration: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration_duration_Duration };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_candidateNote_SettingStringValue = { __typename?: 'SettingStringValue', value: string };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 = { __typename?: 'JobStageSelfScheduleSettingsV2', advanceNotice: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration, candidateNote: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_candidateNote_SettingStringValue };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, candidateAvailabilitySettingsV2?: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 | null, selfScheduleSettingsV2?: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 | null, interviewMeetingLocationSettingWithLevel?: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null };

export type SummaryAlert_JobStageFragment = { __typename?: 'JobStage', id: any, name: string, jobId: any, jobStageSettingsV2?: SummaryAlert_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type SummaryAlert_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, duration?: number | null, interviewType: InterviewType, isHiddenFromCandidate: boolean };

export type SummaryAlert_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<SummaryAlert_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type SummaryAlert_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<SummaryAlert_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type JobStageInterviewPlanQueryQuery_jobStage_JobStage_job_Job = (
  { __typename?: 'Job' }
  & InterviewPlan_JobFragment
);

export type JobStageInterviewPlanQueryQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any, job?: JobStageInterviewPlanQueryQuery_jobStage_JobStage_job_Job | null }
  & InterviewPlan_JobStageFragment
);

export type JobStageInterviewPlanQueryQuery_Query = { __typename?: 'Query', jobStage?: JobStageInterviewPlanQueryQuery_jobStage_JobStage | null };


export type JobStageInterviewPlanQueryQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type JobStageInterviewPlanQueryQuery = JobStageInterviewPlanQueryQuery_Query;

export type CreateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult_sourcingLink_SourcingLink = { __typename?: 'SourcingLink', id: any };

export type CreateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult = { __typename?: 'SourcingLinkResult', sourcingLink: CreateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult_sourcingLink_SourcingLink };

export type CreateSourcingLinkMutation_Mutation = { __typename?: 'Mutation', sourcingLinkCreate: CreateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult };


export type CreateSourcingLinkMutationVariables = Exact<{
  input: SourcingLinkCreateInput;
}>;


export type CreateSourcingLinkMutation = CreateSourcingLinkMutation_Mutation;

export type UpdateSourcingLinkMutation_sourcingLinkUpdate_SourcingLinkResult_sourcingLink_SourcingLink = { __typename?: 'SourcingLink', id: any };

export type UpdateSourcingLinkMutation_sourcingLinkUpdate_SourcingLinkResult = { __typename?: 'SourcingLinkResult', sourcingLink: UpdateSourcingLinkMutation_sourcingLinkUpdate_SourcingLinkResult_sourcingLink_SourcingLink };

export type UpdateSourcingLinkMutation_Mutation = { __typename?: 'Mutation', sourcingLinkUpdate: UpdateSourcingLinkMutation_sourcingLinkUpdate_SourcingLinkResult };


export type UpdateSourcingLinkMutationVariables = Exact<{
  input: SourcingLinkUpdateInput;
}>;


export type UpdateSourcingLinkMutation = UpdateSourcingLinkMutation_Mutation;

export type SourcingLinkForm_CurrentEmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_shouldRespectLoadLimit_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverFreeTime_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 = { __typename?: 'JobStageCandidateAvailabilitySettingsV2', canScheduleOverAvailableKeywords: SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue, canScheduleOverRecruitingKeywords: SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue, shouldRespectLoadLimit: SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_shouldRespectLoadLimit_SettingBoolValue, canScheduleOverFreeTime: SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2_canScheduleOverFreeTime_SettingBoolValue };

export type SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, candidateAvailabilitySettingsV2?: SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettingsV2_JobStageCandidateAvailabilitySettingsV2 | null };

export type SourcingLinkForm_JobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string, atsId?: string | null, index: number, canBeInitialStageForSourcingLink: boolean, jobStageSettingsV2?: SourcingLinkForm_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type SourcingLinkForm_JobFragment_Job_org_Org_recruitingSources_RecruitingSource = (
  { __typename?: 'RecruitingSource' }
  & SourceSelect_RecruitingSourceFragment
);

export type SourcingLinkForm_JobFragment_Job_org_Org = { __typename?: 'Org', id: any, sourcingLinkResumeUploadEnabled: boolean, recruitingSources: Array<SourcingLinkForm_JobFragment_Job_org_Org_recruitingSources_RecruitingSource> };

export type SourcingLinkForm_JobFragment = (
  { __typename?: 'Job', id: any, name: string, jobStages?: Array<SourcingLinkForm_JobFragment_Job_jobStages_JobStage> | null, org?: SourcingLinkForm_JobFragment_Job_org_Org | null }
  & InterviewPlan_JobFragment
);

export type SourcingLinkForm_SourcingLinkFragment_SourcingLink_interviewPlanJobStage_JobStage = (
  { __typename?: 'JobStage' }
  & InterviewPlan_JobStageFragment
);

export type SourcingLinkForm_SourcingLinkFragment_SourcingLink_candidateRecruiter_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkForm_SourcingLinkFragment_SourcingLink_candidateSourcer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkForm_SourcingLinkFragment_SourcingLink_candidateCoordinator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkForm_SourcingLinkFragment_SourcingLink_taskAssignee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkForm_SourcingLinkFragment = { __typename?: 'SourcingLink', id: any, deactivatedAt?: any | null, initialJobStageId: any, name: string, candidateSourcerId?: any | null, candidateRecruiterId?: any | null, candidateCoordinatorId?: any | null, recruitingSource?: string | null, requireResume: boolean, taskAction: SourcingLinkTaskAction, taskAssigneeId: any, taskSubscriberIds: Array<any>, interviewPlanJobStage?: SourcingLinkForm_SourcingLinkFragment_SourcingLink_interviewPlanJobStage_JobStage | null, candidateRecruiter?: SourcingLinkForm_SourcingLinkFragment_SourcingLink_candidateRecruiter_Employee | null, candidateSourcer?: SourcingLinkForm_SourcingLinkFragment_SourcingLink_candidateSourcer_Employee | null, candidateCoordinator?: SourcingLinkForm_SourcingLinkFragment_SourcingLink_candidateCoordinator_Employee | null, taskAssignee?: SourcingLinkForm_SourcingLinkFragment_SourcingLink_taskAssignee_Employee | null };

export type SourcingLinkFormDeprecated_CurrentEmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkFormDeprecated_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettings_JobStageCandidateAvailabilitySettings = { __typename?: 'JobStageCandidateAvailabilitySettings', canScheduleOverAvailableKeywords?: boolean | null, canScheduleOverRecruitingKeywords?: boolean | null, shouldRespectLoadLimit?: boolean | null, canScheduleOverFreeTime?: boolean | null };

export type SourcingLinkFormDeprecated_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, candidateAvailabilitySettings?: SourcingLinkFormDeprecated_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateAvailabilitySettings_JobStageCandidateAvailabilitySettings | null };

export type SourcingLinkFormDeprecated_JobFragment_Job_jobStages_JobStage = (
  { __typename?: 'JobStage', id: any, name: string, atsId?: string | null, index: number, jobStageSettingsV2?: SourcingLinkFormDeprecated_JobFragment_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null }
  & SummaryAlert_JobStageFragment
);

export type SourcingLinkFormDeprecated_JobFragment_Job_org_Org_recruitingSources_RecruitingSource = (
  { __typename?: 'RecruitingSource' }
  & SourceSelect_RecruitingSourceFragment
);

export type SourcingLinkFormDeprecated_JobFragment_Job_org_Org = { __typename?: 'Org', id: any, sourcingLinkResumeUploadEnabled: boolean, recruitingSources: Array<SourcingLinkFormDeprecated_JobFragment_Job_org_Org_recruitingSources_RecruitingSource> };

export type SourcingLinkFormDeprecated_JobFragment = (
  { __typename?: 'Job', id: any, name: string, jobStages?: Array<SourcingLinkFormDeprecated_JobFragment_Job_jobStages_JobStage> | null, org?: SourcingLinkFormDeprecated_JobFragment_Job_org_Org | null }
  & InterviewPlan_JobFragment
);

export type SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_interviewPlanJobStage_JobStage = (
  { __typename?: 'JobStage' }
  & InterviewPlan_JobStageFragment
);

export type SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_candidateRecruiter_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_candidateSourcer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_candidateCoordinator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_taskAssignee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type SourcingLinkFormDeprecated_SourcingLinkFragment = { __typename?: 'SourcingLink', id: any, deactivatedAt?: any | null, initialJobStageId: any, name: string, candidateSourcerId?: any | null, candidateRecruiterId?: any | null, candidateCoordinatorId?: any | null, recruitingSource?: string | null, requireResume: boolean, taskAction: SourcingLinkTaskAction, taskAssigneeId: any, taskSubscriberIds: Array<any>, interviewPlanJobStage?: SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_interviewPlanJobStage_JobStage | null, candidateRecruiter?: SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_candidateRecruiter_Employee | null, candidateSourcer?: SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_candidateSourcer_Employee | null, candidateCoordinator?: SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_candidateCoordinator_Employee | null, taskAssignee?: SourcingLinkFormDeprecated_SourcingLinkFragment_SourcingLink_taskAssignee_Employee | null };

export type DuplicateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult_sourcingLink_SourcingLink = { __typename?: 'SourcingLink', id: any };

export type DuplicateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult = { __typename?: 'SourcingLinkResult', sourcingLink: DuplicateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult_sourcingLink_SourcingLink };

export type DuplicateSourcingLinkMutation_Mutation = { __typename?: 'Mutation', sourcingLinkCreate: DuplicateSourcingLinkMutation_sourcingLinkCreate_SourcingLinkResult };


export type DuplicateSourcingLinkMutationVariables = Exact<{
  input: SourcingLinkCreateInput;
}>;


export type DuplicateSourcingLinkMutation = DuplicateSourcingLinkMutation_Mutation;

export type DuplicateMenuItem_SourcingLinkFragment_SourcingLink_interviewPlanJobStage_JobStage = (
  { __typename?: 'JobStage' }
  & GetSaveInterviewPlanInput_InterviewPlanFragment
);

export type DuplicateMenuItem_SourcingLinkFragment = { __typename?: 'SourcingLink', id: any, requireResume: boolean, initialJobStageId: any, name: string, candidateSourcerId?: any | null, candidateRecruiterId?: any | null, candidateCoordinatorId?: any | null, recruitingSource?: string | null, taskAction: SourcingLinkTaskAction, taskAssigneeId: any, taskSubscriberIds: Array<any>, interviewPlanJobStage?: DuplicateMenuItem_SourcingLinkFragment_SourcingLink_interviewPlanJobStage_JobStage | null };

export type DeleteSourcingLinkMutation_sourcingLinkDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type DeleteSourcingLinkMutation_Mutation = { __typename?: 'Mutation', sourcingLinkDelete: DeleteSourcingLinkMutation_sourcingLinkDelete_EmptyResult };


export type DeleteSourcingLinkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSourcingLinkMutation = DeleteSourcingLinkMutation_Mutation;

export type UpdateSourcingLinkStatusMutation_sourcingLinkUpdate_SourcingLinkResult_sourcingLink_SourcingLink = { __typename?: 'SourcingLink', id: any, deactivatedAt?: any | null };

export type UpdateSourcingLinkStatusMutation_sourcingLinkUpdate_SourcingLinkResult = { __typename?: 'SourcingLinkResult', sourcingLink: UpdateSourcingLinkStatusMutation_sourcingLinkUpdate_SourcingLinkResult_sourcingLink_SourcingLink };

export type UpdateSourcingLinkStatusMutation_Mutation = { __typename?: 'Mutation', sourcingLinkUpdate: UpdateSourcingLinkStatusMutation_sourcingLinkUpdate_SourcingLinkResult };


export type UpdateSourcingLinkStatusMutationVariables = Exact<{
  input: SourcingLinkUpdateInput;
}>;


export type UpdateSourcingLinkStatusMutation = UpdateSourcingLinkStatusMutation_Mutation;

export type SourcingLinksTable_SourcingLinksFragment_SourcingLink_initialJobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type SourcingLinksTable_SourcingLinksFragment_SourcingLink_taskAssignee_Employee = { __typename?: 'Employee', id: any };

export type SourcingLinksTable_SourcingLinksFragment = (
  { __typename?: 'SourcingLink', id: any, name: string, deactivatedAt?: any | null, taskAction: SourcingLinkTaskAction, interviewPlanJobStageId: any, initialJobStage?: SourcingLinksTable_SourcingLinksFragment_SourcingLink_initialJobStage_JobStage | null, taskAssignee?: SourcingLinksTable_SourcingLinksFragment_SourcingLink_taskAssignee_Employee | null }
  & DuplicateMenuItem_SourcingLinkFragment
);

export type SourcingLinksQuery_job_Job_sourcingLinks_SourcingLink = (
  { __typename?: 'SourcingLink', id: any }
  & SourcingLinkForm_SourcingLinkFragment
  & SourcingLinkFormDeprecated_SourcingLinkFragment
  & SourcingLinksTable_SourcingLinksFragment
);

export type SourcingLinksQuery_job_Job = (
  { __typename?: 'Job', id: any, status: JobStatus, sourcingLinks: Array<SourcingLinksQuery_job_Job_sourcingLinks_SourcingLink> }
  & SourcingLinkForm_JobFragment
  & SourcingLinkFormDeprecated_JobFragment
);

export type SourcingLinksQuery_thisEmployee_Employee = (
  { __typename?: 'Employee', id: any }
  & SourcingLinkForm_CurrentEmployeeFragment
  & SourcingLinkFormDeprecated_CurrentEmployeeFragment
);

export type SourcingLinksQuery_Query = { __typename?: 'Query', job?: SourcingLinksQuery_job_Job | null, thisEmployee?: SourcingLinksQuery_thisEmployee_Employee | null };


export type SourcingLinksQueryVariables = Exact<{
  jobId: Scalars['uuid']['input'];
}>;


export type SourcingLinksQuery = SourcingLinksQuery_Query;

export type JobDetailsPage_JobStageFragment = { __typename?: 'JobStage', id: any, name: string, index: number, atsId?: string | null };

export type JobByIdQuery_jobV2_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus = { __typename?: 'HiringProcessWithStatus', atsId?: string | null, name?: string | null, status: HiringProcessStatus };

export type JobByIdQuery_jobV2_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, hiringProcess?: JobByIdQuery_jobV2_Job_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus | null };

export type JobByIdQuery_jobV2_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & JobStageDetailsContent_JobStageSettingsV2Fragment
);

export type JobByIdQuery_jobV2_Job_jobStages_JobStage = (
  { __typename?: 'JobStage', id: any, jobStageSettingsV2?: JobByIdQuery_jobV2_Job_jobStages_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null }
  & JobDetailsPage_JobStageFragment
  & JobStageDetailsContent_JobStageFragment
);

export type JobByIdQuery_jobV2_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags' }
  & GetHiringMismatchError_FlagsFragment
);

export type JobByIdQuery_jobV2_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<JobByIdQuery_jobV2_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type JobByIdQuery_jobV2_Job = (
  { __typename: 'Job', id: any, atsType: AtsType, jobSettings: JobByIdQuery_jobV2_Job_jobSettings_JobSettings, jobStages?: Array<JobByIdQuery_jobV2_Job_jobStages_JobStage> | null, validationIssues: JobByIdQuery_jobV2_Job_validationIssues_JobValidationResult }
  & JobStageDetailsContent_JobFragment
  & JobNameAndLocationHeader_JobFragment
  & JobStageMismatchAlert_JobFragment
  & HiringTeam_JobEmployeeFragment
  & HiringProcess_JobFragment
);

export type JobByIdQuery_jobV2_JobNotFoundError = { __typename: 'JobNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type JobByIdQuery_jobV2_JobPermissionDeniedError = { __typename: 'JobPermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type JobByIdQuery_jobV2_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type JobByIdQuery_jobV2 = JobByIdQuery_jobV2_Job | JobByIdQuery_jobV2_JobNotFoundError | JobByIdQuery_jobV2_JobPermissionDeniedError | JobByIdQuery_jobV2_UnknownError;

export type JobByIdQuery_Query = { __typename?: 'Query', jobV2: JobByIdQuery_jobV2 };


export type JobByIdQueryVariables = Exact<{
  jobId: Scalars['uuid']['input'];
}>;


export type JobByIdQuery = JobByIdQuery_Query;

export type ReSyncHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus = { __typename?: 'HiringProcessWithStatus', atsId?: string | null, name?: string | null, status: HiringProcessStatus };

export type ReSyncHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, hiringProcess?: ReSyncHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings_hiringProcess_HiringProcessWithStatus | null };

export type ReSyncHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult = { __typename?: 'JobSettingsUpsertResult', jobSettings: ReSyncHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult_jobSettings_JobSettings };

export type ReSyncHiringProcessMutation_Mutation = { __typename?: 'Mutation', jobSettingsUpsert?: ReSyncHiringProcessMutation_jobSettingsUpsert_JobSettingsUpsertResult | null };


export type ReSyncHiringProcessMutationVariables = Exact<{
  input: JobSettingsUpsertInput;
}>;


export type ReSyncHiringProcessMutation = ReSyncHiringProcessMutation_Mutation;

export type ExitConfirmationModal_JobsFragment = { __typename?: 'Job', id: any, name: string };

export type FixContentTabMapping_TargetJobFragment = (
  { __typename?: 'Job', id: any }
  & JobStageSelectFixIssues_JobFragment
);

export type FixContentTabMapping_ContentTabMappingFragment = { __typename?: 'ContentTabMapping', sourceName: string, sourceContentTabId: any, sourceIcon?: string | null, sourceVisibility?: PortalJobOptionsTabVisibilityType | null, sourceContentTabType: ContentTabSourceType, sourceJobStageId?: any | null, sourceStageNameFilter?: string | null };

export type FixContentTabMapping_SourceJobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type FixContentTabMapping_SourceJobFragment = { __typename?: 'Job', id: any, name: string, jobStages?: Array<FixContentTabMapping_SourceJobFragment_Job_jobStages_JobStage> | null };

export type FixJobIssues_IssuesFragment_JobImportValidateResult_targetJob_Job = (
  { __typename?: 'Job', id: any, name: string, location?: Array<string> | null }
  & FixJobStageMapping_TargetJobFragment
  & FixContentTabMapping_TargetJobFragment
  & FixScorecardMapping_TargetJobFragment
);

export type FixJobIssues_IssuesFragment_JobImportValidateResult_jobStageMappings_JobStageMapping = (
  { __typename?: 'JobStageMapping', targetJobStageId?: any | null }
  & FixJobStageMapping_JobStageMappingFragment
);

export type FixJobIssues_IssuesFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping = (
  { __typename?: 'ContentTabMapping', targetJobStageId?: any | null, sourceJobStageId?: any | null }
  & FixContentTabMapping_ContentTabMappingFragment
);

export type FixJobIssues_IssuesFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping = (
  { __typename?: 'ScorecardMapping', targetAtsId?: string | null, sourceAtsId: string }
  & FixScorecardMapping_ScorecardMappingFragment
);

export type FixJobIssues_IssuesFragment = { __typename?: 'JobImportValidateResult', targetJob: FixJobIssues_IssuesFragment_JobImportValidateResult_targetJob_Job, jobStageMappings: Array<FixJobIssues_IssuesFragment_JobImportValidateResult_jobStageMappings_JobStageMapping>, contentTabMappings: Array<FixJobIssues_IssuesFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping>, scorecardMappings: Array<FixJobIssues_IssuesFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping> };

export type SourceJobFixIssues_JobFragment = (
  { __typename?: 'Job', id: any, name: string }
  & FixContentTabMapping_SourceJobFragment
  & FixJobStageMapping_SourceJobFragment
);

export type FixAndImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult_sourceJob_Job = { __typename?: 'Job', id: any };

export type FixAndImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult = { __typename?: 'JobSettingsImportResult', sourceJob: FixAndImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult_sourceJob_Job };

export type FixAndImportJobSettingsMutation_Mutation = { __typename?: 'Mutation', jobSettingsImport?: FixAndImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult | null };


export type FixAndImportJobSettingsMutationVariables = Exact<{
  input: JobSettingsImportInput;
}>;


export type FixAndImportJobSettingsMutation = FixAndImportJobSettingsMutation_Mutation;

export type FixJobStageMapping_TargetJobFragment = (
  { __typename?: 'Job', id: any, name: string }
  & JobStageSelectFixIssues_JobFragment
);

export type FixJobStageMapping_SourceJobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, index: number, name: string };

export type FixJobStageMapping_SourceJobFragment = { __typename?: 'Job', id: any, name: string, jobStages?: Array<FixJobStageMapping_SourceJobFragment_Job_jobStages_JobStage> | null };

export type FixJobStageMapping_JobStageMappingFragment_JobStageMapping_sourceJobStage_JobStage = { __typename?: 'JobStage', id: any, index: number };

export type FixJobStageMapping_JobStageMappingFragment = { __typename?: 'JobStageMapping', sourceName: string, sourceJobStageId: any, sourceJobStage: FixJobStageMapping_JobStageMappingFragment_JobStageMapping_sourceJobStage_JobStage };

export type FixScorecardMapping_TargetJobFragment_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsId: string };

export type FixScorecardMapping_TargetJobFragment = { __typename?: 'Job', id: any, name: string, atsJob?: FixScorecardMapping_TargetJobFragment_Job_atsJob_AtsJob | null };

export type FixScorecardMapping_ScorecardMappingFragment_ScorecardMapping_sourceAtsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, name: string, atsJobId?: string | null };

export type FixScorecardMapping_ScorecardMappingFragment_ScorecardMapping_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, name?: string | null };

export type FixScorecardMapping_ScorecardMappingFragment = { __typename?: 'ScorecardMapping', sourceAtsId: string, sourceAtsInterviewDefinition: FixScorecardMapping_ScorecardMappingFragment_ScorecardMapping_sourceAtsInterviewDefinition_AtsInterviewDefinition, jobStageInterviews?: Array<FixScorecardMapping_ScorecardMappingFragment_ScorecardMapping_jobStageInterviews_JobStageInterview> | null };

export type JobStageSelectFixIssues_JobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type JobStageSelectFixIssues_JobFragment = { __typename?: 'Job', id: any, jobStages?: Array<JobStageSelectFixIssues_JobFragment_Job_jobStages_JobStage> | null };

export type FixIssues_IssuesFragment_JobSettingsImportValidateResult_items_JobImportValidateResult = (
  { __typename?: 'JobImportValidateResult' }
  & FixJobIssues_IssuesFragment
);

export type FixIssues_IssuesFragment_JobSettingsImportValidateResult_sourceJob_Job = (
  { __typename?: 'Job' }
  & SourceJobFixIssues_JobFragment
);

export type FixIssues_IssuesFragment = { __typename?: 'JobSettingsImportValidateResult', items: Array<FixIssues_IssuesFragment_JobSettingsImportValidateResult_items_JobImportValidateResult>, sourceJob: FixIssues_IssuesFragment_JobSettingsImportValidateResult_sourceJob_Job };

export type ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_targetJob_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsCustomerFriendlyId?: string | null };

export type ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_targetJob_Job = { __typename?: 'Job', id: any, name: string, location?: Array<string> | null, atsJob?: ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_targetJob_Job_atsJob_AtsJob | null };

export type ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_jobStageMappings_JobStageMapping = (
  { __typename?: 'JobStageMapping', targetJobStageId?: any | null, sourceName: string, sourceJobStageId: any }
  & UnmappedJobStages_JobStageMappingFragment
);

export type ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping = (
  { __typename?: 'ScorecardMapping', targetAtsId?: string | null, sourceName: string, sourceAtsId: string }
  & UnmappedScorecards_ScorecardMappingFragment
);

export type ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping = (
  { __typename?: 'ContentTabMapping', sourceName: string, sourceJobStageId?: any | null, targetJobStageId?: any | null, sourceContentTabId: any }
  & UnmappedContentTabs_ContentTabMappingFragment
);

export type ReviewJobRow_JobImportValidateResultFragment = { __typename?: 'JobImportValidateResult', targetJob: ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_targetJob_Job, jobStageMappings: Array<ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_jobStageMappings_JobStageMapping>, scorecardMappings: Array<ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping>, contentTabMappings: Array<ReviewJobRow_JobImportValidateResultFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping> };

export type ReviewJobsTable_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job = { __typename?: 'Job', id: any };

export type ReviewJobsTable_JobImportValidateResultsFragment = (
  { __typename?: 'JobImportValidateResult', targetJob: ReviewJobsTable_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job }
  & ReviewJobRow_JobImportValidateResultFragment
);

export type Review_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job = { __typename?: 'Job', id: any };

export type Review_JobImportValidateResultsFragment_JobImportValidateResult_jobStageMappings_JobStageMapping = { __typename?: 'JobStageMapping', targetJobStageId?: any | null };

export type Review_JobImportValidateResultsFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping = { __typename?: 'ScorecardMapping', targetAtsId?: string | null };

export type Review_JobImportValidateResultsFragment = (
  { __typename?: 'JobImportValidateResult', targetJob: Review_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job, jobStageMappings: Array<Review_JobImportValidateResultsFragment_JobImportValidateResult_jobStageMappings_JobStageMapping>, scorecardMappings: Array<Review_JobImportValidateResultsFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping> }
  & ReviewJobsTable_JobImportValidateResultsFragment
  & GetJobsWithIssues_JobImportValidateResultsFragment
  & GetJobsWithoutIssues_JobImportValidateResultsFragment
);

export type CandidatePortalImportOptions_PortalJobOptionsFragment_PortalJobOptions_tabs_PortalJobOptionsTab = { __typename?: 'PortalJobOptionsTab', id: any, name: string, visibility: PortalJobOptionsTabVisibilityType };

export type CandidatePortalImportOptions_PortalJobOptionsFragment_PortalJobOptions_linkedPortalConfig_PortalConfig_tabs_PortalConfigTab = { __typename?: 'PortalConfigTab', id: any, name: string, visibility: PortalJobOptionsTabVisibilityType, stageNameFilter?: string | null };

export type CandidatePortalImportOptions_PortalJobOptionsFragment_PortalJobOptions_linkedPortalConfig_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string, tabs: Array<CandidatePortalImportOptions_PortalJobOptionsFragment_PortalJobOptions_linkedPortalConfig_PortalConfig_tabs_PortalConfigTab> };

export type CandidatePortalImportOptions_PortalJobOptionsFragment = { __typename?: 'PortalJobOptions', id: any, tabs: Array<CandidatePortalImportOptions_PortalJobOptionsFragment_PortalJobOptions_tabs_PortalJobOptionsTab>, linkedPortalConfig?: CandidatePortalImportOptions_PortalJobOptionsFragment_PortalJobOptions_linkedPortalConfig_PortalConfig | null };

export type SelectImportOptions_JobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type SelectImportOptions_JobFragment_Job_portalJobOptions_PortalJobOptions = (
  { __typename?: 'PortalJobOptions' }
  & CandidatePortalImportOptions_PortalJobOptionsFragment
);

export type SelectImportOptions_JobFragment = { __typename?: 'Job', id: any, name: string, location?: Array<string> | null, jobStages?: Array<SelectImportOptions_JobFragment_Job_jobStages_JobStage> | null, portalJobOptions?: SelectImportOptions_JobFragment_Job_portalJobOptions_PortalJobOptions | null };

export type SourceJobListItem_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags' }
  & GetHiringSetupError_FlagsFragment
);

export type SourceJobListItem_JobFragment_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<SourceJobListItem_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type SourceJobListItem_JobFragment_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsCustomerFriendlyId?: string | null };

export type SourceJobListItem_JobFragment = { __typename?: 'Job', id: any, name: string, orgId: any, status: JobStatus, location?: Array<string> | null, validationIssues: SourceJobListItem_JobFragment_Job_validationIssues_JobValidationResult, atsJob?: SourceJobListItem_JobFragment_Job_atsJob_AtsJob | null };

export type SourceJobTable_JobFragment = (
  { __typename?: 'Job' }
  & SourceJobListItem_JobFragment
);

export type SourceJobsListQuery_jobs_JobsOutput_items_Job = (
  { __typename?: 'Job' }
  & SourceJobTable_JobFragment
);

export type SourceJobsListQuery_jobs_JobsOutput = { __typename?: 'JobsOutput', nextCursor?: string | null, items: Array<SourceJobsListQuery_jobs_JobsOutput_items_Job> };

export type SourceJobsListQuery_Query = { __typename?: 'Query', jobs?: SourceJobsListQuery_jobs_JobsOutput | null };


export type SourceJobsListQueryVariables = Exact<{
  input: JobsInput;
}>;


export type SourceJobsListQuery = SourceJobsListQuery_Query;

export type GetSourceJobQuery_job_Job = (
  { __typename?: 'Job' }
  & SelectImportOptions_JobFragment
);

export type GetSourceJobQuery_Query = { __typename?: 'Query', job?: GetSourceJobQuery_job_Job | null };


export type GetSourceJobQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSourceJobQuery = GetSourceJobQuery_Query;

export type GetTargetJobsQuery_jobByIds_Job = (
  { __typename?: 'Job', id: any }
  & ExitConfirmationModal_JobsFragment
);

export type GetTargetJobsQuery_Query = { __typename?: 'Query', jobByIds?: Array<GetTargetJobsQuery_jobByIds_Job> | null };


export type GetTargetJobsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetTargetJobsQuery = GetTargetJobsQuery_Query;

export type JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult_jobStageMappings_JobStageMapping = (
  { __typename?: 'JobStageMapping' }
  & GetJobStageMappings_JobStageMappingFragment
);

export type JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult_scorecardMappings_ScorecardMapping = (
  { __typename?: 'ScorecardMapping' }
  & GetScorecardMappings_ScorecardMappingFragment
);

export type JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult_contentTabMappings_ContentTabMapping = { __typename?: 'ContentTabMapping', targetJobStageId?: any | null, sourceContentTabId: any, sourceContentTabType: ContentTabSourceType, sourceVisibility?: PortalJobOptionsTabVisibilityType | null };

export type JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult = (
  { __typename?: 'JobImportValidateResult', jobStageMappings: Array<JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult_jobStageMappings_JobStageMapping>, scorecardMappings: Array<JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult_scorecardMappings_ScorecardMapping>, contentTabMappings: Array<JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult_contentTabMappings_ContentTabMapping> }
  & Review_JobImportValidateResultsFragment
  & GetJobsWithIssues_JobImportValidateResultsFragment
  & GetJobsWithoutIssues_JobImportValidateResultsFragment
);

export type JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult = (
  { __typename?: 'JobSettingsImportValidateResult', items: Array<JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult_items_JobImportValidateResult> }
  & FixIssues_IssuesFragment
);

export type JobSettingsImportValidateQuery_Query = { __typename?: 'Query', jobSettingsImportValidate: JobSettingsImportValidateQuery_jobSettingsImportValidate_JobSettingsImportValidateResult };


export type JobSettingsImportValidateQueryVariables = Exact<{
  input: JobSettingsImportValidateInput;
}>;


export type JobSettingsImportValidateQuery = JobSettingsImportValidateQuery_Query;

export type ImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult_sourceJob_Job = { __typename?: 'Job', id: any };

export type ImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult = { __typename?: 'JobSettingsImportResult', sourceJob: ImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult_sourceJob_Job };

export type ImportJobSettingsMutation_Mutation = { __typename?: 'Mutation', jobSettingsImport?: ImportJobSettingsMutation_jobSettingsImport_JobSettingsImportResult | null };


export type ImportJobSettingsMutationVariables = Exact<{
  input: JobSettingsImportInput;
}>;


export type ImportJobSettingsMutation = ImportJobSettingsMutation_Mutation;

export type GetJobStageMappings_JobStageMappingFragment = { __typename?: 'JobStageMapping', targetJobStageId?: any | null, sourceJobStageId: any };

export type GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job = { __typename?: 'Job', id: any };

export type GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_jobStageMappings_JobStageMapping = (
  { __typename?: 'JobStageMapping' }
  & UnmappedJobStages_JobStageMappingFragment
);

export type GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping = (
  { __typename?: 'ScorecardMapping' }
  & UnmappedScorecards_ScorecardMappingFragment
);

export type GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping = (
  { __typename?: 'ContentTabMapping' }
  & UnmappedContentTabs_ContentTabMappingFragment
);

export type GetJobsWithIssues_JobImportValidateResultsFragment = { __typename?: 'JobImportValidateResult', targetJob: GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job, jobStageMappings: Array<GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_jobStageMappings_JobStageMapping>, scorecardMappings: Array<GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping>, contentTabMappings: Array<GetJobsWithIssues_JobImportValidateResultsFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping> };

export type GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job = { __typename?: 'Job', id: any };

export type GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_jobStageMappings_JobStageMapping = (
  { __typename?: 'JobStageMapping' }
  & UnmappedJobStages_JobStageMappingFragment
);

export type GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping = (
  { __typename?: 'ScorecardMapping' }
  & UnmappedScorecards_ScorecardMappingFragment
);

export type GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping = (
  { __typename?: 'ContentTabMapping' }
  & UnmappedContentTabs_ContentTabMappingFragment
);

export type GetJobsWithoutIssues_JobImportValidateResultsFragment = { __typename?: 'JobImportValidateResult', targetJob: GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_targetJob_Job, jobStageMappings: Array<GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_jobStageMappings_JobStageMapping>, scorecardMappings: Array<GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_scorecardMappings_ScorecardMapping>, contentTabMappings: Array<GetJobsWithoutIssues_JobImportValidateResultsFragment_JobImportValidateResult_contentTabMappings_ContentTabMapping> };

export type GetScorecardMappings_ScorecardMappingFragment = { __typename?: 'ScorecardMapping', targetAtsId?: string | null, sourceAtsId: string };

export type UnmappedContentTabs_ContentTabMappingFragment = { __typename?: 'ContentTabMapping', sourceJobStageId?: any | null, sourceStageNameFilter?: string | null, targetJobStageId?: any | null };

export type UnmappedJobStages_JobStageMappingFragment = { __typename?: 'JobStageMapping', targetJobStageId?: any | null };

export type UnmappedScorecards_ScorecardMappingFragment = { __typename?: 'ScorecardMapping', targetAtsId?: string | null };

export type JobListItemV2_EmployeeFragment = { __typename?: 'Employee', fullName?: string | null, email: string, id: any, orgId: any, internalProfilePictureUrl?: string | null, timezone?: string | null, atsId?: string | null };

export type JobListItemV2_JobFragment_Job_hiringManagers_Employee = (
  { __typename?: 'Employee' }
  & JobListItemV2_EmployeeFragment
);

export type JobListItemV2_JobFragment_Job_recruiters_Employee = (
  { __typename?: 'Employee' }
  & JobListItemV2_EmployeeFragment
);

export type JobListItemV2_JobFragment_Job_coordinators_Employee = (
  { __typename?: 'Employee' }
  & JobListItemV2_EmployeeFragment
);

export type JobListItemV2_JobFragment_Job_sourcers_Employee = (
  { __typename?: 'Employee' }
  & JobListItemV2_EmployeeFragment
);

export type JobListItemV2_JobFragment_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsId: string, jobRequisitionId?: string | null, atsCustomerFriendlyId?: string | null };

export type JobListItemV2_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags = (
  { __typename?: 'JobValidationErrorFlags' }
  & GetHiringSetupError_FlagsFragment
);

export type JobListItemV2_JobFragment_Job_validationIssues_JobValidationResult = { __typename?: 'JobValidationResult', errors?: Array<JobListItemV2_JobFragment_Job_validationIssues_JobValidationResult_errors_JobValidationErrorFlags> | null };

export type JobListItemV2_JobFragment = { __typename?: 'Job', id: any, name: string, orgId: any, status: JobStatus, location?: Array<string> | null, jobStagesWithInterviewPlansCount: any, hiringManagers?: Array<JobListItemV2_JobFragment_Job_hiringManagers_Employee> | null, recruiters?: Array<JobListItemV2_JobFragment_Job_recruiters_Employee> | null, coordinators?: Array<JobListItemV2_JobFragment_Job_coordinators_Employee> | null, sourcers?: Array<JobListItemV2_JobFragment_Job_sourcers_Employee> | null, atsJob?: JobListItemV2_JobFragment_Job_atsJob_AtsJob | null, validationIssues: JobListItemV2_JobFragment_Job_validationIssues_JobValidationResult };

export type JobListTable_JobFragment = (
  { __typename?: 'Job' }
  & JobListItemV2_JobFragment
);

export type JobsListQuery_jobs_JobsOutput_items_Job = (
  { __typename?: 'Job' }
  & JobListTable_JobFragment
);

export type JobsListQuery_jobs_JobsOutput = { __typename?: 'JobsOutput', nextCursor?: string | null, items: Array<JobsListQuery_jobs_JobsOutput_items_Job> };

export type JobsListQuery_Query = { __typename?: 'Query', jobs?: JobsListQuery_jobs_JobsOutput | null };


export type JobsListQueryVariables = Exact<{
  input: JobsInput;
}>;


export type JobsListQuery = JobsListQuery_Query;

export type TagProgress_TagWithPercentageFragment_CandidatePulseTagWithPercentage_tag_CandidatePulseTag = { __typename?: 'CandidatePulseTag', id: any, emoji: string, name: string };

export type TagProgress_TagWithPercentageFragment = { __typename?: 'CandidatePulseTagWithPercentage', percentage: number, tag: TagProgress_TagWithPercentageFragment_CandidatePulseTagWithPercentage_tag_CandidatePulseTag };

export type QuestionSection_TagWithPercentageFragment = (
  { __typename?: 'CandidatePulseTagWithPercentage' }
  & TagProgress_TagWithPercentageFragment
);

export type SummarySection_SummaryFragment = { __typename?: 'CandidatePulseMetricsSummary', averageRating: number, npsScore: any };

export type PulseSurveyMetricsTagsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_positive_CandidatePulseTag = { __typename?: 'CandidatePulseTag', id: any, name: string, emoji: string };

export type PulseSurveyMetricsTagsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_negative_CandidatePulseTag = { __typename?: 'CandidatePulseTag', id: any, name: string, emoji: string };

export type PulseSurveyMetricsTagsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags = { __typename?: 'CandidatePulseTags', positive: Array<PulseSurveyMetricsTagsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_positive_CandidatePulseTag | null>, negative: Array<PulseSurveyMetricsTagsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_negative_CandidatePulseTag | null> };

export type PulseSurveyMetricsTagsQuery_thisOrg_Org = { __typename?: 'Org', candidatePulseTags: PulseSurveyMetricsTagsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags };

export type PulseSurveyMetricsTagsQuery_Query = { __typename?: 'Query', thisOrg?: PulseSurveyMetricsTagsQuery_thisOrg_Org | null };


export type PulseSurveyMetricsTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type PulseSurveyMetricsTagsQuery = PulseSurveyMetricsTagsQuery_Query;

export type PulseSurveyPositiveNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse = { __typename?: 'CandidatePulseResponse', rating: any, positiveNote?: string | null };

export type PulseSurveyPositiveNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput = { __typename?: 'CandidatePulseSearchOutput', total: number, hasNext: boolean, items: Array<PulseSurveyPositiveNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse> };

export type PulseSurveyPositiveNotesQuery_Query = { __typename?: 'Query', candidatePulseSearch?: PulseSurveyPositiveNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput | null };


export type PulseSurveyPositiveNotesQueryVariables = Exact<{
  input: CandidatePulseSearchInput;
}>;


export type PulseSurveyPositiveNotesQuery = PulseSurveyPositiveNotesQuery_Query;

export type PulseSurveyNegativeNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse = { __typename?: 'CandidatePulseResponse', rating: any, negativeNote?: string | null };

export type PulseSurveyNegativeNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput = { __typename?: 'CandidatePulseSearchOutput', total: number, hasNext: boolean, items: Array<PulseSurveyNegativeNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse> };

export type PulseSurveyNegativeNotesQuery_Query = { __typename?: 'Query', candidatePulseSearch?: PulseSurveyNegativeNotesQuery_candidatePulseSearch_CandidatePulseSearchOutput | null };


export type PulseSurveyNegativeNotesQueryVariables = Exact<{
  input: CandidatePulseSearchInput;
}>;


export type PulseSurveyNegativeNotesQuery = PulseSurveyNegativeNotesQuery_Query;

export type PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse_positiveTags_CandidatePulseTag = { __typename?: 'CandidatePulseTag', id: any, name: string };

export type PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse_negativeTags_CandidatePulseTag = { __typename?: 'CandidatePulseTag', id: any, name: string };

export type PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse = { __typename?: 'CandidatePulseResponse', rating: any, npsRating: any, positiveNote?: string | null, negativeNote?: string | null, positiveTags?: Array<PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse_positiveTags_CandidatePulseTag> | null, negativeTags?: Array<PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse_negativeTags_CandidatePulseTag> | null };

export type PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput = { __typename?: 'CandidatePulseSearchOutput', total: number, hasNext: boolean, items: Array<PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput_items_CandidatePulseResponse> };

export type PulseSurveyMetricsDownloadQuery_Query = { __typename?: 'Query', candidatePulseSearch?: PulseSurveyMetricsDownloadQuery_candidatePulseSearch_CandidatePulseSearchOutput | null };


export type PulseSurveyMetricsDownloadQueryVariables = Exact<{
  input: CandidatePulseSearchInput;
}>;


export type PulseSurveyMetricsDownloadQuery = PulseSurveyMetricsDownloadQuery_Query;

export type PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_summary_CandidatePulseMetricsSummary = (
  { __typename?: 'CandidatePulseMetricsSummary', totalResponses: any }
  & SummarySection_SummaryFragment
);

export type PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_positive_CandidatePulseMetricsAggregate_tags_CandidatePulseTagWithPercentage = (
  { __typename?: 'CandidatePulseTagWithPercentage' }
  & QuestionSection_TagWithPercentageFragment
);

export type PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_positive_CandidatePulseMetricsAggregate = { __typename?: 'CandidatePulseMetricsAggregate', tags: Array<PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_positive_CandidatePulseMetricsAggregate_tags_CandidatePulseTagWithPercentage> };

export type PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_negative_CandidatePulseMetricsAggregate_tags_CandidatePulseTagWithPercentage = (
  { __typename?: 'CandidatePulseTagWithPercentage' }
  & QuestionSection_TagWithPercentageFragment
);

export type PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_negative_CandidatePulseMetricsAggregate = { __typename?: 'CandidatePulseMetricsAggregate', tags: Array<PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_negative_CandidatePulseMetricsAggregate_tags_CandidatePulseTagWithPercentage> };

export type PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics = { __typename?: 'CandidatePulseMetrics', summary: PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_summary_CandidatePulseMetricsSummary, positive: PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_positive_CandidatePulseMetricsAggregate, negative: PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics_negative_CandidatePulseMetricsAggregate };

export type PulseSurveyMetricsQuery_Query = { __typename?: 'Query', candidatePulseMetrics?: PulseSurveyMetricsQuery_candidatePulseMetrics_CandidatePulseMetrics | null };


export type PulseSurveyMetricsQueryVariables = Exact<{
  input: CandidatePulseMetricsInput;
}>;


export type PulseSurveyMetricsQuery = PulseSurveyMetricsQuery_Query;

export type DebriefMetricsDownloadQuery_debriefMetricsDownload_DebriefMetricsDownloadRow_scheduler_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string };

export type DebriefMetricsDownloadQuery_debriefMetricsDownload_DebriefMetricsDownloadRow = { __typename?: 'DebriefMetricsDownloadRow', debriefId: any, name: string, startAt: any, endAt: any, isCancelled: boolean, cancelledAt?: any | null, candidateName?: string | null, jobName?: string | null, taskId?: any | null, attendeeCount: number, acceptedCount: number, declinedCount: number, scheduler?: DebriefMetricsDownloadQuery_debriefMetricsDownload_DebriefMetricsDownloadRow_scheduler_Employee | null };

export type DebriefMetricsDownloadQuery_Query = { __typename?: 'Query', debriefMetricsDownload: Array<DebriefMetricsDownloadQuery_debriefMetricsDownload_DebriefMetricsDownloadRow> };


export type DebriefMetricsDownloadQueryVariables = Exact<{
  input: DebriefMetricsDownloadInput;
}>;


export type DebriefMetricsDownloadQuery = DebriefMetricsDownloadQuery_Query;

export type DebriefMetricsQuery_debriefMetrics_DebriefMetrics_totals_DebriefMetricsTotals = { __typename?: 'DebriefMetricsTotals', scheduled: number, completed: number, upcoming: number, cancelled: number, attendeeDeclines: number };

export type DebriefMetricsQuery_debriefMetrics_DebriefMetrics_trend_DebriefMetricsTrendPoint = { __typename?: 'DebriefMetricsTrendPoint', bucketStart: any, scheduled: number, completed: number, upcoming: number, cancelled: number };

export type DebriefMetricsQuery_debriefMetrics_DebriefMetrics_bySchedulers_DebriefMetricsSchedulerRow_scheduler_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string };

export type DebriefMetricsQuery_debriefMetrics_DebriefMetrics_bySchedulers_DebriefMetricsSchedulerRow = { __typename?: 'DebriefMetricsSchedulerRow', schedulerEmployeeId?: any | null, scheduled: number, completed: number, upcoming: number, cancelled: number, attendeeDeclines: number, scheduler?: DebriefMetricsQuery_debriefMetrics_DebriefMetrics_bySchedulers_DebriefMetricsSchedulerRow_scheduler_Employee | null };

export type DebriefMetricsQuery_debriefMetrics_DebriefMetrics_byAttendees_DebriefMetricsAttendeeRow_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string };

export type DebriefMetricsQuery_debriefMetrics_DebriefMetrics_byAttendees_DebriefMetricsAttendeeRow = { __typename?: 'DebriefMetricsAttendeeRow', interviewerId: any, invited: number, accepted: number, declined: number, tentative: number, needsAction: number, interviewer?: DebriefMetricsQuery_debriefMetrics_DebriefMetrics_byAttendees_DebriefMetricsAttendeeRow_interviewer_Employee | null };

export type DebriefMetricsQuery_debriefMetrics_DebriefMetrics = { __typename?: 'DebriefMetrics', totals: DebriefMetricsQuery_debriefMetrics_DebriefMetrics_totals_DebriefMetricsTotals, trend: Array<DebriefMetricsQuery_debriefMetrics_DebriefMetrics_trend_DebriefMetricsTrendPoint>, bySchedulers: Array<DebriefMetricsQuery_debriefMetrics_DebriefMetrics_bySchedulers_DebriefMetricsSchedulerRow>, byAttendees: Array<DebriefMetricsQuery_debriefMetrics_DebriefMetrics_byAttendees_DebriefMetricsAttendeeRow> };

export type DebriefMetricsQuery_Query = { __typename?: 'Query', debriefMetrics: DebriefMetricsQuery_debriefMetrics_DebriefMetrics };


export type DebriefMetricsQueryVariables = Exact<{
  input: DebriefMetricsInput;
}>;


export type DebriefMetricsQuery = DebriefMetricsQuery_Query;

export type DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewModule_InterviewModule = { __typename?: 'InterviewModule', name: string };

export type DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_manager_Employee = { __typename?: 'Employee', email: string };

export type DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', name: string };

export type DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', value: string, name?: DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName | null };

export type DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee = { __typename?: 'Employee', id: any, manager?: DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_manager_Employee | null, attributes?: Array<DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue> | null };

export type DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics = { __typename?: 'InterviewMetrics', interviewDate?: any | null, candidate?: string | null, interviewName?: string | null, calendarEventTitle?: string | null, jobStage?: string | null, scorecard?: string | null, scheduler?: string | null, interviewer?: string | null, declineLeadTime?: number | null, jobName?: string | null, atsJobId?: string | null, jobLocations: Array<string>, atsApplicationId?: string | null, atsCandidateId?: string | null, taskId?: string | null, job?: string | null, interviewModule?: DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewModule_InterviewModule | null, interviewerEmployee?: DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee | null };

export type DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult = { __typename?: 'MetricsChartDownloadResult', data?: Array<DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics> | null };

export type DeclineMetricesDownloadQuery_Query = { __typename?: 'Query', interviewerMetricsChartDownload?: DeclineMetricesDownloadQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult | null };


export type DeclineMetricesDownloadQueryVariables = Exact<{
  input: InterviewerMetricsChartInput;
}>;


export type DeclineMetricesDownloadQuery = DeclineMetricesDownloadQuery_Query;

export type InterviewsCompletedChartQuery_interviewerMetricsChart_InterviewerMetricsChartResult_data_ChartCoordinateData = { __typename?: 'ChartCoordinateData', x?: string | null, y?: number | null };

export type InterviewsCompletedChartQuery_interviewerMetricsChart_InterviewerMetricsChartResult = { __typename?: 'InterviewerMetricsChartResult', data?: Array<InterviewsCompletedChartQuery_interviewerMetricsChart_InterviewerMetricsChartResult_data_ChartCoordinateData> | null };

export type InterviewsCompletedChartQuery_Query = { __typename?: 'Query', interviewerMetricsChart?: InterviewsCompletedChartQuery_interviewerMetricsChart_InterviewerMetricsChartResult | null };


export type InterviewsCompletedChartQueryVariables = Exact<{
  input: InterviewerMetricsChartInput;
}>;


export type InterviewsCompletedChartQuery = InterviewsCompletedChartQuery_Query;

export type InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewModule_InterviewModule = { __typename?: 'InterviewModule', name: string };

export type InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_manager_Employee = { __typename?: 'Employee', email: string };

export type InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', name: string };

export type InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', value: string, name?: InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName | null };

export type InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee = { __typename?: 'Employee', id: any, manager?: InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_manager_Employee | null, attributes?: Array<InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue> | null };

export type InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics = { __typename?: 'InterviewMetrics', interviewDate?: any | null, candidate?: string | null, interviewName?: string | null, calendarEventTitle?: string | null, jobStage?: string | null, job?: string | null, scorecard?: string | null, scheduler?: string | null, interviewer?: string | null, jobName?: string | null, jobLocations: Array<string>, atsJobId?: string | null, atsApplicationId?: string | null, atsCandidateId?: string | null, taskId?: string | null, interviewModule?: InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewModule_InterviewModule | null, interviewerEmployee?: InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee | null };

export type InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult = { __typename?: 'MetricsChartDownloadResult', data?: Array<InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics> | null };

export type InterviewsCompletedDownloadChartQuery_Query = { __typename?: 'Query', interviewerMetricsChartDownload?: InterviewsCompletedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult | null };


export type InterviewsCompletedDownloadChartQueryVariables = Exact<{
  input: InterviewerMetricsChartInput;
}>;


export type InterviewsCompletedDownloadChartQuery = InterviewsCompletedDownloadChartQuery_Query;

export type InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewModule_InterviewModule = { __typename?: 'InterviewModule', name: string };

export type InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_manager_Employee = { __typename?: 'Employee', email: string };

export type InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', name: string };

export type InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', value: string, name?: InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName | null };

export type InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee = { __typename?: 'Employee', id: any, manager?: InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_manager_Employee | null, attributes?: Array<InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee_attributes_EmployeeAttributeTagValue> | null };

export type InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics = { __typename?: 'InterviewMetrics', interviewDate?: any | null, candidate?: string | null, interviewName?: string | null, calendarEventTitle?: string | null, jobStage?: string | null, scorecard?: string | null, scheduler?: string | null, interviewer?: string | null, jobName?: string | null, job?: string | null, jobLocations: Array<string>, atsJobId?: string | null, atsApplicationId?: string | null, atsCandidateId?: string | null, taskId?: string | null, declineReason?: string | null, declineComment?: string | null, interviewModule?: InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewModule_InterviewModule | null, interviewerEmployee?: InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics_interviewerEmployee_Employee | null };

export type InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult = { __typename?: 'MetricsChartDownloadResult', data?: Array<InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics> | null };

export type InterviewsDeclinedDownloadChartQuery_Query = { __typename?: 'Query', interviewerMetricsChartDownload?: InterviewsDeclinedDownloadChartQuery_interviewerMetricsChartDownload_MetricsChartDownloadResult | null };


export type InterviewsDeclinedDownloadChartQueryVariables = Exact<{
  input: InterviewerMetricsChartInput;
}>;


export type InterviewsDeclinedDownloadChartQuery = InterviewsDeclinedDownloadChartQuery_Query;

export type InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee_manager_Employee = { __typename?: 'Employee', email: string };

export type InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', name: string };

export type InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', value: string, name?: InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName | null };

export type InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string, manager?: InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee_manager_Employee | null, attributes?: Array<InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee_attributes_EmployeeAttributeTagValue> | null };

export type InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing = { __typename?: 'InterviewerMetricsInterviewing', upcoming?: any | null, completed?: any | null, declines?: any | null, totalTime?: number | null, interviewPerWeek?: number | null, timePerWeek?: number | null, interviewer?: InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing_interviewer_Employee | null };

export type InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult = { __typename?: 'InterviewerMetricsInterviewingResult', items?: Array<InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult_items_InterviewerMetricsInterviewing> | null };

export type InterviewerMetricsInterviewingQuery_Query = { __typename?: 'Query', interviewerMetricsInterviewing?: InterviewerMetricsInterviewingQuery_interviewerMetricsInterviewing_InterviewerMetricsInterviewingResult | null };


export type InterviewerMetricsInterviewingQueryVariables = Exact<{
  input: InterviewerMetricsTableInput;
}>;


export type InterviewerMetricsInterviewingQuery = InterviewerMetricsInterviewingQuery_Query;

export type InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee_manager_Employee = { __typename?: 'Employee', email: string };

export type InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', name: string };

export type InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', value: string, name?: InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName | null };

export type InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null, email: string, manager?: InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee_manager_Employee | null, attributes?: Array<InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee_attributes_EmployeeAttributeTagValue> | null };

export type InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining = { __typename?: 'InterviewerMetricsTraining', trainer?: any | null, shadows?: any | null, reverseShadows?: any | null, modulesAsTrainee?: string | null, interviewer?: InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining_interviewer_Employee | null };

export type InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult = { __typename?: 'InterviewerMetricsTrainingResult', items?: Array<InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult_items_InterviewerMetricsTraining> | null };

export type InterviewerMetricsTrainingQuery_Query = { __typename?: 'Query', interviewerMetricsTraining?: InterviewerMetricsTrainingQuery_interviewerMetricsTraining_InterviewerMetricsTrainingResult | null };


export type InterviewerMetricsTrainingQueryVariables = Exact<{
  input: InterviewerMetricsTableInput;
}>;


export type InterviewerMetricsTrainingQuery = InterviewerMetricsTrainingQuery_Query;

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineReasonsChart_InterviewerMetricsChartResult_data_ChartCoordinateData = { __typename?: 'ChartCoordinateData', x?: string | null, y?: number | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineReasonsChart_InterviewerMetricsChartResult = { __typename?: 'InterviewerMetricsChartResult', data?: Array<DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineReasonsChart_InterviewerMetricsChartResult_data_ChartCoordinateData> | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineLeadTimeChart_InterviewerMetricsChartResult_data_ChartCoordinateData = { __typename?: 'ChartCoordinateData', x?: string | null, y?: number | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineLeadTimeChart_InterviewerMetricsChartResult = { __typename?: 'InterviewerMetricsChartResult', data?: Array<DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineLeadTimeChart_InterviewerMetricsChartResult_data_ChartCoordinateData> | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee_manager_Employee = { __typename?: 'Employee', email: string };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', name: string };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee_attributes_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', value: string, name?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee_attributes_EmployeeAttributeTagValue_name_EmployeeAttributeName | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string, manager?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee_manager_Employee | null, attributes?: Array<DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee_attributes_EmployeeAttributeTagValue> | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines = { __typename?: 'InterviewerMetricsDeclines', date?: string | null, leadTime?: number | null, declineSource?: string | null, declineComment?: string | null, declineReason?: string | null, interviewer?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines_interviewer_Employee | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult = { __typename?: 'InterviewerMetricsDeclinesResult', items?: Array<DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult_items_InterviewerMetricsDeclines> | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declinesChart_InterviewerMetricsChartResult_data_ChartCoordinateData = { __typename?: 'ChartCoordinateData', x?: string | null, y?: number | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declinesChart_InterviewerMetricsChartResult = { __typename?: 'InterviewerMetricsChartResult', data?: Array<DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declinesChart_InterviewerMetricsChartResult_data_ChartCoordinateData> | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_autoReplacementChart_InterviewerMetricsChartResult_data_ChartCoordinateData = { __typename?: 'ChartCoordinateData', x?: string | null, y?: number | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_autoReplacementChart_InterviewerMetricsChartResult = { __typename?: 'InterviewerMetricsChartResult', data?: Array<DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_autoReplacementChart_InterviewerMetricsChartResult_data_ChartCoordinateData> | null };

export type DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult = { __typename?: 'InterviewerMetricsDeclinesWrapperResult', declineReasonsChart?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineReasonsChart_InterviewerMetricsChartResult | null, declineLeadTimeChart?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineLeadTimeChart_InterviewerMetricsChartResult | null, declineTable?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declineTable_InterviewerMetricsDeclinesResult | null, declinesChart?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_declinesChart_InterviewerMetricsChartResult | null, autoReplacementChart?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult_autoReplacementChart_InterviewerMetricsChartResult | null };

export type DeclineMetricesQuery_Query = { __typename?: 'Query', interviewerMetricsDeclinesWrapper?: DeclineMetricesQuery_interviewerMetricsDeclinesWrapper_InterviewerMetricsDeclinesWrapperResult | null };


export type DeclineMetricesQueryVariables = Exact<{
  input: InterviewerMetricsChartInput;
}>;


export type DeclineMetricesQuery = DeclineMetricesQuery_Query;

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_rescheduleLogsChart_RecruiterRescheduleLogsData_rescheduleReason_RescheduleReason = { __typename?: 'RescheduleReason', id: any, reason: string };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_rescheduleLogsChart_RecruiterRescheduleLogsData_data_ChartCoordinateData = { __typename?: 'ChartCoordinateData', x?: string | null, y?: number | null };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_rescheduleLogsChart_RecruiterRescheduleLogsData = { __typename?: 'RecruiterRescheduleLogsData', rescheduleReason: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_rescheduleLogsChart_RecruiterRescheduleLogsData_rescheduleReason_RescheduleReason, data: Array<RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_rescheduleLogsChart_RecruiterRescheduleLogsData_data_ChartCoordinateData> };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_rescheduleReason_RescheduleReason = { __typename?: 'RescheduleReason', id: any, reason: string };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_performedBy_Employee = { __typename?: 'Employee', fullName?: string | null };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_createdBy_Employee = { __typename?: 'Employee', fullName?: string | null };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_jobStage_JobStage = { __typename?: 'JobStage', name: string };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_application_Application_job_Job = { __typename?: 'Job', name: string };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_application_Application = { __typename?: 'Application', id: any, job?: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_application_Application_job_Job | null, candidate?: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_application_Application_candidate_Candidate | null };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task = { __typename?: 'Task', createdBy: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_createdBy_Employee, jobStage?: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_jobStage_JobStage | null, application: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task_application_Application };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog = { __typename?: 'RecruiterRescheduleLog', taskId?: any | null, atsApplicationId?: string | null, atsCandidateId?: string | null, atsJobId?: string | null, date?: string | null, note?: string | null, rescheduleReason?: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_rescheduleReason_RescheduleReason | null, performedBy?: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_performedBy_Employee | null, task?: RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog_task_Task | null };

export type RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment = { __typename?: 'RecruiterRescheduleLogsWrapperResult', rescheduleLogsChart?: Array<RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_rescheduleLogsChart_RecruiterRescheduleLogsData> | null, items?: Array<RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog> | null };

export type RecruiterChartQuery_recruiterMetricsChart_RecruiterMetricsChartResult_data_ChartCoordinateData = { __typename?: 'ChartCoordinateData', x?: string | null, y?: number | null };

export type RecruiterChartQuery_recruiterMetricsChart_RecruiterMetricsChartResult = { __typename?: 'RecruiterMetricsChartResult', data?: Array<RecruiterChartQuery_recruiterMetricsChart_RecruiterMetricsChartResult_data_ChartCoordinateData> | null };

export type RecruiterChartQuery_Query = { __typename?: 'Query', recruiterMetricsChart?: RecruiterChartQuery_recruiterMetricsChart_RecruiterMetricsChartResult | null };


export type RecruiterChartQueryVariables = Exact<{
  input: RecruiterMetricsChartInput;
}>;


export type RecruiterChartQuery = RecruiterChartQuery_Query;

export type RecruiterChartDownloadQuery_recruiterMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics = { __typename?: 'InterviewMetrics', interviewDate?: any | null, startsAt?: any | null, endsAt?: any | null, id?: string | null, interviewName?: string | null, calendarEventTitle?: string | null, scorecard?: string | null, jobStage?: string | null, scheduler?: string | null, candidate?: string | null, job?: string | null, jobName?: string | null, jobLocations: Array<string>, atsJobId?: string | null, atsApplicationId?: string | null, atsCandidateId?: string | null, taskId?: string | null };

export type RecruiterChartDownloadQuery_recruiterMetricsChartDownload_MetricsChartDownloadResult_scheduleStages_ScheduleStageMetrics = { __typename?: 'ScheduleStageMetrics', id?: string | null, jobStage?: string | null, candidate?: string | null, scheduler?: string | null, scheduleStageDate?: any | null, startsAt?: any | null, endsAt?: any | null, job?: string | null, atsJobId?: string | null, atsApplicationId?: string | null, atsCandidateId?: string | null, taskId?: string | null };

export type RecruiterChartDownloadQuery_recruiterMetricsChartDownload_MetricsChartDownloadResult = { __typename?: 'MetricsChartDownloadResult', data?: Array<RecruiterChartDownloadQuery_recruiterMetricsChartDownload_MetricsChartDownloadResult_data_InterviewMetrics> | null, scheduleStages?: Array<RecruiterChartDownloadQuery_recruiterMetricsChartDownload_MetricsChartDownloadResult_scheduleStages_ScheduleStageMetrics> | null };

export type RecruiterChartDownloadQuery_Query = { __typename?: 'Query', recruiterMetricsChartDownload?: RecruiterChartDownloadQuery_recruiterMetricsChartDownload_MetricsChartDownloadResult | null };


export type RecruiterChartDownloadQueryVariables = Exact<{
  input: RecruiterMetricsChartInput;
}>;


export type RecruiterChartDownloadQuery = RecruiterChartDownloadQuery_Query;

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_rescheduleReason_RescheduleReason = { __typename?: 'RescheduleReason', id: any, reason: string };

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_performedBy_Employee = { __typename?: 'Employee', fullName?: string | null, internalProfilePictureUrl?: string | null };

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_createdBy_Employee = { __typename?: 'Employee', fullName?: string | null };

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_jobStage_JobStage = { __typename?: 'JobStage', name: string };

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_application_Application_job_Job = { __typename?: 'Job', name: string };

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_application_Application = { __typename?: 'Application', id: any, job?: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_application_Application_job_Job | null, candidate?: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_application_Application_candidate_Candidate | null };

export type RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task = { __typename?: 'Task', id: any, createdBy: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_createdBy_Employee, jobStage?: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_jobStage_JobStage | null, application: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task_application_Application };

export type RescheduleLogNotes_RescheduleLogItemsFragment = { __typename?: 'RecruiterRescheduleLog', id?: any | null, date?: string | null, note?: string | null, rescheduleReason?: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_rescheduleReason_RescheduleReason | null, performedBy?: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_performedBy_Employee | null, task?: RescheduleLogNotes_RescheduleLogItemsFragment_RecruiterRescheduleLog_task_Task | null };

export type RecruitersMetricsTableQuery_recruiterMetricsTable_RecruiterMetricsTableResult_items_RecruiterMetricsTable_recruiter_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string };

export type RecruitersMetricsTableQuery_recruiterMetricsTable_RecruiterMetricsTableResult_items_RecruiterMetricsTable = { __typename?: 'RecruiterMetricsTable', scheduled?: any | null, completed?: any | null, declines?: any | null, cancelled?: any | null, changed?: any | null, facilitated?: any | null, recruiter?: RecruitersMetricsTableQuery_recruiterMetricsTable_RecruiterMetricsTableResult_items_RecruiterMetricsTable_recruiter_Employee | null };

export type RecruitersMetricsTableQuery_recruiterMetricsTable_RecruiterMetricsTableResult = { __typename?: 'RecruiterMetricsTableResult', items?: Array<RecruitersMetricsTableQuery_recruiterMetricsTable_RecruiterMetricsTableResult_items_RecruiterMetricsTable> | null };

export type RecruitersMetricsTableQuery_Query = { __typename?: 'Query', recruiterMetricsTable?: RecruitersMetricsTableQuery_recruiterMetricsTable_RecruiterMetricsTableResult | null };


export type RecruitersMetricsTableQueryVariables = Exact<{
  input: RecruiterMetricsChartInput;
}>;


export type RecruitersMetricsTableQuery = RecruitersMetricsTableQuery_Query;

export type RecruiterMetricsRescheduleLogsQuery_recruiterMetricsRescheduleLogs_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog = (
  { __typename?: 'RecruiterRescheduleLog' }
  & RescheduleLogNotes_RescheduleLogItemsFragment
);

export type RecruiterMetricsRescheduleLogsQuery_recruiterMetricsRescheduleLogs_RecruiterRescheduleLogsWrapperResult = (
  { __typename?: 'RecruiterRescheduleLogsWrapperResult', items?: Array<RecruiterMetricsRescheduleLogsQuery_recruiterMetricsRescheduleLogs_RecruiterRescheduleLogsWrapperResult_items_RecruiterRescheduleLog> | null }
  & RescheduleLogReasonsChart_RescheduleLogReasonsDataFragment
);

export type RecruiterMetricsRescheduleLogsQuery_Query = { __typename?: 'Query', recruiterMetricsRescheduleLogs?: RecruiterMetricsRescheduleLogsQuery_recruiterMetricsRescheduleLogs_RecruiterRescheduleLogsWrapperResult | null };


export type RecruiterMetricsRescheduleLogsQueryVariables = Exact<{
  input: RecruiterMetricsChartInput;
}>;


export type RecruiterMetricsRescheduleLogsQuery = RecruiterMetricsRescheduleLogsQuery_Query;

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage_job_Job | null };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application = { __typename?: 'Application', id: any, candidate?: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application_candidate_Candidate | null };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_assignee_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task = { __typename?: 'Task', id: any, jobStage?: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage | null, application: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application, assignee?: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_assignee_Employee | null };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_totalDuration_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask = { __typename?: 'TimeToScheduleTask', startTime: any, endTime: any, task: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task, totalDuration: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_totalDuration_Duration };

export type TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult = { __typename?: 'TimeToScheduleMetricsResult', hasNext: boolean, tasksPage: Array<TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask> };

export type TimeToScheduleTasksQuery_Query = { __typename?: 'Query', taskMetrics: TimeToScheduleTasksQuery_taskMetrics_TimeToScheduleMetricsResult };


export type TimeToScheduleTasksQueryVariables = Exact<{
  input: TimeToScheduleMetricsInput;
}>;


export type TimeToScheduleTasksQuery = TimeToScheduleTasksQuery_Query;

export type TimeToScheduleSummaryQuery_summary_TimeToScheduleMetricsResult_totalAverage_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleSummaryQuery_summary_TimeToScheduleMetricsResult = { __typename?: 'TimeToScheduleMetricsResult', totalTaskCount: number, totalAverage?: TimeToScheduleSummaryQuery_summary_TimeToScheduleMetricsResult_totalAverage_Duration | null };

export type TimeToScheduleSummaryQuery_Query = { __typename?: 'Query', summary: TimeToScheduleSummaryQuery_summary_TimeToScheduleMetricsResult };


export type TimeToScheduleSummaryQueryVariables = Exact<{
  input: TimeToScheduleMetricsInput;
}>;


export type TimeToScheduleSummaryQuery = TimeToScheduleSummaryQuery_Query;

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_totalAverage_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byAssignee_TimeToScheduleTaskAssigneeAggregation_taskAssignee_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byAssignee_TimeToScheduleTaskAssigneeAggregation_average_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byAssignee_TimeToScheduleTaskAssigneeAggregation = { __typename?: 'TimeToScheduleTaskAssigneeAggregation', taskCount: number, taskAssignee?: TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byAssignee_TimeToScheduleTaskAssigneeAggregation_taskAssignee_Employee | null, average: TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byAssignee_TimeToScheduleTaskAssigneeAggregation_average_Duration };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJob_TimeToScheduleJobAggregation_job_Job = { __typename?: 'Job', id: any, name: string };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJob_TimeToScheduleJobAggregation_average_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJob_TimeToScheduleJobAggregation = { __typename?: 'TimeToScheduleJobAggregation', taskCount: number, job: TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJob_TimeToScheduleJobAggregation_job_Job, average: TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJob_TimeToScheduleJobAggregation_average_Duration };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJobStageName_TimeToScheduleJobStageAggregation_average_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJobStageName_TimeToScheduleJobStageAggregation = { __typename?: 'TimeToScheduleJobStageAggregation', jobStageName: string, taskCount: number, average: TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJobStageName_TimeToScheduleJobStageAggregation_average_Duration };

export type TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult = { __typename?: 'TimeToScheduleMetricsResult', totalTaskCount: number, totalAverage?: TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_totalAverage_Duration | null, byAssignee: Array<TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byAssignee_TimeToScheduleTaskAssigneeAggregation>, byJob: Array<TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJob_TimeToScheduleJobAggregation>, byJobStageName: Array<TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult_byJobStageName_TimeToScheduleJobStageAggregation> };

export type TimeToScheduleGroupTableQuery_Query = { __typename?: 'Query', groupMetrics: TimeToScheduleGroupTableQuery_groupMetrics_TimeToScheduleMetricsResult };


export type TimeToScheduleGroupTableQueryVariables = Exact<{
  input: TimeToScheduleMetricsInput;
}>;


export type TimeToScheduleGroupTableQuery = TimeToScheduleGroupTableQuery_Query;

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage_job_Job | null };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application = { __typename?: 'Application', id: any, candidate?: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application_candidate_Candidate | null };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_assignee_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task = { __typename?: 'Task', id: any, jobStage?: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_jobStage_JobStage | null, application: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_application_Application, assignee?: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task_assignee_Employee | null };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_totalDuration_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask = { __typename?: 'TimeToScheduleTask', startTime: any, endTime: any, task: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_task_Task, totalDuration: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask_totalDuration_Duration };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_totalAverage_Duration = { __typename?: 'Duration', seconds: any };

export type TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult = { __typename?: 'TimeToScheduleMetricsResult', totalTaskCount: number, hasNext: boolean, tasksPage: Array<TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_tasksPage_TimeToScheduleTask>, totalAverage?: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult_totalAverage_Duration | null };

export type TimeToScheduleTaskDownloadQuery_Query = { __typename?: 'Query', taskMetricsDownload: TimeToScheduleTaskDownloadQuery_taskMetricsDownload_TimeToScheduleMetricsResult };


export type TimeToScheduleTaskDownloadQueryVariables = Exact<{
  input: TimeToScheduleMetricsInput;
}>;


export type TimeToScheduleTaskDownloadQuery = TimeToScheduleTaskDownloadQuery_Query;

export type AtsPermissionQuery_thisUserInfo_UserInfo = { __typename?: 'UserInfo', isAtsAdmin: boolean };

export type AtsPermissionQuery_Query = { __typename?: 'Query', thisUserInfo?: AtsPermissionQuery_thisUserInfo_UserInfo | null };


export type AtsPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type AtsPermissionQuery = AtsPermissionQuery_Query;

export type MetricsPageAverageTimesFiltersEmployeePrefFragment = { __typename?: 'MetricsPageAverageTimesFiltersPref', assigneeEmployeeIds: Array<any>, jobIds: Array<any>, jobStageNames: Array<string>, startMetric: TimeToScheduleMetric, endMetric: TimeToScheduleMetric };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = (
  { __typename?: 'MetricsPageAverageTimesFiltersPref' }
  & MetricsPageAverageTimesFiltersEmployeePrefFragment
);

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref = UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref | null };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_Mutation = { __typename?: 'Mutation', employeePrefUpdate?: UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult | null };


export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationVariables = Exact<{
  input: EmployeePrefUpdateInput;
}>;


export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation = UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation_Mutation;

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = (
  { __typename?: 'MetricsPageAverageTimesFiltersPref' }
  & MetricsPageAverageTimesFiltersEmployeePrefFragment
);

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref = MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref | null };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, employeePref?: MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref | null };

export type MetricsPageAverageTimesFiltersEmployeePrefQuery_Query = { __typename?: 'Query', thisEmployee?: MetricsPageAverageTimesFiltersEmployeePrefQuery_thisEmployee_Employee | null };


export type MetricsPageAverageTimesFiltersEmployeePrefQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type MetricsPageAverageTimesFiltersEmployeePrefQuery = MetricsPageAverageTimesFiltersEmployeePrefQuery_Query;

export type MetricsPageInterviewerFiltersEmployeePrefFragment = { __typename?: 'MetricsPageInterviewerFiltersPref', interviewerEmployeeIds: Array<any>, managerEmployeeIds: Array<any>, jobIds: Array<any>, interviewModuleIds: Array<any>, departmentAttributeIds: Array<any>, teamAttributeIds: Array<any>, locationAttributeIds: Array<any>, levelAttributeIds: Array<any>, countryAttributeIds: Array<any>, customAttributeIds: Array<any>, showArchived: boolean, jobLocations: Array<string>, atsDepartmentIds: Array<string> };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = (
  { __typename?: 'MetricsPageInterviewerFiltersPref' }
  & MetricsPageInterviewerFiltersEmployeePrefFragment
);

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref = UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref | null };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_Mutation = { __typename?: 'Mutation', employeePrefUpdate?: UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult | null };


export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutationVariables = Exact<{
  input: EmployeePrefUpdateInput;
}>;


export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutation = UpdateMetricsPageInterviewerFiltersEmployeePrefMutation_Mutation;

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = (
  { __typename?: 'MetricsPageInterviewerFiltersPref' }
  & MetricsPageInterviewerFiltersEmployeePrefFragment
);

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref = MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref | null };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, employeePref?: MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref | null };

export type MetricsPageInterviewerFiltersEmployeePrefQuery_Query = { __typename?: 'Query', thisEmployee?: MetricsPageInterviewerFiltersEmployeePrefQuery_thisEmployee_Employee | null };


export type MetricsPageInterviewerFiltersEmployeePrefQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type MetricsPageInterviewerFiltersEmployeePrefQuery = MetricsPageInterviewerFiltersEmployeePrefQuery_Query;

export type MetricsPageRecruitingTeamFiltersEmployeePrefFragment = { __typename?: 'MetricsPageRecruitingTeamFiltersPref', schedulerEmployeeIds: Array<any>, jobIds: Array<any>, jobStageNames: Array<string>, showArchived: boolean, jobLocations: Array<string>, atsDepartmentIds: Array<string> };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = (
  { __typename?: 'MetricsPageRecruitingTeamFiltersPref' }
  & MetricsPageRecruitingTeamFiltersEmployeePrefFragment
);

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref = UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref | null };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_Mutation = { __typename?: 'Mutation', employeePrefUpdate?: UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult | null };


export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationVariables = Exact<{
  input: EmployeePrefUpdateInput;
}>;


export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation = UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation_Mutation;

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = (
  { __typename?: 'MetricsPageRecruitingTeamFiltersPref' }
  & MetricsPageRecruitingTeamFiltersEmployeePrefFragment
);

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref = MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref | null };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, employeePref?: MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref | null };

export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery_Query = { __typename?: 'Query', thisEmployee?: MetricsPageRecruitingTeamFiltersEmployeePrefQuery_thisEmployee_Employee | null };


export type MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type MetricsPageRecruitingTeamFiltersEmployeePrefQuery = MetricsPageRecruitingTeamFiltersEmployeePrefQuery_Query;

export type EmployeeNotificationReceivedSubscription_employeeNotificationReceived_EmployeeNotification = { __typename?: 'EmployeeNotification', notificationType: string, plainText: string, ctaText?: string | null, ctaLink?: string | null };

export type EmployeeNotificationReceivedSubscription_Subscription = { __typename?: 'Subscription', employeeNotificationReceived: EmployeeNotificationReceivedSubscription_employeeNotificationReceived_EmployeeNotification };


export type EmployeeNotificationReceivedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type EmployeeNotificationReceivedSubscription = EmployeeNotificationReceivedSubscription_Subscription;

export type EmployeeNotificationsQuery_employeeNotifications_EmployeeNotificationsResult_items_EmployeeNotification_actorEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, photoUrl?: string | null };

export type EmployeeNotificationsQuery_employeeNotifications_EmployeeNotificationsResult_items_EmployeeNotification = { __typename?: 'EmployeeNotification', id: any, notificationType: string, plainText: string, ctaLink?: string | null, isRead: boolean, isSeen: boolean, createdAt: any, actorEmployee?: EmployeeNotificationsQuery_employeeNotifications_EmployeeNotificationsResult_items_EmployeeNotification_actorEmployee_Employee | null };

export type EmployeeNotificationsQuery_employeeNotifications_EmployeeNotificationsResult = { __typename?: 'EmployeeNotificationsResult', unreadCount: number, unseenCount: number, nextCursor?: string | null, items: Array<EmployeeNotificationsQuery_employeeNotifications_EmployeeNotificationsResult_items_EmployeeNotification> };

export type EmployeeNotificationsQuery_Query = { __typename?: 'Query', employeeNotifications: EmployeeNotificationsQuery_employeeNotifications_EmployeeNotificationsResult };


export type EmployeeNotificationsQueryVariables = Exact<{
  input: EmployeeNotificationsInput;
}>;


export type EmployeeNotificationsQuery = EmployeeNotificationsQuery_Query;

export type MarkNotificationReadMutation_markNotificationRead_MarkNotificationReadOutput_notification_EmployeeNotification = { __typename?: 'EmployeeNotification', id: any, isRead: boolean };

export type MarkNotificationReadMutation_markNotificationRead_MarkNotificationReadOutput = { __typename?: 'MarkNotificationReadOutput', notification?: MarkNotificationReadMutation_markNotificationRead_MarkNotificationReadOutput_notification_EmployeeNotification | null };

export type MarkNotificationReadMutation_Mutation = { __typename?: 'Mutation', markNotificationRead: MarkNotificationReadMutation_markNotificationRead_MarkNotificationReadOutput };


export type MarkNotificationReadMutationVariables = Exact<{
  input: MarkNotificationReadInput;
}>;


export type MarkNotificationReadMutation = MarkNotificationReadMutation_Mutation;

export type MarkNotificationUnreadMutation_markNotificationUnread_MarkNotificationUnreadOutput_notification_EmployeeNotification = { __typename?: 'EmployeeNotification', id: any, isRead: boolean };

export type MarkNotificationUnreadMutation_markNotificationUnread_MarkNotificationUnreadOutput = { __typename?: 'MarkNotificationUnreadOutput', notification?: MarkNotificationUnreadMutation_markNotificationUnread_MarkNotificationUnreadOutput_notification_EmployeeNotification | null };

export type MarkNotificationUnreadMutation_Mutation = { __typename?: 'Mutation', markNotificationUnread: MarkNotificationUnreadMutation_markNotificationUnread_MarkNotificationUnreadOutput };


export type MarkNotificationUnreadMutationVariables = Exact<{
  input: MarkNotificationUnreadInput;
}>;


export type MarkNotificationUnreadMutation = MarkNotificationUnreadMutation_Mutation;

export type EmployeeNotificationPrefUpdateMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult_employeeNotificationPref_EmployeeNotificationPreference = { __typename?: 'EmployeeNotificationPreference', employeeId: any, medium: EmployeeNotificationMedium, type: EmployeeNotificationType, value: boolean };

export type EmployeeNotificationPrefUpdateMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult = { __typename?: 'EmployeeNotificationPrefUpdateResult', employeeNotificationPref?: EmployeeNotificationPrefUpdateMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult_employeeNotificationPref_EmployeeNotificationPreference | null };

export type EmployeeNotificationPrefUpdateMutation_Mutation = { __typename?: 'Mutation', employeeNotificationPrefUpdate?: EmployeeNotificationPrefUpdateMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult | null };


export type EmployeeNotificationPrefUpdateMutationVariables = Exact<{
  input: EmployeeNotificationPrefUpdateInput;
}>;


export type EmployeeNotificationPrefUpdateMutation = EmployeeNotificationPrefUpdateMutation_Mutation;

export type MarkAllNotificationsReadMutation_markAllNotificationsRead_MarkAllNotificationsReadOutput = { __typename?: 'MarkAllNotificationsReadOutput', _empty?: boolean | null };

export type MarkAllNotificationsReadMutation_Mutation = { __typename?: 'Mutation', markAllNotificationsRead: MarkAllNotificationsReadMutation_markAllNotificationsRead_MarkAllNotificationsReadOutput };


export type MarkAllNotificationsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsReadMutation = MarkAllNotificationsReadMutation_Mutation;

export type MarkAllNotificationsSeenMutation_markAllNotificationsSeen_MarkAllNotificationsSeenOutput = { __typename?: 'MarkAllNotificationsSeenOutput', _empty?: boolean | null };

export type MarkAllNotificationsSeenMutation_Mutation = { __typename?: 'Mutation', markAllNotificationsSeen: MarkAllNotificationsSeenMutation_markAllNotificationsSeen_MarkAllNotificationsSeenOutput };


export type MarkAllNotificationsSeenMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsSeenMutation = MarkAllNotificationsSeenMutation_Mutation;

export type OAuthConsentAdapterQuery_oauthConsent_OAuthConsentResult_projection_OAuthConsentProjection_eligibleOrganizations_OAuthConsentOrganization = { __typename?: 'OAuthConsentOrganization', organizationId: any, displayName: string };

export type OAuthConsentAdapterQuery_oauthConsent_OAuthConsentResult_projection_OAuthConsentProjection = { __typename?: 'OAuthConsentProjection', applicationName: string, verifiedClientName: string, expiresAt: any, requestedScopes: Array<string>, redirectHost: string, eligibleOrganizations: Array<OAuthConsentAdapterQuery_oauthConsent_OAuthConsentResult_projection_OAuthConsentProjection_eligibleOrganizations_OAuthConsentOrganization> };

export type OAuthConsentAdapterQuery_oauthConsent_OAuthConsentResult = { __typename?: 'OAuthConsentResult', status: OAuthConsentStatus, verifiedClientName?: string | null, projection?: OAuthConsentAdapterQuery_oauthConsent_OAuthConsentResult_projection_OAuthConsentProjection | null };

export type OAuthConsentAdapterQuery_Query = { __typename?: 'Query', oauthConsent: OAuthConsentAdapterQuery_oauthConsent_OAuthConsentResult };


export type OAuthConsentAdapterQueryVariables = Exact<{
  input: OAuthConsentInput;
}>;


export type OAuthConsentAdapterQuery = OAuthConsentAdapterQuery_Query;

export type OAuthConsentCompleteAdapterMutation_oauthConsentComplete_OAuthConsentCompleteOutput = { __typename?: 'OAuthConsentCompleteOutput', handoffPath: string };

export type OAuthConsentCompleteAdapterMutation_Mutation = { __typename?: 'Mutation', oauthConsentComplete: OAuthConsentCompleteAdapterMutation_oauthConsentComplete_OAuthConsentCompleteOutput };


export type OAuthConsentCompleteAdapterMutationVariables = Exact<{
  input: OAuthConsentCompleteInput;
}>;


export type OAuthConsentCompleteAdapterMutation = OAuthConsentCompleteAdapterMutation_Mutation;

export type OmniSearchOptionApplication_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null };

export type OmniSearchOptionApplication_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type OmniSearchOptionApplication_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type OmniSearchOptionApplication_ApplicationFragment = { __typename?: 'Application', id: any, candidate?: OmniSearchOptionApplication_ApplicationFragment_Application_candidate_Candidate | null, job?: OmniSearchOptionApplication_ApplicationFragment_Application_job_Job | null, jobStage?: OmniSearchOptionApplication_ApplicationFragment_Application_jobStage_JobStage | null };

export type OmniSearchApplicationsQuery_applicationSearch_ApplicationSearchOutput_items_Application_candidate_Candidate = { __typename?: 'Candidate', fullName?: string | null };

export type OmniSearchApplicationsQuery_applicationSearch_ApplicationSearchOutput_items_Application = (
  { __typename?: 'Application', id: any, candidate?: OmniSearchApplicationsQuery_applicationSearch_ApplicationSearchOutput_items_Application_candidate_Candidate | null }
  & OmniSearchOptionApplication_ApplicationFragment
);

export type OmniSearchApplicationsQuery_applicationSearch_ApplicationSearchOutput = { __typename?: 'ApplicationSearchOutput', hasNext: boolean, items: Array<OmniSearchApplicationsQuery_applicationSearch_ApplicationSearchOutput_items_Application> };

export type OmniSearchApplicationsQuery_Query = { __typename?: 'Query', applicationSearch?: OmniSearchApplicationsQuery_applicationSearch_ApplicationSearchOutput | null };


export type OmniSearchApplicationsQueryVariables = Exact<{
  input: ApplicationSearchInput;
}>;


export type OmniSearchApplicationsQuery = OmniSearchApplicationsQuery_Query;

export type OmniSearchOptionEmployee_EmployeeFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, isArchived?: boolean | null, isAtsDisabled?: boolean | null, hasAtsId?: boolean | null, atsType?: AtsType | null };

export type OmniSearchEmployeesQuery_employeeSearch_EmployeeSearchOutput_items_Employee = (
  { __typename?: 'Employee', id: any, fullName?: string | null }
  & OmniSearchOptionEmployee_EmployeeFragment
);

export type OmniSearchEmployeesQuery_employeeSearch_EmployeeSearchOutput = { __typename?: 'EmployeeSearchOutput', total?: number | null, items: Array<OmniSearchEmployeesQuery_employeeSearch_EmployeeSearchOutput_items_Employee> };

export type OmniSearchEmployeesQuery_Query = { __typename?: 'Query', employeeSearch?: OmniSearchEmployeesQuery_employeeSearch_EmployeeSearchOutput | null };


export type OmniSearchEmployeesQueryVariables = Exact<{
  input: EmployeeSearchInput;
}>;


export type OmniSearchEmployeesQuery = OmniSearchEmployeesQuery_Query;

export type OmniSearchOptionInterviewModule_InterviewModuleFragment = { __typename?: 'InterviewModule', id: any, name: string };

export type OmniSearchInterviewModulesQuery_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule = (
  { __typename?: 'InterviewModule', id: any, name: string }
  & OmniSearchOptionInterviewModule_InterviewModuleFragment
);

export type OmniSearchInterviewModulesQuery_interviewModuleSearch_InterviewModuleSearchOutput = { __typename?: 'InterviewModuleSearchOutput', total?: number | null, items: Array<OmniSearchInterviewModulesQuery_interviewModuleSearch_InterviewModuleSearchOutput_items_InterviewModule> };

export type OmniSearchInterviewModulesQuery_Query = { __typename?: 'Query', interviewModuleSearch?: OmniSearchInterviewModulesQuery_interviewModuleSearch_InterviewModuleSearchOutput | null };


export type OmniSearchInterviewModulesQueryVariables = Exact<{
  input: InterviewModuleSearchInput;
}>;


export type OmniSearchInterviewModulesQuery = OmniSearchInterviewModulesQuery_Query;

export type OmniSearchOptionJob_JobFragment_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsCustomerFriendlyId?: string | null };

export type OmniSearchOptionJob_JobFragment = { __typename?: 'Job', id: any, name: string, atsJob?: OmniSearchOptionJob_JobFragment_Job_atsJob_AtsJob | null };

export type OmniSearchJobsQuery_jobs_JobsOutput_items_Job = (
  { __typename?: 'Job', id: any, name: string }
  & OmniSearchOptionJob_JobFragment
);

export type OmniSearchJobsQuery_jobs_JobsOutput = { __typename?: 'JobsOutput', nextCursor?: string | null, items: Array<OmniSearchJobsQuery_jobs_JobsOutput_items_Job> };

export type OmniSearchJobsQuery_Query = { __typename?: 'Query', jobs?: OmniSearchJobsQuery_jobs_JobsOutput | null };


export type OmniSearchJobsQueryVariables = Exact<{
  input: JobsInput;
}>;


export type OmniSearchJobsQuery = OmniSearchJobsQuery_Query;

export type PublicIdRedirectQuery_getUrlForPublicId_PublicIdInvalidError = { __typename: 'PublicIdInvalidError' };

export type PublicIdRedirectQuery_getUrlForPublicId_PublicIdNotFoundError = { __typename: 'PublicIdNotFoundError' };

export type PublicIdRedirectQuery_getUrlForPublicId_PublicIdUrl = { __typename: 'PublicIdUrl', publicId: string, url: string };

export type PublicIdRedirectQuery_getUrlForPublicId_UnknownError = { __typename: 'UnknownError' };

export type PublicIdRedirectQuery_getUrlForPublicId = PublicIdRedirectQuery_getUrlForPublicId_PublicIdInvalidError | PublicIdRedirectQuery_getUrlForPublicId_PublicIdNotFoundError | PublicIdRedirectQuery_getUrlForPublicId_PublicIdUrl | PublicIdRedirectQuery_getUrlForPublicId_UnknownError;

export type PublicIdRedirectQuery_Query = { __typename?: 'Query', getUrlForPublicId: PublicIdRedirectQuery_getUrlForPublicId };


export type PublicIdRedirectQueryVariables = Exact<{
  input: GetUrlForPublicIdInput;
}>;


export type PublicIdRedirectQuery = PublicIdRedirectQuery_Query;

export type RescheduleFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability = (
  { __typename?: 'CandidateAtsAvailability', timezone?: any | null, originalText?: string | null }
  & UseCandidateAvailability_AtsLatestAvailabilityFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any, timezone?: string | null, atsLatestAvailability?: RescheduleFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability | null }
  & ScheduleFlowDataProvider_CandidateFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: RescheduleFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null };

export type RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job_jobSettings_JobSettings = (
  { __typename?: 'JobSettings', id: any }
  & ScheduleFlowDataProvider_JobSettingsFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job = (
  { __typename?: 'Job', id: any, name: string, atsId: string, jobSettings: RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job_jobSettings_JobSettings }
  & ScheduleFlowDataProvider_JobFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & ScheduleFlowDataProvider_JobStageSettingsFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job | null, jobStageSettingsV2?: RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type RescheduleFlowQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability = (
  { __typename?: 'CandidateAvailability', id: any }
  & UseCandidateAvailability_AvailabilitiesFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage_task_Task_interviewPlan_JobStage = (
  { __typename?: 'JobStage', id: any }
  & ScheduleFlowDataProvider_InterviewPlanFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage_task_Task = (
  { __typename?: 'Task', id: any, availabilities: Array<RescheduleFlowQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability>, interviewPlan: RescheduleFlowQuery_applicationStage_ApplicationStage_task_Task_interviewPlan_JobStage }
  & ScheduleFlowDataProvider_TaskFragment
);

export type RescheduleFlowQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, application?: RescheduleFlowQuery_applicationStage_ApplicationStage_application_Application | null, jobStage?: RescheduleFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage | null, task?: RescheduleFlowQuery_applicationStage_ApplicationStage_task_Task | null };

export type RescheduleFlowQuery_Query = { __typename?: 'Query', applicationStage?: RescheduleFlowQuery_applicationStage_ApplicationStage | null };


export type RescheduleFlowQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RescheduleFlowQuery = RescheduleFlowQuery_Query;

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_shouldSendEmailToCandidate_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_shouldSendCalendarInviteToCandidate_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_shouldSendChatMessage_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_slackTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_isPrivateCalendarEvent_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees = { __typename?: 'SettingAdditionalAttendees', attendees: Array<JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees_attendees_SettingAdditionalAttendee> };

export type JobStageSettingsV2FragmentFragment = { __typename?: 'JobStageSettingsV2', id: any, jobStageId: any, shouldSendEmailToCandidate?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_shouldSendEmailToCandidate_SettingBoolValue | null, shouldSendCalendarInviteToCandidate?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_shouldSendCalendarInviteToCandidate_SettingBoolValue | null, shouldSendChatMessage?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_shouldSendChatMessage_SettingBoolValue | null, chatConversationMembers?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_chatConversationMembers_SettingNotificationPreference | null, candidateEmailTemplateId?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId | null, candidateEventTemplateId?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId | null, interviewerEventTemplateId?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId | null, interviewerCalendarId?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId | null, candidateCalendarId?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId | null, slackTemplateId?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_slackTemplateId_SettingTemplateId | null, isPrivateCalendarEvent: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_isPrivateCalendarEvent_SettingBoolValue, ccRecipientsV2?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_ccRecipientsV2_SettingNotificationPreference | null, bccRecipientsV2?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_bccRecipientsV2_SettingNotificationPreference | null, candidateEventAdditionalAttendees?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference | null, interviewerEventAdditionalAttendees?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference | null, debriefEventAdditionalAttendees?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendees_SettingNotificationPreference | null, candidateEventAdditionalAttendeesOptional?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesOptional_SettingBoolValue | null, interviewerEventAdditionalAttendeesOptional?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesOptional_SettingBoolValue | null, debriefEventAdditionalAttendeesOptional?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesOptional_SettingBoolValue | null, candidateEventAdditionalAttendeesV2?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_candidateEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, interviewerEventAdditionalAttendeesV2?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_interviewerEventAdditionalAttendeesV2_SettingAdditionalAttendees | null, debriefEventAdditionalAttendeesV2?: JobStageSettingsV2FragmentFragment_JobStageSettingsV2_debriefEventAdditionalAttendeesV2_SettingAdditionalAttendees | null };

export type JobStageSettingsV2GqlQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & JobStageSettingsV2FragmentFragment
);

export type JobStageSettingsV2GqlQuery_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: JobStageSettingsV2GqlQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type JobStageSettingsV2GqlQuery_Query = { __typename?: 'Query', jobStage?: JobStageSettingsV2GqlQuery_jobStage_JobStage | null };


export type JobStageSettingsV2GqlQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type JobStageSettingsV2GqlQuery = JobStageSettingsV2GqlQuery_Query;

export type ScheduleFlowDataProvider_CandidateFragment = (
  { __typename?: 'Candidate', id: any }
  & CandidateAvailabilityStep_CandidateFragment
  & Communications_CandidateFragment
  & UpdateCommunications_CandidateFragment
);

export type ScheduleFlowDataProvider_JobFragment = (
  { __typename?: 'Job', id: any }
  & ScheduleInterviewPlan_JobFragment
);

export type ScheduleFlowDataProvider_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & ScheduleInterviewPlan_JobStageFragment
  & Communications_InterviewPlanFragment
  & CalendarView_InterviewPlanFragment
  & UpdateCalendarView_InterviewPlanFragment
  & UpdateCommunications_InterviewPlanFragment
  & ScheduleOptions_InterviewPlanFragment
  & CloneInterviewPlan_InterviewPlanFragment
);

export type ScheduleFlowDataProvider_JobSettingsFragment = (
  { __typename?: 'JobSettings', id: any }
  & Communications_JobSettingsFragment
);

export type ScheduleFlowDataProvider_TaskFragment = (
  { __typename?: 'Task', id: any }
  & Communications_TaskFragment
  & UpdateCommunications_TaskFragment
);

export type ScheduleFlowDataProvider_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel_debriefAtsWriteSetting_DebriefAtsWriteSettingPref = (
  { __typename?: 'DebriefAtsWriteSettingPref' }
  & DebriefAtsWriteRow_SettingFragment
);

export type ScheduleFlowDataProvider_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel = { __typename?: 'DebriefAtsWriteSettingWithLevel', level: SettingLevel, debriefAtsWriteSetting?: ScheduleFlowDataProvider_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel_debriefAtsWriteSetting_DebriefAtsWriteSettingPref | null };

export type ScheduleFlowDataProvider_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, debriefAtsWriteSettingWithLevel?: ScheduleFlowDataProvider_JobStageSettingsFragment_JobStageSettingsV2_debriefAtsWriteSettingWithLevel_DebriefAtsWriteSettingWithLevel | null }
  & Communications_JobStageSettingsFragment
  & DebriefCommunications_JobStageSettingsFragment
  & UpdateCommunications_JobStageSettingsFragment
);

export type TaskDebriefRequirementQuery_application_Application_applicationStages_ApplicationStage = { __typename?: 'ApplicationStage', id: any, isHoldForRsvp: boolean, isReadyForCandidateComms: boolean };

export type TaskDebriefRequirementQuery_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any };

export type TaskDebriefRequirementQuery_application_Application = { __typename?: 'Application', id: any, applicationStages?: Array<TaskDebriefRequirementQuery_application_Application_applicationStages_ApplicationStage> | null, candidate?: TaskDebriefRequirementQuery_application_Application_candidate_Candidate | null };

export type TaskDebriefRequirementQuery_task_Task_debriefs_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any };

export type TaskDebriefRequirementQuery_task_Task = { __typename?: 'Task', isDebriefRequired: boolean, debriefs: Array<TaskDebriefRequirementQuery_task_Task_debriefs_ApplicationDebrief> };

export type TaskDebriefRequirementQuery_Query = { __typename?: 'Query', application?: TaskDebriefRequirementQuery_application_Application | null, task?: TaskDebriefRequirementQuery_task_Task | null };


export type TaskDebriefRequirementQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
  taskId: Scalars['uuid']['input'];
}>;


export type TaskDebriefRequirementQuery = TaskDebriefRequirementQuery_Query;

export type ScheduleFlowHeaderQuery_application_Application_candidate_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsId: string, atsUrl: string };

export type ScheduleFlowHeaderQuery_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, timezone?: string | null, email?: string | null, additionalEmails?: Array<string> | null, atsCandidate?: ScheduleFlowHeaderQuery_application_Application_candidate_Candidate_atsCandidate_AtsCandidate | null };

export type ScheduleFlowHeaderQuery_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type ScheduleFlowHeaderQuery_application_Application_job_Job = { __typename?: 'Job', id: any, name: string, isConfidential: boolean };

export type ScheduleFlowHeaderQuery_application_Application_existingConversations_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string, isArchived: boolean };

export type ScheduleFlowHeaderQuery_application_Application = { __typename?: 'Application', id: any, candidate?: ScheduleFlowHeaderQuery_application_Application_candidate_Candidate | null, jobStage?: ScheduleFlowHeaderQuery_application_Application_jobStage_JobStage | null, job?: ScheduleFlowHeaderQuery_application_Application_job_Job | null, existingConversations?: Array<ScheduleFlowHeaderQuery_application_Application_existingConversations_Conversation> | null };

export type ScheduleFlowHeaderQuery_Query = { __typename?: 'Query', application?: ScheduleFlowHeaderQuery_application_Application | null };


export type ScheduleFlowHeaderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ScheduleFlowHeaderQuery = ScheduleFlowHeaderQuery_Query;

export type JobStageNameQuery_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type JobStageNameQuery_Query = { __typename?: 'Query', jobStage?: JobStageNameQuery_jobStage_JobStage | null };


export type JobStageNameQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobStageNameQuery = JobStageNameQuery_Query;

export type CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability = { __typename?: 'CandidateAvailability', id: any, candidateEnteredAvailability?: Array<CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null };

export type CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task = { __typename?: 'Task', id: any, availabilities: Array<CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task_availabilities_CandidateAvailability> };

export type CandidateAvailabilityApplicationTasksQuery_application_Application = { __typename?: 'Application', tasks: Array<CandidateAvailabilityApplicationTasksQuery_application_Application_tasks_Task> };

export type CandidateAvailabilityApplicationTasksQuery_Query = { __typename?: 'Query', application?: CandidateAvailabilityApplicationTasksQuery_application_Application | null };


export type CandidateAvailabilityApplicationTasksQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type CandidateAvailabilityApplicationTasksQuery = CandidateAvailabilityApplicationTasksQuery_Query;

export type CandidateAvailabilityStep_CandidateFragment_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsId: string, atsUrl: string };

export type CandidateAvailabilityStep_CandidateFragment = { __typename?: 'Candidate', id: any, atsCandidate?: CandidateAvailabilityStep_CandidateFragment_Candidate_atsCandidate_AtsCandidate | null };

export type ScheduleIssuesDialogApplicationStageInterviewFragment_ApplicationStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, name: string };

export type ScheduleIssuesDialogApplicationStageInterviewFragment = { __typename?: 'ApplicationStageInterview', id: any, startAt: any, endAt: any, atsInterviewDefinition?: ScheduleIssuesDialogApplicationStageInterviewFragment_ApplicationStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null };

export type ScheduleIssuesDialogApplicationStageInterviewInterviewersFragment_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ScheduleIssuesDialogApplicationStageInterviewInterviewersFragment_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined = { __typename?: 'InterviewInterviewerDeclined', source?: string | null, reason?: DeclineReason | null, comment?: string | null };

export type ScheduleIssuesDialogApplicationStageInterviewInterviewersFragment = { __typename?: 'ApplicationStageInterviewInterviewer', applicationStageInterviewId: any, interviewerId: any, interviewer?: ScheduleIssuesDialogApplicationStageInterviewInterviewersFragment_ApplicationStageInterviewInterviewer_interviewer_Employee | null, declines?: Array<ScheduleIssuesDialogApplicationStageInterviewInterviewersFragment_ApplicationStageInterviewInterviewer_declines_InterviewInterviewerDeclined> | null };

export type InterviewInterviewerDeclinedQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = (
  { __typename?: 'ApplicationStageInterviewInterviewer' }
  & ScheduleIssuesDialogApplicationStageInterviewInterviewersFragment
);

export type InterviewInterviewerDeclinedQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = (
  { __typename?: 'ApplicationStageInterview', applicationStageInterviewInterviewers?: Array<InterviewInterviewerDeclinedQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null }
  & ScheduleIssuesDialogApplicationStageInterviewFragment
);

export type InterviewInterviewerDeclinedQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, applicationStageInterviews?: Array<InterviewInterviewerDeclinedQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type InterviewInterviewerDeclinedQuery_Query = { __typename?: 'Query', applicationStage?: InterviewInterviewerDeclinedQuery_applicationStage_ApplicationStage | null };


export type InterviewInterviewerDeclinedQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InterviewInterviewerDeclinedQuery = InterviewInterviewerDeclinedQuery_Query;

export type CandidateEmailCard_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseCandidateEventTemplateContent_InterviewPlanFragment
);

export type CandidateEmailCard_TaskFragment_Task_assignee_Employee = { __typename?: 'Employee', id: any };

export type CandidateEmailCard_TaskFragment_Task_createdBy_Employee = { __typename?: 'Employee', id: any };

export type CandidateEmailCard_TaskFragment = { __typename?: 'Task', id: any, assignee?: CandidateEmailCard_TaskFragment_Task_assignee_Employee | null, createdBy: CandidateEmailCard_TaskFragment_Task_createdBy_Employee };

export type SubscribersCandidateEmailCardQuery_subscribers_SubscribersResult_items_Employee = { __typename?: 'Employee', id: any };

export type SubscribersCandidateEmailCardQuery_subscribers_SubscribersResult = { __typename?: 'SubscribersResult', items: Array<SubscribersCandidateEmailCardQuery_subscribers_SubscribersResult_items_Employee> };

export type SubscribersCandidateEmailCardQuery_Query = { __typename?: 'Query', subscribers?: SubscribersCandidateEmailCardQuery_subscribers_SubscribersResult | null };


export type SubscribersCandidateEmailCardQueryVariables = Exact<{
  subscribersInput: SubscribersInput;
}>;


export type SubscribersCandidateEmailCardQuery = SubscribersCandidateEmailCardQuery_Query;

export type UseCandidateEventTemplateContent_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseScheduleContent_InterviewPlanFragment
);

export type CandidateEventCard_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseCandidateCalendarEventTemplateContent_InterviewPlanFragment
);

export type UseCandidateCalendarEventTemplateContent_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseScheduleContent_InterviewPlanFragment
);

export type CodingCard_CandidateFragment = { __typename?: 'Candidate', id: any, fullName?: string | null, email?: string | null, preferredEmail?: string | null, additionalEmails?: Array<string> | null };

export type CodingCard_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseCreateCodingUrls_InterviewPlanFragment
);

export type UseCreateCodingUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, dynamicLinkTypes?: Array<DynamicLinkType> | null };

export type UseCreateCodingUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<UseCreateCodingUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UseCreateCodingUrls_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UseCreateCodingUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type CollaborationToolCard_CandidateFragment = { __typename?: 'Candidate', id: any };

export type CollaborationToolCard_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_collaborationLinkTypes_CollaborationLinkType = (
  { __typename?: 'CollaborationLinkType' }
  & CollaborationToolCardRow_CollaborationLinkTypeFragment
);

export type CollaborationToolCard_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, collaborationLinkTypes?: Array<CollaborationToolCard_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_collaborationLinkTypes_CollaborationLinkType> | null };

export type CollaborationToolCard_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<CollaborationToolCard_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type CollaborationToolCard_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<CollaborationToolCard_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null }
  & UseCollaborationToolUrls_InterviewPlanFragment
);

export type CollaborationToolCardRow_CollaborationLinkTypeFragment = (
  { __typename?: 'CollaborationLinkType' }
  & CollaborationToolSelect_CollaborationLinkTypeFragment
);

export type CollaborationToolCardRowCollaborationLinkMutation_collaborationLinkCreate_CollaborationLinkCreateResult_collaborationLink_CollaborationLink = { __typename?: 'CollaborationLink', id: any, url: string, collaborationLinkTemplateId?: any | null };

export type CollaborationToolCardRowCollaborationLinkMutation_collaborationLinkCreate_CollaborationLinkCreateResult = { __typename?: 'CollaborationLinkCreateResult', collaborationLink: CollaborationToolCardRowCollaborationLinkMutation_collaborationLinkCreate_CollaborationLinkCreateResult_collaborationLink_CollaborationLink };

export type CollaborationToolCardRowCollaborationLinkMutation_Mutation = { __typename?: 'Mutation', collaborationLinkCreate: CollaborationToolCardRowCollaborationLinkMutation_collaborationLinkCreate_CollaborationLinkCreateResult };


export type CollaborationToolCardRowCollaborationLinkMutationVariables = Exact<{
  options: CollaborationLinkCreateInput;
}>;


export type CollaborationToolCardRowCollaborationLinkMutation = CollaborationToolCardRowCollaborationLinkMutation_Mutation;

export type UseCollaborationToolUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_collaborationLinkTypes_CollaborationLinkType = { __typename?: 'CollaborationLinkType', collaborationToolType: CollaborationToolType, collaborationLinkTemplateId?: any | null };

export type UseCollaborationToolUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, collaborationLinkTypes?: Array<UseCollaborationToolUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_collaborationLinkTypes_CollaborationLinkType> | null };

export type UseCollaborationToolUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<UseCollaborationToolUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UseCollaborationToolUrls_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UseCollaborationToolUrls_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type CreateCodingUrlsCollaborationLinkCreateMutationMutation_collaborationLinkCreate_CollaborationLinkCreateResult_collaborationLink_CollaborationLink = { __typename?: 'CollaborationLink', id: any, url: string, collaborationLinkTemplateId?: any | null };

export type CreateCodingUrlsCollaborationLinkCreateMutationMutation_collaborationLinkCreate_CollaborationLinkCreateResult = { __typename?: 'CollaborationLinkCreateResult', collaborationLink: CreateCodingUrlsCollaborationLinkCreateMutationMutation_collaborationLinkCreate_CollaborationLinkCreateResult_collaborationLink_CollaborationLink };

export type CreateCodingUrlsCollaborationLinkCreateMutationMutation_Mutation = { __typename?: 'Mutation', collaborationLinkCreate: CreateCodingUrlsCollaborationLinkCreateMutationMutation_collaborationLinkCreate_CollaborationLinkCreateResult };


export type CreateCodingUrlsCollaborationLinkCreateMutationMutationVariables = Exact<{
  options: CollaborationLinkCreateInput;
}>;


export type CreateCodingUrlsCollaborationLinkCreateMutationMutation = CreateCodingUrlsCollaborationLinkCreateMutationMutation_Mutation;

export type GetWarningModalCalendarQuery_calendar_Calendar = { __typename?: 'Calendar', id?: string | null, name?: string | null };

export type GetWarningModalCalendarQuery_Query = { __typename?: 'Query', calendar?: GetWarningModalCalendarQuery_calendar_Calendar | null };


export type GetWarningModalCalendarQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetWarningModalCalendarQuery = GetWarningModalCalendarQuery_Query;

export type HasApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any };

export type HasApplicationStageInterviewQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, applicationStageInterviews?: Array<HasApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null };

export type HasApplicationStageInterviewQuery_Query = { __typename?: 'Query', applicationStage?: HasApplicationStageInterviewQuery_applicationStage_ApplicationStage | null };


export type HasApplicationStageInterviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type HasApplicationStageInterviewQuery = HasApplicationStageInterviewQuery_Query;

export type CommunicationsPreview_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseSubmitCreateSchedule_InterviewPlanFragment
);

export type CommunicationsPreview_JobSettingsFragment_JobSettings_defaultTaskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any };

export type CommunicationsPreview_JobSettingsFragment = { __typename?: 'JobSettings', id: any, defaultTaskQueue?: CommunicationsPreview_JobSettingsFragment_JobSettings_defaultTaskQueue_TaskQueue | null };

export type UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee = { __typename?: 'JobStageInterviewSeatEmployee', jobStageInterviewSeatId: any, employeeId: any, preferenceLevel?: number | null };

export type UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat = { __typename?: 'FreeformSeat', jobStageInterviewSeatEmployees?: Array<UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee> | null };

export type UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any };

export type UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat = { __typename?: 'LinkedSeat', linkedJobStageInterviewSeatId: any };

export type UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = { __typename?: 'JobStageInterviewSeat', id: any, freeformSeat?: UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat | null, moduleSeat?: UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat | null, linkedSeat?: UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat | null };

export type UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, jobStageInterviewSeats?: Array<UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null };

export type UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UseGetInterviewers_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UseGetInterviewers_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string };

export type UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_interviewGuide_InterviewGuide = { __typename?: 'InterviewGuide', id: any };

export type UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, atsInterviewDefinition?: UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null, interviewGuide?: UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_interviewGuide_InterviewGuide | null };

export type UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UsePopulateEventData_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UsePopulateEventData_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type ScheduleFlowSaveSettingsToJobStageMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any };

export type ScheduleFlowSaveSettingsToJobStageMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult = { __typename?: 'JobStageSettingsUpsertResult', jobStageSettingsV2?: ScheduleFlowSaveSettingsToJobStageMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ScheduleFlowSaveSettingsToJobStageMutation_Mutation = { __typename?: 'Mutation', jobStageSettingsUpsert?: ScheduleFlowSaveSettingsToJobStageMutation_jobStageSettingsUpsert_JobStageSettingsUpsertResult | null };


export type ScheduleFlowSaveSettingsToJobStageMutationVariables = Exact<{
  input: JobStageSettingsUpsertInput;
}>;


export type ScheduleFlowSaveSettingsToJobStageMutation = ScheduleFlowSaveSettingsToJobStageMutation_Mutation;

export type ScheduleNowTaskCreateMutation_taskCreate_TaskCreateResult_task_Task = { __typename?: 'Task', id: any };

export type ScheduleNowTaskCreateMutation_taskCreate_TaskCreateResult = { __typename?: 'TaskCreateResult', task: ScheduleNowTaskCreateMutation_taskCreate_TaskCreateResult_task_Task };

export type ScheduleNowTaskCreateMutation_Mutation = { __typename?: 'Mutation', taskCreate?: ScheduleNowTaskCreateMutation_taskCreate_TaskCreateResult | null };


export type ScheduleNowTaskCreateMutationVariables = Exact<{
  input: TaskCreateInput;
}>;


export type ScheduleNowTaskCreateMutation = ScheduleNowTaskCreateMutation_Mutation;

export type CreateScheduleMutation_scheduleCreate_ScheduleCreateResult_debriefRescheduleDetails_DebriefRescheduleDetails = { __typename?: 'DebriefRescheduleDetails', hasScheduleTimeAfterDebriefStartAt: boolean, hasAttendeeAdded: boolean };

export type CreateScheduleMutation_scheduleCreate_ScheduleCreateResult = { __typename?: 'ScheduleCreateResult', applicationStageId: any, debriefRescheduleDetails: CreateScheduleMutation_scheduleCreate_ScheduleCreateResult_debriefRescheduleDetails_DebriefRescheduleDetails };

export type CreateScheduleMutation_Mutation = { __typename?: 'Mutation', scheduleCreate?: CreateScheduleMutation_scheduleCreate_ScheduleCreateResult | null };


export type CreateScheduleMutationVariables = Exact<{
  input: ScheduleCreateInput;
}>;


export type CreateScheduleMutation = CreateScheduleMutation_Mutation;

export type RescheduleMutation_scheduleReschedule_ScheduleRescheduleResult_debriefRescheduleDetails_DebriefRescheduleDetails = { __typename?: 'DebriefRescheduleDetails', hasScheduleTimeAfterDebriefStartAt: boolean, hasAttendeeAdded: boolean };

export type RescheduleMutation_scheduleReschedule_ScheduleRescheduleResult = { __typename?: 'ScheduleRescheduleResult', applicationStageId: any, debriefRescheduleDetails: RescheduleMutation_scheduleReschedule_ScheduleRescheduleResult_debriefRescheduleDetails_DebriefRescheduleDetails };

export type RescheduleMutation_Mutation = { __typename?: 'Mutation', scheduleReschedule?: RescheduleMutation_scheduleReschedule_ScheduleRescheduleResult | null };


export type RescheduleMutationVariables = Exact<{
  input: ScheduleRescheduleInput;
}>;


export type RescheduleMutation = RescheduleMutation_Mutation;

export type UseSubmitCreateSchedule_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseGetInterviewers_InterviewPlanFragment
  & GetSaveInterviewPlanInput_InterviewPlanFragment
  & UsePopulateEventData_InterviewPlanFragment
);

export type CreateScheduleSaveInterviewPlanMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type CreateScheduleSaveInterviewPlanMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult = { __typename?: 'JobStageInterviewPlanResult', jobStage?: CreateScheduleSaveInterviewPlanMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage | null };

export type CreateScheduleSaveInterviewPlanMutation_Mutation = { __typename?: 'Mutation', jobStageInterviewPlanUpsert?: CreateScheduleSaveInterviewPlanMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult | null };


export type CreateScheduleSaveInterviewPlanMutationVariables = Exact<{
  input: JobStageInterviewPlanUpsertInput;
}>;


export type CreateScheduleSaveInterviewPlanMutation = CreateScheduleSaveInterviewPlanMutation_Mutation;

export type InterviewerContentCard_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseInterviewEventTemplateContent_InterviewPlanFragment
);

export type UseInterviewEventTemplateContent_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseScheduleContent_InterviewPlanFragment
);

export type InterviewerCommunicationCards_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & InterviewerContentCard_InterviewPlanFragment
);

export type CustomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails = { __typename?: 'MeetingLocationDetails', customLocation?: string | null };

export type CustomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation = { __typename?: 'MeetingLocation', id: any, type: InterviewMeetingLocationType, videoMeetingLink?: string | null, details?: CustomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails | null };

export type CustomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult = { __typename?: 'MeetingLocationCreateResult', meetingLocation?: CustomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation | null };

export type CustomInterviewMeetingLocationCreateMutation_Mutation = { __typename?: 'Mutation', meetingLocationCreate?: CustomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult | null };


export type CustomInterviewMeetingLocationCreateMutationVariables = Exact<{
  input: MeetingLocationCreateInput;
}>;


export type CustomInterviewMeetingLocationCreateMutation = CustomInterviewMeetingLocationCreateMutation_Mutation;

export type CalendarMeetingCreateMutation_calendarMeetingCreate_GoogleMeetingResult = { __typename?: 'GoogleMeetingResult', url: string };

export type CalendarMeetingCreateMutation_Mutation = { __typename?: 'Mutation', calendarMeetingCreate?: CalendarMeetingCreateMutation_calendarMeetingCreate_GoogleMeetingResult | null };


export type CalendarMeetingCreateMutationVariables = Exact<{
  input: CalendarMeetingCreateInput;
}>;


export type CalendarMeetingCreateMutation = CalendarMeetingCreateMutation_Mutation;

export type VideoInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation = { __typename?: 'MeetingLocation', id: any, type: InterviewMeetingLocationType, videoMeetingLink?: string | null };

export type VideoInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult = { __typename?: 'MeetingLocationCreateResult', meetingLocation?: VideoInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation | null };

export type VideoInterviewMeetingLocationCreateMutation_Mutation = { __typename?: 'Mutation', meetingLocationCreate?: VideoInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult | null };


export type VideoInterviewMeetingLocationCreateMutationVariables = Exact<{
  input: MeetingLocationCreateInput;
}>;


export type VideoInterviewMeetingLocationCreateMutation = VideoInterviewMeetingLocationCreateMutation_Mutation;

export type ZoomMeetingCreateMutation_zoomMeetingCreate_ZoomMeetingCreateResult_dialInfo_DialInfo = { __typename?: 'DialInfo', country?: string | null, countryName?: string | null, city?: string | null, number?: string | null, type?: string | null };

export type ZoomMeetingCreateMutation_zoomMeetingCreate_ZoomMeetingCreateResult = { __typename?: 'ZoomMeetingCreateResult', joinUrl?: string | null, meetingId: any, password?: string | null, pstnPassword?: string | null, dialInfo?: Array<ZoomMeetingCreateMutation_zoomMeetingCreate_ZoomMeetingCreateResult_dialInfo_DialInfo> | null };

export type ZoomMeetingCreateMutation_Mutation = { __typename?: 'Mutation', zoomMeetingCreate?: ZoomMeetingCreateMutation_zoomMeetingCreate_ZoomMeetingCreateResult | null };


export type ZoomMeetingCreateMutationVariables = Exact<{
  input: ZoomMeetingCreateInput;
}>;


export type ZoomMeetingCreateMutation = ZoomMeetingCreateMutation_Mutation;

export type ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo = { __typename?: 'DialInfo', type?: string | null, number?: string | null, city?: string | null, countryName?: string | null, country?: string | null };

export type ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo = { __typename?: 'ZoomInfo', meetingId?: any | null, password?: string | null, pstnPassword?: string | null, dialInfo?: Array<ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo> | null };

export type ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails = { __typename?: 'MeetingLocationDetails', zoomInfo?: ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo | null };

export type ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation = { __typename?: 'MeetingLocation', id: any, videoMeetingLink?: string | null, details?: ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails | null };

export type ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult = { __typename?: 'MeetingLocationCreateResult', meetingLocation?: ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation | null };

export type ZoomSingleDebriefMeetingLocationCreateMutation_Mutation = { __typename?: 'Mutation', meetingLocationCreate?: ZoomSingleDebriefMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult | null };


export type ZoomSingleDebriefMeetingLocationCreateMutationVariables = Exact<{
  input: MeetingLocationCreateInput;
}>;


export type ZoomSingleDebriefMeetingLocationCreateMutation = ZoomSingleDebriefMeetingLocationCreateMutation_Mutation;

export type ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo = { __typename?: 'DialInfo', type?: string | null, number?: string | null, city?: string | null, countryName?: string | null, country?: string | null };

export type ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo = { __typename?: 'ZoomInfo', password?: string | null, meetingId?: any | null, userId?: string | null, pstnPassword?: string | null, dialInfo?: Array<ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo> | null };

export type ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails = { __typename?: 'MeetingLocationDetails', zoomInfo?: ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo | null };

export type ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation = { __typename?: 'MeetingLocation', id: any, type: InterviewMeetingLocationType, videoMeetingLink?: string | null, details?: ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation_details_MeetingLocationDetails | null };

export type ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult = { __typename?: 'MeetingLocationCreateResult', meetingLocation?: ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult_meetingLocation_MeetingLocation | null };

export type ZoomInterviewMeetingLocationCreateMutation_Mutation = { __typename?: 'Mutation', meetingLocationCreate?: ZoomInterviewMeetingLocationCreateMutation_meetingLocationCreate_MeetingLocationCreateResult | null };


export type ZoomInterviewMeetingLocationCreateMutationVariables = Exact<{
  input: MeetingLocationCreateInput;
}>;


export type ZoomInterviewMeetingLocationCreateMutation = ZoomInterviewMeetingLocationCreateMutation_Mutation;

export type LocationCard_InterviewMeetingLocationSettingFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & UsePopulateInterviewMeetingLocation_InterviewMeetingLocationSettingFragment
);

export type UsePopulateInterviewMeetingLocation_InterviewMeetingLocationSettingFragment = { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, videoMeetingLinkScope: VideoMeetingLinkScope, dynamicHost?: DynamicInterviewMeetingHost | null, hostEmployeeId?: string | null, remoteVideoMeetingHostUserId?: string | null, customLocation?: string | null };

export type InterviewMeetingLocationZoomUsersByEmployeeIdsQuery_zoomUsersByIds_ZoomUser = { __typename?: 'ZoomUser', employeeId?: string | null, zoomUserId: string };

export type InterviewMeetingLocationZoomUsersByEmployeeIdsQuery_Query = { __typename?: 'Query', zoomUsersByIds?: Array<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery_zoomUsersByIds_ZoomUser> | null };


export type InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables = Exact<{
  employeeIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type InterviewMeetingLocationZoomUsersByEmployeeIdsQuery = InterviewMeetingLocationZoomUsersByEmployeeIdsQuery_Query;

export type BaseSlackChannelCard_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseSlackTemplateContent_InterviewPlanFragment
);

export type SlackChannelByNameQuery_slackChannelByName_SlackChannel = { __typename?: 'SlackChannel', id: string, name: string };

export type SlackChannelByNameQuery_Query = { __typename?: 'Query', slackChannelByName?: Array<SlackChannelByNameQuery_slackChannelByName_SlackChannel> | null };


export type SlackChannelByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type SlackChannelByNameQuery = SlackChannelByNameQuery_Query;

export type ExistingSlackChannelsQuery_application_Application_existingConversations_Conversation = { __typename?: 'Conversation', id: any, remoteName: string, isArchived: boolean };

export type ExistingSlackChannelsQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversation_SettingChatConversation_chatConversation_Conversation = { __typename?: 'Conversation', id: any, remoteName: string, isArchived: boolean };

export type ExistingSlackChannelsQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversation_SettingChatConversation = { __typename?: 'SettingChatConversation', chatConversationId?: any | null, chatConversationType?: ChatConversationType | null, chatConversation?: ExistingSlackChannelsQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversation_SettingChatConversation_chatConversation_Conversation | null };

export type ExistingSlackChannelsQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, chatConversation?: ExistingSlackChannelsQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_chatConversation_SettingChatConversation | null };

export type ExistingSlackChannelsQuery_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: ExistingSlackChannelsQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ExistingSlackChannelsQuery_application_Application = { __typename?: 'Application', id: any, existingConversations?: Array<ExistingSlackChannelsQuery_application_Application_existingConversations_Conversation> | null, jobStage?: ExistingSlackChannelsQuery_application_Application_jobStage_JobStage | null };

export type ExistingSlackChannelsQuery_Query = { __typename?: 'Query', application?: ExistingSlackChannelsQuery_application_Application | null };


export type ExistingSlackChannelsQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type ExistingSlackChannelsQuery = ExistingSlackChannelsQuery_Query;

export type SlackChannelCard_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & BaseSlackChannelCard_InterviewPlanFragment
);

export type SlackChannelCard_JobStageSettingsV2Fragment_JobStageSettingsV2_chatConversation_SettingChatConversation_chatConversation_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string, isArchived: boolean };

export type SlackChannelCard_JobStageSettingsV2Fragment_JobStageSettingsV2_chatConversation_SettingChatConversation = { __typename?: 'SettingChatConversation', chatConversationId?: any | null, chatConversationType?: ChatConversationType | null, chatConversation?: SlackChannelCard_JobStageSettingsV2Fragment_JobStageSettingsV2_chatConversation_SettingChatConversation_chatConversation_Conversation | null };

export type SlackChannelCard_JobStageSettingsV2Fragment = { __typename?: 'JobStageSettingsV2', chatConversation?: SlackChannelCard_JobStageSettingsV2Fragment_JobStageSettingsV2_chatConversation_SettingChatConversation | null };

export type UseSlackTemplateContent_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseScheduleContent_InterviewPlanFragment
);

export type UseScheduleContent_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UsePopulateEventData_InterviewPlanFragment
);

export type CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration = { __typename?: 'CoderpadIntegration', apiKey: string };

export type CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration = { __typename?: 'CodilityIntegration', apiKey: string };

export type CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration = { __typename?: 'CodesignalIntegration', apiKey: string };

export type CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration = { __typename?: 'HackerRankIntegration', apiKey: string };

export type CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, coderpad?: CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration | null, codility?: CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration | null, codesignal?: CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration | null, hackerrank?: CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration | null };

export type CommunicationsOrgIntegrationQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: CommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type CommunicationsOrgIntegrationQuery_Query = { __typename?: 'Query', thisOrg?: CommunicationsOrgIntegrationQuery_thisOrg_Org | null };


export type CommunicationsOrgIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunicationsOrgIntegrationQuery = CommunicationsOrgIntegrationQuery_Query;

export type Communications_CandidateFragment = (
  { __typename?: 'Candidate', id: any, fullName?: string | null, preferredName?: string | null, preferredPhoneNumber?: string | null }
  & CodingCard_CandidateFragment
);

export type Communications_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & CandidateEmailCard_InterviewPlanFragment
  & CandidateEventCard_InterviewPlanFragment
  & CodingCard_InterviewPlanFragment
  & CommunicationsPreview_InterviewPlanFragment
  & InterviewerCommunicationCards_InterviewPlanFragment
  & SlackChannelCard_InterviewPlanFragment
);

export type Communications_TaskFragment = (
  { __typename?: 'Task', id: any }
  & CandidateEmailCard_TaskFragment
);

export type Communications_JobSettingsFragment = (
  { __typename?: 'JobSettings', id: any }
  & CommunicationsPreview_JobSettingsFragment
);

export type Communications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & LocationCard_InterviewMeetingLocationSettingFragment
);

export type Communications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: Communications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type Communications_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, interviewMeetingLocationSettingWithLevel?: Communications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null }
  & SlackChannelCard_JobStageSettingsV2Fragment
);

export type InterviewDetails_InterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string };

export type InterviewDetails_InterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & UpdateInterviewSeat_InterviewSeatFragment
);

export type InterviewDetails_InterviewFragment_JobStageInterview_interviewGuide_InterviewGuide = (
  { __typename?: 'InterviewGuide' }
  & BrighthireSelect_InterviewGuideFragment
);

export type InterviewDetails_InterviewFragment = (
  { __typename?: 'JobStageInterview', id: any, atsInterviewDefinition?: InterviewDetails_InterviewFragment_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null, jobStageInterviewSeats?: Array<InterviewDetails_InterviewFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null, interviewGuide?: InterviewDetails_InterviewFragment_JobStageInterview_interviewGuide_InterviewGuide | null }
  & UpdateInterviewSeat_InterviewFragment
);

export type InterviewDetails_OriginalInterviewsFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = (
  { __typename?: 'JobStageInterviewSeat', id: any }
  & UpdateInterviewSeat_OriginalInterviewSeatFragment
);

export type InterviewDetails_OriginalInterviewsFragment = (
  { __typename?: 'JobStageInterview', id: any, jobStageInterviewSeats?: Array<InterviewDetails_OriginalInterviewsFragment_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null }
  & UpdateInterviewSeat_OriginalInterviewFragment
);

export type InterviewModuleQuery_interviewModule_InterviewModule = (
  { __typename?: 'InterviewModule', membersCount: any, membersTrainedCount: any, membersInTrainingCount: any, membersInShadowCount: any, membersInReverseShadowCount: any, graduateFromShadowApprovalType: GraduationApprovalType, graduateFromShadowCustomApprovers?: Array<GraduationApproverType> | null, graduateFromReverseShadowApprovalType: GraduationApprovalType, graduateFromReverseShadowCustomApprovers?: Array<GraduationApproverType> | null }
  & InterviewModuleFragment
);

export type InterviewModuleQuery_Query = { __typename?: 'Query', interviewModule?: InterviewModuleQuery_interviewModule_InterviewModule | null };


export type InterviewModuleQueryVariables = Exact<{
  interviewModuleId: Scalars['uuid']['input'];
}>;


export type InterviewModuleQuery = InterviewModuleQuery_Query;

export type UpdateInterviewSeat_InterviewFragment = { __typename?: 'JobStageInterview', id: any, name?: string | null };

export type UpdateInterviewSeat_OriginalInterviewFragment = { __typename?: 'JobStageInterview', id: any, name?: string | null };

export type UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee = { __typename?: 'JobStageInterviewSeatEmployee', employeeId: any, preferenceLevel?: number | null };

export type UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat = { __typename?: 'FreeformSeat', jobStageInterviewSeatEmployees?: Array<UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee> | null };

export type UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any, selectedEmployeeIds: Array<any>, jobStageInterviewSeatAttributes?: Array<UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute> | null };

export type UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_linkedSeat_LinkedSeat = { __typename?: 'LinkedSeat', linkedJobStageInterviewSeatId: any };

export type UpdateInterviewSeat_InterviewSeatFragment = { __typename?: 'JobStageInterviewSeat', id: any, type: JobStageInterviewSeatType, index?: number | null, freeformSeat?: UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat | null, moduleSeat?: UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat | null, linkedSeat?: UpdateInterviewSeat_InterviewSeatFragment_JobStageInterviewSeat_linkedSeat_LinkedSeat | null };

export type UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee = { __typename?: 'JobStageInterviewSeatEmployee', employeeId: any, preferenceLevel?: number | null };

export type UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat = { __typename?: 'FreeformSeat', jobStageInterviewSeatEmployees?: Array<UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee> | null };

export type UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any, selectedEmployeeIds: Array<any>, jobStageInterviewSeatAttributes?: Array<UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute> | null };

export type UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_linkedSeat_LinkedSeat = { __typename?: 'LinkedSeat', linkedJobStageInterviewSeatId: any };

export type UpdateInterviewSeat_OriginalInterviewSeatFragment = { __typename?: 'JobStageInterviewSeat', id: any, type: JobStageInterviewSeatType, index?: number | null, freeformSeat?: UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_freeformSeat_FreeformSeat | null, moduleSeat?: UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_moduleSeat_ModuleSeat | null, linkedSeat?: UpdateInterviewSeat_OriginalInterviewSeatFragment_JobStageInterviewSeat_linkedSeat_LinkedSeat | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_companyHolidays_CompanyHoliday = (
  { __typename?: 'CompanyHoliday', id: any }
  & GetTextForFlag_CompanyHolidayFragment
);

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_loadAndLimit_LoadAndLimit = { __typename?: 'LoadAndLimit', dailyLoad?: number | null, weeklyLoad?: number | null, lastWeeklyLoad?: number | null, dailyLoadMinutes?: number | null, weeklyLoadMinutes?: number | null, lastWeeklyLoadMinutes?: number | null, dailyInterviewLimit?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit | null, weeklyInterviewLimit?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_employee_Employee_interviewModuleMember_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', trainingStatus?: TrainingStatus | null, currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null, completedAsShadow?: any | null, completedAsReverseShadow?: any | null, shadowOffset?: any | null, reverseShadowOffset?: any | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_employee_Employee_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, stats?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_employee_Employee_interviewModuleMember_InterviewModuleMember_stats_InterviewModuleMemberStats | null }
  & IsModuleMemberDisabledForScheduling_ModuleMemberFragment
  & ModuleMember_InterviewModuleMemberFragment
);

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, linkedinUrl?: string | null, internalProfilePictureUrl?: string | null, timezone?: string | null, email: string, title?: string | null, interviewModuleMember?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_employee_Employee_interviewModuleMember_InterviewModuleMember | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_eventsWithConflicts_EventsWithConflicts = { __typename?: 'EventsWithConflicts', flag?: InterviewerFlag | null, events?: Array<string> | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion = { __typename?: 'InterviewerSuggestion', role?: InterviewerRole | null, employeeId: string, flags?: Array<InterviewerFlag> | null, companyHolidays: Array<InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_companyHolidays_CompanyHoliday>, loadAndLimit?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_loadAndLimit_LoadAndLimit | null, employee?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_employee_Employee | null, eventsWithConflicts?: Array<InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion_eventsWithConflicts_EventsWithConflicts> | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_companyHolidays_CompanyHoliday = (
  { __typename?: 'CompanyHoliday', id: any }
  & GetTextForFlag_CompanyHolidayFragment
);

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit = { __typename?: 'InterviewLimit', type?: InterviewLimitType | null, limit?: number | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_loadAndLimit_LoadAndLimit = { __typename?: 'LoadAndLimit', dailyLoad?: number | null, weeklyLoad?: number | null, lastWeeklyLoad?: number | null, dailyLoadMinutes?: number | null, weeklyLoadMinutes?: number | null, lastWeeklyLoadMinutes?: number | null, dailyInterviewLimit?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_loadAndLimit_LoadAndLimit_dailyInterviewLimit_InterviewLimit | null, weeklyInterviewLimit?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_loadAndLimit_LoadAndLimit_weeklyInterviewLimit_InterviewLimit | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, givenName?: string | null, linkedinUrl?: string | null, internalProfilePictureUrl?: string | null, timezone?: string | null, email: string, title?: string | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_eventsWithConflicts_EventsWithConflicts = { __typename?: 'EventsWithConflicts', flag?: InterviewerFlag | null, events?: Array<string> | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion = { __typename?: 'InterviewerSuggestion', role?: InterviewerRole | null, employeeId: string, flags?: Array<InterviewerFlag> | null, companyHolidays: Array<InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_companyHolidays_CompanyHoliday>, loadAndLimit?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_loadAndLimit_LoadAndLimit | null, employee?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_employee_Employee | null, eventsWithConflicts?: Array<InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion_eventsWithConflicts_EventsWithConflicts> | null };

export type InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput = { __typename?: 'InterviewerSuggestionsOutput', employees?: Array<InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_employees_InterviewerSuggestion> | null, others?: Array<InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput_others_InterviewerSuggestion> | null };

export type InterviewerSuggestionsQuery_Query = { __typename?: 'Query', interviewerSuggestions?: InterviewerSuggestionsQuery_interviewerSuggestions_InterviewerSuggestionsOutput | null };


export type InterviewerSuggestionsQueryVariables = Exact<{
  input: InterviewerSuggestionsInput;
  interviewModuleId: Scalars['uuid']['input'];
}>;


export type InterviewerSuggestionsQuery = InterviewerSuggestionsQuery_Query;

export type InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, name: string, shadowsRequired: any, reverseShadowsRequired: any };

export type InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_stats_InterviewModuleMemberStats = { __typename?: 'InterviewModuleMemberStats', completed?: any | null, upcoming?: any | null, shadowOffset?: any | null, shadowsRequired?: any | null, reverseShadowOffset?: any | null, reverseShadowsRequired?: any | null, completedAsShadow?: any | null, completedAsReverseShadow?: any | null, currentTrainingSessionStatus?: CurrentTrainingSessionStatus | null };

export type InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember = { __typename?: 'InterviewModuleMember', interviewModuleId: any, employeeId: any, status: TrainingStatus, interviewModule?: InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_interviewModule_InterviewModule | null, employee?: InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_employee_Employee | null, stats?: InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember_stats_InterviewModuleMemberStats | null };

export type InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput = { __typename?: 'InterviewModuleMemberLookupOutput', items: Array<InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput_items_InterviewModuleMember> };

export type InterviewModuleMemberLookupQuery_Query = { __typename?: 'Query', interviewModuleMemberLookup?: InterviewModuleMemberLookupQuery_interviewModuleMemberLookup_InterviewModuleMemberLookupOutput | null };


export type InterviewModuleMemberLookupQueryVariables = Exact<{
  memberIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  interviewModuleIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type InterviewModuleMemberLookupQuery = InterviewModuleMemberLookupQuery_Query;

export type BaseCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = (
  { __typename?: 'JobStageInterview', id: any }
  & InterviewDetails_InterviewFragment
  & InterviewDetails_OriginalInterviewsFragment
);

export type BaseCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<BaseCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type BaseCalendarView_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<BaseCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null }
  & UseSubmitInterviewPlan_InterviewPlanFragment
);

export type CalendarView_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & BaseCalendarView_InterviewPlanFragment
  & UsePopulateEventData_InterviewPlanFragment
);

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_after_Duration = { __typename?: 'Duration', seconds: any };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_before_Duration = { __typename?: 'Duration', seconds: any };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref', after?: GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_after_Duration | null, before?: GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref_before_Duration | null };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewLimit = { __typename?: 'InterviewLimit' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value = GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_CandidatePageFiltersPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_DirectoryPageFiltersPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardFilterPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_EmployeeTaskDashboardLayoutPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewBufferTimePref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_InterviewLimit | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageAverageTimesFiltersPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageCandidatePulseFiltersPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageInterviewerFiltersPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_MetricsPageRecruitingTeamFiltersPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_ProfilePicturePref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_RecentlyUsedZoomUsersPref | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value_UpcomingEventsPageFiltersPref;

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_BoolEmployeePrefValue = { __typename?: 'BoolEmployeePrefValue' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_DurationEmployeePrefValue = { __typename?: 'DurationEmployeePrefValue' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_IntEmployeePrefValue = { __typename?: 'IntEmployeePrefValue' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonArrayEmployeePrefValue = { __typename?: 'JsonArrayEmployeePrefValue' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue = { __typename?: 'JsonEmployeePrefValue', id: string, prefName: string, value?: GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue_value | null };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_StringArrayEmployeePrefValue = { __typename?: 'StringArrayEmployeePrefValue' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_StringEmployeePrefValue = { __typename?: 'StringEmployeePrefValue' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_TimestampEmployeePrefValue = { __typename?: 'TimestampEmployeePrefValue' };

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues = GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_BoolEmployeePrefValue | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_DurationEmployeePrefValue | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_IntEmployeePrefValue | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonArrayEmployeePrefValue | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_JsonEmployeePrefValue | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_StringArrayEmployeePrefValue | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_StringEmployeePrefValue | GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues_TimestampEmployeePrefValue;

export type GetAllEmployeeBufferTimesQuery_employeeByIds_Employee = { __typename?: 'Employee', id: any, employeePrefValues: Array<GetAllEmployeeBufferTimesQuery_employeeByIds_Employee_employeePrefValues> };

export type GetAllEmployeeBufferTimesQuery_Query = { __typename?: 'Query', employeeByIds?: Array<GetAllEmployeeBufferTimesQuery_employeeByIds_Employee> | null };


export type GetAllEmployeeBufferTimesQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAllEmployeeBufferTimesQuery = GetAllEmployeeBufferTimesQuery_Query;

export type AbsoluteEmployeeWorkHoursQuery_employeeByIds_Employee_absoluteWorkHours_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type AbsoluteEmployeeWorkHoursQuery_employeeByIds_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, absoluteWorkHours: Array<AbsoluteEmployeeWorkHoursQuery_employeeByIds_Employee_absoluteWorkHours_DateTimeRangeOutput> };

export type AbsoluteEmployeeWorkHoursQuery_Query = { __typename?: 'Query', employeeByIds?: Array<AbsoluteEmployeeWorkHoursQuery_employeeByIds_Employee> | null };


export type AbsoluteEmployeeWorkHoursQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  startAt: Scalars['datetime']['input'];
  endAt: Scalars['datetime']['input'];
}>;


export type AbsoluteEmployeeWorkHoursQuery = AbsoluteEmployeeWorkHoursQuery_Query;

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition = { __typename?: 'AshbyInterviewDefinition' };

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition = { __typename?: 'GemInterviewDefinition' };

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition = { __typename?: 'GreenhouseInterviewDefinition', estimatedMinutes: any };

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition = { __typename?: 'LeverInterviewDefinition' };

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition = { __typename?: 'WorkdayInterviewDefinition' };

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields = BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition | BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition | BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition | BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition | BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition;

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, name: string, atsFields?: BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields | null };

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, name?: string | null, interviewType: InterviewType, duration?: number | null, isLockedOrder: boolean, atsInterviewDefinition?: BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null };

export type BaseInterviewPlanPreview_JobStageInterviewGroupsFragment = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<BaseInterviewPlanPreview_JobStageInterviewGroupsFragment_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type InterviewPlanPreview_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = (
  { __typename?: 'JobStageInterviewGroup', id: any }
  & BaseInterviewPlanPreview_JobStageInterviewGroupsFragment
);

export type InterviewPlanPreview_JobStageFragment = (
  { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<InterviewPlanPreview_JobStageFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null }
  & GetSaveInterviewPlanInput_InterviewPlanFragment
  & UseIsInterviewPlanValid_JobStageFragment
  & UseSubmitInterviewPlan_InterviewPlanFragment
);

export type SaveInterviewPlanToJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type SaveInterviewPlanToJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult = { __typename?: 'JobStageInterviewPlanResult', jobStage?: SaveInterviewPlanToJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage | null };

export type SaveInterviewPlanToJobStageMutation_Mutation = { __typename?: 'Mutation', jobStageInterviewPlanUpsert?: SaveInterviewPlanToJobStageMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult | null };


export type SaveInterviewPlanToJobStageMutationVariables = Exact<{
  input: JobStageInterviewPlanUpsertInput;
}>;


export type SaveInterviewPlanToJobStageMutation = SaveInterviewPlanToJobStageMutation_Mutation;

export type ScheduleInterviewPlan_JobFragment = { __typename?: 'Job', id: any, atsId: string };

export type ScheduleInterviewPlan_JobStageFragment = (
  { __typename?: 'JobStage', id: any }
  & InterviewPlanPreview_JobStageFragment
  & InterviewPlan_JobStageFragment
);

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition = { __typename?: 'AshbyInterviewDefinition' };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition = { __typename?: 'GemInterviewDefinition' };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition = { __typename?: 'GreenhouseInterviewDefinition', estimatedMinutes: any };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition = { __typename?: 'LeverInterviewDefinition' };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition = { __typename?: 'WorkdayInterviewDefinition' };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields = UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_AshbyInterviewDefinition | UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GemInterviewDefinition | UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_GreenhouseInterviewDefinition | UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_LeverInterviewDefinition | UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields_WorkdayInterviewDefinition;

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition = { __typename?: 'AtsInterviewDefinition', atsId: string, name: string, atsFields?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition_atsFields | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee = { __typename?: 'JobStageInterviewSeatEmployee', jobStageInterviewSeatId: any, employeeId: any, preferenceLevel?: number | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat = { __typename?: 'FreeformSeat', jobStageInterviewSeatEmployees?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat_jobStageInterviewSeatEmployees_JobStageInterviewSeatEmployee> | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember = { __typename?: 'InterviewModuleMember', id: string, employeeId: any, status: TrainingStatus };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput = { __typename?: 'InterviewModuleMembersOutput', items: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput_items_InterviewModuleMember> };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule = { __typename?: 'InterviewModule', id: any, interviewModuleMembers?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule_interviewModuleMembers_InterviewModuleMembersOutput | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig = { __typename?: 'InterviewModuleSeatConfig', selectedEmployeeIds?: Array<any> | null, selectedAttributes?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute> | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute = { __typename?: 'JobStageInterviewSeatAttribute', id: any, attributeNameId?: any | null, attributeTagValueId?: any | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig = { __typename?: 'InterviewModuleSeatConfig', selectedEmployeeIds?: Array<any> | null, selectedAttributes?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig_selectedAttributes_JobStageInterviewSeatAttribute> | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat = { __typename?: 'ModuleSeat', interviewModuleId: any, selectedEmployeeIds: Array<any>, jobStageInterviewSeatAttributes?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_jobStageInterviewSeatAttributes_JobStageInterviewSeatAttribute> | null, interviewModule?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_interviewModule_InterviewModule | null, shadowConfig?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_shadowConfig_InterviewModuleSeatConfig | null, reverseShadowConfig?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat_reverseShadowConfig_InterviewModuleSeatConfig | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat = { __typename?: 'LinkedSeat', linkedJobStageInterviewSeatId: any };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat = { __typename?: 'JobStageInterviewSeat', id: any, freeformSeat?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_freeformSeat_FreeformSeat | null, moduleSeat?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_moduleSeat_ModuleSeat | null, linkedSeat?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat_linkedSeat_LinkedSeat | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, duration?: number | null, forcedStartAt?: string | null, name?: string | null, isLockedOrder: boolean, isHiddenFromCandidate: boolean, atsInterviewDefinition?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null, jobStageInterviewSeats?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview_jobStageInterviewSeats_JobStageInterviewSeat> | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, locked: boolean, jobStageInterviews?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_schedulingWindow_Duration = { __typename?: 'Duration', seconds: any };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_excludedEmployees_Employee = { __typename?: 'Employee', id: any };

export type UseScheduleOptionsRequestBody_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null, schedulingWindow?: UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_schedulingWindow_Duration | null, excludedEmployees?: Array<UseScheduleOptionsRequestBody_InterviewPlanFragment_JobStage_excludedEmployees_Employee> | null };

export type UseSubmitInterviewPlan_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseScheduleOptionsRequestBody_InterviewPlanFragment
);

export type BaseScheduleOptions_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseSubmitInterviewPlan_InterviewPlanFragment
);

export type ScheduleOptions_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & BaseScheduleOptions_InterviewPlanFragment
);

export type GetTextForFlag_CompanyHolidayFragment = { __typename?: 'CompanyHoliday', id: any, name: string, startAt: any };

export type ScheduleFlowApplicationQuery_application_Application_job_Job_jobSettings_JobSettings = (
  { __typename?: 'JobSettings', id: any }
  & ScheduleFlowDataProvider_JobSettingsFragment
);

export type ScheduleFlowApplicationQuery_application_Application_job_Job = (
  { __typename?: 'Job', id: any, name: string, atsId: string, jobSettings: ScheduleFlowApplicationQuery_application_Application_job_Job_jobSettings_JobSettings }
  & ScheduleFlowDataProvider_JobFragment
);

export type ScheduleFlowApplicationQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & ScheduleFlowDataProvider_JobStageSettingsFragment
);

export type ScheduleFlowApplicationQuery_application_Application_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any, name: string, jobStageSettingsV2?: ScheduleFlowApplicationQuery_application_Application_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null }
  & ScheduleFlowDataProvider_InterviewPlanFragment
);

export type ScheduleFlowApplicationQuery_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability = (
  { __typename?: 'CandidateAtsAvailability', timezone?: any | null }
  & UseCandidateAvailability_AtsLatestAvailabilityFragment
);

export type ScheduleFlowApplicationQuery_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any, timezone?: string | null, atsLatestAvailability?: ScheduleFlowApplicationQuery_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability | null }
  & ScheduleFlowDataProvider_CandidateFragment
);

export type ScheduleFlowApplicationQuery_application_Application = { __typename?: 'Application', id: any, job?: ScheduleFlowApplicationQuery_application_Application_job_Job | null, jobStage?: ScheduleFlowApplicationQuery_application_Application_jobStage_JobStage | null, candidate?: ScheduleFlowApplicationQuery_application_Application_candidate_Candidate | null };

export type ScheduleFlowApplicationQuery_Query = { __typename?: 'Query', application?: ScheduleFlowApplicationQuery_application_Application | null };


export type ScheduleFlowApplicationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  fetchInterviewPlan: Scalars['Boolean']['input'];
}>;


export type ScheduleFlowApplicationQuery = ScheduleFlowApplicationQuery_Query;

export type ScheduleFlowJobStageQuery_jobStage_JobStage_job_Job = (
  { __typename?: 'Job', id: any, name: string, atsId: string }
  & ScheduleFlowDataProvider_JobFragment
);

export type ScheduleFlowJobStageQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & ScheduleFlowDataProvider_JobStageSettingsFragment
);

export type ScheduleFlowJobStageQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any, name: string, job?: ScheduleFlowJobStageQuery_jobStage_JobStage_job_Job | null, jobStageSettingsV2?: ScheduleFlowJobStageQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null }
  & ScheduleFlowDataProvider_InterviewPlanFragment
);

export type ScheduleFlowJobStageQuery_Query = { __typename?: 'Query', jobStage?: ScheduleFlowJobStageQuery_jobStage_JobStage | null };


export type ScheduleFlowJobStageQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type ScheduleFlowJobStageQuery = ScheduleFlowJobStageQuery_Query;

export type ScheduleFlowTaskQuery_task_Task_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability = (
  { __typename?: 'CandidateAtsAvailability', timezone?: any | null }
  & UseCandidateAvailability_AtsLatestAvailabilityFragment
);

export type ScheduleFlowTaskQuery_task_Task_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any, timezone?: string | null, atsLatestAvailability?: ScheduleFlowTaskQuery_task_Task_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability | null }
  & ScheduleFlowDataProvider_CandidateFragment
);

export type ScheduleFlowTaskQuery_task_Task_application_Application = { __typename?: 'Application', id: any, candidate?: ScheduleFlowTaskQuery_task_Task_application_Application_candidate_Candidate | null };

export type ScheduleFlowTaskQuery_task_Task_interviewPlan_JobStage = (
  { __typename?: 'JobStage', id: any }
  & ScheduleFlowDataProvider_InterviewPlanFragment
);

export type ScheduleFlowTaskQuery_task_Task_jobStage_JobStage_job_Job_jobSettings_JobSettings = (
  { __typename?: 'JobSettings', id: any }
  & ScheduleFlowDataProvider_JobSettingsFragment
);

export type ScheduleFlowTaskQuery_task_Task_jobStage_JobStage_job_Job = (
  { __typename?: 'Job', id: any, name: string, atsId: string, jobSettings: ScheduleFlowTaskQuery_task_Task_jobStage_JobStage_job_Job_jobSettings_JobSettings }
  & ScheduleFlowDataProvider_JobFragment
);

export type ScheduleFlowTaskQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & ScheduleFlowDataProvider_JobStageSettingsFragment
);

export type ScheduleFlowTaskQuery_task_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: ScheduleFlowTaskQuery_task_Task_jobStage_JobStage_job_Job | null, jobStageSettingsV2?: ScheduleFlowTaskQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ScheduleFlowTaskQuery_task_Task_availabilities_CandidateAvailability = (
  { __typename?: 'CandidateAvailability', id: any }
  & UseCandidateAvailability_AvailabilitiesFragment
);

export type ScheduleFlowTaskQuery_task_Task = (
  { __typename?: 'Task', id: any, application: ScheduleFlowTaskQuery_task_Task_application_Application, interviewPlan: ScheduleFlowTaskQuery_task_Task_interviewPlan_JobStage, jobStage?: ScheduleFlowTaskQuery_task_Task_jobStage_JobStage | null, availabilities: Array<ScheduleFlowTaskQuery_task_Task_availabilities_CandidateAvailability> }
  & ScheduleFlowDataProvider_TaskFragment
);

export type ScheduleFlowTaskQuery_Query = { __typename?: 'Query', task?: ScheduleFlowTaskQuery_task_Task | null };


export type ScheduleFlowTaskQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ScheduleFlowTaskQuery = ScheduleFlowTaskQuery_Query;

export type CandidateAtsLatestAvailabilityQuery_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate' }
  & CandidateAtsLatestAvailabilityFragmentFragment
);

export type CandidateAtsLatestAvailabilityQuery_application_Application_coordinator_Employee = { __typename?: 'Employee', id: any };

export type CandidateAtsLatestAvailabilityQuery_application_Application_recruiter_Employee = { __typename?: 'Employee', id: any };

export type CandidateAtsLatestAvailabilityQuery_application_Application_job_Job_hiringManagers_Employee = { __typename?: 'Employee', id: any };

export type CandidateAtsLatestAvailabilityQuery_application_Application_job_Job = { __typename?: 'Job', hiringManagers?: Array<CandidateAtsLatestAvailabilityQuery_application_Application_job_Job_hiringManagers_Employee> | null };

export type CandidateAtsLatestAvailabilityQuery_application_Application = { __typename?: 'Application', candidate?: CandidateAtsLatestAvailabilityQuery_application_Application_candidate_Candidate | null, coordinator?: CandidateAtsLatestAvailabilityQuery_application_Application_coordinator_Employee | null, recruiter?: CandidateAtsLatestAvailabilityQuery_application_Application_recruiter_Employee | null, job?: CandidateAtsLatestAvailabilityQuery_application_Application_job_Job | null };

export type CandidateAtsLatestAvailabilityQuery_Query = { __typename?: 'Query', application?: CandidateAtsLatestAvailabilityQuery_application_Application | null };


export type CandidateAtsLatestAvailabilityQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
}>;


export type CandidateAtsLatestAvailabilityQuery = CandidateAtsLatestAvailabilityQuery_Query;

export type InitScheduleFlowData_TemplateFragment = { __typename?: 'Template', id: any, name?: string | null, type: TemplateType };

export type InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_candidateConfirmationEmailTemplate_Template = (
  { __typename?: 'Template' }
  & InitScheduleFlowData_TemplateFragment
);

export type InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_candidateConfirmationInviteTemplate_Template = (
  { __typename?: 'Template' }
  & InitScheduleFlowData_TemplateFragment
);

export type InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_interviewerConfirmationInviteTemplate_Template = (
  { __typename?: 'Template' }
  & InitScheduleFlowData_TemplateFragment
);

export type InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_interviewerConversationMessageTemplate_Template = (
  { __typename?: 'Template' }
  & InitScheduleFlowData_TemplateFragment
);

export type InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_candidateCalendar_Calendar = { __typename?: 'Calendar', remoteId?: string | null };

export type InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_interviewerCalendar_Calendar = { __typename?: 'Calendar', remoteId?: string | null };

export type InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult = { __typename?: 'InitScheduleFlowResult', isPrivateCalendarEvents: boolean, candidateConfirmationEmailTemplate?: InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_candidateConfirmationEmailTemplate_Template | null, candidateConfirmationInviteTemplate?: InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_candidateConfirmationInviteTemplate_Template | null, interviewerConfirmationInviteTemplate?: InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_interviewerConfirmationInviteTemplate_Template | null, interviewerConversationMessageTemplate?: InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_interviewerConversationMessageTemplate_Template | null, candidateCalendar?: InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_candidateCalendar_Calendar | null, interviewerCalendar?: InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult_interviewerCalendar_Calendar | null };

export type InitScheduleFlowDataQuery_Query = { __typename?: 'Query', initScheduleFlow?: InitScheduleFlowDataQuery_initScheduleFlow_InitScheduleFlowResult | null };


export type InitScheduleFlowDataQueryVariables = Exact<{
  input: InitScheduleFlowInput;
}>;


export type InitScheduleFlowDataQuery = InitScheduleFlowDataQuery_Query;

export type InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsId: string, atsUrl: string };

export type InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability_intervals_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability = { __typename?: 'CandidateAtsAvailability', jobName?: string | null, jobStageName?: string | null, timezone?: any | null, originalText?: string | null, intervals?: Array<InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability_intervals_DateTimeRangeOutput> | null };

export type InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, timezone?: string | null, email?: string | null, additionalEmails?: Array<string> | null, atsCandidate?: InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate_atsCandidate_AtsCandidate | null, atsLatestAvailability?: InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability | null };

export type InterviewPlanFromTaskQuery_task_Task_application_Application_coordinator_Employee = { __typename?: 'Employee', id: any };

export type InterviewPlanFromTaskQuery_task_Task_application_Application_recruiter_Employee = { __typename?: 'Employee', id: any };

export type InterviewPlanFromTaskQuery_task_Task_application_Application_existingConversations_Conversation = { __typename?: 'Conversation', id: any, remoteId: string, remoteName: string };

export type InterviewPlanFromTaskQuery_task_Task_application_Application = { __typename?: 'Application', id: any, candidate?: InterviewPlanFromTaskQuery_task_Task_application_Application_candidate_Candidate | null, coordinator?: InterviewPlanFromTaskQuery_task_Task_application_Application_coordinator_Employee | null, recruiter?: InterviewPlanFromTaskQuery_task_Task_application_Application_recruiter_Employee | null, existingConversations?: Array<InterviewPlanFromTaskQuery_task_Task_application_Application_existingConversations_Conversation> | null };

export type InterviewPlanFromTaskQuery_task_Task_availabilities_CandidateAvailability = (
  { __typename?: 'CandidateAvailability', id: any, createdAt: any }
  & CandidateAvailabilityFragmentFragment
);

export type InterviewPlanFromTaskQuery_task_Task_jobStage_JobStage_job_Job_hiringManagers_Employee = { __typename?: 'Employee', id: any };

export type InterviewPlanFromTaskQuery_task_Task_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string, isConfidential: boolean, hiringManagers?: Array<InterviewPlanFromTaskQuery_task_Task_jobStage_JobStage_job_Job_hiringManagers_Employee> | null };

export type InterviewPlanFromTaskQuery_task_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: InterviewPlanFromTaskQuery_task_Task_jobStage_JobStage_job_Job | null };

export type InterviewPlanFromTaskQuery_task_Task = { __typename?: 'Task', application: InterviewPlanFromTaskQuery_task_Task_application_Application, availabilities: Array<InterviewPlanFromTaskQuery_task_Task_availabilities_CandidateAvailability>, jobStage?: InterviewPlanFromTaskQuery_task_Task_jobStage_JobStage | null };

export type InterviewPlanFromTaskQuery_Query = { __typename?: 'Query', task?: InterviewPlanFromTaskQuery_task_Task | null };


export type InterviewPlanFromTaskQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type InterviewPlanFromTaskQuery = InterviewPlanFromTaskQuery_Query;

export type UseCandidateAvailability_AtsLatestAvailabilityFragment_CandidateAtsAvailability_intervals_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type UseCandidateAvailability_AtsLatestAvailabilityFragment = { __typename?: 'CandidateAtsAvailability', jobName?: string | null, jobStageName?: string | null, originalText?: string | null, intervals?: Array<UseCandidateAvailability_AtsLatestAvailabilityFragment_CandidateAtsAvailability_intervals_DateTimeRangeOutput> | null };

export type UseCandidateAvailability_AvailabilitiesFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type UseCandidateAvailability_AvailabilitiesFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type UseCandidateAvailability_AvailabilitiesFragment = { __typename?: 'CandidateAvailability', id: any, candidateEnteredAvailability?: Array<UseCandidateAvailability_AvailabilitiesFragment_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null, rcEnteredAvailability?: Array<UseCandidateAvailability_AvailabilitiesFragment_CandidateAvailability_rcEnteredAvailability_DateTimeRangeOutput> | null };

export type CandidateAvailabilitySidebarSection_TaskFragment_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type CandidateAvailabilitySidebarSection_TaskFragment_Task_availabilities_CandidateAvailability = { __typename?: 'CandidateAvailability', candidateEnteredAvailability?: Array<CandidateAvailabilitySidebarSection_TaskFragment_Task_availabilities_CandidateAvailability_candidateEnteredAvailability_DateTimeRangeOutput> | null };

export type CandidateAvailabilitySidebarSection_TaskFragment_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', timezone?: string | null };

export type CandidateAvailabilitySidebarSection_TaskFragment_Task_application_Application = { __typename?: 'Application', candidate?: CandidateAvailabilitySidebarSection_TaskFragment_Task_application_Application_candidate_Candidate | null };

export type CandidateAvailabilitySidebarSection_TaskFragment = { __typename?: 'Task', availabilities: Array<CandidateAvailabilitySidebarSection_TaskFragment_Task_availabilities_CandidateAvailability>, application: CandidateAvailabilitySidebarSection_TaskFragment_Task_application_Application };

export type AvailabilityTaskModal_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, timezone?: string | null };

export type AvailabilityTaskModal_ApplicationFragment_Application_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any };

export type AvailabilityTaskModal_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, job?: AvailabilityTaskModal_ApplicationFragment_Application_jobStage_JobStage_job_Job | null };

export type AvailabilityTaskModal_ApplicationFragment = { __typename?: 'Application', id: any, candidate?: AvailabilityTaskModal_ApplicationFragment_Application_candidate_Candidate | null, jobStage?: AvailabilityTaskModal_ApplicationFragment_Application_jobStage_JobStage | null };

export type AvailabilityOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2' }
  & CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2Fragment
  & GetProvideAvailabilitySettings_JobStageSettingsV2Fragment
);

export type AvailabilityOptionsSettingsQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any, jobStageSettingsV2?: AvailabilityOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null }
  & GetProvideAvailabilitySettings_JobStageFragment
);

export type AvailabilityOptionsSettingsQuery_Query = { __typename?: 'Query', jobStage?: AvailabilityOptionsSettingsQuery_jobStage_JobStage | null };


export type AvailabilityOptionsSettingsQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type AvailabilityOptionsSettingsQuery = AvailabilityOptionsSettingsQuery_Query;

export type BasicTaskModal_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type BasicTaskModal_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, timezone?: string | null };

export type BasicTaskModal_ApplicationFragment = (
  { __typename?: 'Application', id: any, jobStage?: BasicTaskModal_ApplicationFragment_Application_jobStage_JobStage | null, candidate?: BasicTaskModal_ApplicationFragment_Application_candidate_Candidate | null }
  & CreateTaskStep_ApplicationFragment
);

export type BasicTaskModalMutation_taskCreate_TaskCreateResult_task_Task = { __typename?: 'Task', id: any };

export type BasicTaskModalMutation_taskCreate_TaskCreateResult = { __typename?: 'TaskCreateResult', task: BasicTaskModalMutation_taskCreate_TaskCreateResult_task_Task };

export type BasicTaskModalMutation_Mutation = { __typename?: 'Mutation', taskCreate?: BasicTaskModalMutation_taskCreate_TaskCreateResult | null };


export type BasicTaskModalMutationVariables = Exact<{
  input: TaskCreateInput;
}>;


export type BasicTaskModalMutation = BasicTaskModalMutation_Mutation;

export type CreateBasicTaskInterviewPlanQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any }
  & CreateTaskStep_JobStageFragment
  & CloneInterviewPlan_InterviewPlanFragment
  & GetSaveInterviewPlanInput_InterviewPlanFragment
);

export type CreateBasicTaskInterviewPlanQuery_Query = { __typename?: 'Query', jobStage?: CreateBasicTaskInterviewPlanQuery_jobStage_JobStage | null };


export type CreateBasicTaskInterviewPlanQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type CreateBasicTaskInterviewPlanQuery = CreateBasicTaskInterviewPlanQuery_Query;

export type SelfScheduleTaskModal_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, timezone?: string | null };

export type SelfScheduleTaskModal_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type SelfScheduleTaskModal_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any };

export type SelfScheduleTaskModal_ApplicationFragment = { __typename?: 'Application', id: any, candidate?: SelfScheduleTaskModal_ApplicationFragment_Application_candidate_Candidate | null, jobStage?: SelfScheduleTaskModal_ApplicationFragment_Application_jobStage_JobStage | null, job?: SelfScheduleTaskModal_ApplicationFragment_Application_job_Job | null };

export type SelfScheduleOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragment
);

export type SelfScheduleOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: SelfScheduleOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type SelfScheduleOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', interviewMeetingLocationSettingWithLevel?: SelfScheduleOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null }
  & SelfScheduleOptionsModalWrapper_JobStageSettingsV2Fragment
);

export type SelfScheduleOptionsSettingsQuery_jobStage_JobStage = { __typename?: 'JobStage', jobStageSettingsV2?: SelfScheduleOptionsSettingsQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type SelfScheduleOptionsSettingsQuery_Query = { __typename?: 'Query', jobStage?: SelfScheduleOptionsSettingsQuery_jobStage_JobStage | null };


export type SelfScheduleOptionsSettingsQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type SelfScheduleOptionsSettingsQuery = SelfScheduleOptionsSettingsQuery_Query;

export type CreateTaskDialogPage_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any };

export type CreateTaskDialogPage_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, timezone?: string | null };

export type CreateTaskDialogPage_ApplicationFragment = (
  { __typename?: 'Application', id: any, jobStage?: CreateTaskDialogPage_ApplicationFragment_Application_jobStage_JobStage | null, candidate?: CreateTaskDialogPage_ApplicationFragment_Application_candidate_Candidate | null }
  & CreateTaskStep_ApplicationFragment
);

export type CreateTaskDialogPage_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & CreateTaskStep_JobStageFragment
  & CloneInterviewPlan_InterviewPlanFragment
  & UseIsInterviewPlanValid_JobStageFragment
  & UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment
);

export type CreateTaskJobStageSelect_JobFragment_Job_jobStages_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type CreateTaskJobStageSelect_JobFragment = { __typename?: 'Job', id: any, jobStages?: Array<CreateTaskJobStageSelect_JobFragment_Job_jobStages_JobStage> | null };

export type CreateTaskStep_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type CreateTaskStep_ApplicationFragment_Application_job_Job_jobSettings_JobSettings_defaultTaskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any };

export type CreateTaskStep_ApplicationFragment_Application_job_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, defaultTaskQueue?: CreateTaskStep_ApplicationFragment_Application_job_Job_jobSettings_JobSettings_defaultTaskQueue_TaskQueue | null };

export type CreateTaskStep_ApplicationFragment_Application_job_Job = (
  { __typename?: 'Job', id: any, jobSettings: CreateTaskStep_ApplicationFragment_Application_job_Job_jobSettings_JobSettings }
  & InterviewPlan_JobFragment
  & CreateTaskJobStageSelect_JobFragment
);

export type CreateTaskStep_ApplicationFragment_Application_candidate_Candidate = { __typename?: 'Candidate', id: any };

export type CreateTaskStep_ApplicationFragment_Application_coordinator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type CreateTaskStep_ApplicationFragment_Application_recruiter_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type CreateTaskStep_ApplicationFragment_Application_atsApplication_AtsApplication = { __typename?: 'AtsApplication', atsId: string, canMoveJobStage: boolean };

export type CreateTaskStep_ApplicationFragment = { __typename?: 'Application', id: any, jobStage?: CreateTaskStep_ApplicationFragment_Application_jobStage_JobStage | null, job?: CreateTaskStep_ApplicationFragment_Application_job_Job | null, candidate?: CreateTaskStep_ApplicationFragment_Application_candidate_Candidate | null, coordinator?: CreateTaskStep_ApplicationFragment_Application_coordinator_Employee | null, recruiter?: CreateTaskStep_ApplicationFragment_Application_recruiter_Employee | null, atsApplication?: CreateTaskStep_ApplicationFragment_Application_atsApplication_AtsApplication | null };

export type CreateTaskStep_JobStageFragment = (
  { __typename?: 'JobStage', id: any }
  & InterviewPlan_JobStageFragment
  & UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragment
);

export type DefaultTaskAssigneeQuery_application_Application_coordinator_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type DefaultTaskAssigneeQuery_application_Application_recruiter_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type DefaultTaskAssigneeQuery_application_Application = { __typename?: 'Application', coordinator?: DefaultTaskAssigneeQuery_application_Application_coordinator_Employee | null, recruiter?: DefaultTaskAssigneeQuery_application_Application_recruiter_Employee | null };

export type DefaultTaskAssigneeQuery_thisOrg_Org_orgPref_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, stringValue?: string | null };

export type DefaultTaskAssigneeQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPref?: DefaultTaskAssigneeQuery_thisOrg_Org_orgPref_OrgPref | null };

export type DefaultTaskAssigneeQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type DefaultTaskAssigneeQuery_Query = { __typename?: 'Query', application?: DefaultTaskAssigneeQuery_application_Application | null, thisOrg?: DefaultTaskAssigneeQuery_thisOrg_Org | null, thisEmployee?: DefaultTaskAssigneeQuery_thisEmployee_Employee | null };


export type DefaultTaskAssigneeQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
  prefName: Scalars['String']['input'];
}>;


export type DefaultTaskAssigneeQuery = DefaultTaskAssigneeQuery_Query;

export type CoordinatorRecruiterUserInfosQuery_userInfoByEmployeeIds_UserInfo = { __typename?: 'UserInfo', userId: any, employeeId?: any | null, permissions: Array<Permission> };

export type CoordinatorRecruiterUserInfosQuery_Query = { __typename?: 'Query', userInfoByEmployeeIds?: Array<CoordinatorRecruiterUserInfosQuery_userInfoByEmployeeIds_UserInfo> | null };


export type CoordinatorRecruiterUserInfosQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type CoordinatorRecruiterUserInfosQuery = CoordinatorRecruiterUserInfosQuery_Query;

export type MockScheduleTaskDetails_TaskFragment = { __typename?: 'Task', id: any };

export type TaskSetDelegateMutation_taskSetDelegate_Task = { __typename?: 'Task', id: any, delegateType: string };

export type TaskSetDelegateMutation_Mutation = { __typename?: 'Mutation', taskSetDelegate: TaskSetDelegateMutation_taskSetDelegate_Task };


export type TaskSetDelegateMutationVariables = Exact<{
  input: TaskSetDelegateInput;
}>;


export type TaskSetDelegateMutation = TaskSetDelegateMutation_Mutation;

export type TaskSetAssigneeMutation_taskSetAssignee_Task_assignee_Employee = (
  { __typename?: 'Employee' }
  & EmployeeFragment
);

export type TaskSetAssigneeMutation_taskSetAssignee_Task = { __typename?: 'Task', id: any, assignee?: TaskSetAssigneeMutation_taskSetAssignee_Task_assignee_Employee | null };

export type TaskSetAssigneeMutation_Mutation = { __typename?: 'Mutation', taskSetAssignee: TaskSetAssigneeMutation_taskSetAssignee_Task };


export type TaskSetAssigneeMutationVariables = Exact<{
  input: TaskSetAssigneeInput;
}>;


export type TaskSetAssigneeMutation = TaskSetAssigneeMutation_Mutation;

export type ScheduleTaskAssignee_TaskFragment_Task_assignee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type ScheduleTaskAssignee_TaskFragment = { __typename?: 'Task', id: any, assignee?: ScheduleTaskAssignee_TaskFragment_Task_assignee_Employee | null };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateDeclined_Fragment = { __typename?: 'TaskFlagCandidateDeclined', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateTentative_Fragment = { __typename?: 'TaskFlagCandidateTentative', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment = { __typename?: 'TaskFlagDebriefAttendeeDeactivated', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment = { __typename?: 'TaskFlagDebriefAttendeeTentative', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeactivated_Fragment = { __typename?: 'TaskFlagInterviewerDeactivated', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment = { __typename?: 'TaskFlagInterviewerDebriefDeclined', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeclined_Fragment = { __typename?: 'TaskFlagInterviewerDeclined', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerTentative_Fragment = { __typename?: 'TaskFlagInterviewerTentative', id: any, flagType: TaskFlagType };

type ScheduleTaskFlagCompact_TaskFlag_TaskFlagRequestedChange_Fragment = { __typename?: 'TaskFlagRequestedChange', id: any, flagType: TaskFlagType };

export type ScheduleTaskFlagCompact_TaskFlagFragment = ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateDeclined_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateTentative_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeactivated_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeclined_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerTentative_Fragment | ScheduleTaskFlagCompact_TaskFlag_TaskFlagRequestedChange_Fragment;

export type ScheduleTaskTagCompact_TaskTagFragment = { __typename?: 'TaskTag', id: any, name: string };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_declinedCandidateEvent_ApplicationStageCandidateEvent = { __typename?: 'ApplicationStageCandidateEvent', id: any, name?: string | null };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee = (
  { __typename?: 'Employee' }
  & EmployeeFragment
);

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee = (
  { __typename?: 'Employee' }
  & EmployeeFragment
);

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateTentative_tentativeCandidateEvent_ApplicationStageCandidateEvent = { __typename?: 'ApplicationStageCandidateEvent', id: any, name?: string | null };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagDebriefAttendeeDeactivated_deactivatedDebrief_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any, name?: string | null };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagDebriefAttendeeTentative_tentativeDebrief_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any, name?: string | null };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerDeactivated_deactivatedInterview_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, name?: string | null };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerDebriefDeclined_declinedDebrief_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any, name?: string | null };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerDeclined_declinedInterview_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, name?: string | null };

export type ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerTentative_tentativeInterview_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, name?: string | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagCandidateDeclined_Fragment = { __typename: 'TaskFlagCandidateDeclined', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, declinedCandidateEvent: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_declinedCandidateEvent_ApplicationStageCandidateEvent, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagCandidateTentative_Fragment = { __typename: 'TaskFlagCandidateTentative', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, tentativeCandidateEvent: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateTentative_tentativeCandidateEvent_ApplicationStageCandidateEvent, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment = { __typename: 'TaskFlagDebriefAttendeeDeactivated', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, deactivatedDebrief: ScheduleTaskFlags_TaskFlagFragment_TaskFlagDebriefAttendeeDeactivated_deactivatedDebrief_ApplicationDebrief, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment = { __typename: 'TaskFlagDebriefAttendeeTentative', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, tentativeDebrief: ScheduleTaskFlags_TaskFlagFragment_TaskFlagDebriefAttendeeTentative_tentativeDebrief_ApplicationDebrief, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeactivated_Fragment = { __typename: 'TaskFlagInterviewerDeactivated', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, deactivatedInterview: ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerDeactivated_deactivatedInterview_ApplicationStageInterview, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment = { __typename: 'TaskFlagInterviewerDebriefDeclined', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, declinedDebrief: ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerDebriefDeclined_declinedDebrief_ApplicationDebrief, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeclined_Fragment = { __typename: 'TaskFlagInterviewerDeclined', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, declinedInterview: ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerDeclined_declinedInterview_ApplicationStageInterview, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerTentative_Fragment = { __typename: 'TaskFlagInterviewerTentative', id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, tentativeInterview: ScheduleTaskFlags_TaskFlagFragment_TaskFlagInterviewerTentative_tentativeInterview_ApplicationStageInterview, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

type ScheduleTaskFlags_TaskFlag_TaskFlagRequestedChange_Fragment = { __typename: 'TaskFlagRequestedChange', note?: string | null, id: any, createdAt: any, flagType: TaskFlagType, actorType: TaskFlagActorType, resolvedAt?: any | null, actorEmployee?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_actorEmployee_Employee | null, resolvedBy?: ScheduleTaskFlags_TaskFlagFragment_TaskFlagCandidateDeclined_resolvedBy_Employee | null };

export type ScheduleTaskFlags_TaskFlagFragment = ScheduleTaskFlags_TaskFlag_TaskFlagCandidateDeclined_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagCandidateTentative_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeactivated_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeclined_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerTentative_Fragment | ScheduleTaskFlags_TaskFlag_TaskFlagRequestedChange_Fragment;

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagCandidateDeclined = (
  { __typename?: 'TaskFlagCandidateDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagCandidateDeclined_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagCandidateTentative = (
  { __typename?: 'TaskFlagCandidateTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagCandidateTentative_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagDebriefAttendeeDeactivated = (
  { __typename?: 'TaskFlagDebriefAttendeeDeactivated' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagDebriefAttendeeTentative = (
  { __typename?: 'TaskFlagDebriefAttendeeTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerDeactivated = (
  { __typename?: 'TaskFlagInterviewerDeactivated' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeactivated_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerDebriefDeclined = (
  { __typename?: 'TaskFlagInterviewerDebriefDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerDeclined = (
  { __typename?: 'TaskFlagInterviewerDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeclined_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerTentative = (
  { __typename?: 'TaskFlagInterviewerTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerTentative_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagRequestedChange = (
  { __typename?: 'TaskFlagRequestedChange' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagRequestedChange_Fragment
);

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag = TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagCandidateDeclined | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagCandidateTentative | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagDebriefAttendeeDeactivated | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagDebriefAttendeeTentative | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerDeactivated | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerDebriefDeclined | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerDeclined | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagInterviewerTentative | TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag_TaskFlagRequestedChange;

export type TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult = { __typename?: 'TaskFlagMarkResolvedResult', taskFlag: TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult_taskFlag };

export type TaskFlagMarkResolvedMutation_Mutation = { __typename?: 'Mutation', taskFlagMarkResolved: TaskFlagMarkResolvedMutation_taskFlagMarkResolved_TaskFlagMarkResolvedResult };


export type TaskFlagMarkResolvedMutationVariables = Exact<{
  input: TaskFlagMarkResolvedInput;
}>;


export type TaskFlagMarkResolvedMutation = TaskFlagMarkResolvedMutation_Mutation;

export type ScheduleTaskStatusSubText_TaskFragment_Task_availabilityRequests_CandidateAvailabilityOptions = { __typename?: 'CandidateAvailabilityOptions', id: any, createdAt: any };

export type ScheduleTaskStatusSubText_TaskFragment_Task_selfScheduleRequests_SelfScheduleOptions = { __typename?: 'SelfScheduleOptions', id: any, createdAt?: any | null, creatorEmployeeId?: any | null };

export type ScheduleTaskStatusSubText_TaskFragment = { __typename?: 'Task', id: any, status: TaskStatus, availabilityRequests: Array<ScheduleTaskStatusSubText_TaskFragment_Task_availabilityRequests_CandidateAvailabilityOptions>, selfScheduleRequests: Array<ScheduleTaskStatusSubText_TaskFragment_Task_selfScheduleRequests_SelfScheduleOptions> };

export type ScheduleTaskDetails_TaskFragment_Task_application_Application_job_Job_jobSettings_JobSettings_defaultTaskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any };

export type ScheduleTaskDetails_TaskFragment_Task_application_Application_job_Job_jobSettings_JobSettings = { __typename?: 'JobSettings', id: any, defaultTaskQueue?: ScheduleTaskDetails_TaskFragment_Task_application_Application_job_Job_jobSettings_JobSettings_defaultTaskQueue_TaskQueue | null };

export type ScheduleTaskDetails_TaskFragment_Task_application_Application_job_Job = { __typename?: 'Job', id: any, name: string, jobSettings: ScheduleTaskDetails_TaskFragment_Task_application_Application_job_Job_jobSettings_JobSettings };

export type ScheduleTaskDetails_TaskFragment_Task_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any, fullName?: string | null }
  & Candidate_CandidateFragment
);

export type ScheduleTaskDetails_TaskFragment_Task_application_Application = { __typename?: 'Application', id: any, status: ApplicationStatus, job?: ScheduleTaskDetails_TaskFragment_Task_application_Application_job_Job | null, candidate?: ScheduleTaskDetails_TaskFragment_Task_application_Application_candidate_Candidate | null };

export type ScheduleTaskDetails_TaskFragment_Task_taskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any };

export type ScheduleTaskDetails_TaskFragment_Task_createdBy_Employee = (
  { __typename?: 'Employee' }
  & EmployeeFragment
);

export type ScheduleTaskDetails_TaskFragment_Task_jobStage_JobStage_job_Job_atsJob_AtsJob = { __typename?: 'AtsJob', atsCustomerFriendlyId?: string | null };

export type ScheduleTaskDetails_TaskFragment_Task_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string, location?: Array<string> | null, atsJob?: ScheduleTaskDetails_TaskFragment_Task_jobStage_JobStage_job_Job_atsJob_AtsJob | null };

export type ScheduleTaskDetails_TaskFragment_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: ScheduleTaskDetails_TaskFragment_Task_jobStage_JobStage_job_Job | null };

export type ScheduleTaskDetails_TaskFragment_Task_tags_TaskTag = (
  { __typename?: 'TaskTag' }
  & TaskTags_SelectedTaskTagFragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagCandidateDeclined = (
  { __typename?: 'TaskFlagCandidateDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagCandidateDeclined_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagCandidateTentative = (
  { __typename?: 'TaskFlagCandidateTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagCandidateTentative_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated = (
  { __typename?: 'TaskFlagDebriefAttendeeDeactivated' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative = (
  { __typename?: 'TaskFlagDebriefAttendeeTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated = (
  { __typename?: 'TaskFlagInterviewerDeactivated' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeactivated_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined = (
  { __typename?: 'TaskFlagInterviewerDebriefDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerDeclined = (
  { __typename?: 'TaskFlagInterviewerDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeclined_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerTentative = (
  { __typename?: 'TaskFlagInterviewerTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerTentative_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagRequestedChange = (
  { __typename?: 'TaskFlagRequestedChange' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagRequestedChange_Fragment
);

export type ScheduleTaskDetails_TaskFragment_Task_flags = ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagCandidateDeclined | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagCandidateTentative | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerDeclined | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagInterviewerTentative | ScheduleTaskDetails_TaskFragment_Task_flags_TaskFlagRequestedChange;

export type ScheduleTaskDetails_TaskFragment = (
  { __typename?: 'Task', id: any, delegateType: string, delegateStatus: string, isUrgent: boolean, name: string, status: TaskStatus, createdAt: any, application: ScheduleTaskDetails_TaskFragment_Task_application_Application, taskQueue?: ScheduleTaskDetails_TaskFragment_Task_taskQueue_TaskQueue | null, createdBy: ScheduleTaskDetails_TaskFragment_Task_createdBy_Employee, jobStage?: ScheduleTaskDetails_TaskFragment_Task_jobStage_JobStage | null, tags: Array<ScheduleTaskDetails_TaskFragment_Task_tags_TaskTag>, flags: Array<ScheduleTaskDetails_TaskFragment_Task_flags> }
  & TaskName_TaskFragment
  & ScheduleTaskAssignee_TaskFragment
  & ScheduleTaskStatusSubText_TaskFragment
  & ApplicationConflict_TaskFragment
);

export type TaskSetTagsMutation_taskSetTags_Task_tags_TaskTag = (
  { __typename?: 'TaskTag' }
  & TaskTags_SelectedTaskTagFragment
);

export type TaskSetTagsMutation_taskSetTags_Task = { __typename?: 'Task', id: any, tags: Array<TaskSetTagsMutation_taskSetTags_Task_tags_TaskTag> };

export type TaskSetTagsMutation_Mutation = { __typename?: 'Mutation', taskSetTags: TaskSetTagsMutation_taskSetTags_Task };


export type TaskSetTagsMutationVariables = Exact<{
  input: TaskSetTagsInput;
}>;


export type TaskSetTagsMutation = TaskSetTagsMutation_Mutation;

export type TaskUpdateQueueMutation_taskUpdate_Task_taskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any };

export type TaskUpdateQueueMutation_taskUpdate_Task = { __typename?: 'Task', id: any, taskQueue?: TaskUpdateQueueMutation_taskUpdate_Task_taskQueue_TaskQueue | null };

export type TaskUpdateQueueMutation_Mutation = { __typename?: 'Mutation', taskUpdate: TaskUpdateQueueMutation_taskUpdate_Task };


export type TaskUpdateQueueMutationVariables = Exact<{
  input: TaskUpdateInput;
}>;


export type TaskUpdateQueueMutation = TaskUpdateQueueMutation_Mutation;

export type Availability_ApplicationFragment_Application_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any };

export type Availability_ApplicationFragment_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, job?: Availability_ApplicationFragment_Application_jobStage_JobStage_job_Job | null };

export type Availability_ApplicationFragment = (
  { __typename?: 'Application', id: any, jobStage?: Availability_ApplicationFragment_Application_jobStage_JobStage | null }
  & BaseCandidateAvailabilitySection_ApplicationFragment
);

export type Availability_AvailabilityFragment = (
  { __typename?: 'CandidateAvailability' }
  & CandidateAvailabilityFragmentFragment
  & BaseCandidateAvailabilitySection_AvailabilityFragment
);

export type Availability_AvailabilityRequestFragment_CandidateAvailabilityOptions_creator_Employee = { __typename?: 'Employee', fullName?: string | null };

export type Availability_AvailabilityRequestFragment = (
  { __typename?: 'CandidateAvailabilityOptions', id: any, applicationId: any, availabilityEndDate?: any | null, availabilityStartDate?: any | null, candidateNote?: string | null, externalId: string, createdAt: any, jobStageId: any, minimumTimeBlockMinutes: any, minutesPerDays: any, numberOfDays: any, timezone: string, updatedAt: any, lastCandidateCommunicationSentAt?: any | null, advanceNoticeMinutes?: any | null, shouldRespectLoadLimit: boolean, bookIfPerfectScheduleFound: boolean, suggestOverRecruitingKeywords: boolean, suggestOverAvailableKeywords: boolean, suggestOverFreeTime: boolean, rollingDays: any, inclusionDays: Array<string>, creator?: Availability_AvailabilityRequestFragment_CandidateAvailabilityOptions_creator_Employee | null }
  & BaseCandidateAvailabilitySection_AvailabilityRequestFragment
);

export type Availability_CandidateFragment = { __typename?: 'Candidate', id: any, timezone?: string | null, atsType?: AtsType | null };

export type Availability_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2' }
  & GetProvideAvailabilitySettings_JobStageSettingsV2Fragment
  & BaseCandidateAvailabilitySection_JobStageSettingsV2Fragment
);

export type Availability_JobStageFragment = { __typename?: 'JobStage', id: any, name: string, jobStageSettingsV2?: Availability_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type Availability_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = { __typename?: 'JobStageInterview', id: any, interviewType: InterviewType, duration?: number | null };

export type Availability_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<Availability_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type Availability_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<Availability_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null }
  & GetProvideAvailabilitySettings_JobStageFragment
);

export type Availability_ScheduleFragment = { __typename?: 'ApplicationStage', id: any, createdAt: any };

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagCandidateDeclined = (
  { __typename?: 'TaskFlagCandidateDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagCandidateDeclined_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagCandidateTentative = (
  { __typename?: 'TaskFlagCandidateTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagCandidateTentative_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagDebriefAttendeeDeactivated = (
  { __typename?: 'TaskFlagDebriefAttendeeDeactivated' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagDebriefAttendeeTentative = (
  { __typename?: 'TaskFlagDebriefAttendeeTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerDeactivated = (
  { __typename?: 'TaskFlagInterviewerDeactivated' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeactivated_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerDebriefDeclined = (
  { __typename?: 'TaskFlagInterviewerDebriefDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerDeclined = (
  { __typename?: 'TaskFlagInterviewerDeclined' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerDeclined_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerTentative = (
  { __typename?: 'TaskFlagInterviewerTentative' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagInterviewerTentative_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagRequestedChange = (
  { __typename?: 'TaskFlagRequestedChange' }
  & ScheduleTaskFlags_TaskFlag_TaskFlagRequestedChange_Fragment
);

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags = TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagCandidateDeclined | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagCandidateTentative | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagDebriefAttendeeDeactivated | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagDebriefAttendeeTentative | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerDeactivated | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerDebriefDeclined | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerDeclined | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagInterviewerTentative | TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags_TaskFlagRequestedChange;

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task = { __typename?: 'Task', id: any, flags: Array<TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task_flags> };

export type TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult = { __typename?: 'TaskRequestChangeResult', task: TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult_task_Task };

export type TaskRequestChangeMutation_Mutation = { __typename?: 'Mutation', taskRequestChange: TaskRequestChangeMutation_taskRequestChange_TaskRequestChangeResult };


export type TaskRequestChangeMutationVariables = Exact<{
  input: TaskRequestChangeInput;
}>;


export type TaskRequestChangeMutation = TaskRequestChangeMutation_Mutation;

export type TaskSetDebriefRequiredMutation_taskSetDebriefRequired_Task = { __typename?: 'Task', id: any, isDebriefRequired: boolean };

export type TaskSetDebriefRequiredMutation_Mutation = { __typename?: 'Mutation', taskSetDebriefRequired: TaskSetDebriefRequiredMutation_taskSetDebriefRequired_Task };


export type TaskSetDebriefRequiredMutationVariables = Exact<{
  input: TaskSetDebriefRequiredInput;
}>;


export type TaskSetDebriefRequiredMutation = TaskSetDebriefRequiredMutation_Mutation;

export type Debrief_DebriefRequirementsFragment_Task_application_Application = { __typename?: 'Application', id: any };

export type Debrief_DebriefRequirementsFragment_Task_debriefs_ApplicationDebrief = (
  { __typename?: 'ApplicationDebrief', id: any, createdAt?: any | null }
  & DebriefContentEntity_DebriefFragment
);

export type Debrief_DebriefRequirementsFragment = { __typename?: 'Task', id: any, isDebriefRequired: boolean, application: Debrief_DebriefRequirementsFragment_Task_application_Application, debriefs: Array<Debrief_DebriefRequirementsFragment_Task_debriefs_ApplicationDebrief> };

export type RescheduleLogModal_RescheduleLogFragment_RescheduleLog_lastUpdatedBy_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type RescheduleLogModal_RescheduleLogFragment_RescheduleLog_rescheduleReason_RescheduleReason = { __typename?: 'RescheduleReason', reason: string };

export type RescheduleLogModal_RescheduleLogFragment_RescheduleLog_performedBy_Employee = { __typename?: 'Employee', id: any, fullName?: string | null };

export type RescheduleLogModal_RescheduleLogFragment = { __typename?: 'RescheduleLog', id: any, note?: string | null, rescheduledAt: any, createdAt: any, updatedAt: any, rescheduleReasonId: any, lastUpdatedBy?: RescheduleLogModal_RescheduleLogFragment_RescheduleLog_lastUpdatedBy_Employee | null, rescheduleReason?: RescheduleLogModal_RescheduleLogFragment_RescheduleLog_rescheduleReason_RescheduleReason | null, performedBy?: RescheduleLogModal_RescheduleLogFragment_RescheduleLog_performedBy_Employee | null };

export type RescheduleLogCreateMutation_rescheduleLogCreate_RescheduleLogResult_rescheduleLog_RescheduleLog = (
  { __typename?: 'RescheduleLog' }
  & RescheduleLogModal_RescheduleLogFragment
);

export type RescheduleLogCreateMutation_rescheduleLogCreate_RescheduleLogResult = { __typename?: 'RescheduleLogResult', rescheduleLog?: RescheduleLogCreateMutation_rescheduleLogCreate_RescheduleLogResult_rescheduleLog_RescheduleLog | null };

export type RescheduleLogCreateMutation_Mutation = { __typename?: 'Mutation', rescheduleLogCreate?: RescheduleLogCreateMutation_rescheduleLogCreate_RescheduleLogResult | null };


export type RescheduleLogCreateMutationVariables = Exact<{
  input: RescheduleLogCreateInput;
}>;


export type RescheduleLogCreateMutation = RescheduleLogCreateMutation_Mutation;

export type RescheduleLogUpdateMutation_rescheduleLogUpdate_RescheduleLogResult_rescheduleLog_RescheduleLog = (
  { __typename?: 'RescheduleLog' }
  & RescheduleLogModal_RescheduleLogFragment
);

export type RescheduleLogUpdateMutation_rescheduleLogUpdate_RescheduleLogResult = { __typename?: 'RescheduleLogResult', rescheduleLog?: RescheduleLogUpdateMutation_rescheduleLogUpdate_RescheduleLogResult_rescheduleLog_RescheduleLog | null };

export type RescheduleLogUpdateMutation_Mutation = { __typename?: 'Mutation', rescheduleLogUpdate?: RescheduleLogUpdateMutation_rescheduleLogUpdate_RescheduleLogResult | null };


export type RescheduleLogUpdateMutationVariables = Exact<{
  input: RescheduleLogUpdateInput;
}>;


export type RescheduleLogUpdateMutation = RescheduleLogUpdateMutation_Mutation;

export type RescheduleLogsList_RescheduleLogsFragment = (
  { __typename?: 'RescheduleLog', id: any }
  & RescheduleLogModal_RescheduleLogFragment
);

export type RescheduleLogDeleteMutation_rescheduleLogDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type RescheduleLogDeleteMutation_Mutation = { __typename?: 'Mutation', rescheduleLogDelete?: RescheduleLogDeleteMutation_rescheduleLogDelete_EmptyResult | null };


export type RescheduleLogDeleteMutationVariables = Exact<{
  input: RescheduleLogDeleteInput;
}>;


export type RescheduleLogDeleteMutation = RescheduleLogDeleteMutation_Mutation;

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCandidatePhone = { __typename?: 'TaskMeetingLocationCandidatePhone', kind: 'TaskMeetingLocationCandidatePhone' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCustomLink = { __typename?: 'TaskMeetingLocationCustomLink', value: string, kind: 'TaskMeetingLocationCustomLink' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCustomPhone = { __typename?: 'TaskMeetingLocationCustomPhone', value: string, kind: 'TaskMeetingLocationCustomPhone' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCustomText = { __typename?: 'TaskMeetingLocationCustomText', value: string, kind: 'TaskMeetingLocationCustomText' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationGoogleMeet = { __typename?: 'TaskMeetingLocationGoogleMeet', hostType: MeetingLocationHostType, hostEmployeeId?: any | null, kind: 'TaskMeetingLocationGoogleMeet' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationMicrosoftTeams = { __typename?: 'TaskMeetingLocationMicrosoftTeams', hostType: MeetingLocationHostType, hostEmployeeId?: any | null, kind: 'TaskMeetingLocationMicrosoftTeams' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationNone = { __typename?: 'TaskMeetingLocationNone', kind: 'TaskMeetingLocationNone' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationZoom = { __typename?: 'TaskMeetingLocationZoom', hostType: MeetingLocationHostType, hostEmployeeId?: any | null, remoteVideoMeetingHostUserId?: string | null, kind: 'TaskMeetingLocationZoom' };

export type TaskMeetingLocationQuery_task_Task_meetingLocationSetting = TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCandidatePhone | TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCustomLink | TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCustomPhone | TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationCustomText | TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationGoogleMeet | TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationMicrosoftTeams | TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationNone | TaskMeetingLocationQuery_task_Task_meetingLocationSetting_TaskMeetingLocationZoom;

export type TaskMeetingLocationQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragment
  & InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment
);

export type TaskMeetingLocationQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: TaskMeetingLocationQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type TaskMeetingLocationQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', interviewMeetingLocationSettingWithLevel?: TaskMeetingLocationQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null };

export type TaskMeetingLocationQuery_task_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: TaskMeetingLocationQuery_task_Task_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type TaskMeetingLocationQuery_task_Task = { __typename?: 'Task', id: any, meetingLocationSetting?: TaskMeetingLocationQuery_task_Task_meetingLocationSetting | null, jobStage?: TaskMeetingLocationQuery_task_Task_jobStage_JobStage | null };

export type TaskMeetingLocationQuery_Query = { __typename?: 'Query', task?: TaskMeetingLocationQuery_task_Task | null };


export type TaskMeetingLocationQueryVariables = Exact<{
  taskId: Scalars['uuid']['input'];
}>;


export type TaskMeetingLocationQuery = TaskMeetingLocationQuery_Query;

export type TaskUpdateMeetingLocationMutation_taskUpdate_Task = { __typename?: 'Task', id: any };

export type TaskUpdateMeetingLocationMutation_Mutation = { __typename?: 'Mutation', taskUpdate: TaskUpdateMeetingLocationMutation_taskUpdate_Task };


export type TaskUpdateMeetingLocationMutationVariables = Exact<{
  input: TaskUpdateInput;
}>;


export type TaskUpdateMeetingLocationMutation = TaskUpdateMeetingLocationMutation_Mutation;

export type Schedule_ApplicationFragment_Application_atsApplication_AtsApplication_atsFields_AshbyApplication = { __typename: 'AshbyApplication' };

export type Schedule_ApplicationFragment_Application_atsApplication_AtsApplication_atsFields_WorkdayApplication = { __typename: 'WorkdayApplication', currentStepName?: string | null };

export type Schedule_ApplicationFragment_Application_atsApplication_AtsApplication_atsFields = Schedule_ApplicationFragment_Application_atsApplication_AtsApplication_atsFields_AshbyApplication | Schedule_ApplicationFragment_Application_atsApplication_AtsApplication_atsFields_WorkdayApplication;

export type Schedule_ApplicationFragment_Application_atsApplication_AtsApplication = { __typename?: 'AtsApplication', atsId: string, atsFields?: Schedule_ApplicationFragment_Application_atsApplication_AtsApplication_atsFields | null };

export type Schedule_ApplicationFragment_Application_job_Job = { __typename?: 'Job', id: any };

export type Schedule_ApplicationFragment = (
  { __typename?: 'Application', id: any, status: ApplicationStatus, atsType?: AtsType | null, atsApplication?: Schedule_ApplicationFragment_Application_atsApplication_AtsApplication | null, job?: Schedule_ApplicationFragment_Application_job_Job | null }
  & ScheduleContent_ApplicationFragment
  & UseApplicationJobStageSchedulable_ApplicationFragment
);

export type Schedule_CandidateFragment = { __typename?: 'Candidate', id: any };

export type Schedule_InterviewPlanFragment_JobStage_job_Job = (
  { __typename?: 'Job', id: any }
  & InterviewPlan_JobFragment
);

export type Schedule_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = (
  { __typename?: 'JobStageInterview', id: any }
  & UseGetInterviewNames_InterviewsFragment
);

export type Schedule_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<Schedule_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type Schedule_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any, job?: Schedule_InterviewPlanFragment_JobStage_job_Job | null, jobStageInterviewGroups?: Array<Schedule_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null }
  & InterviewPlan_JobStageFragment
  & GetSaveInterviewPlanInput_InterviewPlanFragment
  & UseIsInterviewPlanValid_JobStageFragment
);

export type Schedule_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragment
);

export type Schedule_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: Schedule_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type Schedule_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', interviewMeetingLocationSettingWithLevel?: Schedule_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null }
  & SelfScheduleOptionsModalWrapper_JobStageSettingsV2Fragment
  & SelfSchedule_JobStageSettingsFragment
);

export type Schedule_JobStageFragment = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: Schedule_JobStageFragment_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type Schedule_SelfScheduleRequestFragment_SelfScheduleOptions_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragment
);

export type Schedule_SelfScheduleRequestFragment = (
  { __typename?: 'SelfScheduleOptions', interviewMeetingLocationSetting?: Schedule_SelfScheduleRequestFragment_SelfScheduleOptions_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null }
  & SelfScheduleOptionsModalWrapper_SelfScheduleFragment
);

export type Schedule_ScheduleFragment = (
  { __typename?: 'ApplicationStage' }
  & ScheduleContent_ScheduleFragment
);

export type ScheduleTaskInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any }
  & InterviewPlan_JobStageFragment
  & GetSaveInterviewPlanInput_InterviewPlanFragment
);

export type ScheduleTaskInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult = { __typename?: 'JobStageInterviewPlanResult', jobStage?: ScheduleTaskInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult_jobStage_JobStage | null };

export type ScheduleTaskInterviewPlanUpsertMutation_Mutation = { __typename?: 'Mutation', jobStageInterviewPlanUpsert?: ScheduleTaskInterviewPlanUpsertMutation_jobStageInterviewPlanUpsert_JobStageInterviewPlanResult | null };


export type ScheduleTaskInterviewPlanUpsertMutationVariables = Exact<{
  input: JobStageInterviewPlanUpsertInput;
}>;


export type ScheduleTaskInterviewPlanUpsertMutation = ScheduleTaskInterviewPlanUpsertMutation_Mutation;

export type UseGetInterviewNames_InterviewsFragment = { __typename?: 'JobStageInterview', id: any, name?: string | null, interviewType: InterviewType };

export type ScheduleTaskRequirementsQuery_task_Task_rescheduleLogs_RescheduleLogsResult_items_RescheduleLog = (
  { __typename?: 'RescheduleLog' }
  & RescheduleLogsList_RescheduleLogsFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_rescheduleLogs_RescheduleLogsResult = { __typename?: 'RescheduleLogsResult', items: Array<ScheduleTaskRequirementsQuery_task_Task_rescheduleLogs_RescheduleLogsResult_items_RescheduleLog> };

export type ScheduleTaskRequirementsQuery_task_Task_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate' }
  & Schedule_CandidateFragment
  & Availability_CandidateFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_application_Application = (
  { __typename?: 'Application', candidate?: ScheduleTaskRequirementsQuery_task_Task_application_Application_candidate_Candidate | null }
  & Availability_ApplicationFragment
  & Schedule_ApplicationFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_availabilities_CandidateAvailability = (
  { __typename?: 'CandidateAvailability', id: any, createdAt: any }
  & Availability_AvailabilityFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_availabilityRequests_CandidateAvailabilityOptions = (
  { __typename?: 'CandidateAvailabilityOptions', id: any, createdAt: any }
  & Availability_AvailabilityRequestFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_interviewPlan_JobStage = (
  { __typename?: 'JobStage' }
  & Availability_InterviewPlanFragment
  & Schedule_InterviewPlanFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_jobStage_JobStage = (
  { __typename?: 'JobStage' }
  & Availability_JobStageFragment
  & Schedule_JobStageFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_selfScheduleRequests_SelfScheduleOptions = (
  { __typename?: 'SelfScheduleOptions', id: any, createdAt?: any | null }
  & Schedule_SelfScheduleRequestFragment
);

export type ScheduleTaskRequirementsQuery_task_Task_schedules_ApplicationStage = (
  { __typename?: 'ApplicationStage', id: any, createdAt: any, updatedAt: any }
  & Availability_ScheduleFragment
  & Schedule_ScheduleFragment
);

export type ScheduleTaskRequirementsQuery_task_Task = (
  { __typename?: 'Task', id: any, status: TaskStatus, rescheduleLogs: ScheduleTaskRequirementsQuery_task_Task_rescheduleLogs_RescheduleLogsResult, application: ScheduleTaskRequirementsQuery_task_Task_application_Application, availabilities: Array<ScheduleTaskRequirementsQuery_task_Task_availabilities_CandidateAvailability>, availabilityRequests: Array<ScheduleTaskRequirementsQuery_task_Task_availabilityRequests_CandidateAvailabilityOptions>, interviewPlan: ScheduleTaskRequirementsQuery_task_Task_interviewPlan_JobStage, jobStage?: ScheduleTaskRequirementsQuery_task_Task_jobStage_JobStage | null, selfScheduleRequests: Array<ScheduleTaskRequirementsQuery_task_Task_selfScheduleRequests_SelfScheduleOptions>, schedules: Array<ScheduleTaskRequirementsQuery_task_Task_schedules_ApplicationStage> }
  & Debrief_DebriefRequirementsFragment
);

export type ScheduleTaskRequirementsQuery_Query = { __typename?: 'Query', task?: ScheduleTaskRequirementsQuery_task_Task | null };


export type ScheduleTaskRequirementsQueryVariables = Exact<{
  scheduleTaskId: Scalars['uuid']['input'];
}>;


export type ScheduleTaskRequirementsQuery = ScheduleTaskRequirementsQuery_Query;

export type ScheduleTask_TaskFragment_Task_application_Application = { __typename?: 'Application', id: any };

export type ScheduleTask_TaskFragment = (
  { __typename?: 'Task', status: TaskStatus, delegateType: string, delegateStatus: string, application: ScheduleTask_TaskFragment_Task_application_Application }
  & ScheduleTaskDetails_TaskFragment
  & CandidateAvailabilitySidebarSection_TaskFragment
);

export type TaskDashboardTable_TaskFragment = (
  { __typename?: 'Task', id: any }
  & TaskDashboardTableRowItem_TaskFragment
);

export type ScheduleDateCell_SchedulesFragment = { __typename?: 'ApplicationStage', id: any, createdAt: any, startAt?: any | null, endAt?: any | null };

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagCandidateDeclined_Fragment = (
  { __typename?: 'TaskFlagCandidateDeclined', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateDeclined_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagCandidateTentative_Fragment = (
  { __typename?: 'TaskFlagCandidateTentative', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagCandidateTentative_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagDebriefAttendeeDeactivated_Fragment = (
  { __typename?: 'TaskFlagDebriefAttendeeDeactivated', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeDeactivated_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagDebriefAttendeeTentative_Fragment = (
  { __typename?: 'TaskFlagDebriefAttendeeTentative', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagDebriefAttendeeTentative_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDeactivated_Fragment = (
  { __typename?: 'TaskFlagInterviewerDeactivated', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeactivated_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDebriefDeclined_Fragment = (
  { __typename?: 'TaskFlagInterviewerDebriefDeclined', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDebriefDeclined_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDeclined_Fragment = (
  { __typename?: 'TaskFlagInterviewerDeclined', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerDeclined_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerTentative_Fragment = (
  { __typename?: 'TaskFlagInterviewerTentative', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagInterviewerTentative_Fragment
);

type ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagRequestedChange_Fragment = (
  { __typename?: 'TaskFlagRequestedChange', id: any, resolvedAt?: any | null }
  & ScheduleTaskFlagCompact_TaskFlag_TaskFlagRequestedChange_Fragment
);

export type ScheduleTaskDashboardTaskFlags_TaskFlagsFragment = ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagCandidateDeclined_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagCandidateTentative_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagDebriefAttendeeDeactivated_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagDebriefAttendeeTentative_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDeactivated_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDebriefDeclined_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDeclined_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerTentative_Fragment | ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagRequestedChange_Fragment;

export type ScheduleTaskDashboardTaskTags_TaskTagsFragment = (
  { __typename?: 'TaskTag', id: any }
  & ScheduleTaskTagCompact_TaskTagFragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type TaskDashboardTableRowItem_TaskFragment_Task_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any, fullName?: string | null }
  & Candidate_CandidateFragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_application_Application = { __typename?: 'Application', id: any, status: ApplicationStatus, job?: TaskDashboardTableRowItem_TaskFragment_Task_application_Application_job_Job | null, candidate?: TaskDashboardTableRowItem_TaskFragment_Task_application_Application_candidate_Candidate | null };

export type TaskDashboardTableRowItem_TaskFragment_Task_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, name: string };

export type TaskDashboardTableRowItem_TaskFragment_Task_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: TaskDashboardTableRowItem_TaskFragment_Task_jobStage_JobStage_job_Job | null };

export type TaskDashboardTableRowItem_TaskFragment_Task_taskQueue_TaskQueue = { __typename?: 'TaskQueue', id: any, name: string };

export type TaskDashboardTableRowItem_TaskFragment_Task_createdBy_Employee = { __typename?: 'Employee', id: any, internalProfilePictureUrl?: string | null, fullName?: string | null };

export type TaskDashboardTableRowItem_TaskFragment_Task_schedules_ApplicationStage = (
  { __typename?: 'ApplicationStage', id: any }
  & ScheduleDateCell_SchedulesFragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagCandidateDeclined = (
  { __typename?: 'TaskFlagCandidateDeclined', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagCandidateDeclined_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagCandidateTentative = (
  { __typename?: 'TaskFlagCandidateTentative', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagCandidateTentative_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated = (
  { __typename?: 'TaskFlagDebriefAttendeeDeactivated', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagDebriefAttendeeDeactivated_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative = (
  { __typename?: 'TaskFlagDebriefAttendeeTentative', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagDebriefAttendeeTentative_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated = (
  { __typename?: 'TaskFlagInterviewerDeactivated', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDeactivated_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined = (
  { __typename?: 'TaskFlagInterviewerDebriefDeclined', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDebriefDeclined_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerDeclined = (
  { __typename?: 'TaskFlagInterviewerDeclined', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerDeclined_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerTentative = (
  { __typename?: 'TaskFlagInterviewerTentative', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagInterviewerTentative_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagRequestedChange = (
  { __typename?: 'TaskFlagRequestedChange', id: any }
  & ScheduleTaskDashboardTaskFlags_TaskFlags_TaskFlagRequestedChange_Fragment
);

export type TaskDashboardTableRowItem_TaskFragment_Task_flags = TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagCandidateDeclined | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagCandidateTentative | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagDebriefAttendeeDeactivated | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagDebriefAttendeeTentative | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerDeactivated | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerDebriefDeclined | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerDeclined | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagInterviewerTentative | TaskDashboardTableRowItem_TaskFragment_Task_flags_TaskFlagRequestedChange;

export type TaskDashboardTableRowItem_TaskFragment_Task_tags_TaskTag = (
  { __typename?: 'TaskTag', id: any }
  & ScheduleTaskDashboardTaskTags_TaskTagsFragment
);

export type TaskDashboardTableRowItem_TaskFragment = (
  { __typename?: 'Task', id: any, status: TaskStatus, isUrgent: boolean, createdAt: any, lastActivityAt: any, candidateAvailabilityStartAt?: any | null, scheduleCreatedAt?: any | null, firstInterviewAt?: any | null, application: TaskDashboardTableRowItem_TaskFragment_Task_application_Application, jobStage?: TaskDashboardTableRowItem_TaskFragment_Task_jobStage_JobStage | null, taskQueue?: TaskDashboardTableRowItem_TaskFragment_Task_taskQueue_TaskQueue | null, createdBy: TaskDashboardTableRowItem_TaskFragment_Task_createdBy_Employee, schedules: Array<TaskDashboardTableRowItem_TaskFragment_Task_schedules_ApplicationStage>, flags: Array<TaskDashboardTableRowItem_TaskFragment_Task_flags>, tags: Array<TaskDashboardTableRowItem_TaskFragment_Task_tags_TaskTag> }
  & ScheduleTaskAssignee_TaskFragment
);

export type MemberPreferredEmployeeList_EmployeeFragment_Employee_orgUser_OrgUser = { __typename?: 'OrgUser', role: OrgUserRole };

export type MemberPreferredEmployeeList_EmployeeFragment = { __typename?: 'Employee', id: any, email: string, fullName?: string | null, internalProfilePictureUrl?: string | null, isArchived?: boolean | null, isDirectoryDisabled: boolean, isAtsDisabled?: boolean | null, orgUser?: MemberPreferredEmployeeList_EmployeeFragment_Employee_orgUser_OrgUser | null };

export type MemberPreferredEmployeeListQuery_employees_EmployeesOutput_items_Employee = (
  { __typename?: 'Employee' }
  & MemberPreferredEmployeeList_EmployeeFragment
);

export type MemberPreferredEmployeeListQuery_employees_EmployeesOutput = { __typename?: 'EmployeesOutput', nextCursor?: string | null, items: Array<MemberPreferredEmployeeListQuery_employees_EmployeesOutput_items_Employee> };

export type MemberPreferredEmployeeListQuery_employeeByIds_Employee = (
  { __typename?: 'Employee' }
  & MemberPreferredEmployeeList_EmployeeFragment
);

export type MemberPreferredEmployeeListQuery_Query = { __typename?: 'Query', employees?: MemberPreferredEmployeeListQuery_employees_EmployeesOutput | null, employeeByIds?: Array<MemberPreferredEmployeeListQuery_employeeByIds_Employee> | null };


export type MemberPreferredEmployeeListQueryVariables = Exact<{
  employeesInput: EmployeesInput;
  selectedEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type MemberPreferredEmployeeListQuery = MemberPreferredEmployeeListQuery_Query;

export type QueueFilter_SelectedOptionsFragment = { __typename?: 'TaskQueue', id: any, name: string, memberCount: number };

export type QueueFilterTaskQueueSearchQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue = (
  { __typename?: 'TaskQueue' }
  & QueueFilter_SelectedOptionsFragment
);

export type QueueFilterTaskQueueSearchQuery_taskQueueSearch_TaskQueueSearchResult = { __typename?: 'TaskQueueSearchResult', items: Array<QueueFilterTaskQueueSearchQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue> };

export type QueueFilterTaskQueueSearchQuery_Query = { __typename?: 'Query', taskQueueSearch?: QueueFilterTaskQueueSearchQuery_taskQueueSearch_TaskQueueSearchResult | null };


export type QueueFilterTaskQueueSearchQueryVariables = Exact<{
  input: TaskQueueSearchInput;
}>;


export type QueueFilterTaskQueueSearchQuery = QueueFilterTaskQueueSearchQuery_Query;

export type ScheduleTaskDashboardTaskSearchQuery_taskSearch_TaskSearchResult_items_Task = (
  { __typename?: 'Task', id: any }
  & TaskDashboardTable_TaskFragment
);

export type ScheduleTaskDashboardTaskSearchQuery_taskSearch_TaskSearchResult = { __typename?: 'TaskSearchResult', hasNext: boolean, nextOffset: number, items: Array<ScheduleTaskDashboardTaskSearchQuery_taskSearch_TaskSearchResult_items_Task> };

export type ScheduleTaskDashboardTaskSearchQuery_Query = { __typename?: 'Query', taskSearch?: ScheduleTaskDashboardTaskSearchQuery_taskSearch_TaskSearchResult | null };


export type ScheduleTaskDashboardTaskSearchQueryVariables = Exact<{
  input: TaskSearchInput;
}>;


export type ScheduleTaskDashboardTaskSearchQuery = ScheduleTaskDashboardTaskSearchQuery_Query;

export type MySchedulingTasksQuery_assignedToMe_TaskSearchResult = { __typename?: 'TaskSearchResult', total: number };

export type MySchedulingTasksQuery_created_TaskSearchResult = { __typename?: 'TaskSearchResult', total: number };

export type MySchedulingTasksQuery_subscribed_TaskSearchResult = { __typename?: 'TaskSearchResult', total: number };

export type MySchedulingTasksQuery_myQueues_TaskSearchResult = { __typename?: 'TaskSearchResult', total: number };

export type MySchedulingTasksQuery_Query = { __typename?: 'Query', assignedToMe?: MySchedulingTasksQuery_assignedToMe_TaskSearchResult | null, created?: MySchedulingTasksQuery_created_TaskSearchResult | null, subscribed?: MySchedulingTasksQuery_subscribed_TaskSearchResult | null, myQueues?: MySchedulingTasksQuery_myQueues_TaskSearchResult | null };


export type MySchedulingTasksQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MySchedulingTasksQuery = MySchedulingTasksQuery_Query;

export type ScheduleTaskDashboardFiltersEmployeePrefFragment_EmployeeTaskDashboardFilterPref_tags_TaskTag = { __typename?: 'TaskTag', id: any, name: string };

export type ScheduleTaskDashboardFiltersEmployeePrefFragment = { __typename?: 'EmployeeTaskDashboardFilterPref', isUrgent: boolean, assigneeEmployeeIds: Array<any>, showUnassigned: boolean, creatorEmployeeIds: Array<any>, applicationStatuses: Array<ApplicationStatus>, taskStatuses: Array<TaskStatus>, jobIds: Array<any>, jobStageNames: Array<string>, flags: Array<TaskFlagType>, taskQueueIds: Array<any>, showNoQueue: boolean, showCompletedInFlagged: boolean, delegateTypes?: Array<string> | null, tags: Array<ScheduleTaskDashboardFiltersEmployeePrefFragment_EmployeeTaskDashboardFilterPref_tags_TaskTag> };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = (
  { __typename?: 'EmployeeTaskDashboardFilterPref' }
  & ScheduleTaskDashboardFiltersEmployeePrefFragment
);

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = { __typename?: 'UpcomingEventsPageFiltersPref' };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref = ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref | null };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, employeePref?: ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref | null };

export type ScheduleTaskDashboardFiltersEmployeePrefQuery_Query = { __typename?: 'Query', thisEmployee?: ScheduleTaskDashboardFiltersEmployeePrefQuery_thisEmployee_Employee | null };


export type ScheduleTaskDashboardFiltersEmployeePrefQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type ScheduleTaskDashboardFiltersEmployeePrefQuery = ScheduleTaskDashboardFiltersEmployeePrefQuery_Query;

export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string };

export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: UpdateScheduleTaskDashboardFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutation_Mutation = { __typename?: 'Mutation', employeePrefUpdate?: UpdateScheduleTaskDashboardFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult | null };


export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutationVariables = Exact<{
  input: EmployeePrefUpdateInput;
}>;


export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutation = UpdateScheduleTaskDashboardFiltersEmployeePrefMutation_Mutation;

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_CandidatePageFiltersPref = { __typename: 'CandidatePageFiltersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_DirectoryPageFiltersPref = { __typename: 'DirectoryPageFiltersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_EmployeeTaskDashboardFilterPref = { __typename: 'EmployeeTaskDashboardFilterPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_EmployeeTaskDashboardLayoutPref = { __typename: 'EmployeeTaskDashboardLayoutPref', columnType: ScheduleTaskColumnType, isVisible: boolean };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_InterviewBufferTimePref = { __typename: 'InterviewBufferTimePref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_InterviewLimit = { __typename: 'InterviewLimit' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageAverageTimesFiltersPref = { __typename: 'MetricsPageAverageTimesFiltersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageCandidatePulseFiltersPref = { __typename: 'MetricsPageCandidatePulseFiltersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageInterviewerFiltersPref = { __typename: 'MetricsPageInterviewerFiltersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageRecruitingTeamFiltersPref = { __typename: 'MetricsPageRecruitingTeamFiltersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_ProfilePicturePref = { __typename: 'ProfilePicturePref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_RecentlyUsedZoomUsersPref = { __typename: 'RecentlyUsedZoomUsersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_UpcomingEventsPageFiltersPref = { __typename: 'UpcomingEventsPageFiltersPref' };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref = ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_CandidatePageFiltersPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_DirectoryPageFiltersPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_EmployeeTaskDashboardFilterPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_EmployeeTaskDashboardLayoutPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_InterviewBufferTimePref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_InterviewLimit | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageAverageTimesFiltersPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageCandidatePulseFiltersPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageInterviewerFiltersPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_MetricsPageRecruitingTeamFiltersPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_ProfilePicturePref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_RecentlyUsedZoomUsersPref | ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref_UpcomingEventsPageFiltersPref;

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonArrayPref: Array<ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonArrayPref> };

export type ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, employeePref?: ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee_employeePref_EmployeePref | null };

export type ScheduleTaskDashboardColumnsQuery_Query = { __typename?: 'Query', thisEmployee?: ScheduleTaskDashboardColumnsQuery_thisEmployee_Employee | null };


export type ScheduleTaskDashboardColumnsQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type ScheduleTaskDashboardColumnsQuery = ScheduleTaskDashboardColumnsQuery_Query;

export type ConfigurableSelfScheduleOptions_InterviewMeetingLocationFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfSchedulePreferences_InterviewMeetingLocationFragment
);

export type SelfSchedule_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragment
);

export type SelfSchedule_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: SelfSchedule_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type SelfSchedule_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, interviewMeetingLocationSettingWithLevel?: SelfSchedule_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null }
  & SelfScheduleOptionsModalWrapper_JobStageSettingsV2Fragment
);

export type SelfScheduleEmail_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId_template_Template = (
  { __typename?: 'Template', id: any }
  & TemplateSelectRow_TemplateFragment
);

export type SelfScheduleEmail_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null, template?: SelfScheduleEmail_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId_template_Template | null };

export type SelfScheduleEmail_JobStageSettingsV2Fragment = { __typename?: 'JobStageSettingsV2', id: any, selfScheduleRequestEmailTemplateId?: SelfScheduleEmail_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleRequestEmailTemplateId_SettingTemplateId | null };

export type SelfScheduleInterviewMeetingLocation_InterviewMeetingLocationFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref', interviewMeetingLocationType: InterviewMeetingLocationType, videoMeetingLinkScope: VideoMeetingLinkScope, dynamicHost?: DynamicInterviewMeetingHost | null, hostEmployeeId?: string | null, remoteVideoMeetingHostUserId?: string | null, customLocation?: string | null }
  & VideoMeetingHost_InterviewMeetingLocationSettingPrefFragment
);

export type SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery_zoomUsersByIds_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, employeeId?: string | null };

export type SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery_Query = { __typename?: 'Query', zoomUsersByIds?: Array<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery_zoomUsersByIds_ZoomUser> | null };


export type SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables = Exact<{
  schedulerId: Scalars['uuid']['input'];
}>;


export type SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery = SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery_Query;

export type JobStageQuery_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type JobStageQuery_Query = { __typename?: 'Query', jobStage?: JobStageQuery_jobStage_JobStage | null };


export type JobStageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type JobStageQuery = JobStageQuery_Query;

export type SelfScheduleOptions_OptionsFragment_Options_candidateEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type SelfScheduleOptions_OptionsFragment_Options_interviewerEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type SelfScheduleOptions_OptionsFragment = { __typename?: 'Options', inclusionDays?: Array<string> | null, rollingDays?: any | null, advanceNoticeInHours?: any | null, candidateCalendarId?: string | null, interviewerCalendarId?: string | null, location?: SelfScheduleLocation | null, zoomHost?: SelfScheduleZoomHost | null, zoomHostUserId?: string | null, candidateEmail: string, shouldRespectLoadLimit: boolean, canScheduleOverRecruitingKeywords: boolean, canScheduleOverAvailableKeywords: boolean, canScheduleOverFreeTime: boolean, meetingHost?: SelfScheduleMeetingHost | null, videoMeetingHostEmployeeId?: any | null, note?: string | null, candidateEventAdditionalAttendees?: SelfScheduleOptions_OptionsFragment_Options_candidateEventAdditionalAttendees_NotificationPreference | null, interviewerEventAdditionalAttendees?: SelfScheduleOptions_OptionsFragment_Options_interviewerEventAdditionalAttendees_NotificationPreference | null };

export type SelfScheduleOptions_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseInterviewPlanDescription_JobStageFragment
);

export type SelfScheduleOptions_InterviewMeetingLocationFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & ConfigurableSelfScheduleOptions_InterviewMeetingLocationFragment
);

export type CandidateSelfScheduleEmailQuery_candidate_Candidate = { __typename?: 'Candidate', email?: string | null };

export type CandidateSelfScheduleEmailQuery_Query = { __typename?: 'Query', candidate?: CandidateSelfScheduleEmailQuery_candidate_Candidate | null };


export type CandidateSelfScheduleEmailQueryVariables = Exact<{
  candidateId: Scalars['uuid']['input'];
}>;


export type CandidateSelfScheduleEmailQuery = CandidateSelfScheduleEmailQuery_Query;

export type SelfScheduleOptionsModalQuery_application_Application = (
  { __typename?: 'Application', id: any }
  & CreateTaskDialogPage_ApplicationFragment
);

export type SelfScheduleOptionsModalQuery_zoomUsersByIds_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string, employeeId?: string | null };

export type SelfScheduleOptionsModalQuery_Query = { __typename?: 'Query', application?: SelfScheduleOptionsModalQuery_application_Application | null, zoomUsersByIds?: Array<SelfScheduleOptionsModalQuery_zoomUsersByIds_ZoomUser> | null };


export type SelfScheduleOptionsModalQueryVariables = Exact<{
  applicationId: Scalars['uuid']['input'];
  zoomUserEmployeeIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SelfScheduleOptionsModalQuery = SelfScheduleOptionsModalQuery_Query;

export type SelfScheduleCalendarsQuery_initScheduleFlow_InitScheduleFlowResult_candidateCalendar_Calendar = { __typename?: 'Calendar', remoteId?: string | null };

export type SelfScheduleCalendarsQuery_initScheduleFlow_InitScheduleFlowResult_interviewerCalendar_Calendar = { __typename?: 'Calendar', remoteId?: string | null };

export type SelfScheduleCalendarsQuery_initScheduleFlow_InitScheduleFlowResult = { __typename?: 'InitScheduleFlowResult', candidateCalendar?: SelfScheduleCalendarsQuery_initScheduleFlow_InitScheduleFlowResult_candidateCalendar_Calendar | null, interviewerCalendar?: SelfScheduleCalendarsQuery_initScheduleFlow_InitScheduleFlowResult_interviewerCalendar_Calendar | null };

export type SelfScheduleCalendarsQuery_Query = { __typename?: 'Query', initScheduleFlow?: SelfScheduleCalendarsQuery_initScheduleFlow_InitScheduleFlowResult | null };


export type SelfScheduleCalendarsQueryVariables = Exact<{
  input: InitScheduleFlowInput;
}>;


export type SelfScheduleCalendarsQuery = SelfScheduleCalendarsQuery_Query;

export type SelfScheduleOptionsInterviewPlanQuery_jobStage_JobStage = (
  { __typename?: 'JobStage', id: any }
  & CreateTaskDialogPage_InterviewPlanFragment
  & CloneInterviewPlan_InterviewPlanFragment
  & GetSaveInterviewPlanInput_InterviewPlanFragment
  & SelfScheduleOptions_InterviewPlanFragment
);

export type SelfScheduleOptionsInterviewPlanQuery_Query = { __typename?: 'Query', jobStage?: SelfScheduleOptionsInterviewPlanQuery_jobStage_JobStage | null };


export type SelfScheduleOptionsInterviewPlanQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type SelfScheduleOptionsInterviewPlanQuery = SelfScheduleOptionsInterviewPlanQuery_Query;

export type SelfScheduleOptionsModal_SelfScheduleFragment_SelfScheduleOptions_options_Options = (
  { __typename?: 'Options' }
  & SelfScheduleOptions_OptionsFragment
);

export type SelfScheduleOptionsModal_SelfScheduleFragment_SelfScheduleOptions_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptions_InterviewMeetingLocationFragment
);

export type SelfScheduleOptionsModal_SelfScheduleFragment = { __typename?: 'SelfScheduleOptions', id: any, taskId?: any | null, createdAt?: any | null, creatorEmployeeId?: any | null, deletedAt?: any | null, jobStageId: any, candidateEmailTemplateId?: any | null, candidateEventTemplateId?: any | null, interviewerEventTemplateId?: any | null, lastUpdatedByEmployeeId?: any | null, rescheduledAt?: any | null, selfScheduleEmailTemplateId?: any | null, selfScheduleEmailSentAt?: any | null, updatedAt?: any | null, options?: SelfScheduleOptionsModal_SelfScheduleFragment_SelfScheduleOptions_options_Options | null, interviewMeetingLocationSetting?: SelfScheduleOptionsModal_SelfScheduleFragment_SelfScheduleOptions_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_isPrivateCalendarEvent_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_shouldSendEmailToCandidate_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptions_InterviewMeetingLocationFragment
);

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration = { __typename?: 'SettingDuration', duration: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration_duration_Duration };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration_duration_Duration = { __typename?: 'Duration', seconds: any };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration = { __typename?: 'SettingDuration', duration: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration_duration_Duration };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_shouldRespectLoadLimit_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverFreeTime_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_candidateNote_SettingStringValue = { __typename?: 'SettingStringValue', value: string };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', dynamicAudiences?: Array<DynamicAudience> | null, employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', dynamicAudiences?: Array<DynamicAudience> | null, employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_useRollingDays_SettingBoolValue = { __typename?: 'SettingBoolValue', value: boolean };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 = { __typename?: 'JobStageSelfScheduleSettingsV2', timeframe: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_timeframe_SettingDuration, advanceNotice: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_advanceNotice_SettingDuration, shouldRespectLoadLimit: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_shouldRespectLoadLimit_SettingBoolValue, canScheduleOverRecruitingKeywords: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverRecruitingKeywords_SettingBoolValue, canScheduleOverAvailableKeywords: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverAvailableKeywords_SettingBoolValue, canScheduleOverFreeTime: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_canScheduleOverFreeTime_SettingBoolValue, candidateNote: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_candidateNote_SettingStringValue, ccRecipients: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_ccRecipients_SettingNotificationPreference, bccRecipients: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_bccRecipients_SettingNotificationPreference, useRollingDays: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2_useRollingDays_SettingBoolValue };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', dynamicAudiences?: Array<DynamicAudience> | null, employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference = { __typename?: 'NotificationPreference', dynamicAudiences?: Array<DynamicAudience> | null, employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference = { __typename?: 'SettingNotificationPreference', notificationPreference: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference_notificationPreference_NotificationPreference };

export type SelfScheduleOptionsModal_JobStageSettingsV2Fragment = (
  { __typename?: 'JobStageSettingsV2', id: any, candidateCalendarId?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateCalendarId_SettingCalendarId | null, interviewerCalendarId?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId | null, isPrivateCalendarEvent: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_isPrivateCalendarEvent_SettingBoolValue, candidateEventTemplateId?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId | null, shouldSendEmailToCandidate?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_shouldSendEmailToCandidate_SettingBoolValue | null, candidateEmailTemplateId?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId | null, interviewerEventTemplateId?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId | null, interviewMeetingLocationSettingWithLevel?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null, selfScheduleSettingsV2?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_selfScheduleSettingsV2_JobStageSelfScheduleSettingsV2 | null, candidateEventAdditionalAttendees?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_candidateEventAdditionalAttendees_SettingNotificationPreference | null, interviewerEventAdditionalAttendees?: SelfScheduleOptionsModal_JobStageSettingsV2Fragment_JobStageSettingsV2_interviewerEventAdditionalAttendees_SettingNotificationPreference | null }
  & SelfScheduleEmail_JobStageSettingsV2Fragment
);

export type SelfScheduleOptionsModal_InterviewMeetingLocationFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptions_InterviewMeetingLocationFragment
);

export type SelfScheduleOptionsModalWrapper_SelfScheduleFragment = (
  { __typename?: 'SelfScheduleOptions' }
  & SelfScheduleOptionsModal_SelfScheduleFragment
);

export type SelfScheduleOptionsModalWrapper_JobStageSettingsV2Fragment = (
  { __typename?: 'JobStageSettingsV2' }
  & SelfScheduleOptionsModal_JobStageSettingsV2Fragment
);

export type SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleOptionsModal_InterviewMeetingLocationFragment
);

export type SelfScheduleOptionsUpsertMutation_selfScheduleOptionsUpsert_SelfScheduleOptions = (
  { __typename?: 'SelfScheduleOptions' }
  & SelfScheduleOptionsModal_SelfScheduleFragment
);

export type SelfScheduleOptionsUpsertMutation_Mutation = { __typename?: 'Mutation', selfScheduleOptionsUpsert?: SelfScheduleOptionsUpsertMutation_selfScheduleOptionsUpsert_SelfScheduleOptions | null };


export type SelfScheduleOptionsUpsertMutationVariables = Exact<{
  input: SelfScheduleOptionsUpsertInput;
}>;


export type SelfScheduleOptionsUpsertMutation = SelfScheduleOptionsUpsertMutation_Mutation;

export type SelfSchedulePreferences_InterviewMeetingLocationFragment = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & SelfScheduleInterviewMeetingLocation_InterviewMeetingLocationFragment
);

export type SelfSchedulePreferences_CandidateEventAdditionalAttendeesFragment_CandidateEventAdditionalAttendeesPref_candidateEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null, externalEmailAddresses?: Array<string> | null };

export type SelfSchedulePreferences_CandidateEventAdditionalAttendeesFragment = { __typename?: 'CandidateEventAdditionalAttendeesPref', candidateEventAdditionalAttendees: SelfSchedulePreferences_CandidateEventAdditionalAttendeesFragment_CandidateEventAdditionalAttendeesPref_candidateEventAdditionalAttendees_NotificationPreference };

export type SelfSchedulePreferences_InterviewerEventAdditionalAttendeesFragment_InterviewerEventAdditionalAttendeesPref_interviewerEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, dynamicAudiences?: Array<DynamicAudience> | null, externalEmailAddresses?: Array<string> | null };

export type SelfSchedulePreferences_InterviewerEventAdditionalAttendeesFragment = { __typename?: 'InterviewerEventAdditionalAttendeesPref', interviewerEventAdditionalAttendees: SelfSchedulePreferences_InterviewerEventAdditionalAttendeesFragment_InterviewerEventAdditionalAttendeesPref_interviewerEventAdditionalAttendees_NotificationPreference };

export type SuggestedTimeRangesCountQuery_suggestedTimeRangesCount_SuggestedTimeRangesCountOutput_timeRangeCounts_TimeRangeCount_range_DateTimeRangeOutput = { __typename?: 'DateTimeRangeOutput', startAt: any, endAt: any };

export type SuggestedTimeRangesCountQuery_suggestedTimeRangesCount_SuggestedTimeRangesCountOutput_timeRangeCounts_TimeRangeCount = { __typename?: 'TimeRangeCount', count: any, range: SuggestedTimeRangesCountQuery_suggestedTimeRangesCount_SuggestedTimeRangesCountOutput_timeRangeCounts_TimeRangeCount_range_DateTimeRangeOutput };

export type SuggestedTimeRangesCountQuery_suggestedTimeRangesCount_SuggestedTimeRangesCountOutput = { __typename?: 'SuggestedTimeRangesCountOutput', employeeMissingZoomUserId: Array<any>, timeRangeCounts: Array<SuggestedTimeRangesCountQuery_suggestedTimeRangesCount_SuggestedTimeRangesCountOutput_timeRangeCounts_TimeRangeCount> };

export type SuggestedTimeRangesCountQuery_Query = { __typename?: 'Query', suggestedTimeRangesCount?: SuggestedTimeRangesCountQuery_suggestedTimeRangesCount_SuggestedTimeRangesCountOutput | null };


export type SuggestedTimeRangesCountQueryVariables = Exact<{
  input: SuggestedTimeRangesCountInput;
}>;


export type SuggestedTimeRangesCountQuery = SuggestedTimeRangesCountQuery_Query;

export type SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', interviewerEventTemplateId?: SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId | null, candidateEventTemplateId?: SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId | null, candidateEmailTemplateId?: SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId | null };

export type SelfScheduleTemplatesQuery_jobStage_JobStage = { __typename?: 'JobStage', jobStageSettingsV2?: SelfScheduleTemplatesQuery_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type SelfScheduleTemplatesQuery_Query = { __typename?: 'Query', jobStage?: SelfScheduleTemplatesQuery_jobStage_JobStage | null };


export type SelfScheduleTemplatesQueryVariables = Exact<{
  jobStageId: Scalars['uuid']['input'];
}>;


export type SelfScheduleTemplatesQuery = SelfScheduleTemplatesQuery_Query;

export type SelfScheduleOptionsDeleteMutation_selfScheduleOptionsDelete_SelfScheduleOptionsDeleteInput = { __typename?: 'SelfScheduleOptionsDeleteInput', id: any };

export type SelfScheduleOptionsDeleteMutation_Mutation = { __typename?: 'Mutation', selfScheduleOptionsDelete?: SelfScheduleOptionsDeleteMutation_selfScheduleOptionsDelete_SelfScheduleOptionsDeleteInput | null };


export type SelfScheduleOptionsDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SelfScheduleOptionsDeleteMutation = SelfScheduleOptionsDeleteMutation_Mutation;

export type SelfScheduleTaskCreateMutation_taskCreate_TaskCreateResult_task_Task = { __typename?: 'Task', id: any };

export type SelfScheduleTaskCreateMutation_taskCreate_TaskCreateResult = { __typename?: 'TaskCreateResult', task: SelfScheduleTaskCreateMutation_taskCreate_TaskCreateResult_task_Task };

export type SelfScheduleTaskCreateMutation_Mutation = { __typename?: 'Mutation', taskCreate?: SelfScheduleTaskCreateMutation_taskCreate_TaskCreateResult | null };


export type SelfScheduleTaskCreateMutationVariables = Exact<{
  input: TaskCreateInput;
}>;


export type SelfScheduleTaskCreateMutation = SelfScheduleTaskCreateMutation_Mutation;

export type OrgAiContextSectionQuery_thisOrg_Org_aiInstruction_AiInstruction = (
  { __typename?: 'AiInstruction' }
  & AiInstructionsCard_InstructionFragment
);

export type OrgAiContextSectionQuery_thisOrg_Org_aiMemories_AiMemory = (
  { __typename?: 'AiMemory' }
  & AiMemoriesCard_MemoryFragment
);

export type OrgAiContextSectionQuery_thisOrg_Org = { __typename?: 'Org', id: any, aiInstruction?: OrgAiContextSectionQuery_thisOrg_Org_aiInstruction_AiInstruction | null, aiMemories: Array<OrgAiContextSectionQuery_thisOrg_Org_aiMemories_AiMemory> };

export type OrgAiContextSectionQuery_Query = { __typename?: 'Query', thisOrg?: OrgAiContextSectionQuery_thisOrg_Org | null };


export type OrgAiContextSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgAiContextSectionQuery = OrgAiContextSectionQuery_Query;

export type SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentIntegrations_google_AiAgentIntegrationConnection = { __typename?: 'AiAgentIntegrationConnection', provider: AiAgentIntegrationProvider, installed: boolean, connected: boolean, accountEmail?: string | null };

export type SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentIntegrations_microsoft_AiAgentIntegrationConnection = { __typename?: 'AiAgentIntegrationConnection', provider: AiAgentIntegrationProvider, installed: boolean, connected: boolean, accountEmail?: string | null };

export type SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentEmailNotConfiguredError = { __typename: 'AiAgentEmailNotConfiguredError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentEmployeeNotFoundError = { __typename: 'AiAgentEmployeeNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentIntegrations = { __typename: 'AiAgentIntegrations', agentEmployeeId: any, agentEmail: string, google: SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentIntegrations_google_AiAgentIntegrationConnection, microsoft: SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentIntegrations_microsoft_AiAgentIntegrationConnection };

export type SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationsQuery_aiAgentIntegrations = SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentEmailNotConfiguredError | SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentEmployeeNotFoundError | SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_AiAgentIntegrations | SettingsAiAgentIntegrationsQuery_aiAgentIntegrations_UnknownError;

export type SettingsAiAgentIntegrationsQuery_Query = { __typename?: 'Query', aiAgentIntegrations: SettingsAiAgentIntegrationsQuery_aiAgentIntegrations };


export type SettingsAiAgentIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsAiAgentIntegrationsQuery = SettingsAiAgentIntegrationsQuery_Query;

export type SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentEmailNotConfiguredError = { __typename: 'AiAgentEmailNotConfiguredError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentEmployeeNotFoundError = { __typename: 'AiAgentEmployeeNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentIntegrationConnectSuccess = { __typename: 'AiAgentIntegrationConnectSuccess', url: string, redirectUri: string };

export type SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentIntegrationProviderNotInstalledError = { __typename: 'AiAgentIntegrationProviderNotInstalledError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect = SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentEmailNotConfiguredError | SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentEmployeeNotFoundError | SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentIntegrationConnectSuccess | SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_AiAgentIntegrationProviderNotInstalledError | SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect_UnknownError;

export type SettingsAiAgentIntegrationConnectMutation_Mutation = { __typename?: 'Mutation', aiAgentIntegrationConnect: SettingsAiAgentIntegrationConnectMutation_aiAgentIntegrationConnect };


export type SettingsAiAgentIntegrationConnectMutationVariables = Exact<{
  input: AiAgentIntegrationConnectInput;
}>;


export type SettingsAiAgentIntegrationConnectMutation = SettingsAiAgentIntegrationConnectMutation_Mutation;

export type SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentEmailNotConfiguredError = { __typename: 'AiAgentEmailNotConfiguredError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentEmployeeNotFoundError = { __typename: 'AiAgentEmployeeNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentIntegrationDisconnectSuccess = { __typename: 'AiAgentIntegrationDisconnectSuccess', provider: AiAgentIntegrationProvider };

export type SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentIntegrationProviderNotInstalledError = { __typename: 'AiAgentIntegrationProviderNotInstalledError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect = SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentEmailNotConfiguredError | SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentEmployeeNotFoundError | SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentIntegrationDisconnectSuccess | SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_AiAgentIntegrationProviderNotInstalledError | SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect_UnknownError;

export type SettingsAiAgentIntegrationDisconnectMutation_Mutation = { __typename?: 'Mutation', aiAgentIntegrationDisconnect: SettingsAiAgentIntegrationDisconnectMutation_aiAgentIntegrationDisconnect };


export type SettingsAiAgentIntegrationDisconnectMutationVariables = Exact<{
  input: AiAgentIntegrationDisconnectInput;
}>;


export type SettingsAiAgentIntegrationDisconnectMutation = SettingsAiAgentIntegrationDisconnectMutation_Mutation;

export type SettingsExternalApiTokensQuery_externalApiTokens_ExternalApiTokenMetadata_employee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string };

export type SettingsExternalApiTokensQuery_externalApiTokens_ExternalApiTokenMetadata = { __typename?: 'ExternalApiTokenMetadata', tokenId: any, employeeId: any, name: string, tokenPrefix: string, scopes: Array<string>, createdAt: any, expiresAt?: any | null, lastUsedAt?: any | null, revokedAt?: any | null, employee: SettingsExternalApiTokensQuery_externalApiTokens_ExternalApiTokenMetadata_employee_Employee };

export type SettingsExternalApiTokensQuery_Query = { __typename?: 'Query', externalApiTokens: Array<SettingsExternalApiTokensQuery_externalApiTokens_ExternalApiTokenMetadata> };


export type SettingsExternalApiTokensQueryVariables = Exact<{
  input: ExternalApiTokensInput;
}>;


export type SettingsExternalApiTokensQuery = SettingsExternalApiTokensQuery_Query;

export type SettingsCreateExternalApiTokenMutation_createExternalApiToken_CreateExternalApiTokenPayload = { __typename?: 'CreateExternalApiTokenPayload', token: string, tokenId: any, tokenPrefix: string };

export type SettingsCreateExternalApiTokenMutation_Mutation = { __typename?: 'Mutation', createExternalApiToken: SettingsCreateExternalApiTokenMutation_createExternalApiToken_CreateExternalApiTokenPayload };


export type SettingsCreateExternalApiTokenMutationVariables = Exact<{
  input: CreateExternalApiTokenInput;
}>;


export type SettingsCreateExternalApiTokenMutation = SettingsCreateExternalApiTokenMutation_Mutation;

export type SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_ExternalApiKeyRevokeFailureAlreadyRevoked = { __typename: 'ExternalApiKeyRevokeFailureAlreadyRevoked', errorCode: ErrorCode, errorMessage: string };

export type SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_ExternalApiKeyRevokeFailureNotFound = { __typename: 'ExternalApiKeyRevokeFailureNotFound', errorCode: ErrorCode, errorMessage: string };

export type SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_ExternalApiKeyRevokeSuccess = { __typename: 'ExternalApiKeyRevokeSuccess', tokenId: any };

export type SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke = SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_ExternalApiKeyRevokeFailureAlreadyRevoked | SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_ExternalApiKeyRevokeFailureNotFound | SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_ExternalApiKeyRevokeSuccess | SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke_UnknownError;

export type SettingsExternalApiKeyRevokeMutation_Mutation = { __typename?: 'Mutation', externalApiKeyRevoke: SettingsExternalApiKeyRevokeMutation_externalApiKeyRevoke };


export type SettingsExternalApiKeyRevokeMutationVariables = Exact<{
  input: ExternalApiKeyRevokeInput;
}>;


export type SettingsExternalApiKeyRevokeMutation = SettingsExternalApiKeyRevokeMutation_Mutation;

export type AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_portalConfig_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string };

export type AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_criteria_PortalConfigAutomationRuleCriterion = { __typename?: 'PortalConfigAutomationRuleCriterion', field: PortalConfigAutomationRuleField, operator: PortalConfigAutomationRuleOperator, value: Array<string> };

export type AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule = { __typename?: 'PortalConfigAutomationRule', id: any, portalConfigId?: any | null, index: number, portalConfig?: AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_portalConfig_PortalConfig | null, criteria: Array<AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_criteria_PortalConfigAutomationRuleCriterion> };

export type AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult = { __typename?: 'PortalConfigAutomationRulesResult', rules: Array<AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule> };

export type AutomationRulesQuery_Query = { __typename?: 'Query', portalConfigAutomationRules?: AutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult | null };


export type AutomationRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationRulesQuery = AutomationRulesQuery_Query;

export type AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_portalConfig_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string };

export type AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_criteria_PortalConfigAutomationRuleCriterion = { __typename?: 'PortalConfigAutomationRuleCriterion', field: PortalConfigAutomationRuleField, operator: PortalConfigAutomationRuleOperator, value: Array<string> };

export type AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule = { __typename?: 'PortalConfigAutomationRule', id: any, portalConfigId?: any | null, index: number, portalConfig?: AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_portalConfig_PortalConfig | null, criteria: Array<AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule_criteria_PortalConfigAutomationRuleCriterion> };

export type AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult = { __typename?: 'PortalConfigAutomationRulesResult', rules: Array<AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule> };

export type AutomationSaveMutation_Mutation = { __typename?: 'Mutation', portalConfigAutomationSave: AutomationSaveMutation_portalConfigAutomationSave_PortalConfigAutomationRulesResult };


export type AutomationSaveMutationVariables = Exact<{
  input: PortalConfigAutomationSaveInput;
}>;


export type AutomationSaveMutation = AutomationSaveMutation_Mutation;

export type AutomationPortalConfigsQuery_portalConfigs_PortalConfigsResult_items_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string, isDefault: boolean };

export type AutomationPortalConfigsQuery_portalConfigs_PortalConfigsResult = { __typename?: 'PortalConfigsResult', items: Array<AutomationPortalConfigsQuery_portalConfigs_PortalConfigsResult_items_PortalConfig> };

export type AutomationPortalConfigsQuery_Query = { __typename?: 'Query', portalConfigs?: AutomationPortalConfigsQuery_portalConfigs_PortalConfigsResult | null };


export type AutomationPortalConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationPortalConfigsQuery = AutomationPortalConfigsQuery_Query;

export type AutomationRuleApplyMutation_portalConfigAutomationRuleApply_PortalConfigAutomationRuleApplyResult = { __typename?: 'PortalConfigAutomationRuleApplyResult', linkedJobCount: number };

export type AutomationRuleApplyMutation_Mutation = { __typename?: 'Mutation', portalConfigAutomationRuleApply: AutomationRuleApplyMutation_portalConfigAutomationRuleApply_PortalConfigAutomationRuleApplyResult };


export type AutomationRuleApplyMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AutomationRuleApplyMutation = AutomationRuleApplyMutation_Mutation;

export type AutomationJobLocationsQuery_automationJobLocations_AutomationJobLocationsOutput = { __typename?: 'AutomationJobLocationsOutput', items: Array<string> };

export type AutomationJobLocationsQuery_Query = { __typename?: 'Query', automationJobLocations?: AutomationJobLocationsQuery_automationJobLocations_AutomationJobLocationsOutput | null };


export type AutomationJobLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationJobLocationsQuery = AutomationJobLocationsQuery_Query;

export type AutomationDepartmentsQuery_automationDepartments_AutomationDepartmentsOutput_items_AutomationDepartment = { __typename?: 'AutomationDepartment', id: string, name: string, parentId?: string | null };

export type AutomationDepartmentsQuery_automationDepartments_AutomationDepartmentsOutput = { __typename?: 'AutomationDepartmentsOutput', nextCursor?: string | null, items: Array<AutomationDepartmentsQuery_automationDepartments_AutomationDepartmentsOutput_items_AutomationDepartment> };

export type AutomationDepartmentsQuery_Query = { __typename?: 'Query', automationDepartments?: AutomationDepartmentsQuery_automationDepartments_AutomationDepartmentsOutput | null };


export type AutomationDepartmentsQueryVariables = Exact<{
  input: AutomationDepartmentsInput;
}>;


export type AutomationDepartmentsQuery = AutomationDepartmentsQuery_Query;

export type BrandingThemeBuilderComponent_BrandingThemeFragment = (
  { __typename?: 'BrandingTheme', id: any, name: string, isOrgDefault: boolean, livePortals: any }
  & BrandingThemeInputsPanel_BrandingThemeFragment
  & BrandingThemePreviewWrapper_BrandingThemeFragment
);

export type BrandingThemeBuilderCreateMutation_brandingThemeCreate_BrandingThemeResult_theme_BrandingTheme = (
  { __typename?: 'BrandingTheme' }
  & BrandingThemeBuilderComponent_BrandingThemeFragment
);

export type BrandingThemeBuilderCreateMutation_brandingThemeCreate_BrandingThemeResult = { __typename?: 'BrandingThemeResult', theme: BrandingThemeBuilderCreateMutation_brandingThemeCreate_BrandingThemeResult_theme_BrandingTheme };

export type BrandingThemeBuilderCreateMutation_Mutation = { __typename?: 'Mutation', brandingThemeCreate: BrandingThemeBuilderCreateMutation_brandingThemeCreate_BrandingThemeResult };


export type BrandingThemeBuilderCreateMutationVariables = Exact<{
  input: BrandingThemeCreateInput;
}>;


export type BrandingThemeBuilderCreateMutation = BrandingThemeBuilderCreateMutation_Mutation;

export type BrandingThemeBuilderUpdateMutation_brandingThemeUpdate_BrandingThemeResult_theme_BrandingTheme = (
  { __typename?: 'BrandingTheme' }
  & BrandingThemeBuilderComponent_BrandingThemeFragment
);

export type BrandingThemeBuilderUpdateMutation_brandingThemeUpdate_BrandingThemeResult = { __typename?: 'BrandingThemeResult', theme: BrandingThemeBuilderUpdateMutation_brandingThemeUpdate_BrandingThemeResult_theme_BrandingTheme };

export type BrandingThemeBuilderUpdateMutation_Mutation = { __typename?: 'Mutation', brandingThemeUpdate: BrandingThemeBuilderUpdateMutation_brandingThemeUpdate_BrandingThemeResult };


export type BrandingThemeBuilderUpdateMutationVariables = Exact<{
  input: BrandingThemeUpdateInput;
}>;


export type BrandingThemeBuilderUpdateMutation = BrandingThemeBuilderUpdateMutation_Mutation;

export type BrandingThemePreviewContent_BrandingThemeFragment = { __typename?: 'BrandingTheme', coverImageUrl?: string | null, profileImageUrl?: string | null };

export type BrandingThemePreviewWrapper_BrandingThemeFragment = (
  { __typename?: 'BrandingTheme', id: any, themeMode?: BrandingThemeMode | null, font?: string | null, primaryColor?: string | null }
  & BrandingThemePreviewContent_BrandingThemeFragment
);

export type BrandingThemeInputsPanel_BrandingThemeFragment = { __typename?: 'BrandingTheme', id: any, profileImageUrl?: string | null, coverImageUrl?: string | null, faviconImageUrl?: string | null, font?: string | null, themeMode?: BrandingThemeMode | null, primaryColor?: string | null };

export type BrandingThemeBuilder_BrandingThemeFragment = (
  { __typename?: 'BrandingTheme' }
  & BrandingThemeBuilderComponent_BrandingThemeFragment
);

export type BrandingThemeDeleteMutation_brandingThemeDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type BrandingThemeDeleteMutation_Mutation = { __typename?: 'Mutation', brandingThemeDelete: BrandingThemeDeleteMutation_brandingThemeDelete_EmptyResult };


export type BrandingThemeDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BrandingThemeDeleteMutation = BrandingThemeDeleteMutation_Mutation;

export type BrandingThemesItem_BrandingThemeFragment = (
  { __typename?: 'BrandingTheme', id: any, orgId: any, name: string, profileImageUrl?: string | null, coverImageUrl?: string | null, isOrgDefault: boolean, createdAt: any, updatedAt: any, livePortals: any }
  & BrandingThemePlaceholderPreview_BrandingThemeFragment
);

export type BrandingThemeItemDescription_BrandingThemeFragment = { __typename?: 'BrandingTheme', id: any, name: string, isOrgDefault: boolean, livePortals: any };

export type BrandingThemesQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme = (
  { __typename?: 'BrandingTheme' }
  & BrandingThemeBuilder_BrandingThemeFragment
  & BrandingThemesItem_BrandingThemeFragment
);

export type BrandingThemesQuery_brandingThemes_BrandingThemesResult = { __typename?: 'BrandingThemesResult', items: Array<BrandingThemesQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme> };

export type BrandingThemesQuery_Query = { __typename?: 'Query', brandingThemes?: BrandingThemesQuery_brandingThemes_BrandingThemesResult | null };


export type BrandingThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandingThemesQuery = BrandingThemesQuery_Query;

export type DuplicateBrandingThemeMutation_brandingThemeCreate_BrandingThemeResult_theme_BrandingTheme = (
  { __typename?: 'BrandingTheme' }
  & BrandingThemeBuilder_BrandingThemeFragment
  & BrandingThemesItem_BrandingThemeFragment
);

export type DuplicateBrandingThemeMutation_brandingThemeCreate_BrandingThemeResult = { __typename?: 'BrandingThemeResult', theme: DuplicateBrandingThemeMutation_brandingThemeCreate_BrandingThemeResult_theme_BrandingTheme };

export type DuplicateBrandingThemeMutation_Mutation = { __typename?: 'Mutation', brandingThemeCreate: DuplicateBrandingThemeMutation_brandingThemeCreate_BrandingThemeResult };


export type DuplicateBrandingThemeMutationVariables = Exact<{
  input: BrandingThemeCreateInput;
}>;


export type DuplicateBrandingThemeMutation = DuplicateBrandingThemeMutation_Mutation;

export type PortalTemplatesQuery_portalTemplates_PortalTemplatesResult_items_PortalTemplate = (
  { __typename?: 'PortalTemplate', id: any }
  & PageTemplateRow_TemplateFragment
);

export type PortalTemplatesQuery_portalTemplates_PortalTemplatesResult = { __typename?: 'PortalTemplatesResult', nextCursor?: string | null, items: Array<PortalTemplatesQuery_portalTemplates_PortalTemplatesResult_items_PortalTemplate> };

export type PortalTemplatesQuery_Query = { __typename?: 'Query', portalTemplates?: PortalTemplatesQuery_portalTemplates_PortalTemplatesResult | null };


export type PortalTemplatesQueryVariables = Exact<{
  input: PortalTemplatesInput;
  includeLivePortals: Scalars['Boolean']['input'];
}>;


export type PortalTemplatesQuery = PortalTemplatesQuery_Query;

export type PortalTemplatePreviewQuery_portalTemplate_PortalTemplate = (
  { __typename?: 'PortalTemplate', id: any }
  & TemplatePreview_PortalTemplateFragment
);

export type PortalTemplatePreviewQuery_Query = { __typename?: 'Query', portalTemplate?: PortalTemplatePreviewQuery_portalTemplate_PortalTemplate | null };


export type PortalTemplatePreviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalTemplatePreviewQuery = PortalTemplatePreviewQuery_Query;

export type PortalTemplateDeleteMutation_portalTemplateDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type PortalTemplateDeleteMutation_Mutation = { __typename?: 'Mutation', portalTemplateDelete: PortalTemplateDeleteMutation_portalTemplateDelete_EmptyResult };


export type PortalTemplateDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalTemplateDeleteMutation = PortalTemplateDeleteMutation_Mutation;

type BlockPreview_Block_PortalTemplateBlockContentCard_Fragment = (
  { __typename?: 'PortalTemplateBlockContentCard', id: any, type: BlockType, index: any }
  & ContentCardBlock_BlockFragment
);

type BlockPreview_Block_PortalTemplateBlockDivider_Fragment = (
  { __typename?: 'PortalTemplateBlockDivider', id: any, type: BlockType, index: any }
  & DividerBlock_BlockFragment
);

type BlockPreview_Block_PortalTemplateBlockImage_Fragment = (
  { __typename?: 'PortalTemplateBlockImage', id: any, type: BlockType, index: any }
  & ImageBlock_BlockFragment
);

type BlockPreview_Block_PortalTemplateBlockLinkedCard_Fragment = (
  { __typename?: 'PortalTemplateBlockLinkedCard', id: any, type: BlockType, index: any }
  & LinkedCardBlock_BlockFragment
);

type BlockPreview_Block_PortalTemplateBlockText_Fragment = (
  { __typename?: 'PortalTemplateBlockText', id: any, type: BlockType, index: any }
  & TextBlock_BlockFragment
);

type BlockPreview_Block_PortalTemplateBlockVideo_Fragment = (
  { __typename?: 'PortalTemplateBlockVideo', id: any, type: BlockType, index: any }
  & VideoBlock_BlockFragment
);

export type BlockPreview_BlockFragment = BlockPreview_Block_PortalTemplateBlockContentCard_Fragment | BlockPreview_Block_PortalTemplateBlockDivider_Fragment | BlockPreview_Block_PortalTemplateBlockImage_Fragment | BlockPreview_Block_PortalTemplateBlockLinkedCard_Fragment | BlockPreview_Block_PortalTemplateBlockText_Fragment | BlockPreview_Block_PortalTemplateBlockVideo_Fragment;

export type ContentCardBlock_BlockFragment_PortalTemplateBlockContentCard_cards_ContentCard = { __typename?: 'ContentCard', header: string, body?: string | null };

export type ContentCardBlock_BlockFragment = { __typename?: 'PortalTemplateBlockContentCard', id: any, type: BlockType, index: any, header?: string | null, cards: Array<ContentCardBlock_BlockFragment_PortalTemplateBlockContentCard_cards_ContentCard> };

export type DividerBlock_BlockFragment = { __typename?: 'PortalTemplateBlockDivider', id: any, index: any, type: BlockType };

export type ImageBlock_BlockFragment = { __typename?: 'PortalTemplateBlockImage', id: any, type: BlockType, index: any, url: string, header?: string | null, caption?: string | null, fillPage: boolean };

export type LinkedCardBlock_BlockFragment_PortalTemplateBlockLinkedCard_cards_LinkedCard = { __typename?: 'LinkedCard', url: string, header: string, body?: string | null, previewImageUrl?: string | null };

export type LinkedCardBlock_BlockFragment = { __typename?: 'PortalTemplateBlockLinkedCard', id: any, type: BlockType, index: any, header?: string | null, cards: Array<LinkedCardBlock_BlockFragment_PortalTemplateBlockLinkedCard_cards_LinkedCard> };

export type TextBlock_BlockFragment = { __typename?: 'PortalTemplateBlockText', id: any, index: any, type: BlockType, content: string };

export type VideoBlock_BlockFragment = { __typename?: 'PortalTemplateBlockVideo', id: any, type: BlockType, url: string, index: any, caption?: string | null, header?: string | null };

export type TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockContentCard = (
  { __typename?: 'PortalTemplateBlockContentCard', id: any, index: any, type: BlockType }
  & BlockPreview_Block_PortalTemplateBlockContentCard_Fragment
);

export type TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockDivider = (
  { __typename?: 'PortalTemplateBlockDivider', id: any, index: any, type: BlockType }
  & BlockPreview_Block_PortalTemplateBlockDivider_Fragment
);

export type TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockImage = (
  { __typename?: 'PortalTemplateBlockImage', id: any, index: any, type: BlockType }
  & BlockPreview_Block_PortalTemplateBlockImage_Fragment
);

export type TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockLinkedCard = (
  { __typename?: 'PortalTemplateBlockLinkedCard', id: any, index: any, type: BlockType }
  & BlockPreview_Block_PortalTemplateBlockLinkedCard_Fragment
);

export type TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockText = (
  { __typename?: 'PortalTemplateBlockText', id: any, index: any, type: BlockType }
  & BlockPreview_Block_PortalTemplateBlockText_Fragment
);

export type TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockVideo = (
  { __typename?: 'PortalTemplateBlockVideo', id: any, index: any, type: BlockType }
  & BlockPreview_Block_PortalTemplateBlockVideo_Fragment
);

export type TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks = TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockContentCard | TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockDivider | TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockImage | TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockLinkedCard | TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockText | TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks_PortalTemplateBlockVideo;

export type TemplatePreview_PortalTemplateFragment = { __typename?: 'PortalTemplate', id: any, name: string, orgId: any, updatedAt: any, blocks: Array<TemplatePreview_PortalTemplateFragment_PortalTemplate_blocks> };

export type LinkUnfurlQuery_linkUnfurl_LinkUnfurlResult = { __typename?: 'LinkUnfurlResult', url: string, title?: string | null, description?: string | null, thumbnail?: string | null };

export type LinkUnfurlQuery_Query = { __typename?: 'Query', linkUnfurl?: LinkUnfurlQuery_linkUnfurl_LinkUnfurlResult | null };


export type LinkUnfurlQueryVariables = Exact<{
  input: LinkUnfurlInput;
}>;


export type LinkUnfurlQuery = LinkUnfurlQuery_Query;

export type PortalTemplateQuery_portalTemplate_PortalTemplate = (
  { __typename?: 'PortalTemplate' }
  & TemplatePreview_PortalTemplateFragment
);

export type PortalTemplateQuery_Query = { __typename?: 'Query', portalTemplate?: PortalTemplateQuery_portalTemplate_PortalTemplate | null };


export type PortalTemplateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalTemplateQuery = PortalTemplateQuery_Query;

export type PortalTemplateUpdateMutation_portalTemplateUpdate_PortalTemplateResult_template_PortalTemplate = (
  { __typename?: 'PortalTemplate', id: any }
  & TemplatePreview_PortalTemplateFragment
);

export type PortalTemplateUpdateMutation_portalTemplateUpdate_PortalTemplateResult = { __typename?: 'PortalTemplateResult', template: PortalTemplateUpdateMutation_portalTemplateUpdate_PortalTemplateResult_template_PortalTemplate };

export type PortalTemplateUpdateMutation_Mutation = { __typename?: 'Mutation', portalTemplateUpdate: PortalTemplateUpdateMutation_portalTemplateUpdate_PortalTemplateResult };


export type PortalTemplateUpdateMutationVariables = Exact<{
  input: PortalTemplateUpdateInput;
}>;


export type PortalTemplateUpdateMutation = PortalTemplateUpdateMutation_Mutation;

export type PortalTemplateCreateMutation_portalTemplateCreate_PortalTemplateResult_template_PortalTemplate = (
  { __typename?: 'PortalTemplate', id: any }
  & TemplatePreview_PortalTemplateFragment
);

export type PortalTemplateCreateMutation_portalTemplateCreate_PortalTemplateResult = { __typename?: 'PortalTemplateResult', template: PortalTemplateCreateMutation_portalTemplateCreate_PortalTemplateResult_template_PortalTemplate };

export type PortalTemplateCreateMutation_Mutation = { __typename?: 'Mutation', portalTemplateCreate: PortalTemplateCreateMutation_portalTemplateCreate_PortalTemplateResult };


export type PortalTemplateCreateMutationVariables = Exact<{
  input: PortalTemplateCreateInput;
}>;


export type PortalTemplateCreateMutation = PortalTemplateCreateMutation_Mutation;

export type PageTemplateRow_TemplateFragment = { __typename?: 'PortalTemplate', id: any, name: string, orgId: any, livePortals?: any, updatedAt: any };

export type PortalTemplateLivePortalsQuery_portalTemplate_PortalTemplate = { __typename?: 'PortalTemplate', id: any, livePortals: any };

export type PortalTemplateLivePortalsQuery_Query = { __typename?: 'Query', portalTemplate?: PortalTemplateLivePortalsQuery_portalTemplate_PortalTemplate | null };


export type PortalTemplateLivePortalsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalTemplateLivePortalsQuery = PortalTemplateLivePortalsQuery_Query;

export type PortalConfigBuilder_PortalConfigFragment_PortalConfig_tabs_PortalConfigTab = { __typename?: 'PortalConfigTab', id: any, name: string, icon: string, visibility: PortalJobOptionsTabVisibilityType, index: any, portalTemplateId: any, stageNameFilter?: string | null };

export type PortalConfigBuilder_PortalConfigFragment = { __typename?: 'PortalConfig', id: any, name: string, isDefault: boolean, brandingThemeId?: any | null, intro?: string | null, aiAssistantId?: string | null, tabs: Array<PortalConfigBuilder_PortalConfigFragment_PortalConfig_tabs_PortalConfigTab> };

export type PortalConfigCreateMutation_portalConfigCreate_PortalConfigResult_config_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string, isDefault: boolean, brandingThemeId?: any | null, intro?: string | null, aiAssistantId?: string | null };

export type PortalConfigCreateMutation_portalConfigCreate_PortalConfigResult = { __typename?: 'PortalConfigResult', config: PortalConfigCreateMutation_portalConfigCreate_PortalConfigResult_config_PortalConfig };

export type PortalConfigCreateMutation_Mutation = { __typename?: 'Mutation', portalConfigCreate: PortalConfigCreateMutation_portalConfigCreate_PortalConfigResult };


export type PortalConfigCreateMutationVariables = Exact<{
  input: PortalConfigCreateInput;
}>;


export type PortalConfigCreateMutation = PortalConfigCreateMutation_Mutation;

export type PortalConfigUpdateMutation_portalConfigUpdate_PortalConfigResult_config_PortalConfig = { __typename?: 'PortalConfig', id: any, name: string, isDefault: boolean, brandingThemeId?: any | null, intro?: string | null, aiAssistantId?: string | null };

export type PortalConfigUpdateMutation_portalConfigUpdate_PortalConfigResult = { __typename?: 'PortalConfigResult', config: PortalConfigUpdateMutation_portalConfigUpdate_PortalConfigResult_config_PortalConfig };

export type PortalConfigUpdateMutation_Mutation = { __typename?: 'Mutation', portalConfigUpdate: PortalConfigUpdateMutation_portalConfigUpdate_PortalConfigResult };


export type PortalConfigUpdateMutationVariables = Exact<{
  input: PortalConfigUpdateInput;
}>;


export type PortalConfigUpdateMutation = PortalConfigUpdateMutation_Mutation;

export type PortalConfigTabCreateMutation_portalConfigTabCreate_PortalConfigTabResult_tab_PortalConfigTab = { __typename?: 'PortalConfigTab', id: any, name: string, icon: string, visibility: PortalJobOptionsTabVisibilityType, index: any, portalTemplateId: any, stageNameFilter?: string | null };

export type PortalConfigTabCreateMutation_portalConfigTabCreate_PortalConfigTabResult = { __typename?: 'PortalConfigTabResult', tab: PortalConfigTabCreateMutation_portalConfigTabCreate_PortalConfigTabResult_tab_PortalConfigTab };

export type PortalConfigTabCreateMutation_Mutation = { __typename?: 'Mutation', portalConfigTabCreate: PortalConfigTabCreateMutation_portalConfigTabCreate_PortalConfigTabResult };


export type PortalConfigTabCreateMutationVariables = Exact<{
  input: PortalConfigTabCreateInput;
}>;


export type PortalConfigTabCreateMutation = PortalConfigTabCreateMutation_Mutation;

export type PortalConfigTabDeleteMutation_portalConfigTabDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type PortalConfigTabDeleteMutation_Mutation = { __typename?: 'Mutation', portalConfigTabDelete: PortalConfigTabDeleteMutation_portalConfigTabDelete_EmptyResult };


export type PortalConfigTabDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalConfigTabDeleteMutation = PortalConfigTabDeleteMutation_Mutation;

export type PortalConfigTabUpdateMutation_portalConfigTabUpdate_PortalConfigTabResult_tab_PortalConfigTab = { __typename?: 'PortalConfigTab', id: any, name: string, icon: string, visibility: PortalJobOptionsTabVisibilityType, index: any, portalTemplateId: any, stageNameFilter?: string | null };

export type PortalConfigTabUpdateMutation_portalConfigTabUpdate_PortalConfigTabResult = { __typename?: 'PortalConfigTabResult', tab: PortalConfigTabUpdateMutation_portalConfigTabUpdate_PortalConfigTabResult_tab_PortalConfigTab };

export type PortalConfigTabUpdateMutation_Mutation = { __typename?: 'Mutation', portalConfigTabUpdate: PortalConfigTabUpdateMutation_portalConfigTabUpdate_PortalConfigTabResult };


export type PortalConfigTabUpdateMutationVariables = Exact<{
  input: PortalConfigTabUpdateInput;
}>;


export type PortalConfigTabUpdateMutation = PortalConfigTabUpdateMutation_Mutation;

export type PortalConfigDeleteDialog_PortalConfigFragment_PortalConfig_linkedJobs_Job = { __typename?: 'Job', id: any };

export type PortalConfigDeleteDialog_PortalConfigFragment = { __typename?: 'PortalConfig', id: any, name: string, linkedJobs: Array<PortalConfigDeleteDialog_PortalConfigFragment_PortalConfig_linkedJobs_Job> };

export type PortalConfigDeleteMutation_portalConfigDelete_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type PortalConfigDeleteMutation_Mutation = { __typename?: 'Mutation', portalConfigDelete: PortalConfigDeleteMutation_portalConfigDelete_EmptyResult };


export type PortalConfigDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalConfigDeleteMutation = PortalConfigDeleteMutation_Mutation;

export type PortalConfigDeleteDialogAutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule = { __typename?: 'PortalConfigAutomationRule', id: any, portalConfigId?: any | null };

export type PortalConfigDeleteDialogAutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult = { __typename?: 'PortalConfigAutomationRulesResult', rules: Array<PortalConfigDeleteDialogAutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult_rules_PortalConfigAutomationRule> };

export type PortalConfigDeleteDialogAutomationRulesQuery_Query = { __typename?: 'Query', portalConfigAutomationRules?: PortalConfigDeleteDialogAutomationRulesQuery_portalConfigAutomationRules_PortalConfigAutomationRulesResult | null };


export type PortalConfigDeleteDialogAutomationRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalConfigDeleteDialogAutomationRulesQuery = PortalConfigDeleteDialogAutomationRulesQuery_Query;

export type PortalConfigPreviewBrandingThemesQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme = (
  { __typename?: 'BrandingTheme', id: any, isOrgDefault: boolean }
  & PortalPreviewByJobStage_BrandingThemeFragment
);

export type PortalConfigPreviewBrandingThemesQuery_brandingThemes_BrandingThemesResult = { __typename?: 'BrandingThemesResult', items: Array<PortalConfigPreviewBrandingThemesQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme> };

export type PortalConfigPreviewBrandingThemesQuery_Query = { __typename?: 'Query', brandingThemes?: PortalConfigPreviewBrandingThemesQuery_brandingThemes_BrandingThemesResult | null };


export type PortalConfigPreviewBrandingThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalConfigPreviewBrandingThemesQuery = PortalConfigPreviewBrandingThemesQuery_Query;

export type PortalConfigUsageDialog_PortalConfigFragment_PortalConfig_linkedJobs_Job = { __typename?: 'Job', id: any, externalJobName: string, location?: Array<string> | null, departments?: Array<string> | null };

export type PortalConfigUsageDialog_PortalConfigFragment = { __typename?: 'PortalConfig', id: any, name: string, linkedJobs: Array<PortalConfigUsageDialog_PortalConfigFragment_PortalConfig_linkedJobs_Job> };

export type PortalConfigQuery_portalConfig_PortalConfig = (
  { __typename?: 'PortalConfig', id: any }
  & PortalConfigBuilder_PortalConfigFragment
);

export type PortalConfigQuery_Query = { __typename?: 'Query', portalConfig?: PortalConfigQuery_portalConfig_PortalConfig | null };


export type PortalConfigQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type PortalConfigQuery = PortalConfigQuery_Query;

export type PortalConfigsBrandingThemesQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme = { __typename?: 'BrandingTheme', id: any, name: string, primaryColor?: string | null, isOrgDefault: boolean };

export type PortalConfigsBrandingThemesQuery_brandingThemes_BrandingThemesResult = { __typename?: 'BrandingThemesResult', items: Array<PortalConfigsBrandingThemesQuery_brandingThemes_BrandingThemesResult_items_BrandingTheme> };

export type PortalConfigsBrandingThemesQuery_Query = { __typename?: 'Query', brandingThemes?: PortalConfigsBrandingThemesQuery_brandingThemes_BrandingThemesResult | null };


export type PortalConfigsBrandingThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalConfigsBrandingThemesQuery = PortalConfigsBrandingThemesQuery_Query;

export type PortalConfigsListItemFragment_PortalConfig_tabs_PortalConfigTab = { __typename?: 'PortalConfigTab', id: any };

export type PortalConfigsListItemFragment_PortalConfig_linkedJobs_Job = { __typename?: 'Job', id: any, externalJobName: string, location?: Array<string> | null, departments?: Array<string> | null };

export type PortalConfigsListItemFragment = (
  { __typename?: 'PortalConfig', id: any, name: string, isDefault: boolean, intro?: string | null, brandingThemeId?: any | null, tabs: Array<PortalConfigsListItemFragment_PortalConfig_tabs_PortalConfigTab>, linkedJobs: Array<PortalConfigsListItemFragment_PortalConfig_linkedJobs_Job> }
  & PortalConfigBuilder_PortalConfigFragment
  & PortalConfigDeleteDialog_PortalConfigFragment
  & PortalConfigUsageDialog_PortalConfigFragment
);

export type PortalConfigsListFragment_PortalConfigsResult_items_PortalConfig = (
  { __typename?: 'PortalConfig', id: any }
  & PortalConfigsListItemFragment
);

export type PortalConfigsListFragment = { __typename?: 'PortalConfigsResult', items: Array<PortalConfigsListFragment_PortalConfigsResult_items_PortalConfig> };

export type PortalConfigsListQuery_portalConfigs_PortalConfigsResult = (
  { __typename?: 'PortalConfigsResult' }
  & PortalConfigsListFragment
);

export type PortalConfigsListQuery_Query = { __typename?: 'Query', portalConfigs?: PortalConfigsListQuery_portalConfigs_PortalConfigsResult | null };


export type PortalConfigsListQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalConfigsListQuery = PortalConfigsListQuery_Query;

export type UpsertCandidatePulseTagsMutation_candidatePulseTagUpsert_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type UpsertCandidatePulseTagsMutation_Mutation = { __typename?: 'Mutation', candidatePulseTagUpsert: UpsertCandidatePulseTagsMutation_candidatePulseTagUpsert_EmptyResult };


export type UpsertCandidatePulseTagsMutationVariables = Exact<{
  input: CandidatePulseTagUpsertInput;
}>;


export type UpsertCandidatePulseTagsMutation = UpsertCandidatePulseTagsMutation_Mutation;

export type QuestionSetupDialog_CandidatePulseTagsFragment_CandidatePulseTag_translationStatus_TranslationStatus = { __typename?: 'TranslationStatus', isComplete: boolean, missingLocales: Array<Locale> };

export type QuestionSetupDialog_CandidatePulseTagsFragment_CandidatePulseTag_translations_ContentTranslationValue = { __typename?: 'ContentTranslationValue', locale: Locale, name: string };

export type QuestionSetupDialog_CandidatePulseTagsFragment = { __typename?: 'CandidatePulseTag', id: any, archivedAt?: any | null, emoji: string, name: string, tagType: CandidatePulseTagType, index: any, translationStatus: QuestionSetupDialog_CandidatePulseTagsFragment_CandidatePulseTag_translationStatus_TranslationStatus, translations: Array<QuestionSetupDialog_CandidatePulseTagsFragment_CandidatePulseTag_translations_ContentTranslationValue> };

export type ContentTranslationUpsertMutation_contentTranslationUpsert_ContentTranslationUpsertOutput = { __typename?: 'ContentTranslationUpsertOutput', _empty?: boolean | null };

export type ContentTranslationUpsertMutation_Mutation = { __typename?: 'Mutation', contentTranslationUpsert: ContentTranslationUpsertMutation_contentTranslationUpsert_ContentTranslationUpsertOutput };


export type ContentTranslationUpsertMutationVariables = Exact<{
  input: ContentTranslationUpsertInput;
}>;


export type ContentTranslationUpsertMutation = ContentTranslationUpsertMutation_Mutation;

export type PulseSurveySettingsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_positive_CandidatePulseTag = (
  { __typename?: 'CandidatePulseTag', id: any, name: string, emoji: string, index: any, archivedAt?: any | null }
  & QuestionSetupDialog_CandidatePulseTagsFragment
);

export type PulseSurveySettingsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_negative_CandidatePulseTag = (
  { __typename?: 'CandidatePulseTag', id: any, name: string, emoji: string, index: any, archivedAt?: any | null }
  & QuestionSetupDialog_CandidatePulseTagsFragment
);

export type PulseSurveySettingsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags = { __typename?: 'CandidatePulseTags', positive: Array<PulseSurveySettingsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_positive_CandidatePulseTag | null>, negative: Array<PulseSurveySettingsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags_negative_CandidatePulseTag | null> };

export type PulseSurveySettingsQuery_thisOrg_Org = { __typename?: 'Org', id: any, candidatePulseTags: PulseSurveySettingsQuery_thisOrg_Org_candidatePulseTags_CandidatePulseTags };

export type PulseSurveySettingsQuery_Query = { __typename?: 'Query', thisOrg?: PulseSurveySettingsQuery_thisOrg_Org | null };


export type PulseSurveySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type PulseSurveySettingsQuery = PulseSurveySettingsQuery_Query;

export type SettingsInitiateCandidateDataExportMutation_initiateCandidateDataExport_InitiateCandidateDataExportOutput = { __typename: 'InitiateCandidateDataExportOutput' };

export type SettingsInitiateCandidateDataExportMutation_Mutation = { __typename?: 'Mutation', initiateCandidateDataExport: SettingsInitiateCandidateDataExportMutation_initiateCandidateDataExport_InitiateCandidateDataExportOutput };


export type SettingsInitiateCandidateDataExportMutationVariables = Exact<{
  input: InitiateCandidateDataExportInput;
}>;


export type SettingsInitiateCandidateDataExportMutation = SettingsInitiateCandidateDataExportMutation_Mutation;

export type SettingsAnonymizeCandidateMutation_candidateAnonymize_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type SettingsAnonymizeCandidateMutation_Mutation = { __typename?: 'Mutation', candidateAnonymize: SettingsAnonymizeCandidateMutation_candidateAnonymize_EmptyResult };


export type SettingsAnonymizeCandidateMutationVariables = Exact<{
  input: CandidateAnonymizeInput;
}>;


export type SettingsAnonymizeCandidateMutation = SettingsAnonymizeCandidateMutation_Mutation;

export type SettingsBulkAnonymizeCandidateMutation_candidateBulkAnonymize_CandidateBulkAnonymizeResult = { __typename?: 'CandidateBulkAnonymizeResult', count: number };

export type SettingsBulkAnonymizeCandidateMutation_Mutation = { __typename?: 'Mutation', candidateBulkAnonymize: SettingsBulkAnonymizeCandidateMutation_candidateBulkAnonymize_CandidateBulkAnonymizeResult };


export type SettingsBulkAnonymizeCandidateMutationVariables = Exact<{
  input: CandidateBulkAnonymizeInput;
}>;


export type SettingsBulkAnonymizeCandidateMutation = SettingsBulkAnonymizeCandidateMutation_Mutation;

export type OrgApplicationCalendarWriteQuery_thisOrg_Org = { __typename?: 'Org', hasApplicationCalendarWrite?: boolean | null };

export type OrgApplicationCalendarWriteQuery_Query = { __typename?: 'Query', thisOrg?: OrgApplicationCalendarWriteQuery_thisOrg_Org | null };


export type OrgApplicationCalendarWriteQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgApplicationCalendarWriteQuery = OrgApplicationCalendarWriteQuery_Query;

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration = { __typename?: 'GreenhouseOAuthIntegration', subdomain: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_lever_LeverIntegration = { __typename?: 'LeverIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_ashby_AshbyIntegration = { __typename?: 'AshbyIntegration', apiKey: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_workday_WorkdayIntegration = { __typename?: 'WorkdayIntegration', tenant?: string | null };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoft_MicrosoftIntegration = { __typename?: 'MicrosoftIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftCustom_MicrosoftIntegration = { __typename?: 'MicrosoftIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftGccHigh_MicrosoftGccHighIntegration = { __typename?: 'MicrosoftGccHighIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftServiceUser_MicrosoftServiceUserIntegration = { __typename?: 'MicrosoftServiceUserIntegration', serviceAccountEmail: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_google_GoogleIntegration = { __typename?: 'GoogleIntegration', adminUserId: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_smartRecruiters_SmartRecruitersIntegration = { __typename?: 'SmartRecruitersIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_gem_GemIntegration = { __typename?: 'GemIntegration', apiKey: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration = { __typename?: 'SlackOrgIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_zoom_ZoomIntegration = { __typename?: 'ZoomIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_zoomCustom_ZoomIntegration = { __typename?: 'ZoomIntegration', active: boolean };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration = { __typename?: 'CoderpadIntegration', apiKey: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration = { __typename?: 'CodilityIntegration', apiKey: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration = { __typename?: 'CodesignalIntegration', apiKey: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration = { __typename?: 'HackerRankIntegration', apiKey: string };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, greenhouseOauth?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration | null, lever?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_lever_LeverIntegration | null, ashby?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_ashby_AshbyIntegration | null, workday?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_workday_WorkdayIntegration | null, microsoft?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoft_MicrosoftIntegration | null, microsoftCustom?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftCustom_MicrosoftIntegration | null, microsoftGccHigh?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftGccHigh_MicrosoftGccHighIntegration | null, microsoftServiceUser?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_microsoftServiceUser_MicrosoftServiceUserIntegration | null, google?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_google_GoogleIntegration | null, smartRecruiters?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_smartRecruiters_SmartRecruitersIntegration | null, gem?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_gem_GemIntegration | null, slack?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration | null, zoom?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_zoom_ZoomIntegration | null, zoomCustom?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_zoomCustom_ZoomIntegration | null, coderpad?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration | null, codility?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration | null, codesignal?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration | null, hackerrank?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration | null };

export type OrgSettingsNavIntegrationsQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: OrgSettingsNavIntegrationsQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type OrgSettingsNavIntegrationsQuery_Query = { __typename?: 'Query', thisOrg?: OrgSettingsNavIntegrationsQuery_thisOrg_Org | null };


export type OrgSettingsNavIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgSettingsNavIntegrationsQuery = OrgSettingsNavIntegrationsQuery_Query;

export type EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations_microsoftCustomEmployee_MicrosoftEmployeeIntegration = { __typename?: 'MicrosoftEmployeeIntegration', active: boolean };

export type EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations_microsoft_MicrosoftEmployeeIntegration = { __typename?: 'MicrosoftEmployeeIntegration', active: boolean };

export type EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations_microsoftGccHighEmployee_MicrosoftGccHighEmployeeIntegration = { __typename?: 'MicrosoftGccHighEmployeeIntegration', active: boolean };

export type EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations = { __typename?: 'EmployeeIntegrations', id: any, microsoftCustomEmployee?: EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations_microsoftCustomEmployee_MicrosoftEmployeeIntegration | null, microsoft?: EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations_microsoft_MicrosoftEmployeeIntegration | null, microsoftGccHighEmployee?: EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations_microsoftGccHighEmployee_MicrosoftGccHighEmployeeIntegration | null };

export type EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, integrations?: EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee_integrations_EmployeeIntegrations | null };

export type EditCalendarPreferenceDialogEmployeeByIdsQuery_Query = { __typename?: 'Query', employeeByIds?: Array<EditCalendarPreferenceDialogEmployeeByIdsQuery_employeeByIds_Employee> | null };


export type EditCalendarPreferenceDialogEmployeeByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type EditCalendarPreferenceDialogEmployeeByIdsQuery = EditCalendarPreferenceDialogEmployeeByIdsQuery_Query;

export type GreenhouseOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration = { __typename?: 'GreenhouseOAuthIntegration', subdomain: string };

export type GreenhouseOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, greenhouseOauth?: GreenhouseOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration | null };

export type GreenhouseOAuthStatusQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: GreenhouseOAuthStatusQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type GreenhouseOAuthStatusQuery_Query = { __typename?: 'Query', thisOrg?: GreenhouseOAuthStatusQuery_thisOrg_Org | null };


export type GreenhouseOAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GreenhouseOAuthStatusQuery = GreenhouseOAuthStatusQuery_Query;

export type OrgIntegrationsGreenhouseOAuthQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration = { __typename?: 'GreenhouseOAuthIntegration', subdomain: string };

export type OrgIntegrationsGreenhouseOAuthQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, greenhouseOauth?: OrgIntegrationsGreenhouseOAuthQuery_thisOrg_Org_integrations_OrgIntegrations_greenhouseOauth_GreenhouseOAuthIntegration | null };

export type OrgIntegrationsGreenhouseOAuthQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: OrgIntegrationsGreenhouseOAuthQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type OrgIntegrationsGreenhouseOAuthQuery_Query = { __typename?: 'Query', thisOrg?: OrgIntegrationsGreenhouseOAuthQuery_thisOrg_Org | null };


export type OrgIntegrationsGreenhouseOAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgIntegrationsGreenhouseOAuthQuery = OrgIntegrationsGreenhouseOAuthQuery_Query;

export type MicrosoftIntegrationGetOAuthUrlQuery_integrationGetOauthUrl_IntegrationGetOauthUrlResult = { __typename?: 'IntegrationGetOauthUrlResult', url: string };

export type MicrosoftIntegrationGetOAuthUrlQuery_Query = { __typename?: 'Query', integrationGetOauthUrl?: MicrosoftIntegrationGetOAuthUrlQuery_integrationGetOauthUrl_IntegrationGetOauthUrlResult | null };


export type MicrosoftIntegrationGetOAuthUrlQueryVariables = Exact<{
  input: IntegrationGetOauthUrlInput;
}>;


export type MicrosoftIntegrationGetOAuthUrlQuery = MicrosoftIntegrationGetOAuthUrlQuery_Query;

export type MicrosoftGccHighIntegrationGetOAuthUrlQuery_integrationGetOauthUrl_IntegrationGetOauthUrlResult = { __typename?: 'IntegrationGetOauthUrlResult', url: string };

export type MicrosoftGccHighIntegrationGetOAuthUrlQuery_Query = { __typename?: 'Query', integrationGetOauthUrl?: MicrosoftGccHighIntegrationGetOAuthUrlQuery_integrationGetOauthUrl_IntegrationGetOauthUrlResult | null };


export type MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables = Exact<{
  input: IntegrationGetOauthUrlInput;
}>;


export type MicrosoftGccHighIntegrationGetOAuthUrlQuery = MicrosoftGccHighIntegrationGetOAuthUrlQuery_Query;

export type MicrosoftServiceUserIntegrationGetOAuthUrlQuery_integrationGetOauthUrl_IntegrationGetOauthUrlResult = { __typename?: 'IntegrationGetOauthUrlResult', url: string };

export type MicrosoftServiceUserIntegrationGetOAuthUrlQuery_Query = { __typename?: 'Query', integrationGetOauthUrl?: MicrosoftServiceUserIntegrationGetOAuthUrlQuery_integrationGetOauthUrl_IntegrationGetOauthUrlResult | null };


export type MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables = Exact<{
  input: IntegrationGetOauthUrlInput;
}>;


export type MicrosoftServiceUserIntegrationGetOAuthUrlQuery = MicrosoftServiceUserIntegrationGetOAuthUrlQuery_Query;

export type DisconnectAtsDialogQuery_thisOrg_Org = { __typename?: 'Org', upcomingInterviewsCount: any, activeCandidateAvailabilityLinksCount: any, activeSelfScheduleLinksCount: any };

export type DisconnectAtsDialogQuery_Query = { __typename?: 'Query', thisOrg?: DisconnectAtsDialogQuery_thisOrg_Org | null };


export type DisconnectAtsDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type DisconnectAtsDialogQuery = DisconnectAtsDialogQuery_Query;

export type OrgDomainsQuery_thisOrg_Org = { __typename?: 'Org', id: any, domains: Array<string> };

export type OrgDomainsQuery_Query = { __typename?: 'Query', thisOrg?: OrgDomainsQuery_thisOrg_Org | null };


export type OrgDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgDomainsQuery = OrgDomainsQuery_Query;

export type AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsSuccess_items_AtsRemoteDepartment = { __typename?: 'AtsRemoteDepartment', id: string, name: string, parentId?: string | null };

export type AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsAccessDeniedError = { __typename: 'AtsRemoteDepartmentsAccessDeniedError', errorMessage: string };

export type AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsInsufficientScopeError = { __typename: 'AtsRemoteDepartmentsInsufficientScopeError', scope: string };

export type AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsNotConnectedError = { __typename: 'AtsRemoteDepartmentsNotConnectedError', errorMessage: string };

export type AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsSuccess = { __typename: 'AtsRemoteDepartmentsSuccess', items: Array<AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsSuccess_items_AtsRemoteDepartment> };

export type AtsRemoteDepartmentsQuery_atsRemoteDepartments_UnknownError = { __typename: 'UnknownError', errorMessage: string };

export type AtsRemoteDepartmentsQuery_atsRemoteDepartments = AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsAccessDeniedError | AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsInsufficientScopeError | AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsNotConnectedError | AtsRemoteDepartmentsQuery_atsRemoteDepartments_AtsRemoteDepartmentsSuccess | AtsRemoteDepartmentsQuery_atsRemoteDepartments_UnknownError;

export type AtsRemoteDepartmentsQuery_Query = { __typename?: 'Query', atsRemoteDepartments: AtsRemoteDepartmentsQuery_atsRemoteDepartments };


export type AtsRemoteDepartmentsQueryVariables = Exact<{
  input?: InputMaybe<AtsRemoteListsInput>;
}>;


export type AtsRemoteDepartmentsQuery = AtsRemoteDepartmentsQuery_Query;

export type AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesSuccess_items_AtsRemoteOffice = { __typename?: 'AtsRemoteOffice', id: string, name: string, parentId?: string | null, location?: string | null };

export type AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesAccessDeniedError = { __typename: 'AtsRemoteOfficesAccessDeniedError', errorMessage: string };

export type AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesInsufficientScopeError = { __typename: 'AtsRemoteOfficesInsufficientScopeError', scope: string };

export type AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesNotConnectedError = { __typename: 'AtsRemoteOfficesNotConnectedError', errorMessage: string };

export type AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesSuccess = { __typename: 'AtsRemoteOfficesSuccess', items: Array<AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesSuccess_items_AtsRemoteOffice> };

export type AtsRemoteOfficesQuery_atsRemoteOffices_UnknownError = { __typename: 'UnknownError', errorMessage: string };

export type AtsRemoteOfficesQuery_atsRemoteOffices = AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesAccessDeniedError | AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesInsufficientScopeError | AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesNotConnectedError | AtsRemoteOfficesQuery_atsRemoteOffices_AtsRemoteOfficesSuccess | AtsRemoteOfficesQuery_atsRemoteOffices_UnknownError;

export type AtsRemoteOfficesQuery_Query = { __typename?: 'Query', atsRemoteOffices: AtsRemoteOfficesQuery_atsRemoteOffices };


export type AtsRemoteOfficesQueryVariables = Exact<{
  input?: InputMaybe<AtsRemoteListsInput>;
}>;


export type AtsRemoteOfficesQuery = AtsRemoteOfficesQuery_Query;

export type AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsSuccess_items_AtsRemoteJob = { __typename?: 'AtsRemoteJob', id: string, name: string, status: string, departmentId?: string | null, officeIds: Array<string> };

export type AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsAccessDeniedError = { __typename: 'AtsRemoteJobsAccessDeniedError', errorMessage: string };

export type AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsInsufficientScopeError = { __typename: 'AtsRemoteJobsInsufficientScopeError', scope: string };

export type AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsInvalidInputError = { __typename: 'AtsRemoteJobsInvalidInputError' };

export type AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsNotConnectedError = { __typename: 'AtsRemoteJobsNotConnectedError', errorMessage: string };

export type AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsSuccess = { __typename: 'AtsRemoteJobsSuccess', items: Array<AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsSuccess_items_AtsRemoteJob> };

export type AtsRemoteJobsQuery_atsRemoteJobs_UnknownError = { __typename: 'UnknownError', errorMessage: string };

export type AtsRemoteJobsQuery_atsRemoteJobs = AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsAccessDeniedError | AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsInsufficientScopeError | AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsInvalidInputError | AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsNotConnectedError | AtsRemoteJobsQuery_atsRemoteJobs_AtsRemoteJobsSuccess | AtsRemoteJobsQuery_atsRemoteJobs_UnknownError;

export type AtsRemoteJobsQuery_Query = { __typename?: 'Query', atsRemoteJobs: AtsRemoteJobsQuery_atsRemoteJobs };


export type AtsRemoteJobsQueryVariables = Exact<{
  input: AtsRemoteJobsInput;
}>;


export type AtsRemoteJobsQuery = AtsRemoteJobsQuery_Query;

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref_departments_AtsIdSelection = { __typename?: 'AtsIdSelection', ids: Array<string> };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref_offices_AtsIdSelection = { __typename?: 'AtsIdSelection', ids: Array<string> };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref_jobs_AtsIdSelection = { __typename?: 'AtsIdSelection', ids: Array<string> };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref = { __typename: 'AtsJobSyncScopePref', departments?: AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref_departments_AtsIdSelection | null, offices?: AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref_offices_AtsIdSelection | null, jobs?: AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref_jobs_AtsIdSelection | null };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateInvalidSelectionError = { __typename: 'AtsJobSyncScopeUpdateInvalidSelectionError', errorMessage: string };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateNotConnectedError = { __typename: 'AtsJobSyncScopeUpdateNotConnectedError', errorMessage: string };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess = { __typename: 'AtsJobSyncScopeUpdateSuccess', scope?: AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess_scope_AtsJobSyncScopePref | null };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_UnknownError = { __typename: 'UnknownError', errorMessage: string };

export type AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate = AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateInvalidSelectionError | AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateNotConnectedError | AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_AtsJobSyncScopeUpdateSuccess | AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate_UnknownError;

export type AtsJobSyncScopeUpdateMutation_Mutation = { __typename?: 'Mutation', atsJobSyncScopeUpdate: AtsJobSyncScopeUpdateMutation_atsJobSyncScopeUpdate };


export type AtsJobSyncScopeUpdateMutationVariables = Exact<{
  input: AtsJobSyncScopeUpdateInput;
}>;


export type AtsJobSyncScopeUpdateMutation = AtsJobSyncScopeUpdateMutation_Mutation;

export type Attribute_AttributeFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue = (
  { __typename?: 'EmployeeAttributeTagValue', id: any }
  & AttributeValue_AttributeValueFragment
  & AttributeValueDetailsDialog_AttributeValueFragment
);

export type Attribute_AttributeFragment = (
  { __typename?: 'EmployeeAttributeName', id: any, name: string, type: AttributeNameType, syncSourceType: SyncSourceType, values?: Array<Attribute_AttributeFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue> | null }
  & AttributeDetailsDialog_AttributeFragment
  & AttributeChangeSyncSourceTypeDialog_AttributeFragment
  & DeleteAllAttributeValuesDialog_AttributeFragment
  & DeleteAttributeDialog_AttributeFragment
);

export type Attribute_AttributesFragment = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & AttributeValue_AttributesFragment
  & AttributeValueDetailsDialog_AttributesFragment
);

export type AttributeChangeSyncSourceTypeDialog_AttributeFragment = { __typename?: 'EmployeeAttributeName', id: any, syncSourceType: SyncSourceType, name: string };

export type AttributeChangeSyncSourceTypeUpdateMutation_employeeAttributeNameUpdate_EmployeeAttributeName = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & AttributeChangeSyncSourceTypeDialog_AttributeFragment
);

export type AttributeChangeSyncSourceTypeUpdateMutation_Mutation = { __typename?: 'Mutation', employeeAttributeNameUpdate?: AttributeChangeSyncSourceTypeUpdateMutation_employeeAttributeNameUpdate_EmployeeAttributeName | null };


export type AttributeChangeSyncSourceTypeUpdateMutationVariables = Exact<{
  input: EmployeeAttributeNameUpdateInput;
}>;


export type AttributeChangeSyncSourceTypeUpdateMutation = AttributeChangeSyncSourceTypeUpdateMutation_Mutation;

export type AttributeDetailsDialog_AttributeFragment = { __typename?: 'EmployeeAttributeName', id: any, name: string, type: AttributeNameType };

export type AttributeDetailsDialogCreateAttributeNameMutation_employeeAttributeNameCreate_EmployeeAttributeName = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & AttributeDetailsDialog_AttributeFragment
);

export type AttributeDetailsDialogCreateAttributeNameMutation_Mutation = { __typename?: 'Mutation', employeeAttributeNameCreate?: AttributeDetailsDialogCreateAttributeNameMutation_employeeAttributeNameCreate_EmployeeAttributeName | null };


export type AttributeDetailsDialogCreateAttributeNameMutationVariables = Exact<{
  input: EmployeeAttributeNameCreateInput;
}>;


export type AttributeDetailsDialogCreateAttributeNameMutation = AttributeDetailsDialogCreateAttributeNameMutation_Mutation;

export type AttributeDetailsDialogUpdateAttributeNameMutation_employeeAttributeNameUpdate_EmployeeAttributeName = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & AttributeDetailsDialog_AttributeFragment
);

export type AttributeDetailsDialogUpdateAttributeNameMutation_Mutation = { __typename?: 'Mutation', employeeAttributeNameUpdate?: AttributeDetailsDialogUpdateAttributeNameMutation_employeeAttributeNameUpdate_EmployeeAttributeName | null };


export type AttributeDetailsDialogUpdateAttributeNameMutationVariables = Exact<{
  input: EmployeeAttributeNameUpdateInput;
}>;


export type AttributeDetailsDialogUpdateAttributeNameMutation = AttributeDetailsDialogUpdateAttributeNameMutation_Mutation;

export type AttributeValue_AttributesFragment = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & AttributeValueDetailsDialog_AttributesFragment
);

export type AttributeValue_AttributeValueFragment_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, syncSourceType: SyncSourceType };

export type AttributeValue_AttributeValueFragment = (
  { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, name?: AttributeValue_AttributeValueFragment_EmployeeAttributeTagValue_name_EmployeeAttributeName | null }
  & AttributeValueDeleteDialog_AttributeValueFragment
  & AttributeValueDetailsDialog_AttributeValueFragment
);

export type AttributeValueDeleteDialog_AttributeValueFragment_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, name: string };

export type AttributeValueDeleteDialog_AttributeValueFragment = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, name?: AttributeValueDeleteDialog_AttributeValueFragment_EmployeeAttributeTagValue_name_EmployeeAttributeName | null };

export type AttributeValueDeleteMutation_employeeAttributeValueDelete_Id = { __typename?: 'Id', id: any };

export type AttributeValueDeleteMutation_Mutation = { __typename?: 'Mutation', employeeAttributeValueDelete?: AttributeValueDeleteMutation_employeeAttributeValueDelete_Id | null };


export type AttributeValueDeleteMutationVariables = Exact<{
  input: EmployeeAttributeValueDeleteInput;
}>;


export type AttributeValueDeleteMutation = AttributeValueDeleteMutation_Mutation;

export type AttributeValueDetailsDialog_AttributesFragment = { __typename?: 'EmployeeAttributeName', id: any, name: string, syncSourceType: SyncSourceType };

export type AttributeValueDetailsDialog_AttributeValueFragment_EmployeeAttributeTagValue_name_EmployeeAttributeName = { __typename?: 'EmployeeAttributeName', id: any, name: string, syncSourceType: SyncSourceType };

export type AttributeValueDetailsDialog_AttributeValueFragment_EmployeeAttributeTagValue_employees_Employee = (
  { __typename?: 'Employee', id: any }
  & AttributeValueEmployees_EmployeesFragment
);

export type AttributeValueDetailsDialog_AttributeValueFragment = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string, name?: AttributeValueDetailsDialog_AttributeValueFragment_EmployeeAttributeTagValue_name_EmployeeAttributeName | null, employees?: Array<AttributeValueDetailsDialog_AttributeValueFragment_EmployeeAttributeTagValue_employees_Employee> | null };

export type AttributeValueDetailsCreateMutation_employeeAttributeValueCreate_EmployeeAttributeTagValue = (
  { __typename?: 'EmployeeAttributeTagValue', id: any }
  & AttributeValueDetailsDialog_AttributeValueFragment
);

export type AttributeValueDetailsCreateMutation_Mutation = { __typename?: 'Mutation', employeeAttributeValueCreate?: Array<AttributeValueDetailsCreateMutation_employeeAttributeValueCreate_EmployeeAttributeTagValue> | null };


export type AttributeValueDetailsCreateMutationVariables = Exact<{
  input: EmployeeAttributeValueCreateInput;
}>;


export type AttributeValueDetailsCreateMutation = AttributeValueDetailsCreateMutation_Mutation;

export type AttributeValueDetailsUpdateMutation_employeeAttributeValueUpdate_EmployeeAttributeTagValue = (
  { __typename?: 'EmployeeAttributeTagValue', id: any }
  & AttributeValueDetailsDialog_AttributeValueFragment
);

export type AttributeValueDetailsUpdateMutation_Mutation = { __typename?: 'Mutation', employeeAttributeValueUpdate?: Array<AttributeValueDetailsUpdateMutation_employeeAttributeValueUpdate_EmployeeAttributeTagValue> | null };


export type AttributeValueDetailsUpdateMutationVariables = Exact<{
  input: EmployeeAttributeValueUpdateInput;
}>;


export type AttributeValueDetailsUpdateMutation = AttributeValueDetailsUpdateMutation_Mutation;

export type AttributeValueDetailsEmployeesUpsertMutation_attributeValueEmployeesUpsert_EmployeeUpdateResult_employee_Employee = { __typename?: 'Employee', id: any };

export type AttributeValueDetailsEmployeesUpsertMutation_attributeValueEmployeesUpsert_EmployeeUpdateResult = { __typename?: 'EmployeeUpdateResult', employee?: AttributeValueDetailsEmployeesUpsertMutation_attributeValueEmployeesUpsert_EmployeeUpdateResult_employee_Employee | null };

export type AttributeValueDetailsEmployeesUpsertMutation_Mutation = { __typename?: 'Mutation', attributeValueEmployeesUpsert?: Array<AttributeValueDetailsEmployeesUpsertMutation_attributeValueEmployeesUpsert_EmployeeUpdateResult> | null };


export type AttributeValueDetailsEmployeesUpsertMutationVariables = Exact<{
  input: AttributeValueEmployeesInput;
}>;


export type AttributeValueDetailsEmployeesUpsertMutation = AttributeValueDetailsEmployeesUpsertMutation_Mutation;

export type AttributeValueEmployees_EmployeesFragment = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type CustomAttributesTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & Attributes_AttributesFragment
);

export type CustomAttributesTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<CustomAttributesTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type CustomAttributesTabQuery_thisOrg_Org = { __typename?: 'Org', id: any, hasScim: boolean };

export type CustomAttributesTabQuery_Query = { __typename?: 'Query', employeeAttributeNames?: CustomAttributesTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null, thisOrg?: CustomAttributesTabQuery_thisOrg_Org | null };


export type CustomAttributesTabQueryVariables = Exact<{
  types?: InputMaybe<Array<InputMaybe<AttributeNameType>> | InputMaybe<AttributeNameType>>;
}>;


export type CustomAttributesTabQuery = CustomAttributesTabQuery_Query;

export type DeleteAllAttributeValuesDialog_AttributeFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any };

export type DeleteAllAttributeValuesDialog_AttributeFragment = { __typename?: 'EmployeeAttributeName', id: any, name: string, values?: Array<DeleteAllAttributeValuesDialog_AttributeFragment_EmployeeAttributeName_values_EmployeeAttributeTagValue> | null };

export type DeleteAllAttributeValuesMutation_employeeAttributeValueDelete_Id = { __typename?: 'Id', id: any };

export type DeleteAllAttributeValuesMutation_Mutation = { __typename?: 'Mutation', employeeAttributeValueDelete?: DeleteAllAttributeValuesMutation_employeeAttributeValueDelete_Id | null };


export type DeleteAllAttributeValuesMutationVariables = Exact<{
  input: EmployeeAttributeValueDeleteInput;
}>;


export type DeleteAllAttributeValuesMutation = DeleteAllAttributeValuesMutation_Mutation;

export type DeleteAttributeDialog_AttributeFragment = { __typename?: 'EmployeeAttributeName', id: any, name: string };

export type DeleteAttributeDialogAttributeDeleteMutation_employeeAttributeNameDelete_Id = { __typename?: 'Id', id: any };

export type DeleteAttributeDialogAttributeDeleteMutation_Mutation = { __typename?: 'Mutation', employeeAttributeNameDelete?: DeleteAttributeDialogAttributeDeleteMutation_employeeAttributeNameDelete_Id | null };


export type DeleteAttributeDialogAttributeDeleteMutationVariables = Exact<{
  input: EmployeeAttributeNameDeleteInput;
}>;


export type DeleteAttributeDialogAttributeDeleteMutation = DeleteAttributeDialogAttributeDeleteMutation_Mutation;

export type InterviewerFieldsQuery_thisOrg_Org = { __typename?: 'Org', id: any, hasScim: boolean, totalEmployees: number };

export type InterviewerFieldsQuery_Query = { __typename?: 'Query', thisOrg?: InterviewerFieldsQuery_thisOrg_Org | null };


export type InterviewerFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewerFieldsQuery = InterviewerFieldsQuery_Query;

export type InterviewerFieldsClearForAllInterviewersMutation_employeeBulkUpdate_EmptyResult = { __typename?: 'EmptyResult', result?: Result | null };

export type InterviewerFieldsClearForAllInterviewersMutation_Mutation = { __typename?: 'Mutation', employeeBulkUpdate?: InterviewerFieldsClearForAllInterviewersMutation_employeeBulkUpdate_EmptyResult | null };


export type InterviewerFieldsClearForAllInterviewersMutationVariables = Exact<{
  input: EmployeeBulkUpdateInput;
}>;


export type InterviewerFieldsClearForAllInterviewersMutation = InterviewerFieldsClearForAllInterviewersMutation_Mutation;

export type WorkInfoTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & Attributes_AttributesFragment
);

export type WorkInfoTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult = { __typename?: 'EmployeeAttributeNamesResult', items?: Array<WorkInfoTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult_items_EmployeeAttributeName> | null };

export type WorkInfoTabQuery_thisOrg_Org = { __typename?: 'Org', id: any, hasScim: boolean };

export type WorkInfoTabQuery_Query = { __typename?: 'Query', employeeAttributeNames?: WorkInfoTabQuery_employeeAttributeNames_EmployeeAttributeNamesResult | null, thisOrg?: WorkInfoTabQuery_thisOrg_Org | null };


export type WorkInfoTabQueryVariables = Exact<{
  types?: InputMaybe<Array<InputMaybe<AttributeNameType>> | InputMaybe<AttributeNameType>>;
}>;


export type WorkInfoTabQuery = WorkInfoTabQuery_Query;

export type Attributes_AttributesFragment = (
  { __typename?: 'EmployeeAttributeName', id: any }
  & Attribute_AttributeFragment
  & Attribute_AttributesFragment
);

export type InterviewerPortalSettingsFragment = { __typename?: 'InterviewerPortalSettings', id: any, firstName: InterviewerPortalFieldPermission, lastName: InterviewerPortalFieldPermission, title: InterviewerPortalFieldPermission, emailAddress: InterviewerPortalFieldPermission, linkedinUrl: InterviewerPortalFieldPermission, timezone: InterviewerPortalFieldPermission, interviewLoadCapacity: InterviewerPortalFieldPermission, interviewAvailability: InterviewerPortalFieldPermission, temporaryAvailability: InterviewerPortalFieldPermission, bufferTime: InterviewerPortalFieldPermission, pauseFromInterviews: InterviewerPortalFieldPermission, interviewerKeywords: InterviewerPortalFieldPermission, profilePicture: InterviewerPortalFieldPermission, pronouns: InterviewerPortalFieldPermission, bio: InterviewerPortalFieldPermission, feedbackWritingTime: InterviewerPortalFieldPermission };

export type InterviewerPortalTabQuery_thisOrg_Org_interviewerPortalSettings_InterviewerPortalSettings = (
  { __typename?: 'InterviewerPortalSettings' }
  & InterviewerPortalSettingsFragment
);

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref', name?: SyncSourceType | null, title?: SyncSourceType | null, linkedInUrl?: SyncSourceType | null };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference = { __typename?: 'NotificationPreference' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref = InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref | InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek;

export type InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref_jsonPref | null };

export type InterviewerPortalTabQuery_thisOrg_Org = { __typename?: 'Org', id: any, interviewerPortalSettings: InterviewerPortalTabQuery_thisOrg_Org_interviewerPortalSettings_InterviewerPortalSettings, orgPref?: InterviewerPortalTabQuery_thisOrg_Org_orgPref_OrgPref | null };

export type InterviewerPortalTabQuery_Query = { __typename?: 'Query', thisOrg?: InterviewerPortalTabQuery_thisOrg_Org | null };


export type InterviewerPortalTabQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewerPortalTabQuery = InterviewerPortalTabQuery_Query;

export type UpdateInterviewPortalSettingMutation_interviewerPortalSettingsUpsert_InterviewerPortalSettings = (
  { __typename?: 'InterviewerPortalSettings' }
  & InterviewerPortalSettingsFragment
);

export type UpdateInterviewPortalSettingMutation_Mutation = { __typename?: 'Mutation', interviewerPortalSettingsUpsert: UpdateInterviewPortalSettingMutation_interviewerPortalSettingsUpsert_InterviewerPortalSettings };


export type UpdateInterviewPortalSettingMutationVariables = Exact<{
  input: InterviewerPortalSettingsUpsertInput;
}>;


export type UpdateInterviewPortalSettingMutation = UpdateInterviewPortalSettingMutation_Mutation;

export type AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsSuccess_userInfo_UserInfo = { __typename?: 'UserInfo', userId: any, role: UserRole, additionalPermissions: Array<Permission> };

export type AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsInterviewerError = { __typename: 'OrgMemberSetAdditionalPermissionsInterviewerError', errorCode: ErrorCode, errorMessage: string };

export type AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsNotFoundError = { __typename: 'OrgMemberSetAdditionalPermissionsNotFoundError', errorCode: ErrorCode, errorMessage: string };

export type AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsPermissionDeniedError = { __typename: 'OrgMemberSetAdditionalPermissionsPermissionDeniedError', errorCode: ErrorCode, errorMessage: string };

export type AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsSuccess = { __typename: 'OrgMemberSetAdditionalPermissionsSuccess', userInfo: AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsSuccess_userInfo_UserInfo };

export type AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions = AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsInterviewerError | AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsNotFoundError | AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsPermissionDeniedError | AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_OrgMemberSetAdditionalPermissionsSuccess | AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions_UnknownError;

export type AdditionalPermissionsSaveMutation_Mutation = { __typename?: 'Mutation', orgMemberSetAdditionalPermissions: AdditionalPermissionsSaveMutation_orgMemberSetAdditionalPermissions };


export type AdditionalPermissionsSaveMutationVariables = Exact<{
  input: OrgMemberSetAdditionalPermissionsInput;
}>;


export type AdditionalPermissionsSaveMutation = AdditionalPermissionsSaveMutation_Mutation;

export type InviteByEmailUsersInviteMutation_usersInvite_UsersInviteResult_failed_UserInviteFailure = { __typename?: 'UserInviteFailure', email: string, reason: string };

export type InviteByEmailUsersInviteMutation_usersInvite_UsersInviteResult = { __typename?: 'UsersInviteResult', success: Array<string>, skipped: Array<string>, failed: Array<InviteByEmailUsersInviteMutation_usersInvite_UsersInviteResult_failed_UserInviteFailure> };

export type InviteByEmailUsersInviteMutation_Mutation = { __typename?: 'Mutation', usersInvite?: InviteByEmailUsersInviteMutation_usersInvite_UsersInviteResult | null };


export type InviteByEmailUsersInviteMutationVariables = Exact<{
  users: Array<UserInviteInput> | UserInviteInput;
}>;


export type InviteByEmailUsersInviteMutation = InviteByEmailUsersInviteMutation_Mutation;

export type MemberRoleSelectUpdateRoleMutation_userUpdate_UserUpdateResult_userInfo_UserInfo = { __typename?: 'UserInfo', userId: any, role: UserRole };

export type MemberRoleSelectUpdateRoleMutation_userUpdate_UserUpdateResult = { __typename?: 'UserUpdateResult', userInfo?: MemberRoleSelectUpdateRoleMutation_userUpdate_UserUpdateResult_userInfo_UserInfo | null };

export type MemberRoleSelectUpdateRoleMutation_Mutation = { __typename?: 'Mutation', userUpdate?: MemberRoleSelectUpdateRoleMutation_userUpdate_UserUpdateResult | null };


export type MemberRoleSelectUpdateRoleMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  role: UserRole;
}>;


export type MemberRoleSelectUpdateRoleMutation = MemberRoleSelectUpdateRoleMutation_Mutation;

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgBccRecipientsFragment
  & AdditionalRecipientsRow_OrgCcRecipientsFragment
);

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref = AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DateBlock | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewBufferTimePref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewLimit | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_NotificationPreference | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_PaidFeaturePreference | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref | AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref_TimeBlockWeek;

export type AvailabilityRequestOrgPrefDataFragment = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: AvailabilityRequestOrgPrefDataFragment_OrgPref_jsonPref | null };

export type UpdateAvailabilityRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref = (
  { __typename?: 'OrgPref' }
  & AvailabilityRequestOrgPrefDataFragment
);

export type UpdateAvailabilityRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult = { __typename?: 'OrgPrefUpdateResult', orgPref?: UpdateAvailabilityRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref | null };

export type UpdateAvailabilityRequestOrgPrefsMutation_Mutation = { __typename?: 'Mutation', orgPrefUpdate?: UpdateAvailabilityRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult | null };


export type UpdateAvailabilityRequestOrgPrefsMutationVariables = Exact<{
  input: OrgPrefUpdateInput;
}>;


export type UpdateAvailabilityRequestOrgPrefsMutation = UpdateAvailabilityRequestOrgPrefsMutation_Mutation;

export type AvailabilityRequestSettingsOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref = (
  { __typename?: 'OrgPref' }
  & AvailabilityRequestOrgPrefDataFragment
);

export type AvailabilityRequestSettingsOrgPrefsQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPrefs?: Array<AvailabilityRequestSettingsOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type AvailabilityRequestSettingsOrgPrefsQuery_Query = { __typename?: 'Query', thisOrg?: AvailabilityRequestSettingsOrgPrefsQuery_thisOrg_Org | null };


export type AvailabilityRequestSettingsOrgPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailabilityRequestSettingsOrgPrefsQuery = AvailabilityRequestSettingsOrgPrefsQuery_Query;

export type OrgAvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateRow_OrgTemplateFragment
);

export type OrgAvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<OrgAvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput_items_Template> };

export type OrgAvailabilityRequestSettingsTemplateQuery_Query = { __typename?: 'Query', templates?: OrgAvailabilityRequestSettingsTemplateQuery_templates_TemplatesOutput | null };


export type OrgAvailabilityRequestSettingsTemplateQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type OrgAvailabilityRequestSettingsTemplateQuery = OrgAvailabilityRequestSettingsTemplateQuery_Query;

export type OrgAvailabilityRequestUpdateMutation_templateUpdate_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type OrgAvailabilityRequestUpdateMutation_templateUpdate_TemplateResult = { __typename?: 'TemplateResult', template?: OrgAvailabilityRequestUpdateMutation_templateUpdate_TemplateResult_template_Template | null };

export type OrgAvailabilityRequestUpdateMutation_Mutation = { __typename?: 'Mutation', templateUpdate?: OrgAvailabilityRequestUpdateMutation_templateUpdate_TemplateResult | null };


export type OrgAvailabilityRequestUpdateMutationVariables = Exact<{
  input: TemplateUpdateInput;
}>;


export type OrgAvailabilityRequestUpdateMutation = OrgAvailabilityRequestUpdateMutation_Mutation;

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgBccRecipientsFragment
  & AdditionalRecipientsRow_OrgCcRecipientsFragment
);

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref = SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DateBlock | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewBufferTimePref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewLimit | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_NotificationPreference | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_PaidFeaturePreference | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref | SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref_TimeBlockWeek;

export type SelfScheduleRequestSettingsOrgPrefsDataFragment = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: SelfScheduleRequestSettingsOrgPrefsDataFragment_OrgPref_jsonPref | null };

export type UpdateSelfScheduleRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref = (
  { __typename?: 'OrgPref' }
  & SelfScheduleRequestSettingsOrgPrefsDataFragment
);

export type UpdateSelfScheduleRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult = { __typename?: 'OrgPrefUpdateResult', orgPref?: UpdateSelfScheduleRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref | null };

export type UpdateSelfScheduleRequestOrgPrefsMutation_Mutation = { __typename?: 'Mutation', orgPrefUpdate?: UpdateSelfScheduleRequestOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult | null };


export type UpdateSelfScheduleRequestOrgPrefsMutationVariables = Exact<{
  input: OrgPrefUpdateInput;
}>;


export type UpdateSelfScheduleRequestOrgPrefsMutation = UpdateSelfScheduleRequestOrgPrefsMutation_Mutation;

export type SelfScheduleRequestSettingsOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref = (
  { __typename?: 'OrgPref' }
  & SelfScheduleRequestSettingsOrgPrefsDataFragment
);

export type SelfScheduleRequestSettingsOrgPrefsQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPrefs?: Array<SelfScheduleRequestSettingsOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type SelfScheduleRequestSettingsOrgPrefsQuery_Query = { __typename?: 'Query', thisOrg?: SelfScheduleRequestSettingsOrgPrefsQuery_thisOrg_Org | null };


export type SelfScheduleRequestSettingsOrgPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfScheduleRequestSettingsOrgPrefsQuery = SelfScheduleRequestSettingsOrgPrefsQuery_Query;

export type OrgSelfScheduleRequestSettingsTemplateQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateRow_OrgTemplateFragment
);

export type OrgSelfScheduleRequestSettingsTemplateQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<OrgSelfScheduleRequestSettingsTemplateQuery_templates_TemplatesOutput_items_Template> };

export type OrgSelfScheduleRequestSettingsTemplateQuery_Query = { __typename?: 'Query', templates?: OrgSelfScheduleRequestSettingsTemplateQuery_templates_TemplatesOutput | null };


export type OrgSelfScheduleRequestSettingsTemplateQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type OrgSelfScheduleRequestSettingsTemplateQuery = OrgSelfScheduleRequestSettingsTemplateQuery_Query;

export type OrgSelfScheduleRequestTemplateUpdateMutation_templateUpdate_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type OrgSelfScheduleRequestTemplateUpdateMutation_templateUpdate_TemplateResult = { __typename?: 'TemplateResult', template?: OrgSelfScheduleRequestTemplateUpdateMutation_templateUpdate_TemplateResult_template_Template | null };

export type OrgSelfScheduleRequestTemplateUpdateMutation_Mutation = { __typename?: 'Mutation', templateUpdate?: OrgSelfScheduleRequestTemplateUpdateMutation_templateUpdate_TemplateResult | null };


export type OrgSelfScheduleRequestTemplateUpdateMutationVariables = Exact<{
  input: TemplateUpdateInput;
}>;


export type OrgSelfScheduleRequestTemplateUpdateMutation = OrgSelfScheduleRequestTemplateUpdateMutation_Mutation;

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref_ccRecipients_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgBccRecipientsFragment
);

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref_bccRecipients_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & AdditionalRecipientsRow_OrgCcRecipientsFragment
);

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_candidateEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_debriefEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_interviewerEventAdditionalAttendees_NotificationPreference = { __typename?: 'NotificationPreference', employeeIds?: Array<any> | null, externalEmailAddresses?: Array<string> | null, dynamicAudiences?: Array<DynamicAudience> | null };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee = { __typename?: 'SettingAdditionalAttendee', email?: string | null, employeeId?: any | null, dynamicAudience?: DynamicAudience | null, isOptional: boolean };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref', ccRecipients?: CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref_ccRecipients_NotificationPreference | null, bccRecipients?: CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref_bccRecipients_NotificationPreference | null };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref', additionalRecipientsOptional: boolean, candidateEventAdditionalAttendees: CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_candidateEventAdditionalAttendees_NotificationPreference, additionalAttendees: Array<CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee> };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref = (
  { __typename?: 'ChatCommunicationsSettingPref' }
  & SlackChannelRow_OrgConversationFragment
);

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref', additionalRecipientsOptional: boolean, debriefEventAdditionalAttendees: CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_debriefEventAdditionalAttendees_NotificationPreference, additionalAttendees: Array<CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee> };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref', additionalRecipientsOptional: boolean, interviewerEventAdditionalAttendees: CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_interviewerEventAdditionalAttendees_NotificationPreference, additionalAttendees: Array<CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref_additionalAttendees_SettingAdditionalAttendee> };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_NotificationPreference = (
  { __typename?: 'NotificationPreference' }
  & SlackChannelMembers_OrgMembersFragment
);

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type CommunicationOrgPrefDataFragment_OrgPref_jsonPref = CommunicationOrgPrefDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DateBlock | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewBufferTimePref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewLimit | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_NotificationPreference | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_PaidFeaturePreference | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref | CommunicationOrgPrefDataFragment_OrgPref_jsonPref_TimeBlockWeek;

export type CommunicationOrgPrefDataFragment = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, stringValue?: string | null, jsonPref?: CommunicationOrgPrefDataFragment_OrgPref_jsonPref | null };

export type UpdateCommunicationOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref = (
  { __typename?: 'OrgPref' }
  & CommunicationOrgPrefDataFragment
);

export type UpdateCommunicationOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult = { __typename?: 'OrgPrefUpdateResult', orgPref?: UpdateCommunicationOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref | null };

export type UpdateCommunicationOrgPrefsMutation_Mutation = { __typename?: 'Mutation', orgPrefUpdate?: UpdateCommunicationOrgPrefsMutation_orgPrefUpdate_OrgPrefUpdateResult | null };


export type UpdateCommunicationOrgPrefsMutationVariables = Exact<{
  input: OrgPrefUpdateInput;
}>;


export type UpdateCommunicationOrgPrefsMutation = UpdateCommunicationOrgPrefsMutation_Mutation;

export type CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration = { __typename?: 'SlackOrgIntegration', active: boolean };

export type CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, slack?: CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations_slack_SlackOrgIntegration | null };

export type CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref = (
  { __typename?: 'OrgPref' }
  & CommunicationOrgPrefDataFragment
);

export type CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org_integrations_OrgIntegrations | null, orgPrefs?: Array<CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type CommunicationRequestSettingsOrgPrefsQuery_Query = { __typename?: 'Query', thisOrg?: CommunicationRequestSettingsOrgPrefsQuery_thisOrg_Org | null };


export type CommunicationRequestSettingsOrgPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunicationRequestSettingsOrgPrefsQuery = CommunicationRequestSettingsOrgPrefsQuery_Query;

export type OrgCommunicationSettingsTemplateQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateRow_OrgTemplateFragment
);

export type OrgCommunicationSettingsTemplateQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<OrgCommunicationSettingsTemplateQuery_templates_TemplatesOutput_items_Template> };

export type OrgCommunicationSettingsTemplateQuery_Query = { __typename?: 'Query', templates?: OrgCommunicationSettingsTemplateQuery_templates_TemplatesOutput | null };


export type OrgCommunicationSettingsTemplateQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type OrgCommunicationSettingsTemplateQuery = OrgCommunicationSettingsTemplateQuery_Query;

export type CommunicationCalendarQuery_calendar_Calendar = { __typename?: 'Calendar', id?: string | null, name?: string | null, isReadOnly?: boolean | null, remoteId?: string | null, canActorWriteToCalendar?: boolean | null };

export type CommunicationCalendarQuery_Query = { __typename?: 'Query', calendar?: CommunicationCalendarQuery_calendar_Calendar | null };


export type CommunicationCalendarQueryVariables = Exact<{
  input: Scalars['String']['input'];
}>;


export type CommunicationCalendarQuery = CommunicationCalendarQuery_Query;

export type OrgCommunicationTemplateUpdateMutation_templateUpdate_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type OrgCommunicationTemplateUpdateMutation_templateUpdate_TemplateResult = { __typename?: 'TemplateResult', template?: OrgCommunicationTemplateUpdateMutation_templateUpdate_TemplateResult_template_Template | null };

export type OrgCommunicationTemplateUpdateMutation_Mutation = { __typename?: 'Mutation', templateUpdate?: OrgCommunicationTemplateUpdateMutation_templateUpdate_TemplateResult | null };


export type OrgCommunicationTemplateUpdateMutationVariables = Exact<{
  input: TemplateUpdateInput;
}>;


export type OrgCommunicationTemplateUpdateMutation = OrgCommunicationTemplateUpdateMutation_Mutation;

export type CompanyHoliday_CompanyHolidayFragment_CompanyHoliday_countries_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type CompanyHoliday_CompanyHolidayFragment = (
  { __typename?: 'CompanyHoliday', id: any, name: string, startAt: any, endAt: any, countries?: Array<CompanyHoliday_CompanyHolidayFragment_CompanyHoliday_countries_EmployeeAttributeTagValue> | null }
  & CompanyHolidayModal_CompanyHolidayFragment
  & DeleteCompanyHolidayModal_CompanyHolidayFragment
);

export type CompanyHolidayModal_CompanyHolidayFragment_CompanyHoliday_countries_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type CompanyHolidayModal_CompanyHolidayFragment = { __typename?: 'CompanyHoliday', id: any, name: string, startAt: any, endAt: any, countries?: Array<CompanyHolidayModal_CompanyHolidayFragment_CompanyHoliday_countries_EmployeeAttributeTagValue> | null };

export type CompanyHolidayCreateMutation_companyHolidayCreate_CompanyHolidayUpsertResult_companyHoliday_CompanyHoliday = (
  { __typename?: 'CompanyHoliday' }
  & CompanyHolidayModal_CompanyHolidayFragment
);

export type CompanyHolidayCreateMutation_companyHolidayCreate_CompanyHolidayUpsertResult = { __typename?: 'CompanyHolidayUpsertResult', companyHoliday: CompanyHolidayCreateMutation_companyHolidayCreate_CompanyHolidayUpsertResult_companyHoliday_CompanyHoliday };

export type CompanyHolidayCreateMutation_Mutation = { __typename?: 'Mutation', companyHolidayCreate?: CompanyHolidayCreateMutation_companyHolidayCreate_CompanyHolidayUpsertResult | null };


export type CompanyHolidayCreateMutationVariables = Exact<{
  input: CompanyHolidayCreateInput;
}>;


export type CompanyHolidayCreateMutation = CompanyHolidayCreateMutation_Mutation;

export type CompanyHolidayUpdateMutation_companyHolidayUpdate_CompanyHolidayUpsertResult_companyHoliday_CompanyHoliday = (
  { __typename?: 'CompanyHoliday' }
  & CompanyHolidayModal_CompanyHolidayFragment
);

export type CompanyHolidayUpdateMutation_companyHolidayUpdate_CompanyHolidayUpsertResult = { __typename?: 'CompanyHolidayUpsertResult', companyHoliday: CompanyHolidayUpdateMutation_companyHolidayUpdate_CompanyHolidayUpsertResult_companyHoliday_CompanyHoliday };

export type CompanyHolidayUpdateMutation_Mutation = { __typename?: 'Mutation', companyHolidayUpdate?: CompanyHolidayUpdateMutation_companyHolidayUpdate_CompanyHolidayUpsertResult | null };


export type CompanyHolidayUpdateMutationVariables = Exact<{
  input: CompanyHolidayUpdateInput;
}>;


export type CompanyHolidayUpdateMutation = CompanyHolidayUpdateMutation_Mutation;

export type CompanyHolidaysQuery_companyHolidays_CompanyHolidayResult_items_CompanyHoliday = (
  { __typename?: 'CompanyHoliday' }
  & CompanyHoliday_CompanyHolidayFragment
);

export type CompanyHolidaysQuery_companyHolidays_CompanyHolidayResult = { __typename?: 'CompanyHolidayResult', items: Array<CompanyHolidaysQuery_companyHolidays_CompanyHolidayResult_items_CompanyHoliday> };

export type CompanyHolidaysQuery_Query = { __typename?: 'Query', companyHolidays?: CompanyHolidaysQuery_companyHolidays_CompanyHolidayResult | null };


export type CompanyHolidaysQueryVariables = Exact<{
  input: CompanyHolidaysInput;
}>;


export type CompanyHolidaysQuery = CompanyHolidaysQuery_Query;

export type DeleteCompanyHolidayModal_CompanyHolidayFragment_CompanyHoliday_countries_EmployeeAttributeTagValue = { __typename?: 'EmployeeAttributeTagValue', id: any, value: string };

export type DeleteCompanyHolidayModal_CompanyHolidayFragment = { __typename?: 'CompanyHoliday', id: any, name: string, startAt: any, endAt: any, countries?: Array<DeleteCompanyHolidayModal_CompanyHolidayFragment_CompanyHoliday_countries_EmployeeAttributeTagValue> | null };

export type CompanyHolidayDeleteMutation_companyHolidayDelete_CompanyHolidayDeleteResult = { __typename?: 'CompanyHolidayDeleteResult', result?: Result | null };

export type CompanyHolidayDeleteMutation_Mutation = { __typename?: 'Mutation', companyHolidayDelete?: CompanyHolidayDeleteMutation_companyHolidayDelete_CompanyHolidayDeleteResult | null };


export type CompanyHolidayDeleteMutationVariables = Exact<{
  input: CompanyHolidayDeleteInput;
}>;


export type CompanyHolidayDeleteMutation = CompanyHolidayDeleteMutation_Mutation;

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref = (
  { __typename?: 'DebriefAtsWriteSettingPref' }
  & DebriefAtsWriteRow_SettingFragment
);

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = { __typename?: 'InterviewMeetingLocationSettingPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_NotificationPreference = { __typename?: 'NotificationPreference' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref = DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_AiOrgCustomLlmPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_AtsJobSyncScopePref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateCommunicationsSettingPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_CandidateFacingInterviewerInfo | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_ChatCommunicationsSettingPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DateBlock | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DebriefAtsWriteSettingPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewBufferTimePref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewLimit | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_NotificationPreference | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_PaidFeaturePreference | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_PortalConfigAutomationRulesPref | DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref_TimeBlockWeek;

export type DebriefAtsWriteOrgPrefDataFragment = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: DebriefAtsWriteOrgPrefDataFragment_OrgPref_jsonPref | null };

export type DebriefAtsWriteOrgPrefQuery_thisOrg_Org_orgPrefs_OrgPref = (
  { __typename?: 'OrgPref' }
  & DebriefAtsWriteOrgPrefDataFragment
);

export type DebriefAtsWriteOrgPrefQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPrefs?: Array<DebriefAtsWriteOrgPrefQuery_thisOrg_Org_orgPrefs_OrgPref> | null };

export type DebriefAtsWriteOrgPrefQuery_Query = { __typename?: 'Query', thisOrg?: DebriefAtsWriteOrgPrefQuery_thisOrg_Org | null };


export type DebriefAtsWriteOrgPrefQueryVariables = Exact<{ [key: string]: never; }>;


export type DebriefAtsWriteOrgPrefQuery = DebriefAtsWriteOrgPrefQuery_Query;

export type UpdateDebriefAtsWriteOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref = (
  { __typename?: 'OrgPref' }
  & DebriefAtsWriteOrgPrefDataFragment
);

export type UpdateDebriefAtsWriteOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult = { __typename?: 'OrgPrefUpdateResult', orgPref?: UpdateDebriefAtsWriteOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref | null };

export type UpdateDebriefAtsWriteOrgPrefMutation_Mutation = { __typename?: 'Mutation', orgPrefUpdate?: UpdateDebriefAtsWriteOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult | null };


export type UpdateDebriefAtsWriteOrgPrefMutationVariables = Exact<{
  input: OrgPrefUpdateInput;
}>;


export type UpdateDebriefAtsWriteOrgPrefMutation = UpdateDebriefAtsWriteOrgPrefMutation_Mutation;

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref_hostEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref', hostEmployee?: InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref_hostEmployee_Employee | null }
  & InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragment
  & InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment
);

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference = { __typename?: 'NotificationPreference' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref = InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DateBlock | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewBufferTimePref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewLimit | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_NotificationPreference | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PaidFeaturePreference | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref | InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref_TimeBlockWeek;

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref_jsonPref | null };

export type InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org = { __typename?: 'Org', id: any, orgPref?: InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org_orgPref_OrgPref | null };

export type InterviewMeetingLocationSettingOrgPrefQuery_Query = { __typename?: 'Query', thisOrg?: InterviewMeetingLocationSettingOrgPrefQuery_thisOrg_Org | null };


export type InterviewMeetingLocationSettingOrgPrefQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type InterviewMeetingLocationSettingOrgPrefQuery = InterviewMeetingLocationSettingOrgPrefQuery_Query;

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref_hostEmployee_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref = { __typename?: 'AddZoomHostAsInternalInviteePref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref = { __typename?: 'AiOrgCustomLlmPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref = { __typename?: 'AtsJobSyncScopePref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref = { __typename?: 'CandidateCommunicationsSettingPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref = { __typename?: 'CandidateEventAdditionalAttendeesPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo = { __typename?: 'CandidateFacingHiringTeamContactInfo' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo = { __typename?: 'CandidateFacingInterviewerInfo' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref = { __typename?: 'ChatCommunicationsSettingPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DateBlock = { __typename?: 'DateBlock' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref = { __typename?: 'DebriefAtsWriteSettingPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref = { __typename?: 'DebriefEventAdditionalAttendeesPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref = { __typename?: 'EmployeeFieldSyncSourcePref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref', hostEmployee?: UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref_hostEmployee_Employee | null }
  & InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragment
  & InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragment
);

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref = { __typename?: 'InterviewerEventAdditionalAttendeesPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref = { __typename?: 'MinimumInterviewerLoadLimitOrgPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_NotificationPreference = { __typename?: 'NotificationPreference' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_PaidFeaturePreference = { __typename?: 'PaidFeaturePreference' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref = { __typename?: 'PortalConfigAutomationRulesPref' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_TimeBlockWeek = { __typename?: 'TimeBlockWeek' };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref = UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_AddZoomHostAsInternalInviteePref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_AiOrgCustomLlmPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_AtsJobSyncScopePref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateCommunicationsSettingPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateEventAdditionalAttendeesPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateFacingHiringTeamContactInfo | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_CandidateFacingInterviewerInfo | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_ChatCommunicationsSettingPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DateBlock | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DebriefAtsWriteSettingPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DebriefEventAdditionalAttendeesPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_DefaultCustomInterviewScheduleTokenPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_EmployeeFieldSyncSourcePref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewBufferTimePref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewLimit | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewMeetingLocationSettingPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_InterviewerEventAdditionalAttendeesPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_MinimumInterviewerLoadLimitOrgPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_NotificationPreference | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_PaidFeaturePreference | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_PortalConfigAutomationRulesPref | UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref_TimeBlockWeek;

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref = { __typename?: 'OrgPref', id: string, orgId: any, prefName: string, jsonPref?: UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref_jsonPref | null };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult = { __typename?: 'OrgPrefUpdateResult', orgPref?: UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult_orgPref_OrgPref | null };

export type UpdateInterviewMeetingLocationSettingOrgPrefMutation_Mutation = { __typename?: 'Mutation', orgPrefUpdate?: UpdateInterviewMeetingLocationSettingOrgPrefMutation_orgPrefUpdate_OrgPrefUpdateResult | null };


export type UpdateInterviewMeetingLocationSettingOrgPrefMutationVariables = Exact<{
  prefName: Scalars['String']['input'];
  json?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateInterviewMeetingLocationSettingOrgPrefMutation = UpdateInterviewMeetingLocationSettingOrgPrefMutation_Mutation;

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_actor_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_AbsentAuditLogPayload = { __typename: 'AbsentAuditLogPayload' };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_CapturedAuditLogPayload = { __typename: 'CapturedAuditLogPayload', text: string, truncated: boolean };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_ExpiredAuditLogPayload = { __typename: 'ExpiredAuditLogPayload' };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_TooLargeAuditLogPayload = { __typename: 'TooLargeAuditLogPayload', maxBytes: number };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput = McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_AbsentAuditLogPayload | McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_CapturedAuditLogPayload | McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_ExpiredAuditLogPayload | McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput_TooLargeAuditLogPayload;

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_AbsentAuditLogPayload = { __typename: 'AbsentAuditLogPayload' };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_CapturedAuditLogPayload = { __typename: 'CapturedAuditLogPayload', text: string, truncated: boolean };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_ExpiredAuditLogPayload = { __typename: 'ExpiredAuditLogPayload' };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_TooLargeAuditLogPayload = { __typename: 'TooLargeAuditLogPayload', maxBytes: number };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput = McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_AbsentAuditLogPayload | McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_CapturedAuditLogPayload | McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_ExpiredAuditLogPayload | McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput_TooLargeAuditLogPayload;

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry = { __typename?: 'McpToolCallAuditLogEntry', id: string, calledAt: any, actorId: string, tokenType: PlatformAuditTokenType, tokenName?: string | null, toolName: string, intent?: string | null, status: PlatformAuditCallStatus, errorCode?: string | null, durationMs?: number | null, actor?: McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_actor_Employee | null, toolInput: McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolInput, toolOutput: McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry_toolOutput };

export type McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult = { __typename?: 'McpToolCallAuditLogsResult', nextCursor?: string | null, items: Array<McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult_items_McpToolCallAuditLogEntry> };

export type McpToolCallAuditLogsQuery_Query = { __typename?: 'Query', mcpToolCallAuditLogs: McpToolCallAuditLogsQuery_mcpToolCallAuditLogs_McpToolCallAuditLogsResult };


export type McpToolCallAuditLogsQueryVariables = Exact<{
  input: McpToolCallAuditLogsInput;
}>;


export type McpToolCallAuditLogsQuery = McpToolCallAuditLogsQuery_Query;

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_actor_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_AbsentAuditLogPayload = { __typename: 'AbsentAuditLogPayload' };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_CapturedAuditLogPayload = { __typename: 'CapturedAuditLogPayload', text: string, truncated: boolean };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_ExpiredAuditLogPayload = { __typename: 'ExpiredAuditLogPayload' };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_TooLargeAuditLogPayload = { __typename: 'TooLargeAuditLogPayload', maxBytes: number };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody = ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_AbsentAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_CapturedAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_ExpiredAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody_TooLargeAuditLogPayload;

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_AbsentAuditLogPayload = { __typename: 'AbsentAuditLogPayload' };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_CapturedAuditLogPayload = { __typename: 'CapturedAuditLogPayload', text: string, truncated: boolean };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_ExpiredAuditLogPayload = { __typename: 'ExpiredAuditLogPayload' };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_TooLargeAuditLogPayload = { __typename: 'TooLargeAuditLogPayload', maxBytes: number };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery = ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_AbsentAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_CapturedAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_ExpiredAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery_TooLargeAuditLogPayload;

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_AbsentAuditLogPayload = { __typename: 'AbsentAuditLogPayload' };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_CapturedAuditLogPayload = { __typename: 'CapturedAuditLogPayload', text: string, truncated: boolean };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_ExpiredAuditLogPayload = { __typename: 'ExpiredAuditLogPayload' };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_TooLargeAuditLogPayload = { __typename: 'TooLargeAuditLogPayload', maxBytes: number };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody = ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_AbsentAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_CapturedAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_ExpiredAuditLogPayload | ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody_TooLargeAuditLogPayload;

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry = { __typename?: 'ApiRequestAuditLogEntry', id: string, requestedAt: any, actorId: string, tokenType: PlatformAuditTokenType, tokenName?: string | null, method: string, path: string, statusCode: number, durationMs?: number | null, actor?: ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_actor_Employee | null, requestBody: ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestBody, requestQuery: ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_requestQuery, responseBody: ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry_responseBody };

export type ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult = { __typename?: 'ApiRequestAuditLogsResult', nextCursor?: string | null, items: Array<ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult_items_ApiRequestAuditLogEntry> };

export type ApiRequestAuditLogsQuery_Query = { __typename?: 'Query', apiRequestAuditLogs: ApiRequestAuditLogsQuery_apiRequestAuditLogs_ApiRequestAuditLogsResult };


export type ApiRequestAuditLogsQueryVariables = Exact<{
  input: ApiRequestAuditLogsInput;
}>;


export type ApiRequestAuditLogsQuery = ApiRequestAuditLogsQuery_Query;

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_BulkPrivacyAuditLogEntry_actor_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string };

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry_subject_Candidate = { __typename: 'Candidate', id: any, fullName?: string | null, candidateEmail?: string | null };

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry_subject_Employee = { __typename: 'Employee', id: any, fullName?: string | null, employeeEmail: string };

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry_subject = PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry_subject_Candidate | PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry_subject_Employee;

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_BulkPrivacyAuditLogEntry = { __typename: 'BulkPrivacyAuditLogEntry', bulkQuery: string, bulkCount: number, bulkScope?: PrivacyAuditBulkScope | null, id: any, accessTime: any, actorId: any, ipAddresses: Array<string>, accessData: Array<PrivacyAuditAccessData>, accessMenu: string, accessMenuPath: string, activityCategory: PrivacyAuditActivityCategory, customData?: string | null, userProvidedReason?: string | null, actor?: PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_BulkPrivacyAuditLogEntry_actor_Employee | null };

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry = { __typename: 'SinglePrivacyAuditLogEntry', subjectType: PrivacyAuditSubjectType, subjectId: any, id: any, accessTime: any, actorId: any, ipAddresses: Array<string>, accessData: Array<PrivacyAuditAccessData>, accessMenu: string, accessMenuPath: string, activityCategory: PrivacyAuditActivityCategory, customData?: string | null, userProvidedReason?: string | null, subject?: PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry_subject | null, actor?: PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_BulkPrivacyAuditLogEntry_actor_Employee | null };

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items = PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_BulkPrivacyAuditLogEntry | PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items_SinglePrivacyAuditLogEntry;

export type PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult = { __typename?: 'PrivacyAuditLogsResult', nextCursor?: string | null, items: Array<PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult_items> };

export type PrivacyAuditLogsQuery_Query = { __typename?: 'Query', privacyAuditLogs: PrivacyAuditLogsQuery_privacyAuditLogs_PrivacyAuditLogsResult };


export type PrivacyAuditLogsQueryVariables = Exact<{
  input: PrivacyAuditLogsInput;
}>;


export type PrivacyAuditLogsQuery = PrivacyAuditLogsQuery_Query;

export type OrgApiKeyQuery_thisOrg_Org = { __typename?: 'Org', id: any, apiKey?: string | null };

export type OrgApiKeyQuery_Query = { __typename?: 'Query', thisOrg?: OrgApiKeyQuery_thisOrg_Org | null };


export type OrgApiKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgApiKeyQuery = OrgApiKeyQuery_Query;

export type OrgScimTokenQuery_thisOrg_Org = { __typename?: 'Org', id: any, scimToken?: string | null };

export type OrgScimTokenQuery_Query = { __typename?: 'Query', thisOrg?: OrgScimTokenQuery_thisOrg_Org | null };


export type OrgScimTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgScimTokenQuery = OrgScimTokenQuery_Query;

export type EditLanguagesEmployeeLocaleQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, locale?: Locale | null };

export type EditLanguagesEmployeeLocaleQuery_Query = { __typename?: 'Query', thisEmployee?: EditLanguagesEmployeeLocaleQuery_thisEmployee_Employee | null };


export type EditLanguagesEmployeeLocaleQueryVariables = Exact<{ [key: string]: never; }>;


export type EditLanguagesEmployeeLocaleQuery = EditLanguagesEmployeeLocaleQuery_Query;

export type LocaleTranslationStatusQuery_localeTranslationStatus_LocaleTranslationStatusResult = { __typename?: 'LocaleTranslationStatusResult', total: number, translated: number, missing: number };

export type LocaleTranslationStatusQuery_Query = { __typename?: 'Query', localeTranslationStatus: LocaleTranslationStatusQuery_localeTranslationStatus_LocaleTranslationStatusResult };


export type LocaleTranslationStatusQueryVariables = Exact<{
  input: LocaleTranslationStatusInput;
}>;


export type LocaleTranslationStatusQuery = LocaleTranslationStatusQuery_Query;

export type EditOrgNameDialog_OrgFragment = { __typename?: 'Org', id: any, name: string };

export type UpdateOrgNameMutation_orgUpdate_Org = (
  { __typename?: 'Org' }
  & EditOrgNameDialog_OrgFragment
);

export type UpdateOrgNameMutation_Mutation = { __typename?: 'Mutation', orgUpdate?: UpdateOrgNameMutation_orgUpdate_Org | null };


export type UpdateOrgNameMutationVariables = Exact<{
  input: OrgUpdateInput;
}>;


export type UpdateOrgNameMutation = UpdateOrgNameMutation_Mutation;

export type PortalCreateOrgSlugMutation_portalSlugCreate_PortalOrgSlug = { __typename?: 'PortalOrgSlug', orgId: any };

export type PortalCreateOrgSlugMutation_Mutation = { __typename?: 'Mutation', portalSlugCreate?: PortalCreateOrgSlugMutation_portalSlugCreate_PortalOrgSlug | null };


export type PortalCreateOrgSlugMutationVariables = Exact<{
  input: PortalSlugCreateInput;
}>;


export type PortalCreateOrgSlugMutation = PortalCreateOrgSlugMutation_Mutation;

export type OrgNameAndSlugQuery_thisOrg_Org_slugs_PortalOrgSlug = { __typename?: 'PortalOrgSlug', slug: string, isPrimary: boolean };

export type OrgNameAndSlugQuery_thisOrg_Org = (
  { __typename?: 'Org', id: any, name: string, domains: Array<string>, slugs: Array<OrgNameAndSlugQuery_thisOrg_Org_slugs_PortalOrgSlug> }
  & EditOrgNameDialog_OrgFragment
);

export type OrgNameAndSlugQuery_Query = { __typename?: 'Query', thisOrg?: OrgNameAndSlugQuery_thisOrg_Org | null };


export type OrgNameAndSlugQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgNameAndSlugQuery = OrgNameAndSlugQuery_Query;

export type TaskTagCreateMutation_taskTagCreate_TaskTagCreateOutput_taskTag_TaskTag = { __typename?: 'TaskTag', id: any, name: string };

export type TaskTagCreateMutation_taskTagCreate_TaskTagCreateOutput = { __typename?: 'TaskTagCreateOutput', taskTag: TaskTagCreateMutation_taskTagCreate_TaskTagCreateOutput_taskTag_TaskTag };

export type TaskTagCreateMutation_Mutation = { __typename?: 'Mutation', taskTagCreate?: TaskTagCreateMutation_taskTagCreate_TaskTagCreateOutput | null };


export type TaskTagCreateMutationVariables = Exact<{
  input: TaskTagCreateInput;
}>;


export type TaskTagCreateMutation = TaskTagCreateMutation_Mutation;

export type DeleteTagModal_TaskTagFragment = { __typename?: 'TaskTag', id: any, taskCount: number };

export type TaskTagDeleteMutation_taskTagDelete_TaskTagDeleteOutput = { __typename?: 'TaskTagDeleteOutput', ok: boolean };

export type TaskTagDeleteMutation_Mutation = { __typename?: 'Mutation', taskTagDelete?: TaskTagDeleteMutation_taskTagDelete_TaskTagDeleteOutput | null };


export type TaskTagDeleteMutationVariables = Exact<{
  input: TaskTagDeleteInput;
}>;


export type TaskTagDeleteMutation = TaskTagDeleteMutation_Mutation;

export type EditTagModal_TaskTagFragment = { __typename?: 'TaskTag', id: any, name: string };

export type TaskTagUpdateMutation_taskTagUpdate_TaskTagUpdateOutput_taskTag_TaskTag = (
  { __typename?: 'TaskTag' }
  & EditTagModal_TaskTagFragment
);

export type TaskTagUpdateMutation_taskTagUpdate_TaskTagUpdateOutput = { __typename?: 'TaskTagUpdateOutput', taskTag: TaskTagUpdateMutation_taskTagUpdate_TaskTagUpdateOutput_taskTag_TaskTag };

export type TaskTagUpdateMutation_Mutation = { __typename?: 'Mutation', taskTagUpdate?: TaskTagUpdateMutation_taskTagUpdate_TaskTagUpdateOutput | null };


export type TaskTagUpdateMutationVariables = Exact<{
  input: TaskTagUpdateInput;
}>;


export type TaskTagUpdateMutation = TaskTagUpdateMutation_Mutation;

export type TaskTagItem_TaskTagFragment = { __typename?: 'TaskTag', id: any, name: string, taskCount: number };

export type TaskTagList_TaskTagFragment = (
  { __typename?: 'TaskTag', id: any, name: string }
  & TaskTagItem_TaskTagFragment
  & EditTagModal_TaskTagFragment
);

export type TaskTagListQuery_taskTags_TaskTagsResult_items_TaskTag = (
  { __typename?: 'TaskTag' }
  & TaskTagList_TaskTagFragment
);

export type TaskTagListQuery_taskTags_TaskTagsResult = { __typename?: 'TaskTagsResult', nextCursor?: string | null, items: Array<TaskTagListQuery_taskTags_TaskTagsResult_items_TaskTag> };

export type TaskTagListQuery_Query = { __typename?: 'Query', taskTags?: TaskTagListQuery_taskTags_TaskTagsResult | null };


export type TaskTagListQueryVariables = Exact<{
  input: TaskTagsInput;
}>;


export type TaskTagListQuery = TaskTagListQuery_Query;

export type AddMemberModal_SelectedEmployeesFragment = (
  { __typename?: 'Employee', id: any }
  & EmployeeFragment
);

export type DeleteQueueModal_TaskQueueFragment = { __typename?: 'TaskQueue', id: any, name: string };

export type DeleteTaskQueueMutation_taskQueueDelete_TaskQueueDeleteResult = { __typename?: 'TaskQueueDeleteResult', result: Result };

export type DeleteTaskQueueMutation_Mutation = { __typename?: 'Mutation', taskQueueDelete?: DeleteTaskQueueMutation_taskQueueDelete_TaskQueueDeleteResult | null };


export type DeleteTaskQueueMutationVariables = Exact<{
  input: TaskQueueDeleteInput;
}>;


export type DeleteTaskQueueMutation = DeleteTaskQueueMutation_Mutation;

export type QueueDialogContent_QueueMembersFragment = (
  { __typename?: 'Employee', id: any }
  & AddMemberModal_SelectedEmployeesFragment
);

export type CreateTaskQueueMutation_taskQueueCreate_TaskQueueCreateOutput_taskQueue_TaskQueue = (
  { __typename?: 'TaskQueue', id: any }
  & QueueRow_TaskQueueFragment
);

export type CreateTaskQueueMutation_taskQueueCreate_TaskQueueCreateOutput = { __typename?: 'TaskQueueCreateOutput', taskQueue: CreateTaskQueueMutation_taskQueueCreate_TaskQueueCreateOutput_taskQueue_TaskQueue };

export type CreateTaskQueueMutation_Mutation = { __typename?: 'Mutation', taskQueueCreate?: CreateTaskQueueMutation_taskQueueCreate_TaskQueueCreateOutput | null };


export type CreateTaskQueueMutationVariables = Exact<{
  input: TaskQueueCreateInput;
}>;


export type CreateTaskQueueMutation = CreateTaskQueueMutation_Mutation;

export type EditTaskQueueMutation_taskQueueUpdate_TaskQueueUpdateOutput_taskQueue_TaskQueue = (
  { __typename?: 'TaskQueue', id: any }
  & QueueRow_TaskQueueFragment
);

export type EditTaskQueueMutation_taskQueueUpdate_TaskQueueUpdateOutput = { __typename?: 'TaskQueueUpdateOutput', taskQueue: EditTaskQueueMutation_taskQueueUpdate_TaskQueueUpdateOutput_taskQueue_TaskQueue };

export type EditTaskQueueMutation_Mutation = { __typename?: 'Mutation', taskQueueUpdate?: EditTaskQueueMutation_taskQueueUpdate_TaskQueueUpdateOutput | null };


export type EditTaskQueueMutationVariables = Exact<{
  input: TaskQueueUpdateInput;
}>;


export type EditTaskQueueMutation = EditTaskQueueMutation_Mutation;

export type SubscribersListQueueModalQuery_subscribers_SubscribersResult_items_Employee = (
  { __typename?: 'Employee', id: any }
  & QueueDialogContent_QueueMembersFragment
);

export type SubscribersListQueueModalQuery_subscribers_SubscribersResult = { __typename?: 'SubscribersResult', items: Array<SubscribersListQueueModalQuery_subscribers_SubscribersResult_items_Employee> };

export type SubscribersListQueueModalQuery_Query = { __typename?: 'Query', subscribers?: SubscribersListQueueModalQuery_subscribers_SubscribersResult | null };


export type SubscribersListQueueModalQueryVariables = Exact<{
  input: SubscribersInput;
}>;


export type SubscribersListQueueModalQuery = SubscribersListQueueModalQuery_Query;

export type QueueModal_TaskQueueFragment = { __typename?: 'TaskQueue', id: any, name: string, memberCount: number, taskCount: number };

export type QueueRow_TaskQueueFragment = (
  { __typename?: 'TaskQueue', id: any, memberCount: number, taskCount: number, name: string }
  & QueueModal_TaskQueueFragment
  & DeleteQueueModal_TaskQueueFragment
);

export type QueueList_TaskQueueFragment = (
  { __typename?: 'TaskQueue', id: any }
  & QueueRow_TaskQueueFragment
);

export type TaskQueuesQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue = (
  { __typename?: 'TaskQueue' }
  & QueueList_TaskQueueFragment
);

export type TaskQueuesQuery_taskQueueSearch_TaskQueueSearchResult = { __typename?: 'TaskQueueSearchResult', items: Array<TaskQueuesQuery_taskQueueSearch_TaskQueueSearchResult_items_TaskQueue> };

export type TaskQueuesQuery_Query = { __typename?: 'Query', taskQueueSearch?: TaskQueuesQuery_taskQueueSearch_TaskQueueSearchResult | null };


export type TaskQueuesQueryVariables = Exact<{
  input: TaskQueueSearchInput;
}>;


export type TaskQueuesQuery = TaskQueuesQuery_Query;

export type RescheduleReasonCreateMutation_rescheduleReasonCreate_RescheduleReasonUpsertResult_rescheduleReason_RescheduleReason = { __typename?: 'RescheduleReason', id: any, reason: string };

export type RescheduleReasonCreateMutation_rescheduleReasonCreate_RescheduleReasonUpsertResult = { __typename?: 'RescheduleReasonUpsertResult', rescheduleReason?: RescheduleReasonCreateMutation_rescheduleReasonCreate_RescheduleReasonUpsertResult_rescheduleReason_RescheduleReason | null };

export type RescheduleReasonCreateMutation_Mutation = { __typename?: 'Mutation', rescheduleReasonCreate?: RescheduleReasonCreateMutation_rescheduleReasonCreate_RescheduleReasonUpsertResult | null };


export type RescheduleReasonCreateMutationVariables = Exact<{
  input: RescheduleReasonCreateInput;
}>;


export type RescheduleReasonCreateMutation = RescheduleReasonCreateMutation_Mutation;

export type EditRescheduleReasonModal_RescheduleReasonFragment = { __typename?: 'RescheduleReason', id: any, reason: string };

export type RescheduleReasonUpdateMutation_rescheduleReasonUpdate_RescheduleReasonUpsertResult_rescheduleReason_RescheduleReason = (
  { __typename?: 'RescheduleReason' }
  & EditRescheduleReasonModal_RescheduleReasonFragment
);

export type RescheduleReasonUpdateMutation_rescheduleReasonUpdate_RescheduleReasonUpsertResult = { __typename?: 'RescheduleReasonUpsertResult', rescheduleReason?: RescheduleReasonUpdateMutation_rescheduleReasonUpdate_RescheduleReasonUpsertResult_rescheduleReason_RescheduleReason | null };

export type RescheduleReasonUpdateMutation_Mutation = { __typename?: 'Mutation', rescheduleReasonUpdate?: RescheduleReasonUpdateMutation_rescheduleReasonUpdate_RescheduleReasonUpsertResult | null };


export type RescheduleReasonUpdateMutationVariables = Exact<{
  input: RescheduleReasonUpdateInput;
}>;


export type RescheduleReasonUpdateMutation = RescheduleReasonUpdateMutation_Mutation;

export type RescheduleReasonItem_RescheduleReasonFragment = { __typename?: 'RescheduleReason', id: any, reason: string, type: string, archivedAt?: any | null };

export type RescheduleReasonsList_RescheduleReasonFragment = (
  { __typename?: 'RescheduleReason', id: any, reason: string }
  & RescheduleReasonItem_RescheduleReasonFragment
  & EditRescheduleReasonModal_RescheduleReasonFragment
);

export type RescheduleReasonsListQuery_rescheduleReasons_RescheduleReasonsResult_items_RescheduleReason = (
  { __typename?: 'RescheduleReason' }
  & RescheduleReasonsList_RescheduleReasonFragment
);

export type RescheduleReasonsListQuery_rescheduleReasons_RescheduleReasonsResult = { __typename?: 'RescheduleReasonsResult', nextCursor?: string | null, items: Array<RescheduleReasonsListQuery_rescheduleReasons_RescheduleReasonsResult_items_RescheduleReason> };

export type RescheduleReasonsListQuery_Query = { __typename?: 'Query', rescheduleReasons?: RescheduleReasonsListQuery_rescheduleReasons_RescheduleReasonsResult | null };


export type RescheduleReasonsListQueryVariables = Exact<{
  input: RescheduleReasonsInput;
}>;


export type RescheduleReasonsListQuery = RescheduleReasonsListQuery_Query;

export type EmployeesWithOnBehalfOfPermissionQuery_employeeSearch_EmployeeSearchOutput_items_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, email: string, internalProfilePictureUrl?: string | null };

export type EmployeesWithOnBehalfOfPermissionQuery_employeeSearch_EmployeeSearchOutput = { __typename?: 'EmployeeSearchOutput', items: Array<EmployeesWithOnBehalfOfPermissionQuery_employeeSearch_EmployeeSearchOutput_items_Employee> };

export type EmployeesWithOnBehalfOfPermissionQuery_Query = { __typename?: 'Query', employeeSearch?: EmployeesWithOnBehalfOfPermissionQuery_employeeSearch_EmployeeSearchOutput | null };


export type EmployeesWithOnBehalfOfPermissionQueryVariables = Exact<{
  input: EmployeeSearchInput;
}>;


export type EmployeesWithOnBehalfOfPermissionQuery = EmployeesWithOnBehalfOfPermissionQuery_Query;

export type AttachmentsFragment_Template_attachments_Attachment = { __typename?: 'Attachment', name?: string | null, path?: string | null, size?: any | null, timestamp?: any | null };

export type AttachmentsFragment = { __typename?: 'Template', attachments?: Array<AttachmentsFragment_Template_attachments_Attachment> | null };

export type TemplateFragFragment = { __typename?: 'Template', id: any, type: TemplateType, locale: Locale, name?: string | null, updatedAt: any, subject?: string | null, body?: string | null, isOrganizationDefault: boolean, isSystem: boolean, liveSettingsUsages: any, lastSentAt?: any | null };

export type DefaultTemplateForTypesQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateFragFragment
);

export type DefaultTemplateForTypesQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<DefaultTemplateForTypesQuery_templates_TemplatesOutput_items_Template> };

export type DefaultTemplateForTypesQuery_Query = { __typename?: 'Query', templates?: DefaultTemplateForTypesQuery_templates_TemplatesOutput | null };


export type DefaultTemplateForTypesQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type DefaultTemplateForTypesQuery = DefaultTemplateForTypesQuery_Query;

export type OrganizationTemplatesQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template' }
  & TemplateFragFragment
);

export type OrganizationTemplatesQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<OrganizationTemplatesQuery_templates_TemplatesOutput_items_Template> };

export type OrganizationTemplatesQuery_Query = { __typename?: 'Query', templates?: OrganizationTemplatesQuery_templates_TemplatesOutput | null };


export type OrganizationTemplatesQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type OrganizationTemplatesQuery = OrganizationTemplatesQuery_Query;

export type OrganizationTemplateCreateMutation_templateCreate_TemplateResult_template_Template = (
  { __typename?: 'Template' }
  & TemplateFragFragment
  & AttachmentsFragment
);

export type OrganizationTemplateCreateMutation_templateCreate_TemplateResult = { __typename?: 'TemplateResult', template?: OrganizationTemplateCreateMutation_templateCreate_TemplateResult_template_Template | null };

export type OrganizationTemplateCreateMutation_Mutation = { __typename?: 'Mutation', templateCreate?: OrganizationTemplateCreateMutation_templateCreate_TemplateResult | null };


export type OrganizationTemplateCreateMutationVariables = Exact<{
  input: TemplateCreateInput;
}>;


export type OrganizationTemplateCreateMutation = OrganizationTemplateCreateMutation_Mutation;

export type OrganizationTemplateUpdateMutation_templateUpdate_TemplateResult_template_Template = (
  { __typename?: 'Template' }
  & TemplateFragFragment
  & AttachmentsFragment
);

export type OrganizationTemplateUpdateMutation_templateUpdate_TemplateResult = { __typename?: 'TemplateResult', template?: OrganizationTemplateUpdateMutation_templateUpdate_TemplateResult_template_Template | null };

export type OrganizationTemplateUpdateMutation_Mutation = { __typename?: 'Mutation', templateUpdate?: OrganizationTemplateUpdateMutation_templateUpdate_TemplateResult | null };


export type OrganizationTemplateUpdateMutationVariables = Exact<{
  input: TemplateUpdateInput;
}>;


export type OrganizationTemplateUpdateMutation = OrganizationTemplateUpdateMutation_Mutation;

export type OrganizationTemplateDeleteMutation_templateDelete_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type OrganizationTemplateDeleteMutation_templateDelete_TemplateResult = { __typename?: 'TemplateResult', template?: OrganizationTemplateDeleteMutation_templateDelete_TemplateResult_template_Template | null };

export type OrganizationTemplateDeleteMutation_Mutation = { __typename?: 'Mutation', templateDelete?: OrganizationTemplateDeleteMutation_templateDelete_TemplateResult | null };


export type OrganizationTemplateDeleteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type OrganizationTemplateDeleteMutation = OrganizationTemplateDeleteMutation_Mutation;

export type TemplateAttachementsQuery_template_Template = (
  { __typename?: 'Template', id: any }
  & AttachmentsFragment
);

export type TemplateAttachementsQuery_Query = { __typename?: 'Query', template?: TemplateAttachementsQuery_template_Template | null };


export type TemplateAttachementsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TemplateAttachementsQuery = TemplateAttachementsQuery_Query;

export type TemplateDeleteConfirmModal_TemplateFragment = { __typename?: 'Template', id: any, name?: string | null, liveSettingsUsages: any };

export type TemplateDeleteConfirmModal_OrgDefaultTemplateFragment = { __typename?: 'Template', id: any, name?: string | null };

export type TemplateMenu_TemplateFragment = (
  { __typename?: 'Template', id: any, isOrganizationDefault: boolean, isSystem: boolean, type: TemplateType }
  & TemplateDeleteConfirmModal_TemplateFragment
);

export type TemplateMenu_OrgDefaultTemplateFragment = (
  { __typename?: 'Template', id: any }
  & TemplateDeleteConfirmModal_OrgDefaultTemplateFragment
);

export type DeleteTemplateMutation_templateDelete_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type DeleteTemplateMutation_templateDelete_TemplateResult = { __typename?: 'TemplateResult', template?: DeleteTemplateMutation_templateDelete_TemplateResult_template_Template | null };

export type DeleteTemplateMutation_Mutation = { __typename?: 'Mutation', templateDelete?: DeleteTemplateMutation_templateDelete_TemplateResult | null };


export type DeleteTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTemplateMutation = DeleteTemplateMutation_Mutation;

export type TemplateModal_TemplateFragment_Template_attachments_Attachment = { __typename?: 'Attachment', name?: string | null, timestamp?: any | null, path?: string | null, size?: any | null };

export type TemplateModal_TemplateFragment = (
  { __typename?: 'Template', id: any, name?: string | null, type: TemplateType, locale: Locale, subject?: string | null, body?: string | null, isOrganizationDefault: boolean, isSystem: boolean, liveSettingsUsages: any, attachments?: Array<TemplateModal_TemplateFragment_Template_attachments_Attachment> | null }
  & TemplateTypeChangeConfirmModal_TemplateFragment
);

export type TemplateCreateMutation_templateCreate_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type TemplateCreateMutation_templateCreate_TemplateResult = { __typename?: 'TemplateResult', template?: TemplateCreateMutation_templateCreate_TemplateResult_template_Template | null };

export type TemplateCreateMutation_Mutation = { __typename?: 'Mutation', templateCreate?: TemplateCreateMutation_templateCreate_TemplateResult | null };


export type TemplateCreateMutationVariables = Exact<{
  input: TemplateCreateInput;
}>;


export type TemplateCreateMutation = TemplateCreateMutation_Mutation;

export type TemplateUpdateMutation_templateUpdate_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type TemplateUpdateMutation_templateUpdate_TemplateResult = { __typename?: 'TemplateResult', template?: TemplateUpdateMutation_templateUpdate_TemplateResult_template_Template | null };

export type TemplateUpdateMutation_Mutation = { __typename?: 'Mutation', templateUpdate?: TemplateUpdateMutation_templateUpdate_TemplateResult | null };


export type TemplateUpdateMutationVariables = Exact<{
  input: TemplateUpdateInput;
}>;


export type TemplateUpdateMutation = TemplateUpdateMutation_Mutation;

export type TemplateTypeChangeConfirmModal_TemplateFragment = { __typename?: 'Template', id: any, liveSettingsUsages: any };

export type TemplatesQuery_templates_TemplatesOutput_items_Template = (
  { __typename?: 'Template', id: any }
  & Template_TemplateFragment
  & Template_OrgDefaultTemplateFragment
  & TemplateModal_TemplateFragment
);

export type TemplatesQuery_templates_TemplatesOutput = { __typename?: 'TemplatesOutput', items: Array<TemplatesQuery_templates_TemplatesOutput_items_Template> };

export type TemplatesQuery_Query = { __typename?: 'Query', templates?: TemplatesQuery_templates_TemplatesOutput | null };


export type TemplatesQueryVariables = Exact<{
  input: TemplatesInput;
}>;


export type TemplatesQuery = TemplatesQuery_Query;

export type SetTemplateAsOrgDefaultMutation_templateUpdate_TemplateResult_template_Template = { __typename?: 'Template', id: any };

export type SetTemplateAsOrgDefaultMutation_templateUpdate_TemplateResult = { __typename?: 'TemplateResult', template?: SetTemplateAsOrgDefaultMutation_templateUpdate_TemplateResult_template_Template | null };

export type SetTemplateAsOrgDefaultMutation_Mutation = { __typename?: 'Mutation', templateUpdate?: SetTemplateAsOrgDefaultMutation_templateUpdate_TemplateResult | null };


export type SetTemplateAsOrgDefaultMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  isOrganizationDefault: Scalars['Boolean']['input'];
}>;


export type SetTemplateAsOrgDefaultMutation = SetTemplateAsOrgDefaultMutation_Mutation;

export type Template_TemplateFragment = (
  { __typename?: 'Template', id: any, name?: string | null, type: TemplateType, locale: Locale, isOrganizationDefault: boolean, isSystem: boolean, updatedAt: any, lastSentAt?: any | null }
  & TemplateMenu_TemplateFragment
);

export type Template_OrgDefaultTemplateFragment = (
  { __typename?: 'Template' }
  & TemplateMenu_OrgDefaultTemplateFragment
);

export type CustomInterviewScheduleTokenPreviewQuery_customInterviewScheduleTokenPreview_CustomInterviewScheduleTokenPreviewResult = { __typename?: 'CustomInterviewScheduleTokenPreviewResult', html?: string | null };

export type CustomInterviewScheduleTokenPreviewQuery_Query = { __typename?: 'Query', customInterviewScheduleTokenPreview?: CustomInterviewScheduleTokenPreviewQuery_customInterviewScheduleTokenPreview_CustomInterviewScheduleTokenPreviewResult | null };


export type CustomInterviewScheduleTokenPreviewQueryVariables = Exact<{
  input: CustomInterviewScheduleTokenPreviewInput;
}>;


export type CustomInterviewScheduleTokenPreviewQuery = CustomInterviewScheduleTokenPreviewQuery_Query;

export type DefaultCustomInterviewScheduleTokenQuery_defaultCustomInterviewScheduleToken_DefaultCustomInterviewScheduleTokenPref_uniqueMeetingLinkFormat_DefaultMeetingLinkFormat = { __typename?: 'DefaultMeetingLinkFormat', zoomLinkFormat?: string | null, workspaceVideoLinkFormat?: string | null, customLinkFormat?: string | null };

export type DefaultCustomInterviewScheduleTokenQuery_defaultCustomInterviewScheduleToken_DefaultCustomInterviewScheduleTokenPref_singleMeetingLinkFormat_DefaultMeetingLinkFormat = { __typename?: 'DefaultMeetingLinkFormat', zoomLinkFormat?: string | null, workspaceVideoLinkFormat?: string | null, customLinkFormat?: string | null };

export type DefaultCustomInterviewScheduleTokenQuery_defaultCustomInterviewScheduleToken_DefaultCustomInterviewScheduleTokenPref = { __typename?: 'DefaultCustomInterviewScheduleTokenPref', dateHeaderFormat: string, breakDividerFormat: string, interviewDetailWithTime: string, codingLinkFormat?: string | null, candidatePhoneNumberFormat?: string | null, uniqueMeetingLinkFormat?: DefaultCustomInterviewScheduleTokenQuery_defaultCustomInterviewScheduleToken_DefaultCustomInterviewScheduleTokenPref_uniqueMeetingLinkFormat_DefaultMeetingLinkFormat | null, singleMeetingLinkFormat?: DefaultCustomInterviewScheduleTokenQuery_defaultCustomInterviewScheduleToken_DefaultCustomInterviewScheduleTokenPref_singleMeetingLinkFormat_DefaultMeetingLinkFormat | null };

export type DefaultCustomInterviewScheduleTokenQuery_Query = { __typename?: 'Query', defaultCustomInterviewScheduleToken?: DefaultCustomInterviewScheduleTokenQuery_defaultCustomInterviewScheduleToken_DefaultCustomInterviewScheduleTokenPref | null };


export type DefaultCustomInterviewScheduleTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type DefaultCustomInterviewScheduleTokenQuery = DefaultCustomInterviewScheduleTokenQuery_Query;

export type OrgTranslationsQuery_orgTranslations_OrgTranslationsResult_rows_TranslationRow_cells_TranslationCell = { __typename?: 'TranslationCell', locale: Locale, value?: string | null, isMissing: boolean };

export type OrgTranslationsQuery_orgTranslations_OrgTranslationsResult_rows_TranslationRow = { __typename?: 'TranslationRow', category: TranslationEntityType, entityId: any, sourceText: string, cells: Array<OrgTranslationsQuery_orgTranslations_OrgTranslationsResult_rows_TranslationRow_cells_TranslationCell> };

export type OrgTranslationsQuery_orgTranslations_OrgTranslationsResult = { __typename?: 'OrgTranslationsResult', rows: Array<OrgTranslationsQuery_orgTranslations_OrgTranslationsResult_rows_TranslationRow> };

export type OrgTranslationsQuery_Query = { __typename?: 'Query', orgTranslations: OrgTranslationsQuery_orgTranslations_OrgTranslationsResult };


export type OrgTranslationsQueryVariables = Exact<{
  input: OrgTranslationsInput;
}>;


export type OrgTranslationsQuery = OrgTranslationsQuery_Query;

export type AgendaTab_UpcomingEventsFragment = (
  { __typename?: 'UpcomingEvent' }
  & SchedulesList_UpcomingEventsFragment
);

export type AgendaTab_DebriefsFragment = (
  { __typename?: 'ApplicationDebrief' }
  & SchedulesList_DebriefsFragment
);

export type FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_interviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any };

export type FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_candidateEvent_ApplicationStageCandidateEvent = { __typename?: 'ApplicationStageCandidateEvent', id: any };

export type FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, anonymizedAt?: any | null };

export type FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage_application_Application_candidate_Candidate | null };

export type FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage = { __typename?: 'ApplicationStage', id: any, taskId?: any | null, jobStage?: FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage_jobStage_JobStage | null, application?: FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage_application_Application | null };

export type FullCalendarViews_UpcomingEventsFragment = { __typename?: 'UpcomingEvent', startAt: any, endAt: any, dayIndex: any, dayTotal: any, interviews?: Array<FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_interviews_ApplicationStageInterview> | null, candidateEvent?: FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_candidateEvent_ApplicationStageCandidateEvent | null, schedule: FullCalendarViews_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage };

export type FullCalendarViews_DebriefsFragment_ApplicationDebrief_task_Task = { __typename?: 'Task', id: any };

export type FullCalendarViews_DebriefsFragment_ApplicationDebrief_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, anonymizedAt?: any | null };

export type FullCalendarViews_DebriefsFragment_ApplicationDebrief_application_Application = { __typename?: 'Application', id: any, candidate?: FullCalendarViews_DebriefsFragment_ApplicationDebrief_application_Application_candidate_Candidate | null };

export type FullCalendarViews_DebriefsFragment = { __typename?: 'ApplicationDebrief', id: any, startAt?: any | null, endAt?: any | null, task?: FullCalendarViews_DebriefsFragment_ApplicationDebrief_task_Task | null, application?: FullCalendarViews_DebriefsFragment_ApplicationDebrief_application_Application | null };

export type DebriefListItem_DebriefFragment_ApplicationDebrief_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type DebriefListItem_DebriefFragment_ApplicationDebrief_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any }
  & Candidate_CandidateFragment
);

export type DebriefListItem_DebriefFragment_ApplicationDebrief_application_Application = { __typename?: 'Application', id: any, job?: DebriefListItem_DebriefFragment_ApplicationDebrief_application_Application_job_Job | null, candidate?: DebriefListItem_DebriefFragment_ApplicationDebrief_application_Application_candidate_Candidate | null };

export type DebriefListItem_DebriefFragment_ApplicationDebrief_attendees_ApplicationDebriefAttendee_interviewer_Employee = { __typename?: 'Employee', id: any, fullName?: string | null, internalProfilePictureUrl?: string | null };

export type DebriefListItem_DebriefFragment_ApplicationDebrief_attendees_ApplicationDebriefAttendee = { __typename?: 'ApplicationDebriefAttendee', interviewerId: any, responseStatus?: ResponseStatus | null, isOptional: boolean, interviewer?: DebriefListItem_DebriefFragment_ApplicationDebrief_attendees_ApplicationDebriefAttendee_interviewer_Employee | null };

export type DebriefListItem_DebriefFragment = { __typename?: 'ApplicationDebrief', id: any, name?: string | null, startAt?: any | null, endAt?: any | null, googleEventUrl?: string | null, application?: DebriefListItem_DebriefFragment_ApplicationDebrief_application_Application | null, attendees?: Array<DebriefListItem_DebriefFragment_ApplicationDebrief_attendees_ApplicationDebriefAttendee> | null };

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any }
  & Candidate_CandidateFragment
);

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_application_Application = { __typename?: 'Application', id: any, job?: ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_application_Application_job_Job | null, candidate?: ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_application_Application_candidate_Candidate | null };

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage = { __typename?: 'ApplicationStage', id: any, isHoldForRsvp: boolean, isReadyForCandidateComms: boolean, jobStage?: ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_jobStage_JobStage | null, application?: ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage_application_Application | null };

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_candidateEvent_ApplicationStageCandidateEvent = { __typename?: 'ApplicationStageCandidateEvent', id: any, responseStatus?: ResponseStatus | null };

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_interviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = (
  { __typename?: 'ApplicationStageInterviewInterviewer', interviewerId: any, responseStatus?: ResponseStatus | null }
  & AvatarFacePile_InterviewersFragment
);

export type ScheduleListItem_UpcomingEventFragment_UpcomingEvent_interviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, applicationStageInterviewInterviewers?: Array<ScheduleListItem_UpcomingEventFragment_UpcomingEvent_interviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null };

export type ScheduleListItem_UpcomingEventFragment = { __typename?: 'UpcomingEvent', startAt: any, endAt: any, dayIndex: any, dayTotal: any, schedule: ScheduleListItem_UpcomingEventFragment_UpcomingEvent_schedule_ApplicationStage, candidateEvent?: ScheduleListItem_UpcomingEventFragment_UpcomingEvent_candidateEvent_ApplicationStageCandidateEvent | null, interviews?: Array<ScheduleListItem_UpcomingEventFragment_UpcomingEvent_interviews_ApplicationStageInterview> | null };

export type SchedulesList_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage = { __typename?: 'ApplicationStage', id: any, taskId?: any | null };

export type SchedulesList_UpcomingEventsFragment = (
  { __typename?: 'UpcomingEvent', schedule: SchedulesList_UpcomingEventsFragment_UpcomingEvent_schedule_ApplicationStage }
  & ScheduleListItem_UpcomingEventFragment
);

export type SchedulesList_DebriefsFragment_ApplicationDebrief_task_Task = { __typename?: 'Task', id: any };

export type SchedulesList_DebriefsFragment = (
  { __typename?: 'ApplicationDebrief', task?: SchedulesList_DebriefsFragment_ApplicationDebrief_task_Task | null }
  & DebriefListItem_DebriefFragment
);

export type UpcomingEventsQuery_upcomingEvents_UpcomingEventsResult = (
  { __typename?: 'UpcomingEventsResult' }
  & Views_UpcomingEventsResultFragment
);

export type UpcomingEventsQuery_Query = { __typename?: 'Query', upcomingEvents?: UpcomingEventsQuery_upcomingEvents_UpcomingEventsResult | null };


export type UpcomingEventsQueryVariables = Exact<{
  input: UpcomingEventsInput;
  includeDebriefs: Scalars['Boolean']['input'];
}>;


export type UpcomingEventsQuery = UpcomingEventsQuery_Query;

export type Views_UpcomingEventsFragment = (
  { __typename?: 'UpcomingEvent', startAt: any, endAt: any }
  & AgendaTab_UpcomingEventsFragment
);

export type Views_DebriefsFragment = (
  { __typename?: 'ApplicationDebrief' }
  & AgendaTab_DebriefsFragment
  & FullCalendarViews_DebriefsFragment
);

export type Views_UpcomingEventsResultFragment_UpcomingEventsResult_items_UpcomingEvent = (
  { __typename?: 'UpcomingEvent' }
  & Views_UpcomingEventsFragment
);

export type Views_UpcomingEventsResultFragment_UpcomingEventsResult_debriefs_ApplicationDebrief = (
  { __typename?: 'ApplicationDebrief' }
  & Views_DebriefsFragment
);

export type Views_UpcomingEventsResultFragment = { __typename?: 'UpcomingEventsResult', items: Array<Views_UpcomingEventsResultFragment_UpcomingEventsResult_items_UpcomingEvent>, debriefs?: Array<Views_UpcomingEventsResultFragment_UpcomingEventsResult_debriefs_ApplicationDebrief> };

export type UpcomingEventsPageFiltersEmployeePrefFragment = { __typename?: 'UpcomingEventsPageFiltersPref', schedulerEmployeeIds: Array<any>, recruiterEmployeeIds: Array<any>, interviewerEmployeeIds: Array<any>, candidateRsvps: Array<ResponseStatus>, interviewerRsvps: Array<ResponseStatus>, allAccepted: boolean, taskAssigneeEmployeeIds: Array<any> };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = (
  { __typename?: 'UpcomingEventsPageFiltersPref' }
  & UpcomingEventsPageFiltersEmployeePrefFragment
);

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref = UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_InterviewLimit | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_ProfilePicturePref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref_jsonPref | null };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult = { __typename?: 'EmployeePrefUpdateResult', employeePref?: UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult_employeePref_EmployeePref | null };

export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation_Mutation = { __typename?: 'Mutation', employeePrefUpdate?: UpdateUpcomingEventsPageFiltersEmployeePrefMutation_employeePrefUpdate_EmployeePrefUpdateResult | null };


export type UpdateUpcomingEventsPageFiltersEmployeePrefMutationVariables = Exact<{
  input: EmployeePrefUpdateInput;
}>;


export type UpdateUpcomingEventsPageFiltersEmployeePrefMutation = UpdateUpcomingEventsPageFiltersEmployeePrefMutation_Mutation;

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref = { __typename?: 'CandidatePageFiltersPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref = { __typename?: 'DirectoryPageFiltersPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref = { __typename?: 'EmployeeTaskDashboardFilterPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref = { __typename?: 'EmployeeTaskDashboardLayoutPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref = { __typename?: 'InterviewBufferTimePref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit = { __typename?: 'InterviewLimit' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref = { __typename?: 'MetricsPageAverageTimesFiltersPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref = { __typename?: 'MetricsPageCandidatePulseFiltersPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref = { __typename?: 'MetricsPageInterviewerFiltersPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref = { __typename?: 'MetricsPageRecruitingTeamFiltersPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref = { __typename?: 'ProfilePicturePref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref = { __typename?: 'RecentlyUsedZoomUsersPref' };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref = (
  { __typename?: 'UpcomingEventsPageFiltersPref' }
  & UpcomingEventsPageFiltersEmployeePrefFragment
);

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref = UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_CandidatePageFiltersPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_DirectoryPageFiltersPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardFilterPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_EmployeeTaskDashboardLayoutPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewBufferTimePref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_InterviewLimit | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageAverageTimesFiltersPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageCandidatePulseFiltersPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageInterviewerFiltersPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_MetricsPageRecruitingTeamFiltersPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_ProfilePicturePref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_RecentlyUsedZoomUsersPref | UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref_UpcomingEventsPageFiltersPref;

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref = { __typename?: 'EmployeePref', id: string, jsonPref?: UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref_jsonPref | null };

export type UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, employeePref?: UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee_employeePref_EmployeePref | null };

export type UpcomingEventsPageFiltersEmployeePrefQuery_Query = { __typename?: 'Query', thisEmployee?: UpcomingEventsPageFiltersEmployeePrefQuery_thisEmployee_Employee | null };


export type UpcomingEventsPageFiltersEmployeePrefQueryVariables = Exact<{
  prefName: Scalars['String']['input'];
}>;


export type UpcomingEventsPageFiltersEmployeePrefQuery = UpcomingEventsPageFiltersEmployeePrefQuery_Query;

export type UpdateCommunicationsPreview_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UseSubmitUpdateSchedule_InterviewPlanFragment
);

export type UseSubmitUpdateSchedule_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & UsePopulateEventData_InterviewPlanFragment
  & UseGetInterviewers_InterviewPlanFragment
);

export type UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration = { __typename?: 'CoderpadIntegration', apiKey: string };

export type UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration = { __typename?: 'CodilityIntegration', apiKey: string };

export type UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration = { __typename?: 'CodesignalIntegration', apiKey: string };

export type UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration = { __typename?: 'HackerRankIntegration', apiKey: string };

export type UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations = { __typename?: 'OrgIntegrations', id: any, coderpad?: UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_coderpad_CoderpadIntegration | null, codility?: UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codility_CodilityIntegration | null, codesignal?: UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_codesignal_CodesignalIntegration | null, hackerrank?: UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations_hackerrank_HackerRankIntegration | null };

export type UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org = { __typename?: 'Org', id: any, integrations?: UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org_integrations_OrgIntegrations | null };

export type UpdateCommunicationsOrgIntegrationQuery_Query = { __typename?: 'Query', thisOrg?: UpdateCommunicationsOrgIntegrationQuery_thisOrg_Org | null };


export type UpdateCommunicationsOrgIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateCommunicationsOrgIntegrationQuery = UpdateCommunicationsOrgIntegrationQuery_Query;

export type UpdateCommunications_CandidateFragment = (
  { __typename?: 'Candidate', id: any, fullName?: string | null, preferredName?: string | null, preferredPhoneNumber?: string | null }
  & CodingCard_CandidateFragment
);

export type UpdateCommunications_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & CandidateEmailCard_InterviewPlanFragment
  & CandidateEventCard_InterviewPlanFragment
  & CodingCard_InterviewPlanFragment
  & InterviewerCommunicationCards_InterviewPlanFragment
  & SlackChannelCard_InterviewPlanFragment
  & UpdateCommunicationsPreview_InterviewPlanFragment
);

export type UpdateCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref = (
  { __typename?: 'InterviewMeetingLocationSettingPref' }
  & LocationCard_InterviewMeetingLocationSettingFragment
);

export type UpdateCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel = { __typename?: 'InterviewMeetingLocationSettingWithLevel', interviewMeetingLocationSetting?: UpdateCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel_interviewMeetingLocationSetting_InterviewMeetingLocationSettingPref | null };

export type UpdateCommunications_JobStageSettingsFragment = (
  { __typename?: 'JobStageSettingsV2', id: any, interviewMeetingLocationSettingWithLevel?: UpdateCommunications_JobStageSettingsFragment_JobStageSettingsV2_interviewMeetingLocationSettingWithLevel_InterviewMeetingLocationSettingWithLevel | null }
  & SlackChannelCard_JobStageSettingsV2Fragment
);

export type UpdateCommunications_TaskFragment = (
  { __typename?: 'Task', id: any }
  & CandidateEmailCard_TaskFragment
);

export type UpdateFlowDoneQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidateId: any };

export type UpdateFlowDoneQuery_applicationStage_ApplicationStage_task_Task_debriefs_ApplicationDebrief = { __typename?: 'ApplicationDebrief', id: any };

export type UpdateFlowDoneQuery_applicationStage_ApplicationStage_task_Task = { __typename?: 'Task', id: any, isDebriefRequired: boolean, debriefs: Array<UpdateFlowDoneQuery_applicationStage_ApplicationStage_task_Task_debriefs_ApplicationDebrief> };

export type UpdateFlowDoneQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, isHoldForRsvp: boolean, isReadyForCandidateComms: boolean, application?: UpdateFlowDoneQuery_applicationStage_ApplicationStage_application_Application | null, task?: UpdateFlowDoneQuery_applicationStage_ApplicationStage_task_Task | null };

export type UpdateFlowDoneQuery_Query = { __typename?: 'Query', applicationStage?: UpdateFlowDoneQuery_applicationStage_ApplicationStage | null };


export type UpdateFlowDoneQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateFlowDoneQuery = UpdateFlowDoneQuery_Query;

export type UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string };

export type UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, timezone?: string | null };

export type UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_application_Application_job_Job = { __typename?: 'Job', id: any, name: string };

export type UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null, job?: UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_application_Application_job_Job | null };

export type UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, taskId?: any | null, name?: string | null, jobStage?: UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_jobStage_JobStage | null, application?: UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage_application_Application | null };

export type UpdateScheduleFlowHeaderQuery_Query = { __typename?: 'Query', applicationStage?: UpdateScheduleFlowHeaderQuery_applicationStage_ApplicationStage | null };


export type UpdateScheduleFlowHeaderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateScheduleFlowHeaderQuery = UpdateScheduleFlowHeaderQuery_Query;

export type UpdateFlowBase_TaskFragment = (
  { __typename?: 'Task', id: any }
  & UpdateCommunications_TaskFragment
);

export type UpdateFlow_TaskFragment = (
  { __typename?: 'Task', id: any }
  & UpdateFlowBase_TaskFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability = (
  { __typename?: 'CandidateAtsAvailability', timezone?: any | null, originalText?: string | null }
  & UseCandidateAvailability_AtsLatestAvailabilityFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate = (
  { __typename?: 'Candidate', id: any, timezone?: string | null, atsLatestAvailability?: UpdateFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsLatestAvailability_CandidateAtsAvailability | null }
  & ScheduleFlowDataProvider_CandidateFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, candidate?: UpdateFlowQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null };

export type UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job_jobSettings_JobSettings = (
  { __typename?: 'JobSettings', id: any }
  & ScheduleFlowDataProvider_JobSettingsFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job = (
  { __typename?: 'Job', id: any, name: string, atsId: string, jobSettings: UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job_jobSettings_JobSettings }
  & ScheduleInterviewPlan_JobFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = (
  { __typename?: 'JobStageSettingsV2', id: any }
  & ScheduleFlowDataProvider_JobStageSettingsFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, name: string, job?: UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_job_Job | null, jobStageSettingsV2?: UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type UpdateFlowQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability = (
  { __typename?: 'CandidateAvailability', id: any }
  & UseCandidateAvailability_AvailabilitiesFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_task_Task_interviewPlan_JobStage = (
  { __typename?: 'JobStage', id: any }
  & ScheduleFlowDataProvider_InterviewPlanFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage_task_Task = (
  { __typename?: 'Task', id: any, availabilities: Array<UpdateFlowQuery_applicationStage_ApplicationStage_task_Task_availabilities_CandidateAvailability>, interviewPlan: UpdateFlowQuery_applicationStage_ApplicationStage_task_Task_interviewPlan_JobStage }
  & ScheduleFlowDataProvider_TaskFragment
  & UpdateFlow_TaskFragment
);

export type UpdateFlowQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, application?: UpdateFlowQuery_applicationStage_ApplicationStage_application_Application | null, jobStage?: UpdateFlowQuery_applicationStage_ApplicationStage_jobStage_JobStage | null, task?: UpdateFlowQuery_applicationStage_ApplicationStage_task_Task | null };

export type UpdateFlowQuery_Query = { __typename?: 'Query', applicationStage?: UpdateFlowQuery_applicationStage_ApplicationStage | null };


export type UpdateFlowQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateFlowQuery = UpdateFlowQuery_Query;

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_conversation_Conversation = { __typename?: 'Conversation', id: any, remoteName: string };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent = { __typename?: 'ApplicationStageCandidateEvent', id: any, name?: string | null, googleEventId?: string | null, googleCalendarId?: string | null, calendarEventTemplateId?: string | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_jobStage_JobStage_job_Job = { __typename?: 'Job', id: any, atsId: string };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_jobStage_JobStage = { __typename?: 'JobStage', id: any, atsId?: string | null, job?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_jobStage_JobStage_job_Job | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsCandidate_AtsCandidate = { __typename?: 'AtsCandidate', atsId: string, atsUrl: string };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any, fullName?: string | null, email?: string | null, additionalEmails?: Array<string> | null, atsCandidate?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate_atsCandidate_AtsCandidate | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application = { __typename?: 'Application', id: any, jobStage?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_jobStage_JobStage | null, candidate?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application_candidate_Candidate | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_collaborationLink_CollaborationLink = { __typename?: 'CollaborationLink', id: any, collaborationToolType: CollaborationToolType, collaborationLinkTemplateId?: any | null, url: string };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo = { __typename?: 'DialInfo', type?: string | null, number?: string | null, city?: string | null, countryName?: string | null, country?: string | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo = { __typename?: 'ZoomInfo', password?: string | null, meetingId?: any | null, userId?: string | null, pstnPassword?: string | null, dialInfo?: Array<ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo_dialInfo_DialInfo> | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails = { __typename?: 'MeetingLocationDetails', customLocation?: string | null, zoomInfo?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails_zoomInfo_ZoomInfo | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_hostEmployee_Employee = { __typename?: 'Employee', id: any };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_remoteVideoMeetingHostUser_ZoomUser = { __typename?: 'ZoomUser', zoomUserId: string };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation = { __typename?: 'MeetingLocation', id: any, type: InterviewMeetingLocationType, videoMeetingLink?: string | null, details?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_details_MeetingLocationDetails | null, hostEmployee?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_hostEmployee_Employee | null, remoteVideoMeetingHostUser?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation_remoteVideoMeetingHostUser_ZoomUser | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee = { __typename?: 'Employee', id: any, atsId?: string | null, fullName?: string | null, internalProfilePictureUrl?: string | null, email: string, givenName?: string | null, timezone?: string | null, title?: string | null, linkedinUrl?: string | null, familyName?: string | null, orgId: any, isDirectoryDisabled: boolean, useCalendarTimezone: boolean, isPaused: boolean };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer = { __typename?: 'ApplicationStageInterviewInterviewer', interviewModuleId?: any | null, isOptional: boolean, jobStageInterviewSeatId?: any | null, role?: InterviewerRole | null, responseStatus?: ResponseStatus | null, interviewerId: any, interviewer?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer_interviewer_Employee | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom = { __typename?: 'ApplicationStageInterviewRoom', applicationStageInterviewId: any, meetingRoomId: any, responseStatus?: ResponseStatus | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_atsInterviewDefinition_AtsInterviewDefinition = (
  { __typename?: 'AtsInterviewDefinition' }
  & AtsInterviewDefinitionFragment
);

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_interviewGuide_InterviewGuide = { __typename?: 'InterviewGuide', id: any };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview = { __typename?: 'ApplicationStageInterview', id: any, name?: string | null, endAt: any, startAt: any, googleEventId?: string | null, googleCalendarId?: string | null, jobStageInterviewId?: any | null, videoMeetingUrl?: string | null, zoomHostUserId?: string | null, zoomMeetingId?: any | null, zoomPassword?: string | null, zoomPstnPassword?: any | null, zoomDialInInfo?: any | null, codingInterviewUrl?: string | null, emailTemplateId?: string | null, isHiddenFromCandidate: boolean, videoMeetingHostEmployeeId?: any | null, atsScheduledInterviewId?: string | null, atsInterviewDefinitionId?: string | null, collaborationLink?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_collaborationLink_CollaborationLink | null, meetingLocation?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_meetingLocation_MeetingLocation | null, applicationStageInterviewInterviewers?: Array<ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewInterviewers_ApplicationStageInterviewInterviewer> | null, applicationStageInterviewRooms?: Array<ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_applicationStageInterviewRooms_ApplicationStageInterviewRoom> | null, atsInterviewDefinition?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_atsInterviewDefinition_AtsInterviewDefinition | null, interviewGuide?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview_interviewGuide_InterviewGuide | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_slackTemplateId_SettingTemplateId = { __typename?: 'SettingTemplateId', templateId?: any | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateCalendarId_SettingCalendarId = { __typename?: 'SettingCalendarId', remoteCalendarId?: string | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 = { __typename?: 'JobStageSettingsV2', id: any, candidateEmailTemplateId?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEmailTemplateId_SettingTemplateId | null, candidateEventTemplateId?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateEventTemplateId_SettingTemplateId | null, interviewerEventTemplateId?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerEventTemplateId_SettingTemplateId | null, slackTemplateId?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_slackTemplateId_SettingTemplateId | null, interviewerCalendarId?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_interviewerCalendarId_SettingCalendarId | null, candidateCalendarId?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2_candidateCalendarId_SettingCalendarId | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage = { __typename?: 'JobStage', id: any, jobStageSettingsV2?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage_jobStageSettingsV2_JobStageSettingsV2 | null };

export type ApplicationStageInterviewQuery_applicationStage_ApplicationStage = { __typename?: 'ApplicationStage', id: any, isCancelled: boolean, applicationId?: any | null, jobStageId?: any | null, emailTemplateId?: string | null, timezone?: string | null, videoMeetingUrl?: string | null, initialEmailSubject?: string | null, initialEmailBody?: string | null, isPrivateCalendarEvent: boolean, conversation?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_conversation_Conversation | null, applicationStageCandidateEvents?: Array<ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageCandidateEvents_ApplicationStageCandidateEvent> | null, application?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_application_Application | null, applicationStageInterviews?: Array<ApplicationStageInterviewQuery_applicationStage_ApplicationStage_applicationStageInterviews_ApplicationStageInterview> | null, jobStage?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage_jobStage_JobStage | null };

export type ApplicationStageInterviewQuery_Query = { __typename?: 'Query', applicationStage?: ApplicationStageInterviewQuery_applicationStage_ApplicationStage | null };


export type ApplicationStageInterviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApplicationStageInterviewQuery = ApplicationStageInterviewQuery_Query;

export type BaseUpdateCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview = (
  { __typename?: 'JobStageInterview', id: any }
  & InterviewDetails_InterviewFragment
  & InterviewDetails_OriginalInterviewsFragment
);

export type BaseUpdateCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup = { __typename?: 'JobStageInterviewGroup', id: any, jobStageInterviews?: Array<BaseUpdateCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup_jobStageInterviews_JobStageInterview> | null };

export type BaseUpdateCalendarView_InterviewPlanFragment = { __typename?: 'JobStage', id: any, jobStageInterviewGroups?: Array<BaseUpdateCalendarView_InterviewPlanFragment_JobStage_jobStageInterviewGroups_JobStageInterviewGroup> | null };

export type UpdateCalendarView_InterviewPlanFragment = (
  { __typename?: 'JobStage', id: any }
  & BaseUpdateCalendarView_InterviewPlanFragment
  & UsePopulateEventData_InterviewPlanFragment
);

export type OAuthConnectedAppsAdapterQuery_oauthConnectedApps_OAuthConnectedAppGrant = { __typename?: 'OAuthConnectedAppGrant', grantId: any, clientName: string, actingEmployeeName: string, scopes: Array<string>, createdAt: any, lastUsedAt?: any | null, status: OAuthConnectedAppGrantStatus };

export type OAuthConnectedAppsAdapterQuery_Query = { __typename?: 'Query', oauthConnectedApps: Array<OAuthConnectedAppsAdapterQuery_oauthConnectedApps_OAuthConnectedAppGrant> };


export type OAuthConnectedAppsAdapterQueryVariables = Exact<{
  input: OAuthConnectedAppsInput;
}>;


export type OAuthConnectedAppsAdapterQuery = OAuthConnectedAppsAdapterQuery_Query;

export type OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_OAuthGrantRevokeFailureAlreadyRevoked = { __typename: 'OAuthGrantRevokeFailureAlreadyRevoked', errorCode: ErrorCode, errorMessage: string };

export type OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_OAuthGrantRevokeFailureNotFound = { __typename: 'OAuthGrantRevokeFailureNotFound', errorCode: ErrorCode, errorMessage: string };

export type OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_OAuthGrantRevokeSuccess = { __typename: 'OAuthGrantRevokeSuccess', grantId: any };

export type OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type OAuthGrantRevokeAdapterMutation_oauthGrantRevoke = OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_OAuthGrantRevokeFailureAlreadyRevoked | OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_OAuthGrantRevokeFailureNotFound | OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_OAuthGrantRevokeSuccess | OAuthGrantRevokeAdapterMutation_oauthGrantRevoke_UnknownError;

export type OAuthGrantRevokeAdapterMutation_Mutation = { __typename?: 'Mutation', oauthGrantRevoke: OAuthGrantRevokeAdapterMutation_oauthGrantRevoke };


export type OAuthGrantRevokeAdapterMutationVariables = Exact<{
  input: OAuthGrantRevokeInput;
}>;


export type OAuthGrantRevokeAdapterMutation = OAuthGrantRevokeAdapterMutation_Mutation;

export type AccountPhoneNumberQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, phoneNumber?: string | null, email: string };

export type AccountPhoneNumberQuery_Query = { __typename?: 'Query', thisEmployee?: AccountPhoneNumberQuery_thisEmployee_Employee | null };


export type AccountPhoneNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountPhoneNumberQuery = AccountPhoneNumberQuery_Query;

export type Notification_EmployeeNotificationPrefFragment = { __typename?: 'EmployeeNotificationPreference', employeeId: any, type: EmployeeNotificationType, medium: EmployeeNotificationMedium, value: boolean };

export type EmployeeNotificationPrefsQuery_thisEmployee_Employee_notificationPrefs_EmployeeNotificationPreference = (
  { __typename?: 'EmployeeNotificationPreference' }
  & Notification_EmployeeNotificationPrefFragment
);

export type EmployeeNotificationPrefsQuery_thisEmployee_Employee = { __typename?: 'Employee', id: any, notificationPrefs: Array<EmployeeNotificationPrefsQuery_thisEmployee_Employee_notificationPrefs_EmployeeNotificationPreference> };

export type EmployeeNotificationPrefsQuery_Query = { __typename?: 'Query', thisEmployee?: EmployeeNotificationPrefsQuery_thisEmployee_Employee | null };


export type EmployeeNotificationPrefsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployeeNotificationPrefsQuery = EmployeeNotificationPrefsQuery_Query;

export type EmployeeNotificationPrefMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult_employeeNotificationPref_EmployeeNotificationPreference = (
  { __typename?: 'EmployeeNotificationPreference' }
  & Notification_EmployeeNotificationPrefFragment
);

export type EmployeeNotificationPrefMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult = { __typename?: 'EmployeeNotificationPrefUpdateResult', employeeNotificationPref?: EmployeeNotificationPrefMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult_employeeNotificationPref_EmployeeNotificationPreference | null };

export type EmployeeNotificationPrefMutation_Mutation = { __typename?: 'Mutation', employeeNotificationPrefUpdate?: EmployeeNotificationPrefMutation_employeeNotificationPrefUpdate_EmployeeNotificationPrefUpdateResult | null };


export type EmployeeNotificationPrefMutationVariables = Exact<{
  input: EmployeeNotificationPrefUpdateInput;
}>;


export type EmployeeNotificationPrefMutation = EmployeeNotificationPrefMutation_Mutation;

export type InterviewModuleMemberMenuOptionsQuery_interviewModuleMember_InterviewModuleMember = (
  { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any }
  & InterviewModuleMemberMenuOptionsFragment
  & RemoveMemberModal_InterviewModuleMemberFragment
  & SetModuleMemberAsTrained_InterviewModuleMemberFragment
  & PauseMemberModal_ModuleMemberFragment
  & SetModuleMemberAsTrainee_ModuleMemberFragment
);

export type InterviewModuleMemberMenuOptionsQuery_Query = { __typename?: 'Query', interviewModuleMember?: InterviewModuleMemberMenuOptionsQuery_interviewModuleMember_InterviewModuleMember | null };


export type InterviewModuleMemberMenuOptionsQueryVariables = Exact<{
  interviewModuleId: Scalars['uuid']['input'];
  employeeId: Scalars['uuid']['input'];
}>;


export type InterviewModuleMemberMenuOptionsQuery = InterviewModuleMemberMenuOptionsQuery_Query;

export type InterviewModuleMemberMenuOptionsFragment = { __typename?: 'InterviewModuleMember', employeeId: any, interviewModuleId: any, status: TrainingStatus };

export type MockScheduleTask_TaskFragment = { __typename?: 'Task', id: any };

export type MockUseScheduleTaskMenuOptions_TaskFragment = { __typename?: 'Task', id: any };

export type TaskSetIsUrgentMutation_taskSetIsUrgent_Task = { __typename?: 'Task', id: any, isUrgent: boolean };

export type TaskSetIsUrgentMutation_Mutation = { __typename?: 'Mutation', taskSetIsUrgent: TaskSetIsUrgentMutation_taskSetIsUrgent_Task };


export type TaskSetIsUrgentMutationVariables = Exact<{
  input: TaskSetIsUrgentInput;
}>;


export type TaskSetIsUrgentMutation = TaskSetIsUrgentMutation_Mutation;

export type TaskCancelMutation_taskCancel_Task = { __typename?: 'Task', id: any };

export type TaskCancelMutation_Mutation = { __typename?: 'Mutation', taskCancel: TaskCancelMutation_taskCancel_Task };


export type TaskCancelMutationVariables = Exact<{
  input: TaskCancelInput;
}>;


export type TaskCancelMutation = TaskCancelMutation_Mutation;

export type TaskPokeAgentMutation_taskPokeAgent_TaskPokeAgentSuccess_task_Task = { __typename?: 'Task', id: any, delegateStatus: string };

export type TaskPokeAgentMutation_taskPokeAgent_TaskPokeAgentFailureNotDelegated = { __typename: 'TaskPokeAgentFailureNotDelegated', errorCode: ErrorCode, errorMessage: string };

export type TaskPokeAgentMutation_taskPokeAgent_TaskPokeAgentSuccess = { __typename: 'TaskPokeAgentSuccess', task: TaskPokeAgentMutation_taskPokeAgent_TaskPokeAgentSuccess_task_Task };

export type TaskPokeAgentMutation_taskPokeAgent_UnknownError = { __typename: 'UnknownError', errorCode: ErrorCode, errorMessage: string };

export type TaskPokeAgentMutation_taskPokeAgent = TaskPokeAgentMutation_taskPokeAgent_TaskPokeAgentFailureNotDelegated | TaskPokeAgentMutation_taskPokeAgent_TaskPokeAgentSuccess | TaskPokeAgentMutation_taskPokeAgent_UnknownError;

export type TaskPokeAgentMutation_Mutation = { __typename?: 'Mutation', taskPokeAgent: TaskPokeAgentMutation_taskPokeAgent };


export type TaskPokeAgentMutationVariables = Exact<{
  input: TaskPokeAgentInput;
}>;


export type TaskPokeAgentMutation = TaskPokeAgentMutation_Mutation;

export type ScheduleTaskQuery_task_Task_application_Application_candidate_Candidate = { __typename?: 'Candidate', id: any };

export type ScheduleTaskQuery_task_Task_application_Application = { __typename?: 'Application', id: any, candidate?: ScheduleTaskQuery_task_Task_application_Application_candidate_Candidate | null };

export type ScheduleTaskQuery_task_Task = (
  { __typename?: 'Task', application: ScheduleTaskQuery_task_Task_application_Application }
  & ScheduleTask_TaskFragment
  & UseSchduleTaskMenuOptions_TaskFragment
);

export type ScheduleTaskQuery_Query = { __typename?: 'Query', task?: ScheduleTaskQuery_task_Task | null };


export type ScheduleTaskQueryVariables = Exact<{
  scheduleTaskId: Scalars['uuid']['input'];
}>;


export type ScheduleTaskQuery = ScheduleTaskQuery_Query;

export type UseSchduleTaskMenuOptions_TaskFragment = { __typename?: 'Task', id: any, isUrgent: boolean, status: TaskStatus, delegateType: string };

export const TaskName_TaskFragmentDoc = gql`
    fragment TaskName_task on Task {
  id
  name
}
    `;
export const ActivityLogAvatar_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAvatar_activityLog on ActivityLog {
  id
  activityActorType
  actorEmployee {
    id
    fullName
    internalProfilePictureUrl
  }
  details {
    __typename
  }
}
    `;
export const ActivityLogBase_ActivityLogFragmentDoc = gql`
    fragment ActivityLogBase_activityLog on ActivityLog {
  id
  source {
    ... on Task {
      id
      __typename
    }
    ... on Task @include(if: $showTaskName) {
      ...TaskName_task
    }
  }
  createdAt
  sourceType
  activityActorType
  actorEmployee {
    id
    fullName
    internalProfilePictureUrl
  }
  details {
    ... on ActivityLogTaskDetails {
      __typename
      task {
        id
        createdBy {
          id
          fullName
        }
      }
    }
  }
  ...ActivityLogAvatar_activityLog
}
    ${TaskName_TaskFragmentDoc}
${ActivityLogAvatar_ActivityLogFragmentDoc}`;
export const ActivityLogTaskClosedDueToStageChange_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskClosedDueToStageChange_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
  details {
    ... on ActivityLogTaskDetails {
      __typename
    }
  }
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskDebriefRescheduled_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskDebriefRescheduled_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskMigrated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskMigrated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogApplicationCandidatePortalNoteCreated_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogCandidatePortalNoteDetails {
      candidatePortalNoteId
      portalNoteContent: content
      sendToCandidate
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateAnonymized_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateAnonymized_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogApplicationCandidatePortalNoteUpdated_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogCandidatePortalNoteDetails {
      candidatePortalNoteId
      portalNoteContent: content
      sendToCandidate
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragmentDoc = gql`
    fragment ActivityLogApplicationCandidatePortalNoteDeleted_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogCandidatePortalNoteDetails {
      candidatePortalNoteId
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogEmail_ActivityLogFragmentDoc = gql`
    fragment ActivityLogEmail_activityLog on ActivityLog {
  id
  activityType
  details {
    ... on ActivityLogEmailDetails {
      __typename
      fromEmailAddress
      toEmailAddress
      ccAddresses
      subject
      body
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogEmployeeEmailSent_ActivityLogFragmentDoc = gql`
    fragment ActivityLogEmployeeEmailSent_activityLog on ActivityLog {
  id
  activityType
  details {
    ... on ActivityLogEmployeeEmailSentDetails {
      __typename
      employeeId
      employeeName
      fromEmailAddress
      toEmailAddress
      ccAddresses
      subject
      body
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogEmployeeEmailReceived_ActivityLogFragmentDoc = gql`
    fragment ActivityLogEmployeeEmailReceived_activityLog on ActivityLog {
  id
  activityType
  details {
    ... on ActivityLogEmployeeEmailReceivedDetails {
      __typename
      employeeId
      employeeName
      fromEmailAddress
      toEmailAddress
      ccAddresses
      subject
      body
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogEmployeeSlackMessageReceived_ActivityLogFragmentDoc = gql`
    fragment ActivityLogEmployeeSlackMessageReceived_activityLog on ActivityLog {
  id
  activityType
  details {
    ... on ActivityLogEmployeeSlackMessageReceivedDetails {
      __typename
      employeeId
      employeeName
      channelId
      threadTs
      messageTs
      body
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogEmployeeSlackMessageSent_ActivityLogFragmentDoc = gql`
    fragment ActivityLogEmployeeSlackMessageSent_activityLog on ActivityLog {
  id
  activityType
  details {
    ... on ActivityLogEmployeeSlackMessageSentDetails {
      __typename
      employeeId
      employeeName
      channelId
      threadTs
      messageTs
      body
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogNote_ActivityLogFragmentDoc = gql`
    fragment ActivityLogNote_activityLog on ActivityLog {
  id
  activityActorEmployeeId
  details {
    ... on ActivityLogNoteDetails {
      __typename
      note
      isEdited
      content {
        markdown
        plaintext
        formatVersion
        editorStateJson
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskAgentDelegated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskAgentDelegated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskAgentThinking_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskAgentThinking_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskAgentUndelegated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskAgentUndelegated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogAgentMessage_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAgentMessage_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogAgentMessageDetails {
      __typename
      message
      content {
        markdown
        plaintext
        formatVersion
        editorStateJson
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogAgentQuestion_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAgentQuestion_activityLog on ActivityLog {
  id
  source {
    ... on Task {
      id
    }
  }
  details {
    ... on ActivityLogAgentQuestionDetails {
      __typename
      question
      options
      content {
        markdown
        plaintext
        formatVersion
        editorStateJson
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogAgentReasoning_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAgentReasoning_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogAgentReasoningDetails {
      __typename
      reasoning
      content {
        markdown
        plaintext
        formatVersion
        editorStateJson
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogAgentDebug_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAgentDebug_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogAgentDebugDetails {
      __typename
      json
    }
  }
}
    `;
export const ActivityLogAgentToolCalls_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAgentToolCalls_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogAgentToolCallsDetails {
      __typename
      toolCalls {
        toolName
        toolCallId
        argumentsJson
        displayLabelPresent
        displayLabelPast
      }
      completedToolCalls {
        toolName
        toolCallId
        resultJson
        isError
      }
    }
    ... on ActivityLogAgentToolCallsStartDetails {
      __typename
      toolCalls {
        toolName
        toolCallId
        argumentsJson
        displayLabelPresent
        displayLabelPast
      }
    }
    ... on ActivityLogAgentToolCallsContinueDetails {
      __typename
      remainingToolCalls {
        toolName
        toolCallId
        argumentsJson
        displayLabelPresent
        displayLabelPast
      }
      completedToolCalls {
        toolName
        toolCallId
        resultJson
        isError
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogAgentQueued_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAgentQueued_activityLog on ActivityLog {
  id
  source {
    ... on Task {
      id
    }
  }
  details {
    ... on ActivityLogAgentQueuedDetails {
      startAt
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogAgentStopped_ActivityLogFragmentDoc = gql`
    fragment ActivityLogAgentStopped_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskAssigned_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskAssigned_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogTaskAssigneeDetails {
      assigneeId
      assignee {
        id
        fullName
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCalendarChanges_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCalendarChanges_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateAvailabilityDeleted_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateAvailabilityDeleted_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateRsvp_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateRsvp_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogRsvpDetails {
      startAt
      endAt
      responseStatus
      comment
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateSelfScheduleCanceled_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskEventDetails {
      __typename
      selfScheduleCandidateNote
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateSelfScheduleCreated_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskEventDetails {
      __typename
      selfScheduleCandidateNote
      sourcingLinkId
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateSelfScheduleRescheduled_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskEventDetails {
      __typename
      selfScheduleCandidateNote
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateSubmittedAvailability_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskAvailabilityDetails {
      sourcingLinkId
      note
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskChangedStatus_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskChangedStatus_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogTaskStatusDetails {
      taskStatus
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskChangeRequested_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskChangeRequested_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogFlagDetails {
      flagContent
      __typename
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskClosed_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskClosed_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskDetails {
      __typename
      taskId
      task {
        id
        ...TaskName_task
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${TaskName_TaskFragmentDoc}
${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCreated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCreated_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskDetails {
      __typename
      taskId
      sourcingLinkId
      task {
        id
        creationSource
        ...TaskName_task
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${TaskName_TaskFragmentDoc}
${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskDebriefCanceled_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskDebriefCanceled_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskDebriefCreated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskDebriefCreated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskEditedAvailability_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskEditedAvailability_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskFlagAdded_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskFlagAdded_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogFlagDetails {
      flagContent
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskFlagLifecycleResolved_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskFlagLifecycleResolved_activityLog on ActivityLog {
  id
  activityType
  plaintext
  details {
    ... on ActivityLogTaskInterviewerDetails {
      __typename
      interviewName
      interviewer {
        id
        fullName
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskFlagResolvedCandidateDeclined_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskFlagResolvedCandidateDeclined_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskFlagResolvedChangeRequested_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogFlagDetails {
      flagContent
      __typename
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskFlagResolvedDebriefDeclined_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskInterviewerDetails {
      __typename
      interviewName
      interviewer {
        id
        fullName
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskFlagResolvedInterviewDeclined_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskInterviewerDetails {
      __typename
      interviewName
      interviewer {
        id
        fullName
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRcAdjustInterviewerRsvp_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogRsvpDetails {
      interviewName
      responseStatus
      comment
      rsvp: interviewer {
        fullName
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskMarkedUrgent_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskMarkedUrgent_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskMeetingRoomRsvp_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskMeetingRoomRsvp_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskMeetingRoomDetails {
      __typename
      responseStatus
      comment
      interviewName
      room {
        id
        name
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRescheduleLogCreated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRescheduleLogCreated_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogRescheduleLogDetails {
      __typename
      rescheduleLog {
        id
        rescheduleReason {
          reason
        }
        note
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRescheduleLogDeleted_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRescheduleLogDeleted_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogRescheduleLogDetails {
      __typename
      rescheduleLog {
        id
        note
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRescheduleLogEdited_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRescheduleLogEdited_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogRescheduleLogDetails {
      __typename
      rescheduleLog {
        id
        note
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskReopened_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskReopened_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskDetails {
      __typename
      taskId
      task {
        id
        ...TaskName_task
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${TaskName_TaskFragmentDoc}
${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementApplicationDebriefAdded_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementApplicationDebriefAdded_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementApplicationDebriefRemoved_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementApplicationDebriefRemoved_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementCandidateAvailabilityAdded_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementCandidateAvailabilityAdded_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementCandidateAvailabilityRemoved_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementCandidateAvailabilityRemoved_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementCandidateAvailabilityUpdated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementCandidateAvailabilityUpdated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementScheduleAdded_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementScheduleAdded_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementSelfScheduleAdded_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementSelfScheduleAdded_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementSelfScheduleRemoved_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementSelfScheduleRemoved_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskRequirementSelfScheduleUpdated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskRequirementSelfScheduleUpdated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskScheduleCanceled_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskScheduleCanceled_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskScheduleCreated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskScheduleCreated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskScheduleRescheduled_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskScheduleRescheduled_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskScheduleUpdated_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskScheduleUpdated_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskTagAdded_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskTagAdded_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogTaskTagDetails {
      taskTags {
        id
        name
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskTagRemoved_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskTagRemoved_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskTagDetails {
      taskTags {
        id
        name
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskUnassigned_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskUnassigned_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskUnmarkedUrgent_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskUnmarkedUrgent_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskReadyForCandidateComm_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskReadyForCandidateComm_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogCandidateViewedTabDetails_ActivityLogFragmentDoc = gql`
    fragment ActivityLogCandidateViewedTabDetails_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogCandidateViewedTabDetails {
      __typename
      tabName
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskQueueSet_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskQueueSet_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogTaskQueueDetails {
      taskQueue {
        id
        name
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskQueueUnset_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskQueueUnset_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogTaskQueueDetails {
      taskQueue {
        id
        name
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateInterviewReminderSent_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateInterviewReminderSent_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateSelfScheduleReminderSent_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateSelfScheduleReminderSent_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidateAvailabilityReminderSent_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidateAvailabilityReminderSent_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskDeclinedInterviewerAutoReplaced_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogRsvpDetails {
      interviewName
      previous: interviewer {
        fullName
      }
      current: addedInterviewer {
        fullName
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragmentDoc = gql`
    fragment ActivityLogCandidatePreferredPhoneNumberChangeDetails_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogCandidatePreferredPhoneNumberChangeDetails {
      updatedPhoneNumber
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogInterviewerRsvpDeclined_ActivityLogFragmentDoc = gql`
    fragment ActivityLogInterviewerRsvpDeclined_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogInterviewerRsvpDeclinedDetails {
      __typename
      interviewName
      comment
      proposedTime {
        startAt
        endAt
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogInterviewerRsvpAccepted_ActivityLogFragmentDoc = gql`
    fragment ActivityLogInterviewerRsvpAccepted_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogInterviewerRsvpAcceptedDetails {
      __typename
      interviewName
      comment
      proposedTime {
        startAt
        endAt
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogInterviewerRsvpTentative_ActivityLogFragmentDoc = gql`
    fragment ActivityLogInterviewerRsvpTentative_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogInterviewerRsvpTentativeDetails {
      __typename
      interviewName
      comment
      proposedTime {
        startAt
        endAt
      }
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogCandidateRsvpAccepted_ActivityLogFragmentDoc = gql`
    fragment ActivityLogCandidateRsvpAccepted_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogCandidateRsvpAcceptedDetails {
      __typename
      startAt
      endAt
      comment
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogCandidateRsvpDeclined_ActivityLogFragmentDoc = gql`
    fragment ActivityLogCandidateRsvpDeclined_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogCandidateRsvpDeclinedDetails {
      __typename
      startAt
      endAt
      comment
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogCandidateRsvpTentative_ActivityLogFragmentDoc = gql`
    fragment ActivityLogCandidateRsvpTentative_activityLog on ActivityLog {
  id
  details {
    __typename
    ... on ActivityLogCandidateRsvpTentativeDetails {
      __typename
      startAt
      endAt
      comment
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidatePulseSurveyRequested_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidatePulseSurveyRequested_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskCandidatePulseSurveySubmitted_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskCandidatePulseSurveySubmitted_activityLog on ActivityLog {
  id
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskAutoCancelFailed_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskAutoCancelFailed_activityLog on ActivityLog {
  id
  details {
    ... on ActivityLogTaskAutoCancelFailedDetails {
      __typename
      failureReason
      failureMessage
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragmentDoc = gql`
    fragment ActivityLogTaskSourcingLinkResumeUpload_activityLog on ActivityLog {
  id
  activityType
  details {
    ... on ActivityLogTaskSourcingLinkResumeUploadDetails {
      __typename
      reason
    }
  }
  ...ActivityLogBase_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}`;
export const ActivityLog_ActivityLogFragmentDoc = gql`
    fragment ActivityLog_activityLog on ActivityLog {
  id
  activityType
  plaintext
  ephemeral
  ...ActivityLogBase_activityLog
  ...ActivityLogApplicationCandidatePortalNoteCreated_activityLog
  ...ActivityLogTaskCandidateAnonymized_activityLog
  ...ActivityLogApplicationCandidatePortalNoteUpdated_activityLog
  ...ActivityLogApplicationCandidatePortalNoteDeleted_activityLog
  ...ActivityLogEmail_activityLog
  ...ActivityLogEmployeeEmailSent_activityLog
  ...ActivityLogEmployeeEmailReceived_activityLog
  ...ActivityLogEmployeeSlackMessageReceived_activityLog
  ...ActivityLogEmployeeSlackMessageSent_activityLog
  ...ActivityLogNote_activityLog
  ...ActivityLogTaskAgentDelegated_activityLog
  ...ActivityLogTaskAgentThinking_activityLog
  ...ActivityLogTaskAgentUndelegated_activityLog
  ...ActivityLogAgentMessage_activityLog
  ...ActivityLogAgentQuestion_activityLog
  ...ActivityLogAgentReasoning_activityLog
  ...ActivityLogAgentDebug_activityLog
  ...ActivityLogAgentToolCalls_activityLog
  ...ActivityLogAgentQueued_activityLog
  ...ActivityLogAgentStopped_activityLog
  ...ActivityLogTaskAssigned_activityLog
  ...ActivityLogTaskCalendarChanges_activityLog
  ...ActivityLogTaskCandidateAvailabilityDeleted_activityLog
  ...ActivityLogTaskCandidateRsvp_activityLog
  ...ActivityLogTaskCandidateSelfScheduleCanceled_activityLog
  ...ActivityLogTaskCandidateSelfScheduleCreated_activityLog
  ...ActivityLogTaskCandidateSelfScheduleRescheduled_activityLog
  ...ActivityLogTaskCandidateSubmittedAvailability_activityLog
  ...ActivityLogTaskChangedStatus_activityLog
  ...ActivityLogTaskChangeRequested_activityLog
  ...ActivityLogTaskClosed_activityLog
  ...ActivityLogTaskClosed_activityLog
  ...ActivityLogTaskCreated_activityLog
  ...ActivityLogTaskCreated_activityLog
  ...ActivityLogTaskDebriefCanceled_activityLog
  ...ActivityLogTaskDebriefCreated_activityLog
  ...ActivityLogTaskEditedAvailability_activityLog
  ...ActivityLogTaskFlagAdded_activityLog
  ...ActivityLogTaskFlagLifecycleResolved_activityLog
  ...ActivityLogTaskFlagResolvedCandidateDeclined_activityLog
  ...ActivityLogTaskFlagResolvedChangeRequested_activityLog
  ...ActivityLogTaskFlagResolvedDebriefDeclined_activityLog
  ...ActivityLogTaskFlagResolvedInterviewDeclined_activityLog
  ...ActivityLogTaskRcAdjustInterviewerRsvp_activityLog
  ...ActivityLogTaskMarkedUrgent_activityLog
  ...ActivityLogTaskMeetingRoomRsvp_activityLog
  ...ActivityLogTaskRescheduleLogCreated_activityLog
  ...ActivityLogTaskRescheduleLogDeleted_activityLog
  ...ActivityLogTaskRescheduleLogEdited_activityLog
  ...ActivityLogTaskReopened_activityLog
  ...ActivityLogTaskRequirementApplicationDebriefAdded_activityLog
  ...ActivityLogTaskRequirementApplicationDebriefRemoved_activityLog
  ...ActivityLogTaskRequirementCandidateAvailabilityAdded_activityLog
  ...ActivityLogTaskRequirementCandidateAvailabilityRemoved_activityLog
  ...ActivityLogTaskRequirementCandidateAvailabilityUpdated_activityLog
  ...ActivityLogTaskRequirementScheduleAdded_activityLog
  ...ActivityLogTaskRequirementSelfScheduleAdded_activityLog
  ...ActivityLogTaskRequirementSelfScheduleRemoved_activityLog
  ...ActivityLogTaskRequirementSelfScheduleUpdated_activityLog
  ...ActivityLogTaskScheduleCanceled_activityLog
  ...ActivityLogTaskScheduleCreated_activityLog
  ...ActivityLogTaskScheduleRescheduled_activityLog
  ...ActivityLogTaskScheduleUpdated_activityLog
  ...ActivityLogTaskTagAdded_activityLog
  ...ActivityLogTaskTagRemoved_activityLog
  ...ActivityLogTaskUnassigned_activityLog
  ...ActivityLogTaskUnmarkedUrgent_activityLog
  ...ActivityLogTaskReadyForCandidateComm_activityLog
  ...ActivityLogCandidateViewedTabDetails_activityLog
  ...ActivityLogTaskQueueSet_activityLog
  ...ActivityLogTaskQueueUnset_activityLog
  ...ActivityLogTaskCandidateInterviewReminderSent_activityLog
  ...ActivityLogTaskCandidateSelfScheduleReminderSent_activityLog
  ...ActivityLogTaskCandidateAvailabilityReminderSent_activityLog
  ...ActivityLogTaskDeclinedInterviewerAutoReplaced_activityLog
  ...ActivityLogCandidatePreferredPhoneNumberChangeDetails_activityLog
  ...ActivityLogInterviewerRsvpDeclined_activityLog
  ...ActivityLogInterviewerRsvpAccepted_activityLog
  ...ActivityLogInterviewerRsvpTentative_activityLog
  ...ActivityLogCandidateRsvpAccepted_activityLog
  ...ActivityLogCandidateRsvpDeclined_activityLog
  ...ActivityLogCandidateRsvpTentative_activityLog
  ...ActivityLogTaskCandidatePulseSurveyRequested_activityLog
  ...ActivityLogTaskCandidatePulseSurveySubmitted_activityLog
  ...ActivityLogTaskAutoCancelFailed_activityLog
  ...ActivityLogTaskSourcingLinkResumeUpload_activityLog
}
    ${ActivityLogBase_ActivityLogFragmentDoc}
${ActivityLogApplicationCandidatePortalNoteCreated_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateAnonymized_ActivityLogFragmentDoc}
${ActivityLogApplicationCandidatePortalNoteUpdated_ActivityLogFragmentDoc}
${ActivityLogApplicationCandidatePortalNoteDeleted_ActivityLogFragmentDoc}
${ActivityLogEmail_ActivityLogFragmentDoc}
${ActivityLogEmployeeEmailSent_ActivityLogFragmentDoc}
${ActivityLogEmployeeEmailReceived_ActivityLogFragmentDoc}
${ActivityLogEmployeeSlackMessageReceived_ActivityLogFragmentDoc}
${ActivityLogEmployeeSlackMessageSent_ActivityLogFragmentDoc}
${ActivityLogNote_ActivityLogFragmentDoc}
${ActivityLogTaskAgentDelegated_ActivityLogFragmentDoc}
${ActivityLogTaskAgentThinking_ActivityLogFragmentDoc}
${ActivityLogTaskAgentUndelegated_ActivityLogFragmentDoc}
${ActivityLogAgentMessage_ActivityLogFragmentDoc}
${ActivityLogAgentQuestion_ActivityLogFragmentDoc}
${ActivityLogAgentReasoning_ActivityLogFragmentDoc}
${ActivityLogAgentDebug_ActivityLogFragmentDoc}
${ActivityLogAgentToolCalls_ActivityLogFragmentDoc}
${ActivityLogAgentQueued_ActivityLogFragmentDoc}
${ActivityLogAgentStopped_ActivityLogFragmentDoc}
${ActivityLogTaskAssigned_ActivityLogFragmentDoc}
${ActivityLogTaskCalendarChanges_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateAvailabilityDeleted_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateRsvp_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateSelfScheduleCanceled_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateSelfScheduleCreated_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateSelfScheduleRescheduled_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateSubmittedAvailability_ActivityLogFragmentDoc}
${ActivityLogTaskChangedStatus_ActivityLogFragmentDoc}
${ActivityLogTaskChangeRequested_ActivityLogFragmentDoc}
${ActivityLogTaskClosed_ActivityLogFragmentDoc}
${ActivityLogTaskCreated_ActivityLogFragmentDoc}
${ActivityLogTaskDebriefCanceled_ActivityLogFragmentDoc}
${ActivityLogTaskDebriefCreated_ActivityLogFragmentDoc}
${ActivityLogTaskEditedAvailability_ActivityLogFragmentDoc}
${ActivityLogTaskFlagAdded_ActivityLogFragmentDoc}
${ActivityLogTaskFlagLifecycleResolved_ActivityLogFragmentDoc}
${ActivityLogTaskFlagResolvedCandidateDeclined_ActivityLogFragmentDoc}
${ActivityLogTaskFlagResolvedChangeRequested_ActivityLogFragmentDoc}
${ActivityLogTaskFlagResolvedDebriefDeclined_ActivityLogFragmentDoc}
${ActivityLogTaskFlagResolvedInterviewDeclined_ActivityLogFragmentDoc}
${ActivityLogTaskRcAdjustInterviewerRsvp_ActivityLogFragmentDoc}
${ActivityLogTaskMarkedUrgent_ActivityLogFragmentDoc}
${ActivityLogTaskMeetingRoomRsvp_ActivityLogFragmentDoc}
${ActivityLogTaskRescheduleLogCreated_ActivityLogFragmentDoc}
${ActivityLogTaskRescheduleLogDeleted_ActivityLogFragmentDoc}
${ActivityLogTaskRescheduleLogEdited_ActivityLogFragmentDoc}
${ActivityLogTaskReopened_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementApplicationDebriefAdded_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementApplicationDebriefRemoved_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementCandidateAvailabilityAdded_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementCandidateAvailabilityRemoved_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementCandidateAvailabilityUpdated_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementScheduleAdded_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementSelfScheduleAdded_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementSelfScheduleRemoved_ActivityLogFragmentDoc}
${ActivityLogTaskRequirementSelfScheduleUpdated_ActivityLogFragmentDoc}
${ActivityLogTaskScheduleCanceled_ActivityLogFragmentDoc}
${ActivityLogTaskScheduleCreated_ActivityLogFragmentDoc}
${ActivityLogTaskScheduleRescheduled_ActivityLogFragmentDoc}
${ActivityLogTaskScheduleUpdated_ActivityLogFragmentDoc}
${ActivityLogTaskTagAdded_ActivityLogFragmentDoc}
${ActivityLogTaskTagRemoved_ActivityLogFragmentDoc}
${ActivityLogTaskUnassigned_ActivityLogFragmentDoc}
${ActivityLogTaskUnmarkedUrgent_ActivityLogFragmentDoc}
${ActivityLogTaskReadyForCandidateComm_ActivityLogFragmentDoc}
${ActivityLogCandidateViewedTabDetails_ActivityLogFragmentDoc}
${ActivityLogTaskQueueSet_ActivityLogFragmentDoc}
${ActivityLogTaskQueueUnset_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateInterviewReminderSent_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateSelfScheduleReminderSent_ActivityLogFragmentDoc}
${ActivityLogTaskCandidateAvailabilityReminderSent_ActivityLogFragmentDoc}
${ActivityLogTaskDeclinedInterviewerAutoReplaced_ActivityLogFragmentDoc}
${ActivityLogCandidatePreferredPhoneNumberChangeDetails_ActivityLogFragmentDoc}
${ActivityLogInterviewerRsvpDeclined_ActivityLogFragmentDoc}
${ActivityLogInterviewerRsvpAccepted_ActivityLogFragmentDoc}
${ActivityLogInterviewerRsvpTentative_ActivityLogFragmentDoc}
${ActivityLogCandidateRsvpAccepted_ActivityLogFragmentDoc}
${ActivityLogCandidateRsvpDeclined_ActivityLogFragmentDoc}
${ActivityLogCandidateRsvpTentative_ActivityLogFragmentDoc}
${ActivityLogTaskCandidatePulseSurveyRequested_ActivityLogFragmentDoc}
${ActivityLogTaskCandidatePulseSurveySubmitted_ActivityLogFragmentDoc}
${ActivityLogTaskAutoCancelFailed_ActivityLogFragmentDoc}
${ActivityLogTaskSourcingLinkResumeUpload_ActivityLogFragmentDoc}`;
export const ActivityLogsList_ActivityLogFragmentDoc = gql`
    fragment ActivityLogsList_activityLog on ActivityLog {
  id
  activityType
  ...ActivityLog_activityLog
}
    ${ActivityLog_ActivityLogFragmentDoc}`;
export const ApplicationDetailsActivityLogsList_ActivityLogFragmentDoc = gql`
    fragment ApplicationDetailsActivityLogsList_activityLog on ActivityLog {
  id
  ...ActivityLogsList_activityLog
}
    ${ActivityLogsList_ActivityLogFragmentDoc}`;
export const MockActivityLogFragmentDoc = gql`
    fragment MockActivityLog on ActivityLog {
  id
}
    `;
export const MockActivityLogsListFragmentDoc = gql`
    fragment MockActivityLogsList on ActivityLog {
  id
}
    `;
export const NewActivityLogFragmentDoc = gql`
    fragment NewActivityLog on ActivityLog {
  id
  activityType
  createdAt
}
    `;
export const TaskDetailsActivityLogsList_ActivityLogFragmentDoc = gql`
    fragment TaskDetailsActivityLogsList_activityLog on ActivityLog {
  id
  ...ActivityLogsList_activityLog
}
    ${ActivityLogsList_ActivityLogFragmentDoc}`;
export const NewTimelineActivityLogFragmentDoc = gql`
    fragment NewTimelineActivityLog on ActivityLog {
  id
  activityType
  createdAt
}
    `;
export const TaskTimelineActivityLogsList_ActivityLogFragmentDoc = gql`
    fragment TaskTimelineActivityLogsList_activityLog on ActivityLog {
  id
  ...ActivityLogsList_activityLog
}
    ${ActivityLogsList_ActivityLogFragmentDoc}`;
export const AiActorName_ActorFragmentDoc = gql`
    fragment AiActorName_actor on Actor {
  __typename
  id
  type
  displayName
}
    `;
export const AiInstructionsCard_InstructionFragmentDoc = gql`
    fragment AiInstructionsCard_instruction on AiInstruction {
  id
  content
  updatedAt
  updatedBy {
    ...AiActorName_actor
  }
}
    ${AiActorName_ActorFragmentDoc}`;
export const AiMemoriesCard_MemoryFragmentDoc = gql`
    fragment AiMemoriesCard_memory on AiMemory {
  id
  content
  createdAt
  createdBy {
    ...AiActorName_actor
  }
}
    ${AiActorName_ActorFragmentDoc}`;
export const ApplicationItem_ApplicationFragmentDoc = gql`
    fragment ApplicationItem_application on Application {
  id
  status
  currentJobStageActiveTaskCount
  candidate {
    id
    fullName
  }
  recruiter {
    id
    fullName
    internalProfilePictureUrl
  }
  coordinator {
    id
    fullName
    internalProfilePictureUrl
  }
  job {
    id
    name
  }
  jobStage {
    id
    name
  }
}
    `;
export const AtsInterviewDefinitionFragmentDoc = gql`
    fragment AtsInterviewDefinition on AtsInterviewDefinition {
  name
  atsId
  atsJobStageId
  atsJobId
  atsJobStage {
    atsId
    name
    index
  }
  atsFields {
    ... on GreenhouseInterviewDefinition {
      estimatedMinutes
      index
    }
    ... on LeverInterviewDefinition {
      groupId
      groupName
    }
  }
}
    `;
export const CompanyHolidayIcon_CompanyHolidaysFragmentDoc = gql`
    fragment CompanyHolidayIcon_companyHolidays on CompanyHoliday {
  countries {
    id
    value
  }
  id
  name
  startAt
  endAt
}
    `;
export const DebriefAtsWriteRow_OrgSettingFragmentDoc = gql`
    fragment DebriefAtsWriteRow_orgSetting on DebriefAtsWriteSettingPref {
  atsInterviewDefinitionId
  definitionNameMatch
  scorecardRecipients {
    employeeIds
    dynamicAudiences
    externalEmailAddresses
  }
}
    `;
export const EmployeeFragmentDoc = gql`
    fragment Employee on Employee {
  fullName
  email
  id
  orgId
  internalProfilePictureUrl
  timezone
  atsId
  isDirectoryDisabled
  isArchived
  isAtsDisabled
  hasAtsId
  title
}
    `;
export const EmployeeAttributesFragmentDoc = gql`
    fragment EmployeeAttributes on Employee {
  id
  isArchived
  fullName
  email
  timezone
  linkedinUrl
  title
  googleUserId
  isDirectoryDisabled
  isAtsDisabled
  hasAtsId
  atsId
  manager {
    id
    fullName
    internalProfilePictureUrl
  }
  calendarDelegate {
    id
    fullName
    internalProfilePictureUrl
  }
  atsUser {
    atsId
    fullName
    email
    isDisabled
  }
}
    `;
export const EmployeeWorkHoursFragmentDoc = gql`
    fragment EmployeeWorkHours on Employee {
  workHours {
    monday {
      start
      end
    }
    tuesday {
      start
      end
    }
    wednesday {
      start
      end
    }
    thursday {
      start
      end
    }
    friday {
      start
      end
    }
    saturday {
      start
      end
    }
    sunday {
      start
      end
    }
  }
}
    `;
export const EmployeeDetailsFragmentFragmentDoc = gql`
    fragment EmployeeDetailsFragment on Employee {
  ...Employee
  linkedinUrl
  googleUserId
  givenName
  useCalendarTimezone
  calendarTimezone
  interviewPauseDates {
    start
    end
  }
  ...EmployeeAttributes
  ...EmployeeWorkHours
}
    ${EmployeeFragmentDoc}
${EmployeeAttributesFragmentDoc}
${EmployeeWorkHoursFragmentDoc}`;
export const EmployeePicker_EmployeeFragmentDoc = gql`
    fragment EmployeePicker_employee on Employee {
  id
  fullName
  email
  orgId
  internalProfilePictureUrl
  timezone
  atsId
  isDirectoryDisabled
  isArchived
  isAtsDisabled
  hasAtsId
  title
}
    `;
export const IsModuleMemberPaused_ModuleMemberFragmentDoc = gql`
    fragment isModuleMemberPaused_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  isPaused
  pausedUntil
}
    `;
export const BaseEditInterviewSeatModuleEmployeeSearchV2FragmentDoc = gql`
    fragment BaseEditInterviewSeatModuleEmployeeSearchV2 on Employee {
  id
  fullName
  email
  orgId
  isDirectoryDisabled
  hasAtsId
  internalProfilePictureUrl
  timezone
  atsId
  isAtsDisabled
}
    `;
export const InterviewModuleFragmentDoc = gql`
    fragment InterviewModule on InterviewModule {
  id
  name
  shadowsRequired
  reverseShadowsRequired
  weeklyNumInterviewLimit
}
    `;
export const GetShadowCompletedCount_ModuleMemberFragmentDoc = gql`
    fragment getShadowCompletedCount_moduleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  stats {
    completedAsShadow
    manualCompletedAsShadow
  }
}
    `;
export const GetShadowPendingCount_ModuleMemberFragmentDoc = gql`
    fragment getShadowPendingCount_moduleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  shadowsRequired
  ...getShadowCompletedCount_moduleMember
}
    ${GetShadowCompletedCount_ModuleMemberFragmentDoc}`;
export const GetReverseShadowCompletedCount_ModuleMemberFragmentDoc = gql`
    fragment getReverseShadowCompletedCount_moduleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  stats {
    completedAsReverseShadow
    manualCompletedAsReverseShadow
  }
}
    `;
export const GetReverseShadowPendingCount_ModuleMemberFragmentDoc = gql`
    fragment getReverseShadowPendingCount_moduleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  reverseShadowsRequired
  ...getReverseShadowCompletedCount_moduleMember
}
    ${GetReverseShadowCompletedCount_ModuleMemberFragmentDoc}`;
export const GetModuleMemberPendingTrainingCount_ModuleMemberFragmentDoc = gql`
    fragment getModuleMemberPendingTrainingCount_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  status
  stats {
    upcoming
  }
  ...getShadowPendingCount_moduleMember
  ...getReverseShadowPendingCount_moduleMember
}
    ${GetShadowPendingCount_ModuleMemberFragmentDoc}
${GetReverseShadowPendingCount_ModuleMemberFragmentDoc}`;
export const IsModuleMemberDisabledForScheduling_ModuleMemberFragmentDoc = gql`
    fragment isModuleMemberDisabledForScheduling_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  status
  shadowsRequired
  reverseShadowsRequired
  stats {
    currentTrainingSessionStatus
  }
  interviewModule {
    id
    shouldFastTrackTraining
  }
  ...getModuleMemberPendingTrainingCount_ModuleMember
}
    ${GetModuleMemberPendingTrainingCount_ModuleMemberFragmentDoc}`;
export const IsModuleMembreOrEmployeePaused_ModuleMemberFragmentDoc = gql`
    fragment isModuleMembreOrEmployeePaused_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  employee {
    id
    isPaused
  }
  isPaused
}
    `;
export const ModuleMember_InterviewModuleMemberFragmentDoc = gql`
    fragment ModuleMember_interviewModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  employee {
    id
    fullName
    internalProfilePictureUrl
    title
  }
  stats {
    currentTrainingSessionStatus
  }
  ...isModuleMembreOrEmployeePaused_ModuleMember
  ...getModuleMemberPendingTrainingCount_ModuleMember
}
    ${IsModuleMembreOrEmployeePaused_ModuleMemberFragmentDoc}
${GetModuleMemberPendingTrainingCount_ModuleMemberFragmentDoc}`;
export const InterviewModuleMember_InterviewModuleMemberFragmentDoc = gql`
    fragment InterviewModuleMember_interviewModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  ...ModuleMember_interviewModuleMember
}
    ${ModuleMember_InterviewModuleMemberFragmentDoc}`;
export const EmployeeFilterFragmentDoc = gql`
    fragment EmployeeFilter on InterviewModuleMember {
  id
  ...isModuleMemberDisabledForScheduling_ModuleMember
  ...InterviewModuleMember_interviewModuleMember
  interviewModuleId
  employeeId
  status
  shadowsRequired
  reverseShadowsRequired
  pausedUntil
  stats {
    completedAsReverseShadow
    completedAsShadow
    shadowOffset
    reverseShadowOffset
  }
  employee {
    id
    fullName
    email
    title
    internalProfilePictureUrl
    attributes {
      id
      value
    }
    interviewPauseDates {
      start
      end
    }
  }
}
    ${IsModuleMemberDisabledForScheduling_ModuleMemberFragmentDoc}
${InterviewModuleMember_InterviewModuleMemberFragmentDoc}`;
export const BaseEditInterviewSeatModuleInterviewModuleSearchV2FragmentDoc = gql`
    fragment BaseEditInterviewSeatModuleInterviewModuleSearchV2 on InterviewModule {
  ...InterviewModule
  orgId
  membersCount
  membersTrainedCount
  membersInTrainingCount
  membersInReverseShadowCount
  membersInShadowCount
  membersInPendingApprovalCount
  graduateFromShadowApprovalType
  graduateFromReverseShadowApprovalType
  interviewModuleMembers(input: {pageInput: {limit: 500, offset: 0}}) {
    items {
      interviewModuleId
      employeeId
      ...EmployeeFilter
    }
  }
}
    ${InterviewModuleFragmentDoc}
${EmployeeFilterFragmentDoc}`;
export const EmployeeAndAttributesFilterFragmentDoc = gql`
    fragment EmployeeAndAttributesFilter on InterviewModuleMember {
  ...EmployeeFilter
}
    ${EmployeeFilterFragmentDoc}`;
export const EditModuleSeatInterviewModuleV2FragmentDoc = gql`
    fragment EditModuleSeatInterviewModuleV2 on InterviewModuleMember {
  interviewModuleId
  ...EmployeeAndAttributesFilter
}
    ${EmployeeAndAttributesFilterFragmentDoc}`;
export const EditModuleSeatInterviewStatsV2FragmentDoc = gql`
    fragment EditModuleSeatInterviewStatsV2 on InterviewModule {
  id
  name
  membersCount
  membersInReverseShadowCount
  membersInShadowCount
  membersTrainedCount
}
    `;
export const MeetingRoomFragmentFragmentDoc = gql`
    fragment MeetingRoomFragment on MeetingRoom {
  id
  name
  floorName
  description
  capacity
  features
}
    `;
export const QuickTaskCreateButton_TaskQuickCreateValidateResultFragmentDoc = gql`
    fragment QuickTaskCreateButton_taskQuickCreateValidateResult on TaskQuickCreateValidateResult {
  suggestionCount
  errors {
    type
  }
}
    `;
export const CreateInfo_SuggestionTimeRangeFragmentDoc = gql`
    fragment CreateInfo_suggestionTimeRange on DateTimeRangeOutput {
  startAt
  endAt
}
    `;
export const ErrorList_ErrorsFragmentDoc = gql`
    fragment ErrorList_errors on TaskCreateValidateErrorFlags {
  type
  message
}
    `;
export const ErrorInfo_ErrorsFragmentDoc = gql`
    fragment ErrorInfo_errors on TaskCreateValidateErrorFlags {
  ...ErrorList_errors
}
    ${ErrorList_ErrorsFragmentDoc}`;
export const InfoList_WarningsFragmentDoc = gql`
    fragment InfoList_warnings on TaskCreateValidateWarnFlags {
  type
  message
}
    `;
export const CreateInfo_WarningsFragmentDoc = gql`
    fragment CreateInfo_warnings on TaskCreateValidateWarnFlags {
  ...InfoList_warnings
}
    ${InfoList_WarningsFragmentDoc}`;
export const QuickTaskValidationIcon_TaskQuickCreateValidateResultFragmentDoc = gql`
    fragment QuickTaskValidationIcon_taskQuickCreateValidateResult on TaskQuickCreateValidateResult {
  suggestionCount
  suggestionLastCalculatedAt
  suggestionTimeRanges {
    ...CreateInfo_suggestionTimeRange
  }
  errors {
    ...ErrorInfo_errors
  }
  warnings {
    ...CreateInfo_warnings
  }
}
    ${CreateInfo_SuggestionTimeRangeFragmentDoc}
${ErrorInfo_ErrorsFragmentDoc}
${CreateInfo_WarningsFragmentDoc}`;
export const ScheduleContentInterviewDetails_CandidateEventFragmentDoc = gql`
    fragment ScheduleContentInterviewDetails_candidateEvent on ApplicationStageCandidateEvent {
  id
  responseStatus
}
    `;
export const RequestTemplateSelect_TemplateFragmentDoc = gql`
    fragment RequestTemplateSelect_template on Template {
  id
  name
}
    `;
export const RequestTemplateValue_TemplateFragmentDoc = gql`
    fragment RequestTemplateValue_template on Template {
  id
  name
}
    `;
export const TemplateRow_OrgTemplateFragmentDoc = gql`
    fragment TemplateRow_orgTemplate on Template {
  id
  name
}
    `;
export const AtsUserFragmentDoc = gql`
    fragment AtsUser on AtsUser {
  id
  email
  name
  disabled
  employeeId
  employee {
    id
    fullName
    internalProfilePictureUrl
  }
}
    `;
export const BrandingThemePlaceholderPreview_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemePlaceholderPreview_brandingTheme on BrandingTheme {
  id
  themeMode
  profileImageUrl
  coverImageUrl
  primaryColor
  font
}
    `;
export const Row_BrandingOptionsFragmentDoc = gql`
    fragment Row_BrandingOptions on BrandingTheme {
  id
  name
  profileImageUrl
  coverImageUrl
  isOrgDefault
  ...BrandingThemePlaceholderPreview_brandingTheme
}
    ${BrandingThemePlaceholderPreview_BrandingThemeFragmentDoc}`;
export const BrighthireGuideOptionFragmentDoc = gql`
    fragment BrighthireGuideOption on InterviewGuide {
  id
  name
  remoteInterviewGuideId
  remoteInterviewGuideType
  job {
    id
  }
}
    `;
export const Calendar_CalendarFragmentDoc = gql`
    fragment Calendar_calendar on Calendar {
  id
  name
  remoteId
}
    `;
export const CollaborationToolTemplate_CollaborationLinkTemplateFragmentDoc = gql`
    fragment CollaborationToolTemplate_collaborationLinkTemplate on CollaborationLinkTemplate {
  id
  name
  groupName
}
    `;
export const JobBrandingTemplate_PortalTemplateFragmentDoc = gql`
    fragment JobBrandingTemplate_portalTemplate on PortalTemplate {
  id
  name
}
    `;
export const JobBrandingTemplateSelect_PortalTemplateFragmentDoc = gql`
    fragment JobBrandingTemplateSelect_portalTemplate on PortalTemplate {
  id
  name
}
    `;
export const MemberSelect_UserInfoFragmentDoc = gql`
    fragment MemberSelect_userInfo on UserInfo {
  userId
  employee {
    id
    fullName
    internalProfilePictureUrl
  }
}
    `;
export const PortalTemplateSelect_PortalTemplateFragmentDoc = gql`
    fragment PortalTemplateSelect_portalTemplate on PortalTemplate {
  id
  name
}
    `;
export const TaskQueue_TaskQueueFragmentDoc = gql`
    fragment TaskQueue_taskQueue on TaskQueue {
  id
  name
  memberCount
}
    `;
export const SmartEmployeeSelectFragmentDoc = gql`
    fragment SmartEmployeeSelect on Employee {
  id
  fullName
  givenName
  familyName
  internalProfilePictureUrl
  email
  isArchived
  isAtsDisabled
  hasAtsId
  isDisabled
  orgId
}
    `;
export const OptionRenderer_EmployeesFragmentDoc = gql`
    fragment OptionRenderer_employees on Employee {
  id
  fullName
  givenName
  familyName
  internalProfilePictureUrl
  email
  isArchived
  isAtsDisabled
  hasAtsId
  isDisabled
  orgId
}
    `;
export const UseCandidateSmartOptions_CandidateCoordinatorDataFragmentDoc = gql`
    fragment useCandidateSmartOptions_candidateCoordinatorData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseCandidateSmartOptions_CandidateRecruiterDataFragmentDoc = gql`
    fragment useCandidateSmartOptions_candidateRecruiterData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseCandidateSmartOptions_CandidateSourcerDataFragmentDoc = gql`
    fragment useCandidateSmartOptions_candidateSourcerData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseCandidateSmartOptions_PreviousCandidateInterviewersDataFragmentDoc = gql`
    fragment useCandidateSmartOptions_previousCandidateInterviewersData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseGetDynamicAudienceData_DynamicEmployeeFragmentDoc = gql`
    fragment useGetDynamicAudienceData_DynamicEmployee on Employee {
  id
  fullName
  givenName
  familyName
  internalProfilePictureUrl
  email
  isArchived
  isAtsDisabled
  hasAtsId
  isDisabled
  orgId
}
    `;
export const UseJobSmartOptions_JobCoordinatorDataFragmentDoc = gql`
    fragment useJobSmartOptions_jobCoordinatorData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseJobSmartOptions_JobRecruiterDataFragmentDoc = gql`
    fragment useJobSmartOptions_jobRecruiterData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseJobSmartOptions_JobSourcerDataFragmentDoc = gql`
    fragment useJobSmartOptions_jobSourcerData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseJobSmartOptions_JobHiringManagersDataFragmentDoc = gql`
    fragment useJobSmartOptions_jobHiringManagersData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseTaskSmartOptions_TaskAssigneeDataFragmentDoc = gql`
    fragment useTaskSmartOptions_taskAssigneeData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseTaskSmartOptions_TaskCreatorDataFragmentDoc = gql`
    fragment useTaskSmartOptions_taskCreatorData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseTaskSmartOptions_TaskDebriefDataFragmentDoc = gql`
    fragment useTaskSmartOptions_taskDebriefData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseTaskSmartOptions_TaskSubscriberDataFragmentDoc = gql`
    fragment useTaskSmartOptions_taskSubscriberData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const UseTaskSmartOptions_TaskInterviewersDataFragmentDoc = gql`
    fragment useTaskSmartOptions_taskInterviewersData on Employee {
  ...OptionRenderer_employees
}
    ${OptionRenderer_EmployeesFragmentDoc}`;
export const ZoomUserFragmentFragmentDoc = gql`
    fragment ZoomUserFragment on ZoomUser {
  orgId
  zoomUserId
  status
  email
  employeeId
  firstName
  lastName
}
    `;
export const SubscribersSelect_ThisEmployeeFragmentDoc = gql`
    fragment SubscribersSelect_thisEmployee on Employee {
  id
  fullName
  internalProfilePictureUrl
}
    `;
export const EmployeeFacePile_EmployeeFragmentDoc = gql`
    fragment EmployeeFacePile_employee on Employee {
  id
  fullName
  internalProfilePictureUrl
}
    `;
export const SubscribersSelect_EmployeeFragmentDoc = gql`
    fragment SubscribersSelect_employee on Employee {
  id
  ...EmployeeFacePile_employee
}
    ${EmployeeFacePile_EmployeeFragmentDoc}`;
export const EmployeePrefDataFragmentDoc = gql`
    fragment EmployeePrefData on EmployeePref {
  id
  orgId
  prefName
  json
  boolValue
  stringValue
  intValue
  stringArray
  jsonArray
  employeeId
  timestamp
}
    `;
export const CandidateAtsLatestAvailabilityFragmentFragmentDoc = gql`
    fragment CandidateAtsLatestAvailabilityFragment on Candidate {
  atsLatestAvailability {
    intervals {
      startAt
      endAt
    }
    jobName
    jobStageName
    timezone
    originalText
  }
}
    `;
export const OrgPrefsDataFragmentDoc = gql`
    fragment OrgPrefsData on OrgPref {
  id
  orgId
  prefName
  json
  boolValue
  stringValue
  intValue
  stringArray
  jsonArray
  isLocked
  timestamp
  duration {
    seconds
    nanos
  }
  jsonPref {
    ... on InterviewLimit {
      type
      limit
    }
    ... on MinimumInterviewerLoadLimitOrgPref {
      interviews
      minutes
    }
    ... on InterviewMeetingLocationSettingPref {
      interviewMeetingLocationType
      dynamicHost
      hostEmployeeId
      remoteVideoMeetingHostUserId
      customLocation
      videoMeetingLinkScope
    }
    ... on CandidateFacingHiringTeamContactInfo {
      showCoordinator
      showRecruiter
      canShowJobTitle
      canShowLinkedin
      canShowPhone
      canShowProfilePicture
      canShowPronouns
      canShowBio
    }
    ... on CandidateFacingInterviewerInfo {
      canShowInfo
      canShowFullName
      canShowJobTitle
      canShowLinkedin
      canShowEmail
      canShowProfilePicture
      canShowPronouns
      canShowBio
    }
    ... on EmployeeFieldSyncSourcePref {
      name
      title
      manager
      linkedInUrl
    }
    ... on InterviewBufferTimePref {
      after {
        seconds
      }
      before {
        seconds
      }
    }
    ... on TimeBlockWeek {
      sunday {
        start
        end
      }
      monday {
        start
        end
      }
      tuesday {
        start
        end
      }
      wednesday {
        start
        end
      }
      thursday {
        start
        end
      }
      friday {
        start
        end
      }
      saturday {
        start
        end
      }
    }
    ... on AiOrgCustomLlmPref {
      completionUrl
      model
      apiKey
      headers {
        name
        value
      }
      wireFormat
      responseJsonPath
    }
    ... on AtsJobSyncScopePref {
      departments {
        ids
      }
      offices {
        ids
      }
      jobs {
        ids
      }
    }
  }
}
    `;
export const HiringProcessSelectDialog_JobFragmentDoc = gql`
    fragment HiringProcessSelectDialog_job on Job {
  id
  atsJob {
    atsUrl
  }
  jobSettings {
    id
    hiringProcess {
      atsId
      name
    }
  }
}
    `;
export const CompanyHolidaysFragmentDoc = gql`
    fragment CompanyHolidays on CompanyHoliday {
  id
  start: startAt
  end: endAt
  countries {
    id
    value
  }
}
    `;
export const AshbyHealthCheckBanner_AshbyFragmentDoc = gql`
    fragment AshbyHealthCheckBanner_ashby on AshbyIntegrationHealth {
  isHealthy
  isInstalled
}
    `;
export const GemHealthCheckBanner_GemFragmentDoc = gql`
    fragment GemHealthCheckBanner_gem on GemIntegrationHealth {
  isInstalled
  isHealthy
  canReadUsers
  canReadUser
  canReadJobs
  canReadJob
  canReadJobStages
  canReadJobStageForJob
  canReadJobPostings
  canReadUserRoles
  canReadInterviews
  canReadInterview
  canReadCandidates
  canReadCandidate
  canReadActivityFeed
  canReadApplications
  canReadApplication
}
    `;
export const GoogleHealthCheckBanner_GoogleFragmentDoc = gql`
    fragment GoogleHealthCheckBanner_google on GoogleIntegrationHealth {
  isHealthy
  isInstalled
  canReadDirectory
  canReadCalendars
  canReadMeetingRooms
}
    `;
export const GreenhouseHealthCheckBanner_GreenhouseFragmentDoc = gql`
    fragment GreenhouseHealthCheckBanner_greenhouse on GreenhouseIntegrationHealth {
  isHealthy
  isInstalled
  canReadUsers
  canReadUser
  canReadJobs
  canReadJob
  canReadJobStages
  canReadJobStageForJob
  canReadJobPostings
  canReadUserRoles
  canReadEmailTemplates
  canReadInterviews
  canReadInterview
  canReadCandidates
  canReadCandidate
  canReadActivityFeed
  canReadApplications
  canReadApplication
  canReadUserPermission
}
    `;
export const LeverHealthCheckBanner_LeverFragmentDoc = gql`
    fragment LeverHealthCheckBanner_lever on LeverIntegrationHealth {
  isHealthy
  isInstalled
  canReadUsers
  canReadJobs
  canReadCandidates
  canReadApplications
  canReadArchiveReasons
  canReadPanels
  canReadStages
  canReadDeletedCandidates
}
    `;
export const MicrosoftHealthCheckBanner_MicrosoftGccHighFragmentDoc = gql`
    fragment MicrosoftHealthCheckBanner_microsoftGccHigh on MicrosoftIntegrationHealth {
  isHealthy
  isInstalled
  canReadDirectory
  canReadCalendars
  canReadMeetingRooms
}
    `;
export const MicrosoftHealthCheckBanner_MicrosoftFragmentDoc = gql`
    fragment MicrosoftHealthCheckBanner_microsoft on MicrosoftIntegrationHealth {
  isHealthy
  isInstalled
  canReadDirectory
  canReadCalendars
  canReadMeetingRooms
}
    `;
export const SmartRecruitersHealthCheckBanner_SmartRecruitersFragmentDoc = gql`
    fragment SmartRecruitersHealthCheckBanner_smartRecruiters on SmartRecruitersIntegrationHealth {
  isInstalled
  isHealthy
}
    `;
export const ZoomHealthCheckBanner_ZoomFragmentDoc = gql`
    fragment ZoomHealthCheckBanner_zoom on ZoomIntegrationHealth {
  isHealthy
  isInstalled
}
    `;
export const MicrosoftCustomExpirationBanner_EmployeeFragmentDoc = gql`
    fragment MicrosoftCustomExpirationBanner_employee on Employee {
  id
  email
  integrations {
    id
    microsoftCustomEmployee {
      updatedAt
    }
  }
}
    `;
export const MicrosoftServiceUserExpirationBanner_MicrosoftServiceUserFragmentDoc = gql`
    fragment MicrosoftServiceUserExpirationBanner_microsoftServiceUser on MicrosoftServiceUserIntegration {
  updatedAt
}
    `;
export const InterviewTranscript_TranscriptFragmentDoc = gql`
    fragment InterviewTranscript_transcript on MeetingLocation {
  remoteNotetakerTranscript
}
    `;
export const SuggestedScheduleInterviewer_InterviewerFragmentDoc = gql`
    fragment SuggestedScheduleInterviewer_interviewer on InterviewerWithRole {
  employeeId
  role
  employee {
    id
    fullName
    internalProfilePictureUrl
  }
}
    `;
export const SuggestedScheduledInterviewSeat_SeatFragmentDoc = gql`
    fragment SuggestedScheduledInterviewSeat_seat on SuggestedScheduledInterviewSeat {
  id
  interviewers {
    ...SuggestedScheduleInterviewer_interviewer
  }
}
    ${SuggestedScheduleInterviewer_InterviewerFragmentDoc}`;
export const SuggestedScheduleInterview_InterviewFragmentDoc = gql`
    fragment SuggestedScheduleInterview_interview on SuggestedScheduledInterview {
  id
  startAt
  endAt
  name
  seats {
    id
    ...SuggestedScheduledInterviewSeat_seat
  }
}
    ${SuggestedScheduledInterviewSeat_SeatFragmentDoc}`;
export const SuggestedSchedule_SuggestedScheduleFragmentDoc = gql`
    fragment SuggestedSchedule_suggestedSchedule on SuggestedSchedule {
  id
  interviews {
    id
    ...SuggestedScheduleInterview_interview
  }
}
    ${SuggestedScheduleInterview_InterviewFragmentDoc}`;
export const Candidate_CandidateFragmentDoc = gql`
    fragment Candidate_candidate on Candidate {
  id
  fullName
  anonymizedAt
  atsCandidate {
    atsId
    atsFields {
      ... on LeverCandidate {
        origin
      }
    }
  }
}
    `;
export const SuggestedScheduleOptionsHeader_CandidateFragmentDoc = gql`
    fragment SuggestedScheduleOptionsHeader_candidate on Candidate {
  id
  ...Candidate_candidate
}
    ${Candidate_CandidateFragmentDoc}`;
export const UseIsInterviewPlanValid_JobStageFragmentDoc = gql`
    fragment useIsInterviewPlanValid_jobStage on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      interviewType
      isHiddenFromCandidate
      jobStageInterviewSeats {
        id
        freeformSeat {
          jobStageInterviewSeatEmployees {
            employeeId
            employee {
              id
              fullName
              isArchived
              isDirectoryDisabled
              isAtsDisabled
              hasAtsId
            }
          }
        }
        moduleSeat {
          interviewModuleId
        }
        linkedSeat {
          linkedJobStageInterviewSeatId
        }
      }
    }
  }
}
    `;
export const SuggestedScheduleOptions_TaskFragmentDoc = gql`
    fragment SuggestedScheduleOptions_task on Task {
  id
  application {
    id
    candidate {
      id
      ...SuggestedScheduleOptionsHeader_candidate
    }
  }
  availabilities {
    id
    candidateEnteredAvailability {
      startAt
      endAt
    }
    rcEnteredAvailability {
      startAt
      endAt
    }
  }
  interviewPlan {
    id
    ...useIsInterviewPlanValid_jobStage
  }
}
    ${SuggestedScheduleOptionsHeader_CandidateFragmentDoc}
${UseIsInterviewPlanValid_JobStageFragmentDoc}`;
export const MockApplicationSidebarContent_ApplicationFragmentDoc = gql`
    fragment MockApplicationSidebarContent_application on Application {
  id
}
    `;
export const MockApplicationSidebarHeader_ApplicationFragmentDoc = gql`
    fragment MockApplicationSidebarHeader_application on Application {
  id
}
    `;
export const MockJobStageDetails_JobFragmentDoc = gql`
    fragment MockJobStageDetails_job on Job {
  id
}
    `;
export const MockTaskList_ApplicationFragmentDoc = gql`
    fragment MockTaskList_application on Application {
  id
}
    `;
export const MockApplicationSidebarCreateTaskButton_ApplicationFragmentDoc = gql`
    fragment MockApplicationSidebarCreateTaskButton_application on Application {
  id
}
    `;
export const MockCandidateInfoSidebar_ApplicationFragmentDoc = gql`
    fragment MockCandidateInfoSidebar_application on Application {
  id
}
    `;
export const MockCandidateInfoSidebar_CandidateFragmentDoc = gql`
    fragment MockCandidateInfoSidebar_candidate on Candidate {
  id
}
    `;
export const MockJobStageMismatchAlert_JobFragmentDoc = gql`
    fragment MockJobStageMismatchAlert_job on Job {
  id
}
    `;
export const MockGetHiringSetupError_FlagsFragmentDoc = gql`
    fragment MockGetHiringSetupError_flags on JobValidationErrorFlags {
  message
}
    `;
export const MockGetHiringMismatchError_FlagsFragmentDoc = gql`
    fragment MockGetHiringMismatchError_flags on JobValidationErrorFlags {
  message
}
    `;
export const GetHiringMismatchError_FlagsFragmentDoc = gql`
    fragment getHiringMismatchError_flags on JobValidationErrorFlags {
  type
  message
}
    `;
export const GetHiringSetupError_FlagsFragmentDoc = gql`
    fragment getHiringSetupError_flags on JobValidationErrorFlags {
  type
  message
}
    `;
export const InterviewCardHeader_JobFragmentDoc = gql`
    fragment InterviewCardHeader_job on Job {
  id
  atsId
}
    `;
export const JobStageInterview_JobFragmentDoc = gql`
    fragment JobStageInterview_job on Job {
  id
  ...InterviewCardHeader_job
}
    ${InterviewCardHeader_JobFragmentDoc}`;
export const InterviewGroupOld_JobFragmentDoc = gql`
    fragment InterviewGroupOld_job on Job {
  id
  ...JobStageInterview_job
}
    ${JobStageInterview_JobFragmentDoc}`;
export const InterviewGroup_JobFragmentDoc = gql`
    fragment InterviewGroup_job on Job {
  id
  ...InterviewGroupOld_job
  ...JobStageInterview_job
}
    ${InterviewGroupOld_JobFragmentDoc}
${JobStageInterview_JobFragmentDoc}`;
export const InterviewPlan_JobFragmentDoc = gql`
    fragment InterviewPlan_job on Job {
  id
  atsId
  ...InterviewGroup_job
}
    ${InterviewGroup_JobFragmentDoc}`;
export const CreateTaskJobStageSelect_JobFragmentDoc = gql`
    fragment CreateTaskJobStageSelect_job on Job {
  id
  jobStages {
    id
    name
  }
}
    `;
export const CreateTaskStep_ApplicationFragmentDoc = gql`
    fragment CreateTaskStep_application on Application {
  id
  jobStage {
    id
    name
  }
  job {
    id
    ...InterviewPlan_job
    ...CreateTaskJobStageSelect_job
    jobSettings {
      id
      defaultTaskQueue {
        id
      }
    }
  }
  candidate {
    id
  }
  coordinator {
    id
    fullName
  }
  recruiter {
    id
    fullName
  }
  atsApplication {
    atsId
    canMoveJobStage
  }
}
    ${InterviewPlan_JobFragmentDoc}
${CreateTaskJobStageSelect_JobFragmentDoc}`;
export const BasicTaskModal_ApplicationFragmentDoc = gql`
    fragment BasicTaskModal_application on Application {
  id
  ...CreateTaskStep_application
  jobStage {
    id
  }
  candidate {
    id
    timezone
  }
}
    ${CreateTaskStep_ApplicationFragmentDoc}`;
export const AvailabilityTaskModal_ApplicationFragmentDoc = gql`
    fragment AvailabilityTaskModal_application on Application {
  id
  candidate {
    id
    timezone
  }
  jobStage {
    id
    job {
      id
    }
  }
}
    `;
export const SelfScheduleTaskModal_ApplicationFragmentDoc = gql`
    fragment SelfScheduleTaskModal_application on Application {
  id
  candidate {
    id
    timezone
  }
  jobStage {
    id
  }
  job {
    id
  }
}
    `;
export const CreateTaskModals_ApplicationFragmentDoc = gql`
    fragment CreateTaskModals_application on Application {
  id
  ...BasicTaskModal_application
  ...AvailabilityTaskModal_application
  ...SelfScheduleTaskModal_application
}
    ${BasicTaskModal_ApplicationFragmentDoc}
${AvailabilityTaskModal_ApplicationFragmentDoc}
${SelfScheduleTaskModal_ApplicationFragmentDoc}`;
export const GetActiveTasksForJobStage_ApplictionFragmentDoc = gql`
    fragment getActiveTasksForJobStage_appliction on Application {
  id
  tasks {
    status
    jobStage {
      id
    }
  }
}
    `;
export const UseApplicationJobStageSchedulable_ApplicationFragmentDoc = gql`
    fragment useApplicationJobStageSchedulable_application on Application {
  id
  jobStageId
  validateCanEnterScheduleFlow {
    valid
    message
  }
  validateCanMoveStage {
    valid
    message
  }
}
    `;
export const CreateTaskActions_ApplicationFragmentDoc = gql`
    fragment CreateTaskActions_application on Application {
  id
  status
  jobId
  job {
    validationIssues {
      errors {
        type
        ...getHiringMismatchError_flags
        ...getHiringSetupError_flags
      }
    }
  }
  ...CreateTaskModals_application
  ...getActiveTasksForJobStage_appliction
  ...useApplicationJobStageSchedulable_application
}
    ${GetHiringMismatchError_FlagsFragmentDoc}
${GetHiringSetupError_FlagsFragmentDoc}
${CreateTaskModals_ApplicationFragmentDoc}
${GetActiveTasksForJobStage_ApplictionFragmentDoc}
${UseApplicationJobStageSchedulable_ApplicationFragmentDoc}`;
export const NonSchedulableJobStageAlert_ApplicationFragmentDoc = gql`
    fragment NonSchedulableJobStageAlert_application on Application {
  id
  jobStageId
  jobStage {
    id
    name
  }
  validateCanEnterScheduleFlow {
    valid
    message
  }
  ...useApplicationJobStageSchedulable_application
}
    ${UseApplicationJobStageSchedulable_ApplicationFragmentDoc}`;
export const ApplicationSidebarCreateTaskButton_ApplicationFragmentDoc = gql`
    fragment ApplicationSidebarCreateTaskButton_application on Application {
  id
  job {
    id
    validationIssues {
      errors {
        ...getHiringMismatchError_flags
        ...getHiringSetupError_flags
      }
    }
  }
  ...CreateTaskActions_application
  ...getActiveTasksForJobStage_appliction
  ...NonSchedulableJobStageAlert_application
}
    ${GetHiringMismatchError_FlagsFragmentDoc}
${GetHiringSetupError_FlagsFragmentDoc}
${CreateTaskActions_ApplicationFragmentDoc}
${GetActiveTasksForJobStage_ApplictionFragmentDoc}
${NonSchedulableJobStageAlert_ApplicationFragmentDoc}`;
export const ApplicationSidebarCreateTaskActions_ApplicationFragmentDoc = gql`
    fragment ApplicationSidebarCreateTaskActions_application on Application {
  id
  ...CreateTaskActions_application
  ...NonSchedulableJobStageAlert_application
}
    ${CreateTaskActions_ApplicationFragmentDoc}
${NonSchedulableJobStageAlert_ApplicationFragmentDoc}`;
export const TaskList_ApplicationFragmentDoc = gql`
    fragment TaskList_application on Application {
  id
  ...getActiveTasksForJobStage_appliction
  ...ApplicationSidebarCreateTaskActions_application
}
    ${GetActiveTasksForJobStage_ApplictionFragmentDoc}
${ApplicationSidebarCreateTaskActions_ApplicationFragmentDoc}`;
export const SelectButtonLabel_EmployeeFragmentDoc = gql`
    fragment SelectButtonLabel_employee on Employee {
  id
  fullName
  internalProfilePictureUrl
}
    `;
export const RecruiterSelect_ApplicationFragmentDoc = gql`
    fragment RecruiterSelect_application on Application {
  id
  recruiter {
    id
    ...SelectButtonLabel_employee
  }
}
    ${SelectButtonLabel_EmployeeFragmentDoc}`;
export const CoordinatorSelect_ApplicationFragmentDoc = gql`
    fragment CoordinatorSelect_application on Application {
  id
  coordinator {
    id
    ...SelectButtonLabel_employee
  }
}
    ${SelectButtonLabel_EmployeeFragmentDoc}`;
export const SourcerSelect_ApplicationFragmentDoc = gql`
    fragment SourcerSelect_application on Application {
  id
  candidateId
  sourcer {
    id
    ...SelectButtonLabel_employee
  }
}
    ${SelectButtonLabel_EmployeeFragmentDoc}`;
export const CandidateInfoSidebar_ApplicationFragmentDoc = gql`
    fragment CandidateInfoSidebar_application on Application {
  id
  ...RecruiterSelect_application
  ...CoordinatorSelect_application
  ...SourcerSelect_application
}
    ${RecruiterSelect_ApplicationFragmentDoc}
${CoordinatorSelect_ApplicationFragmentDoc}
${SourcerSelect_ApplicationFragmentDoc}`;
export const JobStageDetails_JobFragmentDoc = gql`
    fragment JobStageDetails_job on Job {
  id
  jobStages {
    id
    name
    index
  }
}
    `;
export const JobStageMismatchModal_JobFragmentDoc = gql`
    fragment JobStageMismatchModal_job on Job {
  id
  mismatchedApplications {
    id
    application {
      id
      candidate {
        id
        fullName
      }
      job {
        id
        name
      }
    }
    jobStageName
  }
}
    `;
export const JobStageMismatchAlert_JobFragmentDoc = gql`
    fragment JobStageMismatchAlert_job on Job {
  id
  validationIssues {
    errors {
      ...getHiringMismatchError_flags
    }
  }
  ...JobStageMismatchModal_job
}
    ${GetHiringMismatchError_FlagsFragmentDoc}
${JobStageMismatchModal_JobFragmentDoc}`;
export const CandidateTimezoneSelect_CandidateFragmentDoc = gql`
    fragment CandidateTimezoneSelect_candidate on Candidate {
  id
  timezone
}
    `;
export const CandidateLocaleSelect_CandidateFragmentDoc = gql`
    fragment CandidateLocaleSelect_candidate on Candidate {
  id
  locale
}
    `;
export const CandidateInfoSidebar_CandidateFragmentDoc = gql`
    fragment CandidateInfoSidebar_candidate on Candidate {
  id
  ...CandidateTimezoneSelect_candidate
  ...CandidateLocaleSelect_candidate
}
    ${CandidateTimezoneSelect_CandidateFragmentDoc}
${CandidateLocaleSelect_CandidateFragmentDoc}`;
export const ApplicationSidebarContent_ApplicationFragmentDoc = gql`
    fragment ApplicationSidebarContent_application on Application {
  ...ApplicationSidebarCreateTaskButton_application
  ...TaskList_application
  ...CandidateInfoSidebar_application
  id
  jobStage {
    id
  }
  job {
    id
    ...JobStageDetails_job
    ...JobStageMismatchAlert_job
    validationIssues {
      errors {
        ...getHiringSetupError_flags
        ...getHiringMismatchError_flags
      }
    }
  }
  candidate {
    id
    ...CandidateInfoSidebar_candidate
  }
  tasks {
    id
    jobStage {
      id
    }
  }
  validateCanEnterScheduleFlow {
    message
    valid
  }
}
    ${ApplicationSidebarCreateTaskButton_ApplicationFragmentDoc}
${TaskList_ApplicationFragmentDoc}
${CandidateInfoSidebar_ApplicationFragmentDoc}
${JobStageDetails_JobFragmentDoc}
${JobStageMismatchAlert_JobFragmentDoc}
${GetHiringSetupError_FlagsFragmentDoc}
${GetHiringMismatchError_FlagsFragmentDoc}
${CandidateInfoSidebar_CandidateFragmentDoc}`;
export const ApplicationSidebarHeader_ApplicationFragmentDoc = gql`
    fragment ApplicationSidebarHeader_application on Application {
  id
  candidate {
    id
    fullName
  }
  job {
    id
    name
    location
  }
}
    `;
export const MockCandidateLocaleSelect_CandidateFragmentDoc = gql`
    fragment MockCandidateLocaleSelect_candidate on Candidate {
  id
  locale
}
    `;
export const MockCandidateTimezoneSelect_CandidateFragmentDoc = gql`
    fragment MockCandidateTimezoneSelect_candidate on Candidate {
  id
  timezone
}
    `;
export const MockCoordinatorSelect_ApplicationFragmentDoc = gql`
    fragment MockCoordinatorSelect_application on Application {
  id
}
    `;
export const MockRecruiterSelect_ApplicationFragmentDoc = gql`
    fragment MockRecruiterSelect_application on Application {
  id
}
    `;
export const MockSourcerSelect_ApplicationFragmentDoc = gql`
    fragment MockSourcerSelect_application on Application {
  id
}
    `;
export const ScheduleContent_ApplicationFragmentDoc = gql`
    fragment ScheduleContent_application on Application {
  id
  status
}
    `;
export const ScheduleTaskFlagCompact_TaskFlagFragmentDoc = gql`
    fragment ScheduleTaskFlagCompact_taskFlag on TaskFlag {
  id
  flagType
}
    `;
export const ScheduleTaskTagCompact_TaskTagFragmentDoc = gql`
    fragment ScheduleTaskTagCompact_taskTag on TaskTag {
  id
  name
}
    `;
export const CancelScheduleDialog_InterviewsFragmentDoc = gql`
    fragment CancelScheduleDialog_interviews on ApplicationStageInterview {
  id
  startAt
}
    `;
export const ScheduleContentActions_InterviewsFragmentDoc = gql`
    fragment ScheduleContentActions_interviews on ApplicationStageInterview {
  id
  startAt
  endAt
  atsSyncStatus {
    id
    state
  }
  ...CancelScheduleDialog_interviews
}
    ${CancelScheduleDialog_InterviewsFragmentDoc}`;
export const ScheduleContentInterviewMenu_InterviewFragmentDoc = gql`
    fragment ScheduleContentInterviewMenu_interview on ApplicationStageInterview {
  id
  startAt
  googleEventUrl
  videoMeetingUrl
  zoomHostUserId
  zoomDialInInfo
  zoomMeetingId
  zoomPassword
  zoomPstnPassword
  codingInterviewUrl
  isHiddenFromCandidate
  videoMeetingHostEmployee {
    id
    fullName
  }
  meetingLocation {
    id
    type
    videoMeetingLink
    hostEmployee {
      id
      fullName
    }
    remoteVideoMeetingHostUser {
      ... on ZoomUser {
        zoomUserId
        firstName
        lastName
        email
      }
    }
    details {
      customLocation
      zoomInfo {
        meetingId
        userId
        password
        pstnPassword
        dialInfo {
          type
          number
          city
          countryName
          country
        }
      }
    }
  }
  collaborationLink {
    id
    collaborationToolType
    url
  }
}
    `;
export const ScheduleContentInterviewHeader_InterviewFragmentDoc = gql`
    fragment ScheduleContentInterviewHeader_interview on ApplicationStageInterview {
  id
  name
  startAt
  endAt
  googleEventUrl
  videoMeetingUrl
  zoomDialInInfo
  atsInterviewDefinitionId
  atsScheduledInterviewId
  atsSyncStatus {
    id
    providerType
    state
    syncedAt
    errorCode
    errorMessage
    isRetryExhausted
    attemptCount
  }
  codingInterviewUrl
  collaborationLink {
    id
    collaborationToolType
  }
  isHiddenFromCandidate
  ...ScheduleContentInterviewMenu_interview
}
    ${ScheduleContentInterviewMenu_InterviewFragmentDoc}`;
export const AdditionalAttendeesDetails_AdditionalAttendeesFragmentDoc = gql`
    fragment AdditionalAttendeesDetails_additionalAttendees on AdditionalAttendees {
  emails
  isOptional
  attendees {
    email
    employeeId
    isOptional
    employee {
      id
      fullName
      email
      internalProfilePictureUrl
    }
  }
  employees {
    id
    fullName
    email
    internalProfilePictureUrl
  }
}
    `;
export const AdjustInterviewerRsvp_InterviewFragmentDoc = gql`
    fragment AdjustInterviewerRsvp_interview on ApplicationStageInterview {
  id
  startAt
  endAt
  name
  isHiddenFromCandidate
  applicationStageInterviewInterviewers {
    interviewerId
    role
    responseStatus
    isOptional
    declines {
      reason
      comment
    }
    interviewer {
      id
      internalProfilePictureUrl
      fullName
      givenName
    }
  }
}
    `;
export const ScheduleContentInterviewDetailsInterviewer_InterviewFragmentDoc = gql`
    fragment ScheduleContentInterviewDetailsInterviewer_interview on ApplicationStageInterview {
  id
  ...AdjustInterviewerRsvp_interview
}
    ${AdjustInterviewerRsvp_InterviewFragmentDoc}`;
export const ScheduleContentInterviewDetailsInterviewer_InterviewerFragmentDoc = gql`
    fragment ScheduleContentInterviewDetailsInterviewer_interviewer on ApplicationStageInterviewInterviewer {
  applicationStageInterviewId
  interviewerId
  interviewer {
    id
    fullName
    internalProfilePictureUrl
  }
  responseStatus
  proposedTime {
    startAt
    endAt
  }
  calendarEventNote
  isOptional
  role
}
    `;
export const ScheduleContentInterviewDetailsMeetingRoom_MeetingRoomFragmentDoc = gql`
    fragment ScheduleContentInterviewDetailsMeetingRoom_meetingRoom on ApplicationStageInterviewRoom {
  applicationStageInterviewId
  meetingRoomId
  responseStatus
  meetingRoom {
    id
    name
    description
  }
}
    `;
export const ScheduleContentInterviewDetails_InterviewFragmentDoc = gql`
    fragment ScheduleContentInterviewDetails_interview on ApplicationStageInterview {
  id
  additionalAttendeesV2 {
    ...AdditionalAttendeesDetails_additionalAttendees
  }
  ...ScheduleContentInterviewDetailsInterviewer_interview
  applicationStageInterviewInterviewers {
    interviewerId
    ...ScheduleContentInterviewDetailsInterviewer_interviewer
  }
  applicationStageInterviewRooms {
    applicationStageInterviewId
    meetingRoomId
    ...ScheduleContentInterviewDetailsMeetingRoom_meetingRoom
  }
}
    ${AdditionalAttendeesDetails_AdditionalAttendeesFragmentDoc}
${ScheduleContentInterviewDetailsInterviewer_InterviewFragmentDoc}
${ScheduleContentInterviewDetailsInterviewer_InterviewerFragmentDoc}
${ScheduleContentInterviewDetailsMeetingRoom_MeetingRoomFragmentDoc}`;
export const ScheduleContentInterview_InterviewFragmentDoc = gql`
    fragment ScheduleContentInterview_interview on ApplicationStageInterview {
  id
  ...ScheduleContentInterviewHeader_interview
  ...ScheduleContentInterviewDetails_interview
}
    ${ScheduleContentInterviewHeader_InterviewFragmentDoc}
${ScheduleContentInterviewDetails_InterviewFragmentDoc}`;
export const GroupInterviewEventsByDate_InterviewsFragmentDoc = gql`
    fragment groupInterviewEventsByDate_interviews on ApplicationStageInterview {
  id
  startAt
}
    `;
export const GetCandidateEventByInterviewId_InterviewsFragmentDoc = gql`
    fragment getCandidateEventByInterviewId_interviews on ApplicationStageInterview {
  id
  startAt
  endAt
}
    `;
export const ScheduleContentInterviewMenu_CandidateEventFragmentDoc = gql`
    fragment ScheduleContentInterviewMenu_candidateEvent on ApplicationStageCandidateEvent {
  id
  googleEventUrl
}
    `;
export const ScheduleContentInterviewHeader_CandidateEventFragmentDoc = gql`
    fragment ScheduleContentInterviewHeader_candidateEvent on ApplicationStageCandidateEvent {
  id
  ...ScheduleContentInterviewMenu_candidateEvent
}
    ${ScheduleContentInterviewMenu_CandidateEventFragmentDoc}`;
export const ScheduleContentInterview_CandidateEventFragmentDoc = gql`
    fragment ScheduleContentInterview_candidateEvent on ApplicationStageCandidateEvent {
  id
  responseStatus
  ...ScheduleContentInterviewHeader_candidateEvent
  ...ScheduleContentInterviewHeader_candidateEvent
}
    ${ScheduleContentInterviewHeader_CandidateEventFragmentDoc}`;
export const GetCandidateEventByInterviewId_CandidateEventsFragmentDoc = gql`
    fragment getCandidateEventByInterviewId_candidateEvents on ApplicationStageCandidateEvent {
  id
  startAt
  endAt
}
    `;
export const HoldForCandidateCommunications_ApplicationStageFragmentDoc = gql`
    fragment HoldForCandidateCommunications_applicationStage on ApplicationStage {
  id
  isHoldForRsvp
  isReadyForCandidateComms
}
    `;
export const CancelScheduleDialog_ApplicationStageFragmentDoc = gql`
    fragment CancelScheduleDialog_applicationStage on ApplicationStage {
  id
  minStartAt
  maxEndAt
}
    `;
export const ScheduleContentActions_ApplicationStageFragmentDoc = gql`
    fragment ScheduleContentActions_applicationStage on ApplicationStage {
  id
  selfScheduleOptionsId
  frozenAt
  task {
    id
    availabilityRequests {
      id
    }
  }
  ...CancelScheduleDialog_applicationStage
}
    ${CancelScheduleDialog_ApplicationStageFragmentDoc}`;
export const ScheduleContent_ScheduleFragmentDoc = gql`
    fragment ScheduleContent_schedule on ApplicationStage {
  id
  createdAt
  frozenAt
  creator {
    id
    fullName
  }
  applicationStageInterviews(input: {orderBy: {startAt: ASC}, isCancelled: false}) {
    id
    ...ScheduleContentActions_interviews
    ...ScheduleContentInterview_interview
    ...groupInterviewEventsByDate_interviews
    ...getCandidateEventByInterviewId_interviews
  }
  applicationStageCandidateEvents(input: {orderBy: {createdAt: DESC}}) {
    id
    ...ScheduleContentInterview_candidateEvent
    ...getCandidateEventByInterviewId_candidateEvents
  }
  ...HoldForCandidateCommunications_applicationStage
  ...ScheduleContentActions_applicationStage
}
    ${ScheduleContentActions_InterviewsFragmentDoc}
${ScheduleContentInterview_InterviewFragmentDoc}
${GroupInterviewEventsByDate_InterviewsFragmentDoc}
${GetCandidateEventByInterviewId_InterviewsFragmentDoc}
${ScheduleContentInterview_CandidateEventFragmentDoc}
${GetCandidateEventByInterviewId_CandidateEventsFragmentDoc}
${HoldForCandidateCommunications_ApplicationStageFragmentDoc}
${ScheduleContentActions_ApplicationStageFragmentDoc}`;
export const DebriefContentActions_DebriefFragmentDoc = gql`
    fragment DebriefContentActions_debrief on ApplicationDebrief {
  id
  applicationId
  startAt
  endAt
  task {
    id
  }
}
    `;
export const DebriefContentMenu_DebriefFragmentDoc = gql`
    fragment DebriefContentMenu_debrief on ApplicationDebrief {
  id
  startAt
  googleEventUrl
  videoMeetingUrl
  applicationId
  task {
    id
  }
  zoomMeetingId
  zoomHostUserId
  zoomPassword
  zoomPstnPassword
  zoomDialIns
}
    `;
export const DebriefContentHeader_DebriefFragmentDoc = gql`
    fragment DebriefContentHeader_debrief on ApplicationDebrief {
  id
  name
  startAt
  endAt
  videoMeetingUrl
  ...DebriefContentMenu_debrief
}
    ${DebriefContentMenu_DebriefFragmentDoc}`;
export const DebriefContentDetailsInterviewer_DebriefFragmentDoc = gql`
    fragment DebriefContentDetailsInterviewer_debrief on ApplicationDebriefAttendee {
  applicationDebriefId
  interviewerId
  interviewer {
    id
    fullName
    internalProfilePictureUrl
  }
  responseStatus
  isOptional
  proposedTime {
    startAt
    endAt
  }
}
    `;
export const DebriefContentDetailsMeetingRoom_MeetingRoomFragmentDoc = gql`
    fragment DebriefContentDetailsMeetingRoom_meetingRoom on ApplicationDebriefRoom {
  applicationDebriefId
  meetingRoomId
  responseStatus
  meetingRoom {
    id
    name
    description
  }
}
    `;
export const DebriefContentDetails_DebriefFragmentDoc = gql`
    fragment DebriefContentDetails_debrief on ApplicationDebrief {
  id
  additionalAttendeesV2 {
    ...AdditionalAttendeesDetails_additionalAttendees
  }
  attendees {
    applicationDebriefId
    ...DebriefContentDetailsInterviewer_debrief
  }
  meetingRooms {
    applicationDebriefId
    meetingRoomId
    ...DebriefContentDetailsMeetingRoom_meetingRoom
  }
}
    ${AdditionalAttendeesDetails_AdditionalAttendeesFragmentDoc}
${DebriefContentDetailsInterviewer_DebriefFragmentDoc}
${DebriefContentDetailsMeetingRoom_MeetingRoomFragmentDoc}`;
export const DebriefContentMeeting_DebriefFragmentDoc = gql`
    fragment DebriefContentMeeting_debrief on ApplicationDebrief {
  id
  ...DebriefContentHeader_debrief
  ...DebriefContentDetails_debrief
}
    ${DebriefContentHeader_DebriefFragmentDoc}
${DebriefContentDetails_DebriefFragmentDoc}`;
export const DebriefContentEntity_DebriefFragmentDoc = gql`
    fragment DebriefContentEntity_debrief on ApplicationDebrief {
  id
  ...DebriefContentActions_debrief
  ...DebriefContentMeeting_debrief
  startAt
  endAt
  creator {
    fullName
  }
  createdAt
}
    ${DebriefContentActions_DebriefFragmentDoc}
${DebriefContentMeeting_DebriefFragmentDoc}`;
export const TaskCard_TaskFragmentDoc = gql`
    fragment TaskCard_task on Task {
  id
  count
  status
  application {
    id
    ...ScheduleContent_application
  }
  assignee {
    id
    fullName
    internalProfilePictureUrl
  }
  flags {
    id
    resolvedAt
    ...ScheduleTaskFlagCompact_taskFlag
  }
  tags {
    id
    ...ScheduleTaskTagCompact_taskTag
  }
  isUrgent
  schedules {
    id
    createdAt
    ...ScheduleContent_schedule
  }
  debriefs {
    id
    createdAt
    ...DebriefContentEntity_debrief
  }
  jobStage {
    id
    name
  }
  availabilityRequests {
    id
  }
  ...TaskName_task
}
    ${ScheduleContent_ApplicationFragmentDoc}
${ScheduleTaskFlagCompact_TaskFlagFragmentDoc}
${ScheduleTaskTagCompact_TaskTagFragmentDoc}
${ScheduleContent_ScheduleFragmentDoc}
${DebriefContentEntity_DebriefFragmentDoc}
${TaskName_TaskFragmentDoc}`;
export const TaskList_TaskFragmentDoc = gql`
    fragment TaskList_task on Task {
  id
  count
  flags {
    id
    resolvedAt
  }
  status
  ...TaskCard_task
}
    ${TaskCard_TaskFragmentDoc}`;
export const JobSetupRequiredAlert_ApplicationFragmentDoc = gql`
    fragment JobSetupRequiredAlert_application on Application {
  id
  jobStageId
  job {
    id
    validationIssues {
      errors {
        type
        ...getHiringSetupError_flags
      }
    }
  }
}
    ${GetHiringSetupError_FlagsFragmentDoc}`;
export const UpcomingScheduleAlert_ApplicationStagesFragmentDoc = gql`
    fragment UpcomingScheduleAlert_applicationStages on ApplicationStage {
  id
  jobStageId
  startAt
  endAt
  hasInterviewerDeclined
  task {
    id
    status
    flags {
      id
      flagType
      resolvedAt
    }
  }
  applicationStageInterviews {
    id
    startAt
    endAt
    applicationStageInterviewInterviewers {
      interviewerId
      declines {
        applicationStageInterviewId
      }
    }
  }
}
    `;
export const ApplicationAlert_ApplicationFragmentDoc = gql`
    fragment ApplicationAlert_application on Application {
  id
  status
  applicationStages(input: {isCancelled: false}) {
    ...UpcomingScheduleAlert_applicationStages
  }
}
    ${UpcomingScheduleAlert_ApplicationStagesFragmentDoc}`;
export const ApplicationDebriefs_ApplicationFragmentDoc = gql`
    fragment ApplicationDebriefs_application on Application {
  id
  status
  debriefs: applicationDebriefs(
    input: {orderBy: {createdAt: DESC}, isCancelled: false}
  ) {
    id
    task {
      id
    }
    ...DebriefContentEntity_debrief
  }
  ...useApplicationJobStageSchedulable_application
}
    ${DebriefContentEntity_DebriefFragmentDoc}
${UseApplicationJobStageSchedulable_ApplicationFragmentDoc}`;
export const JobStageOptionFragmentDoc = gql`
    fragment JobStageOption on JobStage {
  id
  name
  index
  schedulable
  atsId
  jobId
  jobStageSettingsV2 {
    id
    defaultTask
    isAutomatedTaskEnabled
  }
}
    `;
export const MoveJobStageButton_ApplicationFragmentDoc = gql`
    fragment MoveJobStageButton_application on Application {
  id
  jobStage {
    id
    name
  }
  job {
    id
    aliasedJs: jobStages {
      id
      ...JobStageOption
    }
  }
  candidate {
    id
  }
  validateCanMoveStage {
    valid
    message
  }
  ...getActiveTasksForJobStage_appliction
}
    ${JobStageOptionFragmentDoc}
${GetActiveTasksForJobStage_ApplictionFragmentDoc}`;
export const MoveToNextStageAlert_ApplicationFragmentDoc = gql`
    fragment MoveToNextStageAlert_application on Application {
  id
  candidate {
    id
  }
  job {
    id
    name
    MoveToNextStageAlert_jobStages: jobStages {
      id
      name
      index
    }
  }
  jobStage {
    id
    name
    index
  }
  tasks {
    id
    status
    jobStage {
      id
    }
  }
  atsApplication {
    atsId
    canMoveJobStage
  }
  validateCanMoveStage {
    valid
    message
  }
  ...getActiveTasksForJobStage_appliction
}
    ${GetActiveTasksForJobStage_ApplictionFragmentDoc}`;
export const OpenTaskOnOtherJobStageAlert_ApplicationFragmentDoc = gql`
    fragment OpenTaskOnOtherJobStageAlert_application on Application {
  tasks {
    id
    status
    jobStage {
      id
      name
    }
  }
}
    `;
export const ApplicationContent_ApplicationFragmentDoc = gql`
    fragment ApplicationContent_application on Application {
  id
  jobStageId
  jobStage {
    id
    name
  }
  job {
    id
    name
    ...JobStageDetails_job
    ...JobStageMismatchAlert_job
  }
  ...JobSetupRequiredAlert_application
  tasks {
    id
    jobStage {
      id
    }
  }
  ...ApplicationAlert_application
  ...ApplicationDebriefs_application
  ...MoveJobStageButton_application
  ...TaskList_application
  ...MoveToNextStageAlert_application
  ...OpenTaskOnOtherJobStageAlert_application
  ...ApplicationSidebarCreateTaskButton_application
}
    ${JobStageDetails_JobFragmentDoc}
${JobStageMismatchAlert_JobFragmentDoc}
${JobSetupRequiredAlert_ApplicationFragmentDoc}
${ApplicationAlert_ApplicationFragmentDoc}
${ApplicationDebriefs_ApplicationFragmentDoc}
${MoveJobStageButton_ApplicationFragmentDoc}
${TaskList_ApplicationFragmentDoc}
${MoveToNextStageAlert_ApplicationFragmentDoc}
${OpenTaskOnOtherJobStageAlert_ApplicationFragmentDoc}
${ApplicationSidebarCreateTaskButton_ApplicationFragmentDoc}`;
export const ApplicationNoteEditor_ApplicationFragmentDoc = gql`
    fragment ApplicationNoteEditor_application on Application {
  id
  internalNote
}
    `;
export const ApplicationNote_ApplicationFragmentDoc = gql`
    fragment ApplicationNote_application on Application {
  id
  internalNote
  ...ApplicationNoteEditor_application
}
    ${ApplicationNoteEditor_ApplicationFragmentDoc}`;
export const CandidatePortalActionsMenu_ApplicationFragmentDoc = gql`
    fragment CandidatePortalActionsMenu_application on Application {
  id
  jobId
  jobStageId
  isPortalAccessible
}
    `;
export const CandidatePortalNoteEditor_CandidatePortalNoteFragmentDoc = gql`
    fragment CandidatePortalNoteEditor_candidatePortalNote on CandidatePortalNote {
  id
  content
  lastNotificationSentAt
}
    `;
export const CandidatePortalNote_CandidatePortalNoteFragmentDoc = gql`
    fragment CandidatePortalNote_candidatePortalNote on CandidatePortalNote {
  id
  content
  updatedAt
  ...CandidatePortalNoteEditor_candidatePortalNote
}
    ${CandidatePortalNoteEditor_CandidatePortalNoteFragmentDoc}`;
export const CandidatePortalSettings_ApplicationFragmentDoc = gql`
    fragment CandidatePortalSettings_application on Application {
  ...CandidatePortalActionsMenu_application
  id
  isPortalAccessible
  job {
    org {
      slugs {
        orgId
        slug
      }
    }
  }
  candidatePortalNote {
    id
    ...CandidatePortalNote_candidatePortalNote
  }
}
    ${CandidatePortalActionsMenu_ApplicationFragmentDoc}
${CandidatePortalNote_CandidatePortalNoteFragmentDoc}`;
export const AboutSettings_ApplicationFragmentDoc = gql`
    fragment AboutSettings_application on Application {
  id
  atsApplication {
    atsType
    atsId
    atsUrl
  }
  job {
    id
    mismatchedApplications {
      id
      application {
        id
      }
      jobStageName
    }
  }
  jobStage {
    id
    name
  }
  conversations: existingConversations {
    id
    remoteId
    remoteName
    isArchived
  }
}
    `;
export const HiringTeam_ApplicationFragmentDoc = gql`
    fragment HiringTeam_application on Application {
  id
  ...RecruiterSelect_application
  ...CoordinatorSelect_application
  ...SourcerSelect_application
}
    ${RecruiterSelect_ApplicationFragmentDoc}
${CoordinatorSelect_ApplicationFragmentDoc}
${SourcerSelect_ApplicationFragmentDoc}`;
export const CandidateInfo_ApplicationFragmentDoc = gql`
    fragment CandidateInfo_application on Application {
  existingConversations(input: {isCancelled: false}) {
    id
    remoteId
    remoteName
    isArchived
  }
  ...CandidatePortalSettings_application
  atsApplication {
    atsId
    atsUrl
  }
  ...AboutSettings_application
  ...HiringTeam_application
  atsType
}
    ${CandidatePortalSettings_ApplicationFragmentDoc}
${AboutSettings_ApplicationFragmentDoc}
${HiringTeam_ApplicationFragmentDoc}`;
export const CandidateSecondaryContent_ApplicationFragmentDoc = gql`
    fragment CandidateSecondaryContent_application on Application {
  ...ApplicationNote_application
  ...CandidateInfo_application
}
    ${ApplicationNote_ApplicationFragmentDoc}
${CandidateInfo_ApplicationFragmentDoc}`;
export const ApplicationList_ApplicationFragmentDoc = gql`
    fragment ApplicationList_application on Application {
  id
  jobStageId
  status
  state {
    isSchedulable
    isNotScheduleable
    isUnscheduled
    isAvailabilityRequested
    isReadyToSchedule
    isCanceled
    isOngoing
    isScheduled
    isCompleted
    isScheduledInAts
    isCompletedInAts
    isCandidateDeclined
    isInterviewerDeclined
    isSelfScheduleRequested
  }
  job {
    id
    name
    jobStagesAggregate
  }
  jobStage {
    id
    name
    index
  }
}
    `;
export const CandidateSecondaryContent_ApplicationsFragmentDoc = gql`
    fragment CandidateSecondaryContent_applications on Application {
  ...ApplicationList_application
}
    ${ApplicationList_ApplicationFragmentDoc}`;
export const EditCandidatePhoneNumberModal_CandidateFragmentDoc = gql`
    fragment EditCandidatePhoneNumberModal_candidate on Candidate {
  id
  preferredPhoneNumber
  phoneNumbers
}
    `;
export const AboutSettings_CandidateFragmentDoc = gql`
    fragment AboutSettings_candidate on Candidate {
  id
  timezone
  locale
  updatedAt
  preferredEmail
  email
  linkedinUrl
  preferredPhoneNumber
  phoneNumbers
  atsCandidate {
    atsUrl
  }
  ...CandidateTimezoneSelect_candidate
  ...CandidateLocaleSelect_candidate
  ...EditCandidatePhoneNumberModal_candidate
}
    ${CandidateTimezoneSelect_CandidateFragmentDoc}
${CandidateLocaleSelect_CandidateFragmentDoc}
${EditCandidatePhoneNumberModal_CandidateFragmentDoc}`;
export const ConflictInterestSection_CandidateFragmentDoc = gql`
    fragment ConflictInterestSection_candidate on Candidate {
  id
  conflictOfInterestEmployees {
    id
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;
export const CandidateInfo_CandidateFragmentDoc = gql`
    fragment CandidateInfo_candidate on Candidate {
  id
  email
  preferredEmail
  atsCandidate {
    atsId
    atsUrl
    primaryEmail
  }
  linkedinUrl
  updatedAt
  timezone
  ...AboutSettings_candidate
  ...CandidateTimezoneSelect_candidate
  ...ConflictInterestSection_candidate
}
    ${AboutSettings_CandidateFragmentDoc}
${CandidateTimezoneSelect_CandidateFragmentDoc}
${ConflictInterestSection_CandidateFragmentDoc}`;
export const CandidateSecondaryContent_CandidateFragmentDoc = gql`
    fragment CandidateSecondaryContent_candidate on Candidate {
  ...CandidateInfo_candidate
}
    ${CandidateInfo_CandidateFragmentDoc}`;
export const UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragmentDoc = gql`
    fragment useInterviewPlanHasInterviewHiddenFromCandidate_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      isHiddenFromCandidate
    }
  }
}
    `;
export const BaseCandidateAvailabilityOption_InterviewPlanFragmentDoc = gql`
    fragment BaseCandidateAvailabilityOption_interviewPlan on JobStage {
  id
  ...useIsInterviewPlanValid_jobStage
  ...useInterviewPlanHasInterviewHiddenFromCandidate_interviewPlan
}
    ${UseIsInterviewPlanValid_JobStageFragmentDoc}
${UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragmentDoc}`;
export const CandidateAvailabilityOption_InterviewPlanFragmentDoc = gql`
    fragment CandidateAvailabilityOption_interviewPlan on JobStage {
  id
  ...BaseCandidateAvailabilityOption_interviewPlan
}
    ${BaseCandidateAvailabilityOption_InterviewPlanFragmentDoc}`;
export const CandidateInterviewRowFragmentDoc = gql`
    fragment CandidateInterviewRow on ApplicationStageInterview {
  id
  startAt
  endAt
  isCancelled
  name
  applicationStageInterviewInterviewers {
    applicationStageInterviewId
    interviewerId
    responseStatus
    role
    interviewer {
      id
      fullName
      internalProfilePictureUrl
    }
  }
  googleEventUrl
}
    `;
export const CandidateEventRowFragmentDoc = gql`
    fragment CandidateEventRow on ApplicationStageCandidateEvent {
  id
  isCancelled
  startAt
  endAt
  responseStatus
  name
  googleEventId
  googleEventUrl
  googleCalendarId
}
    `;
export const CandidateApplicationStageFragmentDoc = gql`
    fragment CandidateApplicationStage on ApplicationStage {
  id
  isCancelled
  timezone
  startAt
  endAt
  hasCandidateDeclined
  hasInterviewerDeclined
  hasCandidateTentative
  hasInterviewerTentative
  jobStage {
    id
    name
  }
  applicationStageInterviews(input: {orderBy: {startAt: ASC}}) {
    ...CandidateInterviewRow
  }
  applicationStageCandidateEvents(input: {orderBy: {createdAt: DESC}}) {
    ...CandidateEventRow
  }
}
    ${CandidateInterviewRowFragmentDoc}
${CandidateEventRowFragmentDoc}`;
export const CandidateApplicationStagesRowApplicationFragmentDoc = gql`
    fragment CandidateApplicationStagesRowApplication on Application {
  job {
    id
    name
  }
  upcomingApplicationStage {
    id
    minStartAt
  }
}
    `;
export const CandidateApplicationStagesFragmentDoc = gql`
    fragment CandidateApplicationStages on Application {
  id
  applicationStages(input: {orderBy: {createdAt: DESC}}) {
    ...CandidateApplicationStage
  }
  ...CandidateApplicationStagesRowApplication
}
    ${CandidateApplicationStageFragmentDoc}
${CandidateApplicationStagesRowApplicationFragmentDoc}`;
export const CancelScheduleApplicationStageFragmentDoc = gql`
    fragment CancelScheduleApplicationStage on ApplicationStage {
  id
  minStartAt
  maxEndAt
  jobStageId
  cancelScheduleApplicationStageInterviews: applicationStageInterviews {
    id
    startAt
  }
}
    `;
export const CandidateAvailabilityStatus_AvailabilityFragmentDoc = gql`
    fragment CandidateAvailabilityStatus_availability on CandidateAvailability {
  id
  candidateEnteredAvailability {
    startAt
    endAt
  }
  rcEnteredAvailability {
    startAt
    endAt
  }
  lastUpdatedByEmployee {
    id
    fullName
  }
  employeeUpdatedAt
  candidateUpdatedAt
  updatedAt
}
    `;
export const JobStageFragmentFragmentDoc = gql`
    fragment JobStageFragment on JobStage {
  id
  name
  jobId
  schedulable
  atsId
  index
}
    `;
export const ActionReadyCandidateRow_ApplicationFragmentDoc = gql`
    fragment ActionReadyCandidateRow_application on Application {
  id
  job {
    id
    name
  }
  jobStage {
    id
    name
    jobStageSettingsV2 {
      id
      defaultTask
    }
  }
  candidate {
    id
    fullName
    email
  }
}
    `;
export const AllCandidateTable_ApplicationFragmentDoc = gql`
    fragment AllCandidateTable_application on Application {
  id
  status
  currentJobStageActiveTaskCount
  candidate {
    id
    fullName
  }
  recruiter {
    id
    fullName
    internalProfilePictureUrl
  }
  coordinator {
    id
    fullName
    internalProfilePictureUrl
  }
  job {
    id
    name
  }
  jobStage {
    id
    name
  }
}
    `;
export const CandidatePageFiltersEmployeePrefFragmentDoc = gql`
    fragment CandidatePageFiltersEmployeePref on CandidatePageFiltersPref {
  coordinatorEmployeeIds
  jobIds
  jobStageNames
  recruiterEmployeeIds
  showInactiveApplications
}
    `;
export const RemoveMemberModal_InterviewModuleMemberFragmentDoc = gql`
    fragment RemoveMemberModal_interviewModuleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  stats {
    upcoming
  }
}
    `;
export const SetModuleMemberAsTrained_InterviewModuleMemberFragmentDoc = gql`
    fragment SetModuleMemberAsTrained_interviewModuleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  stats {
    upcoming
  }
}
    `;
export const DeleteModuleLogModal_ModuleMemberInterviewFragmentDoc = gql`
    fragment deleteModuleLogModal_moduleMemberInterview on ModuleMemberInterview {
  id
  trainingRole
  status
}
    `;
export const UpdateModuleLogModal_ModuleMemberInterviewFragmentDoc = gql`
    fragment updateModuleLogModal_moduleMemberInterview on ModuleMemberInterview {
  id
  interviewDate
  trainingRole
  status
  ... on ModuleMemberApplicationStageInterviewLog {
    applicationStageInterview {
      id
    }
    __typename
  }
  __typename
  ...deleteModuleLogModal_moduleMemberInterview
}
    ${DeleteModuleLogModal_ModuleMemberInterviewFragmentDoc}`;
export const Interviewfeedback_InterviewfeedbackFragmentDoc = gql`
    fragment Interviewfeedback_interviewfeedback on ApplicationStageInterviewFeedback {
  reviewer {
    id
    fullName
    internalProfilePictureUrl
  }
  decisionType
  note
  reviewerId
  reviewedAt
}
    `;
export const ApprovalFeedback_FeedbackFragmentDoc = gql`
    fragment ApprovalFeedback_feedback on ApplicationStageInterviewFeedback {
  reviewerId
  decisionType
  reviewedAt
  reviewer {
    id
    fullName
  }
}
    `;
export const ApprovalFeedback_TraineeFeedbackFragmentDoc = gql`
    fragment ApprovalFeedback_traineeFeedback on ApplicationStageInterviewFeedback {
  ...ApprovalFeedback_feedback
}
    ${ApprovalFeedback_FeedbackFragmentDoc}`;
export const ApprovalFeedback_TrainedFeedbackFragmentDoc = gql`
    fragment ApprovalFeedback_trainedFeedback on ApplicationStageInterviewFeedback {
  ...ApprovalFeedback_feedback
}
    ${ApprovalFeedback_FeedbackFragmentDoc}`;
export const ApprovalFeedback_SchedulerFeedbackFragmentDoc = gql`
    fragment ApprovalFeedback_schedulerFeedback on ApplicationStageInterviewFeedback {
  ...ApprovalFeedback_feedback
}
    ${ApprovalFeedback_FeedbackFragmentDoc}`;
export const InterviewLogInterview_InterviewFragmentDoc = gql`
    fragment InterviewLogInterview_interview on ApplicationStageInterview {
  id
  name
  startAt
  endAt
  googleEventUrl
  applicationStageInterviewInterviewers {
    responseStatus
    interviewerId
  }
  applicationStage {
    id
    taskId
    application {
      id
      candidate {
        id
        fullName
      }
      job {
        id
        name
      }
      jobStage {
        id
        name
      }
    }
  }
  traineeFeedback: traineeFeedback(reviewerType: TRAINEE) {
    ...Interviewfeedback_interviewfeedback
    ...ApprovalFeedback_traineeFeedback
  }
  trainedFeedback: traineeFeedback(reviewerType: TRAINED) {
    ...Interviewfeedback_interviewfeedback
    ...ApprovalFeedback_trainedFeedback
  }
  schedulerFeedback: traineeFeedback(reviewerType: SCHEDULER) {
    ...Interviewfeedback_interviewfeedback
    ...ApprovalFeedback_schedulerFeedback
  }
  isHiddenFromCandidate
}
    ${Interviewfeedback_InterviewfeedbackFragmentDoc}
${ApprovalFeedback_TraineeFeedbackFragmentDoc}
${ApprovalFeedback_TrainedFeedbackFragmentDoc}
${ApprovalFeedback_SchedulerFeedbackFragmentDoc}`;
export const InterviewLog_InterviewLogFragmentDoc = gql`
    fragment InterviewLog_interviewLog on ModuleMemberInterview {
  id
  trainingRole
  ... on ModuleMemberApplicationStageInterviewLog {
    applicationStageInterview {
      ...InterviewLogInterview_interview
    }
    __typename
  }
  ... on ModuleMemberManualLog {
    id
    __typename
  }
  __typename
}
    ${InterviewLogInterview_InterviewFragmentDoc}`;
export const InterviewModuleMemberModuleLogRow_ModuleMemberInterviewFragmentDoc = gql`
    fragment interviewModuleMemberModuleLogRow_moduleMemberInterview on ModuleMemberInterview {
  id
  interviewDate
  trainingRole
  status
  ... on ModuleMemberApplicationStageInterviewLog {
    applicationStageInterview {
      startAt
      endAt
      id
    }
    __typename
  }
  ...updateModuleLogModal_moduleMemberInterview
  ...InterviewLog_interviewLog
  __typename
}
    ${UpdateModuleLogModal_ModuleMemberInterviewFragmentDoc}
${InterviewLog_InterviewLogFragmentDoc}`;
export const EditTrainigPlan_ModuleMemberFragmentDoc = gql`
    fragment EditTrainigPlan_moduleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  status
  shadowsRequired
  reverseShadowsRequired
  stats {
    completedAsReverseShadow
    completedAsShadow
    manualCompletedAsShadow
    manualCompletedAsReverseShadow
  }
  interviewModule {
    id
    shadowsRequired
    reverseShadowsRequired
    shouldFastTrackTraining
    graduateFromShadowApprovalType
    graduateFromReverseShadowApprovalType
  }
}
    `;
export const AddModuleLog_ModuleMemberFragmentDoc = gql`
    fragment AddModuleLog_moduleMember on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  shadowsRequired
  status
  reverseShadowsRequired
  stats {
    completedAsReverseShadow
    completedAsShadow
    manualCompletedAsReverseShadow
    manualCompletedAsShadow
  }
  ...EditTrainigPlan_moduleMember
  ...getReverseShadowPendingCount_moduleMember
}
    ${EditTrainigPlan_ModuleMemberFragmentDoc}
${GetReverseShadowPendingCount_ModuleMemberFragmentDoc}`;
export const DeleteModuleLogModal_ModuleMemberFragmentDoc = gql`
    fragment deleteModuleLogModal_moduleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  shadowsRequired
  status
  stats {
    completedAsShadow
    manualCompletedAsShadow
  }
}
    `;
export const UpdateModuleLogModal_ModuleMemberFragmentDoc = gql`
    fragment updateModuleLogModal_moduleMember on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  shadowsRequired
  status
  reverseShadowsRequired
  stats {
    completedAsShadow
    completedAsReverseShadow
    manualCompletedAsShadow
    manualCompletedAsReverseShadow
  }
  ...deleteModuleLogModal_moduleMember
  ...getReverseShadowCompletedCount_moduleMember
}
    ${DeleteModuleLogModal_ModuleMemberFragmentDoc}
${GetReverseShadowCompletedCount_ModuleMemberFragmentDoc}`;
export const InterviewLogInterview_ModuleMemberFragmentDoc = gql`
    fragment InterviewLogInterview_moduleMember on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
}
    `;
export const InterviewLog_ModuleMemberFragmentDoc = gql`
    fragment InterviewLog_moduleMember on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  ...InterviewLogInterview_moduleMember
}
    ${InterviewLogInterview_ModuleMemberFragmentDoc}`;
export const InterviewModuleMemberModuleLogRow_ModuleMemberFragmentDoc = gql`
    fragment interviewModuleMemberModuleLogRow_moduleMember on InterviewModuleMember {
  id
  employeeId
  status
  interviewModuleId
  stats {
    currentTrainingSessionStatus
  }
  ...updateModuleLogModal_moduleMember
  ...InterviewLog_moduleMember
}
    ${UpdateModuleLogModal_ModuleMemberFragmentDoc}
${InterviewLog_ModuleMemberFragmentDoc}`;
export const InterviewModuleMemberModuleLog_ModuleMemberFragmentDoc = gql`
    fragment InterviewModuleMemberModuleLog_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  employee {
    id
    fullName
    internalProfilePictureUrl
  }
  interviewModule {
    id
    name
  }
  stats {
    currentTrainingSessionStatus
  }
  ...AddModuleLog_moduleMember
  ...interviewModuleMemberModuleLogRow_moduleMember
}
    ${AddModuleLog_ModuleMemberFragmentDoc}
${InterviewModuleMemberModuleLogRow_ModuleMemberFragmentDoc}`;
export const ActionButtons_ModuleMemberFragmentDoc = gql`
    fragment ActionButtons_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  status
  shadowsRequired
  reverseShadowsRequired
  pendingApprovalApplicationStageInterview {
    id
  }
  stats {
    currentTrainingSessionStatus
    completedAsShadow
    completedAsReverseShadow
    manualCompletedAsShadow
    manualCompletedAsReverseShadow
  }
  ...getReverseShadowCompletedCount_moduleMember
  ...getShadowCompletedCount_moduleMember
  ...getReverseShadowPendingCount_moduleMember
}
    ${GetReverseShadowCompletedCount_ModuleMemberFragmentDoc}
${GetShadowCompletedCount_ModuleMemberFragmentDoc}
${GetReverseShadowPendingCount_ModuleMemberFragmentDoc}`;
export const PendingApprovalAlert_ModuleMemberFragmentDoc = gql`
    fragment PendingApprovalAlert_moduleMember on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  pendingApprovalApplicationStageInterview {
    id
    traineeFeedback: traineeFeedback(reviewerType: TRAINEE) {
      reviewerId
      reviewedAt
    }
    trainedFeedback: traineeFeedback(reviewerType: TRAINED) {
      reviewerId
      reviewedAt
    }
  }
}
    `;
export const PendingApproval_ModuleMemberFragmentDoc = gql`
    fragment PendingApproval_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  status
  stats {
    currentTrainingSessionStatus
  }
  pendingApprovalApplicationStageInterview {
    id
    startAt
    ...InterviewLogInterview_interview
  }
  ...ActionButtons_moduleMember
  ...InterviewLogInterview_moduleMember
  ...PendingApprovalAlert_moduleMember
}
    ${InterviewLogInterview_InterviewFragmentDoc}
${ActionButtons_ModuleMemberFragmentDoc}
${InterviewLogInterview_ModuleMemberFragmentDoc}
${PendingApprovalAlert_ModuleMemberFragmentDoc}`;
export const IsModuleMemberEmployeePaused_ModuleMemberFragmentDoc = gql`
    fragment isModuleMemberEmployeePaused_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  employee {
    id
    isPaused
  }
}
    `;
export const IsModuleMemberPauseIndefinitely_ModuleMemberFragmentDoc = gql`
    fragment isModuleMemberPauseIndefinitely_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  isPausedIndefinitely
}
    `;
export const GetModuleMemberEmployeePausedText_ModuleMemberFragmentDoc = gql`
    fragment getModuleMemberEmployeePausedText_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  employee {
    id
    isPaused
    timezone
    interviewPauseDates {
      start
      end
    }
  }
}
    `;
export const GetModuleMemberPauseText_ModuleMemberFragmentDoc = gql`
    fragment getModuleMemberPauseText_ModuleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  pausedUntil
  employee {
    id
    timezone
  }
}
    `;
export const ModuleMemberPausedChip_ModuleMemberFragmentDoc = gql`
    fragment ModuleMemberPausedChip_moduleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  isPausedIndefinitely
  isPaused
  pausedUntil
  id
  employee {
    id
    isPaused
    timezone
    interviewPauseDates {
      start
      end
    }
  }
  ...isModuleMemberEmployeePaused_ModuleMember
  ...isModuleMembreOrEmployeePaused_ModuleMember
  ...isModuleMemberPauseIndefinitely_ModuleMember
  ...getModuleMemberEmployeePausedText_ModuleMember
  ...getModuleMemberPauseText_ModuleMember
}
    ${IsModuleMemberEmployeePaused_ModuleMemberFragmentDoc}
${IsModuleMembreOrEmployeePaused_ModuleMemberFragmentDoc}
${IsModuleMemberPauseIndefinitely_ModuleMemberFragmentDoc}
${GetModuleMemberEmployeePausedText_ModuleMemberFragmentDoc}
${GetModuleMemberPauseText_ModuleMemberFragmentDoc}`;
export const ModuleMemberPendingChip_ModuleMemberFragmentDoc = gql`
    fragment ModuleMemberPendingChip_moduleMember on InterviewModuleMember {
  stats {
    currentTrainingSessionStatus
  }
  id
}
    `;
export const InterviewModuleMemberHeader_ModuleMemberFragmentDoc = gql`
    fragment InterviewModuleMemberHeader_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  employee {
    id
    fullName
    internalProfilePictureUrl
  }
  interviewModule {
    id
    name
  }
  status
  ...ModuleMemberPausedChip_moduleMember
  ...ModuleMemberPendingChip_moduleMember
}
    ${ModuleMemberPausedChip_ModuleMemberFragmentDoc}
${ModuleMemberPendingChip_ModuleMemberFragmentDoc}`;
export const EditKeyDatesModal_ModuleMemberFragmentDoc = gql`
    fragment EditKeyDatesModal_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  trainedAt
  createdAt
}
    `;
export const InterviewModuleMemberKeyDates_ModuleMemberFragmentDoc = gql`
    fragment InterviewModuleMemberKeyDates_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  shadowStartAt
  reverseShadowStartAt
  employee {
    id
    fullName
    internalProfilePictureUrl
  }
  shadowsRequired
  reverseShadowsRequired
  interviewModule {
    id
    name
  }
  status
  createdAt
  trainedAt
  timeToTrain
  ...EditKeyDatesModal_moduleMember
}
    ${EditKeyDatesModal_ModuleMemberFragmentDoc}`;
export const PauseMemberModal_ModuleMemberFragmentDoc = gql`
    fragment pauseMemberModal_moduleMember on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  isPausedIndefinitely
  isPaused
  pausedUntil
  employee {
    id
    timezone
  }
}
    `;
export const ModuleLoadPauseRow_ModuleMemberFragmentDoc = gql`
    fragment moduleLoadPauseRow_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  weeklyNumInterviewLimit
  ...pauseMemberModal_moduleMember
  employee {
    id
    isPaused
    timezone
    interviewPauseDates {
      start
      end
    }
  }
  ...isModuleMemberEmployeePaused_ModuleMember
  ...isModuleMembreOrEmployeePaused_ModuleMember
  ...isModuleMemberPauseIndefinitely_ModuleMember
}
    ${PauseMemberModal_ModuleMemberFragmentDoc}
${IsModuleMemberEmployeePaused_ModuleMemberFragmentDoc}
${IsModuleMembreOrEmployeePaused_ModuleMemberFragmentDoc}
${IsModuleMemberPauseIndefinitely_ModuleMemberFragmentDoc}`;
export const ModuleLoad_ModuleMemberFragmentDoc = gql`
    fragment moduleLoad_moduleMember on InterviewModuleMember {
  id
  interviewModuleId
  employeeId
  weeklyNumInterviewLimit
  employee {
    id
    isPaused
    timezone
    interviewPauseDates {
      start
      end
    }
  }
  ...pauseMemberModal_moduleMember
  ...moduleLoadPauseRow_moduleMember
  ...isModuleMemberEmployeePaused_ModuleMember
  ...isModuleMembreOrEmployeePaused_ModuleMember
  ...isModuleMemberPauseIndefinitely_ModuleMember
  ...getModuleMemberEmployeePausedText_ModuleMember
  ...getModuleMemberPauseText_ModuleMember
}
    ${PauseMemberModal_ModuleMemberFragmentDoc}
${ModuleLoadPauseRow_ModuleMemberFragmentDoc}
${IsModuleMemberEmployeePaused_ModuleMemberFragmentDoc}
${IsModuleMembreOrEmployeePaused_ModuleMemberFragmentDoc}
${IsModuleMemberPauseIndefinitely_ModuleMemberFragmentDoc}
${GetModuleMemberEmployeePausedText_ModuleMemberFragmentDoc}
${GetModuleMemberPauseText_ModuleMemberFragmentDoc}`;
export const AddToTrainingPlan_ModuleMemberFragmentDoc = gql`
    fragment AddToTrainingPlan_moduleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  shadowsRequired
  reverseShadowsRequired
  stats {
    completedAsShadow
    completedAsReverseShadow
    manualCompletedAsShadow
    manualCompletedAsReverseShadow
  }
}
    `;
export const SetModuleMemberAsTrainee_ModuleMemberFragmentDoc = gql`
    fragment SetModuleMemberAsTrainee_moduleMember on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  stats {
    upcoming
  }
  ...AddToTrainingPlan_moduleMember
}
    ${AddToTrainingPlan_ModuleMemberFragmentDoc}`;
export const TrainingPlanSection_ModuleMemberFragmentDoc = gql`
    fragment TrainingPlanSection_moduleMember on InterviewModuleMember {
  employeeId
  interviewModuleId
  status
  shadowsRequired
  reverseShadowsRequired
  trainedAt
  stats {
    currentTrainingSessionStatus
  }
  ...getReverseShadowCompletedCount_moduleMember
  ...getReverseShadowPendingCount_moduleMember
  ...getShadowCompletedCount_moduleMember
  ...getShadowPendingCount_moduleMember
  ...SetModuleMemberAsTrainee_moduleMember
  ...EditTrainigPlan_moduleMember
}
    ${GetReverseShadowCompletedCount_ModuleMemberFragmentDoc}
${GetReverseShadowPendingCount_ModuleMemberFragmentDoc}
${GetShadowCompletedCount_ModuleMemberFragmentDoc}
${GetShadowPendingCount_ModuleMemberFragmentDoc}
${SetModuleMemberAsTrainee_ModuleMemberFragmentDoc}
${EditTrainigPlan_ModuleMemberFragmentDoc}`;
export const AddMembersModal_ModuleFragmentDoc = gql`
    fragment AddMembersModal_module on InterviewModule {
  id
  shadowsRequired
  reverseShadowsRequired
}
    `;
export const MembersList_ModuleFragmentDoc = gql`
    fragment MembersList_module on InterviewModule {
  id
  membersCount
  membersTrainedCount
  ...AddMembersModal_module
}
    ${AddMembersModal_ModuleFragmentDoc}`;
export const ModuleMemberSidePanelFragmentDoc = gql`
    fragment ModuleMemberSidePanel on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  ...PendingApproval_moduleMember
  ...InterviewModuleMemberHeader_moduleMember
  ...InterviewModuleMemberKeyDates_moduleMember
  ...moduleLoad_moduleMember
  ...TrainingPlanSection_moduleMember
  interviewModule {
    id
    ...MembersList_module
  }
}
    ${PendingApproval_ModuleMemberFragmentDoc}
${InterviewModuleMemberHeader_ModuleMemberFragmentDoc}
${InterviewModuleMemberKeyDates_ModuleMemberFragmentDoc}
${ModuleLoad_ModuleMemberFragmentDoc}
${TrainingPlanSection_ModuleMemberFragmentDoc}
${MembersList_ModuleFragmentDoc}`;
export const DebriefCommunications_CandidateFragmentDoc = gql`
    fragment DebriefCommunications_candidate on Candidate {
  id
  preferredName
  preferredPhoneNumber
}
    `;
export const AttendeeAttributesFragmentDoc = gql`
    fragment AttendeeAttributes on Employee {
  id
  fullName
  internalProfilePictureUrl
  familyName
  isArchived
  isAtsDisabled
  isDirectoryDisabled
  hasAtsId
}
    `;
export const AtsDebriefStageFromApplicationFragmentDoc = gql`
    fragment AtsDebriefStageFromApplication on AtsApplication {
  atsId
  atsScheduledInterviews {
    atsId
    startAt
    endAt
    atsInterviewDefinition {
      atsId
      atsJobStage {
        atsId
        name
      }
    }
    interviewers {
      atsUser {
        id
        employee {
          ...AttendeeAttributes
        }
      }
    }
  }
}
    ${AttendeeAttributesFragmentDoc}`;
export const AttributesFilterFragmentDoc = gql`
    fragment AttributesFilter on EmployeeAttributeName {
  id
  name
  type
  values {
    id
    value
  }
}
    `;
export const InterviewModuleRow_InterviewModuleFragmentDoc = gql`
    fragment InterviewModuleRow_InterviewModule on InterviewModule {
  id
  name
  membersTrainedCount
  membersInTrainingCount
  membersInPendingApprovalCount
  shadowsRequired
  reverseShadowsRequired
  trained: interviewModuleMembers(input: $trainedEmployeesInput) {
    items {
      interviewModuleId
      employeeId
      employee {
        internalProfilePictureUrl
        fullName
        id
      }
    }
  }
  untrained: interviewModuleMembers(input: $untrainedEmployeesInput) {
    items {
      interviewModuleId
      employeeId
      employee {
        internalProfilePictureUrl
        fullName
        id
      }
    }
  }
}
    `;
export const InterviewModuleList_InterviewModuleFragmentDoc = gql`
    fragment InterviewModuleList_InterviewModule on InterviewModule {
  id
  ...InterviewModuleRow_InterviewModule
}
    ${InterviewModuleRow_InterviewModuleFragmentDoc}`;
export const UpdateModuleName_TrainingScheduleFragmentDoc = gql`
    fragment UpdateModuleName_trainingSchedule on InterviewModule {
  id
  name
  shouldFastTrackTraining
}
    `;
export const UpdateModuleName_InterviewModuleFragmentDoc = gql`
    fragment UpdateModuleName_interviewModule on InterviewModule {
  id
  name
}
    `;
export const InterviewModuleSetup_InterviewModuleFragmentDoc = gql`
    fragment InterviewModuleSetup_interviewModule on InterviewModule {
  id
  name
  weeklyNumInterviewLimit
  shadowsRequired
  reverseShadowsRequired
  shouldFastTrackTraining
  graduateFromReverseShadowApprovalType
  graduateFromReverseShadowCustomApprovers
  graduateFromShadowApprovalType
  graduateFromShadowCustomApprovers
  ...UpdateModuleName_trainingSchedule
  ...UpdateModuleName_interviewModule
}
    ${UpdateModuleName_TrainingScheduleFragmentDoc}
${UpdateModuleName_InterviewModuleFragmentDoc}`;
export const ModuleMemberTrainingStatus_ModuleMemberFragmentDoc = gql`
    fragment ModuleMemberTrainingStatus_moduleMember on InterviewModuleMember {
  interviewModuleId
  employeeId
  isPausedIndefinitely
  isPaused
  pausedUntil
  stats {
    currentTrainingSessionStatus
  }
  employee {
    id
    isPaused
    timezone
    isAtsDisabled
    isDirectoryDisabled
    hasAtsId
    interviewPauseDates {
      start
      end
    }
  }
  ...ModuleMemberPendingChip_moduleMember
  ...ModuleMemberPausedChip_moduleMember
}
    ${ModuleMemberPendingChip_ModuleMemberFragmentDoc}
${ModuleMemberPausedChip_ModuleMemberFragmentDoc}`;
export const ModuleMemberRow_ModuleMemberFragmentDoc = gql`
    fragment ModuleMemberRow_moduleMember on InterviewModuleMember {
  id
  ...ModuleMemberTrainingStatus_moduleMember
  status
  employeeId
  interviewModuleId
  shadowsRequired
  reverseShadowsRequired
  employee {
    id
    fullName
    internalProfilePictureUrl
    title
  }
  interviewModule {
    id
    name
  }
  stats {
    upcoming
    completedAsShadow
    completedAsReverseShadow
    completed
    completedAsInterviewer
    manualCompletedAsInterviewer
    manualCompletedAsShadow
    manualCompletedAsReverseShadow
  }
}
    ${ModuleMemberTrainingStatus_ModuleMemberFragmentDoc}`;
export const Members_MembersFragmentDoc = gql`
    fragment Members_members on InterviewModuleMember {
  interviewModuleId
  employeeId
  ...ModuleMemberRow_moduleMember
}
    ${ModuleMemberRow_ModuleMemberFragmentDoc}`;
export const Modules_MemberModulesFragmentDoc = gql`
    fragment Modules_memberModules on InterviewModuleMember {
  interviewModuleId
  employeeId
  ...ModuleMemberRow_moduleMember
}
    ${ModuleMemberRow_ModuleMemberFragmentDoc}`;
export const ModulesList_EmployeeFragmentDoc = gql`
    fragment ModulesList_employee on Employee {
  id
  modulesTrainedCount
  modulesInTrainingCount
}
    `;
export const InterviewModulesTab_EmployeeFragmentDoc = gql`
    fragment InterviewModulesTab_employee on Employee {
  id
  ...ModulesList_employee
}
    ${ModulesList_EmployeeFragmentDoc}`;
export const AttributeEditRow_AttributeTagValueFragmentDoc = gql`
    fragment AttributeEditRow_attributeTagValue on EmployeeAttributeTagValue {
  id
  value
  parent: name {
    id
    type
    name
    syncSourceType
  }
}
    `;
export const AttributeEditRow_EmployeeAttributeParentFragmentDoc = gql`
    fragment AttributeEditRow_employeeAttributeParent on EmployeeAttributeName {
  id
  name
  type
  syncSourceType
  values {
    ...AttributeEditRow_attributeTagValue
  }
}
    ${AttributeEditRow_AttributeTagValueFragmentDoc}`;
export const AttributeSectionEditDialog_AttributeTagValueFragmentDoc = gql`
    fragment AttributeSectionEditDialog_attributeTagValue on EmployeeAttributeTagValue {
  id
  value
  parent: name {
    id
    type
    name
    syncSourceType
  }
}
    `;
export const SchedulingContactEmployeeCacheFragmentFragmentDoc = gql`
    fragment SchedulingContactEmployeeCacheFragment on Employee {
  id
  internalProfilePictureUrl
  fullName
}
    `;
export const BufferTimesSection_InterviewerFragmentDoc = gql`
    fragment BufferTimesSection_interviewer on Employee {
  id
  employeePrefValues {
    ... on JsonEmployeePrefValue {
      id
      prefName
      level
      value {
        ... on InterviewBufferTimePref {
          after {
            seconds
          }
          before {
            seconds
          }
        }
      }
    }
  }
}
    `;
export const FeedbackWritingTimeSection_InterviewerFragmentDoc = gql`
    fragment FeedbackWritingTimeSection_interviewer on Employee {
  id
  employeePrefValues {
    ... on DurationEmployeePrefValue {
      id
      prefName
      level
      value {
        seconds
      }
    }
  }
}
    `;
export const InterviewerStatusAccordion_InterviewerFragmentDoc = gql`
    fragment InterviewerStatusAccordion_interviewer on Employee {
  id
  isAtsDisabled
  isArchived
  isDirectoryDisabled
  isDisabled
  isPaused
  hasAtsId
  timezone
  interviewPauseDates {
    start
    end
  }
  loadAndLimit(input: {date: $date, timezone: $timezone}) {
    dailyLoad
    weeklyLoad
    lastWeeklyLoad
    dailyLoadMinutes
    weeklyLoadMinutes
    lastWeeklyLoadMinutes
    dailyInterviewLimit {
      type
      limit
    }
    weeklyInterviewLimit {
      type
      limit
    }
  }
  interviewModuleMembers(input: {pageInput: {limit: 500, offset: 0}}) {
    items {
      interviewModuleId
      employeeId
      isPaused
      interviewModule {
        id
        name
      }
    }
  }
  orgDirectoryIntegration {
    name
    type
  }
}
    `;
export const AboutSectionEditDialog_InterviewerFragmentDoc = gql`
    fragment AboutSectionEditDialog_interviewer on Employee {
  id
  fullName
  givenName
  isArchived
  familyName
  email
  title
  linkedinUrl
  atsUser {
    atsId
    name
    email
    disabled: isDisabled
  }
  manager {
    id
    internalProfilePictureUrl
    fullName
  }
  attributes {
    id
    value
    parent: name {
      id
      name
      type
      syncSourceType
    }
  }
}
    `;
export const InterviewerAboutSection_InterviewerFragmentDoc = gql`
    fragment InterviewerAboutSection_interviewer on Employee {
  ...AboutSectionEditDialog_interviewer
  id
  fullName
  givenName
  familyName
  email
  title
  linkedinUrl
  pronouns
  bio
  manager {
    id
    internalProfilePictureUrl
    fullName
  }
  atsUser {
    atsId
    name
    email
    disabled: isDisabled
  }
  attributes {
    id
    parent: name {
      id
      name
      type
    }
    value
  }
}
    ${AboutSectionEditDialog_InterviewerFragmentDoc}`;
export const SchedulingContactSectionEditDialog_InterviewerFragmentDoc = gql`
    fragment SchedulingContactSectionEditDialog_interviewer on Employee {
  id
  email
  calendarDelegate {
    id
    internalProfilePictureUrl
    fullName
  }
}
    `;
export const SchedulingContactSection_InterviewerFragmentDoc = gql`
    fragment SchedulingContactSection_interviewer on Employee {
  ...SchedulingContactSectionEditDialog_interviewer
  fullName
  calendarDelegate {
    id
    internalProfilePictureUrl
    fullName
  }
}
    ${SchedulingContactSectionEditDialog_InterviewerFragmentDoc}`;
export const InterviewerWorkHours_WorkHoursFragmentDoc = gql`
    fragment InterviewerWorkHours_workHours on Employee {
  id
  workHours {
    monday {
      start
      end
    }
    tuesday {
      start
      end
    }
    wednesday {
      start
      end
    }
    thursday {
      start
      end
    }
    friday {
      start
      end
    }
    saturday {
      start
      end
    }
    sunday {
      start
      end
    }
  }
}
    `;
export const AvailabilitySectionEditDialog_InterviewerFragmentDoc = gql`
    fragment AvailabilitySectionEditDialog_interviewer on Employee {
  id
  fullName
  useCalendarTimezone
  calendarTimezone
  timezone
  employeePrefs {
    id
    prefName
    json
  }
  ...InterviewerWorkHours_workHours
}
    ${InterviewerWorkHours_WorkHoursFragmentDoc}`;
export const AvailabilitySection_InterviewerFragmentDoc = gql`
    fragment AvailabilitySection_interviewer on Employee {
  id
  useCalendarTimezone
  calendarTimezone
  timezone
  interviewPauseDates {
    start
    end
  }
  loadAndLimit(input: {date: $date, timezone: $timezone}) {
    dailyInterviewLimit {
      type
      limit
    }
    weeklyInterviewLimit {
      type
      limit
    }
  }
  employeePrefs {
    orgId
    employeeId
    prefName
    json
  }
  workHours {
    monday {
      start
      end
    }
    tuesday {
      start
      end
    }
    wednesday {
      start
      end
    }
    thursday {
      start
      end
    }
    friday {
      start
      end
    }
    saturday {
      start
      end
    }
    sunday {
      start
      end
    }
  }
  ...AvailabilitySectionEditDialog_interviewer
}
    ${AvailabilitySectionEditDialog_InterviewerFragmentDoc}`;
export const AttributeEditRow_InterviewerAttributesFragmentDoc = gql`
    fragment AttributeEditRow_interviewerAttributes on EmployeeAttributeTagValue {
  ...AttributeEditRow_attributeTagValue
}
    ${AttributeEditRow_AttributeTagValueFragmentDoc}`;
export const AttributesSectionEditDialog_InterviewerFragmentDoc = gql`
    fragment AttributesSectionEditDialog_interviewer on Employee {
  id
  fullName
  attributes {
    id
    value
    parent: name {
      id
      type
      name
      syncSourceType
    }
    ...AttributeEditRow_interviewerAttributes
  }
}
    ${AttributeEditRow_InterviewerAttributesFragmentDoc}`;
export const InterviewerAttributesSection_InterviewerFragmentDoc = gql`
    fragment InterviewerAttributesSection_interviewer on Employee {
  id
  attributes {
    id
    value
    parent: name {
      id
      type
      name
    }
  }
  ...AttributesSectionEditDialog_interviewer
}
    ${AttributesSectionEditDialog_InterviewerFragmentDoc}`;
export const TemporaryAvailabilityWorkHours_WorkHoursFragmentDoc = gql`
    fragment TemporaryAvailabilityWorkHours_workHours on TimeBlockWeek {
  monday {
    start
    end
  }
  tuesday {
    start
    end
  }
  wednesday {
    start
    end
  }
  thursday {
    start
    end
  }
  friday {
    start
    end
  }
  saturday {
    start
    end
  }
  sunday {
    start
    end
  }
}
    `;
export const TemporaryAvailabilityDialog_PlannedAvailabilityFragmentDoc = gql`
    fragment TemporaryAvailabilityDialog_plannedAvailability on EmployeePlannedAvailability {
  id
  employeeId
  startAt
  endAt
  timezone
  workHours {
    ...TemporaryAvailabilityWorkHours_workHours
  }
}
    ${TemporaryAvailabilityWorkHours_WorkHoursFragmentDoc}`;
export const PlannedAvailabilitySection_InterviewerFragmentDoc = gql`
    fragment PlannedAvailabilitySection_interviewer on Employee {
  id
  interviewPauseDates {
    start
    end
  }
  useCalendarTimezone
  calendarTimezone
  timezone
  plannedAvailabilities {
    id
    ...TemporaryAvailabilityDialog_plannedAvailability
  }
}
    ${TemporaryAvailabilityDialog_PlannedAvailabilityFragmentDoc}`;
export const ExternalProfileModalInterviewerFragmentDoc = gql`
    fragment ExternalProfileModalInterviewer on Employee {
  id
  givenName
  familyName
  fullName
  title
  linkedinUrl
  bio
  pronouns
  email
  externalProfilePicture {
    imageOriginal
  }
}
    `;
export const ExternalProfileEditModal_InterviewerFragmentDoc = gql`
    fragment ExternalProfileEditModal_interviewer on Employee {
  ...ExternalProfileModalInterviewer
}
    ${ExternalProfileModalInterviewerFragmentDoc}`;
export const ProfileCard_InterviewerFragmentDoc = gql`
    fragment ProfileCard_interviewer on Employee {
  id
  fullName
  title
  linkedinUrl
  bio
  pronouns
  email
  externalProfilePicture {
    imageOriginal
  }
}
    `;
export const ExternalProfileSection_InterviewerFragmentDoc = gql`
    fragment ExternalProfileSection_interviewer on Employee {
  ...ExternalProfileEditModal_interviewer
  ...ProfileCard_interviewer
}
    ${ExternalProfileEditModal_InterviewerFragmentDoc}
${ProfileCard_InterviewerFragmentDoc}`;
export const InterviewModulesAccordion_InterviewerModulesFragmentDoc = gql`
    fragment InterviewModulesAccordion_interviewerModules on InterviewModuleMember {
  id
  employeeId
  interviewModuleId
  status
  shadowsRequired
  reverseShadowsRequired
  isPausedIndefinitely
  pausedUntil
  weeklyNumInterviewLimit
  isPaused
  employee {
    fullName
    timezone
    id
    isPaused
    internalProfilePictureUrl
    title
  }
  interviewModule {
    id
    name
  }
  stats {
    currentTrainingSessionStatus
    upcoming
    completed
    manualCompletedAsShadow
    manualCompletedAsReverseShadow
  }
  ...ModuleMemberRow_moduleMember
}
    ${ModuleMemberRow_ModuleMemberFragmentDoc}`;
export const InterviewsAccordion_EmployeeFragmentDoc = gql`
    fragment InterviewsAccordion_employee on Employee {
  id
}
    `;
export const InterviewItemFragmentDoc = gql`
    fragment InterviewItem on ApplicationStageInterview {
  id
  name
  startAt
  endAt
  isCancelled
  googleEventUrl
  applicationStage {
    id
    application {
      id
      candidate {
        id
        fullName
      }
      job {
        id
        name
      }
      jobStage {
        id
        name
      }
    }
  }
  applicationStageInterviewInterviewers {
    interviewerId
    role
    responseStatus
    isOptional
    interviewer {
      id
      fullName
      internalProfilePictureUrl
    }
    declines {
      reason
      comment
      source
    }
  }
  applicationStageInterviewRooms {
    applicationStageInterviewId
    meetingRoomId
    responseStatus
  }
}
    `;
export const InterviewsAccordion_InterviewFragmentDoc = gql`
    fragment InterviewsAccordion_interview on ApplicationStageInterview {
  ...InterviewItem
}
    ${InterviewItemFragmentDoc}`;
export const InterviewerInfoContainer_EmployeeFragmentDoc = gql`
    fragment InterviewerInfoContainer_employee on Employee {
  id
  fullName
  email
  isPaused
  orgId
  ...BufferTimesSection_interviewer
  ...FeedbackWritingTimeSection_interviewer
  ...InterviewerStatusAccordion_interviewer
  ...InterviewerAboutSection_interviewer
  ...SchedulingContactSection_interviewer
  ...AvailabilitySection_interviewer
  ...InterviewerAttributesSection_interviewer
  ...PlannedAvailabilitySection_interviewer
  ...ExternalProfileSection_interviewer
  interviewModuleMembers(input: {pageInput: {limit: 500, offset: 0}}) {
    items {
      ...InterviewModulesAccordion_interviewerModules
    }
  }
  ...InterviewsAccordion_employee
  applicationStageInterviews(
    input: {pageInput: {limit: 3}, orderBy: {property: DATE, direction: ASC}, statusFilters: [SCHEDULED, ONGOING]}
  ) {
    items {
      ...InterviewsAccordion_interview
    }
  }
}
    ${BufferTimesSection_InterviewerFragmentDoc}
${FeedbackWritingTimeSection_InterviewerFragmentDoc}
${InterviewerStatusAccordion_InterviewerFragmentDoc}
${InterviewerAboutSection_InterviewerFragmentDoc}
${SchedulingContactSection_InterviewerFragmentDoc}
${AvailabilitySection_InterviewerFragmentDoc}
${InterviewerAttributesSection_InterviewerFragmentDoc}
${PlannedAvailabilitySection_InterviewerFragmentDoc}
${ExternalProfileSection_InterviewerFragmentDoc}
${InterviewModulesAccordion_InterviewerModulesFragmentDoc}
${InterviewsAccordion_EmployeeFragmentDoc}
${InterviewsAccordion_InterviewFragmentDoc}`;
export const ExternalProfileEditModal_InterviewerFieldsSyncSourceFragmentDoc = gql`
    fragment ExternalProfileEditModal_interviewerFieldsSyncSource on EmployeeFieldSyncSourcePref {
  name
  title
  linkedInUrl
}
    `;
export const ExternalProfileSection_InterviewerFieldsSyncSourceFragmentDoc = gql`
    fragment ExternalProfileSection_interviewerFieldsSyncSource on EmployeeFieldSyncSourcePref {
  ...ExternalProfileEditModal_interviewerFieldsSyncSource
}
    ${ExternalProfileEditModal_InterviewerFieldsSyncSourceFragmentDoc}`;
export const InterviewerInfoContainer_InterviewerFieldsSyncSourceFragmentDoc = gql`
    fragment InterviewerInfoContainer_interviewerFieldsSyncSource on EmployeeFieldSyncSourcePref {
  ...ExternalProfileSection_interviewerFieldsSyncSource
}
    ${ExternalProfileSection_InterviewerFieldsSyncSourceFragmentDoc}`;
export const InterviewsTab_InterviewFragmentDoc = gql`
    fragment InterviewsTab_interview on ApplicationStageInterview {
  id
  name
  startAt
  endAt
  isCancelled
  googleEventUrl
  applicationStage {
    id
    application {
      id
      candidate {
        id
        fullName
      }
      job {
        id
        name
      }
      jobStage {
        id
        name
      }
    }
  }
  applicationStageInterviewInterviewers {
    interviewerId
    role
    responseStatus
    isOptional
    interviewer {
      id
      fullName
      internalProfilePictureUrl
    }
    declines {
      reason
      comment
      source
    }
  }
  applicationStageInterviewRooms {
    applicationStageInterviewId
    meetingRoomId
    responseStatus
  }
}
    `;
export const InterviewsTab_InterviewerFragmentDoc = gql`
    fragment InterviewsTab_interviewer on Employee {
  id
  applicationStageInterviews(input: $input) {
    items {
      ...InterviewsTab_interview
    }
    nextCursor
  }
}
    ${InterviewsTab_InterviewFragmentDoc}`;
export const PortalPreviewByJobStage_BrandingThemeFragmentDoc = gql`
    fragment PortalPreviewByJobStage_brandingTheme on BrandingTheme {
  id
  coverImageUrl
  profileImageUrl
  font
  themeMode
  primaryColor
}
    `;
export const PortalPreviewByJobStage_JobStagesFragmentDoc = gql`
    fragment PortalPreviewByJobStage_jobStages on JobStage {
  id
  name
  index
}
    `;
export const PortalPreviewByJobStage_RecruitingTeamContactInfoFragmentDoc = gql`
    fragment PortalPreviewByJobStage_recruitingTeamContactInfo on RecruitingTeamContactInfoSetting {
  showRecruiter
  showCoordinator
}
    `;
export const TabRow_TabFragmentDoc = gql`
    fragment TabRow_tab on PortalJobOptionsTab {
  id
  index
  name
  icon
  visibility
  portalTemplateId
  jobStageId
  jobStage {
    id
  }
}
    `;
export const DraggableTabRows_TabsFragmentDoc = gql`
    fragment DraggableTabRows_tabs on PortalJobOptionsTab {
  id
  ...TabRow_tab
}
    ${TabRow_TabFragmentDoc}`;
export const CustomTabs_CustomTabsFragmentDoc = gql`
    fragment CustomTabs_customTabs on PortalJobOptionsTab {
  id
  ...DraggableTabRows_tabs
}
    ${DraggableTabRows_TabsFragmentDoc}`;
export const Settings_PortalJobOptionsFragmentDoc = gql`
    fragment Settings_portalJobOptions on PortalJobOptions {
  intro
  brandingThemeId
  useOrgDefaultBrandingTheme
  aiAssistantId
}
    `;
export const JobNameAndLocationHeader_JobFragmentDoc = gql`
    fragment JobNameAndLocationHeader_job on Job {
  id
  status
  name
  location
  atsJob {
    atsCustomerFriendlyId
  }
}
    `;
export const HiringProcess_JobFragmentDoc = gql`
    fragment HiringProcess_job on Job {
  id
  ...JobNameAndLocationHeader_job
}
    ${JobNameAndLocationHeader_JobFragmentDoc}`;
export const HiringTeamJobEmployeeFragmentFragmentDoc = gql`
    fragment HiringTeamJobEmployeeFragment on Employee {
  fullName
  email
  id
  orgId
  internalProfilePictureUrl
  timezone
  atsId
}
    `;
export const HiringTeam_JobEmployeeFragmentDoc = gql`
    fragment HiringTeam_jobEmployee on Job {
  hiringManagers {
    ...HiringTeamJobEmployeeFragment
  }
  recruiters {
    ...HiringTeamJobEmployeeFragment
  }
  coordinators {
    ...HiringTeamJobEmployeeFragment
  }
  sourcers {
    ...HiringTeamJobEmployeeFragment
  }
}
    ${HiringTeamJobEmployeeFragmentFragmentDoc}`;
export const JobLocale_JobFragmentDoc = gql`
    fragment JobLocale_job on Job {
  jobSettings {
    locale {
      value
      level
    }
  }
}
    `;
export const ResetSmartRecruitersHiringProcessDialog_JobFragmentDoc = gql`
    fragment ResetSmartRecruitersHiringProcessDialog_job on Job {
  id
  atsJob {
    atsUrl
  }
  jobSettings {
    id
    hiringProcess {
      atsId
      name
    }
  }
}
    `;
export const GeneralSetupSettings_JobFragmentDoc = gql`
    fragment GeneralSetupSettings_job on Job {
  id
  jobSettings {
    id
    defaultTaskQueue {
      id
    }
    hiringProcess {
      name
      status
    }
  }
  validationIssues {
    errors {
      ...getHiringMismatchError_flags
    }
  }
  ...JobLocale_job
  ...ResetSmartRecruitersHiringProcessDialog_job
}
    ${GetHiringMismatchError_FlagsFragmentDoc}
${JobLocale_JobFragmentDoc}
${ResetSmartRecruitersHiringProcessDialog_JobFragmentDoc}`;
export const ManageJobDisplayNameModal_JobFragmentDoc = gql`
    fragment ManageJobDisplayNameModal_job on Job {
  id
  name
  fallbackName
}
    `;
export const JobDisplayNameSection_JobFragmentDoc = gql`
    fragment JobDisplayNameSection_job on Job {
  id
  name
  fallbackName
  atsJobPostingName
  ...ManageJobDisplayNameModal_job
}
    ${ManageJobDisplayNameModal_JobFragmentDoc}`;
export const InterviewNameDialog_InterviewNameInfoFromJobFragmentDoc = gql`
    fragment InterviewNameDialog_interviewNameInfoFromJob on InterviewNameSetting {
  showInterviewName
  isCustom
  isLocked
}
    `;
export const InterviewName_InterviewNameInfoFromJobFragmentDoc = gql`
    fragment InterviewName_interviewNameInfoFromJob on InterviewNameSetting {
  ...InterviewNameDialog_interviewNameInfoFromJob
  isCustom
  isLocked
  showInterviewName
}
    ${InterviewNameDialog_InterviewNameInfoFromJobFragmentDoc}`;
export const PrivacySettings_InterviewNameInfoFromJobFragmentDoc = gql`
    fragment PrivacySettings_interviewNameInfoFromJob on InterviewNameSetting {
  ...InterviewName_interviewNameInfoFromJob
}
    ${InterviewName_InterviewNameInfoFromJobFragmentDoc}`;
export const InterviewerVisibilityDialog_InterviewerVisibilityFromJobFragmentDoc = gql`
    fragment InterviewerVisibilityDialog_interviewerVisibilityFromJob on InterviewerInfoSetting {
  isCustom
  isLocked
  canShowInfo
}
    `;
export const InterviewerVisibility_InterviewerVisibilityFromJobFragmentDoc = gql`
    fragment InterviewerVisibility_interviewerVisibilityFromJob on InterviewerInfoSetting {
  ...InterviewerVisibilityDialog_interviewerVisibilityFromJob
  isCustom
  isLocked
  canShowInfo
  canShowFullName
  canShowJobTitle
  canShowLinkedin
  canShowEmail
  canShowProfilePicture
  canShowPronouns
  canShowBio
}
    ${InterviewerVisibilityDialog_InterviewerVisibilityFromJobFragmentDoc}`;
export const PrivacySettings_InterviewerVisibilityFromJobFragmentDoc = gql`
    fragment PrivacySettings_interviewerVisibilityFromJob on InterviewerInfoSetting {
  ...InterviewerVisibility_interviewerVisibilityFromJob
}
    ${InterviewerVisibility_InterviewerVisibilityFromJobFragmentDoc}`;
export const RecruitingTeamDialog_RecruitingTeamVisibilityFromJobFragmentDoc = gql`
    fragment RecruitingTeamDialog_recruitingTeamVisibilityFromJob on RecruitingTeamContactInfoSetting {
  showCoordinator
  showRecruiter
  isCustom
}
    `;
export const RecruitingTeamVisibility_RecruitingTeamVisibilityFromJobFragmentDoc = gql`
    fragment RecruitingTeamVisibility_recruitingTeamVisibilityFromJob on RecruitingTeamContactInfoSetting {
  ...RecruitingTeamDialog_recruitingTeamVisibilityFromJob
  isCustom
  isLocked
  showCoordinator
  showRecruiter
  canShowJobTitle
  canShowLinkedin
  canShowProfilePicture
  canShowPronouns
  canShowBio
  canShowPhone
}
    ${RecruitingTeamDialog_RecruitingTeamVisibilityFromJobFragmentDoc}`;
export const PrivacySettings_RecruitingTeamVisibilityFromJobFragmentDoc = gql`
    fragment PrivacySettings_recruitingTeamVisibilityFromJob on RecruitingTeamContactInfoSetting {
  ...RecruitingTeamVisibility_recruitingTeamVisibilityFromJob
}
    ${RecruitingTeamVisibility_RecruitingTeamVisibilityFromJobFragmentDoc}`;
export const JobDetailsSetup_JobSettingsFragmentDoc = gql`
    fragment JobDetailsSetup_jobSettings on JobSettings {
  settingLevelId
  settingLevel
  interviewNameSetting {
    ...InterviewName_interviewNameInfoFromJob
  }
  interviewerInfoSetting {
    ...InterviewerVisibility_interviewerVisibilityFromJob
    canShowEmail
    canShowBio
    canShowPronouns
    canShowProfilePicture
  }
  recruitingTeamContactInfoSetting {
    ...RecruitingTeamVisibility_recruitingTeamVisibilityFromJob
    canShowBio
    canShowPronouns
    canShowProfilePicture
    canShowJobTitle
    canShowLinkedin
    canShowPhone
  }
}
    ${InterviewName_InterviewNameInfoFromJobFragmentDoc}
${InterviewerVisibility_InterviewerVisibilityFromJobFragmentDoc}
${RecruitingTeamVisibility_RecruitingTeamVisibilityFromJobFragmentDoc}`;
export const JobStageProgressIcon_JobFragmentDoc = gql`
    fragment JobStageProgressIcon_job on Job {
  id
  jobStages {
    id
    atsId
    index
  }
}
    `;
export const JobStageDetailsContent_JobFragmentDoc = gql`
    fragment JobStageDetailsContent_job on Job {
  id
  atsId
  ...JobStageProgressIcon_job
}
    ${JobStageProgressIcon_JobFragmentDoc}`;
export const JobStageDetailsContent_JobStageFragmentDoc = gql`
    fragment JobStageDetailsContent_jobStage on JobStage {
  id
  name
  atsId
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      interviewType
    }
  }
}
    `;
export const TemplateRow_TemplateFragmentDoc = gql`
    fragment TemplateRow_template on Template {
  id
  name
}
    `;
export const AdditionalRecipientsDialog_CcRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsDialog_ccRecipients on NotificationPreference {
  employeeIds
  externalEmailAddresses
  dynamicAudiences
}
    `;
export const SmartEmployeeSelectLabel_SmartOptionsFragmentDoc = gql`
    fragment SmartEmployeeSelectLabel_smartOptions on NotificationPreference {
  dynamicAudiences
  externalEmailAddresses
  employees {
    id
    fullName
    givenName
    familyName
    email
    internalProfilePictureUrl
  }
}
    `;
export const AdditionalRecipientsRow_CcRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsRow_ccRecipients on NotificationPreference {
  employeeIds
  employees {
    id
  }
  externalEmailAddresses
  dynamicAudiences
  ...AdditionalRecipientsDialog_ccRecipients
  ...SmartEmployeeSelectLabel_smartOptions
}
    ${AdditionalRecipientsDialog_CcRecipientsFragmentDoc}
${SmartEmployeeSelectLabel_SmartOptionsFragmentDoc}`;
export const AdditionalRecipientsDialog_BccRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsDialog_bccRecipients on NotificationPreference {
  employeeIds
  externalEmailAddresses
  dynamicAudiences
}
    `;
export const AdditionalRecipientsRow_BccRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsRow_bccRecipients on NotificationPreference {
  employeeIds
  employees {
    id
  }
  externalEmailAddresses
  dynamicAudiences
  ...AdditionalRecipientsDialog_bccRecipients
  ...SmartEmployeeSelectLabel_smartOptions
}
    ${AdditionalRecipientsDialog_BccRecipientsFragmentDoc}
${SmartEmployeeSelectLabel_SmartOptionsFragmentDoc}`;
export const AvailabilityRequest_JobStageSettingsFragmentDoc = gql`
    fragment AvailabilityRequest_jobStageSettings on JobStageSettingsV2 {
  availabilityRequestEmailTemplateId {
    templateId
    level
    template {
      id
      ...TemplateRow_template
    }
  }
  candidateAvailabilitySettingsV2 {
    numberOfDays {
      value
      level
    }
    minutesPerDays {
      value
      level
    }
    minimumTimeBlockMinutes {
      value
      level
    }
    advanceNotice {
      duration {
        seconds
        nanos
      }
      level
    }
    candidateNote {
      value
      level
    }
    shouldRespectLoadLimit {
      value
      level
    }
    bookIfPerfectScheduleFound {
      value
      level
    }
    canScheduleOverRecruitingKeywords {
      level
      value
    }
    canScheduleOverAvailableKeywords {
      level
      value
    }
    canScheduleOverFreeTime {
      level
      value
    }
    useRollingDays {
      level
      value
    }
    timeframe {
      duration {
        seconds
        nanos
      }
      level
    }
    ccRecipients {
      notificationPreference {
        ...AdditionalRecipientsRow_ccRecipients
      }
      level
    }
    bccRecipients {
      notificationPreference {
        ...AdditionalRecipientsRow_bccRecipients
      }
      level
    }
  }
}
    ${TemplateRow_TemplateFragmentDoc}
${AdditionalRecipientsRow_CcRecipientsFragmentDoc}
${AdditionalRecipientsRow_BccRecipientsFragmentDoc}`;
export const SelfScheduleRequest_JobStageSettingsFragmentDoc = gql`
    fragment SelfScheduleRequest_jobStageSettings on JobStageSettingsV2 {
  selfScheduleRequestEmailTemplateId {
    templateId
    level
    template {
      ...TemplateRow_template
    }
  }
  selfScheduleSettingsV2 {
    advanceNotice {
      duration {
        seconds
        nanos
      }
      level
    }
    candidateNote {
      value
      level
    }
    ccRecipients {
      notificationPreference {
        ...AdditionalRecipientsRow_ccRecipients
      }
      level
    }
    bccRecipients {
      level
      notificationPreference {
        ...AdditionalRecipientsRow_bccRecipients
      }
    }
    shouldRespectLoadLimit {
      value
      level
    }
    canScheduleOverRecruitingKeywords {
      level
      value
    }
    canScheduleOverAvailableKeywords {
      level
      value
    }
    canScheduleOverFreeTime {
      level
      value
    }
    useRollingDays {
      level
      value
    }
    timeframe {
      duration {
        seconds
      }
      level
    }
  }
}
    ${TemplateRow_TemplateFragmentDoc}
${AdditionalRecipientsRow_CcRecipientsFragmentDoc}
${AdditionalRecipientsRow_BccRecipientsFragmentDoc}`;
export const CalendarEventVisibilityRow_JobStageSettingsFragmentDoc = gql`
    fragment CalendarEventVisibilityRow_jobStageSettings on JobStageSettingsV2 {
  id
  isPrivateCalendarEvent {
    value
    level
  }
}
    `;
export const ExistingSlackChannels_ChatConversationFragmentDoc = gql`
    fragment ExistingSlackChannels_chatConversation on SettingChatConversation {
  chatConversationType
  chatConversationId
  level
  chatConversation {
    id
    remoteId
    orgId
    type
    remoteName
  }
}
    `;
export const SlackChannelRow_ChatConversationFragmentDoc = gql`
    fragment SlackChannelRow_chatConversation on SettingChatConversation {
  ...ExistingSlackChannels_chatConversation
}
    ${ExistingSlackChannels_ChatConversationFragmentDoc}`;
export const SlackChannelMembersDialog_MembersFragmentDoc = gql`
    fragment SlackChannelMembersDialog_members on NotificationPreference {
  employeeIds
  externalEmailAddresses
  dynamicAudiences
}
    `;
export const SlackChannelMembers_MembersFragmentDoc = gql`
    fragment SlackChannelMembers_members on NotificationPreference {
  employeeIds
  externalEmailAddresses
  dynamicAudiences
  ...SlackChannelMembersDialog_members
  ...SmartEmployeeSelectLabel_smartOptions
}
    ${SlackChannelMembersDialog_MembersFragmentDoc}
${SmartEmployeeSelectLabel_SmartOptionsFragmentDoc}`;
export const DebriefAtsWriteRow_SettingFragmentDoc = gql`
    fragment DebriefAtsWriteRow_setting on DebriefAtsWriteSettingPref {
  atsInterviewDefinitionId
  definitionNameMatch
  scorecardRecipients {
    employeeIds
    dynamicAudiences
    externalEmailAddresses
  }
}
    `;
export const Communication_JobStageSettingsFragmentDoc = gql`
    fragment Communication_jobStageSettings on JobStageSettingsV2 {
  id
  ...CalendarEventVisibilityRow_jobStageSettings
  shouldSendEmailToCandidate {
    value
    level
  }
  shouldSendCalendarInviteToCandidate {
    value
    level
  }
  shouldSendChatMessage {
    value
    level
  }
  slackTemplateId {
    templateId
    level
    template {
      ...TemplateRow_template
    }
  }
  candidateEmailTemplateId {
    level
    template {
      ...TemplateRow_template
    }
    templateId
  }
  interviewerEventTemplateId {
    templateId
    template {
      ...TemplateRow_template
    }
    level
  }
  interviewerCalendarId {
    remoteCalendarId
    remoteCalendar {
      id
      name
      isPartOfCalendarList
    }
    level
    dynamicValue
  }
  candidateCalendarId {
    remoteCalendarId
    remoteCalendar {
      id
      name
      isPartOfCalendarList
    }
    level
    dynamicValue
  }
  candidateEventTemplateId {
    template {
      ...TemplateRow_template
    }
    level
    templateId
  }
  chatConversation {
    ...SlackChannelRow_chatConversation
  }
  chatConversationMembers {
    level
    notificationPreference {
      ...SlackChannelMembers_members
    }
  }
  ccRecipientsV2 {
    notificationPreference {
      ...AdditionalRecipientsRow_ccRecipients
    }
    level
  }
  bccRecipientsV2 {
    level
    notificationPreference {
      ...AdditionalRecipientsRow_bccRecipients
    }
  }
  candidateEventAdditionalAttendees {
    level
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  candidateEventAdditionalAttendeesV2 {
    attendees {
      email
      employeeId
      dynamicAudience
      isOptional
    }
  }
  interviewerEventAdditionalAttendees {
    level
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  interviewerEventAdditionalAttendeesV2 {
    attendees {
      email
      employeeId
      dynamicAudience
      isOptional
    }
  }
  debriefEventAdditionalAttendees {
    level
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  debriefEventAdditionalAttendeesV2 {
    attendees {
      email
      employeeId
      dynamicAudience
      isOptional
    }
  }
  candidateEventAdditionalAttendeesOptional {
    value
    level
  }
  interviewerEventAdditionalAttendeesOptional {
    value
    level
  }
  debriefEventAdditionalAttendeesOptional {
    value
    level
  }
  debriefAtsWriteSettingWithLevel {
    level
    debriefAtsWriteSetting {
      ...DebriefAtsWriteRow_setting
    }
  }
}
    ${CalendarEventVisibilityRow_JobStageSettingsFragmentDoc}
${TemplateRow_TemplateFragmentDoc}
${SlackChannelRow_ChatConversationFragmentDoc}
${SlackChannelMembers_MembersFragmentDoc}
${AdditionalRecipientsRow_CcRecipientsFragmentDoc}
${AdditionalRecipientsRow_BccRecipientsFragmentDoc}
${DebriefAtsWriteRow_SettingFragmentDoc}`;
export const SenderEmployeeChip_EmployeeFragmentDoc = gql`
    fragment SenderEmployeeChip_employee on Employee {
  id
  fullName
  internalProfilePictureUrl
}
    `;
export const CandidatePulseSurveySetting_JobStageSettingsFragmentDoc = gql`
    fragment CandidatePulseSurveySetting_jobStageSettings on JobStageSettingsV2 {
  id
  shouldSendCandidatePulse {
    value
    level
  }
}
    `;
export const EnableAutomationModalCommonFragmentFragmentDoc = gql`
    fragment EnableAutomationModalCommonFragment on JobStageSettingsV2 {
  id
  isAutomatedTaskEnabled
  createAutomatedTaskOnBehalfOf {
    employee {
      id
      fullName
      internalProfilePictureUrl
    }
    dynamicAudience
    backupSenderEmployee {
      id
      fullName
      internalProfilePictureUrl
    }
  }
}
    `;
export const EnableAutomationModal_JobStageSettingsFragmentDoc = gql`
    fragment EnableAutomationModal_jobStageSettings on JobStageSettingsV2 {
  id
  ...EnableAutomationModalCommonFragment
}
    ${EnableAutomationModalCommonFragmentFragmentDoc}`;
export const Rescheduling_AutomaticallyReplaceDeclinedInterviewerFragmentDoc = gql`
    fragment Rescheduling_automaticallyReplaceDeclinedInterviewer on SettingBoolValue {
  level
  value
}
    `;
export const General_JobStageSettingsFragmentDoc = gql`
    fragment General_jobStageSettings on JobStageSettingsV2 {
  id
  defaultTask
  isAutomatedTaskEnabled
  createAutomatedTaskOnBehalfOf {
    employee {
      id
      ...SenderEmployeeChip_employee
    }
    dynamicAudience
    backupSenderEmployee {
      id
      ...SenderEmployeeChip_employee
    }
  }
  ...CandidatePulseSurveySetting_jobStageSettings
  ...EnableAutomationModal_jobStageSettings
  automaticallyReplaceDeclinedInterviewer {
    ...Rescheduling_automaticallyReplaceDeclinedInterviewer
  }
}
    ${SenderEmployeeChip_EmployeeFragmentDoc}
${CandidatePulseSurveySetting_JobStageSettingsFragmentDoc}
${EnableAutomationModal_JobStageSettingsFragmentDoc}
${Rescheduling_AutomaticallyReplaceDeclinedInterviewerFragmentDoc}`;
export const VideoMeetingHost_InterviewMeetingLocationSettingPrefFragmentDoc = gql`
    fragment VideoMeetingHost_interviewMeetingLocationSettingPref on InterviewMeetingLocationSettingPref {
  interviewMeetingLocationType
  videoMeetingLinkScope
  dynamicHost
  hostEmployeeId
}
    `;
export const InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragmentDoc = gql`
    fragment InterviewMeetingLocationHost_interviewMeetingLocationSettingPref on InterviewMeetingLocationSettingPref {
  interviewMeetingLocationType
  videoMeetingLinkScope
  dynamicHost
  hostEmployeeId
  remoteVideoMeetingHostUserId
  remoteVideoMeetingHostUser {
    ... on ZoomUser {
      zoomUserId
      firstName
      lastName
      email
    }
  }
  customLocation
  ...VideoMeetingHost_interviewMeetingLocationSettingPref
}
    ${VideoMeetingHost_InterviewMeetingLocationSettingPrefFragmentDoc}`;
export const InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragmentDoc = gql`
    fragment InterviewMeetingLocationInfo_interviewMeetingLocationSettingPref on InterviewMeetingLocationSettingPref {
  interviewMeetingLocationType
  videoMeetingLinkScope
  dynamicHost
  hostEmployee {
    id
    fullName
    email
    internalProfilePictureUrl
  }
  remoteVideoMeetingHostUser {
    ... on ZoomUser {
      zoomUserId
      firstName
      lastName
      email
    }
  }
  customLocation
}
    `;
export const ScheduleLocation_InterviewMeetingLocationSettingFragmentDoc = gql`
    fragment ScheduleLocation_interviewMeetingLocationSetting on InterviewMeetingLocationSettingWithLevel {
  level
  interviewMeetingLocationSetting {
    interviewMeetingLocationType
    dynamicHost
    hostEmployee {
      id
      fullName
      internalProfilePictureUrl
    }
    remoteVideoMeetingHostUser {
      ... on ZoomUser {
        zoomUserId
        firstName
        lastName
        email
      }
    }
    ...InterviewMeetingLocationHost_interviewMeetingLocationSettingPref
    ...InterviewMeetingLocationInfo_interviewMeetingLocationSettingPref
  }
}
    ${InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragmentDoc}
${InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragmentDoc}`;
export const InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragmentDoc = gql`
    fragment InterviewMeetingLocationModal_interviewMeetingLocationSettingPref on InterviewMeetingLocationSettingPref {
  interviewMeetingLocationType
  videoMeetingLinkScope
  ...InterviewMeetingLocationHost_interviewMeetingLocationSettingPref
}
    ${InterviewMeetingLocationHost_InterviewMeetingLocationSettingPrefFragmentDoc}`;
export const DebriefScheduleLocation_DebriefMeetingLocationSettingFragmentDoc = gql`
    fragment DebriefScheduleLocation_debriefMeetingLocationSetting on DebriefMeetingLocationSettingWithLevel {
  level
  debriefMeetingLocationSetting {
    interviewMeetingLocationType
    dynamicHost
    hostEmployee {
      id
      fullName
      internalProfilePictureUrl
    }
    remoteVideoMeetingHostUser {
      ... on ZoomUser {
        zoomUserId
        firstName
        lastName
        email
      }
    }
    ...InterviewMeetingLocationModal_interviewMeetingLocationSettingPref
    ...InterviewMeetingLocationInfo_interviewMeetingLocationSettingPref
  }
}
    ${InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragmentDoc}
${InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragmentDoc}`;
export const InterviewPlan_JobStageSettingsFragmentDoc = gql`
    fragment InterviewPlan_jobStageSettings on JobStageSettingsV2 {
  id
  interviewMeetingLocationSettingWithLevel {
    ...ScheduleLocation_interviewMeetingLocationSetting
  }
  debriefMeetingLocationSettingWithLevel {
    ...DebriefScheduleLocation_debriefMeetingLocationSetting
  }
  syncScorecardsFromAts {
    value
    level
  }
}
    ${ScheduleLocation_InterviewMeetingLocationSettingFragmentDoc}
${DebriefScheduleLocation_DebriefMeetingLocationSettingFragmentDoc}`;
export const JobStageSettingsFragmentFragmentDoc = gql`
    fragment JobStageSettingsFragment on JobStageSettingsV2 {
  id
  jobStageId
  isAutomatedTaskEnabled
  ...AvailabilityRequest_jobStageSettings
  ...SelfScheduleRequest_jobStageSettings
  ...Communication_jobStageSettings
  ...General_jobStageSettings
  ...InterviewPlan_jobStageSettings
}
    ${AvailabilityRequest_JobStageSettingsFragmentDoc}
${SelfScheduleRequest_JobStageSettingsFragmentDoc}
${Communication_JobStageSettingsFragmentDoc}
${General_JobStageSettingsFragmentDoc}
${InterviewPlan_JobStageSettingsFragmentDoc}`;
export const JobStageDetailsContent_JobStageSettingsV2FragmentDoc = gql`
    fragment JobStageDetailsContent_jobStageSettingsV2 on JobStageSettingsV2 {
  id
  ...JobStageSettingsFragment
}
    ${JobStageSettingsFragmentFragmentDoc}`;
export const SummaryAlert_InterviewPlanFragmentDoc = gql`
    fragment SummaryAlert_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      duration
      interviewType
      isHiddenFromCandidate
    }
  }
}
    `;
export const SourcingLinkForm_CurrentEmployeeFragmentDoc = gql`
    fragment SourcingLinkForm_currentEmployee on Employee {
  id
  fullName
  internalProfilePictureUrl
}
    `;
export const SourceSelect_RecruitingSourceFragmentDoc = gql`
    fragment SourceSelect_recruitingSource on RecruitingSource {
  source
}
    `;
export const SourcingLinkForm_JobFragmentDoc = gql`
    fragment SourcingLinkForm_job on Job {
  id
  name
  jobStages {
    id
    name
    atsId
    index
    canBeInitialStageForSourcingLink
    jobStageSettingsV2 {
      id
      candidateAvailabilitySettingsV2 {
        canScheduleOverAvailableKeywords {
          value
        }
        canScheduleOverRecruitingKeywords {
          value
        }
        shouldRespectLoadLimit {
          value
        }
        canScheduleOverFreeTime {
          value
        }
      }
    }
  }
  org {
    id
    sourcingLinkResumeUploadEnabled
    recruitingSources {
      ...SourceSelect_recruitingSource
    }
  }
  ...InterviewPlan_job
}
    ${SourceSelect_RecruitingSourceFragmentDoc}
${InterviewPlan_JobFragmentDoc}`;
export const CollaborationToolFilterPopover_CollaborationLinkTypeFragmentDoc = gql`
    fragment CollaborationToolFilterPopover_collaborationLinkType on CollaborationLinkType {
  collaborationToolType
  collaborationLinkTemplateId
}
    `;
export const BrighthireButtonSelect_InterviewGuideFragmentDoc = gql`
    fragment BrighthireButtonSelect_interviewGuide on InterviewGuide {
  id
  name
}
    `;
export const CodingLink_JobStageInterviewFragmentDoc = gql`
    fragment CodingLink_jobStageInterview on JobStageInterview {
  id
  dynamicLinkTypes
}
    `;
export const MoreMenuOptions_JobStageInterviewFragmentDoc = gql`
    fragment MoreMenuOptions_jobStageInterview on JobStageInterview {
  id
  interviewType
  jobStageInterviewGroupId
  isHiddenFromCandidate
}
    `;
export const InterviewCardHeader_JobStageInterviewFragmentDoc = gql`
    fragment InterviewCardHeader_jobStageInterview on JobStageInterview {
  id
  name
  isLockedOrder
  duration
  forcedStartAt @client
  atsInterviewDefinition {
    atsId
    name
    atsJobId
    atsFields {
      ... on GreenhouseInterviewDefinition {
        estimatedMinutes
        index
      }
    }
  }
  collaborationLinkTypes {
    ...CollaborationToolFilterPopover_collaborationLinkType
  }
  interviewGuide {
    ...BrighthireButtonSelect_interviewGuide
  }
  ...CodingLink_jobStageInterview
  ...MoreMenuOptions_jobStageInterview
}
    ${CollaborationToolFilterPopover_CollaborationLinkTypeFragmentDoc}
${BrighthireButtonSelect_InterviewGuideFragmentDoc}
${CodingLink_JobStageInterviewFragmentDoc}
${MoreMenuOptions_JobStageInterviewFragmentDoc}`;
export const BreakSlot_BreakSlotFragmentDoc = gql`
    fragment BreakSlot_breakSlot on JobStageInterview {
  id
  interviewType
  name
  duration
  isLockedOrder
  ...MoreMenuOptions_jobStageInterview
}
    ${MoreMenuOptions_JobStageInterviewFragmentDoc}`;
export const Break_BreakSlotFragmentDoc = gql`
    fragment Break_breakSlot on JobStageInterview {
  id
  interviewType
  name
  duration
  isLockedOrder
}
    `;
export const FreeformSeat_SeatFragmentDoc = gql`
    fragment FreeformSeat_seat on JobStageInterviewSeat {
  id
  freeformSeat {
    jobStageInterviewSeatEmployees {
      jobStageInterviewSeatId
      employeeId
      employee {
        id
        ...Employee
      }
      preferenceLevel
    }
  }
}
    ${EmployeeFragmentDoc}`;
export const ModuleSeat_SeatFragmentDoc = gql`
    fragment ModuleSeat_seat on JobStageInterviewSeat {
  id
  moduleSeat {
    interviewModuleId
    interviewModule {
      id
      orgId
      shadowsRequired
      reverseShadowsRequired
      membersCount
      name
      membersTrainedCount
      membersInTrainingCount
      membersInReverseShadowCount
      membersInShadowCount
      membersInPendingApprovalCount
      graduateFromShadowApprovalType
      graduateFromReverseShadowApprovalType
      interviewModuleMembers(input: {pageInput: {limit: 500, offset: 0}}) {
        items {
          id
          interviewModuleId
          ...EmployeeFilter
        }
      }
    }
    selectedEmployeeIds
    jobStageInterviewSeatAttributes {
      id
      jobStageInterviewSeatId
      attributeNameId
      attributeTagValueId
    }
  }
}
    ${EmployeeFilterFragmentDoc}`;
export const ModuleSeatV2_SeatFragmentDoc = gql`
    fragment ModuleSeatV2_seat on JobStageInterviewSeat {
  id
  moduleSeat {
    interviewModuleId
    interviewModule {
      id
      orgId
      shadowsRequired
      reverseShadowsRequired
      membersCount
      name
      membersTrainedCount
      membersInTrainingCount
      membersInReverseShadowCount
      membersInShadowCount
      membersInPendingApprovalCount
      graduateFromShadowApprovalType
      graduateFromReverseShadowApprovalType
      interviewModuleMembers(input: {pageInput: {limit: 500, offset: 0}}) {
        items {
          id
          interviewModuleId
          ...EmployeeFilter
        }
      }
    }
    selectedEmployeeIds
    jobStageInterviewSeatAttributes {
      id
      jobStageInterviewSeatId
      attributeNameId
      attributeTagValueId
    }
    trainedConfig {
      selectedEmployeeIds
      selectedAttributes {
        id
        jobStageInterviewSeatId
        attributeNameId
        attributeTagValueId
      }
    }
    shadowConfig {
      selectedEmployeeIds
      selectedAttributes {
        id
        jobStageInterviewSeatId
        attributeNameId
        attributeTagValueId
      }
    }
    reverseShadowConfig {
      selectedEmployeeIds
      selectedAttributes {
        id
        jobStageInterviewSeatId
        attributeNameId
        attributeTagValueId
      }
    }
    traineeRequirement
    traineeSchedulingStrategy
  }
}
    ${EmployeeFilterFragmentDoc}`;
export const LinkedSeat_SeatFragmentDoc = gql`
    fragment LinkedSeat_seat on JobStageInterviewSeat {
  id
  linkedSeat {
    linkedJobStageInterviewSeatId
  }
}
    `;
export const BaseReadInterviewSeatModule_SeatFragmentDoc = gql`
    fragment BaseReadInterviewSeatModule_seat on JobStageInterviewSeat {
  id
  type
  index
  ...FreeformSeat_seat
  ...ModuleSeat_seat
  ...ModuleSeatV2_seat
  ...LinkedSeat_seat
}
    ${FreeformSeat_SeatFragmentDoc}
${ModuleSeat_SeatFragmentDoc}
${ModuleSeatV2_SeatFragmentDoc}
${LinkedSeat_SeatFragmentDoc}`;
export const BaseEditInterviewSeatModule_SeatFragmentDoc = gql`
    fragment BaseEditInterviewSeatModule_seat on JobStageInterviewSeat {
  id
  ...BaseReadInterviewSeatModule_seat
}
    ${BaseReadInterviewSeatModule_SeatFragmentDoc}`;
export const BaseInterviewSeatModule_SeatFragmentDoc = gql`
    fragment BaseInterviewSeatModule_seat on JobStageInterviewSeat {
  id
  type
  ...BaseReadInterviewSeatModule_seat
  ...BaseEditInterviewSeatModule_seat
}
    ${BaseReadInterviewSeatModule_SeatFragmentDoc}
${BaseEditInterviewSeatModule_SeatFragmentDoc}`;
export const InterviewSeatsModule_SeatsFragmentDoc = gql`
    fragment InterviewSeatsModule_seats on JobStageInterviewSeat {
  id
  ...BaseInterviewSeatModule_seat
}
    ${BaseInterviewSeatModule_SeatFragmentDoc}`;
export const JobStageInterview_JobStageInterviewFragmentDoc = gql`
    fragment JobStageInterview_jobStageInterview on JobStageInterview {
  id
  ...InterviewCardHeader_jobStageInterview
  ...BreakSlot_breakSlot
  ...Break_breakSlot
  jobStageInterviewSeats {
    id
    ...InterviewSeatsModule_seats
  }
}
    ${InterviewCardHeader_JobStageInterviewFragmentDoc}
${BreakSlot_BreakSlotFragmentDoc}
${Break_BreakSlotFragmentDoc}
${InterviewSeatsModule_SeatsFragmentDoc}`;
export const InterviewGroupOld_JobStageInterviewGroupFragmentDoc = gql`
    fragment InterviewGroupOld_jobStageInterviewGroup on JobStageInterviewGroup {
  id
  locked
  name
  jobStageInterviews {
    id
    ...JobStageInterview_jobStageInterview
  }
}
    ${JobStageInterview_JobStageInterviewFragmentDoc}`;
export const InterviewGroup_JobStageInterviewGroupFragmentDoc = gql`
    fragment InterviewGroup_jobStageInterviewGroup on JobStageInterviewGroup {
  id
  locked
  name
  jobStageInterviews {
    id
    ...JobStageInterview_jobStageInterview
  }
  ...InterviewGroupOld_jobStageInterviewGroup
}
    ${JobStageInterview_JobStageInterviewFragmentDoc}
${InterviewGroupOld_JobStageInterviewGroupFragmentDoc}`;
export const MoreMenuOptions_JobStageInterviewGroupsFragmentDoc = gql`
    fragment MoreMenuOptions_jobStageInterviewGroups on JobStageInterviewGroup {
  id
  jobStageInterviews {
    id
  }
}
    `;
export const BreakSlot_JobStageInterviewGroupsFragmentDoc = gql`
    fragment BreakSlot_jobStageInterviewGroups on JobStageInterviewGroup {
  id
  ...MoreMenuOptions_jobStageInterviewGroups
}
    ${MoreMenuOptions_JobStageInterviewGroupsFragmentDoc}`;
export const InterviewCardHeader_JobStageInterviewGroupsFragmentDoc = gql`
    fragment InterviewCardHeader_jobStageInterviewGroups on JobStageInterviewGroup {
  id
  ...MoreMenuOptions_jobStageInterviewGroups
}
    ${MoreMenuOptions_JobStageInterviewGroupsFragmentDoc}`;
export const JobStageInterview_JobStageInterviewGroupsFragmentDoc = gql`
    fragment JobStageInterview_jobStageInterviewGroups on JobStageInterviewGroup {
  id
  jobStageInterviews {
    id
    interviewType
  }
  ...BreakSlot_jobStageInterviewGroups
  ...InterviewCardHeader_jobStageInterviewGroups
}
    ${BreakSlot_JobStageInterviewGroupsFragmentDoc}
${InterviewCardHeader_JobStageInterviewGroupsFragmentDoc}`;
export const InterviewGroupOld_JobStageInterviewGroupsFragmentDoc = gql`
    fragment InterviewGroupOld_jobStageInterviewGroups on JobStageInterviewGroup {
  id
  ...JobStageInterview_jobStageInterviewGroups
}
    ${JobStageInterview_JobStageInterviewGroupsFragmentDoc}`;
export const InterviewGroup_JobStageInterviewGroupsFragmentDoc = gql`
    fragment InterviewGroup_jobStageInterviewGroups on JobStageInterviewGroup {
  id
  jobStageInterviews {
    id
  }
  ...InterviewGroupOld_jobStageInterviewGroups
  ...JobStageInterview_jobStageInterviewGroups
}
    ${InterviewGroupOld_JobStageInterviewGroupsFragmentDoc}
${JobStageInterview_JobStageInterviewGroupsFragmentDoc}`;
export const UseWarningForStartAt_JobStageInterviewsFragmentDoc = gql`
    fragment useWarningForStartAt_jobStageInterviews on JobStageInterview {
  id
  duration
  forcedStartAt @client
}
    `;
export const InterviewCardHeader_JobStageInterviewsFragmentDoc = gql`
    fragment InterviewCardHeader_jobStageInterviews on JobStageInterview {
  id
  duration
  forcedStartAt @client
  atsInterviewDefinition {
    atsId
    atsFields {
      ... on GreenhouseInterviewDefinition {
        estimatedMinutes
        index
      }
    }
  }
  ...useWarningForStartAt_jobStageInterviews
}
    ${UseWarningForStartAt_JobStageInterviewsFragmentDoc}`;
export const JobStageInterview_JobStageInterviewsFragmentDoc = gql`
    fragment JobStageInterview_jobStageInterviews on JobStageInterview {
  id
  ...InterviewCardHeader_jobStageInterviews
}
    ${InterviewCardHeader_JobStageInterviewsFragmentDoc}`;
export const BaseEditInterviewSeatModule_LinkableInterviewsFragmentDoc = gql`
    fragment BaseEditInterviewSeatModule_linkableInterviews on JobStageInterview {
  id
  name
  jobStageInterviewSeats {
    id
    type
  }
}
    `;
export const BaseInterviewSeatModule_LinkableInterviewsFragmentDoc = gql`
    fragment BaseInterviewSeatModule_linkableInterviews on JobStageInterview {
  id
  ...BaseEditInterviewSeatModule_linkableInterviews
}
    ${BaseEditInterviewSeatModule_LinkableInterviewsFragmentDoc}`;
export const LinkedSeat_LinkedInterviewFragmentDoc = gql`
    fragment LinkedSeat_linkedInterview on JobStageInterview {
  id
  name
  jobStageInterviewSeats {
    id
  }
}
    `;
export const BaseReadInterviewSeatModule_LinkedInterviewFragmentDoc = gql`
    fragment BaseReadInterviewSeatModule_linkedInterview on JobStageInterview {
  id
  ...LinkedSeat_linkedInterview
}
    ${LinkedSeat_LinkedInterviewFragmentDoc}`;
export const BaseEditInterviewSeatModule_LinkedInterviewFragmentDoc = gql`
    fragment BaseEditInterviewSeatModule_linkedInterview on JobStageInterview {
  id
  name
  jobStageInterviewSeats {
    id
  }
}
    `;
export const BaseInterviewSeatModule_LinkedInterviewFragmentDoc = gql`
    fragment BaseInterviewSeatModule_linkedInterview on JobStageInterview {
  id
  ...BaseReadInterviewSeatModule_linkedInterview
  ...BaseEditInterviewSeatModule_linkedInterview
}
    ${BaseReadInterviewSeatModule_LinkedInterviewFragmentDoc}
${BaseEditInterviewSeatModule_LinkedInterviewFragmentDoc}`;
export const InterviewSeatsModule_LinkableInterviewsFragmentDoc = gql`
    fragment InterviewSeatsModule_linkableInterviews on JobStageInterview {
  id
  ...BaseInterviewSeatModule_linkableInterviews
  ...BaseInterviewSeatModule_linkedInterview
}
    ${BaseInterviewSeatModule_LinkableInterviewsFragmentDoc}
${BaseInterviewSeatModule_LinkedInterviewFragmentDoc}`;
export const LinkedSeat_OriginalSeatFragmentDoc = gql`
    fragment LinkedSeat_originalSeat on JobStageInterviewSeat {
  id
  freeformSeat {
    jobStageInterviewSeatEmployees {
      employeeId
      employee {
        id
        fullName
        internalProfilePictureUrl
      }
    }
  }
  moduleSeat {
    interviewModuleId
    interviewModule {
      id
      name
    }
  }
}
    `;
export const BaseReadInterviewSeatModule_OriginalSeatFragmentDoc = gql`
    fragment BaseReadInterviewSeatModule_originalSeat on JobStageInterviewSeat {
  id
  ...LinkedSeat_originalSeat
}
    ${LinkedSeat_OriginalSeatFragmentDoc}`;
export const BaseInterviewSeatModule_OriginalSeatFragmentDoc = gql`
    fragment BaseInterviewSeatModule_originalSeat on JobStageInterviewSeat {
  id
  ...BaseReadInterviewSeatModule_originalSeat
}
    ${BaseReadInterviewSeatModule_OriginalSeatFragmentDoc}`;
export const InterviewSeatsModule_OriginalSeatsFragmentDoc = gql`
    fragment InterviewSeatsModule_originalSeats on JobStageInterviewSeat {
  id
  ...BaseInterviewSeatModule_originalSeat
}
    ${BaseInterviewSeatModule_OriginalSeatFragmentDoc}`;
export const JobStageInterview_LinkableInterviewsFragmentDoc = gql`
    fragment JobStageInterview_linkableInterviews on JobStageInterview {
  id
  ...InterviewSeatsModule_linkableInterviews
  jobStageInterviewSeats {
    id
    ...InterviewSeatsModule_originalSeats
  }
}
    ${InterviewSeatsModule_LinkableInterviewsFragmentDoc}
${InterviewSeatsModule_OriginalSeatsFragmentDoc}`;
export const InterviewGroupOld_JobStageInterviewsFragmentDoc = gql`
    fragment InterviewGroupOld_jobStageInterviews on JobStageInterview {
  id
  ...JobStageInterview_jobStageInterview
  ...JobStageInterview_jobStageInterviews
  ...JobStageInterview_linkableInterviews
}
    ${JobStageInterview_JobStageInterviewFragmentDoc}
${JobStageInterview_JobStageInterviewsFragmentDoc}
${JobStageInterview_LinkableInterviewsFragmentDoc}`;
export const InterviewGroup_JobStageInterviewsFragmentDoc = gql`
    fragment InterviewGroup_jobStageInterviews on JobStageInterview {
  id
  ...InterviewGroupOld_jobStageInterviews
  ...JobStageInterview_jobStageInterview
  ...JobStageInterview_jobStageInterviews
  ...JobStageInterview_linkableInterviews
}
    ${InterviewGroupOld_JobStageInterviewsFragmentDoc}
${JobStageInterview_JobStageInterviewFragmentDoc}
${JobStageInterview_JobStageInterviewsFragmentDoc}
${JobStageInterview_LinkableInterviewsFragmentDoc}`;
export const AdvancedOptions_InterviewPlanFragmentDoc = gql`
    fragment AdvancedOptions_interviewPlan on JobStage {
  id
  schedulingWindow {
    seconds
  }
  excludedEmployees {
    id
  }
}
    `;
export const Break_SchedulingWindowFragmentDoc = gql`
    fragment Break_schedulingWindow on Duration {
  seconds
}
    `;
export const JobStageInterview_SchedulingWindowFragmentDoc = gql`
    fragment JobStageInterview_schedulingWindow on Duration {
  ...Break_schedulingWindow
}
    ${Break_SchedulingWindowFragmentDoc}`;
export const InterviewGroup_SchedulingWindowFragmentDoc = gql`
    fragment InterviewGroup_schedulingWindow on Duration {
  ...JobStageInterview_schedulingWindow
}
    ${JobStageInterview_SchedulingWindowFragmentDoc}`;
export const InterviewPlan_JobStageFragmentDoc = gql`
    fragment InterviewPlan_jobStage on JobStage {
  id
  jobStageInterviewGroups {
    id
    ...InterviewGroup_jobStageInterviewGroup
    ...InterviewGroup_jobStageInterviewGroups
    jobStageInterviews {
      id
      ...InterviewGroup_jobStageInterviews
    }
  }
  ...AdvancedOptions_interviewPlan
  schedulingWindow {
    ...InterviewGroup_schedulingWindow
  }
}
    ${InterviewGroup_JobStageInterviewGroupFragmentDoc}
${InterviewGroup_JobStageInterviewGroupsFragmentDoc}
${InterviewGroup_JobStageInterviewsFragmentDoc}
${AdvancedOptions_InterviewPlanFragmentDoc}
${InterviewGroup_SchedulingWindowFragmentDoc}`;
export const SourcingLinkForm_SourcingLinkFragmentDoc = gql`
    fragment SourcingLinkForm_sourcingLink on SourcingLink {
  id
  deactivatedAt
  initialJobStageId
  interviewPlanJobStage {
    ...InterviewPlan_jobStage
  }
  name
  candidateSourcerId
  candidateRecruiterId
  candidateCoordinatorId
  candidateRecruiter {
    id
    fullName
    internalProfilePictureUrl
  }
  candidateSourcer {
    id
    fullName
    internalProfilePictureUrl
  }
  candidateCoordinator {
    id
    fullName
    internalProfilePictureUrl
  }
  recruitingSource
  requireResume
  taskAction
  taskAssigneeId
  taskAssignee {
    id
    fullName
    internalProfilePictureUrl
  }
  taskSubscriberIds
}
    ${InterviewPlan_JobStageFragmentDoc}`;
export const SourcingLinkFormDeprecated_CurrentEmployeeFragmentDoc = gql`
    fragment SourcingLinkFormDeprecated_currentEmployee on Employee {
  id
  fullName
  internalProfilePictureUrl
}
    `;
export const SummaryAlert_JobStageFragmentDoc = gql`
    fragment SummaryAlert_jobStage on JobStage {
  id
  name
  jobId
  jobStageSettingsV2 {
    id
    candidateAvailabilitySettingsV2 {
      advanceNotice {
        duration {
          seconds
        }
      }
      minutesPerDays {
        value
      }
      numberOfDays {
        value
      }
      minimumTimeBlockMinutes {
        value
      }
      candidateNote {
        value
      }
    }
    selfScheduleSettingsV2 {
      advanceNotice {
        duration {
          seconds
        }
      }
      candidateNote {
        value
      }
    }
    interviewMeetingLocationSettingWithLevel {
      interviewMeetingLocationSetting {
        interviewMeetingLocationType
      }
    }
  }
}
    `;
export const SourcingLinkFormDeprecated_JobFragmentDoc = gql`
    fragment SourcingLinkFormDeprecated_job on Job {
  id
  name
  jobStages {
    id
    name
    atsId
    index
    jobStageSettingsV2 {
      id
      candidateAvailabilitySettings {
        canScheduleOverAvailableKeywords
        canScheduleOverRecruitingKeywords
        shouldRespectLoadLimit
        canScheduleOverFreeTime
      }
    }
    ...SummaryAlert_jobStage
  }
  org {
    id
    sourcingLinkResumeUploadEnabled
    recruitingSources {
      ...SourceSelect_recruitingSource
    }
  }
  ...InterviewPlan_job
}
    ${SummaryAlert_JobStageFragmentDoc}
${SourceSelect_RecruitingSourceFragmentDoc}
${InterviewPlan_JobFragmentDoc}`;
export const SourcingLinkFormDeprecated_SourcingLinkFragmentDoc = gql`
    fragment SourcingLinkFormDeprecated_sourcingLink on SourcingLink {
  id
  deactivatedAt
  initialJobStageId
  interviewPlanJobStage {
    ...InterviewPlan_jobStage
  }
  name
  candidateSourcerId
  candidateRecruiterId
  candidateCoordinatorId
  candidateRecruiter {
    id
    fullName
    internalProfilePictureUrl
  }
  candidateSourcer {
    id
    fullName
    internalProfilePictureUrl
  }
  candidateCoordinator {
    id
    fullName
    internalProfilePictureUrl
  }
  recruitingSource
  requireResume
  taskAction
  taskAssigneeId
  taskAssignee {
    id
    fullName
    internalProfilePictureUrl
  }
  taskSubscriberIds
}
    ${InterviewPlan_JobStageFragmentDoc}`;
export const GetSaveInterviewPlanInput_InterviewPlanFragmentDoc = gql`
    fragment getSaveInterviewPlanInput_interviewPlan on JobStage {
  id
  ...InterviewPlan_jobStage
}
    ${InterviewPlan_JobStageFragmentDoc}`;
export const DuplicateMenuItem_SourcingLinkFragmentDoc = gql`
    fragment DuplicateMenuItem_sourcingLink on SourcingLink {
  id
  requireResume
  initialJobStageId
  interviewPlanJobStage {
    ...getSaveInterviewPlanInput_interviewPlan
  }
  name
  candidateSourcerId
  candidateRecruiterId
  candidateCoordinatorId
  recruitingSource
  taskAction
  taskAssigneeId
  taskSubscriberIds
}
    ${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}`;
export const SourcingLinksTable_SourcingLinksFragmentDoc = gql`
    fragment SourcingLinksTable_sourcingLinks on SourcingLink {
  id
  name
  deactivatedAt
  taskAction
  initialJobStage {
    id
    name
  }
  interviewPlanJobStageId
  ...DuplicateMenuItem_sourcingLink
  taskAssignee {
    id
  }
}
    ${DuplicateMenuItem_SourcingLinkFragmentDoc}`;
export const JobDetailsPage_JobStageFragmentDoc = gql`
    fragment JobDetailsPage_jobStage on JobStage {
  id
  name
  index
  atsId
}
    `;
export const ExitConfirmationModal_JobsFragmentDoc = gql`
    fragment ExitConfirmationModal_jobs on Job {
  id
  name
}
    `;
export const JobStageSelectFixIssues_JobFragmentDoc = gql`
    fragment JobStageSelectFixIssues_job on Job {
  id
  jobStages {
    id
    name
  }
}
    `;
export const FixJobStageMapping_TargetJobFragmentDoc = gql`
    fragment FixJobStageMapping_targetJob on Job {
  id
  name
  ...JobStageSelectFixIssues_job
}
    ${JobStageSelectFixIssues_JobFragmentDoc}`;
export const FixContentTabMapping_TargetJobFragmentDoc = gql`
    fragment FixContentTabMapping_targetJob on Job {
  id
  ...JobStageSelectFixIssues_job
}
    ${JobStageSelectFixIssues_JobFragmentDoc}`;
export const FixScorecardMapping_TargetJobFragmentDoc = gql`
    fragment FixScorecardMapping_targetJob on Job {
  id
  name
  atsJob {
    atsId
  }
}
    `;
export const FixJobStageMapping_JobStageMappingFragmentDoc = gql`
    fragment FixJobStageMapping_jobStageMapping on JobStageMapping {
  sourceName
  sourceJobStageId
  sourceJobStage {
    id
    index
  }
}
    `;
export const FixContentTabMapping_ContentTabMappingFragmentDoc = gql`
    fragment FixContentTabMapping_ContentTabMapping on ContentTabMapping {
  sourceName
  sourceContentTabId
  sourceIcon
  sourceVisibility
  sourceContentTabType
  sourceJobStageId
  sourceStageNameFilter
}
    `;
export const FixScorecardMapping_ScorecardMappingFragmentDoc = gql`
    fragment FixScorecardMapping_scorecardMapping on ScorecardMapping {
  sourceAtsId
  sourceAtsInterviewDefinition {
    atsId
    name
    atsJobId
  }
  jobStageInterviews {
    id
    name
  }
}
    `;
export const FixJobIssues_IssuesFragmentDoc = gql`
    fragment FixJobIssues_issues on JobImportValidateResult {
  targetJob {
    id
    name
    location
    ...FixJobStageMapping_targetJob
    ...FixContentTabMapping_targetJob
    ...FixScorecardMapping_targetJob
  }
  jobStageMappings {
    targetJobStageId
    ...FixJobStageMapping_jobStageMapping
  }
  contentTabMappings {
    targetJobStageId
    sourceJobStageId
    ...FixContentTabMapping_ContentTabMapping
  }
  scorecardMappings {
    targetAtsId
    sourceAtsId
    ...FixScorecardMapping_scorecardMapping
  }
}
    ${FixJobStageMapping_TargetJobFragmentDoc}
${FixContentTabMapping_TargetJobFragmentDoc}
${FixScorecardMapping_TargetJobFragmentDoc}
${FixJobStageMapping_JobStageMappingFragmentDoc}
${FixContentTabMapping_ContentTabMappingFragmentDoc}
${FixScorecardMapping_ScorecardMappingFragmentDoc}`;
export const FixContentTabMapping_SourceJobFragmentDoc = gql`
    fragment FixContentTabMapping_sourceJob on Job {
  id
  name
  jobStages {
    id
    name
  }
}
    `;
export const FixJobStageMapping_SourceJobFragmentDoc = gql`
    fragment FixJobStageMapping_sourceJob on Job {
  id
  name
  jobStages {
    id
    index
    name
  }
}
    `;
export const SourceJobFixIssues_JobFragmentDoc = gql`
    fragment SourceJobFixIssues_job on Job {
  id
  name
  ...FixContentTabMapping_sourceJob
  ...FixJobStageMapping_sourceJob
}
    ${FixContentTabMapping_SourceJobFragmentDoc}
${FixJobStageMapping_SourceJobFragmentDoc}`;
export const FixIssues_IssuesFragmentDoc = gql`
    fragment FixIssues_issues on JobSettingsImportValidateResult {
  items {
    ...FixJobIssues_issues
  }
  sourceJob {
    ...SourceJobFixIssues_job
  }
}
    ${FixJobIssues_IssuesFragmentDoc}
${SourceJobFixIssues_JobFragmentDoc}`;
export const UnmappedJobStages_JobStageMappingFragmentDoc = gql`
    fragment unmappedJobStages_jobStageMapping on JobStageMapping {
  targetJobStageId
}
    `;
export const UnmappedScorecards_ScorecardMappingFragmentDoc = gql`
    fragment unmappedScorecards_scorecardMapping on ScorecardMapping {
  targetAtsId
}
    `;
export const UnmappedContentTabs_ContentTabMappingFragmentDoc = gql`
    fragment unmappedContentTabs_contentTabMapping on ContentTabMapping {
  sourceJobStageId
  sourceStageNameFilter
  targetJobStageId
}
    `;
export const ReviewJobRow_JobImportValidateResultFragmentDoc = gql`
    fragment ReviewJobRow_jobImportValidateResult on JobImportValidateResult {
  targetJob {
    id
    name
    location
    atsJob {
      atsCustomerFriendlyId
    }
  }
  jobStageMappings {
    targetJobStageId
    sourceName
    sourceJobStageId
    ...unmappedJobStages_jobStageMapping
  }
  scorecardMappings {
    targetAtsId
    sourceName
    sourceAtsId
    ...unmappedScorecards_scorecardMapping
  }
  contentTabMappings {
    sourceName
    sourceJobStageId
    targetJobStageId
    sourceContentTabId
    ...unmappedContentTabs_contentTabMapping
  }
}
    ${UnmappedJobStages_JobStageMappingFragmentDoc}
${UnmappedScorecards_ScorecardMappingFragmentDoc}
${UnmappedContentTabs_ContentTabMappingFragmentDoc}`;
export const ReviewJobsTable_JobImportValidateResultsFragmentDoc = gql`
    fragment ReviewJobsTable_jobImportValidateResults on JobImportValidateResult {
  targetJob {
    id
  }
  ...ReviewJobRow_jobImportValidateResult
}
    ${ReviewJobRow_JobImportValidateResultFragmentDoc}`;
export const GetJobsWithIssues_JobImportValidateResultsFragmentDoc = gql`
    fragment getJobsWithIssues_jobImportValidateResults on JobImportValidateResult {
  targetJob {
    id
  }
  jobStageMappings {
    ...unmappedJobStages_jobStageMapping
  }
  scorecardMappings {
    ...unmappedScorecards_scorecardMapping
  }
  contentTabMappings {
    ...unmappedContentTabs_contentTabMapping
  }
}
    ${UnmappedJobStages_JobStageMappingFragmentDoc}
${UnmappedScorecards_ScorecardMappingFragmentDoc}
${UnmappedContentTabs_ContentTabMappingFragmentDoc}`;
export const GetJobsWithoutIssues_JobImportValidateResultsFragmentDoc = gql`
    fragment getJobsWithoutIssues_jobImportValidateResults on JobImportValidateResult {
  targetJob {
    id
  }
  jobStageMappings {
    ...unmappedJobStages_jobStageMapping
  }
  scorecardMappings {
    ...unmappedScorecards_scorecardMapping
  }
  contentTabMappings {
    ...unmappedContentTabs_contentTabMapping
  }
}
    ${UnmappedJobStages_JobStageMappingFragmentDoc}
${UnmappedScorecards_ScorecardMappingFragmentDoc}
${UnmappedContentTabs_ContentTabMappingFragmentDoc}`;
export const Review_JobImportValidateResultsFragmentDoc = gql`
    fragment Review_jobImportValidateResults on JobImportValidateResult {
  targetJob {
    id
  }
  jobStageMappings {
    targetJobStageId
  }
  scorecardMappings {
    targetAtsId
  }
  ...ReviewJobsTable_jobImportValidateResults
  ...getJobsWithIssues_jobImportValidateResults
  ...getJobsWithoutIssues_jobImportValidateResults
}
    ${ReviewJobsTable_JobImportValidateResultsFragmentDoc}
${GetJobsWithIssues_JobImportValidateResultsFragmentDoc}
${GetJobsWithoutIssues_JobImportValidateResultsFragmentDoc}`;
export const CandidatePortalImportOptions_PortalJobOptionsFragmentDoc = gql`
    fragment CandidatePortalImportOptions_portalJobOptions on PortalJobOptions {
  id
  tabs {
    id
    name
    visibility
  }
  linkedPortalConfig {
    id
    name
    tabs {
      id
      name
      visibility
      stageNameFilter
    }
  }
}
    `;
export const SelectImportOptions_JobFragmentDoc = gql`
    fragment SelectImportOptions_job on Job {
  id
  name
  location
  jobStages {
    id
    name
  }
  portalJobOptions {
    ...CandidatePortalImportOptions_portalJobOptions
  }
}
    ${CandidatePortalImportOptions_PortalJobOptionsFragmentDoc}`;
export const SourceJobListItem_JobFragmentDoc = gql`
    fragment SourceJobListItem_job on Job {
  id
  name
  orgId
  status
  location
  validationIssues {
    errors {
      ...getHiringSetupError_flags
    }
  }
  atsJob {
    atsCustomerFriendlyId
  }
}
    ${GetHiringSetupError_FlagsFragmentDoc}`;
export const SourceJobTable_JobFragmentDoc = gql`
    fragment SourceJobTable_job on Job {
  ...SourceJobListItem_job
}
    ${SourceJobListItem_JobFragmentDoc}`;
export const GetJobStageMappings_JobStageMappingFragmentDoc = gql`
    fragment getJobStageMappings_jobStageMapping on JobStageMapping {
  targetJobStageId
  sourceJobStageId
}
    `;
export const GetScorecardMappings_ScorecardMappingFragmentDoc = gql`
    fragment getScorecardMappings_scorecardMapping on ScorecardMapping {
  targetAtsId
  sourceAtsId
}
    `;
export const JobListItemV2_EmployeeFragmentDoc = gql`
    fragment JobListItemV2_employee on Employee {
  fullName
  email
  id
  orgId
  internalProfilePictureUrl
  timezone
  atsId
}
    `;
export const JobListItemV2_JobFragmentDoc = gql`
    fragment JobListItemV2_job on Job {
  id
  name
  orgId
  status
  hiringManagers {
    ...JobListItemV2_employee
  }
  recruiters {
    ...JobListItemV2_employee
  }
  coordinators {
    ...JobListItemV2_employee
  }
  sourcers {
    ...JobListItemV2_employee
  }
  atsJob {
    atsId
    jobRequisitionId
    atsCustomerFriendlyId
  }
  validationIssues {
    errors {
      ...getHiringSetupError_flags
    }
  }
  location
  jobStagesWithInterviewPlansCount
}
    ${JobListItemV2_EmployeeFragmentDoc}
${GetHiringSetupError_FlagsFragmentDoc}`;
export const JobListTable_JobFragmentDoc = gql`
    fragment JobListTable_job on Job {
  ...JobListItemV2_job
}
    ${JobListItemV2_JobFragmentDoc}`;
export const TagProgress_TagWithPercentageFragmentDoc = gql`
    fragment TagProgress_tagWithPercentage on CandidatePulseTagWithPercentage {
  tag {
    id
    emoji
    name
  }
  percentage
}
    `;
export const QuestionSection_TagWithPercentageFragmentDoc = gql`
    fragment QuestionSection_tagWithPercentage on CandidatePulseTagWithPercentage {
  ...TagProgress_tagWithPercentage
}
    ${TagProgress_TagWithPercentageFragmentDoc}`;
export const SummarySection_SummaryFragmentDoc = gql`
    fragment SummarySection_summary on CandidatePulseMetricsSummary {
  averageRating
  npsScore
}
    `;
export const RescheduleLogReasonsChart_RescheduleLogReasonsDataFragmentDoc = gql`
    fragment RescheduleLogReasonsChart_rescheduleLogReasonsData on RecruiterRescheduleLogsWrapperResult {
  rescheduleLogsChart {
    rescheduleReason {
      id
      reason
    }
    data {
      x: xpoint
      y: ypoint
    }
  }
  items {
    taskId
    atsApplicationId
    atsCandidateId
    atsJobId
    date
    note
    rescheduleReason {
      id
      reason
    }
    performedBy {
      fullName
    }
    task {
      createdBy {
        fullName
      }
      jobStage {
        name
      }
      application {
        id
        job {
          name
        }
        candidate {
          id
          fullName
        }
      }
    }
  }
}
    `;
export const RescheduleLogNotes_RescheduleLogItemsFragmentDoc = gql`
    fragment RescheduleLogNotes_rescheduleLogItems on RecruiterRescheduleLog {
  id
  date
  note
  rescheduleReason {
    id
    reason
  }
  performedBy {
    fullName
    internalProfilePictureUrl
  }
  task {
    id
    createdBy {
      fullName
    }
    jobStage {
      name
    }
    application {
      id
      job {
        name
      }
      candidate {
        id
        fullName
      }
    }
  }
}
    `;
export const MetricsPageAverageTimesFiltersEmployeePrefFragmentDoc = gql`
    fragment MetricsPageAverageTimesFiltersEmployeePref on MetricsPageAverageTimesFiltersPref {
  assigneeEmployeeIds
  jobIds
  jobStageNames
  startMetric
  endMetric
}
    `;
export const MetricsPageInterviewerFiltersEmployeePrefFragmentDoc = gql`
    fragment MetricsPageInterviewerFiltersEmployeePref on MetricsPageInterviewerFiltersPref {
  interviewerEmployeeIds
  managerEmployeeIds
  jobIds
  interviewModuleIds
  departmentAttributeIds
  teamAttributeIds
  locationAttributeIds
  levelAttributeIds
  countryAttributeIds
  customAttributeIds
  showArchived
  jobLocations
  atsDepartmentIds
}
    `;
export const MetricsPageRecruitingTeamFiltersEmployeePrefFragmentDoc = gql`
    fragment MetricsPageRecruitingTeamFiltersEmployeePref on MetricsPageRecruitingTeamFiltersPref {
  schedulerEmployeeIds
  jobIds
  jobStageNames
  showArchived
  jobLocations
  atsDepartmentIds
}
    `;
export const OmniSearchOptionApplication_ApplicationFragmentDoc = gql`
    fragment OmniSearchOptionApplication_application on Application {
  id
  candidate {
    id
    fullName
  }
  job {
    id
    name
  }
  jobStage {
    id
    name
  }
}
    `;
export const OmniSearchOptionEmployee_EmployeeFragmentDoc = gql`
    fragment OmniSearchOptionEmployee_employee on Employee {
  id
  fullName
  internalProfilePictureUrl
  isArchived
  isAtsDisabled
  hasAtsId
  atsType
}
    `;
export const OmniSearchOptionInterviewModule_InterviewModuleFragmentDoc = gql`
    fragment OmniSearchOptionInterviewModule_interviewModule on InterviewModule {
  id
  name
}
    `;
export const OmniSearchOptionJob_JobFragmentDoc = gql`
    fragment OmniSearchOptionJob_job on Job {
  id
  name
  atsJob {
    atsCustomerFriendlyId
  }
}
    `;
export const JobStageSettingsV2FragmentFragmentDoc = gql`
    fragment JobStageSettingsV2Fragment on JobStageSettingsV2 {
  id
  jobStageId
  shouldSendEmailToCandidate {
    value
  }
  shouldSendCalendarInviteToCandidate {
    value
  }
  shouldSendChatMessage {
    value
  }
  chatConversationMembers {
    notificationPreference {
      employeeIds
      dynamicAudiences
    }
  }
  candidateEmailTemplateId {
    templateId
  }
  candidateEventTemplateId {
    templateId
  }
  interviewerEventTemplateId {
    templateId
  }
  interviewerCalendarId {
    remoteCalendarId
  }
  candidateCalendarId {
    remoteCalendarId
  }
  slackTemplateId {
    templateId
  }
  isPrivateCalendarEvent {
    value
  }
  ccRecipientsV2 {
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  bccRecipientsV2 {
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  candidateEventAdditionalAttendees {
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  interviewerEventAdditionalAttendees {
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  debriefEventAdditionalAttendees {
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  candidateEventAdditionalAttendeesOptional {
    value
  }
  interviewerEventAdditionalAttendeesOptional {
    value
  }
  debriefEventAdditionalAttendeesOptional {
    value
  }
  candidateEventAdditionalAttendeesV2 {
    attendees {
      email
      employeeId
      dynamicAudience
      isOptional
    }
  }
  interviewerEventAdditionalAttendeesV2 {
    attendees {
      email
      employeeId
      dynamicAudience
      isOptional
    }
  }
  debriefEventAdditionalAttendeesV2 {
    attendees {
      email
      employeeId
      dynamicAudience
      isOptional
    }
  }
}
    `;
export const CandidateAvailabilityStep_CandidateFragmentDoc = gql`
    fragment CandidateAvailabilityStep_candidate on Candidate {
  id
  atsCandidate {
    atsId
    atsUrl
  }
}
    `;
export const CodingCard_CandidateFragmentDoc = gql`
    fragment CodingCard_candidate on Candidate {
  id
  fullName
  email
  preferredEmail
  additionalEmails
}
    `;
export const Communications_CandidateFragmentDoc = gql`
    fragment Communications_candidate on Candidate {
  id
  fullName
  preferredName
  preferredPhoneNumber
  ...CodingCard_candidate
}
    ${CodingCard_CandidateFragmentDoc}`;
export const UpdateCommunications_CandidateFragmentDoc = gql`
    fragment UpdateCommunications_candidate on Candidate {
  id
  fullName
  preferredName
  preferredPhoneNumber
  ...CodingCard_candidate
}
    ${CodingCard_CandidateFragmentDoc}`;
export const ScheduleFlowDataProvider_CandidateFragmentDoc = gql`
    fragment ScheduleFlowDataProvider_candidate on Candidate {
  id
  ...CandidateAvailabilityStep_candidate
  ...Communications_candidate
  ...UpdateCommunications_candidate
}
    ${CandidateAvailabilityStep_CandidateFragmentDoc}
${Communications_CandidateFragmentDoc}
${UpdateCommunications_CandidateFragmentDoc}`;
export const ScheduleInterviewPlan_JobFragmentDoc = gql`
    fragment ScheduleInterviewPlan_job on Job {
  id
  atsId
}
    `;
export const ScheduleFlowDataProvider_JobFragmentDoc = gql`
    fragment ScheduleFlowDataProvider_job on Job {
  id
  ...ScheduleInterviewPlan_job
}
    ${ScheduleInterviewPlan_JobFragmentDoc}`;
export const BaseInterviewPlanPreview_JobStageInterviewGroupsFragmentDoc = gql`
    fragment BaseInterviewPlanPreview_jobStageInterviewGroups on JobStageInterviewGroup {
  id
  jobStageInterviews {
    id
    name
    interviewType
    duration
    isLockedOrder
    atsInterviewDefinition {
      atsId
      name
      atsFields {
        ... on GreenhouseInterviewDefinition {
          estimatedMinutes
        }
      }
    }
  }
}
    `;
export const UseScheduleOptionsRequestBody_InterviewPlanFragmentDoc = gql`
    fragment useScheduleOptionsRequestBody_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    locked
    jobStageInterviews {
      id
      interviewType
      duration
      forcedStartAt @client
      name
      atsInterviewDefinition {
        atsId
        name
        atsFields {
          ... on GreenhouseInterviewDefinition {
            estimatedMinutes
          }
        }
      }
      isLockedOrder
      isHiddenFromCandidate
      jobStageInterviewSeats {
        id
        freeformSeat {
          jobStageInterviewSeatEmployees {
            jobStageInterviewSeatId
            employeeId
            preferenceLevel
          }
        }
        moduleSeat {
          interviewModuleId
          jobStageInterviewSeatAttributes {
            id
            attributeNameId
            attributeTagValueId
          }
          selectedEmployeeIds
          interviewModule {
            id
            interviewModuleMembers(input: {pageInput: {limit: 500, offset: 0}}) {
              items {
                id
                employeeId
                status
              }
            }
          }
          shadowConfig {
            selectedEmployeeIds
            selectedAttributes {
              id
              attributeNameId
              attributeTagValueId
            }
          }
          reverseShadowConfig {
            selectedEmployeeIds
            selectedAttributes {
              id
              attributeNameId
              attributeTagValueId
            }
          }
        }
        linkedSeat {
          linkedJobStageInterviewSeatId
        }
      }
    }
  }
  schedulingWindow {
    seconds
  }
  excludedEmployees {
    id
  }
}
    `;
export const UseSubmitInterviewPlan_InterviewPlanFragmentDoc = gql`
    fragment useSubmitInterviewPlan_interviewPlan on JobStage {
  id
  ...useScheduleOptionsRequestBody_interviewPlan
}
    ${UseScheduleOptionsRequestBody_InterviewPlanFragmentDoc}`;
export const InterviewPlanPreview_JobStageFragmentDoc = gql`
    fragment InterviewPlanPreview_jobStage on JobStage {
  id
  jobStageInterviewGroups {
    id
    ...BaseInterviewPlanPreview_jobStageInterviewGroups
  }
  ...getSaveInterviewPlanInput_interviewPlan
  ...useIsInterviewPlanValid_jobStage
  ...useSubmitInterviewPlan_interviewPlan
}
    ${BaseInterviewPlanPreview_JobStageInterviewGroupsFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}
${UseIsInterviewPlanValid_JobStageFragmentDoc}
${UseSubmitInterviewPlan_InterviewPlanFragmentDoc}`;
export const ScheduleInterviewPlan_JobStageFragmentDoc = gql`
    fragment ScheduleInterviewPlan_jobStage on JobStage {
  id
  ...InterviewPlanPreview_jobStage
  ...InterviewPlan_jobStage
}
    ${InterviewPlanPreview_JobStageFragmentDoc}
${InterviewPlan_JobStageFragmentDoc}`;
export const UsePopulateEventData_InterviewPlanFragmentDoc = gql`
    fragment usePopulateEventData_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      interviewType
      atsInterviewDefinition {
        atsId
      }
      interviewGuide {
        id
      }
    }
  }
}
    `;
export const UseScheduleContent_InterviewPlanFragmentDoc = gql`
    fragment useScheduleContent_interviewPlan on JobStage {
  id
  ...usePopulateEventData_interviewPlan
}
    ${UsePopulateEventData_InterviewPlanFragmentDoc}`;
export const UseCandidateEventTemplateContent_InterviewPlanFragmentDoc = gql`
    fragment useCandidateEventTemplateContent_interviewPlan on JobStage {
  id
  ...useScheduleContent_interviewPlan
}
    ${UseScheduleContent_InterviewPlanFragmentDoc}`;
export const CandidateEmailCard_InterviewPlanFragmentDoc = gql`
    fragment CandidateEmailCard_interviewPlan on JobStage {
  id
  ...useCandidateEventTemplateContent_interviewPlan
}
    ${UseCandidateEventTemplateContent_InterviewPlanFragmentDoc}`;
export const UseCandidateCalendarEventTemplateContent_InterviewPlanFragmentDoc = gql`
    fragment useCandidateCalendarEventTemplateContent_interviewPlan on JobStage {
  id
  ...useScheduleContent_interviewPlan
}
    ${UseScheduleContent_InterviewPlanFragmentDoc}`;
export const CandidateEventCard_InterviewPlanFragmentDoc = gql`
    fragment CandidateEventCard_interviewPlan on JobStage {
  id
  ...useCandidateCalendarEventTemplateContent_interviewPlan
}
    ${UseCandidateCalendarEventTemplateContent_InterviewPlanFragmentDoc}`;
export const UseCreateCodingUrls_InterviewPlanFragmentDoc = gql`
    fragment useCreateCodingUrls_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      dynamicLinkTypes
    }
  }
}
    `;
export const CodingCard_InterviewPlanFragmentDoc = gql`
    fragment CodingCard_interviewPlan on JobStage {
  id
  ...useCreateCodingUrls_interviewPlan
}
    ${UseCreateCodingUrls_InterviewPlanFragmentDoc}`;
export const UseGetInterviewers_InterviewPlanFragmentDoc = gql`
    fragment useGetInterviewers_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      jobStageInterviewSeats {
        id
        freeformSeat {
          jobStageInterviewSeatEmployees {
            jobStageInterviewSeatId
            employeeId
            preferenceLevel
          }
        }
        moduleSeat {
          interviewModuleId
        }
        linkedSeat {
          linkedJobStageInterviewSeatId
        }
      }
    }
  }
}
    `;
export const UseSubmitCreateSchedule_InterviewPlanFragmentDoc = gql`
    fragment useSubmitCreateSchedule_interviewPlan on JobStage {
  id
  ...useGetInterviewers_interviewPlan
  ...getSaveInterviewPlanInput_interviewPlan
  ...usePopulateEventData_interviewPlan
}
    ${UseGetInterviewers_InterviewPlanFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}
${UsePopulateEventData_InterviewPlanFragmentDoc}`;
export const CommunicationsPreview_InterviewPlanFragmentDoc = gql`
    fragment CommunicationsPreview_interviewPlan on JobStage {
  id
  ...useSubmitCreateSchedule_interviewPlan
}
    ${UseSubmitCreateSchedule_InterviewPlanFragmentDoc}`;
export const UseInterviewEventTemplateContent_InterviewPlanFragmentDoc = gql`
    fragment useInterviewEventTemplateContent_interviewPlan on JobStage {
  id
  ...useScheduleContent_interviewPlan
}
    ${UseScheduleContent_InterviewPlanFragmentDoc}`;
export const InterviewerContentCard_InterviewPlanFragmentDoc = gql`
    fragment InterviewerContentCard_interviewPlan on JobStage {
  id
  ...useInterviewEventTemplateContent_interviewPlan
}
    ${UseInterviewEventTemplateContent_InterviewPlanFragmentDoc}`;
export const InterviewerCommunicationCards_InterviewPlanFragmentDoc = gql`
    fragment InterviewerCommunicationCards_interviewPlan on JobStage {
  id
  ...InterviewerContentCard_interviewPlan
}
    ${InterviewerContentCard_InterviewPlanFragmentDoc}`;
export const UseSlackTemplateContent_InterviewPlanFragmentDoc = gql`
    fragment useSlackTemplateContent_interviewPlan on JobStage {
  id
  ...useScheduleContent_interviewPlan
}
    ${UseScheduleContent_InterviewPlanFragmentDoc}`;
export const BaseSlackChannelCard_InterviewPlanFragmentDoc = gql`
    fragment BaseSlackChannelCard_interviewPlan on JobStage {
  id
  ...useSlackTemplateContent_interviewPlan
}
    ${UseSlackTemplateContent_InterviewPlanFragmentDoc}`;
export const SlackChannelCard_InterviewPlanFragmentDoc = gql`
    fragment SlackChannelCard_interviewPlan on JobStage {
  id
  ...BaseSlackChannelCard_interviewPlan
}
    ${BaseSlackChannelCard_InterviewPlanFragmentDoc}`;
export const Communications_InterviewPlanFragmentDoc = gql`
    fragment Communications_interviewPlan on JobStage {
  id
  ...CandidateEmailCard_interviewPlan
  ...CandidateEventCard_interviewPlan
  ...CodingCard_interviewPlan
  ...CommunicationsPreview_interviewPlan
  ...InterviewerCommunicationCards_interviewPlan
  ...SlackChannelCard_interviewPlan
}
    ${CandidateEmailCard_InterviewPlanFragmentDoc}
${CandidateEventCard_InterviewPlanFragmentDoc}
${CodingCard_InterviewPlanFragmentDoc}
${CommunicationsPreview_InterviewPlanFragmentDoc}
${InterviewerCommunicationCards_InterviewPlanFragmentDoc}
${SlackChannelCard_InterviewPlanFragmentDoc}`;
export const UpdateInterviewSeat_InterviewSeatFragmentDoc = gql`
    fragment UpdateInterviewSeat_interviewSeat on JobStageInterviewSeat {
  id
  type
  index
  freeformSeat {
    jobStageInterviewSeatEmployees {
      employeeId
      preferenceLevel
    }
  }
  moduleSeat {
    interviewModuleId
    jobStageInterviewSeatAttributes {
      id
      attributeNameId
      attributeTagValueId
    }
    selectedEmployeeIds
  }
  linkedSeat {
    linkedJobStageInterviewSeatId
  }
}
    `;
export const BrighthireSelect_InterviewGuideFragmentDoc = gql`
    fragment BrighthireSelect_interviewGuide on InterviewGuide {
  id
  name
}
    `;
export const UpdateInterviewSeat_InterviewFragmentDoc = gql`
    fragment UpdateInterviewSeat_interview on JobStageInterview {
  id
  name
}
    `;
export const InterviewDetails_InterviewFragmentDoc = gql`
    fragment InterviewDetails_interview on JobStageInterview {
  id
  atsInterviewDefinition {
    atsId
  }
  jobStageInterviewSeats {
    id
    ...UpdateInterviewSeat_interviewSeat
  }
  interviewGuide {
    ...BrighthireSelect_interviewGuide
  }
  ...UpdateInterviewSeat_interview
}
    ${UpdateInterviewSeat_InterviewSeatFragmentDoc}
${BrighthireSelect_InterviewGuideFragmentDoc}
${UpdateInterviewSeat_InterviewFragmentDoc}`;
export const UpdateInterviewSeat_OriginalInterviewSeatFragmentDoc = gql`
    fragment UpdateInterviewSeat_originalInterviewSeat on JobStageInterviewSeat {
  id
  type
  index
  freeformSeat {
    jobStageInterviewSeatEmployees {
      employeeId
      preferenceLevel
    }
  }
  moduleSeat {
    interviewModuleId
    jobStageInterviewSeatAttributes {
      id
      attributeNameId
      attributeTagValueId
    }
    selectedEmployeeIds
  }
  linkedSeat {
    linkedJobStageInterviewSeatId
  }
}
    `;
export const UpdateInterviewSeat_OriginalInterviewFragmentDoc = gql`
    fragment UpdateInterviewSeat_originalInterview on JobStageInterview {
  id
  name
}
    `;
export const InterviewDetails_OriginalInterviewsFragmentDoc = gql`
    fragment InterviewDetails_originalInterviews on JobStageInterview {
  id
  jobStageInterviewSeats {
    id
    ...UpdateInterviewSeat_originalInterviewSeat
  }
  ...UpdateInterviewSeat_originalInterview
}
    ${UpdateInterviewSeat_OriginalInterviewSeatFragmentDoc}
${UpdateInterviewSeat_OriginalInterviewFragmentDoc}`;
export const BaseCalendarView_InterviewPlanFragmentDoc = gql`
    fragment BaseCalendarView_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      ...InterviewDetails_interview
      ...InterviewDetails_originalInterviews
    }
  }
  ...useSubmitInterviewPlan_interviewPlan
}
    ${InterviewDetails_InterviewFragmentDoc}
${InterviewDetails_OriginalInterviewsFragmentDoc}
${UseSubmitInterviewPlan_InterviewPlanFragmentDoc}`;
export const CalendarView_InterviewPlanFragmentDoc = gql`
    fragment CalendarView_interviewPlan on JobStage {
  id
  ...BaseCalendarView_interviewPlan
  ...usePopulateEventData_interviewPlan
}
    ${BaseCalendarView_InterviewPlanFragmentDoc}
${UsePopulateEventData_InterviewPlanFragmentDoc}`;
export const BaseUpdateCalendarView_InterviewPlanFragmentDoc = gql`
    fragment BaseUpdateCalendarView_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      ...InterviewDetails_interview
      ...InterviewDetails_originalInterviews
    }
  }
}
    ${InterviewDetails_InterviewFragmentDoc}
${InterviewDetails_OriginalInterviewsFragmentDoc}`;
export const UpdateCalendarView_InterviewPlanFragmentDoc = gql`
    fragment UpdateCalendarView_interviewPlan on JobStage {
  id
  ...BaseUpdateCalendarView_interviewPlan
  ...usePopulateEventData_interviewPlan
}
    ${BaseUpdateCalendarView_InterviewPlanFragmentDoc}
${UsePopulateEventData_InterviewPlanFragmentDoc}`;
export const UseSubmitUpdateSchedule_InterviewPlanFragmentDoc = gql`
    fragment useSubmitUpdateSchedule_interviewPlan on JobStage {
  id
  ...usePopulateEventData_interviewPlan
  ...useGetInterviewers_interviewPlan
}
    ${UsePopulateEventData_InterviewPlanFragmentDoc}
${UseGetInterviewers_InterviewPlanFragmentDoc}`;
export const UpdateCommunicationsPreview_InterviewPlanFragmentDoc = gql`
    fragment UpdateCommunicationsPreview_interviewPlan on JobStage {
  id
  ...useSubmitUpdateSchedule_interviewPlan
}
    ${UseSubmitUpdateSchedule_InterviewPlanFragmentDoc}`;
export const UpdateCommunications_InterviewPlanFragmentDoc = gql`
    fragment UpdateCommunications_interviewPlan on JobStage {
  id
  ...CandidateEmailCard_interviewPlan
  ...CandidateEventCard_interviewPlan
  ...CodingCard_interviewPlan
  ...InterviewerCommunicationCards_interviewPlan
  ...SlackChannelCard_interviewPlan
  ...UpdateCommunicationsPreview_interviewPlan
}
    ${CandidateEmailCard_InterviewPlanFragmentDoc}
${CandidateEventCard_InterviewPlanFragmentDoc}
${CodingCard_InterviewPlanFragmentDoc}
${InterviewerCommunicationCards_InterviewPlanFragmentDoc}
${SlackChannelCard_InterviewPlanFragmentDoc}
${UpdateCommunicationsPreview_InterviewPlanFragmentDoc}`;
export const BaseScheduleOptions_InterviewPlanFragmentDoc = gql`
    fragment BaseScheduleOptions_interviewPlan on JobStage {
  id
  ...useSubmitInterviewPlan_interviewPlan
}
    ${UseSubmitInterviewPlan_InterviewPlanFragmentDoc}`;
export const ScheduleOptions_InterviewPlanFragmentDoc = gql`
    fragment ScheduleOptions_interviewPlan on JobStage {
  id
  ...BaseScheduleOptions_interviewPlan
}
    ${BaseScheduleOptions_InterviewPlanFragmentDoc}`;
export const CloneInterviewPlan_InterviewPlanFragmentDoc = gql`
    fragment cloneInterviewPlan_interviewPlan on JobStage {
  id
  job {
    id
    ...InterviewPlan_job
  }
  ...InterviewPlan_jobStage
}
    ${InterviewPlan_JobFragmentDoc}
${InterviewPlan_JobStageFragmentDoc}`;
export const ScheduleFlowDataProvider_InterviewPlanFragmentDoc = gql`
    fragment ScheduleFlowDataProvider_interviewPlan on JobStage {
  id
  ...ScheduleInterviewPlan_jobStage
  ...Communications_interviewPlan
  ...CalendarView_interviewPlan
  ...UpdateCalendarView_interviewPlan
  ...UpdateCommunications_interviewPlan
  ...ScheduleOptions_interviewPlan
  ...cloneInterviewPlan_interviewPlan
}
    ${ScheduleInterviewPlan_JobStageFragmentDoc}
${Communications_InterviewPlanFragmentDoc}
${CalendarView_InterviewPlanFragmentDoc}
${UpdateCalendarView_InterviewPlanFragmentDoc}
${UpdateCommunications_InterviewPlanFragmentDoc}
${ScheduleOptions_InterviewPlanFragmentDoc}
${CloneInterviewPlan_InterviewPlanFragmentDoc}`;
export const CommunicationsPreview_JobSettingsFragmentDoc = gql`
    fragment CommunicationsPreview_jobSettings on JobSettings {
  id
  defaultTaskQueue {
    id
  }
}
    `;
export const Communications_JobSettingsFragmentDoc = gql`
    fragment Communications_jobSettings on JobSettings {
  id
  ...CommunicationsPreview_jobSettings
}
    ${CommunicationsPreview_JobSettingsFragmentDoc}`;
export const ScheduleFlowDataProvider_JobSettingsFragmentDoc = gql`
    fragment ScheduleFlowDataProvider_jobSettings on JobSettings {
  id
  ...Communications_jobSettings
}
    ${Communications_JobSettingsFragmentDoc}`;
export const CandidateEmailCard_TaskFragmentDoc = gql`
    fragment CandidateEmailCard_task on Task {
  id
  assignee {
    id
  }
  createdBy {
    id
  }
}
    `;
export const Communications_TaskFragmentDoc = gql`
    fragment Communications_task on Task {
  id
  ...CandidateEmailCard_task
}
    ${CandidateEmailCard_TaskFragmentDoc}`;
export const UpdateCommunications_TaskFragmentDoc = gql`
    fragment UpdateCommunications_task on Task {
  id
  ...CandidateEmailCard_task
}
    ${CandidateEmailCard_TaskFragmentDoc}`;
export const ScheduleFlowDataProvider_TaskFragmentDoc = gql`
    fragment ScheduleFlowDataProvider_task on Task {
  id
  ...Communications_task
  ...UpdateCommunications_task
}
    ${Communications_TaskFragmentDoc}
${UpdateCommunications_TaskFragmentDoc}`;
export const UsePopulateInterviewMeetingLocation_InterviewMeetingLocationSettingFragmentDoc = gql`
    fragment usePopulateInterviewMeetingLocation_interviewMeetingLocationSetting on InterviewMeetingLocationSettingPref {
  interviewMeetingLocationType
  videoMeetingLinkScope
  dynamicHost
  hostEmployeeId
  remoteVideoMeetingHostUserId
  customLocation
}
    `;
export const LocationCard_InterviewMeetingLocationSettingFragmentDoc = gql`
    fragment LocationCard_interviewMeetingLocationSetting on InterviewMeetingLocationSettingPref {
  ...usePopulateInterviewMeetingLocation_interviewMeetingLocationSetting
}
    ${UsePopulateInterviewMeetingLocation_InterviewMeetingLocationSettingFragmentDoc}`;
export const SlackChannelCard_JobStageSettingsV2FragmentDoc = gql`
    fragment SlackChannelCard_jobStageSettingsV2 on JobStageSettingsV2 {
  chatConversation {
    chatConversationId
    chatConversation {
      id
      remoteId
      remoteName
      isArchived
    }
    chatConversationType
  }
}
    `;
export const Communications_JobStageSettingsFragmentDoc = gql`
    fragment Communications_jobStageSettings on JobStageSettingsV2 {
  id
  interviewMeetingLocationSettingWithLevel {
    interviewMeetingLocationSetting {
      ...LocationCard_interviewMeetingLocationSetting
    }
  }
  ...SlackChannelCard_jobStageSettingsV2
}
    ${LocationCard_InterviewMeetingLocationSettingFragmentDoc}
${SlackChannelCard_JobStageSettingsV2FragmentDoc}`;
export const DebriefCommunications_JobStageSettingsFragmentDoc = gql`
    fragment DebriefCommunications_jobStageSettings on JobStageSettingsV2 {
  id
  interviewMeetingLocationSettingWithLevel {
    interviewMeetingLocationSetting {
      ...LocationCard_interviewMeetingLocationSetting
    }
  }
  debriefMeetingLocationSettingWithLevel {
    debriefMeetingLocationSetting {
      ...LocationCard_interviewMeetingLocationSetting
    }
  }
  debriefEventAdditionalAttendees {
    level
    notificationPreference {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
  }
  debriefEventAdditionalAttendeesOptional {
    value
  }
  debriefEventAdditionalAttendeesV2 {
    attendees {
      email
      employeeId
      dynamicAudience
      isOptional
    }
  }
  ...SlackChannelCard_jobStageSettingsV2
}
    ${LocationCard_InterviewMeetingLocationSettingFragmentDoc}
${SlackChannelCard_JobStageSettingsV2FragmentDoc}`;
export const UpdateCommunications_JobStageSettingsFragmentDoc = gql`
    fragment UpdateCommunications_jobStageSettings on JobStageSettingsV2 {
  id
  interviewMeetingLocationSettingWithLevel {
    interviewMeetingLocationSetting {
      ...LocationCard_interviewMeetingLocationSetting
    }
  }
  ...SlackChannelCard_jobStageSettingsV2
}
    ${LocationCard_InterviewMeetingLocationSettingFragmentDoc}
${SlackChannelCard_JobStageSettingsV2FragmentDoc}`;
export const ScheduleFlowDataProvider_JobStageSettingsFragmentDoc = gql`
    fragment ScheduleFlowDataProvider_jobStageSettings on JobStageSettingsV2 {
  id
  ...Communications_jobStageSettings
  ...DebriefCommunications_jobStageSettings
  ...UpdateCommunications_jobStageSettings
  debriefAtsWriteSettingWithLevel {
    level
    debriefAtsWriteSetting {
      ...DebriefAtsWriteRow_setting
    }
  }
}
    ${Communications_JobStageSettingsFragmentDoc}
${DebriefCommunications_JobStageSettingsFragmentDoc}
${UpdateCommunications_JobStageSettingsFragmentDoc}
${DebriefAtsWriteRow_SettingFragmentDoc}`;
export const ScheduleIssuesDialogApplicationStageInterviewFragmentDoc = gql`
    fragment ScheduleIssuesDialogApplicationStageInterview on ApplicationStageInterview {
  id
  atsInterviewDefinition {
    atsId
    name
  }
  startAt
  endAt
}
    `;
export const ScheduleIssuesDialogApplicationStageInterviewInterviewersFragmentDoc = gql`
    fragment ScheduleIssuesDialogApplicationStageInterviewInterviewers on ApplicationStageInterviewInterviewer {
  applicationStageInterviewId
  interviewerId
  interviewer {
    id
    fullName
    internalProfilePictureUrl
  }
  declines {
    source
    reason
    comment
  }
}
    `;
export const CollaborationToolCard_CandidateFragmentDoc = gql`
    fragment CollaborationToolCard_candidate on Candidate {
  id
}
    `;
export const UseCollaborationToolUrls_InterviewPlanFragmentDoc = gql`
    fragment useCollaborationToolUrls_interviewPlan on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      collaborationLinkTypes {
        collaborationToolType
        collaborationLinkTemplateId
      }
    }
  }
}
    `;
export const CollaborationToolSelect_CollaborationLinkTypeFragmentDoc = gql`
    fragment CollaborationToolSelect_collaborationLinkType on CollaborationLinkType {
  collaborationToolType
  collaborationLinkTemplateId
}
    `;
export const CollaborationToolCardRow_CollaborationLinkTypeFragmentDoc = gql`
    fragment CollaborationToolCardRow_collaborationLinkType on CollaborationLinkType {
  ...CollaborationToolSelect_collaborationLinkType
}
    ${CollaborationToolSelect_CollaborationLinkTypeFragmentDoc}`;
export const CollaborationToolCard_InterviewPlanFragmentDoc = gql`
    fragment CollaborationToolCard_interviewPlan on JobStage {
  id
  ...useCollaborationToolUrls_interviewPlan
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      collaborationLinkTypes {
        ...CollaborationToolCardRow_collaborationLinkType
      }
    }
  }
}
    ${UseCollaborationToolUrls_InterviewPlanFragmentDoc}
${CollaborationToolCardRow_CollaborationLinkTypeFragmentDoc}`;
export const GetTextForFlag_CompanyHolidayFragmentDoc = gql`
    fragment getTextForFlag_companyHoliday on CompanyHoliday {
  id
  name
  startAt
}
    `;
export const InitScheduleFlowData_TemplateFragmentDoc = gql`
    fragment InitScheduleFlowData_template on Template {
  id
  name
  type
}
    `;
export const UseCandidateAvailability_AtsLatestAvailabilityFragmentDoc = gql`
    fragment useCandidateAvailability_atsLatestAvailability on CandidateAtsAvailability {
  intervals {
    startAt
    endAt
  }
  jobName
  jobStageName
  originalText
}
    `;
export const UseCandidateAvailability_AvailabilitiesFragmentDoc = gql`
    fragment useCandidateAvailability_availabilities on CandidateAvailability {
  id
  candidateEnteredAvailability {
    startAt
    endAt
  }
  rcEnteredAvailability {
    startAt
    endAt
  }
}
    `;
export const CreateTaskDialogPage_ApplicationFragmentDoc = gql`
    fragment CreateTaskDialogPage_application on Application {
  id
  ...CreateTaskStep_application
  jobStage {
    id
  }
  candidate {
    id
    timezone
  }
}
    ${CreateTaskStep_ApplicationFragmentDoc}`;
export const CreateTaskStep_JobStageFragmentDoc = gql`
    fragment CreateTaskStep_jobStage on JobStage {
  id
  ...InterviewPlan_jobStage
  ...useInterviewPlanHasInterviewHiddenFromCandidate_interviewPlan
}
    ${InterviewPlan_JobStageFragmentDoc}
${UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragmentDoc}`;
export const CreateTaskDialogPage_InterviewPlanFragmentDoc = gql`
    fragment CreateTaskDialogPage_interviewPlan on JobStage {
  id
  ...CreateTaskStep_jobStage
  ...cloneInterviewPlan_interviewPlan
  ...useIsInterviewPlanValid_jobStage
  ...useInterviewPlanHasInterviewHiddenFromCandidate_interviewPlan
}
    ${CreateTaskStep_JobStageFragmentDoc}
${CloneInterviewPlan_InterviewPlanFragmentDoc}
${UseIsInterviewPlanValid_JobStageFragmentDoc}
${UseInterviewPlanHasInterviewHiddenFromCandidate_InterviewPlanFragmentDoc}`;
export const MockScheduleTaskDetails_TaskFragmentDoc = gql`
    fragment MockScheduleTaskDetails_task on Task {
  id
}
    `;
export const CandidateAvailabilityStatus_ApplicationFragmentDoc = gql`
    fragment CandidateAvailabilityStatus_application on Application {
  id
  status
}
    `;
export const BaseCandidateAvailabilitySection_ApplicationFragmentDoc = gql`
    fragment BaseCandidateAvailabilitySection_application on Application {
  id
  status
  ...CandidateAvailabilityStatus_application
}
    ${CandidateAvailabilityStatus_ApplicationFragmentDoc}`;
export const Availability_ApplicationFragmentDoc = gql`
    fragment Availability_application on Application {
  id
  jobStage {
    id
    job {
      id
    }
  }
  ...BaseCandidateAvailabilitySection_application
}
    ${BaseCandidateAvailabilitySection_ApplicationFragmentDoc}`;
export const CandidateAvailabilityFragmentFragmentDoc = gql`
    fragment CandidateAvailabilityFragment on CandidateAvailability {
  id
  createdAt
  updatedAt
  candidateEnteredAvailability {
    startAt
    endAt
  }
  rcEnteredAvailability {
    startAt
    endAt
  }
  lastUpdatedByEmployeeId
  lastUpdatedByEmployee {
    id
    fullName
  }
  employeeUpdatedAt
  candidateUpdatedAt
}
    `;
export const CandidateAvailability_AvailabilityFragmentDoc = gql`
    fragment CandidateAvailability_availability on CandidateAvailability {
  id
  rcEnteredAvailability {
    startAt
    endAt
  }
  candidateEnteredAvailability {
    startAt
    endAt
  }
  updatedAt
}
    `;
export const EditCandidateAvailabilityModal_AvailabilityFragmentDoc = gql`
    fragment EditCandidateAvailabilityModal_availability on CandidateAvailability {
  id
  candidateEnteredAvailability {
    startAt
    endAt
  }
  rcEnteredAvailability {
    startAt
    endAt
  }
  lastUpdatedByEmployee {
    id
    fullName
  }
}
    `;
export const BaseCandidateAvailabilitySection_AvailabilityFragmentDoc = gql`
    fragment BaseCandidateAvailabilitySection_availability on CandidateAvailability {
  id
  lastUpdatedByEmployee {
    id
    fullName
  }
  candidateUpdatedAt
  ...CandidateAvailability_availability
  ...EditCandidateAvailabilityModal_availability
}
    ${CandidateAvailability_AvailabilityFragmentDoc}
${EditCandidateAvailabilityModal_AvailabilityFragmentDoc}`;
export const Availability_AvailabilityFragmentDoc = gql`
    fragment Availability_availability on CandidateAvailability {
  ...CandidateAvailabilityFragment
  ...BaseCandidateAvailabilitySection_availability
}
    ${CandidateAvailabilityFragmentFragmentDoc}
${BaseCandidateAvailabilitySection_AvailabilityFragmentDoc}`;
export const RecjectetCandidateAvailabilitySectionAlert_AvailabilityRequestFragmentDoc = gql`
    fragment RecjectetCandidateAvailabilitySectionAlert_availabilityRequest on CandidateAvailabilityOptions {
  id
  updatedAt
  lastCandidateCommunicationSentAt
  creator {
    fullName
  }
}
    `;
export const CandidateAvailabilityStatus_AvailabilityRequestFragmentDoc = gql`
    fragment CandidateAvailabilityStatus_availabilityRequest on CandidateAvailabilityOptions {
  ...RecjectetCandidateAvailabilitySectionAlert_availabilityRequest
}
    ${RecjectetCandidateAvailabilitySectionAlert_AvailabilityRequestFragmentDoc}`;
export const CandidateAvailability_AvailabilityRequestFragmentDoc = gql`
    fragment CandidateAvailability_availabilityRequest on CandidateAvailabilityOptions {
  id
  timezone
  lastCandidateCommunicationSentAt
}
    `;
export const BaseCandidateAvailabilitySection_AvailabilityRequestFragmentDoc = gql`
    fragment BaseCandidateAvailabilitySection_availabilityRequest on CandidateAvailabilityOptions {
  id
  createdAt
  updatedAt
  timezone
  externalId
  creator {
    id
    fullName
  }
  lastCandidateCommunicationSentAt
  ...CandidateAvailabilityStatus_availabilityRequest
  ...CandidateAvailability_availabilityRequest
}
    ${CandidateAvailabilityStatus_AvailabilityRequestFragmentDoc}
${CandidateAvailability_AvailabilityRequestFragmentDoc}`;
export const Availability_AvailabilityRequestFragmentDoc = gql`
    fragment Availability_availabilityRequest on CandidateAvailabilityOptions {
  id
  applicationId
  availabilityEndDate
  availabilityStartDate
  candidateNote
  externalId
  createdAt
  jobStageId
  minimumTimeBlockMinutes
  minutesPerDays
  numberOfDays
  timezone
  updatedAt
  lastCandidateCommunicationSentAt
  advanceNoticeMinutes
  creator {
    fullName
  }
  shouldRespectLoadLimit
  bookIfPerfectScheduleFound
  suggestOverRecruitingKeywords
  suggestOverAvailableKeywords
  suggestOverFreeTime
  rollingDays
  inclusionDays
  ...BaseCandidateAvailabilitySection_availabilityRequest
}
    ${BaseCandidateAvailabilitySection_AvailabilityRequestFragmentDoc}`;
export const Availability_CandidateFragmentDoc = gql`
    fragment Availability_candidate on Candidate {
  id
  timezone
  atsType
}
    `;
export const GetBasicAvailabilityOptionsConfigV2_SettingsFragmentDoc = gql`
    fragment getBasicAvailabilityOptionsConfigV2_settings on JobStageCandidateAvailabilitySettingsV2 {
  numberOfDays {
    value
  }
  minutesPerDays {
    value
  }
  minimumTimeBlockMinutes {
    value
  }
}
    `;
export const GetProvideAvailabilitySettings_JobStageSettingsV2FragmentDoc = gql`
    fragment getProvideAvailabilitySettings_JobStageSettingsV2 on JobStageSettingsV2 {
  id
  candidateAvailabilitySettingsV2 {
    ...getBasicAvailabilityOptionsConfigV2_settings
  }
}
    ${GetBasicAvailabilityOptionsConfigV2_SettingsFragmentDoc}`;
export const TemplateOption_TemplateFragmentDoc = gql`
    fragment TemplateOption_Template on Template {
  id
  type
  name
  subject
  body
}
    `;
export const TemplateSelectRow_TemplateFragmentDoc = gql`
    fragment TemplateSelectRow_template on Template {
  id
  name
  ...TemplateOption_Template
}
    ${TemplateOption_TemplateFragmentDoc}`;
export const CandidateAvailabilityEmailPreview_JobStageSettingsV2FragmentDoc = gql`
    fragment CandidateAvailabilityEmailPreview_jobStageSettingsV2 on JobStageSettingsV2 {
  id
  availabilityRequestEmailTemplateId {
    templateId
    template {
      id
      ...TemplateSelectRow_template
    }
  }
  candidateAvailabilitySettingsV2 {
    bookIfPerfectScheduleFound {
      value
    }
  }
}
    ${TemplateSelectRow_TemplateFragmentDoc}`;
export const CandidateAvailabilityOptionsModal_JobStageSettingsV2FragmentDoc = gql`
    fragment CandidateAvailabilityOptionsModal_jobStageSettingsV2 on JobStageSettingsV2 {
  id
  ...CandidateAvailabilityEmailPreview_jobStageSettingsV2
  availabilityRequestEmailTemplateId {
    templateId
  }
  candidateAvailabilitySettingsV2 {
    ...getBasicAvailabilityOptionsConfigV2_settings
    numberOfDays {
      value
    }
    minutesPerDays {
      value
    }
    minimumTimeBlockMinutes {
      value
    }
    advanceNotice {
      duration {
        seconds
      }
    }
    candidateNote {
      value
    }
    ccRecipients {
      notificationPreference {
        employeeIds
        dynamicAudiences
        externalEmailAddresses
      }
    }
    bccRecipients {
      notificationPreference {
        employeeIds
        dynamicAudiences
        externalEmailAddresses
      }
    }
    shouldRespectLoadLimit {
      value
    }
    bookIfPerfectScheduleFound {
      value
    }
    canScheduleOverRecruitingKeywords {
      value
    }
    canScheduleOverAvailableKeywords {
      value
    }
    canScheduleOverFreeTime {
      value
    }
    useRollingDays {
      value
    }
    timeframe {
      duration {
        seconds
      }
    }
  }
}
    ${CandidateAvailabilityEmailPreview_JobStageSettingsV2FragmentDoc}
${GetBasicAvailabilityOptionsConfigV2_SettingsFragmentDoc}`;
export const CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2FragmentDoc = gql`
    fragment CandidateAvailabilityOptionsModalWrapper_jobStageSettingsV2 on JobStageSettingsV2 {
  id
  ...CandidateAvailabilityOptionsModal_jobStageSettingsV2
}
    ${CandidateAvailabilityOptionsModal_JobStageSettingsV2FragmentDoc}`;
export const BaseCandidateAvailabilitySection_JobStageSettingsV2FragmentDoc = gql`
    fragment BaseCandidateAvailabilitySection_JobStageSettingsV2 on JobStageSettingsV2 {
  ...CandidateAvailabilityOptionsModalWrapper_jobStageSettingsV2
}
    ${CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2FragmentDoc}`;
export const Availability_JobStageFragmentDoc = gql`
    fragment Availability_jobStage on JobStage {
  id
  name
  jobStageSettingsV2 {
    ...getProvideAvailabilitySettings_JobStageSettingsV2
    ...BaseCandidateAvailabilitySection_JobStageSettingsV2
  }
}
    ${GetProvideAvailabilitySettings_JobStageSettingsV2FragmentDoc}
${BaseCandidateAvailabilitySection_JobStageSettingsV2FragmentDoc}`;
export const GetProvideAvailabilitySettings_JobStageFragmentDoc = gql`
    fragment getProvideAvailabilitySettings_JobStage on JobStage {
  id
  ...cloneInterviewPlan_interviewPlan
  ...getSaveInterviewPlanInput_interviewPlan
}
    ${CloneInterviewPlan_InterviewPlanFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}`;
export const Availability_InterviewPlanFragmentDoc = gql`
    fragment Availability_interviewPlan on JobStage {
  id
  ...getProvideAvailabilitySettings_JobStage
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      interviewType
      duration
    }
  }
}
    ${GetProvideAvailabilitySettings_JobStageFragmentDoc}`;
export const Availability_ScheduleFragmentDoc = gql`
    fragment Availability_schedule on ApplicationStage {
  id
  createdAt
}
    `;
export const Debrief_DebriefRequirementsFragmentDoc = gql`
    fragment Debrief_debriefRequirements on Task {
  id
  isDebriefRequired
  application {
    id
  }
  debriefs {
    id
    createdAt
    ...DebriefContentEntity_debrief
  }
}
    ${DebriefContentEntity_DebriefFragmentDoc}`;
export const RescheduleLogModal_RescheduleLogFragmentDoc = gql`
    fragment RescheduleLogModal_rescheduleLog on RescheduleLog {
  id
  note
  rescheduledAt
  createdAt
  updatedAt
  lastUpdatedBy {
    id
    fullName
  }
  rescheduleReasonId
  rescheduleReason {
    reason
  }
  performedBy {
    id
    fullName
  }
}
    `;
export const RescheduleLogsList_RescheduleLogsFragmentDoc = gql`
    fragment RescheduleLogsList_rescheduleLogs on RescheduleLog {
  id
  ...RescheduleLogModal_rescheduleLog
}
    ${RescheduleLogModal_RescheduleLogFragmentDoc}`;
export const Schedule_ApplicationFragmentDoc = gql`
    fragment Schedule_application on Application {
  id
  status
  atsType
  atsApplication {
    atsId
    atsFields {
      ... on WorkdayApplication {
        currentStepName
        __typename
      }
      __typename
    }
  }
  job {
    id
  }
  ...ScheduleContent_application
  ...useApplicationJobStageSchedulable_application
}
    ${ScheduleContent_ApplicationFragmentDoc}
${UseApplicationJobStageSchedulable_ApplicationFragmentDoc}`;
export const Schedule_CandidateFragmentDoc = gql`
    fragment Schedule_candidate on Candidate {
  id
}
    `;
export const UseGetInterviewNames_InterviewsFragmentDoc = gql`
    fragment useGetInterviewNames_interviews on JobStageInterview {
  id
  name
  interviewType
}
    `;
export const Schedule_InterviewPlanFragmentDoc = gql`
    fragment Schedule_interviewPlan on JobStage {
  id
  ...InterviewPlan_jobStage
  ...getSaveInterviewPlanInput_interviewPlan
  ...useIsInterviewPlanValid_jobStage
  job {
    id
    ...InterviewPlan_job
  }
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      ...useGetInterviewNames_interviews
    }
  }
}
    ${InterviewPlan_JobStageFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}
${UseIsInterviewPlanValid_JobStageFragmentDoc}
${InterviewPlan_JobFragmentDoc}
${UseGetInterviewNames_InterviewsFragmentDoc}`;
export const SelfScheduleEmail_JobStageSettingsV2FragmentDoc = gql`
    fragment SelfScheduleEmail_jobStageSettingsV2 on JobStageSettingsV2 {
  id
  selfScheduleRequestEmailTemplateId {
    templateId
    template {
      id
      ...TemplateSelectRow_template
    }
  }
}
    ${TemplateSelectRow_TemplateFragmentDoc}`;
export const SelfScheduleInterviewMeetingLocation_InterviewMeetingLocationFragmentDoc = gql`
    fragment SelfScheduleInterviewMeetingLocation_interviewMeetingLocation on InterviewMeetingLocationSettingPref {
  interviewMeetingLocationType
  videoMeetingLinkScope
  dynamicHost
  hostEmployeeId
  remoteVideoMeetingHostUserId
  customLocation
  ...VideoMeetingHost_interviewMeetingLocationSettingPref
}
    ${VideoMeetingHost_InterviewMeetingLocationSettingPrefFragmentDoc}`;
export const SelfSchedulePreferences_InterviewMeetingLocationFragmentDoc = gql`
    fragment SelfSchedulePreferences_interviewMeetingLocation on InterviewMeetingLocationSettingPref {
  ...SelfScheduleInterviewMeetingLocation_interviewMeetingLocation
}
    ${SelfScheduleInterviewMeetingLocation_InterviewMeetingLocationFragmentDoc}`;
export const ConfigurableSelfScheduleOptions_InterviewMeetingLocationFragmentDoc = gql`
    fragment ConfigurableSelfScheduleOptions_interviewMeetingLocation on InterviewMeetingLocationSettingPref {
  ...SelfSchedulePreferences_interviewMeetingLocation
}
    ${SelfSchedulePreferences_InterviewMeetingLocationFragmentDoc}`;
export const SelfScheduleOptions_InterviewMeetingLocationFragmentDoc = gql`
    fragment SelfScheduleOptions_interviewMeetingLocation on InterviewMeetingLocationSettingPref {
  ...ConfigurableSelfScheduleOptions_interviewMeetingLocation
}
    ${ConfigurableSelfScheduleOptions_InterviewMeetingLocationFragmentDoc}`;
export const SelfScheduleOptionsModal_JobStageSettingsV2FragmentDoc = gql`
    fragment SelfScheduleOptionsModal_jobStageSettingsV2 on JobStageSettingsV2 {
  id
  ...SelfScheduleEmail_jobStageSettingsV2
  candidateCalendarId {
    remoteCalendarId
  }
  interviewerCalendarId {
    remoteCalendarId
  }
  isPrivateCalendarEvent {
    value
  }
  candidateEventTemplateId {
    templateId
  }
  shouldSendEmailToCandidate {
    value
  }
  candidateEmailTemplateId {
    templateId
  }
  interviewerCalendarId {
    remoteCalendarId
  }
  interviewerEventTemplateId {
    templateId
  }
  interviewMeetingLocationSettingWithLevel {
    interviewMeetingLocationSetting {
      ...SelfScheduleOptions_interviewMeetingLocation
    }
  }
  isPrivateCalendarEvent {
    value
  }
  selfScheduleSettingsV2 {
    timeframe {
      duration {
        seconds
      }
    }
    advanceNotice {
      duration {
        seconds
      }
    }
    shouldRespectLoadLimit {
      value
    }
    canScheduleOverRecruitingKeywords {
      value
    }
    canScheduleOverAvailableKeywords {
      value
    }
    canScheduleOverFreeTime {
      value
    }
    candidateNote {
      value
    }
    ccRecipients {
      notificationPreference {
        dynamicAudiences
        employeeIds
        externalEmailAddresses
      }
    }
    bccRecipients {
      notificationPreference {
        dynamicAudiences
        employeeIds
        externalEmailAddresses
      }
    }
    useRollingDays {
      value
    }
  }
  candidateEventAdditionalAttendees {
    notificationPreference {
      dynamicAudiences
      employeeIds
      externalEmailAddresses
    }
  }
  interviewerEventAdditionalAttendees {
    notificationPreference {
      dynamicAudiences
      employeeIds
      externalEmailAddresses
    }
  }
}
    ${SelfScheduleEmail_JobStageSettingsV2FragmentDoc}
${SelfScheduleOptions_InterviewMeetingLocationFragmentDoc}`;
export const SelfScheduleOptionsModalWrapper_JobStageSettingsV2FragmentDoc = gql`
    fragment SelfScheduleOptionsModalWrapper_jobStageSettingsV2 on JobStageSettingsV2 {
  ...SelfScheduleOptionsModal_jobStageSettingsV2
}
    ${SelfScheduleOptionsModal_JobStageSettingsV2FragmentDoc}`;
export const SelfScheduleOptionsModal_InterviewMeetingLocationFragmentDoc = gql`
    fragment SelfScheduleOptionsModal_interviewMeetingLocation on InterviewMeetingLocationSettingPref {
  ...SelfScheduleOptions_interviewMeetingLocation
}
    ${SelfScheduleOptions_InterviewMeetingLocationFragmentDoc}`;
export const SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragmentDoc = gql`
    fragment SelfScheduleOptionsModalWrapper_interviewMeetingLocation on InterviewMeetingLocationSettingPref {
  ...SelfScheduleOptionsModal_interviewMeetingLocation
}
    ${SelfScheduleOptionsModal_InterviewMeetingLocationFragmentDoc}`;
export const SelfSchedule_JobStageSettingsFragmentDoc = gql`
    fragment SelfSchedule_jobStageSettings on JobStageSettingsV2 {
  id
  ...SelfScheduleOptionsModalWrapper_jobStageSettingsV2
  interviewMeetingLocationSettingWithLevel {
    interviewMeetingLocationSetting {
      ...SelfScheduleOptionsModalWrapper_interviewMeetingLocation
    }
  }
}
    ${SelfScheduleOptionsModalWrapper_JobStageSettingsV2FragmentDoc}
${SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragmentDoc}`;
export const Schedule_JobStageFragmentDoc = gql`
    fragment Schedule_jobStage on JobStage {
  id
  jobStageSettingsV2 {
    ...SelfScheduleOptionsModalWrapper_jobStageSettingsV2
    ...SelfSchedule_jobStageSettings
    interviewMeetingLocationSettingWithLevel {
      interviewMeetingLocationSetting {
        ...SelfScheduleOptionsModalWrapper_interviewMeetingLocation
      }
    }
  }
}
    ${SelfScheduleOptionsModalWrapper_JobStageSettingsV2FragmentDoc}
${SelfSchedule_JobStageSettingsFragmentDoc}
${SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragmentDoc}`;
export const SelfScheduleOptions_OptionsFragmentDoc = gql`
    fragment SelfScheduleOptions_options on Options {
  inclusionDays
  rollingDays
  advanceNoticeInHours
  candidateCalendarId
  interviewerCalendarId
  location
  zoomHost
  zoomHostUserId
  candidateEmail
  shouldRespectLoadLimit
  canScheduleOverRecruitingKeywords
  canScheduleOverAvailableKeywords
  canScheduleOverFreeTime
  meetingHost
  videoMeetingHostEmployeeId
  note
  candidateEventAdditionalAttendees {
    employeeIds
    externalEmailAddresses
    dynamicAudiences
  }
  interviewerEventAdditionalAttendees {
    employeeIds
    externalEmailAddresses
    dynamicAudiences
  }
}
    `;
export const SelfScheduleOptionsModal_SelfScheduleFragmentDoc = gql`
    fragment SelfScheduleOptionsModal_selfSchedule on SelfScheduleOptions {
  id
  taskId
  createdAt
  creatorEmployeeId
  deletedAt
  jobStageId
  candidateEmailTemplateId
  candidateEventTemplateId
  interviewerEventTemplateId
  lastUpdatedByEmployeeId
  options {
    ...SelfScheduleOptions_options
  }
  rescheduledAt
  selfScheduleEmailTemplateId
  selfScheduleEmailSentAt
  updatedAt
  interviewMeetingLocationSetting {
    ...SelfScheduleOptions_interviewMeetingLocation
  }
}
    ${SelfScheduleOptions_OptionsFragmentDoc}
${SelfScheduleOptions_InterviewMeetingLocationFragmentDoc}`;
export const SelfScheduleOptionsModalWrapper_SelfScheduleFragmentDoc = gql`
    fragment SelfScheduleOptionsModalWrapper_selfSchedule on SelfScheduleOptions {
  ...SelfScheduleOptionsModal_selfSchedule
}
    ${SelfScheduleOptionsModal_SelfScheduleFragmentDoc}`;
export const Schedule_SelfScheduleRequestFragmentDoc = gql`
    fragment Schedule_selfScheduleRequest on SelfScheduleOptions {
  ...SelfScheduleOptionsModalWrapper_selfSchedule
  interviewMeetingLocationSetting {
    ...SelfScheduleOptionsModalWrapper_interviewMeetingLocation
  }
}
    ${SelfScheduleOptionsModalWrapper_SelfScheduleFragmentDoc}
${SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragmentDoc}`;
export const Schedule_ScheduleFragmentDoc = gql`
    fragment Schedule_schedule on ApplicationStage {
  ...ScheduleContent_schedule
}
    ${ScheduleContent_ScheduleFragmentDoc}`;
export const TaskTagsBase_TaskTagFragmentDoc = gql`
    fragment TaskTagsBase_taskTag on TaskTag {
  id
  name
}
    `;
export const TaskTags_SelectedTaskTagFragmentDoc = gql`
    fragment TaskTags_selectedTaskTag on TaskTag {
  ...TaskTagsBase_taskTag
}
    ${TaskTagsBase_TaskTagFragmentDoc}`;
export const ScheduleTaskFlags_TaskFlagFragmentDoc = gql`
    fragment ScheduleTaskFlags_taskFlag on TaskFlag {
  __typename
  id
  createdAt
  flagType
  actorType
  actorEmployee {
    ...Employee
  }
  resolvedAt
  resolvedBy {
    ...Employee
  }
  ... on TaskFlagCandidateDeclined {
    declinedCandidateEvent {
      id
      name
    }
  }
  ... on TaskFlagInterviewerDeclined {
    declinedInterview {
      id
      name
    }
  }
  ... on TaskFlagRequestedChange {
    note
  }
  ... on TaskFlagInterviewerDebriefDeclined {
    declinedDebrief {
      id
      name
    }
  }
  ... on TaskFlagInterviewerDeactivated {
    deactivatedInterview {
      id
      name
    }
  }
  ... on TaskFlagInterviewerTentative {
    tentativeInterview {
      id
      name
    }
  }
  ... on TaskFlagDebriefAttendeeTentative {
    tentativeDebrief {
      id
      name
    }
  }
  ... on TaskFlagDebriefAttendeeDeactivated {
    deactivatedDebrief {
      id
      name
    }
  }
  ... on TaskFlagCandidateTentative {
    tentativeCandidateEvent {
      id
      name
    }
  }
}
    ${EmployeeFragmentDoc}`;
export const ScheduleTaskAssignee_TaskFragmentDoc = gql`
    fragment ScheduleTaskAssignee_task on Task {
  id
  assignee {
    id
    fullName
    internalProfilePictureUrl
  }
}
    `;
export const ScheduleTaskStatusSubText_TaskFragmentDoc = gql`
    fragment ScheduleTaskStatusSubText_task on Task {
  id
  status
  availabilityRequests {
    id
    createdAt
  }
  selfScheduleRequests {
    id
    createdAt
    creatorEmployeeId
  }
}
    `;
export const ApplicationConflict_TaskFragmentDoc = gql`
    fragment ApplicationConflict_task on Task {
  id
  jobStage {
    id
    job {
      id
      name
    }
  }
  application {
    id
    jobStage {
      id
      job {
        id
        name
      }
    }
  }
}
    `;
export const ScheduleTaskDetails_TaskFragmentDoc = gql`
    fragment ScheduleTaskDetails_task on Task {
  id
  delegateType
  delegateStatus
  isUrgent
  name
  status
  application {
    id
    job {
      id
      name
      jobSettings {
        id
        defaultTaskQueue {
          id
        }
      }
    }
    status
    candidate {
      id
      fullName
      ...Candidate_candidate
    }
  }
  taskQueue {
    id
  }
  createdBy {
    ...Employee
  }
  createdAt
  jobStage {
    id
    name
    job {
      id
      name
      location
      atsJob {
        atsCustomerFriendlyId
      }
    }
  }
  tags {
    ...TaskTags_selectedTaskTag
  }
  flags {
    ...ScheduleTaskFlags_taskFlag
  }
  ...TaskName_task
  ...ScheduleTaskAssignee_task
  ...ScheduleTaskStatusSubText_task
  ...ApplicationConflict_task
}
    ${Candidate_CandidateFragmentDoc}
${EmployeeFragmentDoc}
${TaskTags_SelectedTaskTagFragmentDoc}
${ScheduleTaskFlags_TaskFlagFragmentDoc}
${TaskName_TaskFragmentDoc}
${ScheduleTaskAssignee_TaskFragmentDoc}
${ScheduleTaskStatusSubText_TaskFragmentDoc}
${ApplicationConflict_TaskFragmentDoc}`;
export const CandidateAvailabilitySidebarSection_TaskFragmentDoc = gql`
    fragment CandidateAvailabilitySidebarSection_task on Task {
  availabilities {
    candidateEnteredAvailability {
      startAt
      endAt
    }
  }
  application {
    candidate {
      timezone
    }
  }
}
    `;
export const ScheduleTask_TaskFragmentDoc = gql`
    fragment ScheduleTask_task on Task {
  status
  delegateType
  delegateStatus
  application {
    id
  }
  ...ScheduleTaskDetails_task
  ...CandidateAvailabilitySidebarSection_task
}
    ${ScheduleTaskDetails_TaskFragmentDoc}
${CandidateAvailabilitySidebarSection_TaskFragmentDoc}`;
export const ScheduleDateCell_SchedulesFragmentDoc = gql`
    fragment ScheduleDateCell_schedules on ApplicationStage {
  id
  createdAt
  startAt
  endAt
}
    `;
export const ScheduleTaskDashboardTaskFlags_TaskFlagsFragmentDoc = gql`
    fragment ScheduleTaskDashboardTaskFlags_taskFlags on TaskFlag {
  id
  resolvedAt
  ...ScheduleTaskFlagCompact_taskFlag
}
    ${ScheduleTaskFlagCompact_TaskFlagFragmentDoc}`;
export const ScheduleTaskDashboardTaskTags_TaskTagsFragmentDoc = gql`
    fragment ScheduleTaskDashboardTaskTags_taskTags on TaskTag {
  id
  ...ScheduleTaskTagCompact_taskTag
}
    ${ScheduleTaskTagCompact_TaskTagFragmentDoc}`;
export const TaskDashboardTableRowItem_TaskFragmentDoc = gql`
    fragment TaskDashboardTableRowItem_task on Task {
  id
  status
  isUrgent
  createdAt
  lastActivityAt
  candidateAvailabilityStartAt
  scheduleCreatedAt
  firstInterviewAt
  application {
    id
    status
    job {
      id
      name
    }
    candidate {
      id
      fullName
      ...Candidate_candidate
    }
  }
  jobStage {
    id
    name
    job {
      id
      name
    }
  }
  taskQueue {
    id
    name
  }
  createdBy {
    id
    internalProfilePictureUrl
    fullName
  }
  schedules {
    id
    ...ScheduleDateCell_schedules
  }
  flags {
    id
    ...ScheduleTaskDashboardTaskFlags_taskFlags
  }
  tags {
    id
    ...ScheduleTaskDashboardTaskTags_taskTags
  }
  ...ScheduleTaskAssignee_task
}
    ${Candidate_CandidateFragmentDoc}
${ScheduleDateCell_SchedulesFragmentDoc}
${ScheduleTaskDashboardTaskFlags_TaskFlagsFragmentDoc}
${ScheduleTaskDashboardTaskTags_TaskTagsFragmentDoc}
${ScheduleTaskAssignee_TaskFragmentDoc}`;
export const TaskDashboardTable_TaskFragmentDoc = gql`
    fragment TaskDashboardTable_task on Task {
  id
  ...TaskDashboardTableRowItem_task
}
    ${TaskDashboardTableRowItem_TaskFragmentDoc}`;
export const MemberPreferredEmployeeList_EmployeeFragmentDoc = gql`
    fragment MemberPreferredEmployeeList_employee on Employee {
  id
  email
  fullName
  internalProfilePictureUrl
  isArchived
  isDirectoryDisabled
  isAtsDisabled
  orgUser {
    role
  }
}
    `;
export const QueueFilter_SelectedOptionsFragmentDoc = gql`
    fragment QueueFilter_selectedOptions on TaskQueue {
  id
  name
  memberCount
}
    `;
export const ScheduleTaskDashboardFiltersEmployeePrefFragmentDoc = gql`
    fragment ScheduleTaskDashboardFiltersEmployeePref on EmployeeTaskDashboardFilterPref {
  isUrgent
  assigneeEmployeeIds
  showUnassigned
  creatorEmployeeIds
  applicationStatuses
  taskStatuses
  jobIds
  jobStageNames
  flags
  taskQueueIds
  showNoQueue
  showCompletedInFlagged
  delegateTypes
  tags {
    id
    name
  }
}
    `;
export const UseInterviewPlanDescription_JobStageFragmentDoc = gql`
    fragment useInterviewPlanDescription_jobStage on JobStage {
  id
  jobStageInterviewGroups {
    id
    jobStageInterviews {
      id
      interviewType
      duration
      atsInterviewDefinition {
        atsId
        atsFields {
          ... on GreenhouseInterviewDefinition {
            estimatedMinutes
          }
        }
      }
      jobStageInterviewSeats {
        id
        type
        linkedSeat {
          linkedJobStageInterviewSeatId
        }
      }
    }
  }
}
    `;
export const SelfScheduleOptions_InterviewPlanFragmentDoc = gql`
    fragment SelfScheduleOptions_interviewPlan on JobStage {
  id
  ...useInterviewPlanDescription_jobStage
}
    ${UseInterviewPlanDescription_JobStageFragmentDoc}`;
export const SelfSchedulePreferences_CandidateEventAdditionalAttendeesFragmentDoc = gql`
    fragment SelfSchedulePreferences_candidateEventAdditionalAttendees on CandidateEventAdditionalAttendeesPref {
  candidateEventAdditionalAttendees {
    employeeIds
    dynamicAudiences
    externalEmailAddresses
  }
}
    `;
export const SelfSchedulePreferences_InterviewerEventAdditionalAttendeesFragmentDoc = gql`
    fragment SelfSchedulePreferences_interviewerEventAdditionalAttendees on InterviewerEventAdditionalAttendeesPref {
  interviewerEventAdditionalAttendees {
    employeeIds
    dynamicAudiences
    externalEmailAddresses
  }
}
    `;
export const BrandingThemeInputsPanel_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemeInputsPanel_brandingTheme on BrandingTheme {
  id
  profileImageUrl
  coverImageUrl
  faviconImageUrl
  font
  themeMode
  primaryColor
}
    `;
export const BrandingThemePreviewContent_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemePreviewContent_brandingTheme on BrandingTheme {
  coverImageUrl
  profileImageUrl
}
    `;
export const BrandingThemePreviewWrapper_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemePreviewWrapper_brandingTheme on BrandingTheme {
  id
  themeMode
  font
  primaryColor
  ...BrandingThemePreviewContent_brandingTheme
}
    ${BrandingThemePreviewContent_BrandingThemeFragmentDoc}`;
export const BrandingThemeBuilderComponent_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemeBuilderComponent_brandingTheme on BrandingTheme {
  id
  name
  isOrgDefault
  livePortals
  ...BrandingThemeInputsPanel_brandingTheme
  ...BrandingThemePreviewWrapper_brandingTheme
}
    ${BrandingThemeInputsPanel_BrandingThemeFragmentDoc}
${BrandingThemePreviewWrapper_BrandingThemeFragmentDoc}`;
export const BrandingThemeBuilder_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemeBuilder_brandingTheme on BrandingTheme {
  ...BrandingThemeBuilderComponent_brandingTheme
}
    ${BrandingThemeBuilderComponent_BrandingThemeFragmentDoc}`;
export const BrandingThemesItem_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemesItem_brandingTheme on BrandingTheme {
  ...BrandingThemePlaceholderPreview_brandingTheme
  id
  orgId
  name
  profileImageUrl
  coverImageUrl
  isOrgDefault
  createdAt
  updatedAt
  livePortals
}
    ${BrandingThemePlaceholderPreview_BrandingThemeFragmentDoc}`;
export const BrandingThemeItemDescription_BrandingThemeFragmentDoc = gql`
    fragment BrandingThemeItemDescription_brandingTheme on BrandingTheme {
  id
  name
  isOrgDefault
  livePortals
}
    `;
export const TextBlock_BlockFragmentDoc = gql`
    fragment TextBlock_block on PortalTemplateBlockText {
  id
  index
  type
  content
}
    `;
export const ImageBlock_BlockFragmentDoc = gql`
    fragment ImageBlock_block on PortalTemplateBlockImage {
  id
  type
  index
  url
  header
  caption
  fillPage
}
    `;
export const VideoBlock_BlockFragmentDoc = gql`
    fragment VideoBlock_block on PortalTemplateBlockVideo {
  id
  type
  url
  index
  caption
  header
}
    `;
export const ContentCardBlock_BlockFragmentDoc = gql`
    fragment ContentCardBlock_block on PortalTemplateBlockContentCard {
  id
  type
  index
  header
  cards {
    header
    body
  }
}
    `;
export const LinkedCardBlock_BlockFragmentDoc = gql`
    fragment LinkedCardBlock_block on PortalTemplateBlockLinkedCard {
  id
  type
  index
  header
  cards {
    url
    header
    body
    previewImageUrl
  }
}
    `;
export const DividerBlock_BlockFragmentDoc = gql`
    fragment DividerBlock_block on PortalTemplateBlockDivider {
  id
  index
  type
}
    `;
export const BlockPreview_BlockFragmentDoc = gql`
    fragment BlockPreview_block on PortalTemplateBlock {
  id
  type
  index
  ... on PortalTemplateBlockText {
    id
    ...TextBlock_block
  }
  ... on PortalTemplateBlockImage {
    id
    ...ImageBlock_block
  }
  ... on PortalTemplateBlockVideo {
    id
    ...VideoBlock_block
  }
  ... on PortalTemplateBlockContentCard {
    id
    ...ContentCardBlock_block
  }
  ... on PortalTemplateBlockLinkedCard {
    id
    ...LinkedCardBlock_block
  }
  ... on PortalTemplateBlockDivider {
    id
    ...DividerBlock_block
  }
}
    ${TextBlock_BlockFragmentDoc}
${ImageBlock_BlockFragmentDoc}
${VideoBlock_BlockFragmentDoc}
${ContentCardBlock_BlockFragmentDoc}
${LinkedCardBlock_BlockFragmentDoc}
${DividerBlock_BlockFragmentDoc}`;
export const TemplatePreview_PortalTemplateFragmentDoc = gql`
    fragment TemplatePreview_portalTemplate on PortalTemplate {
  id
  name
  orgId
  updatedAt
  blocks {
    id
    index
    type
    ...BlockPreview_block
  }
}
    ${BlockPreview_BlockFragmentDoc}`;
export const PageTemplateRow_TemplateFragmentDoc = gql`
    fragment PageTemplateRow_template on PortalTemplate {
  id
  name
  orgId
  livePortals @include(if: $includeLivePortals)
  updatedAt
}
    `;
export const PortalConfigBuilder_PortalConfigFragmentDoc = gql`
    fragment PortalConfigBuilder_portalConfig on PortalConfig {
  id
  name
  isDefault
  brandingThemeId
  intro
  aiAssistantId
  tabs {
    id
    name
    icon
    visibility
    index
    portalTemplateId
    stageNameFilter
  }
}
    `;
export const PortalConfigDeleteDialog_PortalConfigFragmentDoc = gql`
    fragment PortalConfigDeleteDialog_portalConfig on PortalConfig {
  id
  name
  linkedJobs {
    id
  }
}
    `;
export const PortalConfigUsageDialog_PortalConfigFragmentDoc = gql`
    fragment PortalConfigUsageDialog_portalConfig on PortalConfig {
  id
  name
  linkedJobs {
    id
    externalJobName
    location
    departments
  }
}
    `;
export const PortalConfigsListItemFragmentDoc = gql`
    fragment PortalConfigsListItem on PortalConfig {
  id
  name
  isDefault
  intro
  brandingThemeId
  tabs {
    id
  }
  linkedJobs {
    id
    externalJobName
    location
    departments
  }
  ...PortalConfigBuilder_portalConfig
  ...PortalConfigDeleteDialog_portalConfig
  ...PortalConfigUsageDialog_portalConfig
}
    ${PortalConfigBuilder_PortalConfigFragmentDoc}
${PortalConfigDeleteDialog_PortalConfigFragmentDoc}
${PortalConfigUsageDialog_PortalConfigFragmentDoc}`;
export const PortalConfigsListFragmentDoc = gql`
    fragment PortalConfigsList on PortalConfigsResult {
  items {
    id
    ...PortalConfigsListItem
  }
}
    ${PortalConfigsListItemFragmentDoc}`;
export const QuestionSetupDialog_CandidatePulseTagsFragmentDoc = gql`
    fragment QuestionSetupDialog_candidatePulseTags on CandidatePulseTag {
  id
  archivedAt
  emoji
  name
  tagType
  index
  translationStatus {
    isComplete
    missingLocales
  }
  translations {
    locale
    name
  }
}
    `;
export const AttributeValueDeleteDialog_AttributeValueFragmentDoc = gql`
    fragment AttributeValueDeleteDialog_attributeValue on EmployeeAttributeTagValue {
  id
  value
  name {
    id
    name
  }
}
    `;
export const AttributeValueEmployees_EmployeesFragmentDoc = gql`
    fragment AttributeValueEmployees_employees on Employee {
  id
  fullName
  internalProfilePictureUrl
}
    `;
export const AttributeValueDetailsDialog_AttributeValueFragmentDoc = gql`
    fragment AttributeValueDetailsDialog_attributeValue on EmployeeAttributeTagValue {
  id
  value
  name {
    id
    name
    syncSourceType
  }
  employees {
    id
    ...AttributeValueEmployees_employees
  }
}
    ${AttributeValueEmployees_EmployeesFragmentDoc}`;
export const AttributeValue_AttributeValueFragmentDoc = gql`
    fragment AttributeValue_attributeValue on EmployeeAttributeTagValue {
  id
  value
  name {
    id
    syncSourceType
  }
  ...AttributeValueDeleteDialog_attributeValue
  ...AttributeValueDetailsDialog_attributeValue
}
    ${AttributeValueDeleteDialog_AttributeValueFragmentDoc}
${AttributeValueDetailsDialog_AttributeValueFragmentDoc}`;
export const AttributeDetailsDialog_AttributeFragmentDoc = gql`
    fragment AttributeDetailsDialog_attribute on EmployeeAttributeName {
  id
  name
  type
}
    `;
export const AttributeChangeSyncSourceTypeDialog_AttributeFragmentDoc = gql`
    fragment AttributeChangeSyncSourceTypeDialog_attribute on EmployeeAttributeName {
  id
  syncSourceType
  name
}
    `;
export const DeleteAllAttributeValuesDialog_AttributeFragmentDoc = gql`
    fragment DeleteAllAttributeValuesDialog_attribute on EmployeeAttributeName {
  id
  name
  values {
    id
  }
}
    `;
export const DeleteAttributeDialog_AttributeFragmentDoc = gql`
    fragment DeleteAttributeDialog_attribute on EmployeeAttributeName {
  id
  name
}
    `;
export const Attribute_AttributeFragmentDoc = gql`
    fragment Attribute_attribute on EmployeeAttributeName {
  id
  name
  type
  syncSourceType
  values {
    id
    ...AttributeValue_attributeValue
    ...AttributeValueDetailsDialog_attributeValue
  }
  ...AttributeDetailsDialog_attribute
  ...AttributeChangeSyncSourceTypeDialog_attribute
  ...DeleteAllAttributeValuesDialog_attribute
  ...DeleteAttributeDialog_attribute
}
    ${AttributeValue_AttributeValueFragmentDoc}
${AttributeValueDetailsDialog_AttributeValueFragmentDoc}
${AttributeDetailsDialog_AttributeFragmentDoc}
${AttributeChangeSyncSourceTypeDialog_AttributeFragmentDoc}
${DeleteAllAttributeValuesDialog_AttributeFragmentDoc}
${DeleteAttributeDialog_AttributeFragmentDoc}`;
export const AttributeValueDetailsDialog_AttributesFragmentDoc = gql`
    fragment AttributeValueDetailsDialog_attributes on EmployeeAttributeName {
  id
  name
  syncSourceType
}
    `;
export const AttributeValue_AttributesFragmentDoc = gql`
    fragment AttributeValue_attributes on EmployeeAttributeName {
  id
  ...AttributeValueDetailsDialog_attributes
}
    ${AttributeValueDetailsDialog_AttributesFragmentDoc}`;
export const Attribute_AttributesFragmentDoc = gql`
    fragment Attribute_attributes on EmployeeAttributeName {
  id
  ...AttributeValue_attributes
  ...AttributeValueDetailsDialog_attributes
}
    ${AttributeValue_AttributesFragmentDoc}
${AttributeValueDetailsDialog_AttributesFragmentDoc}`;
export const Attributes_AttributesFragmentDoc = gql`
    fragment Attributes_attributes on EmployeeAttributeName {
  id
  ...Attribute_attribute
  ...Attribute_attributes
}
    ${Attribute_AttributeFragmentDoc}
${Attribute_AttributesFragmentDoc}`;
export const InterviewerPortalSettingsFragmentDoc = gql`
    fragment InterviewerPortalSettings on InterviewerPortalSettings {
  id
  firstName
  lastName
  title
  emailAddress
  linkedinUrl
  timezone
  interviewLoadCapacity
  interviewAvailability
  temporaryAvailability
  bufferTime
  pauseFromInterviews
  interviewerKeywords
  profilePicture
  pronouns
  bio
  feedbackWritingTime
}
    `;
export const AdditionalRecipientsDialog_OrgBccRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsDialog_orgBccRecipients on NotificationPreference {
  employeeIds
  externalEmailAddresses
  dynamicAudiences
}
    `;
export const AdditionalRecipientsRow_OrgBccRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsRow_orgBccRecipients on NotificationPreference {
  ...AdditionalRecipientsDialog_orgBccRecipients
  ...SmartEmployeeSelectLabel_smartOptions
}
    ${AdditionalRecipientsDialog_OrgBccRecipientsFragmentDoc}
${SmartEmployeeSelectLabel_SmartOptionsFragmentDoc}`;
export const AdditionalRecipientsDialog_OrgCcRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsDialog_orgCcRecipients on NotificationPreference {
  employeeIds
  externalEmailAddresses
  dynamicAudiences
}
    `;
export const AdditionalRecipientsRow_OrgCcRecipientsFragmentDoc = gql`
    fragment AdditionalRecipientsRow_orgCcRecipients on NotificationPreference {
  ...AdditionalRecipientsDialog_orgCcRecipients
  ...SmartEmployeeSelectLabel_smartOptions
}
    ${AdditionalRecipientsDialog_OrgCcRecipientsFragmentDoc}
${SmartEmployeeSelectLabel_SmartOptionsFragmentDoc}`;
export const AvailabilityRequestOrgPrefDataFragmentDoc = gql`
    fragment AvailabilityRequestOrgPrefData on OrgPref {
  id
  orgId
  prefName
  jsonPref {
    ... on NotificationPreference {
      ...AdditionalRecipientsRow_orgBccRecipients
      ...AdditionalRecipientsRow_orgCcRecipients
    }
  }
}
    ${AdditionalRecipientsRow_OrgBccRecipientsFragmentDoc}
${AdditionalRecipientsRow_OrgCcRecipientsFragmentDoc}`;
export const SelfScheduleRequestSettingsOrgPrefsDataFragmentDoc = gql`
    fragment SelfScheduleRequestSettingsOrgPrefsData on OrgPref {
  id
  orgId
  prefName
  jsonPref {
    ... on NotificationPreference {
      ...AdditionalRecipientsRow_orgBccRecipients
      ...AdditionalRecipientsRow_orgCcRecipients
    }
  }
}
    ${AdditionalRecipientsRow_OrgBccRecipientsFragmentDoc}
${AdditionalRecipientsRow_OrgCcRecipientsFragmentDoc}`;
export const ExistingSlackChannels_OrgConversationFragmentDoc = gql`
    fragment ExistingSlackChannels_orgConversation on ChatCommunicationsSettingPref {
  chatConversationType
  chatConversationId
  chatConversation {
    id
    remoteId
    orgId
    type
    remoteName
  }
}
    `;
export const SlackChannelRow_OrgConversationFragmentDoc = gql`
    fragment SlackChannelRow_orgConversation on ChatCommunicationsSettingPref {
  ...ExistingSlackChannels_orgConversation
}
    ${ExistingSlackChannels_OrgConversationFragmentDoc}`;
export const SlackChannelMembersDialog_OrgMembersFragmentDoc = gql`
    fragment SlackChannelMembersDialog_orgMembers on NotificationPreference {
  employeeIds
  externalEmailAddresses
  dynamicAudiences
}
    `;
export const SlackChannelMembers_OrgMembersFragmentDoc = gql`
    fragment SlackChannelMembers_orgMembers on NotificationPreference {
  ...SlackChannelMembersDialog_orgMembers
  ...SmartEmployeeSelectLabel_smartOptions
}
    ${SlackChannelMembersDialog_OrgMembersFragmentDoc}
${SmartEmployeeSelectLabel_SmartOptionsFragmentDoc}`;
export const CommunicationOrgPrefDataFragmentDoc = gql`
    fragment CommunicationOrgPrefData on OrgPref {
  id
  orgId
  prefName
  stringValue
  jsonPref {
    ... on ChatCommunicationsSettingPref {
      ...SlackChannelRow_orgConversation
    }
    ... on CandidateCommunicationsSettingPref {
      ccRecipients {
        ...AdditionalRecipientsRow_orgBccRecipients
      }
      bccRecipients {
        ...AdditionalRecipientsRow_orgCcRecipients
      }
    }
    ... on NotificationPreference {
      ...SlackChannelMembers_orgMembers
    }
    ... on CandidateEventAdditionalAttendeesPref {
      candidateEventAdditionalAttendees {
        employeeIds
        externalEmailAddresses
        dynamicAudiences
      }
      additionalRecipientsOptional
      additionalAttendees {
        email
        employeeId
        dynamicAudience
        isOptional
      }
    }
    ... on InterviewerEventAdditionalAttendeesPref {
      interviewerEventAdditionalAttendees {
        employeeIds
        externalEmailAddresses
        dynamicAudiences
      }
      additionalRecipientsOptional
      additionalAttendees {
        email
        employeeId
        dynamicAudience
        isOptional
      }
    }
    ... on DebriefEventAdditionalAttendeesPref {
      debriefEventAdditionalAttendees {
        employeeIds
        externalEmailAddresses
        dynamicAudiences
      }
      additionalRecipientsOptional
      additionalAttendees {
        email
        employeeId
        dynamicAudience
        isOptional
      }
    }
  }
}
    ${SlackChannelRow_OrgConversationFragmentDoc}
${AdditionalRecipientsRow_OrgBccRecipientsFragmentDoc}
${AdditionalRecipientsRow_OrgCcRecipientsFragmentDoc}
${SlackChannelMembers_OrgMembersFragmentDoc}`;
export const CompanyHolidayModal_CompanyHolidayFragmentDoc = gql`
    fragment CompanyHolidayModal_companyHoliday on CompanyHoliday {
  id
  name
  startAt
  endAt
  countries {
    id
    value
  }
}
    `;
export const DeleteCompanyHolidayModal_CompanyHolidayFragmentDoc = gql`
    fragment DeleteCompanyHolidayModal_companyHoliday on CompanyHoliday {
  id
  name
  startAt
  endAt
  countries {
    id
    value
  }
}
    `;
export const CompanyHoliday_CompanyHolidayFragmentDoc = gql`
    fragment CompanyHoliday_companyHoliday on CompanyHoliday {
  id
  name
  startAt
  endAt
  countries {
    id
    value
  }
  ...CompanyHolidayModal_companyHoliday
  ...DeleteCompanyHolidayModal_companyHoliday
}
    ${CompanyHolidayModal_CompanyHolidayFragmentDoc}
${DeleteCompanyHolidayModal_CompanyHolidayFragmentDoc}`;
export const DebriefAtsWriteOrgPrefDataFragmentDoc = gql`
    fragment DebriefAtsWriteOrgPrefData on OrgPref {
  id
  orgId
  prefName
  jsonPref {
    ... on DebriefAtsWriteSettingPref {
      ...DebriefAtsWriteRow_setting
    }
  }
}
    ${DebriefAtsWriteRow_SettingFragmentDoc}`;
export const EditOrgNameDialog_OrgFragmentDoc = gql`
    fragment EditOrgNameDialog_org on Org {
  id
  name
}
    `;
export const DeleteTagModal_TaskTagFragmentDoc = gql`
    fragment DeleteTagModal_taskTag on TaskTag {
  id
  taskCount
}
    `;
export const TaskTagItem_TaskTagFragmentDoc = gql`
    fragment TaskTagItem_taskTag on TaskTag {
  id
  name
  taskCount
}
    `;
export const EditTagModal_TaskTagFragmentDoc = gql`
    fragment EditTagModal_taskTag on TaskTag {
  id
  name
}
    `;
export const TaskTagList_TaskTagFragmentDoc = gql`
    fragment TaskTagList_taskTag on TaskTag {
  id
  name
  ...TaskTagItem_taskTag
  ...EditTagModal_taskTag
}
    ${TaskTagItem_TaskTagFragmentDoc}
${EditTagModal_TaskTagFragmentDoc}`;
export const AddMemberModal_SelectedEmployeesFragmentDoc = gql`
    fragment AddMemberModal_selectedEmployees on Employee {
  id
  ...Employee
}
    ${EmployeeFragmentDoc}`;
export const QueueDialogContent_QueueMembersFragmentDoc = gql`
    fragment QueueDialogContent_queueMembers on Employee {
  id
  ...AddMemberModal_selectedEmployees
}
    ${AddMemberModal_SelectedEmployeesFragmentDoc}`;
export const QueueModal_TaskQueueFragmentDoc = gql`
    fragment QueueModal_taskQueue on TaskQueue {
  id
  name
  memberCount
  taskCount
}
    `;
export const DeleteQueueModal_TaskQueueFragmentDoc = gql`
    fragment DeleteQueueModal_taskQueue on TaskQueue {
  id
  name
}
    `;
export const QueueRow_TaskQueueFragmentDoc = gql`
    fragment QueueRow_taskQueue on TaskQueue {
  id
  memberCount
  taskCount
  name
  ...QueueModal_taskQueue
  ...DeleteQueueModal_taskQueue
}
    ${QueueModal_TaskQueueFragmentDoc}
${DeleteQueueModal_TaskQueueFragmentDoc}`;
export const QueueList_TaskQueueFragmentDoc = gql`
    fragment QueueList_taskQueue on TaskQueue {
  id
  ...QueueRow_taskQueue
}
    ${QueueRow_TaskQueueFragmentDoc}`;
export const RescheduleReasonItem_RescheduleReasonFragmentDoc = gql`
    fragment RescheduleReasonItem_rescheduleReason on RescheduleReason {
  id
  reason
  type
  archivedAt
}
    `;
export const EditRescheduleReasonModal_RescheduleReasonFragmentDoc = gql`
    fragment EditRescheduleReasonModal_rescheduleReason on RescheduleReason {
  id
  reason
}
    `;
export const RescheduleReasonsList_RescheduleReasonFragmentDoc = gql`
    fragment RescheduleReasonsList_rescheduleReason on RescheduleReason {
  id
  reason
  ...RescheduleReasonItem_rescheduleReason
  ...EditRescheduleReasonModal_rescheduleReason
}
    ${RescheduleReasonItem_RescheduleReasonFragmentDoc}
${EditRescheduleReasonModal_RescheduleReasonFragmentDoc}`;
export const AttachmentsFragmentDoc = gql`
    fragment Attachments on Template {
  attachments {
    name
    path
    size
    timestamp
  }
}
    `;
export const TemplateFragFragmentDoc = gql`
    fragment TemplateFrag on Template {
  id
  type
  locale
  name
  updatedAt
  subject
  body
  isOrganizationDefault
  isSystem
  liveSettingsUsages
  lastSentAt
}
    `;
export const TemplateTypeChangeConfirmModal_TemplateFragmentDoc = gql`
    fragment TemplateTypeChangeConfirmModal_template on Template {
  id
  liveSettingsUsages
}
    `;
export const TemplateModal_TemplateFragmentDoc = gql`
    fragment TemplateModal_template on Template {
  id
  name
  type
  locale
  subject
  body
  isOrganizationDefault
  isSystem
  liveSettingsUsages
  attachments {
    name
    timestamp
    path
    size
  }
  ...TemplateTypeChangeConfirmModal_template
}
    ${TemplateTypeChangeConfirmModal_TemplateFragmentDoc}`;
export const TemplateDeleteConfirmModal_TemplateFragmentDoc = gql`
    fragment TemplateDeleteConfirmModal_template on Template {
  id
  name
  liveSettingsUsages
}
    `;
export const TemplateMenu_TemplateFragmentDoc = gql`
    fragment TemplateMenu_template on Template {
  id
  isOrganizationDefault
  isSystem
  type
  ...TemplateDeleteConfirmModal_template
}
    ${TemplateDeleteConfirmModal_TemplateFragmentDoc}`;
export const Template_TemplateFragmentDoc = gql`
    fragment Template_template on Template {
  id
  name
  type
  locale
  isOrganizationDefault
  isSystem
  updatedAt
  lastSentAt
  ...TemplateMenu_template
}
    ${TemplateMenu_TemplateFragmentDoc}`;
export const TemplateDeleteConfirmModal_OrgDefaultTemplateFragmentDoc = gql`
    fragment TemplateDeleteConfirmModal_orgDefaultTemplate on Template {
  id
  name
}
    `;
export const TemplateMenu_OrgDefaultTemplateFragmentDoc = gql`
    fragment TemplateMenu_orgDefaultTemplate on Template {
  id
  ...TemplateDeleteConfirmModal_orgDefaultTemplate
}
    ${TemplateDeleteConfirmModal_OrgDefaultTemplateFragmentDoc}`;
export const Template_OrgDefaultTemplateFragmentDoc = gql`
    fragment Template_orgDefaultTemplate on Template {
  ...TemplateMenu_orgDefaultTemplate
}
    ${TemplateMenu_OrgDefaultTemplateFragmentDoc}`;
export const FullCalendarViews_UpcomingEventsFragmentDoc = gql`
    fragment FullCalendarViews_upcomingEvents on UpcomingEvent {
  startAt
  endAt
  dayIndex
  dayTotal
  interviews {
    id
  }
  candidateEvent {
    id
  }
  schedule {
    id
    taskId
    jobStage {
      id
      name
    }
    application {
      id
      candidate {
        id
        fullName
        anonymizedAt
      }
    }
  }
}
    `;
export const AvatarFacePile_InterviewersFragmentDoc = gql`
    fragment AvatarFacePile_interviewers on ApplicationStageInterviewInterviewer {
  interviewerId
  responseStatus
  isOptional
  interviewer {
    id
    fullName
    internalProfilePictureUrl
  }
}
    `;
export const ScheduleListItem_UpcomingEventFragmentDoc = gql`
    fragment ScheduleListItem_upcomingEvent on UpcomingEvent {
  startAt
  endAt
  dayIndex
  dayTotal
  schedule {
    id
    jobStage {
      id
      name
    }
    application {
      id
      job {
        id
        name
      }
      candidate {
        id
        ...Candidate_candidate
      }
    }
    isHoldForRsvp
    isReadyForCandidateComms
  }
  candidateEvent {
    id
    responseStatus
  }
  interviews {
    id
    applicationStageInterviewInterviewers {
      interviewerId
      responseStatus
      ...AvatarFacePile_interviewers
    }
  }
}
    ${Candidate_CandidateFragmentDoc}
${AvatarFacePile_InterviewersFragmentDoc}`;
export const SchedulesList_UpcomingEventsFragmentDoc = gql`
    fragment SchedulesList_upcomingEvents on UpcomingEvent {
  ...ScheduleListItem_upcomingEvent
  schedule {
    id
    taskId
  }
}
    ${ScheduleListItem_UpcomingEventFragmentDoc}`;
export const AgendaTab_UpcomingEventsFragmentDoc = gql`
    fragment AgendaTab_upcomingEvents on UpcomingEvent {
  ...SchedulesList_upcomingEvents
}
    ${SchedulesList_UpcomingEventsFragmentDoc}`;
export const Views_UpcomingEventsFragmentDoc = gql`
    fragment Views_upcomingEvents on UpcomingEvent {
  startAt
  endAt
  ...AgendaTab_upcomingEvents
}
    ${AgendaTab_UpcomingEventsFragmentDoc}`;
export const DebriefListItem_DebriefFragmentDoc = gql`
    fragment DebriefListItem_debrief on ApplicationDebrief {
  id
  name
  startAt
  endAt
  googleEventUrl
  application {
    id
    job {
      id
      name
    }
    candidate {
      id
      ...Candidate_candidate
    }
  }
  attendees {
    interviewerId
    responseStatus
    isOptional
    interviewer {
      id
      fullName
      internalProfilePictureUrl
    }
  }
}
    ${Candidate_CandidateFragmentDoc}`;
export const SchedulesList_DebriefsFragmentDoc = gql`
    fragment SchedulesList_debriefs on ApplicationDebrief {
  ...DebriefListItem_debrief
  task {
    id
  }
}
    ${DebriefListItem_DebriefFragmentDoc}`;
export const AgendaTab_DebriefsFragmentDoc = gql`
    fragment AgendaTab_debriefs on ApplicationDebrief {
  ...SchedulesList_debriefs
}
    ${SchedulesList_DebriefsFragmentDoc}`;
export const FullCalendarViews_DebriefsFragmentDoc = gql`
    fragment FullCalendarViews_debriefs on ApplicationDebrief {
  id
  startAt
  endAt
  task {
    id
  }
  application {
    id
    candidate {
      id
      fullName
      anonymizedAt
    }
  }
}
    `;
export const Views_DebriefsFragmentDoc = gql`
    fragment Views_debriefs on ApplicationDebrief {
  ...AgendaTab_debriefs
  ...FullCalendarViews_debriefs
}
    ${AgendaTab_DebriefsFragmentDoc}
${FullCalendarViews_DebriefsFragmentDoc}`;
export const Views_UpcomingEventsResultFragmentDoc = gql`
    fragment Views_upcomingEventsResult on UpcomingEventsResult {
  items {
    ...Views_upcomingEvents
  }
  debriefs @include(if: $includeDebriefs) {
    ...Views_debriefs
  }
}
    ${Views_UpcomingEventsFragmentDoc}
${Views_DebriefsFragmentDoc}`;
export const UpcomingEventsPageFiltersEmployeePrefFragmentDoc = gql`
    fragment UpcomingEventsPageFiltersEmployeePref on UpcomingEventsPageFiltersPref {
  schedulerEmployeeIds
  recruiterEmployeeIds
  interviewerEmployeeIds
  candidateRsvps
  interviewerRsvps
  allAccepted
  taskAssigneeEmployeeIds
}
    `;
export const UpdateFlowBase_TaskFragmentDoc = gql`
    fragment UpdateFlowBase_task on Task {
  id
  ...UpdateCommunications_task
}
    ${UpdateCommunications_TaskFragmentDoc}`;
export const UpdateFlow_TaskFragmentDoc = gql`
    fragment UpdateFlow_task on Task {
  id
  ...UpdateFlowBase_task
}
    ${UpdateFlowBase_TaskFragmentDoc}`;
export const Notification_EmployeeNotificationPrefFragmentDoc = gql`
    fragment Notification_EmployeeNotificationPref on EmployeeNotificationPreference {
  employeeId
  type
  medium
  value
}
    `;
export const InterviewModuleMemberMenuOptionsFragmentDoc = gql`
    fragment InterviewModuleMemberMenuOptions on InterviewModuleMember {
  employeeId
  interviewModuleId
  status
}
    `;
export const MockScheduleTask_TaskFragmentDoc = gql`
    fragment MockScheduleTask_task on Task {
  id
}
    `;
export const MockUseScheduleTaskMenuOptions_TaskFragmentDoc = gql`
    fragment MockUseScheduleTaskMenuOptions_task on Task {
  id
}
    `;
export const UseSchduleTaskMenuOptions_TaskFragmentDoc = gql`
    fragment UseSchduleTaskMenuOptions_task on Task {
  id
  isUrgent
  status
  delegateType
}
    `;
export const OrganizationSwitcherMembershipsDocument = gql`
    query OrganizationSwitcherMemberships {
  thisUserInfo {
    userId
    memberships {
      organization {
        id
        name
      }
      isActive
    }
  }
}
    `;

/**
 * __useOrganizationSwitcherMembershipsQuery__
 *
 * To run a query within a React component, call `useOrganizationSwitcherMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSwitcherMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSwitcherMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSwitcherMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>(OrganizationSwitcherMembershipsDocument, options);
      }
export function useOrganizationSwitcherMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>(OrganizationSwitcherMembershipsDocument, options);
        }
// @ts-ignore
export function useOrganizationSwitcherMembershipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>;
export function useOrganizationSwitcherMembershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationSwitcherMembershipsQuery | undefined, OrganizationSwitcherMembershipsQueryVariables>;
export function useOrganizationSwitcherMembershipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>(OrganizationSwitcherMembershipsDocument, options);
        }
export type OrganizationSwitcherMembershipsQueryHookResult = ReturnType<typeof useOrganizationSwitcherMembershipsQuery>;
export type OrganizationSwitcherMembershipsLazyQueryHookResult = ReturnType<typeof useOrganizationSwitcherMembershipsLazyQuery>;
export type OrganizationSwitcherMembershipsSuspenseQueryHookResult = ReturnType<typeof useOrganizationSwitcherMembershipsSuspenseQuery>;
export type OrganizationSwitcherMembershipsQueryResult = Apollo.QueryResult<OrganizationSwitcherMembershipsQuery, OrganizationSwitcherMembershipsQueryVariables>;
export const SwitchActiveOrganizationDocument = gql`
    mutation SwitchActiveOrganization($input: SwitchActiveOrganizationInput!) {
  switchActiveOrganization(input: $input) {
    __typename
    ... on SwitchActiveOrganizationSuccess {
      activeOrganizationId
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    `;
export type SwitchActiveOrganizationMutationFn = Apollo.MutationFunction<SwitchActiveOrganizationMutation, SwitchActiveOrganizationMutationVariables>;

/**
 * __useSwitchActiveOrganizationMutation__
 *
 * To run a mutation, you first call `useSwitchActiveOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchActiveOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchActiveOrganizationMutation, { data, loading, error }] = useSwitchActiveOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchActiveOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SwitchActiveOrganizationMutation, SwitchActiveOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchActiveOrganizationMutation, SwitchActiveOrganizationMutationVariables>(SwitchActiveOrganizationDocument, options);
      }
export type SwitchActiveOrganizationMutationHookResult = ReturnType<typeof useSwitchActiveOrganizationMutation>;
export type SwitchActiveOrganizationMutationResult = Apollo.MutationResult<SwitchActiveOrganizationMutation>;
export type SwitchActiveOrganizationMutationOptions = Apollo.BaseMutationOptions<SwitchActiveOrganizationMutation, SwitchActiveOrganizationMutationVariables>;
export const TaskStopAgentDocument = gql`
    mutation TaskStopAgent($input: TaskStopAgentInput!) {
  taskStopAgent(input: $input) {
    task {
      id
      delegateType
      delegateStatus
    }
  }
}
    `;
export type TaskStopAgentMutationFn = Apollo.MutationFunction<TaskStopAgentMutation, TaskStopAgentMutationVariables>;

/**
 * __useTaskStopAgentMutation__
 *
 * To run a mutation, you first call `useTaskStopAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskStopAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskStopAgentMutation, { data, loading, error }] = useTaskStopAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskStopAgentMutation(baseOptions?: Apollo.MutationHookOptions<TaskStopAgentMutation, TaskStopAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskStopAgentMutation, TaskStopAgentMutationVariables>(TaskStopAgentDocument, options);
      }
export type TaskStopAgentMutationHookResult = ReturnType<typeof useTaskStopAgentMutation>;
export type TaskStopAgentMutationResult = Apollo.MutationResult<TaskStopAgentMutation>;
export type TaskStopAgentMutationOptions = Apollo.BaseMutationOptions<TaskStopAgentMutation, TaskStopAgentMutationVariables>;
export const ActivityLogEditNoteDocument = gql`
    mutation ActivityLogEditNote($input: ActivityNoteEditInput!, $showTaskName: Boolean! = false) {
  activityNoteEdit(input: $input) {
    activityLog {
      ...ActivityLogNote_activityLog
    }
  }
}
    ${ActivityLogNote_ActivityLogFragmentDoc}`;
export type ActivityLogEditNoteMutationFn = Apollo.MutationFunction<ActivityLogEditNoteMutation, ActivityLogEditNoteMutationVariables>;

/**
 * __useActivityLogEditNoteMutation__
 *
 * To run a mutation, you first call `useActivityLogEditNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityLogEditNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityLogEditNoteMutation, { data, loading, error }] = useActivityLogEditNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      showTaskName: // value for 'showTaskName'
 *   },
 * });
 */
export function useActivityLogEditNoteMutation(baseOptions?: Apollo.MutationHookOptions<ActivityLogEditNoteMutation, ActivityLogEditNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivityLogEditNoteMutation, ActivityLogEditNoteMutationVariables>(ActivityLogEditNoteDocument, options);
      }
export type ActivityLogEditNoteMutationHookResult = ReturnType<typeof useActivityLogEditNoteMutation>;
export type ActivityLogEditNoteMutationResult = Apollo.MutationResult<ActivityLogEditNoteMutation>;
export type ActivityLogEditNoteMutationOptions = Apollo.BaseMutationOptions<ActivityLogEditNoteMutation, ActivityLogEditNoteMutationVariables>;
export const ActivityLogDeleteNoteDocument = gql`
    mutation ActivityLogDeleteNote($input: ActivityNoteDeleteInput!) {
  activityNoteDelete(input: $input) {
    result
  }
}
    `;
export type ActivityLogDeleteNoteMutationFn = Apollo.MutationFunction<ActivityLogDeleteNoteMutation, ActivityLogDeleteNoteMutationVariables>;

/**
 * __useActivityLogDeleteNoteMutation__
 *
 * To run a mutation, you first call `useActivityLogDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityLogDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityLogDeleteNoteMutation, { data, loading, error }] = useActivityLogDeleteNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityLogDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<ActivityLogDeleteNoteMutation, ActivityLogDeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivityLogDeleteNoteMutation, ActivityLogDeleteNoteMutationVariables>(ActivityLogDeleteNoteDocument, options);
      }
export type ActivityLogDeleteNoteMutationHookResult = ReturnType<typeof useActivityLogDeleteNoteMutation>;
export type ActivityLogDeleteNoteMutationResult = Apollo.MutationResult<ActivityLogDeleteNoteMutation>;
export type ActivityLogDeleteNoteMutationOptions = Apollo.BaseMutationOptions<ActivityLogDeleteNoteMutation, ActivityLogDeleteNoteMutationVariables>;
export const ApplicationDetailsActivityLogsListDocument = gql`
    query ApplicationDetailsActivityLogsList($applicationId: uuid!, $input: ActivityLogsForSourceInput!, $showTaskName: Boolean! = true) {
  application(id: $applicationId) {
    id
    activityLogs(input: $input) {
      items {
        ...ApplicationDetailsActivityLogsList_activityLog
      }
      nextCursor
    }
  }
}
    ${ApplicationDetailsActivityLogsList_ActivityLogFragmentDoc}`;

/**
 * __useApplicationDetailsActivityLogsListQuery__
 *
 * To run a query within a React component, call `useApplicationDetailsActivityLogsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationDetailsActivityLogsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationDetailsActivityLogsListQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      input: // value for 'input'
 *      showTaskName: // value for 'showTaskName'
 *   },
 * });
 */
export function useApplicationDetailsActivityLogsListQuery(baseOptions: Apollo.QueryHookOptions<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables> & ({ variables: ApplicationDetailsActivityLogsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>(ApplicationDetailsActivityLogsListDocument, options);
      }
export function useApplicationDetailsActivityLogsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>(ApplicationDetailsActivityLogsListDocument, options);
        }
// @ts-ignore
export function useApplicationDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>;
export function useApplicationDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationDetailsActivityLogsListQuery | undefined, ApplicationDetailsActivityLogsListQueryVariables>;
export function useApplicationDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>(ApplicationDetailsActivityLogsListDocument, options);
        }
export type ApplicationDetailsActivityLogsListQueryHookResult = ReturnType<typeof useApplicationDetailsActivityLogsListQuery>;
export type ApplicationDetailsActivityLogsListLazyQueryHookResult = ReturnType<typeof useApplicationDetailsActivityLogsListLazyQuery>;
export type ApplicationDetailsActivityLogsListSuspenseQueryHookResult = ReturnType<typeof useApplicationDetailsActivityLogsListSuspenseQuery>;
export type ApplicationDetailsActivityLogsListQueryResult = Apollo.QueryResult<ApplicationDetailsActivityLogsListQuery, ApplicationDetailsActivityLogsListQueryVariables>;
export const ActivityNoteCreateDocument = gql`
    mutation ActivityNoteCreate($input: ActivityNoteCreateInput!) {
  activityNoteCreate(input: $input) {
    activityLog {
      id
      createdAt
      activityType
      activityActorType
      activityActorEmployeeId
      actorEmployee {
        id
        fullName
        internalProfilePictureUrl
      }
      details {
        ... on ActivityLogNoteDetails {
          note
        }
      }
    }
  }
}
    `;
export type ActivityNoteCreateMutationFn = Apollo.MutationFunction<ActivityNoteCreateMutation, ActivityNoteCreateMutationVariables>;

/**
 * __useActivityNoteCreateMutation__
 *
 * To run a mutation, you first call `useActivityNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityNoteCreateMutation, { data, loading, error }] = useActivityNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityNoteCreateMutation(baseOptions?: Apollo.MutationHookOptions<ActivityNoteCreateMutation, ActivityNoteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivityNoteCreateMutation, ActivityNoteCreateMutationVariables>(ActivityNoteCreateDocument, options);
      }
export type ActivityNoteCreateMutationHookResult = ReturnType<typeof useActivityNoteCreateMutation>;
export type ActivityNoteCreateMutationResult = Apollo.MutationResult<ActivityNoteCreateMutation>;
export type ActivityNoteCreateMutationOptions = Apollo.BaseMutationOptions<ActivityNoteCreateMutation, ActivityNoteCreateMutationVariables>;
export const ActivityLogsCacheProbeDocument = gql`
    query ActivityLogsCacheProbe($input: ActivityLogsInput!) {
  activityLogs(input: $input) {
    nextCursor
  }
}
    `;

/**
 * __useActivityLogsCacheProbeQuery__
 *
 * To run a query within a React component, call `useActivityLogsCacheProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogsCacheProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogsCacheProbeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityLogsCacheProbeQuery(baseOptions: Apollo.QueryHookOptions<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables> & ({ variables: ActivityLogsCacheProbeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>(ActivityLogsCacheProbeDocument, options);
      }
export function useActivityLogsCacheProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>(ActivityLogsCacheProbeDocument, options);
        }
// @ts-ignore
export function useActivityLogsCacheProbeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>;
export function useActivityLogsCacheProbeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogsCacheProbeQuery | undefined, ActivityLogsCacheProbeQueryVariables>;
export function useActivityLogsCacheProbeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>(ActivityLogsCacheProbeDocument, options);
        }
export type ActivityLogsCacheProbeQueryHookResult = ReturnType<typeof useActivityLogsCacheProbeQuery>;
export type ActivityLogsCacheProbeLazyQueryHookResult = ReturnType<typeof useActivityLogsCacheProbeLazyQuery>;
export type ActivityLogsCacheProbeSuspenseQueryHookResult = ReturnType<typeof useActivityLogsCacheProbeSuspenseQuery>;
export type ActivityLogsCacheProbeQueryResult = Apollo.QueryResult<ActivityLogsCacheProbeQuery, ActivityLogsCacheProbeQueryVariables>;
export const ActivityLogsScopeCacheProbeDocument = gql`
    query ActivityLogsScopeCacheProbe($input: ActivityLogsInput!) {
  activityLogs(input: $input) {
    nextCursor
  }
}
    `;

/**
 * __useActivityLogsScopeCacheProbeQuery__
 *
 * To run a query within a React component, call `useActivityLogsScopeCacheProbeQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogsScopeCacheProbeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogsScopeCacheProbeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityLogsScopeCacheProbeQuery(baseOptions: Apollo.QueryHookOptions<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables> & ({ variables: ActivityLogsScopeCacheProbeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>(ActivityLogsScopeCacheProbeDocument, options);
      }
export function useActivityLogsScopeCacheProbeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>(ActivityLogsScopeCacheProbeDocument, options);
        }
// @ts-ignore
export function useActivityLogsScopeCacheProbeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>;
export function useActivityLogsScopeCacheProbeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>): Apollo.UseSuspenseQueryResult<ActivityLogsScopeCacheProbeQuery | undefined, ActivityLogsScopeCacheProbeQueryVariables>;
export function useActivityLogsScopeCacheProbeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>(ActivityLogsScopeCacheProbeDocument, options);
        }
export type ActivityLogsScopeCacheProbeQueryHookResult = ReturnType<typeof useActivityLogsScopeCacheProbeQuery>;
export type ActivityLogsScopeCacheProbeLazyQueryHookResult = ReturnType<typeof useActivityLogsScopeCacheProbeLazyQuery>;
export type ActivityLogsScopeCacheProbeSuspenseQueryHookResult = ReturnType<typeof useActivityLogsScopeCacheProbeSuspenseQuery>;
export type ActivityLogsScopeCacheProbeQueryResult = Apollo.QueryResult<ActivityLogsScopeCacheProbeQuery, ActivityLogsScopeCacheProbeQueryVariables>;
export const EntityDetailsActivityLogsListDocument = gql`
    query EntityDetailsActivityLogsList($input: ActivityLogsInput!, $showTaskName: Boolean! = false) {
  activityLogs(input: $input) {
    items {
      ...ActivityLogsList_activityLog
    }
    nextCursor
  }
}
    ${ActivityLogsList_ActivityLogFragmentDoc}`;

/**
 * __useEntityDetailsActivityLogsListQuery__
 *
 * To run a query within a React component, call `useEntityDetailsActivityLogsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsActivityLogsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsActivityLogsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      showTaskName: // value for 'showTaskName'
 *   },
 * });
 */
export function useEntityDetailsActivityLogsListQuery(baseOptions: Apollo.QueryHookOptions<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables> & ({ variables: EntityDetailsActivityLogsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>(EntityDetailsActivityLogsListDocument, options);
      }
export function useEntityDetailsActivityLogsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>(EntityDetailsActivityLogsListDocument, options);
        }
// @ts-ignore
export function useEntityDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>;
export function useEntityDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<EntityDetailsActivityLogsListQuery | undefined, EntityDetailsActivityLogsListQueryVariables>;
export function useEntityDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>(EntityDetailsActivityLogsListDocument, options);
        }
export type EntityDetailsActivityLogsListQueryHookResult = ReturnType<typeof useEntityDetailsActivityLogsListQuery>;
export type EntityDetailsActivityLogsListLazyQueryHookResult = ReturnType<typeof useEntityDetailsActivityLogsListLazyQuery>;
export type EntityDetailsActivityLogsListSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsActivityLogsListSuspenseQuery>;
export type EntityDetailsActivityLogsListQueryResult = Apollo.QueryResult<EntityDetailsActivityLogsListQuery, EntityDetailsActivityLogsListQueryVariables>;
export const MentionEmployeeSearchDocument = gql`
    query MentionEmployeeSearch($input: EmployeeSearchInput!) {
  employeeSearch(input: $input) {
    items {
      id
      fullName
      email
      internalProfilePictureUrl
    }
  }
}
    `;

/**
 * __useMentionEmployeeSearchQuery__
 *
 * To run a query within a React component, call `useMentionEmployeeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionEmployeeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionEmployeeSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMentionEmployeeSearchQuery(baseOptions: Apollo.QueryHookOptions<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables> & ({ variables: MentionEmployeeSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>(MentionEmployeeSearchDocument, options);
      }
export function useMentionEmployeeSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>(MentionEmployeeSearchDocument, options);
        }
// @ts-ignore
export function useMentionEmployeeSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>): Apollo.UseSuspenseQueryResult<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>;
export function useMentionEmployeeSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>): Apollo.UseSuspenseQueryResult<MentionEmployeeSearchQuery | undefined, MentionEmployeeSearchQueryVariables>;
export function useMentionEmployeeSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>(MentionEmployeeSearchDocument, options);
        }
export type MentionEmployeeSearchQueryHookResult = ReturnType<typeof useMentionEmployeeSearchQuery>;
export type MentionEmployeeSearchLazyQueryHookResult = ReturnType<typeof useMentionEmployeeSearchLazyQuery>;
export type MentionEmployeeSearchSuspenseQueryHookResult = ReturnType<typeof useMentionEmployeeSearchSuspenseQuery>;
export type MentionEmployeeSearchQueryResult = Apollo.QueryResult<MentionEmployeeSearchQuery, MentionEmployeeSearchQueryVariables>;
export const ActivityNoteCreateWithContentDocument = gql`
    mutation ActivityNoteCreateWithContent($input: ActivityNoteCreateInput!) {
  activityNoteCreate(input: $input) {
    activityLog {
      id
    }
  }
}
    `;
export type ActivityNoteCreateWithContentMutationFn = Apollo.MutationFunction<ActivityNoteCreateWithContentMutation, ActivityNoteCreateWithContentMutationVariables>;

/**
 * __useActivityNoteCreateWithContentMutation__
 *
 * To run a mutation, you first call `useActivityNoteCreateWithContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivityNoteCreateWithContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activityNoteCreateWithContentMutation, { data, loading, error }] = useActivityNoteCreateWithContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityNoteCreateWithContentMutation(baseOptions?: Apollo.MutationHookOptions<ActivityNoteCreateWithContentMutation, ActivityNoteCreateWithContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivityNoteCreateWithContentMutation, ActivityNoteCreateWithContentMutationVariables>(ActivityNoteCreateWithContentDocument, options);
      }
export type ActivityNoteCreateWithContentMutationHookResult = ReturnType<typeof useActivityNoteCreateWithContentMutation>;
export type ActivityNoteCreateWithContentMutationResult = Apollo.MutationResult<ActivityNoteCreateWithContentMutation>;
export type ActivityNoteCreateWithContentMutationOptions = Apollo.BaseMutationOptions<ActivityNoteCreateWithContentMutation, ActivityNoteCreateWithContentMutationVariables>;
export const ActivityLogCreatedDocument = gql`
    subscription ActivityLogCreated($input: ActivityLogSubscriptionInput!) {
  activityLogCreated(input: $input) {
    id
    activityType
    createdAt
  }
}
    `;

/**
 * __useActivityLogCreatedSubscription__
 *
 * To run a query within a React component, call `useActivityLogCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActivityLogCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLogCreatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivityLogCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ActivityLogCreatedSubscription, ActivityLogCreatedSubscriptionVariables> & ({ variables: ActivityLogCreatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ActivityLogCreatedSubscription, ActivityLogCreatedSubscriptionVariables>(ActivityLogCreatedDocument, options);
      }
export type ActivityLogCreatedSubscriptionHookResult = ReturnType<typeof useActivityLogCreatedSubscription>;
export type ActivityLogCreatedSubscriptionResult = Apollo.SubscriptionResult<ActivityLogCreatedSubscription>;
export const TaskUpdatedDocument = gql`
    subscription TaskUpdated($input: TaskUpdatedSubscriptionInput!) {
  taskUpdated(input: $input) {
    taskId
    updateType
    delegateStatus
  }
}
    `;

/**
 * __useTaskUpdatedSubscription__
 *
 * To run a query within a React component, call `useTaskUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskUpdatedSubscription({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<TaskUpdatedSubscription, TaskUpdatedSubscriptionVariables> & ({ variables: TaskUpdatedSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TaskUpdatedSubscription, TaskUpdatedSubscriptionVariables>(TaskUpdatedDocument, options);
      }
export type TaskUpdatedSubscriptionHookResult = ReturnType<typeof useTaskUpdatedSubscription>;
export type TaskUpdatedSubscriptionResult = Apollo.SubscriptionResult<TaskUpdatedSubscription>;
export const TaskDetailsActivityLogsListDocument = gql`
    query TaskDetailsActivityLogsList($taskId: uuid!, $input: ActivityLogsForSourceInput!, $showTaskName: Boolean! = false) {
  task(id: $taskId) {
    id
    activityLogs(input: $input) {
      items {
        id
        ...TaskDetailsActivityLogsList_activityLog
      }
      nextCursor
    }
  }
}
    ${TaskDetailsActivityLogsList_ActivityLogFragmentDoc}`;

/**
 * __useTaskDetailsActivityLogsListQuery__
 *
 * To run a query within a React component, call `useTaskDetailsActivityLogsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDetailsActivityLogsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDetailsActivityLogsListQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *      showTaskName: // value for 'showTaskName'
 *   },
 * });
 */
export function useTaskDetailsActivityLogsListQuery(baseOptions: Apollo.QueryHookOptions<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables> & ({ variables: TaskDetailsActivityLogsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>(TaskDetailsActivityLogsListDocument, options);
      }
export function useTaskDetailsActivityLogsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>(TaskDetailsActivityLogsListDocument, options);
        }
// @ts-ignore
export function useTaskDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>;
export function useTaskDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDetailsActivityLogsListQuery | undefined, TaskDetailsActivityLogsListQueryVariables>;
export function useTaskDetailsActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>(TaskDetailsActivityLogsListDocument, options);
        }
export type TaskDetailsActivityLogsListQueryHookResult = ReturnType<typeof useTaskDetailsActivityLogsListQuery>;
export type TaskDetailsActivityLogsListLazyQueryHookResult = ReturnType<typeof useTaskDetailsActivityLogsListLazyQuery>;
export type TaskDetailsActivityLogsListSuspenseQueryHookResult = ReturnType<typeof useTaskDetailsActivityLogsListSuspenseQuery>;
export type TaskDetailsActivityLogsListQueryResult = Apollo.QueryResult<TaskDetailsActivityLogsListQuery, TaskDetailsActivityLogsListQueryVariables>;
export const TaskTimelineActivityLogsListDocument = gql`
    query TaskTimelineActivityLogsList($taskId: uuid!, $input: ActivityLogsForSourceInput!, $showTaskName: Boolean! = false) {
  task(id: $taskId) {
    id
    activityLogs(input: $input) {
      items {
        id
        ...TaskTimelineActivityLogsList_activityLog
      }
      nextCursor
    }
  }
}
    ${TaskTimelineActivityLogsList_ActivityLogFragmentDoc}`;

/**
 * __useTaskTimelineActivityLogsListQuery__
 *
 * To run a query within a React component, call `useTaskTimelineActivityLogsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTimelineActivityLogsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTimelineActivityLogsListQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *      showTaskName: // value for 'showTaskName'
 *   },
 * });
 */
export function useTaskTimelineActivityLogsListQuery(baseOptions: Apollo.QueryHookOptions<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables> & ({ variables: TaskTimelineActivityLogsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>(TaskTimelineActivityLogsListDocument, options);
      }
export function useTaskTimelineActivityLogsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>(TaskTimelineActivityLogsListDocument, options);
        }
// @ts-ignore
export function useTaskTimelineActivityLogsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>;
export function useTaskTimelineActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTimelineActivityLogsListQuery | undefined, TaskTimelineActivityLogsListQueryVariables>;
export function useTaskTimelineActivityLogsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>(TaskTimelineActivityLogsListDocument, options);
        }
export type TaskTimelineActivityLogsListQueryHookResult = ReturnType<typeof useTaskTimelineActivityLogsListQuery>;
export type TaskTimelineActivityLogsListLazyQueryHookResult = ReturnType<typeof useTaskTimelineActivityLogsListLazyQuery>;
export type TaskTimelineActivityLogsListSuspenseQueryHookResult = ReturnType<typeof useTaskTimelineActivityLogsListSuspenseQuery>;
export type TaskTimelineActivityLogsListQueryResult = Apollo.QueryResult<TaskTimelineActivityLogsListQuery, TaskTimelineActivityLogsListQueryVariables>;
export const AiInstructionUpsertDocument = gql`
    mutation AiInstructionUpsert($input: AiInstructionUpsertInput!) {
  aiInstructionUpsert(input: $input) {
    id
  }
}
    `;
export type AiInstructionUpsertMutationFn = Apollo.MutationFunction<AiInstructionUpsertMutation, AiInstructionUpsertMutationVariables>;

/**
 * __useAiInstructionUpsertMutation__
 *
 * To run a mutation, you first call `useAiInstructionUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiInstructionUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiInstructionUpsertMutation, { data, loading, error }] = useAiInstructionUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiInstructionUpsertMutation(baseOptions?: Apollo.MutationHookOptions<AiInstructionUpsertMutation, AiInstructionUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiInstructionUpsertMutation, AiInstructionUpsertMutationVariables>(AiInstructionUpsertDocument, options);
      }
export type AiInstructionUpsertMutationHookResult = ReturnType<typeof useAiInstructionUpsertMutation>;
export type AiInstructionUpsertMutationResult = Apollo.MutationResult<AiInstructionUpsertMutation>;
export type AiInstructionUpsertMutationOptions = Apollo.BaseMutationOptions<AiInstructionUpsertMutation, AiInstructionUpsertMutationVariables>;
export const AiInstructionDeleteDocument = gql`
    mutation AiInstructionDelete($input: AiInstructionDeleteInput!) {
  aiInstructionDelete(input: $input) {
    result
  }
}
    `;
export type AiInstructionDeleteMutationFn = Apollo.MutationFunction<AiInstructionDeleteMutation, AiInstructionDeleteMutationVariables>;

/**
 * __useAiInstructionDeleteMutation__
 *
 * To run a mutation, you first call `useAiInstructionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiInstructionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiInstructionDeleteMutation, { data, loading, error }] = useAiInstructionDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiInstructionDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AiInstructionDeleteMutation, AiInstructionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiInstructionDeleteMutation, AiInstructionDeleteMutationVariables>(AiInstructionDeleteDocument, options);
      }
export type AiInstructionDeleteMutationHookResult = ReturnType<typeof useAiInstructionDeleteMutation>;
export type AiInstructionDeleteMutationResult = Apollo.MutationResult<AiInstructionDeleteMutation>;
export type AiInstructionDeleteMutationOptions = Apollo.BaseMutationOptions<AiInstructionDeleteMutation, AiInstructionDeleteMutationVariables>;
export const AiMemoryCreateDocument = gql`
    mutation AiMemoryCreate($input: AiMemoryCreateInput!) {
  aiMemoryCreate(input: $input) {
    id
  }
}
    `;
export type AiMemoryCreateMutationFn = Apollo.MutationFunction<AiMemoryCreateMutation, AiMemoryCreateMutationVariables>;

/**
 * __useAiMemoryCreateMutation__
 *
 * To run a mutation, you first call `useAiMemoryCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiMemoryCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiMemoryCreateMutation, { data, loading, error }] = useAiMemoryCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiMemoryCreateMutation(baseOptions?: Apollo.MutationHookOptions<AiMemoryCreateMutation, AiMemoryCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiMemoryCreateMutation, AiMemoryCreateMutationVariables>(AiMemoryCreateDocument, options);
      }
export type AiMemoryCreateMutationHookResult = ReturnType<typeof useAiMemoryCreateMutation>;
export type AiMemoryCreateMutationResult = Apollo.MutationResult<AiMemoryCreateMutation>;
export type AiMemoryCreateMutationOptions = Apollo.BaseMutationOptions<AiMemoryCreateMutation, AiMemoryCreateMutationVariables>;
export const AiMemoryUpdateDocument = gql`
    mutation AiMemoryUpdate($input: AiMemoryUpdateInput!) {
  aiMemoryUpdate(input: $input) {
    id
  }
}
    `;
export type AiMemoryUpdateMutationFn = Apollo.MutationFunction<AiMemoryUpdateMutation, AiMemoryUpdateMutationVariables>;

/**
 * __useAiMemoryUpdateMutation__
 *
 * To run a mutation, you first call `useAiMemoryUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiMemoryUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiMemoryUpdateMutation, { data, loading, error }] = useAiMemoryUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiMemoryUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AiMemoryUpdateMutation, AiMemoryUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiMemoryUpdateMutation, AiMemoryUpdateMutationVariables>(AiMemoryUpdateDocument, options);
      }
export type AiMemoryUpdateMutationHookResult = ReturnType<typeof useAiMemoryUpdateMutation>;
export type AiMemoryUpdateMutationResult = Apollo.MutationResult<AiMemoryUpdateMutation>;
export type AiMemoryUpdateMutationOptions = Apollo.BaseMutationOptions<AiMemoryUpdateMutation, AiMemoryUpdateMutationVariables>;
export const AiMemoryDeleteDocument = gql`
    mutation AiMemoryDelete($id: uuid!) {
  aiMemoryDelete(id: $id) {
    result
  }
}
    `;
export type AiMemoryDeleteMutationFn = Apollo.MutationFunction<AiMemoryDeleteMutation, AiMemoryDeleteMutationVariables>;

/**
 * __useAiMemoryDeleteMutation__
 *
 * To run a mutation, you first call `useAiMemoryDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiMemoryDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiMemoryDeleteMutation, { data, loading, error }] = useAiMemoryDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiMemoryDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AiMemoryDeleteMutation, AiMemoryDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiMemoryDeleteMutation, AiMemoryDeleteMutationVariables>(AiMemoryDeleteDocument, options);
      }
export type AiMemoryDeleteMutationHookResult = ReturnType<typeof useAiMemoryDeleteMutation>;
export type AiMemoryDeleteMutationResult = Apollo.MutationResult<AiMemoryDeleteMutation>;
export type AiMemoryDeleteMutationOptions = Apollo.BaseMutationOptions<AiMemoryDeleteMutation, AiMemoryDeleteMutationVariables>;
export const AtsInterviewDefinitionsDocument = gql`
    query AtsInterviewDefinitions($input: AtsInterviewDefinitionsInput!) {
  atsInterviewDefinitions(input: $input) {
    atsInterviewDefinitions {
      ...AtsInterviewDefinition
    }
  }
}
    ${AtsInterviewDefinitionFragmentDoc}`;

/**
 * __useAtsInterviewDefinitionsQuery__
 *
 * To run a query within a React component, call `useAtsInterviewDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsInterviewDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsInterviewDefinitionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsInterviewDefinitionsQuery(baseOptions: Apollo.QueryHookOptions<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables> & ({ variables: AtsInterviewDefinitionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>(AtsInterviewDefinitionsDocument, options);
      }
export function useAtsInterviewDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>(AtsInterviewDefinitionsDocument, options);
        }
// @ts-ignore
export function useAtsInterviewDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>;
export function useAtsInterviewDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsInterviewDefinitionsQuery | undefined, AtsInterviewDefinitionsQueryVariables>;
export function useAtsInterviewDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>(AtsInterviewDefinitionsDocument, options);
        }
export type AtsInterviewDefinitionsQueryHookResult = ReturnType<typeof useAtsInterviewDefinitionsQuery>;
export type AtsInterviewDefinitionsLazyQueryHookResult = ReturnType<typeof useAtsInterviewDefinitionsLazyQuery>;
export type AtsInterviewDefinitionsSuspenseQueryHookResult = ReturnType<typeof useAtsInterviewDefinitionsSuspenseQuery>;
export type AtsInterviewDefinitionsQueryResult = Apollo.QueryResult<AtsInterviewDefinitionsQuery, AtsInterviewDefinitionsQueryVariables>;
export const AtsInterviewDefinitionsByIdsDocument = gql`
    query AtsInterviewDefinitionsByIds($input: AtsInterviewDefinitionsByIdsInput!) {
  atsInterviewDefinitionsByIds(input: $input) {
    atsInterviewDefinitions {
      ...AtsInterviewDefinition
    }
  }
}
    ${AtsInterviewDefinitionFragmentDoc}`;

/**
 * __useAtsInterviewDefinitionsByIdsQuery__
 *
 * To run a query within a React component, call `useAtsInterviewDefinitionsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsInterviewDefinitionsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsInterviewDefinitionsByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsInterviewDefinitionsByIdsQuery(baseOptions: Apollo.QueryHookOptions<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables> & ({ variables: AtsInterviewDefinitionsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>(AtsInterviewDefinitionsByIdsDocument, options);
      }
export function useAtsInterviewDefinitionsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>(AtsInterviewDefinitionsByIdsDocument, options);
        }
// @ts-ignore
export function useAtsInterviewDefinitionsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>;
export function useAtsInterviewDefinitionsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsInterviewDefinitionsByIdsQuery | undefined, AtsInterviewDefinitionsByIdsQueryVariables>;
export function useAtsInterviewDefinitionsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>(AtsInterviewDefinitionsByIdsDocument, options);
        }
export type AtsInterviewDefinitionsByIdsQueryHookResult = ReturnType<typeof useAtsInterviewDefinitionsByIdsQuery>;
export type AtsInterviewDefinitionsByIdsLazyQueryHookResult = ReturnType<typeof useAtsInterviewDefinitionsByIdsLazyQuery>;
export type AtsInterviewDefinitionsByIdsSuspenseQueryHookResult = ReturnType<typeof useAtsInterviewDefinitionsByIdsSuspenseQuery>;
export type AtsInterviewDefinitionsByIdsQueryResult = Apollo.QueryResult<AtsInterviewDefinitionsByIdsQuery, AtsInterviewDefinitionsByIdsQueryVariables>;
export const CompanyHolidaysForDaysDocument = gql`
    query CompanyHolidaysForDays($input: CompanyHolidaysForDaysInput!) {
  companyHolidaysForDays(input: $input) {
    items {
      date
      companyHolidays {
        ...CompanyHolidayIcon_companyHolidays
      }
    }
  }
}
    ${CompanyHolidayIcon_CompanyHolidaysFragmentDoc}`;

/**
 * __useCompanyHolidaysForDaysQuery__
 *
 * To run a query within a React component, call `useCompanyHolidaysForDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHolidaysForDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHolidaysForDaysQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyHolidaysForDaysQuery(baseOptions: Apollo.QueryHookOptions<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables> & ({ variables: CompanyHolidaysForDaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>(CompanyHolidaysForDaysDocument, options);
      }
export function useCompanyHolidaysForDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>(CompanyHolidaysForDaysDocument, options);
        }
// @ts-ignore
export function useCompanyHolidaysForDaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>;
export function useCompanyHolidaysForDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyHolidaysForDaysQuery | undefined, CompanyHolidaysForDaysQueryVariables>;
export function useCompanyHolidaysForDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>(CompanyHolidaysForDaysDocument, options);
        }
export type CompanyHolidaysForDaysQueryHookResult = ReturnType<typeof useCompanyHolidaysForDaysQuery>;
export type CompanyHolidaysForDaysLazyQueryHookResult = ReturnType<typeof useCompanyHolidaysForDaysLazyQuery>;
export type CompanyHolidaysForDaysSuspenseQueryHookResult = ReturnType<typeof useCompanyHolidaysForDaysSuspenseQuery>;
export type CompanyHolidaysForDaysQueryResult = Apollo.QueryResult<CompanyHolidaysForDaysQuery, CompanyHolidaysForDaysQueryVariables>;
export const VisibilitySelectFixIssuesDocument = gql`
    query VisibilitySelectFixIssues($input: JobStagesInput!) {
  jobStages(input: $input) {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useVisibilitySelectFixIssuesQuery__
 *
 * To run a query within a React component, call `useVisibilitySelectFixIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibilitySelectFixIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibilitySelectFixIssuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisibilitySelectFixIssuesQuery(baseOptions: Apollo.QueryHookOptions<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables> & ({ variables: VisibilitySelectFixIssuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>(VisibilitySelectFixIssuesDocument, options);
      }
export function useVisibilitySelectFixIssuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>(VisibilitySelectFixIssuesDocument, options);
        }
// @ts-ignore
export function useVisibilitySelectFixIssuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>): Apollo.UseSuspenseQueryResult<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>;
export function useVisibilitySelectFixIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>): Apollo.UseSuspenseQueryResult<VisibilitySelectFixIssuesQuery | undefined, VisibilitySelectFixIssuesQueryVariables>;
export function useVisibilitySelectFixIssuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>(VisibilitySelectFixIssuesDocument, options);
        }
export type VisibilitySelectFixIssuesQueryHookResult = ReturnType<typeof useVisibilitySelectFixIssuesQuery>;
export type VisibilitySelectFixIssuesLazyQueryHookResult = ReturnType<typeof useVisibilitySelectFixIssuesLazyQuery>;
export type VisibilitySelectFixIssuesSuspenseQueryHookResult = ReturnType<typeof useVisibilitySelectFixIssuesSuspenseQuery>;
export type VisibilitySelectFixIssuesQueryResult = Apollo.QueryResult<VisibilitySelectFixIssuesQuery, VisibilitySelectFixIssuesQueryVariables>;
export const VisibilitySelectJobStagesDocument = gql`
    query VisibilitySelectJobStages($input: JobStagesInput!) {
  jobStages(input: $input) {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useVisibilitySelectJobStagesQuery__
 *
 * To run a query within a React component, call `useVisibilitySelectJobStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisibilitySelectJobStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisibilitySelectJobStagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVisibilitySelectJobStagesQuery(baseOptions: Apollo.QueryHookOptions<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables> & ({ variables: VisibilitySelectJobStagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>(VisibilitySelectJobStagesDocument, options);
      }
export function useVisibilitySelectJobStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>(VisibilitySelectJobStagesDocument, options);
        }
// @ts-ignore
export function useVisibilitySelectJobStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>): Apollo.UseSuspenseQueryResult<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>;
export function useVisibilitySelectJobStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>): Apollo.UseSuspenseQueryResult<VisibilitySelectJobStagesQuery | undefined, VisibilitySelectJobStagesQueryVariables>;
export function useVisibilitySelectJobStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>(VisibilitySelectJobStagesDocument, options);
        }
export type VisibilitySelectJobStagesQueryHookResult = ReturnType<typeof useVisibilitySelectJobStagesQuery>;
export type VisibilitySelectJobStagesLazyQueryHookResult = ReturnType<typeof useVisibilitySelectJobStagesLazyQuery>;
export type VisibilitySelectJobStagesSuspenseQueryHookResult = ReturnType<typeof useVisibilitySelectJobStagesSuspenseQuery>;
export type VisibilitySelectJobStagesQueryResult = Apollo.QueryResult<VisibilitySelectJobStagesQuery, VisibilitySelectJobStagesQueryVariables>;
export const CountryAttributeDocument = gql`
    query CountryAttribute($input: EmployeeAttributeNamesInput!) {
  employeeAttributeNames(input: $input) {
    items {
      id
      values {
        id
        value
      }
    }
  }
}
    `;

/**
 * __useCountryAttributeQuery__
 *
 * To run a query within a React component, call `useCountryAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryAttributeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryAttributeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCountryAttributeQuery(baseOptions: Apollo.QueryHookOptions<CountryAttributeQuery, CountryAttributeQueryVariables> & ({ variables: CountryAttributeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountryAttributeQuery, CountryAttributeQueryVariables>(CountryAttributeDocument, options);
      }
export function useCountryAttributeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountryAttributeQuery, CountryAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountryAttributeQuery, CountryAttributeQueryVariables>(CountryAttributeDocument, options);
        }
// @ts-ignore
export function useCountryAttributeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountryAttributeQuery, CountryAttributeQueryVariables>): Apollo.UseSuspenseQueryResult<CountryAttributeQuery, CountryAttributeQueryVariables>;
export function useCountryAttributeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountryAttributeQuery, CountryAttributeQueryVariables>): Apollo.UseSuspenseQueryResult<CountryAttributeQuery | undefined, CountryAttributeQueryVariables>;
export function useCountryAttributeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountryAttributeQuery, CountryAttributeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountryAttributeQuery, CountryAttributeQueryVariables>(CountryAttributeDocument, options);
        }
export type CountryAttributeQueryHookResult = ReturnType<typeof useCountryAttributeQuery>;
export type CountryAttributeLazyQueryHookResult = ReturnType<typeof useCountryAttributeLazyQuery>;
export type CountryAttributeSuspenseQueryHookResult = ReturnType<typeof useCountryAttributeSuspenseQuery>;
export type CountryAttributeQueryResult = Apollo.QueryResult<CountryAttributeQuery, CountryAttributeQueryVariables>;
export const DebriefAtsWriteCapabilityDocument = gql`
    query DebriefAtsWriteCapability {
  thisOrg {
    id
    canSendDebriefToAts
  }
}
    `;

/**
 * __useDebriefAtsWriteCapabilityQuery__
 *
 * To run a query within a React component, call `useDebriefAtsWriteCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefAtsWriteCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefAtsWriteCapabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useDebriefAtsWriteCapabilityQuery(baseOptions?: Apollo.QueryHookOptions<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>(DebriefAtsWriteCapabilityDocument, options);
      }
export function useDebriefAtsWriteCapabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>(DebriefAtsWriteCapabilityDocument, options);
        }
// @ts-ignore
export function useDebriefAtsWriteCapabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>;
export function useDebriefAtsWriteCapabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefAtsWriteCapabilityQuery | undefined, DebriefAtsWriteCapabilityQueryVariables>;
export function useDebriefAtsWriteCapabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>(DebriefAtsWriteCapabilityDocument, options);
        }
export type DebriefAtsWriteCapabilityQueryHookResult = ReturnType<typeof useDebriefAtsWriteCapabilityQuery>;
export type DebriefAtsWriteCapabilityLazyQueryHookResult = ReturnType<typeof useDebriefAtsWriteCapabilityLazyQuery>;
export type DebriefAtsWriteCapabilitySuspenseQueryHookResult = ReturnType<typeof useDebriefAtsWriteCapabilitySuspenseQuery>;
export type DebriefAtsWriteCapabilityQueryResult = Apollo.QueryResult<DebriefAtsWriteCapabilityQuery, DebriefAtsWriteCapabilityQueryVariables>;
export const DebriefContentInterviewMenuDocument = gql`
    query DebriefContentInterviewMenu($input: TemplateTokenInput!, $zoomMeetingInfoInput: TokenZoomMeetingInput!) {
  templateToken(input: $input) {
    ZOOM_MEETING_INFO(input: $zoomMeetingInfoInput)
    ZOOM_MEETING_DIAL_IN_INFO(input: $zoomMeetingInfoInput)
  }
}
    `;

/**
 * __useDebriefContentInterviewMenuQuery__
 *
 * To run a query within a React component, call `useDebriefContentInterviewMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefContentInterviewMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefContentInterviewMenuQuery({
 *   variables: {
 *      input: // value for 'input'
 *      zoomMeetingInfoInput: // value for 'zoomMeetingInfoInput'
 *   },
 * });
 */
export function useDebriefContentInterviewMenuQuery(baseOptions: Apollo.QueryHookOptions<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables> & ({ variables: DebriefContentInterviewMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>(DebriefContentInterviewMenuDocument, options);
      }
export function useDebriefContentInterviewMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>(DebriefContentInterviewMenuDocument, options);
        }
// @ts-ignore
export function useDebriefContentInterviewMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>;
export function useDebriefContentInterviewMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefContentInterviewMenuQuery | undefined, DebriefContentInterviewMenuQueryVariables>;
export function useDebriefContentInterviewMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>(DebriefContentInterviewMenuDocument, options);
        }
export type DebriefContentInterviewMenuQueryHookResult = ReturnType<typeof useDebriefContentInterviewMenuQuery>;
export type DebriefContentInterviewMenuLazyQueryHookResult = ReturnType<typeof useDebriefContentInterviewMenuLazyQuery>;
export type DebriefContentInterviewMenuSuspenseQueryHookResult = ReturnType<typeof useDebriefContentInterviewMenuSuspenseQuery>;
export type DebriefContentInterviewMenuQueryResult = Apollo.QueryResult<DebriefContentInterviewMenuQuery, DebriefContentInterviewMenuQueryVariables>;
export const EmployeeListDocument = gql`
    query EmployeeList($input: EmployeeSearchInput!) {
  employeeSearch(input: $input) {
    total
    items {
      ...Employee
      upcomingInterviewsCount
      modulesTrainedCount
      modulesInTrainingCount
    }
  }
}
    ${EmployeeFragmentDoc}`;

/**
 * __useEmployeeListQuery__
 *
 * To run a query within a React component, call `useEmployeeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeListQuery(baseOptions: Apollo.QueryHookOptions<EmployeeListQuery, EmployeeListQueryVariables> & ({ variables: EmployeeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeListQuery, EmployeeListQueryVariables>(EmployeeListDocument, options);
      }
export function useEmployeeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeListQuery, EmployeeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeListQuery, EmployeeListQueryVariables>(EmployeeListDocument, options);
        }
// @ts-ignore
export function useEmployeeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeListQuery, EmployeeListQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeListQuery, EmployeeListQueryVariables>;
export function useEmployeeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeListQuery, EmployeeListQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeListQuery | undefined, EmployeeListQueryVariables>;
export function useEmployeeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeListQuery, EmployeeListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeListQuery, EmployeeListQueryVariables>(EmployeeListDocument, options);
        }
export type EmployeeListQueryHookResult = ReturnType<typeof useEmployeeListQuery>;
export type EmployeeListLazyQueryHookResult = ReturnType<typeof useEmployeeListLazyQuery>;
export type EmployeeListSuspenseQueryHookResult = ReturnType<typeof useEmployeeListSuspenseQuery>;
export type EmployeeListQueryResult = Apollo.QueryResult<EmployeeListQuery, EmployeeListQueryVariables>;
export const EmployeesDocument = gql`
    query Employees($input: EmployeesInput!) {
  employees(input: $input) {
    nextCursor
    items {
      ...Employee
    }
  }
}
    ${EmployeeFragmentDoc}`;

/**
 * __useEmployeesQuery__
 *
 * To run a query within a React component, call `useEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeesQuery(baseOptions: Apollo.QueryHookOptions<EmployeesQuery, EmployeesQueryVariables> & ({ variables: EmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
      }
export function useEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
// @ts-ignore
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesQuery, EmployeesQueryVariables>;
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesQuery | undefined, EmployeesQueryVariables>;
export function useEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesQuery, EmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesQuery, EmployeesQueryVariables>(EmployeesDocument, options);
        }
export type EmployeesQueryHookResult = ReturnType<typeof useEmployeesQuery>;
export type EmployeesLazyQueryHookResult = ReturnType<typeof useEmployeesLazyQuery>;
export type EmployeesSuspenseQueryHookResult = ReturnType<typeof useEmployeesSuspenseQuery>;
export type EmployeesQueryResult = Apollo.QueryResult<EmployeesQuery, EmployeesQueryVariables>;
export const EmployeeByIdsDocument = gql`
    query EmployeeByIds($input: [uuid!]!) {
  employeeByIds(ids: $input) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;

/**
 * __useEmployeeByIdsQuery__
 *
 * To run a query within a React component, call `useEmployeeByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeByIdsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeByIdsQuery, EmployeeByIdsQueryVariables> & ({ variables: EmployeeByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>(EmployeeByIdsDocument, options);
      }
export function useEmployeeByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>(EmployeeByIdsDocument, options);
        }
// @ts-ignore
export function useEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>;
export function useEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeByIdsQuery | undefined, EmployeeByIdsQueryVariables>;
export function useEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>(EmployeeByIdsDocument, options);
        }
export type EmployeeByIdsQueryHookResult = ReturnType<typeof useEmployeeByIdsQuery>;
export type EmployeeByIdsLazyQueryHookResult = ReturnType<typeof useEmployeeByIdsLazyQuery>;
export type EmployeeByIdsSuspenseQueryHookResult = ReturnType<typeof useEmployeeByIdsSuspenseQuery>;
export type EmployeeByIdsQueryResult = Apollo.QueryResult<EmployeeByIdsQuery, EmployeeByIdsQueryVariables>;
export const EmployeeDetailsDocument = gql`
    query EmployeeDetails($id: uuid!) {
  employee(id: $id) {
    ...EmployeeDetailsFragment
  }
}
    ${EmployeeDetailsFragmentFragmentDoc}`;

/**
 * __useEmployeeDetailsQuery__
 *
 * To run a query within a React component, call `useEmployeeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeDetailsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables> & ({ variables: EmployeeDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>(EmployeeDetailsDocument, options);
      }
export function useEmployeeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>(EmployeeDetailsDocument, options);
        }
// @ts-ignore
export function useEmployeeDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>;
export function useEmployeeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeDetailsQuery | undefined, EmployeeDetailsQueryVariables>;
export function useEmployeeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>(EmployeeDetailsDocument, options);
        }
export type EmployeeDetailsQueryHookResult = ReturnType<typeof useEmployeeDetailsQuery>;
export type EmployeeDetailsLazyQueryHookResult = ReturnType<typeof useEmployeeDetailsLazyQuery>;
export type EmployeeDetailsSuspenseQueryHookResult = ReturnType<typeof useEmployeeDetailsSuspenseQuery>;
export type EmployeeDetailsQueryResult = Apollo.QueryResult<EmployeeDetailsQuery, EmployeeDetailsQueryVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($input: EmployeeUpdateInput!) {
  employeeUpdate(input: $input) {
    employee {
      ...Employee
    }
  }
}
    ${EmployeeFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const EmployeesWorkHoursDocument = gql`
    query EmployeesWorkHours($ids: [uuid!]!) {
  employeeByIds(ids: $ids) {
    id
    timezone
    ...EmployeeWorkHours
  }
}
    ${EmployeeWorkHoursFragmentDoc}`;

/**
 * __useEmployeesWorkHoursQuery__
 *
 * To run a query within a React component, call `useEmployeesWorkHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesWorkHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesWorkHoursQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEmployeesWorkHoursQuery(baseOptions: Apollo.QueryHookOptions<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables> & ({ variables: EmployeesWorkHoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>(EmployeesWorkHoursDocument, options);
      }
export function useEmployeesWorkHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>(EmployeesWorkHoursDocument, options);
        }
// @ts-ignore
export function useEmployeesWorkHoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>;
export function useEmployeesWorkHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesWorkHoursQuery | undefined, EmployeesWorkHoursQueryVariables>;
export function useEmployeesWorkHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>(EmployeesWorkHoursDocument, options);
        }
export type EmployeesWorkHoursQueryHookResult = ReturnType<typeof useEmployeesWorkHoursQuery>;
export type EmployeesWorkHoursLazyQueryHookResult = ReturnType<typeof useEmployeesWorkHoursLazyQuery>;
export type EmployeesWorkHoursSuspenseQueryHookResult = ReturnType<typeof useEmployeesWorkHoursSuspenseQuery>;
export type EmployeesWorkHoursQueryResult = Apollo.QueryResult<EmployeesWorkHoursQuery, EmployeesWorkHoursQueryVariables>;
export const EmployeePickerListDocument = gql`
    query EmployeePickerList($input: EmployeeSearchInput!) {
  employeeSearch(input: $input) {
    total
    items {
      ...EmployeePicker_employee
    }
  }
}
    ${EmployeePicker_EmployeeFragmentDoc}`;

/**
 * __useEmployeePickerListQuery__
 *
 * To run a query within a React component, call `useEmployeePickerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePickerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePickerListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeePickerListQuery(baseOptions: Apollo.QueryHookOptions<EmployeePickerListQuery, EmployeePickerListQueryVariables> & ({ variables: EmployeePickerListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePickerListQuery, EmployeePickerListQueryVariables>(EmployeePickerListDocument, options);
      }
export function useEmployeePickerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePickerListQuery, EmployeePickerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePickerListQuery, EmployeePickerListQueryVariables>(EmployeePickerListDocument, options);
        }
// @ts-ignore
export function useEmployeePickerListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePickerListQuery, EmployeePickerListQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeePickerListQuery, EmployeePickerListQueryVariables>;
export function useEmployeePickerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeePickerListQuery, EmployeePickerListQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeePickerListQuery | undefined, EmployeePickerListQueryVariables>;
export function useEmployeePickerListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeePickerListQuery, EmployeePickerListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePickerListQuery, EmployeePickerListQueryVariables>(EmployeePickerListDocument, options);
        }
export type EmployeePickerListQueryHookResult = ReturnType<typeof useEmployeePickerListQuery>;
export type EmployeePickerListLazyQueryHookResult = ReturnType<typeof useEmployeePickerListLazyQuery>;
export type EmployeePickerListSuspenseQueryHookResult = ReturnType<typeof useEmployeePickerListSuspenseQuery>;
export type EmployeePickerListQueryResult = Apollo.QueryResult<EmployeePickerListQuery, EmployeePickerListQueryVariables>;
export const AttributesDocument = gql`
    query Attributes($input: EmployeeAttributeNamesInput!) {
  employeeAttributeNames(input: $input) {
    items {
      id
      name
      values {
        id
        name: value
        attribute: name {
          name
          id
          type
          syncSourceType
        }
      }
    }
  }
}
    `;

/**
 * __useAttributesQuery__
 *
 * To run a query within a React component, call `useAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributesQuery(baseOptions: Apollo.QueryHookOptions<AttributesQuery, AttributesQueryVariables> & ({ variables: AttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
      }
export function useAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributesQuery, AttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
        }
// @ts-ignore
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttributesQuery, AttributesQueryVariables>): Apollo.UseSuspenseQueryResult<AttributesQuery, AttributesQueryVariables>;
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributesQuery, AttributesQueryVariables>): Apollo.UseSuspenseQueryResult<AttributesQuery | undefined, AttributesQueryVariables>;
export function useAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributesQuery, AttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttributesQuery, AttributesQueryVariables>(AttributesDocument, options);
        }
export type AttributesQueryHookResult = ReturnType<typeof useAttributesQuery>;
export type AttributesLazyQueryHookResult = ReturnType<typeof useAttributesLazyQuery>;
export type AttributesSuspenseQueryHookResult = ReturnType<typeof useAttributesSuspenseQuery>;
export type AttributesQueryResult = Apollo.QueryResult<AttributesQuery, AttributesQueryVariables>;
export const JobStagesByNameDocument = gql`
    query JobStagesByName($input: JobStagesInput!) {
  jobStagesByName(input: $input) {
    items
    nextCursor
  }
}
    `;

/**
 * __useJobStagesByNameQuery__
 *
 * To run a query within a React component, call `useJobStagesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStagesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStagesByNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobStagesByNameQuery(baseOptions: Apollo.QueryHookOptions<JobStagesByNameQuery, JobStagesByNameQueryVariables> & ({ variables: JobStagesByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStagesByNameQuery, JobStagesByNameQueryVariables>(JobStagesByNameDocument, options);
      }
export function useJobStagesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStagesByNameQuery, JobStagesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStagesByNameQuery, JobStagesByNameQueryVariables>(JobStagesByNameDocument, options);
        }
// @ts-ignore
export function useJobStagesByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStagesByNameQuery, JobStagesByNameQueryVariables>): Apollo.UseSuspenseQueryResult<JobStagesByNameQuery, JobStagesByNameQueryVariables>;
export function useJobStagesByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStagesByNameQuery, JobStagesByNameQueryVariables>): Apollo.UseSuspenseQueryResult<JobStagesByNameQuery | undefined, JobStagesByNameQueryVariables>;
export function useJobStagesByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStagesByNameQuery, JobStagesByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStagesByNameQuery, JobStagesByNameQueryVariables>(JobStagesByNameDocument, options);
        }
export type JobStagesByNameQueryHookResult = ReturnType<typeof useJobStagesByNameQuery>;
export type JobStagesByNameLazyQueryHookResult = ReturnType<typeof useJobStagesByNameLazyQuery>;
export type JobStagesByNameSuspenseQueryHookResult = ReturnType<typeof useJobStagesByNameSuspenseQuery>;
export type JobStagesByNameQueryResult = Apollo.QueryResult<JobStagesByNameQuery, JobStagesByNameQueryVariables>;
export const JobsByIdsDocument = gql`
    query JobsByIds($ids: [uuid!]!) {
  jobByIds(ids: $ids) {
    id
    name
    status
    atsJob {
      atsCustomerFriendlyId
    }
  }
}
    `;

/**
 * __useJobsByIdsQuery__
 *
 * To run a query within a React component, call `useJobsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useJobsByIdsQuery(baseOptions: Apollo.QueryHookOptions<JobsByIdsQuery, JobsByIdsQueryVariables> & ({ variables: JobsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsByIdsQuery, JobsByIdsQueryVariables>(JobsByIdsDocument, options);
      }
export function useJobsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsByIdsQuery, JobsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsByIdsQuery, JobsByIdsQueryVariables>(JobsByIdsDocument, options);
        }
// @ts-ignore
export function useJobsByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobsByIdsQuery, JobsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<JobsByIdsQuery, JobsByIdsQueryVariables>;
export function useJobsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsByIdsQuery, JobsByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<JobsByIdsQuery | undefined, JobsByIdsQueryVariables>;
export function useJobsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsByIdsQuery, JobsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobsByIdsQuery, JobsByIdsQueryVariables>(JobsByIdsDocument, options);
        }
export type JobsByIdsQueryHookResult = ReturnType<typeof useJobsByIdsQuery>;
export type JobsByIdsLazyQueryHookResult = ReturnType<typeof useJobsByIdsLazyQuery>;
export type JobsByIdsSuspenseQueryHookResult = ReturnType<typeof useJobsByIdsSuspenseQuery>;
export type JobsByIdsQueryResult = Apollo.QueryResult<JobsByIdsQuery, JobsByIdsQueryVariables>;
export const CandidateListJobsDocument = gql`
    query CandidateListJobs($input: JobsInput!) {
  jobs(input: $input) {
    items {
      id
      name
      status
      atsJob {
        atsCustomerFriendlyId
      }
    }
    nextCursor
  }
}
    `;

/**
 * __useCandidateListJobsQuery__
 *
 * To run a query within a React component, call `useCandidateListJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateListJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateListJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateListJobsQuery(baseOptions: Apollo.QueryHookOptions<CandidateListJobsQuery, CandidateListJobsQueryVariables> & ({ variables: CandidateListJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateListJobsQuery, CandidateListJobsQueryVariables>(CandidateListJobsDocument, options);
      }
export function useCandidateListJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateListJobsQuery, CandidateListJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateListJobsQuery, CandidateListJobsQueryVariables>(CandidateListJobsDocument, options);
        }
// @ts-ignore
export function useCandidateListJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateListJobsQuery, CandidateListJobsQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateListJobsQuery, CandidateListJobsQueryVariables>;
export function useCandidateListJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateListJobsQuery, CandidateListJobsQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateListJobsQuery | undefined, CandidateListJobsQueryVariables>;
export function useCandidateListJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateListJobsQuery, CandidateListJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateListJobsQuery, CandidateListJobsQueryVariables>(CandidateListJobsDocument, options);
        }
export type CandidateListJobsQueryHookResult = ReturnType<typeof useCandidateListJobsQuery>;
export type CandidateListJobsLazyQueryHookResult = ReturnType<typeof useCandidateListJobsLazyQuery>;
export type CandidateListJobsSuspenseQueryHookResult = ReturnType<typeof useCandidateListJobsSuspenseQuery>;
export type CandidateListJobsQueryResult = Apollo.QueryResult<CandidateListJobsQuery, CandidateListJobsQueryVariables>;
export const ManagersDocument = gql`
    query Managers($input: ManagersInput!) {
  managers(input: $input) {
    items {
      id
      internalProfilePictureUrl
      fullName
    }
    nextCursor
  }
}
    `;

/**
 * __useManagersQuery__
 *
 * To run a query within a React component, call `useManagersQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManagersQuery(baseOptions: Apollo.QueryHookOptions<ManagersQuery, ManagersQueryVariables> & ({ variables: ManagersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagersQuery, ManagersQueryVariables>(ManagersDocument, options);
      }
export function useManagersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagersQuery, ManagersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagersQuery, ManagersQueryVariables>(ManagersDocument, options);
        }
// @ts-ignore
export function useManagersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ManagersQuery, ManagersQueryVariables>): Apollo.UseSuspenseQueryResult<ManagersQuery, ManagersQueryVariables>;
export function useManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagersQuery, ManagersQueryVariables>): Apollo.UseSuspenseQueryResult<ManagersQuery | undefined, ManagersQueryVariables>;
export function useManagersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ManagersQuery, ManagersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ManagersQuery, ManagersQueryVariables>(ManagersDocument, options);
        }
export type ManagersQueryHookResult = ReturnType<typeof useManagersQuery>;
export type ManagersLazyQueryHookResult = ReturnType<typeof useManagersLazyQuery>;
export type ManagersSuspenseQueryHookResult = ReturnType<typeof useManagersSuspenseQuery>;
export type ManagersQueryResult = Apollo.QueryResult<ManagersQuery, ManagersQueryVariables>;
export const ListSelectedManagersByIdsDocument = gql`
    query ListSelectedManagersByIds($ids: [uuid!]!) {
  employeeByIds(ids: $ids) {
    id
    internalProfilePictureUrl
    fullName
  }
}
    `;

/**
 * __useListSelectedManagersByIdsQuery__
 *
 * To run a query within a React component, call `useListSelectedManagersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSelectedManagersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSelectedManagersByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useListSelectedManagersByIdsQuery(baseOptions: Apollo.QueryHookOptions<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables> & ({ variables: ListSelectedManagersByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>(ListSelectedManagersByIdsDocument, options);
      }
export function useListSelectedManagersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>(ListSelectedManagersByIdsDocument, options);
        }
// @ts-ignore
export function useListSelectedManagersByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>;
export function useListSelectedManagersByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSelectedManagersByIdsQuery | undefined, ListSelectedManagersByIdsQueryVariables>;
export function useListSelectedManagersByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>(ListSelectedManagersByIdsDocument, options);
        }
export type ListSelectedManagersByIdsQueryHookResult = ReturnType<typeof useListSelectedManagersByIdsQuery>;
export type ListSelectedManagersByIdsLazyQueryHookResult = ReturnType<typeof useListSelectedManagersByIdsLazyQuery>;
export type ListSelectedManagersByIdsSuspenseQueryHookResult = ReturnType<typeof useListSelectedManagersByIdsSuspenseQuery>;
export type ListSelectedManagersByIdsQueryResult = Apollo.QueryResult<ListSelectedManagersByIdsQuery, ListSelectedManagersByIdsQueryVariables>;
export const InterviewModulesSelectDocument = gql`
    query InterviewModulesSelect($input: InterviewModuleSearchInput!) {
  interviewModuleSearch(input: $input) {
    total
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useInterviewModulesSelectQuery__
 *
 * To run a query within a React component, call `useInterviewModulesSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModulesSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModulesSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModulesSelectQuery(baseOptions: Apollo.QueryHookOptions<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables> & ({ variables: InterviewModulesSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>(InterviewModulesSelectDocument, options);
      }
export function useInterviewModulesSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>(InterviewModulesSelectDocument, options);
        }
// @ts-ignore
export function useInterviewModulesSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>;
export function useInterviewModulesSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModulesSelectQuery | undefined, InterviewModulesSelectQueryVariables>;
export function useInterviewModulesSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>(InterviewModulesSelectDocument, options);
        }
export type InterviewModulesSelectQueryHookResult = ReturnType<typeof useInterviewModulesSelectQuery>;
export type InterviewModulesSelectLazyQueryHookResult = ReturnType<typeof useInterviewModulesSelectLazyQuery>;
export type InterviewModulesSelectSuspenseQueryHookResult = ReturnType<typeof useInterviewModulesSelectSuspenseQuery>;
export type InterviewModulesSelectQueryResult = Apollo.QueryResult<InterviewModulesSelectQuery, InterviewModulesSelectQueryVariables>;
export const ListSelectedModulesByIdDocument = gql`
    query ListSelectedModulesById($ids: [uuid!]!) {
  interviewModuleByIds(ids: $ids) {
    id
    name
  }
}
    `;

/**
 * __useListSelectedModulesByIdQuery__
 *
 * To run a query within a React component, call `useListSelectedModulesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSelectedModulesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSelectedModulesByIdQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useListSelectedModulesByIdQuery(baseOptions: Apollo.QueryHookOptions<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables> & ({ variables: ListSelectedModulesByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>(ListSelectedModulesByIdDocument, options);
      }
export function useListSelectedModulesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>(ListSelectedModulesByIdDocument, options);
        }
// @ts-ignore
export function useListSelectedModulesByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>;
export function useListSelectedModulesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ListSelectedModulesByIdQuery | undefined, ListSelectedModulesByIdQueryVariables>;
export function useListSelectedModulesByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>(ListSelectedModulesByIdDocument, options);
        }
export type ListSelectedModulesByIdQueryHookResult = ReturnType<typeof useListSelectedModulesByIdQuery>;
export type ListSelectedModulesByIdLazyQueryHookResult = ReturnType<typeof useListSelectedModulesByIdLazyQuery>;
export type ListSelectedModulesByIdSuspenseQueryHookResult = ReturnType<typeof useListSelectedModulesByIdSuspenseQuery>;
export type ListSelectedModulesByIdQueryResult = Apollo.QueryResult<ListSelectedModulesByIdQuery, ListSelectedModulesByIdQueryVariables>;
export const TaskQueuesFilterDocument = gql`
    query TaskQueuesFilter($input: TaskQueueSearchInput!) {
  taskQueueSearch(input: $input) {
    items {
      id
      name
      memberCount
    }
    total
    hasNext
  }
}
    `;

/**
 * __useTaskQueuesFilterQuery__
 *
 * To run a query within a React component, call `useTaskQueuesFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQueuesFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQueuesFilterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskQueuesFilterQuery(baseOptions: Apollo.QueryHookOptions<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables> & ({ variables: TaskQueuesFilterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>(TaskQueuesFilterDocument, options);
      }
export function useTaskQueuesFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>(TaskQueuesFilterDocument, options);
        }
// @ts-ignore
export function useTaskQueuesFilterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>;
export function useTaskQueuesFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueuesFilterQuery | undefined, TaskQueuesFilterQueryVariables>;
export function useTaskQueuesFilterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>(TaskQueuesFilterDocument, options);
        }
export type TaskQueuesFilterQueryHookResult = ReturnType<typeof useTaskQueuesFilterQuery>;
export type TaskQueuesFilterLazyQueryHookResult = ReturnType<typeof useTaskQueuesFilterLazyQuery>;
export type TaskQueuesFilterSuspenseQueryHookResult = ReturnType<typeof useTaskQueuesFilterSuspenseQuery>;
export type TaskQueuesFilterQueryResult = Apollo.QueryResult<TaskQueuesFilterQuery, TaskQueuesFilterQueryVariables>;
export const TaskQueueByIdsDocument = gql`
    query TaskQueueByIds($input: [uuid!]!) {
  taskQueueByIds(ids: $input) {
    id
    name
    memberCount
  }
}
    `;

/**
 * __useTaskQueueByIdsQuery__
 *
 * To run a query within a React component, call `useTaskQueueByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQueueByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQueueByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskQueueByIdsQuery(baseOptions: Apollo.QueryHookOptions<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables> & ({ variables: TaskQueueByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>(TaskQueueByIdsDocument, options);
      }
export function useTaskQueueByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>(TaskQueueByIdsDocument, options);
        }
// @ts-ignore
export function useTaskQueueByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>;
export function useTaskQueueByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueueByIdsQuery | undefined, TaskQueueByIdsQueryVariables>;
export function useTaskQueueByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>(TaskQueueByIdsDocument, options);
        }
export type TaskQueueByIdsQueryHookResult = ReturnType<typeof useTaskQueueByIdsQuery>;
export type TaskQueueByIdsLazyQueryHookResult = ReturnType<typeof useTaskQueueByIdsLazyQuery>;
export type TaskQueueByIdsSuspenseQueryHookResult = ReturnType<typeof useTaskQueueByIdsSuspenseQuery>;
export type TaskQueueByIdsQueryResult = Apollo.QueryResult<TaskQueueByIdsQuery, TaskQueueByIdsQueryVariables>;
export const TaskTagsDocument = gql`
    query TaskTags {
  taskTags(input: {page: {offset: 0, limit: 100}}) {
    items {
      ...TaskTags_selectedTaskTag
    }
  }
}
    ${TaskTags_SelectedTaskTagFragmentDoc}`;

/**
 * __useTaskTagsQuery__
 *
 * To run a query within a React component, call `useTaskTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskTagsQuery(baseOptions?: Apollo.QueryHookOptions<TaskTagsQuery, TaskTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskTagsQuery, TaskTagsQueryVariables>(TaskTagsDocument, options);
      }
export function useTaskTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskTagsQuery, TaskTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskTagsQuery, TaskTagsQueryVariables>(TaskTagsDocument, options);
        }
// @ts-ignore
export function useTaskTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskTagsQuery, TaskTagsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTagsQuery, TaskTagsQueryVariables>;
export function useTaskTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTagsQuery, TaskTagsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTagsQuery | undefined, TaskTagsQueryVariables>;
export function useTaskTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTagsQuery, TaskTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskTagsQuery, TaskTagsQueryVariables>(TaskTagsDocument, options);
        }
export type TaskTagsQueryHookResult = ReturnType<typeof useTaskTagsQuery>;
export type TaskTagsLazyQueryHookResult = ReturnType<typeof useTaskTagsLazyQuery>;
export type TaskTagsSuspenseQueryHookResult = ReturnType<typeof useTaskTagsSuspenseQuery>;
export type TaskTagsQueryResult = Apollo.QueryResult<TaskTagsQuery, TaskTagsQueryVariables>;
export const VideoMeetingHostEmployeeValueDocument = gql`
    query VideoMeetingHostEmployeeValue($employeeId: uuid!) {
  employeeByIds(ids: [$employeeId]) {
    id
    fullName
    email
    internalProfilePictureUrl
  }
}
    `;

/**
 * __useVideoMeetingHostEmployeeValueQuery__
 *
 * To run a query within a React component, call `useVideoMeetingHostEmployeeValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoMeetingHostEmployeeValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoMeetingHostEmployeeValueQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useVideoMeetingHostEmployeeValueQuery(baseOptions: Apollo.QueryHookOptions<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables> & ({ variables: VideoMeetingHostEmployeeValueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>(VideoMeetingHostEmployeeValueDocument, options);
      }
export function useVideoMeetingHostEmployeeValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>(VideoMeetingHostEmployeeValueDocument, options);
        }
// @ts-ignore
export function useVideoMeetingHostEmployeeValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>): Apollo.UseSuspenseQueryResult<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>;
export function useVideoMeetingHostEmployeeValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>): Apollo.UseSuspenseQueryResult<VideoMeetingHostEmployeeValueQuery | undefined, VideoMeetingHostEmployeeValueQueryVariables>;
export function useVideoMeetingHostEmployeeValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>(VideoMeetingHostEmployeeValueDocument, options);
        }
export type VideoMeetingHostEmployeeValueQueryHookResult = ReturnType<typeof useVideoMeetingHostEmployeeValueQuery>;
export type VideoMeetingHostEmployeeValueLazyQueryHookResult = ReturnType<typeof useVideoMeetingHostEmployeeValueLazyQuery>;
export type VideoMeetingHostEmployeeValueSuspenseQueryHookResult = ReturnType<typeof useVideoMeetingHostEmployeeValueSuspenseQuery>;
export type VideoMeetingHostEmployeeValueQueryResult = Apollo.QueryResult<VideoMeetingHostEmployeeValueQuery, VideoMeetingHostEmployeeValueQueryVariables>;
export const EmployeesAndModulesSearchV2Document = gql`
    query EmployeesAndModulesSearchV2($employeeSearchInput: EmployeeSearchInput!, $moduleSearchInput: InterviewModuleSearchInput!) {
  employeeSearch(input: $employeeSearchInput) {
    items {
      ...BaseEditInterviewSeatModuleEmployeeSearchV2
    }
  }
  interviewModuleSearch(input: $moduleSearchInput) {
    items {
      ...BaseEditInterviewSeatModuleInterviewModuleSearchV2
    }
  }
}
    ${BaseEditInterviewSeatModuleEmployeeSearchV2FragmentDoc}
${BaseEditInterviewSeatModuleInterviewModuleSearchV2FragmentDoc}`;

/**
 * __useEmployeesAndModulesSearchV2Query__
 *
 * To run a query within a React component, call `useEmployeesAndModulesSearchV2Query` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesAndModulesSearchV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesAndModulesSearchV2Query({
 *   variables: {
 *      employeeSearchInput: // value for 'employeeSearchInput'
 *      moduleSearchInput: // value for 'moduleSearchInput'
 *   },
 * });
 */
export function useEmployeesAndModulesSearchV2Query(baseOptions: Apollo.QueryHookOptions<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables> & ({ variables: EmployeesAndModulesSearchV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>(EmployeesAndModulesSearchV2Document, options);
      }
export function useEmployeesAndModulesSearchV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>(EmployeesAndModulesSearchV2Document, options);
        }
// @ts-ignore
export function useEmployeesAndModulesSearchV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>;
export function useEmployeesAndModulesSearchV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesAndModulesSearchV2Query | undefined, EmployeesAndModulesSearchV2QueryVariables>;
export function useEmployeesAndModulesSearchV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>(EmployeesAndModulesSearchV2Document, options);
        }
export type EmployeesAndModulesSearchV2QueryHookResult = ReturnType<typeof useEmployeesAndModulesSearchV2Query>;
export type EmployeesAndModulesSearchV2LazyQueryHookResult = ReturnType<typeof useEmployeesAndModulesSearchV2LazyQuery>;
export type EmployeesAndModulesSearchV2SuspenseQueryHookResult = ReturnType<typeof useEmployeesAndModulesSearchV2SuspenseQuery>;
export type EmployeesAndModulesSearchV2QueryResult = Apollo.QueryResult<EmployeesAndModulesSearchV2Query, EmployeesAndModulesSearchV2QueryVariables>;
export const InterviewModuleMemberFilteredByAttributesV2Document = gql`
    query InterviewModuleMemberFilteredByAttributesV2($input: InterviewModuleMemberSearchInput!) {
  interviewModuleMemberSearch(input: $input) {
    items {
      ...EditModuleSeatInterviewModuleV2
    }
  }
}
    ${EditModuleSeatInterviewModuleV2FragmentDoc}`;

/**
 * __useInterviewModuleMemberFilteredByAttributesV2Query__
 *
 * To run a query within a React component, call `useInterviewModuleMemberFilteredByAttributesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberFilteredByAttributesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMemberFilteredByAttributesV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModuleMemberFilteredByAttributesV2Query(baseOptions: Apollo.QueryHookOptions<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables> & ({ variables: InterviewModuleMemberFilteredByAttributesV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>(InterviewModuleMemberFilteredByAttributesV2Document, options);
      }
export function useInterviewModuleMemberFilteredByAttributesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>(InterviewModuleMemberFilteredByAttributesV2Document, options);
        }
// @ts-ignore
export function useInterviewModuleMemberFilteredByAttributesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>;
export function useInterviewModuleMemberFilteredByAttributesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberFilteredByAttributesV2Query | undefined, InterviewModuleMemberFilteredByAttributesV2QueryVariables>;
export function useInterviewModuleMemberFilteredByAttributesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>(InterviewModuleMemberFilteredByAttributesV2Document, options);
        }
export type InterviewModuleMemberFilteredByAttributesV2QueryHookResult = ReturnType<typeof useInterviewModuleMemberFilteredByAttributesV2Query>;
export type InterviewModuleMemberFilteredByAttributesV2LazyQueryHookResult = ReturnType<typeof useInterviewModuleMemberFilteredByAttributesV2LazyQuery>;
export type InterviewModuleMemberFilteredByAttributesV2SuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMemberFilteredByAttributesV2SuspenseQuery>;
export type InterviewModuleMemberFilteredByAttributesV2QueryResult = Apollo.QueryResult<InterviewModuleMemberFilteredByAttributesV2Query, InterviewModuleMemberFilteredByAttributesV2QueryVariables>;
export const ModuleMemberStatsV2Document = gql`
    query ModuleMemberStatsV2 {
  interviewModuleMemberStats {
    interviewModule {
      ...EditModuleSeatInterviewStatsV2
    }
  }
}
    ${EditModuleSeatInterviewStatsV2FragmentDoc}`;

/**
 * __useModuleMemberStatsV2Query__
 *
 * To run a query within a React component, call `useModuleMemberStatsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useModuleMemberStatsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleMemberStatsV2Query({
 *   variables: {
 *   },
 * });
 */
export function useModuleMemberStatsV2Query(baseOptions?: Apollo.QueryHookOptions<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>(ModuleMemberStatsV2Document, options);
      }
export function useModuleMemberStatsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>(ModuleMemberStatsV2Document, options);
        }
// @ts-ignore
export function useModuleMemberStatsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>;
export function useModuleMemberStatsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>): Apollo.UseSuspenseQueryResult<ModuleMemberStatsV2Query | undefined, ModuleMemberStatsV2QueryVariables>;
export function useModuleMemberStatsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>(ModuleMemberStatsV2Document, options);
        }
export type ModuleMemberStatsV2QueryHookResult = ReturnType<typeof useModuleMemberStatsV2Query>;
export type ModuleMemberStatsV2LazyQueryHookResult = ReturnType<typeof useModuleMemberStatsV2LazyQuery>;
export type ModuleMemberStatsV2SuspenseQueryHookResult = ReturnType<typeof useModuleMemberStatsV2SuspenseQuery>;
export type ModuleMemberStatsV2QueryResult = Apollo.QueryResult<ModuleMemberStatsV2Query, ModuleMemberStatsV2QueryVariables>;
export const ResetInterviewPlanToBaseJobStageDocument = gql`
    query ResetInterviewPlanToBaseJobStage($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    ...getSaveInterviewPlanInput_interviewPlan
  }
}
    ${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}`;

/**
 * __useResetInterviewPlanToBaseJobStageQuery__
 *
 * To run a query within a React component, call `useResetInterviewPlanToBaseJobStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useResetInterviewPlanToBaseJobStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResetInterviewPlanToBaseJobStageQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useResetInterviewPlanToBaseJobStageQuery(baseOptions: Apollo.QueryHookOptions<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables> & ({ variables: ResetInterviewPlanToBaseJobStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>(ResetInterviewPlanToBaseJobStageDocument, options);
      }
export function useResetInterviewPlanToBaseJobStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>(ResetInterviewPlanToBaseJobStageDocument, options);
        }
// @ts-ignore
export function useResetInterviewPlanToBaseJobStageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>): Apollo.UseSuspenseQueryResult<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>;
export function useResetInterviewPlanToBaseJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>): Apollo.UseSuspenseQueryResult<ResetInterviewPlanToBaseJobStageQuery | undefined, ResetInterviewPlanToBaseJobStageQueryVariables>;
export function useResetInterviewPlanToBaseJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>(ResetInterviewPlanToBaseJobStageDocument, options);
        }
export type ResetInterviewPlanToBaseJobStageQueryHookResult = ReturnType<typeof useResetInterviewPlanToBaseJobStageQuery>;
export type ResetInterviewPlanToBaseJobStageLazyQueryHookResult = ReturnType<typeof useResetInterviewPlanToBaseJobStageLazyQuery>;
export type ResetInterviewPlanToBaseJobStageSuspenseQueryHookResult = ReturnType<typeof useResetInterviewPlanToBaseJobStageSuspenseQuery>;
export type ResetInterviewPlanToBaseJobStageQueryResult = Apollo.QueryResult<ResetInterviewPlanToBaseJobStageQuery, ResetInterviewPlanToBaseJobStageQueryVariables>;
export const ResetPlanToBaseJobStageDocument = gql`
    mutation ResetPlanToBaseJobStage($input: JobStageInterviewPlanUpsertInput!) {
  jobStageInterviewPlanUpsert(input: $input) {
    jobStage {
      id
      ...getSaveInterviewPlanInput_interviewPlan
    }
  }
}
    ${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}`;
export type ResetPlanToBaseJobStageMutationFn = Apollo.MutationFunction<ResetPlanToBaseJobStageMutation, ResetPlanToBaseJobStageMutationVariables>;

/**
 * __useResetPlanToBaseJobStageMutation__
 *
 * To run a mutation, you first call `useResetPlanToBaseJobStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPlanToBaseJobStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPlanToBaseJobStageMutation, { data, loading, error }] = useResetPlanToBaseJobStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPlanToBaseJobStageMutation(baseOptions?: Apollo.MutationHookOptions<ResetPlanToBaseJobStageMutation, ResetPlanToBaseJobStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPlanToBaseJobStageMutation, ResetPlanToBaseJobStageMutationVariables>(ResetPlanToBaseJobStageDocument, options);
      }
export type ResetPlanToBaseJobStageMutationHookResult = ReturnType<typeof useResetPlanToBaseJobStageMutation>;
export type ResetPlanToBaseJobStageMutationResult = Apollo.MutationResult<ResetPlanToBaseJobStageMutation>;
export type ResetPlanToBaseJobStageMutationOptions = Apollo.BaseMutationOptions<ResetPlanToBaseJobStageMutation, ResetPlanToBaseJobStageMutationVariables>;
export const MeetingRoomSuggestionsDocument = gql`
    query MeetingRoomSuggestions($input: MeetingRoomSuggestionsInput!) {
  meetingRoomSuggestions(input: $input) {
    items {
      room {
        id
        name
        floorName
        description
        capacity
        features
      }
      isBusy
    }
    nextCursor
  }
}
    `;

/**
 * __useMeetingRoomSuggestionsQuery__
 *
 * To run a query within a React component, call `useMeetingRoomSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingRoomSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingRoomSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMeetingRoomSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables> & ({ variables: MeetingRoomSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>(MeetingRoomSuggestionsDocument, options);
      }
export function useMeetingRoomSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>(MeetingRoomSuggestionsDocument, options);
        }
// @ts-ignore
export function useMeetingRoomSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>;
export function useMeetingRoomSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomSuggestionsQuery | undefined, MeetingRoomSuggestionsQueryVariables>;
export function useMeetingRoomSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>(MeetingRoomSuggestionsDocument, options);
        }
export type MeetingRoomSuggestionsQueryHookResult = ReturnType<typeof useMeetingRoomSuggestionsQuery>;
export type MeetingRoomSuggestionsLazyQueryHookResult = ReturnType<typeof useMeetingRoomSuggestionsLazyQuery>;
export type MeetingRoomSuggestionsSuspenseQueryHookResult = ReturnType<typeof useMeetingRoomSuggestionsSuspenseQuery>;
export type MeetingRoomSuggestionsQueryResult = Apollo.QueryResult<MeetingRoomSuggestionsQuery, MeetingRoomSuggestionsQueryVariables>;
export const MeetingRoomDocument = gql`
    query MeetingRoom($id: uuid!) {
  meetingRoom(id: $id) {
    ...MeetingRoomFragment
  }
}
    ${MeetingRoomFragmentFragmentDoc}`;

/**
 * __useMeetingRoomQuery__
 *
 * To run a query within a React component, call `useMeetingRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingRoomQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeetingRoomQuery(baseOptions: Apollo.QueryHookOptions<MeetingRoomQuery, MeetingRoomQueryVariables> & ({ variables: MeetingRoomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingRoomQuery, MeetingRoomQueryVariables>(MeetingRoomDocument, options);
      }
export function useMeetingRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingRoomQuery, MeetingRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingRoomQuery, MeetingRoomQueryVariables>(MeetingRoomDocument, options);
        }
// @ts-ignore
export function useMeetingRoomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingRoomQuery, MeetingRoomQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomQuery, MeetingRoomQueryVariables>;
export function useMeetingRoomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomQuery, MeetingRoomQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomQuery | undefined, MeetingRoomQueryVariables>;
export function useMeetingRoomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomQuery, MeetingRoomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingRoomQuery, MeetingRoomQueryVariables>(MeetingRoomDocument, options);
        }
export type MeetingRoomQueryHookResult = ReturnType<typeof useMeetingRoomQuery>;
export type MeetingRoomLazyQueryHookResult = ReturnType<typeof useMeetingRoomLazyQuery>;
export type MeetingRoomSuspenseQueryHookResult = ReturnType<typeof useMeetingRoomSuspenseQuery>;
export type MeetingRoomQueryResult = Apollo.QueryResult<MeetingRoomQuery, MeetingRoomQueryVariables>;
export const MeetingRoomByIdsDocument = gql`
    query MeetingRoomByIds($ids: [uuid!]!) {
  meetingRoomByIds(ids: $ids) {
    ...MeetingRoomFragment
  }
}
    ${MeetingRoomFragmentFragmentDoc}`;

/**
 * __useMeetingRoomByIdsQuery__
 *
 * To run a query within a React component, call `useMeetingRoomByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingRoomByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingRoomByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMeetingRoomByIdsQuery(baseOptions: Apollo.QueryHookOptions<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables> & ({ variables: MeetingRoomByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>(MeetingRoomByIdsDocument, options);
      }
export function useMeetingRoomByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>(MeetingRoomByIdsDocument, options);
        }
// @ts-ignore
export function useMeetingRoomByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>;
export function useMeetingRoomByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomByIdsQuery | undefined, MeetingRoomByIdsQueryVariables>;
export function useMeetingRoomByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>(MeetingRoomByIdsDocument, options);
        }
export type MeetingRoomByIdsQueryHookResult = ReturnType<typeof useMeetingRoomByIdsQuery>;
export type MeetingRoomByIdsLazyQueryHookResult = ReturnType<typeof useMeetingRoomByIdsLazyQuery>;
export type MeetingRoomByIdsSuspenseQueryHookResult = ReturnType<typeof useMeetingRoomByIdsSuspenseQuery>;
export type MeetingRoomByIdsQueryResult = Apollo.QueryResult<MeetingRoomByIdsQuery, MeetingRoomByIdsQueryVariables>;
export const MeetingRoomsDocument = gql`
    query MeetingRooms($input: MeetingRoomsInput!) {
  meetingRooms(input: $input) {
    items {
      ...MeetingRoomFragment
    }
    nextCursor
  }
}
    ${MeetingRoomFragmentFragmentDoc}`;

/**
 * __useMeetingRoomsQuery__
 *
 * To run a query within a React component, call `useMeetingRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingRoomsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMeetingRoomsQuery(baseOptions: Apollo.QueryHookOptions<MeetingRoomsQuery, MeetingRoomsQueryVariables> & ({ variables: MeetingRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingRoomsQuery, MeetingRoomsQueryVariables>(MeetingRoomsDocument, options);
      }
export function useMeetingRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingRoomsQuery, MeetingRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingRoomsQuery, MeetingRoomsQueryVariables>(MeetingRoomsDocument, options);
        }
// @ts-ignore
export function useMeetingRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingRoomsQuery, MeetingRoomsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomsQuery, MeetingRoomsQueryVariables>;
export function useMeetingRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomsQuery, MeetingRoomsQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingRoomsQuery | undefined, MeetingRoomsQueryVariables>;
export function useMeetingRoomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingRoomsQuery, MeetingRoomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingRoomsQuery, MeetingRoomsQueryVariables>(MeetingRoomsDocument, options);
        }
export type MeetingRoomsQueryHookResult = ReturnType<typeof useMeetingRoomsQuery>;
export type MeetingRoomsLazyQueryHookResult = ReturnType<typeof useMeetingRoomsLazyQuery>;
export type MeetingRoomsSuspenseQueryHookResult = ReturnType<typeof useMeetingRoomsSuspenseQuery>;
export type MeetingRoomsQueryResult = Apollo.QueryResult<MeetingRoomsQuery, MeetingRoomsQueryVariables>;
export const QuickTaskLabelDocument = gql`
    query QuickTaskLabel($input: TaskQuickCreateValidateInput!) {
  taskQuickCreateValidate(input: $input) {
    ...QuickTaskValidationIcon_taskQuickCreateValidateResult
  }
}
    ${QuickTaskValidationIcon_TaskQuickCreateValidateResultFragmentDoc}`;

/**
 * __useQuickTaskLabelQuery__
 *
 * To run a query within a React component, call `useQuickTaskLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickTaskLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickTaskLabelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuickTaskLabelQuery(baseOptions: Apollo.QueryHookOptions<QuickTaskLabelQuery, QuickTaskLabelQueryVariables> & ({ variables: QuickTaskLabelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>(QuickTaskLabelDocument, options);
      }
export function useQuickTaskLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>(QuickTaskLabelDocument, options);
        }
// @ts-ignore
export function useQuickTaskLabelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>): Apollo.UseSuspenseQueryResult<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>;
export function useQuickTaskLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>): Apollo.UseSuspenseQueryResult<QuickTaskLabelQuery | undefined, QuickTaskLabelQueryVariables>;
export function useQuickTaskLabelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>(QuickTaskLabelDocument, options);
        }
export type QuickTaskLabelQueryHookResult = ReturnType<typeof useQuickTaskLabelQuery>;
export type QuickTaskLabelLazyQueryHookResult = ReturnType<typeof useQuickTaskLabelLazyQuery>;
export type QuickTaskLabelSuspenseQueryHookResult = ReturnType<typeof useQuickTaskLabelSuspenseQuery>;
export type QuickTaskLabelQueryResult = Apollo.QueryResult<QuickTaskLabelQuery, QuickTaskLabelQueryVariables>;
export const QuickTaskJobStageSettingsDocument = gql`
    query QuickTaskJobStageSettings($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    jobStageSettingsV2 {
      id
      candidateAvailabilitySettingsV2 {
        timeframe {
          duration {
            seconds
          }
        }
      }
      selfScheduleSettingsV2 {
        timeframe {
          duration {
            seconds
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuickTaskJobStageSettingsQuery__
 *
 * To run a query within a React component, call `useQuickTaskJobStageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickTaskJobStageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickTaskJobStageSettingsQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useQuickTaskJobStageSettingsQuery(baseOptions: Apollo.QueryHookOptions<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables> & ({ variables: QuickTaskJobStageSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>(QuickTaskJobStageSettingsDocument, options);
      }
export function useQuickTaskJobStageSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>(QuickTaskJobStageSettingsDocument, options);
        }
// @ts-ignore
export function useQuickTaskJobStageSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>;
export function useQuickTaskJobStageSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<QuickTaskJobStageSettingsQuery | undefined, QuickTaskJobStageSettingsQueryVariables>;
export function useQuickTaskJobStageSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>(QuickTaskJobStageSettingsDocument, options);
        }
export type QuickTaskJobStageSettingsQueryHookResult = ReturnType<typeof useQuickTaskJobStageSettingsQuery>;
export type QuickTaskJobStageSettingsLazyQueryHookResult = ReturnType<typeof useQuickTaskJobStageSettingsLazyQuery>;
export type QuickTaskJobStageSettingsSuspenseQueryHookResult = ReturnType<typeof useQuickTaskJobStageSettingsSuspenseQuery>;
export type QuickTaskJobStageSettingsQueryResult = Apollo.QueryResult<QuickTaskJobStageSettingsQuery, QuickTaskJobStageSettingsQueryVariables>;
export const JobStageDefaultTaskDocument = gql`
    query JobStageDefaultTask($id: uuid!) {
  jobStage(id: $id) {
    id
    jobStageSettingsV2 {
      id
      defaultTask
      isAutomatedTaskEnabled
    }
  }
}
    `;

/**
 * __useJobStageDefaultTaskQuery__
 *
 * To run a query within a React component, call `useJobStageDefaultTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageDefaultTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageDefaultTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobStageDefaultTaskQuery(baseOptions: Apollo.QueryHookOptions<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables> & ({ variables: JobStageDefaultTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>(JobStageDefaultTaskDocument, options);
      }
export function useJobStageDefaultTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>(JobStageDefaultTaskDocument, options);
        }
// @ts-ignore
export function useJobStageDefaultTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>;
export function useJobStageDefaultTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageDefaultTaskQuery | undefined, JobStageDefaultTaskQueryVariables>;
export function useJobStageDefaultTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>(JobStageDefaultTaskDocument, options);
        }
export type JobStageDefaultTaskQueryHookResult = ReturnType<typeof useJobStageDefaultTaskQuery>;
export type JobStageDefaultTaskLazyQueryHookResult = ReturnType<typeof useJobStageDefaultTaskLazyQuery>;
export type JobStageDefaultTaskSuspenseQueryHookResult = ReturnType<typeof useJobStageDefaultTaskSuspenseQuery>;
export type JobStageDefaultTaskQueryResult = Apollo.QueryResult<JobStageDefaultTaskQuery, JobStageDefaultTaskQueryVariables>;
export const QuickTaskValidationDocument = gql`
    query QuickTaskValidation($input: TaskQuickCreateValidateInput!) {
  taskQuickCreateValidate(input: $input) {
    ...QuickTaskCreateButton_taskQuickCreateValidateResult
    ...QuickTaskValidationIcon_taskQuickCreateValidateResult
  }
}
    ${QuickTaskCreateButton_TaskQuickCreateValidateResultFragmentDoc}
${QuickTaskValidationIcon_TaskQuickCreateValidateResultFragmentDoc}`;

/**
 * __useQuickTaskValidationQuery__
 *
 * To run a query within a React component, call `useQuickTaskValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickTaskValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickTaskValidationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuickTaskValidationQuery(baseOptions: Apollo.QueryHookOptions<QuickTaskValidationQuery, QuickTaskValidationQueryVariables> & ({ variables: QuickTaskValidationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>(QuickTaskValidationDocument, options);
      }
export function useQuickTaskValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>(QuickTaskValidationDocument, options);
        }
// @ts-ignore
export function useQuickTaskValidationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>): Apollo.UseSuspenseQueryResult<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>;
export function useQuickTaskValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>): Apollo.UseSuspenseQueryResult<QuickTaskValidationQuery | undefined, QuickTaskValidationQueryVariables>;
export function useQuickTaskValidationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>(QuickTaskValidationDocument, options);
        }
export type QuickTaskValidationQueryHookResult = ReturnType<typeof useQuickTaskValidationQuery>;
export type QuickTaskValidationLazyQueryHookResult = ReturnType<typeof useQuickTaskValidationLazyQuery>;
export type QuickTaskValidationSuspenseQueryHookResult = ReturnType<typeof useQuickTaskValidationSuspenseQuery>;
export type QuickTaskValidationQueryResult = Apollo.QueryResult<QuickTaskValidationQuery, QuickTaskValidationQueryVariables>;
export const PushScheduleToAtsDryRunDocument = gql`
    query PushScheduleToAtsDryRun($input: PushScheduleToAtsInput!) {
  pushScheduleToAtsDryRun(input: $input) {
    results {
      action
      interviewName
      updateDetails {
        timeChanged
        previousStartAt
        previousEndAt
        newStartAt
        newEndAt
        scorecardChanged
        previousAtsInterviewDefinition {
          atsId
          name
        }
        newAtsInterviewDefinition {
          atsId
          name
        }
        addedInterviewers {
          id
          fullName
        }
        removedInterviewers {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __usePushScheduleToAtsDryRunQuery__
 *
 * To run a query within a React component, call `usePushScheduleToAtsDryRunQuery` and pass it any options that fit your needs.
 * When your component renders, `usePushScheduleToAtsDryRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePushScheduleToAtsDryRunQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushScheduleToAtsDryRunQuery(baseOptions: Apollo.QueryHookOptions<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables> & ({ variables: PushScheduleToAtsDryRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>(PushScheduleToAtsDryRunDocument, options);
      }
export function usePushScheduleToAtsDryRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>(PushScheduleToAtsDryRunDocument, options);
        }
// @ts-ignore
export function usePushScheduleToAtsDryRunSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>): Apollo.UseSuspenseQueryResult<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>;
export function usePushScheduleToAtsDryRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>): Apollo.UseSuspenseQueryResult<PushScheduleToAtsDryRunQuery | undefined, PushScheduleToAtsDryRunQueryVariables>;
export function usePushScheduleToAtsDryRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>(PushScheduleToAtsDryRunDocument, options);
        }
export type PushScheduleToAtsDryRunQueryHookResult = ReturnType<typeof usePushScheduleToAtsDryRunQuery>;
export type PushScheduleToAtsDryRunLazyQueryHookResult = ReturnType<typeof usePushScheduleToAtsDryRunLazyQuery>;
export type PushScheduleToAtsDryRunSuspenseQueryHookResult = ReturnType<typeof usePushScheduleToAtsDryRunSuspenseQuery>;
export type PushScheduleToAtsDryRunQueryResult = Apollo.QueryResult<PushScheduleToAtsDryRunQuery, PushScheduleToAtsDryRunQueryVariables>;
export const PushScheduleToAtsDocument = gql`
    mutation PushScheduleToAts($input: PushScheduleToAtsInput!) {
  pushScheduleToAts(input: $input) {
    results {
      action
      interviewName
    }
  }
}
    `;
export type PushScheduleToAtsMutationFn = Apollo.MutationFunction<PushScheduleToAtsMutation, PushScheduleToAtsMutationVariables>;

/**
 * __usePushScheduleToAtsMutation__
 *
 * To run a mutation, you first call `usePushScheduleToAtsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushScheduleToAtsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushScheduleToAtsMutation, { data, loading, error }] = usePushScheduleToAtsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushScheduleToAtsMutation(baseOptions?: Apollo.MutationHookOptions<PushScheduleToAtsMutation, PushScheduleToAtsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushScheduleToAtsMutation, PushScheduleToAtsMutationVariables>(PushScheduleToAtsDocument, options);
      }
export type PushScheduleToAtsMutationHookResult = ReturnType<typeof usePushScheduleToAtsMutation>;
export type PushScheduleToAtsMutationResult = Apollo.MutationResult<PushScheduleToAtsMutation>;
export type PushScheduleToAtsMutationOptions = Apollo.BaseMutationOptions<PushScheduleToAtsMutation, PushScheduleToAtsMutationVariables>;
export const RetryExternalObjectSyncDocument = gql`
    mutation RetryExternalObjectSync($input: RetryExternalObjectSyncInput!) {
  retryExternalObjectSync(input: $input) {
    syncStatusIds
  }
}
    `;
export type RetryExternalObjectSyncMutationFn = Apollo.MutationFunction<RetryExternalObjectSyncMutation, RetryExternalObjectSyncMutationVariables>;

/**
 * __useRetryExternalObjectSyncMutation__
 *
 * To run a mutation, you first call `useRetryExternalObjectSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryExternalObjectSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryExternalObjectSyncMutation, { data, loading, error }] = useRetryExternalObjectSyncMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryExternalObjectSyncMutation(baseOptions?: Apollo.MutationHookOptions<RetryExternalObjectSyncMutation, RetryExternalObjectSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryExternalObjectSyncMutation, RetryExternalObjectSyncMutationVariables>(RetryExternalObjectSyncDocument, options);
      }
export type RetryExternalObjectSyncMutationHookResult = ReturnType<typeof useRetryExternalObjectSyncMutation>;
export type RetryExternalObjectSyncMutationResult = Apollo.MutationResult<RetryExternalObjectSyncMutation>;
export type RetryExternalObjectSyncMutationOptions = Apollo.BaseMutationOptions<RetryExternalObjectSyncMutation, RetryExternalObjectSyncMutationVariables>;
export const InterviewAdjustRsvpDocument = gql`
    mutation interviewAdjustRsvp($applicationStageInterviewId: uuid!, $interviewerId: uuid!, $responseStatus: ResponseStatus!, $reason: DeclineReason, $comment: String) {
  applicationStageInterviewInterviewerUpdate(
    input: {applicationStageInterviewId: $applicationStageInterviewId, interviewerId: $interviewerId, rsvp: {reason: $reason, comment: $comment, responseStatus: $responseStatus}}
  ) {
    result
  }
}
    `;
export type InterviewAdjustRsvpMutationFn = Apollo.MutationFunction<InterviewAdjustRsvpMutation, InterviewAdjustRsvpMutationVariables>;

/**
 * __useInterviewAdjustRsvpMutation__
 *
 * To run a mutation, you first call `useInterviewAdjustRsvpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewAdjustRsvpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewAdjustRsvpMutation, { data, loading, error }] = useInterviewAdjustRsvpMutation({
 *   variables: {
 *      applicationStageInterviewId: // value for 'applicationStageInterviewId'
 *      interviewerId: // value for 'interviewerId'
 *      responseStatus: // value for 'responseStatus'
 *      reason: // value for 'reason'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useInterviewAdjustRsvpMutation(baseOptions?: Apollo.MutationHookOptions<InterviewAdjustRsvpMutation, InterviewAdjustRsvpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewAdjustRsvpMutation, InterviewAdjustRsvpMutationVariables>(InterviewAdjustRsvpDocument, options);
      }
export type InterviewAdjustRsvpMutationHookResult = ReturnType<typeof useInterviewAdjustRsvpMutation>;
export type InterviewAdjustRsvpMutationResult = Apollo.MutationResult<InterviewAdjustRsvpMutation>;
export type InterviewAdjustRsvpMutationOptions = Apollo.BaseMutationOptions<InterviewAdjustRsvpMutation, InterviewAdjustRsvpMutationVariables>;
export const ScheduleContentInterviewMenuDocument = gql`
    query ScheduleContentInterviewMenu($input: TemplateTokenInput!, $zoomMeetingInfoInput: TokenZoomMeetingInput!, $zoomMeetingUserId: String!) {
  templateToken(input: $input) {
    ZOOM_MEETING_INFO(input: $zoomMeetingInfoInput)
    ZOOM_MEETING_DIAL_IN_INFO(input: $zoomMeetingInfoInput)
  }
  zoomUsersByIds(input: {zoomUserIds: [$zoomMeetingUserId]}) {
    zoomUserId
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useScheduleContentInterviewMenuQuery__
 *
 * To run a query within a React component, call `useScheduleContentInterviewMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleContentInterviewMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleContentInterviewMenuQuery({
 *   variables: {
 *      input: // value for 'input'
 *      zoomMeetingInfoInput: // value for 'zoomMeetingInfoInput'
 *      zoomMeetingUserId: // value for 'zoomMeetingUserId'
 *   },
 * });
 */
export function useScheduleContentInterviewMenuQuery(baseOptions: Apollo.QueryHookOptions<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables> & ({ variables: ScheduleContentInterviewMenuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>(ScheduleContentInterviewMenuDocument, options);
      }
export function useScheduleContentInterviewMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>(ScheduleContentInterviewMenuDocument, options);
        }
// @ts-ignore
export function useScheduleContentInterviewMenuSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>;
export function useScheduleContentInterviewMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleContentInterviewMenuQuery | undefined, ScheduleContentInterviewMenuQueryVariables>;
export function useScheduleContentInterviewMenuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>(ScheduleContentInterviewMenuDocument, options);
        }
export type ScheduleContentInterviewMenuQueryHookResult = ReturnType<typeof useScheduleContentInterviewMenuQuery>;
export type ScheduleContentInterviewMenuLazyQueryHookResult = ReturnType<typeof useScheduleContentInterviewMenuLazyQuery>;
export type ScheduleContentInterviewMenuSuspenseQueryHookResult = ReturnType<typeof useScheduleContentInterviewMenuSuspenseQuery>;
export type ScheduleContentInterviewMenuQueryResult = Apollo.QueryResult<ScheduleContentInterviewMenuQuery, ScheduleContentInterviewMenuQueryVariables>;
export const ExistingSlackChannelsByNameDocument = gql`
    query ExistingSlackChannelsByName($name: String!) {
  slackChannelByName(name: $name) {
    id
    name
  }
}
    `;

/**
 * __useExistingSlackChannelsByNameQuery__
 *
 * To run a query within a React component, call `useExistingSlackChannelsByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingSlackChannelsByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingSlackChannelsByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useExistingSlackChannelsByNameQuery(baseOptions: Apollo.QueryHookOptions<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables> & ({ variables: ExistingSlackChannelsByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>(ExistingSlackChannelsByNameDocument, options);
      }
export function useExistingSlackChannelsByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>(ExistingSlackChannelsByNameDocument, options);
        }
// @ts-ignore
export function useExistingSlackChannelsByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>): Apollo.UseSuspenseQueryResult<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>;
export function useExistingSlackChannelsByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>): Apollo.UseSuspenseQueryResult<ExistingSlackChannelsByNameQuery | undefined, ExistingSlackChannelsByNameQueryVariables>;
export function useExistingSlackChannelsByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>(ExistingSlackChannelsByNameDocument, options);
        }
export type ExistingSlackChannelsByNameQueryHookResult = ReturnType<typeof useExistingSlackChannelsByNameQuery>;
export type ExistingSlackChannelsByNameLazyQueryHookResult = ReturnType<typeof useExistingSlackChannelsByNameLazyQuery>;
export type ExistingSlackChannelsByNameSuspenseQueryHookResult = ReturnType<typeof useExistingSlackChannelsByNameSuspenseQuery>;
export type ExistingSlackChannelsByNameQueryResult = Apollo.QueryResult<ExistingSlackChannelsByNameQuery, ExistingSlackChannelsByNameQueryVariables>;
export const RequestTemplateSelectDocument = gql`
    query RequestTemplateSelect($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      id
      ...RequestTemplateSelect_template
      ...TemplateOption_Template
    }
  }
}
    ${RequestTemplateSelect_TemplateFragmentDoc}
${TemplateOption_TemplateFragmentDoc}`;

/**
 * __useRequestTemplateSelectQuery__
 *
 * To run a query within a React component, call `useRequestTemplateSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestTemplateSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestTemplateSelectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestTemplateSelectQuery(baseOptions: Apollo.QueryHookOptions<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables> & ({ variables: RequestTemplateSelectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>(RequestTemplateSelectDocument, options);
      }
export function useRequestTemplateSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>(RequestTemplateSelectDocument, options);
        }
// @ts-ignore
export function useRequestTemplateSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>): Apollo.UseSuspenseQueryResult<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>;
export function useRequestTemplateSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>): Apollo.UseSuspenseQueryResult<RequestTemplateSelectQuery | undefined, RequestTemplateSelectQueryVariables>;
export function useRequestTemplateSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>(RequestTemplateSelectDocument, options);
        }
export type RequestTemplateSelectQueryHookResult = ReturnType<typeof useRequestTemplateSelectQuery>;
export type RequestTemplateSelectLazyQueryHookResult = ReturnType<typeof useRequestTemplateSelectLazyQuery>;
export type RequestTemplateSelectSuspenseQueryHookResult = ReturnType<typeof useRequestTemplateSelectSuspenseQuery>;
export type RequestTemplateSelectQueryResult = Apollo.QueryResult<RequestTemplateSelectQuery, RequestTemplateSelectQueryVariables>;
export const RequestTemplateValueDocument = gql`
    query RequestTemplateValue($id: uuid!) {
  template(id: $id) {
    ...RequestTemplateValue_template
  }
}
    ${RequestTemplateValue_TemplateFragmentDoc}`;

/**
 * __useRequestTemplateValueQuery__
 *
 * To run a query within a React component, call `useRequestTemplateValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequestTemplateValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestTemplateValueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestTemplateValueQuery(baseOptions: Apollo.QueryHookOptions<RequestTemplateValueQuery, RequestTemplateValueQueryVariables> & ({ variables: RequestTemplateValueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>(RequestTemplateValueDocument, options);
      }
export function useRequestTemplateValueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>(RequestTemplateValueDocument, options);
        }
// @ts-ignore
export function useRequestTemplateValueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>): Apollo.UseSuspenseQueryResult<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>;
export function useRequestTemplateValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>): Apollo.UseSuspenseQueryResult<RequestTemplateValueQuery | undefined, RequestTemplateValueQueryVariables>;
export function useRequestTemplateValueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>(RequestTemplateValueDocument, options);
        }
export type RequestTemplateValueQueryHookResult = ReturnType<typeof useRequestTemplateValueQuery>;
export type RequestTemplateValueLazyQueryHookResult = ReturnType<typeof useRequestTemplateValueLazyQuery>;
export type RequestTemplateValueSuspenseQueryHookResult = ReturnType<typeof useRequestTemplateValueSuspenseQuery>;
export type RequestTemplateValueQueryResult = Apollo.QueryResult<RequestTemplateValueQuery, RequestTemplateValueQueryVariables>;
export const ListAtsUsersDocument = gql`
    query ListAtsUsers($input: AtsUserInput!) {
  atsUsers(input: $input) {
    items {
      ...AtsUser
    }
  }
}
    ${AtsUserFragmentDoc}`;

/**
 * __useListAtsUsersQuery__
 *
 * To run a query within a React component, call `useListAtsUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAtsUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAtsUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListAtsUsersQuery(baseOptions: Apollo.QueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables> & ({ variables: ListAtsUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAtsUsersQuery, ListAtsUsersQueryVariables>(ListAtsUsersDocument, options);
      }
export function useListAtsUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAtsUsersQuery, ListAtsUsersQueryVariables>(ListAtsUsersDocument, options);
        }
// @ts-ignore
export function useListAtsUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListAtsUsersQuery, ListAtsUsersQueryVariables>;
export function useListAtsUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables>): Apollo.UseSuspenseQueryResult<ListAtsUsersQuery | undefined, ListAtsUsersQueryVariables>;
export function useListAtsUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAtsUsersQuery, ListAtsUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAtsUsersQuery, ListAtsUsersQueryVariables>(ListAtsUsersDocument, options);
        }
export type ListAtsUsersQueryHookResult = ReturnType<typeof useListAtsUsersQuery>;
export type ListAtsUsersLazyQueryHookResult = ReturnType<typeof useListAtsUsersLazyQuery>;
export type ListAtsUsersSuspenseQueryHookResult = ReturnType<typeof useListAtsUsersSuspenseQuery>;
export type ListAtsUsersQueryResult = Apollo.QueryResult<ListAtsUsersQuery, ListAtsUsersQueryVariables>;
export const BrandingThemeSelectDocument = gql`
    query BrandingThemeSelect {
  brandingThemes {
    items {
      ...Row_BrandingOptions
    }
  }
}
    ${Row_BrandingOptionsFragmentDoc}`;

/**
 * __useBrandingThemeSelectQuery__
 *
 * To run a query within a React component, call `useBrandingThemeSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandingThemeSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandingThemeSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandingThemeSelectQuery(baseOptions?: Apollo.QueryHookOptions<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>(BrandingThemeSelectDocument, options);
      }
export function useBrandingThemeSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>(BrandingThemeSelectDocument, options);
        }
// @ts-ignore
export function useBrandingThemeSelectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>): Apollo.UseSuspenseQueryResult<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>;
export function useBrandingThemeSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>): Apollo.UseSuspenseQueryResult<BrandingThemeSelectQuery | undefined, BrandingThemeSelectQueryVariables>;
export function useBrandingThemeSelectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>(BrandingThemeSelectDocument, options);
        }
export type BrandingThemeSelectQueryHookResult = ReturnType<typeof useBrandingThemeSelectQuery>;
export type BrandingThemeSelectLazyQueryHookResult = ReturnType<typeof useBrandingThemeSelectLazyQuery>;
export type BrandingThemeSelectSuspenseQueryHookResult = ReturnType<typeof useBrandingThemeSelectSuspenseQuery>;
export type BrandingThemeSelectQueryResult = Apollo.QueryResult<BrandingThemeSelectQuery, BrandingThemeSelectQueryVariables>;
export const BrighthireFormsDocument = gql`
    query BrighthireForms($jobId: uuid!) {
  job(id: $jobId) {
    id
    interviewGuides {
      ...BrighthireGuideOption
    }
  }
}
    ${BrighthireGuideOptionFragmentDoc}`;

/**
 * __useBrighthireFormsQuery__
 *
 * To run a query within a React component, call `useBrighthireFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrighthireFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrighthireFormsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useBrighthireFormsQuery(baseOptions: Apollo.QueryHookOptions<BrighthireFormsQuery, BrighthireFormsQueryVariables> & ({ variables: BrighthireFormsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrighthireFormsQuery, BrighthireFormsQueryVariables>(BrighthireFormsDocument, options);
      }
export function useBrighthireFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrighthireFormsQuery, BrighthireFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrighthireFormsQuery, BrighthireFormsQueryVariables>(BrighthireFormsDocument, options);
        }
// @ts-ignore
export function useBrighthireFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrighthireFormsQuery, BrighthireFormsQueryVariables>): Apollo.UseSuspenseQueryResult<BrighthireFormsQuery, BrighthireFormsQueryVariables>;
export function useBrighthireFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrighthireFormsQuery, BrighthireFormsQueryVariables>): Apollo.UseSuspenseQueryResult<BrighthireFormsQuery | undefined, BrighthireFormsQueryVariables>;
export function useBrighthireFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrighthireFormsQuery, BrighthireFormsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrighthireFormsQuery, BrighthireFormsQueryVariables>(BrighthireFormsDocument, options);
        }
export type BrighthireFormsQueryHookResult = ReturnType<typeof useBrighthireFormsQuery>;
export type BrighthireFormsLazyQueryHookResult = ReturnType<typeof useBrighthireFormsLazyQuery>;
export type BrighthireFormsSuspenseQueryHookResult = ReturnType<typeof useBrighthireFormsSuspenseQuery>;
export type BrighthireFormsQueryResult = Apollo.QueryResult<BrighthireFormsQuery, BrighthireFormsQueryVariables>;
export const BrighthireIntegrationsQueryDocument = gql`
    query BrighthireIntegrationsQuery {
  thisOrg {
    integrations {
      id
      brighthire {
        apiKey
      }
    }
  }
}
    `;

/**
 * __useBrighthireIntegrationsQueryQuery__
 *
 * To run a query within a React component, call `useBrighthireIntegrationsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrighthireIntegrationsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrighthireIntegrationsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrighthireIntegrationsQueryQuery(baseOptions?: Apollo.QueryHookOptions<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>(BrighthireIntegrationsQueryDocument, options);
      }
export function useBrighthireIntegrationsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>(BrighthireIntegrationsQueryDocument, options);
        }
// @ts-ignore
export function useBrighthireIntegrationsQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>;
export function useBrighthireIntegrationsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>): Apollo.UseSuspenseQueryResult<BrighthireIntegrationsQueryQuery | undefined, BrighthireIntegrationsQueryQueryVariables>;
export function useBrighthireIntegrationsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>(BrighthireIntegrationsQueryDocument, options);
        }
export type BrighthireIntegrationsQueryQueryHookResult = ReturnType<typeof useBrighthireIntegrationsQueryQuery>;
export type BrighthireIntegrationsQueryLazyQueryHookResult = ReturnType<typeof useBrighthireIntegrationsQueryLazyQuery>;
export type BrighthireIntegrationsQuerySuspenseQueryHookResult = ReturnType<typeof useBrighthireIntegrationsQuerySuspenseQuery>;
export type BrighthireIntegrationsQueryQueryResult = Apollo.QueryResult<BrighthireIntegrationsQueryQuery, BrighthireIntegrationsQueryQueryVariables>;
export const CalendarDocument = gql`
    query Calendar($input: String!) {
  calendar(id: $input) {
    ...Calendar_calendar
  }
}
    ${Calendar_CalendarFragmentDoc}`;

/**
 * __useCalendarQuery__
 *
 * To run a query within a React component, call `useCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarQuery(baseOptions: Apollo.QueryHookOptions<CalendarQuery, CalendarQueryVariables> & ({ variables: CalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarQuery, CalendarQueryVariables>(CalendarDocument, options);
      }
export function useCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarQuery, CalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarQuery, CalendarQueryVariables>(CalendarDocument, options);
        }
// @ts-ignore
export function useCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarQuery, CalendarQueryVariables>): Apollo.UseSuspenseQueryResult<CalendarQuery, CalendarQueryVariables>;
export function useCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalendarQuery, CalendarQueryVariables>): Apollo.UseSuspenseQueryResult<CalendarQuery | undefined, CalendarQueryVariables>;
export function useCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalendarQuery, CalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendarQuery, CalendarQueryVariables>(CalendarDocument, options);
        }
export type CalendarQueryHookResult = ReturnType<typeof useCalendarQuery>;
export type CalendarLazyQueryHookResult = ReturnType<typeof useCalendarLazyQuery>;
export type CalendarSuspenseQueryHookResult = ReturnType<typeof useCalendarSuspenseQuery>;
export type CalendarQueryResult = Apollo.QueryResult<CalendarQuery, CalendarQueryVariables>;
export const CalendarSelectCalendarsDocument = gql`
    query CalendarSelectCalendars($input: CalendarsInput!) {
  calendars(input: $input) {
    nextCursor
    items {
      id
      name
      isReadOnly
      remoteId
    }
  }
}
    `;

/**
 * __useCalendarSelectCalendarsQuery__
 *
 * To run a query within a React component, call `useCalendarSelectCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarSelectCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarSelectCalendarsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarSelectCalendarsQuery(baseOptions: Apollo.QueryHookOptions<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables> & ({ variables: CalendarSelectCalendarsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>(CalendarSelectCalendarsDocument, options);
      }
export function useCalendarSelectCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>(CalendarSelectCalendarsDocument, options);
        }
// @ts-ignore
export function useCalendarSelectCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>): Apollo.UseSuspenseQueryResult<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>;
export function useCalendarSelectCalendarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>): Apollo.UseSuspenseQueryResult<CalendarSelectCalendarsQuery | undefined, CalendarSelectCalendarsQueryVariables>;
export function useCalendarSelectCalendarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>(CalendarSelectCalendarsDocument, options);
        }
export type CalendarSelectCalendarsQueryHookResult = ReturnType<typeof useCalendarSelectCalendarsQuery>;
export type CalendarSelectCalendarsLazyQueryHookResult = ReturnType<typeof useCalendarSelectCalendarsLazyQuery>;
export type CalendarSelectCalendarsSuspenseQueryHookResult = ReturnType<typeof useCalendarSelectCalendarsSuspenseQuery>;
export type CalendarSelectCalendarsQueryResult = Apollo.QueryResult<CalendarSelectCalendarsQuery, CalendarSelectCalendarsQueryVariables>;
export const CollaborationToolTemplateDocument = gql`
    query CollaborationToolTemplate($input: CollaborationLinkTemplatesInput!) {
  collaborationLinkTemplates(input: $input) {
    items {
      ...CollaborationToolTemplate_collaborationLinkTemplate
    }
  }
}
    ${CollaborationToolTemplate_CollaborationLinkTemplateFragmentDoc}`;

/**
 * __useCollaborationToolTemplateQuery__
 *
 * To run a query within a React component, call `useCollaborationToolTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaborationToolTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaborationToolTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollaborationToolTemplateQuery(baseOptions: Apollo.QueryHookOptions<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables> & ({ variables: CollaborationToolTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>(CollaborationToolTemplateDocument, options);
      }
export function useCollaborationToolTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>(CollaborationToolTemplateDocument, options);
        }
// @ts-ignore
export function useCollaborationToolTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>;
export function useCollaborationToolTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolTemplateQuery | undefined, CollaborationToolTemplateQueryVariables>;
export function useCollaborationToolTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>(CollaborationToolTemplateDocument, options);
        }
export type CollaborationToolTemplateQueryHookResult = ReturnType<typeof useCollaborationToolTemplateQuery>;
export type CollaborationToolTemplateLazyQueryHookResult = ReturnType<typeof useCollaborationToolTemplateLazyQuery>;
export type CollaborationToolTemplateSuspenseQueryHookResult = ReturnType<typeof useCollaborationToolTemplateSuspenseQuery>;
export type CollaborationToolTemplateQueryResult = Apollo.QueryResult<CollaborationToolTemplateQuery, CollaborationToolTemplateQueryVariables>;
export const CollaborationToolFilterPopoverOrgIntegrationDocument = gql`
    query CollaborationToolFilterPopoverOrgIntegration {
  thisOrg {
    integrations {
      id
      coderpad {
        apiKey
      }
      codility {
        apiKey
      }
      codesignal {
        apiKey
      }
      hackerrank {
        apiKey
      }
    }
    id
  }
}
    `;

/**
 * __useCollaborationToolFilterPopoverOrgIntegrationQuery__
 *
 * To run a query within a React component, call `useCollaborationToolFilterPopoverOrgIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaborationToolFilterPopoverOrgIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaborationToolFilterPopoverOrgIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollaborationToolFilterPopoverOrgIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>(CollaborationToolFilterPopoverOrgIntegrationDocument, options);
      }
export function useCollaborationToolFilterPopoverOrgIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>(CollaborationToolFilterPopoverOrgIntegrationDocument, options);
        }
// @ts-ignore
export function useCollaborationToolFilterPopoverOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>;
export function useCollaborationToolFilterPopoverOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolFilterPopoverOrgIntegrationQuery | undefined, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>;
export function useCollaborationToolFilterPopoverOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>(CollaborationToolFilterPopoverOrgIntegrationDocument, options);
        }
export type CollaborationToolFilterPopoverOrgIntegrationQueryHookResult = ReturnType<typeof useCollaborationToolFilterPopoverOrgIntegrationQuery>;
export type CollaborationToolFilterPopoverOrgIntegrationLazyQueryHookResult = ReturnType<typeof useCollaborationToolFilterPopoverOrgIntegrationLazyQuery>;
export type CollaborationToolFilterPopoverOrgIntegrationSuspenseQueryHookResult = ReturnType<typeof useCollaborationToolFilterPopoverOrgIntegrationSuspenseQuery>;
export type CollaborationToolFilterPopoverOrgIntegrationQueryResult = Apollo.QueryResult<CollaborationToolFilterPopoverOrgIntegrationQuery, CollaborationToolFilterPopoverOrgIntegrationQueryVariables>;
export const CollaborationToolOptionsIntegrationsDocument = gql`
    query CollaborationToolOptionsIntegrations {
  thisOrg {
    integrations {
      id
      coderpad {
        apiKey
      }
      codility {
        apiKey
      }
      codesignal {
        apiKey
      }
      hackerrank {
        apiKey
      }
    }
    id
  }
}
    `;

/**
 * __useCollaborationToolOptionsIntegrationsQuery__
 *
 * To run a query within a React component, call `useCollaborationToolOptionsIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaborationToolOptionsIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaborationToolOptionsIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollaborationToolOptionsIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>(CollaborationToolOptionsIntegrationsDocument, options);
      }
export function useCollaborationToolOptionsIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>(CollaborationToolOptionsIntegrationsDocument, options);
        }
// @ts-ignore
export function useCollaborationToolOptionsIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>;
export function useCollaborationToolOptionsIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolOptionsIntegrationsQuery | undefined, CollaborationToolOptionsIntegrationsQueryVariables>;
export function useCollaborationToolOptionsIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>(CollaborationToolOptionsIntegrationsDocument, options);
        }
export type CollaborationToolOptionsIntegrationsQueryHookResult = ReturnType<typeof useCollaborationToolOptionsIntegrationsQuery>;
export type CollaborationToolOptionsIntegrationsLazyQueryHookResult = ReturnType<typeof useCollaborationToolOptionsIntegrationsLazyQuery>;
export type CollaborationToolOptionsIntegrationsSuspenseQueryHookResult = ReturnType<typeof useCollaborationToolOptionsIntegrationsSuspenseQuery>;
export type CollaborationToolOptionsIntegrationsQueryResult = Apollo.QueryResult<CollaborationToolOptionsIntegrationsQuery, CollaborationToolOptionsIntegrationsQueryVariables>;
export const CollaborationToolOptionsDocument = gql`
    query CollaborationToolOptions($input: CollaborationLinkTemplatesInput!) {
  collaborationLinkTemplates(input: $input) {
    items {
      id
      groupName
      name
    }
    nextCursor
    __typename
  }
}
    `;

/**
 * __useCollaborationToolOptionsQuery__
 *
 * To run a query within a React component, call `useCollaborationToolOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaborationToolOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaborationToolOptionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollaborationToolOptionsQuery(baseOptions: Apollo.QueryHookOptions<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables> & ({ variables: CollaborationToolOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>(CollaborationToolOptionsDocument, options);
      }
export function useCollaborationToolOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>(CollaborationToolOptionsDocument, options);
        }
// @ts-ignore
export function useCollaborationToolOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>;
export function useCollaborationToolOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationToolOptionsQuery | undefined, CollaborationToolOptionsQueryVariables>;
export function useCollaborationToolOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>(CollaborationToolOptionsDocument, options);
        }
export type CollaborationToolOptionsQueryHookResult = ReturnType<typeof useCollaborationToolOptionsQuery>;
export type CollaborationToolOptionsLazyQueryHookResult = ReturnType<typeof useCollaborationToolOptionsLazyQuery>;
export type CollaborationToolOptionsSuspenseQueryHookResult = ReturnType<typeof useCollaborationToolOptionsSuspenseQuery>;
export type CollaborationToolOptionsQueryResult = Apollo.QueryResult<CollaborationToolOptionsQuery, CollaborationToolOptionsQueryVariables>;
export const CandidateLocaleSelectUpdateDocument = gql`
    mutation CandidateLocaleSelectUpdate($input: CandidateUpdateInput!) {
  candidateUpdate(input: $input) {
    candidate {
      id
      locale
    }
  }
}
    `;
export type CandidateLocaleSelectUpdateMutationFn = Apollo.MutationFunction<CandidateLocaleSelectUpdateMutation, CandidateLocaleSelectUpdateMutationVariables>;

/**
 * __useCandidateLocaleSelectUpdateMutation__
 *
 * To run a mutation, you first call `useCandidateLocaleSelectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateLocaleSelectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateLocaleSelectUpdateMutation, { data, loading, error }] = useCandidateLocaleSelectUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateLocaleSelectUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CandidateLocaleSelectUpdateMutation, CandidateLocaleSelectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateLocaleSelectUpdateMutation, CandidateLocaleSelectUpdateMutationVariables>(CandidateLocaleSelectUpdateDocument, options);
      }
export type CandidateLocaleSelectUpdateMutationHookResult = ReturnType<typeof useCandidateLocaleSelectUpdateMutation>;
export type CandidateLocaleSelectUpdateMutationResult = Apollo.MutationResult<CandidateLocaleSelectUpdateMutation>;
export type CandidateLocaleSelectUpdateMutationOptions = Apollo.BaseMutationOptions<CandidateLocaleSelectUpdateMutation, CandidateLocaleSelectUpdateMutationVariables>;
export const CandidateTimezoneSelectUpdateDocument = gql`
    mutation CandidateTimezoneSelectUpdate($input: CandidateUpdateInput!) {
  candidateUpdate(input: $input) {
    candidate {
      id
      timezone
    }
  }
}
    `;
export type CandidateTimezoneSelectUpdateMutationFn = Apollo.MutationFunction<CandidateTimezoneSelectUpdateMutation, CandidateTimezoneSelectUpdateMutationVariables>;

/**
 * __useCandidateTimezoneSelectUpdateMutation__
 *
 * To run a mutation, you first call `useCandidateTimezoneSelectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateTimezoneSelectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateTimezoneSelectUpdateMutation, { data, loading, error }] = useCandidateTimezoneSelectUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateTimezoneSelectUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CandidateTimezoneSelectUpdateMutation, CandidateTimezoneSelectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateTimezoneSelectUpdateMutation, CandidateTimezoneSelectUpdateMutationVariables>(CandidateTimezoneSelectUpdateDocument, options);
      }
export type CandidateTimezoneSelectUpdateMutationHookResult = ReturnType<typeof useCandidateTimezoneSelectUpdateMutation>;
export type CandidateTimezoneSelectUpdateMutationResult = Apollo.MutationResult<CandidateTimezoneSelectUpdateMutation>;
export type CandidateTimezoneSelectUpdateMutationOptions = Apollo.BaseMutationOptions<CandidateTimezoneSelectUpdateMutation, CandidateTimezoneSelectUpdateMutationVariables>;
export const CoordinatorSelectApplicationUpdateDocument = gql`
    mutation CoordinatorSelectApplicationUpdate($input: ApplicationUpdateInput!) {
  applicationUpdate(input: $input) {
    id
    coordinator {
      id
      ...SelectButtonLabel_employee
    }
  }
}
    ${SelectButtonLabel_EmployeeFragmentDoc}`;
export type CoordinatorSelectApplicationUpdateMutationFn = Apollo.MutationFunction<CoordinatorSelectApplicationUpdateMutation, CoordinatorSelectApplicationUpdateMutationVariables>;

/**
 * __useCoordinatorSelectApplicationUpdateMutation__
 *
 * To run a mutation, you first call `useCoordinatorSelectApplicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoordinatorSelectApplicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coordinatorSelectApplicationUpdateMutation, { data, loading, error }] = useCoordinatorSelectApplicationUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoordinatorSelectApplicationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CoordinatorSelectApplicationUpdateMutation, CoordinatorSelectApplicationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoordinatorSelectApplicationUpdateMutation, CoordinatorSelectApplicationUpdateMutationVariables>(CoordinatorSelectApplicationUpdateDocument, options);
      }
export type CoordinatorSelectApplicationUpdateMutationHookResult = ReturnType<typeof useCoordinatorSelectApplicationUpdateMutation>;
export type CoordinatorSelectApplicationUpdateMutationResult = Apollo.MutationResult<CoordinatorSelectApplicationUpdateMutation>;
export type CoordinatorSelectApplicationUpdateMutationOptions = Apollo.BaseMutationOptions<CoordinatorSelectApplicationUpdateMutation, CoordinatorSelectApplicationUpdateMutationVariables>;
export const RecruiterSelectApplicationUpdateDocument = gql`
    mutation RecruiterSelectApplicationUpdate($input: ApplicationUpdateInput!) {
  applicationUpdate(input: $input) {
    id
    recruiter {
      id
      ...SelectButtonLabel_employee
    }
  }
}
    ${SelectButtonLabel_EmployeeFragmentDoc}`;
export type RecruiterSelectApplicationUpdateMutationFn = Apollo.MutationFunction<RecruiterSelectApplicationUpdateMutation, RecruiterSelectApplicationUpdateMutationVariables>;

/**
 * __useRecruiterSelectApplicationUpdateMutation__
 *
 * To run a mutation, you first call `useRecruiterSelectApplicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecruiterSelectApplicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recruiterSelectApplicationUpdateMutation, { data, loading, error }] = useRecruiterSelectApplicationUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecruiterSelectApplicationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RecruiterSelectApplicationUpdateMutation, RecruiterSelectApplicationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecruiterSelectApplicationUpdateMutation, RecruiterSelectApplicationUpdateMutationVariables>(RecruiterSelectApplicationUpdateDocument, options);
      }
export type RecruiterSelectApplicationUpdateMutationHookResult = ReturnType<typeof useRecruiterSelectApplicationUpdateMutation>;
export type RecruiterSelectApplicationUpdateMutationResult = Apollo.MutationResult<RecruiterSelectApplicationUpdateMutation>;
export type RecruiterSelectApplicationUpdateMutationOptions = Apollo.BaseMutationOptions<RecruiterSelectApplicationUpdateMutation, RecruiterSelectApplicationUpdateMutationVariables>;
export const SourcerSelectApplicationUpdateDocument = gql`
    mutation SourcerSelectApplicationUpdate($input: ApplicationUpdateInput!) {
  applicationUpdate(input: $input) {
    id
    sourcer {
      id
      ...SelectButtonLabel_employee
    }
  }
}
    ${SelectButtonLabel_EmployeeFragmentDoc}`;
export type SourcerSelectApplicationUpdateMutationFn = Apollo.MutationFunction<SourcerSelectApplicationUpdateMutation, SourcerSelectApplicationUpdateMutationVariables>;

/**
 * __useSourcerSelectApplicationUpdateMutation__
 *
 * To run a mutation, you first call `useSourcerSelectApplicationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSourcerSelectApplicationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sourcerSelectApplicationUpdateMutation, { data, loading, error }] = useSourcerSelectApplicationUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSourcerSelectApplicationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SourcerSelectApplicationUpdateMutation, SourcerSelectApplicationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SourcerSelectApplicationUpdateMutation, SourcerSelectApplicationUpdateMutationVariables>(SourcerSelectApplicationUpdateDocument, options);
      }
export type SourcerSelectApplicationUpdateMutationHookResult = ReturnType<typeof useSourcerSelectApplicationUpdateMutation>;
export type SourcerSelectApplicationUpdateMutationResult = Apollo.MutationResult<SourcerSelectApplicationUpdateMutation>;
export type SourcerSelectApplicationUpdateMutationOptions = Apollo.BaseMutationOptions<SourcerSelectApplicationUpdateMutation, SourcerSelectApplicationUpdateMutationVariables>;
export const InterviewModuleSearchDocument = gql`
    query InterviewModuleSearch($input: InterviewModuleSearchInput!) {
  interviewModuleSearch(input: $input) {
    total
    items {
      ...InterviewModule
    }
  }
}
    ${InterviewModuleFragmentDoc}`;

/**
 * __useInterviewModuleSearchQuery__
 *
 * To run a query within a React component, call `useInterviewModuleSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModuleSearchQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables> & ({ variables: InterviewModuleSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>(InterviewModuleSearchDocument, options);
      }
export function useInterviewModuleSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>(InterviewModuleSearchDocument, options);
        }
// @ts-ignore
export function useInterviewModuleSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>;
export function useInterviewModuleSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleSearchQuery | undefined, InterviewModuleSearchQueryVariables>;
export function useInterviewModuleSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>(InterviewModuleSearchDocument, options);
        }
export type InterviewModuleSearchQueryHookResult = ReturnType<typeof useInterviewModuleSearchQuery>;
export type InterviewModuleSearchLazyQueryHookResult = ReturnType<typeof useInterviewModuleSearchLazyQuery>;
export type InterviewModuleSearchSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleSearchSuspenseQuery>;
export type InterviewModuleSearchQueryResult = Apollo.QueryResult<InterviewModuleSearchQuery, InterviewModuleSearchQueryVariables>;
export const JobBrandingTemplateDocument = gql`
    query JobBrandingTemplate($id: uuid!) {
  portalTemplate(id: $id) {
    ...JobBrandingTemplate_portalTemplate
  }
}
    ${JobBrandingTemplate_PortalTemplateFragmentDoc}`;

/**
 * __useJobBrandingTemplateQuery__
 *
 * To run a query within a React component, call `useJobBrandingTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobBrandingTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobBrandingTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobBrandingTemplateQuery(baseOptions: Apollo.QueryHookOptions<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables> & ({ variables: JobBrandingTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>(JobBrandingTemplateDocument, options);
      }
export function useJobBrandingTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>(JobBrandingTemplateDocument, options);
        }
// @ts-ignore
export function useJobBrandingTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>;
export function useJobBrandingTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<JobBrandingTemplateQuery | undefined, JobBrandingTemplateQueryVariables>;
export function useJobBrandingTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>(JobBrandingTemplateDocument, options);
        }
export type JobBrandingTemplateQueryHookResult = ReturnType<typeof useJobBrandingTemplateQuery>;
export type JobBrandingTemplateLazyQueryHookResult = ReturnType<typeof useJobBrandingTemplateLazyQuery>;
export type JobBrandingTemplateSuspenseQueryHookResult = ReturnType<typeof useJobBrandingTemplateSuspenseQuery>;
export type JobBrandingTemplateQueryResult = Apollo.QueryResult<JobBrandingTemplateQuery, JobBrandingTemplateQueryVariables>;
export const JobBrandingTemplateSelectQueryDocument = gql`
    query JobBrandingTemplateSelectQuery($input: PortalTemplatesInput!) {
  portalTemplates(input: $input) {
    nextCursor
    items {
      id
      ...JobBrandingTemplateSelect_portalTemplate
    }
  }
}
    ${JobBrandingTemplateSelect_PortalTemplateFragmentDoc}`;

/**
 * __useJobBrandingTemplateSelectQueryQuery__
 *
 * To run a query within a React component, call `useJobBrandingTemplateSelectQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobBrandingTemplateSelectQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobBrandingTemplateSelectQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobBrandingTemplateSelectQueryQuery(baseOptions: Apollo.QueryHookOptions<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables> & ({ variables: JobBrandingTemplateSelectQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>(JobBrandingTemplateSelectQueryDocument, options);
      }
export function useJobBrandingTemplateSelectQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>(JobBrandingTemplateSelectQueryDocument, options);
        }
// @ts-ignore
export function useJobBrandingTemplateSelectQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>): Apollo.UseSuspenseQueryResult<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>;
export function useJobBrandingTemplateSelectQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>): Apollo.UseSuspenseQueryResult<JobBrandingTemplateSelectQueryQuery | undefined, JobBrandingTemplateSelectQueryQueryVariables>;
export function useJobBrandingTemplateSelectQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>(JobBrandingTemplateSelectQueryDocument, options);
        }
export type JobBrandingTemplateSelectQueryQueryHookResult = ReturnType<typeof useJobBrandingTemplateSelectQueryQuery>;
export type JobBrandingTemplateSelectQueryLazyQueryHookResult = ReturnType<typeof useJobBrandingTemplateSelectQueryLazyQuery>;
export type JobBrandingTemplateSelectQuerySuspenseQueryHookResult = ReturnType<typeof useJobBrandingTemplateSelectQuerySuspenseQuery>;
export type JobBrandingTemplateSelectQueryQueryResult = Apollo.QueryResult<JobBrandingTemplateSelectQueryQuery, JobBrandingTemplateSelectQueryQueryVariables>;
export const OrgJobDepartmentsDocument = gql`
    query OrgJobDepartments {
  thisOrg {
    id
    jobDepartments {
      id
      name
    }
  }
}
    `;

/**
 * __useOrgJobDepartmentsQuery__
 *
 * To run a query within a React component, call `useOrgJobDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgJobDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgJobDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgJobDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>(OrgJobDepartmentsDocument, options);
      }
export function useOrgJobDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>(OrgJobDepartmentsDocument, options);
        }
// @ts-ignore
export function useOrgJobDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>;
export function useOrgJobDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgJobDepartmentsQuery | undefined, OrgJobDepartmentsQueryVariables>;
export function useOrgJobDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>(OrgJobDepartmentsDocument, options);
        }
export type OrgJobDepartmentsQueryHookResult = ReturnType<typeof useOrgJobDepartmentsQuery>;
export type OrgJobDepartmentsLazyQueryHookResult = ReturnType<typeof useOrgJobDepartmentsLazyQuery>;
export type OrgJobDepartmentsSuspenseQueryHookResult = ReturnType<typeof useOrgJobDepartmentsSuspenseQuery>;
export type OrgJobDepartmentsQueryResult = Apollo.QueryResult<OrgJobDepartmentsQuery, OrgJobDepartmentsQueryVariables>;
export const OrgJobLocationsDocument = gql`
    query OrgJobLocations {
  thisOrg {
    id
    locations
  }
}
    `;

/**
 * __useOrgJobLocationsQuery__
 *
 * To run a query within a React component, call `useOrgJobLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgJobLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgJobLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgJobLocationsQuery(baseOptions?: Apollo.QueryHookOptions<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>(OrgJobLocationsDocument, options);
      }
export function useOrgJobLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>(OrgJobLocationsDocument, options);
        }
// @ts-ignore
export function useOrgJobLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>;
export function useOrgJobLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgJobLocationsQuery | undefined, OrgJobLocationsQueryVariables>;
export function useOrgJobLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>(OrgJobLocationsDocument, options);
        }
export type OrgJobLocationsQueryHookResult = ReturnType<typeof useOrgJobLocationsQuery>;
export type OrgJobLocationsLazyQueryHookResult = ReturnType<typeof useOrgJobLocationsLazyQuery>;
export type OrgJobLocationsSuspenseQueryHookResult = ReturnType<typeof useOrgJobLocationsSuspenseQuery>;
export type OrgJobLocationsQueryResult = Apollo.QueryResult<OrgJobLocationsQuery, OrgJobLocationsQueryVariables>;
export const OrgMembersDocument = gql`
    query OrgMembers($input: OrgUserInfoInput!) {
  thisOrg {
    id
    userInfos(input: $input) {
      items {
        ...MemberSelect_userInfo
      }
      nextCursor
    }
  }
}
    ${MemberSelect_UserInfoFragmentDoc}`;

/**
 * __useOrgMembersQuery__
 *
 * To run a query within a React component, call `useOrgMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgMembersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgMembersQuery(baseOptions: Apollo.QueryHookOptions<OrgMembersQuery, OrgMembersQueryVariables> & ({ variables: OrgMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgMembersQuery, OrgMembersQueryVariables>(OrgMembersDocument, options);
      }
export function useOrgMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgMembersQuery, OrgMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgMembersQuery, OrgMembersQueryVariables>(OrgMembersDocument, options);
        }
// @ts-ignore
export function useOrgMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgMembersQuery, OrgMembersQueryVariables>): Apollo.UseSuspenseQueryResult<OrgMembersQuery, OrgMembersQueryVariables>;
export function useOrgMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgMembersQuery, OrgMembersQueryVariables>): Apollo.UseSuspenseQueryResult<OrgMembersQuery | undefined, OrgMembersQueryVariables>;
export function useOrgMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgMembersQuery, OrgMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgMembersQuery, OrgMembersQueryVariables>(OrgMembersDocument, options);
        }
export type OrgMembersQueryHookResult = ReturnType<typeof useOrgMembersQuery>;
export type OrgMembersLazyQueryHookResult = ReturnType<typeof useOrgMembersLazyQuery>;
export type OrgMembersSuspenseQueryHookResult = ReturnType<typeof useOrgMembersSuspenseQuery>;
export type OrgMembersQueryResult = Apollo.QueryResult<OrgMembersQuery, OrgMembersQueryVariables>;
export const UserInfoByEmployeeIdsDocument = gql`
    query UserInfoByEmployeeIds($input: [uuid!]!) {
  userInfoByEmployeeIds(ids: $input) {
    ...MemberSelect_userInfo
  }
}
    ${MemberSelect_UserInfoFragmentDoc}`;

/**
 * __useUserInfoByEmployeeIdsQuery__
 *
 * To run a query within a React component, call `useUserInfoByEmployeeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoByEmployeeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoByEmployeeIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserInfoByEmployeeIdsQuery(baseOptions: Apollo.QueryHookOptions<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables> & ({ variables: UserInfoByEmployeeIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>(UserInfoByEmployeeIdsDocument, options);
      }
export function useUserInfoByEmployeeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>(UserInfoByEmployeeIdsDocument, options);
        }
// @ts-ignore
export function useUserInfoByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>;
export function useUserInfoByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UserInfoByEmployeeIdsQuery | undefined, UserInfoByEmployeeIdsQueryVariables>;
export function useUserInfoByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>(UserInfoByEmployeeIdsDocument, options);
        }
export type UserInfoByEmployeeIdsQueryHookResult = ReturnType<typeof useUserInfoByEmployeeIdsQuery>;
export type UserInfoByEmployeeIdsLazyQueryHookResult = ReturnType<typeof useUserInfoByEmployeeIdsLazyQuery>;
export type UserInfoByEmployeeIdsSuspenseQueryHookResult = ReturnType<typeof useUserInfoByEmployeeIdsSuspenseQuery>;
export type UserInfoByEmployeeIdsQueryResult = Apollo.QueryResult<UserInfoByEmployeeIdsQuery, UserInfoByEmployeeIdsQueryVariables>;
export const PortalTemplateSelectQueryDocument = gql`
    query PortalTemplateSelectQuery($input: PortalTemplatesInput!) {
  portalTemplates(input: $input) {
    nextCursor
    items {
      id
      ...PortalTemplateSelect_portalTemplate
    }
  }
}
    ${PortalTemplateSelect_PortalTemplateFragmentDoc}`;

/**
 * __usePortalTemplateSelectQueryQuery__
 *
 * To run a query within a React component, call `usePortalTemplateSelectQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplateSelectQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalTemplateSelectQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalTemplateSelectQueryQuery(baseOptions: Apollo.QueryHookOptions<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables> & ({ variables: PortalTemplateSelectQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>(PortalTemplateSelectQueryDocument, options);
      }
export function usePortalTemplateSelectQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>(PortalTemplateSelectQueryDocument, options);
        }
// @ts-ignore
export function usePortalTemplateSelectQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>;
export function usePortalTemplateSelectQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateSelectQueryQuery | undefined, PortalTemplateSelectQueryQueryVariables>;
export function usePortalTemplateSelectQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>(PortalTemplateSelectQueryDocument, options);
        }
export type PortalTemplateSelectQueryQueryHookResult = ReturnType<typeof usePortalTemplateSelectQueryQuery>;
export type PortalTemplateSelectQueryLazyQueryHookResult = ReturnType<typeof usePortalTemplateSelectQueryLazyQuery>;
export type PortalTemplateSelectQuerySuspenseQueryHookResult = ReturnType<typeof usePortalTemplateSelectQuerySuspenseQuery>;
export type PortalTemplateSelectQueryQueryResult = Apollo.QueryResult<PortalTemplateSelectQueryQuery, PortalTemplateSelectQueryQueryVariables>;
export const PortalTemplateSelectByIdQueryDocument = gql`
    query PortalTemplateSelectByIdQuery($id: uuid!) {
  portalTemplate(id: $id) {
    id
    name
  }
}
    `;

/**
 * __usePortalTemplateSelectByIdQueryQuery__
 *
 * To run a query within a React component, call `usePortalTemplateSelectByIdQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplateSelectByIdQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalTemplateSelectByIdQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalTemplateSelectByIdQueryQuery(baseOptions: Apollo.QueryHookOptions<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables> & ({ variables: PortalTemplateSelectByIdQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>(PortalTemplateSelectByIdQueryDocument, options);
      }
export function usePortalTemplateSelectByIdQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>(PortalTemplateSelectByIdQueryDocument, options);
        }
// @ts-ignore
export function usePortalTemplateSelectByIdQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>;
export function usePortalTemplateSelectByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateSelectByIdQueryQuery | undefined, PortalTemplateSelectByIdQueryQueryVariables>;
export function usePortalTemplateSelectByIdQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>(PortalTemplateSelectByIdQueryDocument, options);
        }
export type PortalTemplateSelectByIdQueryQueryHookResult = ReturnType<typeof usePortalTemplateSelectByIdQueryQuery>;
export type PortalTemplateSelectByIdQueryLazyQueryHookResult = ReturnType<typeof usePortalTemplateSelectByIdQueryLazyQuery>;
export type PortalTemplateSelectByIdQuerySuspenseQueryHookResult = ReturnType<typeof usePortalTemplateSelectByIdQuerySuspenseQuery>;
export type PortalTemplateSelectByIdQueryQueryResult = Apollo.QueryResult<PortalTemplateSelectByIdQueryQuery, PortalTemplateSelectByIdQueryQueryVariables>;
export const TaskQueuesSelectListDocument = gql`
    query TaskQueuesSelectList($input: TaskQueueSearchInput!) {
  taskQueueSearch(input: $input) {
    items {
      id
      name
      memberCount
    }
  }
}
    `;

/**
 * __useTaskQueuesSelectListQuery__
 *
 * To run a query within a React component, call `useTaskQueuesSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQueuesSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQueuesSelectListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskQueuesSelectListQuery(baseOptions: Apollo.QueryHookOptions<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables> & ({ variables: TaskQueuesSelectListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>(TaskQueuesSelectListDocument, options);
      }
export function useTaskQueuesSelectListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>(TaskQueuesSelectListDocument, options);
        }
// @ts-ignore
export function useTaskQueuesSelectListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>;
export function useTaskQueuesSelectListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueuesSelectListQuery | undefined, TaskQueuesSelectListQueryVariables>;
export function useTaskQueuesSelectListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>(TaskQueuesSelectListDocument, options);
        }
export type TaskQueuesSelectListQueryHookResult = ReturnType<typeof useTaskQueuesSelectListQuery>;
export type TaskQueuesSelectListLazyQueryHookResult = ReturnType<typeof useTaskQueuesSelectListLazyQuery>;
export type TaskQueuesSelectListSuspenseQueryHookResult = ReturnType<typeof useTaskQueuesSelectListSuspenseQuery>;
export type TaskQueuesSelectListQueryResult = Apollo.QueryResult<TaskQueuesSelectListQuery, TaskQueuesSelectListQueryVariables>;
export const TaskQueueDocument = gql`
    query TaskQueue($id: uuid!) {
  taskQueue(id: $id) {
    ...TaskQueue_taskQueue
  }
}
    ${TaskQueue_TaskQueueFragmentDoc}`;

/**
 * __useTaskQueueQuery__
 *
 * To run a query within a React component, call `useTaskQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQueueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskQueueQuery(baseOptions: Apollo.QueryHookOptions<TaskQueueQuery, TaskQueueQueryVariables> & ({ variables: TaskQueueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQueueQuery, TaskQueueQueryVariables>(TaskQueueDocument, options);
      }
export function useTaskQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQueueQuery, TaskQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQueueQuery, TaskQueueQueryVariables>(TaskQueueDocument, options);
        }
// @ts-ignore
export function useTaskQueueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskQueueQuery, TaskQueueQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueueQuery, TaskQueueQueryVariables>;
export function useTaskQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueueQuery, TaskQueueQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueueQuery | undefined, TaskQueueQueryVariables>;
export function useTaskQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueueQuery, TaskQueueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskQueueQuery, TaskQueueQueryVariables>(TaskQueueDocument, options);
        }
export type TaskQueueQueryHookResult = ReturnType<typeof useTaskQueueQuery>;
export type TaskQueueLazyQueryHookResult = ReturnType<typeof useTaskQueueLazyQuery>;
export type TaskQueueSuspenseQueryHookResult = ReturnType<typeof useTaskQueueSuspenseQuery>;
export type TaskQueueQueryResult = Apollo.QueryResult<TaskQueueQuery, TaskQueueQueryVariables>;
export const SmartEmployeeSelectLabelEmployeeChip_EmployeeDocument = gql`
    query SmartEmployeeSelectLabelEmployeeChip_employee($id: uuid!) {
  employee(id: $id) {
    id
    fullName
    givenName
    familyName
    email
    internalProfilePictureUrl
  }
}
    `;

/**
 * __useSmartEmployeeSelectLabelEmployeeChip_EmployeeQuery__
 *
 * To run a query within a React component, call `useSmartEmployeeSelectLabelEmployeeChip_EmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartEmployeeSelectLabelEmployeeChip_EmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartEmployeeSelectLabelEmployeeChip_EmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSmartEmployeeSelectLabelEmployeeChip_EmployeeQuery(baseOptions: Apollo.QueryHookOptions<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables> & ({ variables: SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>(SmartEmployeeSelectLabelEmployeeChip_EmployeeDocument, options);
      }
export function useSmartEmployeeSelectLabelEmployeeChip_EmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>(SmartEmployeeSelectLabelEmployeeChip_EmployeeDocument, options);
        }
// @ts-ignore
export function useSmartEmployeeSelectLabelEmployeeChip_EmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>;
export function useSmartEmployeeSelectLabelEmployeeChip_EmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery | undefined, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>;
export function useSmartEmployeeSelectLabelEmployeeChip_EmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>(SmartEmployeeSelectLabelEmployeeChip_EmployeeDocument, options);
        }
export type SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryHookResult = ReturnType<typeof useSmartEmployeeSelectLabelEmployeeChip_EmployeeQuery>;
export type SmartEmployeeSelectLabelEmployeeChip_EmployeeLazyQueryHookResult = ReturnType<typeof useSmartEmployeeSelectLabelEmployeeChip_EmployeeLazyQuery>;
export type SmartEmployeeSelectLabelEmployeeChip_EmployeeSuspenseQueryHookResult = ReturnType<typeof useSmartEmployeeSelectLabelEmployeeChip_EmployeeSuspenseQuery>;
export type SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryResult = Apollo.QueryResult<SmartEmployeeSelectLabelEmployeeChip_EmployeeQuery, SmartEmployeeSelectLabelEmployeeChip_EmployeeQueryVariables>;
export const SmartEmployeeSelectMembersDocument = gql`
    query SmartEmployeeSelectMembers($input: EmployeeSearchInput!) {
  employeeSearch(input: $input) {
    items {
      ...SmartEmployeeSelect
    }
  }
}
    ${SmartEmployeeSelectFragmentDoc}`;

/**
 * __useSmartEmployeeSelectMembersQuery__
 *
 * To run a query within a React component, call `useSmartEmployeeSelectMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartEmployeeSelectMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartEmployeeSelectMembersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSmartEmployeeSelectMembersQuery(baseOptions: Apollo.QueryHookOptions<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables> & ({ variables: SmartEmployeeSelectMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>(SmartEmployeeSelectMembersDocument, options);
      }
export function useSmartEmployeeSelectMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>(SmartEmployeeSelectMembersDocument, options);
        }
// @ts-ignore
export function useSmartEmployeeSelectMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>;
export function useSmartEmployeeSelectMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeSelectMembersQuery | undefined, SmartEmployeeSelectMembersQueryVariables>;
export function useSmartEmployeeSelectMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>(SmartEmployeeSelectMembersDocument, options);
        }
export type SmartEmployeeSelectMembersQueryHookResult = ReturnType<typeof useSmartEmployeeSelectMembersQuery>;
export type SmartEmployeeSelectMembersLazyQueryHookResult = ReturnType<typeof useSmartEmployeeSelectMembersLazyQuery>;
export type SmartEmployeeSelectMembersSuspenseQueryHookResult = ReturnType<typeof useSmartEmployeeSelectMembersSuspenseQuery>;
export type SmartEmployeeSelectMembersQueryResult = Apollo.QueryResult<SmartEmployeeSelectMembersQuery, SmartEmployeeSelectMembersQueryVariables>;
export const SmartEmployeeByIdsDocument = gql`
    query SmartEmployeeByIds($input: [uuid!]!) {
  employeeByIds(ids: $input) {
    ...SmartEmployeeSelect
  }
}
    ${SmartEmployeeSelectFragmentDoc}`;

/**
 * __useSmartEmployeeByIdsQuery__
 *
 * To run a query within a React component, call `useSmartEmployeeByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartEmployeeByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartEmployeeByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSmartEmployeeByIdsQuery(baseOptions: Apollo.QueryHookOptions<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables> & ({ variables: SmartEmployeeByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>(SmartEmployeeByIdsDocument, options);
      }
export function useSmartEmployeeByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>(SmartEmployeeByIdsDocument, options);
        }
// @ts-ignore
export function useSmartEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>;
export function useSmartEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeByIdsQuery | undefined, SmartEmployeeByIdsQueryVariables>;
export function useSmartEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>(SmartEmployeeByIdsDocument, options);
        }
export type SmartEmployeeByIdsQueryHookResult = ReturnType<typeof useSmartEmployeeByIdsQuery>;
export type SmartEmployeeByIdsLazyQueryHookResult = ReturnType<typeof useSmartEmployeeByIdsLazyQuery>;
export type SmartEmployeeByIdsSuspenseQueryHookResult = ReturnType<typeof useSmartEmployeeByIdsSuspenseQuery>;
export type SmartEmployeeByIdsQueryResult = Apollo.QueryResult<SmartEmployeeByIdsQuery, SmartEmployeeByIdsQueryVariables>;
export const SmartEmployeeGetInterviewersOnPlanByIdsDocument = gql`
    query SmartEmployeeGetInterviewersOnPlanByIds($taskInterviewersOnScheduleEmployeeIds: [uuid!]!) {
  employeeByIds(ids: $taskInterviewersOnScheduleEmployeeIds) {
    ...useTaskSmartOptions_taskInterviewersData
  }
}
    ${UseTaskSmartOptions_TaskInterviewersDataFragmentDoc}`;

/**
 * __useSmartEmployeeGetInterviewersOnPlanByIdsQuery__
 *
 * To run a query within a React component, call `useSmartEmployeeGetInterviewersOnPlanByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartEmployeeGetInterviewersOnPlanByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartEmployeeGetInterviewersOnPlanByIdsQuery({
 *   variables: {
 *      taskInterviewersOnScheduleEmployeeIds: // value for 'taskInterviewersOnScheduleEmployeeIds'
 *   },
 * });
 */
export function useSmartEmployeeGetInterviewersOnPlanByIdsQuery(baseOptions: Apollo.QueryHookOptions<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables> & ({ variables: SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>(SmartEmployeeGetInterviewersOnPlanByIdsDocument, options);
      }
export function useSmartEmployeeGetInterviewersOnPlanByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>(SmartEmployeeGetInterviewersOnPlanByIdsDocument, options);
        }
// @ts-ignore
export function useSmartEmployeeGetInterviewersOnPlanByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>;
export function useSmartEmployeeGetInterviewersOnPlanByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<SmartEmployeeGetInterviewersOnPlanByIdsQuery | undefined, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>;
export function useSmartEmployeeGetInterviewersOnPlanByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>(SmartEmployeeGetInterviewersOnPlanByIdsDocument, options);
        }
export type SmartEmployeeGetInterviewersOnPlanByIdsQueryHookResult = ReturnType<typeof useSmartEmployeeGetInterviewersOnPlanByIdsQuery>;
export type SmartEmployeeGetInterviewersOnPlanByIdsLazyQueryHookResult = ReturnType<typeof useSmartEmployeeGetInterviewersOnPlanByIdsLazyQuery>;
export type SmartEmployeeGetInterviewersOnPlanByIdsSuspenseQueryHookResult = ReturnType<typeof useSmartEmployeeGetInterviewersOnPlanByIdsSuspenseQuery>;
export type SmartEmployeeGetInterviewersOnPlanByIdsQueryResult = Apollo.QueryResult<SmartEmployeeGetInterviewersOnPlanByIdsQuery, SmartEmployeeGetInterviewersOnPlanByIdsQueryVariables>;
export const DynamicEmployeeDocument = gql`
    query DynamicEmployee($id: String!, $taskId: uuid!, $jobId: uuid!, $applicationId: uuid!, $skipTask: Boolean!, $skipJob: Boolean!, $skipCandidate: Boolean!) {
  task: dynamicEmployee(id: $id) @skip(if: $skipTask) {
    TASK_ASSIGNEE(input: {taskId: $taskId}) {
      ...useTaskSmartOptions_taskAssigneeData
    }
    TASK_SUBSCRIBERS(input: {taskId: $taskId}) {
      ...useTaskSmartOptions_taskSubscriberData
    }
    TASK_CREATOR(input: {taskId: $taskId}) {
      ...useTaskSmartOptions_taskCreatorData
    }
    DEBRIEF_ATTENDEES(input: {taskId: $taskId}) {
      ...useTaskSmartOptions_taskDebriefData
    }
  }
  job: dynamicEmployee(id: $id) @skip(if: $skipJob) {
    JOB_COORDINATORS(input: {jobId: $jobId}) {
      ...useJobSmartOptions_jobCoordinatorData
    }
    JOB_RECRUITERS(input: {jobId: $jobId}) {
      ...useJobSmartOptions_jobRecruiterData
    }
    JOB_SOURCERS(input: {jobId: $jobId}) {
      ...useJobSmartOptions_jobSourcerData
    }
    JOB_HIRING_MANAGERS(input: {jobId: $jobId}) {
      ...useJobSmartOptions_jobHiringManagersData
    }
  }
  candidate: dynamicEmployee(id: $id) @skip(if: $skipCandidate) {
    CANDIDATE_COORDINATOR(input: {applicationId: $applicationId}) {
      ...useCandidateSmartOptions_candidateCoordinatorData
    }
    CANDIDATE_RECRUITER(input: {applicationId: $applicationId}) {
      ...useCandidateSmartOptions_candidateRecruiterData
    }
    CANDIDATE_SOURCER(input: {applicationId: $applicationId}) {
      ...useCandidateSmartOptions_candidateSourcerData
    }
    CANDIDATES_PREVIOUS_INTERVIEWERS(input: {applicationId: $applicationId}) {
      ...useCandidateSmartOptions_previousCandidateInterviewersData
    }
  }
}
    ${UseTaskSmartOptions_TaskAssigneeDataFragmentDoc}
${UseTaskSmartOptions_TaskSubscriberDataFragmentDoc}
${UseTaskSmartOptions_TaskCreatorDataFragmentDoc}
${UseTaskSmartOptions_TaskDebriefDataFragmentDoc}
${UseJobSmartOptions_JobCoordinatorDataFragmentDoc}
${UseJobSmartOptions_JobRecruiterDataFragmentDoc}
${UseJobSmartOptions_JobSourcerDataFragmentDoc}
${UseJobSmartOptions_JobHiringManagersDataFragmentDoc}
${UseCandidateSmartOptions_CandidateCoordinatorDataFragmentDoc}
${UseCandidateSmartOptions_CandidateRecruiterDataFragmentDoc}
${UseCandidateSmartOptions_CandidateSourcerDataFragmentDoc}
${UseCandidateSmartOptions_PreviousCandidateInterviewersDataFragmentDoc}`;

/**
 * __useDynamicEmployeeQuery__
 *
 * To run a query within a React component, call `useDynamicEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDynamicEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDynamicEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      taskId: // value for 'taskId'
 *      jobId: // value for 'jobId'
 *      applicationId: // value for 'applicationId'
 *      skipTask: // value for 'skipTask'
 *      skipJob: // value for 'skipJob'
 *      skipCandidate: // value for 'skipCandidate'
 *   },
 * });
 */
export function useDynamicEmployeeQuery(baseOptions: Apollo.QueryHookOptions<DynamicEmployeeQuery, DynamicEmployeeQueryVariables> & ({ variables: DynamicEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>(DynamicEmployeeDocument, options);
      }
export function useDynamicEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>(DynamicEmployeeDocument, options);
        }
// @ts-ignore
export function useDynamicEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>;
export function useDynamicEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<DynamicEmployeeQuery | undefined, DynamicEmployeeQueryVariables>;
export function useDynamicEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>(DynamicEmployeeDocument, options);
        }
export type DynamicEmployeeQueryHookResult = ReturnType<typeof useDynamicEmployeeQuery>;
export type DynamicEmployeeLazyQueryHookResult = ReturnType<typeof useDynamicEmployeeLazyQuery>;
export type DynamicEmployeeSuspenseQueryHookResult = ReturnType<typeof useDynamicEmployeeSuspenseQuery>;
export type DynamicEmployeeQueryResult = Apollo.QueryResult<DynamicEmployeeQuery, DynamicEmployeeQueryVariables>;
export const UseGetDynamicAudienceDataForTaskDocument = gql`
    query useGetDynamicAudienceDataForTask($taskAssigneeEmployeeIds: [uuid!]!, $taskCreatorEmployeeIds: [uuid!]!, $taskSubscriberEmployeeIds: [uuid!]!, $taskDebriefEmployeeIds: [uuid!]!) {
  taskAssigneeData: employeeByIds(ids: $taskAssigneeEmployeeIds) {
    ...useGetDynamicAudienceData_DynamicEmployee
  }
  taskSubscriberData: employeeByIds(ids: $taskSubscriberEmployeeIds) {
    ...useGetDynamicAudienceData_DynamicEmployee
  }
  taskDebriefData: employeeByIds(ids: $taskDebriefEmployeeIds) {
    ...useGetDynamicAudienceData_DynamicEmployee
  }
  taskCreatorData: employeeByIds(ids: $taskCreatorEmployeeIds) {
    ...useGetDynamicAudienceData_DynamicEmployee
  }
}
    ${UseGetDynamicAudienceData_DynamicEmployeeFragmentDoc}`;

/**
 * __useUseGetDynamicAudienceDataForTaskQuery__
 *
 * To run a query within a React component, call `useUseGetDynamicAudienceDataForTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseGetDynamicAudienceDataForTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseGetDynamicAudienceDataForTaskQuery({
 *   variables: {
 *      taskAssigneeEmployeeIds: // value for 'taskAssigneeEmployeeIds'
 *      taskCreatorEmployeeIds: // value for 'taskCreatorEmployeeIds'
 *      taskSubscriberEmployeeIds: // value for 'taskSubscriberEmployeeIds'
 *      taskDebriefEmployeeIds: // value for 'taskDebriefEmployeeIds'
 *   },
 * });
 */
export function useUseGetDynamicAudienceDataForTaskQuery(baseOptions: Apollo.QueryHookOptions<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables> & ({ variables: UseGetDynamicAudienceDataForTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>(UseGetDynamicAudienceDataForTaskDocument, options);
      }
export function useUseGetDynamicAudienceDataForTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>(UseGetDynamicAudienceDataForTaskDocument, options);
        }
// @ts-ignore
export function useUseGetDynamicAudienceDataForTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>): Apollo.UseSuspenseQueryResult<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>;
export function useUseGetDynamicAudienceDataForTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>): Apollo.UseSuspenseQueryResult<UseGetDynamicAudienceDataForTaskQuery | undefined, UseGetDynamicAudienceDataForTaskQueryVariables>;
export function useUseGetDynamicAudienceDataForTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>(UseGetDynamicAudienceDataForTaskDocument, options);
        }
export type UseGetDynamicAudienceDataForTaskQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataForTaskQuery>;
export type UseGetDynamicAudienceDataForTaskLazyQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataForTaskLazyQuery>;
export type UseGetDynamicAudienceDataForTaskSuspenseQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataForTaskSuspenseQuery>;
export type UseGetDynamicAudienceDataForTaskQueryResult = Apollo.QueryResult<UseGetDynamicAudienceDataForTaskQuery, UseGetDynamicAudienceDataForTaskQueryVariables>;
export const UseGetDynamicAudienceDataByEmployeeIdsDocument = gql`
    query useGetDynamicAudienceDataByEmployeeIds($ids: [uuid!]!) {
  employeeByIds(ids: $ids) {
    ...useGetDynamicAudienceData_DynamicEmployee
  }
}
    ${UseGetDynamicAudienceData_DynamicEmployeeFragmentDoc}`;

/**
 * __useUseGetDynamicAudienceDataByEmployeeIdsQuery__
 *
 * To run a query within a React component, call `useUseGetDynamicAudienceDataByEmployeeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseGetDynamicAudienceDataByEmployeeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseGetDynamicAudienceDataByEmployeeIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUseGetDynamicAudienceDataByEmployeeIdsQuery(baseOptions: Apollo.QueryHookOptions<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables> & ({ variables: UseGetDynamicAudienceDataByEmployeeIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>(UseGetDynamicAudienceDataByEmployeeIdsDocument, options);
      }
export function useUseGetDynamicAudienceDataByEmployeeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>(UseGetDynamicAudienceDataByEmployeeIdsDocument, options);
        }
// @ts-ignore
export function useUseGetDynamicAudienceDataByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>;
export function useUseGetDynamicAudienceDataByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UseGetDynamicAudienceDataByEmployeeIdsQuery | undefined, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>;
export function useUseGetDynamicAudienceDataByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>(UseGetDynamicAudienceDataByEmployeeIdsDocument, options);
        }
export type UseGetDynamicAudienceDataByEmployeeIdsQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataByEmployeeIdsQuery>;
export type UseGetDynamicAudienceDataByEmployeeIdsLazyQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataByEmployeeIdsLazyQuery>;
export type UseGetDynamicAudienceDataByEmployeeIdsSuspenseQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataByEmployeeIdsSuspenseQuery>;
export type UseGetDynamicAudienceDataByEmployeeIdsQueryResult = Apollo.QueryResult<UseGetDynamicAudienceDataByEmployeeIdsQuery, UseGetDynamicAudienceDataByEmployeeIdsQueryVariables>;
export const UseGetDynamicAudienceDataDynamicEmployeeDocument = gql`
    query useGetDynamicAudienceDataDynamicEmployee($id: String!, $taskId: uuid!, $jobId: uuid!, $applicationId: uuid!, $skipTask: Boolean!, $skipJob: Boolean!, $skipCandidate: Boolean!) {
  task: dynamicEmployee(id: $id) @skip(if: $skipTask) {
    TASK_ASSIGNEE(input: {taskId: $taskId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    TASK_SUBSCRIBERS(input: {taskId: $taskId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    TASK_CREATOR(input: {taskId: $taskId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    DEBRIEF_ATTENDEES(input: {taskId: $taskId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
  }
  job: dynamicEmployee(id: $id) @skip(if: $skipJob) {
    JOB_COORDINATORS(input: {jobId: $jobId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    JOB_RECRUITERS(input: {jobId: $jobId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    JOB_SOURCERS(input: {jobId: $jobId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    JOB_HIRING_MANAGERS(input: {jobId: $jobId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
  }
  candidate: dynamicEmployee(id: $id) @skip(if: $skipCandidate) {
    CANDIDATE_COORDINATOR(input: {applicationId: $applicationId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    CANDIDATE_RECRUITER(input: {applicationId: $applicationId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    CANDIDATE_SOURCER(input: {applicationId: $applicationId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
    CANDIDATES_PREVIOUS_INTERVIEWERS(input: {applicationId: $applicationId}) {
      ...useGetDynamicAudienceData_DynamicEmployee
    }
  }
}
    ${UseGetDynamicAudienceData_DynamicEmployeeFragmentDoc}`;

/**
 * __useUseGetDynamicAudienceDataDynamicEmployeeQuery__
 *
 * To run a query within a React component, call `useUseGetDynamicAudienceDataDynamicEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseGetDynamicAudienceDataDynamicEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseGetDynamicAudienceDataDynamicEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      taskId: // value for 'taskId'
 *      jobId: // value for 'jobId'
 *      applicationId: // value for 'applicationId'
 *      skipTask: // value for 'skipTask'
 *      skipJob: // value for 'skipJob'
 *      skipCandidate: // value for 'skipCandidate'
 *   },
 * });
 */
export function useUseGetDynamicAudienceDataDynamicEmployeeQuery(baseOptions: Apollo.QueryHookOptions<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables> & ({ variables: UseGetDynamicAudienceDataDynamicEmployeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>(UseGetDynamicAudienceDataDynamicEmployeeDocument, options);
      }
export function useUseGetDynamicAudienceDataDynamicEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>(UseGetDynamicAudienceDataDynamicEmployeeDocument, options);
        }
// @ts-ignore
export function useUseGetDynamicAudienceDataDynamicEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>;
export function useUseGetDynamicAudienceDataDynamicEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<UseGetDynamicAudienceDataDynamicEmployeeQuery | undefined, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>;
export function useUseGetDynamicAudienceDataDynamicEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>(UseGetDynamicAudienceDataDynamicEmployeeDocument, options);
        }
export type UseGetDynamicAudienceDataDynamicEmployeeQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataDynamicEmployeeQuery>;
export type UseGetDynamicAudienceDataDynamicEmployeeLazyQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataDynamicEmployeeLazyQuery>;
export type UseGetDynamicAudienceDataDynamicEmployeeSuspenseQueryHookResult = ReturnType<typeof useUseGetDynamicAudienceDataDynamicEmployeeSuspenseQuery>;
export type UseGetDynamicAudienceDataDynamicEmployeeQueryResult = Apollo.QueryResult<UseGetDynamicAudienceDataDynamicEmployeeQuery, UseGetDynamicAudienceDataDynamicEmployeeQueryVariables>;
export const UseTaskSmartOptionsEmployeeByIdsDocument = gql`
    query UseTaskSmartOptionsEmployeeByIds($taskAssigneeEmployeeIds: [uuid!]!, $taskCreatorEmployeeIds: [uuid!]!, $taskSubscriberEmployeeIds: [uuid!]!, $taskDebriefEmployeeIds: [uuid!]!) {
  taskAssigneeData: employeeByIds(ids: $taskAssigneeEmployeeIds) {
    ...OptionRenderer_employees
  }
  taskSubscriberData: employeeByIds(ids: $taskSubscriberEmployeeIds) {
    ...OptionRenderer_employees
  }
  taskDebriefData: employeeByIds(ids: $taskDebriefEmployeeIds) {
    ...OptionRenderer_employees
  }
  taskCreatorData: employeeByIds(ids: $taskCreatorEmployeeIds) {
    ...OptionRenderer_employees
  }
}
    ${OptionRenderer_EmployeesFragmentDoc}`;

/**
 * __useUseTaskSmartOptionsEmployeeByIdsQuery__
 *
 * To run a query within a React component, call `useUseTaskSmartOptionsEmployeeByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseTaskSmartOptionsEmployeeByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseTaskSmartOptionsEmployeeByIdsQuery({
 *   variables: {
 *      taskAssigneeEmployeeIds: // value for 'taskAssigneeEmployeeIds'
 *      taskCreatorEmployeeIds: // value for 'taskCreatorEmployeeIds'
 *      taskSubscriberEmployeeIds: // value for 'taskSubscriberEmployeeIds'
 *      taskDebriefEmployeeIds: // value for 'taskDebriefEmployeeIds'
 *   },
 * });
 */
export function useUseTaskSmartOptionsEmployeeByIdsQuery(baseOptions: Apollo.QueryHookOptions<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables> & ({ variables: UseTaskSmartOptionsEmployeeByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>(UseTaskSmartOptionsEmployeeByIdsDocument, options);
      }
export function useUseTaskSmartOptionsEmployeeByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>(UseTaskSmartOptionsEmployeeByIdsDocument, options);
        }
// @ts-ignore
export function useUseTaskSmartOptionsEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>;
export function useUseTaskSmartOptionsEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UseTaskSmartOptionsEmployeeByIdsQuery | undefined, UseTaskSmartOptionsEmployeeByIdsQueryVariables>;
export function useUseTaskSmartOptionsEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>(UseTaskSmartOptionsEmployeeByIdsDocument, options);
        }
export type UseTaskSmartOptionsEmployeeByIdsQueryHookResult = ReturnType<typeof useUseTaskSmartOptionsEmployeeByIdsQuery>;
export type UseTaskSmartOptionsEmployeeByIdsLazyQueryHookResult = ReturnType<typeof useUseTaskSmartOptionsEmployeeByIdsLazyQuery>;
export type UseTaskSmartOptionsEmployeeByIdsSuspenseQueryHookResult = ReturnType<typeof useUseTaskSmartOptionsEmployeeByIdsSuspenseQuery>;
export type UseTaskSmartOptionsEmployeeByIdsQueryResult = Apollo.QueryResult<UseTaskSmartOptionsEmployeeByIdsQuery, UseTaskSmartOptionsEmployeeByIdsQueryVariables>;
export const UseTaskSmartOptionsByEmployeeIdsDocument = gql`
    query useTaskSmartOptionsByEmployeeIds($ids: [uuid!]!) {
  employeeByIds(ids: $ids) {
    ...OptionRenderer_employees
  }
}
    ${OptionRenderer_EmployeesFragmentDoc}`;

/**
 * __useUseTaskSmartOptionsByEmployeeIdsQuery__
 *
 * To run a query within a React component, call `useUseTaskSmartOptionsByEmployeeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseTaskSmartOptionsByEmployeeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseTaskSmartOptionsByEmployeeIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUseTaskSmartOptionsByEmployeeIdsQuery(baseOptions: Apollo.QueryHookOptions<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables> & ({ variables: UseTaskSmartOptionsByEmployeeIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>(UseTaskSmartOptionsByEmployeeIdsDocument, options);
      }
export function useUseTaskSmartOptionsByEmployeeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>(UseTaskSmartOptionsByEmployeeIdsDocument, options);
        }
// @ts-ignore
export function useUseTaskSmartOptionsByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>;
export function useUseTaskSmartOptionsByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<UseTaskSmartOptionsByEmployeeIdsQuery | undefined, UseTaskSmartOptionsByEmployeeIdsQueryVariables>;
export function useUseTaskSmartOptionsByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>(UseTaskSmartOptionsByEmployeeIdsDocument, options);
        }
export type UseTaskSmartOptionsByEmployeeIdsQueryHookResult = ReturnType<typeof useUseTaskSmartOptionsByEmployeeIdsQuery>;
export type UseTaskSmartOptionsByEmployeeIdsLazyQueryHookResult = ReturnType<typeof useUseTaskSmartOptionsByEmployeeIdsLazyQuery>;
export type UseTaskSmartOptionsByEmployeeIdsSuspenseQueryHookResult = ReturnType<typeof useUseTaskSmartOptionsByEmployeeIdsSuspenseQuery>;
export type UseTaskSmartOptionsByEmployeeIdsQueryResult = Apollo.QueryResult<UseTaskSmartOptionsByEmployeeIdsQuery, UseTaskSmartOptionsByEmployeeIdsQueryVariables>;
export const ZoomUsersListDocument = gql`
    query ZoomUsersList($input: ZoomUsersInput!) {
  zoomUsers(input: $input) {
    items {
      ...ZoomUserFragment
    }
    nextCursor
  }
}
    ${ZoomUserFragmentFragmentDoc}`;

/**
 * __useZoomUsersListQuery__
 *
 * To run a query within a React component, call `useZoomUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomUsersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZoomUsersListQuery(baseOptions: Apollo.QueryHookOptions<ZoomUsersListQuery, ZoomUsersListQueryVariables> & ({ variables: ZoomUsersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZoomUsersListQuery, ZoomUsersListQueryVariables>(ZoomUsersListDocument, options);
      }
export function useZoomUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomUsersListQuery, ZoomUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZoomUsersListQuery, ZoomUsersListQueryVariables>(ZoomUsersListDocument, options);
        }
// @ts-ignore
export function useZoomUsersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZoomUsersListQuery, ZoomUsersListQueryVariables>): Apollo.UseSuspenseQueryResult<ZoomUsersListQuery, ZoomUsersListQueryVariables>;
export function useZoomUsersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoomUsersListQuery, ZoomUsersListQueryVariables>): Apollo.UseSuspenseQueryResult<ZoomUsersListQuery | undefined, ZoomUsersListQueryVariables>;
export function useZoomUsersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoomUsersListQuery, ZoomUsersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZoomUsersListQuery, ZoomUsersListQueryVariables>(ZoomUsersListDocument, options);
        }
export type ZoomUsersListQueryHookResult = ReturnType<typeof useZoomUsersListQuery>;
export type ZoomUsersListLazyQueryHookResult = ReturnType<typeof useZoomUsersListLazyQuery>;
export type ZoomUsersListSuspenseQueryHookResult = ReturnType<typeof useZoomUsersListSuspenseQuery>;
export type ZoomUsersListQueryResult = Apollo.QueryResult<ZoomUsersListQuery, ZoomUsersListQueryVariables>;
export const ZoomUsersByIdsDocument = gql`
    query ZoomUsersByIds($input: ZoomUsersByIdsInput!) {
  zoomUsersByIds(input: $input) {
    ...ZoomUserFragment
  }
}
    ${ZoomUserFragmentFragmentDoc}`;

/**
 * __useZoomUsersByIdsQuery__
 *
 * To run a query within a React component, call `useZoomUsersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomUsersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomUsersByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZoomUsersByIdsQuery(baseOptions: Apollo.QueryHookOptions<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables> & ({ variables: ZoomUsersByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>(ZoomUsersByIdsDocument, options);
      }
export function useZoomUsersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>(ZoomUsersByIdsDocument, options);
        }
// @ts-ignore
export function useZoomUsersByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>;
export function useZoomUsersByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ZoomUsersByIdsQuery | undefined, ZoomUsersByIdsQueryVariables>;
export function useZoomUsersByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>(ZoomUsersByIdsDocument, options);
        }
export type ZoomUsersByIdsQueryHookResult = ReturnType<typeof useZoomUsersByIdsQuery>;
export type ZoomUsersByIdsLazyQueryHookResult = ReturnType<typeof useZoomUsersByIdsLazyQuery>;
export type ZoomUsersByIdsSuspenseQueryHookResult = ReturnType<typeof useZoomUsersByIdsSuspenseQuery>;
export type ZoomUsersByIdsQueryResult = Apollo.QueryResult<ZoomUsersByIdsQuery, ZoomUsersByIdsQueryVariables>;
export const ZoomUserByIdsDocument = gql`
    query ZoomUserByIds($input: ZoomUsersByIdsInput!) {
  zoomUsersByIds(input: $input) {
    ...ZoomUserFragment
  }
}
    ${ZoomUserFragmentFragmentDoc}`;

/**
 * __useZoomUserByIdsQuery__
 *
 * To run a query within a React component, call `useZoomUserByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useZoomUserByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZoomUserByIdsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZoomUserByIdsQuery(baseOptions: Apollo.QueryHookOptions<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables> & ({ variables: ZoomUserByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>(ZoomUserByIdsDocument, options);
      }
export function useZoomUserByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>(ZoomUserByIdsDocument, options);
        }
// @ts-ignore
export function useZoomUserByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>;
export function useZoomUserByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<ZoomUserByIdsQuery | undefined, ZoomUserByIdsQueryVariables>;
export function useZoomUserByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>(ZoomUserByIdsDocument, options);
        }
export type ZoomUserByIdsQueryHookResult = ReturnType<typeof useZoomUserByIdsQuery>;
export type ZoomUserByIdsLazyQueryHookResult = ReturnType<typeof useZoomUserByIdsLazyQuery>;
export type ZoomUserByIdsSuspenseQueryHookResult = ReturnType<typeof useZoomUserByIdsSuspenseQuery>;
export type ZoomUserByIdsQueryResult = Apollo.QueryResult<ZoomUserByIdsQuery, ZoomUserByIdsQueryVariables>;
export const CurrentEmployeeDetailsDocument = gql`
    query CurrentEmployeeDetails {
  thisEmployee {
    id
    ...SubscribersSelect_thisEmployee
  }
}
    ${SubscribersSelect_ThisEmployeeFragmentDoc}`;

/**
 * __useCurrentEmployeeDetailsQuery__
 *
 * To run a query within a React component, call `useCurrentEmployeeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentEmployeeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentEmployeeDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentEmployeeDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>(CurrentEmployeeDetailsDocument, options);
      }
export function useCurrentEmployeeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>(CurrentEmployeeDetailsDocument, options);
        }
// @ts-ignore
export function useCurrentEmployeeDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>;
export function useCurrentEmployeeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentEmployeeDetailsQuery | undefined, CurrentEmployeeDetailsQueryVariables>;
export function useCurrentEmployeeDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>(CurrentEmployeeDetailsDocument, options);
        }
export type CurrentEmployeeDetailsQueryHookResult = ReturnType<typeof useCurrentEmployeeDetailsQuery>;
export type CurrentEmployeeDetailsLazyQueryHookResult = ReturnType<typeof useCurrentEmployeeDetailsLazyQuery>;
export type CurrentEmployeeDetailsSuspenseQueryHookResult = ReturnType<typeof useCurrentEmployeeDetailsSuspenseQuery>;
export type CurrentEmployeeDetailsQueryResult = Apollo.QueryResult<CurrentEmployeeDetailsQuery, CurrentEmployeeDetailsQueryVariables>;
export const SubscribersListDocument = gql`
    query SubscribersList($input: SubscribersInput!) {
  subscribers(input: $input) {
    items {
      id
      ...SubscribersSelect_employee
    }
  }
}
    ${SubscribersSelect_EmployeeFragmentDoc}`;

/**
 * __useSubscribersListQuery__
 *
 * To run a query within a React component, call `useSubscribersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribersListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribersListQuery(baseOptions: Apollo.QueryHookOptions<SubscribersListQuery, SubscribersListQueryVariables> & ({ variables: SubscribersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscribersListQuery, SubscribersListQueryVariables>(SubscribersListDocument, options);
      }
export function useSubscribersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscribersListQuery, SubscribersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscribersListQuery, SubscribersListQueryVariables>(SubscribersListDocument, options);
        }
// @ts-ignore
export function useSubscribersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscribersListQuery, SubscribersListQueryVariables>): Apollo.UseSuspenseQueryResult<SubscribersListQuery, SubscribersListQueryVariables>;
export function useSubscribersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribersListQuery, SubscribersListQueryVariables>): Apollo.UseSuspenseQueryResult<SubscribersListQuery | undefined, SubscribersListQueryVariables>;
export function useSubscribersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribersListQuery, SubscribersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscribersListQuery, SubscribersListQueryVariables>(SubscribersListDocument, options);
        }
export type SubscribersListQueryHookResult = ReturnType<typeof useSubscribersListQuery>;
export type SubscribersListLazyQueryHookResult = ReturnType<typeof useSubscribersListLazyQuery>;
export type SubscribersListSuspenseQueryHookResult = ReturnType<typeof useSubscribersListSuspenseQuery>;
export type SubscribersListQueryResult = Apollo.QueryResult<SubscribersListQuery, SubscribersListQueryVariables>;
export const SubscriberAddDocument = gql`
    mutation SubscriberAdd($input: SubscriberAddInput!) {
  subscriberAdd(input: $input) {
    result
    subscribers {
      id
      ...SubscribersSelect_employee
    }
  }
}
    ${SubscribersSelect_EmployeeFragmentDoc}`;
export type SubscriberAddMutationFn = Apollo.MutationFunction<SubscriberAddMutation, SubscriberAddMutationVariables>;

/**
 * __useSubscriberAddMutation__
 *
 * To run a mutation, you first call `useSubscriberAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriberAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriberAddMutation, { data, loading, error }] = useSubscriberAddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscriberAddMutation(baseOptions?: Apollo.MutationHookOptions<SubscriberAddMutation, SubscriberAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriberAddMutation, SubscriberAddMutationVariables>(SubscriberAddDocument, options);
      }
export type SubscriberAddMutationHookResult = ReturnType<typeof useSubscriberAddMutation>;
export type SubscriberAddMutationResult = Apollo.MutationResult<SubscriberAddMutation>;
export type SubscriberAddMutationOptions = Apollo.BaseMutationOptions<SubscriberAddMutation, SubscriberAddMutationVariables>;
export const SubscriberRemoveDocument = gql`
    mutation SubscriberRemove($input: SubscriberRemoveInput!) {
  subscriberRemove(input: $input) {
    result
    subscribers {
      id
      ...SubscribersSelect_employee
    }
  }
}
    ${SubscribersSelect_EmployeeFragmentDoc}`;
export type SubscriberRemoveMutationFn = Apollo.MutationFunction<SubscriberRemoveMutation, SubscriberRemoveMutationVariables>;

/**
 * __useSubscriberRemoveMutation__
 *
 * To run a mutation, you first call `useSubscriberRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscriberRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscriberRemoveMutation, { data, loading, error }] = useSubscriberRemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscriberRemoveMutation(baseOptions?: Apollo.MutationHookOptions<SubscriberRemoveMutation, SubscriberRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscriberRemoveMutation, SubscriberRemoveMutationVariables>(SubscriberRemoveDocument, options);
      }
export type SubscriberRemoveMutationHookResult = ReturnType<typeof useSubscriberRemoveMutation>;
export type SubscriberRemoveMutationResult = Apollo.MutationResult<SubscriberRemoveMutation>;
export type SubscriberRemoveMutationOptions = Apollo.BaseMutationOptions<SubscriberRemoveMutation, SubscriberRemoveMutationVariables>;
export const TemplateSelectTemplateByIdDocument = gql`
    query TemplateSelectTemplateById($id: uuid!) {
  template(id: $id) {
    id
    ...TemplateSelectRow_template
  }
}
    ${TemplateSelectRow_TemplateFragmentDoc}`;

/**
 * __useTemplateSelectTemplateByIdQuery__
 *
 * To run a query within a React component, call `useTemplateSelectTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateSelectTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateSelectTemplateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateSelectTemplateByIdQuery(baseOptions: Apollo.QueryHookOptions<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables> & ({ variables: TemplateSelectTemplateByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>(TemplateSelectTemplateByIdDocument, options);
      }
export function useTemplateSelectTemplateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>(TemplateSelectTemplateByIdDocument, options);
        }
// @ts-ignore
export function useTemplateSelectTemplateByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>;
export function useTemplateSelectTemplateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateSelectTemplateByIdQuery | undefined, TemplateSelectTemplateByIdQueryVariables>;
export function useTemplateSelectTemplateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>(TemplateSelectTemplateByIdDocument, options);
        }
export type TemplateSelectTemplateByIdQueryHookResult = ReturnType<typeof useTemplateSelectTemplateByIdQuery>;
export type TemplateSelectTemplateByIdLazyQueryHookResult = ReturnType<typeof useTemplateSelectTemplateByIdLazyQuery>;
export type TemplateSelectTemplateByIdSuspenseQueryHookResult = ReturnType<typeof useTemplateSelectTemplateByIdSuspenseQuery>;
export type TemplateSelectTemplateByIdQueryResult = Apollo.QueryResult<TemplateSelectTemplateByIdQuery, TemplateSelectTemplateByIdQueryVariables>;
export const TemplateSelectTemplatesSearchDocument = gql`
    query TemplateSelectTemplatesSearch($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      id
      ...TemplateSelectRow_template
    }
  }
}
    ${TemplateSelectRow_TemplateFragmentDoc}`;

/**
 * __useTemplateSelectTemplatesSearchQuery__
 *
 * To run a query within a React component, call `useTemplateSelectTemplatesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateSelectTemplatesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateSelectTemplatesSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateSelectTemplatesSearchQuery(baseOptions: Apollo.QueryHookOptions<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables> & ({ variables: TemplateSelectTemplatesSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>(TemplateSelectTemplatesSearchDocument, options);
      }
export function useTemplateSelectTemplatesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>(TemplateSelectTemplatesSearchDocument, options);
        }
// @ts-ignore
export function useTemplateSelectTemplatesSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>;
export function useTemplateSelectTemplatesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateSelectTemplatesSearchQuery | undefined, TemplateSelectTemplatesSearchQueryVariables>;
export function useTemplateSelectTemplatesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>(TemplateSelectTemplatesSearchDocument, options);
        }
export type TemplateSelectTemplatesSearchQueryHookResult = ReturnType<typeof useTemplateSelectTemplatesSearchQuery>;
export type TemplateSelectTemplatesSearchLazyQueryHookResult = ReturnType<typeof useTemplateSelectTemplatesSearchLazyQuery>;
export type TemplateSelectTemplatesSearchSuspenseQueryHookResult = ReturnType<typeof useTemplateSelectTemplatesSearchSuspenseQuery>;
export type TemplateSelectTemplatesSearchQueryResult = Apollo.QueryResult<TemplateSelectTemplatesSearchQuery, TemplateSelectTemplatesSearchQueryVariables>;
export const EmployeePrefsDocument = gql`
    query EmployeePrefs($id: uuid!, $prefName: String!) {
  employee(id: $id) {
    id
    employeePref(prefName: $prefName) {
      id
      orgId
      employeeId
      prefName
      createdAt
      updatedAt
      ...EmployeePrefData
    }
  }
}
    ${EmployeePrefDataFragmentDoc}`;

/**
 * __useEmployeePrefsQuery__
 *
 * To run a query within a React component, call `useEmployeePrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeePrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeePrefsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useEmployeePrefsQuery(baseOptions: Apollo.QueryHookOptions<EmployeePrefsQuery, EmployeePrefsQueryVariables> & ({ variables: EmployeePrefsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeePrefsQuery, EmployeePrefsQueryVariables>(EmployeePrefsDocument, options);
      }
export function useEmployeePrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeePrefsQuery, EmployeePrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeePrefsQuery, EmployeePrefsQueryVariables>(EmployeePrefsDocument, options);
        }
// @ts-ignore
export function useEmployeePrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeePrefsQuery, EmployeePrefsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeePrefsQuery, EmployeePrefsQueryVariables>;
export function useEmployeePrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeePrefsQuery, EmployeePrefsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeePrefsQuery | undefined, EmployeePrefsQueryVariables>;
export function useEmployeePrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeePrefsQuery, EmployeePrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeePrefsQuery, EmployeePrefsQueryVariables>(EmployeePrefsDocument, options);
        }
export type EmployeePrefsQueryHookResult = ReturnType<typeof useEmployeePrefsQuery>;
export type EmployeePrefsLazyQueryHookResult = ReturnType<typeof useEmployeePrefsLazyQuery>;
export type EmployeePrefsSuspenseQueryHookResult = ReturnType<typeof useEmployeePrefsSuspenseQuery>;
export type EmployeePrefsQueryResult = Apollo.QueryResult<EmployeePrefsQuery, EmployeePrefsQueryVariables>;
export const UpdateEmployeePrefDocument = gql`
    mutation UpdateEmployeePref($input: EmployeePrefUpdateInput!) {
  employeePrefUpdate(input: $input) {
    employeePref {
      id
      orgId
      employeeId
      prefName
      timestamp
    }
  }
}
    `;
export type UpdateEmployeePrefMutationFn = Apollo.MutationFunction<UpdateEmployeePrefMutation, UpdateEmployeePrefMutationVariables>;

/**
 * __useUpdateEmployeePrefMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeePrefMutation, { data, loading, error }] = useUpdateEmployeePrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeePrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeePrefMutation, UpdateEmployeePrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeePrefMutation, UpdateEmployeePrefMutationVariables>(UpdateEmployeePrefDocument, options);
      }
export type UpdateEmployeePrefMutationHookResult = ReturnType<typeof useUpdateEmployeePrefMutation>;
export type UpdateEmployeePrefMutationResult = Apollo.MutationResult<UpdateEmployeePrefMutation>;
export type UpdateEmployeePrefMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeePrefMutation, UpdateEmployeePrefMutationVariables>;
export const EmployeeLocaleDocument = gql`
    query EmployeeLocale {
  thisEmployee {
    id
    locale
  }
}
    `;

/**
 * __useEmployeeLocaleQuery__
 *
 * To run a query within a React component, call `useEmployeeLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeLocaleQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>(EmployeeLocaleDocument, options);
      }
export function useEmployeeLocaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>(EmployeeLocaleDocument, options);
        }
// @ts-ignore
export function useEmployeeLocaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>;
export function useEmployeeLocaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeLocaleQuery | undefined, EmployeeLocaleQueryVariables>;
export function useEmployeeLocaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>(EmployeeLocaleDocument, options);
        }
export type EmployeeLocaleQueryHookResult = ReturnType<typeof useEmployeeLocaleQuery>;
export type EmployeeLocaleLazyQueryHookResult = ReturnType<typeof useEmployeeLocaleLazyQuery>;
export type EmployeeLocaleSuspenseQueryHookResult = ReturnType<typeof useEmployeeLocaleSuspenseQuery>;
export type EmployeeLocaleQueryResult = Apollo.QueryResult<EmployeeLocaleQuery, EmployeeLocaleQueryVariables>;
export const EmployeeLocaleUpdateDocument = gql`
    mutation EmployeeLocaleUpdate($input: EmployeeUpdateInput!) {
  employeeUpdate(input: $input) {
    employee {
      id
      locale
    }
  }
}
    `;
export type EmployeeLocaleUpdateMutationFn = Apollo.MutationFunction<EmployeeLocaleUpdateMutation, EmployeeLocaleUpdateMutationVariables>;

/**
 * __useEmployeeLocaleUpdateMutation__
 *
 * To run a mutation, you first call `useEmployeeLocaleUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeLocaleUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeLocaleUpdateMutation, { data, loading, error }] = useEmployeeLocaleUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeLocaleUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeLocaleUpdateMutation, EmployeeLocaleUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeLocaleUpdateMutation, EmployeeLocaleUpdateMutationVariables>(EmployeeLocaleUpdateDocument, options);
      }
export type EmployeeLocaleUpdateMutationHookResult = ReturnType<typeof useEmployeeLocaleUpdateMutation>;
export type EmployeeLocaleUpdateMutationResult = Apollo.MutationResult<EmployeeLocaleUpdateMutation>;
export type EmployeeLocaleUpdateMutationOptions = Apollo.BaseMutationOptions<EmployeeLocaleUpdateMutation, EmployeeLocaleUpdateMutationVariables>;
export const ApplicationStageInterviewPlanDocument = gql`
    query applicationStageInterviewPlan($id: uuid!) {
  applicationStage(id: $id) {
    id
    task {
      id
      availabilities {
        id
        createdAt
        candidateEnteredAvailability {
          startAt
          endAt
        }
        rcEnteredAvailability {
          startAt
          endAt
        }
      }
    }
    emailTemplateId
    applicationId
    conversation {
      id
      remoteId
      remoteName
    }
    isPrivateCalendarEvent
    ccRecipients {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
    bccRecipients {
      employeeIds
      externalEmailAddresses
      dynamicAudiences
    }
    applicationStageCandidateEvents {
      id
      name
      googleEventId
      googleCalendarId
      calendarEventTemplateId
      __typename
      additionalAttendeesV2 {
        employeeIds
        emails
        isOptional
        attendees {
          email
          employeeId
          isOptional
          sourceAudience
        }
        employees {
          id
          fullName
          email
          internalProfilePictureUrl
        }
      }
    }
    applicationStageInterviews(input: {isCancelled: false}) {
      id
      isCancelled
      __typename
      additionalAttendeesV2 {
        employeeIds
        emails
        isOptional
        attendees {
          email
          employeeId
          isOptional
          sourceAudience
        }
        employees {
          id
          fullName
          email
          internalProfilePictureUrl
        }
      }
    }
    jobStage {
      id
      atsId
      jobId
      name
      createdAt
      updatedAt
      schedulable
      job {
        id
        atsId
        name
        hiringManagers {
          id
        }
      }
      jobStageSettingsV2 {
        id
        ccRecipientsV2 {
          notificationPreference {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
        }
        bccRecipientsV2 {
          notificationPreference {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
        }
        candidateEventAdditionalAttendees {
          notificationPreference {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
        }
        interviewerEventAdditionalAttendees {
          notificationPreference {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
        }
        debriefEventAdditionalAttendees {
          notificationPreference {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
        }
        candidateEventAdditionalAttendeesOptional {
          value
        }
        interviewerEventAdditionalAttendeesOptional {
          value
        }
        debriefEventAdditionalAttendeesOptional {
          value
        }
        candidateEventAdditionalAttendeesV2 {
          attendees {
            email
            employeeId
            dynamicAudience
            isOptional
          }
        }
        interviewerEventAdditionalAttendeesV2 {
          attendees {
            email
            employeeId
            dynamicAudience
            isOptional
          }
        }
        debriefEventAdditionalAttendeesV2 {
          attendees {
            email
            employeeId
            dynamicAudience
            isOptional
          }
        }
        candidateEmailTemplateId {
          templateId
          template {
            id
            name
          }
        }
        candidateCalendarId {
          remoteCalendarId
          remoteCalendar {
            name
            id
          }
        }
        candidateEventTemplateId {
          templateId
          template {
            id
            name
          }
        }
        chatConversationMembers {
          notificationPreference {
            employeeIds
            dynamicAudiences
          }
        }
      }
    }
    application {
      id
      candidate {
        id
        fullName
        email
        additionalEmails
        timezone
        atsCandidate {
          atsUrl
          atsId
        }
        ...CandidateAtsLatestAvailabilityFragment
      }
      coordinator {
        id
      }
      recruiter {
        id
      }
      existingConversations {
        id
        remoteId
        remoteName
        isArchived
      }
    }
  }
}
    ${CandidateAtsLatestAvailabilityFragmentFragmentDoc}`;

/**
 * __useApplicationStageInterviewPlanQuery__
 *
 * To run a query within a React component, call `useApplicationStageInterviewPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStageInterviewPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStageInterviewPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationStageInterviewPlanQuery(baseOptions: Apollo.QueryHookOptions<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables> & ({ variables: ApplicationStageInterviewPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>(ApplicationStageInterviewPlanDocument, options);
      }
export function useApplicationStageInterviewPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>(ApplicationStageInterviewPlanDocument, options);
        }
// @ts-ignore
export function useApplicationStageInterviewPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>;
export function useApplicationStageInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageInterviewPlanQuery | undefined, ApplicationStageInterviewPlanQueryVariables>;
export function useApplicationStageInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>(ApplicationStageInterviewPlanDocument, options);
        }
export type ApplicationStageInterviewPlanQueryHookResult = ReturnType<typeof useApplicationStageInterviewPlanQuery>;
export type ApplicationStageInterviewPlanLazyQueryHookResult = ReturnType<typeof useApplicationStageInterviewPlanLazyQuery>;
export type ApplicationStageInterviewPlanSuspenseQueryHookResult = ReturnType<typeof useApplicationStageInterviewPlanSuspenseQuery>;
export type ApplicationStageInterviewPlanQueryResult = Apollo.QueryResult<ApplicationStageInterviewPlanQuery, ApplicationStageInterviewPlanQueryVariables>;
export const OrgPrefsDocument = gql`
    query OrgPrefs {
  thisOrg {
    id
    orgPrefs {
      ...OrgPrefsData
    }
  }
}
    ${OrgPrefsDataFragmentDoc}`;

/**
 * __useOrgPrefsQuery__
 *
 * To run a query within a React component, call `useOrgPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgPrefsQuery(baseOptions?: Apollo.QueryHookOptions<OrgPrefsQuery, OrgPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgPrefsQuery, OrgPrefsQueryVariables>(OrgPrefsDocument, options);
      }
export function useOrgPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgPrefsQuery, OrgPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgPrefsQuery, OrgPrefsQueryVariables>(OrgPrefsDocument, options);
        }
// @ts-ignore
export function useOrgPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgPrefsQuery, OrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgPrefsQuery, OrgPrefsQueryVariables>;
export function useOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgPrefsQuery, OrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgPrefsQuery | undefined, OrgPrefsQueryVariables>;
export function useOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgPrefsQuery, OrgPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgPrefsQuery, OrgPrefsQueryVariables>(OrgPrefsDocument, options);
        }
export type OrgPrefsQueryHookResult = ReturnType<typeof useOrgPrefsQuery>;
export type OrgPrefsLazyQueryHookResult = ReturnType<typeof useOrgPrefsLazyQuery>;
export type OrgPrefsSuspenseQueryHookResult = ReturnType<typeof useOrgPrefsSuspenseQuery>;
export type OrgPrefsQueryResult = Apollo.QueryResult<OrgPrefsQuery, OrgPrefsQueryVariables>;
export const UpdateOrgPrefsDocument = gql`
    mutation UpdateOrgPrefs($input: OrgPrefUpdateInput!) {
  orgPrefUpdate(input: $input) {
    orgPref {
      ...OrgPrefsData
    }
  }
}
    ${OrgPrefsDataFragmentDoc}`;
export type UpdateOrgPrefsMutationFn = Apollo.MutationFunction<UpdateOrgPrefsMutation, UpdateOrgPrefsMutationVariables>;

/**
 * __useUpdateOrgPrefsMutation__
 *
 * To run a mutation, you first call `useUpdateOrgPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgPrefsMutation, { data, loading, error }] = useUpdateOrgPrefsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgPrefsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgPrefsMutation, UpdateOrgPrefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgPrefsMutation, UpdateOrgPrefsMutationVariables>(UpdateOrgPrefsDocument, options);
      }
export type UpdateOrgPrefsMutationHookResult = ReturnType<typeof useUpdateOrgPrefsMutation>;
export type UpdateOrgPrefsMutationResult = Apollo.MutationResult<UpdateOrgPrefsMutation>;
export type UpdateOrgPrefsMutationOptions = Apollo.BaseMutationOptions<UpdateOrgPrefsMutation, UpdateOrgPrefsMutationVariables>;
export const SupportedLocalesDocument = gql`
    query SupportedLocales {
  thisOrg {
    id
    supportedLocales
  }
}
    `;

/**
 * __useSupportedLocalesQuery__
 *
 * To run a query within a React component, call `useSupportedLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedLocalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedLocalesQuery(baseOptions?: Apollo.QueryHookOptions<SupportedLocalesQuery, SupportedLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedLocalesQuery, SupportedLocalesQueryVariables>(SupportedLocalesDocument, options);
      }
export function useSupportedLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedLocalesQuery, SupportedLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedLocalesQuery, SupportedLocalesQueryVariables>(SupportedLocalesDocument, options);
        }
// @ts-ignore
export function useSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportedLocalesQuery, SupportedLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLocalesQuery, SupportedLocalesQueryVariables>;
export function useSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLocalesQuery, SupportedLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLocalesQuery | undefined, SupportedLocalesQueryVariables>;
export function useSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLocalesQuery, SupportedLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportedLocalesQuery, SupportedLocalesQueryVariables>(SupportedLocalesDocument, options);
        }
export type SupportedLocalesQueryHookResult = ReturnType<typeof useSupportedLocalesQuery>;
export type SupportedLocalesLazyQueryHookResult = ReturnType<typeof useSupportedLocalesLazyQuery>;
export type SupportedLocalesSuspenseQueryHookResult = ReturnType<typeof useSupportedLocalesSuspenseQuery>;
export type SupportedLocalesQueryResult = Apollo.QueryResult<SupportedLocalesQuery, SupportedLocalesQueryVariables>;
export const UserPermissionDocument = gql`
    query UserPermission {
  thisUserInfo {
    permissions
  }
}
    `;

/**
 * __useUserPermissionQuery__
 *
 * To run a query within a React component, call `useUserPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPermissionQuery(baseOptions?: Apollo.QueryHookOptions<UserPermissionQuery, UserPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPermissionQuery, UserPermissionQueryVariables>(UserPermissionDocument, options);
      }
export function useUserPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPermissionQuery, UserPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPermissionQuery, UserPermissionQueryVariables>(UserPermissionDocument, options);
        }
// @ts-ignore
export function useUserPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserPermissionQuery, UserPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<UserPermissionQuery, UserPermissionQueryVariables>;
export function useUserPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPermissionQuery, UserPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<UserPermissionQuery | undefined, UserPermissionQueryVariables>;
export function useUserPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPermissionQuery, UserPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPermissionQuery, UserPermissionQueryVariables>(UserPermissionDocument, options);
        }
export type UserPermissionQueryHookResult = ReturnType<typeof useUserPermissionQuery>;
export type UserPermissionLazyQueryHookResult = ReturnType<typeof useUserPermissionLazyQuery>;
export type UserPermissionSuspenseQueryHookResult = ReturnType<typeof useUserPermissionSuspenseQuery>;
export type UserPermissionQueryResult = Apollo.QueryResult<UserPermissionQuery, UserPermissionQueryVariables>;
export const ResetHiringProcessListAtsConfigDocument = gql`
    query ResetHiringProcessListAtsConfig {
  hiringProcesses {
    atsId
    name
  }
}
    `;

/**
 * __useResetHiringProcessListAtsConfigQuery__
 *
 * To run a query within a React component, call `useResetHiringProcessListAtsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useResetHiringProcessListAtsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResetHiringProcessListAtsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useResetHiringProcessListAtsConfigQuery(baseOptions?: Apollo.QueryHookOptions<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>(ResetHiringProcessListAtsConfigDocument, options);
      }
export function useResetHiringProcessListAtsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>(ResetHiringProcessListAtsConfigDocument, options);
        }
// @ts-ignore
export function useResetHiringProcessListAtsConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>;
export function useResetHiringProcessListAtsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>): Apollo.UseSuspenseQueryResult<ResetHiringProcessListAtsConfigQuery | undefined, ResetHiringProcessListAtsConfigQueryVariables>;
export function useResetHiringProcessListAtsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>(ResetHiringProcessListAtsConfigDocument, options);
        }
export type ResetHiringProcessListAtsConfigQueryHookResult = ReturnType<typeof useResetHiringProcessListAtsConfigQuery>;
export type ResetHiringProcessListAtsConfigLazyQueryHookResult = ReturnType<typeof useResetHiringProcessListAtsConfigLazyQuery>;
export type ResetHiringProcessListAtsConfigSuspenseQueryHookResult = ReturnType<typeof useResetHiringProcessListAtsConfigSuspenseQuery>;
export type ResetHiringProcessListAtsConfigQueryResult = Apollo.QueryResult<ResetHiringProcessListAtsConfigQuery, ResetHiringProcessListAtsConfigQueryVariables>;
export const HiringProcessListAtsConfigDocument = gql`
    query HiringProcessListAtsConfig {
  hiringProcesses {
    atsId
    name
  }
}
    `;

/**
 * __useHiringProcessListAtsConfigQuery__
 *
 * To run a query within a React component, call `useHiringProcessListAtsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useHiringProcessListAtsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHiringProcessListAtsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useHiringProcessListAtsConfigQuery(baseOptions?: Apollo.QueryHookOptions<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>(HiringProcessListAtsConfigDocument, options);
      }
export function useHiringProcessListAtsConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>(HiringProcessListAtsConfigDocument, options);
        }
// @ts-ignore
export function useHiringProcessListAtsConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>): Apollo.UseSuspenseQueryResult<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>;
export function useHiringProcessListAtsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>): Apollo.UseSuspenseQueryResult<HiringProcessListAtsConfigQuery | undefined, HiringProcessListAtsConfigQueryVariables>;
export function useHiringProcessListAtsConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>(HiringProcessListAtsConfigDocument, options);
        }
export type HiringProcessListAtsConfigQueryHookResult = ReturnType<typeof useHiringProcessListAtsConfigQuery>;
export type HiringProcessListAtsConfigLazyQueryHookResult = ReturnType<typeof useHiringProcessListAtsConfigLazyQuery>;
export type HiringProcessListAtsConfigSuspenseQueryHookResult = ReturnType<typeof useHiringProcessListAtsConfigSuspenseQuery>;
export type HiringProcessListAtsConfigQueryResult = Apollo.QueryResult<HiringProcessListAtsConfigQuery, HiringProcessListAtsConfigQueryVariables>;
export const UpdateHiringProcessDocument = gql`
    mutation UpdateHiringProcess($input: JobSettingsUpsertInput!) {
  jobSettingsUpsert(input: $input) {
    jobSettings {
      id
      hiringProcess {
        atsId
        name
      }
    }
  }
}
    `;
export type UpdateHiringProcessMutationFn = Apollo.MutationFunction<UpdateHiringProcessMutation, UpdateHiringProcessMutationVariables>;

/**
 * __useUpdateHiringProcessMutation__
 *
 * To run a mutation, you first call `useUpdateHiringProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHiringProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHiringProcessMutation, { data, loading, error }] = useUpdateHiringProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHiringProcessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHiringProcessMutation, UpdateHiringProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHiringProcessMutation, UpdateHiringProcessMutationVariables>(UpdateHiringProcessDocument, options);
      }
export type UpdateHiringProcessMutationHookResult = ReturnType<typeof useUpdateHiringProcessMutation>;
export type UpdateHiringProcessMutationResult = Apollo.MutationResult<UpdateHiringProcessMutation>;
export type UpdateHiringProcessMutationOptions = Apollo.BaseMutationOptions<UpdateHiringProcessMutation, UpdateHiringProcessMutationVariables>;
export const SmartRecruitersHiringProcessByJobIdDocument = gql`
    query SmartRecruitersHiringProcessByJobId($id: uuid!) {
  job(id: $id) {
    id
    name
    jobSettings {
      id
      hiringProcess {
        atsId
        status
      }
    }
    ...HiringProcessSelectDialog_job
    ...JobNameAndLocationHeader_job
  }
}
    ${HiringProcessSelectDialog_JobFragmentDoc}
${JobNameAndLocationHeader_JobFragmentDoc}`;

/**
 * __useSmartRecruitersHiringProcessByJobIdQuery__
 *
 * To run a query within a React component, call `useSmartRecruitersHiringProcessByJobIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSmartRecruitersHiringProcessByJobIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSmartRecruitersHiringProcessByJobIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSmartRecruitersHiringProcessByJobIdQuery(baseOptions: Apollo.QueryHookOptions<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables> & ({ variables: SmartRecruitersHiringProcessByJobIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>(SmartRecruitersHiringProcessByJobIdDocument, options);
      }
export function useSmartRecruitersHiringProcessByJobIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>(SmartRecruitersHiringProcessByJobIdDocument, options);
        }
// @ts-ignore
export function useSmartRecruitersHiringProcessByJobIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>): Apollo.UseSuspenseQueryResult<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>;
export function useSmartRecruitersHiringProcessByJobIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>): Apollo.UseSuspenseQueryResult<SmartRecruitersHiringProcessByJobIdQuery | undefined, SmartRecruitersHiringProcessByJobIdQueryVariables>;
export function useSmartRecruitersHiringProcessByJobIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>(SmartRecruitersHiringProcessByJobIdDocument, options);
        }
export type SmartRecruitersHiringProcessByJobIdQueryHookResult = ReturnType<typeof useSmartRecruitersHiringProcessByJobIdQuery>;
export type SmartRecruitersHiringProcessByJobIdLazyQueryHookResult = ReturnType<typeof useSmartRecruitersHiringProcessByJobIdLazyQuery>;
export type SmartRecruitersHiringProcessByJobIdSuspenseQueryHookResult = ReturnType<typeof useSmartRecruitersHiringProcessByJobIdSuspenseQuery>;
export type SmartRecruitersHiringProcessByJobIdQueryResult = Apollo.QueryResult<SmartRecruitersHiringProcessByJobIdQuery, SmartRecruitersHiringProcessByJobIdQueryVariables>;
export const CollaborationServiceIntegrationsDocument = gql`
    query CollaborationServiceIntegrations {
  thisOrg {
    integrations {
      id
      coderpad {
        apiKey
      }
      codility {
        apiKey
      }
      codesignal {
        apiKey
      }
      hackerrank {
        apiKey
      }
    }
    id
  }
}
    `;

/**
 * __useCollaborationServiceIntegrationsQuery__
 *
 * To run a query within a React component, call `useCollaborationServiceIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollaborationServiceIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollaborationServiceIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCollaborationServiceIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>(CollaborationServiceIntegrationsDocument, options);
      }
export function useCollaborationServiceIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>(CollaborationServiceIntegrationsDocument, options);
        }
// @ts-ignore
export function useCollaborationServiceIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>;
export function useCollaborationServiceIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<CollaborationServiceIntegrationsQuery | undefined, CollaborationServiceIntegrationsQueryVariables>;
export function useCollaborationServiceIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>(CollaborationServiceIntegrationsDocument, options);
        }
export type CollaborationServiceIntegrationsQueryHookResult = ReturnType<typeof useCollaborationServiceIntegrationsQuery>;
export type CollaborationServiceIntegrationsLazyQueryHookResult = ReturnType<typeof useCollaborationServiceIntegrationsLazyQuery>;
export type CollaborationServiceIntegrationsSuspenseQueryHookResult = ReturnType<typeof useCollaborationServiceIntegrationsSuspenseQuery>;
export type CollaborationServiceIntegrationsQueryResult = Apollo.QueryResult<CollaborationServiceIntegrationsQuery, CollaborationServiceIntegrationsQueryVariables>;
export const DirectoryServiceDocument = gql`
    query DirectoryService {
  thisOrg {
    id
    multiDomainEnabled
    integrations {
      id
      google {
        adminUserId
      }
      microsoft {
        active
      }
      microsoftCustom {
        active
        scopes
      }
      microsoftGccHigh {
        active
      }
    }
  }
}
    `;

/**
 * __useDirectoryServiceQuery__
 *
 * To run a query within a React component, call `useDirectoryServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useDirectoryServiceQuery(baseOptions?: Apollo.QueryHookOptions<DirectoryServiceQuery, DirectoryServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryServiceQuery, DirectoryServiceQueryVariables>(DirectoryServiceDocument, options);
      }
export function useDirectoryServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryServiceQuery, DirectoryServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryServiceQuery, DirectoryServiceQueryVariables>(DirectoryServiceDocument, options);
        }
// @ts-ignore
export function useDirectoryServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryServiceQuery, DirectoryServiceQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryServiceQuery, DirectoryServiceQueryVariables>;
export function useDirectoryServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryServiceQuery, DirectoryServiceQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryServiceQuery | undefined, DirectoryServiceQueryVariables>;
export function useDirectoryServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryServiceQuery, DirectoryServiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryServiceQuery, DirectoryServiceQueryVariables>(DirectoryServiceDocument, options);
        }
export type DirectoryServiceQueryHookResult = ReturnType<typeof useDirectoryServiceQuery>;
export type DirectoryServiceLazyQueryHookResult = ReturnType<typeof useDirectoryServiceLazyQuery>;
export type DirectoryServiceSuspenseQueryHookResult = ReturnType<typeof useDirectoryServiceSuspenseQuery>;
export type DirectoryServiceQueryResult = Apollo.QueryResult<DirectoryServiceQuery, DirectoryServiceQueryVariables>;
export const GoogleIntegrationHealthCheckDocument = gql`
    query GoogleIntegrationHealthCheck {
  integrationCheckHealth(input: {force: false}) {
    id
    google {
      canSendGmail
    }
  }
  thisOrg {
    id
    integrations {
      id
      google {
        adminUserId
      }
    }
  }
  thisEmployee {
    id
    integrations {
      id
      google {
        active
      }
    }
  }
}
    `;

/**
 * __useGoogleIntegrationHealthCheckQuery__
 *
 * To run a query within a React component, call `useGoogleIntegrationHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleIntegrationHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleIntegrationHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoogleIntegrationHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>(GoogleIntegrationHealthCheckDocument, options);
      }
export function useGoogleIntegrationHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>(GoogleIntegrationHealthCheckDocument, options);
        }
// @ts-ignore
export function useGoogleIntegrationHealthCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>;
export function useGoogleIntegrationHealthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GoogleIntegrationHealthCheckQuery | undefined, GoogleIntegrationHealthCheckQueryVariables>;
export function useGoogleIntegrationHealthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>(GoogleIntegrationHealthCheckDocument, options);
        }
export type GoogleIntegrationHealthCheckQueryHookResult = ReturnType<typeof useGoogleIntegrationHealthCheckQuery>;
export type GoogleIntegrationHealthCheckLazyQueryHookResult = ReturnType<typeof useGoogleIntegrationHealthCheckLazyQuery>;
export type GoogleIntegrationHealthCheckSuspenseQueryHookResult = ReturnType<typeof useGoogleIntegrationHealthCheckSuspenseQuery>;
export type GoogleIntegrationHealthCheckQueryResult = Apollo.QueryResult<GoogleIntegrationHealthCheckQuery, GoogleIntegrationHealthCheckQueryVariables>;
export const MicrosoftIntegrationDocument = gql`
    query MicrosoftIntegration {
  thisOrg {
    id
    integrations {
      id
      microsoft {
        active
      }
      microsoftGccHigh {
        active
      }
      microsoftCustom {
        active
      }
      microsoftServiceUser {
        serviceAccountEmail
      }
    }
  }
  thisEmployee {
    id
    integrations {
      id
      microsoft {
        active
      }
      microsoftGccHighEmployee {
        active
      }
      microsoftCustomEmployee {
        active
      }
      microsoftServiceUser {
        active
      }
    }
  }
}
    `;

/**
 * __useMicrosoftIntegrationQuery__
 *
 * To run a query within a React component, call `useMicrosoftIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMicrosoftIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>(MicrosoftIntegrationDocument, options);
      }
export function useMicrosoftIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>(MicrosoftIntegrationDocument, options);
        }
// @ts-ignore
export function useMicrosoftIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>;
export function useMicrosoftIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftIntegrationQuery | undefined, MicrosoftIntegrationQueryVariables>;
export function useMicrosoftIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>(MicrosoftIntegrationDocument, options);
        }
export type MicrosoftIntegrationQueryHookResult = ReturnType<typeof useMicrosoftIntegrationQuery>;
export type MicrosoftIntegrationLazyQueryHookResult = ReturnType<typeof useMicrosoftIntegrationLazyQuery>;
export type MicrosoftIntegrationSuspenseQueryHookResult = ReturnType<typeof useMicrosoftIntegrationSuspenseQuery>;
export type MicrosoftIntegrationQueryResult = Apollo.QueryResult<MicrosoftIntegrationQuery, MicrosoftIntegrationQueryVariables>;
export const ImportCandidateAvailabilityApplicationTasksDocument = gql`
    query ImportCandidateAvailabilityApplicationTasks($applicationId: uuid!) {
  application(id: $applicationId) {
    tasks {
      canceledAt
      id
      availabilities {
        id
        candidateEnteredAvailability {
          startAt
          endAt
        }
        rcEnteredAvailability {
          startAt
          endAt
        }
      }
    }
  }
}
    `;

/**
 * __useImportCandidateAvailabilityApplicationTasksQuery__
 *
 * To run a query within a React component, call `useImportCandidateAvailabilityApplicationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportCandidateAvailabilityApplicationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportCandidateAvailabilityApplicationTasksQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useImportCandidateAvailabilityApplicationTasksQuery(baseOptions: Apollo.QueryHookOptions<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables> & ({ variables: ImportCandidateAvailabilityApplicationTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>(ImportCandidateAvailabilityApplicationTasksDocument, options);
      }
export function useImportCandidateAvailabilityApplicationTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>(ImportCandidateAvailabilityApplicationTasksDocument, options);
        }
// @ts-ignore
export function useImportCandidateAvailabilityApplicationTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>): Apollo.UseSuspenseQueryResult<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>;
export function useImportCandidateAvailabilityApplicationTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>): Apollo.UseSuspenseQueryResult<ImportCandidateAvailabilityApplicationTasksQuery | undefined, ImportCandidateAvailabilityApplicationTasksQueryVariables>;
export function useImportCandidateAvailabilityApplicationTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>(ImportCandidateAvailabilityApplicationTasksDocument, options);
        }
export type ImportCandidateAvailabilityApplicationTasksQueryHookResult = ReturnType<typeof useImportCandidateAvailabilityApplicationTasksQuery>;
export type ImportCandidateAvailabilityApplicationTasksLazyQueryHookResult = ReturnType<typeof useImportCandidateAvailabilityApplicationTasksLazyQuery>;
export type ImportCandidateAvailabilityApplicationTasksSuspenseQueryHookResult = ReturnType<typeof useImportCandidateAvailabilityApplicationTasksSuspenseQuery>;
export type ImportCandidateAvailabilityApplicationTasksQueryResult = Apollo.QueryResult<ImportCandidateAvailabilityApplicationTasksQuery, ImportCandidateAvailabilityApplicationTasksQueryVariables>;
export const DefaultTemplateIdsForTypesDocument = gql`
    query DefaultTemplateIdsForTypes($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      id
      type
    }
  }
}
    `;

/**
 * __useDefaultTemplateIdsForTypesQuery__
 *
 * To run a query within a React component, call `useDefaultTemplateIdsForTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultTemplateIdsForTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultTemplateIdsForTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefaultTemplateIdsForTypesQuery(baseOptions: Apollo.QueryHookOptions<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables> & ({ variables: DefaultTemplateIdsForTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>(DefaultTemplateIdsForTypesDocument, options);
      }
export function useDefaultTemplateIdsForTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>(DefaultTemplateIdsForTypesDocument, options);
        }
// @ts-ignore
export function useDefaultTemplateIdsForTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>;
export function useDefaultTemplateIdsForTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultTemplateIdsForTypesQuery | undefined, DefaultTemplateIdsForTypesQueryVariables>;
export function useDefaultTemplateIdsForTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>(DefaultTemplateIdsForTypesDocument, options);
        }
export type DefaultTemplateIdsForTypesQueryHookResult = ReturnType<typeof useDefaultTemplateIdsForTypesQuery>;
export type DefaultTemplateIdsForTypesLazyQueryHookResult = ReturnType<typeof useDefaultTemplateIdsForTypesLazyQuery>;
export type DefaultTemplateIdsForTypesSuspenseQueryHookResult = ReturnType<typeof useDefaultTemplateIdsForTypesSuspenseQuery>;
export type DefaultTemplateIdsForTypesQueryResult = Apollo.QueryResult<DefaultTemplateIdsForTypesQuery, DefaultTemplateIdsForTypesQueryVariables>;
export const AllCompanyHolidaysDocument = gql`
    query AllCompanyHolidays($input: CompanyHolidaysInput!) {
  companyHolidays(input: $input) {
    items {
      ...CompanyHolidays
    }
  }
}
    ${CompanyHolidaysFragmentDoc}`;

/**
 * __useAllCompanyHolidaysQuery__
 *
 * To run a query within a React component, call `useAllCompanyHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompanyHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompanyHolidaysQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllCompanyHolidaysQuery(baseOptions: Apollo.QueryHookOptions<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables> & ({ variables: AllCompanyHolidaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>(AllCompanyHolidaysDocument, options);
      }
export function useAllCompanyHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>(AllCompanyHolidaysDocument, options);
        }
// @ts-ignore
export function useAllCompanyHolidaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>;
export function useAllCompanyHolidaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompanyHolidaysQuery | undefined, AllCompanyHolidaysQueryVariables>;
export function useAllCompanyHolidaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>(AllCompanyHolidaysDocument, options);
        }
export type AllCompanyHolidaysQueryHookResult = ReturnType<typeof useAllCompanyHolidaysQuery>;
export type AllCompanyHolidaysLazyQueryHookResult = ReturnType<typeof useAllCompanyHolidaysLazyQuery>;
export type AllCompanyHolidaysSuspenseQueryHookResult = ReturnType<typeof useAllCompanyHolidaysSuspenseQuery>;
export type AllCompanyHolidaysQueryResult = Apollo.QueryResult<AllCompanyHolidaysQuery, AllCompanyHolidaysQueryVariables>;
export const DirectoryInfoDocument = gql`
    query DirectoryInfo {
  thisOrg {
    id
    directoryType
    directoryIntegrations {
      id
      name
      type
    }
  }
}
    `;

/**
 * __useDirectoryInfoQuery__
 *
 * To run a query within a React component, call `useDirectoryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useDirectoryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDirectoryInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useDirectoryInfoQuery(baseOptions?: Apollo.QueryHookOptions<DirectoryInfoQuery, DirectoryInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DirectoryInfoQuery, DirectoryInfoQueryVariables>(DirectoryInfoDocument, options);
      }
export function useDirectoryInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DirectoryInfoQuery, DirectoryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DirectoryInfoQuery, DirectoryInfoQueryVariables>(DirectoryInfoDocument, options);
        }
// @ts-ignore
export function useDirectoryInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DirectoryInfoQuery, DirectoryInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryInfoQuery, DirectoryInfoQueryVariables>;
export function useDirectoryInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryInfoQuery, DirectoryInfoQueryVariables>): Apollo.UseSuspenseQueryResult<DirectoryInfoQuery | undefined, DirectoryInfoQueryVariables>;
export function useDirectoryInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DirectoryInfoQuery, DirectoryInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DirectoryInfoQuery, DirectoryInfoQueryVariables>(DirectoryInfoDocument, options);
        }
export type DirectoryInfoQueryHookResult = ReturnType<typeof useDirectoryInfoQuery>;
export type DirectoryInfoLazyQueryHookResult = ReturnType<typeof useDirectoryInfoLazyQuery>;
export type DirectoryInfoSuspenseQueryHookResult = ReturnType<typeof useDirectoryInfoSuspenseQuery>;
export type DirectoryInfoQueryResult = Apollo.QueryResult<DirectoryInfoQuery, DirectoryInfoQueryVariables>;
export const OrgHasAtLeastOneAdminDocument = gql`
    query OrgHasAtLeastOneAdmin {
  thisOrg {
    id
    hasAdmin
  }
}
    `;

/**
 * __useOrgHasAtLeastOneAdminQuery__
 *
 * To run a query within a React component, call `useOrgHasAtLeastOneAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgHasAtLeastOneAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgHasAtLeastOneAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgHasAtLeastOneAdminQuery(baseOptions?: Apollo.QueryHookOptions<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>(OrgHasAtLeastOneAdminDocument, options);
      }
export function useOrgHasAtLeastOneAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>(OrgHasAtLeastOneAdminDocument, options);
        }
// @ts-ignore
export function useOrgHasAtLeastOneAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>): Apollo.UseSuspenseQueryResult<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>;
export function useOrgHasAtLeastOneAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>): Apollo.UseSuspenseQueryResult<OrgHasAtLeastOneAdminQuery | undefined, OrgHasAtLeastOneAdminQueryVariables>;
export function useOrgHasAtLeastOneAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>(OrgHasAtLeastOneAdminDocument, options);
        }
export type OrgHasAtLeastOneAdminQueryHookResult = ReturnType<typeof useOrgHasAtLeastOneAdminQuery>;
export type OrgHasAtLeastOneAdminLazyQueryHookResult = ReturnType<typeof useOrgHasAtLeastOneAdminLazyQuery>;
export type OrgHasAtLeastOneAdminSuspenseQueryHookResult = ReturnType<typeof useOrgHasAtLeastOneAdminSuspenseQuery>;
export type OrgHasAtLeastOneAdminQueryResult = Apollo.QueryResult<OrgHasAtLeastOneAdminQuery, OrgHasAtLeastOneAdminQueryVariables>;
export const HasZoomIntegrationDocument = gql`
    query HasZoomIntegration {
  thisOrg {
    id
    integrations {
      id
      zoom {
        active
      }
      zoomCustom {
        active
      }
    }
  }
}
    `;

/**
 * __useHasZoomIntegrationQuery__
 *
 * To run a query within a React component, call `useHasZoomIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasZoomIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasZoomIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasZoomIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>(HasZoomIntegrationDocument, options);
      }
export function useHasZoomIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>(HasZoomIntegrationDocument, options);
        }
// @ts-ignore
export function useHasZoomIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>;
export function useHasZoomIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<HasZoomIntegrationQuery | undefined, HasZoomIntegrationQueryVariables>;
export function useHasZoomIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>(HasZoomIntegrationDocument, options);
        }
export type HasZoomIntegrationQueryHookResult = ReturnType<typeof useHasZoomIntegrationQuery>;
export type HasZoomIntegrationLazyQueryHookResult = ReturnType<typeof useHasZoomIntegrationLazyQuery>;
export type HasZoomIntegrationSuspenseQueryHookResult = ReturnType<typeof useHasZoomIntegrationSuspenseQuery>;
export type HasZoomIntegrationQueryResult = Apollo.QueryResult<HasZoomIntegrationQuery, HasZoomIntegrationQueryVariables>;
export const SyncEmployeeCalendarManualEntityDocument = gql`
    mutation SyncEmployeeCalendarManualEntity($input: SyncEmployeeCalendarInput!) {
  syncEmployeeCalendar(input: $input) {
    __typename
    ... on SyncEmployeeCalendarSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncEmployeeCalendarManualEntityMutationFn = Apollo.MutationFunction<SyncEmployeeCalendarManualEntityMutation, SyncEmployeeCalendarManualEntityMutationVariables>;

/**
 * __useSyncEmployeeCalendarManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncEmployeeCalendarManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEmployeeCalendarManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEmployeeCalendarManualEntityMutation, { data, loading, error }] = useSyncEmployeeCalendarManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEmployeeCalendarManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncEmployeeCalendarManualEntityMutation, SyncEmployeeCalendarManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEmployeeCalendarManualEntityMutation, SyncEmployeeCalendarManualEntityMutationVariables>(SyncEmployeeCalendarManualEntityDocument, options);
      }
export type SyncEmployeeCalendarManualEntityMutationHookResult = ReturnType<typeof useSyncEmployeeCalendarManualEntityMutation>;
export type SyncEmployeeCalendarManualEntityMutationResult = Apollo.MutationResult<SyncEmployeeCalendarManualEntityMutation>;
export type SyncEmployeeCalendarManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncEmployeeCalendarManualEntityMutation, SyncEmployeeCalendarManualEntityMutationVariables>;
export const SyncEmployeeAtsManualEntityDocument = gql`
    mutation SyncEmployeeAtsManualEntity($input: SyncEmployeeAtsInput!) {
  syncEmployeeAts(input: $input) {
    __typename
    ... on SyncEmployeeAtsSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncEmployeeAtsManualEntityMutationFn = Apollo.MutationFunction<SyncEmployeeAtsManualEntityMutation, SyncEmployeeAtsManualEntityMutationVariables>;

/**
 * __useSyncEmployeeAtsManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncEmployeeAtsManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncEmployeeAtsManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncEmployeeAtsManualEntityMutation, { data, loading, error }] = useSyncEmployeeAtsManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncEmployeeAtsManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncEmployeeAtsManualEntityMutation, SyncEmployeeAtsManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncEmployeeAtsManualEntityMutation, SyncEmployeeAtsManualEntityMutationVariables>(SyncEmployeeAtsManualEntityDocument, options);
      }
export type SyncEmployeeAtsManualEntityMutationHookResult = ReturnType<typeof useSyncEmployeeAtsManualEntityMutation>;
export type SyncEmployeeAtsManualEntityMutationResult = Apollo.MutationResult<SyncEmployeeAtsManualEntityMutation>;
export type SyncEmployeeAtsManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncEmployeeAtsManualEntityMutation, SyncEmployeeAtsManualEntityMutationVariables>;
export const SyncCandidateManualEntityDocument = gql`
    mutation SyncCandidateManualEntity($input: SyncCandidateInput!) {
  syncCandidate(input: $input) {
    __typename
    ... on SyncCandidateSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncCandidateManualEntityMutationFn = Apollo.MutationFunction<SyncCandidateManualEntityMutation, SyncCandidateManualEntityMutationVariables>;

/**
 * __useSyncCandidateManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncCandidateManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCandidateManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCandidateManualEntityMutation, { data, loading, error }] = useSyncCandidateManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncCandidateManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncCandidateManualEntityMutation, SyncCandidateManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncCandidateManualEntityMutation, SyncCandidateManualEntityMutationVariables>(SyncCandidateManualEntityDocument, options);
      }
export type SyncCandidateManualEntityMutationHookResult = ReturnType<typeof useSyncCandidateManualEntityMutation>;
export type SyncCandidateManualEntityMutationResult = Apollo.MutationResult<SyncCandidateManualEntityMutation>;
export type SyncCandidateManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncCandidateManualEntityMutation, SyncCandidateManualEntityMutationVariables>;
export const SyncApplicationManualEntityDocument = gql`
    mutation SyncApplicationManualEntity($input: SyncApplicationInput!) {
  syncApplication(input: $input) {
    __typename
    ... on SyncApplicationSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncApplicationManualEntityMutationFn = Apollo.MutationFunction<SyncApplicationManualEntityMutation, SyncApplicationManualEntityMutationVariables>;

/**
 * __useSyncApplicationManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncApplicationManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncApplicationManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncApplicationManualEntityMutation, { data, loading, error }] = useSyncApplicationManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncApplicationManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncApplicationManualEntityMutation, SyncApplicationManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncApplicationManualEntityMutation, SyncApplicationManualEntityMutationVariables>(SyncApplicationManualEntityDocument, options);
      }
export type SyncApplicationManualEntityMutationHookResult = ReturnType<typeof useSyncApplicationManualEntityMutation>;
export type SyncApplicationManualEntityMutationResult = Apollo.MutationResult<SyncApplicationManualEntityMutation>;
export type SyncApplicationManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncApplicationManualEntityMutation, SyncApplicationManualEntityMutationVariables>;
export const SyncJobManualEntityDocument = gql`
    mutation SyncJobManualEntity($input: SyncJobInput!) {
  syncJob(input: $input) {
    __typename
    ... on SyncJobSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncJobManualEntityMutationFn = Apollo.MutationFunction<SyncJobManualEntityMutation, SyncJobManualEntityMutationVariables>;

/**
 * __useSyncJobManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncJobManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncJobManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncJobManualEntityMutation, { data, loading, error }] = useSyncJobManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncJobManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncJobManualEntityMutation, SyncJobManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncJobManualEntityMutation, SyncJobManualEntityMutationVariables>(SyncJobManualEntityDocument, options);
      }
export type SyncJobManualEntityMutationHookResult = ReturnType<typeof useSyncJobManualEntityMutation>;
export type SyncJobManualEntityMutationResult = Apollo.MutationResult<SyncJobManualEntityMutation>;
export type SyncJobManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncJobManualEntityMutation, SyncJobManualEntityMutationVariables>;
export const SyncUserJobPermissionsForJobManualEntityDocument = gql`
    mutation SyncUserJobPermissionsForJobManualEntity($input: SyncUserJobPermissionsForJobInput!) {
  syncUserJobPermissionsForJob(input: $input) {
    __typename
    ... on SyncUserJobPermissionsForJobSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncUserJobPermissionsForJobManualEntityMutationFn = Apollo.MutationFunction<SyncUserJobPermissionsForJobManualEntityMutation, SyncUserJobPermissionsForJobManualEntityMutationVariables>;

/**
 * __useSyncUserJobPermissionsForJobManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncUserJobPermissionsForJobManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserJobPermissionsForJobManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserJobPermissionsForJobManualEntityMutation, { data, loading, error }] = useSyncUserJobPermissionsForJobManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncUserJobPermissionsForJobManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncUserJobPermissionsForJobManualEntityMutation, SyncUserJobPermissionsForJobManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUserJobPermissionsForJobManualEntityMutation, SyncUserJobPermissionsForJobManualEntityMutationVariables>(SyncUserJobPermissionsForJobManualEntityDocument, options);
      }
export type SyncUserJobPermissionsForJobManualEntityMutationHookResult = ReturnType<typeof useSyncUserJobPermissionsForJobManualEntityMutation>;
export type SyncUserJobPermissionsForJobManualEntityMutationResult = Apollo.MutationResult<SyncUserJobPermissionsForJobManualEntityMutation>;
export type SyncUserJobPermissionsForJobManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncUserJobPermissionsForJobManualEntityMutation, SyncUserJobPermissionsForJobManualEntityMutationVariables>;
export const SyncUserJobPermissionsForEmployeeManualEntityDocument = gql`
    mutation SyncUserJobPermissionsForEmployeeManualEntity($input: SyncUserJobPermissionsForEmployeeInput!) {
  syncUserJobPermissionsForEmployee(input: $input) {
    __typename
    ... on SyncUserJobPermissionsForEmployeeSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncUserJobPermissionsForEmployeeManualEntityMutationFn = Apollo.MutationFunction<SyncUserJobPermissionsForEmployeeManualEntityMutation, SyncUserJobPermissionsForEmployeeManualEntityMutationVariables>;

/**
 * __useSyncUserJobPermissionsForEmployeeManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncUserJobPermissionsForEmployeeManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserJobPermissionsForEmployeeManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserJobPermissionsForEmployeeManualEntityMutation, { data, loading, error }] = useSyncUserJobPermissionsForEmployeeManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncUserJobPermissionsForEmployeeManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncUserJobPermissionsForEmployeeManualEntityMutation, SyncUserJobPermissionsForEmployeeManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUserJobPermissionsForEmployeeManualEntityMutation, SyncUserJobPermissionsForEmployeeManualEntityMutationVariables>(SyncUserJobPermissionsForEmployeeManualEntityDocument, options);
      }
export type SyncUserJobPermissionsForEmployeeManualEntityMutationHookResult = ReturnType<typeof useSyncUserJobPermissionsForEmployeeManualEntityMutation>;
export type SyncUserJobPermissionsForEmployeeManualEntityMutationResult = Apollo.MutationResult<SyncUserJobPermissionsForEmployeeManualEntityMutation>;
export type SyncUserJobPermissionsForEmployeeManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncUserJobPermissionsForEmployeeManualEntityMutation, SyncUserJobPermissionsForEmployeeManualEntityMutationVariables>;
export const SyncJobStageManualEntityDocument = gql`
    mutation SyncJobStageManualEntity($input: SyncJobStageInput!) {
  syncJobStage(input: $input) {
    __typename
    ... on SyncJobStageSuccess {
      enqueued
    }
    ... on Error {
      errorCode
      errorMessage
    }
    ... on SyncRateLimitedError {
      retryAfterSeconds
    }
  }
}
    `;
export type SyncJobStageManualEntityMutationFn = Apollo.MutationFunction<SyncJobStageManualEntityMutation, SyncJobStageManualEntityMutationVariables>;

/**
 * __useSyncJobStageManualEntityMutation__
 *
 * To run a mutation, you first call `useSyncJobStageManualEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncJobStageManualEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncJobStageManualEntityMutation, { data, loading, error }] = useSyncJobStageManualEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncJobStageManualEntityMutation(baseOptions?: Apollo.MutationHookOptions<SyncJobStageManualEntityMutation, SyncJobStageManualEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncJobStageManualEntityMutation, SyncJobStageManualEntityMutationVariables>(SyncJobStageManualEntityDocument, options);
      }
export type SyncJobStageManualEntityMutationHookResult = ReturnType<typeof useSyncJobStageManualEntityMutation>;
export type SyncJobStageManualEntityMutationResult = Apollo.MutationResult<SyncJobStageManualEntityMutation>;
export type SyncJobStageManualEntityMutationOptions = Apollo.BaseMutationOptions<SyncJobStageManualEntityMutation, SyncJobStageManualEntityMutationVariables>;
export const OrgNameDocument = gql`
    query OrgName {
  thisOrg {
    id
    name
  }
}
    `;

/**
 * __useOrgNameQuery__
 *
 * To run a query within a React component, call `useOrgNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgNameQuery(baseOptions?: Apollo.QueryHookOptions<OrgNameQuery, OrgNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgNameQuery, OrgNameQueryVariables>(OrgNameDocument, options);
      }
export function useOrgNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgNameQuery, OrgNameQueryVariables>(OrgNameDocument, options);
        }
// @ts-ignore
export function useOrgNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>): Apollo.UseSuspenseQueryResult<OrgNameQuery, OrgNameQueryVariables>;
export function useOrgNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>): Apollo.UseSuspenseQueryResult<OrgNameQuery | undefined, OrgNameQueryVariables>;
export function useOrgNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgNameQuery, OrgNameQueryVariables>(OrgNameDocument, options);
        }
export type OrgNameQueryHookResult = ReturnType<typeof useOrgNameQuery>;
export type OrgNameLazyQueryHookResult = ReturnType<typeof useOrgNameLazyQuery>;
export type OrgNameSuspenseQueryHookResult = ReturnType<typeof useOrgNameSuspenseQuery>;
export type OrgNameQueryResult = Apollo.QueryResult<OrgNameQuery, OrgNameQueryVariables>;
export const GetOrgRequiredSetupStatusDocument = gql`
    query GetOrgRequiredSetupStatus {
  thisOrg {
    id
    atsStatus
    directoryStatus
  }
}
    `;

/**
 * __useGetOrgRequiredSetupStatusQuery__
 *
 * To run a query within a React component, call `useGetOrgRequiredSetupStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgRequiredSetupStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgRequiredSetupStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgRequiredSetupStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>(GetOrgRequiredSetupStatusDocument, options);
      }
export function useGetOrgRequiredSetupStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>(GetOrgRequiredSetupStatusDocument, options);
        }
// @ts-ignore
export function useGetOrgRequiredSetupStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>;
export function useGetOrgRequiredSetupStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgRequiredSetupStatusQuery | undefined, GetOrgRequiredSetupStatusQueryVariables>;
export function useGetOrgRequiredSetupStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>(GetOrgRequiredSetupStatusDocument, options);
        }
export type GetOrgRequiredSetupStatusQueryHookResult = ReturnType<typeof useGetOrgRequiredSetupStatusQuery>;
export type GetOrgRequiredSetupStatusLazyQueryHookResult = ReturnType<typeof useGetOrgRequiredSetupStatusLazyQuery>;
export type GetOrgRequiredSetupStatusSuspenseQueryHookResult = ReturnType<typeof useGetOrgRequiredSetupStatusSuspenseQuery>;
export type GetOrgRequiredSetupStatusQueryResult = Apollo.QueryResult<GetOrgRequiredSetupStatusQuery, GetOrgRequiredSetupStatusQueryVariables>;
export const OrgSlugDocument = gql`
    query OrgSlug {
  thisOrg {
    id
    slugs {
      id: orgId
      slug
    }
  }
}
    `;

/**
 * __useOrgSlugQuery__
 *
 * To run a query within a React component, call `useOrgSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgSlugQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgSlugQuery(baseOptions?: Apollo.QueryHookOptions<OrgSlugQuery, OrgSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgSlugQuery, OrgSlugQueryVariables>(OrgSlugDocument, options);
      }
export function useOrgSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgSlugQuery, OrgSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgSlugQuery, OrgSlugQueryVariables>(OrgSlugDocument, options);
        }
// @ts-ignore
export function useOrgSlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgSlugQuery, OrgSlugQueryVariables>): Apollo.UseSuspenseQueryResult<OrgSlugQuery, OrgSlugQueryVariables>;
export function useOrgSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgSlugQuery, OrgSlugQueryVariables>): Apollo.UseSuspenseQueryResult<OrgSlugQuery | undefined, OrgSlugQueryVariables>;
export function useOrgSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgSlugQuery, OrgSlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgSlugQuery, OrgSlugQueryVariables>(OrgSlugDocument, options);
        }
export type OrgSlugQueryHookResult = ReturnType<typeof useOrgSlugQuery>;
export type OrgSlugLazyQueryHookResult = ReturnType<typeof useOrgSlugLazyQuery>;
export type OrgSlugSuspenseQueryHookResult = ReturnType<typeof useOrgSlugSuspenseQuery>;
export type OrgSlugQueryResult = Apollo.QueryResult<OrgSlugQuery, OrgSlugQueryVariables>;
export const MyPrimaryCalendarDocument = gql`
    query MyPrimaryCalendar {
  myPrimaryCalendar {
    id
    remoteId
  }
}
    `;

/**
 * __useMyPrimaryCalendarQuery__
 *
 * To run a query within a React component, call `useMyPrimaryCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPrimaryCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPrimaryCalendarQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPrimaryCalendarQuery(baseOptions?: Apollo.QueryHookOptions<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>(MyPrimaryCalendarDocument, options);
      }
export function useMyPrimaryCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>(MyPrimaryCalendarDocument, options);
        }
// @ts-ignore
export function useMyPrimaryCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>;
export function useMyPrimaryCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<MyPrimaryCalendarQuery | undefined, MyPrimaryCalendarQueryVariables>;
export function useMyPrimaryCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>(MyPrimaryCalendarDocument, options);
        }
export type MyPrimaryCalendarQueryHookResult = ReturnType<typeof useMyPrimaryCalendarQuery>;
export type MyPrimaryCalendarLazyQueryHookResult = ReturnType<typeof useMyPrimaryCalendarLazyQuery>;
export type MyPrimaryCalendarSuspenseQueryHookResult = ReturnType<typeof useMyPrimaryCalendarSuspenseQuery>;
export type MyPrimaryCalendarQueryResult = Apollo.QueryResult<MyPrimaryCalendarQuery, MyPrimaryCalendarQueryVariables>;
export const OrgHasSamlSsoDocument = gql`
    query OrgHasSamlSso {
  thisOrg {
    id
    hasSamlSso
  }
}
    `;

/**
 * __useOrgHasSamlSsoQuery__
 *
 * To run a query within a React component, call `useOrgHasSamlSsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgHasSamlSsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgHasSamlSsoQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgHasSamlSsoQuery(baseOptions?: Apollo.QueryHookOptions<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>(OrgHasSamlSsoDocument, options);
      }
export function useOrgHasSamlSsoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>(OrgHasSamlSsoDocument, options);
        }
// @ts-ignore
export function useOrgHasSamlSsoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>): Apollo.UseSuspenseQueryResult<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>;
export function useOrgHasSamlSsoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>): Apollo.UseSuspenseQueryResult<OrgHasSamlSsoQuery | undefined, OrgHasSamlSsoQueryVariables>;
export function useOrgHasSamlSsoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>(OrgHasSamlSsoDocument, options);
        }
export type OrgHasSamlSsoQueryHookResult = ReturnType<typeof useOrgHasSamlSsoQuery>;
export type OrgHasSamlSsoLazyQueryHookResult = ReturnType<typeof useOrgHasSamlSsoLazyQuery>;
export type OrgHasSamlSsoSuspenseQueryHookResult = ReturnType<typeof useOrgHasSamlSsoSuspenseQuery>;
export type OrgHasSamlSsoQueryResult = Apollo.QueryResult<OrgHasSamlSsoQuery, OrgHasSamlSsoQueryVariables>;
export const OrgHasScimDocument = gql`
    query OrgHasScim {
  thisOrg {
    id
    hasScim
  }
}
    `;

/**
 * __useOrgHasScimQuery__
 *
 * To run a query within a React component, call `useOrgHasScimQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgHasScimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgHasScimQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgHasScimQuery(baseOptions?: Apollo.QueryHookOptions<OrgHasScimQuery, OrgHasScimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgHasScimQuery, OrgHasScimQueryVariables>(OrgHasScimDocument, options);
      }
export function useOrgHasScimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgHasScimQuery, OrgHasScimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgHasScimQuery, OrgHasScimQueryVariables>(OrgHasScimDocument, options);
        }
// @ts-ignore
export function useOrgHasScimSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgHasScimQuery, OrgHasScimQueryVariables>): Apollo.UseSuspenseQueryResult<OrgHasScimQuery, OrgHasScimQueryVariables>;
export function useOrgHasScimSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgHasScimQuery, OrgHasScimQueryVariables>): Apollo.UseSuspenseQueryResult<OrgHasScimQuery | undefined, OrgHasScimQueryVariables>;
export function useOrgHasScimSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgHasScimQuery, OrgHasScimQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgHasScimQuery, OrgHasScimQueryVariables>(OrgHasScimDocument, options);
        }
export type OrgHasScimQueryHookResult = ReturnType<typeof useOrgHasScimQuery>;
export type OrgHasScimLazyQueryHookResult = ReturnType<typeof useOrgHasScimLazyQuery>;
export type OrgHasScimSuspenseQueryHookResult = ReturnType<typeof useOrgHasScimSuspenseQuery>;
export type OrgHasScimQueryResult = Apollo.QueryResult<OrgHasScimQuery, OrgHasScimQueryVariables>;
export const SchedulerCalendarTokenAvailabilityDocument = gql`
    query SchedulerCalendarTokenAvailability {
  thisOrg {
    id
    schedulerCalendarTokenAvailable
  }
}
    `;

/**
 * __useSchedulerCalendarTokenAvailabilityQuery__
 *
 * To run a query within a React component, call `useSchedulerCalendarTokenAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerCalendarTokenAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerCalendarTokenAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useSchedulerCalendarTokenAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>(SchedulerCalendarTokenAvailabilityDocument, options);
      }
export function useSchedulerCalendarTokenAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>(SchedulerCalendarTokenAvailabilityDocument, options);
        }
// @ts-ignore
export function useSchedulerCalendarTokenAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>;
export function useSchedulerCalendarTokenAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerCalendarTokenAvailabilityQuery | undefined, SchedulerCalendarTokenAvailabilityQueryVariables>;
export function useSchedulerCalendarTokenAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>(SchedulerCalendarTokenAvailabilityDocument, options);
        }
export type SchedulerCalendarTokenAvailabilityQueryHookResult = ReturnType<typeof useSchedulerCalendarTokenAvailabilityQuery>;
export type SchedulerCalendarTokenAvailabilityLazyQueryHookResult = ReturnType<typeof useSchedulerCalendarTokenAvailabilityLazyQuery>;
export type SchedulerCalendarTokenAvailabilitySuspenseQueryHookResult = ReturnType<typeof useSchedulerCalendarTokenAvailabilitySuspenseQuery>;
export type SchedulerCalendarTokenAvailabilityQueryResult = Apollo.QueryResult<SchedulerCalendarTokenAvailabilityQuery, SchedulerCalendarTokenAvailabilityQueryVariables>;
export const ShortUrlCreateDocument = gql`
    mutation ShortUrlCreate($input: ShortUrlCreateInput!) {
  shortUrlCreate(input: $input) {
    shortUrl
  }
}
    `;
export type ShortUrlCreateMutationFn = Apollo.MutationFunction<ShortUrlCreateMutation, ShortUrlCreateMutationVariables>;

/**
 * __useShortUrlCreateMutation__
 *
 * To run a mutation, you first call `useShortUrlCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortUrlCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortUrlCreateMutation, { data, loading, error }] = useShortUrlCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShortUrlCreateMutation(baseOptions?: Apollo.MutationHookOptions<ShortUrlCreateMutation, ShortUrlCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShortUrlCreateMutation, ShortUrlCreateMutationVariables>(ShortUrlCreateDocument, options);
      }
export type ShortUrlCreateMutationHookResult = ReturnType<typeof useShortUrlCreateMutation>;
export type ShortUrlCreateMutationResult = Apollo.MutationResult<ShortUrlCreateMutation>;
export type ShortUrlCreateMutationOptions = Apollo.BaseMutationOptions<ShortUrlCreateMutation, ShortUrlCreateMutationVariables>;
export const GreenhouseHarvestV3DialogOAuthStatusDocument = gql`
    query GreenhouseHarvestV3DialogOAuthStatus {
  thisOrg {
    id
    integrations {
      id
      greenhouseOauth {
        subdomain
      }
    }
  }
}
    `;

/**
 * __useGreenhouseHarvestV3DialogOAuthStatusQuery__
 *
 * To run a query within a React component, call `useGreenhouseHarvestV3DialogOAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGreenhouseHarvestV3DialogOAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGreenhouseHarvestV3DialogOAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGreenhouseHarvestV3DialogOAuthStatusQuery(baseOptions?: Apollo.QueryHookOptions<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>(GreenhouseHarvestV3DialogOAuthStatusDocument, options);
      }
export function useGreenhouseHarvestV3DialogOAuthStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>(GreenhouseHarvestV3DialogOAuthStatusDocument, options);
        }
// @ts-ignore
export function useGreenhouseHarvestV3DialogOAuthStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>;
export function useGreenhouseHarvestV3DialogOAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseHarvestV3DialogOAuthStatusQuery | undefined, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>;
export function useGreenhouseHarvestV3DialogOAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>(GreenhouseHarvestV3DialogOAuthStatusDocument, options);
        }
export type GreenhouseHarvestV3DialogOAuthStatusQueryHookResult = ReturnType<typeof useGreenhouseHarvestV3DialogOAuthStatusQuery>;
export type GreenhouseHarvestV3DialogOAuthStatusLazyQueryHookResult = ReturnType<typeof useGreenhouseHarvestV3DialogOAuthStatusLazyQuery>;
export type GreenhouseHarvestV3DialogOAuthStatusSuspenseQueryHookResult = ReturnType<typeof useGreenhouseHarvestV3DialogOAuthStatusSuspenseQuery>;
export type GreenhouseHarvestV3DialogOAuthStatusQueryResult = Apollo.QueryResult<GreenhouseHarvestV3DialogOAuthStatusQuery, GreenhouseHarvestV3DialogOAuthStatusQueryVariables>;
export const GreenhouseHarvestV3BannerOAuthStatusDocument = gql`
    query GreenhouseHarvestV3BannerOAuthStatus {
  thisOrg {
    id
    integrations {
      id
      greenhouseOauth {
        subdomain
      }
    }
  }
}
    `;

/**
 * __useGreenhouseHarvestV3BannerOAuthStatusQuery__
 *
 * To run a query within a React component, call `useGreenhouseHarvestV3BannerOAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGreenhouseHarvestV3BannerOAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGreenhouseHarvestV3BannerOAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGreenhouseHarvestV3BannerOAuthStatusQuery(baseOptions?: Apollo.QueryHookOptions<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>(GreenhouseHarvestV3BannerOAuthStatusDocument, options);
      }
export function useGreenhouseHarvestV3BannerOAuthStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>(GreenhouseHarvestV3BannerOAuthStatusDocument, options);
        }
// @ts-ignore
export function useGreenhouseHarvestV3BannerOAuthStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>;
export function useGreenhouseHarvestV3BannerOAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseHarvestV3BannerOAuthStatusQuery | undefined, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>;
export function useGreenhouseHarvestV3BannerOAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>(GreenhouseHarvestV3BannerOAuthStatusDocument, options);
        }
export type GreenhouseHarvestV3BannerOAuthStatusQueryHookResult = ReturnType<typeof useGreenhouseHarvestV3BannerOAuthStatusQuery>;
export type GreenhouseHarvestV3BannerOAuthStatusLazyQueryHookResult = ReturnType<typeof useGreenhouseHarvestV3BannerOAuthStatusLazyQuery>;
export type GreenhouseHarvestV3BannerOAuthStatusSuspenseQueryHookResult = ReturnType<typeof useGreenhouseHarvestV3BannerOAuthStatusSuspenseQuery>;
export type GreenhouseHarvestV3BannerOAuthStatusQueryResult = Apollo.QueryResult<GreenhouseHarvestV3BannerOAuthStatusQuery, GreenhouseHarvestV3BannerOAuthStatusQueryVariables>;
export const IntegrationHealthCheckBannersDocument = gql`
    query IntegrationHealthCheckBanners($force: Boolean!) {
  integrationCheckHealth(input: {force: $force}) {
    id
    google {
      ...GoogleHealthCheckBanner_google
    }
    microsoft {
      ...MicrosoftHealthCheckBanner_microsoft
    }
    microsoftGccHigh {
      ...MicrosoftHealthCheckBanner_microsoftGccHigh
    }
    zoom {
      ...ZoomHealthCheckBanner_zoom
    }
    greenhouseV3 {
      ...GreenhouseHealthCheckBanner_greenhouse
    }
    ashby {
      ...AshbyHealthCheckBanner_ashby
    }
    lever {
      ...LeverHealthCheckBanner_lever
    }
    gem {
      ...GemHealthCheckBanner_gem
    }
    smartRecruiters {
      ...SmartRecruitersHealthCheckBanner_smartRecruiters
    }
  }
}
    ${GoogleHealthCheckBanner_GoogleFragmentDoc}
${MicrosoftHealthCheckBanner_MicrosoftFragmentDoc}
${MicrosoftHealthCheckBanner_MicrosoftGccHighFragmentDoc}
${ZoomHealthCheckBanner_ZoomFragmentDoc}
${GreenhouseHealthCheckBanner_GreenhouseFragmentDoc}
${AshbyHealthCheckBanner_AshbyFragmentDoc}
${LeverHealthCheckBanner_LeverFragmentDoc}
${GemHealthCheckBanner_GemFragmentDoc}
${SmartRecruitersHealthCheckBanner_SmartRecruitersFragmentDoc}`;

/**
 * __useIntegrationHealthCheckBannersQuery__
 *
 * To run a query within a React component, call `useIntegrationHealthCheckBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationHealthCheckBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationHealthCheckBannersQuery({
 *   variables: {
 *      force: // value for 'force'
 *   },
 * });
 */
export function useIntegrationHealthCheckBannersQuery(baseOptions: Apollo.QueryHookOptions<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables> & ({ variables: IntegrationHealthCheckBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>(IntegrationHealthCheckBannersDocument, options);
      }
export function useIntegrationHealthCheckBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>(IntegrationHealthCheckBannersDocument, options);
        }
// @ts-ignore
export function useIntegrationHealthCheckBannersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>;
export function useIntegrationHealthCheckBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationHealthCheckBannersQuery | undefined, IntegrationHealthCheckBannersQueryVariables>;
export function useIntegrationHealthCheckBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>(IntegrationHealthCheckBannersDocument, options);
        }
export type IntegrationHealthCheckBannersQueryHookResult = ReturnType<typeof useIntegrationHealthCheckBannersQuery>;
export type IntegrationHealthCheckBannersLazyQueryHookResult = ReturnType<typeof useIntegrationHealthCheckBannersLazyQuery>;
export type IntegrationHealthCheckBannersSuspenseQueryHookResult = ReturnType<typeof useIntegrationHealthCheckBannersSuspenseQuery>;
export type IntegrationHealthCheckBannersQueryResult = Apollo.QueryResult<IntegrationHealthCheckBannersQuery, IntegrationHealthCheckBannersQueryVariables>;
export const MicrosoftServiceUserIntegrationExpirationDocument = gql`
    query MicrosoftServiceUserIntegrationExpiration {
  thisOrg {
    id
    integrations {
      id
      microsoftServiceUser {
        ...MicrosoftServiceUserExpirationBanner_microsoftServiceUser
      }
    }
  }
}
    ${MicrosoftServiceUserExpirationBanner_MicrosoftServiceUserFragmentDoc}`;

/**
 * __useMicrosoftServiceUserIntegrationExpirationQuery__
 *
 * To run a query within a React component, call `useMicrosoftServiceUserIntegrationExpirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftServiceUserIntegrationExpirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftServiceUserIntegrationExpirationQuery({
 *   variables: {
 *   },
 * });
 */
export function useMicrosoftServiceUserIntegrationExpirationQuery(baseOptions?: Apollo.QueryHookOptions<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>(MicrosoftServiceUserIntegrationExpirationDocument, options);
      }
export function useMicrosoftServiceUserIntegrationExpirationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>(MicrosoftServiceUserIntegrationExpirationDocument, options);
        }
// @ts-ignore
export function useMicrosoftServiceUserIntegrationExpirationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>;
export function useMicrosoftServiceUserIntegrationExpirationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftServiceUserIntegrationExpirationQuery | undefined, MicrosoftServiceUserIntegrationExpirationQueryVariables>;
export function useMicrosoftServiceUserIntegrationExpirationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>(MicrosoftServiceUserIntegrationExpirationDocument, options);
        }
export type MicrosoftServiceUserIntegrationExpirationQueryHookResult = ReturnType<typeof useMicrosoftServiceUserIntegrationExpirationQuery>;
export type MicrosoftServiceUserIntegrationExpirationLazyQueryHookResult = ReturnType<typeof useMicrosoftServiceUserIntegrationExpirationLazyQuery>;
export type MicrosoftServiceUserIntegrationExpirationSuspenseQueryHookResult = ReturnType<typeof useMicrosoftServiceUserIntegrationExpirationSuspenseQuery>;
export type MicrosoftServiceUserIntegrationExpirationQueryResult = Apollo.QueryResult<MicrosoftServiceUserIntegrationExpirationQuery, MicrosoftServiceUserIntegrationExpirationQueryVariables>;
export const MicrosoftCustomEmployeeIntegrationExpirationDocument = gql`
    query MicrosoftCustomEmployeeIntegrationExpiration($employeeIds: [uuid!]!) {
  employeeByIds(ids: $employeeIds) {
    ...MicrosoftCustomExpirationBanner_employee
  }
}
    ${MicrosoftCustomExpirationBanner_EmployeeFragmentDoc}`;

/**
 * __useMicrosoftCustomEmployeeIntegrationExpirationQuery__
 *
 * To run a query within a React component, call `useMicrosoftCustomEmployeeIntegrationExpirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftCustomEmployeeIntegrationExpirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftCustomEmployeeIntegrationExpirationQuery({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useMicrosoftCustomEmployeeIntegrationExpirationQuery(baseOptions: Apollo.QueryHookOptions<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables> & ({ variables: MicrosoftCustomEmployeeIntegrationExpirationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>(MicrosoftCustomEmployeeIntegrationExpirationDocument, options);
      }
export function useMicrosoftCustomEmployeeIntegrationExpirationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>(MicrosoftCustomEmployeeIntegrationExpirationDocument, options);
        }
// @ts-ignore
export function useMicrosoftCustomEmployeeIntegrationExpirationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>;
export function useMicrosoftCustomEmployeeIntegrationExpirationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftCustomEmployeeIntegrationExpirationQuery | undefined, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>;
export function useMicrosoftCustomEmployeeIntegrationExpirationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>(MicrosoftCustomEmployeeIntegrationExpirationDocument, options);
        }
export type MicrosoftCustomEmployeeIntegrationExpirationQueryHookResult = ReturnType<typeof useMicrosoftCustomEmployeeIntegrationExpirationQuery>;
export type MicrosoftCustomEmployeeIntegrationExpirationLazyQueryHookResult = ReturnType<typeof useMicrosoftCustomEmployeeIntegrationExpirationLazyQuery>;
export type MicrosoftCustomEmployeeIntegrationExpirationSuspenseQueryHookResult = ReturnType<typeof useMicrosoftCustomEmployeeIntegrationExpirationSuspenseQuery>;
export type MicrosoftCustomEmployeeIntegrationExpirationQueryResult = Apollo.QueryResult<MicrosoftCustomEmployeeIntegrationExpirationQuery, MicrosoftCustomEmployeeIntegrationExpirationQueryVariables>;
export const RecruitingSessionActivityTimeoutDocument = gql`
    query RecruitingSessionActivityTimeout {
  thisOrg {
    id
    sessionInactivityTimeout {
      seconds
      nanos
    }
  }
}
    `;

/**
 * __useRecruitingSessionActivityTimeoutQuery__
 *
 * To run a query within a React component, call `useRecruitingSessionActivityTimeoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruitingSessionActivityTimeoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruitingSessionActivityTimeoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecruitingSessionActivityTimeoutQuery(baseOptions?: Apollo.QueryHookOptions<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>(RecruitingSessionActivityTimeoutDocument, options);
      }
export function useRecruitingSessionActivityTimeoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>(RecruitingSessionActivityTimeoutDocument, options);
        }
// @ts-ignore
export function useRecruitingSessionActivityTimeoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>): Apollo.UseSuspenseQueryResult<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>;
export function useRecruitingSessionActivityTimeoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>): Apollo.UseSuspenseQueryResult<RecruitingSessionActivityTimeoutQuery | undefined, RecruitingSessionActivityTimeoutQueryVariables>;
export function useRecruitingSessionActivityTimeoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>(RecruitingSessionActivityTimeoutDocument, options);
        }
export type RecruitingSessionActivityTimeoutQueryHookResult = ReturnType<typeof useRecruitingSessionActivityTimeoutQuery>;
export type RecruitingSessionActivityTimeoutLazyQueryHookResult = ReturnType<typeof useRecruitingSessionActivityTimeoutLazyQuery>;
export type RecruitingSessionActivityTimeoutSuspenseQueryHookResult = ReturnType<typeof useRecruitingSessionActivityTimeoutSuspenseQuery>;
export type RecruitingSessionActivityTimeoutQueryResult = Apollo.QueryResult<RecruitingSessionActivityTimeoutQuery, RecruitingSessionActivityTimeoutQueryVariables>;
export const InterviewTranscriptDocument = gql`
    query InterviewTranscript($applicationStageId: uuid!) {
  applicationStage(id: $applicationStageId) {
    id
    jobStage {
      id
      name
      job {
        id
        name
      }
    }
    application {
      status
      candidate {
        id
        fullName
      }
    }
    interviews: applicationStageInterviews {
      id
      ...InterviewItem
      meetingLocation {
        ...InterviewTranscript_transcript
      }
    }
  }
}
    ${InterviewItemFragmentDoc}
${InterviewTranscript_TranscriptFragmentDoc}`;

/**
 * __useInterviewTranscriptQuery__
 *
 * To run a query within a React component, call `useInterviewTranscriptQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewTranscriptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewTranscriptQuery({
 *   variables: {
 *      applicationStageId: // value for 'applicationStageId'
 *   },
 * });
 */
export function useInterviewTranscriptQuery(baseOptions: Apollo.QueryHookOptions<InterviewTranscriptQuery, InterviewTranscriptQueryVariables> & ({ variables: InterviewTranscriptQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>(InterviewTranscriptDocument, options);
      }
export function useInterviewTranscriptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>(InterviewTranscriptDocument, options);
        }
// @ts-ignore
export function useInterviewTranscriptSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>;
export function useInterviewTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewTranscriptQuery | undefined, InterviewTranscriptQueryVariables>;
export function useInterviewTranscriptSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>(InterviewTranscriptDocument, options);
        }
export type InterviewTranscriptQueryHookResult = ReturnType<typeof useInterviewTranscriptQuery>;
export type InterviewTranscriptLazyQueryHookResult = ReturnType<typeof useInterviewTranscriptLazyQuery>;
export type InterviewTranscriptSuspenseQueryHookResult = ReturnType<typeof useInterviewTranscriptSuspenseQuery>;
export type InterviewTranscriptQueryResult = Apollo.QueryResult<InterviewTranscriptQuery, InterviewTranscriptQueryVariables>;
export const TaskSuggestedScheduleOptionsDocument = gql`
    query TaskSuggestedScheduleOptions($taskId: uuid!, $input: TaskSuggestedSchedulesInput!) {
  task(id: $taskId) {
    suggestedSchedules(input: $input) {
      id
      ...SuggestedSchedule_suggestedSchedule
    }
  }
}
    ${SuggestedSchedule_SuggestedScheduleFragmentDoc}`;

/**
 * __useTaskSuggestedScheduleOptionsQuery__
 *
 * To run a query within a React component, call `useTaskSuggestedScheduleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskSuggestedScheduleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskSuggestedScheduleOptionsQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskSuggestedScheduleOptionsQuery(baseOptions: Apollo.QueryHookOptions<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables> & ({ variables: TaskSuggestedScheduleOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>(TaskSuggestedScheduleOptionsDocument, options);
      }
export function useTaskSuggestedScheduleOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>(TaskSuggestedScheduleOptionsDocument, options);
        }
// @ts-ignore
export function useTaskSuggestedScheduleOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>;
export function useTaskSuggestedScheduleOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<TaskSuggestedScheduleOptionsQuery | undefined, TaskSuggestedScheduleOptionsQueryVariables>;
export function useTaskSuggestedScheduleOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>(TaskSuggestedScheduleOptionsDocument, options);
        }
export type TaskSuggestedScheduleOptionsQueryHookResult = ReturnType<typeof useTaskSuggestedScheduleOptionsQuery>;
export type TaskSuggestedScheduleOptionsLazyQueryHookResult = ReturnType<typeof useTaskSuggestedScheduleOptionsLazyQuery>;
export type TaskSuggestedScheduleOptionsSuspenseQueryHookResult = ReturnType<typeof useTaskSuggestedScheduleOptionsSuspenseQuery>;
export type TaskSuggestedScheduleOptionsQueryResult = Apollo.QueryResult<TaskSuggestedScheduleOptionsQuery, TaskSuggestedScheduleOptionsQueryVariables>;
export const TaskSuggestedSchedulesDocument = gql`
    query TaskSuggestedSchedules($taskId: uuid!) {
  task(id: $taskId) {
    ...ScheduleTask_task
    ...SuggestedScheduleOptions_task
  }
}
    ${ScheduleTask_TaskFragmentDoc}
${SuggestedScheduleOptions_TaskFragmentDoc}`;

/**
 * __useTaskSuggestedSchedulesQuery__
 *
 * To run a query within a React component, call `useTaskSuggestedSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskSuggestedSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskSuggestedSchedulesQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskSuggestedSchedulesQuery(baseOptions: Apollo.QueryHookOptions<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables> & ({ variables: TaskSuggestedSchedulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>(TaskSuggestedSchedulesDocument, options);
      }
export function useTaskSuggestedSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>(TaskSuggestedSchedulesDocument, options);
        }
// @ts-ignore
export function useTaskSuggestedSchedulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>): Apollo.UseSuspenseQueryResult<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>;
export function useTaskSuggestedSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>): Apollo.UseSuspenseQueryResult<TaskSuggestedSchedulesQuery | undefined, TaskSuggestedSchedulesQueryVariables>;
export function useTaskSuggestedSchedulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>(TaskSuggestedSchedulesDocument, options);
        }
export type TaskSuggestedSchedulesQueryHookResult = ReturnType<typeof useTaskSuggestedSchedulesQuery>;
export type TaskSuggestedSchedulesLazyQueryHookResult = ReturnType<typeof useTaskSuggestedSchedulesLazyQuery>;
export type TaskSuggestedSchedulesSuspenseQueryHookResult = ReturnType<typeof useTaskSuggestedSchedulesSuspenseQuery>;
export type TaskSuggestedSchedulesQueryResult = Apollo.QueryResult<TaskSuggestedSchedulesQuery, TaskSuggestedSchedulesQueryVariables>;
export const JobStageNameByIdDocument = gql`
    query JobStageNameById($id: uuid!) {
  jobStage(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useJobStageNameByIdQuery__
 *
 * To run a query within a React component, call `useJobStageNameByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageNameByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageNameByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobStageNameByIdQuery(baseOptions: Apollo.QueryHookOptions<JobStageNameByIdQuery, JobStageNameByIdQueryVariables> & ({ variables: JobStageNameByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>(JobStageNameByIdDocument, options);
      }
export function useJobStageNameByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>(JobStageNameByIdDocument, options);
        }
// @ts-ignore
export function useJobStageNameByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>;
export function useJobStageNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageNameByIdQuery | undefined, JobStageNameByIdQueryVariables>;
export function useJobStageNameByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>(JobStageNameByIdDocument, options);
        }
export type JobStageNameByIdQueryHookResult = ReturnType<typeof useJobStageNameByIdQuery>;
export type JobStageNameByIdLazyQueryHookResult = ReturnType<typeof useJobStageNameByIdLazyQuery>;
export type JobStageNameByIdSuspenseQueryHookResult = ReturnType<typeof useJobStageNameByIdSuspenseQuery>;
export type JobStageNameByIdQueryResult = Apollo.QueryResult<JobStageNameByIdQuery, JobStageNameByIdQueryVariables>;
export const QuickTaskCreateDocument = gql`
    mutation QuickTaskCreate($input: TaskQuickCreateInput!) {
  taskQuickCreate(input: $input) {
    taskId
  }
}
    `;
export type QuickTaskCreateMutationFn = Apollo.MutationFunction<QuickTaskCreateMutation, QuickTaskCreateMutationVariables>;

/**
 * __useQuickTaskCreateMutation__
 *
 * To run a mutation, you first call `useQuickTaskCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuickTaskCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quickTaskCreateMutation, { data, loading, error }] = useQuickTaskCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuickTaskCreateMutation(baseOptions?: Apollo.MutationHookOptions<QuickTaskCreateMutation, QuickTaskCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuickTaskCreateMutation, QuickTaskCreateMutationVariables>(QuickTaskCreateDocument, options);
      }
export type QuickTaskCreateMutationHookResult = ReturnType<typeof useQuickTaskCreateMutation>;
export type QuickTaskCreateMutationResult = Apollo.MutationResult<QuickTaskCreateMutation>;
export type QuickTaskCreateMutationOptions = Apollo.BaseMutationOptions<QuickTaskCreateMutation, QuickTaskCreateMutationVariables>;
export const TaskCreateWithAgentDelegateDocument = gql`
    mutation TaskCreateWithAgentDelegate($input: TaskCreateWithAgentDelegateInput!) {
  taskCreateWithAgentDelegate(input: $input) {
    taskId
  }
}
    `;
export type TaskCreateWithAgentDelegateMutationFn = Apollo.MutationFunction<TaskCreateWithAgentDelegateMutation, TaskCreateWithAgentDelegateMutationVariables>;

/**
 * __useTaskCreateWithAgentDelegateMutation__
 *
 * To run a mutation, you first call `useTaskCreateWithAgentDelegateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskCreateWithAgentDelegateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskCreateWithAgentDelegateMutation, { data, loading, error }] = useTaskCreateWithAgentDelegateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskCreateWithAgentDelegateMutation(baseOptions?: Apollo.MutationHookOptions<TaskCreateWithAgentDelegateMutation, TaskCreateWithAgentDelegateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskCreateWithAgentDelegateMutation, TaskCreateWithAgentDelegateMutationVariables>(TaskCreateWithAgentDelegateDocument, options);
      }
export type TaskCreateWithAgentDelegateMutationHookResult = ReturnType<typeof useTaskCreateWithAgentDelegateMutation>;
export type TaskCreateWithAgentDelegateMutationResult = Apollo.MutationResult<TaskCreateWithAgentDelegateMutation>;
export type TaskCreateWithAgentDelegateMutationOptions = Apollo.BaseMutationOptions<TaskCreateWithAgentDelegateMutation, TaskCreateWithAgentDelegateMutationVariables>;
export const ApplicationSidebarDocument = gql`
    query ApplicationSidebar($applicationId: uuid!) {
  applicationV2(input: {id: $applicationId}) {
    __typename
    ... on Application {
      id
      ...ApplicationSidebarHeader_application
      ...ApplicationSidebarContent_application
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    ${ApplicationSidebarHeader_ApplicationFragmentDoc}
${ApplicationSidebarContent_ApplicationFragmentDoc}`;

/**
 * __useApplicationSidebarQuery__
 *
 * To run a query within a React component, call `useApplicationSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationSidebarQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationSidebarQuery(baseOptions: Apollo.QueryHookOptions<ApplicationSidebarQuery, ApplicationSidebarQueryVariables> & ({ variables: ApplicationSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>(ApplicationSidebarDocument, options);
      }
export function useApplicationSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>(ApplicationSidebarDocument, options);
        }
// @ts-ignore
export function useApplicationSidebarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>;
export function useApplicationSidebarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationSidebarQuery | undefined, ApplicationSidebarQueryVariables>;
export function useApplicationSidebarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>(ApplicationSidebarDocument, options);
        }
export type ApplicationSidebarQueryHookResult = ReturnType<typeof useApplicationSidebarQuery>;
export type ApplicationSidebarLazyQueryHookResult = ReturnType<typeof useApplicationSidebarLazyQuery>;
export type ApplicationSidebarSuspenseQueryHookResult = ReturnType<typeof useApplicationSidebarSuspenseQuery>;
export type ApplicationSidebarQueryResult = Apollo.QueryResult<ApplicationSidebarQuery, ApplicationSidebarQueryVariables>;
export const ApplicationByAtsIdV2Document = gql`
    query applicationByAtsIdV2($input: ApplicationByAtsIdV2Input!) {
  applicationByAtsIdV2(input: $input) {
    __typename
    ... on Application {
      id
      candidateId
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    `;

/**
 * __useApplicationByAtsIdV2Query__
 *
 * To run a query within a React component, call `useApplicationByAtsIdV2Query` and pass it any options that fit your needs.
 * When your component renders, `useApplicationByAtsIdV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationByAtsIdV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationByAtsIdV2Query(baseOptions: Apollo.QueryHookOptions<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables> & ({ variables: ApplicationByAtsIdV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>(ApplicationByAtsIdV2Document, options);
      }
export function useApplicationByAtsIdV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>(ApplicationByAtsIdV2Document, options);
        }
// @ts-ignore
export function useApplicationByAtsIdV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>;
export function useApplicationByAtsIdV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationByAtsIdV2Query | undefined, ApplicationByAtsIdV2QueryVariables>;
export function useApplicationByAtsIdV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>(ApplicationByAtsIdV2Document, options);
        }
export type ApplicationByAtsIdV2QueryHookResult = ReturnType<typeof useApplicationByAtsIdV2Query>;
export type ApplicationByAtsIdV2LazyQueryHookResult = ReturnType<typeof useApplicationByAtsIdV2LazyQuery>;
export type ApplicationByAtsIdV2SuspenseQueryHookResult = ReturnType<typeof useApplicationByAtsIdV2SuspenseQuery>;
export type ApplicationByAtsIdV2QueryResult = Apollo.QueryResult<ApplicationByAtsIdV2Query, ApplicationByAtsIdV2QueryVariables>;
export const CandidateByAtsIdV2Document = gql`
    query candidateByAtsIdV2($input: CandidateByAtsIdV2Input!) {
  candidateByAtsIdV2(input: $input) {
    __typename
    ... on Candidate {
      id
      applications {
        id
        status
        job {
          id
          atsJob {
            atsId
            atsFields {
              ... on WorkdayJob {
                referenceId
              }
            }
          }
        }
      }
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    `;

/**
 * __useCandidateByAtsIdV2Query__
 *
 * To run a query within a React component, call `useCandidateByAtsIdV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCandidateByAtsIdV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateByAtsIdV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateByAtsIdV2Query(baseOptions: Apollo.QueryHookOptions<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables> & ({ variables: CandidateByAtsIdV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>(CandidateByAtsIdV2Document, options);
      }
export function useCandidateByAtsIdV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>(CandidateByAtsIdV2Document, options);
        }
// @ts-ignore
export function useCandidateByAtsIdV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>): Apollo.UseSuspenseQueryResult<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>;
export function useCandidateByAtsIdV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>): Apollo.UseSuspenseQueryResult<CandidateByAtsIdV2Query | undefined, CandidateByAtsIdV2QueryVariables>;
export function useCandidateByAtsIdV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>(CandidateByAtsIdV2Document, options);
        }
export type CandidateByAtsIdV2QueryHookResult = ReturnType<typeof useCandidateByAtsIdV2Query>;
export type CandidateByAtsIdV2LazyQueryHookResult = ReturnType<typeof useCandidateByAtsIdV2LazyQuery>;
export type CandidateByAtsIdV2SuspenseQueryHookResult = ReturnType<typeof useCandidateByAtsIdV2SuspenseQuery>;
export type CandidateByAtsIdV2QueryResult = Apollo.QueryResult<CandidateByAtsIdV2Query, CandidateByAtsIdV2QueryVariables>;
export const ApplicationTokensDocument = gql`
    query ApplicationTokens($id: String, $renderType: RenderType!, $input: TokenApplicationInput!) {
  templateToken(input: {id: $id, renderType: $renderType}) {
    id
    INTERNAL_APPLICATION_NOTE(input: $input)
    APPLICATION_CANDIDATE_PORTAL_URL(input: $input)
  }
}
    `;

/**
 * __useApplicationTokensQuery__
 *
 * To run a query within a React component, call `useApplicationTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationTokensQuery(baseOptions: Apollo.QueryHookOptions<ApplicationTokensQuery, ApplicationTokensQueryVariables> & ({ variables: ApplicationTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationTokensQuery, ApplicationTokensQueryVariables>(ApplicationTokensDocument, options);
      }
export function useApplicationTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationTokensQuery, ApplicationTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationTokensQuery, ApplicationTokensQueryVariables>(ApplicationTokensDocument, options);
        }
// @ts-ignore
export function useApplicationTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationTokensQuery, ApplicationTokensQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationTokensQuery, ApplicationTokensQueryVariables>;
export function useApplicationTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationTokensQuery, ApplicationTokensQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationTokensQuery | undefined, ApplicationTokensQueryVariables>;
export function useApplicationTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationTokensQuery, ApplicationTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationTokensQuery, ApplicationTokensQueryVariables>(ApplicationTokensDocument, options);
        }
export type ApplicationTokensQueryHookResult = ReturnType<typeof useApplicationTokensQuery>;
export type ApplicationTokensLazyQueryHookResult = ReturnType<typeof useApplicationTokensLazyQuery>;
export type ApplicationTokensSuspenseQueryHookResult = ReturnType<typeof useApplicationTokensSuspenseQuery>;
export type ApplicationTokensQueryResult = Apollo.QueryResult<ApplicationTokensQuery, ApplicationTokensQueryVariables>;
export const CandidateAvailabilityTokensDocument = gql`
    query CandidateAvailabilityTokens($id: String, $renderType: RenderType!, $candidateAvailabilityInput: TokenCandidateAvailabilityInput!, $timezone: timezone!) {
  CANDIDATE_AVAILABILITY: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_AVAILABILITY(input: $candidateAvailabilityInput)
  }
  CANDIDATE_AVAILABILITY_TIMEZONE: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CANDIDATE_AVAILABILITY_TIMEZONE(input: {timezone: $timezone})
  }
}
    `;

/**
 * __useCandidateAvailabilityTokensQuery__
 *
 * To run a query within a React component, call `useCandidateAvailabilityTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateAvailabilityTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateAvailabilityTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *      candidateAvailabilityInput: // value for 'candidateAvailabilityInput'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useCandidateAvailabilityTokensQuery(baseOptions: Apollo.QueryHookOptions<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables> & ({ variables: CandidateAvailabilityTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>(CandidateAvailabilityTokensDocument, options);
      }
export function useCandidateAvailabilityTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>(CandidateAvailabilityTokensDocument, options);
        }
// @ts-ignore
export function useCandidateAvailabilityTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>;
export function useCandidateAvailabilityTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityTokensQuery | undefined, CandidateAvailabilityTokensQueryVariables>;
export function useCandidateAvailabilityTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>(CandidateAvailabilityTokensDocument, options);
        }
export type CandidateAvailabilityTokensQueryHookResult = ReturnType<typeof useCandidateAvailabilityTokensQuery>;
export type CandidateAvailabilityTokensLazyQueryHookResult = ReturnType<typeof useCandidateAvailabilityTokensLazyQuery>;
export type CandidateAvailabilityTokensSuspenseQueryHookResult = ReturnType<typeof useCandidateAvailabilityTokensSuspenseQuery>;
export type CandidateAvailabilityTokensQueryResult = Apollo.QueryResult<CandidateAvailabilityTokensQuery, CandidateAvailabilityTokensQueryVariables>;
export const CandidateTokensRequestDocument = gql`
    query CandidateTokensRequest($id: String, $renderType: RenderType!, $candidateId: uuid!, $applicationId: uuid!, $jobId: uuid!, $candidateLinkLabel: String, $hasApplicationId: Boolean!, $hasJobId: Boolean!) {
  CANDIDATE_NAME: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_NAME(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_PREFERRED_FULL_NAME: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CANDIDATE_PREFERRED_FULL_NAME(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_FIRST_NAME: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_FIRST_NAME(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_PREFERRED_FIRST_NAME: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CANDIDATE_PREFERRED_FIRST_NAME(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_LAST_NAME: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_LAST_NAME(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_LAST_INITIAL: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_LAST_INITIAL(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_EMAIL_ADDRESS: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CANDIDATE_EMAIL_ADDRESS(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_PHONE: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_PHONE(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_PRONOUNS: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_PRONOUNS(input: {id: $candidateId, jobId: $jobId})
  }
  CANDIDATE_LINKEDIN: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_LINKEDIN(input: {id: $candidateId})
  }
  COORDINATOR_EMAIL: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    COORDINATOR_EMAIL(
      input: {id: $candidateId, jobId: $jobId, applicationId: $applicationId}
    )
  }
  COORDINATOR: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    COORDINATOR(
      input: {id: $candidateId, jobId: $jobId, applicationId: $applicationId}
    )
  }
  RECRUITER_EMAIL: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    RECRUITER_EMAIL(
      input: {id: $candidateId, jobId: $jobId, applicationId: $applicationId}
    )
  }
  RECRUITER: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    RECRUITER(
      input: {id: $candidateId, jobId: $jobId, applicationId: $applicationId}
    )
  }
  HIRING_MANAGER: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasJobId) {
    id
    HIRING_MANAGER(input: {jobId: $jobId})
  }
  CANDIDATE_LINK: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_LINK(
      input: {id: $candidateId, applicationId: $applicationId, label: $candidateLinkLabel}
    )
  }
  SOURCER: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasApplicationId) {
    id
    SOURCER(input: {id: $applicationId})
  }
  CANDIDATE_SOURCER: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    CANDIDATE_SOURCER(
      input: {id: $candidateId, jobId: $jobId, applicationId: $applicationId}
    )
  }
  CANDIDATE_SOURCER_EMAIL: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CANDIDATE_SOURCER_EMAIL(
      input: {id: $candidateId, jobId: $jobId, applicationId: $applicationId}
    )
  }
}
    `;

/**
 * __useCandidateTokensRequestQuery__
 *
 * To run a query within a React component, call `useCandidateTokensRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateTokensRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateTokensRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *      candidateId: // value for 'candidateId'
 *      applicationId: // value for 'applicationId'
 *      jobId: // value for 'jobId'
 *      candidateLinkLabel: // value for 'candidateLinkLabel'
 *      hasApplicationId: // value for 'hasApplicationId'
 *      hasJobId: // value for 'hasJobId'
 *   },
 * });
 */
export function useCandidateTokensRequestQuery(baseOptions: Apollo.QueryHookOptions<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables> & ({ variables: CandidateTokensRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>(CandidateTokensRequestDocument, options);
      }
export function useCandidateTokensRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>(CandidateTokensRequestDocument, options);
        }
// @ts-ignore
export function useCandidateTokensRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>;
export function useCandidateTokensRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateTokensRequestQuery | undefined, CandidateTokensRequestQueryVariables>;
export function useCandidateTokensRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>(CandidateTokensRequestDocument, options);
        }
export type CandidateTokensRequestQueryHookResult = ReturnType<typeof useCandidateTokensRequestQuery>;
export type CandidateTokensRequestLazyQueryHookResult = ReturnType<typeof useCandidateTokensRequestLazyQuery>;
export type CandidateTokensRequestSuspenseQueryHookResult = ReturnType<typeof useCandidateTokensRequestSuspenseQuery>;
export type CandidateTokensRequestQueryResult = Apollo.QueryResult<CandidateTokensRequestQuery, CandidateTokensRequestQueryVariables>;
export const ChatMentionTokensDocument = gql`
    query ChatMentionTokens($id: String!, $applicationId: uuid!, $interviewerIds: [uuid!]!, $renderType: RenderType!) {
  CHAT_MENTION_INTERVIEWERS: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CHAT_MENTION_INTERVIEWERS(input: {interviewerIds: $interviewerIds})
  }
  CHAT_MENTION_DEBRIEF_ATTENDEES: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CHAT_MENTION_DEBRIEF_ATTENDEES(input: {interviewerIds: $interviewerIds})
  }
  CHAT_MENTION_CANDIDATE_SOURCER: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CHAT_MENTION_CANDIDATE_SOURCER(input: {id: $applicationId})
  }
  CHAT_MENTION_CANDIDATE_RECRUITER: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CHAT_MENTION_CANDIDATE_RECRUITER(input: {id: $applicationId})
  }
  CHAT_MENTION_CANDIDATE_COORDINATOR: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CHAT_MENTION_CANDIDATE_COORDINATOR(input: {id: $applicationId})
  }
  CHAT_MENTION_JOB_HIRING_MANAGERS: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    CHAT_MENTION_JOB_HIRING_MANAGERS(input: {id: $applicationId})
  }
}
    `;

/**
 * __useChatMentionTokensQuery__
 *
 * To run a query within a React component, call `useChatMentionTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMentionTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMentionTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      applicationId: // value for 'applicationId'
 *      interviewerIds: // value for 'interviewerIds'
 *      renderType: // value for 'renderType'
 *   },
 * });
 */
export function useChatMentionTokensQuery(baseOptions: Apollo.QueryHookOptions<ChatMentionTokensQuery, ChatMentionTokensQueryVariables> & ({ variables: ChatMentionTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>(ChatMentionTokensDocument, options);
      }
export function useChatMentionTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>(ChatMentionTokensDocument, options);
        }
// @ts-ignore
export function useChatMentionTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>): Apollo.UseSuspenseQueryResult<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>;
export function useChatMentionTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>): Apollo.UseSuspenseQueryResult<ChatMentionTokensQuery | undefined, ChatMentionTokensQueryVariables>;
export function useChatMentionTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>(ChatMentionTokensDocument, options);
        }
export type ChatMentionTokensQueryHookResult = ReturnType<typeof useChatMentionTokensQuery>;
export type ChatMentionTokensLazyQueryHookResult = ReturnType<typeof useChatMentionTokensLazyQuery>;
export type ChatMentionTokensSuspenseQueryHookResult = ReturnType<typeof useChatMentionTokensSuspenseQuery>;
export type ChatMentionTokensQueryResult = Apollo.QueryResult<ChatMentionTokensQuery, ChatMentionTokensQueryVariables>;
export const DebriefTokensDocument = gql`
    query DebriefTokens($id: String, $renderType: RenderType!, $input: TokenDebriefScheduleInput!) {
  DEBRIEF_SCHEDULE: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    DEBRIEF_SCHEDULE(input: $input)
  }
}
    `;

/**
 * __useDebriefTokensQuery__
 *
 * To run a query within a React component, call `useDebriefTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDebriefTokensQuery(baseOptions: Apollo.QueryHookOptions<DebriefTokensQuery, DebriefTokensQueryVariables> & ({ variables: DebriefTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefTokensQuery, DebriefTokensQueryVariables>(DebriefTokensDocument, options);
      }
export function useDebriefTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefTokensQuery, DebriefTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefTokensQuery, DebriefTokensQueryVariables>(DebriefTokensDocument, options);
        }
// @ts-ignore
export function useDebriefTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefTokensQuery, DebriefTokensQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefTokensQuery, DebriefTokensQueryVariables>;
export function useDebriefTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefTokensQuery, DebriefTokensQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefTokensQuery | undefined, DebriefTokensQueryVariables>;
export function useDebriefTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefTokensQuery, DebriefTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefTokensQuery, DebriefTokensQueryVariables>(DebriefTokensDocument, options);
        }
export type DebriefTokensQueryHookResult = ReturnType<typeof useDebriefTokensQuery>;
export type DebriefTokensLazyQueryHookResult = ReturnType<typeof useDebriefTokensLazyQuery>;
export type DebriefTokensSuspenseQueryHookResult = ReturnType<typeof useDebriefTokensSuspenseQuery>;
export type DebriefTokensQueryResult = Apollo.QueryResult<DebriefTokensQuery, DebriefTokensQueryVariables>;
export const InterviewTokensDocument = gql`
    query InterviewTokens($id: String, $uuid: uuid!, $renderType: RenderType!, $name: TokenInterviewNameInput!, $names: TokenInterviewerNamesInput!, $scheduleNames: TokenInterviewerNamesInput!, $days: TokenInterviewDaysInput!, $schedule: TokenInterviewScheduleInput!, $scheduleStartTime: TokenInterviewScheduleStartTimeInput!, $internalInterviewSchedule: TokenInterviewScheduleInput!, $kitLink: TokenInterviewKitLinkInput!, $codeLink: CodeLinkInput!, $hasScorecard: Boolean!, $videoMeetingLink: TokenVideoMeetingLinkInput!, $scheduleLocation: TokenScheduleLocationInput!, $zoom: TokenZoomMeetingInput!, $trainingInfo: TokenInterviewerTrainingInfoInput!, $hasName: Boolean!, $hasNames: Boolean!, $hasDays: Boolean!, $hasSchedule: Boolean!, $hasScheduleStartTime: Boolean!, $hasInternalInterviewSchedule: Boolean!, $hasCodeLink: Boolean!, $hasVideoMeetingLink: Boolean!, $hasScheduleLocation: Boolean!, $hasZoom: Boolean!, $atsInterviewDefinitionId: String) {
  INTERVIEW_NAME: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasName) {
    id
    INTERVIEW_NAME(input: $name)
  }
  EXTERNAL_INTERVIEW_NAME: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasName) {
    id
    EXTERNAL_INTERVIEW_NAME(input: $name)
  }
  INTERVIEWER_NAMES: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasNames) {
    id
    INTERVIEWER_NAMES(input: $names)
  }
  SCHEDULE_INTERVIEWER_NAMES: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasNames) {
    id
    INTERVIEWER_NAMES(input: $scheduleNames)
  }
  INTERVIEW_DAYS: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasDays) {
    id
    INTERVIEW_DAYS(input: $days)
  }
  INTERVIEW_SCHEDULE: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasSchedule) {
    id
    INTERVIEW_SCHEDULE(input: $schedule)
  }
  INTERVIEW_SCHEDULE_START_TIME: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasScheduleStartTime) {
    id
    INTERVIEW_SCHEDULE_START_TIME(input: $scheduleStartTime)
  }
  INTERNAL_INTERVIEW_SCHEDULE: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasInternalInterviewSchedule) {
    id
    INTERNAL_INTERVIEW_SCHEDULE(input: $internalInterviewSchedule)
  }
  INTERVIEW_KIT_LINK: templateToken(input: {id: $id, renderType: $renderType}) {
    id
    INTERVIEW_KIT_LINK(input: $kitLink)
  }
  INTERVIEW_SCORECARD_NAME: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasScorecard) {
    id
    INTERVIEW_SCORECARD_NAME(
      input: {id: $uuid, atsInterviewDefinitionId: $atsInterviewDefinitionId}
    )
  }
  INTERNAL_INTERVIEW_NAME: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasScorecard) {
    id
    INTERNAL_INTERVIEW_NAME(
      input: {id: $uuid, atsInterviewDefinitionId: $atsInterviewDefinitionId}
    )
  }
  CODE_LINK: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasCodeLink) {
    id
    CODE_LINK(input: $codeLink)
  }
  VIDEO_MEETING_LINK: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasVideoMeetingLink) {
    id
    VIDEO_MEETING_LINK(input: $videoMeetingLink)
  }
  SCHEDULE_LOCATION: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasScheduleLocation) {
    id
    SCHEDULE_LOCATION(input: $scheduleLocation)
  }
  ZOOM_MEETING_DIAL_IN_INFO: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasZoom) {
    id
    ZOOM_MEETING_DIAL_IN_INFO(input: $zoom)
  }
  ZOOM_MEETING_INFO: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasZoom) {
    id
    ZOOM_MEETING_INFO(input: $zoom)
  }
  INTERVIEWER_TRAINING_INFO: templateToken(
    input: {id: $id, renderType: $renderType}
  ) {
    id
    INTERVIEWER_TRAINING_INFO(input: $trainingInfo)
  }
}
    `;

/**
 * __useInterviewTokensQuery__
 *
 * To run a query within a React component, call `useInterviewTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *      renderType: // value for 'renderType'
 *      name: // value for 'name'
 *      names: // value for 'names'
 *      scheduleNames: // value for 'scheduleNames'
 *      days: // value for 'days'
 *      schedule: // value for 'schedule'
 *      scheduleStartTime: // value for 'scheduleStartTime'
 *      internalInterviewSchedule: // value for 'internalInterviewSchedule'
 *      kitLink: // value for 'kitLink'
 *      codeLink: // value for 'codeLink'
 *      hasScorecard: // value for 'hasScorecard'
 *      videoMeetingLink: // value for 'videoMeetingLink'
 *      scheduleLocation: // value for 'scheduleLocation'
 *      zoom: // value for 'zoom'
 *      trainingInfo: // value for 'trainingInfo'
 *      hasName: // value for 'hasName'
 *      hasNames: // value for 'hasNames'
 *      hasDays: // value for 'hasDays'
 *      hasSchedule: // value for 'hasSchedule'
 *      hasScheduleStartTime: // value for 'hasScheduleStartTime'
 *      hasInternalInterviewSchedule: // value for 'hasInternalInterviewSchedule'
 *      hasCodeLink: // value for 'hasCodeLink'
 *      hasVideoMeetingLink: // value for 'hasVideoMeetingLink'
 *      hasScheduleLocation: // value for 'hasScheduleLocation'
 *      hasZoom: // value for 'hasZoom'
 *      atsInterviewDefinitionId: // value for 'atsInterviewDefinitionId'
 *   },
 * });
 */
export function useInterviewTokensQuery(baseOptions: Apollo.QueryHookOptions<InterviewTokensQuery, InterviewTokensQueryVariables> & ({ variables: InterviewTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewTokensQuery, InterviewTokensQueryVariables>(InterviewTokensDocument, options);
      }
export function useInterviewTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewTokensQuery, InterviewTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewTokensQuery, InterviewTokensQueryVariables>(InterviewTokensDocument, options);
        }
// @ts-ignore
export function useInterviewTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewTokensQuery, InterviewTokensQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewTokensQuery, InterviewTokensQueryVariables>;
export function useInterviewTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewTokensQuery, InterviewTokensQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewTokensQuery | undefined, InterviewTokensQueryVariables>;
export function useInterviewTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewTokensQuery, InterviewTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewTokensQuery, InterviewTokensQueryVariables>(InterviewTokensDocument, options);
        }
export type InterviewTokensQueryHookResult = ReturnType<typeof useInterviewTokensQuery>;
export type InterviewTokensLazyQueryHookResult = ReturnType<typeof useInterviewTokensLazyQuery>;
export type InterviewTokensSuspenseQueryHookResult = ReturnType<typeof useInterviewTokensSuspenseQuery>;
export type InterviewTokensQueryResult = Apollo.QueryResult<InterviewTokensQuery, InterviewTokensQueryVariables>;
export const JobTokensDocument = gql`
    query JobTokens($id: String, $renderType: RenderType!, $jobId: uuid!, $jobStageId: uuid!, $applicationId: uuid) {
  templateToken(input: {id: $id, renderType: $renderType}) {
    id
    JOB_NAME(input: {id: $jobId})
    JOB_LOCATION(input: {id: $jobId})
    JOB_STAGE_NAME(input: {id: $jobStageId})
    EXTERNAL_JOB_NAME(input: {applicationId: $applicationId})
  }
}
    `;

/**
 * __useJobTokensQuery__
 *
 * To run a query within a React component, call `useJobTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *      jobId: // value for 'jobId'
 *      jobStageId: // value for 'jobStageId'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useJobTokensQuery(baseOptions: Apollo.QueryHookOptions<JobTokensQuery, JobTokensQueryVariables> & ({ variables: JobTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobTokensQuery, JobTokensQueryVariables>(JobTokensDocument, options);
      }
export function useJobTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobTokensQuery, JobTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobTokensQuery, JobTokensQueryVariables>(JobTokensDocument, options);
        }
// @ts-ignore
export function useJobTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobTokensQuery, JobTokensQueryVariables>): Apollo.UseSuspenseQueryResult<JobTokensQuery, JobTokensQueryVariables>;
export function useJobTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTokensQuery, JobTokensQueryVariables>): Apollo.UseSuspenseQueryResult<JobTokensQuery | undefined, JobTokensQueryVariables>;
export function useJobTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobTokensQuery, JobTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobTokensQuery, JobTokensQueryVariables>(JobTokensDocument, options);
        }
export type JobTokensQueryHookResult = ReturnType<typeof useJobTokensQuery>;
export type JobTokensLazyQueryHookResult = ReturnType<typeof useJobTokensLazyQuery>;
export type JobTokensSuspenseQueryHookResult = ReturnType<typeof useJobTokensSuspenseQuery>;
export type JobTokensQueryResult = Apollo.QueryResult<JobTokensQuery, JobTokensQueryVariables>;
export const MeetingsTokenDocument = gql`
    query MeetingsToken($id: String, $renderType: RenderType!, $zoom: TokenZoomMeetingInput!, $videoMeetingLink: TokenVideoMeetingLinkInput!, $scheduleLocationInput: TokenScheduleLocationInput!, $hasVideoMeetingLink: Boolean!, $hasZoom: Boolean!, $hasScheduleLocation: Boolean!) {
  VIDEO_MEETING_LINK: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasVideoMeetingLink) {
    id
    VIDEO_MEETING_LINK(input: $videoMeetingLink)
  }
  SCHEDULE_LOCATION: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasScheduleLocation) {
    id
    SCHEDULE_LOCATION(input: $scheduleLocationInput)
  }
  ZOOM_MEETING_DIAL_IN_INFO: templateToken(
    input: {id: $id, renderType: $renderType}
  ) @include(if: $hasZoom) {
    id
    ZOOM_MEETING_DIAL_IN_INFO(input: $zoom)
  }
  ZOOM_MEETING_INFO: templateToken(input: {id: $id, renderType: $renderType}) @include(if: $hasZoom) {
    id
    ZOOM_MEETING_INFO(input: $zoom)
  }
}
    `;

/**
 * __useMeetingsTokenQuery__
 *
 * To run a query within a React component, call `useMeetingsTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeetingsTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeetingsTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *      zoom: // value for 'zoom'
 *      videoMeetingLink: // value for 'videoMeetingLink'
 *      scheduleLocationInput: // value for 'scheduleLocationInput'
 *      hasVideoMeetingLink: // value for 'hasVideoMeetingLink'
 *      hasZoom: // value for 'hasZoom'
 *      hasScheduleLocation: // value for 'hasScheduleLocation'
 *   },
 * });
 */
export function useMeetingsTokenQuery(baseOptions: Apollo.QueryHookOptions<MeetingsTokenQuery, MeetingsTokenQueryVariables> & ({ variables: MeetingsTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeetingsTokenQuery, MeetingsTokenQueryVariables>(MeetingsTokenDocument, options);
      }
export function useMeetingsTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeetingsTokenQuery, MeetingsTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeetingsTokenQuery, MeetingsTokenQueryVariables>(MeetingsTokenDocument, options);
        }
// @ts-ignore
export function useMeetingsTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeetingsTokenQuery, MeetingsTokenQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingsTokenQuery, MeetingsTokenQueryVariables>;
export function useMeetingsTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingsTokenQuery, MeetingsTokenQueryVariables>): Apollo.UseSuspenseQueryResult<MeetingsTokenQuery | undefined, MeetingsTokenQueryVariables>;
export function useMeetingsTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeetingsTokenQuery, MeetingsTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeetingsTokenQuery, MeetingsTokenQueryVariables>(MeetingsTokenDocument, options);
        }
export type MeetingsTokenQueryHookResult = ReturnType<typeof useMeetingsTokenQuery>;
export type MeetingsTokenLazyQueryHookResult = ReturnType<typeof useMeetingsTokenLazyQuery>;
export type MeetingsTokenSuspenseQueryHookResult = ReturnType<typeof useMeetingsTokenSuspenseQuery>;
export type MeetingsTokenQueryResult = Apollo.QueryResult<MeetingsTokenQuery, MeetingsTokenQueryVariables>;
export const TaskTokensDocument = gql`
    query TaskTokens($id: String, $renderType: RenderType!, $taskId: uuid, $assigneeId: uuid) {
  templateToken(input: {id: $id, renderType: $renderType}) {
    id
    TASK_CREATOR(input: {taskId: $taskId})
    TASK_ASSIGNEE(input: {taskId: $taskId, assigneeId: $assigneeId})
  }
}
    `;

/**
 * __useTaskTokensQuery__
 *
 * To run a query within a React component, call `useTaskTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *      taskId: // value for 'taskId'
 *      assigneeId: // value for 'assigneeId'
 *   },
 * });
 */
export function useTaskTokensQuery(baseOptions: Apollo.QueryHookOptions<TaskTokensQuery, TaskTokensQueryVariables> & ({ variables: TaskTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskTokensQuery, TaskTokensQueryVariables>(TaskTokensDocument, options);
      }
export function useTaskTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskTokensQuery, TaskTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskTokensQuery, TaskTokensQueryVariables>(TaskTokensDocument, options);
        }
// @ts-ignore
export function useTaskTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskTokensQuery, TaskTokensQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTokensQuery, TaskTokensQueryVariables>;
export function useTaskTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTokensQuery, TaskTokensQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTokensQuery | undefined, TaskTokensQueryVariables>;
export function useTaskTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTokensQuery, TaskTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskTokensQuery, TaskTokensQueryVariables>(TaskTokensDocument, options);
        }
export type TaskTokensQueryHookResult = ReturnType<typeof useTaskTokensQuery>;
export type TaskTokensLazyQueryHookResult = ReturnType<typeof useTaskTokensLazyQuery>;
export type TaskTokensSuspenseQueryHookResult = ReturnType<typeof useTaskTokensSuspenseQuery>;
export type TaskTokensQueryResult = Apollo.QueryResult<TaskTokensQuery, TaskTokensQueryVariables>;
export const UserTokensDocument = gql`
    query UserTokens($id: String, $renderType: RenderType!) {
  templateToken(input: {id: $id, renderType: $renderType}) {
    id
    ME
    MY_FULL_NAME
    MY_FIRST_NAME
    MY_PHONE_NUMBER
    MY_SIGNATURE
    COMPANY_NAME
    COMPANY
  }
}
    `;

/**
 * __useUserTokensQuery__
 *
 * To run a query within a React component, call `useUserTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTokensQuery({
 *   variables: {
 *      id: // value for 'id'
 *      renderType: // value for 'renderType'
 *   },
 * });
 */
export function useUserTokensQuery(baseOptions: Apollo.QueryHookOptions<UserTokensQuery, UserTokensQueryVariables> & ({ variables: UserTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTokensQuery, UserTokensQueryVariables>(UserTokensDocument, options);
      }
export function useUserTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTokensQuery, UserTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTokensQuery, UserTokensQueryVariables>(UserTokensDocument, options);
        }
// @ts-ignore
export function useUserTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserTokensQuery, UserTokensQueryVariables>): Apollo.UseSuspenseQueryResult<UserTokensQuery, UserTokensQueryVariables>;
export function useUserTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTokensQuery, UserTokensQueryVariables>): Apollo.UseSuspenseQueryResult<UserTokensQuery | undefined, UserTokensQueryVariables>;
export function useUserTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTokensQuery, UserTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTokensQuery, UserTokensQueryVariables>(UserTokensDocument, options);
        }
export type UserTokensQueryHookResult = ReturnType<typeof useUserTokensQuery>;
export type UserTokensLazyQueryHookResult = ReturnType<typeof useUserTokensLazyQuery>;
export type UserTokensSuspenseQueryHookResult = ReturnType<typeof useUserTokensSuspenseQuery>;
export type UserTokensQueryResult = Apollo.QueryResult<UserTokensQuery, UserTokensQueryVariables>;
export const GreenhouseOAuthIntegrationForPreferredNameTokensDocument = gql`
    query GreenhouseOAuthIntegrationForPreferredNameTokens {
  thisOrg {
    id
    integrations {
      id
      greenhouseOauth {
        subdomain
      }
    }
  }
}
    `;

/**
 * __useGreenhouseOAuthIntegrationForPreferredNameTokensQuery__
 *
 * To run a query within a React component, call `useGreenhouseOAuthIntegrationForPreferredNameTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useGreenhouseOAuthIntegrationForPreferredNameTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGreenhouseOAuthIntegrationForPreferredNameTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useGreenhouseOAuthIntegrationForPreferredNameTokensQuery(baseOptions?: Apollo.QueryHookOptions<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>(GreenhouseOAuthIntegrationForPreferredNameTokensDocument, options);
      }
export function useGreenhouseOAuthIntegrationForPreferredNameTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>(GreenhouseOAuthIntegrationForPreferredNameTokensDocument, options);
        }
// @ts-ignore
export function useGreenhouseOAuthIntegrationForPreferredNameTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>;
export function useGreenhouseOAuthIntegrationForPreferredNameTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseOAuthIntegrationForPreferredNameTokensQuery | undefined, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>;
export function useGreenhouseOAuthIntegrationForPreferredNameTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>(GreenhouseOAuthIntegrationForPreferredNameTokensDocument, options);
        }
export type GreenhouseOAuthIntegrationForPreferredNameTokensQueryHookResult = ReturnType<typeof useGreenhouseOAuthIntegrationForPreferredNameTokensQuery>;
export type GreenhouseOAuthIntegrationForPreferredNameTokensLazyQueryHookResult = ReturnType<typeof useGreenhouseOAuthIntegrationForPreferredNameTokensLazyQuery>;
export type GreenhouseOAuthIntegrationForPreferredNameTokensSuspenseQueryHookResult = ReturnType<typeof useGreenhouseOAuthIntegrationForPreferredNameTokensSuspenseQuery>;
export type GreenhouseOAuthIntegrationForPreferredNameTokensQueryResult = Apollo.QueryResult<GreenhouseOAuthIntegrationForPreferredNameTokensQuery, GreenhouseOAuthIntegrationForPreferredNameTokensQueryVariables>;
export const ScheduleContentTemplateByIdDocument = gql`
    query ScheduleContentTemplateById($id: uuid!) {
  template(id: $id) {
    id
    subject
    body
    type
    attachments {
      name
      path
      size
      timestamp
    }
  }
}
    `;

/**
 * __useScheduleContentTemplateByIdQuery__
 *
 * To run a query within a React component, call `useScheduleContentTemplateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleContentTemplateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleContentTemplateByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduleContentTemplateByIdQuery(baseOptions: Apollo.QueryHookOptions<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables> & ({ variables: ScheduleContentTemplateByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>(ScheduleContentTemplateByIdDocument, options);
      }
export function useScheduleContentTemplateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>(ScheduleContentTemplateByIdDocument, options);
        }
// @ts-ignore
export function useScheduleContentTemplateByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>;
export function useScheduleContentTemplateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleContentTemplateByIdQuery | undefined, ScheduleContentTemplateByIdQueryVariables>;
export function useScheduleContentTemplateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>(ScheduleContentTemplateByIdDocument, options);
        }
export type ScheduleContentTemplateByIdQueryHookResult = ReturnType<typeof useScheduleContentTemplateByIdQuery>;
export type ScheduleContentTemplateByIdLazyQueryHookResult = ReturnType<typeof useScheduleContentTemplateByIdLazyQuery>;
export type ScheduleContentTemplateByIdSuspenseQueryHookResult = ReturnType<typeof useScheduleContentTemplateByIdSuspenseQuery>;
export type ScheduleContentTemplateByIdQueryResult = Apollo.QueryResult<ScheduleContentTemplateByIdQuery, ScheduleContentTemplateByIdQueryVariables>;
export const RecordDataDownloadDocument = gql`
    mutation RecordDataDownload($input: RecordDataDownloadInput!) {
  recordDataDownload(input: $input) {
    __typename
    ... on RecordDataDownloadSuccess {
      recorded
    }
    ... on InvalidDownloadReasonError {
      errorCode
      errorMessage
    }
    ... on InvalidRowCountError {
      errorCode
      errorMessage
    }
    ... on PermissionDeniedError {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type RecordDataDownloadMutationFn = Apollo.MutationFunction<RecordDataDownloadMutation, RecordDataDownloadMutationVariables>;

/**
 * __useRecordDataDownloadMutation__
 *
 * To run a mutation, you first call `useRecordDataDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordDataDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordDataDownloadMutation, { data, loading, error }] = useRecordDataDownloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordDataDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RecordDataDownloadMutation, RecordDataDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordDataDownloadMutation, RecordDataDownloadMutationVariables>(RecordDataDownloadDocument, options);
      }
export type RecordDataDownloadMutationHookResult = ReturnType<typeof useRecordDataDownloadMutation>;
export type RecordDataDownloadMutationResult = Apollo.MutationResult<RecordDataDownloadMutation>;
export type RecordDataDownloadMutationOptions = Apollo.BaseMutationOptions<RecordDataDownloadMutation, RecordDataDownloadMutationVariables>;
export const AgentThreadsDocument = gql`
    query AgentThreads($input: AgentThreadsInput!) {
  agentThreads(input: $input) {
    items {
      externalThreadId
      title
      updatedAt
      lastAccessedAt
    }
    nextCursor
  }
}
    `;

/**
 * __useAgentThreadsQuery__
 *
 * To run a query within a React component, call `useAgentThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentThreadsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgentThreadsQuery(baseOptions: Apollo.QueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables> & ({ variables: AgentThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentThreadsQuery, AgentThreadsQueryVariables>(AgentThreadsDocument, options);
      }
export function useAgentThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentThreadsQuery, AgentThreadsQueryVariables>(AgentThreadsDocument, options);
        }
// @ts-ignore
export function useAgentThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentThreadsQuery, AgentThreadsQueryVariables>;
export function useAgentThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<AgentThreadsQuery | undefined, AgentThreadsQueryVariables>;
export function useAgentThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentThreadsQuery, AgentThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentThreadsQuery, AgentThreadsQueryVariables>(AgentThreadsDocument, options);
        }
export type AgentThreadsQueryHookResult = ReturnType<typeof useAgentThreadsQuery>;
export type AgentThreadsLazyQueryHookResult = ReturnType<typeof useAgentThreadsLazyQuery>;
export type AgentThreadsSuspenseQueryHookResult = ReturnType<typeof useAgentThreadsSuspenseQuery>;
export type AgentThreadsQueryResult = Apollo.QueryResult<AgentThreadsQuery, AgentThreadsQueryVariables>;
export const MintFirstPartyAgentAccessTokenDocument = gql`
    mutation MintFirstPartyAgentAccessToken($input: MintFirstPartyAgentAccessTokenInput!) {
  mintFirstPartyAgentAccessToken(input: $input) {
    __typename
    ... on MintFirstPartyAgentAccessTokenSuccess {
      token
      expiresAt
      scopes
    }
    ... on MintFirstPartyAgentAccessTokenPermissionDeniedError {
      errorCode
      errorMessage
    }
    ... on MintFirstPartyAgentAccessTokenUnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type MintFirstPartyAgentAccessTokenMutationFn = Apollo.MutationFunction<MintFirstPartyAgentAccessTokenMutation, MintFirstPartyAgentAccessTokenMutationVariables>;

/**
 * __useMintFirstPartyAgentAccessTokenMutation__
 *
 * To run a mutation, you first call `useMintFirstPartyAgentAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMintFirstPartyAgentAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mintFirstPartyAgentAccessTokenMutation, { data, loading, error }] = useMintFirstPartyAgentAccessTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMintFirstPartyAgentAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<MintFirstPartyAgentAccessTokenMutation, MintFirstPartyAgentAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MintFirstPartyAgentAccessTokenMutation, MintFirstPartyAgentAccessTokenMutationVariables>(MintFirstPartyAgentAccessTokenDocument, options);
      }
export type MintFirstPartyAgentAccessTokenMutationHookResult = ReturnType<typeof useMintFirstPartyAgentAccessTokenMutation>;
export type MintFirstPartyAgentAccessTokenMutationResult = Apollo.MutationResult<MintFirstPartyAgentAccessTokenMutation>;
export type MintFirstPartyAgentAccessTokenMutationOptions = Apollo.BaseMutationOptions<MintFirstPartyAgentAccessTokenMutation, MintFirstPartyAgentAccessTokenMutationVariables>;
export const AgentThreadRenameDocument = gql`
    mutation AgentThreadRename($input: AgentThreadRenameInput!) {
  agentThreadRename(input: $input) {
    __typename
    ... on AgentThreadRenameSuccess {
      externalThreadId
      title
    }
    ... on AgentThreadRenameInvalidTitleError {
      errorCode
      errorMessage
    }
    ... on AgentThreadRenameNotFoundError {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type AgentThreadRenameMutationFn = Apollo.MutationFunction<AgentThreadRenameMutation, AgentThreadRenameMutationVariables>;

/**
 * __useAgentThreadRenameMutation__
 *
 * To run a mutation, you first call `useAgentThreadRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgentThreadRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agentThreadRenameMutation, { data, loading, error }] = useAgentThreadRenameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgentThreadRenameMutation(baseOptions?: Apollo.MutationHookOptions<AgentThreadRenameMutation, AgentThreadRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgentThreadRenameMutation, AgentThreadRenameMutationVariables>(AgentThreadRenameDocument, options);
      }
export type AgentThreadRenameMutationHookResult = ReturnType<typeof useAgentThreadRenameMutation>;
export type AgentThreadRenameMutationResult = Apollo.MutationResult<AgentThreadRenameMutation>;
export type AgentThreadRenameMutationOptions = Apollo.BaseMutationOptions<AgentThreadRenameMutation, AgentThreadRenameMutationVariables>;
export const CandidateAiTabDocument = gql`
    query CandidateAiTab($id: uuid!) {
  candidate(id: $id) {
    id
    aiInstruction {
      ...AiInstructionsCard_instruction
    }
    aiMemories {
      ...AiMemoriesCard_memory
    }
  }
}
    ${AiInstructionsCard_InstructionFragmentDoc}
${AiMemoriesCard_MemoryFragmentDoc}`;

/**
 * __useCandidateAiTabQuery__
 *
 * To run a query within a React component, call `useCandidateAiTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateAiTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateAiTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateAiTabQuery(baseOptions: Apollo.QueryHookOptions<CandidateAiTabQuery, CandidateAiTabQueryVariables> & ({ variables: CandidateAiTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateAiTabQuery, CandidateAiTabQueryVariables>(CandidateAiTabDocument, options);
      }
export function useCandidateAiTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateAiTabQuery, CandidateAiTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateAiTabQuery, CandidateAiTabQueryVariables>(CandidateAiTabDocument, options);
        }
// @ts-ignore
export function useCandidateAiTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateAiTabQuery, CandidateAiTabQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAiTabQuery, CandidateAiTabQueryVariables>;
export function useCandidateAiTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAiTabQuery, CandidateAiTabQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAiTabQuery | undefined, CandidateAiTabQueryVariables>;
export function useCandidateAiTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAiTabQuery, CandidateAiTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateAiTabQuery, CandidateAiTabQueryVariables>(CandidateAiTabDocument, options);
        }
export type CandidateAiTabQueryHookResult = ReturnType<typeof useCandidateAiTabQuery>;
export type CandidateAiTabLazyQueryHookResult = ReturnType<typeof useCandidateAiTabLazyQuery>;
export type CandidateAiTabSuspenseQueryHookResult = ReturnType<typeof useCandidateAiTabSuspenseQuery>;
export type CandidateAiTabQueryResult = Apollo.QueryResult<CandidateAiTabQuery, CandidateAiTabQueryVariables>;
export const TaskListDocument = gql`
    query TaskList($applicationId: uuid!) {
  application(id: $applicationId) {
    id
    tasks {
      ...TaskList_task
    }
    ...getActiveTasksForJobStage_appliction
    ...ApplicationSidebarCreateTaskActions_application
  }
}
    ${TaskList_TaskFragmentDoc}
${GetActiveTasksForJobStage_ApplictionFragmentDoc}
${ApplicationSidebarCreateTaskActions_ApplicationFragmentDoc}`;

/**
 * __useTaskListQuery__
 *
 * To run a query within a React component, call `useTaskListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskListQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useTaskListQuery(baseOptions: Apollo.QueryHookOptions<TaskListQuery, TaskListQueryVariables> & ({ variables: TaskListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskListQuery, TaskListQueryVariables>(TaskListDocument, options);
      }
export function useTaskListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskListQuery, TaskListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskListQuery, TaskListQueryVariables>(TaskListDocument, options);
        }
// @ts-ignore
export function useTaskListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskListQuery, TaskListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskListQuery, TaskListQueryVariables>;
export function useTaskListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskListQuery, TaskListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskListQuery | undefined, TaskListQueryVariables>;
export function useTaskListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskListQuery, TaskListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskListQuery, TaskListQueryVariables>(TaskListDocument, options);
        }
export type TaskListQueryHookResult = ReturnType<typeof useTaskListQuery>;
export type TaskListLazyQueryHookResult = ReturnType<typeof useTaskListLazyQuery>;
export type TaskListSuspenseQueryHookResult = ReturnType<typeof useTaskListSuspenseQuery>;
export type TaskListQueryResult = Apollo.QueryResult<TaskListQuery, TaskListQueryVariables>;
export const TaskShareDialogDocument = gql`
    query TaskShareDialog($taskId: uuid!) {
  task(id: $taskId) {
    id
    jobStage {
      id
      jobStageSettingsV2 {
        ...CandidateAvailabilityEmailPreview_jobStageSettingsV2
        ...SelfScheduleEmail_jobStageSettingsV2
      }
    }
    application {
      id
      jobId
      candidate {
        id
        fullName
      }
    }
    availabilityRequests {
      id
      applicationId
      availabilityEndDate
      availabilityStartDate
      candidateNote
      externalId
      createdAt
      jobStageId
      minimumTimeBlockMinutes
      minutesPerDays
      numberOfDays
      timezone
      updatedAt
      lastCandidateCommunicationSentAt
      advanceNoticeMinutes
      shouldRespectLoadLimit
      bookIfPerfectScheduleFound
      suggestOverAvailableKeywords
      suggestOverFreeTime
      suggestOverRecruitingKeywords
      rollingDays
      inclusionDays
    }
    selfScheduleRequests {
      id
      applicationId
      createdAt
      creatorEmployeeId
      deletedAt
      jobStageId
      interviewerEventTemplateId
      candidateEventTemplateId
      candidateEmailTemplateId
      lastUpdatedByEmployeeId
      options {
        inclusionDays
        rollingDays
        advanceNoticeInHours
        candidateCalendarId
        interviewerCalendarId
        location
        zoomHost
        zoomHostUserId
        candidateEmail
        canScheduleOverAvailableKeywords
        canScheduleOverFreeTime
        canScheduleOverRecruitingKeywords
        shouldRespectLoadLimit
      }
      rescheduledAt
      selfScheduleEmailTemplateId
      selfScheduleEmailSentAt
      updatedAt
    }
  }
}
    ${CandidateAvailabilityEmailPreview_JobStageSettingsV2FragmentDoc}
${SelfScheduleEmail_JobStageSettingsV2FragmentDoc}`;

/**
 * __useTaskShareDialogQuery__
 *
 * To run a query within a React component, call `useTaskShareDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskShareDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskShareDialogQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskShareDialogQuery(baseOptions: Apollo.QueryHookOptions<TaskShareDialogQuery, TaskShareDialogQueryVariables> & ({ variables: TaskShareDialogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskShareDialogQuery, TaskShareDialogQueryVariables>(TaskShareDialogDocument, options);
      }
export function useTaskShareDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskShareDialogQuery, TaskShareDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskShareDialogQuery, TaskShareDialogQueryVariables>(TaskShareDialogDocument, options);
        }
// @ts-ignore
export function useTaskShareDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskShareDialogQuery, TaskShareDialogQueryVariables>): Apollo.UseSuspenseQueryResult<TaskShareDialogQuery, TaskShareDialogQueryVariables>;
export function useTaskShareDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskShareDialogQuery, TaskShareDialogQueryVariables>): Apollo.UseSuspenseQueryResult<TaskShareDialogQuery | undefined, TaskShareDialogQueryVariables>;
export function useTaskShareDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskShareDialogQuery, TaskShareDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskShareDialogQuery, TaskShareDialogQueryVariables>(TaskShareDialogDocument, options);
        }
export type TaskShareDialogQueryHookResult = ReturnType<typeof useTaskShareDialogQuery>;
export type TaskShareDialogLazyQueryHookResult = ReturnType<typeof useTaskShareDialogLazyQuery>;
export type TaskShareDialogSuspenseQueryHookResult = ReturnType<typeof useTaskShareDialogSuspenseQuery>;
export type TaskShareDialogQueryResult = Apollo.QueryResult<TaskShareDialogQuery, TaskShareDialogQueryVariables>;
export const EditCandidatePhoneNumberDocument = gql`
    mutation EditCandidatePhoneNumber($input: CandidateUpdateInput!) {
  candidateUpdate(input: $input) {
    candidate {
      id
      ...EditCandidatePhoneNumberModal_candidate
    }
  }
}
    ${EditCandidatePhoneNumberModal_CandidateFragmentDoc}`;
export type EditCandidatePhoneNumberMutationFn = Apollo.MutationFunction<EditCandidatePhoneNumberMutation, EditCandidatePhoneNumberMutationVariables>;

/**
 * __useEditCandidatePhoneNumberMutation__
 *
 * To run a mutation, you first call `useEditCandidatePhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCandidatePhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCandidatePhoneNumberMutation, { data, loading, error }] = useEditCandidatePhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCandidatePhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<EditCandidatePhoneNumberMutation, EditCandidatePhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCandidatePhoneNumberMutation, EditCandidatePhoneNumberMutationVariables>(EditCandidatePhoneNumberDocument, options);
      }
export type EditCandidatePhoneNumberMutationHookResult = ReturnType<typeof useEditCandidatePhoneNumberMutation>;
export type EditCandidatePhoneNumberMutationResult = Apollo.MutationResult<EditCandidatePhoneNumberMutation>;
export type EditCandidatePhoneNumberMutationOptions = Apollo.BaseMutationOptions<EditCandidatePhoneNumberMutation, EditCandidatePhoneNumberMutationVariables>;
export const ToggleCandidatePortalDocument = gql`
    mutation toggleCandidatePortal($input: ApplicationUpdateInput!) {
  applicationUpdate(input: $input) {
    ...CandidatePortalActionsMenu_application
  }
}
    ${CandidatePortalActionsMenu_ApplicationFragmentDoc}`;
export type ToggleCandidatePortalMutationFn = Apollo.MutationFunction<ToggleCandidatePortalMutation, ToggleCandidatePortalMutationVariables>;

/**
 * __useToggleCandidatePortalMutation__
 *
 * To run a mutation, you first call `useToggleCandidatePortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCandidatePortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCandidatePortalMutation, { data, loading, error }] = useToggleCandidatePortalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleCandidatePortalMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCandidatePortalMutation, ToggleCandidatePortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCandidatePortalMutation, ToggleCandidatePortalMutationVariables>(ToggleCandidatePortalDocument, options);
      }
export type ToggleCandidatePortalMutationHookResult = ReturnType<typeof useToggleCandidatePortalMutation>;
export type ToggleCandidatePortalMutationResult = Apollo.MutationResult<ToggleCandidatePortalMutation>;
export type ToggleCandidatePortalMutationOptions = Apollo.BaseMutationOptions<ToggleCandidatePortalMutation, ToggleCandidatePortalMutationVariables>;
export const ResetPrimaryEmailDocument = gql`
    mutation resetPrimaryEmail($input: CandidateUpdateInput!) {
  candidateUpdate(input: $input) {
    candidate {
      id
      email
      preferredEmail
    }
  }
}
    `;
export type ResetPrimaryEmailMutationFn = Apollo.MutationFunction<ResetPrimaryEmailMutation, ResetPrimaryEmailMutationVariables>;

/**
 * __useResetPrimaryEmailMutation__
 *
 * To run a mutation, you first call `useResetPrimaryEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPrimaryEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPrimaryEmailMutation, { data, loading, error }] = useResetPrimaryEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPrimaryEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResetPrimaryEmailMutation, ResetPrimaryEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPrimaryEmailMutation, ResetPrimaryEmailMutationVariables>(ResetPrimaryEmailDocument, options);
      }
export type ResetPrimaryEmailMutationHookResult = ReturnType<typeof useResetPrimaryEmailMutation>;
export type ResetPrimaryEmailMutationResult = Apollo.MutationResult<ResetPrimaryEmailMutation>;
export type ResetPrimaryEmailMutationOptions = Apollo.BaseMutationOptions<ResetPrimaryEmailMutation, ResetPrimaryEmailMutationVariables>;
export const DeleteCandidatePortalNoteDocument = gql`
    mutation deleteCandidatePortalNote($applicationCandidatePortalNoteDeleteId: uuid!) {
  applicationCandidatePortalNoteDelete(
    id: $applicationCandidatePortalNoteDeleteId
  ) {
    result
  }
}
    `;
export type DeleteCandidatePortalNoteMutationFn = Apollo.MutationFunction<DeleteCandidatePortalNoteMutation, DeleteCandidatePortalNoteMutationVariables>;

/**
 * __useDeleteCandidatePortalNoteMutation__
 *
 * To run a mutation, you first call `useDeleteCandidatePortalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidatePortalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidatePortalNoteMutation, { data, loading, error }] = useDeleteCandidatePortalNoteMutation({
 *   variables: {
 *      applicationCandidatePortalNoteDeleteId: // value for 'applicationCandidatePortalNoteDeleteId'
 *   },
 * });
 */
export function useDeleteCandidatePortalNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidatePortalNoteMutation, DeleteCandidatePortalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidatePortalNoteMutation, DeleteCandidatePortalNoteMutationVariables>(DeleteCandidatePortalNoteDocument, options);
      }
export type DeleteCandidatePortalNoteMutationHookResult = ReturnType<typeof useDeleteCandidatePortalNoteMutation>;
export type DeleteCandidatePortalNoteMutationResult = Apollo.MutationResult<DeleteCandidatePortalNoteMutation>;
export type DeleteCandidatePortalNoteMutationOptions = Apollo.BaseMutationOptions<DeleteCandidatePortalNoteMutation, DeleteCandidatePortalNoteMutationVariables>;
export const CreateCandidatePortalNoteDocument = gql`
    mutation createCandidatePortalNote($applicationCandidatePortalNoteCreateInput: ApplicationCandidatePortalNoteCreateInput!) {
  applicationCandidatePortalNoteCreate(
    input: $applicationCandidatePortalNoteCreateInput
  ) {
    id
    updatedAt
    lastNotificationSentAt
    ...CandidatePortalNoteEditor_candidatePortalNote
  }
}
    ${CandidatePortalNoteEditor_CandidatePortalNoteFragmentDoc}`;
export type CreateCandidatePortalNoteMutationFn = Apollo.MutationFunction<CreateCandidatePortalNoteMutation, CreateCandidatePortalNoteMutationVariables>;

/**
 * __useCreateCandidatePortalNoteMutation__
 *
 * To run a mutation, you first call `useCreateCandidatePortalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidatePortalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidatePortalNoteMutation, { data, loading, error }] = useCreateCandidatePortalNoteMutation({
 *   variables: {
 *      applicationCandidatePortalNoteCreateInput: // value for 'applicationCandidatePortalNoteCreateInput'
 *   },
 * });
 */
export function useCreateCandidatePortalNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidatePortalNoteMutation, CreateCandidatePortalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidatePortalNoteMutation, CreateCandidatePortalNoteMutationVariables>(CreateCandidatePortalNoteDocument, options);
      }
export type CreateCandidatePortalNoteMutationHookResult = ReturnType<typeof useCreateCandidatePortalNoteMutation>;
export type CreateCandidatePortalNoteMutationResult = Apollo.MutationResult<CreateCandidatePortalNoteMutation>;
export type CreateCandidatePortalNoteMutationOptions = Apollo.BaseMutationOptions<CreateCandidatePortalNoteMutation, CreateCandidatePortalNoteMutationVariables>;
export const UpdateCandidatePortalNoteDocument = gql`
    mutation updateCandidatePortalNote($input: ApplicationCandidatePortalNoteUpdateInput!) {
  applicationCandidatePortalNoteUpdate(input: $input) {
    id
    updatedAt
    lastNotificationSentAt
    ...CandidatePortalNoteEditor_candidatePortalNote
  }
}
    ${CandidatePortalNoteEditor_CandidatePortalNoteFragmentDoc}`;
export type UpdateCandidatePortalNoteMutationFn = Apollo.MutationFunction<UpdateCandidatePortalNoteMutation, UpdateCandidatePortalNoteMutationVariables>;

/**
 * __useUpdateCandidatePortalNoteMutation__
 *
 * To run a mutation, you first call `useUpdateCandidatePortalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidatePortalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidatePortalNoteMutation, { data, loading, error }] = useUpdateCandidatePortalNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidatePortalNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidatePortalNoteMutation, UpdateCandidatePortalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidatePortalNoteMutation, UpdateCandidatePortalNoteMutationVariables>(UpdateCandidatePortalNoteDocument, options);
      }
export type UpdateCandidatePortalNoteMutationHookResult = ReturnType<typeof useUpdateCandidatePortalNoteMutation>;
export type UpdateCandidatePortalNoteMutationResult = Apollo.MutationResult<UpdateCandidatePortalNoteMutation>;
export type UpdateCandidatePortalNoteMutationOptions = Apollo.BaseMutationOptions<UpdateCandidatePortalNoteMutation, UpdateCandidatePortalNoteMutationVariables>;
export const ToggleCandidatePortalStatusDocument = gql`
    mutation toggleCandidatePortalStatus($input: ApplicationUpdateInput!) {
  applicationUpdate(input: $input) {
    id
    isPortalAccessible
  }
}
    `;
export type ToggleCandidatePortalStatusMutationFn = Apollo.MutationFunction<ToggleCandidatePortalStatusMutation, ToggleCandidatePortalStatusMutationVariables>;

/**
 * __useToggleCandidatePortalStatusMutation__
 *
 * To run a mutation, you first call `useToggleCandidatePortalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCandidatePortalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCandidatePortalStatusMutation, { data, loading, error }] = useToggleCandidatePortalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleCandidatePortalStatusMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCandidatePortalStatusMutation, ToggleCandidatePortalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCandidatePortalStatusMutation, ToggleCandidatePortalStatusMutationVariables>(ToggleCandidatePortalStatusDocument, options);
      }
export type ToggleCandidatePortalStatusMutationHookResult = ReturnType<typeof useToggleCandidatePortalStatusMutation>;
export type ToggleCandidatePortalStatusMutationResult = Apollo.MutationResult<ToggleCandidatePortalStatusMutation>;
export type ToggleCandidatePortalStatusMutationOptions = Apollo.BaseMutationOptions<ToggleCandidatePortalStatusMutation, ToggleCandidatePortalStatusMutationVariables>;
export const CandidateUpdateCoiDocument = gql`
    mutation CandidateUpdateCOI($input: CandidateUpdateInput!) {
  candidateUpdate(input: $input) {
    candidate {
      id
      ...ConflictInterestSection_candidate
    }
  }
}
    ${ConflictInterestSection_CandidateFragmentDoc}`;
export type CandidateUpdateCoiMutationFn = Apollo.MutationFunction<CandidateUpdateCoiMutation, CandidateUpdateCoiMutationVariables>;

/**
 * __useCandidateUpdateCoiMutation__
 *
 * To run a mutation, you first call `useCandidateUpdateCoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateUpdateCoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateUpdateCoiMutation, { data, loading, error }] = useCandidateUpdateCoiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateUpdateCoiMutation(baseOptions?: Apollo.MutationHookOptions<CandidateUpdateCoiMutation, CandidateUpdateCoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateUpdateCoiMutation, CandidateUpdateCoiMutationVariables>(CandidateUpdateCoiDocument, options);
      }
export type CandidateUpdateCoiMutationHookResult = ReturnType<typeof useCandidateUpdateCoiMutation>;
export type CandidateUpdateCoiMutationResult = Apollo.MutationResult<CandidateUpdateCoiMutation>;
export type CandidateUpdateCoiMutationOptions = Apollo.BaseMutationOptions<CandidateUpdateCoiMutation, CandidateUpdateCoiMutationVariables>;
export const ApplicationNoteUpdateMutationDocument = gql`
    mutation applicationNoteUpdateMutation($input: ApplicationUpdateInput!) {
  applicationUpdate(input: $input) {
    id
    internalNote
  }
}
    `;
export type ApplicationNoteUpdateMutationMutationFn = Apollo.MutationFunction<ApplicationNoteUpdateMutationMutation, ApplicationNoteUpdateMutationMutationVariables>;

/**
 * __useApplicationNoteUpdateMutationMutation__
 *
 * To run a mutation, you first call `useApplicationNoteUpdateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationNoteUpdateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationNoteUpdateMutationMutation, { data, loading, error }] = useApplicationNoteUpdateMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationNoteUpdateMutationMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationNoteUpdateMutationMutation, ApplicationNoteUpdateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationNoteUpdateMutationMutation, ApplicationNoteUpdateMutationMutationVariables>(ApplicationNoteUpdateMutationDocument, options);
      }
export type ApplicationNoteUpdateMutationMutationHookResult = ReturnType<typeof useApplicationNoteUpdateMutationMutation>;
export type ApplicationNoteUpdateMutationMutationResult = Apollo.MutationResult<ApplicationNoteUpdateMutationMutation>;
export type ApplicationNoteUpdateMutationMutationOptions = Apollo.BaseMutationOptions<ApplicationNoteUpdateMutationMutation, ApplicationNoteUpdateMutationMutationVariables>;
export const InternalNoteUpdateDocument = gql`
    mutation InternalNoteUpdate($input: ApplicationUpdateInput!) {
  applicationUpdate(input: $input) {
    id
    internalNote
  }
}
    `;
export type InternalNoteUpdateMutationFn = Apollo.MutationFunction<InternalNoteUpdateMutation, InternalNoteUpdateMutationVariables>;

/**
 * __useInternalNoteUpdateMutation__
 *
 * To run a mutation, you first call `useInternalNoteUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalNoteUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalNoteUpdateMutation, { data, loading, error }] = useInternalNoteUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalNoteUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InternalNoteUpdateMutation, InternalNoteUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InternalNoteUpdateMutation, InternalNoteUpdateMutationVariables>(InternalNoteUpdateDocument, options);
      }
export type InternalNoteUpdateMutationHookResult = ReturnType<typeof useInternalNoteUpdateMutation>;
export type InternalNoteUpdateMutationResult = Apollo.MutationResult<InternalNoteUpdateMutation>;
export type InternalNoteUpdateMutationOptions = Apollo.BaseMutationOptions<InternalNoteUpdateMutation, InternalNoteUpdateMutationVariables>;
export const ApplicationTaskViewApplicationsDocument = gql`
    query ApplicationTaskViewApplications($id: uuid!) {
  candidateV2(input: {id: $id}) {
    __typename
    ... on Candidate {
      id
      applications {
        id
      }
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    `;

/**
 * __useApplicationTaskViewApplicationsQuery__
 *
 * To run a query within a React component, call `useApplicationTaskViewApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationTaskViewApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationTaskViewApplicationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationTaskViewApplicationsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables> & ({ variables: ApplicationTaskViewApplicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>(ApplicationTaskViewApplicationsDocument, options);
      }
export function useApplicationTaskViewApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>(ApplicationTaskViewApplicationsDocument, options);
        }
// @ts-ignore
export function useApplicationTaskViewApplicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>;
export function useApplicationTaskViewApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationTaskViewApplicationsQuery | undefined, ApplicationTaskViewApplicationsQueryVariables>;
export function useApplicationTaskViewApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>(ApplicationTaskViewApplicationsDocument, options);
        }
export type ApplicationTaskViewApplicationsQueryHookResult = ReturnType<typeof useApplicationTaskViewApplicationsQuery>;
export type ApplicationTaskViewApplicationsLazyQueryHookResult = ReturnType<typeof useApplicationTaskViewApplicationsLazyQuery>;
export type ApplicationTaskViewApplicationsSuspenseQueryHookResult = ReturnType<typeof useApplicationTaskViewApplicationsSuspenseQuery>;
export type ApplicationTaskViewApplicationsQueryResult = Apollo.QueryResult<ApplicationTaskViewApplicationsQuery, ApplicationTaskViewApplicationsQueryVariables>;
export const ApplicationAnonymizeCandidateDocument = gql`
    mutation ApplicationAnonymizeCandidate($input: CandidateAnonymizeInput!) {
  candidateAnonymize(input: $input) {
    result
  }
}
    `;
export type ApplicationAnonymizeCandidateMutationFn = Apollo.MutationFunction<ApplicationAnonymizeCandidateMutation, ApplicationAnonymizeCandidateMutationVariables>;

/**
 * __useApplicationAnonymizeCandidateMutation__
 *
 * To run a mutation, you first call `useApplicationAnonymizeCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationAnonymizeCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationAnonymizeCandidateMutation, { data, loading, error }] = useApplicationAnonymizeCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationAnonymizeCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationAnonymizeCandidateMutation, ApplicationAnonymizeCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationAnonymizeCandidateMutation, ApplicationAnonymizeCandidateMutationVariables>(ApplicationAnonymizeCandidateDocument, options);
      }
export type ApplicationAnonymizeCandidateMutationHookResult = ReturnType<typeof useApplicationAnonymizeCandidateMutation>;
export type ApplicationAnonymizeCandidateMutationResult = Apollo.MutationResult<ApplicationAnonymizeCandidateMutation>;
export type ApplicationAnonymizeCandidateMutationOptions = Apollo.BaseMutationOptions<ApplicationAnonymizeCandidateMutation, ApplicationAnonymizeCandidateMutationVariables>;
export const ApplicationDeAnonymizeCandidateDocument = gql`
    mutation ApplicationDeAnonymizeCandidate($input: CandidateDeAnonymizeInput!) {
  candidateDeAnonymize(input: $input) {
    result
  }
}
    `;
export type ApplicationDeAnonymizeCandidateMutationFn = Apollo.MutationFunction<ApplicationDeAnonymizeCandidateMutation, ApplicationDeAnonymizeCandidateMutationVariables>;

/**
 * __useApplicationDeAnonymizeCandidateMutation__
 *
 * To run a mutation, you first call `useApplicationDeAnonymizeCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationDeAnonymizeCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationDeAnonymizeCandidateMutation, { data, loading, error }] = useApplicationDeAnonymizeCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationDeAnonymizeCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationDeAnonymizeCandidateMutation, ApplicationDeAnonymizeCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationDeAnonymizeCandidateMutation, ApplicationDeAnonymizeCandidateMutationVariables>(ApplicationDeAnonymizeCandidateDocument, options);
      }
export type ApplicationDeAnonymizeCandidateMutationHookResult = ReturnType<typeof useApplicationDeAnonymizeCandidateMutation>;
export type ApplicationDeAnonymizeCandidateMutationResult = Apollo.MutationResult<ApplicationDeAnonymizeCandidateMutation>;
export type ApplicationDeAnonymizeCandidateMutationOptions = Apollo.BaseMutationOptions<ApplicationDeAnonymizeCandidateMutation, ApplicationDeAnonymizeCandidateMutationVariables>;
export const ApplicationDetailsTaskViewDocument = gql`
    query ApplicationDetailsTaskView($applicationId: uuid!) {
  applicationV2(input: {id: $applicationId}) {
    __typename
    ... on Application {
      id
      ...ApplicationContent_application
      ...CandidateSecondaryContent_application
      candidate {
        email
        anonymizedAt
        ...CandidateSecondaryContent_candidate
        ...Candidate_candidate
        applications {
          ...CandidateSecondaryContent_applications
        }
      }
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    ${ApplicationContent_ApplicationFragmentDoc}
${CandidateSecondaryContent_ApplicationFragmentDoc}
${CandidateSecondaryContent_CandidateFragmentDoc}
${Candidate_CandidateFragmentDoc}
${CandidateSecondaryContent_ApplicationsFragmentDoc}`;

/**
 * __useApplicationDetailsTaskViewQuery__
 *
 * To run a query within a React component, call `useApplicationDetailsTaskViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationDetailsTaskViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationDetailsTaskViewQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationDetailsTaskViewQuery(baseOptions: Apollo.QueryHookOptions<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables> & ({ variables: ApplicationDetailsTaskViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>(ApplicationDetailsTaskViewDocument, options);
      }
export function useApplicationDetailsTaskViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>(ApplicationDetailsTaskViewDocument, options);
        }
// @ts-ignore
export function useApplicationDetailsTaskViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>;
export function useApplicationDetailsTaskViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationDetailsTaskViewQuery | undefined, ApplicationDetailsTaskViewQueryVariables>;
export function useApplicationDetailsTaskViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>(ApplicationDetailsTaskViewDocument, options);
        }
export type ApplicationDetailsTaskViewQueryHookResult = ReturnType<typeof useApplicationDetailsTaskViewQuery>;
export type ApplicationDetailsTaskViewLazyQueryHookResult = ReturnType<typeof useApplicationDetailsTaskViewLazyQuery>;
export type ApplicationDetailsTaskViewSuspenseQueryHookResult = ReturnType<typeof useApplicationDetailsTaskViewSuspenseQuery>;
export type ApplicationDetailsTaskViewQueryResult = Apollo.QueryResult<ApplicationDetailsTaskViewQuery, ApplicationDetailsTaskViewQueryVariables>;
export const CandidateAvailabilityOptionsModalDocument = gql`
    query CandidateAvailabilityOptionsModal($applicationId: uuid!) {
  application(id: $applicationId) {
    id
    ...CreateTaskDialogPage_application
  }
  thisEmployee {
    id
    ...Employee
  }
}
    ${CreateTaskDialogPage_ApplicationFragmentDoc}
${EmployeeFragmentDoc}`;

/**
 * __useCandidateAvailabilityOptionsModalQuery__
 *
 * To run a query within a React component, call `useCandidateAvailabilityOptionsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateAvailabilityOptionsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateAvailabilityOptionsModalQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useCandidateAvailabilityOptionsModalQuery(baseOptions: Apollo.QueryHookOptions<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables> & ({ variables: CandidateAvailabilityOptionsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>(CandidateAvailabilityOptionsModalDocument, options);
      }
export function useCandidateAvailabilityOptionsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>(CandidateAvailabilityOptionsModalDocument, options);
        }
// @ts-ignore
export function useCandidateAvailabilityOptionsModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>;
export function useCandidateAvailabilityOptionsModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityOptionsModalQuery | undefined, CandidateAvailabilityOptionsModalQueryVariables>;
export function useCandidateAvailabilityOptionsModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>(CandidateAvailabilityOptionsModalDocument, options);
        }
export type CandidateAvailabilityOptionsModalQueryHookResult = ReturnType<typeof useCandidateAvailabilityOptionsModalQuery>;
export type CandidateAvailabilityOptionsModalLazyQueryHookResult = ReturnType<typeof useCandidateAvailabilityOptionsModalLazyQuery>;
export type CandidateAvailabilityOptionsModalSuspenseQueryHookResult = ReturnType<typeof useCandidateAvailabilityOptionsModalSuspenseQuery>;
export type CandidateAvailabilityOptionsModalQueryResult = Apollo.QueryResult<CandidateAvailabilityOptionsModalQuery, CandidateAvailabilityOptionsModalQueryVariables>;
export const CandidateAvailabilityOptionsInterviewPlanDocument = gql`
    query CandidateAvailabilityOptionsInterviewPlan($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    ...CreateTaskDialogPage_interviewPlan
    ...cloneInterviewPlan_interviewPlan
    ...getSaveInterviewPlanInput_interviewPlan
    ...CandidateAvailabilityOption_interviewPlan
  }
}
    ${CreateTaskDialogPage_InterviewPlanFragmentDoc}
${CloneInterviewPlan_InterviewPlanFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}
${CandidateAvailabilityOption_InterviewPlanFragmentDoc}`;

/**
 * __useCandidateAvailabilityOptionsInterviewPlanQuery__
 *
 * To run a query within a React component, call `useCandidateAvailabilityOptionsInterviewPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateAvailabilityOptionsInterviewPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateAvailabilityOptionsInterviewPlanQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useCandidateAvailabilityOptionsInterviewPlanQuery(baseOptions: Apollo.QueryHookOptions<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables> & ({ variables: CandidateAvailabilityOptionsInterviewPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>(CandidateAvailabilityOptionsInterviewPlanDocument, options);
      }
export function useCandidateAvailabilityOptionsInterviewPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>(CandidateAvailabilityOptionsInterviewPlanDocument, options);
        }
// @ts-ignore
export function useCandidateAvailabilityOptionsInterviewPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>;
export function useCandidateAvailabilityOptionsInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityOptionsInterviewPlanQuery | undefined, CandidateAvailabilityOptionsInterviewPlanQueryVariables>;
export function useCandidateAvailabilityOptionsInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>(CandidateAvailabilityOptionsInterviewPlanDocument, options);
        }
export type CandidateAvailabilityOptionsInterviewPlanQueryHookResult = ReturnType<typeof useCandidateAvailabilityOptionsInterviewPlanQuery>;
export type CandidateAvailabilityOptionsInterviewPlanLazyQueryHookResult = ReturnType<typeof useCandidateAvailabilityOptionsInterviewPlanLazyQuery>;
export type CandidateAvailabilityOptionsInterviewPlanSuspenseQueryHookResult = ReturnType<typeof useCandidateAvailabilityOptionsInterviewPlanSuspenseQuery>;
export type CandidateAvailabilityOptionsInterviewPlanQueryResult = Apollo.QueryResult<CandidateAvailabilityOptionsInterviewPlanQuery, CandidateAvailabilityOptionsInterviewPlanQueryVariables>;
export const TaskInterviewPlanDocument = gql`
    query TaskInterviewPlan($id: uuid!) {
  task(id: $id) {
    interviewPlan {
      id
    }
  }
}
    `;

/**
 * __useTaskInterviewPlanQuery__
 *
 * To run a query within a React component, call `useTaskInterviewPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskInterviewPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskInterviewPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskInterviewPlanQuery(baseOptions: Apollo.QueryHookOptions<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables> & ({ variables: TaskInterviewPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>(TaskInterviewPlanDocument, options);
      }
export function useTaskInterviewPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>(TaskInterviewPlanDocument, options);
        }
// @ts-ignore
export function useTaskInterviewPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>;
export function useTaskInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<TaskInterviewPlanQuery | undefined, TaskInterviewPlanQueryVariables>;
export function useTaskInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>(TaskInterviewPlanDocument, options);
        }
export type TaskInterviewPlanQueryHookResult = ReturnType<typeof useTaskInterviewPlanQuery>;
export type TaskInterviewPlanLazyQueryHookResult = ReturnType<typeof useTaskInterviewPlanLazyQuery>;
export type TaskInterviewPlanSuspenseQueryHookResult = ReturnType<typeof useTaskInterviewPlanSuspenseQuery>;
export type TaskInterviewPlanQueryResult = Apollo.QueryResult<TaskInterviewPlanQuery, TaskInterviewPlanQueryVariables>;
export const CandidateAvailabilityOptionsDeleteDocument = gql`
    mutation CandidateAvailabilityOptionsDelete($id: uuid!) {
  candidateAvailabilityOptionsDelete(id: $id) {
    result
  }
}
    `;
export type CandidateAvailabilityOptionsDeleteMutationFn = Apollo.MutationFunction<CandidateAvailabilityOptionsDeleteMutation, CandidateAvailabilityOptionsDeleteMutationVariables>;

/**
 * __useCandidateAvailabilityOptionsDeleteMutation__
 *
 * To run a mutation, you first call `useCandidateAvailabilityOptionsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateAvailabilityOptionsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateAvailabilityOptionsDeleteMutation, { data, loading, error }] = useCandidateAvailabilityOptionsDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateAvailabilityOptionsDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CandidateAvailabilityOptionsDeleteMutation, CandidateAvailabilityOptionsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateAvailabilityOptionsDeleteMutation, CandidateAvailabilityOptionsDeleteMutationVariables>(CandidateAvailabilityOptionsDeleteDocument, options);
      }
export type CandidateAvailabilityOptionsDeleteMutationHookResult = ReturnType<typeof useCandidateAvailabilityOptionsDeleteMutation>;
export type CandidateAvailabilityOptionsDeleteMutationResult = Apollo.MutationResult<CandidateAvailabilityOptionsDeleteMutation>;
export type CandidateAvailabilityOptionsDeleteMutationOptions = Apollo.BaseMutationOptions<CandidateAvailabilityOptionsDeleteMutation, CandidateAvailabilityOptionsDeleteMutationVariables>;
export const CandidateAvailabilityTaskCreateDocument = gql`
    mutation CandidateAvailabilityTaskCreate($input: TaskCreateInput!) {
  taskCreate(input: $input) {
    task {
      id
    }
  }
}
    `;
export type CandidateAvailabilityTaskCreateMutationFn = Apollo.MutationFunction<CandidateAvailabilityTaskCreateMutation, CandidateAvailabilityTaskCreateMutationVariables>;

/**
 * __useCandidateAvailabilityTaskCreateMutation__
 *
 * To run a mutation, you first call `useCandidateAvailabilityTaskCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateAvailabilityTaskCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateAvailabilityTaskCreateMutation, { data, loading, error }] = useCandidateAvailabilityTaskCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateAvailabilityTaskCreateMutation(baseOptions?: Apollo.MutationHookOptions<CandidateAvailabilityTaskCreateMutation, CandidateAvailabilityTaskCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateAvailabilityTaskCreateMutation, CandidateAvailabilityTaskCreateMutationVariables>(CandidateAvailabilityTaskCreateDocument, options);
      }
export type CandidateAvailabilityTaskCreateMutationHookResult = ReturnType<typeof useCandidateAvailabilityTaskCreateMutation>;
export type CandidateAvailabilityTaskCreateMutationResult = Apollo.MutationResult<CandidateAvailabilityTaskCreateMutation>;
export type CandidateAvailabilityTaskCreateMutationOptions = Apollo.BaseMutationOptions<CandidateAvailabilityTaskCreateMutation, CandidateAvailabilityTaskCreateMutationVariables>;
export const CandidateAvailabilityRequestUpsertDocument = gql`
    mutation CandidateAvailabilityRequestUpsert($input: CandidateAvailabilityOptionsUpsertInput!) {
  candidateAvailabilityOptionsUpsert(input: $input) {
    options {
      id
    }
  }
}
    `;
export type CandidateAvailabilityRequestUpsertMutationFn = Apollo.MutationFunction<CandidateAvailabilityRequestUpsertMutation, CandidateAvailabilityRequestUpsertMutationVariables>;

/**
 * __useCandidateAvailabilityRequestUpsertMutation__
 *
 * To run a mutation, you first call `useCandidateAvailabilityRequestUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateAvailabilityRequestUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateAvailabilityRequestUpsertMutation, { data, loading, error }] = useCandidateAvailabilityRequestUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateAvailabilityRequestUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CandidateAvailabilityRequestUpsertMutation, CandidateAvailabilityRequestUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateAvailabilityRequestUpsertMutation, CandidateAvailabilityRequestUpsertMutationVariables>(CandidateAvailabilityRequestUpsertDocument, options);
      }
export type CandidateAvailabilityRequestUpsertMutationHookResult = ReturnType<typeof useCandidateAvailabilityRequestUpsertMutation>;
export type CandidateAvailabilityRequestUpsertMutationResult = Apollo.MutationResult<CandidateAvailabilityRequestUpsertMutation>;
export type CandidateAvailabilityRequestUpsertMutationOptions = Apollo.BaseMutationOptions<CandidateAvailabilityRequestUpsertMutation, CandidateAvailabilityRequestUpsertMutationVariables>;
export const ApplicationActionsDocument = gql`
    query ApplicationActions($applicationId: uuid!) {
  application(id: $applicationId) {
    id
    status
    upcomingApplicationStage {
      minStartAt
    }
    jobStageId
    applicationStages {
      id
    }
  }
}
    `;

/**
 * __useApplicationActionsQuery__
 *
 * To run a query within a React component, call `useApplicationActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationActionsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationActionsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationActionsQuery, ApplicationActionsQueryVariables> & ({ variables: ApplicationActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationActionsQuery, ApplicationActionsQueryVariables>(ApplicationActionsDocument, options);
      }
export function useApplicationActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationActionsQuery, ApplicationActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationActionsQuery, ApplicationActionsQueryVariables>(ApplicationActionsDocument, options);
        }
// @ts-ignore
export function useApplicationActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationActionsQuery, ApplicationActionsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationActionsQuery, ApplicationActionsQueryVariables>;
export function useApplicationActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationActionsQuery, ApplicationActionsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationActionsQuery | undefined, ApplicationActionsQueryVariables>;
export function useApplicationActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationActionsQuery, ApplicationActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationActionsQuery, ApplicationActionsQueryVariables>(ApplicationActionsDocument, options);
        }
export type ApplicationActionsQueryHookResult = ReturnType<typeof useApplicationActionsQuery>;
export type ApplicationActionsLazyQueryHookResult = ReturnType<typeof useApplicationActionsLazyQuery>;
export type ApplicationActionsSuspenseQueryHookResult = ReturnType<typeof useApplicationActionsSuspenseQuery>;
export type ApplicationActionsQueryResult = Apollo.QueryResult<ApplicationActionsQuery, ApplicationActionsQueryVariables>;
export const ApplicationStageStatusDocument = gql`
    query ApplicationStageStatus($applicationId: uuid!) {
  application(id: $applicationId) {
    id
    upcomingApplicationStage {
      minStartAt
    }
    applicationStages {
      ...CancelScheduleApplicationStage
      minStartAt
      maxEndAt
      isCancelled
      hasInterviewerDeclined
      hasInterviewerTentative
      hasCandidateDeclined
      hasCandidateTentative
    }
  }
}
    ${CancelScheduleApplicationStageFragmentDoc}`;

/**
 * __useApplicationStageStatusQuery__
 *
 * To run a query within a React component, call `useApplicationStageStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStageStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStageStatusQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationStageStatusQuery(baseOptions: Apollo.QueryHookOptions<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables> & ({ variables: ApplicationStageStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>(ApplicationStageStatusDocument, options);
      }
export function useApplicationStageStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>(ApplicationStageStatusDocument, options);
        }
// @ts-ignore
export function useApplicationStageStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>;
export function useApplicationStageStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageStatusQuery | undefined, ApplicationStageStatusQueryVariables>;
export function useApplicationStageStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>(ApplicationStageStatusDocument, options);
        }
export type ApplicationStageStatusQueryHookResult = ReturnType<typeof useApplicationStageStatusQuery>;
export type ApplicationStageStatusLazyQueryHookResult = ReturnType<typeof useApplicationStageStatusLazyQuery>;
export type ApplicationStageStatusSuspenseQueryHookResult = ReturnType<typeof useApplicationStageStatusSuspenseQuery>;
export type ApplicationStageStatusQueryResult = Apollo.QueryResult<ApplicationStageStatusQuery, ApplicationStageStatusQueryVariables>;
export const ApplicationStageActionsDocument = gql`
    query ApplicationStageActions($applicationStageId: uuid!) {
  applicationStage(id: $applicationStageId) {
    id
    isCancelled
    minStartAt
    maxEndAt
    hasInterviewerDeclined
    hasCandidateDeclined
    applicationId
    applicationStageInterviews {
      id
      startAt
      endAt
    }
    task {
      id
      debriefs {
        id
      }
    }
  }
}
    `;

/**
 * __useApplicationStageActionsQuery__
 *
 * To run a query within a React component, call `useApplicationStageActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStageActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStageActionsQuery({
 *   variables: {
 *      applicationStageId: // value for 'applicationStageId'
 *   },
 * });
 */
export function useApplicationStageActionsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables> & ({ variables: ApplicationStageActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>(ApplicationStageActionsDocument, options);
      }
export function useApplicationStageActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>(ApplicationStageActionsDocument, options);
        }
// @ts-ignore
export function useApplicationStageActionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>;
export function useApplicationStageActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageActionsQuery | undefined, ApplicationStageActionsQueryVariables>;
export function useApplicationStageActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>(ApplicationStageActionsDocument, options);
        }
export type ApplicationStageActionsQueryHookResult = ReturnType<typeof useApplicationStageActionsQuery>;
export type ApplicationStageActionsLazyQueryHookResult = ReturnType<typeof useApplicationStageActionsLazyQuery>;
export type ApplicationStageActionsSuspenseQueryHookResult = ReturnType<typeof useApplicationStageActionsSuspenseQuery>;
export type ApplicationStageActionsQueryResult = Apollo.QueryResult<ApplicationStageActionsQuery, ApplicationStageActionsQueryVariables>;
export const CandidateApplicationStagesDocument = gql`
    query CandidateApplicationStages($input: uuid!) {
  candidate(id: $input) {
    id
    fullName
    applications {
      ...CandidateApplicationStages
    }
  }
}
    ${CandidateApplicationStagesFragmentDoc}`;

/**
 * __useCandidateApplicationStagesQuery__
 *
 * To run a query within a React component, call `useCandidateApplicationStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateApplicationStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateApplicationStagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateApplicationStagesQuery(baseOptions: Apollo.QueryHookOptions<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables> & ({ variables: CandidateApplicationStagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>(CandidateApplicationStagesDocument, options);
      }
export function useCandidateApplicationStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>(CandidateApplicationStagesDocument, options);
        }
// @ts-ignore
export function useCandidateApplicationStagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>;
export function useCandidateApplicationStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateApplicationStagesQuery | undefined, CandidateApplicationStagesQueryVariables>;
export function useCandidateApplicationStagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>(CandidateApplicationStagesDocument, options);
        }
export type CandidateApplicationStagesQueryHookResult = ReturnType<typeof useCandidateApplicationStagesQuery>;
export type CandidateApplicationStagesLazyQueryHookResult = ReturnType<typeof useCandidateApplicationStagesLazyQuery>;
export type CandidateApplicationStagesSuspenseQueryHookResult = ReturnType<typeof useCandidateApplicationStagesSuspenseQuery>;
export type CandidateApplicationStagesQueryResult = Apollo.QueryResult<CandidateApplicationStagesQuery, CandidateApplicationStagesQueryVariables>;
export const CandidateApplicationIdsDocument = gql`
    query CandidateApplicationIds($id: uuid!) {
  candidateV2(input: {id: $id}) {
    __typename
    ... on Candidate {
      id
      applications {
        id
      }
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    `;

/**
 * __useCandidateApplicationIdsQuery__
 *
 * To run a query within a React component, call `useCandidateApplicationIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateApplicationIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateApplicationIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateApplicationIdsQuery(baseOptions: Apollo.QueryHookOptions<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables> & ({ variables: CandidateApplicationIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>(CandidateApplicationIdsDocument, options);
      }
export function useCandidateApplicationIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>(CandidateApplicationIdsDocument, options);
        }
// @ts-ignore
export function useCandidateApplicationIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>;
export function useCandidateApplicationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateApplicationIdsQuery | undefined, CandidateApplicationIdsQueryVariables>;
export function useCandidateApplicationIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>(CandidateApplicationIdsDocument, options);
        }
export type CandidateApplicationIdsQueryHookResult = ReturnType<typeof useCandidateApplicationIdsQuery>;
export type CandidateApplicationIdsLazyQueryHookResult = ReturnType<typeof useCandidateApplicationIdsLazyQuery>;
export type CandidateApplicationIdsSuspenseQueryHookResult = ReturnType<typeof useCandidateApplicationIdsSuspenseQuery>;
export type CandidateApplicationIdsQueryResult = Apollo.QueryResult<CandidateApplicationIdsQuery, CandidateApplicationIdsQueryVariables>;
export const CandidateDetailsDocument = gql`
    query CandidateDetails($id: uuid!) {
  candidate(id: $id) {
    id
    fullName
    lastActivityAt
    email
    familyName
    givenName
    atsId
    atsType
    atsCandidate {
      atsId
      atsUrl
      atsFields {
        ... on LeverCandidate {
          __typename
          origin
        }
      }
    }
    linkedinUrl
    phoneNumbers
    pronoun
    timezone
    updatedAt
    additionalEmails
    applications {
      id
      existingConversations(input: {isCancelled: false}) {
        id
        remoteId
        remoteName
        isArchived
      }
      job {
        id
        name
        atsId
        atsType
        location
        jobStagesAggregate
        sourcers {
          id
          fullName
          internalProfilePictureUrl
        }
        hiringManagers {
          id
          fullName
          internalProfilePictureUrl
        }
      }
      jobStage {
        id
        name
        jobId
        schedulable
        atsId
        index
      }
      applicationStages(input: {orderBy: {createdAt: DESC}, isCancelled: false}) {
        id
        startAt
        endAt
        createdAt
        updatedAt
        name
        timezone
        selfScheduleOptionsId
        jobStageId
        creator {
          id
          fullName
        }
        jobStage {
          id
          name
          index
        }
        isHoldForRsvp
        isReadyForCandidateComms
        hasCandidateTentative
        hasInterviewerTentative
        isCancelled
        hasCandidateDeclined
        hasInterviewerDeclined
        applicationStageCandidateEvents(input: {orderBy: {createdAt: DESC}}) {
          id
          startAt
          endAt
          responseStatus
          googleEventUrl
          isCancelled
          name
          googleEventId
          googleCalendarId
        }
        applicationStageInterviews(input: {orderBy: {startAt: ASC}, isCancelled: false}) {
          id
          startAt
          endAt
          name
          calendarEventTitle
          isCancelled
          googleEventId
          googleEventUrl
          googleCalendarId
          applicationStageInterviewInterviewers {
            role
            isOptional
            interviewerId
            responseStatus
            applicationStageInterviewId
            interviewer {
              id
              internalProfilePictureUrl
              fullName
            }
          }
          applicationStageInterviewRooms {
            applicationStageInterviewId
            meetingRoomId
            responseStatus
            meetingRoom {
              id
              name
            }
          }
        }
        selfScheduleOptionsId
      }
      applicationDebriefs(input: {orderBy: {createdAt: DESC}, isCancelled: false}) {
        id
        startAt
        endAt
        isCancelled
        isPrivateCalendarEvent
        attendees {
          interviewerId
          responseStatus
          interviewer {
            id
            fullName
            email
            internalProfilePictureUrl
          }
          isOptional
        }
        meetingRooms {
          applicationDebriefId
          meetingRoomId
          responseStatus
        }
      }
      status
      state {
        isSchedulable
        isNotScheduleable
        isUnscheduled
        isAvailabilityRequested
        isReadyToSchedule
        isCanceled
        isOngoing
        isScheduled
        isCompleted
        isScheduledInAts
        isCompletedInAts
        isCandidateDeclined
        isInterviewerDeclined
        isSelfScheduleRequested
        isHoldForRsvp
        isReadyForCandidateComms
      }
      upcomingApplicationStage {
        id
        startAt
        endAt
        selfScheduleOptionsId
        minStartAt
        applicationStageInterviews(input: {orderBy: {startAt: ASC}, isCancelled: false}) {
          id
          startAt
          endAt
        }
      }
      ...ApplicationNote_application
    }
  }
}
    ${ApplicationNote_ApplicationFragmentDoc}`;

/**
 * __useCandidateDetailsQuery__
 *
 * To run a query within a React component, call `useCandidateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidateDetailsQuery(baseOptions: Apollo.QueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables> & ({ variables: CandidateDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateDetailsQuery, CandidateDetailsQueryVariables>(CandidateDetailsDocument, options);
      }
export function useCandidateDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateDetailsQuery, CandidateDetailsQueryVariables>(CandidateDetailsDocument, options);
        }
// @ts-ignore
export function useCandidateDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateDetailsQuery, CandidateDetailsQueryVariables>;
export function useCandidateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateDetailsQuery | undefined, CandidateDetailsQueryVariables>;
export function useCandidateDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateDetailsQuery, CandidateDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateDetailsQuery, CandidateDetailsQueryVariables>(CandidateDetailsDocument, options);
        }
export type CandidateDetailsQueryHookResult = ReturnType<typeof useCandidateDetailsQuery>;
export type CandidateDetailsLazyQueryHookResult = ReturnType<typeof useCandidateDetailsLazyQuery>;
export type CandidateDetailsSuspenseQueryHookResult = ReturnType<typeof useCandidateDetailsSuspenseQuery>;
export type CandidateDetailsQueryResult = Apollo.QueryResult<CandidateDetailsQuery, CandidateDetailsQueryVariables>;
export const JobStageDetailsDocument = gql`
    query JobStageDetails($input: JobStagesInput!) {
  jobStages(input: $input) {
    items {
      ...JobStageFragment
    }
  }
}
    ${JobStageFragmentFragmentDoc}`;

/**
 * __useJobStageDetailsQuery__
 *
 * To run a query within a React component, call `useJobStageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobStageDetailsQuery(baseOptions: Apollo.QueryHookOptions<JobStageDetailsQuery, JobStageDetailsQueryVariables> & ({ variables: JobStageDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageDetailsQuery, JobStageDetailsQueryVariables>(JobStageDetailsDocument, options);
      }
export function useJobStageDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageDetailsQuery, JobStageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageDetailsQuery, JobStageDetailsQueryVariables>(JobStageDetailsDocument, options);
        }
// @ts-ignore
export function useJobStageDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageDetailsQuery, JobStageDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageDetailsQuery, JobStageDetailsQueryVariables>;
export function useJobStageDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageDetailsQuery, JobStageDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageDetailsQuery | undefined, JobStageDetailsQueryVariables>;
export function useJobStageDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageDetailsQuery, JobStageDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageDetailsQuery, JobStageDetailsQueryVariables>(JobStageDetailsDocument, options);
        }
export type JobStageDetailsQueryHookResult = ReturnType<typeof useJobStageDetailsQuery>;
export type JobStageDetailsLazyQueryHookResult = ReturnType<typeof useJobStageDetailsLazyQuery>;
export type JobStageDetailsSuspenseQueryHookResult = ReturnType<typeof useJobStageDetailsSuspenseQuery>;
export type JobStageDetailsQueryResult = Apollo.QueryResult<JobStageDetailsQuery, JobStageDetailsQueryVariables>;
export const JobStageUpdatedAtDocument = gql`
    query JobStageUpdatedAt($id: uuid!) {
  jobStage(id: $id) {
    id
    updatedAt
  }
}
    `;

/**
 * __useJobStageUpdatedAtQuery__
 *
 * To run a query within a React component, call `useJobStageUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageUpdatedAtQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobStageUpdatedAtQuery(baseOptions: Apollo.QueryHookOptions<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables> & ({ variables: JobStageUpdatedAtQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>(JobStageUpdatedAtDocument, options);
      }
export function useJobStageUpdatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>(JobStageUpdatedAtDocument, options);
        }
// @ts-ignore
export function useJobStageUpdatedAtSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>;
export function useJobStageUpdatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageUpdatedAtQuery | undefined, JobStageUpdatedAtQueryVariables>;
export function useJobStageUpdatedAtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>(JobStageUpdatedAtDocument, options);
        }
export type JobStageUpdatedAtQueryHookResult = ReturnType<typeof useJobStageUpdatedAtQuery>;
export type JobStageUpdatedAtLazyQueryHookResult = ReturnType<typeof useJobStageUpdatedAtLazyQuery>;
export type JobStageUpdatedAtSuspenseQueryHookResult = ReturnType<typeof useJobStageUpdatedAtSuspenseQuery>;
export type JobStageUpdatedAtQueryResult = Apollo.QueryResult<JobStageUpdatedAtQuery, JobStageUpdatedAtQueryVariables>;
export const ConfidentialJobByJobStageDocument = gql`
    query ConfidentialJobByJobStage($id: uuid!) {
  jobStage(id: $id) {
    job {
      isConfidential
      id
    }
  }
}
    `;

/**
 * __useConfidentialJobByJobStageQuery__
 *
 * To run a query within a React component, call `useConfidentialJobByJobStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfidentialJobByJobStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfidentialJobByJobStageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfidentialJobByJobStageQuery(baseOptions: Apollo.QueryHookOptions<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables> & ({ variables: ConfidentialJobByJobStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>(ConfidentialJobByJobStageDocument, options);
      }
export function useConfidentialJobByJobStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>(ConfidentialJobByJobStageDocument, options);
        }
// @ts-ignore
export function useConfidentialJobByJobStageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>): Apollo.UseSuspenseQueryResult<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>;
export function useConfidentialJobByJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>): Apollo.UseSuspenseQueryResult<ConfidentialJobByJobStageQuery | undefined, ConfidentialJobByJobStageQueryVariables>;
export function useConfidentialJobByJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>(ConfidentialJobByJobStageDocument, options);
        }
export type ConfidentialJobByJobStageQueryHookResult = ReturnType<typeof useConfidentialJobByJobStageQuery>;
export type ConfidentialJobByJobStageLazyQueryHookResult = ReturnType<typeof useConfidentialJobByJobStageLazyQuery>;
export type ConfidentialJobByJobStageSuspenseQueryHookResult = ReturnType<typeof useConfidentialJobByJobStageSuspenseQuery>;
export type ConfidentialJobByJobStageQueryResult = Apollo.QueryResult<ConfidentialJobByJobStageQuery, ConfidentialJobByJobStageQueryVariables>;
export const ConfidentialJobByApplicationDocument = gql`
    query ConfidentialJobByApplication($id: uuid!) {
  application(id: $id) {
    job {
      isConfidential
      id
    }
  }
}
    `;

/**
 * __useConfidentialJobByApplicationQuery__
 *
 * To run a query within a React component, call `useConfidentialJobByApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfidentialJobByApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfidentialJobByApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfidentialJobByApplicationQuery(baseOptions: Apollo.QueryHookOptions<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables> & ({ variables: ConfidentialJobByApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>(ConfidentialJobByApplicationDocument, options);
      }
export function useConfidentialJobByApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>(ConfidentialJobByApplicationDocument, options);
        }
// @ts-ignore
export function useConfidentialJobByApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>;
export function useConfidentialJobByApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<ConfidentialJobByApplicationQuery | undefined, ConfidentialJobByApplicationQueryVariables>;
export function useConfidentialJobByApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>(ConfidentialJobByApplicationDocument, options);
        }
export type ConfidentialJobByApplicationQueryHookResult = ReturnType<typeof useConfidentialJobByApplicationQuery>;
export type ConfidentialJobByApplicationLazyQueryHookResult = ReturnType<typeof useConfidentialJobByApplicationLazyQuery>;
export type ConfidentialJobByApplicationSuspenseQueryHookResult = ReturnType<typeof useConfidentialJobByApplicationSuspenseQuery>;
export type ConfidentialJobByApplicationQueryResult = Apollo.QueryResult<ConfidentialJobByApplicationQuery, ConfidentialJobByApplicationQueryVariables>;
export const QuickTaskBulkItemDocument = gql`
    mutation QuickTaskBulkItem($input: TaskQuickCreateInput!) {
  taskQuickCreate(input: $input) {
    taskId
  }
}
    `;
export type QuickTaskBulkItemMutationFn = Apollo.MutationFunction<QuickTaskBulkItemMutation, QuickTaskBulkItemMutationVariables>;

/**
 * __useQuickTaskBulkItemMutation__
 *
 * To run a mutation, you first call `useQuickTaskBulkItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuickTaskBulkItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quickTaskBulkItemMutation, { data, loading, error }] = useQuickTaskBulkItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuickTaskBulkItemMutation(baseOptions?: Apollo.MutationHookOptions<QuickTaskBulkItemMutation, QuickTaskBulkItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuickTaskBulkItemMutation, QuickTaskBulkItemMutationVariables>(QuickTaskBulkItemDocument, options);
      }
export type QuickTaskBulkItemMutationHookResult = ReturnType<typeof useQuickTaskBulkItemMutation>;
export type QuickTaskBulkItemMutationResult = Apollo.MutationResult<QuickTaskBulkItemMutation>;
export type QuickTaskBulkItemMutationOptions = Apollo.BaseMutationOptions<QuickTaskBulkItemMutation, QuickTaskBulkItemMutationVariables>;
export const ActionReadyCandidatesTableDocument = gql`
    query ActionReadyCandidatesTable($input: ApplicationSearchInput!) {
  applicationSearch(input: $input) {
    hasNext
    nextOffset
    items {
      id
      ...ActionReadyCandidateRow_application
      jobStage {
        id
        jobStageSettingsV2 {
          id
          defaultTask
        }
      }
    }
  }
}
    ${ActionReadyCandidateRow_ApplicationFragmentDoc}`;

/**
 * __useActionReadyCandidatesTableQuery__
 *
 * To run a query within a React component, call `useActionReadyCandidatesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionReadyCandidatesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionReadyCandidatesTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActionReadyCandidatesTableQuery(baseOptions: Apollo.QueryHookOptions<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables> & ({ variables: ActionReadyCandidatesTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>(ActionReadyCandidatesTableDocument, options);
      }
export function useActionReadyCandidatesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>(ActionReadyCandidatesTableDocument, options);
        }
// @ts-ignore
export function useActionReadyCandidatesTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>): Apollo.UseSuspenseQueryResult<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>;
export function useActionReadyCandidatesTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>): Apollo.UseSuspenseQueryResult<ActionReadyCandidatesTableQuery | undefined, ActionReadyCandidatesTableQueryVariables>;
export function useActionReadyCandidatesTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>(ActionReadyCandidatesTableDocument, options);
        }
export type ActionReadyCandidatesTableQueryHookResult = ReturnType<typeof useActionReadyCandidatesTableQuery>;
export type ActionReadyCandidatesTableLazyQueryHookResult = ReturnType<typeof useActionReadyCandidatesTableLazyQuery>;
export type ActionReadyCandidatesTableSuspenseQueryHookResult = ReturnType<typeof useActionReadyCandidatesTableSuspenseQuery>;
export type ActionReadyCandidatesTableQueryResult = Apollo.QueryResult<ActionReadyCandidatesTableQuery, ActionReadyCandidatesTableQueryVariables>;
export const CandidateListV2Document = gql`
    query CandidateListV2($input: ApplicationSearchInput!) {
  applicationSearch(input: $input) {
    hasNext
    nextOffset
    items {
      ...AllCandidateTable_application
      upcomingApplicationStage {
        id
        startAt
        endAt
        selfScheduleOptionsId
        minStartAt
        applicationStageInterviews(input: {orderBy: {startAt: ASC}, isCancelled: false}) {
          id
          startAt
          endAt
        }
      }
    }
  }
}
    ${AllCandidateTable_ApplicationFragmentDoc}`;

/**
 * __useCandidateListV2Query__
 *
 * To run a query within a React component, call `useCandidateListV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCandidateListV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateListV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateListV2Query(baseOptions: Apollo.QueryHookOptions<CandidateListV2Query, CandidateListV2QueryVariables> & ({ variables: CandidateListV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateListV2Query, CandidateListV2QueryVariables>(CandidateListV2Document, options);
      }
export function useCandidateListV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateListV2Query, CandidateListV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateListV2Query, CandidateListV2QueryVariables>(CandidateListV2Document, options);
        }
// @ts-ignore
export function useCandidateListV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateListV2Query, CandidateListV2QueryVariables>): Apollo.UseSuspenseQueryResult<CandidateListV2Query, CandidateListV2QueryVariables>;
export function useCandidateListV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateListV2Query, CandidateListV2QueryVariables>): Apollo.UseSuspenseQueryResult<CandidateListV2Query | undefined, CandidateListV2QueryVariables>;
export function useCandidateListV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateListV2Query, CandidateListV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateListV2Query, CandidateListV2QueryVariables>(CandidateListV2Document, options);
        }
export type CandidateListV2QueryHookResult = ReturnType<typeof useCandidateListV2Query>;
export type CandidateListV2LazyQueryHookResult = ReturnType<typeof useCandidateListV2LazyQuery>;
export type CandidateListV2SuspenseQueryHookResult = ReturnType<typeof useCandidateListV2SuspenseQuery>;
export type CandidateListV2QueryResult = Apollo.QueryResult<CandidateListV2Query, CandidateListV2QueryVariables>;
export const CandidateListDocument = gql`
    query CandidateList($input: ApplicationSearchInput!) {
  applicationSearch(input: $input) {
    hasNext
    nextOffset
    items {
      ...ApplicationItem_application
      upcomingApplicationStage {
        id
        startAt
        endAt
        selfScheduleOptionsId
        minStartAt
        applicationStageInterviews(input: {orderBy: {startAt: ASC}, isCancelled: false}) {
          id
          startAt
          endAt
        }
      }
    }
  }
}
    ${ApplicationItem_ApplicationFragmentDoc}`;

/**
 * __useCandidateListQuery__
 *
 * To run a query within a React component, call `useCandidateListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateListQuery(baseOptions: Apollo.QueryHookOptions<CandidateListQuery, CandidateListQueryVariables> & ({ variables: CandidateListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateListQuery, CandidateListQueryVariables>(CandidateListDocument, options);
      }
export function useCandidateListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateListQuery, CandidateListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateListQuery, CandidateListQueryVariables>(CandidateListDocument, options);
        }
// @ts-ignore
export function useCandidateListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateListQuery, CandidateListQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateListQuery, CandidateListQueryVariables>;
export function useCandidateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateListQuery, CandidateListQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateListQuery | undefined, CandidateListQueryVariables>;
export function useCandidateListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateListQuery, CandidateListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateListQuery, CandidateListQueryVariables>(CandidateListDocument, options);
        }
export type CandidateListQueryHookResult = ReturnType<typeof useCandidateListQuery>;
export type CandidateListLazyQueryHookResult = ReturnType<typeof useCandidateListLazyQuery>;
export type CandidateListSuspenseQueryHookResult = ReturnType<typeof useCandidateListSuspenseQuery>;
export type CandidateListQueryResult = Apollo.QueryResult<CandidateListQuery, CandidateListQueryVariables>;
export const UpdateCandidatePageFiltersEmployeePrefDocument = gql`
    mutation updateCandidatePageFiltersEmployeePref($input: EmployeePrefUpdateInput!) {
  employeePrefUpdate(input: $input) {
    employeePref {
      id
      jsonPref {
        ... on CandidatePageFiltersPref {
          ...CandidatePageFiltersEmployeePref
        }
      }
    }
  }
}
    ${CandidatePageFiltersEmployeePrefFragmentDoc}`;
export type UpdateCandidatePageFiltersEmployeePrefMutationFn = Apollo.MutationFunction<UpdateCandidatePageFiltersEmployeePrefMutation, UpdateCandidatePageFiltersEmployeePrefMutationVariables>;

/**
 * __useUpdateCandidatePageFiltersEmployeePrefMutation__
 *
 * To run a mutation, you first call `useUpdateCandidatePageFiltersEmployeePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidatePageFiltersEmployeePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidatePageFiltersEmployeePrefMutation, { data, loading, error }] = useUpdateCandidatePageFiltersEmployeePrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidatePageFiltersEmployeePrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidatePageFiltersEmployeePrefMutation, UpdateCandidatePageFiltersEmployeePrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidatePageFiltersEmployeePrefMutation, UpdateCandidatePageFiltersEmployeePrefMutationVariables>(UpdateCandidatePageFiltersEmployeePrefDocument, options);
      }
export type UpdateCandidatePageFiltersEmployeePrefMutationHookResult = ReturnType<typeof useUpdateCandidatePageFiltersEmployeePrefMutation>;
export type UpdateCandidatePageFiltersEmployeePrefMutationResult = Apollo.MutationResult<UpdateCandidatePageFiltersEmployeePrefMutation>;
export type UpdateCandidatePageFiltersEmployeePrefMutationOptions = Apollo.BaseMutationOptions<UpdateCandidatePageFiltersEmployeePrefMutation, UpdateCandidatePageFiltersEmployeePrefMutationVariables>;
export const CandidatePageFiltersEmployeePrefDocument = gql`
    query CandidatePageFiltersEmployeePref($prefName: String!) {
  thisEmployee {
    id
    employeePref(prefName: $prefName) {
      id
      jsonPref {
        ... on CandidatePageFiltersPref {
          ...CandidatePageFiltersEmployeePref
        }
      }
    }
  }
}
    ${CandidatePageFiltersEmployeePrefFragmentDoc}`;

/**
 * __useCandidatePageFiltersEmployeePrefQuery__
 *
 * To run a query within a React component, call `useCandidatePageFiltersEmployeePrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidatePageFiltersEmployeePrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidatePageFiltersEmployeePrefQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useCandidatePageFiltersEmployeePrefQuery(baseOptions: Apollo.QueryHookOptions<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables> & ({ variables: CandidatePageFiltersEmployeePrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>(CandidatePageFiltersEmployeePrefDocument, options);
      }
export function useCandidatePageFiltersEmployeePrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>(CandidatePageFiltersEmployeePrefDocument, options);
        }
// @ts-ignore
export function useCandidatePageFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>;
export function useCandidatePageFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<CandidatePageFiltersEmployeePrefQuery | undefined, CandidatePageFiltersEmployeePrefQueryVariables>;
export function useCandidatePageFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>(CandidatePageFiltersEmployeePrefDocument, options);
        }
export type CandidatePageFiltersEmployeePrefQueryHookResult = ReturnType<typeof useCandidatePageFiltersEmployeePrefQuery>;
export type CandidatePageFiltersEmployeePrefLazyQueryHookResult = ReturnType<typeof useCandidatePageFiltersEmployeePrefLazyQuery>;
export type CandidatePageFiltersEmployeePrefSuspenseQueryHookResult = ReturnType<typeof useCandidatePageFiltersEmployeePrefSuspenseQuery>;
export type CandidatePageFiltersEmployeePrefQueryResult = Apollo.QueryResult<CandidatePageFiltersEmployeePrefQuery, CandidatePageFiltersEmployeePrefQueryVariables>;
export const EmployeeDataBulkUpsertDocument = gql`
    mutation employeeDataBulkUpsert($name: String!, $path: String!, $dataType: EmployeeBulkUploadDataType!) {
  employeeDataBulkUpsert(input: {name: $name, path: $path, dataType: $dataType}) {
    result
  }
}
    `;
export type EmployeeDataBulkUpsertMutationFn = Apollo.MutationFunction<EmployeeDataBulkUpsertMutation, EmployeeDataBulkUpsertMutationVariables>;

/**
 * __useEmployeeDataBulkUpsertMutation__
 *
 * To run a mutation, you first call `useEmployeeDataBulkUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDataBulkUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeDataBulkUpsertMutation, { data, loading, error }] = useEmployeeDataBulkUpsertMutation({
 *   variables: {
 *      name: // value for 'name'
 *      path: // value for 'path'
 *      dataType: // value for 'dataType'
 *   },
 * });
 */
export function useEmployeeDataBulkUpsertMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeDataBulkUpsertMutation, EmployeeDataBulkUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeDataBulkUpsertMutation, EmployeeDataBulkUpsertMutationVariables>(EmployeeDataBulkUpsertDocument, options);
      }
export type EmployeeDataBulkUpsertMutationHookResult = ReturnType<typeof useEmployeeDataBulkUpsertMutation>;
export type EmployeeDataBulkUpsertMutationResult = Apollo.MutationResult<EmployeeDataBulkUpsertMutation>;
export type EmployeeDataBulkUpsertMutationOptions = Apollo.BaseMutationOptions<EmployeeDataBulkUpsertMutation, EmployeeDataBulkUpsertMutationVariables>;
export const CalendarPermissionsDocument = gql`
    query CalendarPermissions($applicationStageId: uuid!) {
  applicationStage(id: $applicationStageId) {
    id
    application {
      id
      candidateId
    }
    creator {
      id
      orgId
      email
      fullName
      internalProfilePictureUrl
    }
    applicationStageCandidateEvents {
      googleCalendarId
      startAt
      endAt
      name
      googleEventId
      calendar {
        name
        canActorWriteToCalendar
      }
    }
    applicationStageInterviews {
      calendarEventTitle
      googleCalendarId
      id
      name
      startAt
      endAt
      calendar {
        id
        name
        remoteId
        employeeId
        canActorWriteToCalendar
      }
    }
  }
}
    `;

/**
 * __useCalendarPermissionsQuery__
 *
 * To run a query within a React component, call `useCalendarPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarPermissionsQuery({
 *   variables: {
 *      applicationStageId: // value for 'applicationStageId'
 *   },
 * });
 */
export function useCalendarPermissionsQuery(baseOptions: Apollo.QueryHookOptions<CalendarPermissionsQuery, CalendarPermissionsQueryVariables> & ({ variables: CalendarPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>(CalendarPermissionsDocument, options);
      }
export function useCalendarPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>(CalendarPermissionsDocument, options);
        }
// @ts-ignore
export function useCalendarPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>;
export function useCalendarPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<CalendarPermissionsQuery | undefined, CalendarPermissionsQueryVariables>;
export function useCalendarPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>(CalendarPermissionsDocument, options);
        }
export type CalendarPermissionsQueryHookResult = ReturnType<typeof useCalendarPermissionsQuery>;
export type CalendarPermissionsLazyQueryHookResult = ReturnType<typeof useCalendarPermissionsLazyQuery>;
export type CalendarPermissionsSuspenseQueryHookResult = ReturnType<typeof useCalendarPermissionsSuspenseQuery>;
export type CalendarPermissionsQueryResult = Apollo.QueryResult<CalendarPermissionsQuery, CalendarPermissionsQueryVariables>;
export const SlackFeedbackNagDocument = gql`
    mutation SlackFeedbackNag($input: TrainingFeedbackReminderNagInput!) {
  trainingFeedbackReminderNag(input: $input) {
    interviewModuleMember {
      interviewModuleId
      employeeId
    }
  }
}
    `;
export type SlackFeedbackNagMutationFn = Apollo.MutationFunction<SlackFeedbackNagMutation, SlackFeedbackNagMutationVariables>;

/**
 * __useSlackFeedbackNagMutation__
 *
 * To run a mutation, you first call `useSlackFeedbackNagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSlackFeedbackNagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [slackFeedbackNagMutation, { data, loading, error }] = useSlackFeedbackNagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSlackFeedbackNagMutation(baseOptions?: Apollo.MutationHookOptions<SlackFeedbackNagMutation, SlackFeedbackNagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SlackFeedbackNagMutation, SlackFeedbackNagMutationVariables>(SlackFeedbackNagDocument, options);
      }
export type SlackFeedbackNagMutationHookResult = ReturnType<typeof useSlackFeedbackNagMutation>;
export type SlackFeedbackNagMutationResult = Apollo.MutationResult<SlackFeedbackNagMutation>;
export type SlackFeedbackNagMutationOptions = Apollo.BaseMutationOptions<SlackFeedbackNagMutation, SlackFeedbackNagMutationVariables>;
export const InterviewModuleMemberLogCreateDocument = gql`
    mutation InterviewModuleMemberLogCreate($input: InterviewModuleMemberLogCreateInput!) {
  interviewModuleMemberLogCreate(input: $input) {
    interviewModuleMemberManualLog {
      id
    }
  }
}
    `;
export type InterviewModuleMemberLogCreateMutationFn = Apollo.MutationFunction<InterviewModuleMemberLogCreateMutation, InterviewModuleMemberLogCreateMutationVariables>;

/**
 * __useInterviewModuleMemberLogCreateMutation__
 *
 * To run a mutation, you first call `useInterviewModuleMemberLogCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberLogCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewModuleMemberLogCreateMutation, { data, loading, error }] = useInterviewModuleMemberLogCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModuleMemberLogCreateMutation(baseOptions?: Apollo.MutationHookOptions<InterviewModuleMemberLogCreateMutation, InterviewModuleMemberLogCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewModuleMemberLogCreateMutation, InterviewModuleMemberLogCreateMutationVariables>(InterviewModuleMemberLogCreateDocument, options);
      }
export type InterviewModuleMemberLogCreateMutationHookResult = ReturnType<typeof useInterviewModuleMemberLogCreateMutation>;
export type InterviewModuleMemberLogCreateMutationResult = Apollo.MutationResult<InterviewModuleMemberLogCreateMutation>;
export type InterviewModuleMemberLogCreateMutationOptions = Apollo.BaseMutationOptions<InterviewModuleMemberLogCreateMutation, InterviewModuleMemberLogCreateMutationVariables>;
export const InterviewModuleMemberLogDeleteDocument = gql`
    mutation InterviewModuleMemberLogDelete($input: InterviewModuleMemberLogDeleteInput!) {
  interviewModuleMemberLogDelete(input: $input) {
    result
  }
}
    `;
export type InterviewModuleMemberLogDeleteMutationFn = Apollo.MutationFunction<InterviewModuleMemberLogDeleteMutation, InterviewModuleMemberLogDeleteMutationVariables>;

/**
 * __useInterviewModuleMemberLogDeleteMutation__
 *
 * To run a mutation, you first call `useInterviewModuleMemberLogDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberLogDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewModuleMemberLogDeleteMutation, { data, loading, error }] = useInterviewModuleMemberLogDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModuleMemberLogDeleteMutation(baseOptions?: Apollo.MutationHookOptions<InterviewModuleMemberLogDeleteMutation, InterviewModuleMemberLogDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewModuleMemberLogDeleteMutation, InterviewModuleMemberLogDeleteMutationVariables>(InterviewModuleMemberLogDeleteDocument, options);
      }
export type InterviewModuleMemberLogDeleteMutationHookResult = ReturnType<typeof useInterviewModuleMemberLogDeleteMutation>;
export type InterviewModuleMemberLogDeleteMutationResult = Apollo.MutationResult<InterviewModuleMemberLogDeleteMutation>;
export type InterviewModuleMemberLogDeleteMutationOptions = Apollo.BaseMutationOptions<InterviewModuleMemberLogDeleteMutation, InterviewModuleMemberLogDeleteMutationVariables>;
export const PauseMemberModalInterviewModuleMemberUpdateDocument = gql`
    mutation PauseMemberModalInterviewModuleMemberUpdate($input: InterviewModuleMemberUpdateInput!) {
  interviewModuleMemberUpdate(input: $input) {
    interviewModuleMember {
      ...pauseMemberModal_moduleMember
    }
  }
}
    ${PauseMemberModal_ModuleMemberFragmentDoc}`;
export type PauseMemberModalInterviewModuleMemberUpdateMutationFn = Apollo.MutationFunction<PauseMemberModalInterviewModuleMemberUpdateMutation, PauseMemberModalInterviewModuleMemberUpdateMutationVariables>;

/**
 * __usePauseMemberModalInterviewModuleMemberUpdateMutation__
 *
 * To run a mutation, you first call `usePauseMemberModalInterviewModuleMemberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseMemberModalInterviewModuleMemberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseMemberModalInterviewModuleMemberUpdateMutation, { data, loading, error }] = usePauseMemberModalInterviewModuleMemberUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseMemberModalInterviewModuleMemberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PauseMemberModalInterviewModuleMemberUpdateMutation, PauseMemberModalInterviewModuleMemberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseMemberModalInterviewModuleMemberUpdateMutation, PauseMemberModalInterviewModuleMemberUpdateMutationVariables>(PauseMemberModalInterviewModuleMemberUpdateDocument, options);
      }
export type PauseMemberModalInterviewModuleMemberUpdateMutationHookResult = ReturnType<typeof usePauseMemberModalInterviewModuleMemberUpdateMutation>;
export type PauseMemberModalInterviewModuleMemberUpdateMutationResult = Apollo.MutationResult<PauseMemberModalInterviewModuleMemberUpdateMutation>;
export type PauseMemberModalInterviewModuleMemberUpdateMutationOptions = Apollo.BaseMutationOptions<PauseMemberModalInterviewModuleMemberUpdateMutation, PauseMemberModalInterviewModuleMemberUpdateMutationVariables>;
export const InterviewModuleDeleteMemberDocument = gql`
    mutation InterviewModuleDeleteMember($input: InterviewModuleRemoveMembersInput!) {
  interviewModuleRemoveMembers(input: $input) {
    interviewModule {
      id
    }
  }
}
    `;
export type InterviewModuleDeleteMemberMutationFn = Apollo.MutationFunction<InterviewModuleDeleteMemberMutation, InterviewModuleDeleteMemberMutationVariables>;

/**
 * __useInterviewModuleDeleteMemberMutation__
 *
 * To run a mutation, you first call `useInterviewModuleDeleteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleDeleteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewModuleDeleteMemberMutation, { data, loading, error }] = useInterviewModuleDeleteMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModuleDeleteMemberMutation(baseOptions?: Apollo.MutationHookOptions<InterviewModuleDeleteMemberMutation, InterviewModuleDeleteMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewModuleDeleteMemberMutation, InterviewModuleDeleteMemberMutationVariables>(InterviewModuleDeleteMemberDocument, options);
      }
export type InterviewModuleDeleteMemberMutationHookResult = ReturnType<typeof useInterviewModuleDeleteMemberMutation>;
export type InterviewModuleDeleteMemberMutationResult = Apollo.MutationResult<InterviewModuleDeleteMemberMutation>;
export type InterviewModuleDeleteMemberMutationOptions = Apollo.BaseMutationOptions<InterviewModuleDeleteMemberMutation, InterviewModuleDeleteMemberMutationVariables>;
export const InterviewModuleMemberLogUpdateDocument = gql`
    mutation InterviewModuleMemberLogUpdate($input: InterviewModuleMemberLogUpdateInput!) {
  interviewModuleMemberLogUpdate(input: $input) {
    interviewModuleMemberManualLog {
      id
    }
  }
}
    `;
export type InterviewModuleMemberLogUpdateMutationFn = Apollo.MutationFunction<InterviewModuleMemberLogUpdateMutation, InterviewModuleMemberLogUpdateMutationVariables>;

/**
 * __useInterviewModuleMemberLogUpdateMutation__
 *
 * To run a mutation, you first call `useInterviewModuleMemberLogUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberLogUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewModuleMemberLogUpdateMutation, { data, loading, error }] = useInterviewModuleMemberLogUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModuleMemberLogUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InterviewModuleMemberLogUpdateMutation, InterviewModuleMemberLogUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewModuleMemberLogUpdateMutation, InterviewModuleMemberLogUpdateMutationVariables>(InterviewModuleMemberLogUpdateDocument, options);
      }
export type InterviewModuleMemberLogUpdateMutationHookResult = ReturnType<typeof useInterviewModuleMemberLogUpdateMutation>;
export type InterviewModuleMemberLogUpdateMutationResult = Apollo.MutationResult<InterviewModuleMemberLogUpdateMutation>;
export type InterviewModuleMemberLogUpdateMutationOptions = Apollo.BaseMutationOptions<InterviewModuleMemberLogUpdateMutation, InterviewModuleMemberLogUpdateMutationVariables>;
export const ApplicationStageInterviewInterviewerUpdateDocument = gql`
    mutation ApplicationStageInterviewInterviewerUpdate($input: ApplicationStageInterviewInterviewerUpdateInput!) {
  applicationStageInterviewInterviewerUpdate(input: $input) {
    result
  }
}
    `;
export type ApplicationStageInterviewInterviewerUpdateMutationFn = Apollo.MutationFunction<ApplicationStageInterviewInterviewerUpdateMutation, ApplicationStageInterviewInterviewerUpdateMutationVariables>;

/**
 * __useApplicationStageInterviewInterviewerUpdateMutation__
 *
 * To run a mutation, you first call `useApplicationStageInterviewInterviewerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplicationStageInterviewInterviewerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applicationStageInterviewInterviewerUpdateMutation, { data, loading, error }] = useApplicationStageInterviewInterviewerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplicationStageInterviewInterviewerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ApplicationStageInterviewInterviewerUpdateMutation, ApplicationStageInterviewInterviewerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplicationStageInterviewInterviewerUpdateMutation, ApplicationStageInterviewInterviewerUpdateMutationVariables>(ApplicationStageInterviewInterviewerUpdateDocument, options);
      }
export type ApplicationStageInterviewInterviewerUpdateMutationHookResult = ReturnType<typeof useApplicationStageInterviewInterviewerUpdateMutation>;
export type ApplicationStageInterviewInterviewerUpdateMutationResult = Apollo.MutationResult<ApplicationStageInterviewInterviewerUpdateMutation>;
export type ApplicationStageInterviewInterviewerUpdateMutationOptions = Apollo.BaseMutationOptions<ApplicationStageInterviewInterviewerUpdateMutation, ApplicationStageInterviewInterviewerUpdateMutationVariables>;
export const ModuleLoadPauseRowInterviewModuleMemberUpdateDocument = gql`
    mutation ModuleLoadPauseRowInterviewModuleMemberUpdate($input: InterviewModuleMemberUpdateInput!) {
  interviewModuleMemberUpdate(input: $input) {
    interviewModuleMember {
      ...moduleLoadPauseRow_moduleMember
    }
  }
}
    ${ModuleLoadPauseRow_ModuleMemberFragmentDoc}`;
export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutationFn = Apollo.MutationFunction<ModuleLoadPauseRowInterviewModuleMemberUpdateMutation, ModuleLoadPauseRowInterviewModuleMemberUpdateMutationVariables>;

/**
 * __useModuleLoadPauseRowInterviewModuleMemberUpdateMutation__
 *
 * To run a mutation, you first call `useModuleLoadPauseRowInterviewModuleMemberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModuleLoadPauseRowInterviewModuleMemberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moduleLoadPauseRowInterviewModuleMemberUpdateMutation, { data, loading, error }] = useModuleLoadPauseRowInterviewModuleMemberUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModuleLoadPauseRowInterviewModuleMemberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ModuleLoadPauseRowInterviewModuleMemberUpdateMutation, ModuleLoadPauseRowInterviewModuleMemberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModuleLoadPauseRowInterviewModuleMemberUpdateMutation, ModuleLoadPauseRowInterviewModuleMemberUpdateMutationVariables>(ModuleLoadPauseRowInterviewModuleMemberUpdateDocument, options);
      }
export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutationHookResult = ReturnType<typeof useModuleLoadPauseRowInterviewModuleMemberUpdateMutation>;
export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutationResult = Apollo.MutationResult<ModuleLoadPauseRowInterviewModuleMemberUpdateMutation>;
export type ModuleLoadPauseRowInterviewModuleMemberUpdateMutationOptions = Apollo.BaseMutationOptions<ModuleLoadPauseRowInterviewModuleMemberUpdateMutation, ModuleLoadPauseRowInterviewModuleMemberUpdateMutationVariables>;
export const ModuleLoadInterviewModuleMemberUpdateDocument = gql`
    mutation ModuleLoadInterviewModuleMemberUpdate($input: InterviewModuleMemberUpdateInput!) {
  interviewModuleMemberUpdate(input: $input) {
    interviewModuleMember {
      ...moduleLoad_moduleMember
    }
  }
}
    ${ModuleLoad_ModuleMemberFragmentDoc}`;
export type ModuleLoadInterviewModuleMemberUpdateMutationFn = Apollo.MutationFunction<ModuleLoadInterviewModuleMemberUpdateMutation, ModuleLoadInterviewModuleMemberUpdateMutationVariables>;

/**
 * __useModuleLoadInterviewModuleMemberUpdateMutation__
 *
 * To run a mutation, you first call `useModuleLoadInterviewModuleMemberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModuleLoadInterviewModuleMemberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moduleLoadInterviewModuleMemberUpdateMutation, { data, loading, error }] = useModuleLoadInterviewModuleMemberUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModuleLoadInterviewModuleMemberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ModuleLoadInterviewModuleMemberUpdateMutation, ModuleLoadInterviewModuleMemberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModuleLoadInterviewModuleMemberUpdateMutation, ModuleLoadInterviewModuleMemberUpdateMutationVariables>(ModuleLoadInterviewModuleMemberUpdateDocument, options);
      }
export type ModuleLoadInterviewModuleMemberUpdateMutationHookResult = ReturnType<typeof useModuleLoadInterviewModuleMemberUpdateMutation>;
export type ModuleLoadInterviewModuleMemberUpdateMutationResult = Apollo.MutationResult<ModuleLoadInterviewModuleMemberUpdateMutation>;
export type ModuleLoadInterviewModuleMemberUpdateMutationOptions = Apollo.BaseMutationOptions<ModuleLoadInterviewModuleMemberUpdateMutation, ModuleLoadInterviewModuleMemberUpdateMutationVariables>;
export const InterviewModuleMemberModuleLogSidepanelDocument = gql`
    query InterviewModuleMemberModuleLogSidepanel($interviewModuleId: uuid!, $moduleMemberId: uuid!, $moduleMemberInterviewLogsInput: ModuleMemberInterviewLogInput!) {
  interviewModuleMember(
    interviewModuleId: $interviewModuleId
    employeeId: $moduleMemberId
  ) {
    id
    interviewModuleId
    employeeId
    moduleMemberInterviewLogs(input: $moduleMemberInterviewLogsInput) {
      items {
        ...interviewModuleMemberModuleLogRow_moduleMemberInterview
      }
    }
  }
}
    ${InterviewModuleMemberModuleLogRow_ModuleMemberInterviewFragmentDoc}`;

/**
 * __useInterviewModuleMemberModuleLogSidepanelQuery__
 *
 * To run a query within a React component, call `useInterviewModuleMemberModuleLogSidepanelQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberModuleLogSidepanelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMemberModuleLogSidepanelQuery({
 *   variables: {
 *      interviewModuleId: // value for 'interviewModuleId'
 *      moduleMemberId: // value for 'moduleMemberId'
 *      moduleMemberInterviewLogsInput: // value for 'moduleMemberInterviewLogsInput'
 *   },
 * });
 */
export function useInterviewModuleMemberModuleLogSidepanelQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables> & ({ variables: InterviewModuleMemberModuleLogSidepanelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>(InterviewModuleMemberModuleLogSidepanelDocument, options);
      }
export function useInterviewModuleMemberModuleLogSidepanelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>(InterviewModuleMemberModuleLogSidepanelDocument, options);
        }
// @ts-ignore
export function useInterviewModuleMemberModuleLogSidepanelSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>;
export function useInterviewModuleMemberModuleLogSidepanelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberModuleLogSidepanelQuery | undefined, InterviewModuleMemberModuleLogSidepanelQueryVariables>;
export function useInterviewModuleMemberModuleLogSidepanelSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>(InterviewModuleMemberModuleLogSidepanelDocument, options);
        }
export type InterviewModuleMemberModuleLogSidepanelQueryHookResult = ReturnType<typeof useInterviewModuleMemberModuleLogSidepanelQuery>;
export type InterviewModuleMemberModuleLogSidepanelLazyQueryHookResult = ReturnType<typeof useInterviewModuleMemberModuleLogSidepanelLazyQuery>;
export type InterviewModuleMemberModuleLogSidepanelSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMemberModuleLogSidepanelSuspenseQuery>;
export type InterviewModuleMemberModuleLogSidepanelQueryResult = Apollo.QueryResult<InterviewModuleMemberModuleLogSidepanelQuery, InterviewModuleMemberModuleLogSidepanelQueryVariables>;
export const PendingApprovalApplicationStageInterviewInterviewerUpdateDocument = gql`
    mutation PendingApprovalApplicationStageInterviewInterviewerUpdate($input: ApplicationStageInterviewInterviewerUpdateInput!) {
  applicationStageInterviewInterviewerUpdate(input: $input) {
    result
  }
}
    `;
export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutationFn = Apollo.MutationFunction<PendingApprovalApplicationStageInterviewInterviewerUpdateMutation, PendingApprovalApplicationStageInterviewInterviewerUpdateMutationVariables>;

/**
 * __usePendingApprovalApplicationStageInterviewInterviewerUpdateMutation__
 *
 * To run a mutation, you first call `usePendingApprovalApplicationStageInterviewInterviewerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePendingApprovalApplicationStageInterviewInterviewerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pendingApprovalApplicationStageInterviewInterviewerUpdateMutation, { data, loading, error }] = usePendingApprovalApplicationStageInterviewInterviewerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePendingApprovalApplicationStageInterviewInterviewerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PendingApprovalApplicationStageInterviewInterviewerUpdateMutation, PendingApprovalApplicationStageInterviewInterviewerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PendingApprovalApplicationStageInterviewInterviewerUpdateMutation, PendingApprovalApplicationStageInterviewInterviewerUpdateMutationVariables>(PendingApprovalApplicationStageInterviewInterviewerUpdateDocument, options);
      }
export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutationHookResult = ReturnType<typeof usePendingApprovalApplicationStageInterviewInterviewerUpdateMutation>;
export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutationResult = Apollo.MutationResult<PendingApprovalApplicationStageInterviewInterviewerUpdateMutation>;
export type PendingApprovalApplicationStageInterviewInterviewerUpdateMutationOptions = Apollo.BaseMutationOptions<PendingApprovalApplicationStageInterviewInterviewerUpdateMutation, PendingApprovalApplicationStageInterviewInterviewerUpdateMutationVariables>;
export const InterviewModuleMemberSidepanelQueryDocument = gql`
    query InterviewModuleMemberSidepanelQuery($interviewModuleId: uuid!, $moduleMemberId: uuid!) {
  interviewModuleMember(
    interviewModuleId: $interviewModuleId
    employeeId: $moduleMemberId
  ) {
    ...ModuleMemberSidePanel
    ...InterviewModuleMemberModuleLog_moduleMember
  }
}
    ${ModuleMemberSidePanelFragmentDoc}
${InterviewModuleMemberModuleLog_ModuleMemberFragmentDoc}`;

/**
 * __useInterviewModuleMemberSidepanelQueryQuery__
 *
 * To run a query within a React component, call `useInterviewModuleMemberSidepanelQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberSidepanelQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMemberSidepanelQueryQuery({
 *   variables: {
 *      interviewModuleId: // value for 'interviewModuleId'
 *      moduleMemberId: // value for 'moduleMemberId'
 *   },
 * });
 */
export function useInterviewModuleMemberSidepanelQueryQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables> & ({ variables: InterviewModuleMemberSidepanelQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>(InterviewModuleMemberSidepanelQueryDocument, options);
      }
export function useInterviewModuleMemberSidepanelQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>(InterviewModuleMemberSidepanelQueryDocument, options);
        }
// @ts-ignore
export function useInterviewModuleMemberSidepanelQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>;
export function useInterviewModuleMemberSidepanelQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberSidepanelQueryQuery | undefined, InterviewModuleMemberSidepanelQueryQueryVariables>;
export function useInterviewModuleMemberSidepanelQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>(InterviewModuleMemberSidepanelQueryDocument, options);
        }
export type InterviewModuleMemberSidepanelQueryQueryHookResult = ReturnType<typeof useInterviewModuleMemberSidepanelQueryQuery>;
export type InterviewModuleMemberSidepanelQueryLazyQueryHookResult = ReturnType<typeof useInterviewModuleMemberSidepanelQueryLazyQuery>;
export type InterviewModuleMemberSidepanelQuerySuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMemberSidepanelQuerySuspenseQuery>;
export type InterviewModuleMemberSidepanelQueryQueryResult = Apollo.QueryResult<InterviewModuleMemberSidepanelQueryQuery, InterviewModuleMemberSidepanelQueryQueryVariables>;
export const ModuleMemberUpdateDocument = gql`
    mutation ModuleMemberUpdate($input: InterviewModuleMemberUpdateInput!) {
  interviewModuleMemberUpdate(input: $input) {
    interviewModuleMember {
      ...ModuleMemberSidePanel
    }
  }
}
    ${ModuleMemberSidePanelFragmentDoc}`;
export type ModuleMemberUpdateMutationFn = Apollo.MutationFunction<ModuleMemberUpdateMutation, ModuleMemberUpdateMutationVariables>;

/**
 * __useModuleMemberUpdateMutation__
 *
 * To run a mutation, you first call `useModuleMemberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModuleMemberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moduleMemberUpdateMutation, { data, loading, error }] = useModuleMemberUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModuleMemberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ModuleMemberUpdateMutation, ModuleMemberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModuleMemberUpdateMutation, ModuleMemberUpdateMutationVariables>(ModuleMemberUpdateDocument, options);
      }
export type ModuleMemberUpdateMutationHookResult = ReturnType<typeof useModuleMemberUpdateMutation>;
export type ModuleMemberUpdateMutationResult = Apollo.MutationResult<ModuleMemberUpdateMutation>;
export type ModuleMemberUpdateMutationOptions = Apollo.BaseMutationOptions<ModuleMemberUpdateMutation, ModuleMemberUpdateMutationVariables>;
export const ModuleMemberApproveDocument = gql`
    mutation ModuleMemberApprove($input: InterviewModuleMemberApproveInput!) {
  interviewModuleMemberApprove(input: $input) {
    interviewModuleMember {
      ...ModuleMemberSidePanel
    }
  }
}
    ${ModuleMemberSidePanelFragmentDoc}`;
export type ModuleMemberApproveMutationFn = Apollo.MutationFunction<ModuleMemberApproveMutation, ModuleMemberApproveMutationVariables>;

/**
 * __useModuleMemberApproveMutation__
 *
 * To run a mutation, you first call `useModuleMemberApproveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModuleMemberApproveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moduleMemberApproveMutation, { data, loading, error }] = useModuleMemberApproveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModuleMemberApproveMutation(baseOptions?: Apollo.MutationHookOptions<ModuleMemberApproveMutation, ModuleMemberApproveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModuleMemberApproveMutation, ModuleMemberApproveMutationVariables>(ModuleMemberApproveDocument, options);
      }
export type ModuleMemberApproveMutationHookResult = ReturnType<typeof useModuleMemberApproveMutation>;
export type ModuleMemberApproveMutationResult = Apollo.MutationResult<ModuleMemberApproveMutation>;
export type ModuleMemberApproveMutationOptions = Apollo.BaseMutationOptions<ModuleMemberApproveMutation, ModuleMemberApproveMutationVariables>;
export const DebriefFlowDoneDocument = gql`
    query DebriefFlowDone($applicationId: uuid!) {
  application(id: $applicationId) {
    candidate {
      id
    }
  }
}
    `;

/**
 * __useDebriefFlowDoneQuery__
 *
 * To run a query within a React component, call `useDebriefFlowDoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefFlowDoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefFlowDoneQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useDebriefFlowDoneQuery(baseOptions: Apollo.QueryHookOptions<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables> & ({ variables: DebriefFlowDoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>(DebriefFlowDoneDocument, options);
      }
export function useDebriefFlowDoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>(DebriefFlowDoneDocument, options);
        }
// @ts-ignore
export function useDebriefFlowDoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>;
export function useDebriefFlowDoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefFlowDoneQuery | undefined, DebriefFlowDoneQueryVariables>;
export function useDebriefFlowDoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>(DebriefFlowDoneDocument, options);
        }
export type DebriefFlowDoneQueryHookResult = ReturnType<typeof useDebriefFlowDoneQuery>;
export type DebriefFlowDoneLazyQueryHookResult = ReturnType<typeof useDebriefFlowDoneLazyQuery>;
export type DebriefFlowDoneSuspenseQueryHookResult = ReturnType<typeof useDebriefFlowDoneSuspenseQuery>;
export type DebriefFlowDoneQueryResult = Apollo.QueryResult<DebriefFlowDoneQuery, DebriefFlowDoneQueryVariables>;
export const DebriefFlowHeaderDocument = gql`
    query debriefFlowHeader($id: uuid!) {
  application(id: $id) {
    id
    candidate {
      id
      fullName
      anonymizedAt
    }
    jobStage {
      id
      name
    }
    job {
      id
      name
    }
  }
}
    `;

/**
 * __useDebriefFlowHeaderQuery__
 *
 * To run a query within a React component, call `useDebriefFlowHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefFlowHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefFlowHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDebriefFlowHeaderQuery(baseOptions: Apollo.QueryHookOptions<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables> & ({ variables: DebriefFlowHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>(DebriefFlowHeaderDocument, options);
      }
export function useDebriefFlowHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>(DebriefFlowHeaderDocument, options);
        }
// @ts-ignore
export function useDebriefFlowHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>;
export function useDebriefFlowHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefFlowHeaderQuery | undefined, DebriefFlowHeaderQueryVariables>;
export function useDebriefFlowHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>(DebriefFlowHeaderDocument, options);
        }
export type DebriefFlowHeaderQueryHookResult = ReturnType<typeof useDebriefFlowHeaderQuery>;
export type DebriefFlowHeaderLazyQueryHookResult = ReturnType<typeof useDebriefFlowHeaderLazyQuery>;
export type DebriefFlowHeaderSuspenseQueryHookResult = ReturnType<typeof useDebriefFlowHeaderSuspenseQuery>;
export type DebriefFlowHeaderQueryResult = Apollo.QueryResult<DebriefFlowHeaderQuery, DebriefFlowHeaderQueryVariables>;
export const ApplicationAttendeesDocument = gql`
    query applicationAttendees($id: uuid!) {
  application(id: $id) {
    id
    applicationStages(input: {isCancelled: false}) {
      id
      startAt
      endAt
      applicationStageInterviews(input: {isCancelled: false}) {
        id
        atsScheduledInterviewId
        applicationStageInterviewInterviewers {
          interviewerId
          responseStatus
          interviewer {
            ...AttendeeAttributes
          }
        }
      }
      jobStage {
        id
        name
      }
    }
    job {
      id
      hiringManagers {
        ...AttendeeAttributes
      }
      sourcers {
        ...AttendeeAttributes
      }
    }
    candidate {
      id
      sourcer {
        ...AttendeeAttributes
      }
    }
    recruiter {
      ...AttendeeAttributes
    }
    coordinator {
      ...AttendeeAttributes
    }
    atsApplication {
      ...AtsDebriefStageFromApplication
    }
  }
}
    ${AttendeeAttributesFragmentDoc}
${AtsDebriefStageFromApplicationFragmentDoc}`;

/**
 * __useApplicationAttendeesQuery__
 *
 * To run a query within a React component, call `useApplicationAttendeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationAttendeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationAttendeesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationAttendeesQuery(baseOptions: Apollo.QueryHookOptions<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables> & ({ variables: ApplicationAttendeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>(ApplicationAttendeesDocument, options);
      }
export function useApplicationAttendeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>(ApplicationAttendeesDocument, options);
        }
// @ts-ignore
export function useApplicationAttendeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>;
export function useApplicationAttendeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationAttendeesQuery | undefined, ApplicationAttendeesQueryVariables>;
export function useApplicationAttendeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>(ApplicationAttendeesDocument, options);
        }
export type ApplicationAttendeesQueryHookResult = ReturnType<typeof useApplicationAttendeesQuery>;
export type ApplicationAttendeesLazyQueryHookResult = ReturnType<typeof useApplicationAttendeesLazyQuery>;
export type ApplicationAttendeesSuspenseQueryHookResult = ReturnType<typeof useApplicationAttendeesSuspenseQuery>;
export type ApplicationAttendeesQueryResult = Apollo.QueryResult<ApplicationAttendeesQuery, ApplicationAttendeesQueryVariables>;
export const TaskDebriefAttendeeDocument = gql`
    query TaskDebriefAttendee($taskId: uuid!) {
  thisUserInfo {
    userName
  }
  task(id: $taskId) {
    id
    debriefs {
      id
      attendees {
        interviewerId
        interviewer {
          id
          fullName
          internalProfilePictureUrl
          isDirectoryDisabled
          isAtsDisabled
          hasAtsId
        }
      }
    }
  }
}
    `;

/**
 * __useTaskDebriefAttendeeQuery__
 *
 * To run a query within a React component, call `useTaskDebriefAttendeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDebriefAttendeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDebriefAttendeeQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskDebriefAttendeeQuery(baseOptions: Apollo.QueryHookOptions<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables> & ({ variables: TaskDebriefAttendeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>(TaskDebriefAttendeeDocument, options);
      }
export function useTaskDebriefAttendeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>(TaskDebriefAttendeeDocument, options);
        }
// @ts-ignore
export function useTaskDebriefAttendeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>;
export function useTaskDebriefAttendeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDebriefAttendeeQuery | undefined, TaskDebriefAttendeeQueryVariables>;
export function useTaskDebriefAttendeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>(TaskDebriefAttendeeDocument, options);
        }
export type TaskDebriefAttendeeQueryHookResult = ReturnType<typeof useTaskDebriefAttendeeQuery>;
export type TaskDebriefAttendeeLazyQueryHookResult = ReturnType<typeof useTaskDebriefAttendeeLazyQuery>;
export type TaskDebriefAttendeeSuspenseQueryHookResult = ReturnType<typeof useTaskDebriefAttendeeSuspenseQuery>;
export type TaskDebriefAttendeeQueryResult = Apollo.QueryResult<TaskDebriefAttendeeQuery, TaskDebriefAttendeeQueryVariables>;
export const DebriefTaskDocument = gql`
    query DebriefTask($taskId: uuid!) {
  task(id: $taskId) {
    id
    name
    ...ScheduleFlowDataProvider_task
    jobStage {
      id
      job {
        id
        ...ScheduleFlowDataProvider_job
      }
      jobStageSettingsV2 {
        id
        ...ScheduleFlowDataProvider_jobStageSettings
      }
    }
    schedule {
      id
      conversation {
        id
        remoteName
      }
    }
    debriefs {
      id
      conversationTemplateId
      emailTemplateId
      googleCalendarId
      additionalAttendeesV2 {
        employeeIds
        emails
        isOptional
        attendees {
          email
          employeeId
          isOptional
          sourceAudience
        }
      }
      scorecardRecipientEmployeeIds
      conversation {
        id
        remoteName
      }
      startAt
      endAt
    }
  }
}
    ${ScheduleFlowDataProvider_TaskFragmentDoc}
${ScheduleFlowDataProvider_JobFragmentDoc}
${ScheduleFlowDataProvider_JobStageSettingsFragmentDoc}`;

/**
 * __useDebriefTaskQuery__
 *
 * To run a query within a React component, call `useDebriefTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefTaskQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useDebriefTaskQuery(baseOptions: Apollo.QueryHookOptions<DebriefTaskQuery, DebriefTaskQueryVariables> & ({ variables: DebriefTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefTaskQuery, DebriefTaskQueryVariables>(DebriefTaskDocument, options);
      }
export function useDebriefTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefTaskQuery, DebriefTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefTaskQuery, DebriefTaskQueryVariables>(DebriefTaskDocument, options);
        }
// @ts-ignore
export function useDebriefTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefTaskQuery, DebriefTaskQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefTaskQuery, DebriefTaskQueryVariables>;
export function useDebriefTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefTaskQuery, DebriefTaskQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefTaskQuery | undefined, DebriefTaskQueryVariables>;
export function useDebriefTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefTaskQuery, DebriefTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefTaskQuery, DebriefTaskQueryVariables>(DebriefTaskDocument, options);
        }
export type DebriefTaskQueryHookResult = ReturnType<typeof useDebriefTaskQuery>;
export type DebriefTaskLazyQueryHookResult = ReturnType<typeof useDebriefTaskLazyQuery>;
export type DebriefTaskSuspenseQueryHookResult = ReturnType<typeof useDebriefTaskSuspenseQuery>;
export type DebriefTaskQueryResult = Apollo.QueryResult<DebriefTaskQuery, DebriefTaskQueryVariables>;
export const DebriefApplicationDocument = gql`
    query DebriefApplication($applicationId: uuid!) {
  application(id: $applicationId) {
    id
    candidate {
      id
      ...ScheduleFlowDataProvider_candidate
    }
    job {
      id
      atsId
      ...ScheduleFlowDataProvider_job
    }
    jobStage {
      id
      jobStageSettingsV2 {
        id
        ...ScheduleFlowDataProvider_jobStageSettings
      }
    }
    jobStageId
    existingConversations {
      id
      remoteName
    }
  }
}
    ${ScheduleFlowDataProvider_CandidateFragmentDoc}
${ScheduleFlowDataProvider_JobFragmentDoc}
${ScheduleFlowDataProvider_JobStageSettingsFragmentDoc}`;

/**
 * __useDebriefApplicationQuery__
 *
 * To run a query within a React component, call `useDebriefApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefApplicationQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useDebriefApplicationQuery(baseOptions: Apollo.QueryHookOptions<DebriefApplicationQuery, DebriefApplicationQueryVariables> & ({ variables: DebriefApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefApplicationQuery, DebriefApplicationQueryVariables>(DebriefApplicationDocument, options);
      }
export function useDebriefApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefApplicationQuery, DebriefApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefApplicationQuery, DebriefApplicationQueryVariables>(DebriefApplicationDocument, options);
        }
// @ts-ignore
export function useDebriefApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefApplicationQuery, DebriefApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefApplicationQuery, DebriefApplicationQueryVariables>;
export function useDebriefApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefApplicationQuery, DebriefApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefApplicationQuery | undefined, DebriefApplicationQueryVariables>;
export function useDebriefApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefApplicationQuery, DebriefApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefApplicationQuery, DebriefApplicationQueryVariables>(DebriefApplicationDocument, options);
        }
export type DebriefApplicationQueryHookResult = ReturnType<typeof useDebriefApplicationQuery>;
export type DebriefApplicationLazyQueryHookResult = ReturnType<typeof useDebriefApplicationLazyQuery>;
export type DebriefApplicationSuspenseQueryHookResult = ReturnType<typeof useDebriefApplicationSuspenseQuery>;
export type DebriefApplicationQueryResult = Apollo.QueryResult<DebriefApplicationQuery, DebriefApplicationQueryVariables>;
export const DevToolsTaskSearchDocument = gql`
    query DevToolsTaskSearch($input: TaskSearchInput!) {
  taskSearch(input: $input) {
    items {
      id
      status
    }
  }
}
    `;

/**
 * __useDevToolsTaskSearchQuery__
 *
 * To run a query within a React component, call `useDevToolsTaskSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsTaskSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsTaskSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevToolsTaskSearchQuery(baseOptions: Apollo.QueryHookOptions<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables> & ({ variables: DevToolsTaskSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>(DevToolsTaskSearchDocument, options);
      }
export function useDevToolsTaskSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>(DevToolsTaskSearchDocument, options);
        }
// @ts-ignore
export function useDevToolsTaskSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>;
export function useDevToolsTaskSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsTaskSearchQuery | undefined, DevToolsTaskSearchQueryVariables>;
export function useDevToolsTaskSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>(DevToolsTaskSearchDocument, options);
        }
export type DevToolsTaskSearchQueryHookResult = ReturnType<typeof useDevToolsTaskSearchQuery>;
export type DevToolsTaskSearchLazyQueryHookResult = ReturnType<typeof useDevToolsTaskSearchLazyQuery>;
export type DevToolsTaskSearchSuspenseQueryHookResult = ReturnType<typeof useDevToolsTaskSearchSuspenseQuery>;
export type DevToolsTaskSearchQueryResult = Apollo.QueryResult<DevToolsTaskSearchQuery, DevToolsTaskSearchQueryVariables>;
export const DevToolsApplicationTasksDocument = gql`
    query DevToolsApplicationTasks($applicationId: uuid!) {
  application(id: $applicationId) {
    tasks {
      id
      status
    }
  }
}
    `;

/**
 * __useDevToolsApplicationTasksQuery__
 *
 * To run a query within a React component, call `useDevToolsApplicationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevToolsApplicationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevToolsApplicationTasksQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useDevToolsApplicationTasksQuery(baseOptions: Apollo.QueryHookOptions<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables> & ({ variables: DevToolsApplicationTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>(DevToolsApplicationTasksDocument, options);
      }
export function useDevToolsApplicationTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>(DevToolsApplicationTasksDocument, options);
        }
// @ts-ignore
export function useDevToolsApplicationTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>;
export function useDevToolsApplicationTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>): Apollo.UseSuspenseQueryResult<DevToolsApplicationTasksQuery | undefined, DevToolsApplicationTasksQueryVariables>;
export function useDevToolsApplicationTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>(DevToolsApplicationTasksDocument, options);
        }
export type DevToolsApplicationTasksQueryHookResult = ReturnType<typeof useDevToolsApplicationTasksQuery>;
export type DevToolsApplicationTasksLazyQueryHookResult = ReturnType<typeof useDevToolsApplicationTasksLazyQuery>;
export type DevToolsApplicationTasksSuspenseQueryHookResult = ReturnType<typeof useDevToolsApplicationTasksSuspenseQuery>;
export type DevToolsApplicationTasksQueryResult = Apollo.QueryResult<DevToolsApplicationTasksQuery, DevToolsApplicationTasksQueryVariables>;
export const DevToolsTaskCancelDocument = gql`
    mutation DevToolsTaskCancel($input: TaskCancelInput!) {
  taskCancel(input: $input) {
    id
  }
}
    `;
export type DevToolsTaskCancelMutationFn = Apollo.MutationFunction<DevToolsTaskCancelMutation, DevToolsTaskCancelMutationVariables>;

/**
 * __useDevToolsTaskCancelMutation__
 *
 * To run a mutation, you first call `useDevToolsTaskCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevToolsTaskCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devToolsTaskCancelMutation, { data, loading, error }] = useDevToolsTaskCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevToolsTaskCancelMutation(baseOptions?: Apollo.MutationHookOptions<DevToolsTaskCancelMutation, DevToolsTaskCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevToolsTaskCancelMutation, DevToolsTaskCancelMutationVariables>(DevToolsTaskCancelDocument, options);
      }
export type DevToolsTaskCancelMutationHookResult = ReturnType<typeof useDevToolsTaskCancelMutation>;
export type DevToolsTaskCancelMutationResult = Apollo.MutationResult<DevToolsTaskCancelMutation>;
export type DevToolsTaskCancelMutationOptions = Apollo.BaseMutationOptions<DevToolsTaskCancelMutation, DevToolsTaskCancelMutationVariables>;
export const EmployeeAttributeNamesDocument = gql`
    query employeeAttributeNames($input: EmployeeAttributeNamesInput!) {
  employeeAttributeNames(input: $input) {
    items {
      ...AttributesFilter
    }
  }
}
    ${AttributesFilterFragmentDoc}`;

/**
 * __useEmployeeAttributeNamesQuery__
 *
 * To run a query within a React component, call `useEmployeeAttributeNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeAttributeNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeAttributeNamesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeAttributeNamesQuery(baseOptions: Apollo.QueryHookOptions<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables> & ({ variables: EmployeeAttributeNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>(EmployeeAttributeNamesDocument, options);
      }
export function useEmployeeAttributeNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>(EmployeeAttributeNamesDocument, options);
        }
// @ts-ignore
export function useEmployeeAttributeNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>;
export function useEmployeeAttributeNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeAttributeNamesQuery | undefined, EmployeeAttributeNamesQueryVariables>;
export function useEmployeeAttributeNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>(EmployeeAttributeNamesDocument, options);
        }
export type EmployeeAttributeNamesQueryHookResult = ReturnType<typeof useEmployeeAttributeNamesQuery>;
export type EmployeeAttributeNamesLazyQueryHookResult = ReturnType<typeof useEmployeeAttributeNamesLazyQuery>;
export type EmployeeAttributeNamesSuspenseQueryHookResult = ReturnType<typeof useEmployeeAttributeNamesSuspenseQuery>;
export type EmployeeAttributeNamesQueryResult = Apollo.QueryResult<EmployeeAttributeNamesQuery, EmployeeAttributeNamesQueryVariables>;
export const InterviewModuleMemberSearchDocument = gql`
    query InterviewModuleMemberSearch($input: InterviewModuleMemberSearchInput!) {
  interviewModuleMemberSearch(input: $input) {
    items {
      ...EmployeeFilter
    }
  }
}
    ${EmployeeFilterFragmentDoc}`;

/**
 * __useInterviewModuleMemberSearchQuery__
 *
 * To run a query within a React component, call `useInterviewModuleMemberSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMemberSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewModuleMemberSearchQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables> & ({ variables: InterviewModuleMemberSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>(InterviewModuleMemberSearchDocument, options);
      }
export function useInterviewModuleMemberSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>(InterviewModuleMemberSearchDocument, options);
        }
// @ts-ignore
export function useInterviewModuleMemberSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>;
export function useInterviewModuleMemberSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberSearchQuery | undefined, InterviewModuleMemberSearchQueryVariables>;
export function useInterviewModuleMemberSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>(InterviewModuleMemberSearchDocument, options);
        }
export type InterviewModuleMemberSearchQueryHookResult = ReturnType<typeof useInterviewModuleMemberSearchQuery>;
export type InterviewModuleMemberSearchLazyQueryHookResult = ReturnType<typeof useInterviewModuleMemberSearchLazyQuery>;
export type InterviewModuleMemberSearchSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMemberSearchSuspenseQuery>;
export type InterviewModuleMemberSearchQueryResult = Apollo.QueryResult<InterviewModuleMemberSearchQuery, InterviewModuleMemberSearchQueryVariables>;
export const CreateInterviewModuleDocument = gql`
    mutation CreateInterviewModule($input: InterviewModuleCreateInput!) {
  interviewModuleCreate(input: $input) {
    interviewModule {
      id
    }
  }
}
    `;
export type CreateInterviewModuleMutationFn = Apollo.MutationFunction<CreateInterviewModuleMutation, CreateInterviewModuleMutationVariables>;

/**
 * __useCreateInterviewModuleMutation__
 *
 * To run a mutation, you first call `useCreateInterviewModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterviewModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterviewModuleMutation, { data, loading, error }] = useCreateInterviewModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInterviewModuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateInterviewModuleMutation, CreateInterviewModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInterviewModuleMutation, CreateInterviewModuleMutationVariables>(CreateInterviewModuleDocument, options);
      }
export type CreateInterviewModuleMutationHookResult = ReturnType<typeof useCreateInterviewModuleMutation>;
export type CreateInterviewModuleMutationResult = Apollo.MutationResult<CreateInterviewModuleMutation>;
export type CreateInterviewModuleMutationOptions = Apollo.BaseMutationOptions<CreateInterviewModuleMutation, CreateInterviewModuleMutationVariables>;
export const InterviewModuleSearchV2Document = gql`
    query InterviewModuleSearchV2($input: InterviewModuleSearchInput!, $trainedEmployeesInput: InterviewModuleMembersInput!, $untrainedEmployeesInput: InterviewModuleMembersInput!) {
  interviewModuleSearch(input: $input) {
    total
    items {
      id
      ...InterviewModuleList_InterviewModule
    }
  }
}
    ${InterviewModuleList_InterviewModuleFragmentDoc}`;

/**
 * __useInterviewModuleSearchV2Query__
 *
 * To run a query within a React component, call `useInterviewModuleSearchV2Query` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleSearchV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleSearchV2Query({
 *   variables: {
 *      input: // value for 'input'
 *      trainedEmployeesInput: // value for 'trainedEmployeesInput'
 *      untrainedEmployeesInput: // value for 'untrainedEmployeesInput'
 *   },
 * });
 */
export function useInterviewModuleSearchV2Query(baseOptions: Apollo.QueryHookOptions<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables> & ({ variables: InterviewModuleSearchV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>(InterviewModuleSearchV2Document, options);
      }
export function useInterviewModuleSearchV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>(InterviewModuleSearchV2Document, options);
        }
// @ts-ignore
export function useInterviewModuleSearchV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>;
export function useInterviewModuleSearchV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleSearchV2Query | undefined, InterviewModuleSearchV2QueryVariables>;
export function useInterviewModuleSearchV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>(InterviewModuleSearchV2Document, options);
        }
export type InterviewModuleSearchV2QueryHookResult = ReturnType<typeof useInterviewModuleSearchV2Query>;
export type InterviewModuleSearchV2LazyQueryHookResult = ReturnType<typeof useInterviewModuleSearchV2LazyQuery>;
export type InterviewModuleSearchV2SuspenseQueryHookResult = ReturnType<typeof useInterviewModuleSearchV2SuspenseQuery>;
export type InterviewModuleSearchV2QueryResult = Apollo.QueryResult<InterviewModuleSearchV2Query, InterviewModuleSearchV2QueryVariables>;
export const InterviewModuleMemberStatsDocument = gql`
    query InterviewModuleMemberStats {
  interviewModuleMemberStats {
    interviewModule {
      name
    }
    interviewModuleMember {
      interviewModuleId
      employeeId
      employee {
        fullName
      }
    }
    completed
    trainingStatus
    trainingsToPass
    currentTrainingSession
    currentTrainingSessionStatus
    shadowsRequired
    reverseShadowsRequired
    isPaused
    pausedUntil
  }
}
    `;

/**
 * __useInterviewModuleMemberStatsQuery__
 *
 * To run a query within a React component, call `useInterviewModuleMemberStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMemberStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewModuleMemberStatsQuery(baseOptions?: Apollo.QueryHookOptions<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>(InterviewModuleMemberStatsDocument, options);
      }
export function useInterviewModuleMemberStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>(InterviewModuleMemberStatsDocument, options);
        }
// @ts-ignore
export function useInterviewModuleMemberStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>;
export function useInterviewModuleMemberStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberStatsQuery | undefined, InterviewModuleMemberStatsQueryVariables>;
export function useInterviewModuleMemberStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>(InterviewModuleMemberStatsDocument, options);
        }
export type InterviewModuleMemberStatsQueryHookResult = ReturnType<typeof useInterviewModuleMemberStatsQuery>;
export type InterviewModuleMemberStatsLazyQueryHookResult = ReturnType<typeof useInterviewModuleMemberStatsLazyQuery>;
export type InterviewModuleMemberStatsSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMemberStatsSuspenseQuery>;
export type InterviewModuleMemberStatsQueryResult = Apollo.QueryResult<InterviewModuleMemberStatsQuery, InterviewModuleMemberStatsQueryVariables>;
export const UpdateInterviewTrainingScheduleDocument = gql`
    mutation UpdateInterviewTrainingSchedule($input: InterviewModuleUpdateInput!) {
  interviewModuleUpdate(input: $input) {
    interviewModule {
      id
      name
      shouldFastTrackTraining
    }
  }
}
    `;
export type UpdateInterviewTrainingScheduleMutationFn = Apollo.MutationFunction<UpdateInterviewTrainingScheduleMutation, UpdateInterviewTrainingScheduleMutationVariables>;

/**
 * __useUpdateInterviewTrainingScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewTrainingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewTrainingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewTrainingScheduleMutation, { data, loading, error }] = useUpdateInterviewTrainingScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewTrainingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewTrainingScheduleMutation, UpdateInterviewTrainingScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewTrainingScheduleMutation, UpdateInterviewTrainingScheduleMutationVariables>(UpdateInterviewTrainingScheduleDocument, options);
      }
export type UpdateInterviewTrainingScheduleMutationHookResult = ReturnType<typeof useUpdateInterviewTrainingScheduleMutation>;
export type UpdateInterviewTrainingScheduleMutationResult = Apollo.MutationResult<UpdateInterviewTrainingScheduleMutation>;
export type UpdateInterviewTrainingScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewTrainingScheduleMutation, UpdateInterviewTrainingScheduleMutationVariables>;
export const UpdateInterviewModuleNameDocument = gql`
    mutation UpdateInterviewModuleName($input: InterviewModuleUpdateInput!) {
  interviewModuleUpdate(input: $input) {
    interviewModule {
      id
      name
    }
  }
}
    `;
export type UpdateInterviewModuleNameMutationFn = Apollo.MutationFunction<UpdateInterviewModuleNameMutation, UpdateInterviewModuleNameMutationVariables>;

/**
 * __useUpdateInterviewModuleNameMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewModuleNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewModuleNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewModuleNameMutation, { data, loading, error }] = useUpdateInterviewModuleNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewModuleNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewModuleNameMutation, UpdateInterviewModuleNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewModuleNameMutation, UpdateInterviewModuleNameMutationVariables>(UpdateInterviewModuleNameDocument, options);
      }
export type UpdateInterviewModuleNameMutationHookResult = ReturnType<typeof useUpdateInterviewModuleNameMutation>;
export type UpdateInterviewModuleNameMutationResult = Apollo.MutationResult<UpdateInterviewModuleNameMutation>;
export type UpdateInterviewModuleNameMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewModuleNameMutation, UpdateInterviewModuleNameMutationVariables>;
export const TraineeRoleConfigSlackStatusDocument = gql`
    query TraineeRoleConfigSlackStatus {
  thisOrg {
    id
    integrations {
      id
      slack {
        active
      }
    }
  }
}
    `;

/**
 * __useTraineeRoleConfigSlackStatusQuery__
 *
 * To run a query within a React component, call `useTraineeRoleConfigSlackStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useTraineeRoleConfigSlackStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTraineeRoleConfigSlackStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useTraineeRoleConfigSlackStatusQuery(baseOptions?: Apollo.QueryHookOptions<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>(TraineeRoleConfigSlackStatusDocument, options);
      }
export function useTraineeRoleConfigSlackStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>(TraineeRoleConfigSlackStatusDocument, options);
        }
// @ts-ignore
export function useTraineeRoleConfigSlackStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>): Apollo.UseSuspenseQueryResult<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>;
export function useTraineeRoleConfigSlackStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>): Apollo.UseSuspenseQueryResult<TraineeRoleConfigSlackStatusQuery | undefined, TraineeRoleConfigSlackStatusQueryVariables>;
export function useTraineeRoleConfigSlackStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>(TraineeRoleConfigSlackStatusDocument, options);
        }
export type TraineeRoleConfigSlackStatusQueryHookResult = ReturnType<typeof useTraineeRoleConfigSlackStatusQuery>;
export type TraineeRoleConfigSlackStatusLazyQueryHookResult = ReturnType<typeof useTraineeRoleConfigSlackStatusLazyQuery>;
export type TraineeRoleConfigSlackStatusSuspenseQueryHookResult = ReturnType<typeof useTraineeRoleConfigSlackStatusSuspenseQuery>;
export type TraineeRoleConfigSlackStatusQueryResult = Apollo.QueryResult<TraineeRoleConfigSlackStatusQuery, TraineeRoleConfigSlackStatusQueryVariables>;
export const InterviewModuleDeleteDocument = gql`
    mutation InterviewModuleDelete($interviewModuleId: uuid!) {
  interviewModuleDelete(id: $interviewModuleId) {
    interviewModule {
      id
    }
  }
}
    `;
export type InterviewModuleDeleteMutationFn = Apollo.MutationFunction<InterviewModuleDeleteMutation, InterviewModuleDeleteMutationVariables>;

/**
 * __useInterviewModuleDeleteMutation__
 *
 * To run a mutation, you first call `useInterviewModuleDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewModuleDeleteMutation, { data, loading, error }] = useInterviewModuleDeleteMutation({
 *   variables: {
 *      interviewModuleId: // value for 'interviewModuleId'
 *   },
 * });
 */
export function useInterviewModuleDeleteMutation(baseOptions?: Apollo.MutationHookOptions<InterviewModuleDeleteMutation, InterviewModuleDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewModuleDeleteMutation, InterviewModuleDeleteMutationVariables>(InterviewModuleDeleteDocument, options);
      }
export type InterviewModuleDeleteMutationHookResult = ReturnType<typeof useInterviewModuleDeleteMutation>;
export type InterviewModuleDeleteMutationResult = Apollo.MutationResult<InterviewModuleDeleteMutation>;
export type InterviewModuleDeleteMutationOptions = Apollo.BaseMutationOptions<InterviewModuleDeleteMutation, InterviewModuleDeleteMutationVariables>;
export const UpdateInterviewModuleSetupDocument = gql`
    mutation UpdateInterviewModuleSetup($input: InterviewModuleUpdateInput!) {
  interviewModuleUpdate(input: $input) {
    interviewModule {
      id
      ...InterviewModuleSetup_interviewModule
    }
  }
}
    ${InterviewModuleSetup_InterviewModuleFragmentDoc}`;
export type UpdateInterviewModuleSetupMutationFn = Apollo.MutationFunction<UpdateInterviewModuleSetupMutation, UpdateInterviewModuleSetupMutationVariables>;

/**
 * __useUpdateInterviewModuleSetupMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewModuleSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewModuleSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewModuleSetupMutation, { data, loading, error }] = useUpdateInterviewModuleSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewModuleSetupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewModuleSetupMutation, UpdateInterviewModuleSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewModuleSetupMutation, UpdateInterviewModuleSetupMutationVariables>(UpdateInterviewModuleSetupDocument, options);
      }
export type UpdateInterviewModuleSetupMutationHookResult = ReturnType<typeof useUpdateInterviewModuleSetupMutation>;
export type UpdateInterviewModuleSetupMutationResult = Apollo.MutationResult<UpdateInterviewModuleSetupMutation>;
export type UpdateInterviewModuleSetupMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewModuleSetupMutation, UpdateInterviewModuleSetupMutationVariables>;
export const AddMembersToModuleDocument = gql`
    mutation AddMembersToModule($input: InterviewModuleAddMembersInput!) {
  interviewModuleAddMembers(input: $input) {
    interviewModule {
      id
    }
  }
}
    `;
export type AddMembersToModuleMutationFn = Apollo.MutationFunction<AddMembersToModuleMutation, AddMembersToModuleMutationVariables>;

/**
 * __useAddMembersToModuleMutation__
 *
 * To run a mutation, you first call `useAddMembersToModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMembersToModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMembersToModuleMutation, { data, loading, error }] = useAddMembersToModuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMembersToModuleMutation(baseOptions?: Apollo.MutationHookOptions<AddMembersToModuleMutation, AddMembersToModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMembersToModuleMutation, AddMembersToModuleMutationVariables>(AddMembersToModuleDocument, options);
      }
export type AddMembersToModuleMutationHookResult = ReturnType<typeof useAddMembersToModuleMutation>;
export type AddMembersToModuleMutationResult = Apollo.MutationResult<AddMembersToModuleMutation>;
export type AddMembersToModuleMutationOptions = Apollo.BaseMutationOptions<AddMembersToModuleMutation, AddMembersToModuleMutationVariables>;
export const EmployeesToAddForInterviewModuleDocument = gql`
    query EmployeesToAddForInterviewModule($input: EmployeesInput!, $interviewModuleId: uuid!) {
  employees(input: $input) {
    nextCursor
    items {
      ...Employee
      interviewModuleMember(interviewModuleId: $interviewModuleId) {
        employeeId
        status
        interviewModuleId
      }
    }
  }
}
    ${EmployeeFragmentDoc}`;

/**
 * __useEmployeesToAddForInterviewModuleQuery__
 *
 * To run a query within a React component, call `useEmployeesToAddForInterviewModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesToAddForInterviewModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesToAddForInterviewModuleQuery({
 *   variables: {
 *      input: // value for 'input'
 *      interviewModuleId: // value for 'interviewModuleId'
 *   },
 * });
 */
export function useEmployeesToAddForInterviewModuleQuery(baseOptions: Apollo.QueryHookOptions<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables> & ({ variables: EmployeesToAddForInterviewModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>(EmployeesToAddForInterviewModuleDocument, options);
      }
export function useEmployeesToAddForInterviewModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>(EmployeesToAddForInterviewModuleDocument, options);
        }
// @ts-ignore
export function useEmployeesToAddForInterviewModuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>;
export function useEmployeesToAddForInterviewModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesToAddForInterviewModuleQuery | undefined, EmployeesToAddForInterviewModuleQueryVariables>;
export function useEmployeesToAddForInterviewModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>(EmployeesToAddForInterviewModuleDocument, options);
        }
export type EmployeesToAddForInterviewModuleQueryHookResult = ReturnType<typeof useEmployeesToAddForInterviewModuleQuery>;
export type EmployeesToAddForInterviewModuleLazyQueryHookResult = ReturnType<typeof useEmployeesToAddForInterviewModuleLazyQuery>;
export type EmployeesToAddForInterviewModuleSuspenseQueryHookResult = ReturnType<typeof useEmployeesToAddForInterviewModuleSuspenseQuery>;
export type EmployeesToAddForInterviewModuleQueryResult = Apollo.QueryResult<EmployeesToAddForInterviewModuleQuery, EmployeesToAddForInterviewModuleQueryVariables>;
export const InterviewModuleMembersListDocument = gql`
    query InterviewModuleMembersList($id: uuid!, $pageInput: PageInput!, $orderBy: InterviewModuleMemberSearchOrderBy!, $search: String, $filterByTrainingStatus: [TrainingStatus], $filterByState: [InterviewModuleMemberState]) {
  interviewModuleMemberSearch(
    input: {interviewModuleId: $id, pageInput: $pageInput, orderBy: $orderBy, search: $search, filterByTrainingStatus: $filterByTrainingStatus, filterByState: $filterByState}
  ) {
    total
    items {
      ...Members_members
    }
  }
}
    ${Members_MembersFragmentDoc}`;

/**
 * __useInterviewModuleMembersListQuery__
 *
 * To run a query within a React component, call `useInterviewModuleMembersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMembersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMembersListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageInput: // value for 'pageInput'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      filterByTrainingStatus: // value for 'filterByTrainingStatus'
 *      filterByState: // value for 'filterByState'
 *   },
 * });
 */
export function useInterviewModuleMembersListQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables> & ({ variables: InterviewModuleMembersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>(InterviewModuleMembersListDocument, options);
      }
export function useInterviewModuleMembersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>(InterviewModuleMembersListDocument, options);
        }
// @ts-ignore
export function useInterviewModuleMembersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>;
export function useInterviewModuleMembersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMembersListQuery | undefined, InterviewModuleMembersListQueryVariables>;
export function useInterviewModuleMembersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>(InterviewModuleMembersListDocument, options);
        }
export type InterviewModuleMembersListQueryHookResult = ReturnType<typeof useInterviewModuleMembersListQuery>;
export type InterviewModuleMembersListLazyQueryHookResult = ReturnType<typeof useInterviewModuleMembersListLazyQuery>;
export type InterviewModuleMembersListSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMembersListSuspenseQuery>;
export type InterviewModuleMembersListQueryResult = Apollo.QueryResult<InterviewModuleMembersListQuery, InterviewModuleMembersListQueryVariables>;
export const ModuleMembersViewDocument = gql`
    query ModuleMembersView($interviewModuleId: uuid!) {
  interviewModule(id: $interviewModuleId) {
    id
    name
    ...AddMembersModal_module
    ...MembersList_module
    ...InterviewModuleSetup_interviewModule
  }
}
    ${AddMembersModal_ModuleFragmentDoc}
${MembersList_ModuleFragmentDoc}
${InterviewModuleSetup_InterviewModuleFragmentDoc}`;

/**
 * __useModuleMembersViewQuery__
 *
 * To run a query within a React component, call `useModuleMembersViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleMembersViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleMembersViewQuery({
 *   variables: {
 *      interviewModuleId: // value for 'interviewModuleId'
 *   },
 * });
 */
export function useModuleMembersViewQuery(baseOptions: Apollo.QueryHookOptions<ModuleMembersViewQuery, ModuleMembersViewQueryVariables> & ({ variables: ModuleMembersViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>(ModuleMembersViewDocument, options);
      }
export function useModuleMembersViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>(ModuleMembersViewDocument, options);
        }
// @ts-ignore
export function useModuleMembersViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>): Apollo.UseSuspenseQueryResult<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>;
export function useModuleMembersViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>): Apollo.UseSuspenseQueryResult<ModuleMembersViewQuery | undefined, ModuleMembersViewQueryVariables>;
export function useModuleMembersViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>(ModuleMembersViewDocument, options);
        }
export type ModuleMembersViewQueryHookResult = ReturnType<typeof useModuleMembersViewQuery>;
export type ModuleMembersViewLazyQueryHookResult = ReturnType<typeof useModuleMembersViewLazyQuery>;
export type ModuleMembersViewSuspenseQueryHookResult = ReturnType<typeof useModuleMembersViewSuspenseQuery>;
export type ModuleMembersViewQueryResult = Apollo.QueryResult<ModuleMembersViewQuery, ModuleMembersViewQueryVariables>;
export const EmployeeAiTabDocument = gql`
    query EmployeeAiTab($id: uuid!) {
  employee(id: $id) {
    id
    aiInstruction {
      ...AiInstructionsCard_instruction
    }
    aiMemories {
      ...AiMemoriesCard_memory
    }
  }
}
    ${AiInstructionsCard_InstructionFragmentDoc}
${AiMemoriesCard_MemoryFragmentDoc}`;

/**
 * __useEmployeeAiTabQuery__
 *
 * To run a query within a React component, call `useEmployeeAiTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeAiTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeAiTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmployeeAiTabQuery(baseOptions: Apollo.QueryHookOptions<EmployeeAiTabQuery, EmployeeAiTabQueryVariables> & ({ variables: EmployeeAiTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>(EmployeeAiTabDocument, options);
      }
export function useEmployeeAiTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>(EmployeeAiTabDocument, options);
        }
// @ts-ignore
export function useEmployeeAiTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>;
export function useEmployeeAiTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeAiTabQuery | undefined, EmployeeAiTabQueryVariables>;
export function useEmployeeAiTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>(EmployeeAiTabDocument, options);
        }
export type EmployeeAiTabQueryHookResult = ReturnType<typeof useEmployeeAiTabQuery>;
export type EmployeeAiTabLazyQueryHookResult = ReturnType<typeof useEmployeeAiTabLazyQuery>;
export type EmployeeAiTabSuspenseQueryHookResult = ReturnType<typeof useEmployeeAiTabSuspenseQuery>;
export type EmployeeAiTabQueryResult = Apollo.QueryResult<EmployeeAiTabQuery, EmployeeAiTabQueryVariables>;
export const InterviewerAvailabilityTabDocument = gql`
    query InterviewerAvailabilityTab($employeeId: uuid!, $timeRange: DateTimeRangeInput!, $shouldRespectLoadLimit: Boolean!, $canScheduleOverRecruitingKeywords: Boolean!, $canScheduleOverAvailableKeywords: Boolean!, $canScheduleOverFreeTime: Boolean!) {
  employee(id: $employeeId) {
    id
    fullName
    timezone
    calendarTimezone
    useCalendarTimezone
    calendarDelegate {
      id
      fullName
    }
  }
  interviewerAvailability(
    input: {employeeId: $employeeId, timeRange: $timeRange, shouldRespectLoadLimit: $shouldRespectLoadLimit, canScheduleOverRecruitingKeywords: $canScheduleOverRecruitingKeywords, canScheduleOverAvailableKeywords: $canScheduleOverAvailableKeywords, canScheduleOverFreeTime: $canScheduleOverFreeTime}
  ) {
    __typename
    ... on InterviewerAvailabilitySuccess {
      id
      computationId
      windowStartAt
      windowEndAt
      intervals {
        startAt
        endAt
        type
      }
    }
    ... on CalendarUnavailableError {
      errorCode
      errorMessage
    }
    ... on EmployeeNotFoundError {
      errorCode
      errorMessage
    }
    ... on InterviewerAvailabilityInvalidWindowError {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;

/**
 * __useInterviewerAvailabilityTabQuery__
 *
 * To run a query within a React component, call `useInterviewerAvailabilityTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerAvailabilityTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerAvailabilityTabQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      timeRange: // value for 'timeRange'
 *      shouldRespectLoadLimit: // value for 'shouldRespectLoadLimit'
 *      canScheduleOverRecruitingKeywords: // value for 'canScheduleOverRecruitingKeywords'
 *      canScheduleOverAvailableKeywords: // value for 'canScheduleOverAvailableKeywords'
 *      canScheduleOverFreeTime: // value for 'canScheduleOverFreeTime'
 *   },
 * });
 */
export function useInterviewerAvailabilityTabQuery(baseOptions: Apollo.QueryHookOptions<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables> & ({ variables: InterviewerAvailabilityTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>(InterviewerAvailabilityTabDocument, options);
      }
export function useInterviewerAvailabilityTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>(InterviewerAvailabilityTabDocument, options);
        }
// @ts-ignore
export function useInterviewerAvailabilityTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>;
export function useInterviewerAvailabilityTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerAvailabilityTabQuery | undefined, InterviewerAvailabilityTabQueryVariables>;
export function useInterviewerAvailabilityTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>(InterviewerAvailabilityTabDocument, options);
        }
export type InterviewerAvailabilityTabQueryHookResult = ReturnType<typeof useInterviewerAvailabilityTabQuery>;
export type InterviewerAvailabilityTabLazyQueryHookResult = ReturnType<typeof useInterviewerAvailabilityTabLazyQuery>;
export type InterviewerAvailabilityTabSuspenseQueryHookResult = ReturnType<typeof useInterviewerAvailabilityTabSuspenseQuery>;
export type InterviewerAvailabilityTabQueryResult = Apollo.QueryResult<InterviewerAvailabilityTabQuery, InterviewerAvailabilityTabQueryVariables>;
export const AddModuleToInterviewerDocument = gql`
    mutation AddModuleToInterviewer($input: InterviewModuleAddMembersInput!) {
  interviewModuleAddMembers(input: $input) {
    interviewModule {
      id
    }
  }
}
    `;
export type AddModuleToInterviewerMutationFn = Apollo.MutationFunction<AddModuleToInterviewerMutation, AddModuleToInterviewerMutationVariables>;

/**
 * __useAddModuleToInterviewerMutation__
 *
 * To run a mutation, you first call `useAddModuleToInterviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddModuleToInterviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addModuleToInterviewerMutation, { data, loading, error }] = useAddModuleToInterviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddModuleToInterviewerMutation(baseOptions?: Apollo.MutationHookOptions<AddModuleToInterviewerMutation, AddModuleToInterviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddModuleToInterviewerMutation, AddModuleToInterviewerMutationVariables>(AddModuleToInterviewerDocument, options);
      }
export type AddModuleToInterviewerMutationHookResult = ReturnType<typeof useAddModuleToInterviewerMutation>;
export type AddModuleToInterviewerMutationResult = Apollo.MutationResult<AddModuleToInterviewerMutation>;
export type AddModuleToInterviewerMutationOptions = Apollo.BaseMutationOptions<AddModuleToInterviewerMutation, AddModuleToInterviewerMutationVariables>;
export const InterviewerInterviewModuleMemberLookupDocument = gql`
    query InterviewerInterviewModuleMemberLookup($memberIds: [uuid!]!) {
  interviewModuleMemberLookup(input: {interviewModuleMemberIds: $memberIds}) {
    items {
      interviewModuleId
      employeeId
      ...Modules_memberModules
      employee {
        id
        ...ModulesList_employee
      }
    }
  }
}
    ${Modules_MemberModulesFragmentDoc}
${ModulesList_EmployeeFragmentDoc}`;

/**
 * __useInterviewerInterviewModuleMemberLookupQuery__
 *
 * To run a query within a React component, call `useInterviewerInterviewModuleMemberLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerInterviewModuleMemberLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerInterviewModuleMemberLookupQuery({
 *   variables: {
 *      memberIds: // value for 'memberIds'
 *   },
 * });
 */
export function useInterviewerInterviewModuleMemberLookupQuery(baseOptions: Apollo.QueryHookOptions<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables> & ({ variables: InterviewerInterviewModuleMemberLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>(InterviewerInterviewModuleMemberLookupDocument, options);
      }
export function useInterviewerInterviewModuleMemberLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>(InterviewerInterviewModuleMemberLookupDocument, options);
        }
// @ts-ignore
export function useInterviewerInterviewModuleMemberLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>;
export function useInterviewerInterviewModuleMemberLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerInterviewModuleMemberLookupQuery | undefined, InterviewerInterviewModuleMemberLookupQueryVariables>;
export function useInterviewerInterviewModuleMemberLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>(InterviewerInterviewModuleMemberLookupDocument, options);
        }
export type InterviewerInterviewModuleMemberLookupQueryHookResult = ReturnType<typeof useInterviewerInterviewModuleMemberLookupQuery>;
export type InterviewerInterviewModuleMemberLookupLazyQueryHookResult = ReturnType<typeof useInterviewerInterviewModuleMemberLookupLazyQuery>;
export type InterviewerInterviewModuleMemberLookupSuspenseQueryHookResult = ReturnType<typeof useInterviewerInterviewModuleMemberLookupSuspenseQuery>;
export type InterviewerInterviewModuleMemberLookupQueryResult = Apollo.QueryResult<InterviewerInterviewModuleMemberLookupQuery, InterviewerInterviewModuleMemberLookupQueryVariables>;
export const AboutSectionEditDialogDocument = gql`
    query AboutSectionEditDialog($input: EmployeeAttributeNamesInput!) {
  employeeAttributeNames(input: $input) {
    items {
      id
      name
      type
      syncSourceType
      values {
        id
        name: value
        parent: name {
          id
          syncSourceType
        }
      }
    }
  }
  thisOrg {
    id
    orgPref(prefName: "obj_employee_field_sync_source") {
      id
      orgId
      prefName
      jsonPref {
        ... on EmployeeFieldSyncSourcePref {
          manager
        }
      }
    }
  }
}
    `;

/**
 * __useAboutSectionEditDialogQuery__
 *
 * To run a query within a React component, call `useAboutSectionEditDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutSectionEditDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutSectionEditDialogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAboutSectionEditDialogQuery(baseOptions: Apollo.QueryHookOptions<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables> & ({ variables: AboutSectionEditDialogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>(AboutSectionEditDialogDocument, options);
      }
export function useAboutSectionEditDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>(AboutSectionEditDialogDocument, options);
        }
// @ts-ignore
export function useAboutSectionEditDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>;
export function useAboutSectionEditDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AboutSectionEditDialogQuery | undefined, AboutSectionEditDialogQueryVariables>;
export function useAboutSectionEditDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>(AboutSectionEditDialogDocument, options);
        }
export type AboutSectionEditDialogQueryHookResult = ReturnType<typeof useAboutSectionEditDialogQuery>;
export type AboutSectionEditDialogLazyQueryHookResult = ReturnType<typeof useAboutSectionEditDialogLazyQuery>;
export type AboutSectionEditDialogSuspenseQueryHookResult = ReturnType<typeof useAboutSectionEditDialogSuspenseQuery>;
export type AboutSectionEditDialogQueryResult = Apollo.QueryResult<AboutSectionEditDialogQuery, AboutSectionEditDialogQueryVariables>;
export const InterviewerUpdateDocument = gql`
    mutation InterviewerUpdate($input: EmployeeUpdateInput!) {
  employeeUpdate(input: $input) {
    employee {
      ...InterviewerAboutSection_interviewer
    }
  }
}
    ${InterviewerAboutSection_InterviewerFragmentDoc}`;
export type InterviewerUpdateMutationFn = Apollo.MutationFunction<InterviewerUpdateMutation, InterviewerUpdateMutationVariables>;

/**
 * __useInterviewerUpdateMutation__
 *
 * To run a mutation, you first call `useInterviewerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewerUpdateMutation, { data, loading, error }] = useInterviewerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InterviewerUpdateMutation, InterviewerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewerUpdateMutation, InterviewerUpdateMutationVariables>(InterviewerUpdateDocument, options);
      }
export type InterviewerUpdateMutationHookResult = ReturnType<typeof useInterviewerUpdateMutation>;
export type InterviewerUpdateMutationResult = Apollo.MutationResult<InterviewerUpdateMutation>;
export type InterviewerUpdateMutationOptions = Apollo.BaseMutationOptions<InterviewerUpdateMutation, InterviewerUpdateMutationVariables>;
export const InterviewerUpdateAttributesDocument = gql`
    mutation InterviewerUpdateAttributes($input: EmployeeAttributesInput!) {
  employeeAttributesUpsert(input: $input) {
    employee {
      ...InterviewerAboutSection_interviewer
    }
  }
}
    ${InterviewerAboutSection_InterviewerFragmentDoc}`;
export type InterviewerUpdateAttributesMutationFn = Apollo.MutationFunction<InterviewerUpdateAttributesMutation, InterviewerUpdateAttributesMutationVariables>;

/**
 * __useInterviewerUpdateAttributesMutation__
 *
 * To run a mutation, you first call `useInterviewerUpdateAttributesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewerUpdateAttributesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewerUpdateAttributesMutation, { data, loading, error }] = useInterviewerUpdateAttributesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewerUpdateAttributesMutation(baseOptions?: Apollo.MutationHookOptions<InterviewerUpdateAttributesMutation, InterviewerUpdateAttributesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewerUpdateAttributesMutation, InterviewerUpdateAttributesMutationVariables>(InterviewerUpdateAttributesDocument, options);
      }
export type InterviewerUpdateAttributesMutationHookResult = ReturnType<typeof useInterviewerUpdateAttributesMutation>;
export type InterviewerUpdateAttributesMutationResult = Apollo.MutationResult<InterviewerUpdateAttributesMutation>;
export type InterviewerUpdateAttributesMutationOptions = Apollo.BaseMutationOptions<InterviewerUpdateAttributesMutation, InterviewerUpdateAttributesMutationVariables>;
export const AtsUserEmployeeAssociationUpdateDocument = gql`
    mutation AtsUserEmployeeAssociationUpdate($input: AtsUserEmployeeAssociationUpdateInput!) {
  atsUserEmployeeAssociationUpdate(input: $input) {
    atsUser {
      ...AtsUser
    }
  }
}
    ${AtsUserFragmentDoc}`;
export type AtsUserEmployeeAssociationUpdateMutationFn = Apollo.MutationFunction<AtsUserEmployeeAssociationUpdateMutation, AtsUserEmployeeAssociationUpdateMutationVariables>;

/**
 * __useAtsUserEmployeeAssociationUpdateMutation__
 *
 * To run a mutation, you first call `useAtsUserEmployeeAssociationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtsUserEmployeeAssociationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atsUserEmployeeAssociationUpdateMutation, { data, loading, error }] = useAtsUserEmployeeAssociationUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsUserEmployeeAssociationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AtsUserEmployeeAssociationUpdateMutation, AtsUserEmployeeAssociationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AtsUserEmployeeAssociationUpdateMutation, AtsUserEmployeeAssociationUpdateMutationVariables>(AtsUserEmployeeAssociationUpdateDocument, options);
      }
export type AtsUserEmployeeAssociationUpdateMutationHookResult = ReturnType<typeof useAtsUserEmployeeAssociationUpdateMutation>;
export type AtsUserEmployeeAssociationUpdateMutationResult = Apollo.MutationResult<AtsUserEmployeeAssociationUpdateMutation>;
export type AtsUserEmployeeAssociationUpdateMutationOptions = Apollo.BaseMutationOptions<AtsUserEmployeeAssociationUpdateMutation, AtsUserEmployeeAssociationUpdateMutationVariables>;
export const AttributesSectionEditDialogDocument = gql`
    query AttributesSectionEditDialog($input: EmployeeAttributeNamesInput!) {
  employeeAttributeNames(input: $input) {
    items {
      ...AttributeEditRow_employeeAttributeParent
    }
  }
}
    ${AttributeEditRow_EmployeeAttributeParentFragmentDoc}`;

/**
 * __useAttributesSectionEditDialogQuery__
 *
 * To run a query within a React component, call `useAttributesSectionEditDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributesSectionEditDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributesSectionEditDialogQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributesSectionEditDialogQuery(baseOptions: Apollo.QueryHookOptions<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables> & ({ variables: AttributesSectionEditDialogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>(AttributesSectionEditDialogDocument, options);
      }
export function useAttributesSectionEditDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>(AttributesSectionEditDialogDocument, options);
        }
// @ts-ignore
export function useAttributesSectionEditDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>;
export function useAttributesSectionEditDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>): Apollo.UseSuspenseQueryResult<AttributesSectionEditDialogQuery | undefined, AttributesSectionEditDialogQueryVariables>;
export function useAttributesSectionEditDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>(AttributesSectionEditDialogDocument, options);
        }
export type AttributesSectionEditDialogQueryHookResult = ReturnType<typeof useAttributesSectionEditDialogQuery>;
export type AttributesSectionEditDialogLazyQueryHookResult = ReturnType<typeof useAttributesSectionEditDialogLazyQuery>;
export type AttributesSectionEditDialogSuspenseQueryHookResult = ReturnType<typeof useAttributesSectionEditDialogSuspenseQuery>;
export type AttributesSectionEditDialogQueryResult = Apollo.QueryResult<AttributesSectionEditDialogQuery, AttributesSectionEditDialogQueryVariables>;
export const AttributeSectionDocument = gql`
    query AttributeSection($input: EmployeeAttributeNamesInput!) {
  employeeAttributeNames(input: $input) {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useAttributeSectionQuery__
 *
 * To run a query within a React component, call `useAttributeSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeSectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeSectionQuery(baseOptions: Apollo.QueryHookOptions<AttributeSectionQuery, AttributeSectionQueryVariables> & ({ variables: AttributeSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeSectionQuery, AttributeSectionQueryVariables>(AttributeSectionDocument, options);
      }
export function useAttributeSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeSectionQuery, AttributeSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeSectionQuery, AttributeSectionQueryVariables>(AttributeSectionDocument, options);
        }
// @ts-ignore
export function useAttributeSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttributeSectionQuery, AttributeSectionQueryVariables>): Apollo.UseSuspenseQueryResult<AttributeSectionQuery, AttributeSectionQueryVariables>;
export function useAttributeSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributeSectionQuery, AttributeSectionQueryVariables>): Apollo.UseSuspenseQueryResult<AttributeSectionQuery | undefined, AttributeSectionQueryVariables>;
export function useAttributeSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributeSectionQuery, AttributeSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttributeSectionQuery, AttributeSectionQueryVariables>(AttributeSectionDocument, options);
        }
export type AttributeSectionQueryHookResult = ReturnType<typeof useAttributeSectionQuery>;
export type AttributeSectionLazyQueryHookResult = ReturnType<typeof useAttributeSectionLazyQuery>;
export type AttributeSectionSuspenseQueryHookResult = ReturnType<typeof useAttributeSectionSuspenseQuery>;
export type AttributeSectionQueryResult = Apollo.QueryResult<AttributeSectionQuery, AttributeSectionQueryVariables>;
export const AvailabilitySectionSaveDocument = gql`
    mutation AvailabilitySectionSave($input: EmployeeUpdateInput!, $date: date!, $timezone: String!) {
  employeeUpdate(input: $input) {
    employee {
      ...AvailabilitySection_interviewer
    }
  }
}
    ${AvailabilitySection_InterviewerFragmentDoc}`;
export type AvailabilitySectionSaveMutationFn = Apollo.MutationFunction<AvailabilitySectionSaveMutation, AvailabilitySectionSaveMutationVariables>;

/**
 * __useAvailabilitySectionSaveMutation__
 *
 * To run a mutation, you first call `useAvailabilitySectionSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAvailabilitySectionSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [availabilitySectionSaveMutation, { data, loading, error }] = useAvailabilitySectionSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *      date: // value for 'date'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useAvailabilitySectionSaveMutation(baseOptions?: Apollo.MutationHookOptions<AvailabilitySectionSaveMutation, AvailabilitySectionSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AvailabilitySectionSaveMutation, AvailabilitySectionSaveMutationVariables>(AvailabilitySectionSaveDocument, options);
      }
export type AvailabilitySectionSaveMutationHookResult = ReturnType<typeof useAvailabilitySectionSaveMutation>;
export type AvailabilitySectionSaveMutationResult = Apollo.MutationResult<AvailabilitySectionSaveMutation>;
export type AvailabilitySectionSaveMutationOptions = Apollo.BaseMutationOptions<AvailabilitySectionSaveMutation, AvailabilitySectionSaveMutationVariables>;
export const ExternalProfileUpdateInterviewerDocument = gql`
    mutation ExternalProfileUpdateInterviewer($pronounsInput: EmployeePrefUpdateInput!, $profileImageInput: EmployeePrefUpdateInput!, $bioInput: EmployeePrefUpdateInput!, $input: EmployeeUpdateInput!) {
  bioUpdate: employeePrefUpdate(input: $bioInput) {
    employeePref {
      employeeId
      orgId
      prefName
    }
  }
  pronounsUpdate: employeePrefUpdate(input: $pronounsInput) {
    employeePref {
      employeeId
      orgId
      prefName
    }
  }
  profileImageUpdate: employeePrefUpdate(input: $profileImageInput) {
    employeePref {
      employeeId
      orgId
      prefName
    }
  }
  employeeUpdate(input: $input) {
    employee {
      ...ExternalProfileModalInterviewer
    }
  }
}
    ${ExternalProfileModalInterviewerFragmentDoc}`;
export type ExternalProfileUpdateInterviewerMutationFn = Apollo.MutationFunction<ExternalProfileUpdateInterviewerMutation, ExternalProfileUpdateInterviewerMutationVariables>;

/**
 * __useExternalProfileUpdateInterviewerMutation__
 *
 * To run a mutation, you first call `useExternalProfileUpdateInterviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalProfileUpdateInterviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalProfileUpdateInterviewerMutation, { data, loading, error }] = useExternalProfileUpdateInterviewerMutation({
 *   variables: {
 *      pronounsInput: // value for 'pronounsInput'
 *      profileImageInput: // value for 'profileImageInput'
 *      bioInput: // value for 'bioInput'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalProfileUpdateInterviewerMutation(baseOptions?: Apollo.MutationHookOptions<ExternalProfileUpdateInterviewerMutation, ExternalProfileUpdateInterviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExternalProfileUpdateInterviewerMutation, ExternalProfileUpdateInterviewerMutationVariables>(ExternalProfileUpdateInterviewerDocument, options);
      }
export type ExternalProfileUpdateInterviewerMutationHookResult = ReturnType<typeof useExternalProfileUpdateInterviewerMutation>;
export type ExternalProfileUpdateInterviewerMutationResult = Apollo.MutationResult<ExternalProfileUpdateInterviewerMutation>;
export type ExternalProfileUpdateInterviewerMutationOptions = Apollo.BaseMutationOptions<ExternalProfileUpdateInterviewerMutation, ExternalProfileUpdateInterviewerMutationVariables>;
export const EmployeeKeywordsDocument = gql`
    query EmployeeKeywords($employeeId: uuid!, $orgKeywordNames: [String!]!, $employeeKeywordNames: [String!]!) {
  thisOrg {
    id
    orgPrefByNames(prefNames: $orgKeywordNames) {
      orgId
      prefName
      stringArray
    }
  }
  employee(id: $employeeId) {
    id
    employeePrefByNames(prefNames: $employeeKeywordNames) {
      id
      orgId
      employeeId
      prefName
      stringArray
    }
  }
}
    `;

/**
 * __useEmployeeKeywordsQuery__
 *
 * To run a query within a React component, call `useEmployeeKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeKeywordsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      orgKeywordNames: // value for 'orgKeywordNames'
 *      employeeKeywordNames: // value for 'employeeKeywordNames'
 *   },
 * });
 */
export function useEmployeeKeywordsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables> & ({ variables: EmployeeKeywordsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>(EmployeeKeywordsDocument, options);
      }
export function useEmployeeKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>(EmployeeKeywordsDocument, options);
        }
// @ts-ignore
export function useEmployeeKeywordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>;
export function useEmployeeKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeKeywordsQuery | undefined, EmployeeKeywordsQueryVariables>;
export function useEmployeeKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>(EmployeeKeywordsDocument, options);
        }
export type EmployeeKeywordsQueryHookResult = ReturnType<typeof useEmployeeKeywordsQuery>;
export type EmployeeKeywordsLazyQueryHookResult = ReturnType<typeof useEmployeeKeywordsLazyQuery>;
export type EmployeeKeywordsSuspenseQueryHookResult = ReturnType<typeof useEmployeeKeywordsSuspenseQuery>;
export type EmployeeKeywordsQueryResult = Apollo.QueryResult<EmployeeKeywordsQuery, EmployeeKeywordsQueryVariables>;
export const DeletePlannedAvailabilityDocument = gql`
    mutation DeletePlannedAvailability($input: EmployeePlannedAvailabilityDeleteInput!) {
  employeePlannedAvailabilityDelete(input: $input) {
    result
  }
}
    `;
export type DeletePlannedAvailabilityMutationFn = Apollo.MutationFunction<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>;

/**
 * __useDeletePlannedAvailabilityMutation__
 *
 * To run a mutation, you first call `useDeletePlannedAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlannedAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlannedAvailabilityMutation, { data, loading, error }] = useDeletePlannedAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlannedAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>(DeletePlannedAvailabilityDocument, options);
      }
export type DeletePlannedAvailabilityMutationHookResult = ReturnType<typeof useDeletePlannedAvailabilityMutation>;
export type DeletePlannedAvailabilityMutationResult = Apollo.MutationResult<DeletePlannedAvailabilityMutation>;
export type DeletePlannedAvailabilityMutationOptions = Apollo.BaseMutationOptions<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>;
export const CreatePlannedAvailabilityDocument = gql`
    mutation CreatePlannedAvailability($input: EmployeePlannedAvailabilityCreateInput!) {
  employeePlannedAvailabilityCreate(input: $input) {
    item {
      ...TemporaryAvailabilityDialog_plannedAvailability
    }
  }
}
    ${TemporaryAvailabilityDialog_PlannedAvailabilityFragmentDoc}`;
export type CreatePlannedAvailabilityMutationFn = Apollo.MutationFunction<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>;

/**
 * __useCreatePlannedAvailabilityMutation__
 *
 * To run a mutation, you first call `useCreatePlannedAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlannedAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlannedAvailabilityMutation, { data, loading, error }] = useCreatePlannedAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlannedAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>(CreatePlannedAvailabilityDocument, options);
      }
export type CreatePlannedAvailabilityMutationHookResult = ReturnType<typeof useCreatePlannedAvailabilityMutation>;
export type CreatePlannedAvailabilityMutationResult = Apollo.MutationResult<CreatePlannedAvailabilityMutation>;
export type CreatePlannedAvailabilityMutationOptions = Apollo.BaseMutationOptions<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>;
export const UpdatePlannedAvailabilityDocument = gql`
    mutation UpdatePlannedAvailability($input: EmployeePlannedAvailabilityUpdateInput!) {
  employeePlannedAvailabilityUpdate(input: $input) {
    item {
      ...TemporaryAvailabilityDialog_plannedAvailability
    }
  }
}
    ${TemporaryAvailabilityDialog_PlannedAvailabilityFragmentDoc}`;
export type UpdatePlannedAvailabilityMutationFn = Apollo.MutationFunction<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>;

/**
 * __useUpdatePlannedAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlannedAvailabilityMutation, { data, loading, error }] = useUpdatePlannedAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannedAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>(UpdatePlannedAvailabilityDocument, options);
      }
export type UpdatePlannedAvailabilityMutationHookResult = ReturnType<typeof useUpdatePlannedAvailabilityMutation>;
export type UpdatePlannedAvailabilityMutationResult = Apollo.MutationResult<UpdatePlannedAvailabilityMutation>;
export type UpdatePlannedAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>;
export const UpdatePauseDatesDocument = gql`
    mutation UpdatePauseDates($input: EmployeeUpdateInput!) {
  employeeUpdate(input: $input) {
    employee {
      id
      ...PlannedAvailabilitySection_interviewer
      isPaused
    }
  }
}
    ${PlannedAvailabilitySection_InterviewerFragmentDoc}`;
export type UpdatePauseDatesMutationFn = Apollo.MutationFunction<UpdatePauseDatesMutation, UpdatePauseDatesMutationVariables>;

/**
 * __useUpdatePauseDatesMutation__
 *
 * To run a mutation, you first call `useUpdatePauseDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePauseDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePauseDatesMutation, { data, loading, error }] = useUpdatePauseDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePauseDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePauseDatesMutation, UpdatePauseDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePauseDatesMutation, UpdatePauseDatesMutationVariables>(UpdatePauseDatesDocument, options);
      }
export type UpdatePauseDatesMutationHookResult = ReturnType<typeof useUpdatePauseDatesMutation>;
export type UpdatePauseDatesMutationResult = Apollo.MutationResult<UpdatePauseDatesMutation>;
export type UpdatePauseDatesMutationOptions = Apollo.BaseMutationOptions<UpdatePauseDatesMutation, UpdatePauseDatesMutationVariables>;
export const InterviewsTabInterviewerDocument = gql`
    query InterviewsTabInterviewer($id: uuid!, $input: EmployeeApplicationStageInterviewsInput!) {
  employee(id: $id) {
    id
    ...InterviewsTab_interviewer
  }
}
    ${InterviewsTab_InterviewerFragmentDoc}`;

/**
 * __useInterviewsTabInterviewerQuery__
 *
 * To run a query within a React component, call `useInterviewsTabInterviewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewsTabInterviewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewsTabInterviewerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewsTabInterviewerQuery(baseOptions: Apollo.QueryHookOptions<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables> & ({ variables: InterviewsTabInterviewerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>(InterviewsTabInterviewerDocument, options);
      }
export function useInterviewsTabInterviewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>(InterviewsTabInterviewerDocument, options);
        }
// @ts-ignore
export function useInterviewsTabInterviewerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>;
export function useInterviewsTabInterviewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsTabInterviewerQuery | undefined, InterviewsTabInterviewerQueryVariables>;
export function useInterviewsTabInterviewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>(InterviewsTabInterviewerDocument, options);
        }
export type InterviewsTabInterviewerQueryHookResult = ReturnType<typeof useInterviewsTabInterviewerQuery>;
export type InterviewsTabInterviewerLazyQueryHookResult = ReturnType<typeof useInterviewsTabInterviewerLazyQuery>;
export type InterviewsTabInterviewerSuspenseQueryHookResult = ReturnType<typeof useInterviewsTabInterviewerSuspenseQuery>;
export type InterviewsTabInterviewerQueryResult = Apollo.QueryResult<InterviewsTabInterviewerQuery, InterviewsTabInterviewerQueryVariables>;
export const EmployeeDetailsViewDocument = gql`
    query EmployeeDetailsView($id: uuid!, $date: date!, $timezone: String!) {
  employee(id: $id) {
    ...InterviewerInfoContainer_employee
    ...InterviewModulesTab_employee
    ...EmployeeDetailsFragment
  }
  thisOrg {
    id
    orgPref(prefName: "obj_employee_field_sync_source") {
      id
      orgId
      prefName
      jsonPref {
        ... on EmployeeFieldSyncSourcePref {
          ...InterviewerInfoContainer_interviewerFieldsSyncSource
        }
      }
    }
  }
}
    ${InterviewerInfoContainer_EmployeeFragmentDoc}
${InterviewModulesTab_EmployeeFragmentDoc}
${EmployeeDetailsFragmentFragmentDoc}
${InterviewerInfoContainer_InterviewerFieldsSyncSourceFragmentDoc}`;

/**
 * __useEmployeeDetailsViewQuery__
 *
 * To run a query within a React component, call `useEmployeeDetailsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeDetailsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeDetailsViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useEmployeeDetailsViewQuery(baseOptions: Apollo.QueryHookOptions<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables> & ({ variables: EmployeeDetailsViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>(EmployeeDetailsViewDocument, options);
      }
export function useEmployeeDetailsViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>(EmployeeDetailsViewDocument, options);
        }
// @ts-ignore
export function useEmployeeDetailsViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>;
export function useEmployeeDetailsViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeDetailsViewQuery | undefined, EmployeeDetailsViewQueryVariables>;
export function useEmployeeDetailsViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>(EmployeeDetailsViewDocument, options);
        }
export type EmployeeDetailsViewQueryHookResult = ReturnType<typeof useEmployeeDetailsViewQuery>;
export type EmployeeDetailsViewLazyQueryHookResult = ReturnType<typeof useEmployeeDetailsViewLazyQuery>;
export type EmployeeDetailsViewSuspenseQueryHookResult = ReturnType<typeof useEmployeeDetailsViewSuspenseQuery>;
export type EmployeeDetailsViewQueryResult = Apollo.QueryResult<EmployeeDetailsViewQuery, EmployeeDetailsViewQueryVariables>;
export const JobAiTabDocument = gql`
    query JobAiTab($id: uuid!) {
  job(id: $id) {
    id
    aiInstruction {
      ...AiInstructionsCard_instruction
    }
    aiMemories {
      ...AiMemoriesCard_memory
    }
  }
}
    ${AiInstructionsCard_InstructionFragmentDoc}
${AiMemoriesCard_MemoryFragmentDoc}`;

/**
 * __useJobAiTabQuery__
 *
 * To run a query within a React component, call `useJobAiTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobAiTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobAiTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobAiTabQuery(baseOptions: Apollo.QueryHookOptions<JobAiTabQuery, JobAiTabQueryVariables> & ({ variables: JobAiTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobAiTabQuery, JobAiTabQueryVariables>(JobAiTabDocument, options);
      }
export function useJobAiTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobAiTabQuery, JobAiTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobAiTabQuery, JobAiTabQueryVariables>(JobAiTabDocument, options);
        }
// @ts-ignore
export function useJobAiTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobAiTabQuery, JobAiTabQueryVariables>): Apollo.UseSuspenseQueryResult<JobAiTabQuery, JobAiTabQueryVariables>;
export function useJobAiTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobAiTabQuery, JobAiTabQueryVariables>): Apollo.UseSuspenseQueryResult<JobAiTabQuery | undefined, JobAiTabQueryVariables>;
export function useJobAiTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobAiTabQuery, JobAiTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobAiTabQuery, JobAiTabQueryVariables>(JobAiTabDocument, options);
        }
export type JobAiTabQueryHookResult = ReturnType<typeof useJobAiTabQuery>;
export type JobAiTabLazyQueryHookResult = ReturnType<typeof useJobAiTabLazyQuery>;
export type JobAiTabSuspenseQueryHookResult = ReturnType<typeof useJobAiTabSuspenseQuery>;
export type JobAiTabQueryResult = Apollo.QueryResult<JobAiTabQuery, JobAiTabQueryVariables>;
export const CandidatePortalPreviewDocument = gql`
    query CandidatePortalPreview($jobId: uuid!) {
  job(id: $jobId) {
    id
    name
    jobStages {
      ...PortalPreviewByJobStage_jobStages
    }
    jobSettings {
      id
      recruitingTeamContactInfoSetting {
        ...PortalPreviewByJobStage_recruitingTeamContactInfo
      }
    }
  }
  brandingThemes {
    items {
      id
      isOrgDefault
      ...PortalPreviewByJobStage_brandingTheme
    }
  }
}
    ${PortalPreviewByJobStage_JobStagesFragmentDoc}
${PortalPreviewByJobStage_RecruitingTeamContactInfoFragmentDoc}
${PortalPreviewByJobStage_BrandingThemeFragmentDoc}`;

/**
 * __useCandidatePortalPreviewQuery__
 *
 * To run a query within a React component, call `useCandidatePortalPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidatePortalPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidatePortalPreviewQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCandidatePortalPreviewQuery(baseOptions: Apollo.QueryHookOptions<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables> & ({ variables: CandidatePortalPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>(CandidatePortalPreviewDocument, options);
      }
export function useCandidatePortalPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>(CandidatePortalPreviewDocument, options);
        }
// @ts-ignore
export function useCandidatePortalPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>;
export function useCandidatePortalPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<CandidatePortalPreviewQuery | undefined, CandidatePortalPreviewQueryVariables>;
export function useCandidatePortalPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>(CandidatePortalPreviewDocument, options);
        }
export type CandidatePortalPreviewQueryHookResult = ReturnType<typeof useCandidatePortalPreviewQuery>;
export type CandidatePortalPreviewLazyQueryHookResult = ReturnType<typeof useCandidatePortalPreviewLazyQuery>;
export type CandidatePortalPreviewSuspenseQueryHookResult = ReturnType<typeof useCandidatePortalPreviewSuspenseQuery>;
export type CandidatePortalPreviewQueryResult = Apollo.QueryResult<CandidatePortalPreviewQuery, CandidatePortalPreviewQueryVariables>;
export const JobPortalConfigDocument = gql`
    query JobPortalConfig($jobId: uuid!) {
  job(id: $jobId) {
    id
    externalJobName
    jobStages {
      id
      name
      index
    }
    portalJobOptions {
      id
      intro
      brandingThemeId
      useOrgDefaultBrandingTheme
      aiAssistantId
      linkedPortalConfig {
        id
        name
        tabs {
          id
          name
          icon
          index
          portalTemplateId
          visibility
          stageNameFilter
        }
      }
      tabs {
        id
        name
        icon
        index
        portalTemplateId
        visibility
        stageNameFilter
        jobStageId
      }
    }
  }
  portalConfigs {
    items {
      id
      name
      isDefault
      intro
      brandingThemeId
      aiAssistantId
      tabs {
        id
        name
        icon
        index
        portalTemplateId
        visibility
        stageNameFilter
      }
    }
  }
}
    `;

/**
 * __useJobPortalConfigQuery__
 *
 * To run a query within a React component, call `useJobPortalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPortalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPortalConfigQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobPortalConfigQuery(baseOptions: Apollo.QueryHookOptions<JobPortalConfigQuery, JobPortalConfigQueryVariables> & ({ variables: JobPortalConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPortalConfigQuery, JobPortalConfigQueryVariables>(JobPortalConfigDocument, options);
      }
export function useJobPortalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPortalConfigQuery, JobPortalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPortalConfigQuery, JobPortalConfigQueryVariables>(JobPortalConfigDocument, options);
        }
// @ts-ignore
export function useJobPortalConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPortalConfigQuery, JobPortalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<JobPortalConfigQuery, JobPortalConfigQueryVariables>;
export function useJobPortalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPortalConfigQuery, JobPortalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<JobPortalConfigQuery | undefined, JobPortalConfigQueryVariables>;
export function useJobPortalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPortalConfigQuery, JobPortalConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPortalConfigQuery, JobPortalConfigQueryVariables>(JobPortalConfigDocument, options);
        }
export type JobPortalConfigQueryHookResult = ReturnType<typeof useJobPortalConfigQuery>;
export type JobPortalConfigLazyQueryHookResult = ReturnType<typeof useJobPortalConfigLazyQuery>;
export type JobPortalConfigSuspenseQueryHookResult = ReturnType<typeof useJobPortalConfigSuspenseQuery>;
export type JobPortalConfigQueryResult = Apollo.QueryResult<JobPortalConfigQuery, JobPortalConfigQueryVariables>;
export const JobPortalConfigLinkDocument = gql`
    mutation JobPortalConfigLink($input: PortalJobOptionsLinkToConfigInput!) {
  portalJobOptionsLinkToConfig(input: $input) {
    result
  }
}
    `;
export type JobPortalConfigLinkMutationFn = Apollo.MutationFunction<JobPortalConfigLinkMutation, JobPortalConfigLinkMutationVariables>;

/**
 * __useJobPortalConfigLinkMutation__
 *
 * To run a mutation, you first call `useJobPortalConfigLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobPortalConfigLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobPortalConfigLinkMutation, { data, loading, error }] = useJobPortalConfigLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobPortalConfigLinkMutation(baseOptions?: Apollo.MutationHookOptions<JobPortalConfigLinkMutation, JobPortalConfigLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobPortalConfigLinkMutation, JobPortalConfigLinkMutationVariables>(JobPortalConfigLinkDocument, options);
      }
export type JobPortalConfigLinkMutationHookResult = ReturnType<typeof useJobPortalConfigLinkMutation>;
export type JobPortalConfigLinkMutationResult = Apollo.MutationResult<JobPortalConfigLinkMutation>;
export type JobPortalConfigLinkMutationOptions = Apollo.BaseMutationOptions<JobPortalConfigLinkMutation, JobPortalConfigLinkMutationVariables>;
export const JobPortalConfigUnlinkDocument = gql`
    mutation JobPortalConfigUnlink($id: uuid!) {
  portalJobOptionsUnlinkFromConfig(id: $id) {
    result
  }
}
    `;
export type JobPortalConfigUnlinkMutationFn = Apollo.MutationFunction<JobPortalConfigUnlinkMutation, JobPortalConfigUnlinkMutationVariables>;

/**
 * __useJobPortalConfigUnlinkMutation__
 *
 * To run a mutation, you first call `useJobPortalConfigUnlinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobPortalConfigUnlinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobPortalConfigUnlinkMutation, { data, loading, error }] = useJobPortalConfigUnlinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobPortalConfigUnlinkMutation(baseOptions?: Apollo.MutationHookOptions<JobPortalConfigUnlinkMutation, JobPortalConfigUnlinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobPortalConfigUnlinkMutation, JobPortalConfigUnlinkMutationVariables>(JobPortalConfigUnlinkDocument, options);
      }
export type JobPortalConfigUnlinkMutationHookResult = ReturnType<typeof useJobPortalConfigUnlinkMutation>;
export type JobPortalConfigUnlinkMutationResult = Apollo.MutationResult<JobPortalConfigUnlinkMutation>;
export type JobPortalConfigUnlinkMutationOptions = Apollo.BaseMutationOptions<JobPortalConfigUnlinkMutation, JobPortalConfigUnlinkMutationVariables>;
export const JobPortalOptionsDocument = gql`
    query JobPortalOptions($id: uuid!) {
  job(id: $id) {
    id
    externalJobName
    settings: portalJobOptions {
      id
      ...Settings_portalJobOptions
    }
    customTabs: portalJobOptions {
      id
      tabs {
        jobStage {
          id
        }
        ...CustomTabs_customTabs
      }
    }
  }
}
    ${Settings_PortalJobOptionsFragmentDoc}
${CustomTabs_CustomTabsFragmentDoc}`;

/**
 * __useJobPortalOptionsQuery__
 *
 * To run a query within a React component, call `useJobPortalOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPortalOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPortalOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobPortalOptionsQuery(baseOptions: Apollo.QueryHookOptions<JobPortalOptionsQuery, JobPortalOptionsQueryVariables> & ({ variables: JobPortalOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>(JobPortalOptionsDocument, options);
      }
export function useJobPortalOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>(JobPortalOptionsDocument, options);
        }
// @ts-ignore
export function useJobPortalOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>;
export function useJobPortalOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<JobPortalOptionsQuery | undefined, JobPortalOptionsQueryVariables>;
export function useJobPortalOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>(JobPortalOptionsDocument, options);
        }
export type JobPortalOptionsQueryHookResult = ReturnType<typeof useJobPortalOptionsQuery>;
export type JobPortalOptionsLazyQueryHookResult = ReturnType<typeof useJobPortalOptionsLazyQuery>;
export type JobPortalOptionsSuspenseQueryHookResult = ReturnType<typeof useJobPortalOptionsSuspenseQuery>;
export type JobPortalOptionsQueryResult = Apollo.QueryResult<JobPortalOptionsQuery, JobPortalOptionsQueryVariables>;
export const JobPortalOptionMutationDocument = gql`
    mutation JobPortalOptionMutation($input: PortalJobOptionsUpsertInput!) {
  portalJobOptionsUpsert(input: $input) {
    options {
      id
      ...Settings_portalJobOptions
      tabs {
        ...CustomTabs_customTabs
      }
    }
  }
}
    ${Settings_PortalJobOptionsFragmentDoc}
${CustomTabs_CustomTabsFragmentDoc}`;
export type JobPortalOptionMutationMutationFn = Apollo.MutationFunction<JobPortalOptionMutationMutation, JobPortalOptionMutationMutationVariables>;

/**
 * __useJobPortalOptionMutationMutation__
 *
 * To run a mutation, you first call `useJobPortalOptionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobPortalOptionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobPortalOptionMutationMutation, { data, loading, error }] = useJobPortalOptionMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobPortalOptionMutationMutation(baseOptions?: Apollo.MutationHookOptions<JobPortalOptionMutationMutation, JobPortalOptionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobPortalOptionMutationMutation, JobPortalOptionMutationMutationVariables>(JobPortalOptionMutationDocument, options);
      }
export type JobPortalOptionMutationMutationHookResult = ReturnType<typeof useJobPortalOptionMutationMutation>;
export type JobPortalOptionMutationMutationResult = Apollo.MutationResult<JobPortalOptionMutationMutation>;
export type JobPortalOptionMutationMutationOptions = Apollo.BaseMutationOptions<JobPortalOptionMutationMutation, JobPortalOptionMutationMutationVariables>;
export const JobNameUpdateDocument = gql`
    mutation jobNameUpdate($input: JobUpdateInput!) {
  jobUpdate(input: $input) {
    job {
      id
      ...ManageJobDisplayNameModal_job
    }
  }
}
    ${ManageJobDisplayNameModal_JobFragmentDoc}`;
export type JobNameUpdateMutationFn = Apollo.MutationFunction<JobNameUpdateMutation, JobNameUpdateMutationVariables>;

/**
 * __useJobNameUpdateMutation__
 *
 * To run a mutation, you first call `useJobNameUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobNameUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobNameUpdateMutation, { data, loading, error }] = useJobNameUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobNameUpdateMutation(baseOptions?: Apollo.MutationHookOptions<JobNameUpdateMutation, JobNameUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobNameUpdateMutation, JobNameUpdateMutationVariables>(JobNameUpdateDocument, options);
      }
export type JobNameUpdateMutationHookResult = ReturnType<typeof useJobNameUpdateMutation>;
export type JobNameUpdateMutationResult = Apollo.MutationResult<JobNameUpdateMutation>;
export type JobNameUpdateMutationOptions = Apollo.BaseMutationOptions<JobNameUpdateMutation, JobNameUpdateMutationVariables>;
export const JobDetailsSetupDocument = gql`
    query JobDetailsSetup($id: uuid!) {
  job(id: $id) {
    id
    jobSettings {
      id
      ...JobDetailsSetup_jobSettings
    }
    ...GeneralSetupSettings_job
    ...JobDisplayNameSection_job
  }
}
    ${JobDetailsSetup_JobSettingsFragmentDoc}
${GeneralSetupSettings_JobFragmentDoc}
${JobDisplayNameSection_JobFragmentDoc}`;

/**
 * __useJobDetailsSetupQuery__
 *
 * To run a query within a React component, call `useJobDetailsSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDetailsSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDetailsSetupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobDetailsSetupQuery(baseOptions: Apollo.QueryHookOptions<JobDetailsSetupQuery, JobDetailsSetupQueryVariables> & ({ variables: JobDetailsSetupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>(JobDetailsSetupDocument, options);
      }
export function useJobDetailsSetupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>(JobDetailsSetupDocument, options);
        }
// @ts-ignore
export function useJobDetailsSetupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>): Apollo.UseSuspenseQueryResult<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>;
export function useJobDetailsSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>): Apollo.UseSuspenseQueryResult<JobDetailsSetupQuery | undefined, JobDetailsSetupQueryVariables>;
export function useJobDetailsSetupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>(JobDetailsSetupDocument, options);
        }
export type JobDetailsSetupQueryHookResult = ReturnType<typeof useJobDetailsSetupQuery>;
export type JobDetailsSetupLazyQueryHookResult = ReturnType<typeof useJobDetailsSetupLazyQuery>;
export type JobDetailsSetupSuspenseQueryHookResult = ReturnType<typeof useJobDetailsSetupSuspenseQuery>;
export type JobDetailsSetupQueryResult = Apollo.QueryResult<JobDetailsSetupQuery, JobDetailsSetupQueryVariables>;
export const UpdateJobSettingsDocument = gql`
    mutation UpdateJobSettings($input: JobSettingsUpsertInput!) {
  jobSettingsUpsert(input: $input) {
    jobSettings {
      id
      ...JobDetailsSetup_jobSettings
    }
  }
}
    ${JobDetailsSetup_JobSettingsFragmentDoc}`;
export type UpdateJobSettingsMutationFn = Apollo.MutationFunction<UpdateJobSettingsMutation, UpdateJobSettingsMutationVariables>;

/**
 * __useUpdateJobSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateJobSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobSettingsMutation, { data, loading, error }] = useUpdateJobSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobSettingsMutation, UpdateJobSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobSettingsMutation, UpdateJobSettingsMutationVariables>(UpdateJobSettingsDocument, options);
      }
export type UpdateJobSettingsMutationHookResult = ReturnType<typeof useUpdateJobSettingsMutation>;
export type UpdateJobSettingsMutationResult = Apollo.MutationResult<UpdateJobSettingsMutation>;
export type UpdateJobSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateJobSettingsMutation, UpdateJobSettingsMutationVariables>;
export const CalendarEventVisibilityUpsertDocument = gql`
    mutation CalendarEventVisibilityUpsert($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      ...CalendarEventVisibilityRow_jobStageSettings
    }
  }
}
    ${CalendarEventVisibilityRow_JobStageSettingsFragmentDoc}`;
export type CalendarEventVisibilityUpsertMutationFn = Apollo.MutationFunction<CalendarEventVisibilityUpsertMutation, CalendarEventVisibilityUpsertMutationVariables>;

/**
 * __useCalendarEventVisibilityUpsertMutation__
 *
 * To run a mutation, you first call `useCalendarEventVisibilityUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventVisibilityUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventVisibilityUpsertMutation, { data, loading, error }] = useCalendarEventVisibilityUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventVisibilityUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CalendarEventVisibilityUpsertMutation, CalendarEventVisibilityUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarEventVisibilityUpsertMutation, CalendarEventVisibilityUpsertMutationVariables>(CalendarEventVisibilityUpsertDocument, options);
      }
export type CalendarEventVisibilityUpsertMutationHookResult = ReturnType<typeof useCalendarEventVisibilityUpsertMutation>;
export type CalendarEventVisibilityUpsertMutationResult = Apollo.MutationResult<CalendarEventVisibilityUpsertMutation>;
export type CalendarEventVisibilityUpsertMutationOptions = Apollo.BaseMutationOptions<CalendarEventVisibilityUpsertMutation, CalendarEventVisibilityUpsertMutationVariables>;
export const DebriefMeetingLocationUpsertDocument = gql`
    mutation DebriefMeetingLocationUpsert($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      debriefMeetingLocationSettingWithLevel {
        ...DebriefScheduleLocation_debriefMeetingLocationSetting
      }
    }
  }
}
    ${DebriefScheduleLocation_DebriefMeetingLocationSettingFragmentDoc}`;
export type DebriefMeetingLocationUpsertMutationFn = Apollo.MutationFunction<DebriefMeetingLocationUpsertMutation, DebriefMeetingLocationUpsertMutationVariables>;

/**
 * __useDebriefMeetingLocationUpsertMutation__
 *
 * To run a mutation, you first call `useDebriefMeetingLocationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDebriefMeetingLocationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [debriefMeetingLocationUpsertMutation, { data, loading, error }] = useDebriefMeetingLocationUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDebriefMeetingLocationUpsertMutation(baseOptions?: Apollo.MutationHookOptions<DebriefMeetingLocationUpsertMutation, DebriefMeetingLocationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DebriefMeetingLocationUpsertMutation, DebriefMeetingLocationUpsertMutationVariables>(DebriefMeetingLocationUpsertDocument, options);
      }
export type DebriefMeetingLocationUpsertMutationHookResult = ReturnType<typeof useDebriefMeetingLocationUpsertMutation>;
export type DebriefMeetingLocationUpsertMutationResult = Apollo.MutationResult<DebriefMeetingLocationUpsertMutation>;
export type DebriefMeetingLocationUpsertMutationOptions = Apollo.BaseMutationOptions<DebriefMeetingLocationUpsertMutation, DebriefMeetingLocationUpsertMutationVariables>;
export const InterviewMeetingLocationUpsertDocument = gql`
    mutation InterviewMeetingLocationUpsert($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      interviewMeetingLocationSettingWithLevel {
        ...ScheduleLocation_interviewMeetingLocationSetting
      }
    }
  }
}
    ${ScheduleLocation_InterviewMeetingLocationSettingFragmentDoc}`;
export type InterviewMeetingLocationUpsertMutationFn = Apollo.MutationFunction<InterviewMeetingLocationUpsertMutation, InterviewMeetingLocationUpsertMutationVariables>;

/**
 * __useInterviewMeetingLocationUpsertMutation__
 *
 * To run a mutation, you first call `useInterviewMeetingLocationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewMeetingLocationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewMeetingLocationUpsertMutation, { data, loading, error }] = useInterviewMeetingLocationUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewMeetingLocationUpsertMutation(baseOptions?: Apollo.MutationHookOptions<InterviewMeetingLocationUpsertMutation, InterviewMeetingLocationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewMeetingLocationUpsertMutation, InterviewMeetingLocationUpsertMutationVariables>(InterviewMeetingLocationUpsertDocument, options);
      }
export type InterviewMeetingLocationUpsertMutationHookResult = ReturnType<typeof useInterviewMeetingLocationUpsertMutation>;
export type InterviewMeetingLocationUpsertMutationResult = Apollo.MutationResult<InterviewMeetingLocationUpsertMutation>;
export type InterviewMeetingLocationUpsertMutationOptions = Apollo.BaseMutationOptions<InterviewMeetingLocationUpsertMutation, InterviewMeetingLocationUpsertMutationVariables>;
export const CommunicationSettingsTemplateDocument = gql`
    query CommunicationSettingsTemplate($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateRow_orgTemplate
    }
  }
}
    ${TemplateRow_OrgTemplateFragmentDoc}`;

/**
 * __useCommunicationSettingsTemplateQuery__
 *
 * To run a query within a React component, call `useCommunicationSettingsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationSettingsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationSettingsTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommunicationSettingsTemplateQuery(baseOptions: Apollo.QueryHookOptions<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables> & ({ variables: CommunicationSettingsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>(CommunicationSettingsTemplateDocument, options);
      }
export function useCommunicationSettingsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>(CommunicationSettingsTemplateDocument, options);
        }
// @ts-ignore
export function useCommunicationSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>;
export function useCommunicationSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationSettingsTemplateQuery | undefined, CommunicationSettingsTemplateQueryVariables>;
export function useCommunicationSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>(CommunicationSettingsTemplateDocument, options);
        }
export type CommunicationSettingsTemplateQueryHookResult = ReturnType<typeof useCommunicationSettingsTemplateQuery>;
export type CommunicationSettingsTemplateLazyQueryHookResult = ReturnType<typeof useCommunicationSettingsTemplateLazyQuery>;
export type CommunicationSettingsTemplateSuspenseQueryHookResult = ReturnType<typeof useCommunicationSettingsTemplateSuspenseQuery>;
export type CommunicationSettingsTemplateQueryResult = Apollo.QueryResult<CommunicationSettingsTemplateQuery, CommunicationSettingsTemplateQueryVariables>;
export const CommunicationOrgPrefsDocument = gql`
    query CommunicationOrgPrefs {
  thisOrg {
    id
    integrations {
      id
      slack {
        active
      }
    }
    orgPrefs {
      id
      orgId
      prefName
      stringValue
      jsonPref {
        __typename
        ... on ChatCommunicationsSettingPref {
          ...SlackChannelRow_orgConversation
        }
        ... on CandidateCommunicationsSettingPref {
          ccRecipients {
            ...AdditionalRecipientsRow_orgBccRecipients
          }
          bccRecipients {
            ...AdditionalRecipientsRow_orgCcRecipients
          }
        }
        ... on NotificationPreference {
          ...SlackChannelMembers_orgMembers
        }
        ... on CandidateEventAdditionalAttendeesPref {
          candidateEventAdditionalAttendees {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
          additionalRecipientsOptional
          additionalAttendees {
            email
            employeeId
            dynamicAudience
            isOptional
          }
        }
        ... on InterviewerEventAdditionalAttendeesPref {
          interviewerEventAdditionalAttendees {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
          additionalRecipientsOptional
          additionalAttendees {
            email
            employeeId
            dynamicAudience
            isOptional
          }
        }
        ... on DebriefEventAdditionalAttendeesPref {
          debriefEventAdditionalAttendees {
            employeeIds
            externalEmailAddresses
            dynamicAudiences
          }
          additionalRecipientsOptional
          additionalAttendees {
            email
            employeeId
            dynamicAudience
            isOptional
          }
        }
        ... on DebriefAtsWriteSettingPref {
          ...DebriefAtsWriteRow_orgSetting
        }
      }
    }
  }
}
    ${SlackChannelRow_OrgConversationFragmentDoc}
${AdditionalRecipientsRow_OrgBccRecipientsFragmentDoc}
${AdditionalRecipientsRow_OrgCcRecipientsFragmentDoc}
${SlackChannelMembers_OrgMembersFragmentDoc}
${DebriefAtsWriteRow_OrgSettingFragmentDoc}`;

/**
 * __useCommunicationOrgPrefsQuery__
 *
 * To run a query within a React component, call `useCommunicationOrgPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationOrgPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationOrgPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunicationOrgPrefsQuery(baseOptions?: Apollo.QueryHookOptions<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>(CommunicationOrgPrefsDocument, options);
      }
export function useCommunicationOrgPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>(CommunicationOrgPrefsDocument, options);
        }
// @ts-ignore
export function useCommunicationOrgPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>;
export function useCommunicationOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationOrgPrefsQuery | undefined, CommunicationOrgPrefsQueryVariables>;
export function useCommunicationOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>(CommunicationOrgPrefsDocument, options);
        }
export type CommunicationOrgPrefsQueryHookResult = ReturnType<typeof useCommunicationOrgPrefsQuery>;
export type CommunicationOrgPrefsLazyQueryHookResult = ReturnType<typeof useCommunicationOrgPrefsLazyQuery>;
export type CommunicationOrgPrefsSuspenseQueryHookResult = ReturnType<typeof useCommunicationOrgPrefsSuspenseQuery>;
export type CommunicationOrgPrefsQueryResult = Apollo.QueryResult<CommunicationOrgPrefsQuery, CommunicationOrgPrefsQueryVariables>;
export const SaveCandidatePulseSurveySettingDocument = gql`
    mutation SaveCandidatePulseSurveySetting($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      shouldSendCandidatePulse {
        value
        level
      }
    }
  }
}
    `;
export type SaveCandidatePulseSurveySettingMutationFn = Apollo.MutationFunction<SaveCandidatePulseSurveySettingMutation, SaveCandidatePulseSurveySettingMutationVariables>;

/**
 * __useSaveCandidatePulseSurveySettingMutation__
 *
 * To run a mutation, you first call `useSaveCandidatePulseSurveySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCandidatePulseSurveySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCandidatePulseSurveySettingMutation, { data, loading, error }] = useSaveCandidatePulseSurveySettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCandidatePulseSurveySettingMutation(baseOptions?: Apollo.MutationHookOptions<SaveCandidatePulseSurveySettingMutation, SaveCandidatePulseSurveySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCandidatePulseSurveySettingMutation, SaveCandidatePulseSurveySettingMutationVariables>(SaveCandidatePulseSurveySettingDocument, options);
      }
export type SaveCandidatePulseSurveySettingMutationHookResult = ReturnType<typeof useSaveCandidatePulseSurveySettingMutation>;
export type SaveCandidatePulseSurveySettingMutationResult = Apollo.MutationResult<SaveCandidatePulseSurveySettingMutation>;
export type SaveCandidatePulseSurveySettingMutationOptions = Apollo.BaseMutationOptions<SaveCandidatePulseSurveySettingMutation, SaveCandidatePulseSurveySettingMutationVariables>;
export const SaveJobStageDefaultTaskDocument = gql`
    mutation SaveJobStageDefaultTask($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      defaultTask
      __typename
    }
  }
}
    `;
export type SaveJobStageDefaultTaskMutationFn = Apollo.MutationFunction<SaveJobStageDefaultTaskMutation, SaveJobStageDefaultTaskMutationVariables>;

/**
 * __useSaveJobStageDefaultTaskMutation__
 *
 * To run a mutation, you first call `useSaveJobStageDefaultTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveJobStageDefaultTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveJobStageDefaultTaskMutation, { data, loading, error }] = useSaveJobStageDefaultTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveJobStageDefaultTaskMutation(baseOptions?: Apollo.MutationHookOptions<SaveJobStageDefaultTaskMutation, SaveJobStageDefaultTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveJobStageDefaultTaskMutation, SaveJobStageDefaultTaskMutationVariables>(SaveJobStageDefaultTaskDocument, options);
      }
export type SaveJobStageDefaultTaskMutationHookResult = ReturnType<typeof useSaveJobStageDefaultTaskMutation>;
export type SaveJobStageDefaultTaskMutationResult = Apollo.MutationResult<SaveJobStageDefaultTaskMutation>;
export type SaveJobStageDefaultTaskMutationOptions = Apollo.BaseMutationOptions<SaveJobStageDefaultTaskMutation, SaveJobStageDefaultTaskMutationVariables>;
export const DisableJobStageAutomationDocument = gql`
    mutation DisableJobStageAutomation($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      defaultTask
      ...EnableAutomationModal_jobStageSettings
    }
  }
}
    ${EnableAutomationModal_JobStageSettingsFragmentDoc}`;
export type DisableJobStageAutomationMutationFn = Apollo.MutationFunction<DisableJobStageAutomationMutation, DisableJobStageAutomationMutationVariables>;

/**
 * __useDisableJobStageAutomationMutation__
 *
 * To run a mutation, you first call `useDisableJobStageAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableJobStageAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableJobStageAutomationMutation, { data, loading, error }] = useDisableJobStageAutomationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableJobStageAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DisableJobStageAutomationMutation, DisableJobStageAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableJobStageAutomationMutation, DisableJobStageAutomationMutationVariables>(DisableJobStageAutomationDocument, options);
      }
export type DisableJobStageAutomationMutationHookResult = ReturnType<typeof useDisableJobStageAutomationMutation>;
export type DisableJobStageAutomationMutationResult = Apollo.MutationResult<DisableJobStageAutomationMutation>;
export type DisableJobStageAutomationMutationOptions = Apollo.BaseMutationOptions<DisableJobStageAutomationMutation, DisableJobStageAutomationMutationVariables>;
export const UpdateJobStageAutomationDocument = gql`
    mutation UpdateJobStageAutomation($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      ...EnableAutomationModalCommonFragment
    }
  }
}
    ${EnableAutomationModalCommonFragmentFragmentDoc}`;
export type UpdateJobStageAutomationMutationFn = Apollo.MutationFunction<UpdateJobStageAutomationMutation, UpdateJobStageAutomationMutationVariables>;

/**
 * __useUpdateJobStageAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateJobStageAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobStageAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobStageAutomationMutation, { data, loading, error }] = useUpdateJobStageAutomationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobStageAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobStageAutomationMutation, UpdateJobStageAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobStageAutomationMutation, UpdateJobStageAutomationMutationVariables>(UpdateJobStageAutomationDocument, options);
      }
export type UpdateJobStageAutomationMutationHookResult = ReturnType<typeof useUpdateJobStageAutomationMutation>;
export type UpdateJobStageAutomationMutationResult = Apollo.MutationResult<UpdateJobStageAutomationMutation>;
export type UpdateJobStageAutomationMutationOptions = Apollo.BaseMutationOptions<UpdateJobStageAutomationMutation, UpdateJobStageAutomationMutationVariables>;
export const JobStageInterviewPlanDocument = gql`
    query JobStageInterviewPlan($id: uuid!) {
  jobStage(id: $id) {
    id
    ...InterviewPlan_jobStage
    job {
      id
      ...InterviewPlan_job
    }
    atsJobStage {
      atsId
      canResetInterviewPlan
    }
    jobStageSettingsV2 {
      id
      syncScorecardsFromAts {
        value
        level
      }
    }
  }
}
    ${InterviewPlan_JobStageFragmentDoc}
${InterviewPlan_JobFragmentDoc}`;

/**
 * __useJobStageInterviewPlanQuery__
 *
 * To run a query within a React component, call `useJobStageInterviewPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageInterviewPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageInterviewPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobStageInterviewPlanQuery(baseOptions: Apollo.QueryHookOptions<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables> & ({ variables: JobStageInterviewPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>(JobStageInterviewPlanDocument, options);
      }
export function useJobStageInterviewPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>(JobStageInterviewPlanDocument, options);
        }
// @ts-ignore
export function useJobStageInterviewPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>;
export function useJobStageInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageInterviewPlanQuery | undefined, JobStageInterviewPlanQueryVariables>;
export function useJobStageInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>(JobStageInterviewPlanDocument, options);
        }
export type JobStageInterviewPlanQueryHookResult = ReturnType<typeof useJobStageInterviewPlanQuery>;
export type JobStageInterviewPlanLazyQueryHookResult = ReturnType<typeof useJobStageInterviewPlanLazyQuery>;
export type JobStageInterviewPlanSuspenseQueryHookResult = ReturnType<typeof useJobStageInterviewPlanSuspenseQuery>;
export type JobStageInterviewPlanQueryResult = Apollo.QueryResult<JobStageInterviewPlanQuery, JobStageInterviewPlanQueryVariables>;
export const JobStageInterviewPlanUpsertDocument = gql`
    mutation JobStageInterviewPlanUpsert($input: JobStageInterviewPlanUpsertInput!) {
  jobStageInterviewPlanUpsert(input: $input) {
    jobStage {
      id
      ...InterviewPlan_jobStage
    }
  }
}
    ${InterviewPlan_JobStageFragmentDoc}`;
export type JobStageInterviewPlanUpsertMutationFn = Apollo.MutationFunction<JobStageInterviewPlanUpsertMutation, JobStageInterviewPlanUpsertMutationVariables>;

/**
 * __useJobStageInterviewPlanUpsertMutation__
 *
 * To run a mutation, you first call `useJobStageInterviewPlanUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobStageInterviewPlanUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobStageInterviewPlanUpsertMutation, { data, loading, error }] = useJobStageInterviewPlanUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobStageInterviewPlanUpsertMutation(baseOptions?: Apollo.MutationHookOptions<JobStageInterviewPlanUpsertMutation, JobStageInterviewPlanUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobStageInterviewPlanUpsertMutation, JobStageInterviewPlanUpsertMutationVariables>(JobStageInterviewPlanUpsertDocument, options);
      }
export type JobStageInterviewPlanUpsertMutationHookResult = ReturnType<typeof useJobStageInterviewPlanUpsertMutation>;
export type JobStageInterviewPlanUpsertMutationResult = Apollo.MutationResult<JobStageInterviewPlanUpsertMutation>;
export type JobStageInterviewPlanUpsertMutationOptions = Apollo.BaseMutationOptions<JobStageInterviewPlanUpsertMutation, JobStageInterviewPlanUpsertMutationVariables>;
export const AvailabilityRequestSettingsTemplateDocument = gql`
    query AvailabilityRequestSettingsTemplate($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateRow_orgTemplate
    }
  }
}
    ${TemplateRow_OrgTemplateFragmentDoc}`;

/**
 * __useAvailabilityRequestSettingsTemplateQuery__
 *
 * To run a query within a React component, call `useAvailabilityRequestSettingsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityRequestSettingsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityRequestSettingsTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailabilityRequestSettingsTemplateQuery(baseOptions: Apollo.QueryHookOptions<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables> & ({ variables: AvailabilityRequestSettingsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>(AvailabilityRequestSettingsTemplateDocument, options);
      }
export function useAvailabilityRequestSettingsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>(AvailabilityRequestSettingsTemplateDocument, options);
        }
// @ts-ignore
export function useAvailabilityRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>;
export function useAvailabilityRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityRequestSettingsTemplateQuery | undefined, AvailabilityRequestSettingsTemplateQueryVariables>;
export function useAvailabilityRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>(AvailabilityRequestSettingsTemplateDocument, options);
        }
export type AvailabilityRequestSettingsTemplateQueryHookResult = ReturnType<typeof useAvailabilityRequestSettingsTemplateQuery>;
export type AvailabilityRequestSettingsTemplateLazyQueryHookResult = ReturnType<typeof useAvailabilityRequestSettingsTemplateLazyQuery>;
export type AvailabilityRequestSettingsTemplateSuspenseQueryHookResult = ReturnType<typeof useAvailabilityRequestSettingsTemplateSuspenseQuery>;
export type AvailabilityRequestSettingsTemplateQueryResult = Apollo.QueryResult<AvailabilityRequestSettingsTemplateQuery, AvailabilityRequestSettingsTemplateQueryVariables>;
export const AvailabilityRequestOrgPrefsDocument = gql`
    query AvailabilityRequestOrgPrefs {
  thisOrg {
    id
    orgPrefs {
      id
      orgId
      prefName
      jsonPref {
        ... on NotificationPreference {
          ...AdditionalRecipientsRow_orgBccRecipients
          ...AdditionalRecipientsRow_orgCcRecipients
        }
      }
    }
  }
}
    ${AdditionalRecipientsRow_OrgBccRecipientsFragmentDoc}
${AdditionalRecipientsRow_OrgCcRecipientsFragmentDoc}`;

/**
 * __useAvailabilityRequestOrgPrefsQuery__
 *
 * To run a query within a React component, call `useAvailabilityRequestOrgPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityRequestOrgPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityRequestOrgPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailabilityRequestOrgPrefsQuery(baseOptions?: Apollo.QueryHookOptions<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>(AvailabilityRequestOrgPrefsDocument, options);
      }
export function useAvailabilityRequestOrgPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>(AvailabilityRequestOrgPrefsDocument, options);
        }
// @ts-ignore
export function useAvailabilityRequestOrgPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>;
export function useAvailabilityRequestOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityRequestOrgPrefsQuery | undefined, AvailabilityRequestOrgPrefsQueryVariables>;
export function useAvailabilityRequestOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>(AvailabilityRequestOrgPrefsDocument, options);
        }
export type AvailabilityRequestOrgPrefsQueryHookResult = ReturnType<typeof useAvailabilityRequestOrgPrefsQuery>;
export type AvailabilityRequestOrgPrefsLazyQueryHookResult = ReturnType<typeof useAvailabilityRequestOrgPrefsLazyQuery>;
export type AvailabilityRequestOrgPrefsSuspenseQueryHookResult = ReturnType<typeof useAvailabilityRequestOrgPrefsSuspenseQuery>;
export type AvailabilityRequestOrgPrefsQueryResult = Apollo.QueryResult<AvailabilityRequestOrgPrefsQuery, AvailabilityRequestOrgPrefsQueryVariables>;
export const SsrSettingsTemplateDocument = gql`
    query SsrSettingsTemplate($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateRow_orgTemplate
    }
  }
}
    ${TemplateRow_OrgTemplateFragmentDoc}`;

/**
 * __useSsrSettingsTemplateQuery__
 *
 * To run a query within a React component, call `useSsrSettingsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsrSettingsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsrSettingsTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsrSettingsTemplateQuery(baseOptions: Apollo.QueryHookOptions<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables> & ({ variables: SsrSettingsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>(SsrSettingsTemplateDocument, options);
      }
export function useSsrSettingsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>(SsrSettingsTemplateDocument, options);
        }
// @ts-ignore
export function useSsrSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>;
export function useSsrSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<SsrSettingsTemplateQuery | undefined, SsrSettingsTemplateQueryVariables>;
export function useSsrSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>(SsrSettingsTemplateDocument, options);
        }
export type SsrSettingsTemplateQueryHookResult = ReturnType<typeof useSsrSettingsTemplateQuery>;
export type SsrSettingsTemplateLazyQueryHookResult = ReturnType<typeof useSsrSettingsTemplateLazyQuery>;
export type SsrSettingsTemplateSuspenseQueryHookResult = ReturnType<typeof useSsrSettingsTemplateSuspenseQuery>;
export type SsrSettingsTemplateQueryResult = Apollo.QueryResult<SsrSettingsTemplateQuery, SsrSettingsTemplateQueryVariables>;
export const SelfScheduleRequestOrgPrefsDocument = gql`
    query SelfScheduleRequestOrgPrefs {
  thisOrg {
    id
    orgPrefs {
      id
      orgId
      prefName
      jsonPref {
        ... on NotificationPreference {
          ...AdditionalRecipientsRow_orgBccRecipients
          ...AdditionalRecipientsRow_orgCcRecipients
        }
      }
    }
  }
}
    ${AdditionalRecipientsRow_OrgBccRecipientsFragmentDoc}
${AdditionalRecipientsRow_OrgCcRecipientsFragmentDoc}`;

/**
 * __useSelfScheduleRequestOrgPrefsQuery__
 *
 * To run a query within a React component, call `useSelfScheduleRequestOrgPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleRequestOrgPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleRequestOrgPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfScheduleRequestOrgPrefsQuery(baseOptions?: Apollo.QueryHookOptions<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>(SelfScheduleRequestOrgPrefsDocument, options);
      }
export function useSelfScheduleRequestOrgPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>(SelfScheduleRequestOrgPrefsDocument, options);
        }
// @ts-ignore
export function useSelfScheduleRequestOrgPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>;
export function useSelfScheduleRequestOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleRequestOrgPrefsQuery | undefined, SelfScheduleRequestOrgPrefsQueryVariables>;
export function useSelfScheduleRequestOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>(SelfScheduleRequestOrgPrefsDocument, options);
        }
export type SelfScheduleRequestOrgPrefsQueryHookResult = ReturnType<typeof useSelfScheduleRequestOrgPrefsQuery>;
export type SelfScheduleRequestOrgPrefsLazyQueryHookResult = ReturnType<typeof useSelfScheduleRequestOrgPrefsLazyQuery>;
export type SelfScheduleRequestOrgPrefsSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleRequestOrgPrefsSuspenseQuery>;
export type SelfScheduleRequestOrgPrefsQueryResult = Apollo.QueryResult<SelfScheduleRequestOrgPrefsQuery, SelfScheduleRequestOrgPrefsQueryVariables>;
export const ReschedulingJobStageSettingUpsertDocument = gql`
    mutation ReschedulingJobStageSettingUpsert($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      automaticallyReplaceDeclinedInterviewer {
        ...Rescheduling_automaticallyReplaceDeclinedInterviewer
      }
    }
  }
}
    ${Rescheduling_AutomaticallyReplaceDeclinedInterviewerFragmentDoc}`;
export type ReschedulingJobStageSettingUpsertMutationFn = Apollo.MutationFunction<ReschedulingJobStageSettingUpsertMutation, ReschedulingJobStageSettingUpsertMutationVariables>;

/**
 * __useReschedulingJobStageSettingUpsertMutation__
 *
 * To run a mutation, you first call `useReschedulingJobStageSettingUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReschedulingJobStageSettingUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reschedulingJobStageSettingUpsertMutation, { data, loading, error }] = useReschedulingJobStageSettingUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReschedulingJobStageSettingUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ReschedulingJobStageSettingUpsertMutation, ReschedulingJobStageSettingUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReschedulingJobStageSettingUpsertMutation, ReschedulingJobStageSettingUpsertMutationVariables>(ReschedulingJobStageSettingUpsertDocument, options);
      }
export type ReschedulingJobStageSettingUpsertMutationHookResult = ReturnType<typeof useReschedulingJobStageSettingUpsertMutation>;
export type ReschedulingJobStageSettingUpsertMutationResult = Apollo.MutationResult<ReschedulingJobStageSettingUpsertMutation>;
export type ReschedulingJobStageSettingUpsertMutationOptions = Apollo.BaseMutationOptions<ReschedulingJobStageSettingUpsertMutation, ReschedulingJobStageSettingUpsertMutationVariables>;
export const ResetJobStageToAtsInterviewPlanDocument = gql`
    mutation ResetJobStageToAtsInterviewPlan($input: ResetJobStageToAtsInterviewPlanInput!) {
  resetJobStageToAtsInterviewPlan(input: $input) {
    jobStage {
      id
    }
  }
}
    `;
export type ResetJobStageToAtsInterviewPlanMutationFn = Apollo.MutationFunction<ResetJobStageToAtsInterviewPlanMutation, ResetJobStageToAtsInterviewPlanMutationVariables>;

/**
 * __useResetJobStageToAtsInterviewPlanMutation__
 *
 * To run a mutation, you first call `useResetJobStageToAtsInterviewPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetJobStageToAtsInterviewPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetJobStageToAtsInterviewPlanMutation, { data, loading, error }] = useResetJobStageToAtsInterviewPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetJobStageToAtsInterviewPlanMutation(baseOptions?: Apollo.MutationHookOptions<ResetJobStageToAtsInterviewPlanMutation, ResetJobStageToAtsInterviewPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetJobStageToAtsInterviewPlanMutation, ResetJobStageToAtsInterviewPlanMutationVariables>(ResetJobStageToAtsInterviewPlanDocument, options);
      }
export type ResetJobStageToAtsInterviewPlanMutationHookResult = ReturnType<typeof useResetJobStageToAtsInterviewPlanMutation>;
export type ResetJobStageToAtsInterviewPlanMutationResult = Apollo.MutationResult<ResetJobStageToAtsInterviewPlanMutation>;
export type ResetJobStageToAtsInterviewPlanMutationOptions = Apollo.BaseMutationOptions<ResetJobStageToAtsInterviewPlanMutation, ResetJobStageToAtsInterviewPlanMutationVariables>;
export const JobStageDetailsSettingsUpsertDocument = gql`
    mutation JobStageDetailsSettingsUpsert($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
      ...JobStageSettingsFragment
    }
  }
}
    ${JobStageSettingsFragmentFragmentDoc}`;
export type JobStageDetailsSettingsUpsertMutationFn = Apollo.MutationFunction<JobStageDetailsSettingsUpsertMutation, JobStageDetailsSettingsUpsertMutationVariables>;

/**
 * __useJobStageDetailsSettingsUpsertMutation__
 *
 * To run a mutation, you first call `useJobStageDetailsSettingsUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobStageDetailsSettingsUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobStageDetailsSettingsUpsertMutation, { data, loading, error }] = useJobStageDetailsSettingsUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobStageDetailsSettingsUpsertMutation(baseOptions?: Apollo.MutationHookOptions<JobStageDetailsSettingsUpsertMutation, JobStageDetailsSettingsUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobStageDetailsSettingsUpsertMutation, JobStageDetailsSettingsUpsertMutationVariables>(JobStageDetailsSettingsUpsertDocument, options);
      }
export type JobStageDetailsSettingsUpsertMutationHookResult = ReturnType<typeof useJobStageDetailsSettingsUpsertMutation>;
export type JobStageDetailsSettingsUpsertMutationResult = Apollo.MutationResult<JobStageDetailsSettingsUpsertMutation>;
export type JobStageDetailsSettingsUpsertMutationOptions = Apollo.BaseMutationOptions<JobStageDetailsSettingsUpsertMutation, JobStageDetailsSettingsUpsertMutationVariables>;
export const CheckCreateCandidatePermissionDocument = gql`
    mutation CheckCreateCandidatePermission($input: CheckCreateCandidatePermissionInput!) {
  checkCreateCandidatePermission(input: $input) {
    hasPermission
    testCandidateAtsUrl
  }
}
    `;
export type CheckCreateCandidatePermissionMutationFn = Apollo.MutationFunction<CheckCreateCandidatePermissionMutation, CheckCreateCandidatePermissionMutationVariables>;

/**
 * __useCheckCreateCandidatePermissionMutation__
 *
 * To run a mutation, you first call `useCheckCreateCandidatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckCreateCandidatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkCreateCandidatePermissionMutation, { data, loading, error }] = useCheckCreateCandidatePermissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckCreateCandidatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<CheckCreateCandidatePermissionMutation, CheckCreateCandidatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckCreateCandidatePermissionMutation, CheckCreateCandidatePermissionMutationVariables>(CheckCreateCandidatePermissionDocument, options);
      }
export type CheckCreateCandidatePermissionMutationHookResult = ReturnType<typeof useCheckCreateCandidatePermissionMutation>;
export type CheckCreateCandidatePermissionMutationResult = Apollo.MutationResult<CheckCreateCandidatePermissionMutation>;
export type CheckCreateCandidatePermissionMutationOptions = Apollo.BaseMutationOptions<CheckCreateCandidatePermissionMutation, CheckCreateCandidatePermissionMutationVariables>;
export const JobStageInterviewPlanQueryDocument = gql`
    query JobStageInterviewPlanQuery($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    ...InterviewPlan_jobStage
    job {
      ...InterviewPlan_job
    }
  }
}
    ${InterviewPlan_JobStageFragmentDoc}
${InterviewPlan_JobFragmentDoc}`;

/**
 * __useJobStageInterviewPlanQueryQuery__
 *
 * To run a query within a React component, call `useJobStageInterviewPlanQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageInterviewPlanQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageInterviewPlanQueryQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useJobStageInterviewPlanQueryQuery(baseOptions: Apollo.QueryHookOptions<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables> & ({ variables: JobStageInterviewPlanQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>(JobStageInterviewPlanQueryDocument, options);
      }
export function useJobStageInterviewPlanQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>(JobStageInterviewPlanQueryDocument, options);
        }
// @ts-ignore
export function useJobStageInterviewPlanQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>;
export function useJobStageInterviewPlanQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageInterviewPlanQueryQuery | undefined, JobStageInterviewPlanQueryQueryVariables>;
export function useJobStageInterviewPlanQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>(JobStageInterviewPlanQueryDocument, options);
        }
export type JobStageInterviewPlanQueryQueryHookResult = ReturnType<typeof useJobStageInterviewPlanQueryQuery>;
export type JobStageInterviewPlanQueryLazyQueryHookResult = ReturnType<typeof useJobStageInterviewPlanQueryLazyQuery>;
export type JobStageInterviewPlanQuerySuspenseQueryHookResult = ReturnType<typeof useJobStageInterviewPlanQuerySuspenseQuery>;
export type JobStageInterviewPlanQueryQueryResult = Apollo.QueryResult<JobStageInterviewPlanQueryQuery, JobStageInterviewPlanQueryQueryVariables>;
export const CreateSourcingLinkDocument = gql`
    mutation CreateSourcingLink($input: SourcingLinkCreateInput!) {
  sourcingLinkCreate(input: $input) {
    sourcingLink {
      id
    }
  }
}
    `;
export type CreateSourcingLinkMutationFn = Apollo.MutationFunction<CreateSourcingLinkMutation, CreateSourcingLinkMutationVariables>;

/**
 * __useCreateSourcingLinkMutation__
 *
 * To run a mutation, you first call `useCreateSourcingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSourcingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSourcingLinkMutation, { data, loading, error }] = useCreateSourcingLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSourcingLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateSourcingLinkMutation, CreateSourcingLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSourcingLinkMutation, CreateSourcingLinkMutationVariables>(CreateSourcingLinkDocument, options);
      }
export type CreateSourcingLinkMutationHookResult = ReturnType<typeof useCreateSourcingLinkMutation>;
export type CreateSourcingLinkMutationResult = Apollo.MutationResult<CreateSourcingLinkMutation>;
export type CreateSourcingLinkMutationOptions = Apollo.BaseMutationOptions<CreateSourcingLinkMutation, CreateSourcingLinkMutationVariables>;
export const UpdateSourcingLinkDocument = gql`
    mutation UpdateSourcingLink($input: SourcingLinkUpdateInput!) {
  sourcingLinkUpdate(input: $input) {
    sourcingLink {
      id
    }
  }
}
    `;
export type UpdateSourcingLinkMutationFn = Apollo.MutationFunction<UpdateSourcingLinkMutation, UpdateSourcingLinkMutationVariables>;

/**
 * __useUpdateSourcingLinkMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingLinkMutation, { data, loading, error }] = useUpdateSourcingLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourcingLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourcingLinkMutation, UpdateSourcingLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourcingLinkMutation, UpdateSourcingLinkMutationVariables>(UpdateSourcingLinkDocument, options);
      }
export type UpdateSourcingLinkMutationHookResult = ReturnType<typeof useUpdateSourcingLinkMutation>;
export type UpdateSourcingLinkMutationResult = Apollo.MutationResult<UpdateSourcingLinkMutation>;
export type UpdateSourcingLinkMutationOptions = Apollo.BaseMutationOptions<UpdateSourcingLinkMutation, UpdateSourcingLinkMutationVariables>;
export const DuplicateSourcingLinkDocument = gql`
    mutation DuplicateSourcingLink($input: SourcingLinkCreateInput!) {
  sourcingLinkCreate(input: $input) {
    sourcingLink {
      id
    }
  }
}
    `;
export type DuplicateSourcingLinkMutationFn = Apollo.MutationFunction<DuplicateSourcingLinkMutation, DuplicateSourcingLinkMutationVariables>;

/**
 * __useDuplicateSourcingLinkMutation__
 *
 * To run a mutation, you first call `useDuplicateSourcingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateSourcingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateSourcingLinkMutation, { data, loading, error }] = useDuplicateSourcingLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateSourcingLinkMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateSourcingLinkMutation, DuplicateSourcingLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateSourcingLinkMutation, DuplicateSourcingLinkMutationVariables>(DuplicateSourcingLinkDocument, options);
      }
export type DuplicateSourcingLinkMutationHookResult = ReturnType<typeof useDuplicateSourcingLinkMutation>;
export type DuplicateSourcingLinkMutationResult = Apollo.MutationResult<DuplicateSourcingLinkMutation>;
export type DuplicateSourcingLinkMutationOptions = Apollo.BaseMutationOptions<DuplicateSourcingLinkMutation, DuplicateSourcingLinkMutationVariables>;
export const DeleteSourcingLinkDocument = gql`
    mutation DeleteSourcingLink($id: uuid!) {
  sourcingLinkDelete(id: $id) {
    result
  }
}
    `;
export type DeleteSourcingLinkMutationFn = Apollo.MutationFunction<DeleteSourcingLinkMutation, DeleteSourcingLinkMutationVariables>;

/**
 * __useDeleteSourcingLinkMutation__
 *
 * To run a mutation, you first call `useDeleteSourcingLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSourcingLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSourcingLinkMutation, { data, loading, error }] = useDeleteSourcingLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSourcingLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSourcingLinkMutation, DeleteSourcingLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSourcingLinkMutation, DeleteSourcingLinkMutationVariables>(DeleteSourcingLinkDocument, options);
      }
export type DeleteSourcingLinkMutationHookResult = ReturnType<typeof useDeleteSourcingLinkMutation>;
export type DeleteSourcingLinkMutationResult = Apollo.MutationResult<DeleteSourcingLinkMutation>;
export type DeleteSourcingLinkMutationOptions = Apollo.BaseMutationOptions<DeleteSourcingLinkMutation, DeleteSourcingLinkMutationVariables>;
export const UpdateSourcingLinkStatusDocument = gql`
    mutation UpdateSourcingLinkStatus($input: SourcingLinkUpdateInput!) {
  sourcingLinkUpdate(input: $input) {
    sourcingLink {
      id
      deactivatedAt
    }
  }
}
    `;
export type UpdateSourcingLinkStatusMutationFn = Apollo.MutationFunction<UpdateSourcingLinkStatusMutation, UpdateSourcingLinkStatusMutationVariables>;

/**
 * __useUpdateSourcingLinkStatusMutation__
 *
 * To run a mutation, you first call `useUpdateSourcingLinkStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSourcingLinkStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSourcingLinkStatusMutation, { data, loading, error }] = useUpdateSourcingLinkStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSourcingLinkStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSourcingLinkStatusMutation, UpdateSourcingLinkStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSourcingLinkStatusMutation, UpdateSourcingLinkStatusMutationVariables>(UpdateSourcingLinkStatusDocument, options);
      }
export type UpdateSourcingLinkStatusMutationHookResult = ReturnType<typeof useUpdateSourcingLinkStatusMutation>;
export type UpdateSourcingLinkStatusMutationResult = Apollo.MutationResult<UpdateSourcingLinkStatusMutation>;
export type UpdateSourcingLinkStatusMutationOptions = Apollo.BaseMutationOptions<UpdateSourcingLinkStatusMutation, UpdateSourcingLinkStatusMutationVariables>;
export const SourcingLinksDocument = gql`
    query SourcingLinks($jobId: uuid!) {
  job(id: $jobId) {
    id
    status
    sourcingLinks {
      id
      ...SourcingLinkForm_sourcingLink
      ...SourcingLinkFormDeprecated_sourcingLink
      ...SourcingLinksTable_sourcingLinks
    }
    ...SourcingLinkForm_job
    ...SourcingLinkFormDeprecated_job
  }
  thisEmployee {
    id
    ...SourcingLinkForm_currentEmployee
    ...SourcingLinkFormDeprecated_currentEmployee
  }
}
    ${SourcingLinkForm_SourcingLinkFragmentDoc}
${SourcingLinkFormDeprecated_SourcingLinkFragmentDoc}
${SourcingLinksTable_SourcingLinksFragmentDoc}
${SourcingLinkForm_JobFragmentDoc}
${SourcingLinkFormDeprecated_JobFragmentDoc}
${SourcingLinkForm_CurrentEmployeeFragmentDoc}
${SourcingLinkFormDeprecated_CurrentEmployeeFragmentDoc}`;

/**
 * __useSourcingLinksQuery__
 *
 * To run a query within a React component, call `useSourcingLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourcingLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourcingLinksQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useSourcingLinksQuery(baseOptions: Apollo.QueryHookOptions<SourcingLinksQuery, SourcingLinksQueryVariables> & ({ variables: SourcingLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourcingLinksQuery, SourcingLinksQueryVariables>(SourcingLinksDocument, options);
      }
export function useSourcingLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourcingLinksQuery, SourcingLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourcingLinksQuery, SourcingLinksQueryVariables>(SourcingLinksDocument, options);
        }
// @ts-ignore
export function useSourcingLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourcingLinksQuery, SourcingLinksQueryVariables>): Apollo.UseSuspenseQueryResult<SourcingLinksQuery, SourcingLinksQueryVariables>;
export function useSourcingLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourcingLinksQuery, SourcingLinksQueryVariables>): Apollo.UseSuspenseQueryResult<SourcingLinksQuery | undefined, SourcingLinksQueryVariables>;
export function useSourcingLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourcingLinksQuery, SourcingLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourcingLinksQuery, SourcingLinksQueryVariables>(SourcingLinksDocument, options);
        }
export type SourcingLinksQueryHookResult = ReturnType<typeof useSourcingLinksQuery>;
export type SourcingLinksLazyQueryHookResult = ReturnType<typeof useSourcingLinksLazyQuery>;
export type SourcingLinksSuspenseQueryHookResult = ReturnType<typeof useSourcingLinksSuspenseQuery>;
export type SourcingLinksQueryResult = Apollo.QueryResult<SourcingLinksQuery, SourcingLinksQueryVariables>;
export const JobByIdDocument = gql`
    query JobById($jobId: uuid!) {
  jobV2(input: {id: $jobId}) {
    __typename
    ... on Job {
      id
      atsType
      ...JobStageDetailsContent_job
      ...JobNameAndLocationHeader_job
      ...JobStageMismatchAlert_job
      jobSettings {
        id
        hiringProcess {
          atsId
          name
          status
        }
      }
      jobStages {
        id
        ...JobDetailsPage_jobStage
        ...JobStageDetailsContent_jobStage
        jobStageSettingsV2 {
          id
          ...JobStageDetailsContent_jobStageSettingsV2
        }
      }
      ...HiringTeam_jobEmployee
      validationIssues {
        errors {
          ...getHiringMismatchError_flags
        }
      }
      ...HiringProcess_job
    }
    ... on Error {
      errorCode
      errorMessage
    }
  }
}
    ${JobStageDetailsContent_JobFragmentDoc}
${JobNameAndLocationHeader_JobFragmentDoc}
${JobStageMismatchAlert_JobFragmentDoc}
${JobDetailsPage_JobStageFragmentDoc}
${JobStageDetailsContent_JobStageFragmentDoc}
${JobStageDetailsContent_JobStageSettingsV2FragmentDoc}
${HiringTeam_JobEmployeeFragmentDoc}
${GetHiringMismatchError_FlagsFragmentDoc}
${HiringProcess_JobFragmentDoc}`;

/**
 * __useJobByIdQuery__
 *
 * To run a query within a React component, call `useJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useJobByIdQuery(baseOptions: Apollo.QueryHookOptions<JobByIdQuery, JobByIdQueryVariables> & ({ variables: JobByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobByIdQuery, JobByIdQueryVariables>(JobByIdDocument, options);
      }
export function useJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobByIdQuery, JobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobByIdQuery, JobByIdQueryVariables>(JobByIdDocument, options);
        }
// @ts-ignore
export function useJobByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobByIdQuery, JobByIdQueryVariables>): Apollo.UseSuspenseQueryResult<JobByIdQuery, JobByIdQueryVariables>;
export function useJobByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobByIdQuery, JobByIdQueryVariables>): Apollo.UseSuspenseQueryResult<JobByIdQuery | undefined, JobByIdQueryVariables>;
export function useJobByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobByIdQuery, JobByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobByIdQuery, JobByIdQueryVariables>(JobByIdDocument, options);
        }
export type JobByIdQueryHookResult = ReturnType<typeof useJobByIdQuery>;
export type JobByIdLazyQueryHookResult = ReturnType<typeof useJobByIdLazyQuery>;
export type JobByIdSuspenseQueryHookResult = ReturnType<typeof useJobByIdSuspenseQuery>;
export type JobByIdQueryResult = Apollo.QueryResult<JobByIdQuery, JobByIdQueryVariables>;
export const ReSyncHiringProcessDocument = gql`
    mutation ReSyncHiringProcess($input: JobSettingsUpsertInput!) {
  jobSettingsUpsert(input: $input) {
    jobSettings {
      id
      hiringProcess {
        atsId
        name
        status
      }
    }
  }
}
    `;
export type ReSyncHiringProcessMutationFn = Apollo.MutationFunction<ReSyncHiringProcessMutation, ReSyncHiringProcessMutationVariables>;

/**
 * __useReSyncHiringProcessMutation__
 *
 * To run a mutation, you first call `useReSyncHiringProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReSyncHiringProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reSyncHiringProcessMutation, { data, loading, error }] = useReSyncHiringProcessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReSyncHiringProcessMutation(baseOptions?: Apollo.MutationHookOptions<ReSyncHiringProcessMutation, ReSyncHiringProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReSyncHiringProcessMutation, ReSyncHiringProcessMutationVariables>(ReSyncHiringProcessDocument, options);
      }
export type ReSyncHiringProcessMutationHookResult = ReturnType<typeof useReSyncHiringProcessMutation>;
export type ReSyncHiringProcessMutationResult = Apollo.MutationResult<ReSyncHiringProcessMutation>;
export type ReSyncHiringProcessMutationOptions = Apollo.BaseMutationOptions<ReSyncHiringProcessMutation, ReSyncHiringProcessMutationVariables>;
export const FixAndImportJobSettingsDocument = gql`
    mutation FixAndImportJobSettings($input: JobSettingsImportInput!) {
  jobSettingsImport(input: $input) {
    sourceJob {
      id
    }
  }
}
    `;
export type FixAndImportJobSettingsMutationFn = Apollo.MutationFunction<FixAndImportJobSettingsMutation, FixAndImportJobSettingsMutationVariables>;

/**
 * __useFixAndImportJobSettingsMutation__
 *
 * To run a mutation, you first call `useFixAndImportJobSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFixAndImportJobSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fixAndImportJobSettingsMutation, { data, loading, error }] = useFixAndImportJobSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFixAndImportJobSettingsMutation(baseOptions?: Apollo.MutationHookOptions<FixAndImportJobSettingsMutation, FixAndImportJobSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FixAndImportJobSettingsMutation, FixAndImportJobSettingsMutationVariables>(FixAndImportJobSettingsDocument, options);
      }
export type FixAndImportJobSettingsMutationHookResult = ReturnType<typeof useFixAndImportJobSettingsMutation>;
export type FixAndImportJobSettingsMutationResult = Apollo.MutationResult<FixAndImportJobSettingsMutation>;
export type FixAndImportJobSettingsMutationOptions = Apollo.BaseMutationOptions<FixAndImportJobSettingsMutation, FixAndImportJobSettingsMutationVariables>;
export const SourceJobsListDocument = gql`
    query SourceJobsList($input: JobsInput!) {
  jobs(input: $input) {
    items {
      ...SourceJobTable_job
    }
    nextCursor
  }
}
    ${SourceJobTable_JobFragmentDoc}`;

/**
 * __useSourceJobsListQuery__
 *
 * To run a query within a React component, call `useSourceJobsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSourceJobsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSourceJobsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSourceJobsListQuery(baseOptions: Apollo.QueryHookOptions<SourceJobsListQuery, SourceJobsListQueryVariables> & ({ variables: SourceJobsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SourceJobsListQuery, SourceJobsListQueryVariables>(SourceJobsListDocument, options);
      }
export function useSourceJobsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SourceJobsListQuery, SourceJobsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SourceJobsListQuery, SourceJobsListQueryVariables>(SourceJobsListDocument, options);
        }
// @ts-ignore
export function useSourceJobsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SourceJobsListQuery, SourceJobsListQueryVariables>): Apollo.UseSuspenseQueryResult<SourceJobsListQuery, SourceJobsListQueryVariables>;
export function useSourceJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceJobsListQuery, SourceJobsListQueryVariables>): Apollo.UseSuspenseQueryResult<SourceJobsListQuery | undefined, SourceJobsListQueryVariables>;
export function useSourceJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SourceJobsListQuery, SourceJobsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SourceJobsListQuery, SourceJobsListQueryVariables>(SourceJobsListDocument, options);
        }
export type SourceJobsListQueryHookResult = ReturnType<typeof useSourceJobsListQuery>;
export type SourceJobsListLazyQueryHookResult = ReturnType<typeof useSourceJobsListLazyQuery>;
export type SourceJobsListSuspenseQueryHookResult = ReturnType<typeof useSourceJobsListSuspenseQuery>;
export type SourceJobsListQueryResult = Apollo.QueryResult<SourceJobsListQuery, SourceJobsListQueryVariables>;
export const GetSourceJobDocument = gql`
    query GetSourceJob($id: uuid!) {
  job(id: $id) {
    ...SelectImportOptions_job
  }
}
    ${SelectImportOptions_JobFragmentDoc}`;

/**
 * __useGetSourceJobQuery__
 *
 * To run a query within a React component, call `useGetSourceJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourceJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourceJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSourceJobQuery(baseOptions: Apollo.QueryHookOptions<GetSourceJobQuery, GetSourceJobQueryVariables> & ({ variables: GetSourceJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourceJobQuery, GetSourceJobQueryVariables>(GetSourceJobDocument, options);
      }
export function useGetSourceJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourceJobQuery, GetSourceJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourceJobQuery, GetSourceJobQueryVariables>(GetSourceJobDocument, options);
        }
// @ts-ignore
export function useGetSourceJobSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSourceJobQuery, GetSourceJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetSourceJobQuery, GetSourceJobQueryVariables>;
export function useGetSourceJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourceJobQuery, GetSourceJobQueryVariables>): Apollo.UseSuspenseQueryResult<GetSourceJobQuery | undefined, GetSourceJobQueryVariables>;
export function useGetSourceJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourceJobQuery, GetSourceJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSourceJobQuery, GetSourceJobQueryVariables>(GetSourceJobDocument, options);
        }
export type GetSourceJobQueryHookResult = ReturnType<typeof useGetSourceJobQuery>;
export type GetSourceJobLazyQueryHookResult = ReturnType<typeof useGetSourceJobLazyQuery>;
export type GetSourceJobSuspenseQueryHookResult = ReturnType<typeof useGetSourceJobSuspenseQuery>;
export type GetSourceJobQueryResult = Apollo.QueryResult<GetSourceJobQuery, GetSourceJobQueryVariables>;
export const GetTargetJobsDocument = gql`
    query GetTargetJobs($ids: [uuid!]!) {
  jobByIds(ids: $ids) {
    id
    ...ExitConfirmationModal_jobs
  }
}
    ${ExitConfirmationModal_JobsFragmentDoc}`;

/**
 * __useGetTargetJobsQuery__
 *
 * To run a query within a React component, call `useGetTargetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetJobsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetTargetJobsQuery(baseOptions: Apollo.QueryHookOptions<GetTargetJobsQuery, GetTargetJobsQueryVariables> & ({ variables: GetTargetJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetJobsQuery, GetTargetJobsQueryVariables>(GetTargetJobsDocument, options);
      }
export function useGetTargetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetJobsQuery, GetTargetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetJobsQuery, GetTargetJobsQueryVariables>(GetTargetJobsDocument, options);
        }
// @ts-ignore
export function useGetTargetJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTargetJobsQuery, GetTargetJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTargetJobsQuery, GetTargetJobsQueryVariables>;
export function useGetTargetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetJobsQuery, GetTargetJobsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTargetJobsQuery | undefined, GetTargetJobsQueryVariables>;
export function useGetTargetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetJobsQuery, GetTargetJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetJobsQuery, GetTargetJobsQueryVariables>(GetTargetJobsDocument, options);
        }
export type GetTargetJobsQueryHookResult = ReturnType<typeof useGetTargetJobsQuery>;
export type GetTargetJobsLazyQueryHookResult = ReturnType<typeof useGetTargetJobsLazyQuery>;
export type GetTargetJobsSuspenseQueryHookResult = ReturnType<typeof useGetTargetJobsSuspenseQuery>;
export type GetTargetJobsQueryResult = Apollo.QueryResult<GetTargetJobsQuery, GetTargetJobsQueryVariables>;
export const JobSettingsImportValidateDocument = gql`
    query JobSettingsImportValidate($input: JobSettingsImportValidateInput!) {
  jobSettingsImportValidate(input: $input) {
    ...FixIssues_issues
    items {
      ...Review_jobImportValidateResults
      ...getJobsWithIssues_jobImportValidateResults
      ...getJobsWithoutIssues_jobImportValidateResults
      jobStageMappings {
        ...getJobStageMappings_jobStageMapping
      }
      scorecardMappings {
        ...getScorecardMappings_scorecardMapping
      }
      contentTabMappings {
        targetJobStageId
        sourceContentTabId
        sourceContentTabType
        sourceVisibility
      }
    }
  }
}
    ${FixIssues_IssuesFragmentDoc}
${Review_JobImportValidateResultsFragmentDoc}
${GetJobsWithIssues_JobImportValidateResultsFragmentDoc}
${GetJobsWithoutIssues_JobImportValidateResultsFragmentDoc}
${GetJobStageMappings_JobStageMappingFragmentDoc}
${GetScorecardMappings_ScorecardMappingFragmentDoc}`;

/**
 * __useJobSettingsImportValidateQuery__
 *
 * To run a query within a React component, call `useJobSettingsImportValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobSettingsImportValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobSettingsImportValidateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobSettingsImportValidateQuery(baseOptions: Apollo.QueryHookOptions<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables> & ({ variables: JobSettingsImportValidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>(JobSettingsImportValidateDocument, options);
      }
export function useJobSettingsImportValidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>(JobSettingsImportValidateDocument, options);
        }
// @ts-ignore
export function useJobSettingsImportValidateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>): Apollo.UseSuspenseQueryResult<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>;
export function useJobSettingsImportValidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>): Apollo.UseSuspenseQueryResult<JobSettingsImportValidateQuery | undefined, JobSettingsImportValidateQueryVariables>;
export function useJobSettingsImportValidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>(JobSettingsImportValidateDocument, options);
        }
export type JobSettingsImportValidateQueryHookResult = ReturnType<typeof useJobSettingsImportValidateQuery>;
export type JobSettingsImportValidateLazyQueryHookResult = ReturnType<typeof useJobSettingsImportValidateLazyQuery>;
export type JobSettingsImportValidateSuspenseQueryHookResult = ReturnType<typeof useJobSettingsImportValidateSuspenseQuery>;
export type JobSettingsImportValidateQueryResult = Apollo.QueryResult<JobSettingsImportValidateQuery, JobSettingsImportValidateQueryVariables>;
export const ImportJobSettingsDocument = gql`
    mutation ImportJobSettings($input: JobSettingsImportInput!) {
  jobSettingsImport(input: $input) {
    sourceJob {
      id
    }
  }
}
    `;
export type ImportJobSettingsMutationFn = Apollo.MutationFunction<ImportJobSettingsMutation, ImportJobSettingsMutationVariables>;

/**
 * __useImportJobSettingsMutation__
 *
 * To run a mutation, you first call `useImportJobSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportJobSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importJobSettingsMutation, { data, loading, error }] = useImportJobSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportJobSettingsMutation(baseOptions?: Apollo.MutationHookOptions<ImportJobSettingsMutation, ImportJobSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportJobSettingsMutation, ImportJobSettingsMutationVariables>(ImportJobSettingsDocument, options);
      }
export type ImportJobSettingsMutationHookResult = ReturnType<typeof useImportJobSettingsMutation>;
export type ImportJobSettingsMutationResult = Apollo.MutationResult<ImportJobSettingsMutation>;
export type ImportJobSettingsMutationOptions = Apollo.BaseMutationOptions<ImportJobSettingsMutation, ImportJobSettingsMutationVariables>;
export const JobsListDocument = gql`
    query JobsList($input: JobsInput!) {
  jobs(input: $input) {
    items {
      ...JobListTable_job
    }
    nextCursor
  }
}
    ${JobListTable_JobFragmentDoc}`;

/**
 * __useJobsListQuery__
 *
 * To run a query within a React component, call `useJobsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJobsListQuery(baseOptions: Apollo.QueryHookOptions<JobsListQuery, JobsListQueryVariables> & ({ variables: JobsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobsListQuery, JobsListQueryVariables>(JobsListDocument, options);
      }
export function useJobsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobsListQuery, JobsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobsListQuery, JobsListQueryVariables>(JobsListDocument, options);
        }
// @ts-ignore
export function useJobsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobsListQuery, JobsListQueryVariables>): Apollo.UseSuspenseQueryResult<JobsListQuery, JobsListQueryVariables>;
export function useJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsListQuery, JobsListQueryVariables>): Apollo.UseSuspenseQueryResult<JobsListQuery | undefined, JobsListQueryVariables>;
export function useJobsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobsListQuery, JobsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobsListQuery, JobsListQueryVariables>(JobsListDocument, options);
        }
export type JobsListQueryHookResult = ReturnType<typeof useJobsListQuery>;
export type JobsListLazyQueryHookResult = ReturnType<typeof useJobsListLazyQuery>;
export type JobsListSuspenseQueryHookResult = ReturnType<typeof useJobsListSuspenseQuery>;
export type JobsListQueryResult = Apollo.QueryResult<JobsListQuery, JobsListQueryVariables>;
export const PulseSurveyMetricsTagsDocument = gql`
    query PulseSurveyMetricsTags {
  thisOrg {
    candidatePulseTags {
      positive {
        id
        name
        emoji
      }
      negative {
        id
        name
        emoji
      }
    }
  }
}
    `;

/**
 * __usePulseSurveyMetricsTagsQuery__
 *
 * To run a query within a React component, call `usePulseSurveyMetricsTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseSurveyMetricsTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseSurveyMetricsTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePulseSurveyMetricsTagsQuery(baseOptions?: Apollo.QueryHookOptions<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>(PulseSurveyMetricsTagsDocument, options);
      }
export function usePulseSurveyMetricsTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>(PulseSurveyMetricsTagsDocument, options);
        }
// @ts-ignore
export function usePulseSurveyMetricsTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>;
export function usePulseSurveyMetricsTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyMetricsTagsQuery | undefined, PulseSurveyMetricsTagsQueryVariables>;
export function usePulseSurveyMetricsTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>(PulseSurveyMetricsTagsDocument, options);
        }
export type PulseSurveyMetricsTagsQueryHookResult = ReturnType<typeof usePulseSurveyMetricsTagsQuery>;
export type PulseSurveyMetricsTagsLazyQueryHookResult = ReturnType<typeof usePulseSurveyMetricsTagsLazyQuery>;
export type PulseSurveyMetricsTagsSuspenseQueryHookResult = ReturnType<typeof usePulseSurveyMetricsTagsSuspenseQuery>;
export type PulseSurveyMetricsTagsQueryResult = Apollo.QueryResult<PulseSurveyMetricsTagsQuery, PulseSurveyMetricsTagsQueryVariables>;
export const PulseSurveyPositiveNotesDocument = gql`
    query PulseSurveyPositiveNotes($input: CandidatePulseSearchInput!) {
  candidatePulseSearch(input: $input) {
    items {
      rating
      positiveNote
    }
    total
    hasNext
  }
}
    `;

/**
 * __usePulseSurveyPositiveNotesQuery__
 *
 * To run a query within a React component, call `usePulseSurveyPositiveNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseSurveyPositiveNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseSurveyPositiveNotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePulseSurveyPositiveNotesQuery(baseOptions: Apollo.QueryHookOptions<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables> & ({ variables: PulseSurveyPositiveNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>(PulseSurveyPositiveNotesDocument, options);
      }
export function usePulseSurveyPositiveNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>(PulseSurveyPositiveNotesDocument, options);
        }
// @ts-ignore
export function usePulseSurveyPositiveNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>;
export function usePulseSurveyPositiveNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyPositiveNotesQuery | undefined, PulseSurveyPositiveNotesQueryVariables>;
export function usePulseSurveyPositiveNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>(PulseSurveyPositiveNotesDocument, options);
        }
export type PulseSurveyPositiveNotesQueryHookResult = ReturnType<typeof usePulseSurveyPositiveNotesQuery>;
export type PulseSurveyPositiveNotesLazyQueryHookResult = ReturnType<typeof usePulseSurveyPositiveNotesLazyQuery>;
export type PulseSurveyPositiveNotesSuspenseQueryHookResult = ReturnType<typeof usePulseSurveyPositiveNotesSuspenseQuery>;
export type PulseSurveyPositiveNotesQueryResult = Apollo.QueryResult<PulseSurveyPositiveNotesQuery, PulseSurveyPositiveNotesQueryVariables>;
export const PulseSurveyNegativeNotesDocument = gql`
    query PulseSurveyNegativeNotes($input: CandidatePulseSearchInput!) {
  candidatePulseSearch(input: $input) {
    items {
      rating
      negativeNote
    }
    total
    hasNext
  }
}
    `;

/**
 * __usePulseSurveyNegativeNotesQuery__
 *
 * To run a query within a React component, call `usePulseSurveyNegativeNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseSurveyNegativeNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseSurveyNegativeNotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePulseSurveyNegativeNotesQuery(baseOptions: Apollo.QueryHookOptions<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables> & ({ variables: PulseSurveyNegativeNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>(PulseSurveyNegativeNotesDocument, options);
      }
export function usePulseSurveyNegativeNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>(PulseSurveyNegativeNotesDocument, options);
        }
// @ts-ignore
export function usePulseSurveyNegativeNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>;
export function usePulseSurveyNegativeNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyNegativeNotesQuery | undefined, PulseSurveyNegativeNotesQueryVariables>;
export function usePulseSurveyNegativeNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>(PulseSurveyNegativeNotesDocument, options);
        }
export type PulseSurveyNegativeNotesQueryHookResult = ReturnType<typeof usePulseSurveyNegativeNotesQuery>;
export type PulseSurveyNegativeNotesLazyQueryHookResult = ReturnType<typeof usePulseSurveyNegativeNotesLazyQuery>;
export type PulseSurveyNegativeNotesSuspenseQueryHookResult = ReturnType<typeof usePulseSurveyNegativeNotesSuspenseQuery>;
export type PulseSurveyNegativeNotesQueryResult = Apollo.QueryResult<PulseSurveyNegativeNotesQuery, PulseSurveyNegativeNotesQueryVariables>;
export const PulseSurveyMetricsDownloadDocument = gql`
    query PulseSurveyMetricsDownload($input: CandidatePulseSearchInput!) {
  candidatePulseSearch(input: $input) {
    items {
      rating
      npsRating
      positiveNote
      positiveTags {
        id
        name
      }
      negativeNote
      negativeTags {
        id
        name
      }
    }
    total
    hasNext
  }
}
    `;

/**
 * __usePulseSurveyMetricsDownloadQuery__
 *
 * To run a query within a React component, call `usePulseSurveyMetricsDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseSurveyMetricsDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseSurveyMetricsDownloadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePulseSurveyMetricsDownloadQuery(baseOptions: Apollo.QueryHookOptions<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables> & ({ variables: PulseSurveyMetricsDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>(PulseSurveyMetricsDownloadDocument, options);
      }
export function usePulseSurveyMetricsDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>(PulseSurveyMetricsDownloadDocument, options);
        }
// @ts-ignore
export function usePulseSurveyMetricsDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>;
export function usePulseSurveyMetricsDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyMetricsDownloadQuery | undefined, PulseSurveyMetricsDownloadQueryVariables>;
export function usePulseSurveyMetricsDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>(PulseSurveyMetricsDownloadDocument, options);
        }
export type PulseSurveyMetricsDownloadQueryHookResult = ReturnType<typeof usePulseSurveyMetricsDownloadQuery>;
export type PulseSurveyMetricsDownloadLazyQueryHookResult = ReturnType<typeof usePulseSurveyMetricsDownloadLazyQuery>;
export type PulseSurveyMetricsDownloadSuspenseQueryHookResult = ReturnType<typeof usePulseSurveyMetricsDownloadSuspenseQuery>;
export type PulseSurveyMetricsDownloadQueryResult = Apollo.QueryResult<PulseSurveyMetricsDownloadQuery, PulseSurveyMetricsDownloadQueryVariables>;
export const PulseSurveyMetricsDocument = gql`
    query PulseSurveyMetrics($input: CandidatePulseMetricsInput!) {
  candidatePulseMetrics(input: $input) {
    summary {
      totalResponses
      ...SummarySection_summary
    }
    positive {
      tags {
        ...QuestionSection_tagWithPercentage
      }
    }
    negative {
      tags {
        ...QuestionSection_tagWithPercentage
      }
    }
  }
}
    ${SummarySection_SummaryFragmentDoc}
${QuestionSection_TagWithPercentageFragmentDoc}`;

/**
 * __usePulseSurveyMetricsQuery__
 *
 * To run a query within a React component, call `usePulseSurveyMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseSurveyMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseSurveyMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePulseSurveyMetricsQuery(baseOptions: Apollo.QueryHookOptions<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables> & ({ variables: PulseSurveyMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>(PulseSurveyMetricsDocument, options);
      }
export function usePulseSurveyMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>(PulseSurveyMetricsDocument, options);
        }
// @ts-ignore
export function usePulseSurveyMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>;
export function usePulseSurveyMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveyMetricsQuery | undefined, PulseSurveyMetricsQueryVariables>;
export function usePulseSurveyMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>(PulseSurveyMetricsDocument, options);
        }
export type PulseSurveyMetricsQueryHookResult = ReturnType<typeof usePulseSurveyMetricsQuery>;
export type PulseSurveyMetricsLazyQueryHookResult = ReturnType<typeof usePulseSurveyMetricsLazyQuery>;
export type PulseSurveyMetricsSuspenseQueryHookResult = ReturnType<typeof usePulseSurveyMetricsSuspenseQuery>;
export type PulseSurveyMetricsQueryResult = Apollo.QueryResult<PulseSurveyMetricsQuery, PulseSurveyMetricsQueryVariables>;
export const DebriefMetricsDownloadDocument = gql`
    query DebriefMetricsDownload($input: DebriefMetricsDownloadInput!) {
  debriefMetricsDownload(input: $input) {
    debriefId
    name
    startAt
    endAt
    isCancelled
    cancelledAt
    scheduler {
      id
      fullName
      email
    }
    candidateName
    jobName
    taskId
    attendeeCount
    acceptedCount
    declinedCount
  }
}
    `;

/**
 * __useDebriefMetricsDownloadQuery__
 *
 * To run a query within a React component, call `useDebriefMetricsDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefMetricsDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefMetricsDownloadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDebriefMetricsDownloadQuery(baseOptions: Apollo.QueryHookOptions<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables> & ({ variables: DebriefMetricsDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>(DebriefMetricsDownloadDocument, options);
      }
export function useDebriefMetricsDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>(DebriefMetricsDownloadDocument, options);
        }
// @ts-ignore
export function useDebriefMetricsDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>;
export function useDebriefMetricsDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefMetricsDownloadQuery | undefined, DebriefMetricsDownloadQueryVariables>;
export function useDebriefMetricsDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>(DebriefMetricsDownloadDocument, options);
        }
export type DebriefMetricsDownloadQueryHookResult = ReturnType<typeof useDebriefMetricsDownloadQuery>;
export type DebriefMetricsDownloadLazyQueryHookResult = ReturnType<typeof useDebriefMetricsDownloadLazyQuery>;
export type DebriefMetricsDownloadSuspenseQueryHookResult = ReturnType<typeof useDebriefMetricsDownloadSuspenseQuery>;
export type DebriefMetricsDownloadQueryResult = Apollo.QueryResult<DebriefMetricsDownloadQuery, DebriefMetricsDownloadQueryVariables>;
export const DebriefMetricsDocument = gql`
    query DebriefMetrics($input: DebriefMetricsInput!) {
  debriefMetrics(input: $input) {
    totals {
      scheduled
      completed
      upcoming
      cancelled
      attendeeDeclines
    }
    trend {
      bucketStart
      scheduled
      completed
      upcoming
      cancelled
    }
    bySchedulers {
      schedulerEmployeeId
      scheduler {
        id
        fullName
        internalProfilePictureUrl
        email
      }
      scheduled
      completed
      upcoming
      cancelled
      attendeeDeclines
    }
    byAttendees {
      interviewerId
      interviewer {
        id
        fullName
        internalProfilePictureUrl
        email
      }
      invited
      accepted
      declined
      tentative
      needsAction
    }
  }
}
    `;

/**
 * __useDebriefMetricsQuery__
 *
 * To run a query within a React component, call `useDebriefMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDebriefMetricsQuery(baseOptions: Apollo.QueryHookOptions<DebriefMetricsQuery, DebriefMetricsQueryVariables> & ({ variables: DebriefMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefMetricsQuery, DebriefMetricsQueryVariables>(DebriefMetricsDocument, options);
      }
export function useDebriefMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefMetricsQuery, DebriefMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefMetricsQuery, DebriefMetricsQueryVariables>(DebriefMetricsDocument, options);
        }
// @ts-ignore
export function useDebriefMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefMetricsQuery, DebriefMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefMetricsQuery, DebriefMetricsQueryVariables>;
export function useDebriefMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefMetricsQuery, DebriefMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefMetricsQuery | undefined, DebriefMetricsQueryVariables>;
export function useDebriefMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefMetricsQuery, DebriefMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefMetricsQuery, DebriefMetricsQueryVariables>(DebriefMetricsDocument, options);
        }
export type DebriefMetricsQueryHookResult = ReturnType<typeof useDebriefMetricsQuery>;
export type DebriefMetricsLazyQueryHookResult = ReturnType<typeof useDebriefMetricsLazyQuery>;
export type DebriefMetricsSuspenseQueryHookResult = ReturnType<typeof useDebriefMetricsSuspenseQuery>;
export type DebriefMetricsQueryResult = Apollo.QueryResult<DebriefMetricsQuery, DebriefMetricsQueryVariables>;
export const DeclineMetricesDownloadDocument = gql`
    query DeclineMetricesDownload($input: InterviewerMetricsChartInput!) {
  interviewerMetricsChartDownload(input: $input) {
    data {
      interviewDate
      candidate
      interviewName
      calendarEventTitle
      jobStage
      scorecard
      scheduler
      interviewer
      declineLeadTime
      jobName
      atsJobId
      jobLocations
      atsApplicationId
      atsCandidateId
      taskId
      interviewModule {
        name
      }
      job
      interviewerEmployee {
        id
        manager {
          email
        }
        attributes {
          name {
            name
          }
          value
        }
      }
    }
  }
}
    `;

/**
 * __useDeclineMetricesDownloadQuery__
 *
 * To run a query within a React component, call `useDeclineMetricesDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeclineMetricesDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeclineMetricesDownloadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineMetricesDownloadQuery(baseOptions: Apollo.QueryHookOptions<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables> & ({ variables: DeclineMetricesDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>(DeclineMetricesDownloadDocument, options);
      }
export function useDeclineMetricesDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>(DeclineMetricesDownloadDocument, options);
        }
// @ts-ignore
export function useDeclineMetricesDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>;
export function useDeclineMetricesDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<DeclineMetricesDownloadQuery | undefined, DeclineMetricesDownloadQueryVariables>;
export function useDeclineMetricesDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>(DeclineMetricesDownloadDocument, options);
        }
export type DeclineMetricesDownloadQueryHookResult = ReturnType<typeof useDeclineMetricesDownloadQuery>;
export type DeclineMetricesDownloadLazyQueryHookResult = ReturnType<typeof useDeclineMetricesDownloadLazyQuery>;
export type DeclineMetricesDownloadSuspenseQueryHookResult = ReturnType<typeof useDeclineMetricesDownloadSuspenseQuery>;
export type DeclineMetricesDownloadQueryResult = Apollo.QueryResult<DeclineMetricesDownloadQuery, DeclineMetricesDownloadQueryVariables>;
export const InterviewsCompletedChartDocument = gql`
    query InterviewsCompletedChart($input: InterviewerMetricsChartInput!) {
  interviewerMetricsChart(input: $input) {
    data {
      x: xpoint
      y: ypoint
    }
  }
}
    `;

/**
 * __useInterviewsCompletedChartQuery__
 *
 * To run a query within a React component, call `useInterviewsCompletedChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewsCompletedChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewsCompletedChartQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewsCompletedChartQuery(baseOptions: Apollo.QueryHookOptions<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables> & ({ variables: InterviewsCompletedChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>(InterviewsCompletedChartDocument, options);
      }
export function useInterviewsCompletedChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>(InterviewsCompletedChartDocument, options);
        }
// @ts-ignore
export function useInterviewsCompletedChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>;
export function useInterviewsCompletedChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsCompletedChartQuery | undefined, InterviewsCompletedChartQueryVariables>;
export function useInterviewsCompletedChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>(InterviewsCompletedChartDocument, options);
        }
export type InterviewsCompletedChartQueryHookResult = ReturnType<typeof useInterviewsCompletedChartQuery>;
export type InterviewsCompletedChartLazyQueryHookResult = ReturnType<typeof useInterviewsCompletedChartLazyQuery>;
export type InterviewsCompletedChartSuspenseQueryHookResult = ReturnType<typeof useInterviewsCompletedChartSuspenseQuery>;
export type InterviewsCompletedChartQueryResult = Apollo.QueryResult<InterviewsCompletedChartQuery, InterviewsCompletedChartQueryVariables>;
export const InterviewsCompletedDownloadChartDocument = gql`
    query InterviewsCompletedDownloadChart($input: InterviewerMetricsChartInput!) {
  interviewerMetricsChartDownload(input: $input) {
    data {
      interviewDate
      candidate
      interviewName
      calendarEventTitle
      jobStage
      job
      scorecard
      scheduler
      interviewer
      jobName
      jobLocations
      atsJobId
      atsApplicationId
      atsCandidateId
      taskId
      interviewModule {
        name
      }
      interviewerEmployee {
        id
        manager {
          email
        }
        attributes {
          name {
            name
          }
          value
        }
      }
    }
  }
}
    `;

/**
 * __useInterviewsCompletedDownloadChartQuery__
 *
 * To run a query within a React component, call `useInterviewsCompletedDownloadChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewsCompletedDownloadChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewsCompletedDownloadChartQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewsCompletedDownloadChartQuery(baseOptions: Apollo.QueryHookOptions<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables> & ({ variables: InterviewsCompletedDownloadChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>(InterviewsCompletedDownloadChartDocument, options);
      }
export function useInterviewsCompletedDownloadChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>(InterviewsCompletedDownloadChartDocument, options);
        }
// @ts-ignore
export function useInterviewsCompletedDownloadChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>;
export function useInterviewsCompletedDownloadChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsCompletedDownloadChartQuery | undefined, InterviewsCompletedDownloadChartQueryVariables>;
export function useInterviewsCompletedDownloadChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>(InterviewsCompletedDownloadChartDocument, options);
        }
export type InterviewsCompletedDownloadChartQueryHookResult = ReturnType<typeof useInterviewsCompletedDownloadChartQuery>;
export type InterviewsCompletedDownloadChartLazyQueryHookResult = ReturnType<typeof useInterviewsCompletedDownloadChartLazyQuery>;
export type InterviewsCompletedDownloadChartSuspenseQueryHookResult = ReturnType<typeof useInterviewsCompletedDownloadChartSuspenseQuery>;
export type InterviewsCompletedDownloadChartQueryResult = Apollo.QueryResult<InterviewsCompletedDownloadChartQuery, InterviewsCompletedDownloadChartQueryVariables>;
export const InterviewsDeclinedDownloadChartDocument = gql`
    query InterviewsDeclinedDownloadChart($input: InterviewerMetricsChartInput!) {
  interviewerMetricsChartDownload(input: $input) {
    data {
      interviewDate
      candidate
      interviewName
      calendarEventTitle
      jobStage
      scorecard
      scheduler
      interviewer
      jobName
      job
      jobLocations
      atsJobId
      atsApplicationId
      atsCandidateId
      taskId
      declineReason
      declineComment
      interviewModule {
        name
      }
      interviewerEmployee {
        id
        manager {
          email
        }
        attributes {
          name {
            name
          }
          value
        }
      }
    }
  }
}
    `;

/**
 * __useInterviewsDeclinedDownloadChartQuery__
 *
 * To run a query within a React component, call `useInterviewsDeclinedDownloadChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewsDeclinedDownloadChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewsDeclinedDownloadChartQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewsDeclinedDownloadChartQuery(baseOptions: Apollo.QueryHookOptions<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables> & ({ variables: InterviewsDeclinedDownloadChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>(InterviewsDeclinedDownloadChartDocument, options);
      }
export function useInterviewsDeclinedDownloadChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>(InterviewsDeclinedDownloadChartDocument, options);
        }
// @ts-ignore
export function useInterviewsDeclinedDownloadChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>;
export function useInterviewsDeclinedDownloadChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewsDeclinedDownloadChartQuery | undefined, InterviewsDeclinedDownloadChartQueryVariables>;
export function useInterviewsDeclinedDownloadChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>(InterviewsDeclinedDownloadChartDocument, options);
        }
export type InterviewsDeclinedDownloadChartQueryHookResult = ReturnType<typeof useInterviewsDeclinedDownloadChartQuery>;
export type InterviewsDeclinedDownloadChartLazyQueryHookResult = ReturnType<typeof useInterviewsDeclinedDownloadChartLazyQuery>;
export type InterviewsDeclinedDownloadChartSuspenseQueryHookResult = ReturnType<typeof useInterviewsDeclinedDownloadChartSuspenseQuery>;
export type InterviewsDeclinedDownloadChartQueryResult = Apollo.QueryResult<InterviewsDeclinedDownloadChartQuery, InterviewsDeclinedDownloadChartQueryVariables>;
export const InterviewerMetricsInterviewingDocument = gql`
    query interviewerMetricsInterviewing($input: InterviewerMetricsTableInput!) {
  interviewerMetricsInterviewing(input: $input) {
    items {
      interviewer {
        id
        fullName
        internalProfilePictureUrl
        email
        manager {
          email
        }
        attributes {
          name {
            name
          }
          value
        }
      }
      upcoming
      completed
      declines
      totalTime
      interviewPerWeek
      timePerWeek
    }
  }
}
    `;

/**
 * __useInterviewerMetricsInterviewingQuery__
 *
 * To run a query within a React component, call `useInterviewerMetricsInterviewingQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerMetricsInterviewingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerMetricsInterviewingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewerMetricsInterviewingQuery(baseOptions: Apollo.QueryHookOptions<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables> & ({ variables: InterviewerMetricsInterviewingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>(InterviewerMetricsInterviewingDocument, options);
      }
export function useInterviewerMetricsInterviewingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>(InterviewerMetricsInterviewingDocument, options);
        }
// @ts-ignore
export function useInterviewerMetricsInterviewingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>;
export function useInterviewerMetricsInterviewingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerMetricsInterviewingQuery | undefined, InterviewerMetricsInterviewingQueryVariables>;
export function useInterviewerMetricsInterviewingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>(InterviewerMetricsInterviewingDocument, options);
        }
export type InterviewerMetricsInterviewingQueryHookResult = ReturnType<typeof useInterviewerMetricsInterviewingQuery>;
export type InterviewerMetricsInterviewingLazyQueryHookResult = ReturnType<typeof useInterviewerMetricsInterviewingLazyQuery>;
export type InterviewerMetricsInterviewingSuspenseQueryHookResult = ReturnType<typeof useInterviewerMetricsInterviewingSuspenseQuery>;
export type InterviewerMetricsInterviewingQueryResult = Apollo.QueryResult<InterviewerMetricsInterviewingQuery, InterviewerMetricsInterviewingQueryVariables>;
export const InterviewerMetricsTrainingDocument = gql`
    query InterviewerMetricsTraining($input: InterviewerMetricsTableInput!) {
  interviewerMetricsTraining(input: $input) {
    items {
      interviewer {
        id
        internalProfilePictureUrl
        fullName
        email
        manager {
          email
        }
        attributes {
          name {
            name
          }
          value
        }
      }
      trainer
      shadows
      reverseShadows
      modulesAsTrainee
    }
  }
}
    `;

/**
 * __useInterviewerMetricsTrainingQuery__
 *
 * To run a query within a React component, call `useInterviewerMetricsTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerMetricsTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerMetricsTrainingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewerMetricsTrainingQuery(baseOptions: Apollo.QueryHookOptions<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables> & ({ variables: InterviewerMetricsTrainingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>(InterviewerMetricsTrainingDocument, options);
      }
export function useInterviewerMetricsTrainingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>(InterviewerMetricsTrainingDocument, options);
        }
// @ts-ignore
export function useInterviewerMetricsTrainingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>;
export function useInterviewerMetricsTrainingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerMetricsTrainingQuery | undefined, InterviewerMetricsTrainingQueryVariables>;
export function useInterviewerMetricsTrainingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>(InterviewerMetricsTrainingDocument, options);
        }
export type InterviewerMetricsTrainingQueryHookResult = ReturnType<typeof useInterviewerMetricsTrainingQuery>;
export type InterviewerMetricsTrainingLazyQueryHookResult = ReturnType<typeof useInterviewerMetricsTrainingLazyQuery>;
export type InterviewerMetricsTrainingSuspenseQueryHookResult = ReturnType<typeof useInterviewerMetricsTrainingSuspenseQuery>;
export type InterviewerMetricsTrainingQueryResult = Apollo.QueryResult<InterviewerMetricsTrainingQuery, InterviewerMetricsTrainingQueryVariables>;
export const DeclineMetricesDocument = gql`
    query DeclineMetrices($input: InterviewerMetricsChartInput!) {
  interviewerMetricsDeclinesWrapper(input: $input) {
    declineReasonsChart {
      data {
        x: xpoint
        y: ypoint
      }
    }
    declineLeadTimeChart {
      data {
        x: xpoint
        y: ypoint
      }
    }
    declineTable {
      items {
        date
        leadTime
        interviewer {
          id
          fullName
          internalProfilePictureUrl
          email
          manager {
            email
          }
          attributes {
            name {
              name
            }
            value
          }
        }
        declineSource
        declineComment
        declineReason
      }
    }
    declinesChart {
      data {
        x: xpoint
        y: ypoint
      }
    }
    autoReplacementChart {
      data {
        x: xpoint
        y: ypoint
      }
    }
  }
}
    `;

/**
 * __useDeclineMetricesQuery__
 *
 * To run a query within a React component, call `useDeclineMetricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeclineMetricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeclineMetricesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineMetricesQuery(baseOptions: Apollo.QueryHookOptions<DeclineMetricesQuery, DeclineMetricesQueryVariables> & ({ variables: DeclineMetricesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeclineMetricesQuery, DeclineMetricesQueryVariables>(DeclineMetricesDocument, options);
      }
export function useDeclineMetricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeclineMetricesQuery, DeclineMetricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeclineMetricesQuery, DeclineMetricesQueryVariables>(DeclineMetricesDocument, options);
        }
// @ts-ignore
export function useDeclineMetricesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DeclineMetricesQuery, DeclineMetricesQueryVariables>): Apollo.UseSuspenseQueryResult<DeclineMetricesQuery, DeclineMetricesQueryVariables>;
export function useDeclineMetricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeclineMetricesQuery, DeclineMetricesQueryVariables>): Apollo.UseSuspenseQueryResult<DeclineMetricesQuery | undefined, DeclineMetricesQueryVariables>;
export function useDeclineMetricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DeclineMetricesQuery, DeclineMetricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DeclineMetricesQuery, DeclineMetricesQueryVariables>(DeclineMetricesDocument, options);
        }
export type DeclineMetricesQueryHookResult = ReturnType<typeof useDeclineMetricesQuery>;
export type DeclineMetricesLazyQueryHookResult = ReturnType<typeof useDeclineMetricesLazyQuery>;
export type DeclineMetricesSuspenseQueryHookResult = ReturnType<typeof useDeclineMetricesSuspenseQuery>;
export type DeclineMetricesQueryResult = Apollo.QueryResult<DeclineMetricesQuery, DeclineMetricesQueryVariables>;
export const RecruiterChartDocument = gql`
    query RecruiterChart($input: RecruiterMetricsChartInput!) {
  recruiterMetricsChart(input: $input) {
    data {
      x: xpoint
      y: ypoint
    }
  }
}
    `;

/**
 * __useRecruiterChartQuery__
 *
 * To run a query within a React component, call `useRecruiterChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruiterChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruiterChartQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecruiterChartQuery(baseOptions: Apollo.QueryHookOptions<RecruiterChartQuery, RecruiterChartQueryVariables> & ({ variables: RecruiterChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruiterChartQuery, RecruiterChartQueryVariables>(RecruiterChartDocument, options);
      }
export function useRecruiterChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruiterChartQuery, RecruiterChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruiterChartQuery, RecruiterChartQueryVariables>(RecruiterChartDocument, options);
        }
// @ts-ignore
export function useRecruiterChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecruiterChartQuery, RecruiterChartQueryVariables>): Apollo.UseSuspenseQueryResult<RecruiterChartQuery, RecruiterChartQueryVariables>;
export function useRecruiterChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruiterChartQuery, RecruiterChartQueryVariables>): Apollo.UseSuspenseQueryResult<RecruiterChartQuery | undefined, RecruiterChartQueryVariables>;
export function useRecruiterChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruiterChartQuery, RecruiterChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecruiterChartQuery, RecruiterChartQueryVariables>(RecruiterChartDocument, options);
        }
export type RecruiterChartQueryHookResult = ReturnType<typeof useRecruiterChartQuery>;
export type RecruiterChartLazyQueryHookResult = ReturnType<typeof useRecruiterChartLazyQuery>;
export type RecruiterChartSuspenseQueryHookResult = ReturnType<typeof useRecruiterChartSuspenseQuery>;
export type RecruiterChartQueryResult = Apollo.QueryResult<RecruiterChartQuery, RecruiterChartQueryVariables>;
export const RecruiterChartDownloadDocument = gql`
    query RecruiterChartDownload($input: RecruiterMetricsChartInput!) {
  recruiterMetricsChartDownload(input: $input) {
    data {
      interviewDate
      startsAt
      endsAt
      id
      interviewName
      calendarEventTitle
      scorecard
      jobStage
      scheduler
      candidate
      job
      jobName
      jobLocations
      atsJobId
      atsApplicationId
      atsCandidateId
      taskId
    }
    scheduleStages {
      id
      jobStage
      candidate
      scheduler
      scheduleStageDate
      startsAt
      endsAt
      job
      atsJobId
      atsApplicationId
      atsCandidateId
      taskId
    }
  }
}
    `;

/**
 * __useRecruiterChartDownloadQuery__
 *
 * To run a query within a React component, call `useRecruiterChartDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruiterChartDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruiterChartDownloadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecruiterChartDownloadQuery(baseOptions: Apollo.QueryHookOptions<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables> & ({ variables: RecruiterChartDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>(RecruiterChartDownloadDocument, options);
      }
export function useRecruiterChartDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>(RecruiterChartDownloadDocument, options);
        }
// @ts-ignore
export function useRecruiterChartDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>;
export function useRecruiterChartDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<RecruiterChartDownloadQuery | undefined, RecruiterChartDownloadQueryVariables>;
export function useRecruiterChartDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>(RecruiterChartDownloadDocument, options);
        }
export type RecruiterChartDownloadQueryHookResult = ReturnType<typeof useRecruiterChartDownloadQuery>;
export type RecruiterChartDownloadLazyQueryHookResult = ReturnType<typeof useRecruiterChartDownloadLazyQuery>;
export type RecruiterChartDownloadSuspenseQueryHookResult = ReturnType<typeof useRecruiterChartDownloadSuspenseQuery>;
export type RecruiterChartDownloadQueryResult = Apollo.QueryResult<RecruiterChartDownloadQuery, RecruiterChartDownloadQueryVariables>;
export const RecruitersMetricsTableDocument = gql`
    query RecruitersMetricsTable($input: RecruiterMetricsChartInput!) {
  recruiterMetricsTable(input: $input) {
    items {
      recruiter {
        id
        fullName
        internalProfilePictureUrl
        email
      }
      scheduled
      completed
      declines
      cancelled
      changed
      facilitated
    }
  }
}
    `;

/**
 * __useRecruitersMetricsTableQuery__
 *
 * To run a query within a React component, call `useRecruitersMetricsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruitersMetricsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruitersMetricsTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecruitersMetricsTableQuery(baseOptions: Apollo.QueryHookOptions<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables> & ({ variables: RecruitersMetricsTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>(RecruitersMetricsTableDocument, options);
      }
export function useRecruitersMetricsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>(RecruitersMetricsTableDocument, options);
        }
// @ts-ignore
export function useRecruitersMetricsTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>): Apollo.UseSuspenseQueryResult<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>;
export function useRecruitersMetricsTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>): Apollo.UseSuspenseQueryResult<RecruitersMetricsTableQuery | undefined, RecruitersMetricsTableQueryVariables>;
export function useRecruitersMetricsTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>(RecruitersMetricsTableDocument, options);
        }
export type RecruitersMetricsTableQueryHookResult = ReturnType<typeof useRecruitersMetricsTableQuery>;
export type RecruitersMetricsTableLazyQueryHookResult = ReturnType<typeof useRecruitersMetricsTableLazyQuery>;
export type RecruitersMetricsTableSuspenseQueryHookResult = ReturnType<typeof useRecruitersMetricsTableSuspenseQuery>;
export type RecruitersMetricsTableQueryResult = Apollo.QueryResult<RecruitersMetricsTableQuery, RecruitersMetricsTableQueryVariables>;
export const RecruiterMetricsRescheduleLogsDocument = gql`
    query recruiterMetricsRescheduleLogs($input: RecruiterMetricsChartInput!) {
  recruiterMetricsRescheduleLogs(input: $input) {
    ...RescheduleLogReasonsChart_rescheduleLogReasonsData
    items {
      ...RescheduleLogNotes_rescheduleLogItems
    }
  }
}
    ${RescheduleLogReasonsChart_RescheduleLogReasonsDataFragmentDoc}
${RescheduleLogNotes_RescheduleLogItemsFragmentDoc}`;

/**
 * __useRecruiterMetricsRescheduleLogsQuery__
 *
 * To run a query within a React component, call `useRecruiterMetricsRescheduleLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecruiterMetricsRescheduleLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecruiterMetricsRescheduleLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecruiterMetricsRescheduleLogsQuery(baseOptions: Apollo.QueryHookOptions<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables> & ({ variables: RecruiterMetricsRescheduleLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>(RecruiterMetricsRescheduleLogsDocument, options);
      }
export function useRecruiterMetricsRescheduleLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>(RecruiterMetricsRescheduleLogsDocument, options);
        }
// @ts-ignore
export function useRecruiterMetricsRescheduleLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>): Apollo.UseSuspenseQueryResult<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>;
export function useRecruiterMetricsRescheduleLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>): Apollo.UseSuspenseQueryResult<RecruiterMetricsRescheduleLogsQuery | undefined, RecruiterMetricsRescheduleLogsQueryVariables>;
export function useRecruiterMetricsRescheduleLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>(RecruiterMetricsRescheduleLogsDocument, options);
        }
export type RecruiterMetricsRescheduleLogsQueryHookResult = ReturnType<typeof useRecruiterMetricsRescheduleLogsQuery>;
export type RecruiterMetricsRescheduleLogsLazyQueryHookResult = ReturnType<typeof useRecruiterMetricsRescheduleLogsLazyQuery>;
export type RecruiterMetricsRescheduleLogsSuspenseQueryHookResult = ReturnType<typeof useRecruiterMetricsRescheduleLogsSuspenseQuery>;
export type RecruiterMetricsRescheduleLogsQueryResult = Apollo.QueryResult<RecruiterMetricsRescheduleLogsQuery, RecruiterMetricsRescheduleLogsQueryVariables>;
export const TimeToScheduleTasksDocument = gql`
    query TimeToScheduleTasks($input: TimeToScheduleMetricsInput!) {
  taskMetrics: timeToScheduleMetrics(input: $input) {
    tasksPage {
      task {
        id
        jobStage {
          id
          name
          job {
            id
            name
          }
        }
        application {
          id
          candidate {
            id
            fullName
          }
        }
        assignee {
          id
          internalProfilePictureUrl
          fullName
        }
      }
      startTime
      endTime
      totalDuration {
        seconds
      }
    }
    hasNext
  }
}
    `;

/**
 * __useTimeToScheduleTasksQuery__
 *
 * To run a query within a React component, call `useTimeToScheduleTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeToScheduleTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeToScheduleTasksQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeToScheduleTasksQuery(baseOptions: Apollo.QueryHookOptions<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables> & ({ variables: TimeToScheduleTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>(TimeToScheduleTasksDocument, options);
      }
export function useTimeToScheduleTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>(TimeToScheduleTasksDocument, options);
        }
// @ts-ignore
export function useTimeToScheduleTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>;
export function useTimeToScheduleTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleTasksQuery | undefined, TimeToScheduleTasksQueryVariables>;
export function useTimeToScheduleTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>(TimeToScheduleTasksDocument, options);
        }
export type TimeToScheduleTasksQueryHookResult = ReturnType<typeof useTimeToScheduleTasksQuery>;
export type TimeToScheduleTasksLazyQueryHookResult = ReturnType<typeof useTimeToScheduleTasksLazyQuery>;
export type TimeToScheduleTasksSuspenseQueryHookResult = ReturnType<typeof useTimeToScheduleTasksSuspenseQuery>;
export type TimeToScheduleTasksQueryResult = Apollo.QueryResult<TimeToScheduleTasksQuery, TimeToScheduleTasksQueryVariables>;
export const TimeToScheduleSummaryDocument = gql`
    query TimeToScheduleSummary($input: TimeToScheduleMetricsInput!) {
  summary: timeToScheduleMetrics(input: $input) {
    totalTaskCount
    totalAverage {
      seconds
    }
  }
}
    `;

/**
 * __useTimeToScheduleSummaryQuery__
 *
 * To run a query within a React component, call `useTimeToScheduleSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeToScheduleSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeToScheduleSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeToScheduleSummaryQuery(baseOptions: Apollo.QueryHookOptions<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables> & ({ variables: TimeToScheduleSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>(TimeToScheduleSummaryDocument, options);
      }
export function useTimeToScheduleSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>(TimeToScheduleSummaryDocument, options);
        }
// @ts-ignore
export function useTimeToScheduleSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>;
export function useTimeToScheduleSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleSummaryQuery | undefined, TimeToScheduleSummaryQueryVariables>;
export function useTimeToScheduleSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>(TimeToScheduleSummaryDocument, options);
        }
export type TimeToScheduleSummaryQueryHookResult = ReturnType<typeof useTimeToScheduleSummaryQuery>;
export type TimeToScheduleSummaryLazyQueryHookResult = ReturnType<typeof useTimeToScheduleSummaryLazyQuery>;
export type TimeToScheduleSummarySuspenseQueryHookResult = ReturnType<typeof useTimeToScheduleSummarySuspenseQuery>;
export type TimeToScheduleSummaryQueryResult = Apollo.QueryResult<TimeToScheduleSummaryQuery, TimeToScheduleSummaryQueryVariables>;
export const TimeToScheduleGroupTableDocument = gql`
    query TimeToScheduleGroupTable($input: TimeToScheduleMetricsInput!) {
  groupMetrics: timeToScheduleMetrics(input: $input) {
    totalTaskCount
    totalAverage {
      seconds
    }
    byAssignee {
      taskAssignee {
        id
        internalProfilePictureUrl
        fullName
      }
      average {
        seconds
      }
      taskCount
    }
    byJob {
      job {
        id
        name
      }
      average {
        seconds
      }
      taskCount
    }
    byJobStageName {
      jobStageName
      average {
        seconds
      }
      taskCount
    }
  }
}
    `;

/**
 * __useTimeToScheduleGroupTableQuery__
 *
 * To run a query within a React component, call `useTimeToScheduleGroupTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeToScheduleGroupTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeToScheduleGroupTableQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeToScheduleGroupTableQuery(baseOptions: Apollo.QueryHookOptions<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables> & ({ variables: TimeToScheduleGroupTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>(TimeToScheduleGroupTableDocument, options);
      }
export function useTimeToScheduleGroupTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>(TimeToScheduleGroupTableDocument, options);
        }
// @ts-ignore
export function useTimeToScheduleGroupTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>;
export function useTimeToScheduleGroupTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleGroupTableQuery | undefined, TimeToScheduleGroupTableQueryVariables>;
export function useTimeToScheduleGroupTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>(TimeToScheduleGroupTableDocument, options);
        }
export type TimeToScheduleGroupTableQueryHookResult = ReturnType<typeof useTimeToScheduleGroupTableQuery>;
export type TimeToScheduleGroupTableLazyQueryHookResult = ReturnType<typeof useTimeToScheduleGroupTableLazyQuery>;
export type TimeToScheduleGroupTableSuspenseQueryHookResult = ReturnType<typeof useTimeToScheduleGroupTableSuspenseQuery>;
export type TimeToScheduleGroupTableQueryResult = Apollo.QueryResult<TimeToScheduleGroupTableQuery, TimeToScheduleGroupTableQueryVariables>;
export const TimeToScheduleTaskDownloadDocument = gql`
    query TimeToScheduleTaskDownload($input: TimeToScheduleMetricsInput!) {
  taskMetricsDownload: timeToScheduleMetrics(input: $input) {
    tasksPage {
      task {
        id
        jobStage {
          id
          name
          job {
            id
            name
          }
        }
        application {
          id
          candidate {
            id
            fullName
          }
        }
        assignee {
          id
          internalProfilePictureUrl
          fullName
        }
      }
      startTime
      endTime
      totalDuration {
        seconds
      }
    }
    totalAverage {
      seconds
    }
    totalTaskCount
    hasNext
  }
}
    `;

/**
 * __useTimeToScheduleTaskDownloadQuery__
 *
 * To run a query within a React component, call `useTimeToScheduleTaskDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeToScheduleTaskDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeToScheduleTaskDownloadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeToScheduleTaskDownloadQuery(baseOptions: Apollo.QueryHookOptions<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables> & ({ variables: TimeToScheduleTaskDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>(TimeToScheduleTaskDownloadDocument, options);
      }
export function useTimeToScheduleTaskDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>(TimeToScheduleTaskDownloadDocument, options);
        }
// @ts-ignore
export function useTimeToScheduleTaskDownloadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>;
export function useTimeToScheduleTaskDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>): Apollo.UseSuspenseQueryResult<TimeToScheduleTaskDownloadQuery | undefined, TimeToScheduleTaskDownloadQueryVariables>;
export function useTimeToScheduleTaskDownloadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>(TimeToScheduleTaskDownloadDocument, options);
        }
export type TimeToScheduleTaskDownloadQueryHookResult = ReturnType<typeof useTimeToScheduleTaskDownloadQuery>;
export type TimeToScheduleTaskDownloadLazyQueryHookResult = ReturnType<typeof useTimeToScheduleTaskDownloadLazyQuery>;
export type TimeToScheduleTaskDownloadSuspenseQueryHookResult = ReturnType<typeof useTimeToScheduleTaskDownloadSuspenseQuery>;
export type TimeToScheduleTaskDownloadQueryResult = Apollo.QueryResult<TimeToScheduleTaskDownloadQuery, TimeToScheduleTaskDownloadQueryVariables>;
export const AtsPermissionDocument = gql`
    query ATSPermission {
  thisUserInfo {
    isAtsAdmin
  }
}
    `;

/**
 * __useAtsPermissionQuery__
 *
 * To run a query within a React component, call `useAtsPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAtsPermissionQuery(baseOptions?: Apollo.QueryHookOptions<AtsPermissionQuery, AtsPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsPermissionQuery, AtsPermissionQueryVariables>(AtsPermissionDocument, options);
      }
export function useAtsPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsPermissionQuery, AtsPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsPermissionQuery, AtsPermissionQueryVariables>(AtsPermissionDocument, options);
        }
// @ts-ignore
export function useAtsPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AtsPermissionQuery, AtsPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<AtsPermissionQuery, AtsPermissionQueryVariables>;
export function useAtsPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsPermissionQuery, AtsPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<AtsPermissionQuery | undefined, AtsPermissionQueryVariables>;
export function useAtsPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsPermissionQuery, AtsPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AtsPermissionQuery, AtsPermissionQueryVariables>(AtsPermissionDocument, options);
        }
export type AtsPermissionQueryHookResult = ReturnType<typeof useAtsPermissionQuery>;
export type AtsPermissionLazyQueryHookResult = ReturnType<typeof useAtsPermissionLazyQuery>;
export type AtsPermissionSuspenseQueryHookResult = ReturnType<typeof useAtsPermissionSuspenseQuery>;
export type AtsPermissionQueryResult = Apollo.QueryResult<AtsPermissionQuery, AtsPermissionQueryVariables>;
export const UpdateMetricsPageAverageTimesFiltersEmployeePrefDocument = gql`
    mutation updateMetricsPageAverageTimesFiltersEmployeePref($input: EmployeePrefUpdateInput!) {
  employeePrefUpdate(input: $input) {
    employeePref {
      id
      jsonPref {
        ... on MetricsPageAverageTimesFiltersPref {
          ...MetricsPageAverageTimesFiltersEmployeePref
        }
      }
    }
  }
}
    ${MetricsPageAverageTimesFiltersEmployeePrefFragmentDoc}`;
export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationFn = Apollo.MutationFunction<UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation, UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationVariables>;

/**
 * __useUpdateMetricsPageAverageTimesFiltersEmployeePrefMutation__
 *
 * To run a mutation, you first call `useUpdateMetricsPageAverageTimesFiltersEmployeePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricsPageAverageTimesFiltersEmployeePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricsPageAverageTimesFiltersEmployeePrefMutation, { data, loading, error }] = useUpdateMetricsPageAverageTimesFiltersEmployeePrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricsPageAverageTimesFiltersEmployeePrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation, UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation, UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationVariables>(UpdateMetricsPageAverageTimesFiltersEmployeePrefDocument, options);
      }
export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationHookResult = ReturnType<typeof useUpdateMetricsPageAverageTimesFiltersEmployeePrefMutation>;
export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationResult = Apollo.MutationResult<UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation>;
export type UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationOptions = Apollo.BaseMutationOptions<UpdateMetricsPageAverageTimesFiltersEmployeePrefMutation, UpdateMetricsPageAverageTimesFiltersEmployeePrefMutationVariables>;
export const MetricsPageAverageTimesFiltersEmployeePrefDocument = gql`
    query MetricsPageAverageTimesFiltersEmployeePref($prefName: String!) {
  thisEmployee {
    id
    employeePref(prefName: $prefName) {
      id
      jsonPref {
        ... on MetricsPageAverageTimesFiltersPref {
          ...MetricsPageAverageTimesFiltersEmployeePref
        }
      }
    }
  }
}
    ${MetricsPageAverageTimesFiltersEmployeePrefFragmentDoc}`;

/**
 * __useMetricsPageAverageTimesFiltersEmployeePrefQuery__
 *
 * To run a query within a React component, call `useMetricsPageAverageTimesFiltersEmployeePrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsPageAverageTimesFiltersEmployeePrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsPageAverageTimesFiltersEmployeePrefQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useMetricsPageAverageTimesFiltersEmployeePrefQuery(baseOptions: Apollo.QueryHookOptions<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables> & ({ variables: MetricsPageAverageTimesFiltersEmployeePrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>(MetricsPageAverageTimesFiltersEmployeePrefDocument, options);
      }
export function useMetricsPageAverageTimesFiltersEmployeePrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>(MetricsPageAverageTimesFiltersEmployeePrefDocument, options);
        }
// @ts-ignore
export function useMetricsPageAverageTimesFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>;
export function useMetricsPageAverageTimesFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<MetricsPageAverageTimesFiltersEmployeePrefQuery | undefined, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>;
export function useMetricsPageAverageTimesFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>(MetricsPageAverageTimesFiltersEmployeePrefDocument, options);
        }
export type MetricsPageAverageTimesFiltersEmployeePrefQueryHookResult = ReturnType<typeof useMetricsPageAverageTimesFiltersEmployeePrefQuery>;
export type MetricsPageAverageTimesFiltersEmployeePrefLazyQueryHookResult = ReturnType<typeof useMetricsPageAverageTimesFiltersEmployeePrefLazyQuery>;
export type MetricsPageAverageTimesFiltersEmployeePrefSuspenseQueryHookResult = ReturnType<typeof useMetricsPageAverageTimesFiltersEmployeePrefSuspenseQuery>;
export type MetricsPageAverageTimesFiltersEmployeePrefQueryResult = Apollo.QueryResult<MetricsPageAverageTimesFiltersEmployeePrefQuery, MetricsPageAverageTimesFiltersEmployeePrefQueryVariables>;
export const UpdateMetricsPageInterviewerFiltersEmployeePrefDocument = gql`
    mutation updateMetricsPageInterviewerFiltersEmployeePref($input: EmployeePrefUpdateInput!) {
  employeePrefUpdate(input: $input) {
    employeePref {
      id
      jsonPref {
        ... on MetricsPageInterviewerFiltersPref {
          ...MetricsPageInterviewerFiltersEmployeePref
        }
      }
    }
  }
}
    ${MetricsPageInterviewerFiltersEmployeePrefFragmentDoc}`;
export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutationFn = Apollo.MutationFunction<UpdateMetricsPageInterviewerFiltersEmployeePrefMutation, UpdateMetricsPageInterviewerFiltersEmployeePrefMutationVariables>;

/**
 * __useUpdateMetricsPageInterviewerFiltersEmployeePrefMutation__
 *
 * To run a mutation, you first call `useUpdateMetricsPageInterviewerFiltersEmployeePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricsPageInterviewerFiltersEmployeePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricsPageInterviewerFiltersEmployeePrefMutation, { data, loading, error }] = useUpdateMetricsPageInterviewerFiltersEmployeePrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricsPageInterviewerFiltersEmployeePrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricsPageInterviewerFiltersEmployeePrefMutation, UpdateMetricsPageInterviewerFiltersEmployeePrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricsPageInterviewerFiltersEmployeePrefMutation, UpdateMetricsPageInterviewerFiltersEmployeePrefMutationVariables>(UpdateMetricsPageInterviewerFiltersEmployeePrefDocument, options);
      }
export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutationHookResult = ReturnType<typeof useUpdateMetricsPageInterviewerFiltersEmployeePrefMutation>;
export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutationResult = Apollo.MutationResult<UpdateMetricsPageInterviewerFiltersEmployeePrefMutation>;
export type UpdateMetricsPageInterviewerFiltersEmployeePrefMutationOptions = Apollo.BaseMutationOptions<UpdateMetricsPageInterviewerFiltersEmployeePrefMutation, UpdateMetricsPageInterviewerFiltersEmployeePrefMutationVariables>;
export const MetricsPageInterviewerFiltersEmployeePrefDocument = gql`
    query MetricsPageInterviewerFiltersEmployeePref($prefName: String!) {
  thisEmployee {
    id
    employeePref(prefName: $prefName) {
      id
      jsonPref {
        ... on MetricsPageInterviewerFiltersPref {
          ...MetricsPageInterviewerFiltersEmployeePref
        }
      }
    }
  }
}
    ${MetricsPageInterviewerFiltersEmployeePrefFragmentDoc}`;

/**
 * __useMetricsPageInterviewerFiltersEmployeePrefQuery__
 *
 * To run a query within a React component, call `useMetricsPageInterviewerFiltersEmployeePrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsPageInterviewerFiltersEmployeePrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsPageInterviewerFiltersEmployeePrefQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useMetricsPageInterviewerFiltersEmployeePrefQuery(baseOptions: Apollo.QueryHookOptions<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables> & ({ variables: MetricsPageInterviewerFiltersEmployeePrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>(MetricsPageInterviewerFiltersEmployeePrefDocument, options);
      }
export function useMetricsPageInterviewerFiltersEmployeePrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>(MetricsPageInterviewerFiltersEmployeePrefDocument, options);
        }
// @ts-ignore
export function useMetricsPageInterviewerFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>;
export function useMetricsPageInterviewerFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<MetricsPageInterviewerFiltersEmployeePrefQuery | undefined, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>;
export function useMetricsPageInterviewerFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>(MetricsPageInterviewerFiltersEmployeePrefDocument, options);
        }
export type MetricsPageInterviewerFiltersEmployeePrefQueryHookResult = ReturnType<typeof useMetricsPageInterviewerFiltersEmployeePrefQuery>;
export type MetricsPageInterviewerFiltersEmployeePrefLazyQueryHookResult = ReturnType<typeof useMetricsPageInterviewerFiltersEmployeePrefLazyQuery>;
export type MetricsPageInterviewerFiltersEmployeePrefSuspenseQueryHookResult = ReturnType<typeof useMetricsPageInterviewerFiltersEmployeePrefSuspenseQuery>;
export type MetricsPageInterviewerFiltersEmployeePrefQueryResult = Apollo.QueryResult<MetricsPageInterviewerFiltersEmployeePrefQuery, MetricsPageInterviewerFiltersEmployeePrefQueryVariables>;
export const UpdateMetricsPageRecruitingTeamFiltersEmployeePrefDocument = gql`
    mutation updateMetricsPageRecruitingTeamFiltersEmployeePref($input: EmployeePrefUpdateInput!) {
  employeePrefUpdate(input: $input) {
    employeePref {
      id
      jsonPref {
        ... on MetricsPageRecruitingTeamFiltersPref {
          ...MetricsPageRecruitingTeamFiltersEmployeePref
        }
      }
    }
  }
}
    ${MetricsPageRecruitingTeamFiltersEmployeePrefFragmentDoc}`;
export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationFn = Apollo.MutationFunction<UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation, UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationVariables>;

/**
 * __useUpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation__
 *
 * To run a mutation, you first call `useUpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetricsPageRecruitingTeamFiltersEmployeePrefMutation, { data, loading, error }] = useUpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation, UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation, UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationVariables>(UpdateMetricsPageRecruitingTeamFiltersEmployeePrefDocument, options);
      }
export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationHookResult = ReturnType<typeof useUpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation>;
export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationResult = Apollo.MutationResult<UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation>;
export type UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationOptions = Apollo.BaseMutationOptions<UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutation, UpdateMetricsPageRecruitingTeamFiltersEmployeePrefMutationVariables>;
export const MetricsPageRecruitingTeamFiltersEmployeePrefDocument = gql`
    query MetricsPageRecruitingTeamFiltersEmployeePref($prefName: String!) {
  thisEmployee {
    id
    employeePref(prefName: $prefName) {
      id
      jsonPref {
        ... on MetricsPageRecruitingTeamFiltersPref {
          ...MetricsPageRecruitingTeamFiltersEmployeePref
        }
      }
    }
  }
}
    ${MetricsPageRecruitingTeamFiltersEmployeePrefFragmentDoc}`;

/**
 * __useMetricsPageRecruitingTeamFiltersEmployeePrefQuery__
 *
 * To run a query within a React component, call `useMetricsPageRecruitingTeamFiltersEmployeePrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetricsPageRecruitingTeamFiltersEmployeePrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetricsPageRecruitingTeamFiltersEmployeePrefQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useMetricsPageRecruitingTeamFiltersEmployeePrefQuery(baseOptions: Apollo.QueryHookOptions<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables> & ({ variables: MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>(MetricsPageRecruitingTeamFiltersEmployeePrefDocument, options);
      }
export function useMetricsPageRecruitingTeamFiltersEmployeePrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>(MetricsPageRecruitingTeamFiltersEmployeePrefDocument, options);
        }
// @ts-ignore
export function useMetricsPageRecruitingTeamFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>;
export function useMetricsPageRecruitingTeamFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<MetricsPageRecruitingTeamFiltersEmployeePrefQuery | undefined, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>;
export function useMetricsPageRecruitingTeamFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>(MetricsPageRecruitingTeamFiltersEmployeePrefDocument, options);
        }
export type MetricsPageRecruitingTeamFiltersEmployeePrefQueryHookResult = ReturnType<typeof useMetricsPageRecruitingTeamFiltersEmployeePrefQuery>;
export type MetricsPageRecruitingTeamFiltersEmployeePrefLazyQueryHookResult = ReturnType<typeof useMetricsPageRecruitingTeamFiltersEmployeePrefLazyQuery>;
export type MetricsPageRecruitingTeamFiltersEmployeePrefSuspenseQueryHookResult = ReturnType<typeof useMetricsPageRecruitingTeamFiltersEmployeePrefSuspenseQuery>;
export type MetricsPageRecruitingTeamFiltersEmployeePrefQueryResult = Apollo.QueryResult<MetricsPageRecruitingTeamFiltersEmployeePrefQuery, MetricsPageRecruitingTeamFiltersEmployeePrefQueryVariables>;
export const EmployeeNotificationReceivedDocument = gql`
    subscription EmployeeNotificationReceived {
  employeeNotificationReceived {
    notificationType
    plainText
    ctaText
    ctaLink
  }
}
    `;

/**
 * __useEmployeeNotificationReceivedSubscription__
 *
 * To run a query within a React component, call `useEmployeeNotificationReceivedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNotificationReceivedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNotificationReceivedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeNotificationReceivedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<EmployeeNotificationReceivedSubscription, EmployeeNotificationReceivedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EmployeeNotificationReceivedSubscription, EmployeeNotificationReceivedSubscriptionVariables>(EmployeeNotificationReceivedDocument, options);
      }
export type EmployeeNotificationReceivedSubscriptionHookResult = ReturnType<typeof useEmployeeNotificationReceivedSubscription>;
export type EmployeeNotificationReceivedSubscriptionResult = Apollo.SubscriptionResult<EmployeeNotificationReceivedSubscription>;
export const EmployeeNotificationsDocument = gql`
    query EmployeeNotifications($input: EmployeeNotificationsInput!) {
  employeeNotifications(input: $input) {
    items {
      id
      notificationType
      plainText
      ctaLink
      isRead
      isSeen
      createdAt
      actorEmployee {
        id
        fullName
        internalProfilePictureUrl
        photoUrl
      }
    }
    unreadCount
    unseenCount
    nextCursor
  }
}
    `;

/**
 * __useEmployeeNotificationsQuery__
 *
 * To run a query within a React component, call `useEmployeeNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNotificationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeNotificationsQuery(baseOptions: Apollo.QueryHookOptions<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables> & ({ variables: EmployeeNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>(EmployeeNotificationsDocument, options);
      }
export function useEmployeeNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>(EmployeeNotificationsDocument, options);
        }
// @ts-ignore
export function useEmployeeNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>;
export function useEmployeeNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeNotificationsQuery | undefined, EmployeeNotificationsQueryVariables>;
export function useEmployeeNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>(EmployeeNotificationsDocument, options);
        }
export type EmployeeNotificationsQueryHookResult = ReturnType<typeof useEmployeeNotificationsQuery>;
export type EmployeeNotificationsLazyQueryHookResult = ReturnType<typeof useEmployeeNotificationsLazyQuery>;
export type EmployeeNotificationsSuspenseQueryHookResult = ReturnType<typeof useEmployeeNotificationsSuspenseQuery>;
export type EmployeeNotificationsQueryResult = Apollo.QueryResult<EmployeeNotificationsQuery, EmployeeNotificationsQueryVariables>;
export const MarkNotificationReadDocument = gql`
    mutation MarkNotificationRead($input: MarkNotificationReadInput!) {
  markNotificationRead(input: $input) {
    notification {
      id
      isRead
    }
  }
}
    `;
export type MarkNotificationReadMutationFn = Apollo.MutationFunction<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>;

/**
 * __useMarkNotificationReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationReadMutation, { data, loading, error }] = useMarkNotificationReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>(MarkNotificationReadDocument, options);
      }
export type MarkNotificationReadMutationHookResult = ReturnType<typeof useMarkNotificationReadMutation>;
export type MarkNotificationReadMutationResult = Apollo.MutationResult<MarkNotificationReadMutation>;
export type MarkNotificationReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>;
export const MarkNotificationUnreadDocument = gql`
    mutation MarkNotificationUnread($input: MarkNotificationUnreadInput!) {
  markNotificationUnread(input: $input) {
    notification {
      id
      isRead
    }
  }
}
    `;
export type MarkNotificationUnreadMutationFn = Apollo.MutationFunction<MarkNotificationUnreadMutation, MarkNotificationUnreadMutationVariables>;

/**
 * __useMarkNotificationUnreadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationUnreadMutation, { data, loading, error }] = useMarkNotificationUnreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationUnreadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationUnreadMutation, MarkNotificationUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationUnreadMutation, MarkNotificationUnreadMutationVariables>(MarkNotificationUnreadDocument, options);
      }
export type MarkNotificationUnreadMutationHookResult = ReturnType<typeof useMarkNotificationUnreadMutation>;
export type MarkNotificationUnreadMutationResult = Apollo.MutationResult<MarkNotificationUnreadMutation>;
export type MarkNotificationUnreadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationUnreadMutation, MarkNotificationUnreadMutationVariables>;
export const EmployeeNotificationPrefUpdateDocument = gql`
    mutation EmployeeNotificationPrefUpdate($input: EmployeeNotificationPrefUpdateInput!) {
  employeeNotificationPrefUpdate(input: $input) {
    employeeNotificationPref {
      employeeId
      medium
      type
      value
    }
  }
}
    `;
export type EmployeeNotificationPrefUpdateMutationFn = Apollo.MutationFunction<EmployeeNotificationPrefUpdateMutation, EmployeeNotificationPrefUpdateMutationVariables>;

/**
 * __useEmployeeNotificationPrefUpdateMutation__
 *
 * To run a mutation, you first call `useEmployeeNotificationPrefUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNotificationPrefUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeNotificationPrefUpdateMutation, { data, loading, error }] = useEmployeeNotificationPrefUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeNotificationPrefUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeNotificationPrefUpdateMutation, EmployeeNotificationPrefUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeNotificationPrefUpdateMutation, EmployeeNotificationPrefUpdateMutationVariables>(EmployeeNotificationPrefUpdateDocument, options);
      }
export type EmployeeNotificationPrefUpdateMutationHookResult = ReturnType<typeof useEmployeeNotificationPrefUpdateMutation>;
export type EmployeeNotificationPrefUpdateMutationResult = Apollo.MutationResult<EmployeeNotificationPrefUpdateMutation>;
export type EmployeeNotificationPrefUpdateMutationOptions = Apollo.BaseMutationOptions<EmployeeNotificationPrefUpdateMutation, EmployeeNotificationPrefUpdateMutationVariables>;
export const MarkAllNotificationsReadDocument = gql`
    mutation MarkAllNotificationsRead {
  markAllNotificationsRead {
    _empty
  }
}
    `;
export type MarkAllNotificationsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;

/**
 * __useMarkAllNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsReadMutation, { data, loading, error }] = useMarkAllNotificationsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>(MarkAllNotificationsReadDocument, options);
      }
export type MarkAllNotificationsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsReadMutation>;
export type MarkAllNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>;
export const MarkAllNotificationsSeenDocument = gql`
    mutation MarkAllNotificationsSeen {
  markAllNotificationsSeen {
    _empty
  }
}
    `;
export type MarkAllNotificationsSeenMutationFn = Apollo.MutationFunction<MarkAllNotificationsSeenMutation, MarkAllNotificationsSeenMutationVariables>;

/**
 * __useMarkAllNotificationsSeenMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsSeenMutation, { data, loading, error }] = useMarkAllNotificationsSeenMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsSeenMutation, MarkAllNotificationsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsSeenMutation, MarkAllNotificationsSeenMutationVariables>(MarkAllNotificationsSeenDocument, options);
      }
export type MarkAllNotificationsSeenMutationHookResult = ReturnType<typeof useMarkAllNotificationsSeenMutation>;
export type MarkAllNotificationsSeenMutationResult = Apollo.MutationResult<MarkAllNotificationsSeenMutation>;
export type MarkAllNotificationsSeenMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsSeenMutation, MarkAllNotificationsSeenMutationVariables>;
export const OAuthConsentAdapterDocument = gql`
    query OAuthConsentAdapter($input: OAuthConsentInput!) {
  oauthConsent(input: $input) {
    status
    verifiedClientName
    projection {
      applicationName
      verifiedClientName
      expiresAt
      requestedScopes
      redirectHost
      eligibleOrganizations {
        organizationId
        displayName
      }
    }
  }
}
    `;

/**
 * __useOAuthConsentAdapterQuery__
 *
 * To run a query within a React component, call `useOAuthConsentAdapterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuthConsentAdapterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuthConsentAdapterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthConsentAdapterQuery(baseOptions: Apollo.QueryHookOptions<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables> & ({ variables: OAuthConsentAdapterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>(OAuthConsentAdapterDocument, options);
      }
export function useOAuthConsentAdapterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>(OAuthConsentAdapterDocument, options);
        }
// @ts-ignore
export function useOAuthConsentAdapterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>): Apollo.UseSuspenseQueryResult<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>;
export function useOAuthConsentAdapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>): Apollo.UseSuspenseQueryResult<OAuthConsentAdapterQuery | undefined, OAuthConsentAdapterQueryVariables>;
export function useOAuthConsentAdapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>(OAuthConsentAdapterDocument, options);
        }
export type OAuthConsentAdapterQueryHookResult = ReturnType<typeof useOAuthConsentAdapterQuery>;
export type OAuthConsentAdapterLazyQueryHookResult = ReturnType<typeof useOAuthConsentAdapterLazyQuery>;
export type OAuthConsentAdapterSuspenseQueryHookResult = ReturnType<typeof useOAuthConsentAdapterSuspenseQuery>;
export type OAuthConsentAdapterQueryResult = Apollo.QueryResult<OAuthConsentAdapterQuery, OAuthConsentAdapterQueryVariables>;
export const OAuthConsentCompleteAdapterDocument = gql`
    mutation OAuthConsentCompleteAdapter($input: OAuthConsentCompleteInput!) {
  oauthConsentComplete(input: $input) {
    handoffPath
  }
}
    `;
export type OAuthConsentCompleteAdapterMutationFn = Apollo.MutationFunction<OAuthConsentCompleteAdapterMutation, OAuthConsentCompleteAdapterMutationVariables>;

/**
 * __useOAuthConsentCompleteAdapterMutation__
 *
 * To run a mutation, you first call `useOAuthConsentCompleteAdapterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthConsentCompleteAdapterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthConsentCompleteAdapterMutation, { data, loading, error }] = useOAuthConsentCompleteAdapterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthConsentCompleteAdapterMutation(baseOptions?: Apollo.MutationHookOptions<OAuthConsentCompleteAdapterMutation, OAuthConsentCompleteAdapterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OAuthConsentCompleteAdapterMutation, OAuthConsentCompleteAdapterMutationVariables>(OAuthConsentCompleteAdapterDocument, options);
      }
export type OAuthConsentCompleteAdapterMutationHookResult = ReturnType<typeof useOAuthConsentCompleteAdapterMutation>;
export type OAuthConsentCompleteAdapterMutationResult = Apollo.MutationResult<OAuthConsentCompleteAdapterMutation>;
export type OAuthConsentCompleteAdapterMutationOptions = Apollo.BaseMutationOptions<OAuthConsentCompleteAdapterMutation, OAuthConsentCompleteAdapterMutationVariables>;
export const OmniSearchApplicationsDocument = gql`
    query OmniSearchApplications($input: ApplicationSearchInput!) {
  applicationSearch(input: $input) {
    hasNext
    items {
      id
      candidate {
        fullName
      }
      ...OmniSearchOptionApplication_application
    }
  }
}
    ${OmniSearchOptionApplication_ApplicationFragmentDoc}`;

/**
 * __useOmniSearchApplicationsQuery__
 *
 * To run a query within a React component, call `useOmniSearchApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniSearchApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniSearchApplicationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniSearchApplicationsQuery(baseOptions: Apollo.QueryHookOptions<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables> & ({ variables: OmniSearchApplicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>(OmniSearchApplicationsDocument, options);
      }
export function useOmniSearchApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>(OmniSearchApplicationsDocument, options);
        }
// @ts-ignore
export function useOmniSearchApplicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>;
export function useOmniSearchApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchApplicationsQuery | undefined, OmniSearchApplicationsQueryVariables>;
export function useOmniSearchApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>(OmniSearchApplicationsDocument, options);
        }
export type OmniSearchApplicationsQueryHookResult = ReturnType<typeof useOmniSearchApplicationsQuery>;
export type OmniSearchApplicationsLazyQueryHookResult = ReturnType<typeof useOmniSearchApplicationsLazyQuery>;
export type OmniSearchApplicationsSuspenseQueryHookResult = ReturnType<typeof useOmniSearchApplicationsSuspenseQuery>;
export type OmniSearchApplicationsQueryResult = Apollo.QueryResult<OmniSearchApplicationsQuery, OmniSearchApplicationsQueryVariables>;
export const OmniSearchEmployeesDocument = gql`
    query OmniSearchEmployees($input: EmployeeSearchInput!) {
  employeeSearch(input: $input) {
    total
    items {
      id
      fullName
      ...OmniSearchOptionEmployee_employee
    }
  }
}
    ${OmniSearchOptionEmployee_EmployeeFragmentDoc}`;

/**
 * __useOmniSearchEmployeesQuery__
 *
 * To run a query within a React component, call `useOmniSearchEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniSearchEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniSearchEmployeesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniSearchEmployeesQuery(baseOptions: Apollo.QueryHookOptions<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables> & ({ variables: OmniSearchEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>(OmniSearchEmployeesDocument, options);
      }
export function useOmniSearchEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>(OmniSearchEmployeesDocument, options);
        }
// @ts-ignore
export function useOmniSearchEmployeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>;
export function useOmniSearchEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchEmployeesQuery | undefined, OmniSearchEmployeesQueryVariables>;
export function useOmniSearchEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>(OmniSearchEmployeesDocument, options);
        }
export type OmniSearchEmployeesQueryHookResult = ReturnType<typeof useOmniSearchEmployeesQuery>;
export type OmniSearchEmployeesLazyQueryHookResult = ReturnType<typeof useOmniSearchEmployeesLazyQuery>;
export type OmniSearchEmployeesSuspenseQueryHookResult = ReturnType<typeof useOmniSearchEmployeesSuspenseQuery>;
export type OmniSearchEmployeesQueryResult = Apollo.QueryResult<OmniSearchEmployeesQuery, OmniSearchEmployeesQueryVariables>;
export const OmniSearchInterviewModulesDocument = gql`
    query OmniSearchInterviewModules($input: InterviewModuleSearchInput!) {
  interviewModuleSearch(input: $input) {
    total
    items {
      id
      name
      ...OmniSearchOptionInterviewModule_interviewModule
    }
  }
}
    ${OmniSearchOptionInterviewModule_InterviewModuleFragmentDoc}`;

/**
 * __useOmniSearchInterviewModulesQuery__
 *
 * To run a query within a React component, call `useOmniSearchInterviewModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniSearchInterviewModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniSearchInterviewModulesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniSearchInterviewModulesQuery(baseOptions: Apollo.QueryHookOptions<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables> & ({ variables: OmniSearchInterviewModulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>(OmniSearchInterviewModulesDocument, options);
      }
export function useOmniSearchInterviewModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>(OmniSearchInterviewModulesDocument, options);
        }
// @ts-ignore
export function useOmniSearchInterviewModulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>;
export function useOmniSearchInterviewModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchInterviewModulesQuery | undefined, OmniSearchInterviewModulesQueryVariables>;
export function useOmniSearchInterviewModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>(OmniSearchInterviewModulesDocument, options);
        }
export type OmniSearchInterviewModulesQueryHookResult = ReturnType<typeof useOmniSearchInterviewModulesQuery>;
export type OmniSearchInterviewModulesLazyQueryHookResult = ReturnType<typeof useOmniSearchInterviewModulesLazyQuery>;
export type OmniSearchInterviewModulesSuspenseQueryHookResult = ReturnType<typeof useOmniSearchInterviewModulesSuspenseQuery>;
export type OmniSearchInterviewModulesQueryResult = Apollo.QueryResult<OmniSearchInterviewModulesQuery, OmniSearchInterviewModulesQueryVariables>;
export const OmniSearchJobsDocument = gql`
    query OmniSearchJobs($input: JobsInput!) {
  jobs(input: $input) {
    items {
      id
      name
      ...OmniSearchOptionJob_job
    }
    nextCursor
  }
}
    ${OmniSearchOptionJob_JobFragmentDoc}`;

/**
 * __useOmniSearchJobsQuery__
 *
 * To run a query within a React component, call `useOmniSearchJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmniSearchJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmniSearchJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOmniSearchJobsQuery(baseOptions: Apollo.QueryHookOptions<OmniSearchJobsQuery, OmniSearchJobsQueryVariables> & ({ variables: OmniSearchJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>(OmniSearchJobsDocument, options);
      }
export function useOmniSearchJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>(OmniSearchJobsDocument, options);
        }
// @ts-ignore
export function useOmniSearchJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>;
export function useOmniSearchJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>): Apollo.UseSuspenseQueryResult<OmniSearchJobsQuery | undefined, OmniSearchJobsQueryVariables>;
export function useOmniSearchJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>(OmniSearchJobsDocument, options);
        }
export type OmniSearchJobsQueryHookResult = ReturnType<typeof useOmniSearchJobsQuery>;
export type OmniSearchJobsLazyQueryHookResult = ReturnType<typeof useOmniSearchJobsLazyQuery>;
export type OmniSearchJobsSuspenseQueryHookResult = ReturnType<typeof useOmniSearchJobsSuspenseQuery>;
export type OmniSearchJobsQueryResult = Apollo.QueryResult<OmniSearchJobsQuery, OmniSearchJobsQueryVariables>;
export const PublicIdRedirectDocument = gql`
    query PublicIdRedirect($input: GetUrlForPublicIdInput!) {
  getUrlForPublicId(input: $input) {
    __typename
    ... on PublicIdUrl {
      publicId
      url
    }
  }
}
    `;

/**
 * __usePublicIdRedirectQuery__
 *
 * To run a query within a React component, call `usePublicIdRedirectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicIdRedirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicIdRedirectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicIdRedirectQuery(baseOptions: Apollo.QueryHookOptions<PublicIdRedirectQuery, PublicIdRedirectQueryVariables> & ({ variables: PublicIdRedirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>(PublicIdRedirectDocument, options);
      }
export function usePublicIdRedirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>(PublicIdRedirectDocument, options);
        }
// @ts-ignore
export function usePublicIdRedirectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>): Apollo.UseSuspenseQueryResult<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>;
export function usePublicIdRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>): Apollo.UseSuspenseQueryResult<PublicIdRedirectQuery | undefined, PublicIdRedirectQueryVariables>;
export function usePublicIdRedirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>(PublicIdRedirectDocument, options);
        }
export type PublicIdRedirectQueryHookResult = ReturnType<typeof usePublicIdRedirectQuery>;
export type PublicIdRedirectLazyQueryHookResult = ReturnType<typeof usePublicIdRedirectLazyQuery>;
export type PublicIdRedirectSuspenseQueryHookResult = ReturnType<typeof usePublicIdRedirectSuspenseQuery>;
export type PublicIdRedirectQueryResult = Apollo.QueryResult<PublicIdRedirectQuery, PublicIdRedirectQueryVariables>;
export const RescheduleFlowDocument = gql`
    query RescheduleFlow($id: uuid!) {
  applicationStage(id: $id) {
    id
    application {
      id
      candidate {
        id
        timezone
        atsLatestAvailability {
          ...useCandidateAvailability_atsLatestAvailability
          timezone
          originalText
        }
        ...ScheduleFlowDataProvider_candidate
      }
    }
    jobStage {
      id
      name
      job {
        id
        name
        atsId
        ...ScheduleFlowDataProvider_job
        jobSettings {
          id
          ...ScheduleFlowDataProvider_jobSettings
        }
      }
      jobStageSettingsV2 {
        id
        ...ScheduleFlowDataProvider_jobStageSettings
      }
    }
    task {
      id
      ...ScheduleFlowDataProvider_task
      availabilities {
        id
        ...useCandidateAvailability_availabilities
      }
      interviewPlan {
        id
        ...ScheduleFlowDataProvider_interviewPlan
      }
    }
  }
}
    ${UseCandidateAvailability_AtsLatestAvailabilityFragmentDoc}
${ScheduleFlowDataProvider_CandidateFragmentDoc}
${ScheduleFlowDataProvider_JobFragmentDoc}
${ScheduleFlowDataProvider_JobSettingsFragmentDoc}
${ScheduleFlowDataProvider_JobStageSettingsFragmentDoc}
${ScheduleFlowDataProvider_TaskFragmentDoc}
${UseCandidateAvailability_AvailabilitiesFragmentDoc}
${ScheduleFlowDataProvider_InterviewPlanFragmentDoc}`;

/**
 * __useRescheduleFlowQuery__
 *
 * To run a query within a React component, call `useRescheduleFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useRescheduleFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRescheduleFlowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRescheduleFlowQuery(baseOptions: Apollo.QueryHookOptions<RescheduleFlowQuery, RescheduleFlowQueryVariables> & ({ variables: RescheduleFlowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RescheduleFlowQuery, RescheduleFlowQueryVariables>(RescheduleFlowDocument, options);
      }
export function useRescheduleFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RescheduleFlowQuery, RescheduleFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RescheduleFlowQuery, RescheduleFlowQueryVariables>(RescheduleFlowDocument, options);
        }
// @ts-ignore
export function useRescheduleFlowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RescheduleFlowQuery, RescheduleFlowQueryVariables>): Apollo.UseSuspenseQueryResult<RescheduleFlowQuery, RescheduleFlowQueryVariables>;
export function useRescheduleFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RescheduleFlowQuery, RescheduleFlowQueryVariables>): Apollo.UseSuspenseQueryResult<RescheduleFlowQuery | undefined, RescheduleFlowQueryVariables>;
export function useRescheduleFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RescheduleFlowQuery, RescheduleFlowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RescheduleFlowQuery, RescheduleFlowQueryVariables>(RescheduleFlowDocument, options);
        }
export type RescheduleFlowQueryHookResult = ReturnType<typeof useRescheduleFlowQuery>;
export type RescheduleFlowLazyQueryHookResult = ReturnType<typeof useRescheduleFlowLazyQuery>;
export type RescheduleFlowSuspenseQueryHookResult = ReturnType<typeof useRescheduleFlowSuspenseQuery>;
export type RescheduleFlowQueryResult = Apollo.QueryResult<RescheduleFlowQuery, RescheduleFlowQueryVariables>;
export const JobStageSettingsV2GqlDocument = gql`
    query JobStageSettingsV2GQL($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    jobStageSettingsV2 {
      id
      ...JobStageSettingsV2Fragment
    }
  }
}
    ${JobStageSettingsV2FragmentFragmentDoc}`;

/**
 * __useJobStageSettingsV2GqlQuery__
 *
 * To run a query within a React component, call `useJobStageSettingsV2GqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageSettingsV2GqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageSettingsV2GqlQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useJobStageSettingsV2GqlQuery(baseOptions: Apollo.QueryHookOptions<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables> & ({ variables: JobStageSettingsV2GqlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>(JobStageSettingsV2GqlDocument, options);
      }
export function useJobStageSettingsV2GqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>(JobStageSettingsV2GqlDocument, options);
        }
// @ts-ignore
export function useJobStageSettingsV2GqlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>;
export function useJobStageSettingsV2GqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageSettingsV2GqlQuery | undefined, JobStageSettingsV2GqlQueryVariables>;
export function useJobStageSettingsV2GqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>(JobStageSettingsV2GqlDocument, options);
        }
export type JobStageSettingsV2GqlQueryHookResult = ReturnType<typeof useJobStageSettingsV2GqlQuery>;
export type JobStageSettingsV2GqlLazyQueryHookResult = ReturnType<typeof useJobStageSettingsV2GqlLazyQuery>;
export type JobStageSettingsV2GqlSuspenseQueryHookResult = ReturnType<typeof useJobStageSettingsV2GqlSuspenseQuery>;
export type JobStageSettingsV2GqlQueryResult = Apollo.QueryResult<JobStageSettingsV2GqlQuery, JobStageSettingsV2GqlQueryVariables>;
export const TaskDebriefRequirementDocument = gql`
    query TaskDebriefRequirement($applicationId: uuid!, $taskId: uuid!) {
  application(id: $applicationId) {
    id
    applicationStages(input: {orderBy: {createdAt: DESC}}) {
      id
      isHoldForRsvp
      isReadyForCandidateComms
    }
    candidate {
      id
    }
  }
  task(id: $taskId) {
    isDebriefRequired
    debriefs {
      id
    }
  }
}
    `;

/**
 * __useTaskDebriefRequirementQuery__
 *
 * To run a query within a React component, call `useTaskDebriefRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskDebriefRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskDebriefRequirementQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskDebriefRequirementQuery(baseOptions: Apollo.QueryHookOptions<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables> & ({ variables: TaskDebriefRequirementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>(TaskDebriefRequirementDocument, options);
      }
export function useTaskDebriefRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>(TaskDebriefRequirementDocument, options);
        }
// @ts-ignore
export function useTaskDebriefRequirementSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>;
export function useTaskDebriefRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>): Apollo.UseSuspenseQueryResult<TaskDebriefRequirementQuery | undefined, TaskDebriefRequirementQueryVariables>;
export function useTaskDebriefRequirementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>(TaskDebriefRequirementDocument, options);
        }
export type TaskDebriefRequirementQueryHookResult = ReturnType<typeof useTaskDebriefRequirementQuery>;
export type TaskDebriefRequirementLazyQueryHookResult = ReturnType<typeof useTaskDebriefRequirementLazyQuery>;
export type TaskDebriefRequirementSuspenseQueryHookResult = ReturnType<typeof useTaskDebriefRequirementSuspenseQuery>;
export type TaskDebriefRequirementQueryResult = Apollo.QueryResult<TaskDebriefRequirementQuery, TaskDebriefRequirementQueryVariables>;
export const ScheduleFlowHeaderDocument = gql`
    query scheduleFlowHeader($id: uuid!) {
  application(id: $id) {
    id
    candidate {
      id
      fullName
      timezone
      email
      additionalEmails
      atsCandidate {
        atsId
        atsUrl
      }
    }
    jobStage {
      id
      name
    }
    job {
      id
      name
      isConfidential
    }
    existingConversations {
      id
      remoteId
      remoteName
      isArchived
    }
  }
}
    `;

/**
 * __useScheduleFlowHeaderQuery__
 *
 * To run a query within a React component, call `useScheduleFlowHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFlowHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFlowHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduleFlowHeaderQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables> & ({ variables: ScheduleFlowHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>(ScheduleFlowHeaderDocument, options);
      }
export function useScheduleFlowHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>(ScheduleFlowHeaderDocument, options);
        }
// @ts-ignore
export function useScheduleFlowHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>;
export function useScheduleFlowHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowHeaderQuery | undefined, ScheduleFlowHeaderQueryVariables>;
export function useScheduleFlowHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>(ScheduleFlowHeaderDocument, options);
        }
export type ScheduleFlowHeaderQueryHookResult = ReturnType<typeof useScheduleFlowHeaderQuery>;
export type ScheduleFlowHeaderLazyQueryHookResult = ReturnType<typeof useScheduleFlowHeaderLazyQuery>;
export type ScheduleFlowHeaderSuspenseQueryHookResult = ReturnType<typeof useScheduleFlowHeaderSuspenseQuery>;
export type ScheduleFlowHeaderQueryResult = Apollo.QueryResult<ScheduleFlowHeaderQuery, ScheduleFlowHeaderQueryVariables>;
export const JobStageNameDocument = gql`
    query jobStageName($id: uuid!) {
  jobStage(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useJobStageNameQuery__
 *
 * To run a query within a React component, call `useJobStageNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobStageNameQuery(baseOptions: Apollo.QueryHookOptions<JobStageNameQuery, JobStageNameQueryVariables> & ({ variables: JobStageNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageNameQuery, JobStageNameQueryVariables>(JobStageNameDocument, options);
      }
export function useJobStageNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageNameQuery, JobStageNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageNameQuery, JobStageNameQueryVariables>(JobStageNameDocument, options);
        }
// @ts-ignore
export function useJobStageNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageNameQuery, JobStageNameQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageNameQuery, JobStageNameQueryVariables>;
export function useJobStageNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageNameQuery, JobStageNameQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageNameQuery | undefined, JobStageNameQueryVariables>;
export function useJobStageNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageNameQuery, JobStageNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageNameQuery, JobStageNameQueryVariables>(JobStageNameDocument, options);
        }
export type JobStageNameQueryHookResult = ReturnType<typeof useJobStageNameQuery>;
export type JobStageNameLazyQueryHookResult = ReturnType<typeof useJobStageNameLazyQuery>;
export type JobStageNameSuspenseQueryHookResult = ReturnType<typeof useJobStageNameSuspenseQuery>;
export type JobStageNameQueryResult = Apollo.QueryResult<JobStageNameQuery, JobStageNameQueryVariables>;
export const CandidateAvailabilityApplicationTasksDocument = gql`
    query CandidateAvailabilityApplicationTasks($applicationId: uuid!) {
  application(id: $applicationId) {
    tasks {
      id
      availabilities {
        id
        candidateEnteredAvailability {
          startAt
          endAt
        }
        rcEnteredAvailability {
          startAt
          endAt
        }
      }
    }
  }
}
    `;

/**
 * __useCandidateAvailabilityApplicationTasksQuery__
 *
 * To run a query within a React component, call `useCandidateAvailabilityApplicationTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateAvailabilityApplicationTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateAvailabilityApplicationTasksQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useCandidateAvailabilityApplicationTasksQuery(baseOptions: Apollo.QueryHookOptions<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables> & ({ variables: CandidateAvailabilityApplicationTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>(CandidateAvailabilityApplicationTasksDocument, options);
      }
export function useCandidateAvailabilityApplicationTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>(CandidateAvailabilityApplicationTasksDocument, options);
        }
// @ts-ignore
export function useCandidateAvailabilityApplicationTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>;
export function useCandidateAvailabilityApplicationTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAvailabilityApplicationTasksQuery | undefined, CandidateAvailabilityApplicationTasksQueryVariables>;
export function useCandidateAvailabilityApplicationTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>(CandidateAvailabilityApplicationTasksDocument, options);
        }
export type CandidateAvailabilityApplicationTasksQueryHookResult = ReturnType<typeof useCandidateAvailabilityApplicationTasksQuery>;
export type CandidateAvailabilityApplicationTasksLazyQueryHookResult = ReturnType<typeof useCandidateAvailabilityApplicationTasksLazyQuery>;
export type CandidateAvailabilityApplicationTasksSuspenseQueryHookResult = ReturnType<typeof useCandidateAvailabilityApplicationTasksSuspenseQuery>;
export type CandidateAvailabilityApplicationTasksQueryResult = Apollo.QueryResult<CandidateAvailabilityApplicationTasksQuery, CandidateAvailabilityApplicationTasksQueryVariables>;
export const InterviewInterviewerDeclinedDocument = gql`
    query InterviewInterviewerDeclined($id: uuid!) {
  applicationStage(id: $id) {
    id
    applicationStageInterviews(input: {isCancelled: false}) {
      ...ScheduleIssuesDialogApplicationStageInterview
      applicationStageInterviewInterviewers {
        ...ScheduleIssuesDialogApplicationStageInterviewInterviewers
      }
    }
  }
}
    ${ScheduleIssuesDialogApplicationStageInterviewFragmentDoc}
${ScheduleIssuesDialogApplicationStageInterviewInterviewersFragmentDoc}`;

/**
 * __useInterviewInterviewerDeclinedQuery__
 *
 * To run a query within a React component, call `useInterviewInterviewerDeclinedQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewInterviewerDeclinedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewInterviewerDeclinedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterviewInterviewerDeclinedQuery(baseOptions: Apollo.QueryHookOptions<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables> & ({ variables: InterviewInterviewerDeclinedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>(InterviewInterviewerDeclinedDocument, options);
      }
export function useInterviewInterviewerDeclinedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>(InterviewInterviewerDeclinedDocument, options);
        }
// @ts-ignore
export function useInterviewInterviewerDeclinedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>;
export function useInterviewInterviewerDeclinedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewInterviewerDeclinedQuery | undefined, InterviewInterviewerDeclinedQueryVariables>;
export function useInterviewInterviewerDeclinedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>(InterviewInterviewerDeclinedDocument, options);
        }
export type InterviewInterviewerDeclinedQueryHookResult = ReturnType<typeof useInterviewInterviewerDeclinedQuery>;
export type InterviewInterviewerDeclinedLazyQueryHookResult = ReturnType<typeof useInterviewInterviewerDeclinedLazyQuery>;
export type InterviewInterviewerDeclinedSuspenseQueryHookResult = ReturnType<typeof useInterviewInterviewerDeclinedSuspenseQuery>;
export type InterviewInterviewerDeclinedQueryResult = Apollo.QueryResult<InterviewInterviewerDeclinedQuery, InterviewInterviewerDeclinedQueryVariables>;
export const SubscribersCandidateEmailCardDocument = gql`
    query SubscribersCandidateEmailCard($subscribersInput: SubscribersInput!) {
  subscribers(input: $subscribersInput) {
    items {
      id
    }
  }
}
    `;

/**
 * __useSubscribersCandidateEmailCardQuery__
 *
 * To run a query within a React component, call `useSubscribersCandidateEmailCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribersCandidateEmailCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribersCandidateEmailCardQuery({
 *   variables: {
 *      subscribersInput: // value for 'subscribersInput'
 *   },
 * });
 */
export function useSubscribersCandidateEmailCardQuery(baseOptions: Apollo.QueryHookOptions<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables> & ({ variables: SubscribersCandidateEmailCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>(SubscribersCandidateEmailCardDocument, options);
      }
export function useSubscribersCandidateEmailCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>(SubscribersCandidateEmailCardDocument, options);
        }
// @ts-ignore
export function useSubscribersCandidateEmailCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>): Apollo.UseSuspenseQueryResult<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>;
export function useSubscribersCandidateEmailCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>): Apollo.UseSuspenseQueryResult<SubscribersCandidateEmailCardQuery | undefined, SubscribersCandidateEmailCardQueryVariables>;
export function useSubscribersCandidateEmailCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>(SubscribersCandidateEmailCardDocument, options);
        }
export type SubscribersCandidateEmailCardQueryHookResult = ReturnType<typeof useSubscribersCandidateEmailCardQuery>;
export type SubscribersCandidateEmailCardLazyQueryHookResult = ReturnType<typeof useSubscribersCandidateEmailCardLazyQuery>;
export type SubscribersCandidateEmailCardSuspenseQueryHookResult = ReturnType<typeof useSubscribersCandidateEmailCardSuspenseQuery>;
export type SubscribersCandidateEmailCardQueryResult = Apollo.QueryResult<SubscribersCandidateEmailCardQuery, SubscribersCandidateEmailCardQueryVariables>;
export const CollaborationToolCardRowCollaborationLinkDocument = gql`
    mutation CollaborationToolCardRowCollaborationLink($options: CollaborationLinkCreateInput!) {
  collaborationLinkCreate(input: $options) {
    collaborationLink {
      id
      url
      collaborationLinkTemplateId
    }
  }
}
    `;
export type CollaborationToolCardRowCollaborationLinkMutationFn = Apollo.MutationFunction<CollaborationToolCardRowCollaborationLinkMutation, CollaborationToolCardRowCollaborationLinkMutationVariables>;

/**
 * __useCollaborationToolCardRowCollaborationLinkMutation__
 *
 * To run a mutation, you first call `useCollaborationToolCardRowCollaborationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollaborationToolCardRowCollaborationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collaborationToolCardRowCollaborationLinkMutation, { data, loading, error }] = useCollaborationToolCardRowCollaborationLinkMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCollaborationToolCardRowCollaborationLinkMutation(baseOptions?: Apollo.MutationHookOptions<CollaborationToolCardRowCollaborationLinkMutation, CollaborationToolCardRowCollaborationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollaborationToolCardRowCollaborationLinkMutation, CollaborationToolCardRowCollaborationLinkMutationVariables>(CollaborationToolCardRowCollaborationLinkDocument, options);
      }
export type CollaborationToolCardRowCollaborationLinkMutationHookResult = ReturnType<typeof useCollaborationToolCardRowCollaborationLinkMutation>;
export type CollaborationToolCardRowCollaborationLinkMutationResult = Apollo.MutationResult<CollaborationToolCardRowCollaborationLinkMutation>;
export type CollaborationToolCardRowCollaborationLinkMutationOptions = Apollo.BaseMutationOptions<CollaborationToolCardRowCollaborationLinkMutation, CollaborationToolCardRowCollaborationLinkMutationVariables>;
export const CreateCodingUrlsCollaborationLinkCreateMutationDocument = gql`
    mutation CreateCodingUrlsCollaborationLinkCreateMutation($options: CollaborationLinkCreateInput!) {
  collaborationLinkCreate(input: $options) {
    collaborationLink {
      id
      url
      collaborationLinkTemplateId
    }
  }
}
    `;
export type CreateCodingUrlsCollaborationLinkCreateMutationMutationFn = Apollo.MutationFunction<CreateCodingUrlsCollaborationLinkCreateMutationMutation, CreateCodingUrlsCollaborationLinkCreateMutationMutationVariables>;

/**
 * __useCreateCodingUrlsCollaborationLinkCreateMutationMutation__
 *
 * To run a mutation, you first call `useCreateCodingUrlsCollaborationLinkCreateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCodingUrlsCollaborationLinkCreateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCodingUrlsCollaborationLinkCreateMutationMutation, { data, loading, error }] = useCreateCodingUrlsCollaborationLinkCreateMutationMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useCreateCodingUrlsCollaborationLinkCreateMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCodingUrlsCollaborationLinkCreateMutationMutation, CreateCodingUrlsCollaborationLinkCreateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCodingUrlsCollaborationLinkCreateMutationMutation, CreateCodingUrlsCollaborationLinkCreateMutationMutationVariables>(CreateCodingUrlsCollaborationLinkCreateMutationDocument, options);
      }
export type CreateCodingUrlsCollaborationLinkCreateMutationMutationHookResult = ReturnType<typeof useCreateCodingUrlsCollaborationLinkCreateMutationMutation>;
export type CreateCodingUrlsCollaborationLinkCreateMutationMutationResult = Apollo.MutationResult<CreateCodingUrlsCollaborationLinkCreateMutationMutation>;
export type CreateCodingUrlsCollaborationLinkCreateMutationMutationOptions = Apollo.BaseMutationOptions<CreateCodingUrlsCollaborationLinkCreateMutationMutation, CreateCodingUrlsCollaborationLinkCreateMutationMutationVariables>;
export const GetWarningModalCalendarDocument = gql`
    query GetWarningModalCalendar($id: String!) {
  calendar(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useGetWarningModalCalendarQuery__
 *
 * To run a query within a React component, call `useGetWarningModalCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarningModalCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarningModalCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWarningModalCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables> & ({ variables: GetWarningModalCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>(GetWarningModalCalendarDocument, options);
      }
export function useGetWarningModalCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>(GetWarningModalCalendarDocument, options);
        }
// @ts-ignore
export function useGetWarningModalCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>;
export function useGetWarningModalCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<GetWarningModalCalendarQuery | undefined, GetWarningModalCalendarQueryVariables>;
export function useGetWarningModalCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>(GetWarningModalCalendarDocument, options);
        }
export type GetWarningModalCalendarQueryHookResult = ReturnType<typeof useGetWarningModalCalendarQuery>;
export type GetWarningModalCalendarLazyQueryHookResult = ReturnType<typeof useGetWarningModalCalendarLazyQuery>;
export type GetWarningModalCalendarSuspenseQueryHookResult = ReturnType<typeof useGetWarningModalCalendarSuspenseQuery>;
export type GetWarningModalCalendarQueryResult = Apollo.QueryResult<GetWarningModalCalendarQuery, GetWarningModalCalendarQueryVariables>;
export const HasApplicationStageInterviewDocument = gql`
    query HasApplicationStageInterview($id: uuid!) {
  applicationStage(id: $id) {
    id
    applicationStageInterviews(input: {isCancelled: false}) {
      id
    }
  }
}
    `;

/**
 * __useHasApplicationStageInterviewQuery__
 *
 * To run a query within a React component, call `useHasApplicationStageInterviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasApplicationStageInterviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasApplicationStageInterviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHasApplicationStageInterviewQuery(baseOptions: Apollo.QueryHookOptions<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables> & ({ variables: HasApplicationStageInterviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>(HasApplicationStageInterviewDocument, options);
      }
export function useHasApplicationStageInterviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>(HasApplicationStageInterviewDocument, options);
        }
// @ts-ignore
export function useHasApplicationStageInterviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>): Apollo.UseSuspenseQueryResult<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>;
export function useHasApplicationStageInterviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>): Apollo.UseSuspenseQueryResult<HasApplicationStageInterviewQuery | undefined, HasApplicationStageInterviewQueryVariables>;
export function useHasApplicationStageInterviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>(HasApplicationStageInterviewDocument, options);
        }
export type HasApplicationStageInterviewQueryHookResult = ReturnType<typeof useHasApplicationStageInterviewQuery>;
export type HasApplicationStageInterviewLazyQueryHookResult = ReturnType<typeof useHasApplicationStageInterviewLazyQuery>;
export type HasApplicationStageInterviewSuspenseQueryHookResult = ReturnType<typeof useHasApplicationStageInterviewSuspenseQuery>;
export type HasApplicationStageInterviewQueryResult = Apollo.QueryResult<HasApplicationStageInterviewQuery, HasApplicationStageInterviewQueryVariables>;
export const ScheduleFlowSaveSettingsToJobStageDocument = gql`
    mutation ScheduleFlowSaveSettingsToJobStage($input: JobStageSettingsUpsertInput!) {
  jobStageSettingsUpsert(input: $input) {
    jobStageSettingsV2 {
      id
    }
  }
}
    `;
export type ScheduleFlowSaveSettingsToJobStageMutationFn = Apollo.MutationFunction<ScheduleFlowSaveSettingsToJobStageMutation, ScheduleFlowSaveSettingsToJobStageMutationVariables>;

/**
 * __useScheduleFlowSaveSettingsToJobStageMutation__
 *
 * To run a mutation, you first call `useScheduleFlowSaveSettingsToJobStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleFlowSaveSettingsToJobStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleFlowSaveSettingsToJobStageMutation, { data, loading, error }] = useScheduleFlowSaveSettingsToJobStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleFlowSaveSettingsToJobStageMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleFlowSaveSettingsToJobStageMutation, ScheduleFlowSaveSettingsToJobStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleFlowSaveSettingsToJobStageMutation, ScheduleFlowSaveSettingsToJobStageMutationVariables>(ScheduleFlowSaveSettingsToJobStageDocument, options);
      }
export type ScheduleFlowSaveSettingsToJobStageMutationHookResult = ReturnType<typeof useScheduleFlowSaveSettingsToJobStageMutation>;
export type ScheduleFlowSaveSettingsToJobStageMutationResult = Apollo.MutationResult<ScheduleFlowSaveSettingsToJobStageMutation>;
export type ScheduleFlowSaveSettingsToJobStageMutationOptions = Apollo.BaseMutationOptions<ScheduleFlowSaveSettingsToJobStageMutation, ScheduleFlowSaveSettingsToJobStageMutationVariables>;
export const ScheduleNowTaskCreateDocument = gql`
    mutation ScheduleNowTaskCreate($input: TaskCreateInput!) {
  taskCreate(input: $input) {
    task {
      id
    }
  }
}
    `;
export type ScheduleNowTaskCreateMutationFn = Apollo.MutationFunction<ScheduleNowTaskCreateMutation, ScheduleNowTaskCreateMutationVariables>;

/**
 * __useScheduleNowTaskCreateMutation__
 *
 * To run a mutation, you first call `useScheduleNowTaskCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleNowTaskCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleNowTaskCreateMutation, { data, loading, error }] = useScheduleNowTaskCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleNowTaskCreateMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleNowTaskCreateMutation, ScheduleNowTaskCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleNowTaskCreateMutation, ScheduleNowTaskCreateMutationVariables>(ScheduleNowTaskCreateDocument, options);
      }
export type ScheduleNowTaskCreateMutationHookResult = ReturnType<typeof useScheduleNowTaskCreateMutation>;
export type ScheduleNowTaskCreateMutationResult = Apollo.MutationResult<ScheduleNowTaskCreateMutation>;
export type ScheduleNowTaskCreateMutationOptions = Apollo.BaseMutationOptions<ScheduleNowTaskCreateMutation, ScheduleNowTaskCreateMutationVariables>;
export const CreateScheduleDocument = gql`
    mutation CreateSchedule($input: ScheduleCreateInput!) {
  scheduleCreate(input: $input) {
    applicationStageId
    debriefRescheduleDetails {
      hasScheduleTimeAfterDebriefStartAt
      hasAttendeeAdded
    }
  }
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const RescheduleDocument = gql`
    mutation Reschedule($input: ScheduleRescheduleInput!) {
  scheduleReschedule(input: $input) {
    applicationStageId
    debriefRescheduleDetails {
      hasScheduleTimeAfterDebriefStartAt
      hasAttendeeAdded
    }
  }
}
    `;
export type RescheduleMutationFn = Apollo.MutationFunction<RescheduleMutation, RescheduleMutationVariables>;

/**
 * __useRescheduleMutation__
 *
 * To run a mutation, you first call `useRescheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleMutation, { data, loading, error }] = useRescheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleMutation, RescheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleMutation, RescheduleMutationVariables>(RescheduleDocument, options);
      }
export type RescheduleMutationHookResult = ReturnType<typeof useRescheduleMutation>;
export type RescheduleMutationResult = Apollo.MutationResult<RescheduleMutation>;
export type RescheduleMutationOptions = Apollo.BaseMutationOptions<RescheduleMutation, RescheduleMutationVariables>;
export const CreateScheduleSaveInterviewPlanDocument = gql`
    mutation CreateScheduleSaveInterviewPlan($input: JobStageInterviewPlanUpsertInput!) {
  jobStageInterviewPlanUpsert(input: $input) {
    jobStage {
      id
    }
  }
}
    `;
export type CreateScheduleSaveInterviewPlanMutationFn = Apollo.MutationFunction<CreateScheduleSaveInterviewPlanMutation, CreateScheduleSaveInterviewPlanMutationVariables>;

/**
 * __useCreateScheduleSaveInterviewPlanMutation__
 *
 * To run a mutation, you first call `useCreateScheduleSaveInterviewPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleSaveInterviewPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleSaveInterviewPlanMutation, { data, loading, error }] = useCreateScheduleSaveInterviewPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduleSaveInterviewPlanMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleSaveInterviewPlanMutation, CreateScheduleSaveInterviewPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleSaveInterviewPlanMutation, CreateScheduleSaveInterviewPlanMutationVariables>(CreateScheduleSaveInterviewPlanDocument, options);
      }
export type CreateScheduleSaveInterviewPlanMutationHookResult = ReturnType<typeof useCreateScheduleSaveInterviewPlanMutation>;
export type CreateScheduleSaveInterviewPlanMutationResult = Apollo.MutationResult<CreateScheduleSaveInterviewPlanMutation>;
export type CreateScheduleSaveInterviewPlanMutationOptions = Apollo.BaseMutationOptions<CreateScheduleSaveInterviewPlanMutation, CreateScheduleSaveInterviewPlanMutationVariables>;
export const CustomInterviewMeetingLocationCreateDocument = gql`
    mutation CustomInterviewMeetingLocationCreate($input: MeetingLocationCreateInput!) {
  meetingLocationCreate(input: $input) {
    meetingLocation {
      id
      type
      videoMeetingLink
      details {
        customLocation
      }
    }
  }
}
    `;
export type CustomInterviewMeetingLocationCreateMutationFn = Apollo.MutationFunction<CustomInterviewMeetingLocationCreateMutation, CustomInterviewMeetingLocationCreateMutationVariables>;

/**
 * __useCustomInterviewMeetingLocationCreateMutation__
 *
 * To run a mutation, you first call `useCustomInterviewMeetingLocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomInterviewMeetingLocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customInterviewMeetingLocationCreateMutation, { data, loading, error }] = useCustomInterviewMeetingLocationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomInterviewMeetingLocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<CustomInterviewMeetingLocationCreateMutation, CustomInterviewMeetingLocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomInterviewMeetingLocationCreateMutation, CustomInterviewMeetingLocationCreateMutationVariables>(CustomInterviewMeetingLocationCreateDocument, options);
      }
export type CustomInterviewMeetingLocationCreateMutationHookResult = ReturnType<typeof useCustomInterviewMeetingLocationCreateMutation>;
export type CustomInterviewMeetingLocationCreateMutationResult = Apollo.MutationResult<CustomInterviewMeetingLocationCreateMutation>;
export type CustomInterviewMeetingLocationCreateMutationOptions = Apollo.BaseMutationOptions<CustomInterviewMeetingLocationCreateMutation, CustomInterviewMeetingLocationCreateMutationVariables>;
export const CalendarMeetingCreateDocument = gql`
    mutation CalendarMeetingCreate($input: CalendarMeetingCreateInput!) {
  calendarMeetingCreate(input: $input) {
    url
  }
}
    `;
export type CalendarMeetingCreateMutationFn = Apollo.MutationFunction<CalendarMeetingCreateMutation, CalendarMeetingCreateMutationVariables>;

/**
 * __useCalendarMeetingCreateMutation__
 *
 * To run a mutation, you first call `useCalendarMeetingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarMeetingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarMeetingCreateMutation, { data, loading, error }] = useCalendarMeetingCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarMeetingCreateMutation(baseOptions?: Apollo.MutationHookOptions<CalendarMeetingCreateMutation, CalendarMeetingCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarMeetingCreateMutation, CalendarMeetingCreateMutationVariables>(CalendarMeetingCreateDocument, options);
      }
export type CalendarMeetingCreateMutationHookResult = ReturnType<typeof useCalendarMeetingCreateMutation>;
export type CalendarMeetingCreateMutationResult = Apollo.MutationResult<CalendarMeetingCreateMutation>;
export type CalendarMeetingCreateMutationOptions = Apollo.BaseMutationOptions<CalendarMeetingCreateMutation, CalendarMeetingCreateMutationVariables>;
export const VideoInterviewMeetingLocationCreateDocument = gql`
    mutation VideoInterviewMeetingLocationCreate($input: MeetingLocationCreateInput!) {
  meetingLocationCreate(input: $input) {
    meetingLocation {
      id
      type
      videoMeetingLink
    }
  }
}
    `;
export type VideoInterviewMeetingLocationCreateMutationFn = Apollo.MutationFunction<VideoInterviewMeetingLocationCreateMutation, VideoInterviewMeetingLocationCreateMutationVariables>;

/**
 * __useVideoInterviewMeetingLocationCreateMutation__
 *
 * To run a mutation, you first call `useVideoInterviewMeetingLocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVideoInterviewMeetingLocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [videoInterviewMeetingLocationCreateMutation, { data, loading, error }] = useVideoInterviewMeetingLocationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVideoInterviewMeetingLocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<VideoInterviewMeetingLocationCreateMutation, VideoInterviewMeetingLocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VideoInterviewMeetingLocationCreateMutation, VideoInterviewMeetingLocationCreateMutationVariables>(VideoInterviewMeetingLocationCreateDocument, options);
      }
export type VideoInterviewMeetingLocationCreateMutationHookResult = ReturnType<typeof useVideoInterviewMeetingLocationCreateMutation>;
export type VideoInterviewMeetingLocationCreateMutationResult = Apollo.MutationResult<VideoInterviewMeetingLocationCreateMutation>;
export type VideoInterviewMeetingLocationCreateMutationOptions = Apollo.BaseMutationOptions<VideoInterviewMeetingLocationCreateMutation, VideoInterviewMeetingLocationCreateMutationVariables>;
export const ZoomMeetingCreateDocument = gql`
    mutation ZoomMeetingCreate($input: ZoomMeetingCreateInput!) {
  zoomMeetingCreate(input: $input) {
    joinUrl
    meetingId
    password
    pstnPassword
    dialInfo {
      country
      countryName
      city
      number
      type
    }
  }
}
    `;
export type ZoomMeetingCreateMutationFn = Apollo.MutationFunction<ZoomMeetingCreateMutation, ZoomMeetingCreateMutationVariables>;

/**
 * __useZoomMeetingCreateMutation__
 *
 * To run a mutation, you first call `useZoomMeetingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomMeetingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomMeetingCreateMutation, { data, loading, error }] = useZoomMeetingCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZoomMeetingCreateMutation(baseOptions?: Apollo.MutationHookOptions<ZoomMeetingCreateMutation, ZoomMeetingCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZoomMeetingCreateMutation, ZoomMeetingCreateMutationVariables>(ZoomMeetingCreateDocument, options);
      }
export type ZoomMeetingCreateMutationHookResult = ReturnType<typeof useZoomMeetingCreateMutation>;
export type ZoomMeetingCreateMutationResult = Apollo.MutationResult<ZoomMeetingCreateMutation>;
export type ZoomMeetingCreateMutationOptions = Apollo.BaseMutationOptions<ZoomMeetingCreateMutation, ZoomMeetingCreateMutationVariables>;
export const ZoomSingleDebriefMeetingLocationCreateDocument = gql`
    mutation ZoomSingleDebriefMeetingLocationCreate($input: MeetingLocationCreateInput!) {
  meetingLocationCreate(input: $input) {
    meetingLocation {
      id
      videoMeetingLink
      details {
        zoomInfo {
          meetingId
          password
          pstnPassword
          dialInfo {
            type
            number
            city
            countryName
            country
          }
        }
      }
    }
  }
}
    `;
export type ZoomSingleDebriefMeetingLocationCreateMutationFn = Apollo.MutationFunction<ZoomSingleDebriefMeetingLocationCreateMutation, ZoomSingleDebriefMeetingLocationCreateMutationVariables>;

/**
 * __useZoomSingleDebriefMeetingLocationCreateMutation__
 *
 * To run a mutation, you first call `useZoomSingleDebriefMeetingLocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomSingleDebriefMeetingLocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomSingleDebriefMeetingLocationCreateMutation, { data, loading, error }] = useZoomSingleDebriefMeetingLocationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZoomSingleDebriefMeetingLocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<ZoomSingleDebriefMeetingLocationCreateMutation, ZoomSingleDebriefMeetingLocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZoomSingleDebriefMeetingLocationCreateMutation, ZoomSingleDebriefMeetingLocationCreateMutationVariables>(ZoomSingleDebriefMeetingLocationCreateDocument, options);
      }
export type ZoomSingleDebriefMeetingLocationCreateMutationHookResult = ReturnType<typeof useZoomSingleDebriefMeetingLocationCreateMutation>;
export type ZoomSingleDebriefMeetingLocationCreateMutationResult = Apollo.MutationResult<ZoomSingleDebriefMeetingLocationCreateMutation>;
export type ZoomSingleDebriefMeetingLocationCreateMutationOptions = Apollo.BaseMutationOptions<ZoomSingleDebriefMeetingLocationCreateMutation, ZoomSingleDebriefMeetingLocationCreateMutationVariables>;
export const ZoomInterviewMeetingLocationCreateDocument = gql`
    mutation ZoomInterviewMeetingLocationCreate($input: MeetingLocationCreateInput!) {
  meetingLocationCreate(input: $input) {
    meetingLocation {
      id
      type
      videoMeetingLink
      details {
        zoomInfo {
          password
          meetingId
          userId
          pstnPassword
          dialInfo {
            type
            number
            city
            countryName
            country
          }
        }
      }
    }
  }
}
    `;
export type ZoomInterviewMeetingLocationCreateMutationFn = Apollo.MutationFunction<ZoomInterviewMeetingLocationCreateMutation, ZoomInterviewMeetingLocationCreateMutationVariables>;

/**
 * __useZoomInterviewMeetingLocationCreateMutation__
 *
 * To run a mutation, you first call `useZoomInterviewMeetingLocationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZoomInterviewMeetingLocationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zoomInterviewMeetingLocationCreateMutation, { data, loading, error }] = useZoomInterviewMeetingLocationCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useZoomInterviewMeetingLocationCreateMutation(baseOptions?: Apollo.MutationHookOptions<ZoomInterviewMeetingLocationCreateMutation, ZoomInterviewMeetingLocationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZoomInterviewMeetingLocationCreateMutation, ZoomInterviewMeetingLocationCreateMutationVariables>(ZoomInterviewMeetingLocationCreateDocument, options);
      }
export type ZoomInterviewMeetingLocationCreateMutationHookResult = ReturnType<typeof useZoomInterviewMeetingLocationCreateMutation>;
export type ZoomInterviewMeetingLocationCreateMutationResult = Apollo.MutationResult<ZoomInterviewMeetingLocationCreateMutation>;
export type ZoomInterviewMeetingLocationCreateMutationOptions = Apollo.BaseMutationOptions<ZoomInterviewMeetingLocationCreateMutation, ZoomInterviewMeetingLocationCreateMutationVariables>;
export const InterviewMeetingLocationZoomUsersByEmployeeIdsDocument = gql`
    query InterviewMeetingLocationZoomUsersByEmployeeIds($employeeIds: [uuid!]) {
  zoomUsersByIds(input: {employeeIds: $employeeIds}) {
    employeeId
    zoomUserId
  }
}
    `;

/**
 * __useInterviewMeetingLocationZoomUsersByEmployeeIdsQuery__
 *
 * To run a query within a React component, call `useInterviewMeetingLocationZoomUsersByEmployeeIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewMeetingLocationZoomUsersByEmployeeIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewMeetingLocationZoomUsersByEmployeeIdsQuery({
 *   variables: {
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useInterviewMeetingLocationZoomUsersByEmployeeIdsQuery(baseOptions?: Apollo.QueryHookOptions<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>(InterviewMeetingLocationZoomUsersByEmployeeIdsDocument, options);
      }
export function useInterviewMeetingLocationZoomUsersByEmployeeIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>(InterviewMeetingLocationZoomUsersByEmployeeIdsDocument, options);
        }
// @ts-ignore
export function useInterviewMeetingLocationZoomUsersByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>;
export function useInterviewMeetingLocationZoomUsersByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery | undefined, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>;
export function useInterviewMeetingLocationZoomUsersByEmployeeIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>(InterviewMeetingLocationZoomUsersByEmployeeIdsDocument, options);
        }
export type InterviewMeetingLocationZoomUsersByEmployeeIdsQueryHookResult = ReturnType<typeof useInterviewMeetingLocationZoomUsersByEmployeeIdsQuery>;
export type InterviewMeetingLocationZoomUsersByEmployeeIdsLazyQueryHookResult = ReturnType<typeof useInterviewMeetingLocationZoomUsersByEmployeeIdsLazyQuery>;
export type InterviewMeetingLocationZoomUsersByEmployeeIdsSuspenseQueryHookResult = ReturnType<typeof useInterviewMeetingLocationZoomUsersByEmployeeIdsSuspenseQuery>;
export type InterviewMeetingLocationZoomUsersByEmployeeIdsQueryResult = Apollo.QueryResult<InterviewMeetingLocationZoomUsersByEmployeeIdsQuery, InterviewMeetingLocationZoomUsersByEmployeeIdsQueryVariables>;
export const SlackChannelByNameDocument = gql`
    query SlackChannelByName($name: String!) {
  slackChannelByName(name: $name) {
    id
    name
  }
}
    `;

/**
 * __useSlackChannelByNameQuery__
 *
 * To run a query within a React component, call `useSlackChannelByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlackChannelByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlackChannelByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSlackChannelByNameQuery(baseOptions: Apollo.QueryHookOptions<SlackChannelByNameQuery, SlackChannelByNameQueryVariables> & ({ variables: SlackChannelByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>(SlackChannelByNameDocument, options);
      }
export function useSlackChannelByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>(SlackChannelByNameDocument, options);
        }
// @ts-ignore
export function useSlackChannelByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>;
export function useSlackChannelByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>): Apollo.UseSuspenseQueryResult<SlackChannelByNameQuery | undefined, SlackChannelByNameQueryVariables>;
export function useSlackChannelByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>(SlackChannelByNameDocument, options);
        }
export type SlackChannelByNameQueryHookResult = ReturnType<typeof useSlackChannelByNameQuery>;
export type SlackChannelByNameLazyQueryHookResult = ReturnType<typeof useSlackChannelByNameLazyQuery>;
export type SlackChannelByNameSuspenseQueryHookResult = ReturnType<typeof useSlackChannelByNameSuspenseQuery>;
export type SlackChannelByNameQueryResult = Apollo.QueryResult<SlackChannelByNameQuery, SlackChannelByNameQueryVariables>;
export const ExistingSlackChannelsDocument = gql`
    query ExistingSlackChannels($applicationId: uuid!) {
  application(id: $applicationId) {
    id
    existingConversations {
      id
      remoteName
      isArchived
    }
    jobStage {
      id
      jobStageSettingsV2 {
        id
        chatConversation {
          chatConversationId
          chatConversation {
            id
            remoteName
            isArchived
          }
          chatConversationType
        }
      }
    }
  }
}
    `;

/**
 * __useExistingSlackChannelsQuery__
 *
 * To run a query within a React component, call `useExistingSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExistingSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExistingSlackChannelsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useExistingSlackChannelsQuery(baseOptions: Apollo.QueryHookOptions<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables> & ({ variables: ExistingSlackChannelsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>(ExistingSlackChannelsDocument, options);
      }
export function useExistingSlackChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>(ExistingSlackChannelsDocument, options);
        }
// @ts-ignore
export function useExistingSlackChannelsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>;
export function useExistingSlackChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>): Apollo.UseSuspenseQueryResult<ExistingSlackChannelsQuery | undefined, ExistingSlackChannelsQueryVariables>;
export function useExistingSlackChannelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>(ExistingSlackChannelsDocument, options);
        }
export type ExistingSlackChannelsQueryHookResult = ReturnType<typeof useExistingSlackChannelsQuery>;
export type ExistingSlackChannelsLazyQueryHookResult = ReturnType<typeof useExistingSlackChannelsLazyQuery>;
export type ExistingSlackChannelsSuspenseQueryHookResult = ReturnType<typeof useExistingSlackChannelsSuspenseQuery>;
export type ExistingSlackChannelsQueryResult = Apollo.QueryResult<ExistingSlackChannelsQuery, ExistingSlackChannelsQueryVariables>;
export const CommunicationsOrgIntegrationDocument = gql`
    query CommunicationsOrgIntegration {
  thisOrg {
    integrations {
      id
      coderpad {
        apiKey
      }
      codility {
        apiKey
      }
      codesignal {
        apiKey
      }
      hackerrank {
        apiKey
      }
    }
    id
  }
}
    `;

/**
 * __useCommunicationsOrgIntegrationQuery__
 *
 * To run a query within a React component, call `useCommunicationsOrgIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationsOrgIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationsOrgIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunicationsOrgIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>(CommunicationsOrgIntegrationDocument, options);
      }
export function useCommunicationsOrgIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>(CommunicationsOrgIntegrationDocument, options);
        }
// @ts-ignore
export function useCommunicationsOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>;
export function useCommunicationsOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationsOrgIntegrationQuery | undefined, CommunicationsOrgIntegrationQueryVariables>;
export function useCommunicationsOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>(CommunicationsOrgIntegrationDocument, options);
        }
export type CommunicationsOrgIntegrationQueryHookResult = ReturnType<typeof useCommunicationsOrgIntegrationQuery>;
export type CommunicationsOrgIntegrationLazyQueryHookResult = ReturnType<typeof useCommunicationsOrgIntegrationLazyQuery>;
export type CommunicationsOrgIntegrationSuspenseQueryHookResult = ReturnType<typeof useCommunicationsOrgIntegrationSuspenseQuery>;
export type CommunicationsOrgIntegrationQueryResult = Apollo.QueryResult<CommunicationsOrgIntegrationQuery, CommunicationsOrgIntegrationQueryVariables>;
export const InterviewModuleDocument = gql`
    query InterviewModule($interviewModuleId: uuid!) {
  interviewModule(id: $interviewModuleId) {
    ...InterviewModule
    membersCount
    membersTrainedCount
    membersInTrainingCount
    membersInShadowCount
    membersInReverseShadowCount
    graduateFromShadowApprovalType
    graduateFromShadowCustomApprovers
    graduateFromReverseShadowApprovalType
    graduateFromReverseShadowCustomApprovers
  }
}
    ${InterviewModuleFragmentDoc}`;

/**
 * __useInterviewModuleQuery__
 *
 * To run a query within a React component, call `useInterviewModuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleQuery({
 *   variables: {
 *      interviewModuleId: // value for 'interviewModuleId'
 *   },
 * });
 */
export function useInterviewModuleQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleQuery, InterviewModuleQueryVariables> & ({ variables: InterviewModuleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleQuery, InterviewModuleQueryVariables>(InterviewModuleDocument, options);
      }
export function useInterviewModuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleQuery, InterviewModuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleQuery, InterviewModuleQueryVariables>(InterviewModuleDocument, options);
        }
// @ts-ignore
export function useInterviewModuleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleQuery, InterviewModuleQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleQuery, InterviewModuleQueryVariables>;
export function useInterviewModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleQuery, InterviewModuleQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleQuery | undefined, InterviewModuleQueryVariables>;
export function useInterviewModuleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleQuery, InterviewModuleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleQuery, InterviewModuleQueryVariables>(InterviewModuleDocument, options);
        }
export type InterviewModuleQueryHookResult = ReturnType<typeof useInterviewModuleQuery>;
export type InterviewModuleLazyQueryHookResult = ReturnType<typeof useInterviewModuleLazyQuery>;
export type InterviewModuleSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleSuspenseQuery>;
export type InterviewModuleQueryResult = Apollo.QueryResult<InterviewModuleQuery, InterviewModuleQueryVariables>;
export const InterviewerSuggestionsDocument = gql`
    query InterviewerSuggestions($input: InterviewerSuggestionsInput!, $interviewModuleId: uuid!) {
  interviewerSuggestions(input: $input) {
    employees {
      companyHolidays {
        id
        ...getTextForFlag_companyHoliday
      }
      role
      loadAndLimit {
        dailyLoad
        weeklyLoad
        lastWeeklyLoad
        dailyLoadMinutes
        weeklyLoadMinutes
        lastWeeklyLoadMinutes
        dailyInterviewLimit {
          type
          limit
        }
        weeklyInterviewLimit {
          type
          limit
        }
      }
      employeeId
      employee {
        id
        fullName
        givenName
        linkedinUrl
        internalProfilePictureUrl
        timezone
        email
        title
        interviewModuleMember(interviewModuleId: $interviewModuleId) {
          interviewModuleId
          employeeId
          stats {
            trainingStatus
            currentTrainingSessionStatus
            completedAsShadow
            completedAsReverseShadow
            shadowOffset
            reverseShadowOffset
          }
          ...isModuleMemberDisabledForScheduling_ModuleMember
          ...ModuleMember_interviewModuleMember
        }
      }
      flags
      eventsWithConflicts {
        flag
        events
      }
    }
    others {
      companyHolidays {
        id
        ...getTextForFlag_companyHoliday
      }
      role
      loadAndLimit {
        dailyLoad
        weeklyLoad
        lastWeeklyLoad
        dailyLoadMinutes
        weeklyLoadMinutes
        lastWeeklyLoadMinutes
        dailyInterviewLimit {
          type
          limit
        }
        weeklyInterviewLimit {
          type
          limit
        }
      }
      employeeId
      employee {
        id
        fullName
        givenName
        linkedinUrl
        internalProfilePictureUrl
        timezone
        email
        title
      }
      flags
      eventsWithConflicts {
        flag
        events
      }
    }
  }
}
    ${GetTextForFlag_CompanyHolidayFragmentDoc}
${IsModuleMemberDisabledForScheduling_ModuleMemberFragmentDoc}
${ModuleMember_InterviewModuleMemberFragmentDoc}`;

/**
 * __useInterviewerSuggestionsQuery__
 *
 * To run a query within a React component, call `useInterviewerSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      interviewModuleId: // value for 'interviewModuleId'
 *   },
 * });
 */
export function useInterviewerSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables> & ({ variables: InterviewerSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>(InterviewerSuggestionsDocument, options);
      }
export function useInterviewerSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>(InterviewerSuggestionsDocument, options);
        }
// @ts-ignore
export function useInterviewerSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>;
export function useInterviewerSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerSuggestionsQuery | undefined, InterviewerSuggestionsQueryVariables>;
export function useInterviewerSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>(InterviewerSuggestionsDocument, options);
        }
export type InterviewerSuggestionsQueryHookResult = ReturnType<typeof useInterviewerSuggestionsQuery>;
export type InterviewerSuggestionsLazyQueryHookResult = ReturnType<typeof useInterviewerSuggestionsLazyQuery>;
export type InterviewerSuggestionsSuspenseQueryHookResult = ReturnType<typeof useInterviewerSuggestionsSuspenseQuery>;
export type InterviewerSuggestionsQueryResult = Apollo.QueryResult<InterviewerSuggestionsQuery, InterviewerSuggestionsQueryVariables>;
export const InterviewModuleMemberLookupDocument = gql`
    query InterviewModuleMemberLookup($memberIds: [uuid!]!, $interviewModuleIds: [uuid!]) {
  interviewModuleMemberLookup(
    input: {interviewModuleMemberIds: $memberIds, interviewModuleIds: $interviewModuleIds}
  ) {
    items {
      interviewModuleId
      employeeId
      status
      interviewModule {
        id
        name
        shadowsRequired
        reverseShadowsRequired
      }
      employee {
        id
        fullName
      }
      stats {
        completed
        upcoming
        shadowOffset
        shadowsRequired
        reverseShadowOffset
        reverseShadowsRequired
        completedAsShadow
        completedAsReverseShadow
        currentTrainingSessionStatus
      }
    }
  }
}
    `;

/**
 * __useInterviewModuleMemberLookupQuery__
 *
 * To run a query within a React component, call `useInterviewModuleMemberLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMemberLookupQuery({
 *   variables: {
 *      memberIds: // value for 'memberIds'
 *      interviewModuleIds: // value for 'interviewModuleIds'
 *   },
 * });
 */
export function useInterviewModuleMemberLookupQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables> & ({ variables: InterviewModuleMemberLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>(InterviewModuleMemberLookupDocument, options);
      }
export function useInterviewModuleMemberLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>(InterviewModuleMemberLookupDocument, options);
        }
// @ts-ignore
export function useInterviewModuleMemberLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>;
export function useInterviewModuleMemberLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberLookupQuery | undefined, InterviewModuleMemberLookupQueryVariables>;
export function useInterviewModuleMemberLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>(InterviewModuleMemberLookupDocument, options);
        }
export type InterviewModuleMemberLookupQueryHookResult = ReturnType<typeof useInterviewModuleMemberLookupQuery>;
export type InterviewModuleMemberLookupLazyQueryHookResult = ReturnType<typeof useInterviewModuleMemberLookupLazyQuery>;
export type InterviewModuleMemberLookupSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMemberLookupSuspenseQuery>;
export type InterviewModuleMemberLookupQueryResult = Apollo.QueryResult<InterviewModuleMemberLookupQuery, InterviewModuleMemberLookupQueryVariables>;
export const GetAllEmployeeBufferTimesDocument = gql`
    query GetAllEmployeeBufferTimes($ids: [uuid!]!) {
  employeeByIds(ids: $ids) {
    id
    employeePrefValues {
      ... on JsonEmployeePrefValue {
        id
        prefName
        value {
          ... on InterviewBufferTimePref {
            after {
              seconds
            }
            before {
              seconds
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllEmployeeBufferTimesQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeeBufferTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeeBufferTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeeBufferTimesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAllEmployeeBufferTimesQuery(baseOptions: Apollo.QueryHookOptions<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables> & ({ variables: GetAllEmployeeBufferTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>(GetAllEmployeeBufferTimesDocument, options);
      }
export function useGetAllEmployeeBufferTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>(GetAllEmployeeBufferTimesDocument, options);
        }
// @ts-ignore
export function useGetAllEmployeeBufferTimesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>;
export function useGetAllEmployeeBufferTimesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllEmployeeBufferTimesQuery | undefined, GetAllEmployeeBufferTimesQueryVariables>;
export function useGetAllEmployeeBufferTimesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>(GetAllEmployeeBufferTimesDocument, options);
        }
export type GetAllEmployeeBufferTimesQueryHookResult = ReturnType<typeof useGetAllEmployeeBufferTimesQuery>;
export type GetAllEmployeeBufferTimesLazyQueryHookResult = ReturnType<typeof useGetAllEmployeeBufferTimesLazyQuery>;
export type GetAllEmployeeBufferTimesSuspenseQueryHookResult = ReturnType<typeof useGetAllEmployeeBufferTimesSuspenseQuery>;
export type GetAllEmployeeBufferTimesQueryResult = Apollo.QueryResult<GetAllEmployeeBufferTimesQuery, GetAllEmployeeBufferTimesQueryVariables>;
export const AbsoluteEmployeeWorkHoursDocument = gql`
    query AbsoluteEmployeeWorkHours($ids: [uuid!]!, $startAt: datetime!, $endAt: datetime!) {
  employeeByIds(ids: $ids) {
    id
    fullName
    absoluteWorkHours(input: {range: {startAt: $startAt, endAt: $endAt}}) {
      startAt
      endAt
    }
  }
}
    `;

/**
 * __useAbsoluteEmployeeWorkHoursQuery__
 *
 * To run a query within a React component, call `useAbsoluteEmployeeWorkHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbsoluteEmployeeWorkHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbsoluteEmployeeWorkHoursQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *   },
 * });
 */
export function useAbsoluteEmployeeWorkHoursQuery(baseOptions: Apollo.QueryHookOptions<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables> & ({ variables: AbsoluteEmployeeWorkHoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>(AbsoluteEmployeeWorkHoursDocument, options);
      }
export function useAbsoluteEmployeeWorkHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>(AbsoluteEmployeeWorkHoursDocument, options);
        }
// @ts-ignore
export function useAbsoluteEmployeeWorkHoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>): Apollo.UseSuspenseQueryResult<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>;
export function useAbsoluteEmployeeWorkHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>): Apollo.UseSuspenseQueryResult<AbsoluteEmployeeWorkHoursQuery | undefined, AbsoluteEmployeeWorkHoursQueryVariables>;
export function useAbsoluteEmployeeWorkHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>(AbsoluteEmployeeWorkHoursDocument, options);
        }
export type AbsoluteEmployeeWorkHoursQueryHookResult = ReturnType<typeof useAbsoluteEmployeeWorkHoursQuery>;
export type AbsoluteEmployeeWorkHoursLazyQueryHookResult = ReturnType<typeof useAbsoluteEmployeeWorkHoursLazyQuery>;
export type AbsoluteEmployeeWorkHoursSuspenseQueryHookResult = ReturnType<typeof useAbsoluteEmployeeWorkHoursSuspenseQuery>;
export type AbsoluteEmployeeWorkHoursQueryResult = Apollo.QueryResult<AbsoluteEmployeeWorkHoursQuery, AbsoluteEmployeeWorkHoursQueryVariables>;
export const SaveInterviewPlanToJobStageDocument = gql`
    mutation SaveInterviewPlanToJobStage($input: JobStageInterviewPlanUpsertInput!) {
  jobStageInterviewPlanUpsert(input: $input) {
    jobStage {
      id
    }
  }
}
    `;
export type SaveInterviewPlanToJobStageMutationFn = Apollo.MutationFunction<SaveInterviewPlanToJobStageMutation, SaveInterviewPlanToJobStageMutationVariables>;

/**
 * __useSaveInterviewPlanToJobStageMutation__
 *
 * To run a mutation, you first call `useSaveInterviewPlanToJobStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInterviewPlanToJobStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInterviewPlanToJobStageMutation, { data, loading, error }] = useSaveInterviewPlanToJobStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInterviewPlanToJobStageMutation(baseOptions?: Apollo.MutationHookOptions<SaveInterviewPlanToJobStageMutation, SaveInterviewPlanToJobStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInterviewPlanToJobStageMutation, SaveInterviewPlanToJobStageMutationVariables>(SaveInterviewPlanToJobStageDocument, options);
      }
export type SaveInterviewPlanToJobStageMutationHookResult = ReturnType<typeof useSaveInterviewPlanToJobStageMutation>;
export type SaveInterviewPlanToJobStageMutationResult = Apollo.MutationResult<SaveInterviewPlanToJobStageMutation>;
export type SaveInterviewPlanToJobStageMutationOptions = Apollo.BaseMutationOptions<SaveInterviewPlanToJobStageMutation, SaveInterviewPlanToJobStageMutationVariables>;
export const ScheduleFlowApplicationDocument = gql`
    query ScheduleFlowApplication($id: uuid!, $fetchInterviewPlan: Boolean!) {
  application(id: $id) {
    id
    job {
      id
      name
      atsId
      ...ScheduleFlowDataProvider_job
      jobSettings {
        id
        ...ScheduleFlowDataProvider_jobSettings
      }
    }
    jobStage {
      id
      name
      ...ScheduleFlowDataProvider_interviewPlan @include(if: $fetchInterviewPlan)
      jobStageSettingsV2 {
        id
        ...ScheduleFlowDataProvider_jobStageSettings
      }
    }
    candidate {
      id
      timezone
      atsLatestAvailability {
        ...useCandidateAvailability_atsLatestAvailability
        timezone
      }
      ...ScheduleFlowDataProvider_candidate
    }
  }
}
    ${ScheduleFlowDataProvider_JobFragmentDoc}
${ScheduleFlowDataProvider_JobSettingsFragmentDoc}
${ScheduleFlowDataProvider_InterviewPlanFragmentDoc}
${ScheduleFlowDataProvider_JobStageSettingsFragmentDoc}
${UseCandidateAvailability_AtsLatestAvailabilityFragmentDoc}
${ScheduleFlowDataProvider_CandidateFragmentDoc}`;

/**
 * __useScheduleFlowApplicationQuery__
 *
 * To run a query within a React component, call `useScheduleFlowApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFlowApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFlowApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fetchInterviewPlan: // value for 'fetchInterviewPlan'
 *   },
 * });
 */
export function useScheduleFlowApplicationQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables> & ({ variables: ScheduleFlowApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>(ScheduleFlowApplicationDocument, options);
      }
export function useScheduleFlowApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>(ScheduleFlowApplicationDocument, options);
        }
// @ts-ignore
export function useScheduleFlowApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>;
export function useScheduleFlowApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowApplicationQuery | undefined, ScheduleFlowApplicationQueryVariables>;
export function useScheduleFlowApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>(ScheduleFlowApplicationDocument, options);
        }
export type ScheduleFlowApplicationQueryHookResult = ReturnType<typeof useScheduleFlowApplicationQuery>;
export type ScheduleFlowApplicationLazyQueryHookResult = ReturnType<typeof useScheduleFlowApplicationLazyQuery>;
export type ScheduleFlowApplicationSuspenseQueryHookResult = ReturnType<typeof useScheduleFlowApplicationSuspenseQuery>;
export type ScheduleFlowApplicationQueryResult = Apollo.QueryResult<ScheduleFlowApplicationQuery, ScheduleFlowApplicationQueryVariables>;
export const ScheduleFlowJobStageDocument = gql`
    query scheduleFlowJobStage($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    name
    job {
      id
      name
      atsId
      ...ScheduleFlowDataProvider_job
    }
    ...ScheduleFlowDataProvider_interviewPlan
    jobStageSettingsV2 {
      id
      ...ScheduleFlowDataProvider_jobStageSettings
    }
  }
}
    ${ScheduleFlowDataProvider_JobFragmentDoc}
${ScheduleFlowDataProvider_InterviewPlanFragmentDoc}
${ScheduleFlowDataProvider_JobStageSettingsFragmentDoc}`;

/**
 * __useScheduleFlowJobStageQuery__
 *
 * To run a query within a React component, call `useScheduleFlowJobStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFlowJobStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFlowJobStageQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useScheduleFlowJobStageQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables> & ({ variables: ScheduleFlowJobStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>(ScheduleFlowJobStageDocument, options);
      }
export function useScheduleFlowJobStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>(ScheduleFlowJobStageDocument, options);
        }
// @ts-ignore
export function useScheduleFlowJobStageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>;
export function useScheduleFlowJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowJobStageQuery | undefined, ScheduleFlowJobStageQueryVariables>;
export function useScheduleFlowJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>(ScheduleFlowJobStageDocument, options);
        }
export type ScheduleFlowJobStageQueryHookResult = ReturnType<typeof useScheduleFlowJobStageQuery>;
export type ScheduleFlowJobStageLazyQueryHookResult = ReturnType<typeof useScheduleFlowJobStageLazyQuery>;
export type ScheduleFlowJobStageSuspenseQueryHookResult = ReturnType<typeof useScheduleFlowJobStageSuspenseQuery>;
export type ScheduleFlowJobStageQueryResult = Apollo.QueryResult<ScheduleFlowJobStageQuery, ScheduleFlowJobStageQueryVariables>;
export const ScheduleFlowTaskDocument = gql`
    query ScheduleFlowTask($id: uuid!) {
  task(id: $id) {
    id
    ...ScheduleFlowDataProvider_task
    application {
      id
      candidate {
        id
        timezone
        atsLatestAvailability {
          ...useCandidateAvailability_atsLatestAvailability
          timezone
        }
        ...ScheduleFlowDataProvider_candidate
      }
    }
    interviewPlan {
      id
      ...ScheduleFlowDataProvider_interviewPlan
    }
    jobStage {
      id
      job {
        id
        name
        atsId
        ...ScheduleFlowDataProvider_job
        jobSettings {
          id
          ...ScheduleFlowDataProvider_jobSettings
        }
      }
      name
      jobStageSettingsV2 {
        id
        ...ScheduleFlowDataProvider_jobStageSettings
      }
    }
    availabilities {
      id
      ...useCandidateAvailability_availabilities
    }
  }
}
    ${ScheduleFlowDataProvider_TaskFragmentDoc}
${UseCandidateAvailability_AtsLatestAvailabilityFragmentDoc}
${ScheduleFlowDataProvider_CandidateFragmentDoc}
${ScheduleFlowDataProvider_InterviewPlanFragmentDoc}
${ScheduleFlowDataProvider_JobFragmentDoc}
${ScheduleFlowDataProvider_JobSettingsFragmentDoc}
${ScheduleFlowDataProvider_JobStageSettingsFragmentDoc}
${UseCandidateAvailability_AvailabilitiesFragmentDoc}`;

/**
 * __useScheduleFlowTaskQuery__
 *
 * To run a query within a React component, call `useScheduleFlowTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFlowTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFlowTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduleFlowTaskQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables> & ({ variables: ScheduleFlowTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>(ScheduleFlowTaskDocument, options);
      }
export function useScheduleFlowTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>(ScheduleFlowTaskDocument, options);
        }
// @ts-ignore
export function useScheduleFlowTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>;
export function useScheduleFlowTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleFlowTaskQuery | undefined, ScheduleFlowTaskQueryVariables>;
export function useScheduleFlowTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>(ScheduleFlowTaskDocument, options);
        }
export type ScheduleFlowTaskQueryHookResult = ReturnType<typeof useScheduleFlowTaskQuery>;
export type ScheduleFlowTaskLazyQueryHookResult = ReturnType<typeof useScheduleFlowTaskLazyQuery>;
export type ScheduleFlowTaskSuspenseQueryHookResult = ReturnType<typeof useScheduleFlowTaskSuspenseQuery>;
export type ScheduleFlowTaskQueryResult = Apollo.QueryResult<ScheduleFlowTaskQuery, ScheduleFlowTaskQueryVariables>;
export const CandidateAtsLatestAvailabilityDocument = gql`
    query CandidateAtsLatestAvailability($applicationId: uuid!) {
  application(id: $applicationId) {
    candidate {
      ...CandidateAtsLatestAvailabilityFragment
    }
    coordinator {
      id
    }
    recruiter {
      id
    }
    job {
      hiringManagers {
        id
      }
    }
  }
}
    ${CandidateAtsLatestAvailabilityFragmentFragmentDoc}`;

/**
 * __useCandidateAtsLatestAvailabilityQuery__
 *
 * To run a query within a React component, call `useCandidateAtsLatestAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateAtsLatestAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateAtsLatestAvailabilityQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useCandidateAtsLatestAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables> & ({ variables: CandidateAtsLatestAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>(CandidateAtsLatestAvailabilityDocument, options);
      }
export function useCandidateAtsLatestAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>(CandidateAtsLatestAvailabilityDocument, options);
        }
// @ts-ignore
export function useCandidateAtsLatestAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>;
export function useCandidateAtsLatestAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateAtsLatestAvailabilityQuery | undefined, CandidateAtsLatestAvailabilityQueryVariables>;
export function useCandidateAtsLatestAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>(CandidateAtsLatestAvailabilityDocument, options);
        }
export type CandidateAtsLatestAvailabilityQueryHookResult = ReturnType<typeof useCandidateAtsLatestAvailabilityQuery>;
export type CandidateAtsLatestAvailabilityLazyQueryHookResult = ReturnType<typeof useCandidateAtsLatestAvailabilityLazyQuery>;
export type CandidateAtsLatestAvailabilitySuspenseQueryHookResult = ReturnType<typeof useCandidateAtsLatestAvailabilitySuspenseQuery>;
export type CandidateAtsLatestAvailabilityQueryResult = Apollo.QueryResult<CandidateAtsLatestAvailabilityQuery, CandidateAtsLatestAvailabilityQueryVariables>;
export const InitScheduleFlowDataDocument = gql`
    query InitScheduleFlowData($input: InitScheduleFlowInput!) {
  initScheduleFlow(input: $input) {
    candidateConfirmationEmailTemplate {
      ...InitScheduleFlowData_template
    }
    candidateConfirmationInviteTemplate {
      ...InitScheduleFlowData_template
    }
    interviewerConfirmationInviteTemplate {
      ...InitScheduleFlowData_template
    }
    interviewerConversationMessageTemplate {
      ...InitScheduleFlowData_template
    }
    candidateCalendar {
      remoteId
    }
    interviewerCalendar {
      remoteId
    }
    isPrivateCalendarEvents
  }
}
    ${InitScheduleFlowData_TemplateFragmentDoc}`;

/**
 * __useInitScheduleFlowDataQuery__
 *
 * To run a query within a React component, call `useInitScheduleFlowDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitScheduleFlowDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitScheduleFlowDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitScheduleFlowDataQuery(baseOptions: Apollo.QueryHookOptions<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables> & ({ variables: InitScheduleFlowDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>(InitScheduleFlowDataDocument, options);
      }
export function useInitScheduleFlowDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>(InitScheduleFlowDataDocument, options);
        }
// @ts-ignore
export function useInitScheduleFlowDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>): Apollo.UseSuspenseQueryResult<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>;
export function useInitScheduleFlowDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>): Apollo.UseSuspenseQueryResult<InitScheduleFlowDataQuery | undefined, InitScheduleFlowDataQueryVariables>;
export function useInitScheduleFlowDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>(InitScheduleFlowDataDocument, options);
        }
export type InitScheduleFlowDataQueryHookResult = ReturnType<typeof useInitScheduleFlowDataQuery>;
export type InitScheduleFlowDataLazyQueryHookResult = ReturnType<typeof useInitScheduleFlowDataLazyQuery>;
export type InitScheduleFlowDataSuspenseQueryHookResult = ReturnType<typeof useInitScheduleFlowDataSuspenseQuery>;
export type InitScheduleFlowDataQueryResult = Apollo.QueryResult<InitScheduleFlowDataQuery, InitScheduleFlowDataQueryVariables>;
export const InterviewPlanFromTaskDocument = gql`
    query InterviewPlanFromTask($id: uuid!) {
  task(id: $id) {
    application {
      id
      candidate {
        id
        fullName
        timezone
        email
        additionalEmails
        atsCandidate {
          atsId
          atsUrl
        }
        atsLatestAvailability {
          intervals {
            startAt
            endAt
          }
          jobName
          jobStageName
          timezone
          originalText
        }
      }
      coordinator {
        id
      }
      recruiter {
        id
      }
      existingConversations {
        id
        remoteId
        remoteName
      }
    }
    availabilities {
      id
      createdAt
      ...CandidateAvailabilityFragment
    }
    jobStage {
      id
      name
      job {
        id
        name
        isConfidential
        hiringManagers {
          id
        }
      }
    }
  }
}
    ${CandidateAvailabilityFragmentFragmentDoc}`;

/**
 * __useInterviewPlanFromTaskQuery__
 *
 * To run a query within a React component, call `useInterviewPlanFromTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewPlanFromTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewPlanFromTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInterviewPlanFromTaskQuery(baseOptions: Apollo.QueryHookOptions<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables> & ({ variables: InterviewPlanFromTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>(InterviewPlanFromTaskDocument, options);
      }
export function useInterviewPlanFromTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>(InterviewPlanFromTaskDocument, options);
        }
// @ts-ignore
export function useInterviewPlanFromTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>;
export function useInterviewPlanFromTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewPlanFromTaskQuery | undefined, InterviewPlanFromTaskQueryVariables>;
export function useInterviewPlanFromTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>(InterviewPlanFromTaskDocument, options);
        }
export type InterviewPlanFromTaskQueryHookResult = ReturnType<typeof useInterviewPlanFromTaskQuery>;
export type InterviewPlanFromTaskLazyQueryHookResult = ReturnType<typeof useInterviewPlanFromTaskLazyQuery>;
export type InterviewPlanFromTaskSuspenseQueryHookResult = ReturnType<typeof useInterviewPlanFromTaskSuspenseQuery>;
export type InterviewPlanFromTaskQueryResult = Apollo.QueryResult<InterviewPlanFromTaskQuery, InterviewPlanFromTaskQueryVariables>;
export const AvailabilityOptionsSettingsDocument = gql`
    query AvailabilityOptionsSettings($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    ...getProvideAvailabilitySettings_JobStage
    jobStageSettingsV2 {
      ...CandidateAvailabilityOptionsModalWrapper_jobStageSettingsV2
      ...getProvideAvailabilitySettings_JobStageSettingsV2
    }
  }
}
    ${GetProvideAvailabilitySettings_JobStageFragmentDoc}
${CandidateAvailabilityOptionsModalWrapper_JobStageSettingsV2FragmentDoc}
${GetProvideAvailabilitySettings_JobStageSettingsV2FragmentDoc}`;

/**
 * __useAvailabilityOptionsSettingsQuery__
 *
 * To run a query within a React component, call `useAvailabilityOptionsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityOptionsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityOptionsSettingsQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useAvailabilityOptionsSettingsQuery(baseOptions: Apollo.QueryHookOptions<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables> & ({ variables: AvailabilityOptionsSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>(AvailabilityOptionsSettingsDocument, options);
      }
export function useAvailabilityOptionsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>(AvailabilityOptionsSettingsDocument, options);
        }
// @ts-ignore
export function useAvailabilityOptionsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>;
export function useAvailabilityOptionsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityOptionsSettingsQuery | undefined, AvailabilityOptionsSettingsQueryVariables>;
export function useAvailabilityOptionsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>(AvailabilityOptionsSettingsDocument, options);
        }
export type AvailabilityOptionsSettingsQueryHookResult = ReturnType<typeof useAvailabilityOptionsSettingsQuery>;
export type AvailabilityOptionsSettingsLazyQueryHookResult = ReturnType<typeof useAvailabilityOptionsSettingsLazyQuery>;
export type AvailabilityOptionsSettingsSuspenseQueryHookResult = ReturnType<typeof useAvailabilityOptionsSettingsSuspenseQuery>;
export type AvailabilityOptionsSettingsQueryResult = Apollo.QueryResult<AvailabilityOptionsSettingsQuery, AvailabilityOptionsSettingsQueryVariables>;
export const BasicTaskModalDocument = gql`
    mutation BasicTaskModal($input: TaskCreateInput!) {
  taskCreate(input: $input) {
    task {
      id
    }
  }
}
    `;
export type BasicTaskModalMutationFn = Apollo.MutationFunction<BasicTaskModalMutation, BasicTaskModalMutationVariables>;

/**
 * __useBasicTaskModalMutation__
 *
 * To run a mutation, you first call `useBasicTaskModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBasicTaskModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [basicTaskModalMutation, { data, loading, error }] = useBasicTaskModalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBasicTaskModalMutation(baseOptions?: Apollo.MutationHookOptions<BasicTaskModalMutation, BasicTaskModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BasicTaskModalMutation, BasicTaskModalMutationVariables>(BasicTaskModalDocument, options);
      }
export type BasicTaskModalMutationHookResult = ReturnType<typeof useBasicTaskModalMutation>;
export type BasicTaskModalMutationResult = Apollo.MutationResult<BasicTaskModalMutation>;
export type BasicTaskModalMutationOptions = Apollo.BaseMutationOptions<BasicTaskModalMutation, BasicTaskModalMutationVariables>;
export const CreateBasicTaskInterviewPlanDocument = gql`
    query CreateBasicTaskInterviewPlan($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    ...CreateTaskStep_jobStage
    ...cloneInterviewPlan_interviewPlan
    ...getSaveInterviewPlanInput_interviewPlan
  }
}
    ${CreateTaskStep_JobStageFragmentDoc}
${CloneInterviewPlan_InterviewPlanFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}`;

/**
 * __useCreateBasicTaskInterviewPlanQuery__
 *
 * To run a query within a React component, call `useCreateBasicTaskInterviewPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateBasicTaskInterviewPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateBasicTaskInterviewPlanQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useCreateBasicTaskInterviewPlanQuery(baseOptions: Apollo.QueryHookOptions<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables> & ({ variables: CreateBasicTaskInterviewPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>(CreateBasicTaskInterviewPlanDocument, options);
      }
export function useCreateBasicTaskInterviewPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>(CreateBasicTaskInterviewPlanDocument, options);
        }
// @ts-ignore
export function useCreateBasicTaskInterviewPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>;
export function useCreateBasicTaskInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<CreateBasicTaskInterviewPlanQuery | undefined, CreateBasicTaskInterviewPlanQueryVariables>;
export function useCreateBasicTaskInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>(CreateBasicTaskInterviewPlanDocument, options);
        }
export type CreateBasicTaskInterviewPlanQueryHookResult = ReturnType<typeof useCreateBasicTaskInterviewPlanQuery>;
export type CreateBasicTaskInterviewPlanLazyQueryHookResult = ReturnType<typeof useCreateBasicTaskInterviewPlanLazyQuery>;
export type CreateBasicTaskInterviewPlanSuspenseQueryHookResult = ReturnType<typeof useCreateBasicTaskInterviewPlanSuspenseQuery>;
export type CreateBasicTaskInterviewPlanQueryResult = Apollo.QueryResult<CreateBasicTaskInterviewPlanQuery, CreateBasicTaskInterviewPlanQueryVariables>;
export const SelfScheduleOptionsSettingsDocument = gql`
    query SelfScheduleOptionsSettings($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    jobStageSettingsV2 {
      ...SelfScheduleOptionsModalWrapper_jobStageSettingsV2
      interviewMeetingLocationSettingWithLevel {
        interviewMeetingLocationSetting {
          ...SelfScheduleOptionsModalWrapper_interviewMeetingLocation
        }
      }
    }
  }
}
    ${SelfScheduleOptionsModalWrapper_JobStageSettingsV2FragmentDoc}
${SelfScheduleOptionsModalWrapper_InterviewMeetingLocationFragmentDoc}`;

/**
 * __useSelfScheduleOptionsSettingsQuery__
 *
 * To run a query within a React component, call `useSelfScheduleOptionsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleOptionsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleOptionsSettingsQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useSelfScheduleOptionsSettingsQuery(baseOptions: Apollo.QueryHookOptions<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables> & ({ variables: SelfScheduleOptionsSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>(SelfScheduleOptionsSettingsDocument, options);
      }
export function useSelfScheduleOptionsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>(SelfScheduleOptionsSettingsDocument, options);
        }
// @ts-ignore
export function useSelfScheduleOptionsSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>;
export function useSelfScheduleOptionsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleOptionsSettingsQuery | undefined, SelfScheduleOptionsSettingsQueryVariables>;
export function useSelfScheduleOptionsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>(SelfScheduleOptionsSettingsDocument, options);
        }
export type SelfScheduleOptionsSettingsQueryHookResult = ReturnType<typeof useSelfScheduleOptionsSettingsQuery>;
export type SelfScheduleOptionsSettingsLazyQueryHookResult = ReturnType<typeof useSelfScheduleOptionsSettingsLazyQuery>;
export type SelfScheduleOptionsSettingsSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleOptionsSettingsSuspenseQuery>;
export type SelfScheduleOptionsSettingsQueryResult = Apollo.QueryResult<SelfScheduleOptionsSettingsQuery, SelfScheduleOptionsSettingsQueryVariables>;
export const DefaultTaskAssigneeDocument = gql`
    query DefaultTaskAssignee($applicationId: uuid!, $prefName: String!) {
  application(id: $applicationId) {
    coordinator {
      id
      fullName
      internalProfilePictureUrl
    }
    recruiter {
      id
      fullName
      internalProfilePictureUrl
    }
  }
  thisOrg {
    id
    orgPref(prefName: $prefName) {
      id
      orgId
      prefName
      stringValue
    }
  }
  thisEmployee {
    id
    fullName
    internalProfilePictureUrl
  }
}
    `;

/**
 * __useDefaultTaskAssigneeQuery__
 *
 * To run a query within a React component, call `useDefaultTaskAssigneeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultTaskAssigneeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultTaskAssigneeQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useDefaultTaskAssigneeQuery(baseOptions: Apollo.QueryHookOptions<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables> & ({ variables: DefaultTaskAssigneeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>(DefaultTaskAssigneeDocument, options);
      }
export function useDefaultTaskAssigneeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>(DefaultTaskAssigneeDocument, options);
        }
// @ts-ignore
export function useDefaultTaskAssigneeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>;
export function useDefaultTaskAssigneeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultTaskAssigneeQuery | undefined, DefaultTaskAssigneeQueryVariables>;
export function useDefaultTaskAssigneeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>(DefaultTaskAssigneeDocument, options);
        }
export type DefaultTaskAssigneeQueryHookResult = ReturnType<typeof useDefaultTaskAssigneeQuery>;
export type DefaultTaskAssigneeLazyQueryHookResult = ReturnType<typeof useDefaultTaskAssigneeLazyQuery>;
export type DefaultTaskAssigneeSuspenseQueryHookResult = ReturnType<typeof useDefaultTaskAssigneeSuspenseQuery>;
export type DefaultTaskAssigneeQueryResult = Apollo.QueryResult<DefaultTaskAssigneeQuery, DefaultTaskAssigneeQueryVariables>;
export const CoordinatorRecruiterUserInfosDocument = gql`
    query CoordinatorRecruiterUserInfos($ids: [uuid!]!) {
  userInfoByEmployeeIds(ids: $ids) {
    userId
    employeeId
    permissions
  }
}
    `;

/**
 * __useCoordinatorRecruiterUserInfosQuery__
 *
 * To run a query within a React component, call `useCoordinatorRecruiterUserInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoordinatorRecruiterUserInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoordinatorRecruiterUserInfosQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCoordinatorRecruiterUserInfosQuery(baseOptions: Apollo.QueryHookOptions<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables> & ({ variables: CoordinatorRecruiterUserInfosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>(CoordinatorRecruiterUserInfosDocument, options);
      }
export function useCoordinatorRecruiterUserInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>(CoordinatorRecruiterUserInfosDocument, options);
        }
// @ts-ignore
export function useCoordinatorRecruiterUserInfosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>): Apollo.UseSuspenseQueryResult<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>;
export function useCoordinatorRecruiterUserInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>): Apollo.UseSuspenseQueryResult<CoordinatorRecruiterUserInfosQuery | undefined, CoordinatorRecruiterUserInfosQueryVariables>;
export function useCoordinatorRecruiterUserInfosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>(CoordinatorRecruiterUserInfosDocument, options);
        }
export type CoordinatorRecruiterUserInfosQueryHookResult = ReturnType<typeof useCoordinatorRecruiterUserInfosQuery>;
export type CoordinatorRecruiterUserInfosLazyQueryHookResult = ReturnType<typeof useCoordinatorRecruiterUserInfosLazyQuery>;
export type CoordinatorRecruiterUserInfosSuspenseQueryHookResult = ReturnType<typeof useCoordinatorRecruiterUserInfosSuspenseQuery>;
export type CoordinatorRecruiterUserInfosQueryResult = Apollo.QueryResult<CoordinatorRecruiterUserInfosQuery, CoordinatorRecruiterUserInfosQueryVariables>;
export const TaskSetDelegateDocument = gql`
    mutation TaskSetDelegate($input: TaskSetDelegateInput!) {
  taskSetDelegate(input: $input) {
    id
    delegateType
  }
}
    `;
export type TaskSetDelegateMutationFn = Apollo.MutationFunction<TaskSetDelegateMutation, TaskSetDelegateMutationVariables>;

/**
 * __useTaskSetDelegateMutation__
 *
 * To run a mutation, you first call `useTaskSetDelegateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskSetDelegateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskSetDelegateMutation, { data, loading, error }] = useTaskSetDelegateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskSetDelegateMutation(baseOptions?: Apollo.MutationHookOptions<TaskSetDelegateMutation, TaskSetDelegateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskSetDelegateMutation, TaskSetDelegateMutationVariables>(TaskSetDelegateDocument, options);
      }
export type TaskSetDelegateMutationHookResult = ReturnType<typeof useTaskSetDelegateMutation>;
export type TaskSetDelegateMutationResult = Apollo.MutationResult<TaskSetDelegateMutation>;
export type TaskSetDelegateMutationOptions = Apollo.BaseMutationOptions<TaskSetDelegateMutation, TaskSetDelegateMutationVariables>;
export const TaskSetAssigneeDocument = gql`
    mutation TaskSetAssignee($input: TaskSetAssigneeInput!) {
  taskSetAssignee(input: $input) {
    id
    assignee {
      ...Employee
    }
  }
}
    ${EmployeeFragmentDoc}`;
export type TaskSetAssigneeMutationFn = Apollo.MutationFunction<TaskSetAssigneeMutation, TaskSetAssigneeMutationVariables>;

/**
 * __useTaskSetAssigneeMutation__
 *
 * To run a mutation, you first call `useTaskSetAssigneeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskSetAssigneeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskSetAssigneeMutation, { data, loading, error }] = useTaskSetAssigneeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskSetAssigneeMutation(baseOptions?: Apollo.MutationHookOptions<TaskSetAssigneeMutation, TaskSetAssigneeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskSetAssigneeMutation, TaskSetAssigneeMutationVariables>(TaskSetAssigneeDocument, options);
      }
export type TaskSetAssigneeMutationHookResult = ReturnType<typeof useTaskSetAssigneeMutation>;
export type TaskSetAssigneeMutationResult = Apollo.MutationResult<TaskSetAssigneeMutation>;
export type TaskSetAssigneeMutationOptions = Apollo.BaseMutationOptions<TaskSetAssigneeMutation, TaskSetAssigneeMutationVariables>;
export const TaskFlagMarkResolvedDocument = gql`
    mutation TaskFlagMarkResolved($input: TaskFlagMarkResolvedInput!) {
  taskFlagMarkResolved(input: $input) {
    taskFlag {
      ...ScheduleTaskFlags_taskFlag
    }
  }
}
    ${ScheduleTaskFlags_TaskFlagFragmentDoc}`;
export type TaskFlagMarkResolvedMutationFn = Apollo.MutationFunction<TaskFlagMarkResolvedMutation, TaskFlagMarkResolvedMutationVariables>;

/**
 * __useTaskFlagMarkResolvedMutation__
 *
 * To run a mutation, you first call `useTaskFlagMarkResolvedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskFlagMarkResolvedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskFlagMarkResolvedMutation, { data, loading, error }] = useTaskFlagMarkResolvedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskFlagMarkResolvedMutation(baseOptions?: Apollo.MutationHookOptions<TaskFlagMarkResolvedMutation, TaskFlagMarkResolvedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskFlagMarkResolvedMutation, TaskFlagMarkResolvedMutationVariables>(TaskFlagMarkResolvedDocument, options);
      }
export type TaskFlagMarkResolvedMutationHookResult = ReturnType<typeof useTaskFlagMarkResolvedMutation>;
export type TaskFlagMarkResolvedMutationResult = Apollo.MutationResult<TaskFlagMarkResolvedMutation>;
export type TaskFlagMarkResolvedMutationOptions = Apollo.BaseMutationOptions<TaskFlagMarkResolvedMutation, TaskFlagMarkResolvedMutationVariables>;
export const TaskSetTagsDocument = gql`
    mutation TaskSetTags($input: TaskSetTagsInput!) {
  taskSetTags(input: $input) {
    id
    tags {
      ...TaskTags_selectedTaskTag
    }
  }
}
    ${TaskTags_SelectedTaskTagFragmentDoc}`;
export type TaskSetTagsMutationFn = Apollo.MutationFunction<TaskSetTagsMutation, TaskSetTagsMutationVariables>;

/**
 * __useTaskSetTagsMutation__
 *
 * To run a mutation, you first call `useTaskSetTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskSetTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskSetTagsMutation, { data, loading, error }] = useTaskSetTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskSetTagsMutation(baseOptions?: Apollo.MutationHookOptions<TaskSetTagsMutation, TaskSetTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskSetTagsMutation, TaskSetTagsMutationVariables>(TaskSetTagsDocument, options);
      }
export type TaskSetTagsMutationHookResult = ReturnType<typeof useTaskSetTagsMutation>;
export type TaskSetTagsMutationResult = Apollo.MutationResult<TaskSetTagsMutation>;
export type TaskSetTagsMutationOptions = Apollo.BaseMutationOptions<TaskSetTagsMutation, TaskSetTagsMutationVariables>;
export const TaskUpdateQueueDocument = gql`
    mutation TaskUpdateQueue($input: TaskUpdateInput!) {
  taskUpdate(input: $input) {
    id
    taskQueue {
      id
    }
  }
}
    `;
export type TaskUpdateQueueMutationFn = Apollo.MutationFunction<TaskUpdateQueueMutation, TaskUpdateQueueMutationVariables>;

/**
 * __useTaskUpdateQueueMutation__
 *
 * To run a mutation, you first call `useTaskUpdateQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdateQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskUpdateQueueMutation, { data, loading, error }] = useTaskUpdateQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskUpdateQueueMutation(baseOptions?: Apollo.MutationHookOptions<TaskUpdateQueueMutation, TaskUpdateQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskUpdateQueueMutation, TaskUpdateQueueMutationVariables>(TaskUpdateQueueDocument, options);
      }
export type TaskUpdateQueueMutationHookResult = ReturnType<typeof useTaskUpdateQueueMutation>;
export type TaskUpdateQueueMutationResult = Apollo.MutationResult<TaskUpdateQueueMutation>;
export type TaskUpdateQueueMutationOptions = Apollo.BaseMutationOptions<TaskUpdateQueueMutation, TaskUpdateQueueMutationVariables>;
export const TaskRequestChangeDocument = gql`
    mutation TaskRequestChange($input: TaskRequestChangeInput!) {
  taskRequestChange(input: $input) {
    task {
      id
      flags {
        ...ScheduleTaskFlags_taskFlag
      }
    }
  }
}
    ${ScheduleTaskFlags_TaskFlagFragmentDoc}`;
export type TaskRequestChangeMutationFn = Apollo.MutationFunction<TaskRequestChangeMutation, TaskRequestChangeMutationVariables>;

/**
 * __useTaskRequestChangeMutation__
 *
 * To run a mutation, you first call `useTaskRequestChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskRequestChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskRequestChangeMutation, { data, loading, error }] = useTaskRequestChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskRequestChangeMutation(baseOptions?: Apollo.MutationHookOptions<TaskRequestChangeMutation, TaskRequestChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskRequestChangeMutation, TaskRequestChangeMutationVariables>(TaskRequestChangeDocument, options);
      }
export type TaskRequestChangeMutationHookResult = ReturnType<typeof useTaskRequestChangeMutation>;
export type TaskRequestChangeMutationResult = Apollo.MutationResult<TaskRequestChangeMutation>;
export type TaskRequestChangeMutationOptions = Apollo.BaseMutationOptions<TaskRequestChangeMutation, TaskRequestChangeMutationVariables>;
export const TaskSetDebriefRequiredDocument = gql`
    mutation TaskSetDebriefRequired($input: TaskSetDebriefRequiredInput!) {
  taskSetDebriefRequired(input: $input) {
    id
    isDebriefRequired
  }
}
    `;
export type TaskSetDebriefRequiredMutationFn = Apollo.MutationFunction<TaskSetDebriefRequiredMutation, TaskSetDebriefRequiredMutationVariables>;

/**
 * __useTaskSetDebriefRequiredMutation__
 *
 * To run a mutation, you first call `useTaskSetDebriefRequiredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskSetDebriefRequiredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskSetDebriefRequiredMutation, { data, loading, error }] = useTaskSetDebriefRequiredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskSetDebriefRequiredMutation(baseOptions?: Apollo.MutationHookOptions<TaskSetDebriefRequiredMutation, TaskSetDebriefRequiredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskSetDebriefRequiredMutation, TaskSetDebriefRequiredMutationVariables>(TaskSetDebriefRequiredDocument, options);
      }
export type TaskSetDebriefRequiredMutationHookResult = ReturnType<typeof useTaskSetDebriefRequiredMutation>;
export type TaskSetDebriefRequiredMutationResult = Apollo.MutationResult<TaskSetDebriefRequiredMutation>;
export type TaskSetDebriefRequiredMutationOptions = Apollo.BaseMutationOptions<TaskSetDebriefRequiredMutation, TaskSetDebriefRequiredMutationVariables>;
export const RescheduleLogCreateDocument = gql`
    mutation RescheduleLogCreate($input: RescheduleLogCreateInput!) {
  rescheduleLogCreate(input: $input) {
    rescheduleLog {
      ...RescheduleLogModal_rescheduleLog
    }
  }
}
    ${RescheduleLogModal_RescheduleLogFragmentDoc}`;
export type RescheduleLogCreateMutationFn = Apollo.MutationFunction<RescheduleLogCreateMutation, RescheduleLogCreateMutationVariables>;

/**
 * __useRescheduleLogCreateMutation__
 *
 * To run a mutation, you first call `useRescheduleLogCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleLogCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleLogCreateMutation, { data, loading, error }] = useRescheduleLogCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleLogCreateMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleLogCreateMutation, RescheduleLogCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleLogCreateMutation, RescheduleLogCreateMutationVariables>(RescheduleLogCreateDocument, options);
      }
export type RescheduleLogCreateMutationHookResult = ReturnType<typeof useRescheduleLogCreateMutation>;
export type RescheduleLogCreateMutationResult = Apollo.MutationResult<RescheduleLogCreateMutation>;
export type RescheduleLogCreateMutationOptions = Apollo.BaseMutationOptions<RescheduleLogCreateMutation, RescheduleLogCreateMutationVariables>;
export const RescheduleLogUpdateDocument = gql`
    mutation RescheduleLogUpdate($input: RescheduleLogUpdateInput!) {
  rescheduleLogUpdate(input: $input) {
    rescheduleLog {
      ...RescheduleLogModal_rescheduleLog
    }
  }
}
    ${RescheduleLogModal_RescheduleLogFragmentDoc}`;
export type RescheduleLogUpdateMutationFn = Apollo.MutationFunction<RescheduleLogUpdateMutation, RescheduleLogUpdateMutationVariables>;

/**
 * __useRescheduleLogUpdateMutation__
 *
 * To run a mutation, you first call `useRescheduleLogUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleLogUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleLogUpdateMutation, { data, loading, error }] = useRescheduleLogUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleLogUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleLogUpdateMutation, RescheduleLogUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleLogUpdateMutation, RescheduleLogUpdateMutationVariables>(RescheduleLogUpdateDocument, options);
      }
export type RescheduleLogUpdateMutationHookResult = ReturnType<typeof useRescheduleLogUpdateMutation>;
export type RescheduleLogUpdateMutationResult = Apollo.MutationResult<RescheduleLogUpdateMutation>;
export type RescheduleLogUpdateMutationOptions = Apollo.BaseMutationOptions<RescheduleLogUpdateMutation, RescheduleLogUpdateMutationVariables>;
export const RescheduleLogDeleteDocument = gql`
    mutation RescheduleLogDelete($input: RescheduleLogDeleteInput!) {
  rescheduleLogDelete(input: $input) {
    result
  }
}
    `;
export type RescheduleLogDeleteMutationFn = Apollo.MutationFunction<RescheduleLogDeleteMutation, RescheduleLogDeleteMutationVariables>;

/**
 * __useRescheduleLogDeleteMutation__
 *
 * To run a mutation, you first call `useRescheduleLogDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleLogDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleLogDeleteMutation, { data, loading, error }] = useRescheduleLogDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleLogDeleteMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleLogDeleteMutation, RescheduleLogDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleLogDeleteMutation, RescheduleLogDeleteMutationVariables>(RescheduleLogDeleteDocument, options);
      }
export type RescheduleLogDeleteMutationHookResult = ReturnType<typeof useRescheduleLogDeleteMutation>;
export type RescheduleLogDeleteMutationResult = Apollo.MutationResult<RescheduleLogDeleteMutation>;
export type RescheduleLogDeleteMutationOptions = Apollo.BaseMutationOptions<RescheduleLogDeleteMutation, RescheduleLogDeleteMutationVariables>;
export const TaskMeetingLocationDocument = gql`
    query TaskMeetingLocation($taskId: uuid!) {
  task(id: $taskId) {
    id
    meetingLocationSetting {
      kind: __typename
      ... on TaskMeetingLocationZoom {
        hostType
        hostEmployeeId
        remoteVideoMeetingHostUserId
      }
      ... on TaskMeetingLocationGoogleMeet {
        hostType
        hostEmployeeId
      }
      ... on TaskMeetingLocationMicrosoftTeams {
        hostType
        hostEmployeeId
      }
      ... on TaskMeetingLocationCustomLink {
        value
      }
      ... on TaskMeetingLocationCustomPhone {
        value
      }
      ... on TaskMeetingLocationCustomText {
        value
      }
    }
    jobStage {
      id
      jobStageSettingsV2 {
        interviewMeetingLocationSettingWithLevel {
          interviewMeetingLocationSetting {
            ...InterviewMeetingLocationModal_interviewMeetingLocationSettingPref
            ...InterviewMeetingLocationInfo_interviewMeetingLocationSettingPref
          }
        }
      }
    }
  }
}
    ${InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragmentDoc}
${InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragmentDoc}`;

/**
 * __useTaskMeetingLocationQuery__
 *
 * To run a query within a React component, call `useTaskMeetingLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskMeetingLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskMeetingLocationQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useTaskMeetingLocationQuery(baseOptions: Apollo.QueryHookOptions<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables> & ({ variables: TaskMeetingLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>(TaskMeetingLocationDocument, options);
      }
export function useTaskMeetingLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>(TaskMeetingLocationDocument, options);
        }
// @ts-ignore
export function useTaskMeetingLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>): Apollo.UseSuspenseQueryResult<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>;
export function useTaskMeetingLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>): Apollo.UseSuspenseQueryResult<TaskMeetingLocationQuery | undefined, TaskMeetingLocationQueryVariables>;
export function useTaskMeetingLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>(TaskMeetingLocationDocument, options);
        }
export type TaskMeetingLocationQueryHookResult = ReturnType<typeof useTaskMeetingLocationQuery>;
export type TaskMeetingLocationLazyQueryHookResult = ReturnType<typeof useTaskMeetingLocationLazyQuery>;
export type TaskMeetingLocationSuspenseQueryHookResult = ReturnType<typeof useTaskMeetingLocationSuspenseQuery>;
export type TaskMeetingLocationQueryResult = Apollo.QueryResult<TaskMeetingLocationQuery, TaskMeetingLocationQueryVariables>;
export const TaskUpdateMeetingLocationDocument = gql`
    mutation TaskUpdateMeetingLocation($input: TaskUpdateInput!) {
  taskUpdate(input: $input) {
    id
  }
}
    `;
export type TaskUpdateMeetingLocationMutationFn = Apollo.MutationFunction<TaskUpdateMeetingLocationMutation, TaskUpdateMeetingLocationMutationVariables>;

/**
 * __useTaskUpdateMeetingLocationMutation__
 *
 * To run a mutation, you first call `useTaskUpdateMeetingLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskUpdateMeetingLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskUpdateMeetingLocationMutation, { data, loading, error }] = useTaskUpdateMeetingLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskUpdateMeetingLocationMutation(baseOptions?: Apollo.MutationHookOptions<TaskUpdateMeetingLocationMutation, TaskUpdateMeetingLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskUpdateMeetingLocationMutation, TaskUpdateMeetingLocationMutationVariables>(TaskUpdateMeetingLocationDocument, options);
      }
export type TaskUpdateMeetingLocationMutationHookResult = ReturnType<typeof useTaskUpdateMeetingLocationMutation>;
export type TaskUpdateMeetingLocationMutationResult = Apollo.MutationResult<TaskUpdateMeetingLocationMutation>;
export type TaskUpdateMeetingLocationMutationOptions = Apollo.BaseMutationOptions<TaskUpdateMeetingLocationMutation, TaskUpdateMeetingLocationMutationVariables>;
export const ScheduleTaskInterviewPlanUpsertDocument = gql`
    mutation ScheduleTaskInterviewPlanUpsert($input: JobStageInterviewPlanUpsertInput!) {
  jobStageInterviewPlanUpsert(input: $input) {
    jobStage {
      id
      ...InterviewPlan_jobStage
      ...getSaveInterviewPlanInput_interviewPlan
    }
  }
}
    ${InterviewPlan_JobStageFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}`;
export type ScheduleTaskInterviewPlanUpsertMutationFn = Apollo.MutationFunction<ScheduleTaskInterviewPlanUpsertMutation, ScheduleTaskInterviewPlanUpsertMutationVariables>;

/**
 * __useScheduleTaskInterviewPlanUpsertMutation__
 *
 * To run a mutation, you first call `useScheduleTaskInterviewPlanUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskInterviewPlanUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleTaskInterviewPlanUpsertMutation, { data, loading, error }] = useScheduleTaskInterviewPlanUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleTaskInterviewPlanUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleTaskInterviewPlanUpsertMutation, ScheduleTaskInterviewPlanUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleTaskInterviewPlanUpsertMutation, ScheduleTaskInterviewPlanUpsertMutationVariables>(ScheduleTaskInterviewPlanUpsertDocument, options);
      }
export type ScheduleTaskInterviewPlanUpsertMutationHookResult = ReturnType<typeof useScheduleTaskInterviewPlanUpsertMutation>;
export type ScheduleTaskInterviewPlanUpsertMutationResult = Apollo.MutationResult<ScheduleTaskInterviewPlanUpsertMutation>;
export type ScheduleTaskInterviewPlanUpsertMutationOptions = Apollo.BaseMutationOptions<ScheduleTaskInterviewPlanUpsertMutation, ScheduleTaskInterviewPlanUpsertMutationVariables>;
export const ScheduleTaskRequirementsDocument = gql`
    query ScheduleTaskRequirements($scheduleTaskId: uuid!) {
  task(id: $scheduleTaskId) {
    id
    status
    rescheduleLogs(input: {pageInput: {offset: 0, cursor: "", limit: 100}}) {
      items {
        ...RescheduleLogsList_rescheduleLogs
      }
    }
    application {
      ...Availability_application
      ...Schedule_application
      candidate {
        ...Schedule_candidate
        ...Availability_candidate
      }
    }
    availabilities {
      id
      createdAt
      ...Availability_availability
    }
    availabilityRequests {
      id
      createdAt
      ...Availability_availabilityRequest
    }
    interviewPlan {
      ...Availability_interviewPlan
      ...Schedule_interviewPlan
    }
    jobStage {
      ...Availability_jobStage
      ...Schedule_jobStage
    }
    selfScheduleRequests {
      id
      createdAt
      ...Schedule_selfScheduleRequest
    }
    schedules {
      id
      createdAt
      updatedAt
      ...Availability_schedule
      ...Schedule_schedule
    }
    ...Debrief_debriefRequirements
  }
}
    ${RescheduleLogsList_RescheduleLogsFragmentDoc}
${Availability_ApplicationFragmentDoc}
${Schedule_ApplicationFragmentDoc}
${Schedule_CandidateFragmentDoc}
${Availability_CandidateFragmentDoc}
${Availability_AvailabilityFragmentDoc}
${Availability_AvailabilityRequestFragmentDoc}
${Availability_InterviewPlanFragmentDoc}
${Schedule_InterviewPlanFragmentDoc}
${Availability_JobStageFragmentDoc}
${Schedule_JobStageFragmentDoc}
${Schedule_SelfScheduleRequestFragmentDoc}
${Availability_ScheduleFragmentDoc}
${Schedule_ScheduleFragmentDoc}
${Debrief_DebriefRequirementsFragmentDoc}`;

/**
 * __useScheduleTaskRequirementsQuery__
 *
 * To run a query within a React component, call `useScheduleTaskRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTaskRequirementsQuery({
 *   variables: {
 *      scheduleTaskId: // value for 'scheduleTaskId'
 *   },
 * });
 */
export function useScheduleTaskRequirementsQuery(baseOptions: Apollo.QueryHookOptions<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables> & ({ variables: ScheduleTaskRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>(ScheduleTaskRequirementsDocument, options);
      }
export function useScheduleTaskRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>(ScheduleTaskRequirementsDocument, options);
        }
// @ts-ignore
export function useScheduleTaskRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>;
export function useScheduleTaskRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskRequirementsQuery | undefined, ScheduleTaskRequirementsQueryVariables>;
export function useScheduleTaskRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>(ScheduleTaskRequirementsDocument, options);
        }
export type ScheduleTaskRequirementsQueryHookResult = ReturnType<typeof useScheduleTaskRequirementsQuery>;
export type ScheduleTaskRequirementsLazyQueryHookResult = ReturnType<typeof useScheduleTaskRequirementsLazyQuery>;
export type ScheduleTaskRequirementsSuspenseQueryHookResult = ReturnType<typeof useScheduleTaskRequirementsSuspenseQuery>;
export type ScheduleTaskRequirementsQueryResult = Apollo.QueryResult<ScheduleTaskRequirementsQuery, ScheduleTaskRequirementsQueryVariables>;
export const MemberPreferredEmployeeListDocument = gql`
    query MemberPreferredEmployeeList($employeesInput: EmployeesInput!, $selectedEmployeeIds: [uuid!]!) {
  employees(input: $employeesInput) {
    items {
      ...MemberPreferredEmployeeList_employee
    }
    nextCursor
  }
  employeeByIds(ids: $selectedEmployeeIds) {
    ...MemberPreferredEmployeeList_employee
  }
}
    ${MemberPreferredEmployeeList_EmployeeFragmentDoc}`;

/**
 * __useMemberPreferredEmployeeListQuery__
 *
 * To run a query within a React component, call `useMemberPreferredEmployeeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberPreferredEmployeeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberPreferredEmployeeListQuery({
 *   variables: {
 *      employeesInput: // value for 'employeesInput'
 *      selectedEmployeeIds: // value for 'selectedEmployeeIds'
 *   },
 * });
 */
export function useMemberPreferredEmployeeListQuery(baseOptions: Apollo.QueryHookOptions<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables> & ({ variables: MemberPreferredEmployeeListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>(MemberPreferredEmployeeListDocument, options);
      }
export function useMemberPreferredEmployeeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>(MemberPreferredEmployeeListDocument, options);
        }
// @ts-ignore
export function useMemberPreferredEmployeeListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>): Apollo.UseSuspenseQueryResult<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>;
export function useMemberPreferredEmployeeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>): Apollo.UseSuspenseQueryResult<MemberPreferredEmployeeListQuery | undefined, MemberPreferredEmployeeListQueryVariables>;
export function useMemberPreferredEmployeeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>(MemberPreferredEmployeeListDocument, options);
        }
export type MemberPreferredEmployeeListQueryHookResult = ReturnType<typeof useMemberPreferredEmployeeListQuery>;
export type MemberPreferredEmployeeListLazyQueryHookResult = ReturnType<typeof useMemberPreferredEmployeeListLazyQuery>;
export type MemberPreferredEmployeeListSuspenseQueryHookResult = ReturnType<typeof useMemberPreferredEmployeeListSuspenseQuery>;
export type MemberPreferredEmployeeListQueryResult = Apollo.QueryResult<MemberPreferredEmployeeListQuery, MemberPreferredEmployeeListQueryVariables>;
export const QueueFilterTaskQueueSearchDocument = gql`
    query QueueFilterTaskQueueSearch($input: TaskQueueSearchInput!) {
  taskQueueSearch(input: $input) {
    items {
      ...QueueFilter_selectedOptions
    }
  }
}
    ${QueueFilter_SelectedOptionsFragmentDoc}`;

/**
 * __useQueueFilterTaskQueueSearchQuery__
 *
 * To run a query within a React component, call `useQueueFilterTaskQueueSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueueFilterTaskQueueSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueueFilterTaskQueueSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueueFilterTaskQueueSearchQuery(baseOptions: Apollo.QueryHookOptions<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables> & ({ variables: QueueFilterTaskQueueSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>(QueueFilterTaskQueueSearchDocument, options);
      }
export function useQueueFilterTaskQueueSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>(QueueFilterTaskQueueSearchDocument, options);
        }
// @ts-ignore
export function useQueueFilterTaskQueueSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>): Apollo.UseSuspenseQueryResult<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>;
export function useQueueFilterTaskQueueSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>): Apollo.UseSuspenseQueryResult<QueueFilterTaskQueueSearchQuery | undefined, QueueFilterTaskQueueSearchQueryVariables>;
export function useQueueFilterTaskQueueSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>(QueueFilterTaskQueueSearchDocument, options);
        }
export type QueueFilterTaskQueueSearchQueryHookResult = ReturnType<typeof useQueueFilterTaskQueueSearchQuery>;
export type QueueFilterTaskQueueSearchLazyQueryHookResult = ReturnType<typeof useQueueFilterTaskQueueSearchLazyQuery>;
export type QueueFilterTaskQueueSearchSuspenseQueryHookResult = ReturnType<typeof useQueueFilterTaskQueueSearchSuspenseQuery>;
export type QueueFilterTaskQueueSearchQueryResult = Apollo.QueryResult<QueueFilterTaskQueueSearchQuery, QueueFilterTaskQueueSearchQueryVariables>;
export const ScheduleTaskDashboardTaskSearchDocument = gql`
    query ScheduleTaskDashboardTaskSearch($input: TaskSearchInput!) {
  taskSearch(input: $input) {
    items {
      id
      ...TaskDashboardTable_task
    }
    hasNext
    nextOffset
  }
}
    ${TaskDashboardTable_TaskFragmentDoc}`;

/**
 * __useScheduleTaskDashboardTaskSearchQuery__
 *
 * To run a query within a React component, call `useScheduleTaskDashboardTaskSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskDashboardTaskSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTaskDashboardTaskSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleTaskDashboardTaskSearchQuery(baseOptions: Apollo.QueryHookOptions<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables> & ({ variables: ScheduleTaskDashboardTaskSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>(ScheduleTaskDashboardTaskSearchDocument, options);
      }
export function useScheduleTaskDashboardTaskSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>(ScheduleTaskDashboardTaskSearchDocument, options);
        }
// @ts-ignore
export function useScheduleTaskDashboardTaskSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>;
export function useScheduleTaskDashboardTaskSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskDashboardTaskSearchQuery | undefined, ScheduleTaskDashboardTaskSearchQueryVariables>;
export function useScheduleTaskDashboardTaskSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>(ScheduleTaskDashboardTaskSearchDocument, options);
        }
export type ScheduleTaskDashboardTaskSearchQueryHookResult = ReturnType<typeof useScheduleTaskDashboardTaskSearchQuery>;
export type ScheduleTaskDashboardTaskSearchLazyQueryHookResult = ReturnType<typeof useScheduleTaskDashboardTaskSearchLazyQuery>;
export type ScheduleTaskDashboardTaskSearchSuspenseQueryHookResult = ReturnType<typeof useScheduleTaskDashboardTaskSearchSuspenseQuery>;
export type ScheduleTaskDashboardTaskSearchQueryResult = Apollo.QueryResult<ScheduleTaskDashboardTaskSearchQuery, ScheduleTaskDashboardTaskSearchQueryVariables>;
export const MySchedulingTasksDocument = gql`
    query MySchedulingTasks($id: uuid!) {
  assignedToMe: taskSearch(
    input: {pageInput: {limit: 10}, assignees: {showUnassigned: false, assigneeIds: [$id]}, filterCompletedCanceled: true}
  ) {
    total
  }
  created: taskSearch(
    input: {pageInput: {limit: 10}, createdByIds: [$id], filterCompletedCanceled: true}
  ) {
    total
  }
  subscribed: taskSearch(
    input: {pageInput: {limit: 10}, subscribedByIds: [$id], filterCompletedCanceled: true}
  ) {
    total
  }
  myQueues: taskSearch(
    input: {pageInput: {limit: 10}, taskQueueMemberEmployeeIds: [$id], filterCompletedCanceled: true}
  ) {
    total
  }
}
    `;

/**
 * __useMySchedulingTasksQuery__
 *
 * To run a query within a React component, call `useMySchedulingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySchedulingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySchedulingTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMySchedulingTasksQuery(baseOptions: Apollo.QueryHookOptions<MySchedulingTasksQuery, MySchedulingTasksQueryVariables> & ({ variables: MySchedulingTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>(MySchedulingTasksDocument, options);
      }
export function useMySchedulingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>(MySchedulingTasksDocument, options);
        }
// @ts-ignore
export function useMySchedulingTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>): Apollo.UseSuspenseQueryResult<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>;
export function useMySchedulingTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>): Apollo.UseSuspenseQueryResult<MySchedulingTasksQuery | undefined, MySchedulingTasksQueryVariables>;
export function useMySchedulingTasksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>(MySchedulingTasksDocument, options);
        }
export type MySchedulingTasksQueryHookResult = ReturnType<typeof useMySchedulingTasksQuery>;
export type MySchedulingTasksLazyQueryHookResult = ReturnType<typeof useMySchedulingTasksLazyQuery>;
export type MySchedulingTasksSuspenseQueryHookResult = ReturnType<typeof useMySchedulingTasksSuspenseQuery>;
export type MySchedulingTasksQueryResult = Apollo.QueryResult<MySchedulingTasksQuery, MySchedulingTasksQueryVariables>;
export const ScheduleTaskDashboardFiltersEmployeePrefDocument = gql`
    query ScheduleTaskDashboardFiltersEmployeePref($prefName: String!) {
  thisEmployee {
    id
    employeePref(prefName: $prefName) {
      id
      jsonPref {
        ... on EmployeeTaskDashboardFilterPref {
          ...ScheduleTaskDashboardFiltersEmployeePref
        }
      }
    }
  }
}
    ${ScheduleTaskDashboardFiltersEmployeePrefFragmentDoc}`;

/**
 * __useScheduleTaskDashboardFiltersEmployeePrefQuery__
 *
 * To run a query within a React component, call `useScheduleTaskDashboardFiltersEmployeePrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskDashboardFiltersEmployeePrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTaskDashboardFiltersEmployeePrefQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useScheduleTaskDashboardFiltersEmployeePrefQuery(baseOptions: Apollo.QueryHookOptions<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables> & ({ variables: ScheduleTaskDashboardFiltersEmployeePrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>(ScheduleTaskDashboardFiltersEmployeePrefDocument, options);
      }
export function useScheduleTaskDashboardFiltersEmployeePrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>(ScheduleTaskDashboardFiltersEmployeePrefDocument, options);
        }
// @ts-ignore
export function useScheduleTaskDashboardFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>;
export function useScheduleTaskDashboardFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskDashboardFiltersEmployeePrefQuery | undefined, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>;
export function useScheduleTaskDashboardFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>(ScheduleTaskDashboardFiltersEmployeePrefDocument, options);
        }
export type ScheduleTaskDashboardFiltersEmployeePrefQueryHookResult = ReturnType<typeof useScheduleTaskDashboardFiltersEmployeePrefQuery>;
export type ScheduleTaskDashboardFiltersEmployeePrefLazyQueryHookResult = ReturnType<typeof useScheduleTaskDashboardFiltersEmployeePrefLazyQuery>;
export type ScheduleTaskDashboardFiltersEmployeePrefSuspenseQueryHookResult = ReturnType<typeof useScheduleTaskDashboardFiltersEmployeePrefSuspenseQuery>;
export type ScheduleTaskDashboardFiltersEmployeePrefQueryResult = Apollo.QueryResult<ScheduleTaskDashboardFiltersEmployeePrefQuery, ScheduleTaskDashboardFiltersEmployeePrefQueryVariables>;
export const UpdateScheduleTaskDashboardFiltersEmployeePrefDocument = gql`
    mutation updateScheduleTaskDashboardFiltersEmployeePref($input: EmployeePrefUpdateInput!) {
  employeePrefUpdate(input: $input) {
    employeePref {
      id
    }
  }
}
    `;
export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutationFn = Apollo.MutationFunction<UpdateScheduleTaskDashboardFiltersEmployeePrefMutation, UpdateScheduleTaskDashboardFiltersEmployeePrefMutationVariables>;

/**
 * __useUpdateScheduleTaskDashboardFiltersEmployeePrefMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleTaskDashboardFiltersEmployeePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleTaskDashboardFiltersEmployeePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleTaskDashboardFiltersEmployeePrefMutation, { data, loading, error }] = useUpdateScheduleTaskDashboardFiltersEmployeePrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduleTaskDashboardFiltersEmployeePrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleTaskDashboardFiltersEmployeePrefMutation, UpdateScheduleTaskDashboardFiltersEmployeePrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleTaskDashboardFiltersEmployeePrefMutation, UpdateScheduleTaskDashboardFiltersEmployeePrefMutationVariables>(UpdateScheduleTaskDashboardFiltersEmployeePrefDocument, options);
      }
export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutationHookResult = ReturnType<typeof useUpdateScheduleTaskDashboardFiltersEmployeePrefMutation>;
export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutationResult = Apollo.MutationResult<UpdateScheduleTaskDashboardFiltersEmployeePrefMutation>;
export type UpdateScheduleTaskDashboardFiltersEmployeePrefMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleTaskDashboardFiltersEmployeePrefMutation, UpdateScheduleTaskDashboardFiltersEmployeePrefMutationVariables>;
export const ScheduleTaskDashboardColumnsDocument = gql`
    query ScheduleTaskDashboardColumns($prefName: String!) {
  thisEmployee {
    id
    employeePref(prefName: $prefName) {
      id
      jsonArrayPref {
        ... on EmployeeTaskDashboardLayoutPref {
          columnType
          isVisible
          __typename
        }
        __typename
      }
    }
  }
}
    `;

/**
 * __useScheduleTaskDashboardColumnsQuery__
 *
 * To run a query within a React component, call `useScheduleTaskDashboardColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskDashboardColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTaskDashboardColumnsQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useScheduleTaskDashboardColumnsQuery(baseOptions: Apollo.QueryHookOptions<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables> & ({ variables: ScheduleTaskDashboardColumnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>(ScheduleTaskDashboardColumnsDocument, options);
      }
export function useScheduleTaskDashboardColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>(ScheduleTaskDashboardColumnsDocument, options);
        }
// @ts-ignore
export function useScheduleTaskDashboardColumnsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>;
export function useScheduleTaskDashboardColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskDashboardColumnsQuery | undefined, ScheduleTaskDashboardColumnsQueryVariables>;
export function useScheduleTaskDashboardColumnsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>(ScheduleTaskDashboardColumnsDocument, options);
        }
export type ScheduleTaskDashboardColumnsQueryHookResult = ReturnType<typeof useScheduleTaskDashboardColumnsQuery>;
export type ScheduleTaskDashboardColumnsLazyQueryHookResult = ReturnType<typeof useScheduleTaskDashboardColumnsLazyQuery>;
export type ScheduleTaskDashboardColumnsSuspenseQueryHookResult = ReturnType<typeof useScheduleTaskDashboardColumnsSuspenseQuery>;
export type ScheduleTaskDashboardColumnsQueryResult = Apollo.QueryResult<ScheduleTaskDashboardColumnsQuery, ScheduleTaskDashboardColumnsQueryVariables>;
export const SelfScheduleMeetingLocationZoomUserBySchedulerIdDocument = gql`
    query SelfScheduleMeetingLocationZoomUserBySchedulerId($schedulerId: uuid!) {
  zoomUsersByIds(input: {employeeIds: [$schedulerId]}) {
    zoomUserId
    employeeId
  }
}
    `;

/**
 * __useSelfScheduleMeetingLocationZoomUserBySchedulerIdQuery__
 *
 * To run a query within a React component, call `useSelfScheduleMeetingLocationZoomUserBySchedulerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleMeetingLocationZoomUserBySchedulerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleMeetingLocationZoomUserBySchedulerIdQuery({
 *   variables: {
 *      schedulerId: // value for 'schedulerId'
 *   },
 * });
 */
export function useSelfScheduleMeetingLocationZoomUserBySchedulerIdQuery(baseOptions: Apollo.QueryHookOptions<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables> & ({ variables: SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>(SelfScheduleMeetingLocationZoomUserBySchedulerIdDocument, options);
      }
export function useSelfScheduleMeetingLocationZoomUserBySchedulerIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>(SelfScheduleMeetingLocationZoomUserBySchedulerIdDocument, options);
        }
// @ts-ignore
export function useSelfScheduleMeetingLocationZoomUserBySchedulerIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>;
export function useSelfScheduleMeetingLocationZoomUserBySchedulerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery | undefined, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>;
export function useSelfScheduleMeetingLocationZoomUserBySchedulerIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>(SelfScheduleMeetingLocationZoomUserBySchedulerIdDocument, options);
        }
export type SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryHookResult = ReturnType<typeof useSelfScheduleMeetingLocationZoomUserBySchedulerIdQuery>;
export type SelfScheduleMeetingLocationZoomUserBySchedulerIdLazyQueryHookResult = ReturnType<typeof useSelfScheduleMeetingLocationZoomUserBySchedulerIdLazyQuery>;
export type SelfScheduleMeetingLocationZoomUserBySchedulerIdSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleMeetingLocationZoomUserBySchedulerIdSuspenseQuery>;
export type SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryResult = Apollo.QueryResult<SelfScheduleMeetingLocationZoomUserBySchedulerIdQuery, SelfScheduleMeetingLocationZoomUserBySchedulerIdQueryVariables>;
export const JobStageDocument = gql`
    query JobStage($id: uuid!) {
  jobStage(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useJobStageQuery__
 *
 * To run a query within a React component, call `useJobStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobStageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useJobStageQuery(baseOptions: Apollo.QueryHookOptions<JobStageQuery, JobStageQueryVariables> & ({ variables: JobStageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobStageQuery, JobStageQueryVariables>(JobStageDocument, options);
      }
export function useJobStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobStageQuery, JobStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobStageQuery, JobStageQueryVariables>(JobStageDocument, options);
        }
// @ts-ignore
export function useJobStageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<JobStageQuery, JobStageQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageQuery, JobStageQueryVariables>;
export function useJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageQuery, JobStageQueryVariables>): Apollo.UseSuspenseQueryResult<JobStageQuery | undefined, JobStageQueryVariables>;
export function useJobStageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobStageQuery, JobStageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobStageQuery, JobStageQueryVariables>(JobStageDocument, options);
        }
export type JobStageQueryHookResult = ReturnType<typeof useJobStageQuery>;
export type JobStageLazyQueryHookResult = ReturnType<typeof useJobStageLazyQuery>;
export type JobStageSuspenseQueryHookResult = ReturnType<typeof useJobStageSuspenseQuery>;
export type JobStageQueryResult = Apollo.QueryResult<JobStageQuery, JobStageQueryVariables>;
export const CandidateSelfScheduleEmailDocument = gql`
    query CandidateSelfScheduleEmail($candidateId: uuid!) {
  candidate(id: $candidateId) {
    email
  }
}
    `;

/**
 * __useCandidateSelfScheduleEmailQuery__
 *
 * To run a query within a React component, call `useCandidateSelfScheduleEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateSelfScheduleEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateSelfScheduleEmailQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useCandidateSelfScheduleEmailQuery(baseOptions: Apollo.QueryHookOptions<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables> & ({ variables: CandidateSelfScheduleEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>(CandidateSelfScheduleEmailDocument, options);
      }
export function useCandidateSelfScheduleEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>(CandidateSelfScheduleEmailDocument, options);
        }
// @ts-ignore
export function useCandidateSelfScheduleEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>;
export function useCandidateSelfScheduleEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>): Apollo.UseSuspenseQueryResult<CandidateSelfScheduleEmailQuery | undefined, CandidateSelfScheduleEmailQueryVariables>;
export function useCandidateSelfScheduleEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>(CandidateSelfScheduleEmailDocument, options);
        }
export type CandidateSelfScheduleEmailQueryHookResult = ReturnType<typeof useCandidateSelfScheduleEmailQuery>;
export type CandidateSelfScheduleEmailLazyQueryHookResult = ReturnType<typeof useCandidateSelfScheduleEmailLazyQuery>;
export type CandidateSelfScheduleEmailSuspenseQueryHookResult = ReturnType<typeof useCandidateSelfScheduleEmailSuspenseQuery>;
export type CandidateSelfScheduleEmailQueryResult = Apollo.QueryResult<CandidateSelfScheduleEmailQuery, CandidateSelfScheduleEmailQueryVariables>;
export const SelfScheduleOptionsModalDocument = gql`
    query SelfScheduleOptionsModal($applicationId: uuid!, $zoomUserEmployeeIds: [uuid!]!) {
  application(id: $applicationId) {
    id
    ...CreateTaskDialogPage_application
  }
  zoomUsersByIds(input: {employeeIds: $zoomUserEmployeeIds}) {
    zoomUserId
    employeeId
  }
}
    ${CreateTaskDialogPage_ApplicationFragmentDoc}`;

/**
 * __useSelfScheduleOptionsModalQuery__
 *
 * To run a query within a React component, call `useSelfScheduleOptionsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleOptionsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleOptionsModalQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      zoomUserEmployeeIds: // value for 'zoomUserEmployeeIds'
 *   },
 * });
 */
export function useSelfScheduleOptionsModalQuery(baseOptions: Apollo.QueryHookOptions<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables> & ({ variables: SelfScheduleOptionsModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>(SelfScheduleOptionsModalDocument, options);
      }
export function useSelfScheduleOptionsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>(SelfScheduleOptionsModalDocument, options);
        }
// @ts-ignore
export function useSelfScheduleOptionsModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>;
export function useSelfScheduleOptionsModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleOptionsModalQuery | undefined, SelfScheduleOptionsModalQueryVariables>;
export function useSelfScheduleOptionsModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>(SelfScheduleOptionsModalDocument, options);
        }
export type SelfScheduleOptionsModalQueryHookResult = ReturnType<typeof useSelfScheduleOptionsModalQuery>;
export type SelfScheduleOptionsModalLazyQueryHookResult = ReturnType<typeof useSelfScheduleOptionsModalLazyQuery>;
export type SelfScheduleOptionsModalSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleOptionsModalSuspenseQuery>;
export type SelfScheduleOptionsModalQueryResult = Apollo.QueryResult<SelfScheduleOptionsModalQuery, SelfScheduleOptionsModalQueryVariables>;
export const SelfScheduleCalendarsDocument = gql`
    query SelfScheduleCalendars($input: InitScheduleFlowInput!) {
  initScheduleFlow(input: $input) {
    candidateCalendar {
      remoteId
    }
    interviewerCalendar {
      remoteId
    }
  }
}
    `;

/**
 * __useSelfScheduleCalendarsQuery__
 *
 * To run a query within a React component, call `useSelfScheduleCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleCalendarsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfScheduleCalendarsQuery(baseOptions: Apollo.QueryHookOptions<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables> & ({ variables: SelfScheduleCalendarsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>(SelfScheduleCalendarsDocument, options);
      }
export function useSelfScheduleCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>(SelfScheduleCalendarsDocument, options);
        }
// @ts-ignore
export function useSelfScheduleCalendarsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>;
export function useSelfScheduleCalendarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleCalendarsQuery | undefined, SelfScheduleCalendarsQueryVariables>;
export function useSelfScheduleCalendarsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>(SelfScheduleCalendarsDocument, options);
        }
export type SelfScheduleCalendarsQueryHookResult = ReturnType<typeof useSelfScheduleCalendarsQuery>;
export type SelfScheduleCalendarsLazyQueryHookResult = ReturnType<typeof useSelfScheduleCalendarsLazyQuery>;
export type SelfScheduleCalendarsSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleCalendarsSuspenseQuery>;
export type SelfScheduleCalendarsQueryResult = Apollo.QueryResult<SelfScheduleCalendarsQuery, SelfScheduleCalendarsQueryVariables>;
export const SelfScheduleOptionsInterviewPlanDocument = gql`
    query SelfScheduleOptionsInterviewPlan($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    id
    ...CreateTaskDialogPage_interviewPlan
    ...cloneInterviewPlan_interviewPlan
    ...getSaveInterviewPlanInput_interviewPlan
    ...SelfScheduleOptions_interviewPlan
  }
}
    ${CreateTaskDialogPage_InterviewPlanFragmentDoc}
${CloneInterviewPlan_InterviewPlanFragmentDoc}
${GetSaveInterviewPlanInput_InterviewPlanFragmentDoc}
${SelfScheduleOptions_InterviewPlanFragmentDoc}`;

/**
 * __useSelfScheduleOptionsInterviewPlanQuery__
 *
 * To run a query within a React component, call `useSelfScheduleOptionsInterviewPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleOptionsInterviewPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleOptionsInterviewPlanQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useSelfScheduleOptionsInterviewPlanQuery(baseOptions: Apollo.QueryHookOptions<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables> & ({ variables: SelfScheduleOptionsInterviewPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>(SelfScheduleOptionsInterviewPlanDocument, options);
      }
export function useSelfScheduleOptionsInterviewPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>(SelfScheduleOptionsInterviewPlanDocument, options);
        }
// @ts-ignore
export function useSelfScheduleOptionsInterviewPlanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>;
export function useSelfScheduleOptionsInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleOptionsInterviewPlanQuery | undefined, SelfScheduleOptionsInterviewPlanQueryVariables>;
export function useSelfScheduleOptionsInterviewPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>(SelfScheduleOptionsInterviewPlanDocument, options);
        }
export type SelfScheduleOptionsInterviewPlanQueryHookResult = ReturnType<typeof useSelfScheduleOptionsInterviewPlanQuery>;
export type SelfScheduleOptionsInterviewPlanLazyQueryHookResult = ReturnType<typeof useSelfScheduleOptionsInterviewPlanLazyQuery>;
export type SelfScheduleOptionsInterviewPlanSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleOptionsInterviewPlanSuspenseQuery>;
export type SelfScheduleOptionsInterviewPlanQueryResult = Apollo.QueryResult<SelfScheduleOptionsInterviewPlanQuery, SelfScheduleOptionsInterviewPlanQueryVariables>;
export const SelfScheduleOptionsUpsertDocument = gql`
    mutation SelfScheduleOptionsUpsert($input: SelfScheduleOptionsUpsertInput!) {
  selfScheduleOptionsUpsert(input: $input) {
    ...SelfScheduleOptionsModal_selfSchedule
  }
}
    ${SelfScheduleOptionsModal_SelfScheduleFragmentDoc}`;
export type SelfScheduleOptionsUpsertMutationFn = Apollo.MutationFunction<SelfScheduleOptionsUpsertMutation, SelfScheduleOptionsUpsertMutationVariables>;

/**
 * __useSelfScheduleOptionsUpsertMutation__
 *
 * To run a mutation, you first call `useSelfScheduleOptionsUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleOptionsUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfScheduleOptionsUpsertMutation, { data, loading, error }] = useSelfScheduleOptionsUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfScheduleOptionsUpsertMutation(baseOptions?: Apollo.MutationHookOptions<SelfScheduleOptionsUpsertMutation, SelfScheduleOptionsUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfScheduleOptionsUpsertMutation, SelfScheduleOptionsUpsertMutationVariables>(SelfScheduleOptionsUpsertDocument, options);
      }
export type SelfScheduleOptionsUpsertMutationHookResult = ReturnType<typeof useSelfScheduleOptionsUpsertMutation>;
export type SelfScheduleOptionsUpsertMutationResult = Apollo.MutationResult<SelfScheduleOptionsUpsertMutation>;
export type SelfScheduleOptionsUpsertMutationOptions = Apollo.BaseMutationOptions<SelfScheduleOptionsUpsertMutation, SelfScheduleOptionsUpsertMutationVariables>;
export const SuggestedTimeRangesCountDocument = gql`
    query SuggestedTimeRangesCount($input: SuggestedTimeRangesCountInput!) {
  suggestedTimeRangesCount(input: $input) {
    timeRangeCounts {
      range {
        startAt
        endAt
      }
      count
    }
    employeeMissingZoomUserId
  }
}
    `;

/**
 * __useSuggestedTimeRangesCountQuery__
 *
 * To run a query within a React component, call `useSuggestedTimeRangesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedTimeRangesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedTimeRangesCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestedTimeRangesCountQuery(baseOptions: Apollo.QueryHookOptions<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables> & ({ variables: SuggestedTimeRangesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>(SuggestedTimeRangesCountDocument, options);
      }
export function useSuggestedTimeRangesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>(SuggestedTimeRangesCountDocument, options);
        }
// @ts-ignore
export function useSuggestedTimeRangesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>;
export function useSuggestedTimeRangesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestedTimeRangesCountQuery | undefined, SuggestedTimeRangesCountQueryVariables>;
export function useSuggestedTimeRangesCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>(SuggestedTimeRangesCountDocument, options);
        }
export type SuggestedTimeRangesCountQueryHookResult = ReturnType<typeof useSuggestedTimeRangesCountQuery>;
export type SuggestedTimeRangesCountLazyQueryHookResult = ReturnType<typeof useSuggestedTimeRangesCountLazyQuery>;
export type SuggestedTimeRangesCountSuspenseQueryHookResult = ReturnType<typeof useSuggestedTimeRangesCountSuspenseQuery>;
export type SuggestedTimeRangesCountQueryResult = Apollo.QueryResult<SuggestedTimeRangesCountQuery, SuggestedTimeRangesCountQueryVariables>;
export const SelfScheduleTemplatesDocument = gql`
    query SelfScheduleTemplates($jobStageId: uuid!) {
  jobStage(id: $jobStageId) {
    jobStageSettingsV2 {
      interviewerEventTemplateId {
        templateId
      }
      candidateEventTemplateId {
        templateId
      }
      candidateEmailTemplateId {
        templateId
      }
    }
  }
}
    `;

/**
 * __useSelfScheduleTemplatesQuery__
 *
 * To run a query within a React component, call `useSelfScheduleTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleTemplatesQuery({
 *   variables: {
 *      jobStageId: // value for 'jobStageId'
 *   },
 * });
 */
export function useSelfScheduleTemplatesQuery(baseOptions: Apollo.QueryHookOptions<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables> & ({ variables: SelfScheduleTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>(SelfScheduleTemplatesDocument, options);
      }
export function useSelfScheduleTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>(SelfScheduleTemplatesDocument, options);
        }
// @ts-ignore
export function useSelfScheduleTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>;
export function useSelfScheduleTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleTemplatesQuery | undefined, SelfScheduleTemplatesQueryVariables>;
export function useSelfScheduleTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>(SelfScheduleTemplatesDocument, options);
        }
export type SelfScheduleTemplatesQueryHookResult = ReturnType<typeof useSelfScheduleTemplatesQuery>;
export type SelfScheduleTemplatesLazyQueryHookResult = ReturnType<typeof useSelfScheduleTemplatesLazyQuery>;
export type SelfScheduleTemplatesSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleTemplatesSuspenseQuery>;
export type SelfScheduleTemplatesQueryResult = Apollo.QueryResult<SelfScheduleTemplatesQuery, SelfScheduleTemplatesQueryVariables>;
export const SelfScheduleOptionsDeleteDocument = gql`
    mutation SelfScheduleOptionsDelete($id: uuid!) {
  selfScheduleOptionsDelete(id: $id) {
    id
  }
}
    `;
export type SelfScheduleOptionsDeleteMutationFn = Apollo.MutationFunction<SelfScheduleOptionsDeleteMutation, SelfScheduleOptionsDeleteMutationVariables>;

/**
 * __useSelfScheduleOptionsDeleteMutation__
 *
 * To run a mutation, you first call `useSelfScheduleOptionsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleOptionsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfScheduleOptionsDeleteMutation, { data, loading, error }] = useSelfScheduleOptionsDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSelfScheduleOptionsDeleteMutation(baseOptions?: Apollo.MutationHookOptions<SelfScheduleOptionsDeleteMutation, SelfScheduleOptionsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfScheduleOptionsDeleteMutation, SelfScheduleOptionsDeleteMutationVariables>(SelfScheduleOptionsDeleteDocument, options);
      }
export type SelfScheduleOptionsDeleteMutationHookResult = ReturnType<typeof useSelfScheduleOptionsDeleteMutation>;
export type SelfScheduleOptionsDeleteMutationResult = Apollo.MutationResult<SelfScheduleOptionsDeleteMutation>;
export type SelfScheduleOptionsDeleteMutationOptions = Apollo.BaseMutationOptions<SelfScheduleOptionsDeleteMutation, SelfScheduleOptionsDeleteMutationVariables>;
export const SelfScheduleTaskCreateDocument = gql`
    mutation SelfScheduleTaskCreate($input: TaskCreateInput!) {
  taskCreate(input: $input) {
    task {
      id
    }
  }
}
    `;
export type SelfScheduleTaskCreateMutationFn = Apollo.MutationFunction<SelfScheduleTaskCreateMutation, SelfScheduleTaskCreateMutationVariables>;

/**
 * __useSelfScheduleTaskCreateMutation__
 *
 * To run a mutation, you first call `useSelfScheduleTaskCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleTaskCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfScheduleTaskCreateMutation, { data, loading, error }] = useSelfScheduleTaskCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfScheduleTaskCreateMutation(baseOptions?: Apollo.MutationHookOptions<SelfScheduleTaskCreateMutation, SelfScheduleTaskCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfScheduleTaskCreateMutation, SelfScheduleTaskCreateMutationVariables>(SelfScheduleTaskCreateDocument, options);
      }
export type SelfScheduleTaskCreateMutationHookResult = ReturnType<typeof useSelfScheduleTaskCreateMutation>;
export type SelfScheduleTaskCreateMutationResult = Apollo.MutationResult<SelfScheduleTaskCreateMutation>;
export type SelfScheduleTaskCreateMutationOptions = Apollo.BaseMutationOptions<SelfScheduleTaskCreateMutation, SelfScheduleTaskCreateMutationVariables>;
export const OrgAiContextSectionDocument = gql`
    query OrgAiContextSection {
  thisOrg {
    id
    aiInstruction {
      ...AiInstructionsCard_instruction
    }
    aiMemories {
      ...AiMemoriesCard_memory
    }
  }
}
    ${AiInstructionsCard_InstructionFragmentDoc}
${AiMemoriesCard_MemoryFragmentDoc}`;

/**
 * __useOrgAiContextSectionQuery__
 *
 * To run a query within a React component, call `useOrgAiContextSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgAiContextSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgAiContextSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgAiContextSectionQuery(baseOptions?: Apollo.QueryHookOptions<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>(OrgAiContextSectionDocument, options);
      }
export function useOrgAiContextSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>(OrgAiContextSectionDocument, options);
        }
// @ts-ignore
export function useOrgAiContextSectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>): Apollo.UseSuspenseQueryResult<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>;
export function useOrgAiContextSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>): Apollo.UseSuspenseQueryResult<OrgAiContextSectionQuery | undefined, OrgAiContextSectionQueryVariables>;
export function useOrgAiContextSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>(OrgAiContextSectionDocument, options);
        }
export type OrgAiContextSectionQueryHookResult = ReturnType<typeof useOrgAiContextSectionQuery>;
export type OrgAiContextSectionLazyQueryHookResult = ReturnType<typeof useOrgAiContextSectionLazyQuery>;
export type OrgAiContextSectionSuspenseQueryHookResult = ReturnType<typeof useOrgAiContextSectionSuspenseQuery>;
export type OrgAiContextSectionQueryResult = Apollo.QueryResult<OrgAiContextSectionQuery, OrgAiContextSectionQueryVariables>;
export const SettingsAiAgentIntegrationsDocument = gql`
    query SettingsAiAgentIntegrations {
  aiAgentIntegrations {
    __typename
    ... on AiAgentIntegrations {
      agentEmployeeId
      agentEmail
      google {
        provider
        installed
        connected
        accountEmail
      }
      microsoft {
        provider
        installed
        connected
        accountEmail
      }
    }
    ... on AiAgentEmailNotConfiguredError {
      errorCode
      errorMessage
    }
    ... on AiAgentEmployeeNotFoundError {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;

/**
 * __useSettingsAiAgentIntegrationsQuery__
 *
 * To run a query within a React component, call `useSettingsAiAgentIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsAiAgentIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsAiAgentIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSettingsAiAgentIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>(SettingsAiAgentIntegrationsDocument, options);
      }
export function useSettingsAiAgentIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>(SettingsAiAgentIntegrationsDocument, options);
        }
// @ts-ignore
export function useSettingsAiAgentIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>;
export function useSettingsAiAgentIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<SettingsAiAgentIntegrationsQuery | undefined, SettingsAiAgentIntegrationsQueryVariables>;
export function useSettingsAiAgentIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>(SettingsAiAgentIntegrationsDocument, options);
        }
export type SettingsAiAgentIntegrationsQueryHookResult = ReturnType<typeof useSettingsAiAgentIntegrationsQuery>;
export type SettingsAiAgentIntegrationsLazyQueryHookResult = ReturnType<typeof useSettingsAiAgentIntegrationsLazyQuery>;
export type SettingsAiAgentIntegrationsSuspenseQueryHookResult = ReturnType<typeof useSettingsAiAgentIntegrationsSuspenseQuery>;
export type SettingsAiAgentIntegrationsQueryResult = Apollo.QueryResult<SettingsAiAgentIntegrationsQuery, SettingsAiAgentIntegrationsQueryVariables>;
export const SettingsAiAgentIntegrationConnectDocument = gql`
    mutation SettingsAiAgentIntegrationConnect($input: AiAgentIntegrationConnectInput!) {
  aiAgentIntegrationConnect(input: $input) {
    __typename
    ... on AiAgentIntegrationConnectSuccess {
      url
      redirectUri
    }
    ... on AiAgentEmailNotConfiguredError {
      errorCode
      errorMessage
    }
    ... on AiAgentEmployeeNotFoundError {
      errorCode
      errorMessage
    }
    ... on AiAgentIntegrationProviderNotInstalledError {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type SettingsAiAgentIntegrationConnectMutationFn = Apollo.MutationFunction<SettingsAiAgentIntegrationConnectMutation, SettingsAiAgentIntegrationConnectMutationVariables>;

/**
 * __useSettingsAiAgentIntegrationConnectMutation__
 *
 * To run a mutation, you first call `useSettingsAiAgentIntegrationConnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsAiAgentIntegrationConnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsAiAgentIntegrationConnectMutation, { data, loading, error }] = useSettingsAiAgentIntegrationConnectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsAiAgentIntegrationConnectMutation(baseOptions?: Apollo.MutationHookOptions<SettingsAiAgentIntegrationConnectMutation, SettingsAiAgentIntegrationConnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsAiAgentIntegrationConnectMutation, SettingsAiAgentIntegrationConnectMutationVariables>(SettingsAiAgentIntegrationConnectDocument, options);
      }
export type SettingsAiAgentIntegrationConnectMutationHookResult = ReturnType<typeof useSettingsAiAgentIntegrationConnectMutation>;
export type SettingsAiAgentIntegrationConnectMutationResult = Apollo.MutationResult<SettingsAiAgentIntegrationConnectMutation>;
export type SettingsAiAgentIntegrationConnectMutationOptions = Apollo.BaseMutationOptions<SettingsAiAgentIntegrationConnectMutation, SettingsAiAgentIntegrationConnectMutationVariables>;
export const SettingsAiAgentIntegrationDisconnectDocument = gql`
    mutation SettingsAiAgentIntegrationDisconnect($input: AiAgentIntegrationDisconnectInput!) {
  aiAgentIntegrationDisconnect(input: $input) {
    __typename
    ... on AiAgentIntegrationDisconnectSuccess {
      provider
    }
    ... on AiAgentEmailNotConfiguredError {
      errorCode
      errorMessage
    }
    ... on AiAgentEmployeeNotFoundError {
      errorCode
      errorMessage
    }
    ... on AiAgentIntegrationProviderNotInstalledError {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type SettingsAiAgentIntegrationDisconnectMutationFn = Apollo.MutationFunction<SettingsAiAgentIntegrationDisconnectMutation, SettingsAiAgentIntegrationDisconnectMutationVariables>;

/**
 * __useSettingsAiAgentIntegrationDisconnectMutation__
 *
 * To run a mutation, you first call `useSettingsAiAgentIntegrationDisconnectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsAiAgentIntegrationDisconnectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsAiAgentIntegrationDisconnectMutation, { data, loading, error }] = useSettingsAiAgentIntegrationDisconnectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsAiAgentIntegrationDisconnectMutation(baseOptions?: Apollo.MutationHookOptions<SettingsAiAgentIntegrationDisconnectMutation, SettingsAiAgentIntegrationDisconnectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsAiAgentIntegrationDisconnectMutation, SettingsAiAgentIntegrationDisconnectMutationVariables>(SettingsAiAgentIntegrationDisconnectDocument, options);
      }
export type SettingsAiAgentIntegrationDisconnectMutationHookResult = ReturnType<typeof useSettingsAiAgentIntegrationDisconnectMutation>;
export type SettingsAiAgentIntegrationDisconnectMutationResult = Apollo.MutationResult<SettingsAiAgentIntegrationDisconnectMutation>;
export type SettingsAiAgentIntegrationDisconnectMutationOptions = Apollo.BaseMutationOptions<SettingsAiAgentIntegrationDisconnectMutation, SettingsAiAgentIntegrationDisconnectMutationVariables>;
export const SettingsExternalApiTokensDocument = gql`
    query SettingsExternalApiTokens($input: ExternalApiTokensInput!) {
  externalApiTokens(input: $input) {
    tokenId
    employeeId
    employee {
      id
      fullName
      email
    }
    name
    tokenPrefix
    scopes
    createdAt
    expiresAt
    lastUsedAt
    revokedAt
  }
}
    `;

/**
 * __useSettingsExternalApiTokensQuery__
 *
 * To run a query within a React component, call `useSettingsExternalApiTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsExternalApiTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsExternalApiTokensQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsExternalApiTokensQuery(baseOptions: Apollo.QueryHookOptions<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables> & ({ variables: SettingsExternalApiTokensQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>(SettingsExternalApiTokensDocument, options);
      }
export function useSettingsExternalApiTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>(SettingsExternalApiTokensDocument, options);
        }
// @ts-ignore
export function useSettingsExternalApiTokensSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>): Apollo.UseSuspenseQueryResult<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>;
export function useSettingsExternalApiTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>): Apollo.UseSuspenseQueryResult<SettingsExternalApiTokensQuery | undefined, SettingsExternalApiTokensQueryVariables>;
export function useSettingsExternalApiTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>(SettingsExternalApiTokensDocument, options);
        }
export type SettingsExternalApiTokensQueryHookResult = ReturnType<typeof useSettingsExternalApiTokensQuery>;
export type SettingsExternalApiTokensLazyQueryHookResult = ReturnType<typeof useSettingsExternalApiTokensLazyQuery>;
export type SettingsExternalApiTokensSuspenseQueryHookResult = ReturnType<typeof useSettingsExternalApiTokensSuspenseQuery>;
export type SettingsExternalApiTokensQueryResult = Apollo.QueryResult<SettingsExternalApiTokensQuery, SettingsExternalApiTokensQueryVariables>;
export const SettingsCreateExternalApiTokenDocument = gql`
    mutation SettingsCreateExternalApiToken($input: CreateExternalApiTokenInput!) {
  createExternalApiToken(input: $input) {
    token
    tokenId
    tokenPrefix
  }
}
    `;
export type SettingsCreateExternalApiTokenMutationFn = Apollo.MutationFunction<SettingsCreateExternalApiTokenMutation, SettingsCreateExternalApiTokenMutationVariables>;

/**
 * __useSettingsCreateExternalApiTokenMutation__
 *
 * To run a mutation, you first call `useSettingsCreateExternalApiTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsCreateExternalApiTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsCreateExternalApiTokenMutation, { data, loading, error }] = useSettingsCreateExternalApiTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsCreateExternalApiTokenMutation(baseOptions?: Apollo.MutationHookOptions<SettingsCreateExternalApiTokenMutation, SettingsCreateExternalApiTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsCreateExternalApiTokenMutation, SettingsCreateExternalApiTokenMutationVariables>(SettingsCreateExternalApiTokenDocument, options);
      }
export type SettingsCreateExternalApiTokenMutationHookResult = ReturnType<typeof useSettingsCreateExternalApiTokenMutation>;
export type SettingsCreateExternalApiTokenMutationResult = Apollo.MutationResult<SettingsCreateExternalApiTokenMutation>;
export type SettingsCreateExternalApiTokenMutationOptions = Apollo.BaseMutationOptions<SettingsCreateExternalApiTokenMutation, SettingsCreateExternalApiTokenMutationVariables>;
export const SettingsExternalApiKeyRevokeDocument = gql`
    mutation SettingsExternalApiKeyRevoke($input: ExternalApiKeyRevokeInput!) {
  externalApiKeyRevoke(input: $input) {
    __typename
    ... on ExternalApiKeyRevokeSuccess {
      tokenId
    }
    ... on ExternalApiKeyRevokeFailureAlreadyRevoked {
      errorCode
      errorMessage
    }
    ... on ExternalApiKeyRevokeFailureNotFound {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type SettingsExternalApiKeyRevokeMutationFn = Apollo.MutationFunction<SettingsExternalApiKeyRevokeMutation, SettingsExternalApiKeyRevokeMutationVariables>;

/**
 * __useSettingsExternalApiKeyRevokeMutation__
 *
 * To run a mutation, you first call `useSettingsExternalApiKeyRevokeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsExternalApiKeyRevokeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsExternalApiKeyRevokeMutation, { data, loading, error }] = useSettingsExternalApiKeyRevokeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsExternalApiKeyRevokeMutation(baseOptions?: Apollo.MutationHookOptions<SettingsExternalApiKeyRevokeMutation, SettingsExternalApiKeyRevokeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsExternalApiKeyRevokeMutation, SettingsExternalApiKeyRevokeMutationVariables>(SettingsExternalApiKeyRevokeDocument, options);
      }
export type SettingsExternalApiKeyRevokeMutationHookResult = ReturnType<typeof useSettingsExternalApiKeyRevokeMutation>;
export type SettingsExternalApiKeyRevokeMutationResult = Apollo.MutationResult<SettingsExternalApiKeyRevokeMutation>;
export type SettingsExternalApiKeyRevokeMutationOptions = Apollo.BaseMutationOptions<SettingsExternalApiKeyRevokeMutation, SettingsExternalApiKeyRevokeMutationVariables>;
export const AutomationRulesDocument = gql`
    query AutomationRules {
  portalConfigAutomationRules {
    rules {
      id
      portalConfigId
      portalConfig {
        id
        name
      }
      index
      criteria {
        field
        operator
        value
      }
    }
  }
}
    `;

/**
 * __useAutomationRulesQuery__
 *
 * To run a query within a React component, call `useAutomationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutomationRulesQuery(baseOptions?: Apollo.QueryHookOptions<AutomationRulesQuery, AutomationRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationRulesQuery, AutomationRulesQueryVariables>(AutomationRulesDocument, options);
      }
export function useAutomationRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationRulesQuery, AutomationRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationRulesQuery, AutomationRulesQueryVariables>(AutomationRulesDocument, options);
        }
// @ts-ignore
export function useAutomationRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutomationRulesQuery, AutomationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationRulesQuery, AutomationRulesQueryVariables>;
export function useAutomationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationRulesQuery, AutomationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationRulesQuery | undefined, AutomationRulesQueryVariables>;
export function useAutomationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationRulesQuery, AutomationRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationRulesQuery, AutomationRulesQueryVariables>(AutomationRulesDocument, options);
        }
export type AutomationRulesQueryHookResult = ReturnType<typeof useAutomationRulesQuery>;
export type AutomationRulesLazyQueryHookResult = ReturnType<typeof useAutomationRulesLazyQuery>;
export type AutomationRulesSuspenseQueryHookResult = ReturnType<typeof useAutomationRulesSuspenseQuery>;
export type AutomationRulesQueryResult = Apollo.QueryResult<AutomationRulesQuery, AutomationRulesQueryVariables>;
export const AutomationSaveDocument = gql`
    mutation AutomationSave($input: PortalConfigAutomationSaveInput!) {
  portalConfigAutomationSave(input: $input) {
    rules {
      id
      portalConfigId
      portalConfig {
        id
        name
      }
      index
      criteria {
        field
        operator
        value
      }
    }
  }
}
    `;
export type AutomationSaveMutationFn = Apollo.MutationFunction<AutomationSaveMutation, AutomationSaveMutationVariables>;

/**
 * __useAutomationSaveMutation__
 *
 * To run a mutation, you first call `useAutomationSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutomationSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [automationSaveMutation, { data, loading, error }] = useAutomationSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutomationSaveMutation(baseOptions?: Apollo.MutationHookOptions<AutomationSaveMutation, AutomationSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutomationSaveMutation, AutomationSaveMutationVariables>(AutomationSaveDocument, options);
      }
export type AutomationSaveMutationHookResult = ReturnType<typeof useAutomationSaveMutation>;
export type AutomationSaveMutationResult = Apollo.MutationResult<AutomationSaveMutation>;
export type AutomationSaveMutationOptions = Apollo.BaseMutationOptions<AutomationSaveMutation, AutomationSaveMutationVariables>;
export const AutomationPortalConfigsDocument = gql`
    query AutomationPortalConfigs {
  portalConfigs {
    items {
      id
      name
      isDefault
    }
  }
}
    `;

/**
 * __useAutomationPortalConfigsQuery__
 *
 * To run a query within a React component, call `useAutomationPortalConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationPortalConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationPortalConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutomationPortalConfigsQuery(baseOptions?: Apollo.QueryHookOptions<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>(AutomationPortalConfigsDocument, options);
      }
export function useAutomationPortalConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>(AutomationPortalConfigsDocument, options);
        }
// @ts-ignore
export function useAutomationPortalConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>;
export function useAutomationPortalConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationPortalConfigsQuery | undefined, AutomationPortalConfigsQueryVariables>;
export function useAutomationPortalConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>(AutomationPortalConfigsDocument, options);
        }
export type AutomationPortalConfigsQueryHookResult = ReturnType<typeof useAutomationPortalConfigsQuery>;
export type AutomationPortalConfigsLazyQueryHookResult = ReturnType<typeof useAutomationPortalConfigsLazyQuery>;
export type AutomationPortalConfigsSuspenseQueryHookResult = ReturnType<typeof useAutomationPortalConfigsSuspenseQuery>;
export type AutomationPortalConfigsQueryResult = Apollo.QueryResult<AutomationPortalConfigsQuery, AutomationPortalConfigsQueryVariables>;
export const AutomationRuleApplyDocument = gql`
    mutation AutomationRuleApply($id: uuid!) {
  portalConfigAutomationRuleApply(id: $id) {
    linkedJobCount
  }
}
    `;
export type AutomationRuleApplyMutationFn = Apollo.MutationFunction<AutomationRuleApplyMutation, AutomationRuleApplyMutationVariables>;

/**
 * __useAutomationRuleApplyMutation__
 *
 * To run a mutation, you first call `useAutomationRuleApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutomationRuleApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [automationRuleApplyMutation, { data, loading, error }] = useAutomationRuleApplyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAutomationRuleApplyMutation(baseOptions?: Apollo.MutationHookOptions<AutomationRuleApplyMutation, AutomationRuleApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutomationRuleApplyMutation, AutomationRuleApplyMutationVariables>(AutomationRuleApplyDocument, options);
      }
export type AutomationRuleApplyMutationHookResult = ReturnType<typeof useAutomationRuleApplyMutation>;
export type AutomationRuleApplyMutationResult = Apollo.MutationResult<AutomationRuleApplyMutation>;
export type AutomationRuleApplyMutationOptions = Apollo.BaseMutationOptions<AutomationRuleApplyMutation, AutomationRuleApplyMutationVariables>;
export const AutomationJobLocationsDocument = gql`
    query AutomationJobLocations {
  automationJobLocations {
    items
  }
}
    `;

/**
 * __useAutomationJobLocationsQuery__
 *
 * To run a query within a React component, call `useAutomationJobLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationJobLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationJobLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutomationJobLocationsQuery(baseOptions?: Apollo.QueryHookOptions<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>(AutomationJobLocationsDocument, options);
      }
export function useAutomationJobLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>(AutomationJobLocationsDocument, options);
        }
// @ts-ignore
export function useAutomationJobLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>;
export function useAutomationJobLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationJobLocationsQuery | undefined, AutomationJobLocationsQueryVariables>;
export function useAutomationJobLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>(AutomationJobLocationsDocument, options);
        }
export type AutomationJobLocationsQueryHookResult = ReturnType<typeof useAutomationJobLocationsQuery>;
export type AutomationJobLocationsLazyQueryHookResult = ReturnType<typeof useAutomationJobLocationsLazyQuery>;
export type AutomationJobLocationsSuspenseQueryHookResult = ReturnType<typeof useAutomationJobLocationsSuspenseQuery>;
export type AutomationJobLocationsQueryResult = Apollo.QueryResult<AutomationJobLocationsQuery, AutomationJobLocationsQueryVariables>;
export const AutomationDepartmentsDocument = gql`
    query AutomationDepartments($input: AutomationDepartmentsInput!) {
  automationDepartments(input: $input) {
    items {
      id
      name
      parentId
    }
    nextCursor
  }
}
    `;

/**
 * __useAutomationDepartmentsQuery__
 *
 * To run a query within a React component, call `useAutomationDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationDepartmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutomationDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables> & ({ variables: AutomationDepartmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>(AutomationDepartmentsDocument, options);
      }
export function useAutomationDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>(AutomationDepartmentsDocument, options);
        }
// @ts-ignore
export function useAutomationDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>;
export function useAutomationDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<AutomationDepartmentsQuery | undefined, AutomationDepartmentsQueryVariables>;
export function useAutomationDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>(AutomationDepartmentsDocument, options);
        }
export type AutomationDepartmentsQueryHookResult = ReturnType<typeof useAutomationDepartmentsQuery>;
export type AutomationDepartmentsLazyQueryHookResult = ReturnType<typeof useAutomationDepartmentsLazyQuery>;
export type AutomationDepartmentsSuspenseQueryHookResult = ReturnType<typeof useAutomationDepartmentsSuspenseQuery>;
export type AutomationDepartmentsQueryResult = Apollo.QueryResult<AutomationDepartmentsQuery, AutomationDepartmentsQueryVariables>;
export const BrandingThemeBuilderCreateDocument = gql`
    mutation BrandingThemeBuilderCreate($input: BrandingThemeCreateInput!) {
  brandingThemeCreate(input: $input) {
    theme {
      ...BrandingThemeBuilderComponent_brandingTheme
    }
  }
}
    ${BrandingThemeBuilderComponent_BrandingThemeFragmentDoc}`;
export type BrandingThemeBuilderCreateMutationFn = Apollo.MutationFunction<BrandingThemeBuilderCreateMutation, BrandingThemeBuilderCreateMutationVariables>;

/**
 * __useBrandingThemeBuilderCreateMutation__
 *
 * To run a mutation, you first call `useBrandingThemeBuilderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandingThemeBuilderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandingThemeBuilderCreateMutation, { data, loading, error }] = useBrandingThemeBuilderCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandingThemeBuilderCreateMutation(baseOptions?: Apollo.MutationHookOptions<BrandingThemeBuilderCreateMutation, BrandingThemeBuilderCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandingThemeBuilderCreateMutation, BrandingThemeBuilderCreateMutationVariables>(BrandingThemeBuilderCreateDocument, options);
      }
export type BrandingThemeBuilderCreateMutationHookResult = ReturnType<typeof useBrandingThemeBuilderCreateMutation>;
export type BrandingThemeBuilderCreateMutationResult = Apollo.MutationResult<BrandingThemeBuilderCreateMutation>;
export type BrandingThemeBuilderCreateMutationOptions = Apollo.BaseMutationOptions<BrandingThemeBuilderCreateMutation, BrandingThemeBuilderCreateMutationVariables>;
export const BrandingThemeBuilderUpdateDocument = gql`
    mutation BrandingThemeBuilderUpdate($input: BrandingThemeUpdateInput!) {
  brandingThemeUpdate(input: $input) {
    theme {
      ...BrandingThemeBuilderComponent_brandingTheme
    }
  }
}
    ${BrandingThemeBuilderComponent_BrandingThemeFragmentDoc}`;
export type BrandingThemeBuilderUpdateMutationFn = Apollo.MutationFunction<BrandingThemeBuilderUpdateMutation, BrandingThemeBuilderUpdateMutationVariables>;

/**
 * __useBrandingThemeBuilderUpdateMutation__
 *
 * To run a mutation, you first call `useBrandingThemeBuilderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandingThemeBuilderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandingThemeBuilderUpdateMutation, { data, loading, error }] = useBrandingThemeBuilderUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandingThemeBuilderUpdateMutation(baseOptions?: Apollo.MutationHookOptions<BrandingThemeBuilderUpdateMutation, BrandingThemeBuilderUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandingThemeBuilderUpdateMutation, BrandingThemeBuilderUpdateMutationVariables>(BrandingThemeBuilderUpdateDocument, options);
      }
export type BrandingThemeBuilderUpdateMutationHookResult = ReturnType<typeof useBrandingThemeBuilderUpdateMutation>;
export type BrandingThemeBuilderUpdateMutationResult = Apollo.MutationResult<BrandingThemeBuilderUpdateMutation>;
export type BrandingThemeBuilderUpdateMutationOptions = Apollo.BaseMutationOptions<BrandingThemeBuilderUpdateMutation, BrandingThemeBuilderUpdateMutationVariables>;
export const BrandingThemeDeleteDocument = gql`
    mutation BrandingThemeDelete($id: uuid!) {
  brandingThemeDelete(id: $id) {
    result
  }
}
    `;
export type BrandingThemeDeleteMutationFn = Apollo.MutationFunction<BrandingThemeDeleteMutation, BrandingThemeDeleteMutationVariables>;

/**
 * __useBrandingThemeDeleteMutation__
 *
 * To run a mutation, you first call `useBrandingThemeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandingThemeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandingThemeDeleteMutation, { data, loading, error }] = useBrandingThemeDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandingThemeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<BrandingThemeDeleteMutation, BrandingThemeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandingThemeDeleteMutation, BrandingThemeDeleteMutationVariables>(BrandingThemeDeleteDocument, options);
      }
export type BrandingThemeDeleteMutationHookResult = ReturnType<typeof useBrandingThemeDeleteMutation>;
export type BrandingThemeDeleteMutationResult = Apollo.MutationResult<BrandingThemeDeleteMutation>;
export type BrandingThemeDeleteMutationOptions = Apollo.BaseMutationOptions<BrandingThemeDeleteMutation, BrandingThemeDeleteMutationVariables>;
export const BrandingThemesDocument = gql`
    query BrandingThemes {
  brandingThemes {
    items {
      ...BrandingThemeBuilder_brandingTheme
      ...BrandingThemesItem_brandingTheme
    }
  }
}
    ${BrandingThemeBuilder_BrandingThemeFragmentDoc}
${BrandingThemesItem_BrandingThemeFragmentDoc}`;

/**
 * __useBrandingThemesQuery__
 *
 * To run a query within a React component, call `useBrandingThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandingThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandingThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandingThemesQuery(baseOptions?: Apollo.QueryHookOptions<BrandingThemesQuery, BrandingThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandingThemesQuery, BrandingThemesQueryVariables>(BrandingThemesDocument, options);
      }
export function useBrandingThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandingThemesQuery, BrandingThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandingThemesQuery, BrandingThemesQueryVariables>(BrandingThemesDocument, options);
        }
// @ts-ignore
export function useBrandingThemesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrandingThemesQuery, BrandingThemesQueryVariables>): Apollo.UseSuspenseQueryResult<BrandingThemesQuery, BrandingThemesQueryVariables>;
export function useBrandingThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandingThemesQuery, BrandingThemesQueryVariables>): Apollo.UseSuspenseQueryResult<BrandingThemesQuery | undefined, BrandingThemesQueryVariables>;
export function useBrandingThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandingThemesQuery, BrandingThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandingThemesQuery, BrandingThemesQueryVariables>(BrandingThemesDocument, options);
        }
export type BrandingThemesQueryHookResult = ReturnType<typeof useBrandingThemesQuery>;
export type BrandingThemesLazyQueryHookResult = ReturnType<typeof useBrandingThemesLazyQuery>;
export type BrandingThemesSuspenseQueryHookResult = ReturnType<typeof useBrandingThemesSuspenseQuery>;
export type BrandingThemesQueryResult = Apollo.QueryResult<BrandingThemesQuery, BrandingThemesQueryVariables>;
export const DuplicateBrandingThemeDocument = gql`
    mutation DuplicateBrandingTheme($input: BrandingThemeCreateInput!) {
  brandingThemeCreate(input: $input) {
    theme {
      ...BrandingThemeBuilder_brandingTheme
      ...BrandingThemesItem_brandingTheme
    }
  }
}
    ${BrandingThemeBuilder_BrandingThemeFragmentDoc}
${BrandingThemesItem_BrandingThemeFragmentDoc}`;
export type DuplicateBrandingThemeMutationFn = Apollo.MutationFunction<DuplicateBrandingThemeMutation, DuplicateBrandingThemeMutationVariables>;

/**
 * __useDuplicateBrandingThemeMutation__
 *
 * To run a mutation, you first call `useDuplicateBrandingThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateBrandingThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateBrandingThemeMutation, { data, loading, error }] = useDuplicateBrandingThemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateBrandingThemeMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateBrandingThemeMutation, DuplicateBrandingThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateBrandingThemeMutation, DuplicateBrandingThemeMutationVariables>(DuplicateBrandingThemeDocument, options);
      }
export type DuplicateBrandingThemeMutationHookResult = ReturnType<typeof useDuplicateBrandingThemeMutation>;
export type DuplicateBrandingThemeMutationResult = Apollo.MutationResult<DuplicateBrandingThemeMutation>;
export type DuplicateBrandingThemeMutationOptions = Apollo.BaseMutationOptions<DuplicateBrandingThemeMutation, DuplicateBrandingThemeMutationVariables>;
export const PortalTemplatesDocument = gql`
    query PortalTemplates($input: PortalTemplatesInput!, $includeLivePortals: Boolean!) {
  portalTemplates(input: $input) {
    nextCursor
    items {
      id
      ...PageTemplateRow_template
    }
  }
}
    ${PageTemplateRow_TemplateFragmentDoc}`;

/**
 * __usePortalTemplatesQuery__
 *
 * To run a query within a React component, call `usePortalTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includeLivePortals: // value for 'includeLivePortals'
 *   },
 * });
 */
export function usePortalTemplatesQuery(baseOptions: Apollo.QueryHookOptions<PortalTemplatesQuery, PortalTemplatesQueryVariables> & ({ variables: PortalTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalTemplatesQuery, PortalTemplatesQueryVariables>(PortalTemplatesDocument, options);
      }
export function usePortalTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalTemplatesQuery, PortalTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalTemplatesQuery, PortalTemplatesQueryVariables>(PortalTemplatesDocument, options);
        }
// @ts-ignore
export function usePortalTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalTemplatesQuery, PortalTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplatesQuery, PortalTemplatesQueryVariables>;
export function usePortalTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplatesQuery, PortalTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplatesQuery | undefined, PortalTemplatesQueryVariables>;
export function usePortalTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplatesQuery, PortalTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalTemplatesQuery, PortalTemplatesQueryVariables>(PortalTemplatesDocument, options);
        }
export type PortalTemplatesQueryHookResult = ReturnType<typeof usePortalTemplatesQuery>;
export type PortalTemplatesLazyQueryHookResult = ReturnType<typeof usePortalTemplatesLazyQuery>;
export type PortalTemplatesSuspenseQueryHookResult = ReturnType<typeof usePortalTemplatesSuspenseQuery>;
export type PortalTemplatesQueryResult = Apollo.QueryResult<PortalTemplatesQuery, PortalTemplatesQueryVariables>;
export const PortalTemplatePreviewDocument = gql`
    query PortalTemplatePreview($id: uuid!) {
  portalTemplate(id: $id) {
    id
    ...TemplatePreview_portalTemplate
  }
}
    ${TemplatePreview_PortalTemplateFragmentDoc}`;

/**
 * __usePortalTemplatePreviewQuery__
 *
 * To run a query within a React component, call `usePortalTemplatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalTemplatePreviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalTemplatePreviewQuery(baseOptions: Apollo.QueryHookOptions<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables> & ({ variables: PortalTemplatePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>(PortalTemplatePreviewDocument, options);
      }
export function usePortalTemplatePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>(PortalTemplatePreviewDocument, options);
        }
// @ts-ignore
export function usePortalTemplatePreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>;
export function usePortalTemplatePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplatePreviewQuery | undefined, PortalTemplatePreviewQueryVariables>;
export function usePortalTemplatePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>(PortalTemplatePreviewDocument, options);
        }
export type PortalTemplatePreviewQueryHookResult = ReturnType<typeof usePortalTemplatePreviewQuery>;
export type PortalTemplatePreviewLazyQueryHookResult = ReturnType<typeof usePortalTemplatePreviewLazyQuery>;
export type PortalTemplatePreviewSuspenseQueryHookResult = ReturnType<typeof usePortalTemplatePreviewSuspenseQuery>;
export type PortalTemplatePreviewQueryResult = Apollo.QueryResult<PortalTemplatePreviewQuery, PortalTemplatePreviewQueryVariables>;
export const PortalTemplateDeleteDocument = gql`
    mutation portalTemplateDelete($id: uuid!) {
  portalTemplateDelete(id: $id) {
    result
  }
}
    `;
export type PortalTemplateDeleteMutationFn = Apollo.MutationFunction<PortalTemplateDeleteMutation, PortalTemplateDeleteMutationVariables>;

/**
 * __usePortalTemplateDeleteMutation__
 *
 * To run a mutation, you first call `usePortalTemplateDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplateDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalTemplateDeleteMutation, { data, loading, error }] = usePortalTemplateDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalTemplateDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PortalTemplateDeleteMutation, PortalTemplateDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalTemplateDeleteMutation, PortalTemplateDeleteMutationVariables>(PortalTemplateDeleteDocument, options);
      }
export type PortalTemplateDeleteMutationHookResult = ReturnType<typeof usePortalTemplateDeleteMutation>;
export type PortalTemplateDeleteMutationResult = Apollo.MutationResult<PortalTemplateDeleteMutation>;
export type PortalTemplateDeleteMutationOptions = Apollo.BaseMutationOptions<PortalTemplateDeleteMutation, PortalTemplateDeleteMutationVariables>;
export const LinkUnfurlDocument = gql`
    query LinkUnfurl($input: LinkUnfurlInput!) {
  linkUnfurl(input: $input) {
    url
    title
    description
    thumbnail
  }
}
    `;

/**
 * __useLinkUnfurlQuery__
 *
 * To run a query within a React component, call `useLinkUnfurlQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkUnfurlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkUnfurlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkUnfurlQuery(baseOptions: Apollo.QueryHookOptions<LinkUnfurlQuery, LinkUnfurlQueryVariables> & ({ variables: LinkUnfurlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkUnfurlQuery, LinkUnfurlQueryVariables>(LinkUnfurlDocument, options);
      }
export function useLinkUnfurlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkUnfurlQuery, LinkUnfurlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkUnfurlQuery, LinkUnfurlQueryVariables>(LinkUnfurlDocument, options);
        }
// @ts-ignore
export function useLinkUnfurlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LinkUnfurlQuery, LinkUnfurlQueryVariables>): Apollo.UseSuspenseQueryResult<LinkUnfurlQuery, LinkUnfurlQueryVariables>;
export function useLinkUnfurlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkUnfurlQuery, LinkUnfurlQueryVariables>): Apollo.UseSuspenseQueryResult<LinkUnfurlQuery | undefined, LinkUnfurlQueryVariables>;
export function useLinkUnfurlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkUnfurlQuery, LinkUnfurlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkUnfurlQuery, LinkUnfurlQueryVariables>(LinkUnfurlDocument, options);
        }
export type LinkUnfurlQueryHookResult = ReturnType<typeof useLinkUnfurlQuery>;
export type LinkUnfurlLazyQueryHookResult = ReturnType<typeof useLinkUnfurlLazyQuery>;
export type LinkUnfurlSuspenseQueryHookResult = ReturnType<typeof useLinkUnfurlSuspenseQuery>;
export type LinkUnfurlQueryResult = Apollo.QueryResult<LinkUnfurlQuery, LinkUnfurlQueryVariables>;
export const PortalTemplateDocument = gql`
    query PortalTemplate($id: uuid!) {
  portalTemplate(id: $id) {
    ...TemplatePreview_portalTemplate
  }
}
    ${TemplatePreview_PortalTemplateFragmentDoc}`;

/**
 * __usePortalTemplateQuery__
 *
 * To run a query within a React component, call `usePortalTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalTemplateQuery(baseOptions: Apollo.QueryHookOptions<PortalTemplateQuery, PortalTemplateQueryVariables> & ({ variables: PortalTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalTemplateQuery, PortalTemplateQueryVariables>(PortalTemplateDocument, options);
      }
export function usePortalTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalTemplateQuery, PortalTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalTemplateQuery, PortalTemplateQueryVariables>(PortalTemplateDocument, options);
        }
// @ts-ignore
export function usePortalTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalTemplateQuery, PortalTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateQuery, PortalTemplateQueryVariables>;
export function usePortalTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateQuery, PortalTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateQuery | undefined, PortalTemplateQueryVariables>;
export function usePortalTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateQuery, PortalTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalTemplateQuery, PortalTemplateQueryVariables>(PortalTemplateDocument, options);
        }
export type PortalTemplateQueryHookResult = ReturnType<typeof usePortalTemplateQuery>;
export type PortalTemplateLazyQueryHookResult = ReturnType<typeof usePortalTemplateLazyQuery>;
export type PortalTemplateSuspenseQueryHookResult = ReturnType<typeof usePortalTemplateSuspenseQuery>;
export type PortalTemplateQueryResult = Apollo.QueryResult<PortalTemplateQuery, PortalTemplateQueryVariables>;
export const PortalTemplateUpdateDocument = gql`
    mutation portalTemplateUpdate($input: PortalTemplateUpdateInput!) {
  portalTemplateUpdate(input: $input) {
    template {
      id
      ...TemplatePreview_portalTemplate
    }
  }
}
    ${TemplatePreview_PortalTemplateFragmentDoc}`;
export type PortalTemplateUpdateMutationFn = Apollo.MutationFunction<PortalTemplateUpdateMutation, PortalTemplateUpdateMutationVariables>;

/**
 * __usePortalTemplateUpdateMutation__
 *
 * To run a mutation, you first call `usePortalTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalTemplateUpdateMutation, { data, loading, error }] = usePortalTemplateUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PortalTemplateUpdateMutation, PortalTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalTemplateUpdateMutation, PortalTemplateUpdateMutationVariables>(PortalTemplateUpdateDocument, options);
      }
export type PortalTemplateUpdateMutationHookResult = ReturnType<typeof usePortalTemplateUpdateMutation>;
export type PortalTemplateUpdateMutationResult = Apollo.MutationResult<PortalTemplateUpdateMutation>;
export type PortalTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<PortalTemplateUpdateMutation, PortalTemplateUpdateMutationVariables>;
export const PortalTemplateCreateDocument = gql`
    mutation portalTemplateCreate($input: PortalTemplateCreateInput!) {
  portalTemplateCreate(input: $input) {
    template {
      id
      ...TemplatePreview_portalTemplate
    }
  }
}
    ${TemplatePreview_PortalTemplateFragmentDoc}`;
export type PortalTemplateCreateMutationFn = Apollo.MutationFunction<PortalTemplateCreateMutation, PortalTemplateCreateMutationVariables>;

/**
 * __usePortalTemplateCreateMutation__
 *
 * To run a mutation, you first call `usePortalTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalTemplateCreateMutation, { data, loading, error }] = usePortalTemplateCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<PortalTemplateCreateMutation, PortalTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalTemplateCreateMutation, PortalTemplateCreateMutationVariables>(PortalTemplateCreateDocument, options);
      }
export type PortalTemplateCreateMutationHookResult = ReturnType<typeof usePortalTemplateCreateMutation>;
export type PortalTemplateCreateMutationResult = Apollo.MutationResult<PortalTemplateCreateMutation>;
export type PortalTemplateCreateMutationOptions = Apollo.BaseMutationOptions<PortalTemplateCreateMutation, PortalTemplateCreateMutationVariables>;
export const PortalTemplateLivePortalsDocument = gql`
    query PortalTemplateLivePortals($id: uuid!) {
  portalTemplate(id: $id) {
    id
    livePortals
  }
}
    `;

/**
 * __usePortalTemplateLivePortalsQuery__
 *
 * To run a query within a React component, call `usePortalTemplateLivePortalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalTemplateLivePortalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalTemplateLivePortalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalTemplateLivePortalsQuery(baseOptions: Apollo.QueryHookOptions<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables> & ({ variables: PortalTemplateLivePortalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>(PortalTemplateLivePortalsDocument, options);
      }
export function usePortalTemplateLivePortalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>(PortalTemplateLivePortalsDocument, options);
        }
// @ts-ignore
export function usePortalTemplateLivePortalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>;
export function usePortalTemplateLivePortalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>): Apollo.UseSuspenseQueryResult<PortalTemplateLivePortalsQuery | undefined, PortalTemplateLivePortalsQueryVariables>;
export function usePortalTemplateLivePortalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>(PortalTemplateLivePortalsDocument, options);
        }
export type PortalTemplateLivePortalsQueryHookResult = ReturnType<typeof usePortalTemplateLivePortalsQuery>;
export type PortalTemplateLivePortalsLazyQueryHookResult = ReturnType<typeof usePortalTemplateLivePortalsLazyQuery>;
export type PortalTemplateLivePortalsSuspenseQueryHookResult = ReturnType<typeof usePortalTemplateLivePortalsSuspenseQuery>;
export type PortalTemplateLivePortalsQueryResult = Apollo.QueryResult<PortalTemplateLivePortalsQuery, PortalTemplateLivePortalsQueryVariables>;
export const PortalConfigCreateDocument = gql`
    mutation PortalConfigCreate($input: PortalConfigCreateInput!) {
  portalConfigCreate(input: $input) {
    config {
      id
      name
      isDefault
      brandingThemeId
      intro
      aiAssistantId
    }
  }
}
    `;
export type PortalConfigCreateMutationFn = Apollo.MutationFunction<PortalConfigCreateMutation, PortalConfigCreateMutationVariables>;

/**
 * __usePortalConfigCreateMutation__
 *
 * To run a mutation, you first call `usePortalConfigCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalConfigCreateMutation, { data, loading, error }] = usePortalConfigCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalConfigCreateMutation(baseOptions?: Apollo.MutationHookOptions<PortalConfigCreateMutation, PortalConfigCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalConfigCreateMutation, PortalConfigCreateMutationVariables>(PortalConfigCreateDocument, options);
      }
export type PortalConfigCreateMutationHookResult = ReturnType<typeof usePortalConfigCreateMutation>;
export type PortalConfigCreateMutationResult = Apollo.MutationResult<PortalConfigCreateMutation>;
export type PortalConfigCreateMutationOptions = Apollo.BaseMutationOptions<PortalConfigCreateMutation, PortalConfigCreateMutationVariables>;
export const PortalConfigUpdateDocument = gql`
    mutation PortalConfigUpdate($input: PortalConfigUpdateInput!) {
  portalConfigUpdate(input: $input) {
    config {
      id
      name
      isDefault
      brandingThemeId
      intro
      aiAssistantId
    }
  }
}
    `;
export type PortalConfigUpdateMutationFn = Apollo.MutationFunction<PortalConfigUpdateMutation, PortalConfigUpdateMutationVariables>;

/**
 * __usePortalConfigUpdateMutation__
 *
 * To run a mutation, you first call `usePortalConfigUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalConfigUpdateMutation, { data, loading, error }] = usePortalConfigUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalConfigUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PortalConfigUpdateMutation, PortalConfigUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalConfigUpdateMutation, PortalConfigUpdateMutationVariables>(PortalConfigUpdateDocument, options);
      }
export type PortalConfigUpdateMutationHookResult = ReturnType<typeof usePortalConfigUpdateMutation>;
export type PortalConfigUpdateMutationResult = Apollo.MutationResult<PortalConfigUpdateMutation>;
export type PortalConfigUpdateMutationOptions = Apollo.BaseMutationOptions<PortalConfigUpdateMutation, PortalConfigUpdateMutationVariables>;
export const PortalConfigTabCreateDocument = gql`
    mutation PortalConfigTabCreate($input: PortalConfigTabCreateInput!) {
  portalConfigTabCreate(input: $input) {
    tab {
      id
      name
      icon
      visibility
      index
      portalTemplateId
      stageNameFilter
    }
  }
}
    `;
export type PortalConfigTabCreateMutationFn = Apollo.MutationFunction<PortalConfigTabCreateMutation, PortalConfigTabCreateMutationVariables>;

/**
 * __usePortalConfigTabCreateMutation__
 *
 * To run a mutation, you first call `usePortalConfigTabCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigTabCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalConfigTabCreateMutation, { data, loading, error }] = usePortalConfigTabCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalConfigTabCreateMutation(baseOptions?: Apollo.MutationHookOptions<PortalConfigTabCreateMutation, PortalConfigTabCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalConfigTabCreateMutation, PortalConfigTabCreateMutationVariables>(PortalConfigTabCreateDocument, options);
      }
export type PortalConfigTabCreateMutationHookResult = ReturnType<typeof usePortalConfigTabCreateMutation>;
export type PortalConfigTabCreateMutationResult = Apollo.MutationResult<PortalConfigTabCreateMutation>;
export type PortalConfigTabCreateMutationOptions = Apollo.BaseMutationOptions<PortalConfigTabCreateMutation, PortalConfigTabCreateMutationVariables>;
export const PortalConfigTabDeleteDocument = gql`
    mutation PortalConfigTabDelete($id: uuid!) {
  portalConfigTabDelete(id: $id) {
    result
  }
}
    `;
export type PortalConfigTabDeleteMutationFn = Apollo.MutationFunction<PortalConfigTabDeleteMutation, PortalConfigTabDeleteMutationVariables>;

/**
 * __usePortalConfigTabDeleteMutation__
 *
 * To run a mutation, you first call `usePortalConfigTabDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigTabDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalConfigTabDeleteMutation, { data, loading, error }] = usePortalConfigTabDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalConfigTabDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PortalConfigTabDeleteMutation, PortalConfigTabDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalConfigTabDeleteMutation, PortalConfigTabDeleteMutationVariables>(PortalConfigTabDeleteDocument, options);
      }
export type PortalConfigTabDeleteMutationHookResult = ReturnType<typeof usePortalConfigTabDeleteMutation>;
export type PortalConfigTabDeleteMutationResult = Apollo.MutationResult<PortalConfigTabDeleteMutation>;
export type PortalConfigTabDeleteMutationOptions = Apollo.BaseMutationOptions<PortalConfigTabDeleteMutation, PortalConfigTabDeleteMutationVariables>;
export const PortalConfigTabUpdateDocument = gql`
    mutation PortalConfigTabUpdate($input: PortalConfigTabUpdateInput!) {
  portalConfigTabUpdate(input: $input) {
    tab {
      id
      name
      icon
      visibility
      index
      portalTemplateId
      stageNameFilter
    }
  }
}
    `;
export type PortalConfigTabUpdateMutationFn = Apollo.MutationFunction<PortalConfigTabUpdateMutation, PortalConfigTabUpdateMutationVariables>;

/**
 * __usePortalConfigTabUpdateMutation__
 *
 * To run a mutation, you first call `usePortalConfigTabUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigTabUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalConfigTabUpdateMutation, { data, loading, error }] = usePortalConfigTabUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalConfigTabUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PortalConfigTabUpdateMutation, PortalConfigTabUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalConfigTabUpdateMutation, PortalConfigTabUpdateMutationVariables>(PortalConfigTabUpdateDocument, options);
      }
export type PortalConfigTabUpdateMutationHookResult = ReturnType<typeof usePortalConfigTabUpdateMutation>;
export type PortalConfigTabUpdateMutationResult = Apollo.MutationResult<PortalConfigTabUpdateMutation>;
export type PortalConfigTabUpdateMutationOptions = Apollo.BaseMutationOptions<PortalConfigTabUpdateMutation, PortalConfigTabUpdateMutationVariables>;
export const PortalConfigDeleteDocument = gql`
    mutation PortalConfigDelete($id: uuid!) {
  portalConfigDelete(id: $id) {
    result
  }
}
    `;
export type PortalConfigDeleteMutationFn = Apollo.MutationFunction<PortalConfigDeleteMutation, PortalConfigDeleteMutationVariables>;

/**
 * __usePortalConfigDeleteMutation__
 *
 * To run a mutation, you first call `usePortalConfigDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalConfigDeleteMutation, { data, loading, error }] = usePortalConfigDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalConfigDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PortalConfigDeleteMutation, PortalConfigDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalConfigDeleteMutation, PortalConfigDeleteMutationVariables>(PortalConfigDeleteDocument, options);
      }
export type PortalConfigDeleteMutationHookResult = ReturnType<typeof usePortalConfigDeleteMutation>;
export type PortalConfigDeleteMutationResult = Apollo.MutationResult<PortalConfigDeleteMutation>;
export type PortalConfigDeleteMutationOptions = Apollo.BaseMutationOptions<PortalConfigDeleteMutation, PortalConfigDeleteMutationVariables>;
export const PortalConfigDeleteDialogAutomationRulesDocument = gql`
    query PortalConfigDeleteDialogAutomationRules {
  portalConfigAutomationRules {
    rules {
      id
      portalConfigId
    }
  }
}
    `;

/**
 * __usePortalConfigDeleteDialogAutomationRulesQuery__
 *
 * To run a query within a React component, call `usePortalConfigDeleteDialogAutomationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigDeleteDialogAutomationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalConfigDeleteDialogAutomationRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalConfigDeleteDialogAutomationRulesQuery(baseOptions?: Apollo.QueryHookOptions<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>(PortalConfigDeleteDialogAutomationRulesDocument, options);
      }
export function usePortalConfigDeleteDialogAutomationRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>(PortalConfigDeleteDialogAutomationRulesDocument, options);
        }
// @ts-ignore
export function usePortalConfigDeleteDialogAutomationRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>;
export function usePortalConfigDeleteDialogAutomationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigDeleteDialogAutomationRulesQuery | undefined, PortalConfigDeleteDialogAutomationRulesQueryVariables>;
export function usePortalConfigDeleteDialogAutomationRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>(PortalConfigDeleteDialogAutomationRulesDocument, options);
        }
export type PortalConfigDeleteDialogAutomationRulesQueryHookResult = ReturnType<typeof usePortalConfigDeleteDialogAutomationRulesQuery>;
export type PortalConfigDeleteDialogAutomationRulesLazyQueryHookResult = ReturnType<typeof usePortalConfigDeleteDialogAutomationRulesLazyQuery>;
export type PortalConfigDeleteDialogAutomationRulesSuspenseQueryHookResult = ReturnType<typeof usePortalConfigDeleteDialogAutomationRulesSuspenseQuery>;
export type PortalConfigDeleteDialogAutomationRulesQueryResult = Apollo.QueryResult<PortalConfigDeleteDialogAutomationRulesQuery, PortalConfigDeleteDialogAutomationRulesQueryVariables>;
export const PortalConfigPreviewBrandingThemesDocument = gql`
    query PortalConfigPreviewBrandingThemes {
  brandingThemes {
    items {
      id
      isOrgDefault
      ...PortalPreviewByJobStage_brandingTheme
    }
  }
}
    ${PortalPreviewByJobStage_BrandingThemeFragmentDoc}`;

/**
 * __usePortalConfigPreviewBrandingThemesQuery__
 *
 * To run a query within a React component, call `usePortalConfigPreviewBrandingThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigPreviewBrandingThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalConfigPreviewBrandingThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalConfigPreviewBrandingThemesQuery(baseOptions?: Apollo.QueryHookOptions<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>(PortalConfigPreviewBrandingThemesDocument, options);
      }
export function usePortalConfigPreviewBrandingThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>(PortalConfigPreviewBrandingThemesDocument, options);
        }
// @ts-ignore
export function usePortalConfigPreviewBrandingThemesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>;
export function usePortalConfigPreviewBrandingThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigPreviewBrandingThemesQuery | undefined, PortalConfigPreviewBrandingThemesQueryVariables>;
export function usePortalConfigPreviewBrandingThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>(PortalConfigPreviewBrandingThemesDocument, options);
        }
export type PortalConfigPreviewBrandingThemesQueryHookResult = ReturnType<typeof usePortalConfigPreviewBrandingThemesQuery>;
export type PortalConfigPreviewBrandingThemesLazyQueryHookResult = ReturnType<typeof usePortalConfigPreviewBrandingThemesLazyQuery>;
export type PortalConfigPreviewBrandingThemesSuspenseQueryHookResult = ReturnType<typeof usePortalConfigPreviewBrandingThemesSuspenseQuery>;
export type PortalConfigPreviewBrandingThemesQueryResult = Apollo.QueryResult<PortalConfigPreviewBrandingThemesQuery, PortalConfigPreviewBrandingThemesQueryVariables>;
export const PortalConfigDocument = gql`
    query PortalConfig($id: uuid!) {
  portalConfig(id: $id) {
    id
    ...PortalConfigBuilder_portalConfig
  }
}
    ${PortalConfigBuilder_PortalConfigFragmentDoc}`;

/**
 * __usePortalConfigQuery__
 *
 * To run a query within a React component, call `usePortalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePortalConfigQuery(baseOptions: Apollo.QueryHookOptions<PortalConfigQuery, PortalConfigQueryVariables> & ({ variables: PortalConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalConfigQuery, PortalConfigQueryVariables>(PortalConfigDocument, options);
      }
export function usePortalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalConfigQuery, PortalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalConfigQuery, PortalConfigQueryVariables>(PortalConfigDocument, options);
        }
// @ts-ignore
export function usePortalConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalConfigQuery, PortalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigQuery, PortalConfigQueryVariables>;
export function usePortalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigQuery, PortalConfigQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigQuery | undefined, PortalConfigQueryVariables>;
export function usePortalConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigQuery, PortalConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalConfigQuery, PortalConfigQueryVariables>(PortalConfigDocument, options);
        }
export type PortalConfigQueryHookResult = ReturnType<typeof usePortalConfigQuery>;
export type PortalConfigLazyQueryHookResult = ReturnType<typeof usePortalConfigLazyQuery>;
export type PortalConfigSuspenseQueryHookResult = ReturnType<typeof usePortalConfigSuspenseQuery>;
export type PortalConfigQueryResult = Apollo.QueryResult<PortalConfigQuery, PortalConfigQueryVariables>;
export const PortalConfigsBrandingThemesDocument = gql`
    query PortalConfigsBrandingThemes {
  brandingThemes {
    items {
      id
      name
      primaryColor
      isOrgDefault
    }
  }
}
    `;

/**
 * __usePortalConfigsBrandingThemesQuery__
 *
 * To run a query within a React component, call `usePortalConfigsBrandingThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigsBrandingThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalConfigsBrandingThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalConfigsBrandingThemesQuery(baseOptions?: Apollo.QueryHookOptions<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>(PortalConfigsBrandingThemesDocument, options);
      }
export function usePortalConfigsBrandingThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>(PortalConfigsBrandingThemesDocument, options);
        }
// @ts-ignore
export function usePortalConfigsBrandingThemesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>;
export function usePortalConfigsBrandingThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigsBrandingThemesQuery | undefined, PortalConfigsBrandingThemesQueryVariables>;
export function usePortalConfigsBrandingThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>(PortalConfigsBrandingThemesDocument, options);
        }
export type PortalConfigsBrandingThemesQueryHookResult = ReturnType<typeof usePortalConfigsBrandingThemesQuery>;
export type PortalConfigsBrandingThemesLazyQueryHookResult = ReturnType<typeof usePortalConfigsBrandingThemesLazyQuery>;
export type PortalConfigsBrandingThemesSuspenseQueryHookResult = ReturnType<typeof usePortalConfigsBrandingThemesSuspenseQuery>;
export type PortalConfigsBrandingThemesQueryResult = Apollo.QueryResult<PortalConfigsBrandingThemesQuery, PortalConfigsBrandingThemesQueryVariables>;
export const PortalConfigsListDocument = gql`
    query PortalConfigsList {
  portalConfigs {
    ...PortalConfigsList
  }
}
    ${PortalConfigsListFragmentDoc}`;

/**
 * __usePortalConfigsListQuery__
 *
 * To run a query within a React component, call `usePortalConfigsListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalConfigsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalConfigsListQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalConfigsListQuery(baseOptions?: Apollo.QueryHookOptions<PortalConfigsListQuery, PortalConfigsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortalConfigsListQuery, PortalConfigsListQueryVariables>(PortalConfigsListDocument, options);
      }
export function usePortalConfigsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalConfigsListQuery, PortalConfigsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortalConfigsListQuery, PortalConfigsListQueryVariables>(PortalConfigsListDocument, options);
        }
// @ts-ignore
export function usePortalConfigsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortalConfigsListQuery, PortalConfigsListQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigsListQuery, PortalConfigsListQueryVariables>;
export function usePortalConfigsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigsListQuery, PortalConfigsListQueryVariables>): Apollo.UseSuspenseQueryResult<PortalConfigsListQuery | undefined, PortalConfigsListQueryVariables>;
export function usePortalConfigsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortalConfigsListQuery, PortalConfigsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortalConfigsListQuery, PortalConfigsListQueryVariables>(PortalConfigsListDocument, options);
        }
export type PortalConfigsListQueryHookResult = ReturnType<typeof usePortalConfigsListQuery>;
export type PortalConfigsListLazyQueryHookResult = ReturnType<typeof usePortalConfigsListLazyQuery>;
export type PortalConfigsListSuspenseQueryHookResult = ReturnType<typeof usePortalConfigsListSuspenseQuery>;
export type PortalConfigsListQueryResult = Apollo.QueryResult<PortalConfigsListQuery, PortalConfigsListQueryVariables>;
export const UpsertCandidatePulseTagsDocument = gql`
    mutation UpsertCandidatePulseTags($input: CandidatePulseTagUpsertInput!) {
  candidatePulseTagUpsert(input: $input) {
    result
  }
}
    `;
export type UpsertCandidatePulseTagsMutationFn = Apollo.MutationFunction<UpsertCandidatePulseTagsMutation, UpsertCandidatePulseTagsMutationVariables>;

/**
 * __useUpsertCandidatePulseTagsMutation__
 *
 * To run a mutation, you first call `useUpsertCandidatePulseTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCandidatePulseTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCandidatePulseTagsMutation, { data, loading, error }] = useUpsertCandidatePulseTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertCandidatePulseTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCandidatePulseTagsMutation, UpsertCandidatePulseTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCandidatePulseTagsMutation, UpsertCandidatePulseTagsMutationVariables>(UpsertCandidatePulseTagsDocument, options);
      }
export type UpsertCandidatePulseTagsMutationHookResult = ReturnType<typeof useUpsertCandidatePulseTagsMutation>;
export type UpsertCandidatePulseTagsMutationResult = Apollo.MutationResult<UpsertCandidatePulseTagsMutation>;
export type UpsertCandidatePulseTagsMutationOptions = Apollo.BaseMutationOptions<UpsertCandidatePulseTagsMutation, UpsertCandidatePulseTagsMutationVariables>;
export const ContentTranslationUpsertDocument = gql`
    mutation ContentTranslationUpsert($input: ContentTranslationUpsertInput!) {
  contentTranslationUpsert(input: $input) {
    _empty
  }
}
    `;
export type ContentTranslationUpsertMutationFn = Apollo.MutationFunction<ContentTranslationUpsertMutation, ContentTranslationUpsertMutationVariables>;

/**
 * __useContentTranslationUpsertMutation__
 *
 * To run a mutation, you first call `useContentTranslationUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentTranslationUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentTranslationUpsertMutation, { data, loading, error }] = useContentTranslationUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContentTranslationUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ContentTranslationUpsertMutation, ContentTranslationUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentTranslationUpsertMutation, ContentTranslationUpsertMutationVariables>(ContentTranslationUpsertDocument, options);
      }
export type ContentTranslationUpsertMutationHookResult = ReturnType<typeof useContentTranslationUpsertMutation>;
export type ContentTranslationUpsertMutationResult = Apollo.MutationResult<ContentTranslationUpsertMutation>;
export type ContentTranslationUpsertMutationOptions = Apollo.BaseMutationOptions<ContentTranslationUpsertMutation, ContentTranslationUpsertMutationVariables>;
export const PulseSurveySettingsDocument = gql`
    query PulseSurveySettings {
  thisOrg {
    id
    candidatePulseTags {
      positive {
        id
        name
        emoji
        index
        archivedAt
        ...QuestionSetupDialog_candidatePulseTags
      }
      negative {
        id
        name
        emoji
        index
        archivedAt
        ...QuestionSetupDialog_candidatePulseTags
      }
    }
  }
}
    ${QuestionSetupDialog_CandidatePulseTagsFragmentDoc}`;

/**
 * __usePulseSurveySettingsQuery__
 *
 * To run a query within a React component, call `usePulseSurveySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseSurveySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseSurveySettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePulseSurveySettingsQuery(baseOptions?: Apollo.QueryHookOptions<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>(PulseSurveySettingsDocument, options);
      }
export function usePulseSurveySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>(PulseSurveySettingsDocument, options);
        }
// @ts-ignore
export function usePulseSurveySettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>;
export function usePulseSurveySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>): Apollo.UseSuspenseQueryResult<PulseSurveySettingsQuery | undefined, PulseSurveySettingsQueryVariables>;
export function usePulseSurveySettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>(PulseSurveySettingsDocument, options);
        }
export type PulseSurveySettingsQueryHookResult = ReturnType<typeof usePulseSurveySettingsQuery>;
export type PulseSurveySettingsLazyQueryHookResult = ReturnType<typeof usePulseSurveySettingsLazyQuery>;
export type PulseSurveySettingsSuspenseQueryHookResult = ReturnType<typeof usePulseSurveySettingsSuspenseQuery>;
export type PulseSurveySettingsQueryResult = Apollo.QueryResult<PulseSurveySettingsQuery, PulseSurveySettingsQueryVariables>;
export const SettingsInitiateCandidateDataExportDocument = gql`
    mutation SettingsInitiateCandidateDataExport($input: InitiateCandidateDataExportInput!) {
  initiateCandidateDataExport(input: $input) {
    __typename
  }
}
    `;
export type SettingsInitiateCandidateDataExportMutationFn = Apollo.MutationFunction<SettingsInitiateCandidateDataExportMutation, SettingsInitiateCandidateDataExportMutationVariables>;

/**
 * __useSettingsInitiateCandidateDataExportMutation__
 *
 * To run a mutation, you first call `useSettingsInitiateCandidateDataExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsInitiateCandidateDataExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsInitiateCandidateDataExportMutation, { data, loading, error }] = useSettingsInitiateCandidateDataExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsInitiateCandidateDataExportMutation(baseOptions?: Apollo.MutationHookOptions<SettingsInitiateCandidateDataExportMutation, SettingsInitiateCandidateDataExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsInitiateCandidateDataExportMutation, SettingsInitiateCandidateDataExportMutationVariables>(SettingsInitiateCandidateDataExportDocument, options);
      }
export type SettingsInitiateCandidateDataExportMutationHookResult = ReturnType<typeof useSettingsInitiateCandidateDataExportMutation>;
export type SettingsInitiateCandidateDataExportMutationResult = Apollo.MutationResult<SettingsInitiateCandidateDataExportMutation>;
export type SettingsInitiateCandidateDataExportMutationOptions = Apollo.BaseMutationOptions<SettingsInitiateCandidateDataExportMutation, SettingsInitiateCandidateDataExportMutationVariables>;
export const SettingsAnonymizeCandidateDocument = gql`
    mutation SettingsAnonymizeCandidate($input: CandidateAnonymizeInput!) {
  candidateAnonymize(input: $input) {
    result
  }
}
    `;
export type SettingsAnonymizeCandidateMutationFn = Apollo.MutationFunction<SettingsAnonymizeCandidateMutation, SettingsAnonymizeCandidateMutationVariables>;

/**
 * __useSettingsAnonymizeCandidateMutation__
 *
 * To run a mutation, you first call `useSettingsAnonymizeCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsAnonymizeCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsAnonymizeCandidateMutation, { data, loading, error }] = useSettingsAnonymizeCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsAnonymizeCandidateMutation(baseOptions?: Apollo.MutationHookOptions<SettingsAnonymizeCandidateMutation, SettingsAnonymizeCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsAnonymizeCandidateMutation, SettingsAnonymizeCandidateMutationVariables>(SettingsAnonymizeCandidateDocument, options);
      }
export type SettingsAnonymizeCandidateMutationHookResult = ReturnType<typeof useSettingsAnonymizeCandidateMutation>;
export type SettingsAnonymizeCandidateMutationResult = Apollo.MutationResult<SettingsAnonymizeCandidateMutation>;
export type SettingsAnonymizeCandidateMutationOptions = Apollo.BaseMutationOptions<SettingsAnonymizeCandidateMutation, SettingsAnonymizeCandidateMutationVariables>;
export const SettingsBulkAnonymizeCandidateDocument = gql`
    mutation SettingsBulkAnonymizeCandidate($input: CandidateBulkAnonymizeInput!) {
  candidateBulkAnonymize(input: $input) {
    count
  }
}
    `;
export type SettingsBulkAnonymizeCandidateMutationFn = Apollo.MutationFunction<SettingsBulkAnonymizeCandidateMutation, SettingsBulkAnonymizeCandidateMutationVariables>;

/**
 * __useSettingsBulkAnonymizeCandidateMutation__
 *
 * To run a mutation, you first call `useSettingsBulkAnonymizeCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettingsBulkAnonymizeCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settingsBulkAnonymizeCandidateMutation, { data, loading, error }] = useSettingsBulkAnonymizeCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingsBulkAnonymizeCandidateMutation(baseOptions?: Apollo.MutationHookOptions<SettingsBulkAnonymizeCandidateMutation, SettingsBulkAnonymizeCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettingsBulkAnonymizeCandidateMutation, SettingsBulkAnonymizeCandidateMutationVariables>(SettingsBulkAnonymizeCandidateDocument, options);
      }
export type SettingsBulkAnonymizeCandidateMutationHookResult = ReturnType<typeof useSettingsBulkAnonymizeCandidateMutation>;
export type SettingsBulkAnonymizeCandidateMutationResult = Apollo.MutationResult<SettingsBulkAnonymizeCandidateMutation>;
export type SettingsBulkAnonymizeCandidateMutationOptions = Apollo.BaseMutationOptions<SettingsBulkAnonymizeCandidateMutation, SettingsBulkAnonymizeCandidateMutationVariables>;
export const OrgApplicationCalendarWriteDocument = gql`
    query OrgApplicationCalendarWrite {
  thisOrg {
    hasApplicationCalendarWrite
  }
}
    `;

/**
 * __useOrgApplicationCalendarWriteQuery__
 *
 * To run a query within a React component, call `useOrgApplicationCalendarWriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgApplicationCalendarWriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgApplicationCalendarWriteQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgApplicationCalendarWriteQuery(baseOptions?: Apollo.QueryHookOptions<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>(OrgApplicationCalendarWriteDocument, options);
      }
export function useOrgApplicationCalendarWriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>(OrgApplicationCalendarWriteDocument, options);
        }
// @ts-ignore
export function useOrgApplicationCalendarWriteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>): Apollo.UseSuspenseQueryResult<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>;
export function useOrgApplicationCalendarWriteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>): Apollo.UseSuspenseQueryResult<OrgApplicationCalendarWriteQuery | undefined, OrgApplicationCalendarWriteQueryVariables>;
export function useOrgApplicationCalendarWriteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>(OrgApplicationCalendarWriteDocument, options);
        }
export type OrgApplicationCalendarWriteQueryHookResult = ReturnType<typeof useOrgApplicationCalendarWriteQuery>;
export type OrgApplicationCalendarWriteLazyQueryHookResult = ReturnType<typeof useOrgApplicationCalendarWriteLazyQuery>;
export type OrgApplicationCalendarWriteSuspenseQueryHookResult = ReturnType<typeof useOrgApplicationCalendarWriteSuspenseQuery>;
export type OrgApplicationCalendarWriteQueryResult = Apollo.QueryResult<OrgApplicationCalendarWriteQuery, OrgApplicationCalendarWriteQueryVariables>;
export const OrgSettingsNavIntegrationsDocument = gql`
    query OrgSettingsNavIntegrations {
  thisOrg {
    id
    integrations {
      id
      greenhouseOauth {
        subdomain
      }
      lever {
        active
      }
      ashby {
        apiKey
      }
      workday {
        tenant
      }
      microsoft {
        active
      }
      microsoftCustom {
        active
      }
      microsoftGccHigh {
        active
      }
      microsoftServiceUser {
        serviceAccountEmail
      }
      google {
        adminUserId
      }
      smartRecruiters {
        active
      }
      gem {
        apiKey
      }
      slack {
        active
      }
      zoom {
        active
      }
      zoomCustom {
        active
      }
      coderpad {
        apiKey
      }
      codility {
        apiKey
      }
      codesignal {
        apiKey
      }
      hackerrank {
        apiKey
      }
    }
  }
}
    `;

/**
 * __useOrgSettingsNavIntegrationsQuery__
 *
 * To run a query within a React component, call `useOrgSettingsNavIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgSettingsNavIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgSettingsNavIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgSettingsNavIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>(OrgSettingsNavIntegrationsDocument, options);
      }
export function useOrgSettingsNavIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>(OrgSettingsNavIntegrationsDocument, options);
        }
// @ts-ignore
export function useOrgSettingsNavIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>;
export function useOrgSettingsNavIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgSettingsNavIntegrationsQuery | undefined, OrgSettingsNavIntegrationsQueryVariables>;
export function useOrgSettingsNavIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>(OrgSettingsNavIntegrationsDocument, options);
        }
export type OrgSettingsNavIntegrationsQueryHookResult = ReturnType<typeof useOrgSettingsNavIntegrationsQuery>;
export type OrgSettingsNavIntegrationsLazyQueryHookResult = ReturnType<typeof useOrgSettingsNavIntegrationsLazyQuery>;
export type OrgSettingsNavIntegrationsSuspenseQueryHookResult = ReturnType<typeof useOrgSettingsNavIntegrationsSuspenseQuery>;
export type OrgSettingsNavIntegrationsQueryResult = Apollo.QueryResult<OrgSettingsNavIntegrationsQuery, OrgSettingsNavIntegrationsQueryVariables>;
export const EditCalendarPreferenceDialogEmployeeByIdsDocument = gql`
    query EditCalendarPreferenceDialogEmployeeByIds($ids: [uuid!]!) {
  employeeByIds(ids: $ids) {
    id
    fullName
    integrations {
      id
      microsoftCustomEmployee {
        active
      }
      microsoft {
        active
      }
      microsoftGccHighEmployee {
        active
      }
    }
  }
}
    `;

/**
 * __useEditCalendarPreferenceDialogEmployeeByIdsQuery__
 *
 * To run a query within a React component, call `useEditCalendarPreferenceDialogEmployeeByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditCalendarPreferenceDialogEmployeeByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditCalendarPreferenceDialogEmployeeByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEditCalendarPreferenceDialogEmployeeByIdsQuery(baseOptions: Apollo.QueryHookOptions<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables> & ({ variables: EditCalendarPreferenceDialogEmployeeByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>(EditCalendarPreferenceDialogEmployeeByIdsDocument, options);
      }
export function useEditCalendarPreferenceDialogEmployeeByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>(EditCalendarPreferenceDialogEmployeeByIdsDocument, options);
        }
// @ts-ignore
export function useEditCalendarPreferenceDialogEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>;
export function useEditCalendarPreferenceDialogEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>): Apollo.UseSuspenseQueryResult<EditCalendarPreferenceDialogEmployeeByIdsQuery | undefined, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>;
export function useEditCalendarPreferenceDialogEmployeeByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>(EditCalendarPreferenceDialogEmployeeByIdsDocument, options);
        }
export type EditCalendarPreferenceDialogEmployeeByIdsQueryHookResult = ReturnType<typeof useEditCalendarPreferenceDialogEmployeeByIdsQuery>;
export type EditCalendarPreferenceDialogEmployeeByIdsLazyQueryHookResult = ReturnType<typeof useEditCalendarPreferenceDialogEmployeeByIdsLazyQuery>;
export type EditCalendarPreferenceDialogEmployeeByIdsSuspenseQueryHookResult = ReturnType<typeof useEditCalendarPreferenceDialogEmployeeByIdsSuspenseQuery>;
export type EditCalendarPreferenceDialogEmployeeByIdsQueryResult = Apollo.QueryResult<EditCalendarPreferenceDialogEmployeeByIdsQuery, EditCalendarPreferenceDialogEmployeeByIdsQueryVariables>;
export const GreenhouseOAuthStatusDocument = gql`
    query GreenhouseOAuthStatus {
  thisOrg {
    id
    integrations {
      id
      greenhouseOauth {
        subdomain
      }
    }
  }
}
    `;

/**
 * __useGreenhouseOAuthStatusQuery__
 *
 * To run a query within a React component, call `useGreenhouseOAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGreenhouseOAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGreenhouseOAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGreenhouseOAuthStatusQuery(baseOptions?: Apollo.QueryHookOptions<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>(GreenhouseOAuthStatusDocument, options);
      }
export function useGreenhouseOAuthStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>(GreenhouseOAuthStatusDocument, options);
        }
// @ts-ignore
export function useGreenhouseOAuthStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>;
export function useGreenhouseOAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GreenhouseOAuthStatusQuery | undefined, GreenhouseOAuthStatusQueryVariables>;
export function useGreenhouseOAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>(GreenhouseOAuthStatusDocument, options);
        }
export type GreenhouseOAuthStatusQueryHookResult = ReturnType<typeof useGreenhouseOAuthStatusQuery>;
export type GreenhouseOAuthStatusLazyQueryHookResult = ReturnType<typeof useGreenhouseOAuthStatusLazyQuery>;
export type GreenhouseOAuthStatusSuspenseQueryHookResult = ReturnType<typeof useGreenhouseOAuthStatusSuspenseQuery>;
export type GreenhouseOAuthStatusQueryResult = Apollo.QueryResult<GreenhouseOAuthStatusQuery, GreenhouseOAuthStatusQueryVariables>;
export const OrgIntegrationsGreenhouseOAuthDocument = gql`
    query OrgIntegrationsGreenhouseOAuth {
  thisOrg {
    id
    integrations {
      id
      greenhouseOauth {
        subdomain
      }
    }
  }
}
    `;

/**
 * __useOrgIntegrationsGreenhouseOAuthQuery__
 *
 * To run a query within a React component, call `useOrgIntegrationsGreenhouseOAuthQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgIntegrationsGreenhouseOAuthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgIntegrationsGreenhouseOAuthQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgIntegrationsGreenhouseOAuthQuery(baseOptions?: Apollo.QueryHookOptions<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>(OrgIntegrationsGreenhouseOAuthDocument, options);
      }
export function useOrgIntegrationsGreenhouseOAuthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>(OrgIntegrationsGreenhouseOAuthDocument, options);
        }
// @ts-ignore
export function useOrgIntegrationsGreenhouseOAuthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>): Apollo.UseSuspenseQueryResult<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>;
export function useOrgIntegrationsGreenhouseOAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>): Apollo.UseSuspenseQueryResult<OrgIntegrationsGreenhouseOAuthQuery | undefined, OrgIntegrationsGreenhouseOAuthQueryVariables>;
export function useOrgIntegrationsGreenhouseOAuthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>(OrgIntegrationsGreenhouseOAuthDocument, options);
        }
export type OrgIntegrationsGreenhouseOAuthQueryHookResult = ReturnType<typeof useOrgIntegrationsGreenhouseOAuthQuery>;
export type OrgIntegrationsGreenhouseOAuthLazyQueryHookResult = ReturnType<typeof useOrgIntegrationsGreenhouseOAuthLazyQuery>;
export type OrgIntegrationsGreenhouseOAuthSuspenseQueryHookResult = ReturnType<typeof useOrgIntegrationsGreenhouseOAuthSuspenseQuery>;
export type OrgIntegrationsGreenhouseOAuthQueryResult = Apollo.QueryResult<OrgIntegrationsGreenhouseOAuthQuery, OrgIntegrationsGreenhouseOAuthQueryVariables>;
export const MicrosoftIntegrationGetOAuthUrlDocument = gql`
    query MicrosoftIntegrationGetOAuthUrl($input: IntegrationGetOauthUrlInput!) {
  integrationGetOauthUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useMicrosoftIntegrationGetOAuthUrlQuery__
 *
 * To run a query within a React component, call `useMicrosoftIntegrationGetOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftIntegrationGetOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftIntegrationGetOAuthUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMicrosoftIntegrationGetOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables> & ({ variables: MicrosoftIntegrationGetOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>(MicrosoftIntegrationGetOAuthUrlDocument, options);
      }
export function useMicrosoftIntegrationGetOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>(MicrosoftIntegrationGetOAuthUrlDocument, options);
        }
// @ts-ignore
export function useMicrosoftIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>;
export function useMicrosoftIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftIntegrationGetOAuthUrlQuery | undefined, MicrosoftIntegrationGetOAuthUrlQueryVariables>;
export function useMicrosoftIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>(MicrosoftIntegrationGetOAuthUrlDocument, options);
        }
export type MicrosoftIntegrationGetOAuthUrlQueryHookResult = ReturnType<typeof useMicrosoftIntegrationGetOAuthUrlQuery>;
export type MicrosoftIntegrationGetOAuthUrlLazyQueryHookResult = ReturnType<typeof useMicrosoftIntegrationGetOAuthUrlLazyQuery>;
export type MicrosoftIntegrationGetOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useMicrosoftIntegrationGetOAuthUrlSuspenseQuery>;
export type MicrosoftIntegrationGetOAuthUrlQueryResult = Apollo.QueryResult<MicrosoftIntegrationGetOAuthUrlQuery, MicrosoftIntegrationGetOAuthUrlQueryVariables>;
export const MicrosoftGccHighIntegrationGetOAuthUrlDocument = gql`
    query MicrosoftGccHighIntegrationGetOAuthUrl($input: IntegrationGetOauthUrlInput!) {
  integrationGetOauthUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useMicrosoftGccHighIntegrationGetOAuthUrlQuery__
 *
 * To run a query within a React component, call `useMicrosoftGccHighIntegrationGetOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftGccHighIntegrationGetOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftGccHighIntegrationGetOAuthUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMicrosoftGccHighIntegrationGetOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables> & ({ variables: MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>(MicrosoftGccHighIntegrationGetOAuthUrlDocument, options);
      }
export function useMicrosoftGccHighIntegrationGetOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>(MicrosoftGccHighIntegrationGetOAuthUrlDocument, options);
        }
// @ts-ignore
export function useMicrosoftGccHighIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>;
export function useMicrosoftGccHighIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftGccHighIntegrationGetOAuthUrlQuery | undefined, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>;
export function useMicrosoftGccHighIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>(MicrosoftGccHighIntegrationGetOAuthUrlDocument, options);
        }
export type MicrosoftGccHighIntegrationGetOAuthUrlQueryHookResult = ReturnType<typeof useMicrosoftGccHighIntegrationGetOAuthUrlQuery>;
export type MicrosoftGccHighIntegrationGetOAuthUrlLazyQueryHookResult = ReturnType<typeof useMicrosoftGccHighIntegrationGetOAuthUrlLazyQuery>;
export type MicrosoftGccHighIntegrationGetOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useMicrosoftGccHighIntegrationGetOAuthUrlSuspenseQuery>;
export type MicrosoftGccHighIntegrationGetOAuthUrlQueryResult = Apollo.QueryResult<MicrosoftGccHighIntegrationGetOAuthUrlQuery, MicrosoftGccHighIntegrationGetOAuthUrlQueryVariables>;
export const MicrosoftServiceUserIntegrationGetOAuthUrlDocument = gql`
    query MicrosoftServiceUserIntegrationGetOAuthUrl($input: IntegrationGetOauthUrlInput!) {
  integrationGetOauthUrl(input: $input) {
    url
  }
}
    `;

/**
 * __useMicrosoftServiceUserIntegrationGetOAuthUrlQuery__
 *
 * To run a query within a React component, call `useMicrosoftServiceUserIntegrationGetOAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMicrosoftServiceUserIntegrationGetOAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMicrosoftServiceUserIntegrationGetOAuthUrlQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMicrosoftServiceUserIntegrationGetOAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables> & ({ variables: MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>(MicrosoftServiceUserIntegrationGetOAuthUrlDocument, options);
      }
export function useMicrosoftServiceUserIntegrationGetOAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>(MicrosoftServiceUserIntegrationGetOAuthUrlDocument, options);
        }
// @ts-ignore
export function useMicrosoftServiceUserIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>;
export function useMicrosoftServiceUserIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<MicrosoftServiceUserIntegrationGetOAuthUrlQuery | undefined, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>;
export function useMicrosoftServiceUserIntegrationGetOAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>(MicrosoftServiceUserIntegrationGetOAuthUrlDocument, options);
        }
export type MicrosoftServiceUserIntegrationGetOAuthUrlQueryHookResult = ReturnType<typeof useMicrosoftServiceUserIntegrationGetOAuthUrlQuery>;
export type MicrosoftServiceUserIntegrationGetOAuthUrlLazyQueryHookResult = ReturnType<typeof useMicrosoftServiceUserIntegrationGetOAuthUrlLazyQuery>;
export type MicrosoftServiceUserIntegrationGetOAuthUrlSuspenseQueryHookResult = ReturnType<typeof useMicrosoftServiceUserIntegrationGetOAuthUrlSuspenseQuery>;
export type MicrosoftServiceUserIntegrationGetOAuthUrlQueryResult = Apollo.QueryResult<MicrosoftServiceUserIntegrationGetOAuthUrlQuery, MicrosoftServiceUserIntegrationGetOAuthUrlQueryVariables>;
export const DisconnectAtsDialogDocument = gql`
    query DisconnectAtsDialog {
  thisOrg {
    upcomingInterviewsCount
    activeCandidateAvailabilityLinksCount
    activeSelfScheduleLinksCount
  }
}
    `;

/**
 * __useDisconnectAtsDialogQuery__
 *
 * To run a query within a React component, call `useDisconnectAtsDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisconnectAtsDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisconnectAtsDialogQuery({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectAtsDialogQuery(baseOptions?: Apollo.QueryHookOptions<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>(DisconnectAtsDialogDocument, options);
      }
export function useDisconnectAtsDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>(DisconnectAtsDialogDocument, options);
        }
// @ts-ignore
export function useDisconnectAtsDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>): Apollo.UseSuspenseQueryResult<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>;
export function useDisconnectAtsDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>): Apollo.UseSuspenseQueryResult<DisconnectAtsDialogQuery | undefined, DisconnectAtsDialogQueryVariables>;
export function useDisconnectAtsDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>(DisconnectAtsDialogDocument, options);
        }
export type DisconnectAtsDialogQueryHookResult = ReturnType<typeof useDisconnectAtsDialogQuery>;
export type DisconnectAtsDialogLazyQueryHookResult = ReturnType<typeof useDisconnectAtsDialogLazyQuery>;
export type DisconnectAtsDialogSuspenseQueryHookResult = ReturnType<typeof useDisconnectAtsDialogSuspenseQuery>;
export type DisconnectAtsDialogQueryResult = Apollo.QueryResult<DisconnectAtsDialogQuery, DisconnectAtsDialogQueryVariables>;
export const OrgDomainsDocument = gql`
    query OrgDomains {
  thisOrg {
    id
    domains
  }
}
    `;

/**
 * __useOrgDomainsQuery__
 *
 * To run a query within a React component, call `useOrgDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgDomainsQuery(baseOptions?: Apollo.QueryHookOptions<OrgDomainsQuery, OrgDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgDomainsQuery, OrgDomainsQueryVariables>(OrgDomainsDocument, options);
      }
export function useOrgDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgDomainsQuery, OrgDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgDomainsQuery, OrgDomainsQueryVariables>(OrgDomainsDocument, options);
        }
// @ts-ignore
export function useOrgDomainsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgDomainsQuery, OrgDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgDomainsQuery, OrgDomainsQueryVariables>;
export function useOrgDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgDomainsQuery, OrgDomainsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgDomainsQuery | undefined, OrgDomainsQueryVariables>;
export function useOrgDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgDomainsQuery, OrgDomainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgDomainsQuery, OrgDomainsQueryVariables>(OrgDomainsDocument, options);
        }
export type OrgDomainsQueryHookResult = ReturnType<typeof useOrgDomainsQuery>;
export type OrgDomainsLazyQueryHookResult = ReturnType<typeof useOrgDomainsLazyQuery>;
export type OrgDomainsSuspenseQueryHookResult = ReturnType<typeof useOrgDomainsSuspenseQuery>;
export type OrgDomainsQueryResult = Apollo.QueryResult<OrgDomainsQuery, OrgDomainsQueryVariables>;
export const AtsRemoteDepartmentsDocument = gql`
    query AtsRemoteDepartments($input: AtsRemoteListsInput) {
  atsRemoteDepartments(input: $input) {
    __typename
    ... on AtsRemoteDepartmentsSuccess {
      items {
        id
        name
        parentId
      }
    }
    ... on AtsRemoteDepartmentsInsufficientScopeError {
      scope
    }
    ... on AtsRemoteDepartmentsNotConnectedError {
      errorMessage
    }
    ... on AtsRemoteDepartmentsAccessDeniedError {
      errorMessage
    }
    ... on UnknownError {
      errorMessage
    }
  }
}
    `;

/**
 * __useAtsRemoteDepartmentsQuery__
 *
 * To run a query within a React component, call `useAtsRemoteDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsRemoteDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsRemoteDepartmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsRemoteDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>(AtsRemoteDepartmentsDocument, options);
      }
export function useAtsRemoteDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>(AtsRemoteDepartmentsDocument, options);
        }
// @ts-ignore
export function useAtsRemoteDepartmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>;
export function useAtsRemoteDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsRemoteDepartmentsQuery | undefined, AtsRemoteDepartmentsQueryVariables>;
export function useAtsRemoteDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>(AtsRemoteDepartmentsDocument, options);
        }
export type AtsRemoteDepartmentsQueryHookResult = ReturnType<typeof useAtsRemoteDepartmentsQuery>;
export type AtsRemoteDepartmentsLazyQueryHookResult = ReturnType<typeof useAtsRemoteDepartmentsLazyQuery>;
export type AtsRemoteDepartmentsSuspenseQueryHookResult = ReturnType<typeof useAtsRemoteDepartmentsSuspenseQuery>;
export type AtsRemoteDepartmentsQueryResult = Apollo.QueryResult<AtsRemoteDepartmentsQuery, AtsRemoteDepartmentsQueryVariables>;
export const AtsRemoteOfficesDocument = gql`
    query AtsRemoteOffices($input: AtsRemoteListsInput) {
  atsRemoteOffices(input: $input) {
    __typename
    ... on AtsRemoteOfficesSuccess {
      items {
        id
        name
        parentId
        location
      }
    }
    ... on AtsRemoteOfficesInsufficientScopeError {
      scope
    }
    ... on AtsRemoteOfficesNotConnectedError {
      errorMessage
    }
    ... on AtsRemoteOfficesAccessDeniedError {
      errorMessage
    }
    ... on UnknownError {
      errorMessage
    }
  }
}
    `;

/**
 * __useAtsRemoteOfficesQuery__
 *
 * To run a query within a React component, call `useAtsRemoteOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsRemoteOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsRemoteOfficesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsRemoteOfficesQuery(baseOptions?: Apollo.QueryHookOptions<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>(AtsRemoteOfficesDocument, options);
      }
export function useAtsRemoteOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>(AtsRemoteOfficesDocument, options);
        }
// @ts-ignore
export function useAtsRemoteOfficesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>): Apollo.UseSuspenseQueryResult<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>;
export function useAtsRemoteOfficesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>): Apollo.UseSuspenseQueryResult<AtsRemoteOfficesQuery | undefined, AtsRemoteOfficesQueryVariables>;
export function useAtsRemoteOfficesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>(AtsRemoteOfficesDocument, options);
        }
export type AtsRemoteOfficesQueryHookResult = ReturnType<typeof useAtsRemoteOfficesQuery>;
export type AtsRemoteOfficesLazyQueryHookResult = ReturnType<typeof useAtsRemoteOfficesLazyQuery>;
export type AtsRemoteOfficesSuspenseQueryHookResult = ReturnType<typeof useAtsRemoteOfficesSuspenseQuery>;
export type AtsRemoteOfficesQueryResult = Apollo.QueryResult<AtsRemoteOfficesQuery, AtsRemoteOfficesQueryVariables>;
export const AtsRemoteJobsDocument = gql`
    query AtsRemoteJobs($input: AtsRemoteJobsInput!) {
  atsRemoteJobs(input: $input) {
    __typename
    ... on AtsRemoteJobsSuccess {
      items {
        id
        name
        status
        departmentId
        officeIds
      }
    }
    ... on AtsRemoteJobsInsufficientScopeError {
      scope
    }
    ... on AtsRemoteJobsNotConnectedError {
      errorMessage
    }
    ... on AtsRemoteJobsAccessDeniedError {
      errorMessage
    }
    ... on UnknownError {
      errorMessage
    }
  }
}
    `;

/**
 * __useAtsRemoteJobsQuery__
 *
 * To run a query within a React component, call `useAtsRemoteJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAtsRemoteJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtsRemoteJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsRemoteJobsQuery(baseOptions: Apollo.QueryHookOptions<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables> & ({ variables: AtsRemoteJobsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>(AtsRemoteJobsDocument, options);
      }
export function useAtsRemoteJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>(AtsRemoteJobsDocument, options);
        }
// @ts-ignore
export function useAtsRemoteJobsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>;
export function useAtsRemoteJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>): Apollo.UseSuspenseQueryResult<AtsRemoteJobsQuery | undefined, AtsRemoteJobsQueryVariables>;
export function useAtsRemoteJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>(AtsRemoteJobsDocument, options);
        }
export type AtsRemoteJobsQueryHookResult = ReturnType<typeof useAtsRemoteJobsQuery>;
export type AtsRemoteJobsLazyQueryHookResult = ReturnType<typeof useAtsRemoteJobsLazyQuery>;
export type AtsRemoteJobsSuspenseQueryHookResult = ReturnType<typeof useAtsRemoteJobsSuspenseQuery>;
export type AtsRemoteJobsQueryResult = Apollo.QueryResult<AtsRemoteJobsQuery, AtsRemoteJobsQueryVariables>;
export const AtsJobSyncScopeUpdateDocument = gql`
    mutation AtsJobSyncScopeUpdate($input: AtsJobSyncScopeUpdateInput!) {
  atsJobSyncScopeUpdate(input: $input) {
    __typename
    ... on AtsJobSyncScopeUpdateSuccess {
      scope {
        __typename
        departments {
          ids
        }
        offices {
          ids
        }
        jobs {
          ids
        }
      }
    }
    ... on AtsJobSyncScopeUpdateInvalidSelectionError {
      errorMessage
    }
    ... on AtsJobSyncScopeUpdateNotConnectedError {
      errorMessage
    }
    ... on UnknownError {
      errorMessage
    }
  }
}
    `;
export type AtsJobSyncScopeUpdateMutationFn = Apollo.MutationFunction<AtsJobSyncScopeUpdateMutation, AtsJobSyncScopeUpdateMutationVariables>;

/**
 * __useAtsJobSyncScopeUpdateMutation__
 *
 * To run a mutation, you first call `useAtsJobSyncScopeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAtsJobSyncScopeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [atsJobSyncScopeUpdateMutation, { data, loading, error }] = useAtsJobSyncScopeUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAtsJobSyncScopeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AtsJobSyncScopeUpdateMutation, AtsJobSyncScopeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AtsJobSyncScopeUpdateMutation, AtsJobSyncScopeUpdateMutationVariables>(AtsJobSyncScopeUpdateDocument, options);
      }
export type AtsJobSyncScopeUpdateMutationHookResult = ReturnType<typeof useAtsJobSyncScopeUpdateMutation>;
export type AtsJobSyncScopeUpdateMutationResult = Apollo.MutationResult<AtsJobSyncScopeUpdateMutation>;
export type AtsJobSyncScopeUpdateMutationOptions = Apollo.BaseMutationOptions<AtsJobSyncScopeUpdateMutation, AtsJobSyncScopeUpdateMutationVariables>;
export const AttributeChangeSyncSourceTypeUpdateDocument = gql`
    mutation AttributeChangeSyncSourceTypeUpdate($input: EmployeeAttributeNameUpdateInput!) {
  employeeAttributeNameUpdate(input: $input) {
    id
    ...AttributeChangeSyncSourceTypeDialog_attribute
  }
}
    ${AttributeChangeSyncSourceTypeDialog_AttributeFragmentDoc}`;
export type AttributeChangeSyncSourceTypeUpdateMutationFn = Apollo.MutationFunction<AttributeChangeSyncSourceTypeUpdateMutation, AttributeChangeSyncSourceTypeUpdateMutationVariables>;

/**
 * __useAttributeChangeSyncSourceTypeUpdateMutation__
 *
 * To run a mutation, you first call `useAttributeChangeSyncSourceTypeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeChangeSyncSourceTypeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeChangeSyncSourceTypeUpdateMutation, { data, loading, error }] = useAttributeChangeSyncSourceTypeUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeChangeSyncSourceTypeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AttributeChangeSyncSourceTypeUpdateMutation, AttributeChangeSyncSourceTypeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeChangeSyncSourceTypeUpdateMutation, AttributeChangeSyncSourceTypeUpdateMutationVariables>(AttributeChangeSyncSourceTypeUpdateDocument, options);
      }
export type AttributeChangeSyncSourceTypeUpdateMutationHookResult = ReturnType<typeof useAttributeChangeSyncSourceTypeUpdateMutation>;
export type AttributeChangeSyncSourceTypeUpdateMutationResult = Apollo.MutationResult<AttributeChangeSyncSourceTypeUpdateMutation>;
export type AttributeChangeSyncSourceTypeUpdateMutationOptions = Apollo.BaseMutationOptions<AttributeChangeSyncSourceTypeUpdateMutation, AttributeChangeSyncSourceTypeUpdateMutationVariables>;
export const AttributeDetailsDialogCreateAttributeNameDocument = gql`
    mutation AttributeDetailsDialogCreateAttributeName($input: EmployeeAttributeNameCreateInput!) {
  employeeAttributeNameCreate(input: $input) {
    id
    ...AttributeDetailsDialog_attribute
  }
}
    ${AttributeDetailsDialog_AttributeFragmentDoc}`;
export type AttributeDetailsDialogCreateAttributeNameMutationFn = Apollo.MutationFunction<AttributeDetailsDialogCreateAttributeNameMutation, AttributeDetailsDialogCreateAttributeNameMutationVariables>;

/**
 * __useAttributeDetailsDialogCreateAttributeNameMutation__
 *
 * To run a mutation, you first call `useAttributeDetailsDialogCreateAttributeNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeDetailsDialogCreateAttributeNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeDetailsDialogCreateAttributeNameMutation, { data, loading, error }] = useAttributeDetailsDialogCreateAttributeNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeDetailsDialogCreateAttributeNameMutation(baseOptions?: Apollo.MutationHookOptions<AttributeDetailsDialogCreateAttributeNameMutation, AttributeDetailsDialogCreateAttributeNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeDetailsDialogCreateAttributeNameMutation, AttributeDetailsDialogCreateAttributeNameMutationVariables>(AttributeDetailsDialogCreateAttributeNameDocument, options);
      }
export type AttributeDetailsDialogCreateAttributeNameMutationHookResult = ReturnType<typeof useAttributeDetailsDialogCreateAttributeNameMutation>;
export type AttributeDetailsDialogCreateAttributeNameMutationResult = Apollo.MutationResult<AttributeDetailsDialogCreateAttributeNameMutation>;
export type AttributeDetailsDialogCreateAttributeNameMutationOptions = Apollo.BaseMutationOptions<AttributeDetailsDialogCreateAttributeNameMutation, AttributeDetailsDialogCreateAttributeNameMutationVariables>;
export const AttributeDetailsDialogUpdateAttributeNameDocument = gql`
    mutation AttributeDetailsDialogUpdateAttributeName($input: EmployeeAttributeNameUpdateInput!) {
  employeeAttributeNameUpdate(input: $input) {
    id
    ...AttributeDetailsDialog_attribute
  }
}
    ${AttributeDetailsDialog_AttributeFragmentDoc}`;
export type AttributeDetailsDialogUpdateAttributeNameMutationFn = Apollo.MutationFunction<AttributeDetailsDialogUpdateAttributeNameMutation, AttributeDetailsDialogUpdateAttributeNameMutationVariables>;

/**
 * __useAttributeDetailsDialogUpdateAttributeNameMutation__
 *
 * To run a mutation, you first call `useAttributeDetailsDialogUpdateAttributeNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeDetailsDialogUpdateAttributeNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeDetailsDialogUpdateAttributeNameMutation, { data, loading, error }] = useAttributeDetailsDialogUpdateAttributeNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeDetailsDialogUpdateAttributeNameMutation(baseOptions?: Apollo.MutationHookOptions<AttributeDetailsDialogUpdateAttributeNameMutation, AttributeDetailsDialogUpdateAttributeNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeDetailsDialogUpdateAttributeNameMutation, AttributeDetailsDialogUpdateAttributeNameMutationVariables>(AttributeDetailsDialogUpdateAttributeNameDocument, options);
      }
export type AttributeDetailsDialogUpdateAttributeNameMutationHookResult = ReturnType<typeof useAttributeDetailsDialogUpdateAttributeNameMutation>;
export type AttributeDetailsDialogUpdateAttributeNameMutationResult = Apollo.MutationResult<AttributeDetailsDialogUpdateAttributeNameMutation>;
export type AttributeDetailsDialogUpdateAttributeNameMutationOptions = Apollo.BaseMutationOptions<AttributeDetailsDialogUpdateAttributeNameMutation, AttributeDetailsDialogUpdateAttributeNameMutationVariables>;
export const AttributeValueDeleteDocument = gql`
    mutation AttributeValueDelete($input: EmployeeAttributeValueDeleteInput!) {
  employeeAttributeValueDelete(input: $input) {
    id
  }
}
    `;
export type AttributeValueDeleteMutationFn = Apollo.MutationFunction<AttributeValueDeleteMutation, AttributeValueDeleteMutationVariables>;

/**
 * __useAttributeValueDeleteMutation__
 *
 * To run a mutation, you first call `useAttributeValueDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeValueDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeValueDeleteMutation, { data, loading, error }] = useAttributeValueDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeValueDeleteMutation(baseOptions?: Apollo.MutationHookOptions<AttributeValueDeleteMutation, AttributeValueDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeValueDeleteMutation, AttributeValueDeleteMutationVariables>(AttributeValueDeleteDocument, options);
      }
export type AttributeValueDeleteMutationHookResult = ReturnType<typeof useAttributeValueDeleteMutation>;
export type AttributeValueDeleteMutationResult = Apollo.MutationResult<AttributeValueDeleteMutation>;
export type AttributeValueDeleteMutationOptions = Apollo.BaseMutationOptions<AttributeValueDeleteMutation, AttributeValueDeleteMutationVariables>;
export const AttributeValueDetailsCreateDocument = gql`
    mutation AttributeValueDetailsCreate($input: EmployeeAttributeValueCreateInput!) {
  employeeAttributeValueCreate(input: $input) {
    id
    ...AttributeValueDetailsDialog_attributeValue
  }
}
    ${AttributeValueDetailsDialog_AttributeValueFragmentDoc}`;
export type AttributeValueDetailsCreateMutationFn = Apollo.MutationFunction<AttributeValueDetailsCreateMutation, AttributeValueDetailsCreateMutationVariables>;

/**
 * __useAttributeValueDetailsCreateMutation__
 *
 * To run a mutation, you first call `useAttributeValueDetailsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeValueDetailsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeValueDetailsCreateMutation, { data, loading, error }] = useAttributeValueDetailsCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeValueDetailsCreateMutation(baseOptions?: Apollo.MutationHookOptions<AttributeValueDetailsCreateMutation, AttributeValueDetailsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeValueDetailsCreateMutation, AttributeValueDetailsCreateMutationVariables>(AttributeValueDetailsCreateDocument, options);
      }
export type AttributeValueDetailsCreateMutationHookResult = ReturnType<typeof useAttributeValueDetailsCreateMutation>;
export type AttributeValueDetailsCreateMutationResult = Apollo.MutationResult<AttributeValueDetailsCreateMutation>;
export type AttributeValueDetailsCreateMutationOptions = Apollo.BaseMutationOptions<AttributeValueDetailsCreateMutation, AttributeValueDetailsCreateMutationVariables>;
export const AttributeValueDetailsUpdateDocument = gql`
    mutation AttributeValueDetailsUpdate($input: EmployeeAttributeValueUpdateInput!) {
  employeeAttributeValueUpdate(input: $input) {
    id
    ...AttributeValueDetailsDialog_attributeValue
  }
}
    ${AttributeValueDetailsDialog_AttributeValueFragmentDoc}`;
export type AttributeValueDetailsUpdateMutationFn = Apollo.MutationFunction<AttributeValueDetailsUpdateMutation, AttributeValueDetailsUpdateMutationVariables>;

/**
 * __useAttributeValueDetailsUpdateMutation__
 *
 * To run a mutation, you first call `useAttributeValueDetailsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeValueDetailsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeValueDetailsUpdateMutation, { data, loading, error }] = useAttributeValueDetailsUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeValueDetailsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AttributeValueDetailsUpdateMutation, AttributeValueDetailsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeValueDetailsUpdateMutation, AttributeValueDetailsUpdateMutationVariables>(AttributeValueDetailsUpdateDocument, options);
      }
export type AttributeValueDetailsUpdateMutationHookResult = ReturnType<typeof useAttributeValueDetailsUpdateMutation>;
export type AttributeValueDetailsUpdateMutationResult = Apollo.MutationResult<AttributeValueDetailsUpdateMutation>;
export type AttributeValueDetailsUpdateMutationOptions = Apollo.BaseMutationOptions<AttributeValueDetailsUpdateMutation, AttributeValueDetailsUpdateMutationVariables>;
export const AttributeValueDetailsEmployeesUpsertDocument = gql`
    mutation AttributeValueDetailsEmployeesUpsert($input: AttributeValueEmployeesInput!) {
  attributeValueEmployeesUpsert(input: $input) {
    employee {
      id
    }
  }
}
    `;
export type AttributeValueDetailsEmployeesUpsertMutationFn = Apollo.MutationFunction<AttributeValueDetailsEmployeesUpsertMutation, AttributeValueDetailsEmployeesUpsertMutationVariables>;

/**
 * __useAttributeValueDetailsEmployeesUpsertMutation__
 *
 * To run a mutation, you first call `useAttributeValueDetailsEmployeesUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributeValueDetailsEmployeesUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributeValueDetailsEmployeesUpsertMutation, { data, loading, error }] = useAttributeValueDetailsEmployeesUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributeValueDetailsEmployeesUpsertMutation(baseOptions?: Apollo.MutationHookOptions<AttributeValueDetailsEmployeesUpsertMutation, AttributeValueDetailsEmployeesUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributeValueDetailsEmployeesUpsertMutation, AttributeValueDetailsEmployeesUpsertMutationVariables>(AttributeValueDetailsEmployeesUpsertDocument, options);
      }
export type AttributeValueDetailsEmployeesUpsertMutationHookResult = ReturnType<typeof useAttributeValueDetailsEmployeesUpsertMutation>;
export type AttributeValueDetailsEmployeesUpsertMutationResult = Apollo.MutationResult<AttributeValueDetailsEmployeesUpsertMutation>;
export type AttributeValueDetailsEmployeesUpsertMutationOptions = Apollo.BaseMutationOptions<AttributeValueDetailsEmployeesUpsertMutation, AttributeValueDetailsEmployeesUpsertMutationVariables>;
export const CustomAttributesTabDocument = gql`
    query CustomAttributesTab($types: [AttributeNameType]) {
  employeeAttributeNames(input: {types: $types}) {
    items {
      id
      ...Attributes_attributes
    }
  }
  thisOrg {
    id
    hasScim
  }
}
    ${Attributes_AttributesFragmentDoc}`;

/**
 * __useCustomAttributesTabQuery__
 *
 * To run a query within a React component, call `useCustomAttributesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomAttributesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomAttributesTabQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useCustomAttributesTabQuery(baseOptions?: Apollo.QueryHookOptions<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>(CustomAttributesTabDocument, options);
      }
export function useCustomAttributesTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>(CustomAttributesTabDocument, options);
        }
// @ts-ignore
export function useCustomAttributesTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>): Apollo.UseSuspenseQueryResult<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>;
export function useCustomAttributesTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>): Apollo.UseSuspenseQueryResult<CustomAttributesTabQuery | undefined, CustomAttributesTabQueryVariables>;
export function useCustomAttributesTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>(CustomAttributesTabDocument, options);
        }
export type CustomAttributesTabQueryHookResult = ReturnType<typeof useCustomAttributesTabQuery>;
export type CustomAttributesTabLazyQueryHookResult = ReturnType<typeof useCustomAttributesTabLazyQuery>;
export type CustomAttributesTabSuspenseQueryHookResult = ReturnType<typeof useCustomAttributesTabSuspenseQuery>;
export type CustomAttributesTabQueryResult = Apollo.QueryResult<CustomAttributesTabQuery, CustomAttributesTabQueryVariables>;
export const DeleteAllAttributeValuesDocument = gql`
    mutation DeleteAllAttributeValues($input: EmployeeAttributeValueDeleteInput!) {
  employeeAttributeValueDelete(input: $input) {
    id
  }
}
    `;
export type DeleteAllAttributeValuesMutationFn = Apollo.MutationFunction<DeleteAllAttributeValuesMutation, DeleteAllAttributeValuesMutationVariables>;

/**
 * __useDeleteAllAttributeValuesMutation__
 *
 * To run a mutation, you first call `useDeleteAllAttributeValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllAttributeValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllAttributeValuesMutation, { data, loading, error }] = useDeleteAllAttributeValuesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllAttributeValuesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllAttributeValuesMutation, DeleteAllAttributeValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllAttributeValuesMutation, DeleteAllAttributeValuesMutationVariables>(DeleteAllAttributeValuesDocument, options);
      }
export type DeleteAllAttributeValuesMutationHookResult = ReturnType<typeof useDeleteAllAttributeValuesMutation>;
export type DeleteAllAttributeValuesMutationResult = Apollo.MutationResult<DeleteAllAttributeValuesMutation>;
export type DeleteAllAttributeValuesMutationOptions = Apollo.BaseMutationOptions<DeleteAllAttributeValuesMutation, DeleteAllAttributeValuesMutationVariables>;
export const DeleteAttributeDialogAttributeDeleteDocument = gql`
    mutation DeleteAttributeDialogAttributeDelete($input: EmployeeAttributeNameDeleteInput!) {
  employeeAttributeNameDelete(input: $input) {
    id
  }
}
    `;
export type DeleteAttributeDialogAttributeDeleteMutationFn = Apollo.MutationFunction<DeleteAttributeDialogAttributeDeleteMutation, DeleteAttributeDialogAttributeDeleteMutationVariables>;

/**
 * __useDeleteAttributeDialogAttributeDeleteMutation__
 *
 * To run a mutation, you first call `useDeleteAttributeDialogAttributeDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributeDialogAttributeDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributeDialogAttributeDeleteMutation, { data, loading, error }] = useDeleteAttributeDialogAttributeDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAttributeDialogAttributeDeleteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributeDialogAttributeDeleteMutation, DeleteAttributeDialogAttributeDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributeDialogAttributeDeleteMutation, DeleteAttributeDialogAttributeDeleteMutationVariables>(DeleteAttributeDialogAttributeDeleteDocument, options);
      }
export type DeleteAttributeDialogAttributeDeleteMutationHookResult = ReturnType<typeof useDeleteAttributeDialogAttributeDeleteMutation>;
export type DeleteAttributeDialogAttributeDeleteMutationResult = Apollo.MutationResult<DeleteAttributeDialogAttributeDeleteMutation>;
export type DeleteAttributeDialogAttributeDeleteMutationOptions = Apollo.BaseMutationOptions<DeleteAttributeDialogAttributeDeleteMutation, DeleteAttributeDialogAttributeDeleteMutationVariables>;
export const InterviewerFieldsDocument = gql`
    query InterviewerFields {
  thisOrg {
    id
    hasScim
    totalEmployees
  }
}
    `;

/**
 * __useInterviewerFieldsQuery__
 *
 * To run a query within a React component, call `useInterviewerFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewerFieldsQuery(baseOptions?: Apollo.QueryHookOptions<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>(InterviewerFieldsDocument, options);
      }
export function useInterviewerFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>(InterviewerFieldsDocument, options);
        }
// @ts-ignore
export function useInterviewerFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>;
export function useInterviewerFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerFieldsQuery | undefined, InterviewerFieldsQueryVariables>;
export function useInterviewerFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>(InterviewerFieldsDocument, options);
        }
export type InterviewerFieldsQueryHookResult = ReturnType<typeof useInterviewerFieldsQuery>;
export type InterviewerFieldsLazyQueryHookResult = ReturnType<typeof useInterviewerFieldsLazyQuery>;
export type InterviewerFieldsSuspenseQueryHookResult = ReturnType<typeof useInterviewerFieldsSuspenseQuery>;
export type InterviewerFieldsQueryResult = Apollo.QueryResult<InterviewerFieldsQuery, InterviewerFieldsQueryVariables>;
export const InterviewerFieldsClearForAllInterviewersDocument = gql`
    mutation InterviewerFieldsClearForAllInterviewers($input: EmployeeBulkUpdateInput!) {
  employeeBulkUpdate(input: $input) {
    result
  }
}
    `;
export type InterviewerFieldsClearForAllInterviewersMutationFn = Apollo.MutationFunction<InterviewerFieldsClearForAllInterviewersMutation, InterviewerFieldsClearForAllInterviewersMutationVariables>;

/**
 * __useInterviewerFieldsClearForAllInterviewersMutation__
 *
 * To run a mutation, you first call `useInterviewerFieldsClearForAllInterviewersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInterviewerFieldsClearForAllInterviewersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [interviewerFieldsClearForAllInterviewersMutation, { data, loading, error }] = useInterviewerFieldsClearForAllInterviewersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInterviewerFieldsClearForAllInterviewersMutation(baseOptions?: Apollo.MutationHookOptions<InterviewerFieldsClearForAllInterviewersMutation, InterviewerFieldsClearForAllInterviewersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InterviewerFieldsClearForAllInterviewersMutation, InterviewerFieldsClearForAllInterviewersMutationVariables>(InterviewerFieldsClearForAllInterviewersDocument, options);
      }
export type InterviewerFieldsClearForAllInterviewersMutationHookResult = ReturnType<typeof useInterviewerFieldsClearForAllInterviewersMutation>;
export type InterviewerFieldsClearForAllInterviewersMutationResult = Apollo.MutationResult<InterviewerFieldsClearForAllInterviewersMutation>;
export type InterviewerFieldsClearForAllInterviewersMutationOptions = Apollo.BaseMutationOptions<InterviewerFieldsClearForAllInterviewersMutation, InterviewerFieldsClearForAllInterviewersMutationVariables>;
export const WorkInfoTabDocument = gql`
    query WorkInfoTab($types: [AttributeNameType]) {
  employeeAttributeNames(input: {types: $types}) {
    items {
      id
      ...Attributes_attributes
    }
  }
  thisOrg {
    id
    hasScim
  }
}
    ${Attributes_AttributesFragmentDoc}`;

/**
 * __useWorkInfoTabQuery__
 *
 * To run a query within a React component, call `useWorkInfoTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkInfoTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkInfoTabQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useWorkInfoTabQuery(baseOptions?: Apollo.QueryHookOptions<WorkInfoTabQuery, WorkInfoTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkInfoTabQuery, WorkInfoTabQueryVariables>(WorkInfoTabDocument, options);
      }
export function useWorkInfoTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkInfoTabQuery, WorkInfoTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkInfoTabQuery, WorkInfoTabQueryVariables>(WorkInfoTabDocument, options);
        }
// @ts-ignore
export function useWorkInfoTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkInfoTabQuery, WorkInfoTabQueryVariables>): Apollo.UseSuspenseQueryResult<WorkInfoTabQuery, WorkInfoTabQueryVariables>;
export function useWorkInfoTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkInfoTabQuery, WorkInfoTabQueryVariables>): Apollo.UseSuspenseQueryResult<WorkInfoTabQuery | undefined, WorkInfoTabQueryVariables>;
export function useWorkInfoTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkInfoTabQuery, WorkInfoTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkInfoTabQuery, WorkInfoTabQueryVariables>(WorkInfoTabDocument, options);
        }
export type WorkInfoTabQueryHookResult = ReturnType<typeof useWorkInfoTabQuery>;
export type WorkInfoTabLazyQueryHookResult = ReturnType<typeof useWorkInfoTabLazyQuery>;
export type WorkInfoTabSuspenseQueryHookResult = ReturnType<typeof useWorkInfoTabSuspenseQuery>;
export type WorkInfoTabQueryResult = Apollo.QueryResult<WorkInfoTabQuery, WorkInfoTabQueryVariables>;
export const InterviewerPortalTabDocument = gql`
    query InterviewerPortalTab {
  thisOrg {
    id
    interviewerPortalSettings {
      ...InterviewerPortalSettings
    }
    orgPref(prefName: "obj_employee_field_sync_source") {
      id
      orgId
      prefName
      jsonPref {
        ... on EmployeeFieldSyncSourcePref {
          name
          title
          linkedInUrl
        }
      }
    }
  }
}
    ${InterviewerPortalSettingsFragmentDoc}`;

/**
 * __useInterviewerPortalTabQuery__
 *
 * To run a query within a React component, call `useInterviewerPortalTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerPortalTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerPortalTabQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewerPortalTabQuery(baseOptions?: Apollo.QueryHookOptions<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>(InterviewerPortalTabDocument, options);
      }
export function useInterviewerPortalTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>(InterviewerPortalTabDocument, options);
        }
// @ts-ignore
export function useInterviewerPortalTabSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>;
export function useInterviewerPortalTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerPortalTabQuery | undefined, InterviewerPortalTabQueryVariables>;
export function useInterviewerPortalTabSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>(InterviewerPortalTabDocument, options);
        }
export type InterviewerPortalTabQueryHookResult = ReturnType<typeof useInterviewerPortalTabQuery>;
export type InterviewerPortalTabLazyQueryHookResult = ReturnType<typeof useInterviewerPortalTabLazyQuery>;
export type InterviewerPortalTabSuspenseQueryHookResult = ReturnType<typeof useInterviewerPortalTabSuspenseQuery>;
export type InterviewerPortalTabQueryResult = Apollo.QueryResult<InterviewerPortalTabQuery, InterviewerPortalTabQueryVariables>;
export const UpdateInterviewPortalSettingDocument = gql`
    mutation UpdateInterviewPortalSetting($input: InterviewerPortalSettingsUpsertInput!) {
  interviewerPortalSettingsUpsert(input: $input) {
    ...InterviewerPortalSettings
  }
}
    ${InterviewerPortalSettingsFragmentDoc}`;
export type UpdateInterviewPortalSettingMutationFn = Apollo.MutationFunction<UpdateInterviewPortalSettingMutation, UpdateInterviewPortalSettingMutationVariables>;

/**
 * __useUpdateInterviewPortalSettingMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewPortalSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewPortalSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewPortalSettingMutation, { data, loading, error }] = useUpdateInterviewPortalSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewPortalSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewPortalSettingMutation, UpdateInterviewPortalSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewPortalSettingMutation, UpdateInterviewPortalSettingMutationVariables>(UpdateInterviewPortalSettingDocument, options);
      }
export type UpdateInterviewPortalSettingMutationHookResult = ReturnType<typeof useUpdateInterviewPortalSettingMutation>;
export type UpdateInterviewPortalSettingMutationResult = Apollo.MutationResult<UpdateInterviewPortalSettingMutation>;
export type UpdateInterviewPortalSettingMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewPortalSettingMutation, UpdateInterviewPortalSettingMutationVariables>;
export const AdditionalPermissionsSaveDocument = gql`
    mutation AdditionalPermissionsSave($input: OrgMemberSetAdditionalPermissionsInput!) {
  orgMemberSetAdditionalPermissions(input: $input) {
    __typename
    ... on OrgMemberSetAdditionalPermissionsSuccess {
      userInfo {
        userId
        role
        additionalPermissions
      }
    }
    ... on OrgMemberSetAdditionalPermissionsInterviewerError {
      errorCode
      errorMessage
    }
    ... on OrgMemberSetAdditionalPermissionsNotFoundError {
      errorCode
      errorMessage
    }
    ... on OrgMemberSetAdditionalPermissionsPermissionDeniedError {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type AdditionalPermissionsSaveMutationFn = Apollo.MutationFunction<AdditionalPermissionsSaveMutation, AdditionalPermissionsSaveMutationVariables>;

/**
 * __useAdditionalPermissionsSaveMutation__
 *
 * To run a mutation, you first call `useAdditionalPermissionsSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdditionalPermissionsSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [additionalPermissionsSaveMutation, { data, loading, error }] = useAdditionalPermissionsSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdditionalPermissionsSaveMutation(baseOptions?: Apollo.MutationHookOptions<AdditionalPermissionsSaveMutation, AdditionalPermissionsSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdditionalPermissionsSaveMutation, AdditionalPermissionsSaveMutationVariables>(AdditionalPermissionsSaveDocument, options);
      }
export type AdditionalPermissionsSaveMutationHookResult = ReturnType<typeof useAdditionalPermissionsSaveMutation>;
export type AdditionalPermissionsSaveMutationResult = Apollo.MutationResult<AdditionalPermissionsSaveMutation>;
export type AdditionalPermissionsSaveMutationOptions = Apollo.BaseMutationOptions<AdditionalPermissionsSaveMutation, AdditionalPermissionsSaveMutationVariables>;
export const InviteByEmailUsersInviteDocument = gql`
    mutation InviteByEmailUsersInvite($users: [UserInviteInput!]!) {
  usersInvite(input: {users: $users}) {
    success
    failed {
      email
      reason
    }
    skipped
  }
}
    `;
export type InviteByEmailUsersInviteMutationFn = Apollo.MutationFunction<InviteByEmailUsersInviteMutation, InviteByEmailUsersInviteMutationVariables>;

/**
 * __useInviteByEmailUsersInviteMutation__
 *
 * To run a mutation, you first call `useInviteByEmailUsersInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteByEmailUsersInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteByEmailUsersInviteMutation, { data, loading, error }] = useInviteByEmailUsersInviteMutation({
 *   variables: {
 *      users: // value for 'users'
 *   },
 * });
 */
export function useInviteByEmailUsersInviteMutation(baseOptions?: Apollo.MutationHookOptions<InviteByEmailUsersInviteMutation, InviteByEmailUsersInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteByEmailUsersInviteMutation, InviteByEmailUsersInviteMutationVariables>(InviteByEmailUsersInviteDocument, options);
      }
export type InviteByEmailUsersInviteMutationHookResult = ReturnType<typeof useInviteByEmailUsersInviteMutation>;
export type InviteByEmailUsersInviteMutationResult = Apollo.MutationResult<InviteByEmailUsersInviteMutation>;
export type InviteByEmailUsersInviteMutationOptions = Apollo.BaseMutationOptions<InviteByEmailUsersInviteMutation, InviteByEmailUsersInviteMutationVariables>;
export const MemberRoleSelectUpdateRoleDocument = gql`
    mutation MemberRoleSelectUpdateRole($userId: uuid!, $role: UserRole!) {
  userUpdate(input: {userId: $userId, set: {role: $role}}) {
    userInfo {
      userId
      role
    }
  }
}
    `;
export type MemberRoleSelectUpdateRoleMutationFn = Apollo.MutationFunction<MemberRoleSelectUpdateRoleMutation, MemberRoleSelectUpdateRoleMutationVariables>;

/**
 * __useMemberRoleSelectUpdateRoleMutation__
 *
 * To run a mutation, you first call `useMemberRoleSelectUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMemberRoleSelectUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [memberRoleSelectUpdateRoleMutation, { data, loading, error }] = useMemberRoleSelectUpdateRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useMemberRoleSelectUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<MemberRoleSelectUpdateRoleMutation, MemberRoleSelectUpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MemberRoleSelectUpdateRoleMutation, MemberRoleSelectUpdateRoleMutationVariables>(MemberRoleSelectUpdateRoleDocument, options);
      }
export type MemberRoleSelectUpdateRoleMutationHookResult = ReturnType<typeof useMemberRoleSelectUpdateRoleMutation>;
export type MemberRoleSelectUpdateRoleMutationResult = Apollo.MutationResult<MemberRoleSelectUpdateRoleMutation>;
export type MemberRoleSelectUpdateRoleMutationOptions = Apollo.BaseMutationOptions<MemberRoleSelectUpdateRoleMutation, MemberRoleSelectUpdateRoleMutationVariables>;
export const UpdateAvailabilityRequestOrgPrefsDocument = gql`
    mutation UpdateAvailabilityRequestOrgPrefs($input: OrgPrefUpdateInput!) {
  orgPrefUpdate(input: $input) {
    orgPref {
      ...AvailabilityRequestOrgPrefData
    }
  }
}
    ${AvailabilityRequestOrgPrefDataFragmentDoc}`;
export type UpdateAvailabilityRequestOrgPrefsMutationFn = Apollo.MutationFunction<UpdateAvailabilityRequestOrgPrefsMutation, UpdateAvailabilityRequestOrgPrefsMutationVariables>;

/**
 * __useUpdateAvailabilityRequestOrgPrefsMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityRequestOrgPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityRequestOrgPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityRequestOrgPrefsMutation, { data, loading, error }] = useUpdateAvailabilityRequestOrgPrefsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAvailabilityRequestOrgPrefsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityRequestOrgPrefsMutation, UpdateAvailabilityRequestOrgPrefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityRequestOrgPrefsMutation, UpdateAvailabilityRequestOrgPrefsMutationVariables>(UpdateAvailabilityRequestOrgPrefsDocument, options);
      }
export type UpdateAvailabilityRequestOrgPrefsMutationHookResult = ReturnType<typeof useUpdateAvailabilityRequestOrgPrefsMutation>;
export type UpdateAvailabilityRequestOrgPrefsMutationResult = Apollo.MutationResult<UpdateAvailabilityRequestOrgPrefsMutation>;
export type UpdateAvailabilityRequestOrgPrefsMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityRequestOrgPrefsMutation, UpdateAvailabilityRequestOrgPrefsMutationVariables>;
export const AvailabilityRequestSettingsOrgPrefsDocument = gql`
    query AvailabilityRequestSettingsOrgPrefs {
  thisOrg {
    id
    orgPrefs {
      ...AvailabilityRequestOrgPrefData
    }
  }
}
    ${AvailabilityRequestOrgPrefDataFragmentDoc}`;

/**
 * __useAvailabilityRequestSettingsOrgPrefsQuery__
 *
 * To run a query within a React component, call `useAvailabilityRequestSettingsOrgPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityRequestSettingsOrgPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityRequestSettingsOrgPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailabilityRequestSettingsOrgPrefsQuery(baseOptions?: Apollo.QueryHookOptions<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>(AvailabilityRequestSettingsOrgPrefsDocument, options);
      }
export function useAvailabilityRequestSettingsOrgPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>(AvailabilityRequestSettingsOrgPrefsDocument, options);
        }
// @ts-ignore
export function useAvailabilityRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>;
export function useAvailabilityRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityRequestSettingsOrgPrefsQuery | undefined, AvailabilityRequestSettingsOrgPrefsQueryVariables>;
export function useAvailabilityRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>(AvailabilityRequestSettingsOrgPrefsDocument, options);
        }
export type AvailabilityRequestSettingsOrgPrefsQueryHookResult = ReturnType<typeof useAvailabilityRequestSettingsOrgPrefsQuery>;
export type AvailabilityRequestSettingsOrgPrefsLazyQueryHookResult = ReturnType<typeof useAvailabilityRequestSettingsOrgPrefsLazyQuery>;
export type AvailabilityRequestSettingsOrgPrefsSuspenseQueryHookResult = ReturnType<typeof useAvailabilityRequestSettingsOrgPrefsSuspenseQuery>;
export type AvailabilityRequestSettingsOrgPrefsQueryResult = Apollo.QueryResult<AvailabilityRequestSettingsOrgPrefsQuery, AvailabilityRequestSettingsOrgPrefsQueryVariables>;
export const OrgAvailabilityRequestSettingsTemplateDocument = gql`
    query OrgAvailabilityRequestSettingsTemplate($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateRow_orgTemplate
    }
  }
}
    ${TemplateRow_OrgTemplateFragmentDoc}`;

/**
 * __useOrgAvailabilityRequestSettingsTemplateQuery__
 *
 * To run a query within a React component, call `useOrgAvailabilityRequestSettingsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgAvailabilityRequestSettingsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgAvailabilityRequestSettingsTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgAvailabilityRequestSettingsTemplateQuery(baseOptions: Apollo.QueryHookOptions<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables> & ({ variables: OrgAvailabilityRequestSettingsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>(OrgAvailabilityRequestSettingsTemplateDocument, options);
      }
export function useOrgAvailabilityRequestSettingsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>(OrgAvailabilityRequestSettingsTemplateDocument, options);
        }
// @ts-ignore
export function useOrgAvailabilityRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>;
export function useOrgAvailabilityRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<OrgAvailabilityRequestSettingsTemplateQuery | undefined, OrgAvailabilityRequestSettingsTemplateQueryVariables>;
export function useOrgAvailabilityRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>(OrgAvailabilityRequestSettingsTemplateDocument, options);
        }
export type OrgAvailabilityRequestSettingsTemplateQueryHookResult = ReturnType<typeof useOrgAvailabilityRequestSettingsTemplateQuery>;
export type OrgAvailabilityRequestSettingsTemplateLazyQueryHookResult = ReturnType<typeof useOrgAvailabilityRequestSettingsTemplateLazyQuery>;
export type OrgAvailabilityRequestSettingsTemplateSuspenseQueryHookResult = ReturnType<typeof useOrgAvailabilityRequestSettingsTemplateSuspenseQuery>;
export type OrgAvailabilityRequestSettingsTemplateQueryResult = Apollo.QueryResult<OrgAvailabilityRequestSettingsTemplateQuery, OrgAvailabilityRequestSettingsTemplateQueryVariables>;
export const OrgAvailabilityRequestUpdateDocument = gql`
    mutation OrgAvailabilityRequestUpdate($input: TemplateUpdateInput!) {
  templateUpdate(input: $input) {
    template {
      id
    }
  }
}
    `;
export type OrgAvailabilityRequestUpdateMutationFn = Apollo.MutationFunction<OrgAvailabilityRequestUpdateMutation, OrgAvailabilityRequestUpdateMutationVariables>;

/**
 * __useOrgAvailabilityRequestUpdateMutation__
 *
 * To run a mutation, you first call `useOrgAvailabilityRequestUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgAvailabilityRequestUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgAvailabilityRequestUpdateMutation, { data, loading, error }] = useOrgAvailabilityRequestUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgAvailabilityRequestUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrgAvailabilityRequestUpdateMutation, OrgAvailabilityRequestUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrgAvailabilityRequestUpdateMutation, OrgAvailabilityRequestUpdateMutationVariables>(OrgAvailabilityRequestUpdateDocument, options);
      }
export type OrgAvailabilityRequestUpdateMutationHookResult = ReturnType<typeof useOrgAvailabilityRequestUpdateMutation>;
export type OrgAvailabilityRequestUpdateMutationResult = Apollo.MutationResult<OrgAvailabilityRequestUpdateMutation>;
export type OrgAvailabilityRequestUpdateMutationOptions = Apollo.BaseMutationOptions<OrgAvailabilityRequestUpdateMutation, OrgAvailabilityRequestUpdateMutationVariables>;
export const UpdateSelfScheduleRequestOrgPrefsDocument = gql`
    mutation UpdateSelfScheduleRequestOrgPrefs($input: OrgPrefUpdateInput!) {
  orgPrefUpdate(input: $input) {
    orgPref {
      ...SelfScheduleRequestSettingsOrgPrefsData
    }
  }
}
    ${SelfScheduleRequestSettingsOrgPrefsDataFragmentDoc}`;
export type UpdateSelfScheduleRequestOrgPrefsMutationFn = Apollo.MutationFunction<UpdateSelfScheduleRequestOrgPrefsMutation, UpdateSelfScheduleRequestOrgPrefsMutationVariables>;

/**
 * __useUpdateSelfScheduleRequestOrgPrefsMutation__
 *
 * To run a mutation, you first call `useUpdateSelfScheduleRequestOrgPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSelfScheduleRequestOrgPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSelfScheduleRequestOrgPrefsMutation, { data, loading, error }] = useUpdateSelfScheduleRequestOrgPrefsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSelfScheduleRequestOrgPrefsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSelfScheduleRequestOrgPrefsMutation, UpdateSelfScheduleRequestOrgPrefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSelfScheduleRequestOrgPrefsMutation, UpdateSelfScheduleRequestOrgPrefsMutationVariables>(UpdateSelfScheduleRequestOrgPrefsDocument, options);
      }
export type UpdateSelfScheduleRequestOrgPrefsMutationHookResult = ReturnType<typeof useUpdateSelfScheduleRequestOrgPrefsMutation>;
export type UpdateSelfScheduleRequestOrgPrefsMutationResult = Apollo.MutationResult<UpdateSelfScheduleRequestOrgPrefsMutation>;
export type UpdateSelfScheduleRequestOrgPrefsMutationOptions = Apollo.BaseMutationOptions<UpdateSelfScheduleRequestOrgPrefsMutation, UpdateSelfScheduleRequestOrgPrefsMutationVariables>;
export const SelfScheduleRequestSettingsOrgPrefsDocument = gql`
    query SelfScheduleRequestSettingsOrgPrefs {
  thisOrg {
    id
    orgPrefs {
      ...SelfScheduleRequestSettingsOrgPrefsData
    }
  }
}
    ${SelfScheduleRequestSettingsOrgPrefsDataFragmentDoc}`;

/**
 * __useSelfScheduleRequestSettingsOrgPrefsQuery__
 *
 * To run a query within a React component, call `useSelfScheduleRequestSettingsOrgPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfScheduleRequestSettingsOrgPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfScheduleRequestSettingsOrgPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfScheduleRequestSettingsOrgPrefsQuery(baseOptions?: Apollo.QueryHookOptions<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>(SelfScheduleRequestSettingsOrgPrefsDocument, options);
      }
export function useSelfScheduleRequestSettingsOrgPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>(SelfScheduleRequestSettingsOrgPrefsDocument, options);
        }
// @ts-ignore
export function useSelfScheduleRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>;
export function useSelfScheduleRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<SelfScheduleRequestSettingsOrgPrefsQuery | undefined, SelfScheduleRequestSettingsOrgPrefsQueryVariables>;
export function useSelfScheduleRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>(SelfScheduleRequestSettingsOrgPrefsDocument, options);
        }
export type SelfScheduleRequestSettingsOrgPrefsQueryHookResult = ReturnType<typeof useSelfScheduleRequestSettingsOrgPrefsQuery>;
export type SelfScheduleRequestSettingsOrgPrefsLazyQueryHookResult = ReturnType<typeof useSelfScheduleRequestSettingsOrgPrefsLazyQuery>;
export type SelfScheduleRequestSettingsOrgPrefsSuspenseQueryHookResult = ReturnType<typeof useSelfScheduleRequestSettingsOrgPrefsSuspenseQuery>;
export type SelfScheduleRequestSettingsOrgPrefsQueryResult = Apollo.QueryResult<SelfScheduleRequestSettingsOrgPrefsQuery, SelfScheduleRequestSettingsOrgPrefsQueryVariables>;
export const OrgSelfScheduleRequestSettingsTemplateDocument = gql`
    query OrgSelfScheduleRequestSettingsTemplate($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateRow_orgTemplate
    }
  }
}
    ${TemplateRow_OrgTemplateFragmentDoc}`;

/**
 * __useOrgSelfScheduleRequestSettingsTemplateQuery__
 *
 * To run a query within a React component, call `useOrgSelfScheduleRequestSettingsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgSelfScheduleRequestSettingsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgSelfScheduleRequestSettingsTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgSelfScheduleRequestSettingsTemplateQuery(baseOptions: Apollo.QueryHookOptions<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables> & ({ variables: OrgSelfScheduleRequestSettingsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>(OrgSelfScheduleRequestSettingsTemplateDocument, options);
      }
export function useOrgSelfScheduleRequestSettingsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>(OrgSelfScheduleRequestSettingsTemplateDocument, options);
        }
// @ts-ignore
export function useOrgSelfScheduleRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>;
export function useOrgSelfScheduleRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<OrgSelfScheduleRequestSettingsTemplateQuery | undefined, OrgSelfScheduleRequestSettingsTemplateQueryVariables>;
export function useOrgSelfScheduleRequestSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>(OrgSelfScheduleRequestSettingsTemplateDocument, options);
        }
export type OrgSelfScheduleRequestSettingsTemplateQueryHookResult = ReturnType<typeof useOrgSelfScheduleRequestSettingsTemplateQuery>;
export type OrgSelfScheduleRequestSettingsTemplateLazyQueryHookResult = ReturnType<typeof useOrgSelfScheduleRequestSettingsTemplateLazyQuery>;
export type OrgSelfScheduleRequestSettingsTemplateSuspenseQueryHookResult = ReturnType<typeof useOrgSelfScheduleRequestSettingsTemplateSuspenseQuery>;
export type OrgSelfScheduleRequestSettingsTemplateQueryResult = Apollo.QueryResult<OrgSelfScheduleRequestSettingsTemplateQuery, OrgSelfScheduleRequestSettingsTemplateQueryVariables>;
export const OrgSelfScheduleRequestTemplateUpdateDocument = gql`
    mutation OrgSelfScheduleRequestTemplateUpdate($input: TemplateUpdateInput!) {
  templateUpdate(input: $input) {
    template {
      id
    }
  }
}
    `;
export type OrgSelfScheduleRequestTemplateUpdateMutationFn = Apollo.MutationFunction<OrgSelfScheduleRequestTemplateUpdateMutation, OrgSelfScheduleRequestTemplateUpdateMutationVariables>;

/**
 * __useOrgSelfScheduleRequestTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useOrgSelfScheduleRequestTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgSelfScheduleRequestTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgSelfScheduleRequestTemplateUpdateMutation, { data, loading, error }] = useOrgSelfScheduleRequestTemplateUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgSelfScheduleRequestTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrgSelfScheduleRequestTemplateUpdateMutation, OrgSelfScheduleRequestTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrgSelfScheduleRequestTemplateUpdateMutation, OrgSelfScheduleRequestTemplateUpdateMutationVariables>(OrgSelfScheduleRequestTemplateUpdateDocument, options);
      }
export type OrgSelfScheduleRequestTemplateUpdateMutationHookResult = ReturnType<typeof useOrgSelfScheduleRequestTemplateUpdateMutation>;
export type OrgSelfScheduleRequestTemplateUpdateMutationResult = Apollo.MutationResult<OrgSelfScheduleRequestTemplateUpdateMutation>;
export type OrgSelfScheduleRequestTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<OrgSelfScheduleRequestTemplateUpdateMutation, OrgSelfScheduleRequestTemplateUpdateMutationVariables>;
export const UpdateCommunicationOrgPrefsDocument = gql`
    mutation UpdateCommunicationOrgPrefs($input: OrgPrefUpdateInput!) {
  orgPrefUpdate(input: $input) {
    orgPref {
      ...CommunicationOrgPrefData
    }
  }
}
    ${CommunicationOrgPrefDataFragmentDoc}`;
export type UpdateCommunicationOrgPrefsMutationFn = Apollo.MutationFunction<UpdateCommunicationOrgPrefsMutation, UpdateCommunicationOrgPrefsMutationVariables>;

/**
 * __useUpdateCommunicationOrgPrefsMutation__
 *
 * To run a mutation, you first call `useUpdateCommunicationOrgPrefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunicationOrgPrefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunicationOrgPrefsMutation, { data, loading, error }] = useUpdateCommunicationOrgPrefsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunicationOrgPrefsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunicationOrgPrefsMutation, UpdateCommunicationOrgPrefsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunicationOrgPrefsMutation, UpdateCommunicationOrgPrefsMutationVariables>(UpdateCommunicationOrgPrefsDocument, options);
      }
export type UpdateCommunicationOrgPrefsMutationHookResult = ReturnType<typeof useUpdateCommunicationOrgPrefsMutation>;
export type UpdateCommunicationOrgPrefsMutationResult = Apollo.MutationResult<UpdateCommunicationOrgPrefsMutation>;
export type UpdateCommunicationOrgPrefsMutationOptions = Apollo.BaseMutationOptions<UpdateCommunicationOrgPrefsMutation, UpdateCommunicationOrgPrefsMutationVariables>;
export const CommunicationRequestSettingsOrgPrefsDocument = gql`
    query CommunicationRequestSettingsOrgPrefs {
  thisOrg {
    id
    integrations {
      id
      slack {
        active
      }
    }
    orgPrefs {
      ...CommunicationOrgPrefData
    }
  }
}
    ${CommunicationOrgPrefDataFragmentDoc}`;

/**
 * __useCommunicationRequestSettingsOrgPrefsQuery__
 *
 * To run a query within a React component, call `useCommunicationRequestSettingsOrgPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationRequestSettingsOrgPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationRequestSettingsOrgPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunicationRequestSettingsOrgPrefsQuery(baseOptions?: Apollo.QueryHookOptions<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>(CommunicationRequestSettingsOrgPrefsDocument, options);
      }
export function useCommunicationRequestSettingsOrgPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>(CommunicationRequestSettingsOrgPrefsDocument, options);
        }
// @ts-ignore
export function useCommunicationRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>;
export function useCommunicationRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationRequestSettingsOrgPrefsQuery | undefined, CommunicationRequestSettingsOrgPrefsQueryVariables>;
export function useCommunicationRequestSettingsOrgPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>(CommunicationRequestSettingsOrgPrefsDocument, options);
        }
export type CommunicationRequestSettingsOrgPrefsQueryHookResult = ReturnType<typeof useCommunicationRequestSettingsOrgPrefsQuery>;
export type CommunicationRequestSettingsOrgPrefsLazyQueryHookResult = ReturnType<typeof useCommunicationRequestSettingsOrgPrefsLazyQuery>;
export type CommunicationRequestSettingsOrgPrefsSuspenseQueryHookResult = ReturnType<typeof useCommunicationRequestSettingsOrgPrefsSuspenseQuery>;
export type CommunicationRequestSettingsOrgPrefsQueryResult = Apollo.QueryResult<CommunicationRequestSettingsOrgPrefsQuery, CommunicationRequestSettingsOrgPrefsQueryVariables>;
export const OrgCommunicationSettingsTemplateDocument = gql`
    query OrgCommunicationSettingsTemplate($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateRow_orgTemplate
    }
  }
}
    ${TemplateRow_OrgTemplateFragmentDoc}`;

/**
 * __useOrgCommunicationSettingsTemplateQuery__
 *
 * To run a query within a React component, call `useOrgCommunicationSettingsTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgCommunicationSettingsTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgCommunicationSettingsTemplateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgCommunicationSettingsTemplateQuery(baseOptions: Apollo.QueryHookOptions<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables> & ({ variables: OrgCommunicationSettingsTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>(OrgCommunicationSettingsTemplateDocument, options);
      }
export function useOrgCommunicationSettingsTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>(OrgCommunicationSettingsTemplateDocument, options);
        }
// @ts-ignore
export function useOrgCommunicationSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>;
export function useOrgCommunicationSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<OrgCommunicationSettingsTemplateQuery | undefined, OrgCommunicationSettingsTemplateQueryVariables>;
export function useOrgCommunicationSettingsTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>(OrgCommunicationSettingsTemplateDocument, options);
        }
export type OrgCommunicationSettingsTemplateQueryHookResult = ReturnType<typeof useOrgCommunicationSettingsTemplateQuery>;
export type OrgCommunicationSettingsTemplateLazyQueryHookResult = ReturnType<typeof useOrgCommunicationSettingsTemplateLazyQuery>;
export type OrgCommunicationSettingsTemplateSuspenseQueryHookResult = ReturnType<typeof useOrgCommunicationSettingsTemplateSuspenseQuery>;
export type OrgCommunicationSettingsTemplateQueryResult = Apollo.QueryResult<OrgCommunicationSettingsTemplateQuery, OrgCommunicationSettingsTemplateQueryVariables>;
export const CommunicationCalendarDocument = gql`
    query CommunicationCalendar($input: String!) {
  calendar(id: $input) {
    id
    name
    isReadOnly
    remoteId
    canActorWriteToCalendar
  }
}
    `;

/**
 * __useCommunicationCalendarQuery__
 *
 * To run a query within a React component, call `useCommunicationCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationCalendarQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommunicationCalendarQuery(baseOptions: Apollo.QueryHookOptions<CommunicationCalendarQuery, CommunicationCalendarQueryVariables> & ({ variables: CommunicationCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>(CommunicationCalendarDocument, options);
      }
export function useCommunicationCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>(CommunicationCalendarDocument, options);
        }
// @ts-ignore
export function useCommunicationCalendarSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>;
export function useCommunicationCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>): Apollo.UseSuspenseQueryResult<CommunicationCalendarQuery | undefined, CommunicationCalendarQueryVariables>;
export function useCommunicationCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>(CommunicationCalendarDocument, options);
        }
export type CommunicationCalendarQueryHookResult = ReturnType<typeof useCommunicationCalendarQuery>;
export type CommunicationCalendarLazyQueryHookResult = ReturnType<typeof useCommunicationCalendarLazyQuery>;
export type CommunicationCalendarSuspenseQueryHookResult = ReturnType<typeof useCommunicationCalendarSuspenseQuery>;
export type CommunicationCalendarQueryResult = Apollo.QueryResult<CommunicationCalendarQuery, CommunicationCalendarQueryVariables>;
export const OrgCommunicationTemplateUpdateDocument = gql`
    mutation OrgCommunicationTemplateUpdate($input: TemplateUpdateInput!) {
  templateUpdate(input: $input) {
    template {
      id
    }
  }
}
    `;
export type OrgCommunicationTemplateUpdateMutationFn = Apollo.MutationFunction<OrgCommunicationTemplateUpdateMutation, OrgCommunicationTemplateUpdateMutationVariables>;

/**
 * __useOrgCommunicationTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useOrgCommunicationTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrgCommunicationTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orgCommunicationTemplateUpdateMutation, { data, loading, error }] = useOrgCommunicationTemplateUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgCommunicationTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrgCommunicationTemplateUpdateMutation, OrgCommunicationTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrgCommunicationTemplateUpdateMutation, OrgCommunicationTemplateUpdateMutationVariables>(OrgCommunicationTemplateUpdateDocument, options);
      }
export type OrgCommunicationTemplateUpdateMutationHookResult = ReturnType<typeof useOrgCommunicationTemplateUpdateMutation>;
export type OrgCommunicationTemplateUpdateMutationResult = Apollo.MutationResult<OrgCommunicationTemplateUpdateMutation>;
export type OrgCommunicationTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<OrgCommunicationTemplateUpdateMutation, OrgCommunicationTemplateUpdateMutationVariables>;
export const CompanyHolidayCreateDocument = gql`
    mutation CompanyHolidayCreate($input: CompanyHolidayCreateInput!) {
  companyHolidayCreate(input: $input) {
    companyHoliday {
      ...CompanyHolidayModal_companyHoliday
    }
  }
}
    ${CompanyHolidayModal_CompanyHolidayFragmentDoc}`;
export type CompanyHolidayCreateMutationFn = Apollo.MutationFunction<CompanyHolidayCreateMutation, CompanyHolidayCreateMutationVariables>;

/**
 * __useCompanyHolidayCreateMutation__
 *
 * To run a mutation, you first call `useCompanyHolidayCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyHolidayCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyHolidayCreateMutation, { data, loading, error }] = useCompanyHolidayCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyHolidayCreateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyHolidayCreateMutation, CompanyHolidayCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyHolidayCreateMutation, CompanyHolidayCreateMutationVariables>(CompanyHolidayCreateDocument, options);
      }
export type CompanyHolidayCreateMutationHookResult = ReturnType<typeof useCompanyHolidayCreateMutation>;
export type CompanyHolidayCreateMutationResult = Apollo.MutationResult<CompanyHolidayCreateMutation>;
export type CompanyHolidayCreateMutationOptions = Apollo.BaseMutationOptions<CompanyHolidayCreateMutation, CompanyHolidayCreateMutationVariables>;
export const CompanyHolidayUpdateDocument = gql`
    mutation CompanyHolidayUpdate($input: CompanyHolidayUpdateInput!) {
  companyHolidayUpdate(input: $input) {
    companyHoliday {
      ...CompanyHolidayModal_companyHoliday
    }
  }
}
    ${CompanyHolidayModal_CompanyHolidayFragmentDoc}`;
export type CompanyHolidayUpdateMutationFn = Apollo.MutationFunction<CompanyHolidayUpdateMutation, CompanyHolidayUpdateMutationVariables>;

/**
 * __useCompanyHolidayUpdateMutation__
 *
 * To run a mutation, you first call `useCompanyHolidayUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyHolidayUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyHolidayUpdateMutation, { data, loading, error }] = useCompanyHolidayUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyHolidayUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CompanyHolidayUpdateMutation, CompanyHolidayUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyHolidayUpdateMutation, CompanyHolidayUpdateMutationVariables>(CompanyHolidayUpdateDocument, options);
      }
export type CompanyHolidayUpdateMutationHookResult = ReturnType<typeof useCompanyHolidayUpdateMutation>;
export type CompanyHolidayUpdateMutationResult = Apollo.MutationResult<CompanyHolidayUpdateMutation>;
export type CompanyHolidayUpdateMutationOptions = Apollo.BaseMutationOptions<CompanyHolidayUpdateMutation, CompanyHolidayUpdateMutationVariables>;
export const CompanyHolidaysDocument = gql`
    query CompanyHolidays($input: CompanyHolidaysInput!) {
  companyHolidays(input: $input) {
    items {
      ...CompanyHoliday_companyHoliday
    }
  }
}
    ${CompanyHoliday_CompanyHolidayFragmentDoc}`;

/**
 * __useCompanyHolidaysQuery__
 *
 * To run a query within a React component, call `useCompanyHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyHolidaysQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyHolidaysQuery(baseOptions: Apollo.QueryHookOptions<CompanyHolidaysQuery, CompanyHolidaysQueryVariables> & ({ variables: CompanyHolidaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>(CompanyHolidaysDocument, options);
      }
export function useCompanyHolidaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>(CompanyHolidaysDocument, options);
        }
// @ts-ignore
export function useCompanyHolidaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>;
export function useCompanyHolidaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyHolidaysQuery | undefined, CompanyHolidaysQueryVariables>;
export function useCompanyHolidaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>(CompanyHolidaysDocument, options);
        }
export type CompanyHolidaysQueryHookResult = ReturnType<typeof useCompanyHolidaysQuery>;
export type CompanyHolidaysLazyQueryHookResult = ReturnType<typeof useCompanyHolidaysLazyQuery>;
export type CompanyHolidaysSuspenseQueryHookResult = ReturnType<typeof useCompanyHolidaysSuspenseQuery>;
export type CompanyHolidaysQueryResult = Apollo.QueryResult<CompanyHolidaysQuery, CompanyHolidaysQueryVariables>;
export const CompanyHolidayDeleteDocument = gql`
    mutation CompanyHolidayDelete($input: CompanyHolidayDeleteInput!) {
  companyHolidayDelete(input: $input) {
    result
  }
}
    `;
export type CompanyHolidayDeleteMutationFn = Apollo.MutationFunction<CompanyHolidayDeleteMutation, CompanyHolidayDeleteMutationVariables>;

/**
 * __useCompanyHolidayDeleteMutation__
 *
 * To run a mutation, you first call `useCompanyHolidayDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompanyHolidayDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companyHolidayDeleteMutation, { data, loading, error }] = useCompanyHolidayDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompanyHolidayDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CompanyHolidayDeleteMutation, CompanyHolidayDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompanyHolidayDeleteMutation, CompanyHolidayDeleteMutationVariables>(CompanyHolidayDeleteDocument, options);
      }
export type CompanyHolidayDeleteMutationHookResult = ReturnType<typeof useCompanyHolidayDeleteMutation>;
export type CompanyHolidayDeleteMutationResult = Apollo.MutationResult<CompanyHolidayDeleteMutation>;
export type CompanyHolidayDeleteMutationOptions = Apollo.BaseMutationOptions<CompanyHolidayDeleteMutation, CompanyHolidayDeleteMutationVariables>;
export const DebriefAtsWriteOrgPrefDocument = gql`
    query DebriefAtsWriteOrgPref {
  thisOrg {
    id
    orgPrefs {
      ...DebriefAtsWriteOrgPrefData
    }
  }
}
    ${DebriefAtsWriteOrgPrefDataFragmentDoc}`;

/**
 * __useDebriefAtsWriteOrgPrefQuery__
 *
 * To run a query within a React component, call `useDebriefAtsWriteOrgPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebriefAtsWriteOrgPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebriefAtsWriteOrgPrefQuery({
 *   variables: {
 *   },
 * });
 */
export function useDebriefAtsWriteOrgPrefQuery(baseOptions?: Apollo.QueryHookOptions<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>(DebriefAtsWriteOrgPrefDocument, options);
      }
export function useDebriefAtsWriteOrgPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>(DebriefAtsWriteOrgPrefDocument, options);
        }
// @ts-ignore
export function useDebriefAtsWriteOrgPrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>;
export function useDebriefAtsWriteOrgPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>): Apollo.UseSuspenseQueryResult<DebriefAtsWriteOrgPrefQuery | undefined, DebriefAtsWriteOrgPrefQueryVariables>;
export function useDebriefAtsWriteOrgPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>(DebriefAtsWriteOrgPrefDocument, options);
        }
export type DebriefAtsWriteOrgPrefQueryHookResult = ReturnType<typeof useDebriefAtsWriteOrgPrefQuery>;
export type DebriefAtsWriteOrgPrefLazyQueryHookResult = ReturnType<typeof useDebriefAtsWriteOrgPrefLazyQuery>;
export type DebriefAtsWriteOrgPrefSuspenseQueryHookResult = ReturnType<typeof useDebriefAtsWriteOrgPrefSuspenseQuery>;
export type DebriefAtsWriteOrgPrefQueryResult = Apollo.QueryResult<DebriefAtsWriteOrgPrefQuery, DebriefAtsWriteOrgPrefQueryVariables>;
export const UpdateDebriefAtsWriteOrgPrefDocument = gql`
    mutation UpdateDebriefAtsWriteOrgPref($input: OrgPrefUpdateInput!) {
  orgPrefUpdate(input: $input) {
    orgPref {
      ...DebriefAtsWriteOrgPrefData
    }
  }
}
    ${DebriefAtsWriteOrgPrefDataFragmentDoc}`;
export type UpdateDebriefAtsWriteOrgPrefMutationFn = Apollo.MutationFunction<UpdateDebriefAtsWriteOrgPrefMutation, UpdateDebriefAtsWriteOrgPrefMutationVariables>;

/**
 * __useUpdateDebriefAtsWriteOrgPrefMutation__
 *
 * To run a mutation, you first call `useUpdateDebriefAtsWriteOrgPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDebriefAtsWriteOrgPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDebriefAtsWriteOrgPrefMutation, { data, loading, error }] = useUpdateDebriefAtsWriteOrgPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDebriefAtsWriteOrgPrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDebriefAtsWriteOrgPrefMutation, UpdateDebriefAtsWriteOrgPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDebriefAtsWriteOrgPrefMutation, UpdateDebriefAtsWriteOrgPrefMutationVariables>(UpdateDebriefAtsWriteOrgPrefDocument, options);
      }
export type UpdateDebriefAtsWriteOrgPrefMutationHookResult = ReturnType<typeof useUpdateDebriefAtsWriteOrgPrefMutation>;
export type UpdateDebriefAtsWriteOrgPrefMutationResult = Apollo.MutationResult<UpdateDebriefAtsWriteOrgPrefMutation>;
export type UpdateDebriefAtsWriteOrgPrefMutationOptions = Apollo.BaseMutationOptions<UpdateDebriefAtsWriteOrgPrefMutation, UpdateDebriefAtsWriteOrgPrefMutationVariables>;
export const InterviewMeetingLocationSettingOrgPrefDocument = gql`
    query InterviewMeetingLocationSettingOrgPref($prefName: String!) {
  thisOrg {
    id
    orgPref(prefName: $prefName) {
      id
      orgId
      prefName
      jsonPref {
        ... on InterviewMeetingLocationSettingPref {
          ...InterviewMeetingLocationModal_interviewMeetingLocationSettingPref
          ...InterviewMeetingLocationInfo_interviewMeetingLocationSettingPref
          hostEmployee {
            id
            fullName
            internalProfilePictureUrl
            email
          }
        }
      }
    }
  }
}
    ${InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragmentDoc}
${InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragmentDoc}`;

/**
 * __useInterviewMeetingLocationSettingOrgPrefQuery__
 *
 * To run a query within a React component, call `useInterviewMeetingLocationSettingOrgPrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewMeetingLocationSettingOrgPrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewMeetingLocationSettingOrgPrefQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useInterviewMeetingLocationSettingOrgPrefQuery(baseOptions: Apollo.QueryHookOptions<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables> & ({ variables: InterviewMeetingLocationSettingOrgPrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>(InterviewMeetingLocationSettingOrgPrefDocument, options);
      }
export function useInterviewMeetingLocationSettingOrgPrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>(InterviewMeetingLocationSettingOrgPrefDocument, options);
        }
// @ts-ignore
export function useInterviewMeetingLocationSettingOrgPrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>;
export function useInterviewMeetingLocationSettingOrgPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewMeetingLocationSettingOrgPrefQuery | undefined, InterviewMeetingLocationSettingOrgPrefQueryVariables>;
export function useInterviewMeetingLocationSettingOrgPrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>(InterviewMeetingLocationSettingOrgPrefDocument, options);
        }
export type InterviewMeetingLocationSettingOrgPrefQueryHookResult = ReturnType<typeof useInterviewMeetingLocationSettingOrgPrefQuery>;
export type InterviewMeetingLocationSettingOrgPrefLazyQueryHookResult = ReturnType<typeof useInterviewMeetingLocationSettingOrgPrefLazyQuery>;
export type InterviewMeetingLocationSettingOrgPrefSuspenseQueryHookResult = ReturnType<typeof useInterviewMeetingLocationSettingOrgPrefSuspenseQuery>;
export type InterviewMeetingLocationSettingOrgPrefQueryResult = Apollo.QueryResult<InterviewMeetingLocationSettingOrgPrefQuery, InterviewMeetingLocationSettingOrgPrefQueryVariables>;
export const UpdateInterviewMeetingLocationSettingOrgPrefDocument = gql`
    mutation updateInterviewMeetingLocationSettingOrgPref($prefName: String!, $json: jsonb) {
  orgPrefUpdate(input: {prefName: $prefName, set: {json: $json}}) {
    orgPref {
      id
      orgId
      prefName
      jsonPref {
        ... on InterviewMeetingLocationSettingPref {
          ...InterviewMeetingLocationModal_interviewMeetingLocationSettingPref
          ...InterviewMeetingLocationInfo_interviewMeetingLocationSettingPref
          hostEmployee {
            id
            fullName
            internalProfilePictureUrl
            email
          }
        }
      }
    }
  }
}
    ${InterviewMeetingLocationModal_InterviewMeetingLocationSettingPrefFragmentDoc}
${InterviewMeetingLocationInfo_InterviewMeetingLocationSettingPrefFragmentDoc}`;
export type UpdateInterviewMeetingLocationSettingOrgPrefMutationFn = Apollo.MutationFunction<UpdateInterviewMeetingLocationSettingOrgPrefMutation, UpdateInterviewMeetingLocationSettingOrgPrefMutationVariables>;

/**
 * __useUpdateInterviewMeetingLocationSettingOrgPrefMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewMeetingLocationSettingOrgPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewMeetingLocationSettingOrgPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewMeetingLocationSettingOrgPrefMutation, { data, loading, error }] = useUpdateInterviewMeetingLocationSettingOrgPrefMutation({
 *   variables: {
 *      prefName: // value for 'prefName'
 *      json: // value for 'json'
 *   },
 * });
 */
export function useUpdateInterviewMeetingLocationSettingOrgPrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewMeetingLocationSettingOrgPrefMutation, UpdateInterviewMeetingLocationSettingOrgPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewMeetingLocationSettingOrgPrefMutation, UpdateInterviewMeetingLocationSettingOrgPrefMutationVariables>(UpdateInterviewMeetingLocationSettingOrgPrefDocument, options);
      }
export type UpdateInterviewMeetingLocationSettingOrgPrefMutationHookResult = ReturnType<typeof useUpdateInterviewMeetingLocationSettingOrgPrefMutation>;
export type UpdateInterviewMeetingLocationSettingOrgPrefMutationResult = Apollo.MutationResult<UpdateInterviewMeetingLocationSettingOrgPrefMutation>;
export type UpdateInterviewMeetingLocationSettingOrgPrefMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewMeetingLocationSettingOrgPrefMutation, UpdateInterviewMeetingLocationSettingOrgPrefMutationVariables>;
export const McpToolCallAuditLogsDocument = gql`
    query McpToolCallAuditLogs($input: McpToolCallAuditLogsInput!) {
  mcpToolCallAuditLogs(input: $input) {
    nextCursor
    items {
      id
      calledAt
      actorId
      actor {
        id
        fullName
        email
      }
      tokenType
      tokenName
      toolName
      intent
      status
      errorCode
      durationMs
      toolInput {
        __typename
        ... on CapturedAuditLogPayload {
          text
          truncated
        }
        ... on TooLargeAuditLogPayload {
          maxBytes
        }
      }
      toolOutput {
        __typename
        ... on CapturedAuditLogPayload {
          text
          truncated
        }
        ... on TooLargeAuditLogPayload {
          maxBytes
        }
      }
    }
  }
}
    `;

/**
 * __useMcpToolCallAuditLogsQuery__
 *
 * To run a query within a React component, call `useMcpToolCallAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpToolCallAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpToolCallAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMcpToolCallAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables> & ({ variables: McpToolCallAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>(McpToolCallAuditLogsDocument, options);
      }
export function useMcpToolCallAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>(McpToolCallAuditLogsDocument, options);
        }
// @ts-ignore
export function useMcpToolCallAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>;
export function useMcpToolCallAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<McpToolCallAuditLogsQuery | undefined, McpToolCallAuditLogsQueryVariables>;
export function useMcpToolCallAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>(McpToolCallAuditLogsDocument, options);
        }
export type McpToolCallAuditLogsQueryHookResult = ReturnType<typeof useMcpToolCallAuditLogsQuery>;
export type McpToolCallAuditLogsLazyQueryHookResult = ReturnType<typeof useMcpToolCallAuditLogsLazyQuery>;
export type McpToolCallAuditLogsSuspenseQueryHookResult = ReturnType<typeof useMcpToolCallAuditLogsSuspenseQuery>;
export type McpToolCallAuditLogsQueryResult = Apollo.QueryResult<McpToolCallAuditLogsQuery, McpToolCallAuditLogsQueryVariables>;
export const ApiRequestAuditLogsDocument = gql`
    query ApiRequestAuditLogs($input: ApiRequestAuditLogsInput!) {
  apiRequestAuditLogs(input: $input) {
    nextCursor
    items {
      id
      requestedAt
      actorId
      actor {
        id
        fullName
        email
      }
      tokenType
      tokenName
      method
      path
      statusCode
      durationMs
      requestBody {
        __typename
        ... on CapturedAuditLogPayload {
          text
          truncated
        }
        ... on TooLargeAuditLogPayload {
          maxBytes
        }
      }
      requestQuery {
        __typename
        ... on CapturedAuditLogPayload {
          text
          truncated
        }
        ... on TooLargeAuditLogPayload {
          maxBytes
        }
      }
      responseBody {
        __typename
        ... on CapturedAuditLogPayload {
          text
          truncated
        }
        ... on TooLargeAuditLogPayload {
          maxBytes
        }
      }
    }
  }
}
    `;

/**
 * __useApiRequestAuditLogsQuery__
 *
 * To run a query within a React component, call `useApiRequestAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiRequestAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiRequestAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApiRequestAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables> & ({ variables: ApiRequestAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>(ApiRequestAuditLogsDocument, options);
      }
export function useApiRequestAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>(ApiRequestAuditLogsDocument, options);
        }
// @ts-ignore
export function useApiRequestAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>;
export function useApiRequestAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<ApiRequestAuditLogsQuery | undefined, ApiRequestAuditLogsQueryVariables>;
export function useApiRequestAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>(ApiRequestAuditLogsDocument, options);
        }
export type ApiRequestAuditLogsQueryHookResult = ReturnType<typeof useApiRequestAuditLogsQuery>;
export type ApiRequestAuditLogsLazyQueryHookResult = ReturnType<typeof useApiRequestAuditLogsLazyQuery>;
export type ApiRequestAuditLogsSuspenseQueryHookResult = ReturnType<typeof useApiRequestAuditLogsSuspenseQuery>;
export type ApiRequestAuditLogsQueryResult = Apollo.QueryResult<ApiRequestAuditLogsQuery, ApiRequestAuditLogsQueryVariables>;
export const PrivacyAuditLogsDocument = gql`
    query PrivacyAuditLogs($input: PrivacyAuditLogsInput!) {
  privacyAuditLogs(input: $input) {
    nextCursor
    items {
      __typename
      id
      accessTime
      actorId
      actor {
        id
        fullName
        email
      }
      ipAddresses
      accessData
      accessMenu
      accessMenuPath
      activityCategory
      customData
      userProvidedReason
      ... on SinglePrivacyAuditLogEntry {
        subjectType
        subjectId
        subject {
          __typename
          ... on Candidate {
            id
            fullName
            candidateEmail: email
          }
          ... on Employee {
            id
            fullName
            employeeEmail: email
          }
        }
      }
      ... on BulkPrivacyAuditLogEntry {
        bulkQuery
        bulkCount
        bulkScope
      }
    }
  }
}
    `;

/**
 * __usePrivacyAuditLogsQuery__
 *
 * To run a query within a React component, call `usePrivacyAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivacyAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivacyAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrivacyAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables> & ({ variables: PrivacyAuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>(PrivacyAuditLogsDocument, options);
      }
export function usePrivacyAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>(PrivacyAuditLogsDocument, options);
        }
// @ts-ignore
export function usePrivacyAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>;
export function usePrivacyAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<PrivacyAuditLogsQuery | undefined, PrivacyAuditLogsQueryVariables>;
export function usePrivacyAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>(PrivacyAuditLogsDocument, options);
        }
export type PrivacyAuditLogsQueryHookResult = ReturnType<typeof usePrivacyAuditLogsQuery>;
export type PrivacyAuditLogsLazyQueryHookResult = ReturnType<typeof usePrivacyAuditLogsLazyQuery>;
export type PrivacyAuditLogsSuspenseQueryHookResult = ReturnType<typeof usePrivacyAuditLogsSuspenseQuery>;
export type PrivacyAuditLogsQueryResult = Apollo.QueryResult<PrivacyAuditLogsQuery, PrivacyAuditLogsQueryVariables>;
export const OrgApiKeyDocument = gql`
    query OrgApiKey {
  thisOrg {
    id
    apiKey
  }
}
    `;

/**
 * __useOrgApiKeyQuery__
 *
 * To run a query within a React component, call `useOrgApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgApiKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgApiKeyQuery(baseOptions?: Apollo.QueryHookOptions<OrgApiKeyQuery, OrgApiKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgApiKeyQuery, OrgApiKeyQueryVariables>(OrgApiKeyDocument, options);
      }
export function useOrgApiKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgApiKeyQuery, OrgApiKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgApiKeyQuery, OrgApiKeyQueryVariables>(OrgApiKeyDocument, options);
        }
// @ts-ignore
export function useOrgApiKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgApiKeyQuery, OrgApiKeyQueryVariables>): Apollo.UseSuspenseQueryResult<OrgApiKeyQuery, OrgApiKeyQueryVariables>;
export function useOrgApiKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgApiKeyQuery, OrgApiKeyQueryVariables>): Apollo.UseSuspenseQueryResult<OrgApiKeyQuery | undefined, OrgApiKeyQueryVariables>;
export function useOrgApiKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgApiKeyQuery, OrgApiKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgApiKeyQuery, OrgApiKeyQueryVariables>(OrgApiKeyDocument, options);
        }
export type OrgApiKeyQueryHookResult = ReturnType<typeof useOrgApiKeyQuery>;
export type OrgApiKeyLazyQueryHookResult = ReturnType<typeof useOrgApiKeyLazyQuery>;
export type OrgApiKeySuspenseQueryHookResult = ReturnType<typeof useOrgApiKeySuspenseQuery>;
export type OrgApiKeyQueryResult = Apollo.QueryResult<OrgApiKeyQuery, OrgApiKeyQueryVariables>;
export const OrgScimTokenDocument = gql`
    query OrgScimToken {
  thisOrg {
    id
    scimToken
  }
}
    `;

/**
 * __useOrgScimTokenQuery__
 *
 * To run a query within a React component, call `useOrgScimTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgScimTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgScimTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgScimTokenQuery(baseOptions?: Apollo.QueryHookOptions<OrgScimTokenQuery, OrgScimTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgScimTokenQuery, OrgScimTokenQueryVariables>(OrgScimTokenDocument, options);
      }
export function useOrgScimTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgScimTokenQuery, OrgScimTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgScimTokenQuery, OrgScimTokenQueryVariables>(OrgScimTokenDocument, options);
        }
// @ts-ignore
export function useOrgScimTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgScimTokenQuery, OrgScimTokenQueryVariables>): Apollo.UseSuspenseQueryResult<OrgScimTokenQuery, OrgScimTokenQueryVariables>;
export function useOrgScimTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgScimTokenQuery, OrgScimTokenQueryVariables>): Apollo.UseSuspenseQueryResult<OrgScimTokenQuery | undefined, OrgScimTokenQueryVariables>;
export function useOrgScimTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgScimTokenQuery, OrgScimTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgScimTokenQuery, OrgScimTokenQueryVariables>(OrgScimTokenDocument, options);
        }
export type OrgScimTokenQueryHookResult = ReturnType<typeof useOrgScimTokenQuery>;
export type OrgScimTokenLazyQueryHookResult = ReturnType<typeof useOrgScimTokenLazyQuery>;
export type OrgScimTokenSuspenseQueryHookResult = ReturnType<typeof useOrgScimTokenSuspenseQuery>;
export type OrgScimTokenQueryResult = Apollo.QueryResult<OrgScimTokenQuery, OrgScimTokenQueryVariables>;
export const EditLanguagesEmployeeLocaleDocument = gql`
    query EditLanguagesEmployeeLocale {
  thisEmployee {
    id
    locale
  }
}
    `;

/**
 * __useEditLanguagesEmployeeLocaleQuery__
 *
 * To run a query within a React component, call `useEditLanguagesEmployeeLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditLanguagesEmployeeLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditLanguagesEmployeeLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditLanguagesEmployeeLocaleQuery(baseOptions?: Apollo.QueryHookOptions<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>(EditLanguagesEmployeeLocaleDocument, options);
      }
export function useEditLanguagesEmployeeLocaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>(EditLanguagesEmployeeLocaleDocument, options);
        }
// @ts-ignore
export function useEditLanguagesEmployeeLocaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>): Apollo.UseSuspenseQueryResult<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>;
export function useEditLanguagesEmployeeLocaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>): Apollo.UseSuspenseQueryResult<EditLanguagesEmployeeLocaleQuery | undefined, EditLanguagesEmployeeLocaleQueryVariables>;
export function useEditLanguagesEmployeeLocaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>(EditLanguagesEmployeeLocaleDocument, options);
        }
export type EditLanguagesEmployeeLocaleQueryHookResult = ReturnType<typeof useEditLanguagesEmployeeLocaleQuery>;
export type EditLanguagesEmployeeLocaleLazyQueryHookResult = ReturnType<typeof useEditLanguagesEmployeeLocaleLazyQuery>;
export type EditLanguagesEmployeeLocaleSuspenseQueryHookResult = ReturnType<typeof useEditLanguagesEmployeeLocaleSuspenseQuery>;
export type EditLanguagesEmployeeLocaleQueryResult = Apollo.QueryResult<EditLanguagesEmployeeLocaleQuery, EditLanguagesEmployeeLocaleQueryVariables>;
export const LocaleTranslationStatusDocument = gql`
    query LocaleTranslationStatus($input: LocaleTranslationStatusInput!) {
  localeTranslationStatus(input: $input) {
    total
    translated
    missing
  }
}
    `;

/**
 * __useLocaleTranslationStatusQuery__
 *
 * To run a query within a React component, call `useLocaleTranslationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocaleTranslationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocaleTranslationStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLocaleTranslationStatusQuery(baseOptions: Apollo.QueryHookOptions<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables> & ({ variables: LocaleTranslationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>(LocaleTranslationStatusDocument, options);
      }
export function useLocaleTranslationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>(LocaleTranslationStatusDocument, options);
        }
// @ts-ignore
export function useLocaleTranslationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>;
export function useLocaleTranslationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<LocaleTranslationStatusQuery | undefined, LocaleTranslationStatusQueryVariables>;
export function useLocaleTranslationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>(LocaleTranslationStatusDocument, options);
        }
export type LocaleTranslationStatusQueryHookResult = ReturnType<typeof useLocaleTranslationStatusQuery>;
export type LocaleTranslationStatusLazyQueryHookResult = ReturnType<typeof useLocaleTranslationStatusLazyQuery>;
export type LocaleTranslationStatusSuspenseQueryHookResult = ReturnType<typeof useLocaleTranslationStatusSuspenseQuery>;
export type LocaleTranslationStatusQueryResult = Apollo.QueryResult<LocaleTranslationStatusQuery, LocaleTranslationStatusQueryVariables>;
export const UpdateOrgNameDocument = gql`
    mutation UpdateOrgName($input: OrgUpdateInput!) {
  orgUpdate(input: $input) {
    ...EditOrgNameDialog_org
  }
}
    ${EditOrgNameDialog_OrgFragmentDoc}`;
export type UpdateOrgNameMutationFn = Apollo.MutationFunction<UpdateOrgNameMutation, UpdateOrgNameMutationVariables>;

/**
 * __useUpdateOrgNameMutation__
 *
 * To run a mutation, you first call `useUpdateOrgNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgNameMutation, { data, loading, error }] = useUpdateOrgNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgNameMutation, UpdateOrgNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgNameMutation, UpdateOrgNameMutationVariables>(UpdateOrgNameDocument, options);
      }
export type UpdateOrgNameMutationHookResult = ReturnType<typeof useUpdateOrgNameMutation>;
export type UpdateOrgNameMutationResult = Apollo.MutationResult<UpdateOrgNameMutation>;
export type UpdateOrgNameMutationOptions = Apollo.BaseMutationOptions<UpdateOrgNameMutation, UpdateOrgNameMutationVariables>;
export const PortalCreateOrgSlugDocument = gql`
    mutation PortalCreateOrgSlug($input: PortalSlugCreateInput!) {
  portalSlugCreate(input: $input) {
    orgId
  }
}
    `;
export type PortalCreateOrgSlugMutationFn = Apollo.MutationFunction<PortalCreateOrgSlugMutation, PortalCreateOrgSlugMutationVariables>;

/**
 * __usePortalCreateOrgSlugMutation__
 *
 * To run a mutation, you first call `usePortalCreateOrgSlugMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalCreateOrgSlugMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalCreateOrgSlugMutation, { data, loading, error }] = usePortalCreateOrgSlugMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePortalCreateOrgSlugMutation(baseOptions?: Apollo.MutationHookOptions<PortalCreateOrgSlugMutation, PortalCreateOrgSlugMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalCreateOrgSlugMutation, PortalCreateOrgSlugMutationVariables>(PortalCreateOrgSlugDocument, options);
      }
export type PortalCreateOrgSlugMutationHookResult = ReturnType<typeof usePortalCreateOrgSlugMutation>;
export type PortalCreateOrgSlugMutationResult = Apollo.MutationResult<PortalCreateOrgSlugMutation>;
export type PortalCreateOrgSlugMutationOptions = Apollo.BaseMutationOptions<PortalCreateOrgSlugMutation, PortalCreateOrgSlugMutationVariables>;
export const OrgNameAndSlugDocument = gql`
    query OrgNameAndSlug {
  thisOrg {
    id
    name
    ...EditOrgNameDialog_org
    slugs {
      slug
      isPrimary
    }
    domains
  }
}
    ${EditOrgNameDialog_OrgFragmentDoc}`;

/**
 * __useOrgNameAndSlugQuery__
 *
 * To run a query within a React component, call `useOrgNameAndSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgNameAndSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgNameAndSlugQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgNameAndSlugQuery(baseOptions?: Apollo.QueryHookOptions<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>(OrgNameAndSlugDocument, options);
      }
export function useOrgNameAndSlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>(OrgNameAndSlugDocument, options);
        }
// @ts-ignore
export function useOrgNameAndSlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>): Apollo.UseSuspenseQueryResult<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>;
export function useOrgNameAndSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>): Apollo.UseSuspenseQueryResult<OrgNameAndSlugQuery | undefined, OrgNameAndSlugQueryVariables>;
export function useOrgNameAndSlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>(OrgNameAndSlugDocument, options);
        }
export type OrgNameAndSlugQueryHookResult = ReturnType<typeof useOrgNameAndSlugQuery>;
export type OrgNameAndSlugLazyQueryHookResult = ReturnType<typeof useOrgNameAndSlugLazyQuery>;
export type OrgNameAndSlugSuspenseQueryHookResult = ReturnType<typeof useOrgNameAndSlugSuspenseQuery>;
export type OrgNameAndSlugQueryResult = Apollo.QueryResult<OrgNameAndSlugQuery, OrgNameAndSlugQueryVariables>;
export const TaskTagCreateDocument = gql`
    mutation TaskTagCreate($input: TaskTagCreateInput!) {
  taskTagCreate(input: $input) {
    taskTag {
      id
      name
    }
  }
}
    `;
export type TaskTagCreateMutationFn = Apollo.MutationFunction<TaskTagCreateMutation, TaskTagCreateMutationVariables>;

/**
 * __useTaskTagCreateMutation__
 *
 * To run a mutation, you first call `useTaskTagCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskTagCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskTagCreateMutation, { data, loading, error }] = useTaskTagCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskTagCreateMutation(baseOptions?: Apollo.MutationHookOptions<TaskTagCreateMutation, TaskTagCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskTagCreateMutation, TaskTagCreateMutationVariables>(TaskTagCreateDocument, options);
      }
export type TaskTagCreateMutationHookResult = ReturnType<typeof useTaskTagCreateMutation>;
export type TaskTagCreateMutationResult = Apollo.MutationResult<TaskTagCreateMutation>;
export type TaskTagCreateMutationOptions = Apollo.BaseMutationOptions<TaskTagCreateMutation, TaskTagCreateMutationVariables>;
export const TaskTagDeleteDocument = gql`
    mutation TaskTagDelete($input: TaskTagDeleteInput!) {
  taskTagDelete(input: $input) {
    ok
  }
}
    `;
export type TaskTagDeleteMutationFn = Apollo.MutationFunction<TaskTagDeleteMutation, TaskTagDeleteMutationVariables>;

/**
 * __useTaskTagDeleteMutation__
 *
 * To run a mutation, you first call `useTaskTagDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskTagDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskTagDeleteMutation, { data, loading, error }] = useTaskTagDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskTagDeleteMutation(baseOptions?: Apollo.MutationHookOptions<TaskTagDeleteMutation, TaskTagDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskTagDeleteMutation, TaskTagDeleteMutationVariables>(TaskTagDeleteDocument, options);
      }
export type TaskTagDeleteMutationHookResult = ReturnType<typeof useTaskTagDeleteMutation>;
export type TaskTagDeleteMutationResult = Apollo.MutationResult<TaskTagDeleteMutation>;
export type TaskTagDeleteMutationOptions = Apollo.BaseMutationOptions<TaskTagDeleteMutation, TaskTagDeleteMutationVariables>;
export const TaskTagUpdateDocument = gql`
    mutation TaskTagUpdate($input: TaskTagUpdateInput!) {
  taskTagUpdate(input: $input) {
    taskTag {
      ...EditTagModal_taskTag
    }
  }
}
    ${EditTagModal_TaskTagFragmentDoc}`;
export type TaskTagUpdateMutationFn = Apollo.MutationFunction<TaskTagUpdateMutation, TaskTagUpdateMutationVariables>;

/**
 * __useTaskTagUpdateMutation__
 *
 * To run a mutation, you first call `useTaskTagUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskTagUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskTagUpdateMutation, { data, loading, error }] = useTaskTagUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskTagUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TaskTagUpdateMutation, TaskTagUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskTagUpdateMutation, TaskTagUpdateMutationVariables>(TaskTagUpdateDocument, options);
      }
export type TaskTagUpdateMutationHookResult = ReturnType<typeof useTaskTagUpdateMutation>;
export type TaskTagUpdateMutationResult = Apollo.MutationResult<TaskTagUpdateMutation>;
export type TaskTagUpdateMutationOptions = Apollo.BaseMutationOptions<TaskTagUpdateMutation, TaskTagUpdateMutationVariables>;
export const TaskTagListDocument = gql`
    query TaskTagList($input: TaskTagsInput!) {
  taskTags(input: $input) {
    items {
      ...TaskTagList_taskTag
    }
    nextCursor
  }
}
    ${TaskTagList_TaskTagFragmentDoc}`;

/**
 * __useTaskTagListQuery__
 *
 * To run a query within a React component, call `useTaskTagListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTagListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTagListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskTagListQuery(baseOptions: Apollo.QueryHookOptions<TaskTagListQuery, TaskTagListQueryVariables> & ({ variables: TaskTagListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskTagListQuery, TaskTagListQueryVariables>(TaskTagListDocument, options);
      }
export function useTaskTagListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskTagListQuery, TaskTagListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskTagListQuery, TaskTagListQueryVariables>(TaskTagListDocument, options);
        }
// @ts-ignore
export function useTaskTagListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskTagListQuery, TaskTagListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTagListQuery, TaskTagListQueryVariables>;
export function useTaskTagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTagListQuery, TaskTagListQueryVariables>): Apollo.UseSuspenseQueryResult<TaskTagListQuery | undefined, TaskTagListQueryVariables>;
export function useTaskTagListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskTagListQuery, TaskTagListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskTagListQuery, TaskTagListQueryVariables>(TaskTagListDocument, options);
        }
export type TaskTagListQueryHookResult = ReturnType<typeof useTaskTagListQuery>;
export type TaskTagListLazyQueryHookResult = ReturnType<typeof useTaskTagListLazyQuery>;
export type TaskTagListSuspenseQueryHookResult = ReturnType<typeof useTaskTagListSuspenseQuery>;
export type TaskTagListQueryResult = Apollo.QueryResult<TaskTagListQuery, TaskTagListQueryVariables>;
export const DeleteTaskQueueDocument = gql`
    mutation deleteTaskQueue($input: TaskQueueDeleteInput!) {
  taskQueueDelete(input: $input) {
    result
  }
}
    `;
export type DeleteTaskQueueMutationFn = Apollo.MutationFunction<DeleteTaskQueueMutation, DeleteTaskQueueMutationVariables>;

/**
 * __useDeleteTaskQueueMutation__
 *
 * To run a mutation, you first call `useDeleteTaskQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskQueueMutation, { data, loading, error }] = useDeleteTaskQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTaskQueueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskQueueMutation, DeleteTaskQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskQueueMutation, DeleteTaskQueueMutationVariables>(DeleteTaskQueueDocument, options);
      }
export type DeleteTaskQueueMutationHookResult = ReturnType<typeof useDeleteTaskQueueMutation>;
export type DeleteTaskQueueMutationResult = Apollo.MutationResult<DeleteTaskQueueMutation>;
export type DeleteTaskQueueMutationOptions = Apollo.BaseMutationOptions<DeleteTaskQueueMutation, DeleteTaskQueueMutationVariables>;
export const CreateTaskQueueDocument = gql`
    mutation CreateTaskQueue($input: TaskQueueCreateInput!) {
  taskQueueCreate(input: $input) {
    taskQueue {
      id
      ...QueueRow_taskQueue
    }
  }
}
    ${QueueRow_TaskQueueFragmentDoc}`;
export type CreateTaskQueueMutationFn = Apollo.MutationFunction<CreateTaskQueueMutation, CreateTaskQueueMutationVariables>;

/**
 * __useCreateTaskQueueMutation__
 *
 * To run a mutation, you first call `useCreateTaskQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskQueueMutation, { data, loading, error }] = useCreateTaskQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskQueueMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskQueueMutation, CreateTaskQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskQueueMutation, CreateTaskQueueMutationVariables>(CreateTaskQueueDocument, options);
      }
export type CreateTaskQueueMutationHookResult = ReturnType<typeof useCreateTaskQueueMutation>;
export type CreateTaskQueueMutationResult = Apollo.MutationResult<CreateTaskQueueMutation>;
export type CreateTaskQueueMutationOptions = Apollo.BaseMutationOptions<CreateTaskQueueMutation, CreateTaskQueueMutationVariables>;
export const EditTaskQueueDocument = gql`
    mutation EditTaskQueue($input: TaskQueueUpdateInput!) {
  taskQueueUpdate(input: $input) {
    taskQueue {
      id
      ...QueueRow_taskQueue
    }
  }
}
    ${QueueRow_TaskQueueFragmentDoc}`;
export type EditTaskQueueMutationFn = Apollo.MutationFunction<EditTaskQueueMutation, EditTaskQueueMutationVariables>;

/**
 * __useEditTaskQueueMutation__
 *
 * To run a mutation, you first call `useEditTaskQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTaskQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTaskQueueMutation, { data, loading, error }] = useEditTaskQueueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditTaskQueueMutation(baseOptions?: Apollo.MutationHookOptions<EditTaskQueueMutation, EditTaskQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTaskQueueMutation, EditTaskQueueMutationVariables>(EditTaskQueueDocument, options);
      }
export type EditTaskQueueMutationHookResult = ReturnType<typeof useEditTaskQueueMutation>;
export type EditTaskQueueMutationResult = Apollo.MutationResult<EditTaskQueueMutation>;
export type EditTaskQueueMutationOptions = Apollo.BaseMutationOptions<EditTaskQueueMutation, EditTaskQueueMutationVariables>;
export const SubscribersListQueueModalDocument = gql`
    query SubscribersListQueueModal($input: SubscribersInput!) {
  subscribers(input: $input) {
    items {
      id
      ...QueueDialogContent_queueMembers
    }
  }
}
    ${QueueDialogContent_QueueMembersFragmentDoc}`;

/**
 * __useSubscribersListQueueModalQuery__
 *
 * To run a query within a React component, call `useSubscribersListQueueModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscribersListQueueModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribersListQueueModalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribersListQueueModalQuery(baseOptions: Apollo.QueryHookOptions<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables> & ({ variables: SubscribersListQueueModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>(SubscribersListQueueModalDocument, options);
      }
export function useSubscribersListQueueModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>(SubscribersListQueueModalDocument, options);
        }
// @ts-ignore
export function useSubscribersListQueueModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>): Apollo.UseSuspenseQueryResult<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>;
export function useSubscribersListQueueModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>): Apollo.UseSuspenseQueryResult<SubscribersListQueueModalQuery | undefined, SubscribersListQueueModalQueryVariables>;
export function useSubscribersListQueueModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>(SubscribersListQueueModalDocument, options);
        }
export type SubscribersListQueueModalQueryHookResult = ReturnType<typeof useSubscribersListQueueModalQuery>;
export type SubscribersListQueueModalLazyQueryHookResult = ReturnType<typeof useSubscribersListQueueModalLazyQuery>;
export type SubscribersListQueueModalSuspenseQueryHookResult = ReturnType<typeof useSubscribersListQueueModalSuspenseQuery>;
export type SubscribersListQueueModalQueryResult = Apollo.QueryResult<SubscribersListQueueModalQuery, SubscribersListQueueModalQueryVariables>;
export const TaskQueuesDocument = gql`
    query TaskQueues($input: TaskQueueSearchInput!) {
  taskQueueSearch(input: $input) {
    items {
      ...QueueList_taskQueue
    }
  }
}
    ${QueueList_TaskQueueFragmentDoc}`;

/**
 * __useTaskQueuesQuery__
 *
 * To run a query within a React component, call `useTaskQueuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQueuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQueuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskQueuesQuery(baseOptions: Apollo.QueryHookOptions<TaskQueuesQuery, TaskQueuesQueryVariables> & ({ variables: TaskQueuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQueuesQuery, TaskQueuesQueryVariables>(TaskQueuesDocument, options);
      }
export function useTaskQueuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQueuesQuery, TaskQueuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQueuesQuery, TaskQueuesQueryVariables>(TaskQueuesDocument, options);
        }
// @ts-ignore
export function useTaskQueuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TaskQueuesQuery, TaskQueuesQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueuesQuery, TaskQueuesQueryVariables>;
export function useTaskQueuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueuesQuery, TaskQueuesQueryVariables>): Apollo.UseSuspenseQueryResult<TaskQueuesQuery | undefined, TaskQueuesQueryVariables>;
export function useTaskQueuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaskQueuesQuery, TaskQueuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaskQueuesQuery, TaskQueuesQueryVariables>(TaskQueuesDocument, options);
        }
export type TaskQueuesQueryHookResult = ReturnType<typeof useTaskQueuesQuery>;
export type TaskQueuesLazyQueryHookResult = ReturnType<typeof useTaskQueuesLazyQuery>;
export type TaskQueuesSuspenseQueryHookResult = ReturnType<typeof useTaskQueuesSuspenseQuery>;
export type TaskQueuesQueryResult = Apollo.QueryResult<TaskQueuesQuery, TaskQueuesQueryVariables>;
export const RescheduleReasonCreateDocument = gql`
    mutation RescheduleReasonCreate($input: RescheduleReasonCreateInput!) {
  rescheduleReasonCreate(input: $input) {
    rescheduleReason {
      id
      reason
    }
  }
}
    `;
export type RescheduleReasonCreateMutationFn = Apollo.MutationFunction<RescheduleReasonCreateMutation, RescheduleReasonCreateMutationVariables>;

/**
 * __useRescheduleReasonCreateMutation__
 *
 * To run a mutation, you first call `useRescheduleReasonCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleReasonCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleReasonCreateMutation, { data, loading, error }] = useRescheduleReasonCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleReasonCreateMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleReasonCreateMutation, RescheduleReasonCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleReasonCreateMutation, RescheduleReasonCreateMutationVariables>(RescheduleReasonCreateDocument, options);
      }
export type RescheduleReasonCreateMutationHookResult = ReturnType<typeof useRescheduleReasonCreateMutation>;
export type RescheduleReasonCreateMutationResult = Apollo.MutationResult<RescheduleReasonCreateMutation>;
export type RescheduleReasonCreateMutationOptions = Apollo.BaseMutationOptions<RescheduleReasonCreateMutation, RescheduleReasonCreateMutationVariables>;
export const RescheduleReasonUpdateDocument = gql`
    mutation RescheduleReasonUpdate($input: RescheduleReasonUpdateInput!) {
  rescheduleReasonUpdate(input: $input) {
    rescheduleReason {
      ...EditRescheduleReasonModal_rescheduleReason
    }
  }
}
    ${EditRescheduleReasonModal_RescheduleReasonFragmentDoc}`;
export type RescheduleReasonUpdateMutationFn = Apollo.MutationFunction<RescheduleReasonUpdateMutation, RescheduleReasonUpdateMutationVariables>;

/**
 * __useRescheduleReasonUpdateMutation__
 *
 * To run a mutation, you first call `useRescheduleReasonUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleReasonUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleReasonUpdateMutation, { data, loading, error }] = useRescheduleReasonUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleReasonUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleReasonUpdateMutation, RescheduleReasonUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleReasonUpdateMutation, RescheduleReasonUpdateMutationVariables>(RescheduleReasonUpdateDocument, options);
      }
export type RescheduleReasonUpdateMutationHookResult = ReturnType<typeof useRescheduleReasonUpdateMutation>;
export type RescheduleReasonUpdateMutationResult = Apollo.MutationResult<RescheduleReasonUpdateMutation>;
export type RescheduleReasonUpdateMutationOptions = Apollo.BaseMutationOptions<RescheduleReasonUpdateMutation, RescheduleReasonUpdateMutationVariables>;
export const RescheduleReasonsListDocument = gql`
    query RescheduleReasonsList($input: RescheduleReasonsInput!) {
  rescheduleReasons(input: $input) {
    items {
      ...RescheduleReasonsList_rescheduleReason
    }
    nextCursor
  }
}
    ${RescheduleReasonsList_RescheduleReasonFragmentDoc}`;

/**
 * __useRescheduleReasonsListQuery__
 *
 * To run a query within a React component, call `useRescheduleReasonsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRescheduleReasonsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRescheduleReasonsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleReasonsListQuery(baseOptions: Apollo.QueryHookOptions<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables> & ({ variables: RescheduleReasonsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>(RescheduleReasonsListDocument, options);
      }
export function useRescheduleReasonsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>(RescheduleReasonsListDocument, options);
        }
// @ts-ignore
export function useRescheduleReasonsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>): Apollo.UseSuspenseQueryResult<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>;
export function useRescheduleReasonsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>): Apollo.UseSuspenseQueryResult<RescheduleReasonsListQuery | undefined, RescheduleReasonsListQueryVariables>;
export function useRescheduleReasonsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>(RescheduleReasonsListDocument, options);
        }
export type RescheduleReasonsListQueryHookResult = ReturnType<typeof useRescheduleReasonsListQuery>;
export type RescheduleReasonsListLazyQueryHookResult = ReturnType<typeof useRescheduleReasonsListLazyQuery>;
export type RescheduleReasonsListSuspenseQueryHookResult = ReturnType<typeof useRescheduleReasonsListSuspenseQuery>;
export type RescheduleReasonsListQueryResult = Apollo.QueryResult<RescheduleReasonsListQuery, RescheduleReasonsListQueryVariables>;
export const EmployeesWithOnBehalfOfPermissionDocument = gql`
    query EmployeesWithOnBehalfOfPermission($input: EmployeeSearchInput!) {
  employeeSearch(input: $input) {
    items {
      id
      fullName
      email
      internalProfilePictureUrl
    }
  }
}
    `;

/**
 * __useEmployeesWithOnBehalfOfPermissionQuery__
 *
 * To run a query within a React component, call `useEmployeesWithOnBehalfOfPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesWithOnBehalfOfPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesWithOnBehalfOfPermissionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeesWithOnBehalfOfPermissionQuery(baseOptions: Apollo.QueryHookOptions<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables> & ({ variables: EmployeesWithOnBehalfOfPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>(EmployeesWithOnBehalfOfPermissionDocument, options);
      }
export function useEmployeesWithOnBehalfOfPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>(EmployeesWithOnBehalfOfPermissionDocument, options);
        }
// @ts-ignore
export function useEmployeesWithOnBehalfOfPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>;
export function useEmployeesWithOnBehalfOfPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeesWithOnBehalfOfPermissionQuery | undefined, EmployeesWithOnBehalfOfPermissionQueryVariables>;
export function useEmployeesWithOnBehalfOfPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>(EmployeesWithOnBehalfOfPermissionDocument, options);
        }
export type EmployeesWithOnBehalfOfPermissionQueryHookResult = ReturnType<typeof useEmployeesWithOnBehalfOfPermissionQuery>;
export type EmployeesWithOnBehalfOfPermissionLazyQueryHookResult = ReturnType<typeof useEmployeesWithOnBehalfOfPermissionLazyQuery>;
export type EmployeesWithOnBehalfOfPermissionSuspenseQueryHookResult = ReturnType<typeof useEmployeesWithOnBehalfOfPermissionSuspenseQuery>;
export type EmployeesWithOnBehalfOfPermissionQueryResult = Apollo.QueryResult<EmployeesWithOnBehalfOfPermissionQuery, EmployeesWithOnBehalfOfPermissionQueryVariables>;
export const DefaultTemplateForTypesDocument = gql`
    query DefaultTemplateForTypes($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateFrag
    }
  }
}
    ${TemplateFragFragmentDoc}`;

/**
 * __useDefaultTemplateForTypesQuery__
 *
 * To run a query within a React component, call `useDefaultTemplateForTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultTemplateForTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultTemplateForTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefaultTemplateForTypesQuery(baseOptions: Apollo.QueryHookOptions<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables> & ({ variables: DefaultTemplateForTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>(DefaultTemplateForTypesDocument, options);
      }
export function useDefaultTemplateForTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>(DefaultTemplateForTypesDocument, options);
        }
// @ts-ignore
export function useDefaultTemplateForTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>;
export function useDefaultTemplateForTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultTemplateForTypesQuery | undefined, DefaultTemplateForTypesQueryVariables>;
export function useDefaultTemplateForTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>(DefaultTemplateForTypesDocument, options);
        }
export type DefaultTemplateForTypesQueryHookResult = ReturnType<typeof useDefaultTemplateForTypesQuery>;
export type DefaultTemplateForTypesLazyQueryHookResult = ReturnType<typeof useDefaultTemplateForTypesLazyQuery>;
export type DefaultTemplateForTypesSuspenseQueryHookResult = ReturnType<typeof useDefaultTemplateForTypesSuspenseQuery>;
export type DefaultTemplateForTypesQueryResult = Apollo.QueryResult<DefaultTemplateForTypesQuery, DefaultTemplateForTypesQueryVariables>;
export const OrganizationTemplatesDocument = gql`
    query OrganizationTemplates($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      ...TemplateFrag
    }
  }
}
    ${TemplateFragFragmentDoc}`;

/**
 * __useOrganizationTemplatesQuery__
 *
 * To run a query within a React component, call `useOrganizationTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationTemplatesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables> & ({ variables: OrganizationTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>(OrganizationTemplatesDocument, options);
      }
export function useOrganizationTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>(OrganizationTemplatesDocument, options);
        }
// @ts-ignore
export function useOrganizationTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>;
export function useOrganizationTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationTemplatesQuery | undefined, OrganizationTemplatesQueryVariables>;
export function useOrganizationTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>(OrganizationTemplatesDocument, options);
        }
export type OrganizationTemplatesQueryHookResult = ReturnType<typeof useOrganizationTemplatesQuery>;
export type OrganizationTemplatesLazyQueryHookResult = ReturnType<typeof useOrganizationTemplatesLazyQuery>;
export type OrganizationTemplatesSuspenseQueryHookResult = ReturnType<typeof useOrganizationTemplatesSuspenseQuery>;
export type OrganizationTemplatesQueryResult = Apollo.QueryResult<OrganizationTemplatesQuery, OrganizationTemplatesQueryVariables>;
export const OrganizationTemplateCreateDocument = gql`
    mutation OrganizationTemplateCreate($input: TemplateCreateInput!) {
  templateCreate(input: $input) {
    template {
      ...TemplateFrag
      ...Attachments
    }
  }
}
    ${TemplateFragFragmentDoc}
${AttachmentsFragmentDoc}`;
export type OrganizationTemplateCreateMutationFn = Apollo.MutationFunction<OrganizationTemplateCreateMutation, OrganizationTemplateCreateMutationVariables>;

/**
 * __useOrganizationTemplateCreateMutation__
 *
 * To run a mutation, you first call `useOrganizationTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationTemplateCreateMutation, { data, loading, error }] = useOrganizationTemplateCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationTemplateCreateMutation, OrganizationTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationTemplateCreateMutation, OrganizationTemplateCreateMutationVariables>(OrganizationTemplateCreateDocument, options);
      }
export type OrganizationTemplateCreateMutationHookResult = ReturnType<typeof useOrganizationTemplateCreateMutation>;
export type OrganizationTemplateCreateMutationResult = Apollo.MutationResult<OrganizationTemplateCreateMutation>;
export type OrganizationTemplateCreateMutationOptions = Apollo.BaseMutationOptions<OrganizationTemplateCreateMutation, OrganizationTemplateCreateMutationVariables>;
export const OrganizationTemplateUpdateDocument = gql`
    mutation OrganizationTemplateUpdate($input: TemplateUpdateInput!) {
  templateUpdate(input: $input) {
    template {
      ...TemplateFrag
      ...Attachments
    }
  }
}
    ${TemplateFragFragmentDoc}
${AttachmentsFragmentDoc}`;
export type OrganizationTemplateUpdateMutationFn = Apollo.MutationFunction<OrganizationTemplateUpdateMutation, OrganizationTemplateUpdateMutationVariables>;

/**
 * __useOrganizationTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useOrganizationTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationTemplateUpdateMutation, { data, loading, error }] = useOrganizationTemplateUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationTemplateUpdateMutation, OrganizationTemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationTemplateUpdateMutation, OrganizationTemplateUpdateMutationVariables>(OrganizationTemplateUpdateDocument, options);
      }
export type OrganizationTemplateUpdateMutationHookResult = ReturnType<typeof useOrganizationTemplateUpdateMutation>;
export type OrganizationTemplateUpdateMutationResult = Apollo.MutationResult<OrganizationTemplateUpdateMutation>;
export type OrganizationTemplateUpdateMutationOptions = Apollo.BaseMutationOptions<OrganizationTemplateUpdateMutation, OrganizationTemplateUpdateMutationVariables>;
export const OrganizationTemplateDeleteDocument = gql`
    mutation OrganizationTemplateDelete($id: uuid!) {
  templateDelete(id: $id) {
    template {
      id
    }
  }
}
    `;
export type OrganizationTemplateDeleteMutationFn = Apollo.MutationFunction<OrganizationTemplateDeleteMutation, OrganizationTemplateDeleteMutationVariables>;

/**
 * __useOrganizationTemplateDeleteMutation__
 *
 * To run a mutation, you first call `useOrganizationTemplateDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTemplateDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationTemplateDeleteMutation, { data, loading, error }] = useOrganizationTemplateDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationTemplateDeleteMutation(baseOptions?: Apollo.MutationHookOptions<OrganizationTemplateDeleteMutation, OrganizationTemplateDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganizationTemplateDeleteMutation, OrganizationTemplateDeleteMutationVariables>(OrganizationTemplateDeleteDocument, options);
      }
export type OrganizationTemplateDeleteMutationHookResult = ReturnType<typeof useOrganizationTemplateDeleteMutation>;
export type OrganizationTemplateDeleteMutationResult = Apollo.MutationResult<OrganizationTemplateDeleteMutation>;
export type OrganizationTemplateDeleteMutationOptions = Apollo.BaseMutationOptions<OrganizationTemplateDeleteMutation, OrganizationTemplateDeleteMutationVariables>;
export const TemplateAttachementsDocument = gql`
    query TemplateAttachements($id: uuid!) {
  template(id: $id) {
    id
    ...Attachments
  }
}
    ${AttachmentsFragmentDoc}`;

/**
 * __useTemplateAttachementsQuery__
 *
 * To run a query within a React component, call `useTemplateAttachementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateAttachementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateAttachementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTemplateAttachementsQuery(baseOptions: Apollo.QueryHookOptions<TemplateAttachementsQuery, TemplateAttachementsQueryVariables> & ({ variables: TemplateAttachementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>(TemplateAttachementsDocument, options);
      }
export function useTemplateAttachementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>(TemplateAttachementsDocument, options);
        }
// @ts-ignore
export function useTemplateAttachementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>;
export function useTemplateAttachementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateAttachementsQuery | undefined, TemplateAttachementsQueryVariables>;
export function useTemplateAttachementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>(TemplateAttachementsDocument, options);
        }
export type TemplateAttachementsQueryHookResult = ReturnType<typeof useTemplateAttachementsQuery>;
export type TemplateAttachementsLazyQueryHookResult = ReturnType<typeof useTemplateAttachementsLazyQuery>;
export type TemplateAttachementsSuspenseQueryHookResult = ReturnType<typeof useTemplateAttachementsSuspenseQuery>;
export type TemplateAttachementsQueryResult = Apollo.QueryResult<TemplateAttachementsQuery, TemplateAttachementsQueryVariables>;
export const DeleteTemplateDocument = gql`
    mutation deleteTemplate($id: uuid!) {
  templateDelete(id: $id) {
    template {
      id
    }
  }
}
    `;
export type DeleteTemplateMutationFn = Apollo.MutationFunction<DeleteTemplateMutation, DeleteTemplateMutationVariables>;

/**
 * __useDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateMutation, { data, loading, error }] = useDeleteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateMutation, DeleteTemplateMutationVariables>(DeleteTemplateDocument, options);
      }
export type DeleteTemplateMutationHookResult = ReturnType<typeof useDeleteTemplateMutation>;
export type DeleteTemplateMutationResult = Apollo.MutationResult<DeleteTemplateMutation>;
export type DeleteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateMutation, DeleteTemplateMutationVariables>;
export const TemplateCreateDocument = gql`
    mutation templateCreate($input: TemplateCreateInput!) {
  templateCreate(input: $input) {
    template {
      id
    }
  }
}
    `;
export type TemplateCreateMutationFn = Apollo.MutationFunction<TemplateCreateMutation, TemplateCreateMutationVariables>;

/**
 * __useTemplateCreateMutation__
 *
 * To run a mutation, you first call `useTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateCreateMutation, { data, loading, error }] = useTemplateCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateCreateMutation(baseOptions?: Apollo.MutationHookOptions<TemplateCreateMutation, TemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateCreateMutation, TemplateCreateMutationVariables>(TemplateCreateDocument, options);
      }
export type TemplateCreateMutationHookResult = ReturnType<typeof useTemplateCreateMutation>;
export type TemplateCreateMutationResult = Apollo.MutationResult<TemplateCreateMutation>;
export type TemplateCreateMutationOptions = Apollo.BaseMutationOptions<TemplateCreateMutation, TemplateCreateMutationVariables>;
export const TemplateUpdateDocument = gql`
    mutation templateUpdate($input: TemplateUpdateInput!) {
  templateUpdate(input: $input) {
    template {
      id
    }
  }
}
    `;
export type TemplateUpdateMutationFn = Apollo.MutationFunction<TemplateUpdateMutation, TemplateUpdateMutationVariables>;

/**
 * __useTemplateUpdateMutation__
 *
 * To run a mutation, you first call `useTemplateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTemplateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [templateUpdateMutation, { data, loading, error }] = useTemplateUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<TemplateUpdateMutation, TemplateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TemplateUpdateMutation, TemplateUpdateMutationVariables>(TemplateUpdateDocument, options);
      }
export type TemplateUpdateMutationHookResult = ReturnType<typeof useTemplateUpdateMutation>;
export type TemplateUpdateMutationResult = Apollo.MutationResult<TemplateUpdateMutation>;
export type TemplateUpdateMutationOptions = Apollo.BaseMutationOptions<TemplateUpdateMutation, TemplateUpdateMutationVariables>;
export const TemplatesDocument = gql`
    query Templates($input: TemplatesInput!) {
  templates(input: $input) {
    items {
      id
      ...Template_template
      ...Template_orgDefaultTemplate
      ...TemplateModal_template
    }
  }
}
    ${Template_TemplateFragmentDoc}
${Template_OrgDefaultTemplateFragmentDoc}
${TemplateModal_TemplateFragmentDoc}`;

/**
 * __useTemplatesQuery__
 *
 * To run a query within a React component, call `useTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTemplatesQuery(baseOptions: Apollo.QueryHookOptions<TemplatesQuery, TemplatesQueryVariables> & ({ variables: TemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
      }
export function useTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
// @ts-ignore
export function useTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<TemplatesQuery, TemplatesQueryVariables>;
export function useTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<TemplatesQuery | undefined, TemplatesQueryVariables>;
export function useTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplatesQuery, TemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplatesQuery, TemplatesQueryVariables>(TemplatesDocument, options);
        }
export type TemplatesQueryHookResult = ReturnType<typeof useTemplatesQuery>;
export type TemplatesLazyQueryHookResult = ReturnType<typeof useTemplatesLazyQuery>;
export type TemplatesSuspenseQueryHookResult = ReturnType<typeof useTemplatesSuspenseQuery>;
export type TemplatesQueryResult = Apollo.QueryResult<TemplatesQuery, TemplatesQueryVariables>;
export const SetTemplateAsOrgDefaultDocument = gql`
    mutation SetTemplateAsOrgDefault($id: uuid!, $isOrganizationDefault: Boolean!) {
  templateUpdate(input: {id: $id, isOrganizationDefault: $isOrganizationDefault}) {
    template {
      id
    }
  }
}
    `;
export type SetTemplateAsOrgDefaultMutationFn = Apollo.MutationFunction<SetTemplateAsOrgDefaultMutation, SetTemplateAsOrgDefaultMutationVariables>;

/**
 * __useSetTemplateAsOrgDefaultMutation__
 *
 * To run a mutation, you first call `useSetTemplateAsOrgDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTemplateAsOrgDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTemplateAsOrgDefaultMutation, { data, loading, error }] = useSetTemplateAsOrgDefaultMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isOrganizationDefault: // value for 'isOrganizationDefault'
 *   },
 * });
 */
export function useSetTemplateAsOrgDefaultMutation(baseOptions?: Apollo.MutationHookOptions<SetTemplateAsOrgDefaultMutation, SetTemplateAsOrgDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTemplateAsOrgDefaultMutation, SetTemplateAsOrgDefaultMutationVariables>(SetTemplateAsOrgDefaultDocument, options);
      }
export type SetTemplateAsOrgDefaultMutationHookResult = ReturnType<typeof useSetTemplateAsOrgDefaultMutation>;
export type SetTemplateAsOrgDefaultMutationResult = Apollo.MutationResult<SetTemplateAsOrgDefaultMutation>;
export type SetTemplateAsOrgDefaultMutationOptions = Apollo.BaseMutationOptions<SetTemplateAsOrgDefaultMutation, SetTemplateAsOrgDefaultMutationVariables>;
export const CustomInterviewScheduleTokenPreviewDocument = gql`
    query CustomInterviewScheduleTokenPreview($input: CustomInterviewScheduleTokenPreviewInput!) {
  customInterviewScheduleTokenPreview(input: $input) {
    html
  }
}
    `;

/**
 * __useCustomInterviewScheduleTokenPreviewQuery__
 *
 * To run a query within a React component, call `useCustomInterviewScheduleTokenPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomInterviewScheduleTokenPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomInterviewScheduleTokenPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomInterviewScheduleTokenPreviewQuery(baseOptions: Apollo.QueryHookOptions<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables> & ({ variables: CustomInterviewScheduleTokenPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>(CustomInterviewScheduleTokenPreviewDocument, options);
      }
export function useCustomInterviewScheduleTokenPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>(CustomInterviewScheduleTokenPreviewDocument, options);
        }
// @ts-ignore
export function useCustomInterviewScheduleTokenPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>;
export function useCustomInterviewScheduleTokenPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<CustomInterviewScheduleTokenPreviewQuery | undefined, CustomInterviewScheduleTokenPreviewQueryVariables>;
export function useCustomInterviewScheduleTokenPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>(CustomInterviewScheduleTokenPreviewDocument, options);
        }
export type CustomInterviewScheduleTokenPreviewQueryHookResult = ReturnType<typeof useCustomInterviewScheduleTokenPreviewQuery>;
export type CustomInterviewScheduleTokenPreviewLazyQueryHookResult = ReturnType<typeof useCustomInterviewScheduleTokenPreviewLazyQuery>;
export type CustomInterviewScheduleTokenPreviewSuspenseQueryHookResult = ReturnType<typeof useCustomInterviewScheduleTokenPreviewSuspenseQuery>;
export type CustomInterviewScheduleTokenPreviewQueryResult = Apollo.QueryResult<CustomInterviewScheduleTokenPreviewQuery, CustomInterviewScheduleTokenPreviewQueryVariables>;
export const DefaultCustomInterviewScheduleTokenDocument = gql`
    query DefaultCustomInterviewScheduleToken {
  defaultCustomInterviewScheduleToken {
    dateHeaderFormat
    breakDividerFormat
    interviewDetailWithTime
    codingLinkFormat
    candidatePhoneNumberFormat
    uniqueMeetingLinkFormat {
      zoomLinkFormat
      workspaceVideoLinkFormat
      customLinkFormat
    }
    singleMeetingLinkFormat {
      zoomLinkFormat
      workspaceVideoLinkFormat
      customLinkFormat
    }
  }
}
    `;

/**
 * __useDefaultCustomInterviewScheduleTokenQuery__
 *
 * To run a query within a React component, call `useDefaultCustomInterviewScheduleTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultCustomInterviewScheduleTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultCustomInterviewScheduleTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefaultCustomInterviewScheduleTokenQuery(baseOptions?: Apollo.QueryHookOptions<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>(DefaultCustomInterviewScheduleTokenDocument, options);
      }
export function useDefaultCustomInterviewScheduleTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>(DefaultCustomInterviewScheduleTokenDocument, options);
        }
// @ts-ignore
export function useDefaultCustomInterviewScheduleTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>;
export function useDefaultCustomInterviewScheduleTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>): Apollo.UseSuspenseQueryResult<DefaultCustomInterviewScheduleTokenQuery | undefined, DefaultCustomInterviewScheduleTokenQueryVariables>;
export function useDefaultCustomInterviewScheduleTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>(DefaultCustomInterviewScheduleTokenDocument, options);
        }
export type DefaultCustomInterviewScheduleTokenQueryHookResult = ReturnType<typeof useDefaultCustomInterviewScheduleTokenQuery>;
export type DefaultCustomInterviewScheduleTokenLazyQueryHookResult = ReturnType<typeof useDefaultCustomInterviewScheduleTokenLazyQuery>;
export type DefaultCustomInterviewScheduleTokenSuspenseQueryHookResult = ReturnType<typeof useDefaultCustomInterviewScheduleTokenSuspenseQuery>;
export type DefaultCustomInterviewScheduleTokenQueryResult = Apollo.QueryResult<DefaultCustomInterviewScheduleTokenQuery, DefaultCustomInterviewScheduleTokenQueryVariables>;
export const OrgTranslationsDocument = gql`
    query OrgTranslations($input: OrgTranslationsInput!) {
  orgTranslations(input: $input) {
    rows {
      category
      entityId
      sourceText
      cells {
        locale
        value
        isMissing
      }
    }
  }
}
    `;

/**
 * __useOrgTranslationsQuery__
 *
 * To run a query within a React component, call `useOrgTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgTranslationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgTranslationsQuery(baseOptions: Apollo.QueryHookOptions<OrgTranslationsQuery, OrgTranslationsQueryVariables> & ({ variables: OrgTranslationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgTranslationsQuery, OrgTranslationsQueryVariables>(OrgTranslationsDocument, options);
      }
export function useOrgTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgTranslationsQuery, OrgTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgTranslationsQuery, OrgTranslationsQueryVariables>(OrgTranslationsDocument, options);
        }
// @ts-ignore
export function useOrgTranslationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgTranslationsQuery, OrgTranslationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgTranslationsQuery, OrgTranslationsQueryVariables>;
export function useOrgTranslationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgTranslationsQuery, OrgTranslationsQueryVariables>): Apollo.UseSuspenseQueryResult<OrgTranslationsQuery | undefined, OrgTranslationsQueryVariables>;
export function useOrgTranslationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgTranslationsQuery, OrgTranslationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgTranslationsQuery, OrgTranslationsQueryVariables>(OrgTranslationsDocument, options);
        }
export type OrgTranslationsQueryHookResult = ReturnType<typeof useOrgTranslationsQuery>;
export type OrgTranslationsLazyQueryHookResult = ReturnType<typeof useOrgTranslationsLazyQuery>;
export type OrgTranslationsSuspenseQueryHookResult = ReturnType<typeof useOrgTranslationsSuspenseQuery>;
export type OrgTranslationsQueryResult = Apollo.QueryResult<OrgTranslationsQuery, OrgTranslationsQueryVariables>;
export const UpcomingEventsDocument = gql`
    query UpcomingEvents($input: UpcomingEventsInput!, $includeDebriefs: Boolean!) {
  upcomingEvents(input: $input) {
    ...Views_upcomingEventsResult
  }
}
    ${Views_UpcomingEventsResultFragmentDoc}`;

/**
 * __useUpcomingEventsQuery__
 *
 * To run a query within a React component, call `useUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includeDebriefs: // value for 'includeDebriefs'
 *   },
 * });
 */
export function useUpcomingEventsQuery(baseOptions: Apollo.QueryHookOptions<UpcomingEventsQuery, UpcomingEventsQueryVariables> & ({ variables: UpcomingEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingEventsQuery, UpcomingEventsQueryVariables>(UpcomingEventsDocument, options);
      }
export function useUpcomingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingEventsQuery, UpcomingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingEventsQuery, UpcomingEventsQueryVariables>(UpcomingEventsDocument, options);
        }
// @ts-ignore
export function useUpcomingEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingEventsQuery, UpcomingEventsQueryVariables>): Apollo.UseSuspenseQueryResult<UpcomingEventsQuery, UpcomingEventsQueryVariables>;
export function useUpcomingEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingEventsQuery, UpcomingEventsQueryVariables>): Apollo.UseSuspenseQueryResult<UpcomingEventsQuery | undefined, UpcomingEventsQueryVariables>;
export function useUpcomingEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingEventsQuery, UpcomingEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingEventsQuery, UpcomingEventsQueryVariables>(UpcomingEventsDocument, options);
        }
export type UpcomingEventsQueryHookResult = ReturnType<typeof useUpcomingEventsQuery>;
export type UpcomingEventsLazyQueryHookResult = ReturnType<typeof useUpcomingEventsLazyQuery>;
export type UpcomingEventsSuspenseQueryHookResult = ReturnType<typeof useUpcomingEventsSuspenseQuery>;
export type UpcomingEventsQueryResult = Apollo.QueryResult<UpcomingEventsQuery, UpcomingEventsQueryVariables>;
export const UpdateUpcomingEventsPageFiltersEmployeePrefDocument = gql`
    mutation updateUpcomingEventsPageFiltersEmployeePref($input: EmployeePrefUpdateInput!) {
  employeePrefUpdate(input: $input) {
    employeePref {
      id
      jsonPref {
        ... on UpcomingEventsPageFiltersPref {
          ...UpcomingEventsPageFiltersEmployeePref
        }
      }
    }
  }
}
    ${UpcomingEventsPageFiltersEmployeePrefFragmentDoc}`;
export type UpdateUpcomingEventsPageFiltersEmployeePrefMutationFn = Apollo.MutationFunction<UpdateUpcomingEventsPageFiltersEmployeePrefMutation, UpdateUpcomingEventsPageFiltersEmployeePrefMutationVariables>;

/**
 * __useUpdateUpcomingEventsPageFiltersEmployeePrefMutation__
 *
 * To run a mutation, you first call `useUpdateUpcomingEventsPageFiltersEmployeePrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUpcomingEventsPageFiltersEmployeePrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUpcomingEventsPageFiltersEmployeePrefMutation, { data, loading, error }] = useUpdateUpcomingEventsPageFiltersEmployeePrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUpcomingEventsPageFiltersEmployeePrefMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUpcomingEventsPageFiltersEmployeePrefMutation, UpdateUpcomingEventsPageFiltersEmployeePrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUpcomingEventsPageFiltersEmployeePrefMutation, UpdateUpcomingEventsPageFiltersEmployeePrefMutationVariables>(UpdateUpcomingEventsPageFiltersEmployeePrefDocument, options);
      }
export type UpdateUpcomingEventsPageFiltersEmployeePrefMutationHookResult = ReturnType<typeof useUpdateUpcomingEventsPageFiltersEmployeePrefMutation>;
export type UpdateUpcomingEventsPageFiltersEmployeePrefMutationResult = Apollo.MutationResult<UpdateUpcomingEventsPageFiltersEmployeePrefMutation>;
export type UpdateUpcomingEventsPageFiltersEmployeePrefMutationOptions = Apollo.BaseMutationOptions<UpdateUpcomingEventsPageFiltersEmployeePrefMutation, UpdateUpcomingEventsPageFiltersEmployeePrefMutationVariables>;
export const UpcomingEventsPageFiltersEmployeePrefDocument = gql`
    query UpcomingEventsPageFiltersEmployeePref($prefName: String!) {
  thisEmployee {
    id
    employeePref(prefName: $prefName) {
      id
      id
      jsonPref {
        ... on UpcomingEventsPageFiltersPref {
          ...UpcomingEventsPageFiltersEmployeePref
        }
      }
    }
  }
}
    ${UpcomingEventsPageFiltersEmployeePrefFragmentDoc}`;

/**
 * __useUpcomingEventsPageFiltersEmployeePrefQuery__
 *
 * To run a query within a React component, call `useUpcomingEventsPageFiltersEmployeePrefQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingEventsPageFiltersEmployeePrefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingEventsPageFiltersEmployeePrefQuery({
 *   variables: {
 *      prefName: // value for 'prefName'
 *   },
 * });
 */
export function useUpcomingEventsPageFiltersEmployeePrefQuery(baseOptions: Apollo.QueryHookOptions<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables> & ({ variables: UpcomingEventsPageFiltersEmployeePrefQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>(UpcomingEventsPageFiltersEmployeePrefDocument, options);
      }
export function useUpcomingEventsPageFiltersEmployeePrefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>(UpcomingEventsPageFiltersEmployeePrefDocument, options);
        }
// @ts-ignore
export function useUpcomingEventsPageFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>;
export function useUpcomingEventsPageFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>): Apollo.UseSuspenseQueryResult<UpcomingEventsPageFiltersEmployeePrefQuery | undefined, UpcomingEventsPageFiltersEmployeePrefQueryVariables>;
export function useUpcomingEventsPageFiltersEmployeePrefSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>(UpcomingEventsPageFiltersEmployeePrefDocument, options);
        }
export type UpcomingEventsPageFiltersEmployeePrefQueryHookResult = ReturnType<typeof useUpcomingEventsPageFiltersEmployeePrefQuery>;
export type UpcomingEventsPageFiltersEmployeePrefLazyQueryHookResult = ReturnType<typeof useUpcomingEventsPageFiltersEmployeePrefLazyQuery>;
export type UpcomingEventsPageFiltersEmployeePrefSuspenseQueryHookResult = ReturnType<typeof useUpcomingEventsPageFiltersEmployeePrefSuspenseQuery>;
export type UpcomingEventsPageFiltersEmployeePrefQueryResult = Apollo.QueryResult<UpcomingEventsPageFiltersEmployeePrefQuery, UpcomingEventsPageFiltersEmployeePrefQueryVariables>;
export const UpdateCommunicationsOrgIntegrationDocument = gql`
    query UpdateCommunicationsOrgIntegration {
  thisOrg {
    integrations {
      id
      coderpad {
        apiKey
      }
      codility {
        apiKey
      }
      codesignal {
        apiKey
      }
      hackerrank {
        apiKey
      }
    }
    id
  }
}
    `;

/**
 * __useUpdateCommunicationsOrgIntegrationQuery__
 *
 * To run a query within a React component, call `useUpdateCommunicationsOrgIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunicationsOrgIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateCommunicationsOrgIntegrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUpdateCommunicationsOrgIntegrationQuery(baseOptions?: Apollo.QueryHookOptions<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>(UpdateCommunicationsOrgIntegrationDocument, options);
      }
export function useUpdateCommunicationsOrgIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>(UpdateCommunicationsOrgIntegrationDocument, options);
        }
// @ts-ignore
export function useUpdateCommunicationsOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>;
export function useUpdateCommunicationsOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateCommunicationsOrgIntegrationQuery | undefined, UpdateCommunicationsOrgIntegrationQueryVariables>;
export function useUpdateCommunicationsOrgIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>(UpdateCommunicationsOrgIntegrationDocument, options);
        }
export type UpdateCommunicationsOrgIntegrationQueryHookResult = ReturnType<typeof useUpdateCommunicationsOrgIntegrationQuery>;
export type UpdateCommunicationsOrgIntegrationLazyQueryHookResult = ReturnType<typeof useUpdateCommunicationsOrgIntegrationLazyQuery>;
export type UpdateCommunicationsOrgIntegrationSuspenseQueryHookResult = ReturnType<typeof useUpdateCommunicationsOrgIntegrationSuspenseQuery>;
export type UpdateCommunicationsOrgIntegrationQueryResult = Apollo.QueryResult<UpdateCommunicationsOrgIntegrationQuery, UpdateCommunicationsOrgIntegrationQueryVariables>;
export const UpdateFlowDoneDocument = gql`
    query UpdateFlowDone($id: uuid!) {
  applicationStage(id: $id) {
    id
    isHoldForRsvp
    isReadyForCandidateComms
    application {
      id
      candidateId
    }
    task {
      id
      isDebriefRequired
      debriefs {
        id
      }
    }
  }
}
    `;

/**
 * __useUpdateFlowDoneQuery__
 *
 * To run a query within a React component, call `useUpdateFlowDoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlowDoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateFlowDoneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFlowDoneQuery(baseOptions: Apollo.QueryHookOptions<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables> & ({ variables: UpdateFlowDoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>(UpdateFlowDoneDocument, options);
      }
export function useUpdateFlowDoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>(UpdateFlowDoneDocument, options);
        }
// @ts-ignore
export function useUpdateFlowDoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>;
export function useUpdateFlowDoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateFlowDoneQuery | undefined, UpdateFlowDoneQueryVariables>;
export function useUpdateFlowDoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>(UpdateFlowDoneDocument, options);
        }
export type UpdateFlowDoneQueryHookResult = ReturnType<typeof useUpdateFlowDoneQuery>;
export type UpdateFlowDoneLazyQueryHookResult = ReturnType<typeof useUpdateFlowDoneLazyQuery>;
export type UpdateFlowDoneSuspenseQueryHookResult = ReturnType<typeof useUpdateFlowDoneSuspenseQuery>;
export type UpdateFlowDoneQueryResult = Apollo.QueryResult<UpdateFlowDoneQuery, UpdateFlowDoneQueryVariables>;
export const UpdateScheduleFlowHeaderDocument = gql`
    query updateScheduleFlowHeader($id: uuid!) {
  applicationStage(id: $id) {
    id
    taskId
    name
    jobStage {
      id
      name
    }
    application {
      id
      candidate {
        id
        fullName
        timezone
      }
      job {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUpdateScheduleFlowHeaderQuery__
 *
 * To run a query within a React component, call `useUpdateScheduleFlowHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleFlowHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateScheduleFlowHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateScheduleFlowHeaderQuery(baseOptions: Apollo.QueryHookOptions<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables> & ({ variables: UpdateScheduleFlowHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>(UpdateScheduleFlowHeaderDocument, options);
      }
export function useUpdateScheduleFlowHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>(UpdateScheduleFlowHeaderDocument, options);
        }
// @ts-ignore
export function useUpdateScheduleFlowHeaderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>;
export function useUpdateScheduleFlowHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateScheduleFlowHeaderQuery | undefined, UpdateScheduleFlowHeaderQueryVariables>;
export function useUpdateScheduleFlowHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>(UpdateScheduleFlowHeaderDocument, options);
        }
export type UpdateScheduleFlowHeaderQueryHookResult = ReturnType<typeof useUpdateScheduleFlowHeaderQuery>;
export type UpdateScheduleFlowHeaderLazyQueryHookResult = ReturnType<typeof useUpdateScheduleFlowHeaderLazyQuery>;
export type UpdateScheduleFlowHeaderSuspenseQueryHookResult = ReturnType<typeof useUpdateScheduleFlowHeaderSuspenseQuery>;
export type UpdateScheduleFlowHeaderQueryResult = Apollo.QueryResult<UpdateScheduleFlowHeaderQuery, UpdateScheduleFlowHeaderQueryVariables>;
export const UpdateFlowDocument = gql`
    query UpdateFlow($id: uuid!) {
  applicationStage(id: $id) {
    id
    application {
      id
      candidate {
        id
        timezone
        atsLatestAvailability {
          ...useCandidateAvailability_atsLatestAvailability
          timezone
          originalText
        }
        ...ScheduleFlowDataProvider_candidate
      }
    }
    jobStage {
      id
      name
      job {
        id
        name
        atsId
        ...ScheduleInterviewPlan_job
        jobSettings {
          id
          ...ScheduleFlowDataProvider_jobSettings
        }
      }
      jobStageSettingsV2 {
        id
        ...ScheduleFlowDataProvider_jobStageSettings
      }
    }
    task {
      id
      ...ScheduleFlowDataProvider_task
      ...UpdateFlow_task
      availabilities {
        id
        ...useCandidateAvailability_availabilities
      }
      interviewPlan {
        id
        ...ScheduleFlowDataProvider_interviewPlan
      }
    }
  }
}
    ${UseCandidateAvailability_AtsLatestAvailabilityFragmentDoc}
${ScheduleFlowDataProvider_CandidateFragmentDoc}
${ScheduleInterviewPlan_JobFragmentDoc}
${ScheduleFlowDataProvider_JobSettingsFragmentDoc}
${ScheduleFlowDataProvider_JobStageSettingsFragmentDoc}
${ScheduleFlowDataProvider_TaskFragmentDoc}
${UpdateFlow_TaskFragmentDoc}
${UseCandidateAvailability_AvailabilitiesFragmentDoc}
${ScheduleFlowDataProvider_InterviewPlanFragmentDoc}`;

/**
 * __useUpdateFlowQuery__
 *
 * To run a query within a React component, call `useUpdateFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateFlowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFlowQuery(baseOptions: Apollo.QueryHookOptions<UpdateFlowQuery, UpdateFlowQueryVariables> & ({ variables: UpdateFlowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateFlowQuery, UpdateFlowQueryVariables>(UpdateFlowDocument, options);
      }
export function useUpdateFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateFlowQuery, UpdateFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateFlowQuery, UpdateFlowQueryVariables>(UpdateFlowDocument, options);
        }
// @ts-ignore
export function useUpdateFlowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UpdateFlowQuery, UpdateFlowQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateFlowQuery, UpdateFlowQueryVariables>;
export function useUpdateFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateFlowQuery, UpdateFlowQueryVariables>): Apollo.UseSuspenseQueryResult<UpdateFlowQuery | undefined, UpdateFlowQueryVariables>;
export function useUpdateFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateFlowQuery, UpdateFlowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateFlowQuery, UpdateFlowQueryVariables>(UpdateFlowDocument, options);
        }
export type UpdateFlowQueryHookResult = ReturnType<typeof useUpdateFlowQuery>;
export type UpdateFlowLazyQueryHookResult = ReturnType<typeof useUpdateFlowLazyQuery>;
export type UpdateFlowSuspenseQueryHookResult = ReturnType<typeof useUpdateFlowSuspenseQuery>;
export type UpdateFlowQueryResult = Apollo.QueryResult<UpdateFlowQuery, UpdateFlowQueryVariables>;
export const ApplicationStageInterviewDocument = gql`
    query applicationStageInterview($id: uuid!) {
  applicationStage(id: $id) {
    id
    isCancelled
    applicationId
    jobStageId
    emailTemplateId
    conversation {
      id
      remoteName
    }
    timezone
    videoMeetingUrl
    initialEmailSubject
    initialEmailBody
    isPrivateCalendarEvent
    applicationStageCandidateEvents {
      id
      name
      googleEventId
      googleCalendarId
      calendarEventTemplateId
    }
    application {
      id
      jobStage {
        id
        atsId
        job {
          id
          atsId
        }
      }
      candidate {
        id
        fullName
        email
        additionalEmails
        atsCandidate {
          atsId
          atsUrl
        }
      }
    }
    applicationStageInterviews(input: {isCancelled: false, orderBy: {startAt: ASC}}) {
      id
      name
      endAt
      startAt
      googleEventId
      googleCalendarId
      jobStageInterviewId
      videoMeetingUrl
      zoomHostUserId
      zoomMeetingId
      zoomPassword
      zoomPstnPassword
      zoomDialInInfo
      codingInterviewUrl
      emailTemplateId
      isHiddenFromCandidate
      videoMeetingHostEmployeeId
      collaborationLink {
        id
        collaborationToolType
        collaborationLinkTemplateId
        url
      }
      meetingLocation {
        id
        type
        videoMeetingLink
        details {
          customLocation
          zoomInfo {
            password
            meetingId
            userId
            pstnPassword
            dialInfo {
              type
              number
              city
              countryName
              country
            }
          }
        }
        hostEmployee {
          id
        }
        remoteVideoMeetingHostUser {
          ... on ZoomUser {
            zoomUserId
          }
        }
      }
      applicationStageInterviewInterviewers {
        interviewModuleId
        interviewer {
          id
          atsId
          fullName
          internalProfilePictureUrl
          email
          givenName
          timezone
          title
          linkedinUrl
          familyName
          orgId
          isDirectoryDisabled
          useCalendarTimezone
          isPaused
        }
        isOptional
        jobStageInterviewSeatId
        role
        responseStatus
        interviewerId
        interviewerId
      }
      applicationStageInterviewRooms {
        applicationStageInterviewId
        meetingRoomId
        responseStatus
      }
      atsInterviewDefinition {
        ...AtsInterviewDefinition
      }
      atsScheduledInterviewId
      atsInterviewDefinitionId
      interviewGuide {
        id
      }
    }
    jobStage {
      id
      jobStageSettingsV2 {
        id
        candidateEmailTemplateId {
          templateId
        }
        candidateEventTemplateId {
          templateId
        }
        interviewerEventTemplateId {
          templateId
        }
        slackTemplateId {
          templateId
        }
        interviewerCalendarId {
          remoteCalendarId
        }
        candidateCalendarId {
          remoteCalendarId
        }
      }
    }
  }
}
    ${AtsInterviewDefinitionFragmentDoc}`;

/**
 * __useApplicationStageInterviewQuery__
 *
 * To run a query within a React component, call `useApplicationStageInterviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStageInterviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStageInterviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationStageInterviewQuery(baseOptions: Apollo.QueryHookOptions<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables> & ({ variables: ApplicationStageInterviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>(ApplicationStageInterviewDocument, options);
      }
export function useApplicationStageInterviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>(ApplicationStageInterviewDocument, options);
        }
// @ts-ignore
export function useApplicationStageInterviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>;
export function useApplicationStageInterviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStageInterviewQuery | undefined, ApplicationStageInterviewQueryVariables>;
export function useApplicationStageInterviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>(ApplicationStageInterviewDocument, options);
        }
export type ApplicationStageInterviewQueryHookResult = ReturnType<typeof useApplicationStageInterviewQuery>;
export type ApplicationStageInterviewLazyQueryHookResult = ReturnType<typeof useApplicationStageInterviewLazyQuery>;
export type ApplicationStageInterviewSuspenseQueryHookResult = ReturnType<typeof useApplicationStageInterviewSuspenseQuery>;
export type ApplicationStageInterviewQueryResult = Apollo.QueryResult<ApplicationStageInterviewQuery, ApplicationStageInterviewQueryVariables>;
export const OAuthConnectedAppsAdapterDocument = gql`
    query OAuthConnectedAppsAdapter($input: OAuthConnectedAppsInput!) {
  oauthConnectedApps(input: $input) {
    grantId
    clientName
    actingEmployeeName
    scopes
    createdAt
    lastUsedAt
    status
  }
}
    `;

/**
 * __useOAuthConnectedAppsAdapterQuery__
 *
 * To run a query within a React component, call `useOAuthConnectedAppsAdapterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOAuthConnectedAppsAdapterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOAuthConnectedAppsAdapterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthConnectedAppsAdapterQuery(baseOptions: Apollo.QueryHookOptions<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables> & ({ variables: OAuthConnectedAppsAdapterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>(OAuthConnectedAppsAdapterDocument, options);
      }
export function useOAuthConnectedAppsAdapterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>(OAuthConnectedAppsAdapterDocument, options);
        }
// @ts-ignore
export function useOAuthConnectedAppsAdapterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>): Apollo.UseSuspenseQueryResult<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>;
export function useOAuthConnectedAppsAdapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>): Apollo.UseSuspenseQueryResult<OAuthConnectedAppsAdapterQuery | undefined, OAuthConnectedAppsAdapterQueryVariables>;
export function useOAuthConnectedAppsAdapterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>(OAuthConnectedAppsAdapterDocument, options);
        }
export type OAuthConnectedAppsAdapterQueryHookResult = ReturnType<typeof useOAuthConnectedAppsAdapterQuery>;
export type OAuthConnectedAppsAdapterLazyQueryHookResult = ReturnType<typeof useOAuthConnectedAppsAdapterLazyQuery>;
export type OAuthConnectedAppsAdapterSuspenseQueryHookResult = ReturnType<typeof useOAuthConnectedAppsAdapterSuspenseQuery>;
export type OAuthConnectedAppsAdapterQueryResult = Apollo.QueryResult<OAuthConnectedAppsAdapterQuery, OAuthConnectedAppsAdapterQueryVariables>;
export const OAuthGrantRevokeAdapterDocument = gql`
    mutation OAuthGrantRevokeAdapter($input: OAuthGrantRevokeInput!) {
  oauthGrantRevoke(input: $input) {
    __typename
    ... on OAuthGrantRevokeSuccess {
      grantId
    }
    ... on OAuthGrantRevokeFailureNotFound {
      errorCode
      errorMessage
    }
    ... on OAuthGrantRevokeFailureAlreadyRevoked {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type OAuthGrantRevokeAdapterMutationFn = Apollo.MutationFunction<OAuthGrantRevokeAdapterMutation, OAuthGrantRevokeAdapterMutationVariables>;

/**
 * __useOAuthGrantRevokeAdapterMutation__
 *
 * To run a mutation, you first call `useOAuthGrantRevokeAdapterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOAuthGrantRevokeAdapterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [oAuthGrantRevokeAdapterMutation, { data, loading, error }] = useOAuthGrantRevokeAdapterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOAuthGrantRevokeAdapterMutation(baseOptions?: Apollo.MutationHookOptions<OAuthGrantRevokeAdapterMutation, OAuthGrantRevokeAdapterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OAuthGrantRevokeAdapterMutation, OAuthGrantRevokeAdapterMutationVariables>(OAuthGrantRevokeAdapterDocument, options);
      }
export type OAuthGrantRevokeAdapterMutationHookResult = ReturnType<typeof useOAuthGrantRevokeAdapterMutation>;
export type OAuthGrantRevokeAdapterMutationResult = Apollo.MutationResult<OAuthGrantRevokeAdapterMutation>;
export type OAuthGrantRevokeAdapterMutationOptions = Apollo.BaseMutationOptions<OAuthGrantRevokeAdapterMutation, OAuthGrantRevokeAdapterMutationVariables>;
export const AccountPhoneNumberDocument = gql`
    query AccountPhoneNumber {
  thisEmployee {
    id
    phoneNumber
    email
  }
}
    `;

/**
 * __useAccountPhoneNumberQuery__
 *
 * To run a query within a React component, call `useAccountPhoneNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountPhoneNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountPhoneNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountPhoneNumberQuery(baseOptions?: Apollo.QueryHookOptions<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>(AccountPhoneNumberDocument, options);
      }
export function useAccountPhoneNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>(AccountPhoneNumberDocument, options);
        }
// @ts-ignore
export function useAccountPhoneNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>;
export function useAccountPhoneNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>): Apollo.UseSuspenseQueryResult<AccountPhoneNumberQuery | undefined, AccountPhoneNumberQueryVariables>;
export function useAccountPhoneNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>(AccountPhoneNumberDocument, options);
        }
export type AccountPhoneNumberQueryHookResult = ReturnType<typeof useAccountPhoneNumberQuery>;
export type AccountPhoneNumberLazyQueryHookResult = ReturnType<typeof useAccountPhoneNumberLazyQuery>;
export type AccountPhoneNumberSuspenseQueryHookResult = ReturnType<typeof useAccountPhoneNumberSuspenseQuery>;
export type AccountPhoneNumberQueryResult = Apollo.QueryResult<AccountPhoneNumberQuery, AccountPhoneNumberQueryVariables>;
export const EmployeeNotificationPrefsDocument = gql`
    query EmployeeNotificationPrefs {
  thisEmployee {
    id
    notificationPrefs {
      ...Notification_EmployeeNotificationPref
    }
  }
}
    ${Notification_EmployeeNotificationPrefFragmentDoc}`;

/**
 * __useEmployeeNotificationPrefsQuery__
 *
 * To run a query within a React component, call `useEmployeeNotificationPrefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNotificationPrefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeNotificationPrefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployeeNotificationPrefsQuery(baseOptions?: Apollo.QueryHookOptions<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>(EmployeeNotificationPrefsDocument, options);
      }
export function useEmployeeNotificationPrefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>(EmployeeNotificationPrefsDocument, options);
        }
// @ts-ignore
export function useEmployeeNotificationPrefsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>;
export function useEmployeeNotificationPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>): Apollo.UseSuspenseQueryResult<EmployeeNotificationPrefsQuery | undefined, EmployeeNotificationPrefsQueryVariables>;
export function useEmployeeNotificationPrefsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>(EmployeeNotificationPrefsDocument, options);
        }
export type EmployeeNotificationPrefsQueryHookResult = ReturnType<typeof useEmployeeNotificationPrefsQuery>;
export type EmployeeNotificationPrefsLazyQueryHookResult = ReturnType<typeof useEmployeeNotificationPrefsLazyQuery>;
export type EmployeeNotificationPrefsSuspenseQueryHookResult = ReturnType<typeof useEmployeeNotificationPrefsSuspenseQuery>;
export type EmployeeNotificationPrefsQueryResult = Apollo.QueryResult<EmployeeNotificationPrefsQuery, EmployeeNotificationPrefsQueryVariables>;
export const EmployeeNotificationPrefDocument = gql`
    mutation EmployeeNotificationPref($input: EmployeeNotificationPrefUpdateInput!) {
  employeeNotificationPrefUpdate(input: $input) {
    employeeNotificationPref {
      ...Notification_EmployeeNotificationPref
    }
  }
}
    ${Notification_EmployeeNotificationPrefFragmentDoc}`;
export type EmployeeNotificationPrefMutationFn = Apollo.MutationFunction<EmployeeNotificationPrefMutation, EmployeeNotificationPrefMutationVariables>;

/**
 * __useEmployeeNotificationPrefMutation__
 *
 * To run a mutation, you first call `useEmployeeNotificationPrefMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployeeNotificationPrefMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employeeNotificationPrefMutation, { data, loading, error }] = useEmployeeNotificationPrefMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeNotificationPrefMutation(baseOptions?: Apollo.MutationHookOptions<EmployeeNotificationPrefMutation, EmployeeNotificationPrefMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployeeNotificationPrefMutation, EmployeeNotificationPrefMutationVariables>(EmployeeNotificationPrefDocument, options);
      }
export type EmployeeNotificationPrefMutationHookResult = ReturnType<typeof useEmployeeNotificationPrefMutation>;
export type EmployeeNotificationPrefMutationResult = Apollo.MutationResult<EmployeeNotificationPrefMutation>;
export type EmployeeNotificationPrefMutationOptions = Apollo.BaseMutationOptions<EmployeeNotificationPrefMutation, EmployeeNotificationPrefMutationVariables>;
export const InterviewModuleMemberMenuOptionsDocument = gql`
    query InterviewModuleMemberMenuOptions($interviewModuleId: uuid!, $employeeId: uuid!) {
  interviewModuleMember(
    interviewModuleId: $interviewModuleId
    employeeId: $employeeId
  ) {
    employeeId
    interviewModuleId
    ...InterviewModuleMemberMenuOptions
    ...RemoveMemberModal_interviewModuleMember
    ...SetModuleMemberAsTrained_interviewModuleMember
    ...pauseMemberModal_moduleMember
    ...SetModuleMemberAsTrainee_moduleMember
  }
}
    ${InterviewModuleMemberMenuOptionsFragmentDoc}
${RemoveMemberModal_InterviewModuleMemberFragmentDoc}
${SetModuleMemberAsTrained_InterviewModuleMemberFragmentDoc}
${PauseMemberModal_ModuleMemberFragmentDoc}
${SetModuleMemberAsTrainee_ModuleMemberFragmentDoc}`;

/**
 * __useInterviewModuleMemberMenuOptionsQuery__
 *
 * To run a query within a React component, call `useInterviewModuleMemberMenuOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewModuleMemberMenuOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewModuleMemberMenuOptionsQuery({
 *   variables: {
 *      interviewModuleId: // value for 'interviewModuleId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useInterviewModuleMemberMenuOptionsQuery(baseOptions: Apollo.QueryHookOptions<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables> & ({ variables: InterviewModuleMemberMenuOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>(InterviewModuleMemberMenuOptionsDocument, options);
      }
export function useInterviewModuleMemberMenuOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>(InterviewModuleMemberMenuOptionsDocument, options);
        }
// @ts-ignore
export function useInterviewModuleMemberMenuOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>;
export function useInterviewModuleMemberMenuOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewModuleMemberMenuOptionsQuery | undefined, InterviewModuleMemberMenuOptionsQueryVariables>;
export function useInterviewModuleMemberMenuOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>(InterviewModuleMemberMenuOptionsDocument, options);
        }
export type InterviewModuleMemberMenuOptionsQueryHookResult = ReturnType<typeof useInterviewModuleMemberMenuOptionsQuery>;
export type InterviewModuleMemberMenuOptionsLazyQueryHookResult = ReturnType<typeof useInterviewModuleMemberMenuOptionsLazyQuery>;
export type InterviewModuleMemberMenuOptionsSuspenseQueryHookResult = ReturnType<typeof useInterviewModuleMemberMenuOptionsSuspenseQuery>;
export type InterviewModuleMemberMenuOptionsQueryResult = Apollo.QueryResult<InterviewModuleMemberMenuOptionsQuery, InterviewModuleMemberMenuOptionsQueryVariables>;
export const TaskSetIsUrgentDocument = gql`
    mutation TaskSetIsUrgent($input: TaskSetIsUrgentInput!) {
  taskSetIsUrgent(input: $input) {
    id
    isUrgent
  }
}
    `;
export type TaskSetIsUrgentMutationFn = Apollo.MutationFunction<TaskSetIsUrgentMutation, TaskSetIsUrgentMutationVariables>;

/**
 * __useTaskSetIsUrgentMutation__
 *
 * To run a mutation, you first call `useTaskSetIsUrgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskSetIsUrgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskSetIsUrgentMutation, { data, loading, error }] = useTaskSetIsUrgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskSetIsUrgentMutation(baseOptions?: Apollo.MutationHookOptions<TaskSetIsUrgentMutation, TaskSetIsUrgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskSetIsUrgentMutation, TaskSetIsUrgentMutationVariables>(TaskSetIsUrgentDocument, options);
      }
export type TaskSetIsUrgentMutationHookResult = ReturnType<typeof useTaskSetIsUrgentMutation>;
export type TaskSetIsUrgentMutationResult = Apollo.MutationResult<TaskSetIsUrgentMutation>;
export type TaskSetIsUrgentMutationOptions = Apollo.BaseMutationOptions<TaskSetIsUrgentMutation, TaskSetIsUrgentMutationVariables>;
export const TaskCancelDocument = gql`
    mutation TaskCancel($input: TaskCancelInput!) {
  taskCancel(input: $input) {
    id
  }
}
    `;
export type TaskCancelMutationFn = Apollo.MutationFunction<TaskCancelMutation, TaskCancelMutationVariables>;

/**
 * __useTaskCancelMutation__
 *
 * To run a mutation, you first call `useTaskCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskCancelMutation, { data, loading, error }] = useTaskCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskCancelMutation(baseOptions?: Apollo.MutationHookOptions<TaskCancelMutation, TaskCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskCancelMutation, TaskCancelMutationVariables>(TaskCancelDocument, options);
      }
export type TaskCancelMutationHookResult = ReturnType<typeof useTaskCancelMutation>;
export type TaskCancelMutationResult = Apollo.MutationResult<TaskCancelMutation>;
export type TaskCancelMutationOptions = Apollo.BaseMutationOptions<TaskCancelMutation, TaskCancelMutationVariables>;
export const TaskPokeAgentDocument = gql`
    mutation TaskPokeAgent($input: TaskPokeAgentInput!) {
  taskPokeAgent(input: $input) {
    __typename
    ... on TaskPokeAgentSuccess {
      task {
        id
        delegateStatus
      }
    }
    ... on TaskPokeAgentFailureNotDelegated {
      errorCode
      errorMessage
    }
    ... on UnknownError {
      errorCode
      errorMessage
    }
  }
}
    `;
export type TaskPokeAgentMutationFn = Apollo.MutationFunction<TaskPokeAgentMutation, TaskPokeAgentMutationVariables>;

/**
 * __useTaskPokeAgentMutation__
 *
 * To run a mutation, you first call `useTaskPokeAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTaskPokeAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [taskPokeAgentMutation, { data, loading, error }] = useTaskPokeAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTaskPokeAgentMutation(baseOptions?: Apollo.MutationHookOptions<TaskPokeAgentMutation, TaskPokeAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TaskPokeAgentMutation, TaskPokeAgentMutationVariables>(TaskPokeAgentDocument, options);
      }
export type TaskPokeAgentMutationHookResult = ReturnType<typeof useTaskPokeAgentMutation>;
export type TaskPokeAgentMutationResult = Apollo.MutationResult<TaskPokeAgentMutation>;
export type TaskPokeAgentMutationOptions = Apollo.BaseMutationOptions<TaskPokeAgentMutation, TaskPokeAgentMutationVariables>;
export const ScheduleTaskDocument = gql`
    query ScheduleTask($scheduleTaskId: uuid!) {
  task(id: $scheduleTaskId) {
    application {
      id
      candidate {
        id
      }
    }
    ...ScheduleTask_task
    ...UseSchduleTaskMenuOptions_task
  }
}
    ${ScheduleTask_TaskFragmentDoc}
${UseSchduleTaskMenuOptions_TaskFragmentDoc}`;

/**
 * __useScheduleTaskQuery__
 *
 * To run a query within a React component, call `useScheduleTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTaskQuery({
 *   variables: {
 *      scheduleTaskId: // value for 'scheduleTaskId'
 *   },
 * });
 */
export function useScheduleTaskQuery(baseOptions: Apollo.QueryHookOptions<ScheduleTaskQuery, ScheduleTaskQueryVariables> & ({ variables: ScheduleTaskQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleTaskQuery, ScheduleTaskQueryVariables>(ScheduleTaskDocument, options);
      }
export function useScheduleTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleTaskQuery, ScheduleTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleTaskQuery, ScheduleTaskQueryVariables>(ScheduleTaskDocument, options);
        }
// @ts-ignore
export function useScheduleTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ScheduleTaskQuery, ScheduleTaskQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskQuery, ScheduleTaskQueryVariables>;
export function useScheduleTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskQuery, ScheduleTaskQueryVariables>): Apollo.UseSuspenseQueryResult<ScheduleTaskQuery | undefined, ScheduleTaskQueryVariables>;
export function useScheduleTaskSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleTaskQuery, ScheduleTaskQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleTaskQuery, ScheduleTaskQueryVariables>(ScheduleTaskDocument, options);
        }
export type ScheduleTaskQueryHookResult = ReturnType<typeof useScheduleTaskQuery>;
export type ScheduleTaskLazyQueryHookResult = ReturnType<typeof useScheduleTaskLazyQuery>;
export type ScheduleTaskSuspenseQueryHookResult = ReturnType<typeof useScheduleTaskSuspenseQuery>;
export type ScheduleTaskQueryResult = Apollo.QueryResult<ScheduleTaskQuery, ScheduleTaskQueryVariables>;